
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea496"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea496"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $jN4Ph = parcelRequire("jN4Ph");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $jN4Ph.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $jN4Ph.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $jN4Ph.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $jN4Ph.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $jN4Ph.unstable_now, $0b2e6adb871a3b94$var$ec = $jN4Ph.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $jN4Ph.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $jN4Ph.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $jN4Ph.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $jN4Ph.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $jN4Ph.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $jN4Ph.unstable_scheduleCallback($jN4Ph.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("jN4Ph", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2ZUhe"));

});
parcelRegister("2ZUhe", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $22eceeba251b2de5$export$c4744153514ff05d, (v) => $22eceeba251b2de5$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $22eceeba251b2de5$export$3e506c1ccc9cc1a7, (v) => $22eceeba251b2de5$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $22eceeba251b2de5$export$e26fe2ed2fa76875, (v) => $22eceeba251b2de5$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $22eceeba251b2de5$export$502329bbf4b505b1, (v) => $22eceeba251b2de5$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $22eceeba251b2de5$export$6e3807111c4874c4, (v) => $22eceeba251b2de5$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $22eceeba251b2de5$export$c27134553091fb3a, (v) => $22eceeba251b2de5$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $22eceeba251b2de5$export$33ee1acdc04fd2a2, (v) => $22eceeba251b2de5$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $22eceeba251b2de5$export$b00a404bbd5edef2, (v) => $22eceeba251b2de5$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $22eceeba251b2de5$export$8352ce38b91d0c62, (v) => $22eceeba251b2de5$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $22eceeba251b2de5$export$d66a1c1c77bd778b, (v) => $22eceeba251b2de5$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $22eceeba251b2de5$export$d3dfb8e4810cb555, (v) => $22eceeba251b2de5$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $22eceeba251b2de5$export$839f9183b0465a69, (v) => $22eceeba251b2de5$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $22eceeba251b2de5$export$72fdf0e06517287b, (v) => $22eceeba251b2de5$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $22eceeba251b2de5$export$4b844e58a3e414b4, (v) => $22eceeba251b2de5$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $22eceeba251b2de5$export$816d2913ae6b83b1, (v) => $22eceeba251b2de5$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $22eceeba251b2de5$export$61bcfe829111a1d0, (v) => $22eceeba251b2de5$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $22eceeba251b2de5$export$7ee8c9beb337bc3f, (v) => $22eceeba251b2de5$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $22eceeba251b2de5$export$b5836b71941fa3ed, (v) => $22eceeba251b2de5$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $22eceeba251b2de5$export$cf845f2c119da08a, (v) => $22eceeba251b2de5$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $22eceeba251b2de5$export$c4744153514ff05d;
var $22eceeba251b2de5$export$3e506c1ccc9cc1a7;
var $22eceeba251b2de5$export$e26fe2ed2fa76875;
var $22eceeba251b2de5$export$502329bbf4b505b1;
var $22eceeba251b2de5$export$6e3807111c4874c4;
var $22eceeba251b2de5$export$c27134553091fb3a;
var $22eceeba251b2de5$export$33ee1acdc04fd2a2;
var $22eceeba251b2de5$export$b00a404bbd5edef2;
var $22eceeba251b2de5$export$8352ce38b91d0c62;
var $22eceeba251b2de5$export$d66a1c1c77bd778b;
var $22eceeba251b2de5$export$d3dfb8e4810cb555;
var $22eceeba251b2de5$export$839f9183b0465a69;
var $22eceeba251b2de5$export$72fdf0e06517287b;
var $22eceeba251b2de5$export$4b844e58a3e414b4;
var $22eceeba251b2de5$export$816d2913ae6b83b1;
var $22eceeba251b2de5$export$61bcfe829111a1d0;
var $22eceeba251b2de5$export$7ee8c9beb337bc3f;
var $22eceeba251b2de5$export$b5836b71941fa3ed;
var $22eceeba251b2de5$export$cf845f2c119da08a;
'use strict';
function $22eceeba251b2de5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $22eceeba251b2de5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $22eceeba251b2de5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $22eceeba251b2de5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $22eceeba251b2de5$var$g(C, c)) n < e && 0 > $22eceeba251b2de5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $22eceeba251b2de5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $22eceeba251b2de5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $22eceeba251b2de5$var$l = performance;
    $22eceeba251b2de5$export$c4744153514ff05d = function() {
        return $22eceeba251b2de5$var$l.now();
    };
} else {
    var $22eceeba251b2de5$var$p = Date, $22eceeba251b2de5$var$q = $22eceeba251b2de5$var$p.now();
    $22eceeba251b2de5$export$c4744153514ff05d = function() {
        return $22eceeba251b2de5$var$p.now() - $22eceeba251b2de5$var$q;
    };
}
var $22eceeba251b2de5$var$r = [], $22eceeba251b2de5$var$t = [], $22eceeba251b2de5$var$u = 1, $22eceeba251b2de5$var$v = null, $22eceeba251b2de5$var$y = 3, $22eceeba251b2de5$var$z = !1, $22eceeba251b2de5$var$A = !1, $22eceeba251b2de5$var$B = !1, $22eceeba251b2de5$var$D = "function" === typeof setTimeout ? setTimeout : null, $22eceeba251b2de5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $22eceeba251b2de5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $22eceeba251b2de5$var$G(a) {
    for(var b = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$t); null !== b;){
        if (null === b.callback) $22eceeba251b2de5$var$k($22eceeba251b2de5$var$t);
        else if (b.startTime <= a) $22eceeba251b2de5$var$k($22eceeba251b2de5$var$t), b.sortIndex = b.expirationTime, $22eceeba251b2de5$var$f($22eceeba251b2de5$var$r, b);
        else break;
        b = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$t);
    }
}
function $22eceeba251b2de5$var$H(a) {
    $22eceeba251b2de5$var$B = !1;
    $22eceeba251b2de5$var$G(a);
    if (!$22eceeba251b2de5$var$A) {
        if (null !== $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r)) $22eceeba251b2de5$var$A = !0, $22eceeba251b2de5$var$I($22eceeba251b2de5$var$J);
        else {
            var b = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$t);
            null !== b && $22eceeba251b2de5$var$K($22eceeba251b2de5$var$H, b.startTime - a);
        }
    }
}
function $22eceeba251b2de5$var$J(a, b) {
    $22eceeba251b2de5$var$A = !1;
    $22eceeba251b2de5$var$B && ($22eceeba251b2de5$var$B = !1, $22eceeba251b2de5$var$E($22eceeba251b2de5$var$L), $22eceeba251b2de5$var$L = -1);
    $22eceeba251b2de5$var$z = !0;
    var c = $22eceeba251b2de5$var$y;
    try {
        $22eceeba251b2de5$var$G(b);
        for($22eceeba251b2de5$var$v = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r); null !== $22eceeba251b2de5$var$v && (!($22eceeba251b2de5$var$v.expirationTime > b) || a && !$22eceeba251b2de5$var$M());){
            var d = $22eceeba251b2de5$var$v.callback;
            if ("function" === typeof d) {
                $22eceeba251b2de5$var$v.callback = null;
                $22eceeba251b2de5$var$y = $22eceeba251b2de5$var$v.priorityLevel;
                var e = d($22eceeba251b2de5$var$v.expirationTime <= b);
                b = $22eceeba251b2de5$export$c4744153514ff05d();
                "function" === typeof e ? $22eceeba251b2de5$var$v.callback = e : $22eceeba251b2de5$var$v === $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r) && $22eceeba251b2de5$var$k($22eceeba251b2de5$var$r);
                $22eceeba251b2de5$var$G(b);
            } else $22eceeba251b2de5$var$k($22eceeba251b2de5$var$r);
            $22eceeba251b2de5$var$v = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r);
        }
        if (null !== $22eceeba251b2de5$var$v) var w = !0;
        else {
            var m = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$t);
            null !== m && $22eceeba251b2de5$var$K($22eceeba251b2de5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $22eceeba251b2de5$var$v = null, $22eceeba251b2de5$var$y = c, $22eceeba251b2de5$var$z = !1;
    }
}
var $22eceeba251b2de5$var$N = !1, $22eceeba251b2de5$var$O = null, $22eceeba251b2de5$var$L = -1, $22eceeba251b2de5$var$P = 5, $22eceeba251b2de5$var$Q = -1;
function $22eceeba251b2de5$var$M() {
    return $22eceeba251b2de5$export$c4744153514ff05d() - $22eceeba251b2de5$var$Q < $22eceeba251b2de5$var$P ? !1 : !0;
}
function $22eceeba251b2de5$var$R() {
    if (null !== $22eceeba251b2de5$var$O) {
        var a = $22eceeba251b2de5$export$c4744153514ff05d();
        $22eceeba251b2de5$var$Q = a;
        var b = !0;
        try {
            b = $22eceeba251b2de5$var$O(!0, a);
        } finally{
            b ? $22eceeba251b2de5$var$S() : ($22eceeba251b2de5$var$N = !1, $22eceeba251b2de5$var$O = null);
        }
    } else $22eceeba251b2de5$var$N = !1;
}
var $22eceeba251b2de5$var$S;
if ("function" === typeof $22eceeba251b2de5$var$F) $22eceeba251b2de5$var$S = function() {
    $22eceeba251b2de5$var$F($22eceeba251b2de5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $22eceeba251b2de5$var$T = new MessageChannel, $22eceeba251b2de5$var$U = $22eceeba251b2de5$var$T.port2;
    $22eceeba251b2de5$var$T.port1.onmessage = $22eceeba251b2de5$var$R;
    $22eceeba251b2de5$var$S = function() {
        $22eceeba251b2de5$var$U.postMessage(null);
    };
} else $22eceeba251b2de5$var$S = function() {
    $22eceeba251b2de5$var$D($22eceeba251b2de5$var$R, 0);
};
function $22eceeba251b2de5$var$I(a) {
    $22eceeba251b2de5$var$O = a;
    $22eceeba251b2de5$var$N || ($22eceeba251b2de5$var$N = !0, $22eceeba251b2de5$var$S());
}
function $22eceeba251b2de5$var$K(a, b) {
    $22eceeba251b2de5$var$L = $22eceeba251b2de5$var$D(function() {
        a($22eceeba251b2de5$export$c4744153514ff05d());
    }, b);
}
$22eceeba251b2de5$export$3e506c1ccc9cc1a7 = 5;
$22eceeba251b2de5$export$e26fe2ed2fa76875 = 1;
$22eceeba251b2de5$export$502329bbf4b505b1 = 4;
$22eceeba251b2de5$export$6e3807111c4874c4 = 3;
$22eceeba251b2de5$export$c27134553091fb3a = null;
$22eceeba251b2de5$export$33ee1acdc04fd2a2 = 2;
$22eceeba251b2de5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$22eceeba251b2de5$export$8352ce38b91d0c62 = function() {
    $22eceeba251b2de5$var$A || $22eceeba251b2de5$var$z || ($22eceeba251b2de5$var$A = !0, $22eceeba251b2de5$var$I($22eceeba251b2de5$var$J));
};
$22eceeba251b2de5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $22eceeba251b2de5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$22eceeba251b2de5$export$d3dfb8e4810cb555 = function() {
    return $22eceeba251b2de5$var$y;
};
$22eceeba251b2de5$export$839f9183b0465a69 = function() {
    return $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r);
};
$22eceeba251b2de5$export$72fdf0e06517287b = function(a) {
    switch($22eceeba251b2de5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $22eceeba251b2de5$var$y;
    }
    var c = $22eceeba251b2de5$var$y;
    $22eceeba251b2de5$var$y = b;
    try {
        return a();
    } finally{
        $22eceeba251b2de5$var$y = c;
    }
};
$22eceeba251b2de5$export$4b844e58a3e414b4 = function() {};
$22eceeba251b2de5$export$816d2913ae6b83b1 = function() {};
$22eceeba251b2de5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $22eceeba251b2de5$var$y;
    $22eceeba251b2de5$var$y = a;
    try {
        return b();
    } finally{
        $22eceeba251b2de5$var$y = c;
    }
};
$22eceeba251b2de5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $22eceeba251b2de5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $22eceeba251b2de5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $22eceeba251b2de5$var$f($22eceeba251b2de5$var$t, a), null === $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r) && a === $22eceeba251b2de5$var$h($22eceeba251b2de5$var$t) && ($22eceeba251b2de5$var$B ? ($22eceeba251b2de5$var$E($22eceeba251b2de5$var$L), $22eceeba251b2de5$var$L = -1) : $22eceeba251b2de5$var$B = !0, $22eceeba251b2de5$var$K($22eceeba251b2de5$var$H, c - d))) : (a.sortIndex = e, $22eceeba251b2de5$var$f($22eceeba251b2de5$var$r, a), $22eceeba251b2de5$var$A || $22eceeba251b2de5$var$z || ($22eceeba251b2de5$var$A = !0, $22eceeba251b2de5$var$I($22eceeba251b2de5$var$J)));
    return a;
};
$22eceeba251b2de5$export$b5836b71941fa3ed = $22eceeba251b2de5$var$M;
$22eceeba251b2de5$export$cf845f2c119da08a = function(a) {
    var b = $22eceeba251b2de5$var$y;
    return function() {
        var c = $22eceeba251b2de5$var$y;
        $22eceeba251b2de5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $22eceeba251b2de5$var$y = c;
        }
    };
};

});



parcelRegister("5Gn6I", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, 'Map'), nativeCreate = getNative(Object, 'create');
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = mergeWith;

});

parcelRegister("hkKGc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9e8838827ce4c4a$export$306c0aa65ff9ec16, (v) => $c9e8838827ce4c4a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9e8838827ce4c4a$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $c9e8838827ce4c4a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9e8838827ce4c4a$var$objectIs = "function" === typeof Object.is ? Object.is : $c9e8838827ce4c4a$var$is, $c9e8838827ce4c4a$var$useState = $acw62.useState, $c9e8838827ce4c4a$var$useEffect = $acw62.useEffect, $c9e8838827ce4c4a$var$useLayoutEffect = $acw62.useLayoutEffect, $c9e8838827ce4c4a$var$useDebugValue = $acw62.useDebugValue;
function $c9e8838827ce4c4a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9e8838827ce4c4a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9e8838827ce4c4a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9e8838827ce4c4a$var$useEffect(function() {
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9e8838827ce4c4a$var$useDebugValue(value);
    return value;
}
function $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9e8838827ce4c4a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9e8838827ce4c4a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9e8838827ce4c4a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9e8838827ce4c4a$var$useSyncExternalStore$1 : $c9e8838827ce4c4a$var$useSyncExternalStore$2;
$c9e8838827ce4c4a$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $c9e8838827ce4c4a$var$shim;

});

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $dca61ba26e2661d8$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $dca61ba26e2661d8$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $69084eaa2e6a0d50$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $69084eaa2e6a0d50$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($dca61ba26e2661d8$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($69084eaa2e6a0d50$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $69084eaa2e6a0d50$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $69084eaa2e6a0d50$var$i = /^\s*$/, $69084eaa2e6a0d50$var$s = Object.create(null);
function $69084eaa2e6a0d50$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($69084eaa2e6a0d50$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var $69084eaa2e6a0d50$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $69084eaa2e6a0d50$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($69084eaa2e6a0d50$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $69084eaa2e6a0d50$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $69084eaa2e6a0d50$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $69084eaa2e6a0d50$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $69084eaa2e6a0d50$var$a("", t);
        }, "");
    }
};
var $69084eaa2e6a0d50$export$2e2bcd8739ae039 = $69084eaa2e6a0d50$var$c;


const $cfb6e0167e0b350d$export$c106dd0671a0fc2d = (...args)=>{
    if (console?.warn) {
        if ($cfb6e0167e0b350d$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
};
const $cfb6e0167e0b350d$var$alreadyWarned = {};
const $cfb6e0167e0b350d$export$5b28268982f175ba = (...args)=>{
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(args[0]) && $cfb6e0167e0b350d$var$alreadyWarned[args[0]]) return;
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(args[0])) $cfb6e0167e0b350d$var$alreadyWarned[args[0]] = new Date();
    $cfb6e0167e0b350d$export$c106dd0671a0fc2d(...args);
};
const $cfb6e0167e0b350d$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $cfb6e0167e0b350d$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $cfb6e0167e0b350d$var$loadedClb(i18n, cb));
};
const $cfb6e0167e0b350d$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return $cfb6e0167e0b350d$export$83be934b53fff43b(i18n, ns, cb);
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $cfb6e0167e0b350d$var$loadedClb(i18n, cb));
};
const $cfb6e0167e0b350d$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $cfb6e0167e0b350d$export$5b28268982f175ba('i18n.languages were undefined or empty', i18n.languages);
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n?.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $cfb6e0167e0b350d$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($cfb6e0167e0b350d$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $cfb6e0167e0b350d$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $cfb6e0167e0b350d$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;


const $d7f2d92b0368699f$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $d7f2d92b0368699f$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $d7f2d92b0368699f$var$unescapeHtmlEntity = (m)=>$d7f2d92b0368699f$var$htmlEntities[m];
const $d7f2d92b0368699f$export$e8bacd2802a88316 = (text)=>text.replace($d7f2d92b0368699f$var$matchHtmlEntity, $d7f2d92b0368699f$var$unescapeHtmlEntity);


let $4f75eea5b29ffc65$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $d7f2d92b0368699f$export$e8bacd2802a88316
};
const $4f75eea5b29ffc65$export$2e2366488d12e20d = (options = {})=>{
    $4f75eea5b29ffc65$var$defaultOptions = {
        ...$4f75eea5b29ffc65$var$defaultOptions,
        ...options
    };
};
const $4f75eea5b29ffc65$export$212bb2fc580a90a8 = ()=>$4f75eea5b29ffc65$var$defaultOptions;


let $1d04edb3ddd0d89e$var$i18nInstance;
const $1d04edb3ddd0d89e$export$a039134f2fc7e0 = (instance)=>{
    $1d04edb3ddd0d89e$var$i18nInstance = instance;
};
const $1d04edb3ddd0d89e$export$64af334f494c2f47 = ()=>$1d04edb3ddd0d89e$var$i18nInstance;


const $acffcb171536f8e9$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props?.children ?? node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $acffcb171536f8e9$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props?.children ?? node.children;
    return node.props?.i18nIsDynamicList ? $acffcb171536f8e9$var$getAsArray(children) : children;
};
const $acffcb171536f8e9$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $acw62.isValidElement));
const $acffcb171536f8e9$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $acffcb171536f8e9$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
};
const $acffcb171536f8e9$export$4f7a36dd898f1267 = (children, i18nOptions)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $acffcb171536f8e9$var$getAsArray(children);
    const keepArray = i18nOptions?.transSupportBasicHtmlNodes ? i18nOptions.transKeepBasicHtmlNodesFor ?? [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) stringNode += `${child}`;
        else if ((0, $acw62.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) stringNode += `<${type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(childChildren)) stringNode += `<${type}>${childChildren}</${type}>`;
            else {
                const content = $acffcb171536f8e9$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
};
const $acffcb171536f8e9$var$renderNodes = (children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    const getData = (childs)=>{
        const childrenArray = $acffcb171536f8e9$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) return;
            if ($acffcb171536f8e9$var$hasChildren(child)) getData($acffcb171536f8e9$var$getChildren(child));
            else if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && !(0, $acw62.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const ast = (0, $69084eaa2e6a0d50$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $acffcb171536f8e9$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $acffcb171536f8e9$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props?.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $acw62.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $acw62.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, $acw62.createElement)(c.type, {
                ...props,
                key: i,
                ref: c.ref
            }, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $acffcb171536f8e9$var$getAsArray(reactNode);
        const astNodes = $acffcb171536f8e9$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children?.[0]?.content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $acffcb171536f8e9$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $acw62.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $acffcb171536f8e9$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(children) && Object.hasOwnProperty.call(children, node.name);
                if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($acffcb171536f8e9$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $acw62.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $acw62.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $acw62.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $acffcb171536f8e9$var$getAsArray(children || []));
    return $acffcb171536f8e9$var$getChildren(result[0]);
};
function $acffcb171536f8e9$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const i18n = i18nFromProps || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)('You will need to pass in an i18next instance by using i18nextReactModule');
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)(),
        ...i18n.options?.react
    };
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const nodeAsString = $acffcb171536f8e9$export$4f7a36dd898f1267(children, reactI18nextOptions);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options?.interpolation?.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values || count !== undefined && !i18n.options?.interpolation?.alwaysFormat || !children ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...tOptions,
        context: context || tOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    if (components) Object.keys(components).forEach((c)=>{
        const componentKey = components[c].key || c;
        const comp = (0, $acw62.cloneElement)(components[c], {
            key: componentKey
        });
        if (!comp.props || !comp.props.children || translation.indexOf(`${c}/>`) < 0 && translation.indexOf(`${c} />`) < 0) return;
        function Componentized() {
            return (0, $acw62.createElement)((0, $acw62.Fragment), null, comp);
        }
        components[c] = (0, $acw62.createElement)(Componentized);
    });
    const content = $acffcb171536f8e9$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent ?? reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $acw62.createElement)(useAsParent, additionalProps, content) : content;
}



var $acw62 = parcelRequire("acw62");




const $26bfda595e5aa141$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $4f75eea5b29ffc65$export$2e2366488d12e20d)(instance.options.react);
        (0, $1d04edb3ddd0d89e$export$a039134f2fc7e0)(instance);
    }
};


const $0636c84fe4549f1f$export$5603ab5ced17ce64 = (0, $acw62.createContext)();
class $0636c84fe4549f1f$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
const $0636c84fe4549f1f$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = await ForComponent.getInitialProps?.(ctx) ?? {};
        const i18nInitialProps = $0636c84fe4549f1f$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $0636c84fe4549f1f$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces?.getUsedNamespaces() ?? [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $e04d9533328ca578$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $acffcb171536f8e9$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $acw62 = parcelRequire("acw62");


const $3765cebd031b52c0$var$usePrevious = (value, ignore)=>{
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
const $3765cebd031b52c0$var$alwaysNewT = (i18n, language, namespace, keyPrefix)=>i18n.getFixedT(language, namespace, keyPrefix);
const $3765cebd031b52c0$var$useMemoizedT = (i18n, language, namespace, keyPrefix)=>(0, $acw62.useCallback)($3765cebd031b52c0$var$alwaysNewT(i18n, language, namespace, keyPrefix), [
        i18n,
        language,
        namespace,
        keyPrefix
    ]);
const $3765cebd031b52c0$export$9fc83ad70ead8663 = (ns, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $0636c84fe4549f1f$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)('You will need to pass in an i18next instance by using initReactI18next');
        const notReadyT = (k, optsOrDefaultValue)=>{
            if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
            if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react?.wait) (0, $cfb6e0167e0b350d$export$5b28268982f175ba)('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    const i18nOptions = {
        ...(0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options?.defaultNS;
    namespaces = (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    i18n.reportNamespaces.addUsedNamespaces?.(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $cfb6e0167e0b350d$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    const memoGetT = $3765cebd031b52c0$var$useMemoizedT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const getT = ()=>memoGetT;
    const getNewT = ()=>$3765cebd031b52c0$var$alwaysNewT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const [t, setT] = (0, $acw62.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $3765cebd031b52c0$var$usePrevious(joinedNS);
    const isMounted = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $cfb6e0167e0b350d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
            else (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getNewT);
        const boundReset = ()=>{
            if (isMounted.current) setT(getNewT);
        };
        if (bindI18n) i18n?.on(bindI18n, boundReset);
        if (bindI18nStore) i18n?.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (i18n) bindI18n?.split(' ').forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isMounted.current && ready) setT(getT);
    }, [
        i18n,
        keyPrefix,
        ready
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $cfb6e0167e0b350d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
};



var $acw62 = parcelRequire("acw62");


const $d9bd4545752f9667$export$2dcb0053efd21124 = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation({ forwardedRef: forwardedRef, ...rest }) {
            const [t, i18n, ready] = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $acw62.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $acw62.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $acw62.forwardRef)(forwardRef) : I18nextWithTranslation;
    };



const $868685a400877801$export$b63289fbda65eed1 = ({ ns: ns, children: children, ...options })=>{
    const [t, i18n, ready] = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
};



var $acw62 = parcelRequire("acw62");

function $c313608318d394ab$export$1325e8699caa160f({ i18n: i18n, defaultNS: defaultNS, children: children }) {
    const value = (0, $acw62.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $acw62.createElement)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $d97c91d803f78bcc$export$3526fb65ade8d8b7 = (initialI18nStore, initialLanguage, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (i18n.options?.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $afd5c8e3ef499392$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR({ initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest }) {
            (0, $d97c91d803f78bcc$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $acw62.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $0636c84fe4549f1f$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $2843511fe0fbbf82$export$324d90190a8b822a = ()=>'';
const $2843511fe0fbbf82$export$2da9be4cfdb689b1 = ()=>'';
const $2843511fe0fbbf82$export$98e628dec113755e = ()=>'';
const $2843511fe0fbbf82$export$2e6c959c16ff56b8 = ()=>'';
const $2843511fe0fbbf82$export$4e35d5c922a95490 = ()=>'';
const $2843511fe0fbbf82$export$720a3b9db04b7a0f = ()=>'';


/**
 * react-router v7.0.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ // lib/router/history.ts

var $acw62 = parcelRequire("acw62");
// src/utils.ts
var $2150357b95f27254$var$HOLE = -1;
var $2150357b95f27254$var$NAN = -2;
var $2150357b95f27254$var$NEGATIVE_INFINITY = -3;
var $2150357b95f27254$var$NEGATIVE_ZERO = -4;
var $2150357b95f27254$var$NULL = -5;
var $2150357b95f27254$var$POSITIVE_INFINITY = -6;
var $2150357b95f27254$var$UNDEFINED = -7;
var $2150357b95f27254$var$TYPE_BIGINT = "B";
var $2150357b95f27254$var$TYPE_DATE = "D";
var $2150357b95f27254$var$TYPE_ERROR = "E";
var $2150357b95f27254$var$TYPE_MAP = "M";
var $2150357b95f27254$var$TYPE_NULL_OBJECT = "N";
var $2150357b95f27254$var$TYPE_PROMISE = "P";
var $2150357b95f27254$var$TYPE_REGEXP = "R";
var $2150357b95f27254$var$TYPE_SET = "S";
var $2150357b95f27254$var$TYPE_SYMBOL = "Y";
var $2150357b95f27254$var$TYPE_URL = "U";
var $2150357b95f27254$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $2150357b95f27254$var$Deferred = class {
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $2150357b95f27254$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// src/flatten.ts
function $2150357b95f27254$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $2150357b95f27254$var$UNDEFINED;
    if (input === null) return $2150357b95f27254$var$NULL;
    if (Number.isNaN(input)) return $2150357b95f27254$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $2150357b95f27254$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $2150357b95f27254$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $2150357b95f27254$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $2150357b95f27254$var$stringify.call(this, input, index);
    return index;
}
function $2150357b95f27254$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$2150357b95f27254$var$flatten.call(this, k)}":${$2150357b95f27254$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${$2150357b95f27254$var$TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${$2150357b95f27254$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${$2150357b95f27254$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$2150357b95f27254$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? $2150357b95f27254$var$flatten.call(this, input2[i]) : $2150357b95f27254$var$HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) str[index2] = `["${$2150357b95f27254$var$TYPE_DATE}",${input2.getTime()}]`;
                        else if (input2 instanceof URL) str[index2] = `["${$2150357b95f27254$var$TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${$2150357b95f27254$var$TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${$2150357b95f27254$var$TYPE_SET}",${[
                                ...input2
                            ].map((val)=>$2150357b95f27254$var$flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${$2150357b95f27254$var$TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${$2150357b95f27254$var$TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    $2150357b95f27254$var$flatten.call(this, k),
                                    $2150357b95f27254$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${$2150357b95f27254$var$TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${$2150357b95f27254$var$TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${$2150357b95f27254$var$TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${$2150357b95f27254$var$TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if ($2150357b95f27254$var$isPlainObject(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$2150357b95f27254$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>$2150357b95f27254$var$flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $2150357b95f27254$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $2150357b95f27254$var$isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $2150357b95f27254$var$objectProtoNames;
}
// src/unflatten.ts
var $2150357b95f27254$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $2150357b95f27254$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $2150357b95f27254$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $2150357b95f27254$var$hydrate.call(this, startIndex);
}
function $2150357b95f27254$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $2150357b95f27254$var$UNDEFINED:
                set(void 0);
                continue;
            case $2150357b95f27254$var$NULL:
                set(null);
                continue;
            case $2150357b95f27254$var$NAN:
                set(NaN);
                continue;
            case $2150357b95f27254$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $2150357b95f27254$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $2150357b95f27254$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $2150357b95f27254$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $2150357b95f27254$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $2150357b95f27254$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $2150357b95f27254$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $2150357b95f27254$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $2150357b95f27254$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = 1; i < value.length; i++)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $2150357b95f27254$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = 1; i < value.length; i += 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $2150357b95f27254$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $2150357b95f27254$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $2150357b95f27254$var$Deferred();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $2150357b95f27254$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $2150357b95f27254$var$globalObj && $2150357b95f27254$var$globalObj[errorType] ? new $2150357b95f27254$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $2150357b95f27254$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $2150357b95f27254$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// src/turbo-stream.ts
async function $2150357b95f27254$export$2f872c0f2117be69(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $2150357b95f27254$var$Deferred();
    const reader = readable.pipeThrough($2150357b95f27254$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $2150357b95f27254$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $2150357b95f27254$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $2150357b95f27254$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $2150357b95f27254$var$unflatten.call(this, line)
    };
}
async function $2150357b95f27254$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $2150357b95f27254$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $2150357b95f27254$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $2150357b95f27254$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $2150357b95f27254$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $2150357b95f27254$export$c564cdbbe6da493(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $2150357b95f27254$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            while(Object.keys(encoder.deferred).length > 0){
                for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                    if (seenPromises.has(deferred)) continue;
                    seenPromises.add(encoder.deferred[Number(deferredId)] = $2150357b95f27254$var$raceSignal(deferred, encoder.signal).then((resolved)=>{
                        const id2 = $2150357b95f27254$var$flatten.call(encoder, resolved);
                        if (Array.isArray(id2)) {
                            controller.enqueue(textEncoder.encode(`${$2150357b95f27254$var$TYPE_PROMISE}${deferredId}:[["${$2150357b95f27254$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                            encoder.index++;
                            lastSentIndex++;
                        } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$2150357b95f27254$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                        else {
                            const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                            controller.enqueue(textEncoder.encode(`${$2150357b95f27254$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                            lastSentIndex = encoder.stringified.length - 1;
                        }
                    }, (reason)=>{
                        if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                        const id2 = $2150357b95f27254$var$flatten.call(encoder, reason);
                        if (Array.isArray(id2)) {
                            controller.enqueue(textEncoder.encode(`${$2150357b95f27254$var$TYPE_ERROR}${deferredId}:[["${$2150357b95f27254$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                            encoder.index++;
                            lastSentIndex++;
                        } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$2150357b95f27254$var$TYPE_ERROR}${deferredId}:${id2}
`));
                        else {
                            const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                            controller.enqueue(textEncoder.encode(`${$2150357b95f27254$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                            lastSentIndex = encoder.stringified.length - 1;
                        }
                    }).finally(()=>{
                        delete encoder.deferred[Number(deferredId)];
                    }));
                }
                await Promise.race(Object.values(encoder.deferred));
            }
            await Promise.all(Object.values(encoder.deferred));
            controller.close();
        }
    });
    return readable;
}
function $2150357b95f27254$var$raceSignal(promise, signal) {
    if (!signal) return promise;
    if (signal.aborted) return Promise.reject(signal.reason || new Error("Signal was aborted."));
    const abort = new Promise((resolve, reject)=>{
        signal.addEventListener("abort", (event)=>{
            reject(signal.reason || new Error("Signal was aborted."));
        });
        promise.then(resolve).catch(reject);
    });
    abort.catch(()=>{});
    return Promise.race([
        abort,
        promise
    ]);
}


var $9fd38747d73cb940$exports = {};
"use strict";
Object.defineProperty($9fd38747d73cb940$exports, "__esModule", {
    value: true
});
$9fd38747d73cb940$exports.parse = $9fd38747d73cb940$var$parse;
$9fd38747d73cb940$exports.serialize = $9fd38747d73cb940$var$serialize;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ const $9fd38747d73cb940$var$cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ const $9fd38747d73cb940$var$cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const $9fd38747d73cb940$var$domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const $9fd38747d73cb940$var$pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
const $9fd38747d73cb940$var$__toString = Object.prototype.toString;
const $9fd38747d73cb940$var$NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function $9fd38747d73cb940$var$parse(str, options) {
    const obj = new $9fd38747d73cb940$var$NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || $9fd38747d73cb940$var$decode;
    let index = 0;
    do {
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break; // No more cookie pairs.
        const colonIdx = str.indexOf(";", index);
        const endIdx = colonIdx === -1 ? len : colonIdx;
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const keyStartIdx = $9fd38747d73cb940$var$startIndex(str, index, eqIdx);
        const keyEndIdx = $9fd38747d73cb940$var$endIndex(str, eqIdx, keyStartIdx);
        const key = str.slice(keyStartIdx, keyEndIdx);
        // only assign once
        if (obj[key] === undefined) {
            let valStartIdx = $9fd38747d73cb940$var$startIndex(str, eqIdx + 1, endIdx);
            let valEndIdx = $9fd38747d73cb940$var$endIndex(str, endIdx, valStartIdx);
            const value = dec(str.slice(valStartIdx, valEndIdx));
            obj[key] = value;
        }
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
function $9fd38747d73cb940$var$startIndex(str, index, max) {
    do {
        const code = str.charCodeAt(index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index;
    }while (++index < max);
    return max;
}
function $9fd38747d73cb940$var$endIndex(str, index, min) {
    while(index > min){
        const code = str.charCodeAt(--index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index + 1;
    }
    return min;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize a name value pair into a cookie string suitable for
 * http headers. An optional options object specifies cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 */ function $9fd38747d73cb940$var$serialize(name, val, options) {
    const enc = options?.encode || encodeURIComponent;
    if (!$9fd38747d73cb940$var$cookieNameRegExp.test(name)) throw new TypeError(`argument name is invalid: ${name}`);
    const value = enc(val);
    if (!$9fd38747d73cb940$var$cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${val}`);
    let str = name + "=" + value;
    if (!options) return str;
    if (options.maxAge !== undefined) {
        if (!Number.isInteger(options.maxAge)) throw new TypeError(`option maxAge is invalid: ${options.maxAge}`);
        str += "; Max-Age=" + options.maxAge;
    }
    if (options.domain) {
        if (!$9fd38747d73cb940$var$domainValueRegExp.test(options.domain)) throw new TypeError(`option domain is invalid: ${options.domain}`);
        str += "; Domain=" + options.domain;
    }
    if (options.path) {
        if (!$9fd38747d73cb940$var$pathValueRegExp.test(options.path)) throw new TypeError(`option path is invalid: ${options.path}`);
        str += "; Path=" + options.path;
    }
    if (options.expires) {
        if (!$9fd38747d73cb940$var$isDate(options.expires) || !Number.isFinite(options.expires.valueOf())) throw new TypeError(`option expires is invalid: ${options.expires}`);
        str += "; Expires=" + options.expires.toUTCString();
    }
    if (options.httpOnly) str += "; HttpOnly";
    if (options.secure) str += "; Secure";
    if (options.partitioned) str += "; Partitioned";
    if (options.priority) {
        const priority = typeof options.priority === "string" ? options.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${options.priority}`);
        }
    }
    if (options.sameSite) {
        const sameSite = typeof options.sameSite === "string" ? options.sameSite.toLowerCase() : options.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${options.sameSite}`);
        }
    }
    return str;
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function $9fd38747d73cb940$var$decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function $9fd38747d73cb940$var$isDate(val) {
    return $9fd38747d73cb940$var$__toString.call(val) === "[object Date]";
}


var $0270cef008d49955$exports = {};
"use strict";
var $0270cef008d49955$var$defaultParseOptions = {
    decodeValues: true,
    map: false,
    silent: false
};
function $0270cef008d49955$var$isNonEmptyString(str) {
    return typeof str === "string" && !!str.trim();
}
function $0270cef008d49955$var$parseString(setCookieValue, options) {
    var parts = setCookieValue.split(";").filter($0270cef008d49955$var$isNonEmptyString);
    var nameValuePairStr = parts.shift();
    var parsed = $0270cef008d49955$var$parseNameValuePair(nameValuePairStr);
    var name = parsed.name;
    var value = parsed.value;
    options = options ? Object.assign({}, $0270cef008d49955$var$defaultParseOptions, options) : $0270cef008d49955$var$defaultParseOptions;
    try {
        value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
    } catch (e) {
        console.error("set-cookie-parser encountered an error while decoding a cookie with value '" + value + "'. Set options.decodeValues to false to disable this feature.", e);
    }
    var cookie = {
        name: name,
        value: value
    };
    parts.forEach(function(part) {
        var sides = part.split("=");
        var key = sides.shift().trimLeft().toLowerCase();
        var value = sides.join("=");
        if (key === "expires") cookie.expires = new Date(value);
        else if (key === "max-age") cookie.maxAge = parseInt(value, 10);
        else if (key === "secure") cookie.secure = true;
        else if (key === "httponly") cookie.httpOnly = true;
        else if (key === "samesite") cookie.sameSite = value;
        else if (key === "partitioned") cookie.partitioned = true;
        else cookie[key] = value;
    });
    return cookie;
}
function $0270cef008d49955$var$parseNameValuePair(nameValuePairStr) {
    // Parses name-value-pair according to rfc6265bis draft
    var name = "";
    var value = "";
    var nameValueArr = nameValuePairStr.split("=");
    if (nameValueArr.length > 1) {
        name = nameValueArr.shift();
        value = nameValueArr.join("="); // everything after the first =, joined by a "=" if there was more than one part
    } else value = nameValuePairStr;
    return {
        name: name,
        value: value
    };
}
function $0270cef008d49955$var$parse(input, options) {
    options = options ? Object.assign({}, $0270cef008d49955$var$defaultParseOptions, options) : $0270cef008d49955$var$defaultParseOptions;
    if (!input) {
        if (!options.map) return [];
        else return {};
    }
    if (input.headers) {
        if (typeof input.headers.getSetCookie === "function") // for fetch responses - they combine headers of the same type in the headers array,
        // but getSetCookie returns an uncombined array
        input = input.headers.getSetCookie();
        else if (input.headers["set-cookie"]) // fast-path for node.js (which automatically normalizes header names to lower-case
        input = input.headers["set-cookie"];
        else {
            // slow-path for other environments - see #25
            var sch = input.headers[Object.keys(input.headers).find(function(key) {
                return key.toLowerCase() === "set-cookie";
            })];
            // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
            if (!sch && input.headers.cookie && !options.silent) console.warn("Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning.");
            input = sch;
        }
    }
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!options.map) return input.filter($0270cef008d49955$var$isNonEmptyString).map(function(str) {
        return $0270cef008d49955$var$parseString(str, options);
    });
    else {
        var cookies = {};
        return input.filter($0270cef008d49955$var$isNonEmptyString).reduce(function(cookies, str) {
            var cookie = $0270cef008d49955$var$parseString(str, options);
            cookies[cookie.name] = cookie;
            return cookies;
        }, cookies);
    }
}
/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/ function $0270cef008d49955$var$splitCookiesString(cookiesString) {
    if (Array.isArray(cookiesString)) return cookiesString;
    if (typeof cookiesString !== "string") return [];
    var cookiesStrings = [];
    var pos = 0;
    var start;
    var ch;
    var lastComma;
    var nextStart;
    var cookiesSeparatorFound;
    function skipWhitespace() {
        while(pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos)))pos += 1;
        return pos < cookiesString.length;
    }
    function notSpecialChar() {
        ch = cookiesString.charAt(pos);
        return ch !== "=" && ch !== ";" && ch !== ",";
    }
    while(pos < cookiesString.length){
        start = pos;
        cookiesSeparatorFound = false;
        while(skipWhitespace()){
            ch = cookiesString.charAt(pos);
            if (ch === ",") {
                // ',' is a cookie separator if we have later first '=', not ';' or ','
                lastComma = pos;
                pos += 1;
                skipWhitespace();
                nextStart = pos;
                while(pos < cookiesString.length && notSpecialChar())pos += 1;
                // currently special character
                if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
                    // we found cookies separator
                    cookiesSeparatorFound = true;
                    // pos is inside the next cookie, so back up and return it.
                    pos = nextStart;
                    cookiesStrings.push(cookiesString.substring(start, lastComma));
                    start = pos;
                } else // in param ',' or param separator ';',
                // we continue from that comma
                pos = lastComma + 1;
            } else pos += 1;
        }
        if (!cookiesSeparatorFound || pos >= cookiesString.length) cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
    return cookiesStrings;
}
$0270cef008d49955$exports = $0270cef008d49955$var$parse;
$0270cef008d49955$exports.parse = $0270cef008d49955$var$parse;
$0270cef008d49955$exports.parseString = $0270cef008d49955$var$parseString;
$0270cef008d49955$exports.splitCookiesString = $0270cef008d49955$var$splitCookiesString;


var $618a07bedf38a2ba$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-D52XG6IA.mjs"
});
var $618a07bedf38a2ba$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($618a07bedf38a2ba$export$e19cd5f9376f8cee || {});
var $618a07bedf38a2ba$var$PopStateEventType = "popstate";
function $618a07bedf38a2ba$var$createMemoryHistory(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = $618a07bedf38a2ba$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $618a07bedf38a2ba$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $618a07bedf38a2ba$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $618a07bedf38a2ba$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $618a07bedf38a2ba$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window2.location;
        return $618a07bedf38a2ba$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $618a07bedf38a2ba$export$fe53371bee54353d(to);
    }
    return $618a07bedf38a2ba$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $618a07bedf38a2ba$var$createHashHistory(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $618a07bedf38a2ba$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $618a07bedf38a2ba$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $618a07bedf38a2ba$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $618a07bedf38a2ba$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $618a07bedf38a2ba$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $618a07bedf38a2ba$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $618a07bedf38a2ba$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $618a07bedf38a2ba$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $618a07bedf38a2ba$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function $618a07bedf38a2ba$var$createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $618a07bedf38a2ba$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $618a07bedf38a2ba$var$createKey()
    };
    return location;
}
function $618a07bedf38a2ba$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $618a07bedf38a2ba$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $618a07bedf38a2ba$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $618a07bedf38a2ba$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $618a07bedf38a2ba$var$getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $618a07bedf38a2ba$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $618a07bedf38a2ba$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        let base = window2.location.origin !== "null" ? window2.location.origin : window2.location.href;
        let href = typeof to === "string" ? to : $618a07bedf38a2ba$export$fe53371bee54353d(to);
        href = href.replace(/ $/, "%20");
        $618a07bedf38a2ba$export$f5708dca728d7177(base, `No window.location.(origin|href) available to create URL for href: ${href}`);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($618a07bedf38a2ba$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($618a07bedf38a2ba$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
// lib/router/utils.ts
var $618a07bedf38a2ba$var$immutableRouteKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $618a07bedf38a2ba$var$isIndexRoute(route) {
    return route.index === true;
}
function $618a07bedf38a2ba$var$convertRoutesToDataRoutes(routes, mapRouteProperties2, parentPath = [], manifest = {}) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $618a07bedf38a2ba$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $618a07bedf38a2ba$export$f5708dca728d7177(!manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($618a07bedf38a2ba$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id
            };
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id,
                children: void 0
            };
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $618a07bedf38a2ba$var$convertRoutesToDataRoutes(route.children, mapRouteProperties2, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
function $618a07bedf38a2ba$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $618a07bedf38a2ba$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $618a07bedf38a2ba$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $618a07bedf38a2ba$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $618a07bedf38a2ba$var$stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $618a07bedf38a2ba$var$flattenRoutes(routes);
    $618a07bedf38a2ba$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $618a07bedf38a2ba$var$decodePath(pathname);
        matches = $618a07bedf38a2ba$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $618a07bedf38a2ba$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $618a07bedf38a2ba$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "") {
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $618a07bedf38a2ba$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $618a07bedf38a2ba$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $618a07bedf38a2ba$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $618a07bedf38a2ba$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $618a07bedf38a2ba$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $618a07bedf38a2ba$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
function $618a07bedf38a2ba$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $618a07bedf38a2ba$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $618a07bedf38a2ba$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $618a07bedf38a2ba$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $618a07bedf38a2ba$var$paramRe = /^:[\w-]+$/;
var $618a07bedf38a2ba$var$dynamicSegmentValue = 3;
var $618a07bedf38a2ba$var$indexRouteValue = 2;
var $618a07bedf38a2ba$var$emptySegmentValue = 1;
var $618a07bedf38a2ba$var$staticSegmentValue = 10;
var $618a07bedf38a2ba$var$splatPenalty = -2;
var $618a07bedf38a2ba$var$isSplat = (s)=>s === "*";
function $618a07bedf38a2ba$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($618a07bedf38a2ba$var$isSplat)) initialScore += $618a07bedf38a2ba$var$splatPenalty;
    if (index) initialScore += $618a07bedf38a2ba$var$indexRouteValue;
    return segments.filter((s)=>!$618a07bedf38a2ba$var$isSplat(s)).reduce((score, segment)=>score + ($618a07bedf38a2ba$var$paramRe.test(segment) ? $618a07bedf38a2ba$var$dynamicSegmentValue : segment === "" ? $618a07bedf38a2ba$var$emptySegmentValue : $618a07bedf38a2ba$var$staticSegmentValue), initialScore);
}
function $618a07bedf38a2ba$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $618a07bedf38a2ba$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $618a07bedf38a2ba$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $618a07bedf38a2ba$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $618a07bedf38a2ba$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $618a07bedf38a2ba$var$normalizePathname($618a07bedf38a2ba$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $618a07bedf38a2ba$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $618a07bedf38a2ba$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $618a07bedf38a2ba$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $618a07bedf38a2ba$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return stringify(param);
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $618a07bedf38a2ba$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $618a07bedf38a2ba$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $618a07bedf38a2ba$var$compilePath(path, caseSensitive = false, end = true) {
    $618a07bedf38a2ba$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $618a07bedf38a2ba$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $618a07bedf38a2ba$var$warning(false, `The URL path "${value}" could not be decoded because it is is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $618a07bedf38a2ba$var$stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $618a07bedf38a2ba$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $618a07bedf38a2ba$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $618a07bedf38a2ba$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $618a07bedf38a2ba$var$normalizeSearch(search),
        hash: $618a07bedf38a2ba$var$normalizeHash(hash)
    };
}
function $618a07bedf38a2ba$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $618a07bedf38a2ba$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $618a07bedf38a2ba$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $618a07bedf38a2ba$var$getResolveToMatches(matches) {
    let pathMatches = $618a07bedf38a2ba$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $618a07bedf38a2ba$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $618a07bedf38a2ba$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $618a07bedf38a2ba$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $618a07bedf38a2ba$var$getInvalidPathError("?", "pathname", "search", to));
        $618a07bedf38a2ba$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $618a07bedf38a2ba$var$getInvalidPathError("#", "pathname", "hash", to));
        $618a07bedf38a2ba$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $618a07bedf38a2ba$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $618a07bedf38a2ba$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $618a07bedf38a2ba$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $618a07bedf38a2ba$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $618a07bedf38a2ba$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $618a07bedf38a2ba$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $618a07bedf38a2ba$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $618a07bedf38a2ba$export$4051a07651545597(data2, init) {
    return new $618a07bedf38a2ba$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $618a07bedf38a2ba$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $618a07bedf38a2ba$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $618a07bedf38a2ba$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $618a07bedf38a2ba$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $618a07bedf38a2ba$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $618a07bedf38a2ba$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $618a07bedf38a2ba$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
// lib/router/router.ts
var $618a07bedf38a2ba$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $618a07bedf38a2ba$var$validMutationMethods = new Set($618a07bedf38a2ba$var$validMutationMethodsArr);
var $618a07bedf38a2ba$var$validRequestMethodsArr = [
    "GET",
    ...$618a07bedf38a2ba$var$validMutationMethodsArr
];
var $618a07bedf38a2ba$var$validRequestMethods = new Set($618a07bedf38a2ba$var$validRequestMethodsArr);
var $618a07bedf38a2ba$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $618a07bedf38a2ba$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $618a07bedf38a2ba$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $618a07bedf38a2ba$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $618a07bedf38a2ba$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $618a07bedf38a2ba$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $618a07bedf38a2ba$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $618a07bedf38a2ba$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $618a07bedf38a2ba$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $618a07bedf38a2ba$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $618a07bedf38a2ba$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties2 = init.mapRouteProperties || $618a07bedf38a2ba$var$defaultMapRouteProperties;
    let manifest = {};
    let dataRoutes = $618a07bedf38a2ba$var$convertRoutesToDataRoutes(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $618a07bedf38a2ba$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $618a07bedf38a2ba$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        let error = $618a07bedf38a2ba$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $618a07bedf38a2ba$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
    } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) initialized = true;
    else {
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$618a07bedf38a2ba$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$618a07bedf38a2ba$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $618a07bedf38a2ba$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $618a07bedf38a2ba$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $618a07bedf38a2ba$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            $618a07bedf38a2ba$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$618a07bedf38a2ba$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $618a07bedf38a2ba$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $618a07bedf38a2ba$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $618a07bedf38a2ba$export$386d57f03f0b2883));
        }
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $618a07bedf38a2ba$var$isMutationMethod(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $618a07bedf38a2ba$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $618a07bedf38a2ba$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $618a07bedf38a2ba$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $618a07bedf38a2ba$var$createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $618a07bedf38a2ba$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $618a07bedf38a2ba$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $618a07bedf38a2ba$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $618a07bedf38a2ba$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        if (state.initialized && !isRevalidationRequired && $618a07bedf38a2ba$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $618a07bedf38a2ba$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $618a07bedf38a2ba$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $618a07bedf38a2ba$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $618a07bedf38a2ba$var$isMutationMethod(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($618a07bedf38a2ba$var$isErrorResult(result) && $618a07bedf38a2ba$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $618a07bedf38a2ba$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $618a07bedf38a2ba$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$618a07bedf38a2ba$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, isFogOfWar, opts = {}) {
        interruptActiveLoads();
        let navigation = $618a07bedf38a2ba$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $618a07bedf38a2ba$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $618a07bedf38a2ba$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $618a07bedf38a2ba$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($618a07bedf38a2ba$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $618a07bedf38a2ba$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($618a07bedf38a2ba$var$isErrorResult(result)) {
            let boundaryMatch = $618a07bedf38a2ba$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        let loadingNavigation = overrideNavigation || $618a07bedf38a2ba$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $618a07bedf38a2ba$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $618a07bedf38a2ba$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $618a07bedf38a2ba$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $618a07bedf38a2ba$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$618a07bedf38a2ba$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $618a07bedf38a2ba$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $618a07bedf38a2ba$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $618a07bedf38a2ba$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$618a07bedf38a2ba$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $618a07bedf38a2ba$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $618a07bedf38a2ba$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $618a07bedf38a2ba$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $618a07bedf38a2ba$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $618a07bedf38a2ba$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $618a07bedf38a2ba$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $618a07bedf38a2ba$var$isMutationMethod(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $618a07bedf38a2ba$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $618a07bedf38a2ba$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $618a07bedf38a2ba$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $618a07bedf38a2ba$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $618a07bedf38a2ba$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($618a07bedf38a2ba$var$isRedirectResult(actionResult) || $618a07bedf38a2ba$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $618a07bedf38a2ba$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($618a07bedf38a2ba$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $618a07bedf38a2ba$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $618a07bedf38a2ba$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($618a07bedf38a2ba$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $618a07bedf38a2ba$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $618a07bedf38a2ba$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $618a07bedf38a2ba$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $618a07bedf38a2ba$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $618a07bedf38a2ba$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $618a07bedf38a2ba$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect2 = $618a07bedf38a2ba$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $618a07bedf38a2ba$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $618a07bedf38a2ba$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        if (state.fetchers.has(key)) {
            let doneFetcher = $618a07bedf38a2ba$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $618a07bedf38a2ba$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $618a07bedf38a2ba$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $618a07bedf38a2ba$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $618a07bedf38a2ba$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $618a07bedf38a2ba$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $618a07bedf38a2ba$var$getTargetMatch(matches, path);
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $618a07bedf38a2ba$var$getDoneFetcher(void 0));
            return;
        }
        if ($618a07bedf38a2ba$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $618a07bedf38a2ba$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($618a07bedf38a2ba$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $618a07bedf38a2ba$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $618a07bedf38a2ba$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $618a07bedf38a2ba$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $618a07bedf38a2ba$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser2) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($618a07bedf38a2ba$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $618a07bedf38a2ba$var$stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $618a07bedf38a2ba$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($618a07bedf38a2ba$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $618a07bedf38a2ba$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $618a07bedf38a2ba$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(type, state2, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $618a07bedf38a2ba$var$callDataStrategyImpl(dataStrategyImpl, type, state2, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties2);
        } catch (e) {
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($618a07bedf38a2ba$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $618a07bedf38a2ba$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $618a07bedf38a2ba$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state2, matches, matchesToLoad, fetchersToLoad, request) {
        let loaderResultsPromise = callDataStrategy("loader", state2, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state2, $618a07bedf38a2ba$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $618a07bedf38a2ba$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $618a07bedf38a2ba$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $618a07bedf38a2ba$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $618a07bedf38a2ba$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $618a07bedf38a2ba$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $618a07bedf38a2ba$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $618a07bedf38a2ba$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $618a07bedf38a2ba$export$386d57f03f0b2883;
        $618a07bedf38a2ba$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $618a07bedf38a2ba$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $618a07bedf38a2ba$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $618a07bedf38a2ba$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $618a07bedf38a2ba$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$618a07bedf38a2ba$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $618a07bedf38a2ba$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $618a07bedf38a2ba$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $618a07bedf38a2ba$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $618a07bedf38a2ba$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $618a07bedf38a2ba$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $618a07bedf38a2ba$var$convertRoutesToDataRoutes(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $618a07bedf38a2ba$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
function $618a07bedf38a2ba$var$createStaticHandler(routes, opts) {
    $618a07bedf38a2ba$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties2 = opts?.mapRouteProperties || $618a07bedf38a2ba$var$defaultMapRouteProperties;
    let dataRoutes = $618a07bedf38a2ba$var$convertRoutesToDataRoutes(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $618a07bedf38a2ba$var$createLocation("", $618a07bedf38a2ba$export$fe53371bee54353d(url), null, "default");
        let matches = $618a07bedf38a2ba$export$2708184779ceb39d(dataRoutes, location, basename);
        if (!$618a07bedf38a2ba$var$isValidMethod(method) && method !== "HEAD") {
            let error = $618a07bedf38a2ba$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $618a07bedf38a2ba$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        } else if (!matches) {
            let error = $618a07bedf38a2ba$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $618a07bedf38a2ba$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($618a07bedf38a2ba$var$isResponse(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $618a07bedf38a2ba$var$createLocation("", $618a07bedf38a2ba$export$fe53371bee54353d(url), null, "default");
        let matches = $618a07bedf38a2ba$export$2708184779ceb39d(dataRoutes, location, basename);
        if (!$618a07bedf38a2ba$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $618a07bedf38a2ba$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $618a07bedf38a2ba$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $618a07bedf38a2ba$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $618a07bedf38a2ba$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $618a07bedf38a2ba$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($618a07bedf38a2ba$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : void 0;
        if (error !== void 0) throw error;
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) return Object.values(result.loaderData)[0];
        return void 0;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $618a07bedf38a2ba$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($618a07bedf38a2ba$var$isMutationMethod(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $618a07bedf38a2ba$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $618a07bedf38a2ba$var$isResponse(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($618a07bedf38a2ba$var$isDataStrategyResult(e) && $618a07bedf38a2ba$var$isResponse(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($618a07bedf38a2ba$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $618a07bedf38a2ba$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $618a07bedf38a2ba$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($618a07bedf38a2ba$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($618a07bedf38a2ba$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($618a07bedf38a2ba$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $618a07bedf38a2ba$var$findNearestBoundary(matches, actionMatch.route.id);
            let context2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...context2,
                statusCode: $618a07bedf38a2ba$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return {
            ...context,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $618a07bedf38a2ba$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $618a07bedf38a2ba$var$isErrorResult(pendingActionResult[1]) ? $618a07bedf38a2ba$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $618a07bedf38a2ba$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $618a07bedf38a2ba$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let context = $618a07bedf38a2ba$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return {
            ...context,
            matches: matches
        };
    }
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $618a07bedf38a2ba$var$callDataStrategyImpl(dataStrategy || $618a07bedf38a2ba$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties2, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($618a07bedf38a2ba$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $618a07bedf38a2ba$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if ($618a07bedf38a2ba$var$isResponse(result.result) && isRouteRequest) throw result;
            dataResults[match.route.id] = await $618a07bedf38a2ba$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $618a07bedf38a2ba$var$getStaticContextFromError(routes, context, error) {
    let newContext = {
        ...context,
        statusCode: $618a07bedf38a2ba$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    };
    return newContext;
}
function $618a07bedf38a2ba$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $618a07bedf38a2ba$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $618a07bedf38a2ba$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $618a07bedf38a2ba$var$resolveTo(to ? to : ".", $618a07bedf38a2ba$var$getResolveToMatches(contextualMatches), $618a07bedf38a2ba$var$stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $618a07bedf38a2ba$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $618a07bedf38a2ba$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $618a07bedf38a2ba$export$fe53371bee54353d(path);
}
function $618a07bedf38a2ba$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$618a07bedf38a2ba$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$618a07bedf38a2ba$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $618a07bedf38a2ba$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $618a07bedf38a2ba$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $618a07bedf38a2ba$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$618a07bedf38a2ba$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$618a07bedf38a2ba$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $618a07bedf38a2ba$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $618a07bedf38a2ba$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $618a07bedf38a2ba$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $618a07bedf38a2ba$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $618a07bedf38a2ba$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($618a07bedf38a2ba$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $618a07bedf38a2ba$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $618a07bedf38a2ba$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $618a07bedf38a2ba$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $618a07bedf38a2ba$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary = false) {
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $618a07bedf38a2ba$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $618a07bedf38a2ba$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let boundaryMatches = matches;
    if (initialHydration && state.errors) boundaryMatches = $618a07bedf38a2ba$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $618a07bedf38a2ba$var$isErrorResult(pendingActionResult[1])) boundaryMatches = $618a07bedf38a2ba$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) return true;
        if (route.loader == null) return false;
        if (initialHydration) return $618a07bedf38a2ba$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        if ($618a07bedf38a2ba$var$isNewLoader(state.loaderData, state.matches[index], match)) return true;
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $618a07bedf38a2ba$var$shouldRevalidateLoader(match, {
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params,
            ...submission,
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $618a07bedf38a2ba$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        });
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcherMatches = $618a07bedf38a2ba$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $618a07bedf38a2ba$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === void 0) shouldRevalidate = isRevalidationRequired;
        else shouldRevalidate = $618a07bedf38a2ba$var$shouldRevalidateLoader(fetcherMatch, {
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params,
            ...submission,
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        });
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $618a07bedf38a2ba$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== void 0;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function $618a07bedf38a2ba$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $618a07bedf38a2ba$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $618a07bedf38a2ba$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $618a07bedf38a2ba$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $618a07bedf38a2ba$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$618a07bedf38a2ba$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $618a07bedf38a2ba$var$convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties2, [
        routeId || "_",
        "patch",
        String(childrenToPatch?.length || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $618a07bedf38a2ba$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>existingRoute.children?.some((bChild)=>$618a07bedf38a2ba$var$isSameRoute(aChild, bChild)));
}
async function $618a07bedf38a2ba$var$loadLazyRouteModule(route, mapRouteProperties2, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $618a07bedf38a2ba$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $618a07bedf38a2ba$var$warning(!isPropertyStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
        if (!isPropertyStaticallyDefined && !$618a07bedf38a2ba$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    Object.assign(routeToUpdate, routeUpdates);
    Object.assign(routeToUpdate, {
        // To keep things framework agnostic, we use the provided `mapRouteProperties`
        // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
        // since the logic will differ between frameworks.
        ...mapRouteProperties2(routeToUpdate),
        lazy: void 0
    });
}
async function $618a07bedf38a2ba$var$defaultDataStrategy({ matches: matches }) {
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $618a07bedf38a2ba$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties2, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $618a07bedf38a2ba$var$loadLazyRouteModule(m.route, mapRouteProperties2, manifest) : void 0);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $618a07bedf38a2ba$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        };
        return {
            ...match,
            shouldLoad: shouldLoad,
            resolve: resolve
        };
    });
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {}
    return results;
}
async function $618a07bedf38a2ba$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (loadRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $618a07bedf38a2ba$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $618a07bedf38a2ba$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $618a07bedf38a2ba$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($618a07bedf38a2ba$var$isResponse(result)) {
        let data2;
        try {
            let contentType = result.headers.get("Content-Type");
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data2 = null;
                else data2 = await result.json();
            } else data2 = await result.text();
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $618a07bedf38a2ba$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($618a07bedf38a2ba$var$isDataWithResponseInit(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status
            };
            result = new $618a07bedf38a2ba$export$f2680fa305b734ca(result.init?.status || 500, void 0, result.data);
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $618a07bedf38a2ba$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($618a07bedf38a2ba$var$isDataWithResponseInit(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $618a07bedf38a2ba$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $618a07bedf38a2ba$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$618a07bedf38a2ba$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $618a07bedf38a2ba$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $618a07bedf38a2ba$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($618a07bedf38a2ba$var$ABSOLUTE_URL_REGEX.test(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $618a07bedf38a2ba$var$stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function $618a07bedf38a2ba$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($618a07bedf38a2ba$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $618a07bedf38a2ba$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $618a07bedf38a2ba$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $618a07bedf38a2ba$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $618a07bedf38a2ba$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $618a07bedf38a2ba$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $618a07bedf38a2ba$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $618a07bedf38a2ba$export$f5708dca728d7177(!$618a07bedf38a2ba$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($618a07bedf38a2ba$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $618a07bedf38a2ba$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $618a07bedf38a2ba$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $618a07bedf38a2ba$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $618a07bedf38a2ba$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $618a07bedf38a2ba$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $618a07bedf38a2ba$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if (controller && controller.signal.aborted) return;
        else if ($618a07bedf38a2ba$var$isErrorResult(result)) {
            let boundaryMatch = $618a07bedf38a2ba$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($618a07bedf38a2ba$var$isRedirectResult(result)) $618a07bedf38a2ba$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $618a07bedf38a2ba$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $618a07bedf38a2ba$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $618a07bedf38a2ba$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $618a07bedf38a2ba$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $618a07bedf38a2ba$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $618a07bedf38a2ba$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $618a07bedf38a2ba$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $618a07bedf38a2ba$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $618a07bedf38a2ba$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $618a07bedf38a2ba$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($618a07bedf38a2ba$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $618a07bedf38a2ba$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $618a07bedf38a2ba$export$8ccf933b0513f8d0(path) : path;
    return $618a07bedf38a2ba$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $618a07bedf38a2ba$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $618a07bedf38a2ba$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $618a07bedf38a2ba$var$isRedirectDataStrategyResult(result) {
    return $618a07bedf38a2ba$var$isResponse(result.result) && $618a07bedf38a2ba$var$redirectStatusCodes.has(result.result.status);
}
function $618a07bedf38a2ba$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $618a07bedf38a2ba$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $618a07bedf38a2ba$var$isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $618a07bedf38a2ba$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $618a07bedf38a2ba$var$isRedirectStatusCode(statusCode) {
    return $618a07bedf38a2ba$var$redirectStatusCodes.has(statusCode);
}
function $618a07bedf38a2ba$var$isRedirectResponse(result) {
    return $618a07bedf38a2ba$var$isResponse(result) && $618a07bedf38a2ba$var$isRedirectStatusCode(result.status) && result.headers.has("Location");
}
function $618a07bedf38a2ba$var$isValidMethod(method) {
    return $618a07bedf38a2ba$var$validRequestMethods.has(method.toUpperCase());
}
function $618a07bedf38a2ba$var$isMutationMethod(method) {
    return $618a07bedf38a2ba$var$validMutationMethods.has(method.toUpperCase());
}
function $618a07bedf38a2ba$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $618a07bedf38a2ba$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $618a07bedf38a2ba$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $618a07bedf38a2ba$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $618a07bedf38a2ba$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $618a07bedf38a2ba$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $618a07bedf38a2ba$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $618a07bedf38a2ba$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $618a07bedf38a2ba$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $618a07bedf38a2ba$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $618a07bedf38a2ba$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $618a07bedf38a2ba$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($618a07bedf38a2ba$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $618a07bedf38a2ba$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($618a07bedf38a2ba$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $618a07bedf38a2ba$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $618a07bedf38a2ba$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $618a07bedf38a2ba$export$2eeee58951ff3c1c = $acw62.createContext(null);
$618a07bedf38a2ba$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $618a07bedf38a2ba$export$315e3ffb01f217 = $acw62.createContext(null);
$618a07bedf38a2ba$export$315e3ffb01f217.displayName = "DataRouterState";
var $618a07bedf38a2ba$export$3681f408decb40d1 = $acw62.createContext({
    isTransitioning: false
});
$618a07bedf38a2ba$export$3681f408decb40d1.displayName = "ViewTransition";
var $618a07bedf38a2ba$export$cb3f1df1bef00a39 = $acw62.createContext(/* @__PURE__ */ new Map());
$618a07bedf38a2ba$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $618a07bedf38a2ba$var$AwaitContext = $acw62.createContext(null);
$618a07bedf38a2ba$var$AwaitContext.displayName = "Await";
var $618a07bedf38a2ba$export$3044ab7fdabeaee6 = $acw62.createContext(null);
$618a07bedf38a2ba$export$3044ab7fdabeaee6.displayName = "Navigation";
var $618a07bedf38a2ba$export$e6a44b110a0c44d3 = $acw62.createContext(null);
$618a07bedf38a2ba$export$e6a44b110a0c44d3.displayName = "Location";
var $618a07bedf38a2ba$export$aac280ed165a4397 = $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$618a07bedf38a2ba$export$aac280ed165a4397.displayName = "Route";
var $618a07bedf38a2ba$var$RouteErrorContext = $acw62.createContext(null);
$618a07bedf38a2ba$var$RouteErrorContext.displayName = "RouteError";
var $618a07bedf38a2ba$var$ENABLE_DEV_WARNINGS = true;
function $618a07bedf38a2ba$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $618a07bedf38a2ba$export$f5708dca728d7177($618a07bedf38a2ba$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator2 } = $acw62.useContext($618a07bedf38a2ba$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $618a07bedf38a2ba$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $618a07bedf38a2ba$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator2.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $618a07bedf38a2ba$export$9c954a9d03d32f4a() {
    return $acw62.useContext($618a07bedf38a2ba$export$e6a44b110a0c44d3) != null;
}
function $618a07bedf38a2ba$export$45d76561a5302f2b() {
    $618a07bedf38a2ba$export$f5708dca728d7177($618a07bedf38a2ba$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $acw62.useContext($618a07bedf38a2ba$export$e6a44b110a0c44d3).location;
}
function $618a07bedf38a2ba$export$1b3f31771c5d07c() {
    return $acw62.useContext($618a07bedf38a2ba$export$e6a44b110a0c44d3).navigationType;
}
function $618a07bedf38a2ba$export$6c330e8992e8a295(pattern) {
    $618a07bedf38a2ba$export$f5708dca728d7177($618a07bedf38a2ba$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $618a07bedf38a2ba$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>$618a07bedf38a2ba$export$81336c211d5ff295(pattern, $618a07bedf38a2ba$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $618a07bedf38a2ba$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $618a07bedf38a2ba$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($618a07bedf38a2ba$export$3044ab7fdabeaee6).static;
    if (!isStatic) $acw62.useLayoutEffect(cb);
}
function $618a07bedf38a2ba$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($618a07bedf38a2ba$export$aac280ed165a4397);
    return isDataRoute ? $618a07bedf38a2ba$var$useNavigateStable() : $618a07bedf38a2ba$var$useNavigateUnstable();
}
function $618a07bedf38a2ba$var$useNavigateUnstable() {
    $618a07bedf38a2ba$export$f5708dca728d7177($618a07bedf38a2ba$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $acw62.useContext($618a07bedf38a2ba$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator2 } = $acw62.useContext($618a07bedf38a2ba$export$3044ab7fdabeaee6);
    let { matches: matches } = $acw62.useContext($618a07bedf38a2ba$export$aac280ed165a4397);
    let { pathname: locationPathname } = $618a07bedf38a2ba$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($618a07bedf38a2ba$var$getResolveToMatches(matches));
    let activeRef = $acw62.useRef(false);
    $618a07bedf38a2ba$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback((to, options = {})=>{
        $618a07bedf38a2ba$var$warning(activeRef.current, $618a07bedf38a2ba$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator2.go(to);
            return;
        }
        let path = $618a07bedf38a2ba$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $618a07bedf38a2ba$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator2.replace : navigator2.push)(path, options.state, options);
    }, [
        basename,
        navigator2,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $618a07bedf38a2ba$var$OutletContext = $acw62.createContext(null);
function $618a07bedf38a2ba$export$4138103a3ae699cc() {
    return $acw62.useContext($618a07bedf38a2ba$var$OutletContext);
}
function $618a07bedf38a2ba$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($618a07bedf38a2ba$export$aac280ed165a4397).outlet;
    if (outlet) return /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
function $618a07bedf38a2ba$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($618a07bedf38a2ba$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $618a07bedf38a2ba$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $acw62.useContext($618a07bedf38a2ba$export$aac280ed165a4397);
    let { pathname: locationPathname } = $618a07bedf38a2ba$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($618a07bedf38a2ba$var$getResolveToMatches(matches));
    return $acw62.useMemo(()=>$618a07bedf38a2ba$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $618a07bedf38a2ba$export$5d3fca4a98652595(routes, locationArg) {
    return $618a07bedf38a2ba$var$useRoutesImpl(routes, locationArg);
}
function $618a07bedf38a2ba$var$useRoutesImpl(routes, locationArg, dataRouterState, future) {
    $618a07bedf38a2ba$export$f5708dca728d7177($618a07bedf38a2ba$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator2 } = $acw62.useContext($618a07bedf38a2ba$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $acw62.useContext($618a07bedf38a2ba$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($618a07bedf38a2ba$var$ENABLE_DEV_WARNINGS) {
        let parentPath = parentRoute && parentRoute.path || "";
        $618a07bedf38a2ba$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $618a07bedf38a2ba$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $618a07bedf38a2ba$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $618a07bedf38a2ba$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $618a07bedf38a2ba$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($618a07bedf38a2ba$var$ENABLE_DEV_WARNINGS) {
        $618a07bedf38a2ba$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $618a07bedf38a2ba$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $618a07bedf38a2ba$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $618a07bedf38a2ba$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator2.encodeLocation ? navigator2.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $618a07bedf38a2ba$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator2.encodeLocation ? navigator2.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $618a07bedf38a2ba$var$DefaultErrorComponent() {
    let error = $618a07bedf38a2ba$export$ed527bf60f6e05f2();
    let message = $618a07bedf38a2ba$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($618a07bedf38a2ba$var$ENABLE_DEV_WARNINGS) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $acw62.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $618a07bedf38a2ba$var$defaultErrorElement = /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$var$DefaultErrorComponent, null);
var $618a07bedf38a2ba$var$RenderErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== void 0 ? /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
};
function $618a07bedf38a2ba$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $acw62.useContext($618a07bedf38a2ba$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $618a07bedf38a2ba$var$_renderMatches(matches, parentMatches = [], dataRouterState = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $618a07bedf38a2ba$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $618a07bedf38a2ba$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $618a07bedf38a2ba$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
function $618a07bedf38a2ba$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $618a07bedf38a2ba$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($618a07bedf38a2ba$export$2eeee58951ff3c1c);
    $618a07bedf38a2ba$export$f5708dca728d7177(ctx, $618a07bedf38a2ba$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $618a07bedf38a2ba$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($618a07bedf38a2ba$export$315e3ffb01f217);
    $618a07bedf38a2ba$export$f5708dca728d7177(state, $618a07bedf38a2ba$var$getDataRouterConsoleError(hookName));
    return state;
}
function $618a07bedf38a2ba$var$useRouteContext(hookName) {
    let route = $acw62.useContext($618a07bedf38a2ba$export$aac280ed165a4397);
    $618a07bedf38a2ba$export$f5708dca728d7177(route, $618a07bedf38a2ba$var$getDataRouterConsoleError(hookName));
    return route;
}
function $618a07bedf38a2ba$var$useCurrentRouteId(hookName) {
    let route = $618a07bedf38a2ba$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $618a07bedf38a2ba$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $618a07bedf38a2ba$var$useRouteId() {
    return $618a07bedf38a2ba$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $618a07bedf38a2ba$export$d0fd4b7106de2769() {
    let state = $618a07bedf38a2ba$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $618a07bedf38a2ba$export$600dc272ed516c15() {
    let dataRouterContext = $618a07bedf38a2ba$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $618a07bedf38a2ba$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    return $acw62.useMemo(()=>({
            async revalidate () {
                await dataRouterContext.router.revalidate();
            },
            state: state.revalidation
        }), [
        dataRouterContext.router,
        state.revalidation
    ]);
}
function $618a07bedf38a2ba$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $618a07bedf38a2ba$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $acw62.useMemo(()=>matches.map((m)=>$618a07bedf38a2ba$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $618a07bedf38a2ba$export$1448a5050d252c4d() {
    let state = $618a07bedf38a2ba$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $618a07bedf38a2ba$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $618a07bedf38a2ba$export$fd5d37484eab868d(routeId) {
    let state = $618a07bedf38a2ba$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $618a07bedf38a2ba$export$fdc00f3f26066d5e() {
    let state = $618a07bedf38a2ba$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $618a07bedf38a2ba$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $618a07bedf38a2ba$export$ed527bf60f6e05f2() {
    let error = $acw62.useContext($618a07bedf38a2ba$var$RouteErrorContext);
    let state = $618a07bedf38a2ba$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $618a07bedf38a2ba$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $618a07bedf38a2ba$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($618a07bedf38a2ba$var$AwaitContext);
    return value?._data;
}
function $618a07bedf38a2ba$export$17f53340677d5831() {
    let value = $acw62.useContext($618a07bedf38a2ba$var$AwaitContext);
    return value?._error;
}
var $618a07bedf38a2ba$var$blockerId = 0;
function $618a07bedf38a2ba$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $618a07bedf38a2ba$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $618a07bedf38a2ba$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $618a07bedf38a2ba$var$stripBasename(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $618a07bedf38a2ba$var$stripBasename(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $acw62.useEffect(()=>{
        let key = String(++$618a07bedf38a2ba$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $618a07bedf38a2ba$export$386d57f03f0b2883;
}
function $618a07bedf38a2ba$var$useNavigateStable() {
    let { router: router } = $618a07bedf38a2ba$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $618a07bedf38a2ba$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $acw62.useRef(false);
    $618a07bedf38a2ba$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(async (to, options = {})=>{
        $618a07bedf38a2ba$var$warning(activeRef.current, $618a07bedf38a2ba$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $618a07bedf38a2ba$var$alreadyWarned = {};
function $618a07bedf38a2ba$var$warningOnce(key, cond, message) {
    if (!cond && !$618a07bedf38a2ba$var$alreadyWarned[key]) {
        $618a07bedf38a2ba$var$alreadyWarned[key] = true;
        $618a07bedf38a2ba$var$warning(false, message);
    }
}
// lib/server-runtime/warnings.ts
var $618a07bedf38a2ba$var$alreadyWarned2 = {};
function $618a07bedf38a2ba$var$warnOnce(condition, message) {
    if (!condition && !$618a07bedf38a2ba$var$alreadyWarned2[message]) {
        $618a07bedf38a2ba$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $618a07bedf38a2ba$var$ENABLE_DEV_WARNINGS2 = true;
function $618a07bedf38a2ba$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($618a07bedf38a2ba$var$ENABLE_DEV_WARNINGS2) {
            if (route.element) $618a07bedf38a2ba$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $acw62.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($618a07bedf38a2ba$var$ENABLE_DEV_WARNINGS2) {
            if (route.hydrateFallbackElement) $618a07bedf38a2ba$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $acw62.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($618a07bedf38a2ba$var$ENABLE_DEV_WARNINGS2) {
            if (route.errorElement) $618a07bedf38a2ba$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $acw62.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
function $618a07bedf38a2ba$export$f30f7e456d254e83(routes, opts) {
    return $618a07bedf38a2ba$export$baddd0131ee8c05b({
        basename: opts?.basename,
        future: opts?.future,
        history: $618a07bedf38a2ba$var$createMemoryHistory({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        mapRouteProperties: $618a07bedf38a2ba$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation
    }).initialize();
}
var $618a07bedf38a2ba$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $618a07bedf38a2ba$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl }) {
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(/* @__PURE__ */ new Map());
    let setState = $acw62.useCallback((newState, { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        $618a07bedf38a2ba$var$warnOnce(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $618a07bedf38a2ba$var$warnOnce(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else $acw62.startTransition(()=>setStateImpl(newState));
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $618a07bedf38a2ba$var$Deferred());
    }, [
        vtContext
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                $acw62.startTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator2 = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator2,
            static: false,
            basename: basename
        }), [
        router,
        navigator2,
        basename
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator2
    }, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), null);
}
var $618a07bedf38a2ba$var$MemoizedDataRoutes = $acw62.memo($618a07bedf38a2ba$var$DataRoutes);
function $618a07bedf38a2ba$var$DataRoutes({ routes: routes, future: future, state: state }) {
    return $618a07bedf38a2ba$var$useRoutesImpl(routes, void 0, state, future);
}
function $618a07bedf38a2ba$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $618a07bedf38a2ba$var$createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $618a07bedf38a2ba$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $618a07bedf38a2ba$export$f5708dca728d7177($618a07bedf38a2ba$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $acw62.useContext($618a07bedf38a2ba$export$3044ab7fdabeaee6);
    $618a07bedf38a2ba$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $acw62.useContext($618a07bedf38a2ba$export$aac280ed165a4397);
    let { pathname: locationPathname } = $618a07bedf38a2ba$export$45d76561a5302f2b();
    let navigate = $618a07bedf38a2ba$export$9770f232ac06a008();
    let path = $618a07bedf38a2ba$var$resolveTo(to, $618a07bedf38a2ba$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $618a07bedf38a2ba$export$910ae8079b2c2852(props) {
    return $618a07bedf38a2ba$export$a3be3530d8e40d0b(props.context);
}
function $618a07bedf38a2ba$export$e7b0ac011bb776c6(_props) {
    $618a07bedf38a2ba$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $618a07bedf38a2ba$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator2, static: staticProp = false }) {
    $618a07bedf38a2ba$export$f5708dca728d7177(!$618a07bedf38a2ba$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator2,
            static: staticProp,
            future: {}
        }), [
        basename,
        navigator2,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = $618a07bedf38a2ba$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = $618a07bedf38a2ba$var$stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    $618a07bedf38a2ba$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $618a07bedf38a2ba$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $618a07bedf38a2ba$export$5d3fca4a98652595($618a07bedf38a2ba$export$16da398f5434bdec(children), location);
}
function $618a07bedf38a2ba$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    return /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$var$ResolveAwait, null, children));
}
var $618a07bedf38a2ba$var$AwaitErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $618a07bedf38a2ba$var$ResolveAwait({ children: children }) {
    let data2 = $618a07bedf38a2ba$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, toRender);
}
function $618a07bedf38a2ba$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!$acw62.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            routes.push.apply(routes, $618a07bedf38a2ba$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $618a07bedf38a2ba$export$f5708dca728d7177(element.type === $618a07bedf38a2ba$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $618a07bedf38a2ba$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $618a07bedf38a2ba$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $618a07bedf38a2ba$export$9b5b6d122dea0c88 = $618a07bedf38a2ba$export$16da398f5434bdec;
function $618a07bedf38a2ba$export$daf73786167a7f72(matches) {
    return $618a07bedf38a2ba$var$_renderMatches(matches);
}
// lib/dom/dom.ts
var $618a07bedf38a2ba$var$defaultMethod = "get";
var $618a07bedf38a2ba$var$defaultEncType = "application/x-www-form-urlencoded";
function $618a07bedf38a2ba$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $618a07bedf38a2ba$var$isButtonElement(object) {
    return $618a07bedf38a2ba$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $618a07bedf38a2ba$var$isFormElement(object) {
    return $618a07bedf38a2ba$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $618a07bedf38a2ba$var$isInputElement(object) {
    return $618a07bedf38a2ba$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $618a07bedf38a2ba$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $618a07bedf38a2ba$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$618a07bedf38a2ba$var$isModifiedEvent(event);
}
function $618a07bedf38a2ba$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $618a07bedf38a2ba$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $618a07bedf38a2ba$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $618a07bedf38a2ba$var$_formDataSupportsSubmitter = null;
function $618a07bedf38a2ba$var$isFormDataSubmitterSupported() {
    if ($618a07bedf38a2ba$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $618a07bedf38a2ba$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $618a07bedf38a2ba$var$_formDataSupportsSubmitter = true;
    }
    return $618a07bedf38a2ba$var$_formDataSupportsSubmitter;
}
var $618a07bedf38a2ba$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $618a07bedf38a2ba$var$getFormEncType(encType) {
    if (encType != null && !$618a07bedf38a2ba$var$supportedFormEncTypes.has(encType)) {
        $618a07bedf38a2ba$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$618a07bedf38a2ba$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $618a07bedf38a2ba$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($618a07bedf38a2ba$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $618a07bedf38a2ba$var$stripBasename(attr, basename) : null;
        method = target.getAttribute("method") || $618a07bedf38a2ba$var$defaultMethod;
        encType = $618a07bedf38a2ba$var$getFormEncType(target.getAttribute("enctype")) || $618a07bedf38a2ba$var$defaultEncType;
        formData = new FormData(target);
    } else if ($618a07bedf38a2ba$var$isButtonElement(target) || $618a07bedf38a2ba$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $618a07bedf38a2ba$var$stripBasename(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $618a07bedf38a2ba$var$defaultMethod;
        encType = $618a07bedf38a2ba$var$getFormEncType(target.getAttribute("formenctype")) || $618a07bedf38a2ba$var$getFormEncType(form.getAttribute("enctype")) || $618a07bedf38a2ba$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$618a07bedf38a2ba$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($618a07bedf38a2ba$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $618a07bedf38a2ba$var$defaultMethod;
        action = null;
        encType = $618a07bedf38a2ba$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// lib/dom/ssr/invariant.ts
function $618a07bedf38a2ba$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/routeModules.ts
async function $618a07bedf38a2ba$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $618a07bedf38a2ba$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $618a07bedf38a2ba$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $618a07bedf38a2ba$var$getCurrentPageModulePreloadHrefs(matches, manifest);
    return $618a07bedf38a2ba$var$dedupeLinkDescriptors(descriptors, preloads);
}
async function $618a07bedf38a2ba$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$618a07bedf38a2ba$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        })));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$618a07bedf38a2ba$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    let matchingLinks = styleLinks.filter((link)=>(!link.media || window.matchMedia(link.media).matches) && !document.querySelector(`link[rel="stylesheet"][href="${link.href}"]`));
    await Promise.all(matchingLinks.map($618a07bedf38a2ba$var$prefetchStyleLink));
}
async function $618a07bedf38a2ba$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $618a07bedf38a2ba$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $618a07bedf38a2ba$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $618a07bedf38a2ba$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $618a07bedf38a2ba$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $618a07bedf38a2ba$var$dedupeLinkDescriptors(links.flat(1).filter($618a07bedf38a2ba$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $618a07bedf38a2ba$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $618a07bedf38a2ba$var$getModuleLinkHrefs(matches, manifestPatch) {
    return $618a07bedf38a2ba$var$dedupeHrefs(matches.map((match)=>{
        let route = manifestPatch.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $618a07bedf38a2ba$var$getCurrentPageModulePreloadHrefs(matches, manifest) {
    return $618a07bedf38a2ba$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $618a07bedf38a2ba$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $618a07bedf38a2ba$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $618a07bedf38a2ba$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$618a07bedf38a2ba$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($618a07bedf38a2ba$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $618a07bedf38a2ba$var$_isPreloadSupported;
function $618a07bedf38a2ba$var$isPreloadSupported() {
    if ($618a07bedf38a2ba$var$_isPreloadSupported !== void 0) return $618a07bedf38a2ba$var$_isPreloadSupported;
    let el = document.createElement("link");
    $618a07bedf38a2ba$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $618a07bedf38a2ba$var$_isPreloadSupported;
}
// lib/dom/ssr/markup.ts
var $618a07bedf38a2ba$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $618a07bedf38a2ba$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $618a07bedf38a2ba$var$escapeHtml(html) {
    return html.replace($618a07bedf38a2ba$var$ESCAPE_REGEX, (match)=>$618a07bedf38a2ba$var$ESCAPE_LOOKUP[match]);
}
function $618a07bedf38a2ba$var$createHtml(html) {
    return {
        __html: html
    };
}
// lib/dom/ssr/data.ts
async function $618a07bedf38a2ba$var$createRequestInit(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/single-fetch.tsx
var $618a07bedf38a2ba$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
function $618a07bedf38a2ba$var$StreamTransfer({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$618a07bedf38a2ba$var$escapeHtml(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$var$StreamTransfer, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $618a07bedf38a2ba$export$c7c51be9b423c4d6(manifest, routeModules, getRouter) {
    return async ({ request: request, matches: matches, fetcherKey: fetcherKey })=>{
        if (request.method !== "GET") return $618a07bedf38a2ba$var$singleFetchActionStrategy(request, matches);
        if (fetcherKey) return $618a07bedf38a2ba$var$singleFetchLoaderFetcherStrategy(request, matches);
        return $618a07bedf38a2ba$var$singleFetchLoaderNavigationStrategy(manifest, routeModules, getRouter(), request, matches);
    };
}
async function $618a07bedf38a2ba$var$singleFetchActionStrategy(request, matches) {
    let actionMatch = matches.find((m)=>m.shouldLoad);
    $618a07bedf38a2ba$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let url = $618a07bedf38a2ba$var$singleFetchUrl(request.url);
            let init = await $618a07bedf38a2ba$var$createRequestInit(request);
            let { data: data2, status: status } = await $618a07bedf38a2ba$var$fetchAndDecode(url, init);
            actionStatus = status;
            return $618a07bedf38a2ba$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($618a07bedf38a2ba$var$isResponse(result.result) || $618a07bedf38a2ba$export$972111febbeef05b(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $618a07bedf38a2ba$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $618a07bedf38a2ba$var$singleFetchLoaderNavigationStrategy(manifest, routeModules, router, request, matches) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = matches.map(()=>$618a07bedf38a2ba$var$createDeferred2());
    let routesLoadedPromise = Promise.all(routeDfds.map((d)=>d.promise));
    let singleFetchDfd = $618a07bedf38a2ba$var$createDeferred2();
    let url = $618a07bedf38a2ba$var$stripIndexParam($618a07bedf38a2ba$var$singleFetchUrl(request.url));
    let init = await $618a07bedf38a2ba$var$createRequestInit(request);
    let results = {};
    let resolvePromise = Promise.all(matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let manifestRoute = manifest.routes[m.route.id];
            if (!m.shouldLoad) {
                if (!router.state.initialized) return;
                if (m.route.id in router.state.loaderData && manifestRoute && manifestRoute.hasLoader && routeModules[m.route.id]?.shouldRevalidate) {
                    foundOptOutRoute = true;
                    return;
                }
            }
            if (manifestRoute && manifestRoute.hasClientLoader) {
                if (manifestRoute.hasLoader) foundOptOutRoute = true;
                try {
                    let result = await $618a07bedf38a2ba$var$fetchSingleLoader(handler, url, init, m.route.id);
                    results[m.route.id] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[m.route.id] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (manifestRoute && manifestRoute.hasLoader) routesParams.add(m.route.id);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $618a07bedf38a2ba$var$unwrapSingleFetchResults(data2, m.route.id);
                });
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await routesLoadedPromise;
    if ((!router.state.initialized || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({});
    else try {
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", matches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        let data2 = await $618a07bedf38a2ba$var$fetchAndDecode(url, init);
        singleFetchDfd.resolve(data2.data);
    } catch (e) {
        singleFetchDfd.reject(e);
    }
    await resolvePromise;
    return results;
}
async function $618a07bedf38a2ba$var$singleFetchLoaderFetcherStrategy(request, matches) {
    let fetcherMatch = matches.find((m)=>m.shouldLoad);
    $618a07bedf38a2ba$var$invariant2(fetcherMatch, "No fetcher match found");
    let result = await fetcherMatch.resolve(async (handler)=>{
        let url = $618a07bedf38a2ba$var$stripIndexParam($618a07bedf38a2ba$var$singleFetchUrl(request.url));
        let init = await $618a07bedf38a2ba$var$createRequestInit(request);
        return $618a07bedf38a2ba$var$fetchSingleLoader(handler, url, init, fetcherMatch.route.id);
    });
    return {
        [fetcherMatch.route.id]: result
    };
}
function $618a07bedf38a2ba$var$fetchSingleLoader(handler, url, init, routeId) {
    return handler(async ()=>{
        let singleLoaderUrl = new URL(url);
        singleLoaderUrl.searchParams.set("_routes", routeId);
        let { data: data2 } = await $618a07bedf38a2ba$var$fetchAndDecode(singleLoaderUrl, init);
        return $618a07bedf38a2ba$var$unwrapSingleFetchResults(data2, routeId);
    });
}
function $618a07bedf38a2ba$var$stripIndexParam(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $618a07bedf38a2ba$var$singleFetchUrl(reqUrl) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = "_root.data";
    else url.pathname = `${url.pathname.replace(/\/$/, "")}.data`;
    return url;
}
async function $618a07bedf38a2ba$var$fetchAndDecode(url, init) {
    let res = await fetch(url, init);
    if (res.status === 404 && !res.headers.has("X-Remix-Response")) throw new $618a07bedf38a2ba$export$f2680fa305b734ca(404, "Not Found", true);
    $618a07bedf38a2ba$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $618a07bedf38a2ba$export$4023ad4ecd4126a2(res.body, window);
        return {
            status: res.status,
            data: decoded.value
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $618a07bedf38a2ba$export$4023ad4ecd4126a2(body, global2) {
    return (0, $2150357b95f27254$export$2f872c0f2117be69)(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global2 && typeof global2[name] === "function") Constructor = global2[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $618a07bedf38a2ba$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$618a07bedf38a2ba$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $618a07bedf38a2ba$var$unwrapSingleFetchResults(results, routeId) {
    let redirect2 = results[$618a07bedf38a2ba$export$60644022b8b46aaa];
    if (redirect2) return $618a07bedf38a2ba$var$unwrapSingleFetchResult(redirect2, routeId);
    return results[routeId] !== void 0 ? $618a07bedf38a2ba$var$unwrapSingleFetchResult(results[routeId], routeId) : null;
}
function $618a07bedf38a2ba$var$unwrapSingleFetchResult(result, routeId) {
    if ("error" in result) throw result.error;
    else if ("redirect" in result) {
        let headers = {};
        if (result.revalidate) headers["X-Remix-Revalidate"] = "yes";
        if (result.reload) headers["X-Remix-Reload-Document"] = "yes";
        if (result.replace) headers["X-Remix-Replace"] = "yes";
        return $618a07bedf38a2ba$export$89e12c5b50f7529d(result.redirect, {
            status: result.status,
            headers: headers
        });
    } else if ("data" in result) return result.data;
    else throw new Error(`No response found for routeId "${routeId}"`);
}
function $618a07bedf38a2ba$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $618a07bedf38a2ba$export$32e57f52df4b6e34 = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $618a07bedf38a2ba$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://remix.run/guides/errors for more information."
        );
      `
        }
    });
    if ($618a07bedf38a2ba$export$972111febbeef05b(error)) return /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), heyDeveloper);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $acw62.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $618a07bedf38a2ba$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $618a07bedf38a2ba$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $acw62.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $acw62.createElement("head", null, /* @__PURE__ */ $acw62.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $acw62.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $acw62.createElement("title", null, title)), /* @__PURE__ */ $acw62.createElement("body", null, /* @__PURE__ */ $acw62.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$ff0bf87698939488, null) : null)));
}
function $618a07bedf38a2ba$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://remix.run/route/hydrate-fallback " +
                "for more information."
              );
            `
        }
    }));
}
// lib/dom/ssr/routes.tsx
function $618a07bedf38a2ba$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $618a07bedf38a2ba$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $618a07bedf38a2ba$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $618a07bedf38a2ba$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$var$RemixRootDefaultErrorBoundary, {
            error: $618a07bedf38a2ba$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $618a07bedf38a2ba$var$createServerRoutes(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $618a07bedf38a2ba$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $618a07bedf38a2ba$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$618a07bedf38a2ba$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $618a07bedf38a2ba$var$createServerRoutes(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $618a07bedf38a2ba$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, future, isSpaMode) {
    return $618a07bedf38a2ba$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, isSpaMode, "", $618a07bedf38a2ba$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $618a07bedf38a2ba$var$preventInvalidServerHandlerCall(type, route, isSpaMode) {
    if (isSpaMode) {
        let fn2 = type === "action" ? "serverAction()" : "serverLoader()";
        let msg2 = `You cannot call ${fn2} in SPA Mode (routeId: "${route.id}")`;
        console.error(msg2);
        throw new $618a07bedf38a2ba$export$f2680fa305b734ca(400, "Bad Request", new Error(msg2), true);
    }
    let fn = type === "action" ? "serverAction()" : "serverLoader()";
    let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        console.error(msg);
        throw new $618a07bedf38a2ba$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $618a07bedf38a2ba$var$noActionDefinedError(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $618a07bedf38a2ba$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $618a07bedf38a2ba$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, isSpaMode, parentId = "", routesByParentId = $618a07bedf38a2ba$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $618a07bedf38a2ba$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $618a07bedf38a2ba$var$noActionDefinedError("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $618a07bedf38a2ba$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$618a07bedf38a2ba$var$getRouteComponents(route, routeModule, isSpaMode),
                handle: routeModule.handle,
                shouldRevalidate: $618a07bedf38a2ba$var$getShouldRevalidateFunction(routeModule, route.id, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $618a07bedf38a2ba$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) {
                            if (isSpaMode) return null;
                            return fetchServerLoader(singleFetch);
                        }
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            async serverLoader () {
                                $618a07bedf38a2ba$var$preventInvalidServerHandlerCall("loader", route, isSpaMode);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $618a07bedf38a2ba$export$6ac68922d4e92125(route, routeModule, isSpaMode);
            dataRoute.action = ({ request: request, params: params }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $618a07bedf38a2ba$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $618a07bedf38a2ba$var$noActionDefinedError("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        async serverAction () {
                            $618a07bedf38a2ba$var$preventInvalidServerHandlerCall("action", route, isSpaMode);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = ({ request: request }, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) return Promise.resolve(null);
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = ({ request: request }, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $618a07bedf38a2ba$var$noActionDefinedError("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            dataRoute.lazy = async ()=>{
                let mod = await $618a07bedf38a2ba$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                let lazyRoute = {
                    ...mod
                };
                if (mod.clientLoader) {
                    let clientLoader = mod.clientLoader;
                    lazyRoute.loader = (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $618a07bedf38a2ba$var$preventInvalidServerHandlerCall("loader", route, isSpaMode);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                }
                if (mod.clientAction) {
                    let clientAction = mod.clientAction;
                    lazyRoute.action = (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $618a07bedf38a2ba$var$preventInvalidServerHandlerCall("action", route, isSpaMode);
                                return fetchServerAction(singleFetch);
                            }
                        });
                }
                return {
                    ...lazyRoute.loader ? {
                        loader: lazyRoute.loader
                    } : {},
                    ...lazyRoute.action ? {
                        action: lazyRoute.action
                    } : {},
                    hasErrorBoundary: lazyRoute.hasErrorBoundary,
                    shouldRevalidate: $618a07bedf38a2ba$var$getShouldRevalidateFunction(lazyRoute, route.id, needsRevalidation),
                    handle: lazyRoute.handle,
                    // No need to wrap these in layout since the root route is never
                    // loaded via route.lazy()
                    Component: lazyRoute.Component,
                    ErrorBoundary: lazyRoute.ErrorBoundary
                };
            };
        }
        let children = $618a07bedf38a2ba$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $618a07bedf38a2ba$var$getShouldRevalidateFunction(route, routeId, needsRevalidation) {
    if (needsRevalidation) return $618a07bedf38a2ba$var$wrapShouldRevalidateForHdr(routeId, route.shouldRevalidate, needsRevalidation);
    if (route.shouldRevalidate) {
        let fn = route.shouldRevalidate;
        return (opts)=>fn({
                ...opts,
                defaultShouldRevalidate: true
            });
    }
    return route.shouldRevalidate;
}
function $618a07bedf38a2ba$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $618a07bedf38a2ba$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModule = await $618a07bedf38a2ba$var$loadRouteModule(route, routeModules);
    await $618a07bedf38a2ba$var$prefetchStyleLinks(route, routeModule);
    return {
        Component: $618a07bedf38a2ba$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $618a07bedf38a2ba$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $618a07bedf38a2ba$export$6ac68922d4e92125(route, routeModule, isSpaMode) {
    return isSpaMode && route.id !== "root" || routeModule.clientLoader != null && (routeModule.clientLoader.hydrate === true || route.hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $618a07bedf38a2ba$var$nextPaths = /* @__PURE__ */ new Set();
var $618a07bedf38a2ba$var$discoveredPathsMaxSize = 1e3;
var $618a07bedf38a2ba$var$discoveredPaths = /* @__PURE__ */ new Set();
var $618a07bedf38a2ba$var$URL_LIMIT = 7680;
function $618a07bedf38a2ba$var$isFogOfWarEnabled(isSpaMode) {
    return !isSpaMode;
}
function $618a07bedf38a2ba$var$getPartialManifest(manifest, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $618a07bedf38a2ba$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes
    };
}
function $618a07bedf38a2ba$export$72ab377a1030deb9(manifest, routeModules, isSpaMode, basename) {
    if (!$618a07bedf38a2ba$var$isFogOfWarEnabled(isSpaMode)) return void 0;
    return async ({ path: path, patch: patch })=>{
        if ($618a07bedf38a2ba$var$discoveredPaths.has(path)) return;
        await $618a07bedf38a2ba$var$fetchAndApplyManifestPatches([
            path
        ], manifest, routeModules, isSpaMode, basename, patch);
    };
}
function $618a07bedf38a2ba$export$5ef046b23d96090d(router, manifest, routeModules, isSpaMode) {
    $acw62.useEffect(()=>{
        if (!$618a07bedf38a2ba$var$isFogOfWarEnabled(isSpaMode) || navigator.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let url = new URL(path, window.location.origin);
            if (!$618a07bedf38a2ba$var$discoveredPaths.has(url.pathname)) $618a07bedf38a2ba$var$nextPaths.add(url.pathname);
        }
        async function fetchPatches() {
            let lazyPaths = Array.from($618a07bedf38a2ba$var$nextPaths.keys()).filter((path)=>{
                if ($618a07bedf38a2ba$var$discoveredPaths.has(path)) {
                    $618a07bedf38a2ba$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $618a07bedf38a2ba$var$fetchAndApplyManifestPatches(lazyPaths, manifest, routeModules, isSpaMode, router.basename, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        document.body.querySelectorAll("a[data-discover], form[data-discover]").forEach((el)=>registerElement(el));
        fetchPatches();
        let debouncedFetchPatches = $618a07bedf38a2ba$var$debounce(fetchPatches, 100);
        function isElement(node) {
            return node.nodeType === Node.ELEMENT_NODE;
        }
        let observer = new MutationObserver((records)=>{
            let elements = /* @__PURE__ */ new Set();
            records.forEach((r)=>{
                [
                    r.target,
                    ...r.addedNodes
                ].forEach((node)=>{
                    if (!isElement(node)) return;
                    if (node.tagName === "A" && node.getAttribute("data-discover")) elements.add(node);
                    else if (node.tagName === "FORM" && node.getAttribute("data-discover")) elements.add(node);
                    if (node.tagName !== "A") node.querySelectorAll("a[data-discover], form[data-discover]").forEach((el)=>elements.add(el));
                });
            });
            elements.forEach((el)=>registerElement(el));
            debouncedFetchPatches();
        });
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        isSpaMode,
        manifest,
        routeModules,
        router
    ]);
}
async function $618a07bedf38a2ba$var$fetchAndApplyManifestPatches(paths, manifest, routeModules, isSpaMode, basename, patchRoutes) {
    let manifestPath = `${basename != null ? basename : "/"}/__manifest`.replace(/\/+/g, "/");
    let url = new URL(manifestPath, window.location.origin);
    paths.sort().forEach((path)=>url.searchParams.append("p", path));
    url.searchParams.set("version", manifest.version);
    if (url.toString().length > $618a07bedf38a2ba$var$URL_LIMIT) {
        $618a07bedf38a2ba$var$nextPaths.clear();
        return;
    }
    let res = await fetch(url);
    if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
    else if (res.status >= 400) throw new Error(await res.text());
    let serverPatches = await res.json();
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$618a07bedf38a2ba$var$addToFifoQueue(p, $618a07bedf38a2ba$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $618a07bedf38a2ba$export$af76e85f27ba0229(patches, routeModules, null, isSpaMode, parentId)));
}
function $618a07bedf38a2ba$var$addToFifoQueue(path, queue) {
    if (queue.size >= $618a07bedf38a2ba$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $618a07bedf38a2ba$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $618a07bedf38a2ba$var$useDataRouterContext2() {
    let context = $acw62.useContext($618a07bedf38a2ba$export$2eeee58951ff3c1c);
    $618a07bedf38a2ba$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $618a07bedf38a2ba$var$useDataRouterStateContext() {
    let context = $acw62.useContext($618a07bedf38a2ba$export$315e3ffb01f217);
    $618a07bedf38a2ba$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $618a07bedf38a2ba$export$208d6a3bc3aa62bd = $acw62.createContext(void 0);
$618a07bedf38a2ba$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $618a07bedf38a2ba$var$useFrameworkContext() {
    let context = $acw62.useContext($618a07bedf38a2ba$export$208d6a3bc3aa62bd);
    $618a07bedf38a2ba$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $618a07bedf38a2ba$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $acw62.useContext($618a07bedf38a2ba$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $acw62.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $acw62.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $acw62.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $618a07bedf38a2ba$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $618a07bedf38a2ba$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $618a07bedf38a2ba$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $618a07bedf38a2ba$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $618a07bedf38a2ba$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $618a07bedf38a2ba$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $618a07bedf38a2ba$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$618a07bedf38a2ba$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
function $618a07bedf38a2ba$export$b2e089eb3692b073() {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $618a07bedf38a2ba$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $618a07bedf38a2ba$var$useDataRouterStateContext();
    let matches = $618a07bedf38a2ba$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $acw62.useMemo(()=>$618a07bedf38a2ba$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, criticalCss ? /* @__PURE__ */ $acw62.createElement("style", {
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, keyedLinks.map(({ key: key, link: link })=>$618a07bedf38a2ba$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$60dcec93e67386bd, {
            key: key,
            ...link
        }) : /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            ...link
        })));
}
function $618a07bedf38a2ba$export$60dcec93e67386bd({ page: page, ...dataLinkProps }) {
    let { router: router } = $618a07bedf38a2ba$var$useDataRouterContext2();
    let matches = $acw62.useMemo(()=>$618a07bedf38a2ba$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) {
        console.warn(`Tried to prefetch ${page} but no routes matched.`);
        return null;
    }
    return /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...dataLinkProps
    });
}
function $618a07bedf38a2ba$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $618a07bedf38a2ba$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        let interrupted = false;
        $618a07bedf38a2ba$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $618a07bedf38a2ba$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $618a07bedf38a2ba$export$45d76561a5302f2b();
    let { manifest: manifest, routeModules: routeModules } = $618a07bedf38a2ba$var$useFrameworkContext();
    let { loaderData: loaderData, matches: matches } = $618a07bedf38a2ba$var$useDataRouterStateContext();
    let newMatchesForData = $acw62.useMemo(()=>$618a07bedf38a2ba$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $acw62.useMemo(()=>$618a07bedf38a2ba$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $618a07bedf38a2ba$var$singleFetchUrl(page);
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $acw62.useMemo(()=>$618a07bedf38a2ba$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $618a07bedf38a2ba$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            ...link
        })));
}
function $618a07bedf38a2ba$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $618a07bedf38a2ba$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $618a07bedf38a2ba$var$useDataRouterStateContext();
    let location = $618a07bedf38a2ba$export$45d76561a5302f2b();
    let _matches = $618a07bedf38a2ba$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$618a07bedf38a2ba$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $acw62.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $acw62.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $acw62.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $acw62.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: json
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $acw62.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $618a07bedf38a2ba$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $618a07bedf38a2ba$var$isHydrated = false;
function $618a07bedf38a2ba$export$ff0bf87698939488(props) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta } = $618a07bedf38a2ba$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $618a07bedf38a2ba$var$useDataRouterContext2();
    let { matches: routerMatches } = $618a07bedf38a2ba$var$useDataRouterStateContext();
    let enableFogOfWar = $618a07bedf38a2ba$var$isFogOfWarEnabled(isSpaMode);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $618a07bedf38a2ba$var$getActiveMatches(routerMatches, null, isSpaMode);
    $acw62.useEffect(()=>{
        $618a07bedf38a2ba$var$isHydrated = true;
    }, []);
    let initialScripts = $acw62.useMemo(()=>{
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, index)=>`import * as route${index} from ${JSON.stringify(manifest.routes[match.route.id].module)};`).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($618a07bedf38a2ba$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: $618a07bedf38a2ba$var$createHtml(contextScript),
            type: void 0
        }), /* @__PURE__ */ $acw62.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: $618a07bedf38a2ba$var$createHtml(routeModulesScript),
            type: "module",
            async: true
        }));
    }, []);
    let routePreloads = matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        return route ? (route.imports || []).concat([
            route.module
        ]) : [];
    }).flat(1);
    let preloads = $618a07bedf38a2ba$var$isHydrated ? [] : manifest.entry.imports.concat(routePreloads);
    return $618a07bedf38a2ba$var$isHydrated ? null : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, !enableFogOfWar ? /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: props.crossOrigin
    }) : null, /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: props.crossOrigin
    }), $618a07bedf38a2ba$var$dedupe(preloads).map((path)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: props.crossOrigin
        })), initialScripts);
}
function $618a07bedf38a2ba$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $618a07bedf38a2ba$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/lib.tsx
var $618a07bedf38a2ba$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($618a07bedf38a2ba$var$isBrowser) window.__reactRouterVersion = "7.0.2";
} catch (e) {}
function $618a07bedf38a2ba$export$1f3f55432a00e06d(routes, opts) {
    return $618a07bedf38a2ba$export$baddd0131ee8c05b({
        basename: opts?.basename,
        future: opts?.future,
        history: $618a07bedf38a2ba$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $618a07bedf38a2ba$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $618a07bedf38a2ba$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function $618a07bedf38a2ba$export$1ba7ed8a3a7b3765(routes, opts) {
    return $618a07bedf38a2ba$export$baddd0131ee8c05b({
        basename: opts?.basename,
        future: opts?.future,
        history: $618a07bedf38a2ba$var$createHashHistory({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $618a07bedf38a2ba$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $618a07bedf38a2ba$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function $618a07bedf38a2ba$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $618a07bedf38a2ba$var$deserializeErrors(state.errors)
    };
    return state;
}
function $618a07bedf38a2ba$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $618a07bedf38a2ba$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $618a07bedf38a2ba$export$9ba4e89fdfa1fc54({ basename: basename, children: children, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $618a07bedf38a2ba$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $618a07bedf38a2ba$export$7221d69dcfc8e36b({ basename: basename, children: children, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $618a07bedf38a2ba$var$createHashHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $618a07bedf38a2ba$export$de73885c9336221c({ basename: basename, children: children, history: history }) {
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
$618a07bedf38a2ba$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $618a07bedf38a2ba$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $618a07bedf38a2ba$export$a6c7ac8248d6e38a = $acw62.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...rest }, forwardedRef) {
    let { basename: basename } = $acw62.useContext($618a07bedf38a2ba$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $618a07bedf38a2ba$var$ABSOLUTE_URL_REGEX2.test(to);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if ($618a07bedf38a2ba$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = $618a07bedf38a2ba$var$stripBasename(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            $618a07bedf38a2ba$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
        }
    }
    let href = $618a07bedf38a2ba$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $618a07bedf38a2ba$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $618a07bedf38a2ba$export$67621102c14d847(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $acw62.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: $618a07bedf38a2ba$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, link, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$618a07bedf38a2ba$export$a6c7ac8248d6e38a.displayName = "Link";
var $618a07bedf38a2ba$export$b0d92dbee9b5b60d = $acw62.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $618a07bedf38a2ba$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $618a07bedf38a2ba$export$45d76561a5302f2b();
    let routerState = $acw62.useContext($618a07bedf38a2ba$export$315e3ffb01f217);
    let { navigator: navigator2, basename: basename } = $acw62.useContext($618a07bedf38a2ba$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $618a07bedf38a2ba$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator2.encodeLocation ? navigator2.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $618a07bedf38a2ba$var$stripBasename(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$618a07bedf38a2ba$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $618a07bedf38a2ba$export$a7fed597f4b8afd8 = $acw62.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $618a07bedf38a2ba$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...props }, forwardedRef)=>{
    let submit = $618a07bedf38a2ba$export$47c85c6e3a081d3();
    let formAction = $618a07bedf38a2ba$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $618a07bedf38a2ba$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace2,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /* @__PURE__ */ $acw62.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$618a07bedf38a2ba$export$a7fed597f4b8afd8.displayName = "Form";
function $618a07bedf38a2ba$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $acw62.useContext($618a07bedf38a2ba$export$208d6a3bc3aa62bd);
    let { basename: basename } = $acw62.useContext($618a07bedf38a2ba$export$3044ab7fdabeaee6);
    let location = $618a07bedf38a2ba$export$45d76561a5302f2b();
    let matches = $618a07bedf38a2ba$export$2378eb7f5ff86053();
    $618a07bedf38a2ba$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $acw62.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $618a07bedf38a2ba$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $acw62.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${JSON.stringify(storageKey || $618a07bedf38a2ba$var$SCROLL_RESTORATION_STORAGE_KEY)}, ${JSON.stringify(ssrKey)})`
        }
    });
}
$618a07bedf38a2ba$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $618a07bedf38a2ba$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $618a07bedf38a2ba$var$useDataRouterContext3(hookName) {
    let ctx = $acw62.useContext($618a07bedf38a2ba$export$2eeee58951ff3c1c);
    $618a07bedf38a2ba$export$f5708dca728d7177(ctx, $618a07bedf38a2ba$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $618a07bedf38a2ba$var$useDataRouterState2(hookName) {
    let state = $acw62.useContext($618a07bedf38a2ba$export$315e3ffb01f217);
    $618a07bedf38a2ba$export$f5708dca728d7177(state, $618a07bedf38a2ba$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $618a07bedf38a2ba$export$67621102c14d847(to, { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = {}) {
    let navigate = $618a07bedf38a2ba$export$9770f232ac06a008();
    let location = $618a07bedf38a2ba$export$45d76561a5302f2b();
    let path = $618a07bedf38a2ba$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($618a07bedf38a2ba$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $618a07bedf38a2ba$export$fe53371bee54353d(location) === $618a07bedf38a2ba$export$fe53371bee54353d(path);
            navigate(to, {
                replace: replace2,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
function $618a07bedf38a2ba$export$f1a78c17382fe22a(defaultInit) {
    $618a07bedf38a2ba$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $acw62.useRef($618a07bedf38a2ba$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = $618a07bedf38a2ba$export$45d76561a5302f2b();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $618a07bedf38a2ba$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $618a07bedf38a2ba$export$9770f232ac06a008();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $618a07bedf38a2ba$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $618a07bedf38a2ba$var$fetcherId = 0;
var $618a07bedf38a2ba$var$getUniqueFetcherId = ()=>`__${String(++$618a07bedf38a2ba$var$fetcherId)}__`;
function $618a07bedf38a2ba$export$47c85c6e3a081d3() {
    let { router: router } = $618a07bedf38a2ba$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $acw62.useContext($618a07bedf38a2ba$export$3044ab7fdabeaee6);
    let currentRouteId = $618a07bedf38a2ba$var$useRouteId();
    return $acw62.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $618a07bedf38a2ba$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $618a07bedf38a2ba$var$getUniqueFetcherId();
            await router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
function $618a07bedf38a2ba$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $acw62.useContext($618a07bedf38a2ba$export$3044ab7fdabeaee6);
    let routeContext = $acw62.useContext($618a07bedf38a2ba$export$aac280ed165a4397);
    $618a07bedf38a2ba$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$618a07bedf38a2ba$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $618a07bedf38a2ba$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $618a07bedf38a2ba$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $618a07bedf38a2ba$export$fe53371bee54353d(path);
}
function $618a07bedf38a2ba$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $618a07bedf38a2ba$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $618a07bedf38a2ba$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $acw62.useContext($618a07bedf38a2ba$export$cb3f1df1bef00a39);
    let route = $acw62.useContext($618a07bedf38a2ba$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $618a07bedf38a2ba$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $618a07bedf38a2ba$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $618a07bedf38a2ba$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $acw62.useId();
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>router.deleteFetcher(fetcherKey);
    }, [
        router,
        fetcherKey
    ]);
    let load = $acw62.useCallback(async (href, opts)=>{
        $618a07bedf38a2ba$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $618a07bedf38a2ba$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm2 = $acw62.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $618a07bedf38a2ba$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $618a07bedf38a2ba$export$fa996778a3a31087() {
    let state = $618a07bedf38a2ba$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $618a07bedf38a2ba$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $618a07bedf38a2ba$var$savedScrollPositions = {};
function $618a07bedf38a2ba$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $618a07bedf38a2ba$var$stripBasename(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $618a07bedf38a2ba$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $618a07bedf38a2ba$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $618a07bedf38a2ba$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $acw62.useContext($618a07bedf38a2ba$export$3044ab7fdabeaee6);
    let location = $618a07bedf38a2ba$export$45d76561a5302f2b();
    let matches = $618a07bedf38a2ba$export$2378eb7f5ff86053();
    let navigation = $618a07bedf38a2ba$export$d0fd4b7106de2769();
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $618a07bedf38a2ba$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $618a07bedf38a2ba$var$getScrollRestorationKey(location, matches, basename, getKey);
            $618a07bedf38a2ba$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $618a07bedf38a2ba$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($618a07bedf38a2ba$var$savedScrollPositions));
        } catch (error) {
            $618a07bedf38a2ba$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $618a07bedf38a2ba$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $618a07bedf38a2ba$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($618a07bedf38a2ba$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$618a07bedf38a2ba$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $acw62.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $618a07bedf38a2ba$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $618a07bedf38a2ba$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $618a07bedf38a2ba$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $618a07bedf38a2ba$export$b273b3273281a049(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $618a07bedf38a2ba$export$e262bd1977bea848(to, opts = {}) {
    let vtContext = $acw62.useContext($618a07bedf38a2ba$export$3681f408decb40d1);
    $618a07bedf38a2ba$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $618a07bedf38a2ba$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $618a07bedf38a2ba$export$e75d2a2d1b3c245b(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $618a07bedf38a2ba$var$stripBasename(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $618a07bedf38a2ba$var$stripBasename(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $618a07bedf38a2ba$export$81336c211d5ff295(path.pathname, nextPath) != null || $618a07bedf38a2ba$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $618a07bedf38a2ba$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $618a07bedf38a2ba$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $618a07bedf38a2ba$var$getStatelessNavigator();
    return /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true
    });
}
function $618a07bedf38a2ba$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate = true, nonce: nonce }) {
    $618a07bedf38a2ba$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $618a07bedf38a2ba$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $618a07bedf38a2ba$var$serializeErrors(context.errors)
        };
        let json = $618a07bedf38a2ba$var$htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static
    }, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$var$DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $acw62.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $618a07bedf38a2ba$var$DataRoutes2({ routes: routes, future: future, state: state }) {
    return $618a07bedf38a2ba$var$useRoutesImpl(routes, void 0, state, future);
}
function $618a07bedf38a2ba$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($618a07bedf38a2ba$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $618a07bedf38a2ba$var$getStatelessNavigator() {
    return {
        createHref: $618a07bedf38a2ba$var$createHref,
        encodeLocation: $618a07bedf38a2ba$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $618a07bedf38a2ba$export$3336b097a6fbc59a(routes, opts) {
    return $618a07bedf38a2ba$var$createStaticHandler(routes, {
        ...opts,
        mapRouteProperties: $618a07bedf38a2ba$export$9269a41d8c4635e
    });
}
function $618a07bedf38a2ba$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $618a07bedf38a2ba$var$convertRoutesToDataRoutes(routes, $618a07bedf38a2ba$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: $618a07bedf38a2ba$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $618a07bedf38a2ba$var$createHref,
        encodeLocation: $618a07bedf38a2ba$var$encodeLocation,
        getFetcher () {
            return $618a07bedf38a2ba$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $618a07bedf38a2ba$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        }
    };
}
function $618a07bedf38a2ba$var$createHref(to) {
    return typeof to === "string" ? to : $618a07bedf38a2ba$export$fe53371bee54353d(to);
}
function $618a07bedf38a2ba$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $618a07bedf38a2ba$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $618a07bedf38a2ba$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $618a07bedf38a2ba$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $618a07bedf38a2ba$var$ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $618a07bedf38a2ba$var$ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function $618a07bedf38a2ba$var$htmlEscape(str) {
    return str.replace($618a07bedf38a2ba$var$ESCAPE_REGEX2, (match)=>$618a07bedf38a2ba$var$ESCAPE_LOOKUP2[match]);
}
function $618a07bedf38a2ba$export$7246f7e18cebe1bd({ context: context, url: url, abortDelay: abortDelay, nonce: nonce }) {
    if (typeof url === "string") url = new URL(url);
    let { manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, serverHandoffString: serverHandoffString } = context;
    let routes = $618a07bedf38a2ba$var$createServerRoutes(manifest.routes, routeModules, context.future, context.isSpaMode);
    context.staticHandlerContext.loaderData = {
        ...context.staticHandlerContext.loaderData
    };
    for (let match of context.staticHandlerContext.matches){
        let routeId = match.route.id;
        let route = routeModules[routeId];
        let manifestRoute = context.manifest.routes[routeId];
        if (route && manifestRoute && $618a07bedf38a2ba$export$6ac68922d4e92125(manifestRoute, route, context.isSpaMode) && (route.HydrateFallback || !manifestRoute.hasLoader)) delete context.staticHandlerContext.loaderData[routeId];
    }
    let router = $618a07bedf38a2ba$export$3dd6171c30258b6f(routes, context.staticHandlerContext);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$208d6a3bc3aa62bd.Provider, {
        value: {
            manifest: manifest,
            routeModules: routeModules,
            criticalCss: criticalCss,
            serverHandoffString: serverHandoffString,
            future: context.future,
            isSpaMode: context.isSpaMode,
            serializeError: context.serializeError,
            abortDelay: abortDelay,
            renderMeta: context.renderMeta
        }
    }, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$32e57f52df4b6e34, {
        location: router.state.location
    }, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$3d80f15952491985, {
        router: router,
        context: context.staticHandlerContext,
        hydrate: false
    }))), context.serverHandoffStream ? /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$var$StreamTransfer, {
        context: context,
        identifier: 0,
        reader: context.serverHandoffStream.getReader(),
        textDecoder: new TextDecoder(),
        nonce: nonce
    })) : null);
}
function $618a07bedf38a2ba$export$bea31554c7dfd2ad(routes, context = {}) {
    return function RoutesTestStub({ initialEntries: initialEntries, initialIndex: initialIndex, hydrationData: hydrationData, future: future }) {
        let routerRef = $acw62.useRef();
        let remixContextRef = $acw62.useRef();
        if (routerRef.current == null) {
            remixContextRef.current = {
                future: {},
                manifest: {
                    routes: {},
                    entry: {
                        imports: [],
                        module: ""
                    },
                    url: "",
                    version: ""
                },
                routeModules: {},
                isSpaMode: false
            };
            let patched = $618a07bedf38a2ba$var$processRoutes(// @ts-expect-error loader/action context types don't match :/
            $618a07bedf38a2ba$var$convertRoutesToDataRoutes(routes, (r)=>r), context, remixContextRef.current.manifest, remixContextRef.current.routeModules);
            routerRef.current = $618a07bedf38a2ba$export$f30f7e456d254e83(patched, {
                initialEntries: initialEntries,
                initialIndex: initialIndex,
                hydrationData: hydrationData
            });
        }
        return /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$208d6a3bc3aa62bd.Provider, {
            value: remixContextRef.current
        }, /* @__PURE__ */ $acw62.createElement($618a07bedf38a2ba$export$323e4fc2fa4753fb, {
            router: routerRef.current
        }));
    };
}
function $618a07bedf38a2ba$var$processRoutes(routes, context, manifest, routeModules, parentId) {
    return routes.map((route)=>{
        if (!route.id) throw new Error("Expected a route.id in @remix-run/testing processRoutes() function");
        let { loader: loader, action: action } = route;
        let newRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            Component: route.Component,
            HydrateFallback: route.HydrateFallback,
            ErrorBoundary: route.ErrorBoundary,
            action: action ? (args)=>action({
                    ...args,
                    context: context
                }) : void 0,
            loader: loader ? (args)=>loader({
                    ...args,
                    context: context
                }) : void 0,
            handle: route.handle,
            shouldRevalidate: route.shouldRevalidate
        };
        let entryRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            parentId: parentId,
            hasAction: route.action != null,
            hasLoader: route.loader != null,
            // When testing routes, you should just be stubbing loader/action, not
            // trying to re-implement the full loader/clientLoader/SSR/hydration flow.
            // That is better tested via E2E tests.
            hasClientAction: false,
            hasClientLoader: false,
            hasErrorBoundary: route.ErrorBoundary != null,
            module: "build/stub-path-to-module.js"
        };
        manifest.routes[newRoute.id] = entryRoute;
        routeModules[route.id] = {
            default: route.Component || $618a07bedf38a2ba$export$910ae8079b2c2852,
            ErrorBoundary: route.ErrorBoundary || void 0,
            handle: route.handle,
            links: route.links,
            meta: route.meta,
            shouldRevalidate: route.shouldRevalidate
        };
        if (route.children) newRoute.children = $618a07bedf38a2ba$var$processRoutes(route.children, context, manifest, routeModules, newRoute.id);
        return newRoute;
    });
}
// lib/server-runtime/crypto.ts
var $618a07bedf38a2ba$var$encoder = new TextEncoder();
var $618a07bedf38a2ba$var$sign = async (value, secret)=>{
    let data2 = $618a07bedf38a2ba$var$encoder.encode(value);
    let key = await $618a07bedf38a2ba$var$createKey2(secret, [
        "sign"
    ]);
    let signature = await crypto.subtle.sign("HMAC", key, data2);
    let hash = btoa(String.fromCharCode(...new Uint8Array(signature))).replace(/=+$/, "");
    return value + "." + hash;
};
var $618a07bedf38a2ba$var$unsign = async (cookie, secret)=>{
    let index = cookie.lastIndexOf(".");
    let value = cookie.slice(0, index);
    let hash = cookie.slice(index + 1);
    let data2 = $618a07bedf38a2ba$var$encoder.encode(value);
    let key = await $618a07bedf38a2ba$var$createKey2(secret, [
        "verify"
    ]);
    let signature = $618a07bedf38a2ba$var$byteStringToUint8Array(atob(hash));
    let valid = await crypto.subtle.verify("HMAC", key, signature, data2);
    return valid ? value : false;
};
var $618a07bedf38a2ba$var$createKey2 = async (secret, usages)=>crypto.subtle.importKey("raw", $618a07bedf38a2ba$var$encoder.encode(secret), {
        name: "HMAC",
        hash: "SHA-256"
    }, false, usages);
function $618a07bedf38a2ba$var$byteStringToUint8Array(byteString) {
    let array = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)array[i] = byteString.charCodeAt(i);
    return array;
}
// lib/server-runtime/cookies.ts
var $618a07bedf38a2ba$export$7892c26d6c7a7447 = (name, cookieOptions = {})=>{
    let { secrets: secrets = [], ...options } = {
        path: "/",
        sameSite: "lax",
        ...cookieOptions
    };
    $618a07bedf38a2ba$var$warnOnceAboutExpiresCookie(name, options.expires);
    return {
        get name () {
            return name;
        },
        get isSigned () {
            return secrets.length > 0;
        },
        get expires () {
            return typeof options.maxAge !== "undefined" ? new Date(Date.now() + options.maxAge * 1e3) : options.expires;
        },
        async parse (cookieHeader, parseOptions) {
            if (!cookieHeader) return null;
            let cookies = (0, $9fd38747d73cb940$exports.parse)(cookieHeader, {
                ...options,
                ...parseOptions
            });
            if (name in cookies) {
                let value = cookies[name];
                if (typeof value === "string" && value !== "") {
                    let decoded = await $618a07bedf38a2ba$var$decodeCookieValue(value, secrets);
                    return decoded;
                } else return "";
            } else return null;
        },
        async serialize (value, serializeOptions) {
            return (0, $9fd38747d73cb940$exports.serialize)(name, value === "" ? "" : await $618a07bedf38a2ba$var$encodeCookieValue(value, secrets), {
                ...options,
                ...serializeOptions
            });
        }
    };
};
var $618a07bedf38a2ba$export$f00768c7d8d5ffdb = (object)=>{
    return object != null && typeof object.name === "string" && typeof object.isSigned === "boolean" && typeof object.parse === "function" && typeof object.serialize === "function";
};
async function $618a07bedf38a2ba$var$encodeCookieValue(value, secrets) {
    let encoded = $618a07bedf38a2ba$var$encodeData(value);
    if (secrets.length > 0) encoded = await $618a07bedf38a2ba$var$sign(encoded, secrets[0]);
    return encoded;
}
async function $618a07bedf38a2ba$var$decodeCookieValue(value, secrets) {
    if (secrets.length > 0) {
        for (let secret of secrets){
            let unsignedValue = await $618a07bedf38a2ba$var$unsign(value, secret);
            if (unsignedValue !== false) return $618a07bedf38a2ba$var$decodeData(unsignedValue);
        }
        return null;
    }
    return $618a07bedf38a2ba$var$decodeData(value);
}
function $618a07bedf38a2ba$var$encodeData(value) {
    return btoa($618a07bedf38a2ba$var$myUnescape(encodeURIComponent(JSON.stringify(value))));
}
function $618a07bedf38a2ba$var$decodeData(value) {
    try {
        return JSON.parse(decodeURIComponent($618a07bedf38a2ba$var$myEscape(atob(value))));
    } catch (error) {
        return {};
    }
}
function $618a07bedf38a2ba$var$myEscape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, code;
    while(index < str.length){
        chr = str.charAt(index++);
        if (/[\w*+\-./@]/.exec(chr)) result += chr;
        else {
            code = chr.charCodeAt(0);
            if (code < 256) result += "%" + $618a07bedf38a2ba$var$hex(code, 2);
            else result += "%u" + $618a07bedf38a2ba$var$hex(code, 4).toUpperCase();
        }
    }
    return result;
}
function $618a07bedf38a2ba$var$hex(code, length) {
    let result = code.toString(16);
    while(result.length < length)result = "0" + result;
    return result;
}
function $618a07bedf38a2ba$var$myUnescape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, part;
    while(index < str.length){
        chr = str.charAt(index++);
        if (chr === "%") {
            if (str.charAt(index) === "u") {
                part = str.slice(index + 1, index + 5);
                if (/^[\da-f]{4}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 5;
                    continue;
                }
            } else {
                part = str.slice(index, index + 2);
                if (/^[\da-f]{2}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 2;
                    continue;
                }
            }
        }
        result += chr;
    }
    return result;
}
function $618a07bedf38a2ba$var$warnOnceAboutExpiresCookie(name, expires) {
    $618a07bedf38a2ba$var$warnOnce(!expires, `The "${name}" cookie has an "expires" property set. This will cause the expires value to not be updated when the session is committed. Instead, you should set the expires value when serializing the cookie. You can use \`commitSession(session, { expires })\` if using a session storage object, or \`cookie.serialize("value", { expires })\` if you're using the cookie directly.`);
}
// lib/server-runtime/entry.ts
function $618a07bedf38a2ba$var$createEntryRouteModules(manifest) {
    return Object.keys(manifest).reduce((memo2, routeId)=>{
        let route = manifest[routeId];
        if (route) memo2[routeId] = route.module;
        return memo2;
    }, {});
}
// lib/server-runtime/mode.ts
var $618a07bedf38a2ba$export$e7973f87fd96e4f2 = /* @__PURE__ */ ((ServerMode2)=>{
    ServerMode2["Development"] = "development";
    ServerMode2["Production"] = "production";
    ServerMode2["Test"] = "test";
    return ServerMode2;
})($618a07bedf38a2ba$export$e7973f87fd96e4f2 || {});
function $618a07bedf38a2ba$var$isServerMode(value) {
    return value === "development" /* Development */  || value === "production" /* Production */  || value === "test" /* Test */ ;
}
// lib/server-runtime/errors.ts
function $618a07bedf38a2ba$var$sanitizeError(error, serverMode) {
    if (error instanceof Error && serverMode !== "development" /* Development */ ) {
        let sanitized = new Error("Unexpected Server Error");
        sanitized.stack = void 0;
        return sanitized;
    }
    return error;
}
function $618a07bedf38a2ba$var$sanitizeErrors(errors, serverMode) {
    return Object.entries(errors).reduce((acc, [routeId, error])=>{
        return Object.assign(acc, {
            [routeId]: $618a07bedf38a2ba$var$sanitizeError(error, serverMode)
        });
    }, {});
}
function $618a07bedf38a2ba$var$serializeError(error, serverMode) {
    let sanitized = $618a07bedf38a2ba$var$sanitizeError(error, serverMode);
    return {
        message: sanitized.message,
        stack: sanitized.stack
    };
}
function $618a07bedf38a2ba$var$serializeErrors2(errors, serverMode) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($618a07bedf38a2ba$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) {
            let sanitized = $618a07bedf38a2ba$var$sanitizeError(val, serverMode);
            serialized[key] = {
                message: sanitized.message,
                stack: sanitized.stack,
                __type: "Error",
                // If this is a subclass (i.e., ReferenceError), send up the type so we
                // can re-create the same type during hydration.  This will only apply
                // in dev mode since all production errors are sanitized to normal
                // Error instances
                ...sanitized.name !== "Error" ? {
                    __subType: sanitized.name
                } : {}
            };
        } else serialized[key] = val;
    }
    return serialized;
}
// lib/server-runtime/routeMatching.ts
function $618a07bedf38a2ba$var$matchServerRoutes(routes, pathname, basename) {
    let matches = $618a07bedf38a2ba$export$2708184779ceb39d(routes, pathname, basename);
    if (!matches) return null;
    return matches.map((match)=>({
            params: match.params,
            pathname: match.pathname,
            route: match.route
        }));
}
// lib/server-runtime/data.ts
async function $618a07bedf38a2ba$var$callRouteHandler(handler, args) {
    let result = await handler({
        request: $618a07bedf38a2ba$var$stripRoutesParam($618a07bedf38a2ba$var$stripIndexParam2(args.request)),
        params: args.params,
        context: args.context
    });
    if ($618a07bedf38a2ba$var$isDataWithResponseInit(result) && result.init && result.init.status && $618a07bedf38a2ba$var$isRedirectStatusCode(result.init.status)) throw new Response(null, result.init);
    return result;
}
function $618a07bedf38a2ba$var$stripIndexParam2(request) {
    let url = new URL(request.url);
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
function $618a07bedf38a2ba$var$stripRoutesParam(request) {
    let url = new URL(request.url);
    url.searchParams.delete("_routes");
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
// lib/server-runtime/invariant.ts
function $618a07bedf38a2ba$var$invariant3(value, message) {
    if (value === false || value === null || typeof value === "undefined") {
        console.error("The following error is a bug in React Router; please open an issue! https://github.com/remix-run/react-router/issues/new/choose");
        throw new Error(message);
    }
}
// lib/server-runtime/routes.ts
function $618a07bedf38a2ba$var$groupRoutesByParentId2(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $618a07bedf38a2ba$var$createRoutes(manifest, parentId = "", routesByParentId = $618a07bedf38a2ba$var$groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>({
            ...route,
            children: $618a07bedf38a2ba$var$createRoutes(manifest, route.id, routesByParentId)
        }));
}
function $618a07bedf38a2ba$var$createStaticHandlerDataRoutes(manifest, future, parentId = "", routesByParentId = $618a07bedf38a2ba$var$groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let commonRoute = {
            // Always include root due to default boundaries
            hasErrorBoundary: route.id === "root" || route.module.ErrorBoundary != null,
            id: route.id,
            path: route.path,
            // Need to use RR's version in the param typed here to permit the optional
            // context even though we know it'll always be provided in remix
            loader: route.module.loader ? async (args)=>{
                if (args.request.headers.has("X-React-Router-Prerender-Data")) {
                    const preRenderedData = args.request.headers.get("X-React-Router-Prerender-Data");
                    let encoded = preRenderedData ? decodeURI(preRenderedData) : preRenderedData;
                    $618a07bedf38a2ba$var$invariant3(encoded, "Missing prerendered data for route");
                    let uint8array = new TextEncoder().encode(encoded);
                    let stream = new ReadableStream({
                        start (controller) {
                            controller.enqueue(uint8array);
                            controller.close();
                        }
                    });
                    let decoded = await $618a07bedf38a2ba$export$4023ad4ecd4126a2(stream, $parcel$global);
                    let data2 = decoded.value;
                    $618a07bedf38a2ba$var$invariant3(data2 && route.id in data2, "Unable to decode prerendered data");
                    let result = data2[route.id];
                    $618a07bedf38a2ba$var$invariant3("data" in result, "Unable to process prerendered data");
                    return result.data;
                }
                let val = await $618a07bedf38a2ba$var$callRouteHandler(route.module.loader, args);
                return val;
            } : void 0,
            action: route.module.action ? (args)=>$618a07bedf38a2ba$var$callRouteHandler(route.module.action, args) : void 0,
            handle: route.module.handle
        };
        return route.index ? {
            index: true,
            ...commonRoute
        } : {
            caseSensitive: route.caseSensitive,
            children: $618a07bedf38a2ba$var$createStaticHandlerDataRoutes(manifest, future, route.id, routesByParentId),
            ...commonRoute
        };
    });
}
// lib/server-runtime/markup.ts
var $618a07bedf38a2ba$var$ESCAPE_LOOKUP3 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $618a07bedf38a2ba$var$ESCAPE_REGEX3 = /[&><\u2028\u2029]/g;
function $618a07bedf38a2ba$var$escapeHtml2(html) {
    return html.replace($618a07bedf38a2ba$var$ESCAPE_REGEX3, (match)=>$618a07bedf38a2ba$var$ESCAPE_LOOKUP3[match]);
}
// lib/server-runtime/serverHandoff.ts
function $618a07bedf38a2ba$var$createServerHandoffString(serverHandoff) {
    return $618a07bedf38a2ba$var$escapeHtml2(JSON.stringify(serverHandoff));
}
// lib/server-runtime/dev.ts
var $618a07bedf38a2ba$var$globalDevServerHooksKey = "__reactRouterDevServerHooks";
function $618a07bedf38a2ba$export$31bc6e795ff1cb0a(devServerHooks) {
    globalThis[$618a07bedf38a2ba$var$globalDevServerHooksKey] = devServerHooks;
}
function $618a07bedf38a2ba$var$getDevServerHooks() {
    return globalThis[$618a07bedf38a2ba$var$globalDevServerHooksKey];
}
function $618a07bedf38a2ba$var$getDocumentHeaders(build, context) {
    let boundaryIdx = context.errors ? context.matches.findIndex((m)=>context.errors[m.route.id]) : -1;
    let matches = boundaryIdx >= 0 ? context.matches.slice(0, boundaryIdx + 1) : context.matches;
    let errorHeaders;
    if (boundaryIdx >= 0) {
        let { actionHeaders: actionHeaders, actionData: actionData, loaderHeaders: loaderHeaders, loaderData: loaderData } = context;
        context.matches.slice(boundaryIdx).some((match)=>{
            let id = match.route.id;
            if (actionHeaders[id] && (!actionData || !actionData.hasOwnProperty(id))) errorHeaders = actionHeaders[id];
            else if (loaderHeaders[id] && !loaderData.hasOwnProperty(id)) errorHeaders = loaderHeaders[id];
            return errorHeaders != null;
        });
    }
    return matches.reduce((parentHeaders, match, idx)=>{
        let { id: id } = match.route;
        let route = build.routes[id];
        $618a07bedf38a2ba$var$invariant3(route, `Route with id "${id}" not found in build`);
        let routeModule = route.module;
        let loaderHeaders = context.loaderHeaders[id] || new Headers();
        let actionHeaders = context.actionHeaders[id] || new Headers();
        let includeErrorHeaders = errorHeaders != null && idx === matches.length - 1;
        let includeErrorCookies = includeErrorHeaders && errorHeaders !== loaderHeaders && errorHeaders !== actionHeaders;
        if (routeModule.headers == null) {
            let headers2 = new Headers(parentHeaders);
            if (includeErrorCookies) $618a07bedf38a2ba$var$prependCookies(errorHeaders, headers2);
            $618a07bedf38a2ba$var$prependCookies(actionHeaders, headers2);
            $618a07bedf38a2ba$var$prependCookies(loaderHeaders, headers2);
            return headers2;
        }
        let headers = new Headers(routeModule.headers ? typeof routeModule.headers === "function" ? routeModule.headers({
            loaderHeaders: loaderHeaders,
            parentHeaders: parentHeaders,
            actionHeaders: actionHeaders,
            errorHeaders: includeErrorHeaders ? errorHeaders : void 0
        }) : routeModule.headers : void 0);
        if (includeErrorCookies) $618a07bedf38a2ba$var$prependCookies(errorHeaders, headers);
        $618a07bedf38a2ba$var$prependCookies(actionHeaders, headers);
        $618a07bedf38a2ba$var$prependCookies(loaderHeaders, headers);
        $618a07bedf38a2ba$var$prependCookies(parentHeaders, headers);
        return headers;
    }, new Headers());
}
function $618a07bedf38a2ba$var$prependCookies(parentHeaders, childHeaders) {
    let parentSetCookieString = parentHeaders.get("Set-Cookie");
    if (parentSetCookieString) {
        let cookies = (0, $0270cef008d49955$exports.splitCookiesString)(parentSetCookieString);
        cookies.forEach((cookie)=>{
            childHeaders.append("Set-Cookie", cookie);
        });
    }
}
// lib/server-runtime/single-fetch.ts
var $618a07bedf38a2ba$var$SINGLE_FETCH_REDIRECT_STATUS = 202;
function $618a07bedf38a2ba$var$getSingleFetchDataStrategy2({ isActionDataRequest: isActionDataRequest, loadRouteIds: loadRouteIds } = {}) {
    return async ({ request: request, matches: matches })=>{
        if (isActionDataRequest && request.method === "GET") return {};
        let matchesToLoad = loadRouteIds ? matches.filter((m)=>loadRouteIds.includes(m.route.id)) : matches;
        let results = await Promise.all(matchesToLoad.map((match)=>match.resolve()));
        return results.reduce((acc, result, i)=>Object.assign(acc, {
                [matchesToLoad[i].route.id]: result
            }), {});
    };
}
async function $618a07bedf38a2ba$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let handlerRequest = new Request(handlerUrl, {
            method: request.method,
            body: request.body,
            headers: request.headers,
            signal: request.signal,
            ...request.body ? {
                duplex: "half"
            } : void 0
        });
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            dataStrategy: $618a07bedf38a2ba$var$getSingleFetchDataStrategy2({
                isActionDataRequest: true
            })
        });
        if ($618a07bedf38a2ba$var$isResponse(result)) return {
            result: $618a07bedf38a2ba$var$getSingleFetchRedirect(result.status, result.headers, build.basename),
            headers: result.headers,
            status: $618a07bedf38a2ba$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        let context = result;
        let headers = $618a07bedf38a2ba$var$getDocumentHeaders(build, context);
        if ($618a07bedf38a2ba$var$isRedirectStatusCode(context.statusCode) && headers.has("Location")) return {
            result: $618a07bedf38a2ba$var$getSingleFetchRedirect(context.statusCode, headers, build.basename),
            headers: headers,
            status: $618a07bedf38a2ba$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!$618a07bedf38a2ba$export$972111febbeef05b(err) || err.error) handleError(err);
            });
            context.errors = $618a07bedf38a2ba$var$sanitizeErrors(context.errors, serverMode);
        }
        let singleFetchResult;
        if (context.errors) singleFetchResult = {
            error: Object.values(context.errors)[0]
        };
        else singleFetchResult = {
            data: Object.values(context.actionData || {})[0]
        };
        return {
            result: singleFetchResult,
            headers: headers,
            status: context.statusCode
        };
    } catch (error) {
        handleError(error);
        return {
            result: {
                error: error
            },
            headers: new Headers(),
            status: 500
        };
    }
}
async function $618a07bedf38a2ba$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let handlerRequest = new Request(handlerUrl, {
            headers: request.headers,
            signal: request.signal
        });
        let loadRouteIds = new URL(request.url).searchParams.get("_routes")?.split(",") || void 0;
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            dataStrategy: $618a07bedf38a2ba$var$getSingleFetchDataStrategy2({
                loadRouteIds: loadRouteIds
            })
        });
        if ($618a07bedf38a2ba$var$isResponse(result)) return {
            result: {
                [$618a07bedf38a2ba$export$60644022b8b46aaa]: $618a07bedf38a2ba$var$getSingleFetchRedirect(result.status, result.headers, build.basename)
            },
            headers: result.headers,
            status: $618a07bedf38a2ba$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        let context = result;
        let headers = $618a07bedf38a2ba$var$getDocumentHeaders(build, context);
        if ($618a07bedf38a2ba$var$isRedirectStatusCode(context.statusCode) && headers.has("Location")) return {
            result: {
                [$618a07bedf38a2ba$export$60644022b8b46aaa]: $618a07bedf38a2ba$var$getSingleFetchRedirect(context.statusCode, headers, build.basename)
            },
            headers: headers,
            status: $618a07bedf38a2ba$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!$618a07bedf38a2ba$export$972111febbeef05b(err) || err.error) handleError(err);
            });
            context.errors = $618a07bedf38a2ba$var$sanitizeErrors(context.errors, serverMode);
        }
        let results = {};
        let loadedMatches = loadRouteIds ? context.matches.filter((m)=>m.route.loader && loadRouteIds.includes(m.route.id)) : context.matches;
        loadedMatches.forEach((m)=>{
            let { id: id } = m.route;
            if (context.errors && context.errors.hasOwnProperty(id)) results[id] = {
                error: context.errors[id]
            };
            else if (context.loaderData.hasOwnProperty(id)) results[id] = {
                data: context.loaderData[id]
            };
        });
        return {
            result: results,
            headers: headers,
            status: context.statusCode
        };
    } catch (error) {
        handleError(error);
        return {
            result: {
                root: {
                    error: error
                }
            },
            headers: new Headers(),
            status: 500
        };
    }
}
function $618a07bedf38a2ba$var$getSingleFetchRedirect(status, headers, basename) {
    let redirect2 = headers.get("Location");
    if (basename) redirect2 = $618a07bedf38a2ba$var$stripBasename(redirect2, basename) || redirect2;
    return {
        redirect: redirect2,
        status: status,
        revalidate: // Technically X-Remix-Revalidate isn't needed here - that was an implementation
        // detail of ?_data requests as our way to tell the front end to revalidate when
        // we didn't have a response body to include that information in.
        // With single fetch, we tell the front end via this revalidate boolean field.
        // However, we're respecting it for now because it may be something folks have
        // used in their own responses
        // TODO(v3): Consider removing or making this official public API
        headers.has("X-Remix-Revalidate") || headers.has("Set-Cookie"),
        reload: headers.has("X-Remix-Reload-Document"),
        replace: headers.has("X-Remix-Replace")
    };
}
function $618a07bedf38a2ba$var$encodeViaTurboStream(data2, requestSignal, streamTimeout, serverMode) {
    let controller = new AbortController();
    let timeoutId = setTimeout(()=>controller.abort(new Error("Server Timeout")), typeof streamTimeout === "number" ? streamTimeout : 4950);
    requestSignal.addEventListener("abort", ()=>clearTimeout(timeoutId));
    return (0, $2150357b95f27254$export$c564cdbbe6da493)(data2, {
        signal: controller.signal,
        plugins: [
            (value)=>{
                if (value instanceof Error) {
                    let { name: name, message: message, stack: stack } = serverMode === "production" /* Production */  ? $618a07bedf38a2ba$var$sanitizeError(value, serverMode) : value;
                    return [
                        "SanitizedError",
                        name,
                        message,
                        stack
                    ];
                }
                if (value instanceof $618a07bedf38a2ba$export$f2680fa305b734ca) {
                    let { data: data3, status: status, statusText: statusText } = value;
                    return [
                        "ErrorResponse",
                        data3,
                        status,
                        statusText
                    ];
                }
                if (value && typeof value === "object" && $618a07bedf38a2ba$export$60644022b8b46aaa in value) return [
                    "SingleFetchRedirect",
                    value[$618a07bedf38a2ba$export$60644022b8b46aaa]
                ];
            }
        ],
        postPlugins: [
            (value)=>{
                if (!value) return;
                if (typeof value !== "object") return;
                return [
                    "SingleFetchClassInstance",
                    Object.fromEntries(Object.entries(value))
                ];
            },
            ()=>[
                    "SingleFetchFallback"
                ]
        ]
    });
}
// lib/server-runtime/server.ts
function $618a07bedf38a2ba$var$derive(build, mode) {
    let routes = $618a07bedf38a2ba$var$createRoutes(build.routes);
    let dataRoutes = $618a07bedf38a2ba$var$createStaticHandlerDataRoutes(build.routes, build.future);
    let serverMode = $618a07bedf38a2ba$var$isServerMode(mode) ? mode : "production" /* Production */ ;
    let staticHandler = $618a07bedf38a2ba$var$createStaticHandler(dataRoutes, {
        basename: build.basename
    });
    let errorHandler = build.entry.module.handleError || ((error, { request: request })=>{
        if (serverMode !== "test" /* Test */  && !request.signal.aborted) console.error(// @ts-expect-error This is "private" from users but intended for internal use
        $618a07bedf38a2ba$export$972111febbeef05b(error) && error.error ? error.error : error);
    });
    return {
        routes: routes,
        dataRoutes: dataRoutes,
        serverMode: serverMode,
        staticHandler: staticHandler,
        errorHandler: errorHandler
    };
}
var $618a07bedf38a2ba$export$6308091d8cbd0718 = (build, mode)=>{
    let _build;
    let routes;
    let serverMode;
    let staticHandler;
    let errorHandler;
    return async function requestHandler(request, loadContext = {}) {
        _build = typeof build === "function" ? await build() : build;
        if (typeof build === "function") {
            let derived = $618a07bedf38a2ba$var$derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        } else if (!routes || !serverMode || !staticHandler || !errorHandler) {
            let derived = $618a07bedf38a2ba$var$derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        }
        let url = new URL(request.url);
        let params = {};
        let handleError = (error)=>{
            if (mode === "development" /* Development */ ) $618a07bedf38a2ba$var$getDevServerHooks()?.processRequestError?.(error);
            errorHandler(error, {
                context: loadContext,
                params: params,
                request: request
            });
        };
        let manifestUrl = `${_build.basename ?? "/"}/__manifest`.replace(/\/+/g, "/");
        if (url.pathname === manifestUrl) try {
            let res = await $618a07bedf38a2ba$var$handleManifestRequest(_build, routes, url);
            return res;
        } catch (e) {
            handleError(e);
            return new Response("Unknown Server Error", {
                status: 500
            });
        }
        let matches = $618a07bedf38a2ba$var$matchServerRoutes(routes, url.pathname, _build.basename);
        if (matches && matches.length > 0) Object.assign(params, matches[0].params);
        let response;
        if (url.pathname.endsWith(".data")) {
            let handlerUrl = new URL(request.url);
            handlerUrl.pathname = handlerUrl.pathname.replace(/\.data$/, "").replace(/^\/_root$/, "/");
            let singleFetchMatches = $618a07bedf38a2ba$var$matchServerRoutes(routes, handlerUrl.pathname, _build.basename);
            response = await $618a07bedf38a2ba$var$handleSingleFetchRequest(serverMode, _build, staticHandler, request, handlerUrl, loadContext, handleError);
            if (_build.entry.module.handleDataRequest) {
                response = await _build.entry.module.handleDataRequest(response, {
                    context: loadContext,
                    params: singleFetchMatches ? singleFetchMatches[0].params : {},
                    request: request
                });
                if ($618a07bedf38a2ba$var$isRedirectResponse(response)) {
                    let result = $618a07bedf38a2ba$var$getSingleFetchRedirect(response.status, response.headers, _build.basename);
                    if (request.method === "GET") result = {
                        [$618a07bedf38a2ba$export$60644022b8b46aaa]: result
                    };
                    let headers = new Headers(response.headers);
                    headers.set("Content-Type", "text/x-script");
                    return new Response($618a07bedf38a2ba$var$encodeViaTurboStream(result, request.signal, _build.entry.module.streamTimeout, serverMode), {
                        status: $618a07bedf38a2ba$var$SINGLE_FETCH_REDIRECT_STATUS,
                        headers: headers
                    });
                }
            }
        } else if (matches && matches[matches.length - 1].route.module.default == null && matches[matches.length - 1].route.module.ErrorBoundary == null) response = await $618a07bedf38a2ba$var$handleResourceRequest(serverMode, staticHandler, matches.slice(-1)[0].route.id, request, loadContext, handleError);
        else {
            let criticalCss = mode === "development" /* Development */  ? await $618a07bedf38a2ba$var$getDevServerHooks()?.getCriticalCss?.(_build, url.pathname) : void 0;
            response = await $618a07bedf38a2ba$var$handleDocumentRequest(serverMode, _build, staticHandler, request, loadContext, handleError, criticalCss);
        }
        if (request.method === "HEAD") return new Response(null, {
            headers: response.headers,
            status: response.status,
            statusText: response.statusText
        });
        return response;
    };
};
async function $618a07bedf38a2ba$var$handleManifestRequest(build, routes, url) {
    let patches = {};
    if (url.searchParams.has("p")) {
        for (let path of url.searchParams.getAll("p")){
            let matches = $618a07bedf38a2ba$var$matchServerRoutes(routes, path, build.basename);
            if (matches) for (let match of matches){
                let routeId = match.route.id;
                let route = build.assets.routes[routeId];
                if (route) patches[routeId] = route;
            }
        }
        return Response.json(patches, {
            headers: {
                "Cache-Control": "public, max-age=31536000, immutable"
            }
        });
    }
    return new Response("Invalid Request", {
        status: 400
    });
}
async function $618a07bedf38a2ba$var$handleSingleFetchRequest(serverMode, build, staticHandler, request, handlerUrl, loadContext, handleError) {
    let { result: result, headers: headers, status: status } = request.method !== "GET" ? await $618a07bedf38a2ba$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) : await $618a07bedf38a2ba$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError);
    let resultHeaders = new Headers(headers);
    resultHeaders.set("X-Remix-Response", "yes");
    if (status === 304) return new Response(null, {
        status: 304,
        headers: resultHeaders
    });
    resultHeaders.set("Content-Type", "text/x-script");
    return new Response($618a07bedf38a2ba$var$encodeViaTurboStream(result, request.signal, build.entry.module.streamTimeout, serverMode), {
        status: status || 200,
        headers: resultHeaders
    });
}
async function $618a07bedf38a2ba$var$handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, criticalCss) {
    let context;
    try {
        context = await staticHandler.query(request, {
            requestContext: loadContext
        });
    } catch (error) {
        handleError(error);
        return new Response(null, {
            status: 500
        });
    }
    if ($618a07bedf38a2ba$var$isResponse(context)) return context;
    let headers = $618a07bedf38a2ba$var$getDocumentHeaders(build, context);
    if (context.statusCode === 304) return new Response(null, {
        status: 304,
        headers: headers
    });
    if (context.errors) {
        Object.values(context.errors).forEach((err)=>{
            if (!$618a07bedf38a2ba$export$972111febbeef05b(err) || err.error) handleError(err);
        });
        context.errors = $618a07bedf38a2ba$var$sanitizeErrors(context.errors, serverMode);
    }
    let state = {
        loaderData: context.loaderData,
        actionData: context.actionData,
        errors: $618a07bedf38a2ba$var$serializeErrors2(context.errors, serverMode)
    };
    let entryContext = {
        manifest: build.assets,
        routeModules: $618a07bedf38a2ba$var$createEntryRouteModules(build.routes),
        staticHandlerContext: context,
        criticalCss: criticalCss,
        serverHandoffString: $618a07bedf38a2ba$var$createServerHandoffString({
            basename: build.basename,
            criticalCss: criticalCss,
            future: build.future,
            isSpaMode: build.isSpaMode
        }),
        serverHandoffStream: $618a07bedf38a2ba$var$encodeViaTurboStream(state, request.signal, build.entry.module.streamTimeout, serverMode),
        renderMeta: {},
        future: build.future,
        isSpaMode: build.isSpaMode,
        serializeError: (err)=>$618a07bedf38a2ba$var$serializeError(err, serverMode)
    };
    let handleDocumentRequestFunction = build.entry.module.default;
    try {
        return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
    } catch (error) {
        handleError(error);
        let errorForSecondRender = error;
        if ($618a07bedf38a2ba$var$isResponse(error)) try {
            let data2 = await $618a07bedf38a2ba$var$unwrapResponse(error);
            errorForSecondRender = new $618a07bedf38a2ba$export$f2680fa305b734ca(error.status, error.statusText, data2);
        } catch (e) {}
        context = $618a07bedf38a2ba$var$getStaticContextFromError(staticHandler.dataRoutes, context, errorForSecondRender);
        if (context.errors) context.errors = $618a07bedf38a2ba$var$sanitizeErrors(context.errors, serverMode);
        let state2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $618a07bedf38a2ba$var$serializeErrors2(context.errors, serverMode)
        };
        entryContext = {
            ...entryContext,
            staticHandlerContext: context,
            serverHandoffString: $618a07bedf38a2ba$var$createServerHandoffString({
                basename: build.basename,
                future: build.future,
                isSpaMode: build.isSpaMode
            }),
            serverHandoffStream: $618a07bedf38a2ba$var$encodeViaTurboStream(state2, request.signal, build.entry.module.streamTimeout, serverMode),
            renderMeta: {}
        };
        try {
            return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
        } catch (error2) {
            handleError(error2);
            return $618a07bedf38a2ba$var$returnLastResortErrorResponse(error2, serverMode);
        }
    }
}
async function $618a07bedf38a2ba$var$handleResourceRequest(serverMode, staticHandler, routeId, request, loadContext, handleError) {
    try {
        let response = await staticHandler.queryRoute(request, {
            routeId: routeId,
            requestContext: loadContext
        });
        $618a07bedf38a2ba$var$invariant3($618a07bedf38a2ba$var$isResponse(response), "Expected a Response to be returned from resource route handler");
        return response;
    } catch (error) {
        if ($618a07bedf38a2ba$var$isResponse(error)) {
            error.headers.set("X-Remix-Catch", "yes");
            return error;
        }
        if ($618a07bedf38a2ba$export$972111febbeef05b(error)) {
            if (error) handleError(error);
            return $618a07bedf38a2ba$var$errorResponseToJson(error, serverMode);
        }
        handleError(error);
        return $618a07bedf38a2ba$var$returnLastResortErrorResponse(error, serverMode);
    }
}
function $618a07bedf38a2ba$var$errorResponseToJson(errorResponse, serverMode) {
    return Response.json($618a07bedf38a2ba$var$serializeError(// @ts-expect-error This is "private" from users but intended for internal use
    errorResponse.error || new Error("Unexpected Server Error"), serverMode), {
        status: errorResponse.status,
        statusText: errorResponse.statusText,
        headers: {
            "X-Remix-Error": "yes"
        }
    });
}
function $618a07bedf38a2ba$var$returnLastResortErrorResponse(error, serverMode) {
    let message = "Unexpected Server Error";
    if (serverMode !== "production" /* Production */ ) message += `

${String(error)}`;
    return new Response(message, {
        status: 500,
        headers: {
            "Content-Type": "text/plain"
        }
    });
}
function $618a07bedf38a2ba$var$unwrapResponse(response) {
    let contentType = response.headers.get("Content-Type");
    return contentType && /\bapplication\/json\b/.test(contentType) ? response.body == null ? null : response.json() : response.text();
}
// lib/server-runtime/sessions.ts
function $618a07bedf38a2ba$var$flash(name) {
    return `__flash_${name}__`;
}
var $618a07bedf38a2ba$export$f7c62c73429afa28 = (initialData = {}, id = "")=>{
    let map = new Map(Object.entries(initialData));
    return {
        get id () {
            return id;
        },
        get data () {
            return Object.fromEntries(map);
        },
        has (name) {
            return map.has(name) || map.has($618a07bedf38a2ba$var$flash(name));
        },
        get (name) {
            if (map.has(name)) return map.get(name);
            let flashName = $618a07bedf38a2ba$var$flash(name);
            if (map.has(flashName)) {
                let value = map.get(flashName);
                map.delete(flashName);
                return value;
            }
            return void 0;
        },
        set (name, value) {
            map.set(name, value);
        },
        flash (name, value) {
            map.set($618a07bedf38a2ba$var$flash(name), value);
        },
        unset (name) {
            map.delete(name);
        }
    };
};
var $618a07bedf38a2ba$export$548944bd211b425f = (object)=>{
    return object != null && typeof object.id === "string" && typeof object.data !== "undefined" && typeof object.has === "function" && typeof object.get === "function" && typeof object.set === "function" && typeof object.flash === "function" && typeof object.unset === "function";
};
function $618a07bedf38a2ba$export$1f1c547b06207ca3({ cookie: cookieArg, createData: createData, readData: readData, updateData: updateData, deleteData: deleteData }) {
    let cookie = $618a07bedf38a2ba$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $618a07bedf38a2ba$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $618a07bedf38a2ba$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            let id = cookieHeader && await cookie.parse(cookieHeader, options);
            let data2 = id && await readData(id);
            return $618a07bedf38a2ba$export$f7c62c73429afa28(data2 || {}, id || "");
        },
        async commitSession (session, options) {
            let { id: id, data: data2 } = session;
            let expires = options?.maxAge != null ? new Date(Date.now() + options.maxAge * 1e3) : options?.expires != null ? options.expires : cookie.expires;
            if (id) await updateData(id, data2, expires);
            else id = await createData(data2, expires);
            return cookie.serialize(id, options);
        },
        async destroySession (session, options) {
            await deleteData(session.id);
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
function $618a07bedf38a2ba$var$warnOnceAboutSigningSessionCookie(cookie) {
    $618a07bedf38a2ba$var$warnOnce(cookie.isSigned, `The "${cookie.name}" cookie is not signed, but session cookies should be signed to prevent tampering on the client before they are sent back to the server. See https://remix.run/utils/cookies#signing-cookies for more information.`);
}
// lib/server-runtime/sessions/cookieStorage.ts
function $618a07bedf38a2ba$export$2641c3ccec6bd360({ cookie: cookieArg } = {}) {
    let cookie = $618a07bedf38a2ba$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $618a07bedf38a2ba$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $618a07bedf38a2ba$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            return $618a07bedf38a2ba$export$f7c62c73429afa28(cookieHeader && await cookie.parse(cookieHeader, options) || {});
        },
        async commitSession (session, options) {
            let serializedCookie = await cookie.serialize(session.data, options);
            if (serializedCookie.length > 4096) throw new Error("Cookie length will exceed browser maximum. Length: " + serializedCookie.length);
            return serializedCookie;
        },
        async destroySession (_session, options) {
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
// lib/server-runtime/sessions/memoryStorage.ts
function $618a07bedf38a2ba$export$abd1f21611468758({ cookie: cookie } = {}) {
    let map = /* @__PURE__ */ new Map();
    return $618a07bedf38a2ba$export$1f1c547b06207ca3({
        cookie: cookie,
        async createData (data2, expires) {
            let id = Math.random().toString(36).substring(2, 10);
            map.set(id, {
                data: data2,
                expires: expires
            });
            return id;
        },
        async readData (id) {
            if (map.has(id)) {
                let { data: data2, expires: expires } = map.get(id);
                if (!expires || expires > /* @__PURE__ */ new Date()) return data2;
                if (expires) map.delete(id);
            }
            return null;
        },
        async updateData (id, data2, expires) {
            map.set(id, {
                data: data2,
                expires: expires
            });
        },
        async deleteData (id) {
            map.delete(id);
        }
    });
}
// lib/dom/ssr/errors.ts
function $618a07bedf38a2ba$export$c923cb491441bb56(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $618a07bedf38a2ba$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = val.stack;
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = val.stack;
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}




var $acw62 = parcelRequire("acw62");
const $2437f33e36922204$var$AuthenticatedContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $2437f33e36922204$var$AuthenticatedDispatchContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $2437f33e36922204$var$initialAuthenticated = {
    authenticated: false
};
function $2437f33e36922204$var$authenticatedReducer(state, action) {
    switch(action.type){
        case 'update':
            return {
                ...state,
                authenticated: !!action.payload
            };
    }
    return state;
}
function $2437f33e36922204$export$d33e3d7abec0d9e9({ children: children }) {
    const [state, dispatch] = (0, $acw62.useReducer)($2437f33e36922204$var$authenticatedReducer, $2437f33e36922204$var$initialAuthenticated);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2437f33e36922204$var$AuthenticatedContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2437f33e36922204$var$AuthenticatedDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
}
function $2437f33e36922204$export$7e9c60d6d1836c84() {
    const state = (0, $acw62.useContext)($2437f33e36922204$var$AuthenticatedContext);
    return !!state.authenticated;
}
function $2437f33e36922204$export$2ecd7e4ddaeabcb1() {
    const dispatch = (0, $acw62.useContext)($2437f33e36922204$var$AuthenticatedDispatchContext);
    return (0, $acw62.useCallback)((value)=>dispatch({
            type: 'update',
            payload: value
        }), [
        dispatch
    ]);
}


/* global process */ const $2bd9d04ce55ef2a0$export$253fab909bb52269 = {};
const $2bd9d04ce55ef2a0$export$2c66e96878bf4792 = [];
function $2bd9d04ce55ef2a0$export$5702a91a6f42969f() {}
function $2bd9d04ce55ef2a0$export$76c0f2b8ecfc3d8a(value) {
    return value;
}
const $2bd9d04ce55ef2a0$export$923ea8233b386e99 = undefined ?? '/api';
const $2bd9d04ce55ef2a0$export$da9c6a3f8147de46 = "52ac9bf6-c0ef-407c-8905-d9c1aa803c1e";
const $2bd9d04ce55ef2a0$export$e9e7dacf7fcb49ea = "1000708297074-rd99b82ffjcrs508jpung4cjfb1t3p6u.apps.googleusercontent.com";
const $2bd9d04ce55ef2a0$export$f8b5ced57f81b80f = "55c34e2e-8785-41e7-b992-9fafa4adf99e";
const $2bd9d04ce55ef2a0$export$1556aa8e8d50f042 = 'Soopa';
const $2bd9d04ce55ef2a0$export$cb2c27f8c491b512 = 'Microsoft';
const $2bd9d04ce55ef2a0$export$6c6d155b8a29f0a9 = 'Google';
const $2bd9d04ce55ef2a0$export$6f5c75afcb5ad5cc = 'Pacific/Auckland';
const $2bd9d04ce55ef2a0$export$58eacdd7158b2a77 = 'YYYY-MM-DD';
const $2bd9d04ce55ef2a0$export$42f5ddd7513edbc8 = /^[a-zA-Z]{3}\d{2}(?:\d{2}|[a-zA-Z][a-zA-Z\d])$/;
const $2bd9d04ce55ef2a0$export$1e760388e1d418c0 = /^([a-zA-Z]{3}\d{2}(?:\d{2}|[a-zA-Z][a-zA-Z\d]))?$/;
const $2bd9d04ce55ef2a0$export$9b5f2e1c20ef6571 = true;
const $2bd9d04ce55ef2a0$export$1543a09f0c460e3d = /^[\da-fA-F]{8}-([\da-fA-F]{4}-){3}[\da-fA-F]{12}$/;




var $acw62 = parcelRequire("acw62");
function $726732e43fc7950f$var$InformationCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z",
        clipRule: "evenodd"
    }));
}
const $726732e43fc7950f$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($726732e43fc7950f$var$InformationCircleIcon);
var $726732e43fc7950f$export$2e2bcd8739ae039 = $726732e43fc7950f$var$ForwardRef;



var $acw62 = parcelRequire("acw62");
var $0d70f179cf56e662$var$isCheckBoxInput = (element)=>element.type === 'checkbox';
var $0d70f179cf56e662$var$isDateObject = (value1)=>value1 instanceof Date;
var $0d70f179cf56e662$var$isNullOrUndefined = (value1)=>value1 == null;
const $0d70f179cf56e662$var$isObjectType = (value1)=>typeof value1 === 'object';
var $0d70f179cf56e662$var$isObject = (value1)=>!$0d70f179cf56e662$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $0d70f179cf56e662$var$isObjectType(value1) && !$0d70f179cf56e662$var$isDateObject(value1);
var $0d70f179cf56e662$var$getEventValue = (event)=>$0d70f179cf56e662$var$isObject(event) && event.target ? $0d70f179cf56e662$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $0d70f179cf56e662$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $0d70f179cf56e662$var$isNameInFieldArray = (names, name)=>names.has($0d70f179cf56e662$var$getNodeParentName(name));
var $0d70f179cf56e662$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $0d70f179cf56e662$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
var $0d70f179cf56e662$var$isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';
function $0d70f179cf56e662$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    const isFileListInstance = typeof FileList !== 'undefined' ? data instanceof FileList : false;
    if (data instanceof Date) copy = new Date(data);
    else if (!($0d70f179cf56e662$var$isWeb && (data instanceof Blob || isFileListInstance)) && (isArray || $0d70f179cf56e662$var$isObject(data))) {
        copy = isArray ? [] : Object.create(Object.getPrototypeOf(data));
        if (!isArray && !$0d70f179cf56e662$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $0d70f179cf56e662$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $0d70f179cf56e662$var$isKey = (value1)=>/^\w*$/.test(value1);
var $0d70f179cf56e662$var$isUndefined = (val)=>val === undefined;
var $0d70f179cf56e662$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $0d70f179cf56e662$var$stringToPath = (input)=>$0d70f179cf56e662$var$compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));
var $0d70f179cf56e662$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$0d70f179cf56e662$var$isObject(object)) return defaultValue;
    const result = ($0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path)).reduce((result, key)=>$0d70f179cf56e662$var$isNullOrUndefined(result) ? result : result[key], object);
    return $0d70f179cf56e662$var$isUndefined(result) || result === object ? $0d70f179cf56e662$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $0d70f179cf56e662$var$isBoolean = (value1)=>typeof value1 === 'boolean';
var $0d70f179cf56e662$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $0d70f179cf56e662$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        object[key] = newValue;
        object = object[key];
    }
};
const $0d70f179cf56e662$var$EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change'
};
const $0d70f179cf56e662$var$VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
};
const $0d70f179cf56e662$var$INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
};
const $0d70f179cf56e662$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
$0d70f179cf56e662$var$HookFormContext.displayName = 'HookFormContext';
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0d70f179cf56e662$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($0d70f179cf56e662$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://react.dev/reference/react/useContext) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0d70f179cf56e662$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0d70f179cf56e662$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $0d70f179cf56e662$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $0d70f179cf56e662$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $0d70f179cf56e662$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
const $0d70f179cf56e662$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect;
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$606f11b2eb45ecc6(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._formState);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    $0d70f179cf56e662$var$useIsomorphicLayoutEffect(()=>control._subscribe({
            name: name,
            formState: _localProxyFormState.current,
            exact: exact,
            callback: (formState)=>{
                !disabled && updateFormState({
                    ...control._formState,
                    ...formState
                });
            }
        }), [
        name,
        disabled,
        exact
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        _localProxyFormState.current.isValid && control._setValid(true);
    }, [
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$0d70f179cf56e662$var$getProxyFormState(formState, control, _localProxyFormState.current, false), [
        formState,
        control
    ]);
}
var $0d70f179cf56e662$var$isString = (value1)=>typeof value1 === 'string';
var $0d70f179cf56e662$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($0d70f179cf56e662$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
var $0d70f179cf56e662$var$isPrimitive = (value1)=>$0d70f179cf56e662$var$isNullOrUndefined(value1) || !$0d70f179cf56e662$var$isObjectType(value1);
function $0d70f179cf56e662$var$deepEqual(object1, object2, _internal_visited = new WeakSet()) {
    if ($0d70f179cf56e662$var$isPrimitive(object1) || $0d70f179cf56e662$var$isPrimitive(object2)) return Object.is(object1, object2);
    if ($0d70f179cf56e662$var$isDateObject(object1) && $0d70f179cf56e662$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    if (_internal_visited.has(object1) || _internal_visited.has(object2)) return true;
    _internal_visited.add(object1);
    _internal_visited.add(object2);
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== 'ref') {
            const val2 = object2[key];
            if ($0d70f179cf56e662$var$isDateObject(val1) && $0d70f179cf56e662$var$isDateObject(val2) || $0d70f179cf56e662$var$isObject(val1) && $0d70f179cf56e662$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$0d70f179cf56e662$var$deepEqual(val1, val2, _internal_visited) : !Object.is(val1, val2)) return false;
        }
    }
    return true;
}
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $0d70f179cf56e662$export$3c773aa2b84f29e0(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact, compute: compute } = props || {};
    const _defaultValue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(defaultValue);
    const _compute = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(compute);
    const _computeFormValues = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(undefined);
    const _prevControl = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control);
    const _prevName = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    _compute.current = compute;
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>{
        const defaultValue = control._getWatch(name, _defaultValue.current);
        return _compute.current ? _compute.current(defaultValue) : defaultValue;
    });
    const getCurrentOutput = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((values)=>{
        const formValues = $0d70f179cf56e662$var$generateWatchOutput(name, control._names, values || control._formValues, false, _defaultValue.current);
        return _compute.current ? _compute.current(formValues) : formValues;
    }, [
        control._formValues,
        control._names,
        name
    ]);
    const refreshValue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((values)=>{
        if (!disabled) {
            const formValues = $0d70f179cf56e662$var$generateWatchOutput(name, control._names, values || control._formValues, false, _defaultValue.current);
            if (_compute.current) {
                const computedFormValues = _compute.current(formValues);
                if (!$0d70f179cf56e662$var$deepEqual(computedFormValues, _computeFormValues.current)) {
                    updateValue(computedFormValues);
                    _computeFormValues.current = computedFormValues;
                }
            } else updateValue(formValues);
        }
    }, [
        control._formValues,
        control._names,
        disabled,
        name
    ]);
    $0d70f179cf56e662$var$useIsomorphicLayoutEffect(()=>{
        if (_prevControl.current !== control || !$0d70f179cf56e662$var$deepEqual(_prevName.current, name)) {
            _prevControl.current = control;
            _prevName.current = name;
            refreshValue();
        }
        return control._subscribe({
            name: name,
            formState: {
                values: true
            },
            exact: exact,
            callback: (formState)=>{
                refreshValue(formState.values);
            }
        });
    }, [
        control,
        exact,
        name,
        refreshValue
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>control._removeUnmounted());
    // If name or control changed for this render, synchronously reflect the
    // latest value so callers (like useController) see the correct value
    // immediately on the same render.
    // Optimize: Check control reference first before expensive deepEqual
    const controlChanged = _prevControl.current !== control;
    const prevName = _prevName.current;
    // Cache the computed output to avoid duplicate calls within the same render
    // We include shouldReturnImmediate in deps to ensure proper recomputation
    const computedOutput = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (disabled) return null;
        const nameChanged = !controlChanged && !$0d70f179cf56e662$var$deepEqual(prevName, name);
        const shouldReturnImmediate = controlChanged || nameChanged;
        return shouldReturnImmediate ? getCurrentOutput() : null;
    }, [
        disabled,
        controlChanged,
        name,
        prevName,
        getCurrentOutput
    ]);
    return computedOutput !== null ? computedOutput : value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$e8c786024a2b0a79(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister, defaultValue: defaultValue } = props;
    const isArrayField = $0d70f179cf56e662$var$isNameInFieldArray(control._names.array, name);
    const defaultValueMemo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name, $0d70f179cf56e662$export$3988ae62b71be9a3(control._defaultValues, name, defaultValue)), [
        control,
        name,
        defaultValue
    ]);
    const value1 = $0d70f179cf56e662$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: defaultValueMemo,
        exact: true
    });
    const formState = $0d70f179cf56e662$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        exact: true
    });
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(props);
    const _previousNameRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(undefined);
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$0d70f179cf56e662$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    _props.current = props;
    const fieldState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$0d70f179cf56e662$export$3988ae62b71be9a3(formState.errors, name)
            }
        }), [
        formState,
        name
    ]);
    const onChange = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((event)=>_registerProps.current.onChange({
            target: {
                value: $0d70f179cf56e662$var$getEventValue(event),
                name: name
            },
            type: $0d70f179cf56e662$var$EVENTS.CHANGE
        }), [
        name
    ]);
    const onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>_registerProps.current.onBlur({
            target: {
                value: $0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name),
                name: name
            },
            type: $0d70f179cf56e662$var$EVENTS.BLUR
        }), [
        name,
        control._formValues
    ]);
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((elm)=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
        if (field && elm) field._f.ref = {
            focus: ()=>elm.focus && elm.focus(),
            select: ()=>elm.select && elm.select(),
            setCustomValidity: (message)=>elm.setCustomValidity(message),
            reportValidity: ()=>elm.reportValidity()
        };
    }, [
        control._fields,
        name
    ]);
    const field = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            name: name,
            value: value1,
            ...$0d70f179cf56e662$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: onChange,
            onBlur: onBlur,
            ref: ref
        }), [
        name,
        disabled,
        formState.disabled,
        onChange,
        onBlur,
        ref,
        value1
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const previousName = _previousNameRef.current;
        if (previousName && previousName !== name && !isArrayField) control.unregister(previousName);
        control.register(name, {
            ..._props.current.rules,
            ...$0d70f179cf56e662$var$isBoolean(_props.current.disabled) ? {
                disabled: _props.current.disabled
            } : {}
        });
        const updateMounted = (name, value1)=>{
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(control._options.defaultValues, name, _props.current.defaultValue));
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($0d70f179cf56e662$var$isUndefined($0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name))) $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        !isArrayField && control.register(name);
        _previousNameRef.current = name;
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        control._setDisabledField({
            disabled: disabled,
            name: name
        });
    }, [
        disabled,
        name,
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            field: field,
            formState: formState,
            fieldState: fieldState
        }), [
        field,
        formState,
        fieldState
    ]);
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $0d70f179cf56e662$export$bd0bf19f25da8474 = (props)=>props.render($0d70f179cf56e662$export$e8c786024a2b0a79(props));
const $0d70f179cf56e662$var$flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if ($0d70f179cf56e662$var$isObjectType(obj[key]) && obj[key] !== null) {
        const nested = $0d70f179cf56e662$var$flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
const $0d70f179cf56e662$var$POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$a7fed597f4b8afd8(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $0d70f179cf56e662$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = '';
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = '';
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            const flattenFormValues = $0d70f179cf56e662$var$flatten(control._formValues);
            for(const key in flattenFormValues)formData.append(key, flattenFormValues[key]);
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers['Content-Type'],
                    encType
                ].some((value1)=>value1 && value1.includes('json'));
                const response = await fetch(String(action), {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType && encType !== 'multipart/form-data' ? {
                            'Content-Type': encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError('root.server', {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $0d70f179cf56e662$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $0d70f179cf56e662$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $0d70f179cf56e662$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
function $0d70f179cf56e662$var$extractFormValues(fieldsState, formValues) {
    const values = {};
    for(const key in fieldsState)if (fieldsState.hasOwnProperty(key)) {
        const fieldState = fieldsState[key];
        const fieldValue = formValues[key];
        if (fieldState && $0d70f179cf56e662$var$isObject(fieldState) && fieldValue) {
            const nestedFieldsState = $0d70f179cf56e662$var$extractFormValues(fieldState, fieldValue);
            if ($0d70f179cf56e662$var$isObject(nestedFieldsState)) values[key] = nestedFieldsState;
        } else if (fieldsState[key]) values[key] = fieldValue;
    }
    return values;
}
var $0d70f179cf56e662$var$isEmptyObject = (value1)=>$0d70f179cf56e662$var$isObject(value1) && !Object.keys(value1).length;
var $0d70f179cf56e662$var$isFileInput = (element)=>element.type === 'file';
var $0d70f179cf56e662$var$isFunction = (value1)=>typeof value1 === 'function';
var $0d70f179cf56e662$var$isHTMLElement = (value1)=>{
    if (!$0d70f179cf56e662$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $0d70f179cf56e662$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $0d70f179cf56e662$var$isRadioInput = (element)=>element.type === 'radio';
var $0d70f179cf56e662$var$isRadioOrCheckbox = (ref)=>$0d70f179cf56e662$var$isRadioInput(ref) || $0d70f179cf56e662$var$isCheckBoxInput(ref);
var $0d70f179cf56e662$var$live = (ref)=>$0d70f179cf56e662$var$isHTMLElement(ref) && ref.isConnected;
function $0d70f179cf56e662$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $0d70f179cf56e662$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $0d70f179cf56e662$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$0d70f179cf56e662$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $0d70f179cf56e662$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $0d70f179cf56e662$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($0d70f179cf56e662$var$isObject(childObject) && $0d70f179cf56e662$var$isEmptyObject(childObject) || Array.isArray(childObject) && $0d70f179cf56e662$var$isEmptyArray(childObject))) $0d70f179cf56e662$var$unset(object, paths.slice(0, -1));
    return object;
}
var $0d70f179cf56e662$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($0d70f179cf56e662$var$isFunction(data[key])) return true;
    }
    return false;
};
function $0d70f179cf56e662$var$isTraversable(value1) {
    return Array.isArray(value1) || $0d70f179cf56e662$var$isObject(value1) && !$0d70f179cf56e662$var$objectHasFunction(value1);
}
function $0d70f179cf56e662$var$markFieldsDirty(data, fields = {}) {
    for(const key in data){
        const value1 = data[key];
        if ($0d70f179cf56e662$var$isTraversable(value1)) {
            fields[key] = Array.isArray(value1) ? [] : {};
            $0d70f179cf56e662$var$markFieldsDirty(value1, fields[key]);
        } else if (!$0d70f179cf56e662$var$isUndefined(value1)) fields[key] = true;
    }
    return fields;
}
function $0d70f179cf56e662$var$getDirtyFields(data, formValues, dirtyFieldsFromValues) {
    if (!dirtyFieldsFromValues) dirtyFieldsFromValues = $0d70f179cf56e662$var$markFieldsDirty(formValues);
    for(const key in data){
        const value1 = data[key];
        if ($0d70f179cf56e662$var$isTraversable(value1)) {
            if ($0d70f179cf56e662$var$isUndefined(formValues) || $0d70f179cf56e662$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = $0d70f179cf56e662$var$markFieldsDirty(value1, Array.isArray(value1) ? [] : {});
            else $0d70f179cf56e662$var$getDirtyFields(value1, $0d70f179cf56e662$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else {
            const formValue = formValues[key];
            dirtyFieldsFromValues[key] = !$0d70f179cf56e662$var$deepEqual(value1, formValue);
        }
    }
    return dirtyFieldsFromValues;
}
const $0d70f179cf56e662$var$defaultResult = {
    value: false,
    isValid: false
};
const $0d70f179cf56e662$var$validResult = {
    value: true,
    isValid: true
};
var $0d70f179cf56e662$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$0d70f179cf56e662$var$isUndefined(options[0].attributes.value) ? $0d70f179cf56e662$var$isUndefined(options[0].value) || options[0].value === '' ? $0d70f179cf56e662$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $0d70f179cf56e662$var$validResult : $0d70f179cf56e662$var$defaultResult;
    }
    return $0d70f179cf56e662$var$defaultResult;
};
var $0d70f179cf56e662$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$0d70f179cf56e662$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === '' ? NaN : value1 ? +value1 : value1 : valueAsDate && $0d70f179cf56e662$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
const $0d70f179cf56e662$var$defaultReturn = {
    isValid: false,
    value: null
};
var $0d70f179cf56e662$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $0d70f179cf56e662$var$defaultReturn) : $0d70f179cf56e662$var$defaultReturn;
function $0d70f179cf56e662$var$getFieldValue(_f) {
    const ref = _f.ref;
    if ($0d70f179cf56e662$var$isFileInput(ref)) return ref.files;
    if ($0d70f179cf56e662$var$isRadioInput(ref)) return $0d70f179cf56e662$var$getRadioValue(_f.refs).value;
    if ($0d70f179cf56e662$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($0d70f179cf56e662$var$isCheckBoxInput(ref)) return $0d70f179cf56e662$var$getCheckboxValue(_f.refs).value;
    return $0d70f179cf56e662$var$getFieldValueAs($0d70f179cf56e662$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $0d70f179cf56e662$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        field && $0d70f179cf56e662$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $0d70f179cf56e662$var$isRegex = (value1)=>value1 instanceof RegExp;
var $0d70f179cf56e662$var$getRuleValue = (rule)=>$0d70f179cf56e662$var$isUndefined(rule) ? rule : $0d70f179cf56e662$var$isRegex(rule) ? rule.source : $0d70f179cf56e662$var$isObject(rule) ? $0d70f179cf56e662$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $0d70f179cf56e662$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $0d70f179cf56e662$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $0d70f179cf56e662$var$VALIDATION_MODE.all,
        isOnTouch: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onTouched
    });
const $0d70f179cf56e662$var$ASYNC_FUNCTION = 'AsyncFunction';
var $0d70f179cf56e662$var$hasPromiseValidation = (fieldReference)=>!!fieldReference && !!fieldReference.validate && !!($0d70f179cf56e662$var$isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === $0d70f179cf56e662$var$ASYNC_FUNCTION || $0d70f179cf56e662$var$isObject(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction)=>validateFunction.constructor.name === $0d70f179cf56e662$var$ASYNC_FUNCTION));
var $0d70f179cf56e662$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
var $0d70f179cf56e662$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $0d70f179cf56e662$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if ($0d70f179cf56e662$var$iterateFieldsByAction(currentField, action)) break;
                }
            } else if ($0d70f179cf56e662$var$isObject(currentField)) {
                if ($0d70f179cf56e662$var$iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
function $0d70f179cf56e662$var$schemaErrorLookup(errors, _fields, name) {
    const error = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, name);
    if (error || $0d70f179cf56e662$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split('.');
    while(names.length){
        const fieldName = names.join('.');
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        if (foundError && foundError.root && foundError.root.type) return {
            name: `${fieldName}.root`,
            error: foundError.root
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $0d70f179cf56e662$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $0d70f179cf56e662$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $0d70f179cf56e662$var$VALIDATION_MODE.all));
};
var $0d70f179cf56e662$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $0d70f179cf56e662$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
var $0d70f179cf56e662$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $0d70f179cf56e662$var$unsetEmptyArray = (ref, name)=>!$0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(ref, name)).length && $0d70f179cf56e662$var$unset(ref, name);
var $0d70f179cf56e662$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$export$3988ae62b71be9a3(errors, name));
    $0d70f179cf56e662$export$adaa4cf7ef1b65be(fieldArrayErrors, 'root', error[name]);
    $0d70f179cf56e662$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
function $0d70f179cf56e662$var$getValidateError(result, ref, type = 'validate') {
    if ($0d70f179cf56e662$var$isString(result) || Array.isArray(result) && result.every($0d70f179cf56e662$var$isString) || $0d70f179cf56e662$var$isBoolean(result) && !result) return {
        type: type,
        message: $0d70f179cf56e662$var$isString(result) ? result : '',
        ref: ref
    };
}
var $0d70f179cf56e662$var$getValueAndMessage = (validationData)=>$0d70f179cf56e662$var$isObject(validationData) && !$0d70f179cf56e662$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ''
    };
var $0d70f179cf56e662$var$validateField = async (field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount } = field._f;
    const inputValue = $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabledFieldNames.has(name)) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($0d70f179cf56e662$var$isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $0d70f179cf56e662$var$isRadioInput(ref);
    const isCheckBox = $0d70f179cf56e662$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $0d70f179cf56e662$var$isFileInput(ref)) && $0d70f179cf56e662$var$isUndefined(ref.value) && $0d70f179cf56e662$var$isUndefined(inputValue) || $0d70f179cf56e662$var$isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $0d70f179cf56e662$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.maxLength, minType = $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $0d70f179cf56e662$var$isNullOrUndefined(inputValue)) || $0d70f179cf56e662$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$0d70f179cf56e662$var$getCheckboxValue(refs).isValid || isRadio && !$0d70f179cf56e662$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $0d70f179cf56e662$var$isString(required) ? {
            value: !!required,
            message: required
        } : $0d70f179cf56e662$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$0d70f179cf56e662$var$isNullOrUndefined(min) || !$0d70f179cf56e662$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $0d70f179cf56e662$var$getValueAndMessage(max);
        const minOutput = $0d70f179cf56e662$var$getValueAndMessage(min);
        if (!$0d70f179cf56e662$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$0d70f179cf56e662$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$0d70f179cf56e662$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if ($0d70f179cf56e662$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($0d70f179cf56e662$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.max, $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($0d70f179cf56e662$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $0d70f179cf56e662$var$getValueAndMessage(maxLength);
        const minLengthOutput = $0d70f179cf56e662$var$getValueAndMessage(minLength);
        const exceedMax = !$0d70f179cf56e662$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$0d70f179cf56e662$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $0d70f179cf56e662$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $0d70f179cf56e662$var$getValueAndMessage(pattern);
        if ($0d70f179cf56e662$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($0d70f179cf56e662$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $0d70f179cf56e662$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($0d70f179cf56e662$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$0d70f179cf56e662$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $0d70f179cf56e662$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$0d70f179cf56e662$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
const $0d70f179cf56e662$var$defaultOptions = {
    mode: $0d70f179cf56e662$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $0d70f179cf56e662$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $0d70f179cf56e662$export$1361f5e0e4cca3c3(props = {}) {
    let _options = {
        ...$0d70f179cf56e662$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isReady: false,
        isLoading: $0d70f179cf56e662$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $0d70f179cf56e662$var$isObject(_options.defaultValues) || $0d70f179cf56e662$var$isObject(_options.values) ? $0d70f179cf56e662$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $0d70f179cf56e662$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        disabled: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    let _proxySubscribeFormState = {
        ..._proxyFormState
    };
    const _subjects = {
        array: $0d70f179cf56e662$var$createSubject(),
        state: $0d70f179cf56e662$var$createSubject()
    };
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $0d70f179cf56e662$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _setValid = async (shouldUpdateValid)=>{
        if (!_options.disabled && (_proxyFormState.isValid || _proxySubscribeFormState.isValid || shouldUpdateValid)) {
            const isValid = _options.resolver ? $0d70f179cf56e662$var$isEmptyObject((await _runSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!_options.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields || _proxySubscribeFormState.isValidating || _proxySubscribeFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $0d70f179cf56e662$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$0d70f179cf56e662$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _setFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !_options.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $0d70f179cf56e662$var$unsetEmptyArray(_formState.errors, name);
            }
            if ((_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) _formState.dirtyFields = $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, name, $0d70f179cf56e662$var$isUndefined(value1) ? $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $0d70f179cf56e662$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $0d70f179cf56e662$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && !_state.action && _setValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!_options.disabled) {
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = $0d70f179cf56e662$var$deepEqual($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
                isPreviousDirty = !!$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.dirtyFields, name);
                isCurrentFieldPristine ? $0d70f179cf56e662$var$unset(_formState.dirtyFields, name) : $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || (_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && $0d70f179cf56e662$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (_options.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(_options.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0d70f179cf56e662$var$unset(_formState.errors, name);
        }
        if ((error ? !$0d70f179cf56e662$var$deepEqual(previousFieldError, error) : previousFieldError) || !$0d70f179cf56e662$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $0d70f179cf56e662$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _runSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $0d70f179cf56e662$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _runSchema(names);
        if (names) for (const name of names){
            const error = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, name);
            error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0d70f179cf56e662$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && $0d70f179cf56e662$var$hasPromiseValidation(field._f);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        _f.name
                    ], true);
                    const fieldError = await $0d70f179cf56e662$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        _f.name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($0d70f179cf56e662$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $0d70f179cf56e662$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $0d70f179cf56e662$var$unset(_formState.errors, _f.name));
                }
                !$0d70f179cf56e662$var$isEmptyObject(fieldValue) && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$0d70f179cf56e662$var$live(ref)) : !$0d70f179cf56e662$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>!_options.disabled && (name && data && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, data), !$0d70f179cf56e662$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$0d70f179cf56e662$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $0d70f179cf56e662$var$isUndefined(defaultValue) ? _defaultValues : $0d70f179cf56e662$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, $0d70f179cf56e662$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $0d70f179cf56e662$var$isHTMLElement(fieldReference.ref) && $0d70f179cf56e662$var$isNullOrUndefined(value1) ? '' : value1;
                if ($0d70f179cf56e662$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($0d70f179cf56e662$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.forEach((checkboxRef)=>{
                        if (!checkboxRef.defaultChecked || !checkboxRef.disabled) {
                            if (Array.isArray(fieldValue)) checkboxRef.checked = !!fieldValue.find((data)=>data === checkboxRef.value);
                            else checkboxRef.checked = fieldValue === checkboxRef.value || !!fieldValue;
                        }
                    });
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($0d70f179cf56e662$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = '';
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.state.next({
                        name: name,
                        values: $0d70f179cf56e662$var$cloneObject(_formValues)
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            if (!value1.hasOwnProperty(fieldKey)) return;
            const fieldValue = value1[fieldKey];
            const fieldName = name + '.' + fieldKey;
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || $0d70f179cf56e662$var$isObject(fieldValue) || field && !field._f) && !$0d70f179cf56e662$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $0d70f179cf56e662$var$cloneObject(value1);
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: $0d70f179cf56e662$var$cloneObject(_formValues)
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields || _proxySubscribeFormState.isDirty || _proxySubscribeFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$0d70f179cf56e662$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $0d70f179cf56e662$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState,
            name: name
        });
        _subjects.state.next({
            name: _state.mount ? name : undefined,
            values: $0d70f179cf56e662$var$cloneObject(_formValues)
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || $0d70f179cf56e662$var$isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || $0d70f179cf56e662$var$deepEqual(fieldValue, $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, name, fieldValue));
        };
        const validationModeBeforeSubmit = $0d70f179cf56e662$var$getValidationModes(_options.mode);
        const validationModeAfterSubmit = $0d70f179cf56e662$var$getValidationModes(_options.reValidateMode);
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type ? $0d70f179cf56e662$var$getFieldValue(field._f) : $0d70f179cf56e662$var$getEventValue(event);
            const isBlurEvent = event.type === $0d70f179cf56e662$var$EVENTS.BLUR || event.type === $0d70f179cf56e662$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$0d70f179cf56e662$var$hasValidation(field._f) && !_options.resolver && !$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $0d70f179cf56e662$var$skipValidation(isBlurEvent, $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $0d70f179cf56e662$var$isWatched(name, _names, isBlurEvent);
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                if (!target || !target.readOnly) {
                    field._f.onBlur && field._f.onBlur(event);
                    delayErrorCallback && delayErrorCallback(0);
                }
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent);
            const shouldRender = !$0d70f179cf56e662$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.state.next({
                name: name,
                type: event.type,
                values: $0d70f179cf56e662$var$cloneObject(_formValues)
            });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) {
                    if (_options.mode === 'onBlur') {
                        if (isBlurEvent) _setValid();
                    } else if (!isBlurEvent) _setValid();
                }
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors: errors } = await _runSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $0d70f179cf56e662$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $0d70f179cf56e662$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $0d70f179cf56e662$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $0d70f179cf56e662$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && (!Array.isArray(field._f.deps) || field._f.deps.length > 0) && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $0d70f179cf56e662$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($0d70f179cf56e662$var$isUndefined(name) ? name : fieldNames);
            isValid = $0d70f179cf56e662$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$0d70f179cf56e662$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _setValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$0d70f179cf56e662$var$isString(name) || (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && $0d70f179cf56e662$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames, config)=>{
        let values = {
            ..._state.mount ? _formValues : _defaultValues
        };
        if (config) values = $0d70f179cf56e662$var$extractFormValues(config.dirtyFields ? _formState.dirtyFields : _formState.touchedFields, values);
        return $0d70f179cf56e662$var$isUndefined(fieldNames) ? values : $0d70f179cf56e662$var$isString(fieldNames) ? $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$0d70f179cf56e662$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            error: $0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isValidating: !!$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.validatingFields, name),
            isTouched: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        name && $0d70f179cf56e662$var$convertToArrayPayload(name).forEach((inputName)=>$0d70f179cf56e662$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message: message, type: type, ...restOfErrorTree } = currentError;
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$0d70f179cf56e662$var$isFunction(name) ? _subjects.state.subscribe({
            next: (payload)=>'values' in payload && name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const _subscribe = (props)=>_subjects.state.subscribe({
            next: (formState)=>{
                if ($0d70f179cf56e662$var$shouldSubscribeByName(props.name, formState.name, props.exact) && $0d70f179cf56e662$var$shouldRenderFormState(formState, props.formState || _proxyFormState, _setFormState, props.reRenderRoot)) props.callback({
                    values: {
                        ..._formValues
                    },
                    ..._formState,
                    ...formState,
                    defaultValues: _defaultValues
                });
            }
        }).unsubscribe;
    const subscribe = (props)=>{
        _state.mount = true;
        _proxySubscribeFormState = {
            ..._proxySubscribeFormState,
            ...props.formState
        };
        return _subscribe({
            ...props,
            formState: _proxySubscribeFormState
        });
    };
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $0d70f179cf56e662$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $0d70f179cf56e662$var$unset(_fields, fieldName);
                $0d70f179cf56e662$var$unset(_formValues, fieldName);
            }
            !options.keepError && $0d70f179cf56e662$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $0d70f179cf56e662$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $0d70f179cf56e662$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $0d70f179cf56e662$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $0d70f179cf56e662$var$unset(_defaultValues, fieldName);
        }
        _subjects.state.next({
            values: $0d70f179cf56e662$var$cloneObject(_formValues)
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _setValid();
    };
    const _setDisabledField = ({ disabled: disabled, name: name })=>{
        if ($0d70f179cf56e662$var$isBoolean(disabled) && _state.mount || !!disabled || _names.disabled.has(name)) disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
    };
    const register = (name, options = {})=>{
        let field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $0d70f179cf56e662$var$isBoolean(options.disabled) || $0d70f179cf56e662$var$isBoolean(_options.disabled);
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _setDisabledField({
            disabled: $0d70f179cf56e662$var$isBoolean(options.disabled) ? options.disabled : _options.disabled,
            name: name
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled || _options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $0d70f179cf56e662$var$getRuleValue(options.min),
                max: $0d70f179cf56e662$var$getRuleValue(options.max),
                minLength: $0d70f179cf56e662$var$getRuleValue(options.minLength),
                maxLength: $0d70f179cf56e662$var$getRuleValue(options.maxLength),
                pattern: $0d70f179cf56e662$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $0d70f179cf56e662$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
                    const radioOrCheckbox = $0d70f179cf56e662$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($0d70f179cf56e662$var$live),
                                    fieldRef,
                                    ...Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($0d70f179cf56e662$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $0d70f179cf56e662$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($0d70f179cf56e662$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $0d70f179cf56e662$var$iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $0d70f179cf56e662$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _runSchema();
                _formState.errors = errors;
                fieldValues = $0d70f179cf56e662$var$cloneObject(values);
            } else await executeBuiltInValidation(_fields);
            if (_names.disabled.size) for (const name of _names.disabled)$0d70f179cf56e662$var$unset(fieldValues, name);
            $0d70f179cf56e662$var$unset(_formState.errors, 'root');
            if ($0d70f179cf56e662$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $0d70f179cf56e662$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name)) {
            if ($0d70f179cf56e662$var$isUndefined(options.defaultValue)) setValue(name, $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $0d70f179cf56e662$export$adaa4cf7ef1b65be(_defaultValues, name, $0d70f179cf56e662$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $0d70f179cf56e662$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $0d70f179cf56e662$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $0d70f179cf56e662$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _setValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $0d70f179cf56e662$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $0d70f179cf56e662$var$cloneObject(updatedValues);
        const isEmptyResetValues = $0d70f179cf56e662$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys($0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues))
                ]);
                for (const fieldName of Array.from(fieldsToCheck))$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(values, fieldName, $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldName));
            } else {
                if ($0d70f179cf56e662$var$isWeb && $0d70f179cf56e662$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($0d70f179cf56e662$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest('form');
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                if (keepStateOptions.keepFieldsRef) for (const fieldName of _names.mount)setValue(fieldName, $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldName));
                else _fields = {};
            }
            _formValues = _options.shouldUnregister ? keepStateOptions.keepDefaultValues ? $0d70f179cf56e662$var$cloneObject(_defaultValues) : {} : $0d70f179cf56e662$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.state.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            disabled: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ''
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues || !_options.shouldUnregister && !$0d70f179cf56e662$var$isEmptyObject(values);
        _state.watch = !!_options.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$0d70f179cf56e662$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $0d70f179cf56e662$var$getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false,
            defaultValues: _defaultValues
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($0d70f179cf56e662$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && $0d70f179cf56e662$var$isFunction(fieldRef.select) && fieldRef.select();
            }
        }
    };
    const _setFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$0d70f179cf56e662$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    const methods = {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _subscribe: _subscribe,
            _runSchema: _runSchema,
            _focusError: _focusError,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _setValid: _setValid,
            _setFieldArray: _setFieldArray,
            _setDisabledField: _setDisabledField,
            _setErrors: _setErrors,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _removeUnmounted: _removeUnmounted,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        subscribe: subscribe,
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
    return {
        ...methods,
        formControl: methods
    };
}
var $0d70f179cf56e662$var$generateId = ()=>{
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $0d70f179cf56e662$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $0d70f179cf56e662$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$0d70f179cf56e662$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : '';
var $0d70f179cf56e662$var$appendAt = (data, value1)=>[
        ...data,
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1)
    ];
var $0d70f179cf56e662$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $0d70f179cf56e662$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $0d70f179cf56e662$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($0d70f179cf56e662$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $0d70f179cf56e662$var$prependAt = (data, value1)=>[
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1),
        ...$0d70f179cf56e662$var$convertToArrayPayload(data)
    ];
function $0d70f179cf56e662$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $0d70f179cf56e662$var$compact(temp).length ? temp : [];
}
var $0d70f179cf56e662$var$removeArrayAt = (data, index)=>$0d70f179cf56e662$var$isUndefined(index) ? [] : $0d70f179cf56e662$var$removeAtIndexes(data, $0d70f179cf56e662$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $0d70f179cf56e662$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
var $0d70f179cf56e662$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$310131896651d559(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = 'id', shouldUnregister: shouldUnregister, rules: rules } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control._getFieldArray(name).map($0d70f179cf56e662$var$generateId));
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    control._names.array.add(name);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>rules && fields.length >= 0 && control.register(name, rules), [
        control,
        name,
        fields.length,
        rules
    ]);
    $0d70f179cf56e662$var$useIsomorphicLayoutEffect(()=>control._subjects.array.subscribe({
            next: ({ values: values, name: fieldArrayName })=>{
                if (fieldArrayName === name || !fieldArrayName) {
                    const fieldValues = $0d70f179cf56e662$export$3988ae62b71be9a3(values, name);
                    if (Array.isArray(fieldValues)) {
                        setFields(fieldValues);
                        ids.current = fieldValues.map($0d70f179cf56e662$var$generateId);
                    }
                }
            }
        }).unsubscribe, [
        control,
        name
    ]);
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._setFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $0d70f179cf56e662$var$appendAt(ids.current, appendValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$appendAt, {
            argA: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, 0, options);
        ids.current = $0d70f179cf56e662$var$prependAt(ids.current, prependValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$prependAt, {
            argA: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $0d70f179cf56e662$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $0d70f179cf56e662$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        !Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name)) && $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._fields, name, undefined);
        control._setFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, index, options);
        ids.current = $0d70f179cf56e662$var$insert(ids.current, index, insertValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$insert, {
            argA: index,
            argB: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0d70f179cf56e662$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $0d70f179cf56e662$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0d70f179cf56e662$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $0d70f179cf56e662$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $0d70f179cf56e662$var$cloneObject(value1);
        const updatedFieldArrayValues = $0d70f179cf56e662$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $0d70f179cf56e662$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($0d70f179cf56e662$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        control._state.action = false;
        $0d70f179cf56e662$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$0d70f179cf56e662$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted) && !$0d70f179cf56e662$var$getValidationModes(control._options.reValidateMode).isOnSubmit) {
            if (control._options.resolver) control._runSchema([
                name
            ]).then((result)=>{
                const error = $0d70f179cf56e662$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $0d70f179cf56e662$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $0d70f179cf56e662$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($0d70f179cf56e662$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $0d70f179cf56e662$var$getValidationModes(control._options.mode).isOnSubmit)) $0d70f179cf56e662$var$validateField(field, control._names.disabled, control._formValues, control._options.criteriaMode === $0d70f179cf56e662$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$0d70f179cf56e662$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $0d70f179cf56e662$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.state.next({
            name: name,
            values: $0d70f179cf56e662$var$cloneObject(control._formValues)
        });
        control._names.focus && $0d70f179cf56e662$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = '';
        control._setValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        !$0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name) && control._setFieldArray(name);
        return ()=>{
            const updateMounted = (name, value1)=>{
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) field._f.mount = value1;
            };
            control._options.shouldUnregister || shouldUnregister ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $0d70f179cf56e662$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(undefined);
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(undefined);
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $0d70f179cf56e662$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        isReady: false,
        defaultValues: $0d70f179cf56e662$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) {
        if (props.formControl) {
            _formControl.current = {
                ...props.formControl,
                formState: formState
            };
            if (props.defaultValues && !$0d70f179cf56e662$var$isFunction(props.defaultValues)) props.formControl.reset(props.defaultValues, props.resetOptions);
        } else {
            const { formControl: formControl, ...rest } = $0d70f179cf56e662$export$1361f5e0e4cca3c3(props);
            _formControl.current = {
                ...rest,
                formState: formState
            };
        }
    }
    const control = _formControl.current.control;
    control._options = props;
    $0d70f179cf56e662$var$useIsomorphicLayoutEffect(()=>{
        const sub = control._subscribe({
            formState: control._proxyFormState,
            callback: ()=>updateFormState({
                    ...control._formState
                }),
            reRenderRoot: true
        });
        updateFormState((data)=>({
                ...data,
                isReady: true
            }));
        control._formState.isReady = true;
        return sub;
    }, [
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (props.mode) control._options.mode = props.mode;
        if (props.reValidateMode) control._options.reValidateMode = props.reValidateMode;
    }, [
        control,
        props.mode,
        props.reValidateMode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (props.errors) {
            control._setErrors(props.errors);
            control._focusError();
        }
    }, [
        control,
        props.errors
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        props.shouldUnregister && control._subjects.state.next({
            values: control._getWatch()
        });
    }, [
        control,
        props.shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        var _a;
        if (props.values && !$0d70f179cf56e662$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, {
                keepFieldsRef: true,
                ...control._options.resetOptions
            });
            if (!((_a = control._options.resetOptions) === null || _a === void 0 ? void 0 : _a.keepIsValid)) control._setValid();
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        control,
        props.values
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!control._state.mount) {
            control._setValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $0d70f179cf56e662$var$getProxyFormState(formState, control);
    return _formControl.current;
}
/**
 * Watch component that subscribes to form field changes and re-renders when watched fields update.
 *
 * @param control - The form control object from useForm
 * @param names - Array of field names to watch for changes
 * @param render - The function that receives watched values and returns ReactNode
 * @returns The result of calling render function with watched values
 *
 * @example
 * The `Watch` component only re-render when the values of `foo`, `bar`, and `baz.qux` change.
 * The types of `foo`, `bar`, and `baz.qux` are precisely inferred.
 *
 * ```tsx
 * const { control } = useForm();
 *
 * <Watch
 *   control={control}
 *   names={['foo', 'bar', 'baz.qux']}
 *   render={([foo, bar, baz_qux]) => <div>{foo}{bar}{baz_qux}</div>}
 * />
 * ```
 */ const $0d70f179cf56e662$export$4c68f1a79f88778c = ({ control: control, names: names, render: render })=>render($0d70f179cf56e662$export$3c773aa2b84f29e0({
        control: control,
        name: names
    }));


const $629af589066638cc$var$r = (t, r, o)=>{
    if (t && "reportValidity" in t) {
        const s = (0, $0d70f179cf56e662$export$3988ae62b71be9a3)(o, r);
        t.setCustomValidity(s && s.message || ""), t.reportValidity();
    }
}, $629af589066638cc$export$6bd436d70894afff = (e, t)=>{
    for(const o in t.fields){
        const s = t.fields[o];
        s && s.ref && "reportValidity" in s.ref ? $629af589066638cc$var$r(s.ref, o, e) : s && s.refs && s.refs.forEach((t)=>$629af589066638cc$var$r(t, o, e));
    }
}, $629af589066638cc$export$f0545b73a179e3a2 = (r, s)=>{
    s.shouldUseNativeValidation && $629af589066638cc$export$6bd436d70894afff(r, s);
    const n = {};
    for(const o in r){
        const f = (0, $0d70f179cf56e662$export$3988ae62b71be9a3)(s.fields, o), c = Object.assign(r[o] || {}, {
            ref: f && f.ref
        });
        if ($629af589066638cc$var$i(s.names || Object.keys(r), o)) {
            const r = Object.assign({}, (0, $0d70f179cf56e662$export$3988ae62b71be9a3)(n, o));
            (0, $0d70f179cf56e662$export$adaa4cf7ef1b65be)(r, "root", c), (0, $0d70f179cf56e662$export$adaa4cf7ef1b65be)(n, o, r);
        } else (0, $0d70f179cf56e662$export$adaa4cf7ef1b65be)(n, o, c);
    }
    return n;
}, $629af589066638cc$var$i = (e, t)=>{
    const r = $629af589066638cc$var$n(t);
    return e.some((e)=>$629af589066638cc$var$n(e).match(`^${r}\\.\\d+`));
};
function $629af589066638cc$var$n(e) {
    return e.replace(/\]|\[/g, "");
}



/** A special constant with type `never` */ const $4488038d123e8fa5$export$96c94437c95d7862 = Object.freeze({
    status: "aborted"
});
/*@__NO_SIDE_EFFECTS__*/ function $4488038d123e8fa5$export$3122533d606194de(name, initializer, params) {
    function init(inst, def) {
        if (!inst._zod) Object.defineProperty(inst, "_zod", {
            value: {
                def: def,
                constr: _,
                traits: new Set()
            },
            enumerable: false
        });
        if (inst._zod.traits.has(name)) return;
        inst._zod.traits.add(name);
        initializer(inst, def);
        // support prototype modifications
        const proto = _.prototype;
        const keys = Object.keys(proto);
        for(let i = 0; i < keys.length; i++){
            const k = keys[i];
            if (!(k in inst)) inst[k] = proto[k].bind(inst);
        }
    }
    // doesn't work if Parent has a constructor with arguments
    const Parent = params?.Parent ?? Object;
    class Definition extends Parent {
    }
    Object.defineProperty(Definition, "name", {
        value: name
    });
    function _(def) {
        var _a;
        const inst = params?.Parent ? new Definition() : this;
        init(inst, def);
        (_a = inst._zod).deferred ?? (_a.deferred = []);
        for (const fn of inst._zod.deferred)fn();
        return inst;
    }
    Object.defineProperty(_, "init", {
        value: init
    });
    Object.defineProperty(_, Symbol.hasInstance, {
        value: (inst)=>{
            if (params?.Parent && inst instanceof params.Parent) return true;
            return inst?._zod?.traits?.has(name);
        }
    });
    Object.defineProperty(_, "name", {
        value: name
    });
    return _;
}
const $4488038d123e8fa5$export$7d40e40c5b5a6c8f = Symbol("zod_brand");
class $4488038d123e8fa5$export$13016bcec11ba196 extends Error {
    constructor(){
        super(`Encountered Promise during synchronous parse. Use .parseAsync() instead.`);
    }
}
class $4488038d123e8fa5$export$a36d4c29b1151bde extends Error {
    constructor(name){
        super(`Encountered unidirectional transform during encode: ${name}`);
        this.name = "ZodEncodeError";
    }
}
const $4488038d123e8fa5$export$f9cd1e43211d8a4a = {};
function $4488038d123e8fa5$export$e506a1d27d1eaa20(newConfig) {
    if (newConfig) Object.assign($4488038d123e8fa5$export$f9cd1e43211d8a4a, newConfig);
    return $4488038d123e8fa5$export$f9cd1e43211d8a4a;
}




var $17ea3f861a2ff584$exports = {};

$parcel$export($17ea3f861a2ff584$exports, "assertEqual", () => $17ea3f861a2ff584$export$27555cdfb0b84a1a);
$parcel$export($17ea3f861a2ff584$exports, "assertNotEqual", () => $17ea3f861a2ff584$export$49eedac51f614f7d);
$parcel$export($17ea3f861a2ff584$exports, "assertIs", () => $17ea3f861a2ff584$export$6fee1f82edcf4a03);
$parcel$export($17ea3f861a2ff584$exports, "assertNever", () => $17ea3f861a2ff584$export$cbadc5a7223772a8);
$parcel$export($17ea3f861a2ff584$exports, "assert", () => $17ea3f861a2ff584$export$a7a9523472993e97);
$parcel$export($17ea3f861a2ff584$exports, "getEnumValues", () => $17ea3f861a2ff584$export$70a5d58ec00f3c11);
$parcel$export($17ea3f861a2ff584$exports, "joinValues", () => $17ea3f861a2ff584$export$e79b744344f50f50);
$parcel$export($17ea3f861a2ff584$exports, "stringifyPrimitive", () => $17ea3f861a2ff584$export$5859860f650378f4);
$parcel$export($17ea3f861a2ff584$exports, "jsonStringifyReplacer", () => $17ea3f861a2ff584$export$f4defb13cab882b2);
$parcel$export($17ea3f861a2ff584$exports, "cached", () => $17ea3f861a2ff584$export$ade7a147f5129058);
$parcel$export($17ea3f861a2ff584$exports, "nullish", () => $17ea3f861a2ff584$export$69fd1b70ebae5687);
$parcel$export($17ea3f861a2ff584$exports, "cleanRegex", () => $17ea3f861a2ff584$export$78d521805d6c22e4);
$parcel$export($17ea3f861a2ff584$exports, "floatSafeRemainder", () => $17ea3f861a2ff584$export$7807b52a740a7117);
$parcel$export($17ea3f861a2ff584$exports, "defineLazy", () => $17ea3f861a2ff584$export$d43070a5843c1e2);
$parcel$export($17ea3f861a2ff584$exports, "objectClone", () => $17ea3f861a2ff584$export$103832c7353c2f50);
$parcel$export($17ea3f861a2ff584$exports, "assignProp", () => $17ea3f861a2ff584$export$2e23d0571746a3fb);
$parcel$export($17ea3f861a2ff584$exports, "mergeDefs", () => $17ea3f861a2ff584$export$8969f8c824382d73);
$parcel$export($17ea3f861a2ff584$exports, "cloneDef", () => $17ea3f861a2ff584$export$21596dc63856f4c1);
$parcel$export($17ea3f861a2ff584$exports, "getElementAtPath", () => $17ea3f861a2ff584$export$4b74d241e1cc7892);
$parcel$export($17ea3f861a2ff584$exports, "promiseAllObject", () => $17ea3f861a2ff584$export$3db3408dad58da23);
$parcel$export($17ea3f861a2ff584$exports, "randomString", () => $17ea3f861a2ff584$export$7fa8378418b4411e);
$parcel$export($17ea3f861a2ff584$exports, "esc", () => $17ea3f861a2ff584$export$a1a11b095f88289a);
$parcel$export($17ea3f861a2ff584$exports, "slugify", () => $17ea3f861a2ff584$export$c383cdd2a518017a);
$parcel$export($17ea3f861a2ff584$exports, "captureStackTrace", () => $17ea3f861a2ff584$export$756e5cd2d260237b);
$parcel$export($17ea3f861a2ff584$exports, "isObject", () => $17ea3f861a2ff584$export$a6cdc56e425d0d0a);
$parcel$export($17ea3f861a2ff584$exports, "allowsEval", () => $17ea3f861a2ff584$export$1f119cb4d720843b);
$parcel$export($17ea3f861a2ff584$exports, "isPlainObject", () => $17ea3f861a2ff584$export$53b83ca8eaab0383);
$parcel$export($17ea3f861a2ff584$exports, "shallowClone", () => $17ea3f861a2ff584$export$370e8311c3cdebd9);
$parcel$export($17ea3f861a2ff584$exports, "numKeys", () => $17ea3f861a2ff584$export$71667e74ba29447f);
$parcel$export($17ea3f861a2ff584$exports, "getParsedType", () => $17ea3f861a2ff584$export$3e9057828ebd5c7a);
$parcel$export($17ea3f861a2ff584$exports, "propertyKeyTypes", () => $17ea3f861a2ff584$export$b99c149ecf60be48);
$parcel$export($17ea3f861a2ff584$exports, "primitiveTypes", () => $17ea3f861a2ff584$export$c34ffd355f76f0e4);
$parcel$export($17ea3f861a2ff584$exports, "escapeRegex", () => $17ea3f861a2ff584$export$104ed90cc1a13451);
$parcel$export($17ea3f861a2ff584$exports, "clone", () => $17ea3f861a2ff584$export$9cd59f9826255e47);
$parcel$export($17ea3f861a2ff584$exports, "normalizeParams", () => $17ea3f861a2ff584$export$d6b7b25dfacfd300);
$parcel$export($17ea3f861a2ff584$exports, "createTransparentProxy", () => $17ea3f861a2ff584$export$6ebbd8d3cb03909b);
$parcel$export($17ea3f861a2ff584$exports, "optionalKeys", () => $17ea3f861a2ff584$export$240159211e66adb9);
$parcel$export($17ea3f861a2ff584$exports, "NUMBER_FORMAT_RANGES", () => $17ea3f861a2ff584$export$8e78302060ccf26f);
$parcel$export($17ea3f861a2ff584$exports, "BIGINT_FORMAT_RANGES", () => $17ea3f861a2ff584$export$538d1d6d5cfcb3b6);
$parcel$export($17ea3f861a2ff584$exports, "pick", () => $17ea3f861a2ff584$export$357523c63a2253b9);
$parcel$export($17ea3f861a2ff584$exports, "omit", () => $17ea3f861a2ff584$export$30a06c8d3562193f);
$parcel$export($17ea3f861a2ff584$exports, "extend", () => $17ea3f861a2ff584$export$8b58be045bf06082);
$parcel$export($17ea3f861a2ff584$exports, "safeExtend", () => $17ea3f861a2ff584$export$40c90eb222f50efb);
$parcel$export($17ea3f861a2ff584$exports, "merge", () => $17ea3f861a2ff584$export$4950aa0f605343fb);
$parcel$export($17ea3f861a2ff584$exports, "partial", () => $17ea3f861a2ff584$export$e45945969df8035a);
$parcel$export($17ea3f861a2ff584$exports, "required", () => $17ea3f861a2ff584$export$a7a0278c004aac3f);
$parcel$export($17ea3f861a2ff584$exports, "aborted", () => $17ea3f861a2ff584$export$bd75b6d981b9c7f2);
$parcel$export($17ea3f861a2ff584$exports, "prefixIssues", () => $17ea3f861a2ff584$export$7f35a4c434118b9e);
$parcel$export($17ea3f861a2ff584$exports, "unwrapMessage", () => $17ea3f861a2ff584$export$56590e5a47837d61);
$parcel$export($17ea3f861a2ff584$exports, "finalizeIssue", () => $17ea3f861a2ff584$export$c5e667bbfc286a9d);
$parcel$export($17ea3f861a2ff584$exports, "getSizableOrigin", () => $17ea3f861a2ff584$export$67a7c9c676c45d2b);
$parcel$export($17ea3f861a2ff584$exports, "getLengthableOrigin", () => $17ea3f861a2ff584$export$479f5a070abeb487);
$parcel$export($17ea3f861a2ff584$exports, "parsedType", () => $17ea3f861a2ff584$export$858d360cf6da2b65);
$parcel$export($17ea3f861a2ff584$exports, "issue", () => $17ea3f861a2ff584$export$69ad3503f98be476);
$parcel$export($17ea3f861a2ff584$exports, "cleanEnum", () => $17ea3f861a2ff584$export$9b57aa937148f32);
$parcel$export($17ea3f861a2ff584$exports, "base64ToUint8Array", () => $17ea3f861a2ff584$export$f01069a3c307e50e);
$parcel$export($17ea3f861a2ff584$exports, "uint8ArrayToBase64", () => $17ea3f861a2ff584$export$36bac84b1c2da9c7);
$parcel$export($17ea3f861a2ff584$exports, "base64urlToUint8Array", () => $17ea3f861a2ff584$export$b9fa2551f2db41e1);
$parcel$export($17ea3f861a2ff584$exports, "uint8ArrayToBase64url", () => $17ea3f861a2ff584$export$975f78e50159df6f);
$parcel$export($17ea3f861a2ff584$exports, "hexToUint8Array", () => $17ea3f861a2ff584$export$6c74ef56152ffb8d);
$parcel$export($17ea3f861a2ff584$exports, "uint8ArrayToHex", () => $17ea3f861a2ff584$export$c44b02fb03dbac82);
$parcel$export($17ea3f861a2ff584$exports, "Class", () => $17ea3f861a2ff584$export$4c85e640eb41c31b);
// functions
function $17ea3f861a2ff584$export$27555cdfb0b84a1a(val) {
    return val;
}
function $17ea3f861a2ff584$export$49eedac51f614f7d(val) {
    return val;
}
function $17ea3f861a2ff584$export$6fee1f82edcf4a03(_arg) {}
function $17ea3f861a2ff584$export$cbadc5a7223772a8(_x) {
    throw new Error("Unexpected value in exhaustive check");
}
function $17ea3f861a2ff584$export$a7a9523472993e97(_) {}
function $17ea3f861a2ff584$export$70a5d58ec00f3c11(entries) {
    const numericValues = Object.values(entries).filter((v)=>typeof v === "number");
    const values = Object.entries(entries).filter(([k, _])=>numericValues.indexOf(+k) === -1).map(([_, v])=>v);
    return values;
}
function $17ea3f861a2ff584$export$e79b744344f50f50(array, separator = "|") {
    return array.map((val)=>$17ea3f861a2ff584$export$5859860f650378f4(val)).join(separator);
}
function $17ea3f861a2ff584$export$f4defb13cab882b2(_, value) {
    if (typeof value === "bigint") return value.toString();
    return value;
}
function $17ea3f861a2ff584$export$ade7a147f5129058(getter) {
    const set = false;
    return {
        get value () {
            if (!set) {
                const value = getter();
                Object.defineProperty(this, "value", {
                    value: value
                });
                return value;
            }
            throw new Error("cached value already set");
        }
    };
}
function $17ea3f861a2ff584$export$69fd1b70ebae5687(input) {
    return input === null || input === undefined;
}
function $17ea3f861a2ff584$export$78d521805d6c22e4(source) {
    const start = source.startsWith("^") ? 1 : 0;
    const end = source.endsWith("$") ? source.length - 1 : source.length;
    return source.slice(start, end);
}
function $17ea3f861a2ff584$export$7807b52a740a7117(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepString = step.toString();
    let stepDecCount = (stepString.split(".")[1] || "").length;
    if (stepDecCount === 0 && /\d?e-\d?/.test(stepString)) {
        const match = stepString.match(/\d?e-(\d?)/);
        if (match?.[1]) stepDecCount = Number.parseInt(match[1]);
    }
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / 10 ** decCount;
}
const $17ea3f861a2ff584$var$EVALUATING = Symbol("evaluating");
function $17ea3f861a2ff584$export$d43070a5843c1e2(object, key, getter) {
    let value = undefined;
    Object.defineProperty(object, key, {
        get () {
            if (value === $17ea3f861a2ff584$var$EVALUATING) // Circular reference detected, return undefined to break the cycle
            return undefined;
            if (value === undefined) {
                value = $17ea3f861a2ff584$var$EVALUATING;
                value = getter();
            }
            return value;
        },
        set (v) {
            Object.defineProperty(object, key, {
                value: v
            });
        // object[key] = v;
        },
        configurable: true
    });
}
function $17ea3f861a2ff584$export$103832c7353c2f50(obj) {
    return Object.create(Object.getPrototypeOf(obj), Object.getOwnPropertyDescriptors(obj));
}
function $17ea3f861a2ff584$export$2e23d0571746a3fb(target, prop, value) {
    Object.defineProperty(target, prop, {
        value: value,
        writable: true,
        enumerable: true,
        configurable: true
    });
}
function $17ea3f861a2ff584$export$8969f8c824382d73(...defs) {
    const mergedDescriptors = {};
    for (const def of defs){
        const descriptors = Object.getOwnPropertyDescriptors(def);
        Object.assign(mergedDescriptors, descriptors);
    }
    return Object.defineProperties({}, mergedDescriptors);
}
function $17ea3f861a2ff584$export$21596dc63856f4c1(schema) {
    return $17ea3f861a2ff584$export$8969f8c824382d73(schema._zod.def);
}
function $17ea3f861a2ff584$export$4b74d241e1cc7892(obj, path) {
    if (!path) return obj;
    return path.reduce((acc, key)=>acc?.[key], obj);
}
function $17ea3f861a2ff584$export$3db3408dad58da23(promisesObj) {
    const keys = Object.keys(promisesObj);
    const promises = keys.map((key)=>promisesObj[key]);
    return Promise.all(promises).then((results)=>{
        const resolvedObj = {};
        for(let i = 0; i < keys.length; i++)resolvedObj[keys[i]] = results[i];
        return resolvedObj;
    });
}
function $17ea3f861a2ff584$export$7fa8378418b4411e(length = 10) {
    const chars = "abcdefghijklmnopqrstuvwxyz";
    let str = "";
    for(let i = 0; i < length; i++)str += chars[Math.floor(Math.random() * chars.length)];
    return str;
}
function $17ea3f861a2ff584$export$a1a11b095f88289a(str) {
    return JSON.stringify(str);
}
function $17ea3f861a2ff584$export$c383cdd2a518017a(input) {
    return input.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const $17ea3f861a2ff584$export$756e5cd2d260237b = "captureStackTrace" in Error ? Error.captureStackTrace : (..._args)=>{};
function $17ea3f861a2ff584$export$a6cdc56e425d0d0a(data) {
    return typeof data === "object" && data !== null && !Array.isArray(data);
}
const $17ea3f861a2ff584$export$1f119cb4d720843b = $17ea3f861a2ff584$export$ade7a147f5129058(()=>{
    // @ts-ignore
    if (typeof navigator !== "undefined" && navigator?.userAgent?.includes("Cloudflare")) return false;
    try {
        const F = Function;
        new F("");
        return true;
    } catch (_) {
        return false;
    }
});
function $17ea3f861a2ff584$export$53b83ca8eaab0383(o) {
    if ($17ea3f861a2ff584$export$a6cdc56e425d0d0a(o) === false) return false;
    // modified constructor
    const ctor = o.constructor;
    if (ctor === undefined) return true;
    if (typeof ctor !== "function") return true;
    // modified prototype
    const prot = ctor.prototype;
    if ($17ea3f861a2ff584$export$a6cdc56e425d0d0a(prot) === false) return false;
    // ctor doesn't have static `isPrototypeOf`
    if (Object.prototype.hasOwnProperty.call(prot, "isPrototypeOf") === false) return false;
    return true;
}
function $17ea3f861a2ff584$export$370e8311c3cdebd9(o) {
    if ($17ea3f861a2ff584$export$53b83ca8eaab0383(o)) return {
        ...o
    };
    if (Array.isArray(o)) return [
        ...o
    ];
    return o;
}
function $17ea3f861a2ff584$export$71667e74ba29447f(data) {
    let keyCount = 0;
    for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) keyCount++;
    return keyCount;
}
const $17ea3f861a2ff584$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return "undefined";
        case "string":
            return "string";
        case "number":
            return Number.isNaN(data) ? "nan" : "number";
        case "boolean":
            return "boolean";
        case "function":
            return "function";
        case "bigint":
            return "bigint";
        case "symbol":
            return "symbol";
        case "object":
            if (Array.isArray(data)) return "array";
            if (data === null) return "null";
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return "promise";
            if (typeof Map !== "undefined" && data instanceof Map) return "map";
            if (typeof Set !== "undefined" && data instanceof Set) return "set";
            if (typeof Date !== "undefined" && data instanceof Date) return "date";
            // @ts-ignore
            if (typeof File !== "undefined" && data instanceof File) return "file";
            return "object";
        default:
            throw new Error(`Unknown data type: ${t}`);
    }
};
const $17ea3f861a2ff584$export$b99c149ecf60be48 = new Set([
    "string",
    "number",
    "symbol"
]);
const $17ea3f861a2ff584$export$c34ffd355f76f0e4 = new Set([
    "string",
    "number",
    "bigint",
    "boolean",
    "symbol",
    "undefined"
]);
function $17ea3f861a2ff584$export$104ed90cc1a13451(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $17ea3f861a2ff584$export$9cd59f9826255e47(inst, def, params) {
    const cl = new inst._zod.constr(def ?? inst._zod.def);
    if (!def || params?.parent) cl._zod.parent = inst;
    return cl;
}
function $17ea3f861a2ff584$export$d6b7b25dfacfd300(_params) {
    const params = _params;
    if (!params) return {};
    if (typeof params === "string") return {
        error: ()=>params
    };
    if (params?.message !== undefined) {
        if (params?.error !== undefined) throw new Error("Cannot specify both `message` and `error` params");
        params.error = params.message;
    }
    delete params.message;
    if (typeof params.error === "string") return {
        ...params,
        error: ()=>params.error
    };
    return params;
}
function $17ea3f861a2ff584$export$6ebbd8d3cb03909b(getter) {
    let target;
    return new Proxy({}, {
        get (_, prop, receiver) {
            target ?? (target = getter());
            return Reflect.get(target, prop, receiver);
        },
        set (_, prop, value, receiver) {
            target ?? (target = getter());
            return Reflect.set(target, prop, value, receiver);
        },
        has (_, prop) {
            target ?? (target = getter());
            return Reflect.has(target, prop);
        },
        deleteProperty (_, prop) {
            target ?? (target = getter());
            return Reflect.deleteProperty(target, prop);
        },
        ownKeys (_) {
            target ?? (target = getter());
            return Reflect.ownKeys(target);
        },
        getOwnPropertyDescriptor (_, prop) {
            target ?? (target = getter());
            return Reflect.getOwnPropertyDescriptor(target, prop);
        },
        defineProperty (_, prop, descriptor) {
            target ?? (target = getter());
            return Reflect.defineProperty(target, prop, descriptor);
        }
    });
}
function $17ea3f861a2ff584$export$5859860f650378f4(value) {
    if (typeof value === "bigint") return value.toString() + "n";
    if (typeof value === "string") return `"${value}"`;
    return `${value}`;
}
function $17ea3f861a2ff584$export$240159211e66adb9(shape) {
    return Object.keys(shape).filter((k)=>{
        return shape[k]._zod.optin === "optional" && shape[k]._zod.optout === "optional";
    });
}
const $17ea3f861a2ff584$export$8e78302060ccf26f = {
    safeint: [
        Number.MIN_SAFE_INTEGER,
        Number.MAX_SAFE_INTEGER
    ],
    int32: [
        -2147483648,
        2147483647
    ],
    uint32: [
        0,
        4294967295
    ],
    float32: [
        -340282346638528860000000000000000000000,
        3.4028234663852886e38
    ],
    float64: [
        -Number.MAX_VALUE,
        Number.MAX_VALUE
    ]
};
const $17ea3f861a2ff584$export$538d1d6d5cfcb3b6 = {
    int64: [
        /* @__PURE__*/ BigInt("-9223372036854775808"),
        /* @__PURE__*/ BigInt("9223372036854775807")
    ],
    uint64: [
        /* @__PURE__*/ BigInt(0),
        /* @__PURE__*/ BigInt("18446744073709551615")
    ]
};
function $17ea3f861a2ff584$export$357523c63a2253b9(schema, mask) {
    const currDef = schema._zod.def;
    const checks = currDef.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) throw new Error(".pick() cannot be used on object schemas containing refinements");
    const def = $17ea3f861a2ff584$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const newShape = {};
            for(const key in mask){
                if (!(key in currDef.shape)) throw new Error(`Unrecognized key: "${key}"`);
                if (!mask[key]) continue;
                newShape[key] = currDef.shape[key];
            }
            $17ea3f861a2ff584$export$2e23d0571746a3fb(this, "shape", newShape); // self-caching
            return newShape;
        },
        checks: []
    });
    return $17ea3f861a2ff584$export$9cd59f9826255e47(schema, def);
}
function $17ea3f861a2ff584$export$30a06c8d3562193f(schema, mask) {
    const currDef = schema._zod.def;
    const checks = currDef.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) throw new Error(".omit() cannot be used on object schemas containing refinements");
    const def = $17ea3f861a2ff584$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const newShape = {
                ...schema._zod.def.shape
            };
            for(const key in mask){
                if (!(key in currDef.shape)) throw new Error(`Unrecognized key: "${key}"`);
                if (!mask[key]) continue;
                delete newShape[key];
            }
            $17ea3f861a2ff584$export$2e23d0571746a3fb(this, "shape", newShape); // self-caching
            return newShape;
        },
        checks: []
    });
    return $17ea3f861a2ff584$export$9cd59f9826255e47(schema, def);
}
function $17ea3f861a2ff584$export$8b58be045bf06082(schema, shape) {
    if (!$17ea3f861a2ff584$export$53b83ca8eaab0383(shape)) throw new Error("Invalid input to extend: expected a plain object");
    const checks = schema._zod.def.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) {
        // Only throw if new shape overlaps with existing shape
        // Use getOwnPropertyDescriptor to check key existence without accessing values
        const existingShape = schema._zod.def.shape;
        for(const key in shape){
            if (Object.getOwnPropertyDescriptor(existingShape, key) !== undefined) throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
        }
    }
    const def = $17ea3f861a2ff584$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const _shape = {
                ...schema._zod.def.shape,
                ...shape
            };
            $17ea3f861a2ff584$export$2e23d0571746a3fb(this, "shape", _shape); // self-caching
            return _shape;
        }
    });
    return $17ea3f861a2ff584$export$9cd59f9826255e47(schema, def);
}
function $17ea3f861a2ff584$export$40c90eb222f50efb(schema, shape) {
    if (!$17ea3f861a2ff584$export$53b83ca8eaab0383(shape)) throw new Error("Invalid input to safeExtend: expected a plain object");
    const def = $17ea3f861a2ff584$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const _shape = {
                ...schema._zod.def.shape,
                ...shape
            };
            $17ea3f861a2ff584$export$2e23d0571746a3fb(this, "shape", _shape); // self-caching
            return _shape;
        }
    });
    return $17ea3f861a2ff584$export$9cd59f9826255e47(schema, def);
}
function $17ea3f861a2ff584$export$4950aa0f605343fb(a, b) {
    const def = $17ea3f861a2ff584$export$8969f8c824382d73(a._zod.def, {
        get shape () {
            const _shape = {
                ...a._zod.def.shape,
                ...b._zod.def.shape
            };
            $17ea3f861a2ff584$export$2e23d0571746a3fb(this, "shape", _shape); // self-caching
            return _shape;
        },
        get catchall () {
            return b._zod.def.catchall;
        },
        checks: []
    });
    return $17ea3f861a2ff584$export$9cd59f9826255e47(a, def);
}
function $17ea3f861a2ff584$export$e45945969df8035a(Class, schema, mask) {
    const currDef = schema._zod.def;
    const checks = currDef.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) throw new Error(".partial() cannot be used on object schemas containing refinements");
    const def = $17ea3f861a2ff584$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const oldShape = schema._zod.def.shape;
            const shape = {
                ...oldShape
            };
            if (mask) for(const key in mask){
                if (!(key in oldShape)) throw new Error(`Unrecognized key: "${key}"`);
                if (!mask[key]) continue;
                // if (oldShape[key]!._zod.optin === "optional") continue;
                shape[key] = Class ? new Class({
                    type: "optional",
                    innerType: oldShape[key]
                }) : oldShape[key];
            }
            else for(const key in oldShape)// if (oldShape[key]!._zod.optin === "optional") continue;
            shape[key] = Class ? new Class({
                type: "optional",
                innerType: oldShape[key]
            }) : oldShape[key];
            $17ea3f861a2ff584$export$2e23d0571746a3fb(this, "shape", shape); // self-caching
            return shape;
        },
        checks: []
    });
    return $17ea3f861a2ff584$export$9cd59f9826255e47(schema, def);
}
function $17ea3f861a2ff584$export$a7a0278c004aac3f(Class, schema, mask) {
    const def = $17ea3f861a2ff584$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const oldShape = schema._zod.def.shape;
            const shape = {
                ...oldShape
            };
            if (mask) for(const key in mask){
                if (!(key in shape)) throw new Error(`Unrecognized key: "${key}"`);
                if (!mask[key]) continue;
                // overwrite with non-optional
                shape[key] = new Class({
                    type: "nonoptional",
                    innerType: oldShape[key]
                });
            }
            else for(const key in oldShape)// overwrite with non-optional
            shape[key] = new Class({
                type: "nonoptional",
                innerType: oldShape[key]
            });
            $17ea3f861a2ff584$export$2e23d0571746a3fb(this, "shape", shape); // self-caching
            return shape;
        }
    });
    return $17ea3f861a2ff584$export$9cd59f9826255e47(schema, def);
}
function $17ea3f861a2ff584$export$bd75b6d981b9c7f2(x, startIndex = 0) {
    if (x.aborted === true) return true;
    for(let i = startIndex; i < x.issues.length; i++){
        if (x.issues[i]?.continue !== true) return true;
    }
    return false;
}
function $17ea3f861a2ff584$export$7f35a4c434118b9e(path, issues) {
    return issues.map((iss)=>{
        var _a;
        (_a = iss).path ?? (_a.path = []);
        iss.path.unshift(path);
        return iss;
    });
}
function $17ea3f861a2ff584$export$56590e5a47837d61(message) {
    return typeof message === "string" ? message : message?.message;
}
function $17ea3f861a2ff584$export$c5e667bbfc286a9d(iss, ctx, config) {
    const full = {
        ...iss,
        path: iss.path ?? []
    };
    // for backwards compatibility
    if (!iss.message) {
        const message = $17ea3f861a2ff584$export$56590e5a47837d61(iss.inst?._zod.def?.error?.(iss)) ?? $17ea3f861a2ff584$export$56590e5a47837d61(ctx?.error?.(iss)) ?? $17ea3f861a2ff584$export$56590e5a47837d61(config.customError?.(iss)) ?? $17ea3f861a2ff584$export$56590e5a47837d61(config.localeError?.(iss)) ?? "Invalid input";
        full.message = message;
    }
    // delete (full as any).def;
    delete full.inst;
    delete full.continue;
    if (!ctx?.reportInput) delete full.input;
    return full;
}
function $17ea3f861a2ff584$export$67a7c9c676c45d2b(input) {
    if (input instanceof Set) return "set";
    if (input instanceof Map) return "map";
    // @ts-ignore
    if (input instanceof File) return "file";
    return "unknown";
}
function $17ea3f861a2ff584$export$479f5a070abeb487(input) {
    if (Array.isArray(input)) return "array";
    if (typeof input === "string") return "string";
    return "unknown";
}
function $17ea3f861a2ff584$export$858d360cf6da2b65(data) {
    const t = typeof data;
    switch(t){
        case "number":
            return Number.isNaN(data) ? "nan" : "number";
        case "object":
            {
                if (data === null) return "null";
                if (Array.isArray(data)) return "array";
                const obj = data;
                if (obj && Object.getPrototypeOf(obj) !== Object.prototype && "constructor" in obj && obj.constructor) return obj.constructor.name;
            }
    }
    return t;
}
function $17ea3f861a2ff584$export$69ad3503f98be476(...args) {
    const [iss, input, inst] = args;
    if (typeof iss === "string") return {
        message: iss,
        code: "custom",
        input: input,
        inst: inst
    };
    return {
        ...iss
    };
}
function $17ea3f861a2ff584$export$9b57aa937148f32(obj) {
    return Object.entries(obj).filter(([k, _])=>{
        // return true if NaN, meaning it's not a number, thus a string key
        return Number.isNaN(Number.parseInt(k, 10));
    }).map((el)=>el[1]);
}
function $17ea3f861a2ff584$export$f01069a3c307e50e(base64) {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for(let i = 0; i < binaryString.length; i++)bytes[i] = binaryString.charCodeAt(i);
    return bytes;
}
function $17ea3f861a2ff584$export$36bac84b1c2da9c7(bytes) {
    let binaryString = "";
    for(let i = 0; i < bytes.length; i++)binaryString += String.fromCharCode(bytes[i]);
    return btoa(binaryString);
}
function $17ea3f861a2ff584$export$b9fa2551f2db41e1(base64url) {
    const base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");
    const padding = "=".repeat((4 - base64.length % 4) % 4);
    return $17ea3f861a2ff584$export$f01069a3c307e50e(base64 + padding);
}
function $17ea3f861a2ff584$export$975f78e50159df6f(bytes) {
    return $17ea3f861a2ff584$export$36bac84b1c2da9c7(bytes).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function $17ea3f861a2ff584$export$6c74ef56152ffb8d(hex) {
    const cleanHex = hex.replace(/^0x/, "");
    if (cleanHex.length % 2 !== 0) throw new Error("Invalid hex string length");
    const bytes = new Uint8Array(cleanHex.length / 2);
    for(let i = 0; i < cleanHex.length; i += 2)bytes[i / 2] = Number.parseInt(cleanHex.slice(i, i + 2), 16);
    return bytes;
}
function $17ea3f861a2ff584$export$c44b02fb03dbac82(bytes) {
    return Array.from(bytes).map((b)=>b.toString(16).padStart(2, "0")).join("");
}
class $17ea3f861a2ff584$export$4c85e640eb41c31b {
    constructor(..._args){}
}


const $0b6c05566f4aeada$var$initializer = (inst, def)=>{
    inst.name = "$ZodError";
    Object.defineProperty(inst, "_zod", {
        value: inst._zod,
        enumerable: false
    });
    Object.defineProperty(inst, "issues", {
        value: def,
        enumerable: false
    });
    inst.message = JSON.stringify(def, $17ea3f861a2ff584$export$f4defb13cab882b2, 2);
    Object.defineProperty(inst, "toString", {
        value: ()=>inst.message,
        enumerable: false
    });
};
const $0b6c05566f4aeada$export$544878318730b1d8 = (0, $4488038d123e8fa5$export$3122533d606194de)("$ZodError", $0b6c05566f4aeada$var$initializer);
const $0b6c05566f4aeada$export$4e07b515db2f7672 = (0, $4488038d123e8fa5$export$3122533d606194de)("$ZodError", $0b6c05566f4aeada$var$initializer, {
    Parent: Error
});
function $0b6c05566f4aeada$export$4d7e0dfd5ca8366f(error, mapper = (issue)=>issue.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub of error.issues)if (sub.path.length > 0) {
        fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
        fieldErrors[sub.path[0]].push(mapper(sub));
    } else formErrors.push(mapper(sub));
    return {
        formErrors: formErrors,
        fieldErrors: fieldErrors
    };
}
function $0b6c05566f4aeada$export$7b5b869ee98c16ab(error, mapper = (issue)=>issue.message) {
    const fieldErrors = {
        _errors: []
    };
    const processError = (error)=>{
        for (const issue of error.issues){
            if (issue.code === "invalid_union" && issue.errors.length) issue.errors.map((issues)=>processError({
                    issues: issues
                }));
            else if (issue.code === "invalid_key") processError({
                issues: issue.issues
            });
            else if (issue.code === "invalid_element") processError({
                issues: issue.issues
            });
            else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
            else {
                let curr = fieldErrors;
                let i = 0;
                while(i < issue.path.length){
                    const el = issue.path[i];
                    const terminal = i === issue.path.length - 1;
                    if (!terminal) curr[el] = curr[el] || {
                        _errors: []
                    };
                    else {
                        curr[el] = curr[el] || {
                            _errors: []
                        };
                        curr[el]._errors.push(mapper(issue));
                    }
                    curr = curr[el];
                    i++;
                }
            }
        }
    };
    processError(error);
    return fieldErrors;
}
function $0b6c05566f4aeada$export$93701dc89257de2f(error, mapper = (issue)=>issue.message) {
    const result = {
        errors: []
    };
    const processError = (error, path = [])=>{
        var _a, _b;
        for (const issue of error.issues){
            if (issue.code === "invalid_union" && issue.errors.length) // regular union error
            issue.errors.map((issues)=>processError({
                    issues: issues
                }, issue.path));
            else if (issue.code === "invalid_key") processError({
                issues: issue.issues
            }, issue.path);
            else if (issue.code === "invalid_element") processError({
                issues: issue.issues
            }, issue.path);
            else {
                const fullpath = [
                    ...path,
                    ...issue.path
                ];
                if (fullpath.length === 0) {
                    result.errors.push(mapper(issue));
                    continue;
                }
                let curr = result;
                let i = 0;
                while(i < fullpath.length){
                    const el = fullpath[i];
                    const terminal = i === fullpath.length - 1;
                    if (typeof el === "string") {
                        curr.properties ?? (curr.properties = {});
                        (_a = curr.properties)[el] ?? (_a[el] = {
                            errors: []
                        });
                        curr = curr.properties[el];
                    } else {
                        curr.items ?? (curr.items = []);
                        (_b = curr.items)[el] ?? (_b[el] = {
                            errors: []
                        });
                        curr = curr.items[el];
                    }
                    if (terminal) curr.errors.push(mapper(issue));
                    i++;
                }
            }
        }
    };
    processError(error);
    return result;
}
function $0b6c05566f4aeada$export$47768e8997ceb13a(_path) {
    const segs = [];
    const path = _path.map((seg)=>typeof seg === "object" ? seg.key : seg);
    for (const seg of path){
        if (typeof seg === "number") segs.push(`[${seg}]`);
        else if (typeof seg === "symbol") segs.push(`[${JSON.stringify(String(seg))}]`);
        else if (/[^\w$]/.test(seg)) segs.push(`[${JSON.stringify(seg)}]`);
        else {
            if (segs.length) segs.push(".");
            segs.push(seg);
        }
    }
    return segs.join("");
}
function $0b6c05566f4aeada$export$44eaaa72d914fe8c(error) {
    const lines = [];
    // sort by path length
    const issues = [
        ...error.issues
    ].sort((a, b)=>(a.path ?? []).length - (b.path ?? []).length);
    // Process each issue
    for (const issue of issues){
        lines.push(`\u{2716} ${issue.message}`);
        if (issue.path?.length) lines.push(`  \u{2192} at ${$0b6c05566f4aeada$export$47768e8997ceb13a(issue.path)}`);
    }
    // Convert Map to formatted string
    return lines.join("\n");
}



const $3bba9a623c1bec43$export$dcd1bb9991b57edf = (_Err)=>(schema, value, _ctx, _params)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            async: false
        }) : {
            async: false
        };
        const result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) throw new $4488038d123e8fa5$export$13016bcec11ba196();
        if (result.issues.length) {
            const e = new (_params?.Err ?? _Err)(result.issues.map((iss)=>$17ea3f861a2ff584$export$c5e667bbfc286a9d(iss, ctx, $4488038d123e8fa5$export$e506a1d27d1eaa20())));
            $17ea3f861a2ff584$export$756e5cd2d260237b(e, _params?.callee);
            throw e;
        }
        return result.value;
    };
const $3bba9a623c1bec43$export$98e6a39c04603d36 = /* @__PURE__*/ $3bba9a623c1bec43$export$dcd1bb9991b57edf($0b6c05566f4aeada$export$4e07b515db2f7672);
const $3bba9a623c1bec43$export$1fcca22dc6c780d0 = (_Err)=>async (schema, value, _ctx, params)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            async: true
        }) : {
            async: true
        };
        let result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) result = await result;
        if (result.issues.length) {
            const e = new (params?.Err ?? _Err)(result.issues.map((iss)=>$17ea3f861a2ff584$export$c5e667bbfc286a9d(iss, ctx, $4488038d123e8fa5$export$e506a1d27d1eaa20())));
            $17ea3f861a2ff584$export$756e5cd2d260237b(e, params?.callee);
            throw e;
        }
        return result.value;
    };
const $3bba9a623c1bec43$export$59b6f938fbf579e3 = /* @__PURE__*/ $3bba9a623c1bec43$export$1fcca22dc6c780d0($0b6c05566f4aeada$export$4e07b515db2f7672);
const $3bba9a623c1bec43$export$5ec32605bf51e98e = (_Err)=>(schema, value, _ctx)=>{
        const ctx = _ctx ? {
            ..._ctx,
            async: false
        } : {
            async: false
        };
        const result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) throw new $4488038d123e8fa5$export$13016bcec11ba196();
        return result.issues.length ? {
            success: false,
            error: new (_Err ?? $0b6c05566f4aeada$export$544878318730b1d8)(result.issues.map((iss)=>$17ea3f861a2ff584$export$c5e667bbfc286a9d(iss, ctx, $4488038d123e8fa5$export$e506a1d27d1eaa20())))
        } : {
            success: true,
            data: result.value
        };
    };
const $3bba9a623c1bec43$export$b48ee232557adc37 = /* @__PURE__*/ $3bba9a623c1bec43$export$5ec32605bf51e98e($0b6c05566f4aeada$export$4e07b515db2f7672);
const $3bba9a623c1bec43$export$c08c7322f5625faf = (_Err)=>async (schema, value, _ctx)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            async: true
        }) : {
            async: true
        };
        let result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) result = await result;
        return result.issues.length ? {
            success: false,
            error: new _Err(result.issues.map((iss)=>$17ea3f861a2ff584$export$c5e667bbfc286a9d(iss, ctx, $4488038d123e8fa5$export$e506a1d27d1eaa20())))
        } : {
            success: true,
            data: result.value
        };
    };
const $3bba9a623c1bec43$export$9b07b0d6e0389261 = /* @__PURE__*/ $3bba9a623c1bec43$export$c08c7322f5625faf($0b6c05566f4aeada$export$4e07b515db2f7672);
const $3bba9a623c1bec43$export$50e4445ccc10715b = (_Err)=>(schema, value, _ctx)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            direction: "backward"
        }) : {
            direction: "backward"
        };
        return $3bba9a623c1bec43$export$dcd1bb9991b57edf(_Err)(schema, value, ctx);
    };
const $3bba9a623c1bec43$export$c564cdbbe6da493 = /* @__PURE__*/ $3bba9a623c1bec43$export$50e4445ccc10715b($0b6c05566f4aeada$export$4e07b515db2f7672);
const $3bba9a623c1bec43$export$bb4a21772f43c982 = (_Err)=>(schema, value, _ctx)=>{
        return $3bba9a623c1bec43$export$dcd1bb9991b57edf(_Err)(schema, value, _ctx);
    };
const $3bba9a623c1bec43$export$2f872c0f2117be69 = /* @__PURE__*/ $3bba9a623c1bec43$export$bb4a21772f43c982($0b6c05566f4aeada$export$4e07b515db2f7672);
const $3bba9a623c1bec43$export$9954740a1a5eaaf1 = (_Err)=>async (schema, value, _ctx)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            direction: "backward"
        }) : {
            direction: "backward"
        };
        return $3bba9a623c1bec43$export$1fcca22dc6c780d0(_Err)(schema, value, ctx);
    };
const $3bba9a623c1bec43$export$1a62660bbffb8f11 = /* @__PURE__*/ $3bba9a623c1bec43$export$9954740a1a5eaaf1($0b6c05566f4aeada$export$4e07b515db2f7672);
const $3bba9a623c1bec43$export$74b09e12c8956d91 = (_Err)=>async (schema, value, _ctx)=>{
        return $3bba9a623c1bec43$export$1fcca22dc6c780d0(_Err)(schema, value, _ctx);
    };
const $3bba9a623c1bec43$export$e4c183687a6ff9b = /* @__PURE__*/ $3bba9a623c1bec43$export$74b09e12c8956d91($0b6c05566f4aeada$export$4e07b515db2f7672);
const $3bba9a623c1bec43$export$6d688d774257f486 = (_Err)=>(schema, value, _ctx)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            direction: "backward"
        }) : {
            direction: "backward"
        };
        return $3bba9a623c1bec43$export$5ec32605bf51e98e(_Err)(schema, value, ctx);
    };
const $3bba9a623c1bec43$export$c094f85f253e4d7d = /* @__PURE__*/ $3bba9a623c1bec43$export$6d688d774257f486($0b6c05566f4aeada$export$4e07b515db2f7672);
const $3bba9a623c1bec43$export$b2ef531a734faad5 = (_Err)=>(schema, value, _ctx)=>{
        return $3bba9a623c1bec43$export$5ec32605bf51e98e(_Err)(schema, value, _ctx);
    };
const $3bba9a623c1bec43$export$7a47376c130cfeac = /* @__PURE__*/ $3bba9a623c1bec43$export$b2ef531a734faad5($0b6c05566f4aeada$export$4e07b515db2f7672);
const $3bba9a623c1bec43$export$fa2ac180d22758d6 = (_Err)=>async (schema, value, _ctx)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            direction: "backward"
        }) : {
            direction: "backward"
        };
        return $3bba9a623c1bec43$export$c08c7322f5625faf(_Err)(schema, value, ctx);
    };
const $3bba9a623c1bec43$export$ed163a34170fecc5 = /* @__PURE__*/ $3bba9a623c1bec43$export$fa2ac180d22758d6($0b6c05566f4aeada$export$4e07b515db2f7672);
const $3bba9a623c1bec43$export$f66d2b402dc6318c = (_Err)=>async (schema, value, _ctx)=>{
        return $3bba9a623c1bec43$export$c08c7322f5625faf(_Err)(schema, value, _ctx);
    };
const $3bba9a623c1bec43$export$9f879005292a9bc9 = /* @__PURE__*/ $3bba9a623c1bec43$export$f66d2b402dc6318c($0b6c05566f4aeada$export$4e07b515db2f7672);



// import { $ZodType } from "./schemas.js";

var $a2fdfdb502fc74b8$exports = {};

$parcel$export($a2fdfdb502fc74b8$exports, "cuid", () => $a2fdfdb502fc74b8$export$e057ec210c7d3443);
$parcel$export($a2fdfdb502fc74b8$exports, "cuid2", () => $a2fdfdb502fc74b8$export$af5866a6cccce9f0);
$parcel$export($a2fdfdb502fc74b8$exports, "ulid", () => $a2fdfdb502fc74b8$export$c34778236461ea95);
$parcel$export($a2fdfdb502fc74b8$exports, "xid", () => $a2fdfdb502fc74b8$export$5eecaf20006cb6cb);
$parcel$export($a2fdfdb502fc74b8$exports, "ksuid", () => $a2fdfdb502fc74b8$export$f49b11deeb9beb0f);
$parcel$export($a2fdfdb502fc74b8$exports, "nanoid", () => $a2fdfdb502fc74b8$export$ac4959f4f1338dfc);
$parcel$export($a2fdfdb502fc74b8$exports, "duration", () => $a2fdfdb502fc74b8$export$1f34108aa9eb96ab);
$parcel$export($a2fdfdb502fc74b8$exports, "extendedDuration", () => $a2fdfdb502fc74b8$export$e30244ba59a8cd84);
$parcel$export($a2fdfdb502fc74b8$exports, "guid", () => $a2fdfdb502fc74b8$export$46e8f25c7328f77e);
$parcel$export($a2fdfdb502fc74b8$exports, "uuid", () => $a2fdfdb502fc74b8$export$31b40729666a4ae0);
$parcel$export($a2fdfdb502fc74b8$exports, "uuid4", () => $a2fdfdb502fc74b8$export$19f53698e68b2496);
$parcel$export($a2fdfdb502fc74b8$exports, "uuid6", () => $a2fdfdb502fc74b8$export$1d78c41b29712c01);
$parcel$export($a2fdfdb502fc74b8$exports, "uuid7", () => $a2fdfdb502fc74b8$export$b3092b3ac1fa0ace);
$parcel$export($a2fdfdb502fc74b8$exports, "email", () => $a2fdfdb502fc74b8$export$d290fa47940df19d);
$parcel$export($a2fdfdb502fc74b8$exports, "html5Email", () => $a2fdfdb502fc74b8$export$d2c782992f0a89ee);
$parcel$export($a2fdfdb502fc74b8$exports, "rfc5322Email", () => $a2fdfdb502fc74b8$export$54f6bc2d4fd0bb08);
$parcel$export($a2fdfdb502fc74b8$exports, "unicodeEmail", () => $a2fdfdb502fc74b8$export$f8855510ae7521df);
$parcel$export($a2fdfdb502fc74b8$exports, "idnEmail", () => $a2fdfdb502fc74b8$export$d402ea1c27a77371);
$parcel$export($a2fdfdb502fc74b8$exports, "browserEmail", () => $a2fdfdb502fc74b8$export$9d1ec0311c8ce72e);
$parcel$export($a2fdfdb502fc74b8$exports, "emoji", () => $a2fdfdb502fc74b8$export$a19185d1233fc4b2);
$parcel$export($a2fdfdb502fc74b8$exports, "ipv4", () => $a2fdfdb502fc74b8$export$291a17a16047f284);
$parcel$export($a2fdfdb502fc74b8$exports, "ipv6", () => $a2fdfdb502fc74b8$export$4e0c86a59c658526);
$parcel$export($a2fdfdb502fc74b8$exports, "mac", () => $a2fdfdb502fc74b8$export$f8d11e097856efcf);
$parcel$export($a2fdfdb502fc74b8$exports, "cidrv4", () => $a2fdfdb502fc74b8$export$fc96793d9715e5a1);
$parcel$export($a2fdfdb502fc74b8$exports, "cidrv6", () => $a2fdfdb502fc74b8$export$b6e650831cac87fb);
$parcel$export($a2fdfdb502fc74b8$exports, "base64", () => $a2fdfdb502fc74b8$export$b3b2de96497acc47);
$parcel$export($a2fdfdb502fc74b8$exports, "base64url", () => $a2fdfdb502fc74b8$export$7d21597c7bc64465);
$parcel$export($a2fdfdb502fc74b8$exports, "hostname", () => $a2fdfdb502fc74b8$export$640106f6dc7d2706);
$parcel$export($a2fdfdb502fc74b8$exports, "domain", () => $a2fdfdb502fc74b8$export$21779e503be4cd98);
$parcel$export($a2fdfdb502fc74b8$exports, "e164", () => $a2fdfdb502fc74b8$export$2fa5ed24c9ef198e);
$parcel$export($a2fdfdb502fc74b8$exports, "date", () => $a2fdfdb502fc74b8$export$324d90190a8b822a);
$parcel$export($a2fdfdb502fc74b8$exports, "time", () => $a2fdfdb502fc74b8$export$2da9be4cfdb689b1);
$parcel$export($a2fdfdb502fc74b8$exports, "datetime", () => $a2fdfdb502fc74b8$export$7ba4466dbd0f07e1);
$parcel$export($a2fdfdb502fc74b8$exports, "string", () => $a2fdfdb502fc74b8$export$22b082955e083ec3);
$parcel$export($a2fdfdb502fc74b8$exports, "bigint", () => $a2fdfdb502fc74b8$export$a0f65b52274bcc00);
$parcel$export($a2fdfdb502fc74b8$exports, "integer", () => $a2fdfdb502fc74b8$export$32744b5b3bba4764);
$parcel$export($a2fdfdb502fc74b8$exports, "number", () => $a2fdfdb502fc74b8$export$98e628dec113755e);
$parcel$export($a2fdfdb502fc74b8$exports, "boolean", () => $a2fdfdb502fc74b8$export$4a21f16c33752377);
$parcel$export($a2fdfdb502fc74b8$exports, "null", () => $a2fdfdb502fc74b8$export$7b1b591b262c240);
$parcel$export($a2fdfdb502fc74b8$exports, "undefined", () => $a2fdfdb502fc74b8$export$1db45310990710a5);
$parcel$export($a2fdfdb502fc74b8$exports, "lowercase", () => $a2fdfdb502fc74b8$export$5b1f80f3c282648c);
$parcel$export($a2fdfdb502fc74b8$exports, "uppercase", () => $a2fdfdb502fc74b8$export$6cfe151e6b925e83);
$parcel$export($a2fdfdb502fc74b8$exports, "hex", () => $a2fdfdb502fc74b8$export$834dfc94dde4b3d8);
$parcel$export($a2fdfdb502fc74b8$exports, "md5_hex", () => $a2fdfdb502fc74b8$export$7d7ef811f6d53a1);
$parcel$export($a2fdfdb502fc74b8$exports, "md5_base64", () => $a2fdfdb502fc74b8$export$85425f7cda9f4890);
$parcel$export($a2fdfdb502fc74b8$exports, "md5_base64url", () => $a2fdfdb502fc74b8$export$e54699b04083758c);
$parcel$export($a2fdfdb502fc74b8$exports, "sha1_hex", () => $a2fdfdb502fc74b8$export$2f163473ef893e12);
$parcel$export($a2fdfdb502fc74b8$exports, "sha1_base64", () => $a2fdfdb502fc74b8$export$fc9670fedfd2524a);
$parcel$export($a2fdfdb502fc74b8$exports, "sha1_base64url", () => $a2fdfdb502fc74b8$export$5b6729b977839ffd);
$parcel$export($a2fdfdb502fc74b8$exports, "sha256_hex", () => $a2fdfdb502fc74b8$export$a923016129fea5fb);
$parcel$export($a2fdfdb502fc74b8$exports, "sha256_base64", () => $a2fdfdb502fc74b8$export$ebc25582a9e85396);
$parcel$export($a2fdfdb502fc74b8$exports, "sha256_base64url", () => $a2fdfdb502fc74b8$export$9b7979bfebd9716e);
$parcel$export($a2fdfdb502fc74b8$exports, "sha384_hex", () => $a2fdfdb502fc74b8$export$61d1fe464d10a5d1);
$parcel$export($a2fdfdb502fc74b8$exports, "sha384_base64", () => $a2fdfdb502fc74b8$export$103403cb96133ac3);
$parcel$export($a2fdfdb502fc74b8$exports, "sha384_base64url", () => $a2fdfdb502fc74b8$export$eeafcb7aab6a9870);
$parcel$export($a2fdfdb502fc74b8$exports, "sha512_hex", () => $a2fdfdb502fc74b8$export$e246a4310a1ad74d);
$parcel$export($a2fdfdb502fc74b8$exports, "sha512_base64", () => $a2fdfdb502fc74b8$export$f698997e063dbdae);
$parcel$export($a2fdfdb502fc74b8$exports, "sha512_base64url", () => $a2fdfdb502fc74b8$export$a63330069e1b81f6);

const $a2fdfdb502fc74b8$export$e057ec210c7d3443 = /^[cC][^\s-]{8,}$/;
const $a2fdfdb502fc74b8$export$af5866a6cccce9f0 = /^[0-9a-z]+$/;
const $a2fdfdb502fc74b8$export$c34778236461ea95 = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/;
const $a2fdfdb502fc74b8$export$5eecaf20006cb6cb = /^[0-9a-vA-V]{20}$/;
const $a2fdfdb502fc74b8$export$f49b11deeb9beb0f = /^[A-Za-z0-9]{27}$/;
const $a2fdfdb502fc74b8$export$ac4959f4f1338dfc = /^[a-zA-Z0-9_-]{21}$/;
const $a2fdfdb502fc74b8$export$1f34108aa9eb96ab = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/;
const $a2fdfdb502fc74b8$export$e30244ba59a8cd84 = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
const $a2fdfdb502fc74b8$export$46e8f25c7328f77e = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/;
const $a2fdfdb502fc74b8$export$31b40729666a4ae0 = (version)=>{
    if (!version) return /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/;
    return new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${version}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`);
};
const $a2fdfdb502fc74b8$export$19f53698e68b2496 = /*@__PURE__*/ $a2fdfdb502fc74b8$export$31b40729666a4ae0(4);
const $a2fdfdb502fc74b8$export$1d78c41b29712c01 = /*@__PURE__*/ $a2fdfdb502fc74b8$export$31b40729666a4ae0(6);
const $a2fdfdb502fc74b8$export$b3092b3ac1fa0ace = /*@__PURE__*/ $a2fdfdb502fc74b8$export$31b40729666a4ae0(7);
const $a2fdfdb502fc74b8$export$d290fa47940df19d = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/;
const $a2fdfdb502fc74b8$export$d2c782992f0a89ee = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
const $a2fdfdb502fc74b8$export$54f6bc2d4fd0bb08 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const $a2fdfdb502fc74b8$export$f8855510ae7521df = /^[^\s@"]{1,64}@[^\s@]{1,255}$/u;
const $a2fdfdb502fc74b8$export$d402ea1c27a77371 = $a2fdfdb502fc74b8$export$f8855510ae7521df;
const $a2fdfdb502fc74b8$export$9d1ec0311c8ce72e = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $a2fdfdb502fc74b8$var$_emoji = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
function $a2fdfdb502fc74b8$export$a19185d1233fc4b2() {
    return new RegExp($a2fdfdb502fc74b8$var$_emoji, "u");
}
const $a2fdfdb502fc74b8$export$291a17a16047f284 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $a2fdfdb502fc74b8$export$4e0c86a59c658526 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/;
const $a2fdfdb502fc74b8$export$f8d11e097856efcf = (delimiter)=>{
    const escapedDelim = $17ea3f861a2ff584$export$104ed90cc1a13451(delimiter ?? ":");
    return new RegExp(`^(?:[0-9A-F]{2}${escapedDelim}){5}[0-9A-F]{2}$|^(?:[0-9a-f]{2}${escapedDelim}){5}[0-9a-f]{2}$`);
};
const $a2fdfdb502fc74b8$export$fc96793d9715e5a1 = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/;
const $a2fdfdb502fc74b8$export$b6e650831cac87fb = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
const $a2fdfdb502fc74b8$export$b3b2de96497acc47 = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/;
const $a2fdfdb502fc74b8$export$7d21597c7bc64465 = /^[A-Za-z0-9_-]*$/;
const $a2fdfdb502fc74b8$export$640106f6dc7d2706 = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/;
const $a2fdfdb502fc74b8$export$21779e503be4cd98 = /^([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
const $a2fdfdb502fc74b8$export$2fa5ed24c9ef198e = /^\+[1-9]\d{6,14}$/;
// const dateSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $a2fdfdb502fc74b8$var$dateSource = `(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))`;
const $a2fdfdb502fc74b8$export$324d90190a8b822a = /*@__PURE__*/ new RegExp(`^${$a2fdfdb502fc74b8$var$dateSource}$`);
function $a2fdfdb502fc74b8$var$timeSource(args) {
    const hhmm = `(?:[01]\\d|2[0-3]):[0-5]\\d`;
    const regex = typeof args.precision === "number" ? args.precision === -1 ? `${hhmm}` : args.precision === 0 ? `${hhmm}:[0-5]\\d` : `${hhmm}:[0-5]\\d\\.\\d{${args.precision}}` : `${hhmm}(?::[0-5]\\d(?:\\.\\d+)?)?`;
    return regex;
}
function $a2fdfdb502fc74b8$export$2da9be4cfdb689b1(args) {
    return new RegExp(`^${$a2fdfdb502fc74b8$var$timeSource(args)}$`);
}
function $a2fdfdb502fc74b8$export$7ba4466dbd0f07e1(args) {
    const time = $a2fdfdb502fc74b8$var$timeSource({
        precision: args.precision
    });
    const opts = [
        "Z"
    ];
    if (args.local) opts.push("");
    // if (args.offset) opts.push(`([+-]\\d{2}:\\d{2})`);
    if (args.offset) opts.push(`([+-](?:[01]\\d|2[0-3]):[0-5]\\d)`);
    const timeRegex = `${time}(?:${opts.join("|")})`;
    return new RegExp(`^${$a2fdfdb502fc74b8$var$dateSource}T(?:${timeRegex})$`);
}
const $a2fdfdb502fc74b8$export$22b082955e083ec3 = (params)=>{
    const regex = params ? `[\\s\\S]{${params?.minimum ?? 0},${params?.maximum ?? ""}}` : `[\\s\\S]*`;
    return new RegExp(`^${regex}$`);
};
const $a2fdfdb502fc74b8$export$a0f65b52274bcc00 = /^-?\d+n?$/;
const $a2fdfdb502fc74b8$export$32744b5b3bba4764 = /^-?\d+$/;
const $a2fdfdb502fc74b8$export$98e628dec113755e = /^-?\d+(?:\.\d+)?$/;
const $a2fdfdb502fc74b8$export$4a21f16c33752377 = /^(?:true|false)$/i;
const $a2fdfdb502fc74b8$export$7b1b591b262c240 = /^null$/i;
const $a2fdfdb502fc74b8$export$1db45310990710a5 = /^undefined$/i;
const $a2fdfdb502fc74b8$export$5b1f80f3c282648c = /^[^A-Z]*$/;
const $a2fdfdb502fc74b8$export$6cfe151e6b925e83 = /^[^a-z]*$/;
const $a2fdfdb502fc74b8$export$834dfc94dde4b3d8 = /^[0-9a-fA-F]*$/;
// Hash regexes for different algorithms and encodings
// Helper function to create base64 regex with exact length and padding
function $a2fdfdb502fc74b8$var$fixedBase64(bodyLength, padding) {
    return new RegExp(`^[A-Za-z0-9+/]{${bodyLength}}${padding}$`);
}
// Helper function to create base64url regex with exact length (no padding)
function $a2fdfdb502fc74b8$var$fixedBase64url(length) {
    return new RegExp(`^[A-Za-z0-9_-]{${length}}$`);
}
const $a2fdfdb502fc74b8$export$7d7ef811f6d53a1 = /^[0-9a-fA-F]{32}$/;
const $a2fdfdb502fc74b8$export$85425f7cda9f4890 = /*@__PURE__*/ $a2fdfdb502fc74b8$var$fixedBase64(22, "==");
const $a2fdfdb502fc74b8$export$e54699b04083758c = /*@__PURE__*/ $a2fdfdb502fc74b8$var$fixedBase64url(22);
const $a2fdfdb502fc74b8$export$2f163473ef893e12 = /^[0-9a-fA-F]{40}$/;
const $a2fdfdb502fc74b8$export$fc9670fedfd2524a = /*@__PURE__*/ $a2fdfdb502fc74b8$var$fixedBase64(27, "=");
const $a2fdfdb502fc74b8$export$5b6729b977839ffd = /*@__PURE__*/ $a2fdfdb502fc74b8$var$fixedBase64url(27);
const $a2fdfdb502fc74b8$export$a923016129fea5fb = /^[0-9a-fA-F]{64}$/;
const $a2fdfdb502fc74b8$export$ebc25582a9e85396 = /*@__PURE__*/ $a2fdfdb502fc74b8$var$fixedBase64(43, "=");
const $a2fdfdb502fc74b8$export$9b7979bfebd9716e = /*@__PURE__*/ $a2fdfdb502fc74b8$var$fixedBase64url(43);
const $a2fdfdb502fc74b8$export$61d1fe464d10a5d1 = /^[0-9a-fA-F]{96}$/;
const $a2fdfdb502fc74b8$export$103403cb96133ac3 = /*@__PURE__*/ $a2fdfdb502fc74b8$var$fixedBase64(64, "");
const $a2fdfdb502fc74b8$export$eeafcb7aab6a9870 = /*@__PURE__*/ $a2fdfdb502fc74b8$var$fixedBase64url(64);
const $a2fdfdb502fc74b8$export$e246a4310a1ad74d = /^[0-9a-fA-F]{128}$/;
const $a2fdfdb502fc74b8$export$f698997e063dbdae = /*@__PURE__*/ $a2fdfdb502fc74b8$var$fixedBase64(86, "==");
const $a2fdfdb502fc74b8$export$a63330069e1b81f6 = /*@__PURE__*/ $a2fdfdb502fc74b8$var$fixedBase64url(86);



const $bd6e402f1568d28b$export$c05d9110ef20bb2c = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheck", (inst, def)=>{
    var _a;
    inst._zod ?? (inst._zod = {});
    inst._zod.def = def;
    (_a = inst._zod).onattach ?? (_a.onattach = []);
});
const $bd6e402f1568d28b$var$numericOriginMap = {
    number: "number",
    bigint: "bigint",
    object: "date"
};
const $bd6e402f1568d28b$export$294415ecbdd02022 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheckLessThan", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    const origin = $bd6e402f1568d28b$var$numericOriginMap[typeof def.value];
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        const curr = (def.inclusive ? bag.maximum : bag.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
        if (def.value < curr) {
            if (def.inclusive) bag.maximum = def.value;
            else bag.exclusiveMaximum = def.value;
        }
    });
    inst._zod.check = (payload)=>{
        if (def.inclusive ? payload.value <= def.value : payload.value < def.value) return;
        payload.issues.push({
            origin: origin,
            code: "too_big",
            maximum: typeof def.value === "object" ? def.value.getTime() : def.value,
            input: payload.value,
            inclusive: def.inclusive,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$8b670f58decbca18 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheckGreaterThan", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    const origin = $bd6e402f1568d28b$var$numericOriginMap[typeof def.value];
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        const curr = (def.inclusive ? bag.minimum : bag.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
        if (def.value > curr) {
            if (def.inclusive) bag.minimum = def.value;
            else bag.exclusiveMinimum = def.value;
        }
    });
    inst._zod.check = (payload)=>{
        if (def.inclusive ? payload.value >= def.value : payload.value > def.value) return;
        payload.issues.push({
            origin: origin,
            code: "too_small",
            minimum: typeof def.value === "object" ? def.value.getTime() : def.value,
            input: payload.value,
            inclusive: def.inclusive,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$ae602e11c1dd0628 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheckMultipleOf", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.onattach.push((inst)=>{
        var _a;
        (_a = inst._zod.bag).multipleOf ?? (_a.multipleOf = def.value);
    });
    inst._zod.check = (payload)=>{
        if (typeof payload.value !== typeof def.value) throw new Error("Cannot mix number and bigint in multiple_of check.");
        const isMultiple = typeof payload.value === "bigint" ? payload.value % def.value === BigInt(0) : $17ea3f861a2ff584$export$7807b52a740a7117(payload.value, def.value) === 0;
        if (isMultiple) return;
        payload.issues.push({
            origin: typeof payload.value,
            code: "not_multiple_of",
            divisor: def.value,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$5c26c85ad6aed3e8 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheckNumberFormat", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def); // no format checks
    def.format = def.format || "float64";
    const isInt = def.format?.includes("int");
    const origin = isInt ? "int" : "number";
    const [minimum, maximum] = $17ea3f861a2ff584$export$8e78302060ccf26f[def.format];
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.format = def.format;
        bag.minimum = minimum;
        bag.maximum = maximum;
        if (isInt) bag.pattern = $a2fdfdb502fc74b8$export$32744b5b3bba4764;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        if (isInt) {
            if (!Number.isInteger(input)) {
                // invalid_format issue
                // payload.issues.push({
                //   expected: def.format,
                //   format: def.format,
                //   code: "invalid_format",
                //   input,
                //   inst,
                // });
                // invalid_type issue
                payload.issues.push({
                    expected: origin,
                    format: def.format,
                    code: "invalid_type",
                    continue: false,
                    input: input,
                    inst: inst
                });
                return;
            // not_multiple_of issue
            // payload.issues.push({
            //   code: "not_multiple_of",
            //   origin: "number",
            //   input,
            //   inst,
            //   divisor: 1,
            // });
            }
            if (!Number.isSafeInteger(input)) {
                if (input > 0) // too_big
                payload.issues.push({
                    input: input,
                    code: "too_big",
                    maximum: Number.MAX_SAFE_INTEGER,
                    note: "Integers must be within the safe integer range.",
                    inst: inst,
                    origin: origin,
                    inclusive: true,
                    continue: !def.abort
                });
                else // too_small
                payload.issues.push({
                    input: input,
                    code: "too_small",
                    minimum: Number.MIN_SAFE_INTEGER,
                    note: "Integers must be within the safe integer range.",
                    inst: inst,
                    origin: origin,
                    inclusive: true,
                    continue: !def.abort
                });
                return;
            }
        }
        if (input < minimum) payload.issues.push({
            origin: "number",
            input: input,
            code: "too_small",
            minimum: minimum,
            inclusive: true,
            inst: inst,
            continue: !def.abort
        });
        if (input > maximum) payload.issues.push({
            origin: "number",
            input: input,
            code: "too_big",
            maximum: maximum,
            inclusive: true,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$a0a6d75ce7dc4d36 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheckBigIntFormat", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def); // no format checks
    const [minimum, maximum] = $17ea3f861a2ff584$export$538d1d6d5cfcb3b6[def.format];
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.format = def.format;
        bag.minimum = minimum;
        bag.maximum = maximum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        if (input < minimum) payload.issues.push({
            origin: "bigint",
            input: input,
            code: "too_small",
            minimum: minimum,
            inclusive: true,
            inst: inst,
            continue: !def.abort
        });
        if (input > maximum) payload.issues.push({
            origin: "bigint",
            input: input,
            code: "too_big",
            maximum: maximum,
            inclusive: true,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$b3cec505675cf50c = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheckMaxSize", (inst, def)=>{
    var _a;
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !$17ea3f861a2ff584$export$69fd1b70ebae5687(val) && val.size !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const curr = inst._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
        if (def.maximum < curr) inst._zod.bag.maximum = def.maximum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const size = input.size;
        if (size <= def.maximum) return;
        payload.issues.push({
            origin: $17ea3f861a2ff584$export$67a7c9c676c45d2b(input),
            code: "too_big",
            maximum: def.maximum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$59fb0a2e7217c42b = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheckMinSize", (inst, def)=>{
    var _a;
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !$17ea3f861a2ff584$export$69fd1b70ebae5687(val) && val.size !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const curr = inst._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
        if (def.minimum > curr) inst._zod.bag.minimum = def.minimum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const size = input.size;
        if (size >= def.minimum) return;
        payload.issues.push({
            origin: $17ea3f861a2ff584$export$67a7c9c676c45d2b(input),
            code: "too_small",
            minimum: def.minimum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$af532c490f33cd47 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheckSizeEquals", (inst, def)=>{
    var _a;
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !$17ea3f861a2ff584$export$69fd1b70ebae5687(val) && val.size !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.minimum = def.size;
        bag.maximum = def.size;
        bag.size = def.size;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const size = input.size;
        if (size === def.size) return;
        const tooBig = size > def.size;
        payload.issues.push({
            origin: $17ea3f861a2ff584$export$67a7c9c676c45d2b(input),
            ...tooBig ? {
                code: "too_big",
                maximum: def.size
            } : {
                code: "too_small",
                minimum: def.size
            },
            inclusive: true,
            exact: true,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$b07b097887f4c15a = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheckMaxLength", (inst, def)=>{
    var _a;
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !$17ea3f861a2ff584$export$69fd1b70ebae5687(val) && val.length !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const curr = inst._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
        if (def.maximum < curr) inst._zod.bag.maximum = def.maximum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const length = input.length;
        if (length <= def.maximum) return;
        const origin = $17ea3f861a2ff584$export$479f5a070abeb487(input);
        payload.issues.push({
            origin: origin,
            code: "too_big",
            maximum: def.maximum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$cd5336aa96b8417c = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheckMinLength", (inst, def)=>{
    var _a;
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !$17ea3f861a2ff584$export$69fd1b70ebae5687(val) && val.length !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const curr = inst._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
        if (def.minimum > curr) inst._zod.bag.minimum = def.minimum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const length = input.length;
        if (length >= def.minimum) return;
        const origin = $17ea3f861a2ff584$export$479f5a070abeb487(input);
        payload.issues.push({
            origin: origin,
            code: "too_small",
            minimum: def.minimum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$ccdb9b9d477068fb = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheckLengthEquals", (inst, def)=>{
    var _a;
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !$17ea3f861a2ff584$export$69fd1b70ebae5687(val) && val.length !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.minimum = def.length;
        bag.maximum = def.length;
        bag.length = def.length;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const length = input.length;
        if (length === def.length) return;
        const origin = $17ea3f861a2ff584$export$479f5a070abeb487(input);
        const tooBig = length > def.length;
        payload.issues.push({
            origin: origin,
            ...tooBig ? {
                code: "too_big",
                maximum: def.length
            } : {
                code: "too_small",
                minimum: def.length
            },
            inclusive: true,
            exact: true,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$e0c7f6847ab1b629 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheckStringFormat", (inst, def)=>{
    var _a, _b;
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.format = def.format;
        if (def.pattern) {
            bag.patterns ?? (bag.patterns = new Set());
            bag.patterns.add(def.pattern);
        }
    });
    if (def.pattern) (_a = inst._zod).check ?? (_a.check = (payload)=>{
        def.pattern.lastIndex = 0;
        if (def.pattern.test(payload.value)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: def.format,
            input: payload.value,
            ...def.pattern ? {
                pattern: def.pattern.toString()
            } : {},
            inst: inst,
            continue: !def.abort
        });
    });
    else (_b = inst._zod).check ?? (_b.check = ()=>{});
});
const $bd6e402f1568d28b$export$6faea86ff718d6df = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheckRegex", (inst, def)=>{
    $bd6e402f1568d28b$export$e0c7f6847ab1b629.init(inst, def);
    inst._zod.check = (payload)=>{
        def.pattern.lastIndex = 0;
        if (def.pattern.test(payload.value)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "regex",
            input: payload.value,
            pattern: def.pattern.toString(),
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$e18e268bd5c9f27a = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheckLowerCase", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$5b1f80f3c282648c);
    $bd6e402f1568d28b$export$e0c7f6847ab1b629.init(inst, def);
});
const $bd6e402f1568d28b$export$6d0944a5127e820a = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheckUpperCase", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$6cfe151e6b925e83);
    $bd6e402f1568d28b$export$e0c7f6847ab1b629.init(inst, def);
});
const $bd6e402f1568d28b$export$600021c28f0498dc = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheckIncludes", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    const escapedRegex = $17ea3f861a2ff584$export$104ed90cc1a13451(def.includes);
    const pattern = new RegExp(typeof def.position === "number" ? `^.{${def.position}}${escapedRegex}` : escapedRegex);
    def.pattern = pattern;
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.patterns ?? (bag.patterns = new Set());
        bag.patterns.add(pattern);
    });
    inst._zod.check = (payload)=>{
        if (payload.value.includes(def.includes, def.position)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "includes",
            includes: def.includes,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$8e83a74b4b83cc62 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheckStartsWith", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    const pattern = new RegExp(`^${$17ea3f861a2ff584$export$104ed90cc1a13451(def.prefix)}.*`);
    def.pattern ?? (def.pattern = pattern);
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.patterns ?? (bag.patterns = new Set());
        bag.patterns.add(pattern);
    });
    inst._zod.check = (payload)=>{
        if (payload.value.startsWith(def.prefix)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "starts_with",
            prefix: def.prefix,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$4a10f85c6af4e92 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheckEndsWith", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    const pattern = new RegExp(`.*${$17ea3f861a2ff584$export$104ed90cc1a13451(def.suffix)}$`);
    def.pattern ?? (def.pattern = pattern);
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.patterns ?? (bag.patterns = new Set());
        bag.patterns.add(pattern);
    });
    inst._zod.check = (payload)=>{
        if (payload.value.endsWith(def.suffix)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "ends_with",
            suffix: def.suffix,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
///////////////////////////////////
/////    $ZodCheckProperty    /////
///////////////////////////////////
function $bd6e402f1568d28b$var$handleCheckPropertyResult(result, payload, property) {
    if (result.issues.length) payload.issues.push(...$17ea3f861a2ff584$export$7f35a4c434118b9e(property, result.issues));
}
const $bd6e402f1568d28b$export$d36a4eecd766dbc0 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheckProperty", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.check = (payload)=>{
        const result = def.schema._zod.run({
            value: payload.value[def.property],
            issues: []
        }, {});
        if (result instanceof Promise) return result.then((result)=>$bd6e402f1568d28b$var$handleCheckPropertyResult(result, payload, def.property));
        $bd6e402f1568d28b$var$handleCheckPropertyResult(result, payload, def.property);
        return;
    };
});
const $bd6e402f1568d28b$export$5546147f1877f806 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheckMimeType", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    const mimeSet = new Set(def.mime);
    inst._zod.onattach.push((inst)=>{
        inst._zod.bag.mime = def.mime;
    });
    inst._zod.check = (payload)=>{
        if (mimeSet.has(payload.value.type)) return;
        payload.issues.push({
            code: "invalid_value",
            values: def.mime,
            input: payload.value.type,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $bd6e402f1568d28b$export$1bda1934456013d3 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCheckOverwrite", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.check = (payload)=>{
        payload.value = def.tx(payload.value);
    };
});



class $ed74c9c3a820a125$export$bceacc74c2212615 {
    constructor(args = []){
        this.content = [];
        this.indent = 0;
        if (this) this.args = args;
    }
    indented(fn) {
        this.indent += 1;
        fn(this);
        this.indent -= 1;
    }
    write(arg) {
        if (typeof arg === "function") {
            arg(this, {
                execution: "sync"
            });
            arg(this, {
                execution: "async"
            });
            return;
        }
        const content = arg;
        const lines = content.split("\n").filter((x)=>x);
        const minIndent = Math.min(...lines.map((x)=>x.length - x.trimStart().length));
        const dedented = lines.map((x)=>x.slice(minIndent)).map((x)=>" ".repeat(this.indent * 2) + x);
        for (const line of dedented)this.content.push(line);
    }
    compile() {
        const F = Function;
        const args = this?.args;
        const content = this?.content ?? [
            ``
        ];
        const lines = [
            ...content.map((x)=>`  ${x}`)
        ];
        // console.log(lines.join("\n"));
        return new F(...args, lines.join("\n"));
    }
}





const $caf928fb0a91b5fd$export$83d89fbfd8236492 = {
    major: 4,
    minor: 3,
    patch: 6
};


const $e32a9d04eaeb9d0c$export$f43a5c3966de8238 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodType", (inst, def)=>{
    var _a;
    inst ?? (inst = {});
    inst._zod.def = def; // set _def property
    inst._zod.bag = inst._zod.bag || {}; // initialize _bag object
    inst._zod.version = (0, $caf928fb0a91b5fd$export$83d89fbfd8236492);
    const checks = [
        ...inst._zod.def.checks ?? []
    ];
    // if inst is itself a checks.$ZodCheck, run it as a check
    if (inst._zod.traits.has("$ZodCheck")) checks.unshift(inst);
    for (const ch of checks)for (const fn of ch._zod.onattach)fn(inst);
    if (checks.length === 0) {
        // deferred initializer
        // inst._zod.parse is not yet defined
        (_a = inst._zod).deferred ?? (_a.deferred = []);
        inst._zod.deferred?.push(()=>{
            inst._zod.run = inst._zod.parse;
        });
    } else {
        const runChecks = (payload, checks, ctx)=>{
            let isAborted = $17ea3f861a2ff584$export$bd75b6d981b9c7f2(payload);
            let asyncResult;
            for (const ch of checks){
                if (ch._zod.def.when) {
                    const shouldRun = ch._zod.def.when(payload);
                    if (!shouldRun) continue;
                } else if (isAborted) continue;
                const currLen = payload.issues.length;
                const _ = ch._zod.check(payload);
                if (_ instanceof Promise && ctx?.async === false) throw new $4488038d123e8fa5$export$13016bcec11ba196();
                if (asyncResult || _ instanceof Promise) asyncResult = (asyncResult ?? Promise.resolve()).then(async ()=>{
                    await _;
                    const nextLen = payload.issues.length;
                    if (nextLen === currLen) return;
                    if (!isAborted) isAborted = $17ea3f861a2ff584$export$bd75b6d981b9c7f2(payload, currLen);
                });
                else {
                    const nextLen = payload.issues.length;
                    if (nextLen === currLen) continue;
                    if (!isAborted) isAborted = $17ea3f861a2ff584$export$bd75b6d981b9c7f2(payload, currLen);
                }
            }
            if (asyncResult) return asyncResult.then(()=>{
                return payload;
            });
            return payload;
        };
        const handleCanaryResult = (canary, payload, ctx)=>{
            // abort if the canary is aborted
            if ($17ea3f861a2ff584$export$bd75b6d981b9c7f2(canary)) {
                canary.aborted = true;
                return canary;
            }
            // run checks first, then
            const checkResult = runChecks(payload, checks, ctx);
            if (checkResult instanceof Promise) {
                if (ctx.async === false) throw new $4488038d123e8fa5$export$13016bcec11ba196();
                return checkResult.then((checkResult)=>inst._zod.parse(checkResult, ctx));
            }
            return inst._zod.parse(checkResult, ctx);
        };
        inst._zod.run = (payload, ctx)=>{
            if (ctx.skipChecks) return inst._zod.parse(payload, ctx);
            if (ctx.direction === "backward") {
                // run canary
                // initial pass (no checks)
                const canary = inst._zod.parse({
                    value: payload.value,
                    issues: []
                }, {
                    ...ctx,
                    skipChecks: true
                });
                if (canary instanceof Promise) return canary.then((canary)=>{
                    return handleCanaryResult(canary, payload, ctx);
                });
                return handleCanaryResult(canary, payload, ctx);
            }
            // forward
            const result = inst._zod.parse(payload, ctx);
            if (result instanceof Promise) {
                if (ctx.async === false) throw new $4488038d123e8fa5$export$13016bcec11ba196();
                return result.then((result)=>runChecks(result, checks, ctx));
            }
            return runChecks(result, checks, ctx);
        };
    }
    // Lazy initialize ~standard to avoid creating objects for every schema
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst, "~standard", ()=>({
            validate: (value)=>{
                try {
                    const r = (0, $3bba9a623c1bec43$export$b48ee232557adc37)(inst, value);
                    return r.success ? {
                        value: r.data
                    } : {
                        issues: r.error?.issues
                    };
                } catch (_) {
                    return (0, $3bba9a623c1bec43$export$9b07b0d6e0389261)(inst, value).then((r)=>r.success ? {
                            value: r.data
                        } : {
                            issues: r.error?.issues
                        });
                }
            },
            vendor: "zod",
            version: 1
        }));
});
const $e32a9d04eaeb9d0c$export$4342b4432d7b1471 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodString", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = [
        ...inst?._zod.bag?.patterns ?? []
    ].pop() ?? $a2fdfdb502fc74b8$export$22b082955e083ec3(inst._zod.bag);
    inst._zod.parse = (payload, _)=>{
        if (def.coerce) try {
            payload.value = String(payload.value);
        } catch (_) {}
        if (typeof payload.value === "string") return payload;
        payload.issues.push({
            expected: "string",
            code: "invalid_type",
            input: payload.value,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodStringFormat", (inst, def)=>{
    // check initialization must come first
    $bd6e402f1568d28b$export$e0c7f6847ab1b629.init(inst, def);
    $e32a9d04eaeb9d0c$export$4342b4432d7b1471.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$4ca4397e3147da59 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodGUID", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$46e8f25c7328f77e);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$8794aae384e3c177 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodUUID", (inst, def)=>{
    if (def.version) {
        const versionMap = {
            v1: 1,
            v2: 2,
            v3: 3,
            v4: 4,
            v5: 5,
            v6: 6,
            v7: 7,
            v8: 8
        };
        const v = versionMap[def.version];
        if (v === undefined) throw new Error(`Invalid UUID version: "${def.version}"`);
        def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$31b40729666a4ae0(v));
    } else def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$31b40729666a4ae0());
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$a3726aadb6108cdc = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodEmail", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$d290fa47940df19d);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$7e12af57cac08b7a = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodURL", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        try {
            // Trim whitespace from input
            const trimmed = payload.value.trim();
            // @ts-ignore
            const url = new URL(trimmed);
            if (def.hostname) {
                def.hostname.lastIndex = 0;
                if (!def.hostname.test(url.hostname)) payload.issues.push({
                    code: "invalid_format",
                    format: "url",
                    note: "Invalid hostname",
                    pattern: def.hostname.source,
                    input: payload.value,
                    inst: inst,
                    continue: !def.abort
                });
            }
            if (def.protocol) {
                def.protocol.lastIndex = 0;
                if (!def.protocol.test(url.protocol.endsWith(":") ? url.protocol.slice(0, -1) : url.protocol)) payload.issues.push({
                    code: "invalid_format",
                    format: "url",
                    note: "Invalid protocol",
                    pattern: def.protocol.source,
                    input: payload.value,
                    inst: inst,
                    continue: !def.abort
                });
            }
            // Set the output value based on normalize flag
            if (def.normalize) // Use normalized URL
            payload.value = url.href;
            else // Preserve the original input (trimmed)
            payload.value = trimmed;
            return;
        } catch (_) {
            payload.issues.push({
                code: "invalid_format",
                format: "url",
                input: payload.value,
                inst: inst,
                continue: !def.abort
            });
        }
    };
});
const $e32a9d04eaeb9d0c$export$154cd448b85bb5a3 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodEmoji", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$a19185d1233fc4b2());
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$5a160d28c6d62c88 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodNanoID", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$ac4959f4f1338dfc);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$f4f84bd3c6706e60 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCUID", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$e057ec210c7d3443);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$faf1483c11362df6 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCUID2", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$af5866a6cccce9f0);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$c5788701f4f55294 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodULID", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$c34778236461ea95);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$e721fd3317199b85 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodXID", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$5eecaf20006cb6cb);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$baa9849ea82bee6e = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodKSUID", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$f49b11deeb9beb0f);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$3273e4d2df37774b = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodISODateTime", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$7ba4466dbd0f07e1(def));
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$75b9bf98f4d806dc = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodISODate", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$324d90190a8b822a);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$e9b9c3c2359a3ebc = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodISOTime", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$2da9be4cfdb689b1(def));
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$d9e850ab18e4b22e = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodISODuration", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$1f34108aa9eb96ab);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$93fc833bbf7ceb99 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodIPv4", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$291a17a16047f284);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.bag.format = `ipv4`;
});
const $e32a9d04eaeb9d0c$export$8c939a460418a1bf = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodIPv6", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$4e0c86a59c658526);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.bag.format = `ipv6`;
    inst._zod.check = (payload)=>{
        try {
            // @ts-ignore
            new URL(`http://[${payload.value}]`);
        // return;
        } catch  {
            payload.issues.push({
                code: "invalid_format",
                format: "ipv6",
                input: payload.value,
                inst: inst,
                continue: !def.abort
            });
        }
    };
});
const $e32a9d04eaeb9d0c$export$747370108f97e6ea = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodMAC", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$f8d11e097856efcf(def.delimiter));
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.bag.format = `mac`;
});
const $e32a9d04eaeb9d0c$export$e164feaf5ae5296b = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCIDRv4", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$fc96793d9715e5a1);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e32a9d04eaeb9d0c$export$3c3aacb740759234 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCIDRv6", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$b6e650831cac87fb); // not used for validation
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        const parts = payload.value.split("/");
        try {
            if (parts.length !== 2) throw new Error();
            const [address, prefix] = parts;
            if (!prefix) throw new Error();
            const prefixNum = Number(prefix);
            if (`${prefixNum}` !== prefix) throw new Error();
            if (prefixNum < 0 || prefixNum > 128) throw new Error();
            // @ts-ignore
            new URL(`http://[${address}]`);
        } catch  {
            payload.issues.push({
                code: "invalid_format",
                format: "cidrv6",
                input: payload.value,
                inst: inst,
                continue: !def.abort
            });
        }
    };
});
function $e32a9d04eaeb9d0c$export$5f5b3f6a560c676b(data) {
    if (data === "") return true;
    if (data.length % 4 !== 0) return false;
    try {
        // @ts-ignore
        atob(data);
        return true;
    } catch  {
        return false;
    }
}
const $e32a9d04eaeb9d0c$export$d7d4932079e2113d = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodBase64", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$b3b2de96497acc47);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.bag.contentEncoding = "base64";
    inst._zod.check = (payload)=>{
        if ($e32a9d04eaeb9d0c$export$5f5b3f6a560c676b(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "base64",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
function $e32a9d04eaeb9d0c$export$eb95420c5686a3be(data) {
    if (!$a2fdfdb502fc74b8$export$7d21597c7bc64465.test(data)) return false;
    const base64 = data.replace(/[-_]/g, (c)=>c === "-" ? "+" : "/");
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    return $e32a9d04eaeb9d0c$export$5f5b3f6a560c676b(padded);
}
const $e32a9d04eaeb9d0c$export$f5c3c3bbec012fa6 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodBase64URL", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$7d21597c7bc64465);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.bag.contentEncoding = "base64url";
    inst._zod.check = (payload)=>{
        if ($e32a9d04eaeb9d0c$export$eb95420c5686a3be(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "base64url",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $e32a9d04eaeb9d0c$export$46d3507e8483217 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodE164", (inst, def)=>{
    def.pattern ?? (def.pattern = $a2fdfdb502fc74b8$export$2fa5ed24c9ef198e);
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
});
function $e32a9d04eaeb9d0c$export$5fc0c2a4042aff0a(token, algorithm = null) {
    try {
        const tokensParts = token.split(".");
        if (tokensParts.length !== 3) return false;
        const [header] = tokensParts;
        if (!header) return false;
        // @ts-ignore
        const parsedHeader = JSON.parse(atob(header));
        if ("typ" in parsedHeader && parsedHeader?.typ !== "JWT") return false;
        if (!parsedHeader.alg) return false;
        if (algorithm && (!("alg" in parsedHeader) || parsedHeader.alg !== algorithm)) return false;
        return true;
    } catch  {
        return false;
    }
}
const $e32a9d04eaeb9d0c$export$f515616cf0cda103 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodJWT", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if ($e32a9d04eaeb9d0c$export$5fc0c2a4042aff0a(payload.value, def.alg)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "jwt",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $e32a9d04eaeb9d0c$export$9dde4397c7b8a192 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCustomStringFormat", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if (def.fn(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: def.format,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $e32a9d04eaeb9d0c$export$b7292ed81eaafd49 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodNumber", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = inst._zod.bag.pattern ?? $a2fdfdb502fc74b8$export$98e628dec113755e;
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = Number(payload.value);
        } catch (_) {}
        const input = payload.value;
        if (typeof input === "number" && !Number.isNaN(input) && Number.isFinite(input)) return payload;
        const received = typeof input === "number" ? Number.isNaN(input) ? "NaN" : !Number.isFinite(input) ? "Infinity" : undefined : undefined;
        payload.issues.push({
            expected: "number",
            code: "invalid_type",
            input: input,
            inst: inst,
            ...received ? {
                received: received
            } : {}
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$2cfebe79b769ec9 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodNumberFormat", (inst, def)=>{
    $bd6e402f1568d28b$export$5c26c85ad6aed3e8.init(inst, def);
    $e32a9d04eaeb9d0c$export$b7292ed81eaafd49.init(inst, def); // no format checks
});
const $e32a9d04eaeb9d0c$export$828bf41e557d7dda = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodBoolean", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $a2fdfdb502fc74b8$export$4a21f16c33752377;
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = Boolean(payload.value);
        } catch (_) {}
        const input = payload.value;
        if (typeof input === "boolean") return payload;
        payload.issues.push({
            expected: "boolean",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$7600843f2a3baa73 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodBigInt", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $a2fdfdb502fc74b8$export$a0f65b52274bcc00;
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = BigInt(payload.value);
        } catch (_) {}
        if (typeof payload.value === "bigint") return payload;
        payload.issues.push({
            expected: "bigint",
            code: "invalid_type",
            input: payload.value,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$487194b75209a5dd = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodBigIntFormat", (inst, def)=>{
    $bd6e402f1568d28b$export$a0a6d75ce7dc4d36.init(inst, def);
    $e32a9d04eaeb9d0c$export$7600843f2a3baa73.init(inst, def); // no format checks
});
const $e32a9d04eaeb9d0c$export$c9e7e1831bb8dd12 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodSymbol", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (typeof input === "symbol") return payload;
        payload.issues.push({
            expected: "symbol",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$379ccf61f9830869 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodUndefined", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $a2fdfdb502fc74b8$export$1db45310990710a5;
    inst._zod.values = new Set([
        undefined
    ]);
    inst._zod.optin = "optional";
    inst._zod.optout = "optional";
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (typeof input === "undefined") return payload;
        payload.issues.push({
            expected: "undefined",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$d05db4d7bc9da27d = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodNull", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $a2fdfdb502fc74b8$export$7b1b591b262c240;
    inst._zod.values = new Set([
        null
    ]);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (input === null) return payload;
        payload.issues.push({
            expected: "null",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$de3a83ac65a18f35 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodAny", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload)=>payload;
});
const $e32a9d04eaeb9d0c$export$37ea092643879ea0 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodUnknown", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload)=>payload;
});
const $e32a9d04eaeb9d0c$export$4b2a18191b39c3b4 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodNever", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        payload.issues.push({
            expected: "never",
            code: "invalid_type",
            input: payload.value,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$6fd82db70787afbb = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodVoid", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (typeof input === "undefined") return payload;
        payload.issues.push({
            expected: "void",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$9a0ab9fbd61629f8 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodDate", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = new Date(payload.value);
        } catch (_err) {}
        const input = payload.value;
        const isDate = input instanceof Date;
        const isValidDate = isDate && !Number.isNaN(input.getTime());
        if (isValidDate) return payload;
        payload.issues.push({
            expected: "date",
            code: "invalid_type",
            input: input,
            ...isDate ? {
                received: "Invalid Date"
            } : {},
            inst: inst
        });
        return payload;
    };
});
function $e32a9d04eaeb9d0c$var$handleArrayResult(result, final, index) {
    if (result.issues.length) final.issues.push(...$17ea3f861a2ff584$export$7f35a4c434118b9e(index, result.issues));
    final.value[index] = result.value;
}
const $e32a9d04eaeb9d0c$export$fd77bdade7d2292b = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodArray", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!Array.isArray(input)) {
            payload.issues.push({
                expected: "array",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        payload.value = Array(input.length);
        const proms = [];
        for(let i = 0; i < input.length; i++){
            const item = input[i];
            const result = def.element._zod.run({
                value: item,
                issues: []
            }, ctx);
            if (result instanceof Promise) proms.push(result.then((result)=>$e32a9d04eaeb9d0c$var$handleArrayResult(result, payload, i)));
            else $e32a9d04eaeb9d0c$var$handleArrayResult(result, payload, i);
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload; //handleArrayResultsAsync(parseResults, final);
    };
});
function $e32a9d04eaeb9d0c$var$handlePropertyResult(result, final, key, input, isOptionalOut) {
    if (result.issues.length) {
        // For optional-out schemas, ignore errors on absent keys
        if (isOptionalOut && !(key in input)) return;
        final.issues.push(...$17ea3f861a2ff584$export$7f35a4c434118b9e(key, result.issues));
    }
    if (result.value === undefined) {
        if (key in input) final.value[key] = undefined;
    } else final.value[key] = result.value;
}
function $e32a9d04eaeb9d0c$var$normalizeDef(def) {
    const keys = Object.keys(def.shape);
    for (const k of keys){
        if (!def.shape?.[k]?._zod?.traits?.has("$ZodType")) throw new Error(`Invalid element at key "${k}": expected a Zod schema`);
    }
    const okeys = $17ea3f861a2ff584$export$240159211e66adb9(def.shape);
    return {
        ...def,
        keys: keys,
        keySet: new Set(keys),
        numKeys: keys.length,
        optionalKeys: new Set(okeys)
    };
}
function $e32a9d04eaeb9d0c$var$handleCatchall(proms, input, payload, ctx, def, inst) {
    const unrecognized = [];
    // iterate over input keys
    const keySet = def.keySet;
    const _catchall = def.catchall._zod;
    const t = _catchall.def.type;
    const isOptionalOut = _catchall.optout === "optional";
    for(const key in input){
        if (keySet.has(key)) continue;
        if (t === "never") {
            unrecognized.push(key);
            continue;
        }
        const r = _catchall.run({
            value: input[key],
            issues: []
        }, ctx);
        if (r instanceof Promise) proms.push(r.then((r)=>$e32a9d04eaeb9d0c$var$handlePropertyResult(r, payload, key, input, isOptionalOut)));
        else $e32a9d04eaeb9d0c$var$handlePropertyResult(r, payload, key, input, isOptionalOut);
    }
    if (unrecognized.length) payload.issues.push({
        code: "unrecognized_keys",
        keys: unrecognized,
        input: input,
        inst: inst
    });
    if (!proms.length) return payload;
    return Promise.all(proms).then(()=>{
        return payload;
    });
}
const $e32a9d04eaeb9d0c$export$54037a1ef79a4f1a = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodObject", (inst, def)=>{
    // requires cast because technically $ZodObject doesn't extend
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    // const sh = def.shape;
    const desc = Object.getOwnPropertyDescriptor(def, "shape");
    if (!desc?.get) {
        const sh = def.shape;
        Object.defineProperty(def, "shape", {
            get: ()=>{
                const newSh = {
                    ...sh
                };
                Object.defineProperty(def, "shape", {
                    value: newSh
                });
                return newSh;
            }
        });
    }
    const _normalized = $17ea3f861a2ff584$export$ade7a147f5129058(()=>$e32a9d04eaeb9d0c$var$normalizeDef(def));
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "propValues", ()=>{
        const shape = def.shape;
        const propValues = {};
        for(const key in shape){
            const field = shape[key]._zod;
            if (field.values) {
                propValues[key] ?? (propValues[key] = new Set());
                for (const v of field.values)propValues[key].add(v);
            }
        }
        return propValues;
    });
    const isObject = $17ea3f861a2ff584$export$a6cdc56e425d0d0a;
    const catchall = def.catchall;
    let value;
    inst._zod.parse = (payload, ctx)=>{
        value ?? (value = _normalized.value);
        const input = payload.value;
        if (!isObject(input)) {
            payload.issues.push({
                expected: "object",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        payload.value = {};
        const proms = [];
        const shape = value.shape;
        for (const key of value.keys){
            const el = shape[key];
            const isOptionalOut = el._zod.optout === "optional";
            const r = el._zod.run({
                value: input[key],
                issues: []
            }, ctx);
            if (r instanceof Promise) proms.push(r.then((r)=>$e32a9d04eaeb9d0c$var$handlePropertyResult(r, payload, key, input, isOptionalOut)));
            else $e32a9d04eaeb9d0c$var$handlePropertyResult(r, payload, key, input, isOptionalOut);
        }
        if (!catchall) return proms.length ? Promise.all(proms).then(()=>payload) : payload;
        return $e32a9d04eaeb9d0c$var$handleCatchall(proms, input, payload, ctx, _normalized.value, inst);
    };
});
const $e32a9d04eaeb9d0c$export$330feb3f8e03c085 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodObjectJIT", (inst, def)=>{
    // requires cast because technically $ZodObject doesn't extend
    $e32a9d04eaeb9d0c$export$54037a1ef79a4f1a.init(inst, def);
    const superParse = inst._zod.parse;
    const _normalized = $17ea3f861a2ff584$export$ade7a147f5129058(()=>$e32a9d04eaeb9d0c$var$normalizeDef(def));
    const generateFastpass = (shape)=>{
        const doc = new (0, $ed74c9c3a820a125$export$bceacc74c2212615)([
            "shape",
            "payload",
            "ctx"
        ]);
        const normalized = _normalized.value;
        const parseStr = (key)=>{
            const k = $17ea3f861a2ff584$export$a1a11b095f88289a(key);
            return `shape[${k}]._zod.run({ value: input[${k}], issues: [] }, ctx)`;
        };
        doc.write(`const input = payload.value;`);
        const ids = Object.create(null);
        let counter = 0;
        for (const key of normalized.keys)ids[key] = `key_${counter++}`;
        // A: preserve key order {
        doc.write(`const newResult = {};`);
        for (const key of normalized.keys){
            const id = ids[key];
            const k = $17ea3f861a2ff584$export$a1a11b095f88289a(key);
            const schema = shape[key];
            const isOptionalOut = schema?._zod?.optout === "optional";
            doc.write(`const ${id} = ${parseStr(key)};`);
            if (isOptionalOut) // For optional-out schemas, ignore errors on absent keys
            doc.write(`
        if (${id}.issues.length) {
          if (${k} in input) {
            payload.issues = payload.issues.concat(${id}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${k}, ...iss.path] : [${k}]
            })));
          }
        }
        
        if (${id}.value === undefined) {
          if (${k} in input) {
            newResult[${k}] = undefined;
          }
        } else {
          newResult[${k}] = ${id}.value;
        }
        
      `);
            else doc.write(`
        if (${id}.issues.length) {
          payload.issues = payload.issues.concat(${id}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${k}, ...iss.path] : [${k}]
          })));
        }
        
        if (${id}.value === undefined) {
          if (${k} in input) {
            newResult[${k}] = undefined;
          }
        } else {
          newResult[${k}] = ${id}.value;
        }
        
      `);
        }
        doc.write(`payload.value = newResult;`);
        doc.write(`return payload;`);
        const fn = doc.compile();
        return (payload, ctx)=>fn(shape, payload, ctx);
    };
    let fastpass;
    const isObject = $17ea3f861a2ff584$export$a6cdc56e425d0d0a;
    const jit = !$4488038d123e8fa5$export$f9cd1e43211d8a4a.jitless;
    const allowsEval = $17ea3f861a2ff584$export$1f119cb4d720843b;
    const fastEnabled = jit && allowsEval.value; // && !def.catchall;
    const catchall = def.catchall;
    let value;
    inst._zod.parse = (payload, ctx)=>{
        value ?? (value = _normalized.value);
        const input = payload.value;
        if (!isObject(input)) {
            payload.issues.push({
                expected: "object",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        if (jit && fastEnabled && ctx?.async === false && ctx.jitless !== true) {
            // always synchronous
            if (!fastpass) fastpass = generateFastpass(def.shape);
            payload = fastpass(payload, ctx);
            if (!catchall) return payload;
            return $e32a9d04eaeb9d0c$var$handleCatchall([], input, payload, ctx, value, inst);
        }
        return superParse(payload, ctx);
    };
});
function $e32a9d04eaeb9d0c$var$handleUnionResults(results, final, inst, ctx) {
    for (const result of results)if (result.issues.length === 0) {
        final.value = result.value;
        return final;
    }
    const nonaborted = results.filter((r)=>!$17ea3f861a2ff584$export$bd75b6d981b9c7f2(r));
    if (nonaborted.length === 1) {
        final.value = nonaborted[0].value;
        return nonaborted[0];
    }
    final.issues.push({
        code: "invalid_union",
        input: final.value,
        inst: inst,
        errors: results.map((result)=>result.issues.map((iss)=>$17ea3f861a2ff584$export$c5e667bbfc286a9d(iss, ctx, $4488038d123e8fa5$export$e506a1d27d1eaa20())))
    });
    return final;
}
const $e32a9d04eaeb9d0c$export$37a2350ef0bd638c = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodUnion", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "optin", ()=>def.options.some((o)=>o._zod.optin === "optional") ? "optional" : undefined);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "optout", ()=>def.options.some((o)=>o._zod.optout === "optional") ? "optional" : undefined);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "values", ()=>{
        if (def.options.every((o)=>o._zod.values)) return new Set(def.options.flatMap((option)=>Array.from(option._zod.values)));
        return undefined;
    });
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "pattern", ()=>{
        if (def.options.every((o)=>o._zod.pattern)) {
            const patterns = def.options.map((o)=>o._zod.pattern);
            return new RegExp(`^(${patterns.map((p)=>$17ea3f861a2ff584$export$78d521805d6c22e4(p.source)).join("|")})$`);
        }
        return undefined;
    });
    const single = def.options.length === 1;
    const first = def.options[0]._zod.run;
    inst._zod.parse = (payload, ctx)=>{
        if (single) return first(payload, ctx);
        let async = false;
        const results = [];
        for (const option of def.options){
            const result = option._zod.run({
                value: payload.value,
                issues: []
            }, ctx);
            if (result instanceof Promise) {
                results.push(result);
                async = true;
            } else {
                if (result.issues.length === 0) return result;
                results.push(result);
            }
        }
        if (!async) return $e32a9d04eaeb9d0c$var$handleUnionResults(results, payload, inst, ctx);
        return Promise.all(results).then((results)=>{
            return $e32a9d04eaeb9d0c$var$handleUnionResults(results, payload, inst, ctx);
        });
    };
});
function $e32a9d04eaeb9d0c$var$handleExclusiveUnionResults(results, final, inst, ctx) {
    const successes = results.filter((r)=>r.issues.length === 0);
    if (successes.length === 1) {
        final.value = successes[0].value;
        return final;
    }
    if (successes.length === 0) // No matches - same as regular union
    final.issues.push({
        code: "invalid_union",
        input: final.value,
        inst: inst,
        errors: results.map((result)=>result.issues.map((iss)=>$17ea3f861a2ff584$export$c5e667bbfc286a9d(iss, ctx, $4488038d123e8fa5$export$e506a1d27d1eaa20())))
    });
    else // Multiple matches - exclusive union failure
    final.issues.push({
        code: "invalid_union",
        input: final.value,
        inst: inst,
        errors: [],
        inclusive: false
    });
    return final;
}
const $e32a9d04eaeb9d0c$export$b04ced974a46c0b4 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodXor", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$37a2350ef0bd638c.init(inst, def);
    def.inclusive = false;
    const single = def.options.length === 1;
    const first = def.options[0]._zod.run;
    inst._zod.parse = (payload, ctx)=>{
        if (single) return first(payload, ctx);
        let async = false;
        const results = [];
        for (const option of def.options){
            const result = option._zod.run({
                value: payload.value,
                issues: []
            }, ctx);
            if (result instanceof Promise) {
                results.push(result);
                async = true;
            } else results.push(result);
        }
        if (!async) return $e32a9d04eaeb9d0c$var$handleExclusiveUnionResults(results, payload, inst, ctx);
        return Promise.all(results).then((results)=>{
            return $e32a9d04eaeb9d0c$var$handleExclusiveUnionResults(results, payload, inst, ctx);
        });
    };
});
const $e32a9d04eaeb9d0c$export$aad4f17edfb83795 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodDiscriminatedUnion", (inst, def)=>{
    def.inclusive = false;
    $e32a9d04eaeb9d0c$export$37a2350ef0bd638c.init(inst, def);
    const _super = inst._zod.parse;
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "propValues", ()=>{
        const propValues = {};
        for (const option of def.options){
            const pv = option._zod.propValues;
            if (!pv || Object.keys(pv).length === 0) throw new Error(`Invalid discriminated union option at index "${def.options.indexOf(option)}"`);
            for (const [k, v] of Object.entries(pv)){
                if (!propValues[k]) propValues[k] = new Set();
                for (const val of v)propValues[k].add(val);
            }
        }
        return propValues;
    });
    const disc = $17ea3f861a2ff584$export$ade7a147f5129058(()=>{
        const opts = def.options;
        const map = new Map();
        for (const o of opts){
            const values = o._zod.propValues?.[def.discriminator];
            if (!values || values.size === 0) throw new Error(`Invalid discriminated union option at index "${def.options.indexOf(o)}"`);
            for (const v of values){
                if (map.has(v)) throw new Error(`Duplicate discriminator value "${String(v)}"`);
                map.set(v, o);
            }
        }
        return map;
    });
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!$17ea3f861a2ff584$export$a6cdc56e425d0d0a(input)) {
            payload.issues.push({
                code: "invalid_type",
                expected: "object",
                input: input,
                inst: inst
            });
            return payload;
        }
        const opt = disc.value.get(input?.[def.discriminator]);
        if (opt) return opt._zod.run(payload, ctx);
        if (def.unionFallback) return _super(payload, ctx);
        // no matching discriminator
        payload.issues.push({
            code: "invalid_union",
            errors: [],
            note: "No matching discriminator",
            discriminator: def.discriminator,
            input: input,
            path: [
                def.discriminator
            ],
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$2299250b426aba4b = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodIntersection", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        const left = def.left._zod.run({
            value: input,
            issues: []
        }, ctx);
        const right = def.right._zod.run({
            value: input,
            issues: []
        }, ctx);
        const async = left instanceof Promise || right instanceof Promise;
        if (async) return Promise.all([
            left,
            right
        ]).then(([left, right])=>{
            return $e32a9d04eaeb9d0c$var$handleIntersectionResults(payload, left, right);
        });
        return $e32a9d04eaeb9d0c$var$handleIntersectionResults(payload, left, right);
    };
});
function $e32a9d04eaeb9d0c$var$mergeValues(a, b) {
    // const aType = parse.t(a);
    // const bType = parse.t(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    if (a instanceof Date && b instanceof Date && +a === +b) return {
        valid: true,
        data: a
    };
    if ($17ea3f861a2ff584$export$53b83ca8eaab0383(a) && $17ea3f861a2ff584$export$53b83ca8eaab0383(b)) {
        const bKeys = Object.keys(b);
        const sharedKeys = Object.keys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $e32a9d04eaeb9d0c$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false,
                mergeErrorPath: [
                    key,
                    ...sharedValue.mergeErrorPath
                ]
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    }
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return {
            valid: false,
            mergeErrorPath: []
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $e32a9d04eaeb9d0c$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false,
                mergeErrorPath: [
                    index,
                    ...sharedValue.mergeErrorPath
                ]
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    }
    return {
        valid: false,
        mergeErrorPath: []
    };
}
function $e32a9d04eaeb9d0c$var$handleIntersectionResults(result, left, right) {
    // Track which side(s) report each key as unrecognized
    const unrecKeys = new Map();
    let unrecIssue;
    for (const iss of left.issues)if (iss.code === "unrecognized_keys") {
        unrecIssue ?? (unrecIssue = iss);
        for (const k of iss.keys){
            if (!unrecKeys.has(k)) unrecKeys.set(k, {});
            unrecKeys.get(k).l = true;
        }
    } else result.issues.push(iss);
    for (const iss of right.issues){
        if (iss.code === "unrecognized_keys") for (const k of iss.keys){
            if (!unrecKeys.has(k)) unrecKeys.set(k, {});
            unrecKeys.get(k).r = true;
        }
        else result.issues.push(iss);
    }
    // Report only keys unrecognized by BOTH sides
    const bothKeys = [
        ...unrecKeys
    ].filter(([, f])=>f.l && f.r).map(([k])=>k);
    if (bothKeys.length && unrecIssue) result.issues.push({
        ...unrecIssue,
        keys: bothKeys
    });
    if ($17ea3f861a2ff584$export$bd75b6d981b9c7f2(result)) return result;
    const merged = $e32a9d04eaeb9d0c$var$mergeValues(left.value, right.value);
    if (!merged.valid) throw new Error(`Unmergable intersection. Error path: ` + `${JSON.stringify(merged.mergeErrorPath)}`);
    result.value = merged.data;
    return result;
}
const $e32a9d04eaeb9d0c$export$bba1b90a721dbd94 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodTuple", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    const items = def.items;
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!Array.isArray(input)) {
            payload.issues.push({
                input: input,
                inst: inst,
                expected: "tuple",
                code: "invalid_type"
            });
            return payload;
        }
        payload.value = [];
        const proms = [];
        const reversedIndex = [
            ...items
        ].reverse().findIndex((item)=>item._zod.optin !== "optional");
        const optStart = reversedIndex === -1 ? 0 : items.length - reversedIndex;
        if (!def.rest) {
            const tooBig = input.length > items.length;
            const tooSmall = input.length < optStart - 1;
            if (tooBig || tooSmall) {
                payload.issues.push({
                    ...tooBig ? {
                        code: "too_big",
                        maximum: items.length,
                        inclusive: true
                    } : {
                        code: "too_small",
                        minimum: items.length
                    },
                    input: input,
                    inst: inst,
                    origin: "array"
                });
                return payload;
            }
        }
        let i = -1;
        for (const item of items){
            i++;
            if (i >= input.length) {
                if (i >= optStart) continue;
            }
            const result = item._zod.run({
                value: input[i],
                issues: []
            }, ctx);
            if (result instanceof Promise) proms.push(result.then((result)=>$e32a9d04eaeb9d0c$var$handleTupleResult(result, payload, i)));
            else $e32a9d04eaeb9d0c$var$handleTupleResult(result, payload, i);
        }
        if (def.rest) {
            const rest = input.slice(items.length);
            for (const el of rest){
                i++;
                const result = def.rest._zod.run({
                    value: el,
                    issues: []
                }, ctx);
                if (result instanceof Promise) proms.push(result.then((result)=>$e32a9d04eaeb9d0c$var$handleTupleResult(result, payload, i)));
                else $e32a9d04eaeb9d0c$var$handleTupleResult(result, payload, i);
            }
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
function $e32a9d04eaeb9d0c$var$handleTupleResult(result, final, index) {
    if (result.issues.length) final.issues.push(...$17ea3f861a2ff584$export$7f35a4c434118b9e(index, result.issues));
    final.value[index] = result.value;
}
const $e32a9d04eaeb9d0c$export$cc20b90ec1a8c208 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodRecord", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!$17ea3f861a2ff584$export$53b83ca8eaab0383(input)) {
            payload.issues.push({
                expected: "record",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        const proms = [];
        const values = def.keyType._zod.values;
        if (values) {
            payload.value = {};
            const recordKeys = new Set();
            for (const key of values)if (typeof key === "string" || typeof key === "number" || typeof key === "symbol") {
                recordKeys.add(typeof key === "number" ? key.toString() : key);
                const result = def.valueType._zod.run({
                    value: input[key],
                    issues: []
                }, ctx);
                if (result instanceof Promise) proms.push(result.then((result)=>{
                    if (result.issues.length) payload.issues.push(...$17ea3f861a2ff584$export$7f35a4c434118b9e(key, result.issues));
                    payload.value[key] = result.value;
                }));
                else {
                    if (result.issues.length) payload.issues.push(...$17ea3f861a2ff584$export$7f35a4c434118b9e(key, result.issues));
                    payload.value[key] = result.value;
                }
            }
            let unrecognized;
            for(const key in input)if (!recordKeys.has(key)) {
                unrecognized = unrecognized ?? [];
                unrecognized.push(key);
            }
            if (unrecognized && unrecognized.length > 0) payload.issues.push({
                code: "unrecognized_keys",
                input: input,
                inst: inst,
                keys: unrecognized
            });
        } else {
            payload.value = {};
            for (const key of Reflect.ownKeys(input)){
                if (key === "__proto__") continue;
                let keyResult = def.keyType._zod.run({
                    value: key,
                    issues: []
                }, ctx);
                if (keyResult instanceof Promise) throw new Error("Async schemas not supported in object keys currently");
                // Numeric string fallback: if key is a numeric string and failed, retry with Number(key)
                // This handles z.number(), z.literal([1, 2, 3]), and unions containing numeric literals
                const checkNumericKey = typeof key === "string" && $a2fdfdb502fc74b8$export$98e628dec113755e.test(key) && keyResult.issues.length;
                if (checkNumericKey) {
                    const retryResult = def.keyType._zod.run({
                        value: Number(key),
                        issues: []
                    }, ctx);
                    if (retryResult instanceof Promise) throw new Error("Async schemas not supported in object keys currently");
                    if (retryResult.issues.length === 0) keyResult = retryResult;
                }
                if (keyResult.issues.length) {
                    if (def.mode === "loose") // Pass through unchanged
                    payload.value[key] = input[key];
                    else // Default "strict" behavior: error on invalid key
                    payload.issues.push({
                        code: "invalid_key",
                        origin: "record",
                        issues: keyResult.issues.map((iss)=>$17ea3f861a2ff584$export$c5e667bbfc286a9d(iss, ctx, $4488038d123e8fa5$export$e506a1d27d1eaa20())),
                        input: key,
                        path: [
                            key
                        ],
                        inst: inst
                    });
                    continue;
                }
                const result = def.valueType._zod.run({
                    value: input[key],
                    issues: []
                }, ctx);
                if (result instanceof Promise) proms.push(result.then((result)=>{
                    if (result.issues.length) payload.issues.push(...$17ea3f861a2ff584$export$7f35a4c434118b9e(key, result.issues));
                    payload.value[keyResult.value] = result.value;
                }));
                else {
                    if (result.issues.length) payload.issues.push(...$17ea3f861a2ff584$export$7f35a4c434118b9e(key, result.issues));
                    payload.value[keyResult.value] = result.value;
                }
            }
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$5ccfd30a7e358409 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodMap", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!(input instanceof Map)) {
            payload.issues.push({
                expected: "map",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        const proms = [];
        payload.value = new Map();
        for (const [key, value] of input){
            const keyResult = def.keyType._zod.run({
                value: key,
                issues: []
            }, ctx);
            const valueResult = def.valueType._zod.run({
                value: value,
                issues: []
            }, ctx);
            if (keyResult instanceof Promise || valueResult instanceof Promise) proms.push(Promise.all([
                keyResult,
                valueResult
            ]).then(([keyResult, valueResult])=>{
                $e32a9d04eaeb9d0c$var$handleMapResult(keyResult, valueResult, payload, key, input, inst, ctx);
            }));
            else $e32a9d04eaeb9d0c$var$handleMapResult(keyResult, valueResult, payload, key, input, inst, ctx);
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
function $e32a9d04eaeb9d0c$var$handleMapResult(keyResult, valueResult, final, key, input, inst, ctx) {
    if (keyResult.issues.length) {
        if ($17ea3f861a2ff584$export$b99c149ecf60be48.has(typeof key)) final.issues.push(...$17ea3f861a2ff584$export$7f35a4c434118b9e(key, keyResult.issues));
        else final.issues.push({
            code: "invalid_key",
            origin: "map",
            input: input,
            inst: inst,
            issues: keyResult.issues.map((iss)=>$17ea3f861a2ff584$export$c5e667bbfc286a9d(iss, ctx, $4488038d123e8fa5$export$e506a1d27d1eaa20()))
        });
    }
    if (valueResult.issues.length) {
        if ($17ea3f861a2ff584$export$b99c149ecf60be48.has(typeof key)) final.issues.push(...$17ea3f861a2ff584$export$7f35a4c434118b9e(key, valueResult.issues));
        else final.issues.push({
            origin: "map",
            code: "invalid_element",
            input: input,
            inst: inst,
            key: key,
            issues: valueResult.issues.map((iss)=>$17ea3f861a2ff584$export$c5e667bbfc286a9d(iss, ctx, $4488038d123e8fa5$export$e506a1d27d1eaa20()))
        });
    }
    final.value.set(keyResult.value, valueResult.value);
}
const $e32a9d04eaeb9d0c$export$20cf27bc33a30268 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodSet", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!(input instanceof Set)) {
            payload.issues.push({
                input: input,
                inst: inst,
                expected: "set",
                code: "invalid_type"
            });
            return payload;
        }
        const proms = [];
        payload.value = new Set();
        for (const item of input){
            const result = def.valueType._zod.run({
                value: item,
                issues: []
            }, ctx);
            if (result instanceof Promise) proms.push(result.then((result)=>$e32a9d04eaeb9d0c$var$handleSetResult(result, payload)));
            else $e32a9d04eaeb9d0c$var$handleSetResult(result, payload);
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
function $e32a9d04eaeb9d0c$var$handleSetResult(result, final) {
    if (result.issues.length) final.issues.push(...result.issues);
    final.value.add(result.value);
}
const $e32a9d04eaeb9d0c$export$31462b6e6c50b618 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodEnum", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    const values = $17ea3f861a2ff584$export$70a5d58ec00f3c11(def.entries);
    const valuesSet = new Set(values);
    inst._zod.values = valuesSet;
    inst._zod.pattern = new RegExp(`^(${values.filter((k)=>$17ea3f861a2ff584$export$b99c149ecf60be48.has(typeof k)).map((o)=>typeof o === "string" ? $17ea3f861a2ff584$export$104ed90cc1a13451(o) : o.toString()).join("|")})$`);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (valuesSet.has(input)) return payload;
        payload.issues.push({
            code: "invalid_value",
            values: values,
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$86699355265fa258 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodLiteral", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    if (def.values.length === 0) throw new Error("Cannot create literal schema with no valid values");
    const values = new Set(def.values);
    inst._zod.values = values;
    inst._zod.pattern = new RegExp(`^(${def.values.map((o)=>typeof o === "string" ? $17ea3f861a2ff584$export$104ed90cc1a13451(o) : o ? $17ea3f861a2ff584$export$104ed90cc1a13451(o.toString()) : String(o)).join("|")})$`);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (values.has(input)) return payload;
        payload.issues.push({
            code: "invalid_value",
            values: def.values,
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$1997de0576a81377 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodFile", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        // @ts-ignore
        if (input instanceof File) return payload;
        payload.issues.push({
            expected: "file",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$14b591f873519189 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodTransform", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") throw new $4488038d123e8fa5$export$a36d4c29b1151bde(inst.constructor.name);
        const _out = def.transform(payload.value, payload);
        if (ctx.async) {
            const output = _out instanceof Promise ? _out : Promise.resolve(_out);
            return output.then((output)=>{
                payload.value = output;
                return payload;
            });
        }
        if (_out instanceof Promise) throw new $4488038d123e8fa5$export$13016bcec11ba196();
        payload.value = _out;
        return payload;
    };
});
function $e32a9d04eaeb9d0c$var$handleOptionalResult(result, input) {
    if (result.issues.length && input === undefined) return {
        issues: [],
        value: undefined
    };
    return result;
}
const $e32a9d04eaeb9d0c$export$980e9af565c4d7aa = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodOptional", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.optin = "optional";
    inst._zod.optout = "optional";
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "values", ()=>{
        return def.innerType._zod.values ? new Set([
            ...def.innerType._zod.values,
            undefined
        ]) : undefined;
    });
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "pattern", ()=>{
        const pattern = def.innerType._zod.pattern;
        return pattern ? new RegExp(`^(${$17ea3f861a2ff584$export$78d521805d6c22e4(pattern.source)})?$`) : undefined;
    });
    inst._zod.parse = (payload, ctx)=>{
        if (def.innerType._zod.optin === "optional") {
            const result = def.innerType._zod.run(payload, ctx);
            if (result instanceof Promise) return result.then((r)=>$e32a9d04eaeb9d0c$var$handleOptionalResult(r, payload.value));
            return $e32a9d04eaeb9d0c$var$handleOptionalResult(result, payload.value);
        }
        if (payload.value === undefined) return payload;
        return def.innerType._zod.run(payload, ctx);
    };
});
const $e32a9d04eaeb9d0c$export$384d083c2a6b693f = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodExactOptional", (inst, def)=>{
    // Call parent init - inherits optin/optout = "optional"
    $e32a9d04eaeb9d0c$export$980e9af565c4d7aa.init(inst, def);
    // Override values/pattern to NOT add undefined
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "values", ()=>def.innerType._zod.values);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "pattern", ()=>def.innerType._zod.pattern);
    // Override parse to just delegate (no undefined handling)
    inst._zod.parse = (payload, ctx)=>{
        return def.innerType._zod.run(payload, ctx);
    };
});
const $e32a9d04eaeb9d0c$export$7994573b6604ec66 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodNullable", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "optin", ()=>def.innerType._zod.optin);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "optout", ()=>def.innerType._zod.optout);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "pattern", ()=>{
        const pattern = def.innerType._zod.pattern;
        return pattern ? new RegExp(`^(${$17ea3f861a2ff584$export$78d521805d6c22e4(pattern.source)}|null)$`) : undefined;
    });
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "values", ()=>{
        return def.innerType._zod.values ? new Set([
            ...def.innerType._zod.values,
            null
        ]) : undefined;
    });
    inst._zod.parse = (payload, ctx)=>{
        // Forward direction (decode): allow null to pass through
        if (payload.value === null) return payload;
        return def.innerType._zod.run(payload, ctx);
    };
});
const $e32a9d04eaeb9d0c$export$ae2d21004b7243f7 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodDefault", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    // inst._zod.qin = "true";
    inst._zod.optin = "optional";
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "values", ()=>def.innerType._zod.values);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        // Forward direction (decode): apply defaults for undefined input
        if (payload.value === undefined) {
            payload.value = def.defaultValue;
            /**
             * $ZodDefault returns the default value immediately in forward direction.
             * It doesn't pass the default value into the validator ("prefault"). There's no reason to pass the default value through validation. The validity of the default is enforced by TypeScript statically. Otherwise, it's the responsibility of the user to ensure the default is valid. In the case of pipes with divergent in/out types, you can specify the default on the `in` schema of your ZodPipe to set a "prefault" for the pipe.   */ return payload;
        }
        // Forward direction: continue with default handling
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>$e32a9d04eaeb9d0c$var$handleDefaultResult(result, def));
        return $e32a9d04eaeb9d0c$var$handleDefaultResult(result, def);
    };
});
function $e32a9d04eaeb9d0c$var$handleDefaultResult(payload, def) {
    if (payload.value === undefined) payload.value = def.defaultValue;
    return payload;
}
const $e32a9d04eaeb9d0c$export$29a8d757258be679 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodPrefault", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.optin = "optional";
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "values", ()=>def.innerType._zod.values);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        // Forward direction (decode): apply prefault for undefined input
        if (payload.value === undefined) payload.value = def.defaultValue;
        return def.innerType._zod.run(payload, ctx);
    };
});
const $e32a9d04eaeb9d0c$export$30ca726c4c50a6d7 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodNonOptional", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "values", ()=>{
        const v = def.innerType._zod.values;
        return v ? new Set([
            ...v
        ].filter((x)=>x !== undefined)) : undefined;
    });
    inst._zod.parse = (payload, ctx)=>{
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>$e32a9d04eaeb9d0c$var$handleNonOptionalResult(result, inst));
        return $e32a9d04eaeb9d0c$var$handleNonOptionalResult(result, inst);
    };
});
function $e32a9d04eaeb9d0c$var$handleNonOptionalResult(payload, inst) {
    if (!payload.issues.length && payload.value === undefined) payload.issues.push({
        code: "invalid_type",
        expected: "nonoptional",
        input: payload.value,
        inst: inst
    });
    return payload;
}
const $e32a9d04eaeb9d0c$export$3cc4d03e729326ea = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodSuccess", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") throw new $4488038d123e8fa5$export$a36d4c29b1151bde("ZodSuccess");
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>{
            payload.value = result.issues.length === 0;
            return payload;
        });
        payload.value = result.issues.length === 0;
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$d6f8b228374f6d37 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCatch", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "optin", ()=>def.innerType._zod.optin);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "optout", ()=>def.innerType._zod.optout);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "values", ()=>def.innerType._zod.values);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        // Forward direction (decode): apply catch logic
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>{
            payload.value = result.value;
            if (result.issues.length) {
                payload.value = def.catchValue({
                    ...payload,
                    error: {
                        issues: result.issues.map((iss)=>$17ea3f861a2ff584$export$c5e667bbfc286a9d(iss, ctx, $4488038d123e8fa5$export$e506a1d27d1eaa20()))
                    },
                    input: payload.value
                });
                payload.issues = [];
            }
            return payload;
        });
        payload.value = result.value;
        if (result.issues.length) {
            payload.value = def.catchValue({
                ...payload,
                error: {
                    issues: result.issues.map((iss)=>$17ea3f861a2ff584$export$c5e667bbfc286a9d(iss, ctx, $4488038d123e8fa5$export$e506a1d27d1eaa20()))
                },
                input: payload.value
            });
            payload.issues = [];
        }
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$528f71701e6a7aee = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodNaN", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        if (typeof payload.value !== "number" || !Number.isNaN(payload.value)) {
            payload.issues.push({
                input: payload.value,
                inst: inst,
                expected: "nan",
                code: "invalid_type"
            });
            return payload;
        }
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$4cb25cfde430326c = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodPipe", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "values", ()=>def.in._zod.values);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "optin", ()=>def.in._zod.optin);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "optout", ()=>def.out._zod.optout);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "propValues", ()=>def.in._zod.propValues);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") {
            const right = def.out._zod.run(payload, ctx);
            if (right instanceof Promise) return right.then((right)=>$e32a9d04eaeb9d0c$var$handlePipeResult(right, def.in, ctx));
            return $e32a9d04eaeb9d0c$var$handlePipeResult(right, def.in, ctx);
        }
        const left = def.in._zod.run(payload, ctx);
        if (left instanceof Promise) return left.then((left)=>$e32a9d04eaeb9d0c$var$handlePipeResult(left, def.out, ctx));
        return $e32a9d04eaeb9d0c$var$handlePipeResult(left, def.out, ctx);
    };
});
function $e32a9d04eaeb9d0c$var$handlePipeResult(left, next, ctx) {
    if (left.issues.length) {
        // prevent further checks
        left.aborted = true;
        return left;
    }
    return next._zod.run({
        value: left.value,
        issues: left.issues
    }, ctx);
}
const $e32a9d04eaeb9d0c$export$c622e07db8a40b53 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCodec", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "values", ()=>def.in._zod.values);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "optin", ()=>def.in._zod.optin);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "optout", ()=>def.out._zod.optout);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "propValues", ()=>def.in._zod.propValues);
    inst._zod.parse = (payload, ctx)=>{
        const direction = ctx.direction || "forward";
        if (direction === "forward") {
            const left = def.in._zod.run(payload, ctx);
            if (left instanceof Promise) return left.then((left)=>$e32a9d04eaeb9d0c$var$handleCodecAResult(left, def, ctx));
            return $e32a9d04eaeb9d0c$var$handleCodecAResult(left, def, ctx);
        } else {
            const right = def.out._zod.run(payload, ctx);
            if (right instanceof Promise) return right.then((right)=>$e32a9d04eaeb9d0c$var$handleCodecAResult(right, def, ctx));
            return $e32a9d04eaeb9d0c$var$handleCodecAResult(right, def, ctx);
        }
    };
});
function $e32a9d04eaeb9d0c$var$handleCodecAResult(result, def, ctx) {
    if (result.issues.length) {
        // prevent further checks
        result.aborted = true;
        return result;
    }
    const direction = ctx.direction || "forward";
    if (direction === "forward") {
        const transformed = def.transform(result.value, result);
        if (transformed instanceof Promise) return transformed.then((value)=>$e32a9d04eaeb9d0c$var$handleCodecTxResult(result, value, def.out, ctx));
        return $e32a9d04eaeb9d0c$var$handleCodecTxResult(result, transformed, def.out, ctx);
    } else {
        const transformed = def.reverseTransform(result.value, result);
        if (transformed instanceof Promise) return transformed.then((value)=>$e32a9d04eaeb9d0c$var$handleCodecTxResult(result, value, def.in, ctx));
        return $e32a9d04eaeb9d0c$var$handleCodecTxResult(result, transformed, def.in, ctx);
    }
}
function $e32a9d04eaeb9d0c$var$handleCodecTxResult(left, value, nextSchema, ctx) {
    // Check if transform added any issues
    if (left.issues.length) {
        left.aborted = true;
        return left;
    }
    return nextSchema._zod.run({
        value: value,
        issues: left.issues
    }, ctx);
}
const $e32a9d04eaeb9d0c$export$f9f268f3fbb1601b = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodReadonly", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "propValues", ()=>def.innerType._zod.propValues);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "values", ()=>def.innerType._zod.values);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "optin", ()=>def.innerType?._zod?.optin);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "optout", ()=>def.innerType?._zod?.optout);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then($e32a9d04eaeb9d0c$var$handleReadonlyResult);
        return $e32a9d04eaeb9d0c$var$handleReadonlyResult(result);
    };
});
function $e32a9d04eaeb9d0c$var$handleReadonlyResult(payload) {
    payload.value = Object.freeze(payload.value);
    return payload;
}
const $e32a9d04eaeb9d0c$export$37ea86c57a77af54 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodTemplateLiteral", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    const regexParts = [];
    for (const part of def.parts){
        if (typeof part === "object" && part !== null) {
            // is Zod schema
            if (!part._zod.pattern) // if (!source)
            throw new Error(`Invalid template literal part, no pattern found: ${[
                ...part._zod.traits
            ].shift()}`);
            const source = part._zod.pattern instanceof RegExp ? part._zod.pattern.source : part._zod.pattern;
            if (!source) throw new Error(`Invalid template literal part: ${part._zod.traits}`);
            const start = source.startsWith("^") ? 1 : 0;
            const end = source.endsWith("$") ? source.length - 1 : source.length;
            regexParts.push(source.slice(start, end));
        } else if (part === null || $17ea3f861a2ff584$export$c34ffd355f76f0e4.has(typeof part)) regexParts.push($17ea3f861a2ff584$export$104ed90cc1a13451(`${part}`));
        else throw new Error(`Invalid template literal part: ${part}`);
    }
    inst._zod.pattern = new RegExp(`^${regexParts.join("")}$`);
    inst._zod.parse = (payload, _ctx)=>{
        if (typeof payload.value !== "string") {
            payload.issues.push({
                input: payload.value,
                inst: inst,
                expected: "string",
                code: "invalid_type"
            });
            return payload;
        }
        inst._zod.pattern.lastIndex = 0;
        if (!inst._zod.pattern.test(payload.value)) {
            payload.issues.push({
                input: payload.value,
                inst: inst,
                code: "invalid_format",
                format: def.format ?? "template_literal",
                pattern: inst._zod.pattern.source
            });
            return payload;
        }
        return payload;
    };
});
const $e32a9d04eaeb9d0c$export$877c6e9c05ede764 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodFunction", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._def = def;
    inst._zod.def = def;
    inst.implement = (func)=>{
        if (typeof func !== "function") throw new Error("implement() must be called with a function");
        return function(...args) {
            const parsedArgs = inst._def.input ? (0, $3bba9a623c1bec43$export$98e6a39c04603d36)(inst._def.input, args) : args;
            const result = Reflect.apply(func, this, parsedArgs);
            if (inst._def.output) return (0, $3bba9a623c1bec43$export$98e6a39c04603d36)(inst._def.output, result);
            return result;
        };
    };
    inst.implementAsync = (func)=>{
        if (typeof func !== "function") throw new Error("implementAsync() must be called with a function");
        return async function(...args) {
            const parsedArgs = inst._def.input ? await (0, $3bba9a623c1bec43$export$59b6f938fbf579e3)(inst._def.input, args) : args;
            const result = await Reflect.apply(func, this, parsedArgs);
            if (inst._def.output) return await (0, $3bba9a623c1bec43$export$59b6f938fbf579e3)(inst._def.output, result);
            return result;
        };
    };
    inst._zod.parse = (payload, _ctx)=>{
        if (typeof payload.value !== "function") {
            payload.issues.push({
                code: "invalid_type",
                expected: "function",
                input: payload.value,
                inst: inst
            });
            return payload;
        }
        // Check if output is a promise type to determine if we should use async implementation
        const hasPromiseOutput = inst._def.output && inst._def.output._zod.def.type === "promise";
        if (hasPromiseOutput) payload.value = inst.implementAsync(payload.value);
        else payload.value = inst.implement(payload.value);
        return payload;
    };
    inst.input = (...args)=>{
        const F = inst.constructor;
        if (Array.isArray(args[0])) return new F({
            type: "function",
            input: new $e32a9d04eaeb9d0c$export$bba1b90a721dbd94({
                type: "tuple",
                items: args[0],
                rest: args[1]
            }),
            output: inst._def.output
        });
        return new F({
            type: "function",
            input: args[0],
            output: inst._def.output
        });
    };
    inst.output = (output)=>{
        const F = inst.constructor;
        return new F({
            type: "function",
            input: inst._def.input,
            output: output
        });
    };
    return inst;
});
const $e32a9d04eaeb9d0c$export$bdefabff0dd84ca4 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodPromise", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        return Promise.resolve(payload.value).then((inner)=>def.innerType._zod.run({
                value: inner,
                issues: []
            }, ctx));
    };
});
const $e32a9d04eaeb9d0c$export$662fecee2efa1a66 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodLazy", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    // let _innerType!: any;
    // util.defineLazy(def, "getter", () => {
    //   if (!_innerType) {
    //     _innerType = def.getter();
    //   }
    //   return () => _innerType;
    // });
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "innerType", ()=>def.getter());
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "pattern", ()=>inst._zod.innerType?._zod?.pattern);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "propValues", ()=>inst._zod.innerType?._zod?.propValues);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "optin", ()=>inst._zod.innerType?._zod?.optin ?? undefined);
    $17ea3f861a2ff584$export$d43070a5843c1e2(inst._zod, "optout", ()=>inst._zod.innerType?._zod?.optout ?? undefined);
    inst._zod.parse = (payload, ctx)=>{
        const inner = inst._zod.innerType;
        return inner._zod.run(payload, ctx);
    };
});
const $e32a9d04eaeb9d0c$export$3a5d0e5e098b79ba = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("$ZodCustom", (inst, def)=>{
    $bd6e402f1568d28b$export$c05d9110ef20bb2c.init(inst, def);
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _)=>{
        return payload;
    };
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const r = def.fn(input);
        if (r instanceof Promise) return r.then((r)=>$e32a9d04eaeb9d0c$var$handleRefineResult(r, payload, input, inst));
        $e32a9d04eaeb9d0c$var$handleRefineResult(r, payload, input, inst);
        return;
    };
});
function $e32a9d04eaeb9d0c$var$handleRefineResult(result, payload, input, inst) {
    if (!result) {
        const _iss = {
            code: "custom",
            input: input,
            inst: inst,
            path: [
                ...inst._zod.def.path ?? []
            ],
            continue: !inst._zod.def.abort
        };
        if (inst._zod.def.params) _iss.params = inst._zod.def.params;
        payload.issues.push($17ea3f861a2ff584$export$69ad3503f98be476(_iss));
    }
}







const $918bb8c403860024$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u062D\u0631\u0641",
            verb: "\u0623\u0646 \u064A\u062D\u0648\u064A"
        },
        file: {
            unit: "\u0628\u0627\u064A\u062A",
            verb: "\u0623\u0646 \u064A\u062D\u0648\u064A"
        },
        array: {
            unit: "\u0639\u0646\u0635\u0631",
            verb: "\u0623\u0646 \u064A\u062D\u0648\u064A"
        },
        set: {
            unit: "\u0639\u0646\u0635\u0631",
            verb: "\u0623\u0646 \u064A\u062D\u0648\u064A"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0645\u062F\u062E\u0644",
        email: "\u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        url: "\u0631\u0627\u0628\u0637",
        emoji: "\u0625\u064A\u0645\u0648\u062C\u064A",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u062A\u0627\u0631\u064A\u062E \u0648\u0648\u0642\u062A \u0628\u0645\u0639\u064A\u0627\u0631 ISO",
        date: "\u062A\u0627\u0631\u064A\u062E \u0628\u0645\u0639\u064A\u0627\u0631 ISO",
        time: "\u0648\u0642\u062A \u0628\u0645\u0639\u064A\u0627\u0631 ISO",
        duration: "\u0645\u062F\u0629 \u0628\u0645\u0639\u064A\u0627\u0631 ISO",
        ipv4: "\u0639\u0646\u0648\u0627\u0646 IPv4",
        ipv6: "\u0639\u0646\u0648\u0627\u0646 IPv6",
        cidrv4: "\u0645\u062F\u0649 \u0639\u0646\u0627\u0648\u064A\u0646 \u0628\u0635\u064A\u063A\u0629 IPv4",
        cidrv6: "\u0645\u062F\u0649 \u0639\u0646\u0627\u0648\u064A\u0646 \u0628\u0635\u064A\u063A\u0629 IPv6",
        base64: "\u0646\u064E\u0635 \u0628\u062A\u0631\u0645\u064A\u0632 base64-encoded",
        base64url: "\u0646\u064E\u0635 \u0628\u062A\u0631\u0645\u064A\u0632 base64url-encoded",
        json_string: "\u0646\u064E\u0635 \u0639\u0644\u0649 \u0647\u064A\u0626\u0629 JSON",
        e164: "\u0631\u0642\u0645 \u0647\u0627\u062A\u0641 \u0628\u0645\u0639\u064A\u0627\u0631 E.164",
        jwt: "JWT",
        template_literal: "\u0645\u062F\u062E\u0644"
    };
    const TypeDictionary = {
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{645}\u{62F}\u{62E}\u{644}\u{627}\u{62A} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}\u{629}: \u{64A}\u{641}\u{62A}\u{631}\u{636} \u{625}\u{62F}\u{62E}\u{627}\u{644} instanceof ${issue.expected}\u{60C} \u{648}\u{644}\u{643}\u{646} \u{62A}\u{645} \u{625}\u{62F}\u{62E}\u{627}\u{644} ${received}`;
                    return `\u{645}\u{62F}\u{62E}\u{644}\u{627}\u{62A} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}\u{629}: \u{64A}\u{641}\u{62A}\u{631}\u{636} \u{625}\u{62F}\u{62E}\u{627}\u{644} ${expected}\u{60C} \u{648}\u{644}\u{643}\u{646} \u{62A}\u{645} \u{625}\u{62F}\u{62E}\u{627}\u{644} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{645}\u{62F}\u{62E}\u{644}\u{627}\u{62A} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}\u{629}: \u{64A}\u{641}\u{62A}\u{631}\u{636} \u{625}\u{62F}\u{62E}\u{627}\u{644} ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `\u{627}\u{62E}\u{62A}\u{64A}\u{627}\u{631} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}: \u{64A}\u{62A}\u{648}\u{642}\u{639} \u{627}\u{646}\u{62A}\u{642}\u{627}\u{621} \u{623}\u{62D}\u{62F} \u{647}\u{630}\u{647} \u{627}\u{644}\u{62E}\u{64A}\u{627}\u{631}\u{627}\u{62A}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return ` \u{623}\u{643}\u{628}\u{631} \u{645}\u{646} \u{627}\u{644}\u{644}\u{627}\u{632}\u{645}: \u{64A}\u{641}\u{62A}\u{631}\u{636} \u{623}\u{646} \u{62A}\u{643}\u{648}\u{646} ${issue.origin ?? "\u0627\u0644\u0642\u064A\u0645\u0629"} ${adj} ${issue.maximum.toString()} ${sizing.unit ?? "\u0639\u0646\u0635\u0631"}`;
                    return `\u{623}\u{643}\u{628}\u{631} \u{645}\u{646} \u{627}\u{644}\u{644}\u{627}\u{632}\u{645}: \u{64A}\u{641}\u{62A}\u{631}\u{636} \u{623}\u{646} \u{62A}\u{643}\u{648}\u{646} ${issue.origin ?? "\u0627\u0644\u0642\u064A\u0645\u0629"} ${adj} ${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{623}\u{635}\u{63A}\u{631} \u{645}\u{646} \u{627}\u{644}\u{644}\u{627}\u{632}\u{645}: \u{64A}\u{641}\u{62A}\u{631}\u{636} \u{644}\u{640} ${issue.origin} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${adj} ${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{623}\u{635}\u{63A}\u{631} \u{645}\u{646} \u{627}\u{644}\u{644}\u{627}\u{632}\u{645}: \u{64A}\u{641}\u{62A}\u{631}\u{636} \u{644}\u{640} ${issue.origin} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${adj} ${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{646}\u{64E}\u{635} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}: \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{628}\u{62F}\u{623} \u{628}\u{640} "${issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{646}\u{64E}\u{635} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}: \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{646}\u{62A}\u{647}\u{64A} \u{628}\u{640} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{646}\u{64E}\u{635} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}: \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{62A}\u{636}\u{645}\u{651}\u{64E}\u{646} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{646}\u{64E}\u{635} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}: \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{637}\u{627}\u{628}\u{642} \u{627}\u{644}\u{646}\u{645}\u{637} ${_issue.pattern}`;
                    return `${FormatDictionary[_issue.format] ?? issue.format} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}`;
                }
            case "not_multiple_of":
                return `\u{631}\u{642}\u{645} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}: \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} \u{645}\u{646} \u{645}\u{636}\u{627}\u{639}\u{641}\u{627}\u{62A} ${issue.divisor}`;
            case "unrecognized_keys":
                return `\u{645}\u{639}\u{631}\u{641}${issue.keys.length > 1 ? "\u0627\u062A" : ""} \u{63A}\u{631}\u{64A}\u{628}${issue.keys.length > 1 ? "\u0629" : ""}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, "\u060C ")}`;
            case "invalid_key":
                return `\u{645}\u{639}\u{631}\u{641} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644} \u{641}\u{64A} ${issue.origin}`;
            case "invalid_union":
                return "\u0645\u062F\u062E\u0644 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644";
            case "invalid_element":
                return `\u{645}\u{62F}\u{62E}\u{644} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644} \u{641}\u{64A} ${issue.origin}`;
            default:
                return "\u0645\u062F\u062E\u0644 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644";
        }
    };
};
function $918bb8c403860024$export$2e2bcd8739ae039() {
    return {
        localeError: $918bb8c403860024$var$error()
    };
}



const $162285d18c0dc9ed$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "simvol",
            verb: "olmal\u0131d\u0131r"
        },
        file: {
            unit: "bayt",
            verb: "olmal\u0131d\u0131r"
        },
        array: {
            unit: "element",
            verb: "olmal\u0131d\u0131r"
        },
        set: {
            unit: "element",
            verb: "olmal\u0131d\u0131r"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "input",
        email: "email address",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datetime",
        date: "ISO date",
        time: "ISO time",
        duration: "ISO duration",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded string",
        base64url: "base64url-encoded string",
        json_string: "JSON string",
        e164: "E.164 number",
        jwt: "JWT",
        template_literal: "input"
    };
    const TypeDictionary = {
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Yanl\u{131}\u{15F} d\u{259}y\u{259}r: g\xf6zl\u{259}nil\u{259}n instanceof ${issue.expected}, daxil olan ${received}`;
                    return `Yanl\u{131}\u{15F} d\u{259}y\u{259}r: g\xf6zl\u{259}nil\u{259}n ${expected}, daxil olan ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Yanl\u{131}\u{15F} d\u{259}y\u{259}r: g\xf6zl\u{259}nil\u{259}n ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Yanl\u{131}\u{15F} se\xe7im: a\u{15F}a\u{11F}\u{131}dak\u{131}lardan biri olmal\u{131}d\u{131}r: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\xc7ox b\xf6y\xfck: g\xf6zl\u{259}nil\u{259}n ${issue.origin ?? "d\u0259y\u0259r"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "element"}`;
                    return `\xc7ox b\xf6y\xfck: g\xf6zl\u{259}nil\u{259}n ${issue.origin ?? "d\u0259y\u0259r"} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\xc7ox ki\xe7ik: g\xf6zl\u{259}nil\u{259}n ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\xc7ox ki\xe7ik: g\xf6zl\u{259}nil\u{259}n ${issue.origin} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Yanl\u{131}\u{15F} m\u{259}tn: "${_issue.prefix}" il\u{259} ba\u{15F}lamal\u{131}d\u{131}r`;
                    if (_issue.format === "ends_with") return `Yanl\u{131}\u{15F} m\u{259}tn: "${_issue.suffix}" il\u{259} bitm\u{259}lidir`;
                    if (_issue.format === "includes") return `Yanl\u{131}\u{15F} m\u{259}tn: "${_issue.includes}" daxil olmal\u{131}d\u{131}r`;
                    if (_issue.format === "regex") return `Yanl\u{131}\u{15F} m\u{259}tn: ${_issue.pattern} \u{15F}ablonuna uy\u{11F}un olmal\u{131}d\u{131}r`;
                    return `Yanl\u{131}\u{15F} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Yanl\u{131}\u{15F} \u{259}d\u{259}d: ${issue.divisor} il\u{259} b\xf6l\xfcn\u{259} bil\u{259}n olmal\u{131}d\u{131}r`;
            case "unrecognized_keys":
                return `Tan\u{131}nmayan a\xe7ar${issue.keys.length > 1 ? "lar" : ""}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `${issue.origin} daxilind\u{259} yanl\u{131}\u{15F} a\xe7ar`;
            case "invalid_union":
                return "Yanl\u0131\u015F d\u0259y\u0259r";
            case "invalid_element":
                return `${issue.origin} daxilind\u{259} yanl\u{131}\u{15F} d\u{259}y\u{259}r`;
            default:
                return `Yanl\u{131}\u{15F} d\u{259}y\u{259}r`;
        }
    };
};
function $162285d18c0dc9ed$export$2e2bcd8739ae039() {
    return {
        localeError: $162285d18c0dc9ed$var$error()
    };
}



function $d84d7e964bc6d0f9$var$getBelarusianPlural(count, one, few, many) {
    const absCount = Math.abs(count);
    const lastDigit = absCount % 10;
    const lastTwoDigits = absCount % 100;
    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) return many;
    if (lastDigit === 1) return one;
    if (lastDigit >= 2 && lastDigit <= 4) return few;
    return many;
}
const $d84d7e964bc6d0f9$var$error = ()=>{
    const Sizable = {
        string: {
            unit: {
                one: "\u0441\u0456\u043C\u0432\u0430\u043B",
                few: "\u0441\u0456\u043C\u0432\u0430\u043B\u044B",
                many: "\u0441\u0456\u043C\u0432\u0430\u043B\u0430\u045E"
            },
            verb: "\u043C\u0435\u0446\u044C"
        },
        array: {
            unit: {
                one: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442",
                few: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B",
                many: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u045E"
            },
            verb: "\u043C\u0435\u0446\u044C"
        },
        set: {
            unit: {
                one: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442",
                few: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B",
                many: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u045E"
            },
            verb: "\u043C\u0435\u0446\u044C"
        },
        file: {
            unit: {
                one: "\u0431\u0430\u0439\u0442",
                few: "\u0431\u0430\u0439\u0442\u044B",
                many: "\u0431\u0430\u0439\u0442\u0430\u045E"
            },
            verb: "\u043C\u0435\u0446\u044C"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0443\u0432\u043E\u0434",
        email: "email \u0430\u0434\u0440\u0430\u0441",
        url: "URL",
        emoji: "\u044D\u043C\u043E\u0434\u0437\u0456",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u0434\u0430\u0442\u0430 \u0456 \u0447\u0430\u0441",
        date: "ISO \u0434\u0430\u0442\u0430",
        time: "ISO \u0447\u0430\u0441",
        duration: "ISO \u043F\u0440\u0430\u0446\u044F\u0433\u043B\u0430\u0441\u0446\u044C",
        ipv4: "IPv4 \u0430\u0434\u0440\u0430\u0441",
        ipv6: "IPv6 \u0430\u0434\u0440\u0430\u0441",
        cidrv4: "IPv4 \u0434\u044B\u044F\u043F\u0430\u0437\u043E\u043D",
        cidrv6: "IPv6 \u0434\u044B\u044F\u043F\u0430\u0437\u043E\u043D",
        base64: "\u0440\u0430\u0434\u043E\u043A \u0443 \u0444\u0430\u0440\u043C\u0430\u0446\u0435 base64",
        base64url: "\u0440\u0430\u0434\u043E\u043A \u0443 \u0444\u0430\u0440\u043C\u0430\u0446\u0435 base64url",
        json_string: "JSON \u0440\u0430\u0434\u043E\u043A",
        e164: "\u043D\u0443\u043C\u0430\u0440 E.164",
        jwt: "JWT",
        template_literal: "\u0443\u0432\u043E\u0434"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u043B\u0456\u043A",
        array: "\u043C\u0430\u0441\u0456\u045E"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{45E}\u{432}\u{43E}\u{434}: \u{447}\u{430}\u{43A}\u{430}\u{45E}\u{441}\u{44F} instanceof ${issue.expected}, \u{430}\u{442}\u{440}\u{44B}\u{43C}\u{430}\u{43D}\u{430} ${received}`;
                    return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{45E}\u{432}\u{43E}\u{434}: \u{447}\u{430}\u{43A}\u{430}\u{45E}\u{441}\u{44F} ${expected}, \u{430}\u{442}\u{440}\u{44B}\u{43C}\u{430}\u{43D}\u{430} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{45E}\u{432}\u{43E}\u{434}: \u{447}\u{430}\u{43A}\u{430}\u{43B}\u{430}\u{441}\u{44F} ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{432}\u{430}\u{440}\u{44B}\u{44F}\u{43D}\u{442}: \u{447}\u{430}\u{43A}\u{430}\u{45E}\u{441}\u{44F} \u{430}\u{434}\u{437}\u{456}\u{43D} \u{437} ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) {
                        const maxValue = Number(issue.maximum);
                        const unit = $d84d7e964bc6d0f9$var$getBelarusianPlural(maxValue, sizing.unit.one, sizing.unit.few, sizing.unit.many);
                        return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{430} \u{432}\u{44F}\u{43B}\u{456}\u{43A}\u{456}: \u{447}\u{430}\u{43A}\u{430}\u{43B}\u{430}\u{441}\u{44F}, \u{448}\u{442}\u{43E} ${issue.origin ?? "\u0437\u043D\u0430\u0447\u044D\u043D\u043D\u0435"} \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{43D}\u{430} ${sizing.verb} ${adj}${issue.maximum.toString()} ${unit}`;
                    }
                    return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{430} \u{432}\u{44F}\u{43B}\u{456}\u{43A}\u{456}: \u{447}\u{430}\u{43A}\u{430}\u{43B}\u{430}\u{441}\u{44F}, \u{448}\u{442}\u{43E} ${issue.origin ?? "\u0437\u043D\u0430\u0447\u044D\u043D\u043D\u0435"} \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{43D}\u{430} \u{431}\u{44B}\u{446}\u{44C} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) {
                        const minValue = Number(issue.minimum);
                        const unit = $d84d7e964bc6d0f9$var$getBelarusianPlural(minValue, sizing.unit.one, sizing.unit.few, sizing.unit.many);
                        return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{430} \u{43C}\u{430}\u{43B}\u{44B}: \u{447}\u{430}\u{43A}\u{430}\u{43B}\u{430}\u{441}\u{44F}, \u{448}\u{442}\u{43E} ${issue.origin} \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{43D}\u{430} ${sizing.verb} ${adj}${issue.minimum.toString()} ${unit}`;
                    }
                    return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{430} \u{43C}\u{430}\u{43B}\u{44B}: \u{447}\u{430}\u{43A}\u{430}\u{43B}\u{430}\u{441}\u{44F}, \u{448}\u{442}\u{43E} ${issue.origin} \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{43D}\u{430} \u{431}\u{44B}\u{446}\u{44C} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{440}\u{430}\u{434}\u{43E}\u{43A}: \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{435}\u{43D} \u{43F}\u{430}\u{447}\u{44B}\u{43D}\u{430}\u{446}\u{446}\u{430} \u{437} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{440}\u{430}\u{434}\u{43E}\u{43A}: \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{435}\u{43D} \u{437}\u{430}\u{43A}\u{430}\u{43D}\u{447}\u{432}\u{430}\u{446}\u{446}\u{430} \u{43D}\u{430} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{440}\u{430}\u{434}\u{43E}\u{43A}: \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{435}\u{43D} \u{437}\u{43C}\u{44F}\u{448}\u{447}\u{430}\u{446}\u{44C} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{440}\u{430}\u{434}\u{43E}\u{43A}: \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{435}\u{43D} \u{430}\u{434}\u{43F}\u{430}\u{432}\u{44F}\u{434}\u{430}\u{446}\u{44C} \u{448}\u{430}\u{431}\u{43B}\u{43E}\u{43D}\u{443} ${_issue.pattern}`;
                    return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{43B}\u{456}\u{43A}: \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{435}\u{43D} \u{431}\u{44B}\u{446}\u{44C} \u{43A}\u{440}\u{430}\u{442}\u{43D}\u{44B}\u{43C} ${issue.divisor}`;
            case "unrecognized_keys":
                return `\u{41D}\u{435}\u{440}\u{430}\u{441}\u{43F}\u{430}\u{437}\u{43D}\u{430}\u{43D}\u{44B} ${issue.keys.length > 1 ? "\u043A\u043B\u044E\u0447\u044B" : "\u043A\u043B\u044E\u0447"}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{43A}\u{43B}\u{44E}\u{447} \u{443} ${issue.origin}`;
            case "invalid_union":
                return "\u041D\u044F\u043F\u0440\u0430\u0432\u0456\u043B\u044C\u043D\u044B \u045E\u0432\u043E\u0434";
            case "invalid_element":
                return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{430}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{44D}\u{43D}\u{43D}\u{435} \u{45E} ${issue.origin}`;
            default:
                return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{45E}\u{432}\u{43E}\u{434}`;
        }
    };
};
function $d84d7e964bc6d0f9$export$2e2bcd8739ae039() {
    return {
        localeError: $d84d7e964bc6d0f9$var$error()
    };
}



const $bc8f56edd3749ef1$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u0441\u0438\u043C\u0432\u043E\u043B\u0430",
            verb: "\u0434\u0430 \u0441\u044A\u0434\u044A\u0440\u0436\u0430"
        },
        file: {
            unit: "\u0431\u0430\u0439\u0442\u0430",
            verb: "\u0434\u0430 \u0441\u044A\u0434\u044A\u0440\u0436\u0430"
        },
        array: {
            unit: "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0430",
            verb: "\u0434\u0430 \u0441\u044A\u0434\u044A\u0440\u0436\u0430"
        },
        set: {
            unit: "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0430",
            verb: "\u0434\u0430 \u0441\u044A\u0434\u044A\u0440\u0436\u0430"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0432\u0445\u043E\u0434",
        email: "\u0438\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441",
        url: "URL",
        emoji: "\u0435\u043C\u043E\u0434\u0436\u0438",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u0432\u0440\u0435\u043C\u0435",
        date: "ISO \u0434\u0430\u0442\u0430",
        time: "ISO \u0432\u0440\u0435\u043C\u0435",
        duration: "ISO \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u043D\u043E\u0441\u0442",
        ipv4: "IPv4 \u0430\u0434\u0440\u0435\u0441",
        ipv6: "IPv6 \u0430\u0434\u0440\u0435\u0441",
        cidrv4: "IPv4 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D",
        cidrv6: "IPv6 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D",
        base64: "base64-\u043A\u043E\u0434\u0438\u0440\u0430\u043D \u043D\u0438\u0437",
        base64url: "base64url-\u043A\u043E\u0434\u0438\u0440\u0430\u043D \u043D\u0438\u0437",
        json_string: "JSON \u043D\u0438\u0437",
        e164: "E.164 \u043D\u043E\u043C\u0435\u0440",
        jwt: "JWT",
        template_literal: "\u0432\u0445\u043E\u0434"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0447\u0438\u0441\u043B\u043E",
        array: "\u043C\u0430\u0441\u0438\u0432"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{432}\u{445}\u{43E}\u{434}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430}\u{43D} instanceof ${issue.expected}, \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D} ${received}`;
                    return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{432}\u{445}\u{43E}\u{434}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430}\u{43D} ${expected}, \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{432}\u{445}\u{43E}\u{434}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430}\u{43D} ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{43D}\u{430} \u{43E}\u{43F}\u{446}\u{438}\u{44F}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430}\u{43D}\u{43E} \u{435}\u{434}\u{43D}\u{43E} \u{43E}\u{442} ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{422}\u{432}\u{44A}\u{440}\u{434}\u{435} \u{433}\u{43E}\u{43B}\u{44F}\u{43C}\u{43E}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430} \u{441}\u{435} ${issue.origin ?? "\u0441\u0442\u043E\u0439\u043D\u043E\u0441\u0442"} \u{434}\u{430} \u{441}\u{44A}\u{434}\u{44A}\u{440}\u{436}\u{430} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0430"}`;
                    return `\u{422}\u{432}\u{44A}\u{440}\u{434}\u{435} \u{433}\u{43E}\u{43B}\u{44F}\u{43C}\u{43E}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430} \u{441}\u{435} ${issue.origin ?? "\u0441\u0442\u043E\u0439\u043D\u043E\u0441\u0442"} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{422}\u{432}\u{44A}\u{440}\u{434}\u{435} \u{43C}\u{430}\u{43B}\u{43A}\u{43E}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430} \u{441}\u{435} ${issue.origin} \u{434}\u{430} \u{441}\u{44A}\u{434}\u{44A}\u{440}\u{436}\u{430} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{422}\u{432}\u{44A}\u{440}\u{434}\u{435} \u{43C}\u{430}\u{43B}\u{43A}\u{43E}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430} \u{441}\u{435} ${issue.origin} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{43D}\u{438}\u{437}: \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{432}\u{430} \u{441} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{43D}\u{438}\u{437}: \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{437}\u{430}\u{432}\u{44A}\u{440}\u{448}\u{432}\u{430} \u{441} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{43D}\u{438}\u{437}: \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{432}\u{43A}\u{43B}\u{44E}\u{447}\u{432}\u{430} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{43D}\u{438}\u{437}: \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{441}\u{44A}\u{432}\u{43F}\u{430}\u{434}\u{430} \u{441} ${_issue.pattern}`;
                    let invalid_adj = "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u0435\u043D";
                    if (_issue.format === "emoji") invalid_adj = "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u043E";
                    if (_issue.format === "datetime") invalid_adj = "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u043E";
                    if (_issue.format === "date") invalid_adj = "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u0430";
                    if (_issue.format === "time") invalid_adj = "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u043E";
                    if (_issue.format === "duration") invalid_adj = "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u0430";
                    return `${invalid_adj} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{43D}\u{43E} \u{447}\u{438}\u{441}\u{43B}\u{43E}: \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} \u{43A}\u{440}\u{430}\u{442}\u{43D}\u{43E} \u{43D}\u{430} ${issue.divisor}`;
            case "unrecognized_keys":
                return `\u{41D}\u{435}\u{440}\u{430}\u{437}\u{43F}\u{43E}\u{437}\u{43D}\u{430}\u{442}${issue.keys.length > 1 ? "\u0438" : ""} \u{43A}\u{43B}\u{44E}\u{447}${issue.keys.length > 1 ? "\u043E\u0432\u0435" : ""}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{43A}\u{43B}\u{44E}\u{447} \u{432} ${issue.origin}`;
            case "invalid_union":
                return "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u0435\u043D \u0432\u0445\u043E\u0434";
            case "invalid_element":
                return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{43D}\u{430} \u{441}\u{442}\u{43E}\u{439}\u{43D}\u{43E}\u{441}\u{442} \u{432} ${issue.origin}`;
            default:
                return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{432}\u{445}\u{43E}\u{434}`;
        }
    };
};
function $bc8f56edd3749ef1$export$2e2bcd8739ae039() {
    return {
        localeError: $bc8f56edd3749ef1$var$error()
    };
}



const $50b4ab178735be3b$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "car\xe0cters",
            verb: "contenir"
        },
        file: {
            unit: "bytes",
            verb: "contenir"
        },
        array: {
            unit: "elements",
            verb: "contenir"
        },
        set: {
            unit: "elements",
            verb: "contenir"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "entrada",
        email: "adre\xe7a electr\xf2nica",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data i hora ISO",
        date: "data ISO",
        time: "hora ISO",
        duration: "durada ISO",
        ipv4: "adre\xe7a IPv4",
        ipv6: "adre\xe7a IPv6",
        cidrv4: "rang IPv4",
        cidrv6: "rang IPv6",
        base64: "cadena codificada en base64",
        base64url: "cadena codificada en base64url",
        json_string: "cadena JSON",
        e164: "n\xfamero E.164",
        jwt: "JWT",
        template_literal: "entrada"
    };
    const TypeDictionary = {
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Tipus inv\xe0lid: s'esperava instanceof ${issue.expected}, s'ha rebut ${received}`;
                    return `Tipus inv\xe0lid: s'esperava ${expected}, s'ha rebut ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Valor inv\xe0lid: s'esperava ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Opci\xf3 inv\xe0lida: s'esperava una de ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, " o ")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "com a m\xe0xim" : "menys de";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Massa gran: s'esperava que ${issue.origin ?? "el valor"} contingu\xe9s ${adj} ${issue.maximum.toString()} ${sizing.unit ?? "elements"}`;
                    return `Massa gran: s'esperava que ${issue.origin ?? "el valor"} fos ${adj} ${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? "com a m\xednim" : "m\xe9s de";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Massa petit: s'esperava que ${issue.origin} contingu\xe9s ${adj} ${issue.minimum.toString()} ${sizing.unit}`;
                    return `Massa petit: s'esperava que ${issue.origin} fos ${adj} ${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Format inv\xe0lid: ha de comen\xe7ar amb "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Format inv\xe0lid: ha d'acabar amb "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Format inv\xe0lid: ha d'incloure "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Format inv\xe0lid: ha de coincidir amb el patr\xf3 ${_issue.pattern}`;
                    return `Format inv\xe0lid per a ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `N\xfamero inv\xe0lid: ha de ser m\xfaltiple de ${issue.divisor}`;
            case "unrecognized_keys":
                return `Clau${issue.keys.length > 1 ? "s" : ""} no reconeguda${issue.keys.length > 1 ? "s" : ""}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Clau inv\xe0lida a ${issue.origin}`;
            case "invalid_union":
                return "Entrada inv\xe0lida"; // Could also be "Tipus d'unió invàlid" but "Entrada invàlida" is more general
            case "invalid_element":
                return `Element inv\xe0lid a ${issue.origin}`;
            default:
                return `Entrada inv\xe0lida`;
        }
    };
};
function $50b4ab178735be3b$export$2e2bcd8739ae039() {
    return {
        localeError: $50b4ab178735be3b$var$error()
    };
}



const $d0e510346c8c5338$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "znak\u016F",
            verb: "m\xedt"
        },
        file: {
            unit: "bajt\u016F",
            verb: "m\xedt"
        },
        array: {
            unit: "prvk\u016F",
            verb: "m\xedt"
        },
        set: {
            unit: "prvk\u016F",
            verb: "m\xedt"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "regul\xe1rn\xed v\xfdraz",
        email: "e-mailov\xe1 adresa",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "datum a \u010Das ve form\xe1tu ISO",
        date: "datum ve form\xe1tu ISO",
        time: "\u010Das ve form\xe1tu ISO",
        duration: "doba trv\xe1n\xed ISO",
        ipv4: "IPv4 adresa",
        ipv6: "IPv6 adresa",
        cidrv4: "rozsah IPv4",
        cidrv6: "rozsah IPv6",
        base64: "\u0159et\u011Bzec zak\xf3dovan\xfd ve form\xe1tu base64",
        base64url: "\u0159et\u011Bzec zak\xf3dovan\xfd ve form\xe1tu base64url",
        json_string: "\u0159et\u011Bzec ve form\xe1tu JSON",
        e164: "\u010D\xedslo E.164",
        jwt: "JWT",
        template_literal: "vstup"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u010D\xedslo",
        string: "\u0159et\u011Bzec",
        function: "funkce",
        array: "pole"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Neplatn\xfd vstup: o\u{10D}ek\xe1v\xe1no instanceof ${issue.expected}, obdr\u{17E}eno ${received}`;
                    return `Neplatn\xfd vstup: o\u{10D}ek\xe1v\xe1no ${expected}, obdr\u{17E}eno ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Neplatn\xfd vstup: o\u{10D}ek\xe1v\xe1no ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Neplatn\xe1 mo\u{17E}nost: o\u{10D}ek\xe1v\xe1na jedna z hodnot ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Hodnota je p\u{159}\xedli\u{161} velk\xe1: ${issue.origin ?? "hodnota"} mus\xed m\xedt ${adj}${issue.maximum.toString()} ${sizing.unit ?? "prvk\u016F"}`;
                    return `Hodnota je p\u{159}\xedli\u{161} velk\xe1: ${issue.origin ?? "hodnota"} mus\xed b\xfdt ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Hodnota je p\u{159}\xedli\u{161} mal\xe1: ${issue.origin ?? "hodnota"} mus\xed m\xedt ${adj}${issue.minimum.toString()} ${sizing.unit ?? "prvk\u016F"}`;
                    return `Hodnota je p\u{159}\xedli\u{161} mal\xe1: ${issue.origin ?? "hodnota"} mus\xed b\xfdt ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Neplatn\xfd \u{159}et\u{11B}zec: mus\xed za\u{10D}\xednat na "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Neplatn\xfd \u{159}et\u{11B}zec: mus\xed kon\u{10D}it na "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Neplatn\xfd \u{159}et\u{11B}zec: mus\xed obsahovat "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Neplatn\xfd \u{159}et\u{11B}zec: mus\xed odpov\xeddat vzoru ${_issue.pattern}`;
                    return `Neplatn\xfd form\xe1t ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Neplatn\xe9 \u{10D}\xedslo: mus\xed b\xfdt n\xe1sobkem ${issue.divisor}`;
            case "unrecognized_keys":
                return `Nezn\xe1m\xe9 kl\xed\u{10D}e: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Neplatn\xfd kl\xed\u{10D} v ${issue.origin}`;
            case "invalid_union":
                return "Neplatn\xfd vstup";
            case "invalid_element":
                return `Neplatn\xe1 hodnota v ${issue.origin}`;
            default:
                return `Neplatn\xfd vstup`;
        }
    };
};
function $d0e510346c8c5338$export$2e2bcd8739ae039() {
    return {
        localeError: $d0e510346c8c5338$var$error()
    };
}



const $3aa3d682944affe9$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "tegn",
            verb: "havde"
        },
        file: {
            unit: "bytes",
            verb: "havde"
        },
        array: {
            unit: "elementer",
            verb: "indeholdt"
        },
        set: {
            unit: "elementer",
            verb: "indeholdt"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "input",
        email: "e-mailadresse",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO dato- og klokkesl\xe6t",
        date: "ISO-dato",
        time: "ISO-klokkesl\xe6t",
        duration: "ISO-varighed",
        ipv4: "IPv4-omr\xe5de",
        ipv6: "IPv6-omr\xe5de",
        cidrv4: "IPv4-spektrum",
        cidrv6: "IPv6-spektrum",
        base64: "base64-kodet streng",
        base64url: "base64url-kodet streng",
        json_string: "JSON-streng",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "input"
    };
    const TypeDictionary = {
        nan: "NaN",
        string: "streng",
        number: "tal",
        boolean: "boolean",
        array: "liste",
        object: "objekt",
        set: "s\xe6t",
        file: "fil"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Ugyldigt input: forventede instanceof ${issue.expected}, fik ${received}`;
                    return `Ugyldigt input: forventede ${expected}, fik ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Ugyldig v\xe6rdi: forventede ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Ugyldigt valg: forventede en af f\xf8lgende ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    const origin = TypeDictionary[issue.origin] ?? issue.origin;
                    if (sizing) return `For stor: forventede ${origin ?? "value"} ${sizing.verb} ${adj} ${issue.maximum.toString()} ${sizing.unit ?? "elementer"}`;
                    return `For stor: forventede ${origin ?? "value"} havde ${adj} ${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    const origin = TypeDictionary[issue.origin] ?? issue.origin;
                    if (sizing) return `For lille: forventede ${origin} ${sizing.verb} ${adj} ${issue.minimum.toString()} ${sizing.unit}`;
                    return `For lille: forventede ${origin} havde ${adj} ${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Ugyldig streng: skal starte med "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Ugyldig streng: skal ende med "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Ugyldig streng: skal indeholde "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Ugyldig streng: skal matche m\xf8nsteret ${_issue.pattern}`;
                    return `Ugyldig ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Ugyldigt tal: skal v\xe6re deleligt med ${issue.divisor}`;
            case "unrecognized_keys":
                return `${issue.keys.length > 1 ? "Ukendte n\xf8gler" : "Ukendt n\xf8gle"}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Ugyldig n\xf8gle i ${issue.origin}`;
            case "invalid_union":
                return "Ugyldigt input: matcher ingen af de tilladte typer";
            case "invalid_element":
                return `Ugyldig v\xe6rdi i ${issue.origin}`;
            default:
                return `Ugyldigt input`;
        }
    };
};
function $3aa3d682944affe9$export$2e2bcd8739ae039() {
    return {
        localeError: $3aa3d682944affe9$var$error()
    };
}



const $ae4f56a3a616562b$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "Zeichen",
            verb: "zu haben"
        },
        file: {
            unit: "Bytes",
            verb: "zu haben"
        },
        array: {
            unit: "Elemente",
            verb: "zu haben"
        },
        set: {
            unit: "Elemente",
            verb: "zu haben"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "Eingabe",
        email: "E-Mail-Adresse",
        url: "URL",
        emoji: "Emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-Datum und -Uhrzeit",
        date: "ISO-Datum",
        time: "ISO-Uhrzeit",
        duration: "ISO-Dauer",
        ipv4: "IPv4-Adresse",
        ipv6: "IPv6-Adresse",
        cidrv4: "IPv4-Bereich",
        cidrv6: "IPv6-Bereich",
        base64: "Base64-codierter String",
        base64url: "Base64-URL-codierter String",
        json_string: "JSON-String",
        e164: "E.164-Nummer",
        jwt: "JWT",
        template_literal: "Eingabe"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "Zahl",
        array: "Array"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Ung\xfcltige Eingabe: erwartet instanceof ${issue.expected}, erhalten ${received}`;
                    return `Ung\xfcltige Eingabe: erwartet ${expected}, erhalten ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Ung\xfcltige Eingabe: erwartet ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Ung\xfcltige Option: erwartet eine von ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Zu gro\xdf: erwartet, dass ${issue.origin ?? "Wert"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "Elemente"} hat`;
                    return `Zu gro\xdf: erwartet, dass ${issue.origin ?? "Wert"} ${adj}${issue.maximum.toString()} ist`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Zu klein: erwartet, dass ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit} hat`;
                    return `Zu klein: erwartet, dass ${issue.origin} ${adj}${issue.minimum.toString()} ist`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Ung\xfcltiger String: muss mit "${_issue.prefix}" beginnen`;
                    if (_issue.format === "ends_with") return `Ung\xfcltiger String: muss mit "${_issue.suffix}" enden`;
                    if (_issue.format === "includes") return `Ung\xfcltiger String: muss "${_issue.includes}" enthalten`;
                    if (_issue.format === "regex") return `Ung\xfcltiger String: muss dem Muster ${_issue.pattern} entsprechen`;
                    return `Ung\xfcltig: ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Ung\xfcltige Zahl: muss ein Vielfaches von ${issue.divisor} sein`;
            case "unrecognized_keys":
                return `${issue.keys.length > 1 ? "Unbekannte Schl\xfcssel" : "Unbekannter Schl\xfcssel"}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Ung\xfcltiger Schl\xfcssel in ${issue.origin}`;
            case "invalid_union":
                return "Ung\xfcltige Eingabe";
            case "invalid_element":
                return `Ung\xfcltiger Wert in ${issue.origin}`;
            default:
                return `Ung\xfcltige Eingabe`;
        }
    };
};
function $ae4f56a3a616562b$export$2e2bcd8739ae039() {
    return {
        localeError: $ae4f56a3a616562b$var$error()
    };
}



const $f94f9f481fcdc5e7$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "characters",
            verb: "to have"
        },
        file: {
            unit: "bytes",
            verb: "to have"
        },
        array: {
            unit: "items",
            verb: "to have"
        },
        set: {
            unit: "items",
            verb: "to have"
        },
        map: {
            unit: "entries",
            verb: "to have"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "input",
        email: "email address",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datetime",
        date: "ISO date",
        time: "ISO time",
        duration: "ISO duration",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        mac: "MAC address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded string",
        base64url: "base64url-encoded string",
        json_string: "JSON string",
        e164: "E.164 number",
        jwt: "JWT",
        template_literal: "input"
    };
    // type names: missing keys = do not translate (use raw value via ?? fallback)
    const TypeDictionary = {
        // Compatibility: "nan" -> "NaN" for display
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    return `Invalid input: expected ${expected}, received ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Invalid input: expected ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Invalid option: expected one of ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Too big: expected ${issue.origin ?? "value"} to have ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elements"}`;
                    return `Too big: expected ${issue.origin ?? "value"} to be ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Too small: expected ${issue.origin} to have ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Too small: expected ${issue.origin} to be ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Invalid string: must start with "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Invalid string: must end with "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Invalid string: must include "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Invalid string: must match pattern ${_issue.pattern}`;
                    return `Invalid ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Invalid number: must be a multiple of ${issue.divisor}`;
            case "unrecognized_keys":
                return `Unrecognized key${issue.keys.length > 1 ? "s" : ""}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Invalid key in ${issue.origin}`;
            case "invalid_union":
                return "Invalid input";
            case "invalid_element":
                return `Invalid value in ${issue.origin}`;
            default:
                return `Invalid input`;
        }
    };
};
function $f94f9f481fcdc5e7$export$2e2bcd8739ae039() {
    return {
        localeError: $f94f9f481fcdc5e7$var$error()
    };
}



const $328cc329b080cc35$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "karaktrojn",
            verb: "havi"
        },
        file: {
            unit: "bajtojn",
            verb: "havi"
        },
        array: {
            unit: "elementojn",
            verb: "havi"
        },
        set: {
            unit: "elementojn",
            verb: "havi"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "enigo",
        email: "retadreso",
        url: "URL",
        emoji: "emo\u011Dio",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-datotempo",
        date: "ISO-dato",
        time: "ISO-tempo",
        duration: "ISO-da\u016Dro",
        ipv4: "IPv4-adreso",
        ipv6: "IPv6-adreso",
        cidrv4: "IPv4-rango",
        cidrv6: "IPv6-rango",
        base64: "64-ume kodita karaktraro",
        base64url: "URL-64-ume kodita karaktraro",
        json_string: "JSON-karaktraro",
        e164: "E.164-nombro",
        jwt: "JWT",
        template_literal: "enigo"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "nombro",
        array: "tabelo",
        null: "senvalora"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Nevalida enigo: atendi\u{11D}is instanceof ${issue.expected}, ricevi\u{11D}is ${received}`;
                    return `Nevalida enigo: atendi\u{11D}is ${expected}, ricevi\u{11D}is ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Nevalida enigo: atendi\u{11D}is ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Nevalida opcio: atendi\u{11D}is unu el ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Tro granda: atendi\u{11D}is ke ${issue.origin ?? "valoro"} havu ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementojn"}`;
                    return `Tro granda: atendi\u{11D}is ke ${issue.origin ?? "valoro"} havu ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Tro malgranda: atendi\u{11D}is ke ${issue.origin} havu ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Tro malgranda: atendi\u{11D}is ke ${issue.origin} estu ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Nevalida karaktraro: devas komenci\u{11D}i per "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Nevalida karaktraro: devas fini\u{11D}i per "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Nevalida karaktraro: devas inkluzivi "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Nevalida karaktraro: devas kongrui kun la modelo ${_issue.pattern}`;
                    return `Nevalida ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Nevalida nombro: devas esti oblo de ${issue.divisor}`;
            case "unrecognized_keys":
                return `Nekonata${issue.keys.length > 1 ? "j" : ""} \u{15D}losilo${issue.keys.length > 1 ? "j" : ""}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Nevalida \u{15D}losilo en ${issue.origin}`;
            case "invalid_union":
                return "Nevalida enigo";
            case "invalid_element":
                return `Nevalida valoro en ${issue.origin}`;
            default:
                return `Nevalida enigo`;
        }
    };
};
function $328cc329b080cc35$export$2e2bcd8739ae039() {
    return {
        localeError: $328cc329b080cc35$var$error()
    };
}



const $111f27d5908b83f1$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "caracteres",
            verb: "tener"
        },
        file: {
            unit: "bytes",
            verb: "tener"
        },
        array: {
            unit: "elementos",
            verb: "tener"
        },
        set: {
            unit: "elementos",
            verb: "tener"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "entrada",
        email: "direcci\xf3n de correo electr\xf3nico",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "fecha y hora ISO",
        date: "fecha ISO",
        time: "hora ISO",
        duration: "duraci\xf3n ISO",
        ipv4: "direcci\xf3n IPv4",
        ipv6: "direcci\xf3n IPv6",
        cidrv4: "rango IPv4",
        cidrv6: "rango IPv6",
        base64: "cadena codificada en base64",
        base64url: "URL codificada en base64",
        json_string: "cadena JSON",
        e164: "n\xfamero E.164",
        jwt: "JWT",
        template_literal: "entrada"
    };
    const TypeDictionary = {
        nan: "NaN",
        string: "texto",
        number: "n\xfamero",
        boolean: "booleano",
        array: "arreglo",
        object: "objeto",
        set: "conjunto",
        file: "archivo",
        date: "fecha",
        bigint: "n\xfamero grande",
        symbol: "s\xedmbolo",
        undefined: "indefinido",
        null: "nulo",
        function: "funci\xf3n",
        map: "mapa",
        record: "registro",
        tuple: "tupla",
        enum: "enumeraci\xf3n",
        union: "uni\xf3n",
        literal: "literal",
        promise: "promesa",
        void: "vac\xedo",
        never: "nunca",
        unknown: "desconocido",
        any: "cualquiera"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Entrada inv\xe1lida: se esperaba instanceof ${issue.expected}, recibido ${received}`;
                    return `Entrada inv\xe1lida: se esperaba ${expected}, recibido ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Entrada inv\xe1lida: se esperaba ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Opci\xf3n inv\xe1lida: se esperaba una de ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    const origin = TypeDictionary[issue.origin] ?? issue.origin;
                    if (sizing) return `Demasiado grande: se esperaba que ${origin ?? "valor"} tuviera ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementos"}`;
                    return `Demasiado grande: se esperaba que ${origin ?? "valor"} fuera ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    const origin = TypeDictionary[issue.origin] ?? issue.origin;
                    if (sizing) return `Demasiado peque\xf1o: se esperaba que ${origin} tuviera ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Demasiado peque\xf1o: se esperaba que ${origin} fuera ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Cadena inv\xe1lida: debe comenzar con "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Cadena inv\xe1lida: debe terminar en "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Cadena inv\xe1lida: debe incluir "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Cadena inv\xe1lida: debe coincidir con el patr\xf3n ${_issue.pattern}`;
                    return `Inv\xe1lido ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `N\xfamero inv\xe1lido: debe ser m\xfaltiplo de ${issue.divisor}`;
            case "unrecognized_keys":
                return `Llave${issue.keys.length > 1 ? "s" : ""} desconocida${issue.keys.length > 1 ? "s" : ""}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Llave inv\xe1lida en ${TypeDictionary[issue.origin] ?? issue.origin}`;
            case "invalid_union":
                return "Entrada inv\xe1lida";
            case "invalid_element":
                return `Valor inv\xe1lido en ${TypeDictionary[issue.origin] ?? issue.origin}`;
            default:
                return `Entrada inv\xe1lida`;
        }
    };
};
function $111f27d5908b83f1$export$2e2bcd8739ae039() {
    return {
        localeError: $111f27d5908b83f1$var$error()
    };
}



const $9b505079f26198ac$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u06A9\u0627\u0631\u0627\u06A9\u062A\u0631",
            verb: "\u062F\u0627\u0634\u062A\u0647 \u0628\u0627\u0634\u062F"
        },
        file: {
            unit: "\u0628\u0627\u06CC\u062A",
            verb: "\u062F\u0627\u0634\u062A\u0647 \u0628\u0627\u0634\u062F"
        },
        array: {
            unit: "\u0622\u06CC\u062A\u0645",
            verb: "\u062F\u0627\u0634\u062A\u0647 \u0628\u0627\u0634\u062F"
        },
        set: {
            unit: "\u0622\u06CC\u062A\u0645",
            verb: "\u062F\u0627\u0634\u062A\u0647 \u0628\u0627\u0634\u062F"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0648\u0631\u0648\u062F\u06CC",
        email: "\u0622\u062F\u0631\u0633 \u0627\u06CC\u0645\u06CC\u0644",
        url: "URL",
        emoji: "\u0627\u06CC\u0645\u0648\u062C\u06CC",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u062A\u0627\u0631\u06CC\u062E \u0648 \u0632\u0645\u0627\u0646 \u0627\u06CC\u0632\u0648",
        date: "\u062A\u0627\u0631\u06CC\u062E \u0627\u06CC\u0632\u0648",
        time: "\u0632\u0645\u0627\u0646 \u0627\u06CC\u0632\u0648",
        duration: "\u0645\u062F\u062A \u0632\u0645\u0627\u0646 \u0627\u06CC\u0632\u0648",
        ipv4: "IPv4 \u0622\u062F\u0631\u0633",
        ipv6: "IPv6 \u0622\u062F\u0631\u0633",
        cidrv4: "IPv4 \u062F\u0627\u0645\u0646\u0647",
        cidrv6: "IPv6 \u062F\u0627\u0645\u0646\u0647",
        base64: "base64-encoded \u0631\u0634\u062A\u0647",
        base64url: "base64url-encoded \u0631\u0634\u062A\u0647",
        json_string: "JSON \u0631\u0634\u062A\u0647",
        e164: "E.164 \u0639\u062F\u062F",
        jwt: "JWT",
        template_literal: "\u0648\u0631\u0648\u062F\u06CC"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0639\u062F\u062F",
        array: "\u0622\u0631\u0627\u06CC\u0647"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{645}\u{6CC}\u{200C}\u{628}\u{627}\u{6CC}\u{633}\u{62A} instanceof ${issue.expected} \u{645}\u{6CC}\u{200C}\u{628}\u{648}\u{62F}\u{60C} ${received} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{634}\u{62F}`;
                    return `\u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{645}\u{6CC}\u{200C}\u{628}\u{627}\u{6CC}\u{633}\u{62A} ${expected} \u{645}\u{6CC}\u{200C}\u{628}\u{648}\u{62F}\u{60C} ${received} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{634}\u{62F}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{645}\u{6CC}\u{200C}\u{628}\u{627}\u{6CC}\u{633}\u{62A} ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])} \u{645}\u{6CC}\u{200C}\u{628}\u{648}\u{62F}`;
                return `\u{6AF}\u{632}\u{6CC}\u{646}\u{647} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{645}\u{6CC}\u{200C}\u{628}\u{627}\u{6CC}\u{633}\u{62A} \u{6CC}\u{6A9}\u{6CC} \u{627}\u{632} ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")} \u{645}\u{6CC}\u{200C}\u{628}\u{648}\u{62F}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{62E}\u{6CC}\u{644}\u{6CC} \u{628}\u{632}\u{631}\u{6AF}: ${issue.origin ?? "\u0645\u0642\u062F\u0627\u0631"} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0639\u0646\u0635\u0631"} \u{628}\u{627}\u{634}\u{62F}`;
                    return `\u{62E}\u{6CC}\u{644}\u{6CC} \u{628}\u{632}\u{631}\u{6AF}: ${issue.origin ?? "\u0645\u0642\u062F\u0627\u0631"} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.maximum.toString()} \u{628}\u{627}\u{634}\u{62F}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{62E}\u{6CC}\u{644}\u{6CC} \u{6A9}\u{648}\u{686}\u{6A9}: ${issue.origin} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.minimum.toString()} ${sizing.unit} \u{628}\u{627}\u{634}\u{62F}`;
                    return `\u{62E}\u{6CC}\u{644}\u{6CC} \u{6A9}\u{648}\u{686}\u{6A9}: ${issue.origin} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.minimum.toString()} \u{628}\u{627}\u{634}\u{62F}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{631}\u{634}\u{62A}\u{647} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{628}\u{627}\u{6CC}\u{62F} \u{628}\u{627} "${_issue.prefix}" \u{634}\u{631}\u{648}\u{639} \u{634}\u{648}\u{62F}`;
                    if (_issue.format === "ends_with") return `\u{631}\u{634}\u{62A}\u{647} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{628}\u{627}\u{6CC}\u{62F} \u{628}\u{627} "${_issue.suffix}" \u{62A}\u{645}\u{627}\u{645} \u{634}\u{648}\u{62F}`;
                    if (_issue.format === "includes") return `\u{631}\u{634}\u{62A}\u{647} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{628}\u{627}\u{6CC}\u{62F} \u{634}\u{627}\u{645}\u{644} "${_issue.includes}" \u{628}\u{627}\u{634}\u{62F}`;
                    if (_issue.format === "regex") return `\u{631}\u{634}\u{62A}\u{647} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{628}\u{627}\u{6CC}\u{62F} \u{628}\u{627} \u{627}\u{644}\u{6AF}\u{648}\u{6CC} ${_issue.pattern} \u{645}\u{637}\u{627}\u{628}\u{642}\u{62A} \u{62F}\u{627}\u{634}\u{62A}\u{647} \u{628}\u{627}\u{634}\u{62F}`;
                    return `${FormatDictionary[_issue.format] ?? issue.format} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}`;
                }
            case "not_multiple_of":
                return `\u{639}\u{62F}\u{62F} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{628}\u{627}\u{6CC}\u{62F} \u{645}\u{636}\u{631}\u{628} ${issue.divisor} \u{628}\u{627}\u{634}\u{62F}`;
            case "unrecognized_keys":
                return `\u{6A9}\u{644}\u{6CC}\u{62F}${issue.keys.length > 1 ? "\u0647\u0627\u06CC" : ""} \u{646}\u{627}\u{634}\u{646}\u{627}\u{633}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{6A9}\u{644}\u{6CC}\u{62F} \u{646}\u{627}\u{634}\u{646}\u{627}\u{633} \u{62F}\u{631} ${issue.origin}`;
            case "invalid_union":
                return `\u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}`;
            case "invalid_element":
                return `\u{645}\u{642}\u{62F}\u{627}\u{631} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631} \u{62F}\u{631} ${issue.origin}`;
            default:
                return `\u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}`;
        }
    };
};
function $9b505079f26198ac$export$2e2bcd8739ae039() {
    return {
        localeError: $9b505079f26198ac$var$error()
    };
}



const $aa90427022011c7e$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "merkki\xe4",
            subject: "merkkijonon"
        },
        file: {
            unit: "tavua",
            subject: "tiedoston"
        },
        array: {
            unit: "alkiota",
            subject: "listan"
        },
        set: {
            unit: "alkiota",
            subject: "joukon"
        },
        number: {
            unit: "",
            subject: "luvun"
        },
        bigint: {
            unit: "",
            subject: "suuren kokonaisluvun"
        },
        int: {
            unit: "",
            subject: "kokonaisluvun"
        },
        date: {
            unit: "",
            subject: "p\xe4iv\xe4m\xe4\xe4r\xe4n"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "s\xe4\xe4nn\xf6llinen lauseke",
        email: "s\xe4hk\xf6postiosoite",
        url: "URL-osoite",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-aikaleima",
        date: "ISO-p\xe4iv\xe4m\xe4\xe4r\xe4",
        time: "ISO-aika",
        duration: "ISO-kesto",
        ipv4: "IPv4-osoite",
        ipv6: "IPv6-osoite",
        cidrv4: "IPv4-alue",
        cidrv6: "IPv6-alue",
        base64: "base64-koodattu merkkijono",
        base64url: "base64url-koodattu merkkijono",
        json_string: "JSON-merkkijono",
        e164: "E.164-luku",
        jwt: "JWT",
        template_literal: "templaattimerkkijono"
    };
    const TypeDictionary = {
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Virheellinen tyyppi: odotettiin instanceof ${issue.expected}, oli ${received}`;
                    return `Virheellinen tyyppi: odotettiin ${expected}, oli ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Virheellinen sy\xf6te: t\xe4ytyy olla ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Virheellinen valinta: t\xe4ytyy olla yksi seuraavista: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Liian suuri: ${sizing.subject} t\xe4ytyy olla ${adj}${issue.maximum.toString()} ${sizing.unit}`.trim();
                    return `Liian suuri: arvon t\xe4ytyy olla ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Liian pieni: ${sizing.subject} t\xe4ytyy olla ${adj}${issue.minimum.toString()} ${sizing.unit}`.trim();
                    return `Liian pieni: arvon t\xe4ytyy olla ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Virheellinen sy\xf6te: t\xe4ytyy alkaa "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Virheellinen sy\xf6te: t\xe4ytyy loppua "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Virheellinen sy\xf6te: t\xe4ytyy sis\xe4lt\xe4\xe4 "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Virheellinen sy\xf6te: t\xe4ytyy vastata s\xe4\xe4nn\xf6llist\xe4 lauseketta ${_issue.pattern}`;
                    return `Virheellinen ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Virheellinen luku: t\xe4ytyy olla luvun ${issue.divisor} monikerta`;
            case "unrecognized_keys":
                return `${issue.keys.length > 1 ? "Tuntemattomat avaimet" : "Tuntematon avain"}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return "Virheellinen avain tietueessa";
            case "invalid_union":
                return "Virheellinen unioni";
            case "invalid_element":
                return "Virheellinen arvo joukossa";
            default:
                return `Virheellinen sy\xf6te`;
        }
    };
};
function $aa90427022011c7e$export$2e2bcd8739ae039() {
    return {
        localeError: $aa90427022011c7e$var$error()
    };
}



const $68e5b0626df84182$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "caract\xe8res",
            verb: "avoir"
        },
        file: {
            unit: "octets",
            verb: "avoir"
        },
        array: {
            unit: "\xe9l\xe9ments",
            verb: "avoir"
        },
        set: {
            unit: "\xe9l\xe9ments",
            verb: "avoir"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "entr\xe9e",
        email: "adresse e-mail",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "date et heure ISO",
        date: "date ISO",
        time: "heure ISO",
        duration: "dur\xe9e ISO",
        ipv4: "adresse IPv4",
        ipv6: "adresse IPv6",
        cidrv4: "plage IPv4",
        cidrv6: "plage IPv6",
        base64: "cha\xeene encod\xe9e en base64",
        base64url: "cha\xeene encod\xe9e en base64url",
        json_string: "cha\xeene JSON",
        e164: "num\xe9ro E.164",
        jwt: "JWT",
        template_literal: "entr\xe9e"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "nombre",
        array: "tableau"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Entr\xe9e invalide : instanceof ${issue.expected} attendu, ${received} re\xe7u`;
                    return `Entr\xe9e invalide : ${expected} attendu, ${received} re\xe7u`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Entr\xe9e invalide : ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])} attendu`;
                return `Option invalide : une valeur parmi ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")} attendue`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Trop grand : ${issue.origin ?? "valeur"} doit ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\xe9l\xe9ment(s)"}`;
                    return `Trop grand : ${issue.origin ?? "valeur"} doit \xeatre ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Trop petit : ${issue.origin} doit ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Trop petit : ${issue.origin} doit \xeatre ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Cha\xeene invalide : doit commencer par "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Cha\xeene invalide : doit se terminer par "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Cha\xeene invalide : doit inclure "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Cha\xeene invalide : doit correspondre au mod\xe8le ${_issue.pattern}`;
                    return `${FormatDictionary[_issue.format] ?? issue.format} invalide`;
                }
            case "not_multiple_of":
                return `Nombre invalide : doit \xeatre un multiple de ${issue.divisor}`;
            case "unrecognized_keys":
                return `Cl\xe9${issue.keys.length > 1 ? "s" : ""} non reconnue${issue.keys.length > 1 ? "s" : ""} : ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Cl\xe9 invalide dans ${issue.origin}`;
            case "invalid_union":
                return "Entr\xe9e invalide";
            case "invalid_element":
                return `Valeur invalide dans ${issue.origin}`;
            default:
                return `Entr\xe9e invalide`;
        }
    };
};
function $68e5b0626df84182$export$2e2bcd8739ae039() {
    return {
        localeError: $68e5b0626df84182$var$error()
    };
}



const $36bae7df081d561c$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "caract\xe8res",
            verb: "avoir"
        },
        file: {
            unit: "octets",
            verb: "avoir"
        },
        array: {
            unit: "\xe9l\xe9ments",
            verb: "avoir"
        },
        set: {
            unit: "\xe9l\xe9ments",
            verb: "avoir"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "entr\xe9e",
        email: "adresse courriel",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "date-heure ISO",
        date: "date ISO",
        time: "heure ISO",
        duration: "dur\xe9e ISO",
        ipv4: "adresse IPv4",
        ipv6: "adresse IPv6",
        cidrv4: "plage IPv4",
        cidrv6: "plage IPv6",
        base64: "cha\xeene encod\xe9e en base64",
        base64url: "cha\xeene encod\xe9e en base64url",
        json_string: "cha\xeene JSON",
        e164: "num\xe9ro E.164",
        jwt: "JWT",
        template_literal: "entr\xe9e"
    };
    const TypeDictionary = {
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Entr\xe9e invalide : attendu instanceof ${issue.expected}, re\xe7u ${received}`;
                    return `Entr\xe9e invalide : attendu ${expected}, re\xe7u ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Entr\xe9e invalide : attendu ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Option invalide : attendu l'une des valeurs suivantes ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "\u2264" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Trop grand : attendu que ${issue.origin ?? "la valeur"} ait ${adj}${issue.maximum.toString()} ${sizing.unit}`;
                    return `Trop grand : attendu que ${issue.origin ?? "la valeur"} soit ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? "\u2265" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Trop petit : attendu que ${issue.origin} ait ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Trop petit : attendu que ${issue.origin} soit ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Cha\xeene invalide : doit commencer par "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Cha\xeene invalide : doit se terminer par "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Cha\xeene invalide : doit inclure "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Cha\xeene invalide : doit correspondre au motif ${_issue.pattern}`;
                    return `${FormatDictionary[_issue.format] ?? issue.format} invalide`;
                }
            case "not_multiple_of":
                return `Nombre invalide : doit \xeatre un multiple de ${issue.divisor}`;
            case "unrecognized_keys":
                return `Cl\xe9${issue.keys.length > 1 ? "s" : ""} non reconnue${issue.keys.length > 1 ? "s" : ""} : ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Cl\xe9 invalide dans ${issue.origin}`;
            case "invalid_union":
                return "Entr\xe9e invalide";
            case "invalid_element":
                return `Valeur invalide dans ${issue.origin}`;
            default:
                return `Entr\xe9e invalide`;
        }
    };
};
function $36bae7df081d561c$export$2e2bcd8739ae039() {
    return {
        localeError: $36bae7df081d561c$var$error()
    };
}



const $92ead0dbe0ca574d$var$error = ()=>{
    // Hebrew labels + grammatical gender
    const TypeNames = {
        string: {
            label: "\u05DE\u05D7\u05E8\u05D5\u05D6\u05EA",
            gender: "f"
        },
        number: {
            label: "\u05DE\u05E1\u05E4\u05E8",
            gender: "m"
        },
        boolean: {
            label: "\u05E2\u05E8\u05DA \u05D1\u05D5\u05DC\u05D9\u05D0\u05E0\u05D9",
            gender: "m"
        },
        bigint: {
            label: "BigInt",
            gender: "m"
        },
        date: {
            label: "\u05EA\u05D0\u05E8\u05D9\u05DA",
            gender: "m"
        },
        array: {
            label: "\u05DE\u05E2\u05E8\u05DA",
            gender: "m"
        },
        object: {
            label: "\u05D0\u05D5\u05D1\u05D9\u05D9\u05E7\u05D8",
            gender: "m"
        },
        null: {
            label: "\u05E2\u05E8\u05DA \u05E8\u05D9\u05E7 (null)",
            gender: "m"
        },
        undefined: {
            label: "\u05E2\u05E8\u05DA \u05DC\u05D0 \u05DE\u05D5\u05D2\u05D3\u05E8 (undefined)",
            gender: "m"
        },
        symbol: {
            label: "\u05E1\u05D9\u05DE\u05D1\u05D5\u05DC (Symbol)",
            gender: "m"
        },
        function: {
            label: "\u05E4\u05D5\u05E0\u05E7\u05E6\u05D9\u05D4",
            gender: "f"
        },
        map: {
            label: "\u05DE\u05E4\u05D4 (Map)",
            gender: "f"
        },
        set: {
            label: "\u05E7\u05D1\u05D5\u05E6\u05D4 (Set)",
            gender: "f"
        },
        file: {
            label: "\u05E7\u05D5\u05D1\u05E5",
            gender: "m"
        },
        promise: {
            label: "Promise",
            gender: "m"
        },
        NaN: {
            label: "NaN",
            gender: "m"
        },
        unknown: {
            label: "\u05E2\u05E8\u05DA \u05DC\u05D0 \u05D9\u05D3\u05D5\u05E2",
            gender: "m"
        },
        value: {
            label: "\u05E2\u05E8\u05DA",
            gender: "m"
        }
    };
    // Sizing units for size-related messages + localized origin labels
    const Sizable = {
        string: {
            unit: "\u05EA\u05D5\u05D5\u05D9\u05DD",
            shortLabel: "\u05E7\u05E6\u05E8",
            longLabel: "\u05D0\u05E8\u05D5\u05DA"
        },
        file: {
            unit: "\u05D1\u05D9\u05D9\u05D8\u05D9\u05DD",
            shortLabel: "\u05E7\u05D8\u05DF",
            longLabel: "\u05D2\u05D3\u05D5\u05DC"
        },
        array: {
            unit: "\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD",
            shortLabel: "\u05E7\u05D8\u05DF",
            longLabel: "\u05D2\u05D3\u05D5\u05DC"
        },
        set: {
            unit: "\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD",
            shortLabel: "\u05E7\u05D8\u05DF",
            longLabel: "\u05D2\u05D3\u05D5\u05DC"
        },
        number: {
            unit: "",
            shortLabel: "\u05E7\u05D8\u05DF",
            longLabel: "\u05D2\u05D3\u05D5\u05DC"
        }
    };
    // Helpers — labels, articles, and verbs
    const typeEntry = (t)=>t ? TypeNames[t] : undefined;
    const typeLabel = (t)=>{
        const e = typeEntry(t);
        if (e) return e.label;
        // fallback: show raw string if unknown
        return t ?? TypeNames.unknown.label;
    };
    const withDefinite = (t)=>`\u{5D4}${typeLabel(t)}`;
    const verbFor = (t)=>{
        const e = typeEntry(t);
        const gender = e?.gender ?? "m";
        return gender === "f" ? "\u05E6\u05E8\u05D9\u05DB\u05D4 \u05DC\u05D4\u05D9\u05D5\u05EA" : "\u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05D9\u05D5\u05EA";
    };
    const getSizing = (origin)=>{
        if (!origin) return null;
        return Sizable[origin] ?? null;
    };
    const FormatDictionary = {
        regex: {
            label: "\u05E7\u05DC\u05D8",
            gender: "m"
        },
        email: {
            label: "\u05DB\u05EA\u05D5\u05D1\u05EA \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC",
            gender: "f"
        },
        url: {
            label: "\u05DB\u05EA\u05D5\u05D1\u05EA \u05E8\u05E9\u05EA",
            gender: "f"
        },
        emoji: {
            label: "\u05D0\u05D9\u05DE\u05D5\u05D2'\u05D9",
            gender: "m"
        },
        uuid: {
            label: "UUID",
            gender: "m"
        },
        nanoid: {
            label: "nanoid",
            gender: "m"
        },
        guid: {
            label: "GUID",
            gender: "m"
        },
        cuid: {
            label: "cuid",
            gender: "m"
        },
        cuid2: {
            label: "cuid2",
            gender: "m"
        },
        ulid: {
            label: "ULID",
            gender: "m"
        },
        xid: {
            label: "XID",
            gender: "m"
        },
        ksuid: {
            label: "KSUID",
            gender: "m"
        },
        datetime: {
            label: "\u05EA\u05D0\u05E8\u05D9\u05DA \u05D5\u05D6\u05DE\u05DF ISO",
            gender: "m"
        },
        date: {
            label: "\u05EA\u05D0\u05E8\u05D9\u05DA ISO",
            gender: "m"
        },
        time: {
            label: "\u05D6\u05DE\u05DF ISO",
            gender: "m"
        },
        duration: {
            label: "\u05DE\u05E9\u05DA \u05D6\u05DE\u05DF ISO",
            gender: "m"
        },
        ipv4: {
            label: "\u05DB\u05EA\u05D5\u05D1\u05EA IPv4",
            gender: "f"
        },
        ipv6: {
            label: "\u05DB\u05EA\u05D5\u05D1\u05EA IPv6",
            gender: "f"
        },
        cidrv4: {
            label: "\u05D8\u05D5\u05D5\u05D7 IPv4",
            gender: "m"
        },
        cidrv6: {
            label: "\u05D8\u05D5\u05D5\u05D7 IPv6",
            gender: "m"
        },
        base64: {
            label: "\u05DE\u05D7\u05E8\u05D5\u05D6\u05EA \u05D1\u05D1\u05E1\u05D9\u05E1 64",
            gender: "f"
        },
        base64url: {
            label: "\u05DE\u05D7\u05E8\u05D5\u05D6\u05EA \u05D1\u05D1\u05E1\u05D9\u05E1 64 \u05DC\u05DB\u05EA\u05D5\u05D1\u05D5\u05EA \u05E8\u05E9\u05EA",
            gender: "f"
        },
        json_string: {
            label: "\u05DE\u05D7\u05E8\u05D5\u05D6\u05EA JSON",
            gender: "f"
        },
        e164: {
            label: "\u05DE\u05E1\u05E4\u05E8 E.164",
            gender: "m"
        },
        jwt: {
            label: "JWT",
            gender: "m"
        },
        ends_with: {
            label: "\u05E7\u05DC\u05D8",
            gender: "m"
        },
        includes: {
            label: "\u05E7\u05DC\u05D8",
            gender: "m"
        },
        lowercase: {
            label: "\u05E7\u05DC\u05D8",
            gender: "m"
        },
        starts_with: {
            label: "\u05E7\u05DC\u05D8",
            gender: "m"
        },
        uppercase: {
            label: "\u05E7\u05DC\u05D8",
            gender: "m"
        }
    };
    const TypeDictionary = {
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    // Expected type: show without definite article for clearer Hebrew
                    const expectedKey = issue.expected;
                    const expected = TypeDictionary[expectedKey ?? ""] ?? typeLabel(expectedKey);
                    // Received: show localized label if known, otherwise constructor/raw
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? TypeNames[receivedType]?.label ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{5E7}\u{5DC}\u{5D8} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF}: \u{5E6}\u{5E8}\u{5D9}\u{5DA} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} instanceof ${issue.expected}, \u{5D4}\u{5EA}\u{5E7}\u{5D1}\u{5DC} ${received}`;
                    return `\u{5E7}\u{5DC}\u{5D8} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF}: \u{5E6}\u{5E8}\u{5D9}\u{5DA} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} ${expected}, \u{5D4}\u{5EA}\u{5E7}\u{5D1}\u{5DC} ${received}`;
                }
            case "invalid_value":
                {
                    if (issue.values.length === 1) return `\u{5E2}\u{5E8}\u{5DA} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF}: \u{5D4}\u{5E2}\u{5E8}\u{5DA} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                    // Join values with proper Hebrew formatting
                    const stringified = issue.values.map((v)=>$17ea3f861a2ff584$export$5859860f650378f4(v));
                    if (issue.values.length === 2) return `\u{5E2}\u{5E8}\u{5DA} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF}: \u{5D4}\u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5D9}\u{5D5}\u{5EA} \u{5D4}\u{5DE}\u{5EA}\u{5D0}\u{5D9}\u{5DE}\u{5D5}\u{5EA} \u{5D4}\u{5DF} ${stringified[0]} \u{5D0}\u{5D5} ${stringified[1]}`;
                    // For 3+ values: "a", "b" או "c"
                    const lastValue = stringified[stringified.length - 1];
                    const restValues = stringified.slice(0, -1).join(", ");
                    return `\u{5E2}\u{5E8}\u{5DA} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF}: \u{5D4}\u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5D9}\u{5D5}\u{5EA} \u{5D4}\u{5DE}\u{5EA}\u{5D0}\u{5D9}\u{5DE}\u{5D5}\u{5EA} \u{5D4}\u{5DF} ${restValues} \u{5D0}\u{5D5} ${lastValue}`;
                }
            case "too_big":
                {
                    const sizing = getSizing(issue.origin);
                    const subject = withDefinite(issue.origin ?? "value");
                    if (issue.origin === "string") // Special handling for strings - more natural Hebrew
                    return `${sizing?.longLabel ?? "\u05D0\u05E8\u05D5\u05DA"} \u{5DE}\u{5D3}\u{5D9}: ${subject} \u{5E6}\u{5E8}\u{5D9}\u{5DB}\u{5D4} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} ${issue.maximum.toString()} ${sizing?.unit ?? ""} ${issue.inclusive ? "\u05D0\u05D5 \u05E4\u05D7\u05D5\u05EA" : "\u05DC\u05DB\u05DC \u05D4\u05D9\u05D5\u05EA\u05E8"}`.trim();
                    if (issue.origin === "number") {
                        // Natural Hebrew for numbers
                        const comparison = issue.inclusive ? `\u{5E7}\u{5D8}\u{5DF} \u{5D0}\u{5D5} \u{5E9}\u{5D5}\u{5D5}\u{5D4} \u{5DC}-${issue.maximum}` : `\u{5E7}\u{5D8}\u{5DF} \u{5DE}-${issue.maximum}`;
                        return `\u{5D2}\u{5D3}\u{5D5}\u{5DC} \u{5DE}\u{5D3}\u{5D9}: ${subject} \u{5E6}\u{5E8}\u{5D9}\u{5DA} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} ${comparison}`;
                    }
                    if (issue.origin === "array" || issue.origin === "set") {
                        // Natural Hebrew for arrays and sets
                        const verb = issue.origin === "set" ? "\u05E6\u05E8\u05D9\u05DB\u05D4" : "\u05E6\u05E8\u05D9\u05DA";
                        const comparison = issue.inclusive ? `${issue.maximum} ${sizing?.unit ?? ""} \u{5D0}\u{5D5} \u{5E4}\u{5D7}\u{5D5}\u{5EA}` : `\u{5E4}\u{5D7}\u{5D5}\u{5EA} \u{5DE}-${issue.maximum} ${sizing?.unit ?? ""}`;
                        return `\u{5D2}\u{5D3}\u{5D5}\u{5DC} \u{5DE}\u{5D3}\u{5D9}: ${subject} ${verb} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} ${comparison}`.trim();
                    }
                    const adj = issue.inclusive ? "<=" : "<";
                    const be = verbFor(issue.origin ?? "value");
                    if (sizing?.unit) return `${sizing.longLabel} \u{5DE}\u{5D3}\u{5D9}: ${subject} ${be} ${adj}${issue.maximum.toString()} ${sizing.unit}`;
                    return `${sizing?.longLabel ?? "\u05D2\u05D3\u05D5\u05DC"} \u{5DE}\u{5D3}\u{5D9}: ${subject} ${be} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const sizing = getSizing(issue.origin);
                    const subject = withDefinite(issue.origin ?? "value");
                    if (issue.origin === "string") // Special handling for strings - more natural Hebrew
                    return `${sizing?.shortLabel ?? "\u05E7\u05E6\u05E8"} \u{5DE}\u{5D3}\u{5D9}: ${subject} \u{5E6}\u{5E8}\u{5D9}\u{5DB}\u{5D4} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} ${issue.minimum.toString()} ${sizing?.unit ?? ""} ${issue.inclusive ? "\u05D0\u05D5 \u05D9\u05D5\u05EA\u05E8" : "\u05DC\u05E4\u05D7\u05D5\u05EA"}`.trim();
                    if (issue.origin === "number") {
                        // Natural Hebrew for numbers
                        const comparison = issue.inclusive ? `\u{5D2}\u{5D3}\u{5D5}\u{5DC} \u{5D0}\u{5D5} \u{5E9}\u{5D5}\u{5D5}\u{5D4} \u{5DC}-${issue.minimum}` : `\u{5D2}\u{5D3}\u{5D5}\u{5DC} \u{5DE}-${issue.minimum}`;
                        return `\u{5E7}\u{5D8}\u{5DF} \u{5DE}\u{5D3}\u{5D9}: ${subject} \u{5E6}\u{5E8}\u{5D9}\u{5DA} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} ${comparison}`;
                    }
                    if (issue.origin === "array" || issue.origin === "set") {
                        // Natural Hebrew for arrays and sets
                        const verb = issue.origin === "set" ? "\u05E6\u05E8\u05D9\u05DB\u05D4" : "\u05E6\u05E8\u05D9\u05DA";
                        // Special case for singular (minimum === 1)
                        if (issue.minimum === 1 && issue.inclusive) {
                            const singularPhrase = issue.origin === "set" ? "\u05DC\u05E4\u05D7\u05D5\u05EA \u05E4\u05E8\u05D9\u05D8 \u05D0\u05D7\u05D3" : "\u05DC\u05E4\u05D7\u05D5\u05EA \u05E4\u05E8\u05D9\u05D8 \u05D0\u05D7\u05D3";
                            return `\u{5E7}\u{5D8}\u{5DF} \u{5DE}\u{5D3}\u{5D9}: ${subject} ${verb} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} ${singularPhrase}`;
                        }
                        const comparison = issue.inclusive ? `${issue.minimum} ${sizing?.unit ?? ""} \u{5D0}\u{5D5} \u{5D9}\u{5D5}\u{5EA}\u{5E8}` : `\u{5D9}\u{5D5}\u{5EA}\u{5E8} \u{5DE}-${issue.minimum} ${sizing?.unit ?? ""}`;
                        return `\u{5E7}\u{5D8}\u{5DF} \u{5DE}\u{5D3}\u{5D9}: ${subject} ${verb} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} ${comparison}`.trim();
                    }
                    const adj = issue.inclusive ? ">=" : ">";
                    const be = verbFor(issue.origin ?? "value");
                    if (sizing?.unit) return `${sizing.shortLabel} \u{5DE}\u{5D3}\u{5D9}: ${subject} ${be} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `${sizing?.shortLabel ?? "\u05E7\u05D8\u05DF"} \u{5DE}\u{5D3}\u{5D9}: ${subject} ${be} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    // These apply to strings — use feminine grammar + ה׳ הידיעה
                    if (_issue.format === "starts_with") return `\u{5D4}\u{5DE}\u{5D7}\u{5E8}\u{5D5}\u{5D6}\u{5EA} \u{5D7}\u{5D9}\u{5D9}\u{5D1}\u{5EA} \u{5DC}\u{5D4}\u{5EA}\u{5D7}\u{5D9}\u{5DC} \u{5D1} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{5D4}\u{5DE}\u{5D7}\u{5E8}\u{5D5}\u{5D6}\u{5EA} \u{5D7}\u{5D9}\u{5D9}\u{5D1}\u{5EA} \u{5DC}\u{5D4}\u{5E1}\u{5EA}\u{5D9}\u{5D9}\u{5DD} \u{5D1} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{5D4}\u{5DE}\u{5D7}\u{5E8}\u{5D5}\u{5D6}\u{5EA} \u{5D7}\u{5D9}\u{5D9}\u{5D1}\u{5EA} \u{5DC}\u{5DB}\u{5DC}\u{5D5}\u{5DC} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{5D4}\u{5DE}\u{5D7}\u{5E8}\u{5D5}\u{5D6}\u{5EA} \u{5D7}\u{5D9}\u{5D9}\u{5D1}\u{5EA} \u{5DC}\u{5D4}\u{5EA}\u{5D0}\u{5D9}\u{5DD} \u{5DC}\u{5EA}\u{5D1}\u{5E0}\u{5D9}\u{5EA} ${_issue.pattern}`;
                    // Handle gender agreement for formats
                    const nounEntry = FormatDictionary[_issue.format];
                    const noun = nounEntry?.label ?? _issue.format;
                    const gender = nounEntry?.gender ?? "m";
                    const adjective = gender === "f" ? "\u05EA\u05E7\u05D9\u05E0\u05D4" : "\u05EA\u05E7\u05D9\u05DF";
                    return `${noun} \u{5DC}\u{5D0} ${adjective}`;
                }
            case "not_multiple_of":
                return `\u{5DE}\u{5E1}\u{5E4}\u{5E8} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF}: \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5DE}\u{5DB}\u{5E4}\u{5DC}\u{5D4} \u{5E9}\u{5DC} ${issue.divisor}`;
            case "unrecognized_keys":
                return `\u{5DE}\u{5E4}\u{5EA}\u{5D7}${issue.keys.length > 1 ? "\u05D5\u05EA" : ""} \u{5DC}\u{5D0} \u{5DE}\u{5D6}\u{5D5}\u{5D4}${issue.keys.length > 1 ? "\u05D9\u05DD" : "\u05D4"}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{5E9}\u{5D3}\u{5D4} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF} \u{5D1}\u{5D0}\u{5D5}\u{5D1}\u{5D9}\u{5D9}\u{5E7}\u{5D8}`;
            case "invalid_union":
                return "\u05E7\u05DC\u05D8 \u05DC\u05D0 \u05EA\u05E7\u05D9\u05DF";
            case "invalid_element":
                {
                    const place = withDefinite(issue.origin ?? "array");
                    return `\u{5E2}\u{5E8}\u{5DA} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF} \u{5D1}${place}`;
                }
            default:
                return `\u{5E7}\u{5DC}\u{5D8} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF}`;
        }
    };
};
function $92ead0dbe0ca574d$export$2e2bcd8739ae039() {
    return {
        localeError: $92ead0dbe0ca574d$var$error()
    };
}



const $5a43ba2afa347f58$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "karakter",
            verb: "legyen"
        },
        file: {
            unit: "byte",
            verb: "legyen"
        },
        array: {
            unit: "elem",
            verb: "legyen"
        },
        set: {
            unit: "elem",
            verb: "legyen"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "bemenet",
        email: "email c\xedm",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO id\u0151b\xe9lyeg",
        date: "ISO d\xe1tum",
        time: "ISO id\u0151",
        duration: "ISO id\u0151intervallum",
        ipv4: "IPv4 c\xedm",
        ipv6: "IPv6 c\xedm",
        cidrv4: "IPv4 tartom\xe1ny",
        cidrv6: "IPv6 tartom\xe1ny",
        base64: "base64-k\xf3dolt string",
        base64url: "base64url-k\xf3dolt string",
        json_string: "JSON string",
        e164: "E.164 sz\xe1m",
        jwt: "JWT",
        template_literal: "bemenet"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "sz\xe1m",
        array: "t\xf6mb"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\xc9rv\xe9nytelen bemenet: a v\xe1rt \xe9rt\xe9k instanceof ${issue.expected}, a kapott \xe9rt\xe9k ${received}`;
                    return `\xc9rv\xe9nytelen bemenet: a v\xe1rt \xe9rt\xe9k ${expected}, a kapott \xe9rt\xe9k ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\xc9rv\xe9nytelen bemenet: a v\xe1rt \xe9rt\xe9k ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `\xc9rv\xe9nytelen opci\xf3: valamelyik \xe9rt\xe9k v\xe1rt ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `T\xfal nagy: ${issue.origin ?? "\xe9rt\xe9k"} m\xe9rete t\xfal nagy ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elem"}`;
                    return `T\xfal nagy: a bemeneti \xe9rt\xe9k ${issue.origin ?? "\xe9rt\xe9k"} t\xfal nagy: ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `T\xfal kicsi: a bemeneti \xe9rt\xe9k ${issue.origin} m\xe9rete t\xfal kicsi ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `T\xfal kicsi: a bemeneti \xe9rt\xe9k ${issue.origin} t\xfal kicsi ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\xc9rv\xe9nytelen string: "${_issue.prefix}" \xe9rt\xe9kkel kell kezd\u{151}dnie`;
                    if (_issue.format === "ends_with") return `\xc9rv\xe9nytelen string: "${_issue.suffix}" \xe9rt\xe9kkel kell v\xe9gz\u{151}dnie`;
                    if (_issue.format === "includes") return `\xc9rv\xe9nytelen string: "${_issue.includes}" \xe9rt\xe9ket kell tartalmaznia`;
                    if (_issue.format === "regex") return `\xc9rv\xe9nytelen string: ${_issue.pattern} mint\xe1nak kell megfelelnie`;
                    return `\xc9rv\xe9nytelen ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\xc9rv\xe9nytelen sz\xe1m: ${issue.divisor} t\xf6bbsz\xf6r\xf6s\xe9nek kell lennie`;
            case "unrecognized_keys":
                return `Ismeretlen kulcs${issue.keys.length > 1 ? "s" : ""}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\xc9rv\xe9nytelen kulcs ${issue.origin}`;
            case "invalid_union":
                return "\xc9rv\xe9nytelen bemenet";
            case "invalid_element":
                return `\xc9rv\xe9nytelen \xe9rt\xe9k: ${issue.origin}`;
            default:
                return `\xc9rv\xe9nytelen bemenet`;
        }
    };
};
function $5a43ba2afa347f58$export$2e2bcd8739ae039() {
    return {
        localeError: $5a43ba2afa347f58$var$error()
    };
}



function $8e18bee4fe2fa86d$var$getArmenianPlural(count, one, many) {
    return Math.abs(count) === 1 ? one : many;
}
function $8e18bee4fe2fa86d$var$withDefiniteArticle(word) {
    if (!word) return "";
    const vowels = [
        "\u0561",
        "\u0565",
        "\u0568",
        "\u056B",
        "\u0578",
        "\u0578\u0582",
        "\u0585"
    ];
    const lastChar = word[word.length - 1];
    return word + (vowels.includes(lastChar) ? "\u0576" : "\u0568");
}
const $8e18bee4fe2fa86d$var$error = ()=>{
    const Sizable = {
        string: {
            unit: {
                one: "\u0576\u0577\u0561\u0576",
                many: "\u0576\u0577\u0561\u0576\u0576\u0565\u0580"
            },
            verb: "\u0578\u0582\u0576\u0565\u0576\u0561\u056C"
        },
        file: {
            unit: {
                one: "\u0562\u0561\u0575\u0569",
                many: "\u0562\u0561\u0575\u0569\u0565\u0580"
            },
            verb: "\u0578\u0582\u0576\u0565\u0576\u0561\u056C"
        },
        array: {
            unit: {
                one: "\u057F\u0561\u0580\u0580",
                many: "\u057F\u0561\u0580\u0580\u0565\u0580"
            },
            verb: "\u0578\u0582\u0576\u0565\u0576\u0561\u056C"
        },
        set: {
            unit: {
                one: "\u057F\u0561\u0580\u0580",
                many: "\u057F\u0561\u0580\u0580\u0565\u0580"
            },
            verb: "\u0578\u0582\u0576\u0565\u0576\u0561\u056C"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0574\u0578\u0582\u057F\u0584",
        email: "\u0567\u056C. \u0570\u0561\u057D\u0581\u0565",
        url: "URL",
        emoji: "\u0567\u0574\u0578\u057B\u056B",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u0561\u0574\u057D\u0561\u0569\u056B\u057E \u0587 \u056A\u0561\u0574",
        date: "ISO \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
        time: "ISO \u056A\u0561\u0574",
        duration: "ISO \u057F\u0587\u0578\u0572\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ipv4: "IPv4 \u0570\u0561\u057D\u0581\u0565",
        ipv6: "IPv6 \u0570\u0561\u057D\u0581\u0565",
        cidrv4: "IPv4 \u0574\u056B\u057B\u0561\u056F\u0561\u0575\u0584",
        cidrv6: "IPv6 \u0574\u056B\u057B\u0561\u056F\u0561\u0575\u0584",
        base64: "base64 \u0571\u0587\u0561\u0579\u0561\u0583\u0578\u057E \u057F\u0578\u0572",
        base64url: "base64url \u0571\u0587\u0561\u0579\u0561\u0583\u0578\u057E \u057F\u0578\u0572",
        json_string: "JSON \u057F\u0578\u0572",
        e164: "E.164 \u0570\u0561\u0574\u0561\u0580",
        jwt: "JWT",
        template_literal: "\u0574\u0578\u0582\u057F\u0584"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0569\u056B\u057E",
        array: "\u0566\u0561\u0576\u0563\u057E\u0561\u056E"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{54D}\u{56D}\u{561}\u{56C} \u{574}\u{578}\u{582}\u{57F}\u{584}\u{561}\u{563}\u{580}\u{578}\u{582}\u{574}\u{2024} \u{57D}\u{57A}\u{561}\u{57D}\u{57E}\u{578}\u{582}\u{574} \u{567}\u{580} instanceof ${issue.expected}, \u{57D}\u{57F}\u{561}\u{581}\u{57E}\u{565}\u{56C} \u{567} ${received}`;
                    return `\u{54D}\u{56D}\u{561}\u{56C} \u{574}\u{578}\u{582}\u{57F}\u{584}\u{561}\u{563}\u{580}\u{578}\u{582}\u{574}\u{2024} \u{57D}\u{57A}\u{561}\u{57D}\u{57E}\u{578}\u{582}\u{574} \u{567}\u{580} ${expected}, \u{57D}\u{57F}\u{561}\u{581}\u{57E}\u{565}\u{56C} \u{567} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{54D}\u{56D}\u{561}\u{56C} \u{574}\u{578}\u{582}\u{57F}\u{584}\u{561}\u{563}\u{580}\u{578}\u{582}\u{574}\u{2024} \u{57D}\u{57A}\u{561}\u{57D}\u{57E}\u{578}\u{582}\u{574} \u{567}\u{580} ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[1])}`;
                return `\u{54D}\u{56D}\u{561}\u{56C} \u{57F}\u{561}\u{580}\u{562}\u{565}\u{580}\u{561}\u{56F}\u{2024} \u{57D}\u{57A}\u{561}\u{57D}\u{57E}\u{578}\u{582}\u{574} \u{567}\u{580} \u{570}\u{565}\u{57F}\u{587}\u{575}\u{561}\u{56C}\u{576}\u{565}\u{580}\u{56B}\u{581} \u{574}\u{565}\u{56F}\u{568}\u{55D} ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) {
                        const maxValue = Number(issue.maximum);
                        const unit = $8e18bee4fe2fa86d$var$getArmenianPlural(maxValue, sizing.unit.one, sizing.unit.many);
                        return `\u{549}\u{561}\u{583}\u{561}\u{566}\u{561}\u{576}\u{581} \u{574}\u{565}\u{56E} \u{561}\u{580}\u{56A}\u{565}\u{584}\u{2024} \u{57D}\u{57A}\u{561}\u{57D}\u{57E}\u{578}\u{582}\u{574} \u{567}, \u{578}\u{580} ${$8e18bee4fe2fa86d$var$withDefiniteArticle(issue.origin ?? "\u0561\u0580\u056A\u0565\u0584")} \u{56F}\u{578}\u{582}\u{576}\u{565}\u{576}\u{561} ${adj}${issue.maximum.toString()} ${unit}`;
                    }
                    return `\u{549}\u{561}\u{583}\u{561}\u{566}\u{561}\u{576}\u{581} \u{574}\u{565}\u{56E} \u{561}\u{580}\u{56A}\u{565}\u{584}\u{2024} \u{57D}\u{57A}\u{561}\u{57D}\u{57E}\u{578}\u{582}\u{574} \u{567}, \u{578}\u{580} ${$8e18bee4fe2fa86d$var$withDefiniteArticle(issue.origin ?? "\u0561\u0580\u056A\u0565\u0584")} \u{56C}\u{56B}\u{576}\u{56B} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) {
                        const minValue = Number(issue.minimum);
                        const unit = $8e18bee4fe2fa86d$var$getArmenianPlural(minValue, sizing.unit.one, sizing.unit.many);
                        return `\u{549}\u{561}\u{583}\u{561}\u{566}\u{561}\u{576}\u{581} \u{583}\u{578}\u{584}\u{580} \u{561}\u{580}\u{56A}\u{565}\u{584}\u{2024} \u{57D}\u{57A}\u{561}\u{57D}\u{57E}\u{578}\u{582}\u{574} \u{567}, \u{578}\u{580} ${$8e18bee4fe2fa86d$var$withDefiniteArticle(issue.origin)} \u{56F}\u{578}\u{582}\u{576}\u{565}\u{576}\u{561} ${adj}${issue.minimum.toString()} ${unit}`;
                    }
                    return `\u{549}\u{561}\u{583}\u{561}\u{566}\u{561}\u{576}\u{581} \u{583}\u{578}\u{584}\u{580} \u{561}\u{580}\u{56A}\u{565}\u{584}\u{2024} \u{57D}\u{57A}\u{561}\u{57D}\u{57E}\u{578}\u{582}\u{574} \u{567}, \u{578}\u{580} ${$8e18bee4fe2fa86d$var$withDefiniteArticle(issue.origin)} \u{56C}\u{56B}\u{576}\u{56B} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{54D}\u{56D}\u{561}\u{56C} \u{57F}\u{578}\u{572}\u{2024} \u{57A}\u{565}\u{57F}\u{584} \u{567} \u{57D}\u{56F}\u{57D}\u{57E}\u{56B} "${_issue.prefix}"-\u{578}\u{57E}`;
                    if (_issue.format === "ends_with") return `\u{54D}\u{56D}\u{561}\u{56C} \u{57F}\u{578}\u{572}\u{2024} \u{57A}\u{565}\u{57F}\u{584} \u{567} \u{561}\u{57E}\u{561}\u{580}\u{57F}\u{57E}\u{56B} "${_issue.suffix}"-\u{578}\u{57E}`;
                    if (_issue.format === "includes") return `\u{54D}\u{56D}\u{561}\u{56C} \u{57F}\u{578}\u{572}\u{2024} \u{57A}\u{565}\u{57F}\u{584} \u{567} \u{57A}\u{561}\u{580}\u{578}\u{582}\u{576}\u{561}\u{56F}\u{56B} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{54D}\u{56D}\u{561}\u{56C} \u{57F}\u{578}\u{572}\u{2024} \u{57A}\u{565}\u{57F}\u{584} \u{567} \u{570}\u{561}\u{574}\u{561}\u{57A}\u{561}\u{57F}\u{561}\u{57D}\u{56D}\u{561}\u{576}\u{56B} ${_issue.pattern} \u{571}\u{587}\u{561}\u{579}\u{561}\u{583}\u{56B}\u{576}`;
                    return `\u{54D}\u{56D}\u{561}\u{56C} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{54D}\u{56D}\u{561}\u{56C} \u{569}\u{56B}\u{57E}\u{2024} \u{57A}\u{565}\u{57F}\u{584} \u{567} \u{562}\u{561}\u{566}\u{574}\u{561}\u{57A}\u{561}\u{57F}\u{56B}\u{56F} \u{56C}\u{56B}\u{576}\u{56B} ${issue.divisor}-\u{56B}`;
            case "unrecognized_keys":
                return `\u{549}\u{573}\u{561}\u{576}\u{561}\u{579}\u{57E}\u{561}\u{56E} \u{562}\u{561}\u{576}\u{561}\u{56C}\u{56B}${issue.keys.length > 1 ? "\u0576\u0565\u0580" : ""}. ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{54D}\u{56D}\u{561}\u{56C} \u{562}\u{561}\u{576}\u{561}\u{56C}\u{56B} ${$8e18bee4fe2fa86d$var$withDefiniteArticle(issue.origin)}-\u{578}\u{582}\u{574}`;
            case "invalid_union":
                return "\u054D\u056D\u0561\u056C \u0574\u0578\u0582\u057F\u0584\u0561\u0563\u0580\u0578\u0582\u0574";
            case "invalid_element":
                return `\u{54D}\u{56D}\u{561}\u{56C} \u{561}\u{580}\u{56A}\u{565}\u{584} ${$8e18bee4fe2fa86d$var$withDefiniteArticle(issue.origin)}-\u{578}\u{582}\u{574}`;
            default:
                return `\u{54D}\u{56D}\u{561}\u{56C} \u{574}\u{578}\u{582}\u{57F}\u{584}\u{561}\u{563}\u{580}\u{578}\u{582}\u{574}`;
        }
    };
};
function $8e18bee4fe2fa86d$export$2e2bcd8739ae039() {
    return {
        localeError: $8e18bee4fe2fa86d$var$error()
    };
}



const $54b9c092341166c1$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "karakter",
            verb: "memiliki"
        },
        file: {
            unit: "byte",
            verb: "memiliki"
        },
        array: {
            unit: "item",
            verb: "memiliki"
        },
        set: {
            unit: "item",
            verb: "memiliki"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "input",
        email: "alamat email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "tanggal dan waktu format ISO",
        date: "tanggal format ISO",
        time: "jam format ISO",
        duration: "durasi format ISO",
        ipv4: "alamat IPv4",
        ipv6: "alamat IPv6",
        cidrv4: "rentang alamat IPv4",
        cidrv6: "rentang alamat IPv6",
        base64: "string dengan enkode base64",
        base64url: "string dengan enkode base64url",
        json_string: "string JSON",
        e164: "angka E.164",
        jwt: "JWT",
        template_literal: "input"
    };
    const TypeDictionary = {
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Input tidak valid: diharapkan instanceof ${issue.expected}, diterima ${received}`;
                    return `Input tidak valid: diharapkan ${expected}, diterima ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Input tidak valid: diharapkan ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Pilihan tidak valid: diharapkan salah satu dari ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Terlalu besar: diharapkan ${issue.origin ?? "value"} memiliki ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elemen"}`;
                    return `Terlalu besar: diharapkan ${issue.origin ?? "value"} menjadi ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Terlalu kecil: diharapkan ${issue.origin} memiliki ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Terlalu kecil: diharapkan ${issue.origin} menjadi ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `String tidak valid: harus dimulai dengan "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `String tidak valid: harus berakhir dengan "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `String tidak valid: harus menyertakan "${_issue.includes}"`;
                    if (_issue.format === "regex") return `String tidak valid: harus sesuai pola ${_issue.pattern}`;
                    return `${FormatDictionary[_issue.format] ?? issue.format} tidak valid`;
                }
            case "not_multiple_of":
                return `Angka tidak valid: harus kelipatan dari ${issue.divisor}`;
            case "unrecognized_keys":
                return `Kunci tidak dikenali ${issue.keys.length > 1 ? "s" : ""}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Kunci tidak valid di ${issue.origin}`;
            case "invalid_union":
                return "Input tidak valid";
            case "invalid_element":
                return `Nilai tidak valid di ${issue.origin}`;
            default:
                return `Input tidak valid`;
        }
    };
};
function $54b9c092341166c1$export$2e2bcd8739ae039() {
    return {
        localeError: $54b9c092341166c1$var$error()
    };
}



const $cac57819cd346eb7$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "stafi",
            verb: "a\xf0 hafa"
        },
        file: {
            unit: "b\xe6ti",
            verb: "a\xf0 hafa"
        },
        array: {
            unit: "hluti",
            verb: "a\xf0 hafa"
        },
        set: {
            unit: "hluti",
            verb: "a\xf0 hafa"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "gildi",
        email: "netfang",
        url: "vefsl\xf3\xf0",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO dagsetning og t\xedmi",
        date: "ISO dagsetning",
        time: "ISO t\xedmi",
        duration: "ISO t\xedmalengd",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded strengur",
        base64url: "base64url-encoded strengur",
        json_string: "JSON strengur",
        e164: "E.164 t\xf6lugildi",
        jwt: "JWT",
        template_literal: "gildi"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "n\xfamer",
        array: "fylki"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Rangt gildi: \xde\xfa sl\xf3st inn ${received} \xfear sem \xe1 a\xf0 vera instanceof ${issue.expected}`;
                    return `Rangt gildi: \xde\xfa sl\xf3st inn ${received} \xfear sem \xe1 a\xf0 vera ${expected}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Rangt gildi: gert r\xe1\xf0 fyrir ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `\xd3gilt val: m\xe1 vera eitt af eftirfarandi ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Of st\xf3rt: gert er r\xe1\xf0 fyrir a\xf0 ${issue.origin ?? "gildi"} hafi ${adj}${issue.maximum.toString()} ${sizing.unit ?? "hluti"}`;
                    return `Of st\xf3rt: gert er r\xe1\xf0 fyrir a\xf0 ${issue.origin ?? "gildi"} s\xe9 ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Of l\xedti\xf0: gert er r\xe1\xf0 fyrir a\xf0 ${issue.origin} hafi ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Of l\xedti\xf0: gert er r\xe1\xf0 fyrir a\xf0 ${issue.origin} s\xe9 ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\xd3gildur strengur: ver\xf0ur a\xf0 byrja \xe1 "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\xd3gildur strengur: ver\xf0ur a\xf0 enda \xe1 "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\xd3gildur strengur: ver\xf0ur a\xf0 innihalda "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\xd3gildur strengur: ver\xf0ur a\xf0 fylgja mynstri ${_issue.pattern}`;
                    return `Rangt ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `R\xf6ng tala: ver\xf0ur a\xf0 vera margfeldi af ${issue.divisor}`;
            case "unrecognized_keys":
                return `\xd3\xfeekkt ${issue.keys.length > 1 ? "ir lyklar" : "ur lykill"}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Rangur lykill \xed ${issue.origin}`;
            case "invalid_union":
                return "Rangt gildi";
            case "invalid_element":
                return `Rangt gildi \xed ${issue.origin}`;
            default:
                return `Rangt gildi`;
        }
    };
};
function $cac57819cd346eb7$export$2e2bcd8739ae039() {
    return {
        localeError: $cac57819cd346eb7$var$error()
    };
}



const $0315e04349f5d918$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "caratteri",
            verb: "avere"
        },
        file: {
            unit: "byte",
            verb: "avere"
        },
        array: {
            unit: "elementi",
            verb: "avere"
        },
        set: {
            unit: "elementi",
            verb: "avere"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "input",
        email: "indirizzo email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data e ora ISO",
        date: "data ISO",
        time: "ora ISO",
        duration: "durata ISO",
        ipv4: "indirizzo IPv4",
        ipv6: "indirizzo IPv6",
        cidrv4: "intervallo IPv4",
        cidrv6: "intervallo IPv6",
        base64: "stringa codificata in base64",
        base64url: "URL codificata in base64",
        json_string: "stringa JSON",
        e164: "numero E.164",
        jwt: "JWT",
        template_literal: "input"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "numero",
        array: "vettore"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Input non valido: atteso instanceof ${issue.expected}, ricevuto ${received}`;
                    return `Input non valido: atteso ${expected}, ricevuto ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Input non valido: atteso ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Opzione non valida: atteso uno tra ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Troppo grande: ${issue.origin ?? "valore"} deve avere ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementi"}`;
                    return `Troppo grande: ${issue.origin ?? "valore"} deve essere ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Troppo piccolo: ${issue.origin} deve avere ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Troppo piccolo: ${issue.origin} deve essere ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Stringa non valida: deve iniziare con "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Stringa non valida: deve terminare con "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Stringa non valida: deve includere "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Stringa non valida: deve corrispondere al pattern ${_issue.pattern}`;
                    return `Invalid ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Numero non valido: deve essere un multiplo di ${issue.divisor}`;
            case "unrecognized_keys":
                return `Chiav${issue.keys.length > 1 ? "i" : "e"} non riconosciut${issue.keys.length > 1 ? "e" : "a"}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Chiave non valida in ${issue.origin}`;
            case "invalid_union":
                return "Input non valido";
            case "invalid_element":
                return `Valore non valido in ${issue.origin}`;
            default:
                return `Input non valido`;
        }
    };
};
function $0315e04349f5d918$export$2e2bcd8739ae039() {
    return {
        localeError: $0315e04349f5d918$var$error()
    };
}



const $cb8a9b2f82a05986$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u6587\u5B57",
            verb: "\u3067\u3042\u308B"
        },
        file: {
            unit: "\u30D0\u30A4\u30C8",
            verb: "\u3067\u3042\u308B"
        },
        array: {
            unit: "\u8981\u7D20",
            verb: "\u3067\u3042\u308B"
        },
        set: {
            unit: "\u8981\u7D20",
            verb: "\u3067\u3042\u308B"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u5165\u529B\u5024",
        email: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
        url: "URL",
        emoji: "\u7D75\u6587\u5B57",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO\u65E5\u6642",
        date: "ISO\u65E5\u4ED8",
        time: "ISO\u6642\u523B",
        duration: "ISO\u671F\u9593",
        ipv4: "IPv4\u30A2\u30C9\u30EC\u30B9",
        ipv6: "IPv6\u30A2\u30C9\u30EC\u30B9",
        cidrv4: "IPv4\u7BC4\u56F2",
        cidrv6: "IPv6\u7BC4\u56F2",
        base64: "base64\u30A8\u30F3\u30B3\u30FC\u30C9\u6587\u5B57\u5217",
        base64url: "base64url\u30A8\u30F3\u30B3\u30FC\u30C9\u6587\u5B57\u5217",
        json_string: "JSON\u6587\u5B57\u5217",
        e164: "E.164\u756A\u53F7",
        jwt: "JWT",
        template_literal: "\u5165\u529B\u5024"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u6570\u5024",
        array: "\u914D\u5217"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{7121}\u{52B9}\u{306A}\u{5165}\u{529B}: instanceof ${issue.expected}\u{304C}\u{671F}\u{5F85}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}\u{304C}\u{3001}${received}\u{304C}\u{5165}\u{529B}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}`;
                    return `\u{7121}\u{52B9}\u{306A}\u{5165}\u{529B}: ${expected}\u{304C}\u{671F}\u{5F85}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}\u{304C}\u{3001}${received}\u{304C}\u{5165}\u{529B}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{7121}\u{52B9}\u{306A}\u{5165}\u{529B}: ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}\u{304C}\u{671F}\u{5F85}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}`;
                return `\u{7121}\u{52B9}\u{306A}\u{9078}\u{629E}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "\u3001")}\u{306E}\u{3044}\u{305A}\u{308C}\u{304B}\u{3067}\u{3042}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "\u4EE5\u4E0B\u3067\u3042\u308B" : "\u3088\u308A\u5C0F\u3055\u3044";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{5927}\u{304D}\u{3059}\u{304E}\u{308B}\u{5024}: ${issue.origin ?? "\u5024"}\u{306F}${issue.maximum.toString()}${sizing.unit ?? "\u8981\u7D20"}${adj}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                    return `\u{5927}\u{304D}\u{3059}\u{304E}\u{308B}\u{5024}: ${issue.origin ?? "\u5024"}\u{306F}${issue.maximum.toString()}${adj}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? "\u4EE5\u4E0A\u3067\u3042\u308B" : "\u3088\u308A\u5927\u304D\u3044";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{5C0F}\u{3055}\u{3059}\u{304E}\u{308B}\u{5024}: ${issue.origin}\u{306F}${issue.minimum.toString()}${sizing.unit}${adj}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                    return `\u{5C0F}\u{3055}\u{3059}\u{304E}\u{308B}\u{5024}: ${issue.origin}\u{306F}${issue.minimum.toString()}${adj}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{7121}\u{52B9}\u{306A}\u{6587}\u{5B57}\u{5217}: "${_issue.prefix}"\u{3067}\u{59CB}\u{307E}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                    if (_issue.format === "ends_with") return `\u{7121}\u{52B9}\u{306A}\u{6587}\u{5B57}\u{5217}: "${_issue.suffix}"\u{3067}\u{7D42}\u{308F}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                    if (_issue.format === "includes") return `\u{7121}\u{52B9}\u{306A}\u{6587}\u{5B57}\u{5217}: "${_issue.includes}"\u{3092}\u{542B}\u{3080}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                    if (_issue.format === "regex") return `\u{7121}\u{52B9}\u{306A}\u{6587}\u{5B57}\u{5217}: \u{30D1}\u{30BF}\u{30FC}\u{30F3}${_issue.pattern}\u{306B}\u{4E00}\u{81F4}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                    return `\u{7121}\u{52B9}\u{306A}${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{7121}\u{52B9}\u{306A}\u{6570}\u{5024}: ${issue.divisor}\u{306E}\u{500D}\u{6570}\u{3067}\u{3042}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
            case "unrecognized_keys":
                return `\u{8A8D}\u{8B58}\u{3055}\u{308C}\u{3066}\u{3044}\u{306A}\u{3044}\u{30AD}\u{30FC}${issue.keys.length > 1 ? "\u7FA4" : ""}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, "\u3001")}`;
            case "invalid_key":
                return `${issue.origin}\u{5185}\u{306E}\u{7121}\u{52B9}\u{306A}\u{30AD}\u{30FC}`;
            case "invalid_union":
                return "\u7121\u52B9\u306A\u5165\u529B";
            case "invalid_element":
                return `${issue.origin}\u{5185}\u{306E}\u{7121}\u{52B9}\u{306A}\u{5024}`;
            default:
                return `\u{7121}\u{52B9}\u{306A}\u{5165}\u{529B}`;
        }
    };
};
function $cb8a9b2f82a05986$export$2e2bcd8739ae039() {
    return {
        localeError: $cb8a9b2f82a05986$var$error()
    };
}



const $89979695c2c8aeff$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u10E1\u10D8\u10DB\u10D1\u10DD\u10DA\u10DD",
            verb: "\u10E3\u10DC\u10D3\u10D0 \u10E8\u10D4\u10D8\u10EA\u10D0\u10D5\u10D3\u10D4\u10E1"
        },
        file: {
            unit: "\u10D1\u10D0\u10D8\u10E2\u10D8",
            verb: "\u10E3\u10DC\u10D3\u10D0 \u10E8\u10D4\u10D8\u10EA\u10D0\u10D5\u10D3\u10D4\u10E1"
        },
        array: {
            unit: "\u10D4\u10DA\u10D4\u10DB\u10D4\u10DC\u10E2\u10D8",
            verb: "\u10E3\u10DC\u10D3\u10D0 \u10E8\u10D4\u10D8\u10EA\u10D0\u10D5\u10D3\u10D4\u10E1"
        },
        set: {
            unit: "\u10D4\u10DA\u10D4\u10DB\u10D4\u10DC\u10E2\u10D8",
            verb: "\u10E3\u10DC\u10D3\u10D0 \u10E8\u10D4\u10D8\u10EA\u10D0\u10D5\u10D3\u10D4\u10E1"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u10E8\u10D4\u10E7\u10D5\u10D0\u10DC\u10D0",
        email: "\u10D4\u10DA-\u10E4\u10DD\u10E1\u10E2\u10D8\u10E1 \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8",
        url: "URL",
        emoji: "\u10D4\u10DB\u10DD\u10EF\u10D8",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8-\u10D3\u10E0\u10DD",
        date: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8",
        time: "\u10D3\u10E0\u10DD",
        duration: "\u10EE\u10D0\u10DC\u10D2\u10E0\u10EB\u10DA\u10D8\u10D5\u10DD\u10D1\u10D0",
        ipv4: "IPv4 \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8",
        ipv6: "IPv6 \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8",
        cidrv4: "IPv4 \u10D3\u10D8\u10D0\u10DE\u10D0\u10D6\u10DD\u10DC\u10D8",
        cidrv6: "IPv6 \u10D3\u10D8\u10D0\u10DE\u10D0\u10D6\u10DD\u10DC\u10D8",
        base64: "base64-\u10D9\u10DD\u10D3\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E1\u10E2\u10E0\u10D8\u10DC\u10D2\u10D8",
        base64url: "base64url-\u10D9\u10DD\u10D3\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E1\u10E2\u10E0\u10D8\u10DC\u10D2\u10D8",
        json_string: "JSON \u10E1\u10E2\u10E0\u10D8\u10DC\u10D2\u10D8",
        e164: "E.164 \u10DC\u10DD\u10DB\u10D4\u10E0\u10D8",
        jwt: "JWT",
        template_literal: "\u10E8\u10D4\u10E7\u10D5\u10D0\u10DC\u10D0"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8",
        string: "\u10E1\u10E2\u10E0\u10D8\u10DC\u10D2\u10D8",
        boolean: "\u10D1\u10E3\u10DA\u10D4\u10D0\u10DC\u10D8",
        function: "\u10E4\u10E3\u10DC\u10E5\u10EA\u10D8\u10D0",
        array: "\u10DB\u10D0\u10E1\u10D8\u10D5\u10D8"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E8}\u{10D4}\u{10E7}\u{10D5}\u{10D0}\u{10DC}\u{10D0}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8} instanceof ${issue.expected}, \u{10DB}\u{10D8}\u{10E6}\u{10D4}\u{10D1}\u{10E3}\u{10DA}\u{10D8} ${received}`;
                    return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E8}\u{10D4}\u{10E7}\u{10D5}\u{10D0}\u{10DC}\u{10D0}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8} ${expected}, \u{10DB}\u{10D8}\u{10E6}\u{10D4}\u{10D1}\u{10E3}\u{10DA}\u{10D8} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E8}\u{10D4}\u{10E7}\u{10D5}\u{10D0}\u{10DC}\u{10D0}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8} ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10D5}\u{10D0}\u{10E0}\u{10D8}\u{10D0}\u{10DC}\u{10E2}\u{10D8}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8}\u{10D0} \u{10D4}\u{10E0}\u{10D7}-\u{10D4}\u{10E0}\u{10D7}\u{10D8} ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}-\u{10D3}\u{10D0}\u{10DC}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{10D6}\u{10D4}\u{10D3}\u{10DB}\u{10D4}\u{10E2}\u{10D0}\u{10D3} \u{10D3}\u{10D8}\u{10D3}\u{10D8}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8} ${issue.origin ?? "\u10DB\u10DC\u10D8\u10E8\u10D5\u10DC\u10D4\u10DA\u10DD\u10D1\u10D0"} ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit}`;
                    return `\u{10D6}\u{10D4}\u{10D3}\u{10DB}\u{10D4}\u{10E2}\u{10D0}\u{10D3} \u{10D3}\u{10D8}\u{10D3}\u{10D8}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8} ${issue.origin ?? "\u10DB\u10DC\u10D8\u10E8\u10D5\u10DC\u10D4\u10DA\u10DD\u10D1\u10D0"} \u{10D8}\u{10E7}\u{10DD}\u{10E1} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{10D6}\u{10D4}\u{10D3}\u{10DB}\u{10D4}\u{10E2}\u{10D0}\u{10D3} \u{10DE}\u{10D0}\u{10E2}\u{10D0}\u{10E0}\u{10D0}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8} ${issue.origin} ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{10D6}\u{10D4}\u{10D3}\u{10DB}\u{10D4}\u{10E2}\u{10D0}\u{10D3} \u{10DE}\u{10D0}\u{10E2}\u{10D0}\u{10E0}\u{10D0}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8} ${issue.origin} \u{10D8}\u{10E7}\u{10DD}\u{10E1} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E1}\u{10E2}\u{10E0}\u{10D8}\u{10DC}\u{10D2}\u{10D8}: \u{10E3}\u{10DC}\u{10D3}\u{10D0} \u{10D8}\u{10EC}\u{10E7}\u{10D4}\u{10D1}\u{10DD}\u{10D3}\u{10D4}\u{10E1} "${_issue.prefix}"-\u{10D8}\u{10D7}`;
                    if (_issue.format === "ends_with") return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E1}\u{10E2}\u{10E0}\u{10D8}\u{10DC}\u{10D2}\u{10D8}: \u{10E3}\u{10DC}\u{10D3}\u{10D0} \u{10DB}\u{10D7}\u{10D0}\u{10D5}\u{10E0}\u{10D3}\u{10D4}\u{10D1}\u{10DD}\u{10D3}\u{10D4}\u{10E1} "${_issue.suffix}"-\u{10D8}\u{10D7}`;
                    if (_issue.format === "includes") return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E1}\u{10E2}\u{10E0}\u{10D8}\u{10DC}\u{10D2}\u{10D8}: \u{10E3}\u{10DC}\u{10D3}\u{10D0} \u{10E8}\u{10D4}\u{10D8}\u{10EA}\u{10D0}\u{10D5}\u{10D3}\u{10D4}\u{10E1} "${_issue.includes}"-\u{10E1}`;
                    if (_issue.format === "regex") return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E1}\u{10E2}\u{10E0}\u{10D8}\u{10DC}\u{10D2}\u{10D8}: \u{10E3}\u{10DC}\u{10D3}\u{10D0} \u{10E8}\u{10D4}\u{10D4}\u{10E1}\u{10D0}\u{10D1}\u{10D0}\u{10DB}\u{10D4}\u{10D1}\u{10DD}\u{10D3}\u{10D4}\u{10E1} \u{10E8}\u{10D0}\u{10D1}\u{10DA}\u{10DD}\u{10DC}\u{10E1} ${_issue.pattern}`;
                    return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E0}\u{10D8}\u{10EA}\u{10EE}\u{10D5}\u{10D8}: \u{10E3}\u{10DC}\u{10D3}\u{10D0} \u{10D8}\u{10E7}\u{10DD}\u{10E1} ${issue.divisor}-\u{10D8}\u{10E1} \u{10EF}\u{10D4}\u{10E0}\u{10D0}\u{10D3}\u{10D8}`;
            case "unrecognized_keys":
                return `\u{10E3}\u{10EA}\u{10DC}\u{10DD}\u{10D1}\u{10D8} \u{10D2}\u{10D0}\u{10E1}\u{10D0}\u{10E6}\u{10D4}\u{10D1}${issue.keys.length > 1 ? "\u10D4\u10D1\u10D8" : "\u10D8"}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10D2}\u{10D0}\u{10E1}\u{10D0}\u{10E6}\u{10D4}\u{10D1}\u{10D8} ${issue.origin}-\u{10E8}\u{10D8}`;
            case "invalid_union":
                return "\u10D0\u10E0\u10D0\u10E1\u10EC\u10DD\u10E0\u10D8 \u10E8\u10D4\u10E7\u10D5\u10D0\u10DC\u10D0";
            case "invalid_element":
                return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10DB}\u{10DC}\u{10D8}\u{10E8}\u{10D5}\u{10DC}\u{10D4}\u{10DA}\u{10DD}\u{10D1}\u{10D0} ${issue.origin}-\u{10E8}\u{10D8}`;
            default:
                return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E8}\u{10D4}\u{10E7}\u{10D5}\u{10D0}\u{10DC}\u{10D0}`;
        }
    };
};
function $89979695c2c8aeff$export$2e2bcd8739ae039() {
    return {
        localeError: $89979695c2c8aeff$var$error()
    };
}



const $a5991a6ef1585f14$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u178F\u17BD\u17A2\u1780\u17D2\u179F\u179A",
            verb: "\u1782\u17BD\u179A\u1798\u17B6\u1793"
        },
        file: {
            unit: "\u1794\u17C3",
            verb: "\u1782\u17BD\u179A\u1798\u17B6\u1793"
        },
        array: {
            unit: "\u1792\u17B6\u178F\u17BB",
            verb: "\u1782\u17BD\u179A\u1798\u17B6\u1793"
        },
        set: {
            unit: "\u1792\u17B6\u178F\u17BB",
            verb: "\u1782\u17BD\u179A\u1798\u17B6\u1793"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799\u1794\u1789\u17D2\u1785\u17BC\u179B",
        email: "\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793\u17A2\u17CA\u17B8\u1798\u17C2\u179B",
        url: "URL",
        emoji: "\u179F\u1789\u17D2\u1789\u17B6\u17A2\u17B6\u179A\u1798\u17D2\u1798\u178E\u17CD",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u1780\u17B6\u179B\u1794\u179A\u17B7\u1785\u17D2\u1786\u17C1\u1791 \u1793\u17B7\u1784\u1798\u17C9\u17C4\u1784 ISO",
        date: "\u1780\u17B6\u179B\u1794\u179A\u17B7\u1785\u17D2\u1786\u17C1\u1791 ISO",
        time: "\u1798\u17C9\u17C4\u1784 ISO",
        duration: "\u179A\u1799\u17C8\u1796\u17C1\u179B ISO",
        ipv4: "\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793 IPv4",
        ipv6: "\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793 IPv6",
        cidrv4: "\u178A\u17C2\u1793\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793 IPv4",
        cidrv6: "\u178A\u17C2\u1793\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793 IPv6",
        base64: "\u1781\u17D2\u179F\u17C2\u17A2\u1780\u17D2\u179F\u179A\u17A2\u17CA\u17B7\u1780\u17BC\u178A base64",
        base64url: "\u1781\u17D2\u179F\u17C2\u17A2\u1780\u17D2\u179F\u179A\u17A2\u17CA\u17B7\u1780\u17BC\u178A base64url",
        json_string: "\u1781\u17D2\u179F\u17C2\u17A2\u1780\u17D2\u179F\u179A JSON",
        e164: "\u179B\u17C1\u1781 E.164",
        jwt: "JWT",
        template_literal: "\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799\u1794\u1789\u17D2\u1785\u17BC\u179B"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u179B\u17C1\u1781",
        array: "\u17A2\u17B6\u179A\u17C1 (Array)",
        null: "\u1782\u17D2\u1798\u17B6\u1793\u178F\u1798\u17D2\u179B\u17C3 (null)"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{1791}\u{17B7}\u{1793}\u{17D2}\u{1793}\u{1793}\u{17D0}\u{1799}\u{1794}\u{1789}\u{17D2}\u{1785}\u{17BC}\u{179B}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1780}\u{17B6}\u{179A} instanceof ${issue.expected} \u{1794}\u{17C9}\u{17BB}\u{1793}\u{17D2}\u{178F}\u{17C2}\u{1791}\u{1791}\u{17BD}\u{179B}\u{1794}\u{17B6}\u{1793} ${received}`;
                    return `\u{1791}\u{17B7}\u{1793}\u{17D2}\u{1793}\u{1793}\u{17D0}\u{1799}\u{1794}\u{1789}\u{17D2}\u{1785}\u{17BC}\u{179B}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1780}\u{17B6}\u{179A} ${expected} \u{1794}\u{17C9}\u{17BB}\u{1793}\u{17D2}\u{178F}\u{17C2}\u{1791}\u{1791}\u{17BD}\u{179B}\u{1794}\u{17B6}\u{1793} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{1791}\u{17B7}\u{1793}\u{17D2}\u{1793}\u{1793}\u{17D0}\u{1799}\u{1794}\u{1789}\u{17D2}\u{1785}\u{17BC}\u{179B}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1780}\u{17B6}\u{179A} ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `\u{1787}\u{1798}\u{17D2}\u{179A}\u{17BE}\u{179F}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1787}\u{17B6}\u{1798}\u{17BD}\u{1799}\u{1780}\u{17D2}\u{1793}\u{17BB}\u{1784}\u{1785}\u{17C6}\u{178E}\u{17C4}\u{1798} ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{1792}\u{17C6}\u{1796}\u{17C1}\u{1780}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1780}\u{17B6}\u{179A} ${issue.origin ?? "\u178F\u1798\u17D2\u179B\u17C3"} ${adj} ${issue.maximum.toString()} ${sizing.unit ?? "\u1792\u17B6\u178F\u17BB"}`;
                    return `\u{1792}\u{17C6}\u{1796}\u{17C1}\u{1780}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1780}\u{17B6}\u{179A} ${issue.origin ?? "\u178F\u1798\u17D2\u179B\u17C3"} ${adj} ${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{178F}\u{17BC}\u{1785}\u{1796}\u{17C1}\u{1780}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1780}\u{17B6}\u{179A} ${issue.origin} ${adj} ${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{178F}\u{17BC}\u{1785}\u{1796}\u{17C1}\u{1780}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1780}\u{17B6}\u{179A} ${issue.origin} ${adj} ${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{1781}\u{17D2}\u{179F}\u{17C2}\u{17A2}\u{1780}\u{17D2}\u{179F}\u{179A}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1785}\u{17B6}\u{1794}\u{17CB}\u{1795}\u{17D2}\u{178F}\u{17BE}\u{1798}\u{178A}\u{17C4}\u{1799} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{1781}\u{17D2}\u{179F}\u{17C2}\u{17A2}\u{1780}\u{17D2}\u{179F}\u{179A}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1794}\u{1789}\u{17D2}\u{1785}\u{1794}\u{17CB}\u{178A}\u{17C4}\u{1799} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{1781}\u{17D2}\u{179F}\u{17C2}\u{17A2}\u{1780}\u{17D2}\u{179F}\u{179A}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1798}\u{17B6}\u{1793} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{1781}\u{17D2}\u{179F}\u{17C2}\u{17A2}\u{1780}\u{17D2}\u{179F}\u{179A}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{178F}\u{17C2}\u{1795}\u{17D2}\u{1782}\u{17BC}\u{1795}\u{17D2}\u{1782}\u{1784}\u{1793}\u{17B9}\u{1784}\u{1791}\u{1798}\u{17D2}\u{179A}\u{1784}\u{17CB}\u{178A}\u{17C2}\u{179B}\u{1794}\u{17B6}\u{1793}\u{1780}\u{17C6}\u{178E}\u{178F}\u{17CB} ${_issue.pattern}`;
                    return `\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{179B}\u{17C1}\u{1781}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{178F}\u{17C2}\u{1787}\u{17B6}\u{1796}\u{17A0}\u{17BB}\u{1782}\u{17BB}\u{178E}\u{1793}\u{17C3} ${issue.divisor}`;
            case "unrecognized_keys":
                return `\u{179A}\u{1780}\u{1783}\u{17BE}\u{1789}\u{179F}\u{17C4}\u{1798}\u{17B7}\u{1793}\u{179F}\u{17D2}\u{1782}\u{17B6}\u{179B}\u{17CB}\u{17D6} ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{179F}\u{17C4}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1793}\u{17C5}\u{1780}\u{17D2}\u{1793}\u{17BB}\u{1784} ${issue.origin}`;
            case "invalid_union":
                return `\u{1791}\u{17B7}\u{1793}\u{17D2}\u{1793}\u{1793}\u{17D0}\u{1799}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}`;
            case "invalid_element":
                return `\u{1791}\u{17B7}\u{1793}\u{17D2}\u{1793}\u{1793}\u{17D0}\u{1799}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1793}\u{17C5}\u{1780}\u{17D2}\u{1793}\u{17BB}\u{1784} ${issue.origin}`;
            default:
                return `\u{1791}\u{17B7}\u{1793}\u{17D2}\u{1793}\u{1793}\u{17D0}\u{1799}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}`;
        }
    };
};
function $a5991a6ef1585f14$export$2e2bcd8739ae039() {
    return {
        localeError: $a5991a6ef1585f14$var$error()
    };
}


function $6996bf209397f70a$export$2e2bcd8739ae039() {
    return (0, $a5991a6ef1585f14$export$2e2bcd8739ae039)();
}




const $090d9d372ade3e3e$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\uBB38\uC790",
            verb: "to have"
        },
        file: {
            unit: "\uBC14\uC774\uD2B8",
            verb: "to have"
        },
        array: {
            unit: "\uAC1C",
            verb: "to have"
        },
        set: {
            unit: "\uAC1C",
            verb: "to have"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\uC785\uB825",
        email: "\uC774\uBA54\uC77C \uC8FC\uC18C",
        url: "URL",
        emoji: "\uC774\uBAA8\uC9C0",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \uB0A0\uC9DC\uC2DC\uAC04",
        date: "ISO \uB0A0\uC9DC",
        time: "ISO \uC2DC\uAC04",
        duration: "ISO \uAE30\uAC04",
        ipv4: "IPv4 \uC8FC\uC18C",
        ipv6: "IPv6 \uC8FC\uC18C",
        cidrv4: "IPv4 \uBC94\uC704",
        cidrv6: "IPv6 \uBC94\uC704",
        base64: "base64 \uC778\uCF54\uB529 \uBB38\uC790\uC5F4",
        base64url: "base64url \uC778\uCF54\uB529 \uBB38\uC790\uC5F4",
        json_string: "JSON \uBB38\uC790\uC5F4",
        e164: "E.164 \uBC88\uD638",
        jwt: "JWT",
        template_literal: "\uC785\uB825"
    };
    const TypeDictionary = {
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{C798}\u{BABB}\u{B41C} \u{C785}\u{B825}: \u{C608}\u{C0C1} \u{D0C0}\u{C785}\u{C740} instanceof ${issue.expected}, \u{BC1B}\u{C740} \u{D0C0}\u{C785}\u{C740} ${received}\u{C785}\u{B2C8}\u{B2E4}`;
                    return `\u{C798}\u{BABB}\u{B41C} \u{C785}\u{B825}: \u{C608}\u{C0C1} \u{D0C0}\u{C785}\u{C740} ${expected}, \u{BC1B}\u{C740} \u{D0C0}\u{C785}\u{C740} ${received}\u{C785}\u{B2C8}\u{B2E4}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{C798}\u{BABB}\u{B41C} \u{C785}\u{B825}: \u{AC12}\u{C740} ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])} \u{C774}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
                return `\u{C798}\u{BABB}\u{B41C} \u{C635}\u{C158}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "\uB610\uB294 ")} \u{C911} \u{D558}\u{B098}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "\uC774\uD558" : "\uBBF8\uB9CC";
                    const suffix = adj === "\uBBF8\uB9CC" ? "\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4" : "\uC5EC\uC57C \uD569\uB2C8\uB2E4";
                    const sizing = getSizing(issue.origin);
                    const unit = sizing?.unit ?? "\uC694\uC18C";
                    if (sizing) return `${issue.origin ?? "\uAC12"}\u{C774} \u{B108}\u{BB34} \u{D07D}\u{B2C8}\u{B2E4}: ${issue.maximum.toString()}${unit} ${adj}${suffix}`;
                    return `${issue.origin ?? "\uAC12"}\u{C774} \u{B108}\u{BB34} \u{D07D}\u{B2C8}\u{B2E4}: ${issue.maximum.toString()} ${adj}${suffix}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? "\uC774\uC0C1" : "\uCD08\uACFC";
                    const suffix = adj === "\uC774\uC0C1" ? "\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4" : "\uC5EC\uC57C \uD569\uB2C8\uB2E4";
                    const sizing = getSizing(issue.origin);
                    const unit = sizing?.unit ?? "\uC694\uC18C";
                    if (sizing) return `${issue.origin ?? "\uAC12"}\u{C774} \u{B108}\u{BB34} \u{C791}\u{C2B5}\u{B2C8}\u{B2E4}: ${issue.minimum.toString()}${unit} ${adj}${suffix}`;
                    return `${issue.origin ?? "\uAC12"}\u{C774} \u{B108}\u{BB34} \u{C791}\u{C2B5}\u{B2C8}\u{B2E4}: ${issue.minimum.toString()} ${adj}${suffix}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{C798}\u{BABB}\u{B41C} \u{BB38}\u{C790}\u{C5F4}: "${_issue.prefix}"(\u{C73C})\u{B85C} \u{C2DC}\u{C791}\u{D574}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
                    if (_issue.format === "ends_with") return `\u{C798}\u{BABB}\u{B41C} \u{BB38}\u{C790}\u{C5F4}: "${_issue.suffix}"(\u{C73C})\u{B85C} \u{B05D}\u{B098}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
                    if (_issue.format === "includes") return `\u{C798}\u{BABB}\u{B41C} \u{BB38}\u{C790}\u{C5F4}: "${_issue.includes}"\u{C744}(\u{B97C}) \u{D3EC}\u{D568}\u{D574}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
                    if (_issue.format === "regex") return `\u{C798}\u{BABB}\u{B41C} \u{BB38}\u{C790}\u{C5F4}: \u{C815}\u{ADDC}\u{C2DD} ${_issue.pattern} \u{D328}\u{D134}\u{ACFC} \u{C77C}\u{CE58}\u{D574}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
                    return `\u{C798}\u{BABB}\u{B41C} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{C798}\u{BABB}\u{B41C} \u{C22B}\u{C790}: ${issue.divisor}\u{C758} \u{BC30}\u{C218}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
            case "unrecognized_keys":
                return `\u{C778}\u{C2DD}\u{D560} \u{C218} \u{C5C6}\u{B294} \u{D0A4}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{C798}\u{BABB}\u{B41C} \u{D0A4}: ${issue.origin}`;
            case "invalid_union":
                return `\u{C798}\u{BABB}\u{B41C} \u{C785}\u{B825}`;
            case "invalid_element":
                return `\u{C798}\u{BABB}\u{B41C} \u{AC12}: ${issue.origin}`;
            default:
                return `\u{C798}\u{BABB}\u{B41C} \u{C785}\u{B825}`;
        }
    };
};
function $090d9d372ade3e3e$export$2e2bcd8739ae039() {
    return {
        localeError: $090d9d372ade3e3e$var$error()
    };
}



const $161bb373fc4961fb$var$capitalizeFirstCharacter = (text)=>{
    return text.charAt(0).toUpperCase() + text.slice(1);
};
function $161bb373fc4961fb$var$getUnitTypeFromNumber(number) {
    const abs = Math.abs(number);
    const last = abs % 10;
    const last2 = abs % 100;
    if (last2 >= 11 && last2 <= 19 || last === 0) return "many";
    if (last === 1) return "one";
    return "few";
}
const $161bb373fc4961fb$var$error = ()=>{
    const Sizable = {
        string: {
            unit: {
                one: "simbolis",
                few: "simboliai",
                many: "simboli\u0173"
            },
            verb: {
                smaller: {
                    inclusive: "turi b\u016Bti ne ilgesn\u0117 kaip",
                    notInclusive: "turi b\u016Bti trumpesn\u0117 kaip"
                },
                bigger: {
                    inclusive: "turi b\u016Bti ne trumpesn\u0117 kaip",
                    notInclusive: "turi b\u016Bti ilgesn\u0117 kaip"
                }
            }
        },
        file: {
            unit: {
                one: "baitas",
                few: "baitai",
                many: "bait\u0173"
            },
            verb: {
                smaller: {
                    inclusive: "turi b\u016Bti ne didesnis kaip",
                    notInclusive: "turi b\u016Bti ma\u017Eesnis kaip"
                },
                bigger: {
                    inclusive: "turi b\u016Bti ne ma\u017Eesnis kaip",
                    notInclusive: "turi b\u016Bti didesnis kaip"
                }
            }
        },
        array: {
            unit: {
                one: "element\u0105",
                few: "elementus",
                many: "element\u0173"
            },
            verb: {
                smaller: {
                    inclusive: "turi tur\u0117ti ne daugiau kaip",
                    notInclusive: "turi tur\u0117ti ma\u017Eiau kaip"
                },
                bigger: {
                    inclusive: "turi tur\u0117ti ne ma\u017Eiau kaip",
                    notInclusive: "turi tur\u0117ti daugiau kaip"
                }
            }
        },
        set: {
            unit: {
                one: "element\u0105",
                few: "elementus",
                many: "element\u0173"
            },
            verb: {
                smaller: {
                    inclusive: "turi tur\u0117ti ne daugiau kaip",
                    notInclusive: "turi tur\u0117ti ma\u017Eiau kaip"
                },
                bigger: {
                    inclusive: "turi tur\u0117ti ne ma\u017Eiau kaip",
                    notInclusive: "turi tur\u0117ti daugiau kaip"
                }
            }
        }
    };
    function getSizing(origin, unitType, inclusive, targetShouldBe) {
        const result = Sizable[origin] ?? null;
        if (result === null) return result;
        return {
            unit: result.unit[unitType],
            verb: result.verb[targetShouldBe][inclusive ? "inclusive" : "notInclusive"]
        };
    }
    const FormatDictionary = {
        regex: "\u012Fvestis",
        email: "el. pa\u0161to adresas",
        url: "URL",
        emoji: "jaustukas",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO data ir laikas",
        date: "ISO data",
        time: "ISO laikas",
        duration: "ISO trukm\u0117",
        ipv4: "IPv4 adresas",
        ipv6: "IPv6 adresas",
        cidrv4: "IPv4 tinklo prefiksas (CIDR)",
        cidrv6: "IPv6 tinklo prefiksas (CIDR)",
        base64: "base64 u\u017Ekoduota eilut\u0117",
        base64url: "base64url u\u017Ekoduota eilut\u0117",
        json_string: "JSON eilut\u0117",
        e164: "E.164 numeris",
        jwt: "JWT",
        template_literal: "\u012Fvestis"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "skai\u010Dius",
        bigint: "sveikasis skai\u010Dius",
        string: "eilut\u0117",
        boolean: "login\u0117 reik\u0161m\u0117",
        undefined: "neapibr\u0117\u017Eta reik\u0161m\u0117",
        function: "funkcija",
        symbol: "simbolis",
        array: "masyvas",
        object: "objektas",
        null: "nulin\u0117 reik\u0161m\u0117"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Gautas tipas ${received}, o tik\u{117}tasi - instanceof ${issue.expected}`;
                    return `Gautas tipas ${received}, o tik\u{117}tasi - ${expected}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Privalo b\u{16B}ti ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Privalo b\u{16B}ti vienas i\u{161} ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")} pasirinkim\u{173}`;
            case "too_big":
                {
                    const origin = TypeDictionary[issue.origin] ?? issue.origin;
                    const sizing = getSizing(issue.origin, $161bb373fc4961fb$var$getUnitTypeFromNumber(Number(issue.maximum)), issue.inclusive ?? false, "smaller");
                    if (sizing?.verb) return `${$161bb373fc4961fb$var$capitalizeFirstCharacter(origin ?? issue.origin ?? "reik\u0161m\u0117")} ${sizing.verb} ${issue.maximum.toString()} ${sizing.unit ?? "element\u0173"}`;
                    const adj = issue.inclusive ? "ne didesnis kaip" : "ma\u017Eesnis kaip";
                    return `${$161bb373fc4961fb$var$capitalizeFirstCharacter(origin ?? issue.origin ?? "reik\u0161m\u0117")} turi b\u{16B}ti ${adj} ${issue.maximum.toString()} ${sizing?.unit}`;
                }
            case "too_small":
                {
                    const origin = TypeDictionary[issue.origin] ?? issue.origin;
                    const sizing = getSizing(issue.origin, $161bb373fc4961fb$var$getUnitTypeFromNumber(Number(issue.minimum)), issue.inclusive ?? false, "bigger");
                    if (sizing?.verb) return `${$161bb373fc4961fb$var$capitalizeFirstCharacter(origin ?? issue.origin ?? "reik\u0161m\u0117")} ${sizing.verb} ${issue.minimum.toString()} ${sizing.unit ?? "element\u0173"}`;
                    const adj = issue.inclusive ? "ne ma\u017Eesnis kaip" : "didesnis kaip";
                    return `${$161bb373fc4961fb$var$capitalizeFirstCharacter(origin ?? issue.origin ?? "reik\u0161m\u0117")} turi b\u{16B}ti ${adj} ${issue.minimum.toString()} ${sizing?.unit}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Eilut\u{117} privalo prasid\u{117}ti "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Eilut\u{117} privalo pasibaigti "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Eilut\u{117} privalo \u{12F}traukti "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Eilut\u{117} privalo atitikti ${_issue.pattern}`;
                    return `Neteisingas ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Skai\u{10D}ius privalo b\u{16B}ti ${issue.divisor} kartotinis.`;
            case "unrecognized_keys":
                return `Neatpa\u{17E}int${issue.keys.length > 1 ? "i" : "as"} rakt${issue.keys.length > 1 ? "ai" : "as"}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return "Rastas klaidingas raktas";
            case "invalid_union":
                return "Klaidinga \u012Fvestis";
            case "invalid_element":
                {
                    const origin = TypeDictionary[issue.origin] ?? issue.origin;
                    return `${$161bb373fc4961fb$var$capitalizeFirstCharacter(origin ?? issue.origin ?? "reik\u0161m\u0117")} turi klaiding\u{105} \u{12F}vest\u{12F}`;
                }
            default:
                return "Klaidinga \u012Fvestis";
        }
    };
};
function $161bb373fc4961fb$export$2e2bcd8739ae039() {
    return {
        localeError: $161bb373fc4961fb$var$error()
    };
}



const $fe11a6509c670361$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u0437\u043D\u0430\u0446\u0438",
            verb: "\u0434\u0430 \u0438\u043C\u0430\u0430\u0442"
        },
        file: {
            unit: "\u0431\u0430\u0458\u0442\u0438",
            verb: "\u0434\u0430 \u0438\u043C\u0430\u0430\u0442"
        },
        array: {
            unit: "\u0441\u0442\u0430\u0432\u043A\u0438",
            verb: "\u0434\u0430 \u0438\u043C\u0430\u0430\u0442"
        },
        set: {
            unit: "\u0441\u0442\u0430\u0432\u043A\u0438",
            verb: "\u0434\u0430 \u0438\u043C\u0430\u0430\u0442"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0432\u043D\u0435\u0441",
        email: "\u0430\u0434\u0440\u0435\u0441\u0430 \u043D\u0430 \u0435-\u043F\u043E\u0448\u0442\u0430",
        url: "URL",
        emoji: "\u0435\u043C\u043E\u045F\u0438",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u0434\u0430\u0442\u0443\u043C \u0438 \u0432\u0440\u0435\u043C\u0435",
        date: "ISO \u0434\u0430\u0442\u0443\u043C",
        time: "ISO \u0432\u0440\u0435\u043C\u0435",
        duration: "ISO \u0432\u0440\u0435\u043C\u0435\u0442\u0440\u0430\u0435\u045A\u0435",
        ipv4: "IPv4 \u0430\u0434\u0440\u0435\u0441\u0430",
        ipv6: "IPv6 \u0430\u0434\u0440\u0435\u0441\u0430",
        cidrv4: "IPv4 \u043E\u043F\u0441\u0435\u0433",
        cidrv6: "IPv6 \u043E\u043F\u0441\u0435\u0433",
        base64: "base64-\u0435\u043D\u043A\u043E\u0434\u0438\u0440\u0430\u043D\u0430 \u043D\u0438\u0437\u0430",
        base64url: "base64url-\u0435\u043D\u043A\u043E\u0434\u0438\u0440\u0430\u043D\u0430 \u043D\u0438\u0437\u0430",
        json_string: "JSON \u043D\u0438\u0437\u0430",
        e164: "E.164 \u0431\u0440\u043E\u0458",
        jwt: "JWT",
        template_literal: "\u0432\u043D\u0435\u0441"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0431\u0440\u043E\u0458",
        array: "\u043D\u0438\u0437\u0430"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{413}\u{440}\u{435}\u{448}\u{435}\u{43D} \u{432}\u{43D}\u{435}\u{441}: \u{441}\u{435} \u{43E}\u{447}\u{435}\u{43A}\u{443}\u{432}\u{430} instanceof ${issue.expected}, \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{43E} ${received}`;
                    return `\u{413}\u{440}\u{435}\u{448}\u{435}\u{43D} \u{432}\u{43D}\u{435}\u{441}: \u{441}\u{435} \u{43E}\u{447}\u{435}\u{43A}\u{443}\u{432}\u{430} ${expected}, \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{43E} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Invalid input: expected ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `\u{413}\u{440}\u{435}\u{448}\u{430}\u{43D}\u{430} \u{43E}\u{43F}\u{446}\u{438}\u{458}\u{430}: \u{441}\u{435} \u{43E}\u{447}\u{435}\u{43A}\u{443}\u{432}\u{430} \u{435}\u{434}\u{43D}\u{430} ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{41F}\u{440}\u{435}\u{43C}\u{43D}\u{43E}\u{433}\u{443} \u{433}\u{43E}\u{43B}\u{435}\u{43C}: \u{441}\u{435} \u{43E}\u{447}\u{435}\u{43A}\u{443}\u{432}\u{430} ${issue.origin ?? "\u0432\u0440\u0435\u0434\u043D\u043E\u0441\u0442\u0430"} \u{434}\u{430} \u{438}\u{43C}\u{430} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438"}`;
                    return `\u{41F}\u{440}\u{435}\u{43C}\u{43D}\u{43E}\u{433}\u{443} \u{433}\u{43E}\u{43B}\u{435}\u{43C}: \u{441}\u{435} \u{43E}\u{447}\u{435}\u{43A}\u{443}\u{432}\u{430} ${issue.origin ?? "\u0432\u0440\u0435\u0434\u043D\u043E\u0441\u0442\u0430"} \u{434}\u{430} \u{431}\u{438}\u{434}\u{435} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{41F}\u{440}\u{435}\u{43C}\u{43D}\u{43E}\u{433}\u{443} \u{43C}\u{430}\u{43B}: \u{441}\u{435} \u{43E}\u{447}\u{435}\u{43A}\u{443}\u{432}\u{430} ${issue.origin} \u{434}\u{430} \u{438}\u{43C}\u{430} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{41F}\u{440}\u{435}\u{43C}\u{43D}\u{43E}\u{433}\u{443} \u{43C}\u{430}\u{43B}: \u{441}\u{435} \u{43E}\u{447}\u{435}\u{43A}\u{443}\u{432}\u{430} ${issue.origin} \u{434}\u{430} \u{431}\u{438}\u{434}\u{435} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{41D}\u{435}\u{432}\u{430}\u{436}\u{435}\u{447}\u{43A}\u{430} \u{43D}\u{438}\u{437}\u{430}: \u{43C}\u{43E}\u{440}\u{430} \u{434}\u{430} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{443}\u{432}\u{430} \u{441}\u{43E} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{41D}\u{435}\u{432}\u{430}\u{436}\u{435}\u{447}\u{43A}\u{430} \u{43D}\u{438}\u{437}\u{430}: \u{43C}\u{43E}\u{440}\u{430} \u{434}\u{430} \u{437}\u{430}\u{432}\u{440}\u{448}\u{443}\u{432}\u{430} \u{441}\u{43E} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{41D}\u{435}\u{432}\u{430}\u{436}\u{435}\u{447}\u{43A}\u{430} \u{43D}\u{438}\u{437}\u{430}: \u{43C}\u{43E}\u{440}\u{430} \u{434}\u{430} \u{432}\u{43A}\u{43B}\u{443}\u{447}\u{443}\u{432}\u{430} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{41D}\u{435}\u{432}\u{430}\u{436}\u{435}\u{447}\u{43A}\u{430} \u{43D}\u{438}\u{437}\u{430}: \u{43C}\u{43E}\u{440}\u{430} \u{434}\u{430} \u{43E}\u{434}\u{433}\u{43E}\u{430}\u{440}\u{430} \u{43D}\u{430} \u{43F}\u{430}\u{442}\u{435}\u{440}\u{43D}\u{43E}\u{442} ${_issue.pattern}`;
                    return `Invalid ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{413}\u{440}\u{435}\u{448}\u{435}\u{43D} \u{431}\u{440}\u{43E}\u{458}: \u{43C}\u{43E}\u{440}\u{430} \u{434}\u{430} \u{431}\u{438}\u{434}\u{435} \u{434}\u{435}\u{43B}\u{438}\u{432} \u{441}\u{43E} ${issue.divisor}`;
            case "unrecognized_keys":
                return `${issue.keys.length > 1 ? "\u041D\u0435\u043F\u0440\u0435\u043F\u043E\u0437\u043D\u0430\u0435\u043D\u0438 \u043A\u043B\u0443\u0447\u0435\u0432\u0438" : "\u041D\u0435\u043F\u0440\u0435\u043F\u043E\u0437\u043D\u0430\u0435\u043D \u043A\u043B\u0443\u0447"}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{413}\u{440}\u{435}\u{448}\u{435}\u{43D} \u{43A}\u{43B}\u{443}\u{447} \u{432}\u{43E} ${issue.origin}`;
            case "invalid_union":
                return "\u0413\u0440\u0435\u0448\u0435\u043D \u0432\u043D\u0435\u0441";
            case "invalid_element":
                return `\u{413}\u{440}\u{435}\u{448}\u{43D}\u{430} \u{432}\u{440}\u{435}\u{434}\u{43D}\u{43E}\u{441}\u{442} \u{432}\u{43E} ${issue.origin}`;
            default:
                return `\u{413}\u{440}\u{435}\u{448}\u{435}\u{43D} \u{432}\u{43D}\u{435}\u{441}`;
        }
    };
};
function $fe11a6509c670361$export$2e2bcd8739ae039() {
    return {
        localeError: $fe11a6509c670361$var$error()
    };
}



const $eb88d5b95f864ccd$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "aksara",
            verb: "mempunyai"
        },
        file: {
            unit: "bait",
            verb: "mempunyai"
        },
        array: {
            unit: "elemen",
            verb: "mempunyai"
        },
        set: {
            unit: "elemen",
            verb: "mempunyai"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "input",
        email: "alamat e-mel",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "tarikh masa ISO",
        date: "tarikh ISO",
        time: "masa ISO",
        duration: "tempoh ISO",
        ipv4: "alamat IPv4",
        ipv6: "alamat IPv6",
        cidrv4: "julat IPv4",
        cidrv6: "julat IPv6",
        base64: "string dikodkan base64",
        base64url: "string dikodkan base64url",
        json_string: "string JSON",
        e164: "nombor E.164",
        jwt: "JWT",
        template_literal: "input"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "nombor"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Input tidak sah: dijangka instanceof ${issue.expected}, diterima ${received}`;
                    return `Input tidak sah: dijangka ${expected}, diterima ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Input tidak sah: dijangka ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Pilihan tidak sah: dijangka salah satu daripada ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Terlalu besar: dijangka ${issue.origin ?? "nilai"} ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elemen"}`;
                    return `Terlalu besar: dijangka ${issue.origin ?? "nilai"} adalah ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Terlalu kecil: dijangka ${issue.origin} ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Terlalu kecil: dijangka ${issue.origin} adalah ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `String tidak sah: mesti bermula dengan "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `String tidak sah: mesti berakhir dengan "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `String tidak sah: mesti mengandungi "${_issue.includes}"`;
                    if (_issue.format === "regex") return `String tidak sah: mesti sepadan dengan corak ${_issue.pattern}`;
                    return `${FormatDictionary[_issue.format] ?? issue.format} tidak sah`;
                }
            case "not_multiple_of":
                return `Nombor tidak sah: perlu gandaan ${issue.divisor}`;
            case "unrecognized_keys":
                return `Kunci tidak dikenali: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Kunci tidak sah dalam ${issue.origin}`;
            case "invalid_union":
                return "Input tidak sah";
            case "invalid_element":
                return `Nilai tidak sah dalam ${issue.origin}`;
            default:
                return `Input tidak sah`;
        }
    };
};
function $eb88d5b95f864ccd$export$2e2bcd8739ae039() {
    return {
        localeError: $eb88d5b95f864ccd$var$error()
    };
}



const $56ca3b1a064b08b0$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "tekens",
            verb: "heeft"
        },
        file: {
            unit: "bytes",
            verb: "heeft"
        },
        array: {
            unit: "elementen",
            verb: "heeft"
        },
        set: {
            unit: "elementen",
            verb: "heeft"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "invoer",
        email: "emailadres",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datum en tijd",
        date: "ISO datum",
        time: "ISO tijd",
        duration: "ISO duur",
        ipv4: "IPv4-adres",
        ipv6: "IPv6-adres",
        cidrv4: "IPv4-bereik",
        cidrv6: "IPv6-bereik",
        base64: "base64-gecodeerde tekst",
        base64url: "base64 URL-gecodeerde tekst",
        json_string: "JSON string",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "invoer"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "getal"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Ongeldige invoer: verwacht instanceof ${issue.expected}, ontving ${received}`;
                    return `Ongeldige invoer: verwacht ${expected}, ontving ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Ongeldige invoer: verwacht ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Ongeldige optie: verwacht \xe9\xe9n van ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    const longName = issue.origin === "date" ? "laat" : issue.origin === "string" ? "lang" : "groot";
                    if (sizing) return `Te ${longName}: verwacht dat ${issue.origin ?? "waarde"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementen"} ${sizing.verb}`;
                    return `Te ${longName}: verwacht dat ${issue.origin ?? "waarde"} ${adj}${issue.maximum.toString()} is`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    const shortName = issue.origin === "date" ? "vroeg" : issue.origin === "string" ? "kort" : "klein";
                    if (sizing) return `Te ${shortName}: verwacht dat ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit} ${sizing.verb}`;
                    return `Te ${shortName}: verwacht dat ${issue.origin} ${adj}${issue.minimum.toString()} is`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Ongeldige tekst: moet met "${_issue.prefix}" beginnen`;
                    if (_issue.format === "ends_with") return `Ongeldige tekst: moet op "${_issue.suffix}" eindigen`;
                    if (_issue.format === "includes") return `Ongeldige tekst: moet "${_issue.includes}" bevatten`;
                    if (_issue.format === "regex") return `Ongeldige tekst: moet overeenkomen met patroon ${_issue.pattern}`;
                    return `Ongeldig: ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Ongeldig getal: moet een veelvoud van ${issue.divisor} zijn`;
            case "unrecognized_keys":
                return `Onbekende key${issue.keys.length > 1 ? "s" : ""}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Ongeldige key in ${issue.origin}`;
            case "invalid_union":
                return "Ongeldige invoer";
            case "invalid_element":
                return `Ongeldige waarde in ${issue.origin}`;
            default:
                return `Ongeldige invoer`;
        }
    };
};
function $56ca3b1a064b08b0$export$2e2bcd8739ae039() {
    return {
        localeError: $56ca3b1a064b08b0$var$error()
    };
}



const $7cc985f38a53903b$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "tegn",
            verb: "\xe5 ha"
        },
        file: {
            unit: "bytes",
            verb: "\xe5 ha"
        },
        array: {
            unit: "elementer",
            verb: "\xe5 inneholde"
        },
        set: {
            unit: "elementer",
            verb: "\xe5 inneholde"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "input",
        email: "e-postadresse",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO dato- og klokkeslett",
        date: "ISO-dato",
        time: "ISO-klokkeslett",
        duration: "ISO-varighet",
        ipv4: "IPv4-omr\xe5de",
        ipv6: "IPv6-omr\xe5de",
        cidrv4: "IPv4-spekter",
        cidrv6: "IPv6-spekter",
        base64: "base64-enkodet streng",
        base64url: "base64url-enkodet streng",
        json_string: "JSON-streng",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "input"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "tall",
        array: "liste"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Ugyldig input: forventet instanceof ${issue.expected}, fikk ${received}`;
                    return `Ugyldig input: forventet ${expected}, fikk ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Ugyldig verdi: forventet ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Ugyldig valg: forventet en av ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `For stor(t): forventet ${issue.origin ?? "value"} til \xe5 ha ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementer"}`;
                    return `For stor(t): forventet ${issue.origin ?? "value"} til \xe5 ha ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `For lite(n): forventet ${issue.origin} til \xe5 ha ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `For lite(n): forventet ${issue.origin} til \xe5 ha ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Ugyldig streng: m\xe5 starte med "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Ugyldig streng: m\xe5 ende med "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Ugyldig streng: m\xe5 inneholde "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Ugyldig streng: m\xe5 matche m\xf8nsteret ${_issue.pattern}`;
                    return `Ugyldig ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Ugyldig tall: m\xe5 v\xe6re et multiplum av ${issue.divisor}`;
            case "unrecognized_keys":
                return `${issue.keys.length > 1 ? "Ukjente n\xf8kler" : "Ukjent n\xf8kkel"}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Ugyldig n\xf8kkel i ${issue.origin}`;
            case "invalid_union":
                return "Ugyldig input";
            case "invalid_element":
                return `Ugyldig verdi i ${issue.origin}`;
            default:
                return `Ugyldig input`;
        }
    };
};
function $7cc985f38a53903b$export$2e2bcd8739ae039() {
    return {
        localeError: $7cc985f38a53903b$var$error()
    };
}



const $eb686398d06bd461$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "harf",
            verb: "olmal\u0131d\u0131r"
        },
        file: {
            unit: "bayt",
            verb: "olmal\u0131d\u0131r"
        },
        array: {
            unit: "unsur",
            verb: "olmal\u0131d\u0131r"
        },
        set: {
            unit: "unsur",
            verb: "olmal\u0131d\u0131r"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "giren",
        email: "epostag\xe2h",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO heng\xe2m\u0131",
        date: "ISO tarihi",
        time: "ISO zaman\u0131",
        duration: "ISO m\xfcddeti",
        ipv4: "IPv4 ni\u015F\xe2n\u0131",
        ipv6: "IPv6 ni\u015F\xe2n\u0131",
        cidrv4: "IPv4 menzili",
        cidrv6: "IPv6 menzili",
        base64: "base64-\u015Fifreli metin",
        base64url: "base64url-\u015Fifreli metin",
        json_string: "JSON metin",
        e164: "E.164 say\u0131s\u0131",
        jwt: "JWT",
        template_literal: "giren"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "numara",
        array: "saf",
        null: "gayb"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `F\xe2sit giren: umulan instanceof ${issue.expected}, al\u{131}nan ${received}`;
                    return `F\xe2sit giren: umulan ${expected}, al\u{131}nan ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `F\xe2sit giren: umulan ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `F\xe2sit tercih: m\xfbteberler ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Fazla b\xfcy\xfck: ${issue.origin ?? "value"}, ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elements"} sahip olmal\u{131}yd\u{131}.`;
                    return `Fazla b\xfcy\xfck: ${issue.origin ?? "value"}, ${adj}${issue.maximum.toString()} olmal\u{131}yd\u{131}.`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Fazla k\xfc\xe7\xfck: ${issue.origin}, ${adj}${issue.minimum.toString()} ${sizing.unit} sahip olmal\u{131}yd\u{131}.`;
                    return `Fazla k\xfc\xe7\xfck: ${issue.origin}, ${adj}${issue.minimum.toString()} olmal\u{131}yd\u{131}.`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `F\xe2sit metin: "${_issue.prefix}" ile ba\u{15F}lamal\u{131}.`;
                    if (_issue.format === "ends_with") return `F\xe2sit metin: "${_issue.suffix}" ile bitmeli.`;
                    if (_issue.format === "includes") return `F\xe2sit metin: "${_issue.includes}" ihtiv\xe2 etmeli.`;
                    if (_issue.format === "regex") return `F\xe2sit metin: ${_issue.pattern} nak\u{15F}\u{131}na uymal\u{131}.`;
                    return `F\xe2sit ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `F\xe2sit say\u{131}: ${issue.divisor} kat\u{131} olmal\u{131}yd\u{131}.`;
            case "unrecognized_keys":
                return `Tan\u{131}nmayan anahtar ${issue.keys.length > 1 ? "s" : ""}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `${issue.origin} i\xe7in tan\u{131}nmayan anahtar var.`;
            case "invalid_union":
                return "Giren tan\u0131namad\u0131.";
            case "invalid_element":
                return `${issue.origin} i\xe7in tan\u{131}nmayan k\u{131}ymet var.`;
            default:
                return `K\u{131}ymet tan\u{131}namad\u{131}.`;
        }
    };
};
function $eb686398d06bd461$export$2e2bcd8739ae039() {
    return {
        localeError: $eb686398d06bd461$var$error()
    };
}



const $30b636c0ba0118e9$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u062A\u0648\u06A9\u064A",
            verb: "\u0648\u0644\u0631\u064A"
        },
        file: {
            unit: "\u0628\u0627\u06CC\u067C\u0633",
            verb: "\u0648\u0644\u0631\u064A"
        },
        array: {
            unit: "\u062A\u0648\u06A9\u064A",
            verb: "\u0648\u0644\u0631\u064A"
        },
        set: {
            unit: "\u062A\u0648\u06A9\u064A",
            verb: "\u0648\u0644\u0631\u064A"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0648\u0631\u0648\u062F\u064A",
        email: "\u0628\u0631\u06CC\u069A\u0646\u0627\u0644\u06CC\u06A9",
        url: "\u06CC\u0648 \u0622\u0631 \u0627\u0644",
        emoji: "\u0627\u06CC\u0645\u0648\u062C\u064A",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u0646\u06CC\u067C\u0647 \u0627\u0648 \u0648\u062E\u062A",
        date: "\u0646\u06D0\u067C\u0647",
        time: "\u0648\u062E\u062A",
        duration: "\u0645\u0648\u062F\u0647",
        ipv4: "\u062F IPv4 \u067E\u062A\u0647",
        ipv6: "\u062F IPv6 \u067E\u062A\u0647",
        cidrv4: "\u062F IPv4 \u0633\u0627\u062D\u0647",
        cidrv6: "\u062F IPv6 \u0633\u0627\u062D\u0647",
        base64: "base64-encoded \u0645\u062A\u0646",
        base64url: "base64url-encoded \u0645\u062A\u0646",
        json_string: "JSON \u0645\u062A\u0646",
        e164: "\u062F E.164 \u0634\u0645\u06D0\u0631\u0647",
        jwt: "JWT",
        template_literal: "\u0648\u0631\u0648\u062F\u064A"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0639\u062F\u062F",
        array: "\u0627\u0631\u06D0"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{646}\u{627}\u{633}\u{645} \u{648}\u{631}\u{648}\u{62F}\u{64A}: \u{628}\u{627}\u{6CC}\u{62F} instanceof ${issue.expected} \u{648}\u{627}\u{6CC}, \u{645}\u{6AB}\u{631} ${received} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{634}\u{648}`;
                    return `\u{646}\u{627}\u{633}\u{645} \u{648}\u{631}\u{648}\u{62F}\u{64A}: \u{628}\u{627}\u{6CC}\u{62F} ${expected} \u{648}\u{627}\u{6CC}, \u{645}\u{6AB}\u{631} ${received} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{634}\u{648}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{646}\u{627}\u{633}\u{645} \u{648}\u{631}\u{648}\u{62F}\u{64A}: \u{628}\u{627}\u{6CC}\u{62F} ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])} \u{648}\u{627}\u{6CC}`;
                return `\u{646}\u{627}\u{633}\u{645} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628}: \u{628}\u{627}\u{6CC}\u{62F} \u{6CC}\u{648} \u{644}\u{647} ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")} \u{685}\u{62E}\u{647} \u{648}\u{627}\u{6CC}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{689}\u{6CC}\u{631} \u{644}\u{648}\u{6CC}: ${issue.origin ?? "\u0627\u0631\u0632\u069A\u062A"} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0639\u0646\u0635\u0631\u0648\u0646\u0647"} \u{648}\u{644}\u{631}\u{64A}`;
                    return `\u{689}\u{6CC}\u{631} \u{644}\u{648}\u{6CC}: ${issue.origin ?? "\u0627\u0631\u0632\u069A\u062A"} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.maximum.toString()} \u{648}\u{64A}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{689}\u{6CC}\u{631} \u{6A9}\u{648}\u{686}\u{646}\u{6CC}: ${issue.origin} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.minimum.toString()} ${sizing.unit} \u{648}\u{644}\u{631}\u{64A}`;
                    return `\u{689}\u{6CC}\u{631} \u{6A9}\u{648}\u{686}\u{646}\u{6CC}: ${issue.origin} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.minimum.toString()} \u{648}\u{64A}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{646}\u{627}\u{633}\u{645} \u{645}\u{62A}\u{646}: \u{628}\u{627}\u{6CC}\u{62F} \u{62F} "${_issue.prefix}" \u{633}\u{631}\u{647} \u{67E}\u{6CC}\u{644} \u{634}\u{64A}`;
                    if (_issue.format === "ends_with") return `\u{646}\u{627}\u{633}\u{645} \u{645}\u{62A}\u{646}: \u{628}\u{627}\u{6CC}\u{62F} \u{62F} "${_issue.suffix}" \u{633}\u{631}\u{647} \u{67E}\u{627}\u{6CC} \u{62A}\u{647} \u{648}\u{631}\u{633}\u{64A}\u{696}\u{64A}`;
                    if (_issue.format === "includes") return `\u{646}\u{627}\u{633}\u{645} \u{645}\u{62A}\u{646}: \u{628}\u{627}\u{6CC}\u{62F} "${_issue.includes}" \u{648}\u{644}\u{631}\u{64A}`;
                    if (_issue.format === "regex") return `\u{646}\u{627}\u{633}\u{645} \u{645}\u{62A}\u{646}: \u{628}\u{627}\u{6CC}\u{62F} \u{62F} ${_issue.pattern} \u{633}\u{631}\u{647} \u{645}\u{637}\u{627}\u{628}\u{642}\u{62A} \u{648}\u{644}\u{631}\u{64A}`;
                    return `${FormatDictionary[_issue.format] ?? issue.format} \u{646}\u{627}\u{633}\u{645} \u{62F}\u{6CC}`;
                }
            case "not_multiple_of":
                return `\u{646}\u{627}\u{633}\u{645} \u{639}\u{62F}\u{62F}: \u{628}\u{627}\u{6CC}\u{62F} \u{62F} ${issue.divisor} \u{645}\u{636}\u{631}\u{628} \u{648}\u{64A}`;
            case "unrecognized_keys":
                return `\u{646}\u{627}\u{633}\u{645} ${issue.keys.length > 1 ? "\u06A9\u0644\u06CC\u0689\u0648\u0646\u0647" : "\u06A9\u0644\u06CC\u0689"}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{646}\u{627}\u{633}\u{645} \u{6A9}\u{644}\u{6CC}\u{689} \u{67E}\u{647} ${issue.origin} \u{6A9}\u{6D0}`;
            case "invalid_union":
                return `\u{646}\u{627}\u{633}\u{645}\u{647} \u{648}\u{631}\u{648}\u{62F}\u{64A}`;
            case "invalid_element":
                return `\u{646}\u{627}\u{633}\u{645} \u{639}\u{646}\u{635}\u{631} \u{67E}\u{647} ${issue.origin} \u{6A9}\u{6D0}`;
            default:
                return `\u{646}\u{627}\u{633}\u{645}\u{647} \u{648}\u{631}\u{648}\u{62F}\u{64A}`;
        }
    };
};
function $30b636c0ba0118e9$export$2e2bcd8739ae039() {
    return {
        localeError: $30b636c0ba0118e9$var$error()
    };
}



const $6f9c1555561b5bd7$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "znak\xf3w",
            verb: "mie\u0107"
        },
        file: {
            unit: "bajt\xf3w",
            verb: "mie\u0107"
        },
        array: {
            unit: "element\xf3w",
            verb: "mie\u0107"
        },
        set: {
            unit: "element\xf3w",
            verb: "mie\u0107"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "wyra\u017Cenie",
        email: "adres email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data i godzina w formacie ISO",
        date: "data w formacie ISO",
        time: "godzina w formacie ISO",
        duration: "czas trwania ISO",
        ipv4: "adres IPv4",
        ipv6: "adres IPv6",
        cidrv4: "zakres IPv4",
        cidrv6: "zakres IPv6",
        base64: "ci\u0105g znak\xf3w zakodowany w formacie base64",
        base64url: "ci\u0105g znak\xf3w zakodowany w formacie base64url",
        json_string: "ci\u0105g znak\xf3w w formacie JSON",
        e164: "liczba E.164",
        jwt: "JWT",
        template_literal: "wej\u015Bcie"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "liczba",
        array: "tablica"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Nieprawid\u{142}owe dane wej\u{15B}ciowe: oczekiwano instanceof ${issue.expected}, otrzymano ${received}`;
                    return `Nieprawid\u{142}owe dane wej\u{15B}ciowe: oczekiwano ${expected}, otrzymano ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Nieprawid\u{142}owe dane wej\u{15B}ciowe: oczekiwano ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Nieprawid\u{142}owa opcja: oczekiwano jednej z warto\u{15B}ci ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Za du\u{17C}a warto\u{15B}\u{107}: oczekiwano, \u{17C}e ${issue.origin ?? "warto\u015B\u0107"} b\u{119}dzie mie\u{107} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "element\xf3w"}`;
                    return `Zbyt du\u{17C}(y/a/e): oczekiwano, \u{17C}e ${issue.origin ?? "warto\u015B\u0107"} b\u{119}dzie wynosi\u{107} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Za ma\u{142}a warto\u{15B}\u{107}: oczekiwano, \u{17C}e ${issue.origin ?? "warto\u015B\u0107"} b\u{119}dzie mie\u{107} ${adj}${issue.minimum.toString()} ${sizing.unit ?? "element\xf3w"}`;
                    return `Zbyt ma\u{142}(y/a/e): oczekiwano, \u{17C}e ${issue.origin ?? "warto\u015B\u0107"} b\u{119}dzie wynosi\u{107} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Nieprawid\u{142}owy ci\u{105}g znak\xf3w: musi zaczyna\u{107} si\u{119} od "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Nieprawid\u{142}owy ci\u{105}g znak\xf3w: musi ko\u{144}czy\u{107} si\u{119} na "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Nieprawid\u{142}owy ci\u{105}g znak\xf3w: musi zawiera\u{107} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Nieprawid\u{142}owy ci\u{105}g znak\xf3w: musi odpowiada\u{107} wzorcowi ${_issue.pattern}`;
                    return `Nieprawid\u{142}ow(y/a/e) ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Nieprawid\u{142}owa liczba: musi by\u{107} wielokrotno\u{15B}ci\u{105} ${issue.divisor}`;
            case "unrecognized_keys":
                return `Nierozpoznane klucze${issue.keys.length > 1 ? "s" : ""}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Nieprawid\u{142}owy klucz w ${issue.origin}`;
            case "invalid_union":
                return "Nieprawid\u0142owe dane wej\u015Bciowe";
            case "invalid_element":
                return `Nieprawid\u{142}owa warto\u{15B}\u{107} w ${issue.origin}`;
            default:
                return `Nieprawid\u{142}owe dane wej\u{15B}ciowe`;
        }
    };
};
function $6f9c1555561b5bd7$export$2e2bcd8739ae039() {
    return {
        localeError: $6f9c1555561b5bd7$var$error()
    };
}



const $3d03302a40824a76$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "caracteres",
            verb: "ter"
        },
        file: {
            unit: "bytes",
            verb: "ter"
        },
        array: {
            unit: "itens",
            verb: "ter"
        },
        set: {
            unit: "itens",
            verb: "ter"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "padr\xe3o",
        email: "endere\xe7o de e-mail",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data e hora ISO",
        date: "data ISO",
        time: "hora ISO",
        duration: "dura\xe7\xe3o ISO",
        ipv4: "endere\xe7o IPv4",
        ipv6: "endere\xe7o IPv6",
        cidrv4: "faixa de IPv4",
        cidrv6: "faixa de IPv6",
        base64: "texto codificado em base64",
        base64url: "URL codificada em base64",
        json_string: "texto JSON",
        e164: "n\xfamero E.164",
        jwt: "JWT",
        template_literal: "entrada"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "n\xfamero",
        null: "nulo"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Tipo inv\xe1lido: esperado instanceof ${issue.expected}, recebido ${received}`;
                    return `Tipo inv\xe1lido: esperado ${expected}, recebido ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Entrada inv\xe1lida: esperado ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Op\xe7\xe3o inv\xe1lida: esperada uma das ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Muito grande: esperado que ${issue.origin ?? "valor"} tivesse ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementos"}`;
                    return `Muito grande: esperado que ${issue.origin ?? "valor"} fosse ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Muito pequeno: esperado que ${issue.origin} tivesse ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Muito pequeno: esperado que ${issue.origin} fosse ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Texto inv\xe1lido: deve come\xe7ar com "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Texto inv\xe1lido: deve terminar com "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Texto inv\xe1lido: deve incluir "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Texto inv\xe1lido: deve corresponder ao padr\xe3o ${_issue.pattern}`;
                    return `${FormatDictionary[_issue.format] ?? issue.format} inv\xe1lido`;
                }
            case "not_multiple_of":
                return `N\xfamero inv\xe1lido: deve ser m\xfaltiplo de ${issue.divisor}`;
            case "unrecognized_keys":
                return `Chave${issue.keys.length > 1 ? "s" : ""} desconhecida${issue.keys.length > 1 ? "s" : ""}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Chave inv\xe1lida em ${issue.origin}`;
            case "invalid_union":
                return "Entrada inv\xe1lida";
            case "invalid_element":
                return `Valor inv\xe1lido em ${issue.origin}`;
            default:
                return `Campo inv\xe1lido`;
        }
    };
};
function $3d03302a40824a76$export$2e2bcd8739ae039() {
    return {
        localeError: $3d03302a40824a76$var$error()
    };
}



function $f7d7eb3d44d149c8$var$getRussianPlural(count, one, few, many) {
    const absCount = Math.abs(count);
    const lastDigit = absCount % 10;
    const lastTwoDigits = absCount % 100;
    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) return many;
    if (lastDigit === 1) return one;
    if (lastDigit >= 2 && lastDigit <= 4) return few;
    return many;
}
const $f7d7eb3d44d149c8$var$error = ()=>{
    const Sizable = {
        string: {
            unit: {
                one: "\u0441\u0438\u043C\u0432\u043E\u043B",
                few: "\u0441\u0438\u043C\u0432\u043E\u043B\u0430",
                many: "\u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432"
            },
            verb: "\u0438\u043C\u0435\u0442\u044C"
        },
        file: {
            unit: {
                one: "\u0431\u0430\u0439\u0442",
                few: "\u0431\u0430\u0439\u0442\u0430",
                many: "\u0431\u0430\u0439\u0442"
            },
            verb: "\u0438\u043C\u0435\u0442\u044C"
        },
        array: {
            unit: {
                one: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442",
                few: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430",
                many: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432"
            },
            verb: "\u0438\u043C\u0435\u0442\u044C"
        },
        set: {
            unit: {
                one: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442",
                few: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430",
                many: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432"
            },
            verb: "\u0438\u043C\u0435\u0442\u044C"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0432\u0432\u043E\u0434",
        email: "email \u0430\u0434\u0440\u0435\u0441",
        url: "URL",
        emoji: "\u044D\u043C\u043E\u0434\u0437\u0438",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u0434\u0430\u0442\u0430 \u0438 \u0432\u0440\u0435\u043C\u044F",
        date: "ISO \u0434\u0430\u0442\u0430",
        time: "ISO \u0432\u0440\u0435\u043C\u044F",
        duration: "ISO \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C",
        ipv4: "IPv4 \u0430\u0434\u0440\u0435\u0441",
        ipv6: "IPv6 \u0430\u0434\u0440\u0435\u0441",
        cidrv4: "IPv4 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D",
        cidrv6: "IPv6 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D",
        base64: "\u0441\u0442\u0440\u043E\u043A\u0430 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 base64",
        base64url: "\u0441\u0442\u0440\u043E\u043A\u0430 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 base64url",
        json_string: "JSON \u0441\u0442\u0440\u043E\u043A\u0430",
        e164: "\u043D\u043E\u043C\u0435\u0440 E.164",
        jwt: "JWT",
        template_literal: "\u0432\u0432\u043E\u0434"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0447\u0438\u0441\u043B\u043E",
        array: "\u043C\u0430\u0441\u0441\u0438\u0432"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{44B}\u{439} \u{432}\u{432}\u{43E}\u{434}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C} instanceof ${issue.expected}, \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D}\u{43E} ${received}`;
                    return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{44B}\u{439} \u{432}\u{432}\u{43E}\u{434}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C} ${expected}, \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D}\u{43E} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{44B}\u{439} \u{432}\u{432}\u{43E}\u{434}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C} ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{44B}\u{439} \u{432}\u{430}\u{440}\u{438}\u{430}\u{43D}\u{442}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C} \u{43E}\u{434}\u{43D}\u{43E} \u{438}\u{437} ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) {
                        const maxValue = Number(issue.maximum);
                        const unit = $f7d7eb3d44d149c8$var$getRussianPlural(maxValue, sizing.unit.one, sizing.unit.few, sizing.unit.many);
                        return `\u{421}\u{43B}\u{438}\u{448}\u{43A}\u{43E}\u{43C} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{43E}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C}, \u{447}\u{442}\u{43E} ${issue.origin ?? "\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435"} \u{431}\u{443}\u{434}\u{435}\u{442} \u{438}\u{43C}\u{435}\u{442}\u{44C} ${adj}${issue.maximum.toString()} ${unit}`;
                    }
                    return `\u{421}\u{43B}\u{438}\u{448}\u{43A}\u{43E}\u{43C} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{43E}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C}, \u{447}\u{442}\u{43E} ${issue.origin ?? "\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435"} \u{431}\u{443}\u{434}\u{435}\u{442} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) {
                        const minValue = Number(issue.minimum);
                        const unit = $f7d7eb3d44d149c8$var$getRussianPlural(minValue, sizing.unit.one, sizing.unit.few, sizing.unit.many);
                        return `\u{421}\u{43B}\u{438}\u{448}\u{43A}\u{43E}\u{43C} \u{43C}\u{430}\u{43B}\u{435}\u{43D}\u{44C}\u{43A}\u{43E}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C}, \u{447}\u{442}\u{43E} ${issue.origin} \u{431}\u{443}\u{434}\u{435}\u{442} \u{438}\u{43C}\u{435}\u{442}\u{44C} ${adj}${issue.minimum.toString()} ${unit}`;
                    }
                    return `\u{421}\u{43B}\u{438}\u{448}\u{43A}\u{43E}\u{43C} \u{43C}\u{430}\u{43B}\u{435}\u{43D}\u{44C}\u{43A}\u{43E}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C}, \u{447}\u{442}\u{43E} ${issue.origin} \u{431}\u{443}\u{434}\u{435}\u{442} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{430}\u{44F} \u{441}\u{442}\u{440}\u{43E}\u{43A}\u{430}: \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{43D}\u{430}\u{447}\u{438}\u{43D}\u{430}\u{442}\u{44C}\u{441}\u{44F} \u{441} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{430}\u{44F} \u{441}\u{442}\u{440}\u{43E}\u{43A}\u{430}: \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{437}\u{430}\u{43A}\u{430}\u{43D}\u{447}\u{438}\u{432}\u{430}\u{442}\u{44C}\u{441}\u{44F} \u{43D}\u{430} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{430}\u{44F} \u{441}\u{442}\u{440}\u{43E}\u{43A}\u{430}: \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{442}\u{44C} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{430}\u{44F} \u{441}\u{442}\u{440}\u{43E}\u{43A}\u{430}: \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{441}\u{43E}\u{43E}\u{442}\u{432}\u{435}\u{442}\u{441}\u{442}\u{432}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{448}\u{430}\u{431}\u{43B}\u{43E}\u{43D}\u{443} ${_issue.pattern}`;
                    return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{44B}\u{439} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{43E}\u{435} \u{447}\u{438}\u{441}\u{43B}\u{43E}: \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{43A}\u{440}\u{430}\u{442}\u{43D}\u{44B}\u{43C} ${issue.divisor}`;
            case "unrecognized_keys":
                return `\u{41D}\u{435}\u{440}\u{430}\u{441}\u{43F}\u{43E}\u{437}\u{43D}\u{430}\u{43D}\u{43D}${issue.keys.length > 1 ? "\u044B\u0435" : "\u044B\u0439"} \u{43A}\u{43B}\u{44E}\u{447}${issue.keys.length > 1 ? "\u0438" : ""}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{44B}\u{439} \u{43A}\u{43B}\u{44E}\u{447} \u{432} ${issue.origin}`;
            case "invalid_union":
                return "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u0432\u0445\u043E\u0434\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435";
            case "invalid_element":
                return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{43E}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{432} ${issue.origin}`;
            default:
                return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{44B}\u{435} \u{432}\u{445}\u{43E}\u{434}\u{43D}\u{44B}\u{435} \u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{435}`;
        }
    };
};
function $f7d7eb3d44d149c8$export$2e2bcd8739ae039() {
    return {
        localeError: $f7d7eb3d44d149c8$var$error()
    };
}



const $1e13a5b3097358ea$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "znakov",
            verb: "imeti"
        },
        file: {
            unit: "bajtov",
            verb: "imeti"
        },
        array: {
            unit: "elementov",
            verb: "imeti"
        },
        set: {
            unit: "elementov",
            verb: "imeti"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "vnos",
        email: "e-po\u0161tni naslov",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datum in \u010Das",
        date: "ISO datum",
        time: "ISO \u010Das",
        duration: "ISO trajanje",
        ipv4: "IPv4 naslov",
        ipv6: "IPv6 naslov",
        cidrv4: "obseg IPv4",
        cidrv6: "obseg IPv6",
        base64: "base64 kodiran niz",
        base64url: "base64url kodiran niz",
        json_string: "JSON niz",
        e164: "E.164 \u0161tevilka",
        jwt: "JWT",
        template_literal: "vnos"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0161tevilo",
        array: "tabela"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Neveljaven vnos: pri\u{10D}akovano instanceof ${issue.expected}, prejeto ${received}`;
                    return `Neveljaven vnos: pri\u{10D}akovano ${expected}, prejeto ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Neveljaven vnos: pri\u{10D}akovano ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Neveljavna mo\u{17E}nost: pri\u{10D}akovano eno izmed ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Preveliko: pri\u{10D}akovano, da bo ${issue.origin ?? "vrednost"} imelo ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementov"}`;
                    return `Preveliko: pri\u{10D}akovano, da bo ${issue.origin ?? "vrednost"} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Premajhno: pri\u{10D}akovano, da bo ${issue.origin} imelo ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Premajhno: pri\u{10D}akovano, da bo ${issue.origin} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Neveljaven niz: mora se za\u{10D}eti z "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Neveljaven niz: mora se kon\u{10D}ati z "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Neveljaven niz: mora vsebovati "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Neveljaven niz: mora ustrezati vzorcu ${_issue.pattern}`;
                    return `Neveljaven ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Neveljavno \u{161}tevilo: mora biti ve\u{10D}kratnik ${issue.divisor}`;
            case "unrecognized_keys":
                return `Neprepoznan${issue.keys.length > 1 ? "i klju\u010Di" : " klju\u010D"}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Neveljaven klju\u{10D} v ${issue.origin}`;
            case "invalid_union":
                return "Neveljaven vnos";
            case "invalid_element":
                return `Neveljavna vrednost v ${issue.origin}`;
            default:
                return "Neveljaven vnos";
        }
    };
};
function $1e13a5b3097358ea$export$2e2bcd8739ae039() {
    return {
        localeError: $1e13a5b3097358ea$var$error()
    };
}



const $639922eacbf2c560$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "tecken",
            verb: "att ha"
        },
        file: {
            unit: "bytes",
            verb: "att ha"
        },
        array: {
            unit: "objekt",
            verb: "att inneh\xe5lla"
        },
        set: {
            unit: "objekt",
            verb: "att inneh\xe5lla"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "regulj\xe4rt uttryck",
        email: "e-postadress",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-datum och tid",
        date: "ISO-datum",
        time: "ISO-tid",
        duration: "ISO-varaktighet",
        ipv4: "IPv4-intervall",
        ipv6: "IPv6-intervall",
        cidrv4: "IPv4-spektrum",
        cidrv6: "IPv6-spektrum",
        base64: "base64-kodad str\xe4ng",
        base64url: "base64url-kodad str\xe4ng",
        json_string: "JSON-str\xe4ng",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "mall-literal"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "antal",
        array: "lista"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Ogiltig inmatning: f\xf6rv\xe4ntat instanceof ${issue.expected}, fick ${received}`;
                    return `Ogiltig inmatning: f\xf6rv\xe4ntat ${expected}, fick ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Ogiltig inmatning: f\xf6rv\xe4ntat ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Ogiltigt val: f\xf6rv\xe4ntade en av ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `F\xf6r stor(t): f\xf6rv\xe4ntade ${issue.origin ?? "v\xe4rdet"} att ha ${adj}${issue.maximum.toString()} ${sizing.unit ?? "element"}`;
                    return `F\xf6r stor(t): f\xf6rv\xe4ntat ${issue.origin ?? "v\xe4rdet"} att ha ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `F\xf6r lite(t): f\xf6rv\xe4ntade ${issue.origin ?? "v\xe4rdet"} att ha ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `F\xf6r lite(t): f\xf6rv\xe4ntade ${issue.origin ?? "v\xe4rdet"} att ha ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Ogiltig str\xe4ng: m\xe5ste b\xf6rja med "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Ogiltig str\xe4ng: m\xe5ste sluta med "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Ogiltig str\xe4ng: m\xe5ste inneh\xe5lla "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Ogiltig str\xe4ng: m\xe5ste matcha m\xf6nstret "${_issue.pattern}"`;
                    return `Ogiltig(t) ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Ogiltigt tal: m\xe5ste vara en multipel av ${issue.divisor}`;
            case "unrecognized_keys":
                return `${issue.keys.length > 1 ? "Ok\xe4nda nycklar" : "Ok\xe4nd nyckel"}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Ogiltig nyckel i ${issue.origin ?? "v\xe4rdet"}`;
            case "invalid_union":
                return "Ogiltig input";
            case "invalid_element":
                return `Ogiltigt v\xe4rde i ${issue.origin ?? "v\xe4rdet"}`;
            default:
                return `Ogiltig input`;
        }
    };
};
function $639922eacbf2c560$export$2e2bcd8739ae039() {
    return {
        localeError: $639922eacbf2c560$var$error()
    };
}



const $b9dcd4e335a45b13$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u0B8E\u0BB4\u0BC1\u0BA4\u0BCD\u0BA4\u0BC1\u0B95\u0BCD\u0B95\u0BB3\u0BCD",
            verb: "\u0B95\u0BCA\u0BA3\u0BCD\u0B9F\u0BBF\u0BB0\u0BC1\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD"
        },
        file: {
            unit: "\u0BAA\u0BC8\u0B9F\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            verb: "\u0B95\u0BCA\u0BA3\u0BCD\u0B9F\u0BBF\u0BB0\u0BC1\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD"
        },
        array: {
            unit: "\u0B89\u0BB1\u0BC1\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD",
            verb: "\u0B95\u0BCA\u0BA3\u0BCD\u0B9F\u0BBF\u0BB0\u0BC1\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD"
        },
        set: {
            unit: "\u0B89\u0BB1\u0BC1\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD",
            verb: "\u0B95\u0BCA\u0BA3\u0BCD\u0B9F\u0BBF\u0BB0\u0BC1\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0B89\u0BB3\u0BCD\u0BB3\u0BC0\u0B9F\u0BC1",
        email: "\u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0B9E\u0BCD\u0B9A\u0BB2\u0BCD \u0BAE\u0BC1\u0B95\u0BB5\u0BB0\u0BBF",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u0BA4\u0BC7\u0BA4\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
        date: "ISO \u0BA4\u0BC7\u0BA4\u0BBF",
        time: "ISO \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
        duration: "ISO \u0B95\u0BBE\u0BB2 \u0B85\u0BB3\u0BB5\u0BC1",
        ipv4: "IPv4 \u0BAE\u0BC1\u0B95\u0BB5\u0BB0\u0BBF",
        ipv6: "IPv6 \u0BAE\u0BC1\u0B95\u0BB5\u0BB0\u0BBF",
        cidrv4: "IPv4 \u0BB5\u0BB0\u0BAE\u0BCD\u0BAA\u0BC1",
        cidrv6: "IPv6 \u0BB5\u0BB0\u0BAE\u0BCD\u0BAA\u0BC1",
        base64: "base64-encoded \u0B9A\u0BB0\u0BAE\u0BCD",
        base64url: "base64url-encoded \u0B9A\u0BB0\u0BAE\u0BCD",
        json_string: "JSON \u0B9A\u0BB0\u0BAE\u0BCD",
        e164: "E.164 \u0B8E\u0BA3\u0BCD",
        jwt: "JWT",
        template_literal: "input"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0B8E\u0BA3\u0BCD",
        array: "\u0B85\u0BA3\u0BBF",
        null: "\u0BB5\u0BC6\u0BB1\u0BC1\u0BAE\u0BC8"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B89}\u{BB3}\u{BCD}\u{BB3}\u{BC0}\u{B9F}\u{BC1}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} instanceof ${issue.expected}, \u{BAA}\u{BC6}\u{BB1}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${received}`;
                    return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B89}\u{BB3}\u{BCD}\u{BB3}\u{BC0}\u{B9F}\u{BC1}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${expected}, \u{BAA}\u{BC6}\u{BB1}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B89}\u{BB3}\u{BCD}\u{BB3}\u{BC0}\u{B9F}\u{BC1}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{BB5}\u{BBF}\u{BB0}\u{BC1}\u{BAA}\u{BCD}\u{BAA}\u{BAE}\u{BCD}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")} \u{B87}\u{BB2}\u{BCD} \u{B92}\u{BA9}\u{BCD}\u{BB1}\u{BC1}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{BAE}\u{BBF}\u{B95} \u{BAA}\u{BC6}\u{BB0}\u{BBF}\u{BAF}\u{BA4}\u{BC1}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${issue.origin ?? "\u0BAE\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0B89\u0BB1\u0BC1\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD"} \u{B86}\u{B95} \u{B87}\u{BB0}\u{BC1}\u{B95}\u{BCD}\u{B95} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
                    return `\u{BAE}\u{BBF}\u{B95} \u{BAA}\u{BC6}\u{BB0}\u{BBF}\u{BAF}\u{BA4}\u{BC1}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${issue.origin ?? "\u0BAE\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1"} ${adj}${issue.maximum.toString()} \u{B86}\u{B95} \u{B87}\u{BB0}\u{BC1}\u{B95}\u{BCD}\u{B95} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{BAE}\u{BBF}\u{B95}\u{B9A}\u{BCD} \u{B9A}\u{BBF}\u{BB1}\u{BBF}\u{BAF}\u{BA4}\u{BC1}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit} \u{B86}\u{B95} \u{B87}\u{BB0}\u{BC1}\u{B95}\u{BCD}\u{B95} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`; //
                    return `\u{BAE}\u{BBF}\u{B95}\u{B9A}\u{BCD} \u{B9A}\u{BBF}\u{BB1}\u{BBF}\u{BAF}\u{BA4}\u{BC1}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${issue.origin} ${adj}${issue.minimum.toString()} \u{B86}\u{B95} \u{B87}\u{BB0}\u{BC1}\u{B95}\u{BCD}\u{B95} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B9A}\u{BB0}\u{BAE}\u{BCD}: "${_issue.prefix}" \u{B87}\u{BB2}\u{BCD} \u{BA4}\u{BCA}\u{B9F}\u{B99}\u{BCD}\u{B95} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
                    if (_issue.format === "ends_with") return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B9A}\u{BB0}\u{BAE}\u{BCD}: "${_issue.suffix}" \u{B87}\u{BB2}\u{BCD} \u{BAE}\u{BC1}\u{B9F}\u{BBF}\u{BB5}\u{B9F}\u{BC8}\u{BAF} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
                    if (_issue.format === "includes") return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B9A}\u{BB0}\u{BAE}\u{BCD}: "${_issue.includes}" \u{B90} \u{B89}\u{BB3}\u{BCD}\u{BB3}\u{B9F}\u{B95}\u{BCD}\u{B95} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
                    if (_issue.format === "regex") return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B9A}\u{BB0}\u{BAE}\u{BCD}: ${_issue.pattern} \u{BAE}\u{BC1}\u{BB1}\u{BC8}\u{BAA}\u{BBE}\u{B9F}\u{BCD}\u{B9F}\u{BC1}\u{B9F}\u{BA9}\u{BCD} \u{BAA}\u{BCA}\u{BB0}\u{BC1}\u{BA8}\u{BCD}\u{BA4} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
                    return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B8E}\u{BA3}\u{BCD}: ${issue.divisor} \u{B87}\u{BA9}\u{BCD} \u{BAA}\u{BB2}\u{BAE}\u{BBE}\u{B95} \u{B87}\u{BB0}\u{BC1}\u{B95}\u{BCD}\u{B95} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
            case "unrecognized_keys":
                return `\u{B85}\u{B9F}\u{BC8}\u{BAF}\u{BBE}\u{BB3}\u{BAE}\u{BCD} \u{BA4}\u{BC6}\u{BB0}\u{BBF}\u{BAF}\u{BBE}\u{BA4} \u{BB5}\u{BBF}\u{B9A}\u{BC8}${issue.keys.length > 1 ? "\u0B95\u0BB3\u0BCD" : ""}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `${issue.origin} \u{B87}\u{BB2}\u{BCD} \u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{BB5}\u{BBF}\u{B9A}\u{BC8}`;
            case "invalid_union":
                return "\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0B89\u0BB3\u0BCD\u0BB3\u0BC0\u0B9F\u0BC1";
            case "invalid_element":
                return `${issue.origin} \u{B87}\u{BB2}\u{BCD} \u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{BAE}\u{BA4}\u{BBF}\u{BAA}\u{BCD}\u{BAA}\u{BC1}`;
            default:
                return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B89}\u{BB3}\u{BCD}\u{BB3}\u{BC0}\u{B9F}\u{BC1}`;
        }
    };
};
function $b9dcd4e335a45b13$export$2e2bcd8739ae039() {
    return {
        localeError: $b9dcd4e335a45b13$var$error()
    };
}



const $8e9c49ed813024bb$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23",
            verb: "\u0E04\u0E27\u0E23\u0E21\u0E35"
        },
        file: {
            unit: "\u0E44\u0E1A\u0E15\u0E4C",
            verb: "\u0E04\u0E27\u0E23\u0E21\u0E35"
        },
        array: {
            unit: "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
            verb: "\u0E04\u0E27\u0E23\u0E21\u0E35"
        },
        set: {
            unit: "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
            verb: "\u0E04\u0E27\u0E23\u0E21\u0E35"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E1B\u0E49\u0E2D\u0E19",
        email: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25",
        url: "URL",
        emoji: "\u0E2D\u0E34\u0E42\u0E21\u0E08\u0E34",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E40\u0E27\u0E25\u0E32\u0E41\u0E1A\u0E1A ISO",
        date: "\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E41\u0E1A\u0E1A ISO",
        time: "\u0E40\u0E27\u0E25\u0E32\u0E41\u0E1A\u0E1A ISO",
        duration: "\u0E0A\u0E48\u0E27\u0E07\u0E40\u0E27\u0E25\u0E32\u0E41\u0E1A\u0E1A ISO",
        ipv4: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48 IPv4",
        ipv6: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48 IPv6",
        cidrv4: "\u0E0A\u0E48\u0E27\u0E07 IP \u0E41\u0E1A\u0E1A IPv4",
        cidrv6: "\u0E0A\u0E48\u0E27\u0E07 IP \u0E41\u0E1A\u0E1A IPv6",
        base64: "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E41\u0E1A\u0E1A Base64",
        base64url: "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E41\u0E1A\u0E1A Base64 \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A URL",
        json_string: "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E41\u0E1A\u0E1A JSON",
        e164: "\u0E40\u0E1A\u0E2D\u0E23\u0E4C\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28 (E.164)",
        jwt: "\u0E42\u0E17\u0E40\u0E04\u0E19 JWT",
        template_literal: "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E1B\u0E49\u0E2D\u0E19"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02",
        array: "\u0E2D\u0E32\u0E23\u0E4C\u0E40\u0E23\u0E22\u0E4C (Array)",
        null: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E04\u0E48\u0E32 (null)"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{E1B}\u{E23}\u{E30}\u{E40}\u{E20}\u{E17}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E04}\u{E27}\u{E23}\u{E40}\u{E1B}\u{E47}\u{E19} instanceof ${issue.expected} \u{E41}\u{E15}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A} ${received}`;
                    return `\u{E1B}\u{E23}\u{E30}\u{E40}\u{E20}\u{E17}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E04}\u{E27}\u{E23}\u{E40}\u{E1B}\u{E47}\u{E19} ${expected} \u{E41}\u{E15}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{E04}\u{E48}\u{E32}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E04}\u{E27}\u{E23}\u{E40}\u{E1B}\u{E47}\u{E19} ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `\u{E15}\u{E31}\u{E27}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E04}\u{E27}\u{E23}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E2B}\u{E19}\u{E36}\u{E48}\u{E07}\u{E43}\u{E19} ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "\u0E44\u0E21\u0E48\u0E40\u0E01\u0E34\u0E19" : "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{E40}\u{E01}\u{E34}\u{E19}\u{E01}\u{E33}\u{E2B}\u{E19}\u{E14}: ${issue.origin ?? "\u0E04\u0E48\u0E32"} \u{E04}\u{E27}\u{E23}\u{E21}\u{E35}${adj} ${issue.maximum.toString()} ${sizing.unit ?? "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23"}`;
                    return `\u{E40}\u{E01}\u{E34}\u{E19}\u{E01}\u{E33}\u{E2B}\u{E19}\u{E14}: ${issue.origin ?? "\u0E04\u0E48\u0E32"} \u{E04}\u{E27}\u{E23}\u{E21}\u{E35}${adj} ${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? "\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22" : "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{E19}\u{E49}\u{E2D}\u{E22}\u{E01}\u{E27}\u{E48}\u{E32}\u{E01}\u{E33}\u{E2B}\u{E19}\u{E14}: ${issue.origin} \u{E04}\u{E27}\u{E23}\u{E21}\u{E35}${adj} ${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{E19}\u{E49}\u{E2D}\u{E22}\u{E01}\u{E27}\u{E48}\u{E32}\u{E01}\u{E33}\u{E2B}\u{E19}\u{E14}: ${issue.origin} \u{E04}\u{E27}\u{E23}\u{E21}\u{E35}${adj} ${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E02}\u{E36}\u{E49}\u{E19}\u{E15}\u{E49}\u{E19}\u{E14}\u{E49}\u{E27}\u{E22} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E25}\u{E07}\u{E17}\u{E49}\u{E32}\u{E22}\u{E14}\u{E49}\u{E27}\u{E22} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35} "${_issue.includes}" \u{E2D}\u{E22}\u{E39}\u{E48}\u{E43}\u{E19}\u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}`;
                    if (_issue.format === "regex") return `\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E15}\u{E49}\u{E2D}\u{E07}\u{E15}\u{E23}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E17}\u{E35}\u{E48}\u{E01}\u{E33}\u{E2B}\u{E19}\u{E14} ${_issue.pattern}`;
                    return `\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{E15}\u{E31}\u{E27}\u{E40}\u{E25}\u{E02}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E15}\u{E49}\u{E2D}\u{E07}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E08}\u{E33}\u{E19}\u{E27}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2B}\u{E32}\u{E23}\u{E14}\u{E49}\u{E27}\u{E22} ${issue.divisor} \u{E44}\u{E14}\u{E49}\u{E25}\u{E07}\u{E15}\u{E31}\u{E27}`;
            case "unrecognized_keys":
                return `\u{E1E}\u{E1A}\u{E04}\u{E35}\u{E22}\u{E4C}\u{E17}\u{E35}\u{E48}\u{E44}\u{E21}\u{E48}\u{E23}\u{E39}\u{E49}\u{E08}\u{E31}\u{E01}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{E04}\u{E35}\u{E22}\u{E4C}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E43}\u{E19} ${issue.origin}`;
            case "invalid_union":
                return "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07: \u0E44\u0E21\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E1A\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E22\u0E39\u0E40\u0E19\u0E35\u0E22\u0E19\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E44\u0E27\u0E49";
            case "invalid_element":
                return `\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E43}\u{E19} ${issue.origin}`;
            default:
                return `\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}`;
        }
    };
};
function $8e9c49ed813024bb$export$2e2bcd8739ae039() {
    return {
        localeError: $8e9c49ed813024bb$var$error()
    };
}



const $b29e5beb289cb304$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "karakter",
            verb: "olmal\u0131"
        },
        file: {
            unit: "bayt",
            verb: "olmal\u0131"
        },
        array: {
            unit: "\xf6\u011Fe",
            verb: "olmal\u0131"
        },
        set: {
            unit: "\xf6\u011Fe",
            verb: "olmal\u0131"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "girdi",
        email: "e-posta adresi",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO tarih ve saat",
        date: "ISO tarih",
        time: "ISO saat",
        duration: "ISO s\xfcre",
        ipv4: "IPv4 adresi",
        ipv6: "IPv6 adresi",
        cidrv4: "IPv4 aral\u0131\u011F\u0131",
        cidrv6: "IPv6 aral\u0131\u011F\u0131",
        base64: "base64 ile \u015Fifrelenmi\u015F metin",
        base64url: "base64url ile \u015Fifrelenmi\u015F metin",
        json_string: "JSON dizesi",
        e164: "E.164 say\u0131s\u0131",
        jwt: "JWT",
        template_literal: "\u015Eablon dizesi"
    };
    const TypeDictionary = {
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Ge\xe7ersiz de\u{11F}er: beklenen instanceof ${issue.expected}, al\u{131}nan ${received}`;
                    return `Ge\xe7ersiz de\u{11F}er: beklenen ${expected}, al\u{131}nan ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Ge\xe7ersiz de\u{11F}er: beklenen ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Ge\xe7ersiz se\xe7enek: a\u{15F}a\u{11F}\u{131}dakilerden biri olmal\u{131}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\xc7ok b\xfcy\xfck: beklenen ${issue.origin ?? "de\u011Fer"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\xf6\u011Fe"}`;
                    return `\xc7ok b\xfcy\xfck: beklenen ${issue.origin ?? "de\u011Fer"} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\xc7ok k\xfc\xe7\xfck: beklenen ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\xc7ok k\xfc\xe7\xfck: beklenen ${issue.origin} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Ge\xe7ersiz metin: "${_issue.prefix}" ile ba\u{15F}lamal\u{131}`;
                    if (_issue.format === "ends_with") return `Ge\xe7ersiz metin: "${_issue.suffix}" ile bitmeli`;
                    if (_issue.format === "includes") return `Ge\xe7ersiz metin: "${_issue.includes}" i\xe7ermeli`;
                    if (_issue.format === "regex") return `Ge\xe7ersiz metin: ${_issue.pattern} desenine uymal\u{131}`;
                    return `Ge\xe7ersiz ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Ge\xe7ersiz say\u{131}: ${issue.divisor} ile tam b\xf6l\xfcnebilmeli`;
            case "unrecognized_keys":
                return `Tan\u{131}nmayan anahtar${issue.keys.length > 1 ? "lar" : ""}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `${issue.origin} i\xe7inde ge\xe7ersiz anahtar`;
            case "invalid_union":
                return "Ge\xe7ersiz de\u011Fer";
            case "invalid_element":
                return `${issue.origin} i\xe7inde ge\xe7ersiz de\u{11F}er`;
            default:
                return `Ge\xe7ersiz de\u{11F}er`;
        }
    };
};
function $b29e5beb289cb304$export$2e2bcd8739ae039() {
    return {
        localeError: $b29e5beb289cb304$var$error()
    };
}



const $5f7c76af623aafa4$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432",
            verb: "\u043C\u0430\u0442\u0438\u043C\u0435"
        },
        file: {
            unit: "\u0431\u0430\u0439\u0442\u0456\u0432",
            verb: "\u043C\u0430\u0442\u0438\u043C\u0435"
        },
        array: {
            unit: "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0456\u0432",
            verb: "\u043C\u0430\u0442\u0438\u043C\u0435"
        },
        set: {
            unit: "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0456\u0432",
            verb: "\u043C\u0430\u0442\u0438\u043C\u0435"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0432\u0445\u0456\u0434\u043D\u0456 \u0434\u0430\u043D\u0456",
        email: "\u0430\u0434\u0440\u0435\u0441\u0430 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
        url: "URL",
        emoji: "\u0435\u043C\u043E\u0434\u0437\u0456",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u0434\u0430\u0442\u0430 \u0442\u0430 \u0447\u0430\u0441 ISO",
        date: "\u0434\u0430\u0442\u0430 ISO",
        time: "\u0447\u0430\u0441 ISO",
        duration: "\u0442\u0440\u0438\u0432\u0430\u043B\u0456\u0441\u0442\u044C ISO",
        ipv4: "\u0430\u0434\u0440\u0435\u0441\u0430 IPv4",
        ipv6: "\u0430\u0434\u0440\u0435\u0441\u0430 IPv6",
        cidrv4: "\u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D IPv4",
        cidrv6: "\u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D IPv6",
        base64: "\u0440\u044F\u0434\u043E\u043A \u0443 \u043A\u043E\u0434\u0443\u0432\u0430\u043D\u043D\u0456 base64",
        base64url: "\u0440\u044F\u0434\u043E\u043A \u0443 \u043A\u043E\u0434\u0443\u0432\u0430\u043D\u043D\u0456 base64url",
        json_string: "\u0440\u044F\u0434\u043E\u043A JSON",
        e164: "\u043D\u043E\u043C\u0435\u0440 E.164",
        jwt: "JWT",
        template_literal: "\u0432\u0445\u0456\u0434\u043D\u0456 \u0434\u0430\u043D\u0456"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0447\u0438\u0441\u043B\u043E",
        array: "\u043C\u0430\u0441\u0438\u0432"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{456} \u{432}\u{445}\u{456}\u{434}\u{43D}\u{456} \u{434}\u{430}\u{43D}\u{456}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F} instanceof ${issue.expected}, \u{43E}\u{442}\u{440}\u{438}\u{43C}\u{430}\u{43D}\u{43E} ${received}`;
                    return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{456} \u{432}\u{445}\u{456}\u{434}\u{43D}\u{456} \u{434}\u{430}\u{43D}\u{456}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F} ${expected}, \u{43E}\u{442}\u{440}\u{438}\u{43C}\u{430}\u{43D}\u{43E} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{456} \u{432}\u{445}\u{456}\u{434}\u{43D}\u{456} \u{434}\u{430}\u{43D}\u{456}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F} ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{430} \u{43E}\u{43F}\u{446}\u{456}\u{44F}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F} \u{43E}\u{434}\u{43D}\u{435} \u{437} ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{43E} \u{432}\u{435}\u{43B}\u{438}\u{43A}\u{435}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F}, \u{449}\u{43E} ${issue.origin ?? "\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F"} ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0456\u0432"}`;
                    return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{43E} \u{432}\u{435}\u{43B}\u{438}\u{43A}\u{435}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F}, \u{449}\u{43E} ${issue.origin ?? "\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F"} \u{431}\u{443}\u{434}\u{435} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{43E} \u{43C}\u{430}\u{43B}\u{435}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F}, \u{449}\u{43E} ${issue.origin} ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{43E} \u{43C}\u{430}\u{43B}\u{435}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F}, \u{449}\u{43E} ${issue.origin} \u{431}\u{443}\u{434}\u{435} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{438}\u{439} \u{440}\u{44F}\u{434}\u{43E}\u{43A}: \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{435}\u{43D} \u{43F}\u{43E}\u{447}\u{438}\u{43D}\u{430}\u{442}\u{438}\u{441}\u{44F} \u{437} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{438}\u{439} \u{440}\u{44F}\u{434}\u{43E}\u{43A}: \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{435}\u{43D} \u{437}\u{430}\u{43A}\u{456}\u{43D}\u{447}\u{443}\u{432}\u{430}\u{442}\u{438}\u{441}\u{44F} \u{43D}\u{430} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{438}\u{439} \u{440}\u{44F}\u{434}\u{43E}\u{43A}: \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{435}\u{43D} \u{43C}\u{456}\u{441}\u{442}\u{438}\u{442}\u{438} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{438}\u{439} \u{440}\u{44F}\u{434}\u{43E}\u{43A}: \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{435}\u{43D} \u{432}\u{456}\u{434}\u{43F}\u{43E}\u{432}\u{456}\u{434}\u{430}\u{442}\u{438} \u{448}\u{430}\u{431}\u{43B}\u{43E}\u{43D}\u{443} ${_issue.pattern}`;
                    return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{438}\u{439} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{435} \u{447}\u{438}\u{441}\u{43B}\u{43E}: \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{43D}\u{43E} \u{431}\u{443}\u{442}\u{438} \u{43A}\u{440}\u{430}\u{442}\u{43D}\u{438}\u{43C} ${issue.divisor}`;
            case "unrecognized_keys":
                return `\u{41D}\u{435}\u{440}\u{43E}\u{437}\u{43F}\u{456}\u{437}\u{43D}\u{430}\u{43D}\u{438}\u{439} \u{43A}\u{43B}\u{44E}\u{447}${issue.keys.length > 1 ? "\u0456" : ""}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{438}\u{439} \u{43A}\u{43B}\u{44E}\u{447} \u{443} ${issue.origin}`;
            case "invalid_union":
                return "\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0456 \u0432\u0445\u0456\u0434\u043D\u0456 \u0434\u0430\u043D\u0456";
            case "invalid_element":
                return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43D}\u{44F} \u{443} ${issue.origin}`;
            default:
                return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{456} \u{432}\u{445}\u{456}\u{434}\u{43D}\u{456} \u{434}\u{430}\u{43D}\u{456}`;
        }
    };
};
function $5f7c76af623aafa4$export$2e2bcd8739ae039() {
    return {
        localeError: $5f7c76af623aafa4$var$error()
    };
}


function $a27980a02898c874$export$2e2bcd8739ae039() {
    return (0, $5f7c76af623aafa4$export$2e2bcd8739ae039)();
}




const $b8c22cef03d71fbf$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u062D\u0631\u0648\u0641",
            verb: "\u06C1\u0648\u0646\u0627"
        },
        file: {
            unit: "\u0628\u0627\u0626\u0679\u0633",
            verb: "\u06C1\u0648\u0646\u0627"
        },
        array: {
            unit: "\u0622\u0626\u0679\u0645\u0632",
            verb: "\u06C1\u0648\u0646\u0627"
        },
        set: {
            unit: "\u0622\u0626\u0679\u0645\u0632",
            verb: "\u06C1\u0648\u0646\u0627"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0627\u0646 \u067E\u0679",
        email: "\u0627\u06CC \u0645\u06CC\u0644 \u0627\u06CC\u0688\u0631\u06CC\u0633",
        url: "\u06CC\u0648 \u0622\u0631 \u0627\u06CC\u0644",
        emoji: "\u0627\u06CC\u0645\u0648\u062C\u06CC",
        uuid: "\u06CC\u0648 \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC",
        uuidv4: "\u06CC\u0648 \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC \u0648\u06CC 4",
        uuidv6: "\u06CC\u0648 \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC \u0648\u06CC 6",
        nanoid: "\u0646\u06CC\u0646\u0648 \u0622\u0626\u06CC \u0688\u06CC",
        guid: "\u062C\u06CC \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC",
        cuid: "\u0633\u06CC \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC",
        cuid2: "\u0633\u06CC \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC 2",
        ulid: "\u06CC\u0648 \u0627\u06CC\u0644 \u0622\u0626\u06CC \u0688\u06CC",
        xid: "\u0627\u06CC\u06A9\u0633 \u0622\u0626\u06CC \u0688\u06CC",
        ksuid: "\u06A9\u06D2 \u0627\u06CC\u0633 \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC",
        datetime: "\u0622\u0626\u06CC \u0627\u06CC\u0633 \u0627\u0648 \u0688\u06CC\u0679 \u0679\u0627\u0626\u0645",
        date: "\u0622\u0626\u06CC \u0627\u06CC\u0633 \u0627\u0648 \u062A\u0627\u0631\u06CC\u062E",
        time: "\u0622\u0626\u06CC \u0627\u06CC\u0633 \u0627\u0648 \u0648\u0642\u062A",
        duration: "\u0622\u0626\u06CC \u0627\u06CC\u0633 \u0627\u0648 \u0645\u062F\u062A",
        ipv4: "\u0622\u0626\u06CC \u067E\u06CC \u0648\u06CC 4 \u0627\u06CC\u0688\u0631\u06CC\u0633",
        ipv6: "\u0622\u0626\u06CC \u067E\u06CC \u0648\u06CC 6 \u0627\u06CC\u0688\u0631\u06CC\u0633",
        cidrv4: "\u0622\u0626\u06CC \u067E\u06CC \u0648\u06CC 4 \u0631\u06CC\u0646\u062C",
        cidrv6: "\u0622\u0626\u06CC \u067E\u06CC \u0648\u06CC 6 \u0631\u06CC\u0646\u062C",
        base64: "\u0628\u06CC\u0633 64 \u0627\u0646 \u06A9\u0648\u0688\u0688 \u0633\u0679\u0631\u0646\u06AF",
        base64url: "\u0628\u06CC\u0633 64 \u06CC\u0648 \u0622\u0631 \u0627\u06CC\u0644 \u0627\u0646 \u06A9\u0648\u0688\u0688 \u0633\u0679\u0631\u0646\u06AF",
        json_string: "\u062C\u06D2 \u0627\u06CC\u0633 \u0627\u0648 \u0627\u06CC\u0646 \u0633\u0679\u0631\u0646\u06AF",
        e164: "\u0627\u06CC 164 \u0646\u0645\u0628\u0631",
        jwt: "\u062C\u06D2 \u0688\u0628\u0644\u06CC\u0648 \u0679\u06CC",
        template_literal: "\u0627\u0646 \u067E\u0679"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0646\u0645\u0628\u0631",
        array: "\u0622\u0631\u06D2",
        null: "\u0646\u0644"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{63A}\u{644}\u{637} \u{627}\u{646} \u{67E}\u{679}: instanceof ${issue.expected} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{627}\u{60C} ${received} \u{645}\u{648}\u{635}\u{648}\u{644} \u{6C1}\u{648}\u{627}`;
                    return `\u{63A}\u{644}\u{637} \u{627}\u{646} \u{67E}\u{679}: ${expected} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{627}\u{60C} ${received} \u{645}\u{648}\u{635}\u{648}\u{644} \u{6C1}\u{648}\u{627}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{63A}\u{644}\u{637} \u{627}\u{646} \u{67E}\u{679}: ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{627}`;
                return `\u{63A}\u{644}\u{637} \u{622}\u{67E}\u{634}\u{646}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")} \u{645}\u{6CC}\u{6BA} \u{633}\u{6D2} \u{627}\u{6CC}\u{6A9} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{627}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{628}\u{6C1}\u{62A} \u{628}\u{691}\u{627}: ${issue.origin ?? "\u0648\u06CC\u0644\u06CC\u0648"} \u{6A9}\u{6D2} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0639\u0646\u0627\u0635\u0631"} \u{6C1}\u{648}\u{646}\u{6D2} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{6D2}`;
                    return `\u{628}\u{6C1}\u{62A} \u{628}\u{691}\u{627}: ${issue.origin ?? "\u0648\u06CC\u0644\u06CC\u0648"} \u{6A9}\u{627} ${adj}${issue.maximum.toString()} \u{6C1}\u{648}\u{646}\u{627} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{627}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{628}\u{6C1}\u{62A} \u{686}\u{6BE}\u{648}\u{679}\u{627}: ${issue.origin} \u{6A9}\u{6D2} ${adj}${issue.minimum.toString()} ${sizing.unit} \u{6C1}\u{648}\u{646}\u{6D2} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{6D2}`;
                    return `\u{628}\u{6C1}\u{62A} \u{686}\u{6BE}\u{648}\u{679}\u{627}: ${issue.origin} \u{6A9}\u{627} ${adj}${issue.minimum.toString()} \u{6C1}\u{648}\u{646}\u{627} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{627}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{63A}\u{644}\u{637} \u{633}\u{679}\u{631}\u{646}\u{6AF}: "${_issue.prefix}" \u{633}\u{6D2} \u{634}\u{631}\u{648}\u{639} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}`;
                    if (_issue.format === "ends_with") return `\u{63A}\u{644}\u{637} \u{633}\u{679}\u{631}\u{646}\u{6AF}: "${_issue.suffix}" \u{67E}\u{631} \u{62E}\u{62A}\u{645} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}`;
                    if (_issue.format === "includes") return `\u{63A}\u{644}\u{637} \u{633}\u{679}\u{631}\u{646}\u{6AF}: "${_issue.includes}" \u{634}\u{627}\u{645}\u{644} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}`;
                    if (_issue.format === "regex") return `\u{63A}\u{644}\u{637} \u{633}\u{679}\u{631}\u{646}\u{6AF}: \u{67E}\u{6CC}\u{679}\u{631}\u{646} ${_issue.pattern} \u{633}\u{6D2} \u{645}\u{6CC}\u{686} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}`;
                    return `\u{63A}\u{644}\u{637} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{63A}\u{644}\u{637} \u{646}\u{645}\u{628}\u{631}: ${issue.divisor} \u{6A9}\u{627} \u{645}\u{636}\u{627}\u{639}\u{641} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}`;
            case "unrecognized_keys":
                return `\u{63A}\u{6CC}\u{631} \u{62A}\u{633}\u{644}\u{6CC}\u{645} \u{634}\u{62F}\u{6C1} \u{6A9}\u{6CC}${issue.keys.length > 1 ? "\u0632" : ""}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, "\u060C ")}`;
            case "invalid_key":
                return `${issue.origin} \u{645}\u{6CC}\u{6BA} \u{63A}\u{644}\u{637} \u{6A9}\u{6CC}`;
            case "invalid_union":
                return "\u063A\u0644\u0637 \u0627\u0646 \u067E\u0679";
            case "invalid_element":
                return `${issue.origin} \u{645}\u{6CC}\u{6BA} \u{63A}\u{644}\u{637} \u{648}\u{6CC}\u{644}\u{6CC}\u{648}`;
            default:
                return `\u{63A}\u{644}\u{637} \u{627}\u{646} \u{67E}\u{679}`;
        }
    };
};
function $b8c22cef03d71fbf$export$2e2bcd8739ae039() {
    return {
        localeError: $b8c22cef03d71fbf$var$error()
    };
}



const $05ce72b299d20c05$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "belgi",
            verb: "bo\u2018lishi kerak"
        },
        file: {
            unit: "bayt",
            verb: "bo\u2018lishi kerak"
        },
        array: {
            unit: "element",
            verb: "bo\u2018lishi kerak"
        },
        set: {
            unit: "element",
            verb: "bo\u2018lishi kerak"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "kirish",
        email: "elektron pochta manzili",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO sana va vaqti",
        date: "ISO sana",
        time: "ISO vaqt",
        duration: "ISO davomiylik",
        ipv4: "IPv4 manzil",
        ipv6: "IPv6 manzil",
        mac: "MAC manzil",
        cidrv4: "IPv4 diapazon",
        cidrv6: "IPv6 diapazon",
        base64: "base64 kodlangan satr",
        base64url: "base64url kodlangan satr",
        json_string: "JSON satr",
        e164: "E.164 raqam",
        jwt: "JWT",
        template_literal: "kirish"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "raqam",
        array: "massiv"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Noto\u{2018}g\u{2018}ri kirish: kutilgan instanceof ${issue.expected}, qabul qilingan ${received}`;
                    return `Noto\u{2018}g\u{2018}ri kirish: kutilgan ${expected}, qabul qilingan ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Noto\u{2018}g\u{2018}ri kirish: kutilgan ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `Noto\u{2018}g\u{2018}ri variant: quyidagilardan biri kutilgan ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Juda katta: kutilgan ${issue.origin ?? "qiymat"} ${adj}${issue.maximum.toString()} ${sizing.unit} ${sizing.verb}`;
                    return `Juda katta: kutilgan ${issue.origin ?? "qiymat"} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Juda kichik: kutilgan ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit} ${sizing.verb}`;
                    return `Juda kichik: kutilgan ${issue.origin} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Noto\u{2018}g\u{2018}ri satr: "${_issue.prefix}" bilan boshlanishi kerak`;
                    if (_issue.format === "ends_with") return `Noto\u{2018}g\u{2018}ri satr: "${_issue.suffix}" bilan tugashi kerak`;
                    if (_issue.format === "includes") return `Noto\u{2018}g\u{2018}ri satr: "${_issue.includes}" ni o\u{2018}z ichiga olishi kerak`;
                    if (_issue.format === "regex") return `Noto\u{2018}g\u{2018}ri satr: ${_issue.pattern} shabloniga mos kelishi kerak`;
                    return `Noto\u{2018}g\u{2018}ri ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Noto\u{2018}g\u{2018}ri raqam: ${issue.divisor} ning karralisi bo\u{2018}lishi kerak`;
            case "unrecognized_keys":
                return `Noma\u{2019}lum kalit${issue.keys.length > 1 ? "lar" : ""}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `${issue.origin} dagi kalit noto\u{2018}g\u{2018}ri`;
            case "invalid_union":
                return "Noto\u2018g\u2018ri kirish";
            case "invalid_element":
                return `${issue.origin} da noto\u{2018}g\u{2018}ri qiymat`;
            default:
                return `Noto\u{2018}g\u{2018}ri kirish`;
        }
    };
};
function $05ce72b299d20c05$export$2e2bcd8739ae039() {
    return {
        localeError: $05ce72b299d20c05$var$error()
    };
}



const $e807a3cb84aebcae$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "k\xfd t\u1EF1",
            verb: "c\xf3"
        },
        file: {
            unit: "byte",
            verb: "c\xf3"
        },
        array: {
            unit: "ph\u1EA7n t\u1EED",
            verb: "c\xf3"
        },
        set: {
            unit: "ph\u1EA7n t\u1EED",
            verb: "c\xf3"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0111\u1EA7u v\xe0o",
        email: "\u0111\u1ECBa ch\u1EC9 email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ng\xe0y gi\u1EDD ISO",
        date: "ng\xe0y ISO",
        time: "gi\u1EDD ISO",
        duration: "kho\u1EA3ng th\u1EDDi gian ISO",
        ipv4: "\u0111\u1ECBa ch\u1EC9 IPv4",
        ipv6: "\u0111\u1ECBa ch\u1EC9 IPv6",
        cidrv4: "d\u1EA3i IPv4",
        cidrv6: "d\u1EA3i IPv6",
        base64: "chu\u1ED7i m\xe3 h\xf3a base64",
        base64url: "chu\u1ED7i m\xe3 h\xf3a base64url",
        json_string: "chu\u1ED7i JSON",
        e164: "s\u1ED1 E.164",
        jwt: "JWT",
        template_literal: "\u0111\u1EA7u v\xe0o"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "s\u1ED1",
        array: "m\u1EA3ng"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{110}\u{1EA7}u v\xe0o kh\xf4ng h\u{1EE3}p l\u{1EC7}: mong \u{111}\u{1EE3}i instanceof ${issue.expected}, nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c ${received}`;
                    return `\u{110}\u{1EA7}u v\xe0o kh\xf4ng h\u{1EE3}p l\u{1EC7}: mong \u{111}\u{1EE3}i ${expected}, nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{110}\u{1EA7}u v\xe0o kh\xf4ng h\u{1EE3}p l\u{1EC7}: mong \u{111}\u{1EE3}i ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `T\xf9y ch\u{1ECD}n kh\xf4ng h\u{1EE3}p l\u{1EC7}: mong \u{111}\u{1EE3}i m\u{1ED9}t trong c\xe1c gi\xe1 tr\u{1ECB} ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Qu\xe1 l\u{1EDB}n: mong \u{111}\u{1EE3}i ${issue.origin ?? "gi\xe1 tr\u1ECB"} ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "ph\u1EA7n t\u1EED"}`;
                    return `Qu\xe1 l\u{1EDB}n: mong \u{111}\u{1EE3}i ${issue.origin ?? "gi\xe1 tr\u1ECB"} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Qu\xe1 nh\u{1ECF}: mong \u{111}\u{1EE3}i ${issue.origin} ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Qu\xe1 nh\u{1ECF}: mong \u{111}\u{1EE3}i ${issue.origin} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Chu\u{1ED7}i kh\xf4ng h\u{1EE3}p l\u{1EC7}: ph\u{1EA3}i b\u{1EAF}t \u{111}\u{1EA7}u b\u{1EB1}ng "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Chu\u{1ED7}i kh\xf4ng h\u{1EE3}p l\u{1EC7}: ph\u{1EA3}i k\u{1EBF}t th\xfac b\u{1EB1}ng "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Chu\u{1ED7}i kh\xf4ng h\u{1EE3}p l\u{1EC7}: ph\u{1EA3}i bao g\u{1ED3}m "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Chu\u{1ED7}i kh\xf4ng h\u{1EE3}p l\u{1EC7}: ph\u{1EA3}i kh\u{1EDB}p v\u{1EDB}i m\u{1EAB}u ${_issue.pattern}`;
                    return `${FormatDictionary[_issue.format] ?? issue.format} kh\xf4ng h\u{1EE3}p l\u{1EC7}`;
                }
            case "not_multiple_of":
                return `S\u{1ED1} kh\xf4ng h\u{1EE3}p l\u{1EC7}: ph\u{1EA3}i l\xe0 b\u{1ED9}i s\u{1ED1} c\u{1EE7}a ${issue.divisor}`;
            case "unrecognized_keys":
                return `Kh\xf3a kh\xf4ng \u{111}\u{1B0}\u{1EE3}c nh\u{1EAD}n d\u{1EA1}ng: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Kh\xf3a kh\xf4ng h\u{1EE3}p l\u{1EC7} trong ${issue.origin}`;
            case "invalid_union":
                return "\u0110\u1EA7u v\xe0o kh\xf4ng h\u1EE3p l\u1EC7";
            case "invalid_element":
                return `Gi\xe1 tr\u{1ECB} kh\xf4ng h\u{1EE3}p l\u{1EC7} trong ${issue.origin}`;
            default:
                return `\u{110}\u{1EA7}u v\xe0o kh\xf4ng h\u{1EE3}p l\u{1EC7}`;
        }
    };
};
function $e807a3cb84aebcae$export$2e2bcd8739ae039() {
    return {
        localeError: $e807a3cb84aebcae$var$error()
    };
}



const $e2a0195ee32321e3$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u5B57\u7B26",
            verb: "\u5305\u542B"
        },
        file: {
            unit: "\u5B57\u8282",
            verb: "\u5305\u542B"
        },
        array: {
            unit: "\u9879",
            verb: "\u5305\u542B"
        },
        set: {
            unit: "\u9879",
            verb: "\u5305\u542B"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u8F93\u5165",
        email: "\u7535\u5B50\u90AE\u4EF6",
        url: "URL",
        emoji: "\u8868\u60C5\u7B26\u53F7",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO\u65E5\u671F\u65F6\u95F4",
        date: "ISO\u65E5\u671F",
        time: "ISO\u65F6\u95F4",
        duration: "ISO\u65F6\u957F",
        ipv4: "IPv4\u5730\u5740",
        ipv6: "IPv6\u5730\u5740",
        cidrv4: "IPv4\u7F51\u6BB5",
        cidrv6: "IPv6\u7F51\u6BB5",
        base64: "base64\u7F16\u7801\u5B57\u7B26\u4E32",
        base64url: "base64url\u7F16\u7801\u5B57\u7B26\u4E32",
        json_string: "JSON\u5B57\u7B26\u4E32",
        e164: "E.164\u53F7\u7801",
        jwt: "JWT",
        template_literal: "\u8F93\u5165"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u6570\u5B57",
        array: "\u6570\u7EC4",
        null: "\u7A7A\u503C(null)"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{65E0}\u{6548}\u{8F93}\u{5165}\u{FF1A}\u{671F}\u{671B} instanceof ${issue.expected}\u{FF0C}\u{5B9E}\u{9645}\u{63A5}\u{6536} ${received}`;
                    return `\u{65E0}\u{6548}\u{8F93}\u{5165}\u{FF1A}\u{671F}\u{671B} ${expected}\u{FF0C}\u{5B9E}\u{9645}\u{63A5}\u{6536} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{65E0}\u{6548}\u{8F93}\u{5165}\u{FF1A}\u{671F}\u{671B} ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `\u{65E0}\u{6548}\u{9009}\u{9879}\u{FF1A}\u{671F}\u{671B}\u{4EE5}\u{4E0B}\u{4E4B}\u{4E00} ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{6570}\u{503C}\u{8FC7}\u{5927}\u{FF1A}\u{671F}\u{671B} ${issue.origin ?? "\u503C"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u4E2A\u5143\u7D20"}`;
                    return `\u{6570}\u{503C}\u{8FC7}\u{5927}\u{FF1A}\u{671F}\u{671B} ${issue.origin ?? "\u503C"} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{6570}\u{503C}\u{8FC7}\u{5C0F}\u{FF1A}\u{671F}\u{671B} ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{6570}\u{503C}\u{8FC7}\u{5C0F}\u{FF1A}\u{671F}\u{671B} ${issue.origin} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{65E0}\u{6548}\u{5B57}\u{7B26}\u{4E32}\u{FF1A}\u{5FC5}\u{987B}\u{4EE5} "${_issue.prefix}" \u{5F00}\u{5934}`;
                    if (_issue.format === "ends_with") return `\u{65E0}\u{6548}\u{5B57}\u{7B26}\u{4E32}\u{FF1A}\u{5FC5}\u{987B}\u{4EE5} "${_issue.suffix}" \u{7ED3}\u{5C3E}`;
                    if (_issue.format === "includes") return `\u{65E0}\u{6548}\u{5B57}\u{7B26}\u{4E32}\u{FF1A}\u{5FC5}\u{987B}\u{5305}\u{542B} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{65E0}\u{6548}\u{5B57}\u{7B26}\u{4E32}\u{FF1A}\u{5FC5}\u{987B}\u{6EE1}\u{8DB3}\u{6B63}\u{5219}\u{8868}\u{8FBE}\u{5F0F} ${_issue.pattern}`;
                    return `\u{65E0}\u{6548}${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{65E0}\u{6548}\u{6570}\u{5B57}\u{FF1A}\u{5FC5}\u{987B}\u{662F} ${issue.divisor} \u{7684}\u{500D}\u{6570}`;
            case "unrecognized_keys":
                return `\u{51FA}\u{73B0}\u{672A}\u{77E5}\u{7684}\u{952E}(key): ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `${issue.origin} \u{4E2D}\u{7684}\u{952E}(key)\u{65E0}\u{6548}`;
            case "invalid_union":
                return "\u65E0\u6548\u8F93\u5165";
            case "invalid_element":
                return `${issue.origin} \u{4E2D}\u{5305}\u{542B}\u{65E0}\u{6548}\u{503C}(value)`;
            default:
                return `\u{65E0}\u{6548}\u{8F93}\u{5165}`;
        }
    };
};
function $e2a0195ee32321e3$export$2e2bcd8739ae039() {
    return {
        localeError: $e2a0195ee32321e3$var$error()
    };
}



const $1d6795a4170ebee9$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u5B57\u5143",
            verb: "\u64C1\u6709"
        },
        file: {
            unit: "\u4F4D\u5143\u7D44",
            verb: "\u64C1\u6709"
        },
        array: {
            unit: "\u9805\u76EE",
            verb: "\u64C1\u6709"
        },
        set: {
            unit: "\u9805\u76EE",
            verb: "\u64C1\u6709"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u8F38\u5165",
        email: "\u90F5\u4EF6\u5730\u5740",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u65E5\u671F\u6642\u9593",
        date: "ISO \u65E5\u671F",
        time: "ISO \u6642\u9593",
        duration: "ISO \u671F\u9593",
        ipv4: "IPv4 \u4F4D\u5740",
        ipv6: "IPv6 \u4F4D\u5740",
        cidrv4: "IPv4 \u7BC4\u570D",
        cidrv6: "IPv6 \u7BC4\u570D",
        base64: "base64 \u7DE8\u78BC\u5B57\u4E32",
        base64url: "base64url \u7DE8\u78BC\u5B57\u4E32",
        json_string: "JSON \u5B57\u4E32",
        e164: "E.164 \u6578\u503C",
        jwt: "JWT",
        template_literal: "\u8F38\u5165"
    };
    const TypeDictionary = {
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{7121}\u{6548}\u{7684}\u{8F38}\u{5165}\u{503C}\u{FF1A}\u{9810}\u{671F}\u{70BA} instanceof ${issue.expected}\u{FF0C}\u{4F46}\u{6536}\u{5230} ${received}`;
                    return `\u{7121}\u{6548}\u{7684}\u{8F38}\u{5165}\u{503C}\u{FF1A}\u{9810}\u{671F}\u{70BA} ${expected}\u{FF0C}\u{4F46}\u{6536}\u{5230} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{7121}\u{6548}\u{7684}\u{8F38}\u{5165}\u{503C}\u{FF1A}\u{9810}\u{671F}\u{70BA} ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `\u{7121}\u{6548}\u{7684}\u{9078}\u{9805}\u{FF1A}\u{9810}\u{671F}\u{70BA}\u{4EE5}\u{4E0B}\u{5176}\u{4E2D}\u{4E4B}\u{4E00} ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{6578}\u{503C}\u{904E}\u{5927}\u{FF1A}\u{9810}\u{671F} ${issue.origin ?? "\u503C"} \u{61C9}\u{70BA} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u500B\u5143\u7D20"}`;
                    return `\u{6578}\u{503C}\u{904E}\u{5927}\u{FF1A}\u{9810}\u{671F} ${issue.origin ?? "\u503C"} \u{61C9}\u{70BA} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{6578}\u{503C}\u{904E}\u{5C0F}\u{FF1A}\u{9810}\u{671F} ${issue.origin} \u{61C9}\u{70BA} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{6578}\u{503C}\u{904E}\u{5C0F}\u{FF1A}\u{9810}\u{671F} ${issue.origin} \u{61C9}\u{70BA} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{7121}\u{6548}\u{7684}\u{5B57}\u{4E32}\u{FF1A}\u{5FC5}\u{9808}\u{4EE5} "${_issue.prefix}" \u{958B}\u{982D}`;
                    if (_issue.format === "ends_with") return `\u{7121}\u{6548}\u{7684}\u{5B57}\u{4E32}\u{FF1A}\u{5FC5}\u{9808}\u{4EE5} "${_issue.suffix}" \u{7D50}\u{5C3E}`;
                    if (_issue.format === "includes") return `\u{7121}\u{6548}\u{7684}\u{5B57}\u{4E32}\u{FF1A}\u{5FC5}\u{9808}\u{5305}\u{542B} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{7121}\u{6548}\u{7684}\u{5B57}\u{4E32}\u{FF1A}\u{5FC5}\u{9808}\u{7B26}\u{5408}\u{683C}\u{5F0F} ${_issue.pattern}`;
                    return `\u{7121}\u{6548}\u{7684} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{7121}\u{6548}\u{7684}\u{6578}\u{5B57}\u{FF1A}\u{5FC5}\u{9808}\u{70BA} ${issue.divisor} \u{7684}\u{500D}\u{6578}`;
            case "unrecognized_keys":
                return `\u{7121}\u{6CD5}\u{8B58}\u{5225}\u{7684}\u{9375}\u{503C}${issue.keys.length > 1 ? "\u5011" : ""}\u{FF1A}${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, "\u3001")}`;
            case "invalid_key":
                return `${issue.origin} \u{4E2D}\u{6709}\u{7121}\u{6548}\u{7684}\u{9375}\u{503C}`;
            case "invalid_union":
                return "\u7121\u6548\u7684\u8F38\u5165\u503C";
            case "invalid_element":
                return `${issue.origin} \u{4E2D}\u{6709}\u{7121}\u{6548}\u{7684}\u{503C}`;
            default:
                return `\u{7121}\u{6548}\u{7684}\u{8F38}\u{5165}\u{503C}`;
        }
    };
};
function $1d6795a4170ebee9$export$2e2bcd8739ae039() {
    return {
        localeError: $1d6795a4170ebee9$var$error()
    };
}



const $a297ee4147b36be2$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\xe0mi",
            verb: "n\xed"
        },
        file: {
            unit: "bytes",
            verb: "n\xed"
        },
        array: {
            unit: "nkan",
            verb: "n\xed"
        },
        set: {
            unit: "nkan",
            verb: "n\xed"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u1EB9\u0300r\u1ECD \xecb\xe1w\u1ECDl\xe9",
        email: "\xe0d\xedr\u1EB9\u0301s\xec \xecm\u1EB9\u0301l\xec",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\xe0k\xf3k\xf2 ISO",
        date: "\u1ECDj\u1ECD\u0301 ISO",
        time: "\xe0k\xf3k\xf2 ISO",
        duration: "\xe0k\xf3k\xf2 t\xf3 p\xe9 ISO",
        ipv4: "\xe0d\xedr\u1EB9\u0301s\xec IPv4",
        ipv6: "\xe0d\xedr\u1EB9\u0301s\xec IPv6",
        cidrv4: "\xe0gb\xe8gb\xe8 IPv4",
        cidrv6: "\xe0gb\xe8gb\xe8 IPv6",
        base64: "\u1ECD\u0300r\u1ECD\u0300 t\xed a k\u1ECD\u0301 n\xed base64",
        base64url: "\u1ECD\u0300r\u1ECD\u0300 base64url",
        json_string: "\u1ECD\u0300r\u1ECD\u0300 JSON",
        e164: "n\u1ECD\u0301mb\xe0 E.164",
        jwt: "JWT",
        template_literal: "\u1EB9\u0300r\u1ECD \xecb\xe1w\u1ECDl\xe9"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "n\u1ECD\u0301mb\xe0",
        array: "akop\u1ECD"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = $17ea3f861a2ff584$export$858d360cf6da2b65(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\xccb\xe1w\u{1ECD}l\xe9 a\u{1E63}\xec\u{1E63}e: a n\xed l\xe1ti fi instanceof ${issue.expected}, \xe0m\u{1ECD}\u{300} a r\xed ${received}`;
                    return `\xccb\xe1w\u{1ECD}l\xe9 a\u{1E63}\xec\u{1E63}e: a n\xed l\xe1ti fi ${expected}, \xe0m\u{1ECD}\u{300} a r\xed ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\xccb\xe1w\u{1ECD}l\xe9 a\u{1E63}\xec\u{1E63}e: a n\xed l\xe1ti fi ${$17ea3f861a2ff584$export$5859860f650378f4(issue.values[0])}`;
                return `\xc0\u{1E63}\xe0y\xe0n a\u{1E63}\xec\u{1E63}e: yan \u{1ECD}\u{300}kan l\xe1ra ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `T\xf3 p\u{1ECD}\u{300} j\xf9: a n\xed l\xe1ti j\u{1EB9}\u{301} p\xe9 ${issue.origin ?? "iye"} ${sizing.verb} ${adj}${issue.maximum} ${sizing.unit}`;
                    return `T\xf3 p\u{1ECD}\u{300} j\xf9: a n\xed l\xe1ti j\u{1EB9}\u{301} ${adj}${issue.maximum}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `K\xe9r\xe9 ju: a n\xed l\xe1ti j\u{1EB9}\u{301} p\xe9 ${issue.origin} ${sizing.verb} ${adj}${issue.minimum} ${sizing.unit}`;
                    return `K\xe9r\xe9 ju: a n\xed l\xe1ti j\u{1EB9}\u{301} ${adj}${issue.minimum}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{1ECC}\u{300}r\u{1ECD}\u{300} a\u{1E63}\xec\u{1E63}e: gb\u{1ECD}\u{301}d\u{1ECD}\u{300} b\u{1EB9}\u{300}r\u{1EB9}\u{300} p\u{1EB9}\u{300}l\xfa "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{1ECC}\u{300}r\u{1ECD}\u{300} a\u{1E63}\xec\u{1E63}e: gb\u{1ECD}\u{301}d\u{1ECD}\u{300} par\xed p\u{1EB9}\u{300}l\xfa "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{1ECC}\u{300}r\u{1ECD}\u{300} a\u{1E63}\xec\u{1E63}e: gb\u{1ECD}\u{301}d\u{1ECD}\u{300} n\xed "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{1ECC}\u{300}r\u{1ECD}\u{300} a\u{1E63}\xec\u{1E63}e: gb\u{1ECD}\u{301}d\u{1ECD}\u{300} b\xe1 \xe0p\u{1EB9}\u{1EB9}r\u{1EB9} mu ${_issue.pattern}`;
                    return `A\u{1E63}\xec\u{1E63}e: ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `N\u{1ECD}\u{301}mb\xe0 a\u{1E63}\xec\u{1E63}e: gb\u{1ECD}\u{301}d\u{1ECD}\u{300} j\u{1EB9}\u{301} \xe8y\xe0 p\xedp\xedn ti ${issue.divisor}`;
            case "unrecognized_keys":
                return `B\u{1ECD}t\xecn\xec \xe0\xecm\u{1ECD}\u{300}: ${$17ea3f861a2ff584$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `B\u{1ECD}t\xecn\xec a\u{1E63}\xec\u{1E63}e n\xedn\xfa ${issue.origin}`;
            case "invalid_union":
                return "\xccb\xe1w\u1ECDl\xe9 a\u1E63\xec\u1E63e";
            case "invalid_element":
                return `Iye a\u{1E63}\xec\u{1E63}e n\xedn\xfa ${issue.origin}`;
            default:
                return "\xccb\xe1w\u1ECDl\xe9 a\u1E63\xec\u1E63e";
        }
    };
};
function $a297ee4147b36be2$export$2e2bcd8739ae039() {
    return {
        localeError: $a297ee4147b36be2$var$error()
    };
}




var $450977dbcfd5dec3$var$_a;
const $450977dbcfd5dec3$export$26c272954616d4a2 = Symbol("ZodOutput");
const $450977dbcfd5dec3$export$4159eb10f43487af = Symbol("ZodInput");
class $450977dbcfd5dec3$export$dc03955eec152cc5 {
    constructor(){
        this._map = new WeakMap();
        this._idmap = new Map();
    }
    add(schema, ..._meta) {
        const meta = _meta[0];
        this._map.set(schema, meta);
        if (meta && typeof meta === "object" && "id" in meta) this._idmap.set(meta.id, schema);
        return this;
    }
    clear() {
        this._map = new WeakMap();
        this._idmap = new Map();
        return this;
    }
    remove(schema) {
        const meta = this._map.get(schema);
        if (meta && typeof meta === "object" && "id" in meta) this._idmap.delete(meta.id);
        this._map.delete(schema);
        return this;
    }
    get(schema) {
        // return this._map.get(schema) as any;
        // inherit metadata
        const p = schema._zod.parent;
        if (p) {
            const pm = {
                ...this.get(p) ?? {}
            };
            delete pm.id; // do not inherit id
            const f = {
                ...pm,
                ...this._map.get(schema)
            };
            return Object.keys(f).length ? f : undefined;
        }
        return this._map.get(schema);
    }
    has(schema) {
        return this._map.has(schema);
    }
}
function $450977dbcfd5dec3$export$4bb7493d241fd8a5() {
    return new $450977dbcfd5dec3$export$dc03955eec152cc5();
}
($450977dbcfd5dec3$var$_a = globalThis).__zod_globalRegistry ?? ($450977dbcfd5dec3$var$_a.__zod_globalRegistry = $450977dbcfd5dec3$export$4bb7493d241fd8a5());
const $450977dbcfd5dec3$export$bc58ce2776ecdb6f = globalThis.__zod_globalRegistry;







function $57904f98be373a74$export$25986a84359f8f7f(Class, params) {
    return new Class({
        type: "string",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$614049477c642ce0(Class, params) {
    return new Class({
        type: "string",
        coerce: true,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$471b39521bec3299(Class, params) {
    return new Class({
        type: "string",
        format: "email",
        check: "string_format",
        abort: false,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$129b5399d64cccb0(Class, params) {
    return new Class({
        type: "string",
        format: "guid",
        check: "string_format",
        abort: false,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$f2f3139038bea52c(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$a5559d7da37a112f(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v4",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$53b427a8173231a(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v6",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$588d23d6e9ec2ed5(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v7",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$e3f203373341d39(Class, params) {
    return new Class({
        type: "string",
        format: "url",
        check: "string_format",
        abort: false,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$936e26d261396f46(Class, params) {
    return new Class({
        type: "string",
        format: "emoji",
        check: "string_format",
        abort: false,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$a030949b19390ea0(Class, params) {
    return new Class({
        type: "string",
        format: "nanoid",
        check: "string_format",
        abort: false,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$639125837b796148(Class, params) {
    return new Class({
        type: "string",
        format: "cuid",
        check: "string_format",
        abort: false,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$36b63ef9af7972c2(Class, params) {
    return new Class({
        type: "string",
        format: "cuid2",
        check: "string_format",
        abort: false,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$95acf3b3fa11bdc9(Class, params) {
    return new Class({
        type: "string",
        format: "ulid",
        check: "string_format",
        abort: false,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$bbb0a2cfb079fa90(Class, params) {
    return new Class({
        type: "string",
        format: "xid",
        check: "string_format",
        abort: false,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$1306ede2f9ea153f(Class, params) {
    return new Class({
        type: "string",
        format: "ksuid",
        check: "string_format",
        abort: false,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$c77a1c80cebc2aad(Class, params) {
    return new Class({
        type: "string",
        format: "ipv4",
        check: "string_format",
        abort: false,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$964dfe0e2e4e8895(Class, params) {
    return new Class({
        type: "string",
        format: "ipv6",
        check: "string_format",
        abort: false,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$84f8b3e041d8e7d9(Class, params) {
    return new Class({
        type: "string",
        format: "mac",
        check: "string_format",
        abort: false,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$feaac4e27a421ddc(Class, params) {
    return new Class({
        type: "string",
        format: "cidrv4",
        check: "string_format",
        abort: false,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$a0518ffc5273ec92(Class, params) {
    return new Class({
        type: "string",
        format: "cidrv6",
        check: "string_format",
        abort: false,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$9fdb09384fbc4988(Class, params) {
    return new Class({
        type: "string",
        format: "base64",
        check: "string_format",
        abort: false,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$178c70fb89c949fa(Class, params) {
    return new Class({
        type: "string",
        format: "base64url",
        check: "string_format",
        abort: false,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$b8bf0b70d4bc7855(Class, params) {
    return new Class({
        type: "string",
        format: "e164",
        check: "string_format",
        abort: false,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$4a9318e6b46f1aa1(Class, params) {
    return new Class({
        type: "string",
        format: "jwt",
        check: "string_format",
        abort: false,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
const $57904f98be373a74$export$3a3ade082c590099 = {
    Any: null,
    Minute: -1,
    Second: 0,
    Millisecond: 3,
    Microsecond: 6
};
function $57904f98be373a74$export$a62adeb27809351b(Class, params) {
    return new Class({
        type: "string",
        format: "datetime",
        check: "string_format",
        offset: false,
        local: false,
        precision: null,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$e4f19dd0a54e7a59(Class, params) {
    return new Class({
        type: "string",
        format: "date",
        check: "string_format",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$36f9f051d5e817c(Class, params) {
    return new Class({
        type: "string",
        format: "time",
        check: "string_format",
        precision: null,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$7d70539c76fbff4(Class, params) {
    return new Class({
        type: "string",
        format: "duration",
        check: "string_format",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$9249bb0b45639623(Class, params) {
    return new Class({
        type: "number",
        checks: [],
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$272511620e4661dd(Class, params) {
    return new Class({
        type: "number",
        coerce: true,
        checks: [],
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$3d5b343b1f51efdd(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "safeint",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$656ad65d6cf64174(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "float32",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$9ddff8176107cc11(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "float64",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$5ec965fd114a2f9f(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "int32",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$a43c28c6e86e066e(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "uint32",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$e23c41ce5ce2db39(Class, params) {
    return new Class({
        type: "boolean",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$c3eb0e1c7c887e5c(Class, params) {
    return new Class({
        type: "boolean",
        coerce: true,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$c96ff33878177e4c(Class, params) {
    return new Class({
        type: "bigint",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$8ff745acc355d077(Class, params) {
    return new Class({
        type: "bigint",
        coerce: true,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$cb7d3ec922804f3f(Class, params) {
    return new Class({
        type: "bigint",
        check: "bigint_format",
        abort: false,
        format: "int64",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$c51606f0dfa0f5a1(Class, params) {
    return new Class({
        type: "bigint",
        check: "bigint_format",
        abort: false,
        format: "uint64",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$a8f93f5b7c030e84(Class, params) {
    return new Class({
        type: "symbol",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$60e4c9fe67803d40(Class, params) {
    return new Class({
        type: "undefined",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$a2cbb38cda512d16(Class, params) {
    return new Class({
        type: "null",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$4678886173313220(Class) {
    return new Class({
        type: "any"
    });
}
function $57904f98be373a74$export$e0ed508a47e00801(Class) {
    return new Class({
        type: "unknown"
    });
}
function $57904f98be373a74$export$887f43204ffc2a69(Class, params) {
    return new Class({
        type: "never",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$9480825d3c8e9ad6(Class, params) {
    return new Class({
        type: "void",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$da799735c76175a(Class, params) {
    return new Class({
        type: "date",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$2efeac445ea43f33(Class, params) {
    return new Class({
        type: "date",
        coerce: true,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$a5e7e1f8491a5e50(Class, params) {
    return new Class({
        type: "nan",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$2a42c74e76a068a(value, params) {
    return new $bd6e402f1568d28b$export$294415ecbdd02022({
        check: "less_than",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params),
        value: value,
        inclusive: false
    });
}
function $57904f98be373a74$export$7a060cf3d60b84a6(value, params) {
    return new $bd6e402f1568d28b$export$294415ecbdd02022({
        check: "less_than",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params),
        value: value,
        inclusive: true
    });
}
function $57904f98be373a74$export$7582466e3ab4d25b(value, params) {
    return new $bd6e402f1568d28b$export$8b670f58decbca18({
        check: "greater_than",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params),
        value: value,
        inclusive: false
    });
}
function $57904f98be373a74$export$a1c6d8834a3b19c9(value, params) {
    return new $bd6e402f1568d28b$export$8b670f58decbca18({
        check: "greater_than",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params),
        value: value,
        inclusive: true
    });
}
function $57904f98be373a74$export$ddfc6f0a2e49a568(params) {
    return $57904f98be373a74$export$7582466e3ab4d25b(0, params);
}
function $57904f98be373a74$export$d30568dda7134ca5(params) {
    return $57904f98be373a74$export$2a42c74e76a068a(0, params);
}
function $57904f98be373a74$export$c3e51eea33419c94(params) {
    return $57904f98be373a74$export$7a060cf3d60b84a6(0, params);
}
function $57904f98be373a74$export$93ec5f75848b1928(params) {
    return $57904f98be373a74$export$a1c6d8834a3b19c9(0, params);
}
function $57904f98be373a74$export$c41e40f80e978ab1(value, params) {
    return new $bd6e402f1568d28b$export$ae602e11c1dd0628({
        check: "multiple_of",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params),
        value: value
    });
}
function $57904f98be373a74$export$3eed6ccb98bc18db(maximum, params) {
    return new $bd6e402f1568d28b$export$b3cec505675cf50c({
        check: "max_size",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params),
        maximum: maximum
    });
}
function $57904f98be373a74$export$e379713268c2c18a(minimum, params) {
    return new $bd6e402f1568d28b$export$59fb0a2e7217c42b({
        check: "min_size",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params),
        minimum: minimum
    });
}
function $57904f98be373a74$export$2621565b966a8d23(size, params) {
    return new $bd6e402f1568d28b$export$af532c490f33cd47({
        check: "size_equals",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params),
        size: size
    });
}
function $57904f98be373a74$export$ec76627108655a22(maximum, params) {
    const ch = new $bd6e402f1568d28b$export$b07b097887f4c15a({
        check: "max_length",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params),
        maximum: maximum
    });
    return ch;
}
function $57904f98be373a74$export$21f6711a906c1450(minimum, params) {
    return new $bd6e402f1568d28b$export$cd5336aa96b8417c({
        check: "min_length",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params),
        minimum: minimum
    });
}
function $57904f98be373a74$export$620b9f7ab17ff8a9(length, params) {
    return new $bd6e402f1568d28b$export$ccdb9b9d477068fb({
        check: "length_equals",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params),
        length: length
    });
}
function $57904f98be373a74$export$c4768a1bd8f8393(pattern, params) {
    return new $bd6e402f1568d28b$export$6faea86ff718d6df({
        check: "string_format",
        format: "regex",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params),
        pattern: pattern
    });
}
function $57904f98be373a74$export$ea67c3edeec85c63(params) {
    return new $bd6e402f1568d28b$export$e18e268bd5c9f27a({
        check: "string_format",
        format: "lowercase",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$2998381b41c6902a(params) {
    return new $bd6e402f1568d28b$export$6d0944a5127e820a({
        check: "string_format",
        format: "uppercase",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$fccf016a6caa651d(includes, params) {
    return new $bd6e402f1568d28b$export$600021c28f0498dc({
        check: "string_format",
        format: "includes",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params),
        includes: includes
    });
}
function $57904f98be373a74$export$2f37aaf99060de76(prefix, params) {
    return new $bd6e402f1568d28b$export$8e83a74b4b83cc62({
        check: "string_format",
        format: "starts_with",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params),
        prefix: prefix
    });
}
function $57904f98be373a74$export$eaeaa2fcd833167e(suffix, params) {
    return new $bd6e402f1568d28b$export$4a10f85c6af4e92({
        check: "string_format",
        format: "ends_with",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params),
        suffix: suffix
    });
}
function $57904f98be373a74$export$537db06738ee7f1b(property, schema, params) {
    return new $bd6e402f1568d28b$export$d36a4eecd766dbc0({
        check: "property",
        property: property,
        schema: schema,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$267177285a1a8b37(types, params) {
    return new $bd6e402f1568d28b$export$5546147f1877f806({
        check: "mime_type",
        mime: types,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$aeea8f004f34f8c2(tx) {
    return new $bd6e402f1568d28b$export$1bda1934456013d3({
        check: "overwrite",
        tx: tx
    });
}
function $57904f98be373a74$export$2b99bb23a814f78e(form) {
    return $57904f98be373a74$export$aeea8f004f34f8c2((input)=>input.normalize(form));
}
function $57904f98be373a74$export$8be2de0b60774d1e() {
    return $57904f98be373a74$export$aeea8f004f34f8c2((input)=>input.trim());
}
function $57904f98be373a74$export$d9cfe939403a2525() {
    return $57904f98be373a74$export$aeea8f004f34f8c2((input)=>input.toLowerCase());
}
function $57904f98be373a74$export$cf76ef1ae9e9944e() {
    return $57904f98be373a74$export$aeea8f004f34f8c2((input)=>input.toUpperCase());
}
function $57904f98be373a74$export$2801993b93f3c232() {
    return $57904f98be373a74$export$aeea8f004f34f8c2((input)=>$17ea3f861a2ff584$export$c383cdd2a518017a(input));
}
function $57904f98be373a74$export$4ea446333e3db634(Class, element, params) {
    return new Class({
        type: "array",
        element: element,
        // get element() {
        //   return element;
        // },
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$48eec03fd15d025b(Class, options, params) {
    return new Class({
        type: "union",
        options: options,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$d941708f3b69bf5a(Class, options, params) {
    return new Class({
        type: "union",
        options: options,
        inclusive: false,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$ffbf51421b0acee1(Class, discriminator, options, params) {
    return new Class({
        type: "union",
        options: options,
        discriminator: discriminator,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$3d0d84e16c5ea809(Class, left, right) {
    return new Class({
        type: "intersection",
        left: left,
        right: right
    });
}
function $57904f98be373a74$export$a13693bfb304605a(Class, items, _paramsOrRest, _params) {
    const hasRest = _paramsOrRest instanceof $e32a9d04eaeb9d0c$export$f43a5c3966de8238;
    const params = hasRest ? _params : _paramsOrRest;
    const rest = hasRest ? _paramsOrRest : null;
    return new Class({
        type: "tuple",
        items: items,
        rest: rest,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$64440e3f2e29d7bc(Class, keyType, valueType, params) {
    return new Class({
        type: "record",
        keyType: keyType,
        valueType: valueType,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$a0135aecf4a782ab(Class, keyType, valueType, params) {
    return new Class({
        type: "map",
        keyType: keyType,
        valueType: valueType,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$c37fd9e9b598996d(Class, valueType, params) {
    return new Class({
        type: "set",
        valueType: valueType,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$3290a9b46bcfecc1(Class, values, params) {
    const entries = Array.isArray(values) ? Object.fromEntries(values.map((v)=>[
            v,
            v
        ])) : values;
    // if (Array.isArray(values)) {
    //   for (const value of values) {
    //     entries[value] = value;
    //   }
    // } else {
    //   Object.assign(entries, values);
    // }
    // const entries: util.EnumLike = {};
    // for (const val of values) {
    //   entries[val] = val;
    // }
    return new Class({
        type: "enum",
        entries: entries,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$6b94bba2375b9e3d(Class, entries, params) {
    return new Class({
        type: "enum",
        entries: entries,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$a03e276eec27de8b(Class, value, params) {
    return new Class({
        type: "literal",
        values: Array.isArray(value) ? value : [
            value
        ],
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$e335cd0b9f8bab1e(Class, params) {
    return new Class({
        type: "file",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$fa4a3df4db7f3166(Class, fn) {
    return new Class({
        type: "transform",
        transform: fn
    });
}
function $57904f98be373a74$export$6d07c57dda792495(Class, innerType) {
    return new Class({
        type: "optional",
        innerType: innerType
    });
}
function $57904f98be373a74$export$4e46ee4534ff341d(Class, innerType) {
    return new Class({
        type: "nullable",
        innerType: innerType
    });
}
function $57904f98be373a74$export$d4b0f68d0d916971(Class, innerType, defaultValue) {
    return new Class({
        type: "default",
        innerType: innerType,
        get defaultValue () {
            return typeof defaultValue === "function" ? defaultValue() : $17ea3f861a2ff584$export$370e8311c3cdebd9(defaultValue);
        }
    });
}
function $57904f98be373a74$export$24cb0533b28b009b(Class, innerType, params) {
    return new Class({
        type: "nonoptional",
        innerType: innerType,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$6f570707f72cba02(Class, innerType) {
    return new Class({
        type: "success",
        innerType: innerType
    });
}
function $57904f98be373a74$export$7f43fa37c3d8a0b3(Class, innerType, catchValue) {
    return new Class({
        type: "catch",
        innerType: innerType,
        catchValue: typeof catchValue === "function" ? catchValue : ()=>catchValue
    });
}
function $57904f98be373a74$export$fc24e256ce7b145(Class, in_, out) {
    return new Class({
        type: "pipe",
        in: in_,
        out: out
    });
}
function $57904f98be373a74$export$4fe7ff2cfb7a6dd7(Class, innerType) {
    return new Class({
        type: "readonly",
        innerType: innerType
    });
}
function $57904f98be373a74$export$f30d99994777b6d(Class, parts, params) {
    return new Class({
        type: "template_literal",
        parts: parts,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
}
function $57904f98be373a74$export$137d76f65e4bcae1(Class, getter) {
    return new Class({
        type: "lazy",
        getter: getter
    });
}
function $57904f98be373a74$export$d91bbb815217feb6(Class, innerType) {
    return new Class({
        type: "promise",
        innerType: innerType
    });
}
function $57904f98be373a74$export$8bfc2ce1398e3071(Class, fn, _params) {
    const norm = $17ea3f861a2ff584$export$d6b7b25dfacfd300(_params);
    norm.abort ?? (norm.abort = true); // default to abort:false
    const schema = new Class({
        type: "custom",
        check: "custom",
        fn: fn,
        ...norm
    });
    return schema;
}
function $57904f98be373a74$export$ac822e05051812e1(Class, fn, _params) {
    const schema = new Class({
        type: "custom",
        check: "custom",
        fn: fn,
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(_params)
    });
    return schema;
}
function $57904f98be373a74$export$f2b01ecb843d7ab9(fn) {
    const ch = $57904f98be373a74$export$d37145829e4ff88e((payload)=>{
        payload.addIssue = (issue)=>{
            if (typeof issue === "string") payload.issues.push($17ea3f861a2ff584$export$69ad3503f98be476(issue, payload.value, ch._zod.def));
            else {
                // for Zod 3 backwards compatibility
                const _issue = issue;
                if (_issue.fatal) _issue.continue = false;
                _issue.code ?? (_issue.code = "custom");
                _issue.input ?? (_issue.input = payload.value);
                _issue.inst ?? (_issue.inst = ch);
                _issue.continue ?? (_issue.continue = !ch._zod.def.abort); // abort is always undefined, so this is always true...
                payload.issues.push($17ea3f861a2ff584$export$69ad3503f98be476(_issue));
            }
        };
        return fn(payload.value, payload);
    });
    return ch;
}
function $57904f98be373a74$export$d37145829e4ff88e(fn, params) {
    const ch = new $bd6e402f1568d28b$export$c05d9110ef20bb2c({
        check: "custom",
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(params)
    });
    ch._zod.check = fn;
    return ch;
}
function $57904f98be373a74$export$cd5450f3a47e3789(description) {
    const ch = new $bd6e402f1568d28b$export$c05d9110ef20bb2c({
        check: "describe"
    });
    ch._zod.onattach = [
        (inst)=>{
            const existing = $450977dbcfd5dec3$export$bc58ce2776ecdb6f.get(inst) ?? {};
            $450977dbcfd5dec3$export$bc58ce2776ecdb6f.add(inst, {
                ...existing,
                description: description
            });
        }
    ];
    ch._zod.check = ()=>{}; // no-op check
    return ch;
}
function $57904f98be373a74$export$6990040ee07315(metadata) {
    const ch = new $bd6e402f1568d28b$export$c05d9110ef20bb2c({
        check: "meta"
    });
    ch._zod.onattach = [
        (inst)=>{
            const existing = $450977dbcfd5dec3$export$bc58ce2776ecdb6f.get(inst) ?? {};
            $450977dbcfd5dec3$export$bc58ce2776ecdb6f.add(inst, {
                ...existing,
                ...metadata
            });
        }
    ];
    ch._zod.check = ()=>{}; // no-op check
    return ch;
}
function $57904f98be373a74$export$a75528509e3a7006(Classes, _params) {
    const params = $17ea3f861a2ff584$export$d6b7b25dfacfd300(_params);
    let truthyArray = params.truthy ?? [
        "true",
        "1",
        "yes",
        "on",
        "y",
        "enabled"
    ];
    let falsyArray = params.falsy ?? [
        "false",
        "0",
        "no",
        "off",
        "n",
        "disabled"
    ];
    if (params.case !== "sensitive") {
        truthyArray = truthyArray.map((v)=>typeof v === "string" ? v.toLowerCase() : v);
        falsyArray = falsyArray.map((v)=>typeof v === "string" ? v.toLowerCase() : v);
    }
    const truthySet = new Set(truthyArray);
    const falsySet = new Set(falsyArray);
    const _Codec = Classes.Codec ?? $e32a9d04eaeb9d0c$export$c622e07db8a40b53;
    const _Boolean = Classes.Boolean ?? $e32a9d04eaeb9d0c$export$828bf41e557d7dda;
    const _String = Classes.String ?? $e32a9d04eaeb9d0c$export$4342b4432d7b1471;
    const stringSchema = new _String({
        type: "string",
        error: params.error
    });
    const booleanSchema = new _Boolean({
        type: "boolean",
        error: params.error
    });
    const codec = new _Codec({
        type: "pipe",
        in: stringSchema,
        out: booleanSchema,
        transform: (input, payload)=>{
            let data = input;
            if (params.case !== "sensitive") data = data.toLowerCase();
            if (truthySet.has(data)) return true;
            else if (falsySet.has(data)) return false;
            else {
                payload.issues.push({
                    code: "invalid_value",
                    expected: "stringbool",
                    values: [
                        ...truthySet,
                        ...falsySet
                    ],
                    input: payload.value,
                    inst: codec,
                    continue: false
                });
                return {};
            }
        },
        reverseTransform: (input, _payload)=>{
            if (input === true) return truthyArray[0] || "true";
            else return falsyArray[0] || "false";
        },
        error: params.error
    });
    return codec;
}
function $57904f98be373a74$export$e25dde89ba546b88(Class, format, fnOrRegex, _params = {}) {
    const params = $17ea3f861a2ff584$export$d6b7b25dfacfd300(_params);
    const def = {
        ...$17ea3f861a2ff584$export$d6b7b25dfacfd300(_params),
        check: "string_format",
        type: "string",
        format: format,
        fn: typeof fnOrRegex === "function" ? fnOrRegex : (val)=>fnOrRegex.test(val),
        ...params
    };
    if (fnOrRegex instanceof RegExp) def.pattern = fnOrRegex;
    const inst = new Class(def);
    return inst;
}



function $e78123e42965e820$export$881f7fb71351b304(params) {
    // Normalize target: convert old non-hyphenated versions to hyphenated versions
    let target = params?.target ?? "draft-2020-12";
    if (target === "draft-4") target = "draft-04";
    if (target === "draft-7") target = "draft-07";
    return {
        processors: params.processors ?? {},
        metadataRegistry: params?.metadata ?? (0, $450977dbcfd5dec3$export$bc58ce2776ecdb6f),
        target: target,
        unrepresentable: params?.unrepresentable ?? "throw",
        override: params?.override ?? (()=>{}),
        io: params?.io ?? "output",
        counter: 0,
        seen: new Map(),
        cycles: params?.cycles ?? "ref",
        reused: params?.reused ?? "inline",
        external: params?.external ?? undefined
    };
}
function $e78123e42965e820$export$e54fe5b0f43758f7(schema, ctx, _params = {
    path: [],
    schemaPath: []
}) {
    var _a;
    const def = schema._zod.def;
    // check for schema in seens
    const seen = ctx.seen.get(schema);
    if (seen) {
        seen.count++;
        // check if cycle
        const isCycle = _params.schemaPath.includes(schema);
        if (isCycle) seen.cycle = _params.path;
        return seen.schema;
    }
    // initialize
    const result = {
        schema: {},
        count: 1,
        cycle: undefined,
        path: _params.path
    };
    ctx.seen.set(schema, result);
    // custom method overrides default behavior
    const overrideSchema = schema._zod.toJSONSchema?.();
    if (overrideSchema) result.schema = overrideSchema;
    else {
        const params = {
            ..._params,
            schemaPath: [
                ..._params.schemaPath,
                schema
            ],
            path: _params.path
        };
        if (schema._zod.processJSONSchema) schema._zod.processJSONSchema(ctx, result.schema, params);
        else {
            const _json = result.schema;
            const processor = ctx.processors[def.type];
            if (!processor) throw new Error(`[toJSONSchema]: Non-representable type encountered: ${def.type}`);
            processor(schema, ctx, _json, params);
        }
        const parent = schema._zod.parent;
        if (parent) {
            // Also set ref if processor didn't (for inheritance)
            if (!result.ref) result.ref = parent;
            $e78123e42965e820$export$e54fe5b0f43758f7(parent, ctx, params);
            ctx.seen.get(parent).isParent = true;
        }
    }
    // metadata
    const meta = ctx.metadataRegistry.get(schema);
    if (meta) Object.assign(result.schema, meta);
    if (ctx.io === "input" && $e78123e42965e820$var$isTransforming(schema)) {
        // examples/defaults only apply to output type of pipe
        delete result.schema.examples;
        delete result.schema.default;
    }
    // set prefault as default
    if (ctx.io === "input" && result.schema._prefault) (_a = result.schema).default ?? (_a.default = result.schema._prefault);
    delete result.schema._prefault;
    // pulling fresh from ctx.seen in case it was overwritten
    const _result = ctx.seen.get(schema);
    return _result.schema;
}
function $e78123e42965e820$export$ba2613251eadea93(ctx, schema) {
    // iterate over seen map;
    const root = ctx.seen.get(schema);
    if (!root) throw new Error("Unprocessed schema. This is a bug in Zod.");
    // Track ids to detect duplicates across different schemas
    const idToSchema = new Map();
    for (const entry of ctx.seen.entries()){
        const id = ctx.metadataRegistry.get(entry[0])?.id;
        if (id) {
            const existing = idToSchema.get(id);
            if (existing && existing !== entry[0]) throw new Error(`Duplicate schema id "${id}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
            idToSchema.set(id, entry[0]);
        }
    }
    // returns a ref to the schema
    // defId will be empty if the ref points to an external schema (or #)
    const makeURI = (entry)=>{
        // comparing the seen objects because sometimes
        // multiple schemas map to the same seen object.
        // e.g. lazy
        // external is configured
        const defsSegment = ctx.target === "draft-2020-12" ? "$defs" : "definitions";
        if (ctx.external) {
            const externalId = ctx.external.registry.get(entry[0])?.id; // ?? "__shared";// `__schema${ctx.counter++}`;
            // check if schema is in the external registry
            const uriGenerator = ctx.external.uri ?? ((id)=>id);
            if (externalId) return {
                ref: uriGenerator(externalId)
            };
            // otherwise, add to __shared
            const id = entry[1].defId ?? entry[1].schema.id ?? `schema${ctx.counter++}`;
            entry[1].defId = id; // set defId so it will be reused if needed
            return {
                defId: id,
                ref: `${uriGenerator("__shared")}#/${defsSegment}/${id}`
            };
        }
        if (entry[1] === root) return {
            ref: "#"
        };
        // self-contained schema
        const uriPrefix = `#`;
        const defUriPrefix = `${uriPrefix}/${defsSegment}/`;
        const defId = entry[1].schema.id ?? `__schema${ctx.counter++}`;
        return {
            defId: defId,
            ref: defUriPrefix + defId
        };
    };
    // stored cached version in `def` property
    // remove all properties, set $ref
    const extractToDef = (entry)=>{
        // if the schema is already a reference, do not extract it
        if (entry[1].schema.$ref) return;
        const seen = entry[1];
        const { ref: ref, defId: defId } = makeURI(entry);
        seen.def = {
            ...seen.schema
        };
        // defId won't be set if the schema is a reference to an external schema
        // or if the schema is the root schema
        if (defId) seen.defId = defId;
        // wipe away all properties except $ref
        const schema = seen.schema;
        for(const key in schema)delete schema[key];
        schema.$ref = ref;
    };
    // throw on cycles
    // break cycles
    if (ctx.cycles === "throw") for (const entry of ctx.seen.entries()){
        const seen = entry[1];
        if (seen.cycle) throw new Error("Cycle detected: " + `#/${seen.cycle?.join("/")}/<root>` + '\n\nSet the `cycles` parameter to `"ref"` to resolve cyclical schemas with defs.');
    }
    // extract schemas into $defs
    for (const entry of ctx.seen.entries()){
        const seen = entry[1];
        // convert root schema to # $ref
        if (schema === entry[0]) {
            extractToDef(entry); // this has special handling for the root schema
            continue;
        }
        // extract schemas that are in the external registry
        if (ctx.external) {
            const ext = ctx.external.registry.get(entry[0])?.id;
            if (schema !== entry[0] && ext) {
                extractToDef(entry);
                continue;
            }
        }
        // extract schemas with `id` meta
        const id = ctx.metadataRegistry.get(entry[0])?.id;
        if (id) {
            extractToDef(entry);
            continue;
        }
        // break cycles
        if (seen.cycle) {
            // any
            extractToDef(entry);
            continue;
        }
        // extract reused schemas
        if (seen.count > 1) {
            if (ctx.reused === "ref") {
                extractToDef(entry);
                continue;
            }
        }
    }
}
function $e78123e42965e820$export$578723aef62d92f5(ctx, schema) {
    const root = ctx.seen.get(schema);
    if (!root) throw new Error("Unprocessed schema. This is a bug in Zod.");
    // flatten refs - inherit properties from parent schemas
    const flattenRef = (zodSchema)=>{
        const seen = ctx.seen.get(zodSchema);
        // already processed
        if (seen.ref === null) return;
        const schema = seen.def ?? seen.schema;
        const _cached = {
            ...schema
        };
        const ref = seen.ref;
        seen.ref = null; // prevent infinite recursion
        if (ref) {
            flattenRef(ref);
            const refSeen = ctx.seen.get(ref);
            const refSchema = refSeen.schema;
            // merge referenced schema into current
            if (refSchema.$ref && (ctx.target === "draft-07" || ctx.target === "draft-04" || ctx.target === "openapi-3.0")) {
                // older drafts can't combine $ref with other properties
                schema.allOf = schema.allOf ?? [];
                schema.allOf.push(refSchema);
            } else Object.assign(schema, refSchema);
            // restore child's own properties (child wins)
            Object.assign(schema, _cached);
            const isParentRef = zodSchema._zod.parent === ref;
            // For parent chain, child is a refinement - remove parent-only properties
            if (isParentRef) for(const key in schema){
                if (key === "$ref" || key === "allOf") continue;
                if (!(key in _cached)) delete schema[key];
            }
            // When ref was extracted to $defs, remove properties that match the definition
            if (refSchema.$ref && refSeen.def) for(const key in schema){
                if (key === "$ref" || key === "allOf") continue;
                if (key in refSeen.def && JSON.stringify(schema[key]) === JSON.stringify(refSeen.def[key])) delete schema[key];
            }
        }
        // If parent was extracted (has $ref), propagate $ref to this schema
        // This handles cases like: readonly().meta({id}).describe()
        // where processor sets ref to innerType but parent should be referenced
        const parent = zodSchema._zod.parent;
        if (parent && parent !== ref) {
            // Ensure parent is processed first so its def has inherited properties
            flattenRef(parent);
            const parentSeen = ctx.seen.get(parent);
            if (parentSeen?.schema.$ref) {
                schema.$ref = parentSeen.schema.$ref;
                // De-duplicate with parent's definition
                if (parentSeen.def) for(const key in schema){
                    if (key === "$ref" || key === "allOf") continue;
                    if (key in parentSeen.def && JSON.stringify(schema[key]) === JSON.stringify(parentSeen.def[key])) delete schema[key];
                }
            }
        }
        // execute overrides
        ctx.override({
            zodSchema: zodSchema,
            jsonSchema: schema,
            path: seen.path ?? []
        });
    };
    for (const entry of [
        ...ctx.seen.entries()
    ].reverse())flattenRef(entry[0]);
    const result = {};
    if (ctx.target === "draft-2020-12") result.$schema = "https://json-schema.org/draft/2020-12/schema";
    else if (ctx.target === "draft-07") result.$schema = "http://json-schema.org/draft-07/schema#";
    else if (ctx.target === "draft-04") result.$schema = "http://json-schema.org/draft-04/schema#";
    else ctx.target;
    if (ctx.external?.uri) {
        const id = ctx.external.registry.get(schema)?.id;
        if (!id) throw new Error("Schema is missing an `id` property");
        result.$id = ctx.external.uri(id);
    }
    Object.assign(result, root.def ?? root.schema);
    // build defs object
    const defs = ctx.external?.defs ?? {};
    for (const entry of ctx.seen.entries()){
        const seen = entry[1];
        if (seen.def && seen.defId) defs[seen.defId] = seen.def;
    }
    // set definitions in result
    if (ctx.external) ;
    else if (Object.keys(defs).length > 0) {
        if (ctx.target === "draft-2020-12") result.$defs = defs;
        else result.definitions = defs;
    }
    try {
        // this "finalizes" this schema and ensures all cycles are removed
        // each call to finalize() is functionally independent
        // though the seen map is shared
        const finalized = JSON.parse(JSON.stringify(result));
        Object.defineProperty(finalized, "~standard", {
            value: {
                ...schema["~standard"],
                jsonSchema: {
                    input: $e78123e42965e820$export$b29c48d79372468a(schema, "input", ctx.processors),
                    output: $e78123e42965e820$export$b29c48d79372468a(schema, "output", ctx.processors)
                }
            },
            enumerable: false,
            writable: false
        });
        return finalized;
    } catch (_err) {
        throw new Error("Error converting schema to JSON.");
    }
}
function $e78123e42965e820$var$isTransforming(_schema, _ctx) {
    const ctx = _ctx ?? {
        seen: new Set()
    };
    if (ctx.seen.has(_schema)) return false;
    ctx.seen.add(_schema);
    const def = _schema._zod.def;
    if (def.type === "transform") return true;
    if (def.type === "array") return $e78123e42965e820$var$isTransforming(def.element, ctx);
    if (def.type === "set") return $e78123e42965e820$var$isTransforming(def.valueType, ctx);
    if (def.type === "lazy") return $e78123e42965e820$var$isTransforming(def.getter(), ctx);
    if (def.type === "promise" || def.type === "optional" || def.type === "nonoptional" || def.type === "nullable" || def.type === "readonly" || def.type === "default" || def.type === "prefault") return $e78123e42965e820$var$isTransforming(def.innerType, ctx);
    if (def.type === "intersection") return $e78123e42965e820$var$isTransforming(def.left, ctx) || $e78123e42965e820$var$isTransforming(def.right, ctx);
    if (def.type === "record" || def.type === "map") return $e78123e42965e820$var$isTransforming(def.keyType, ctx) || $e78123e42965e820$var$isTransforming(def.valueType, ctx);
    if (def.type === "pipe") return $e78123e42965e820$var$isTransforming(def.in, ctx) || $e78123e42965e820$var$isTransforming(def.out, ctx);
    if (def.type === "object") {
        for(const key in def.shape){
            if ($e78123e42965e820$var$isTransforming(def.shape[key], ctx)) return true;
        }
        return false;
    }
    if (def.type === "union") {
        for (const option of def.options){
            if ($e78123e42965e820$var$isTransforming(option, ctx)) return true;
        }
        return false;
    }
    if (def.type === "tuple") {
        for (const item of def.items){
            if ($e78123e42965e820$var$isTransforming(item, ctx)) return true;
        }
        if (def.rest && $e78123e42965e820$var$isTransforming(def.rest, ctx)) return true;
        return false;
    }
    return false;
}
const $e78123e42965e820$export$d24eb8c1ef5f4df1 = (schema, processors = {})=>(params)=>{
        const ctx = $e78123e42965e820$export$881f7fb71351b304({
            ...params,
            processors: processors
        });
        $e78123e42965e820$export$e54fe5b0f43758f7(schema, ctx);
        $e78123e42965e820$export$ba2613251eadea93(ctx, schema);
        return $e78123e42965e820$export$578723aef62d92f5(ctx, schema);
    };
const $e78123e42965e820$export$b29c48d79372468a = (schema, io, processors = {})=>(params)=>{
        const { libraryOptions: libraryOptions, target: target } = params ?? {};
        const ctx = $e78123e42965e820$export$881f7fb71351b304({
            ...libraryOptions ?? {},
            target: target,
            io: io,
            processors: processors
        });
        $e78123e42965e820$export$e54fe5b0f43758f7(schema, ctx);
        $e78123e42965e820$export$ba2613251eadea93(ctx, schema);
        return $e78123e42965e820$export$578723aef62d92f5(ctx, schema);
    };




const $fb6286dd552db993$var$formatMap = {
    guid: "uuid",
    url: "uri",
    datetime: "date-time",
    json_string: "json-string",
    regex: ""
};
const $fb6286dd552db993$export$c6950985d9de996d = (schema, ctx, _json, _params)=>{
    const json = _json;
    json.type = "string";
    const { minimum: minimum, maximum: maximum, format: format, patterns: patterns, contentEncoding: contentEncoding } = schema._zod.bag;
    if (typeof minimum === "number") json.minLength = minimum;
    if (typeof maximum === "number") json.maxLength = maximum;
    // custom pattern overrides format
    if (format) {
        json.format = $fb6286dd552db993$var$formatMap[format] ?? format;
        if (json.format === "") delete json.format; // empty format is not valid
        // JSON Schema format: "time" requires a full time with offset or Z
        // z.iso.time() does not include timezone information, so format: "time" should never be used
        if (format === "time") delete json.format;
    }
    if (contentEncoding) json.contentEncoding = contentEncoding;
    if (patterns && patterns.size > 0) {
        const regexes = [
            ...patterns
        ];
        if (regexes.length === 1) json.pattern = regexes[0].source;
        else if (regexes.length > 1) json.allOf = [
            ...regexes.map((regex)=>({
                    ...ctx.target === "draft-07" || ctx.target === "draft-04" || ctx.target === "openapi-3.0" ? {
                        type: "string"
                    } : {},
                    pattern: regex.source
                }))
        ];
    }
};
const $fb6286dd552db993$export$afd08f475b2e134f = (schema, ctx, _json, _params)=>{
    const json = _json;
    const { minimum: minimum, maximum: maximum, format: format, multipleOf: multipleOf, exclusiveMaximum: exclusiveMaximum, exclusiveMinimum: exclusiveMinimum } = schema._zod.bag;
    if (typeof format === "string" && format.includes("int")) json.type = "integer";
    else json.type = "number";
    if (typeof exclusiveMinimum === "number") {
        if (ctx.target === "draft-04" || ctx.target === "openapi-3.0") {
            json.minimum = exclusiveMinimum;
            json.exclusiveMinimum = true;
        } else json.exclusiveMinimum = exclusiveMinimum;
    }
    if (typeof minimum === "number") {
        json.minimum = minimum;
        if (typeof exclusiveMinimum === "number" && ctx.target !== "draft-04") {
            if (exclusiveMinimum >= minimum) delete json.minimum;
            else delete json.exclusiveMinimum;
        }
    }
    if (typeof exclusiveMaximum === "number") {
        if (ctx.target === "draft-04" || ctx.target === "openapi-3.0") {
            json.maximum = exclusiveMaximum;
            json.exclusiveMaximum = true;
        } else json.exclusiveMaximum = exclusiveMaximum;
    }
    if (typeof maximum === "number") {
        json.maximum = maximum;
        if (typeof exclusiveMaximum === "number" && ctx.target !== "draft-04") {
            if (exclusiveMaximum <= maximum) delete json.maximum;
            else delete json.exclusiveMaximum;
        }
    }
    if (typeof multipleOf === "number") json.multipleOf = multipleOf;
};
const $fb6286dd552db993$export$f03e9163a5233fc4 = (_schema, _ctx, json, _params)=>{
    json.type = "boolean";
};
const $fb6286dd552db993$export$8810d61ae56edc9c = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("BigInt cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$fd2b3c73524160ce = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("Symbols cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$7667b76b86382b1f = (_schema, ctx, json, _params)=>{
    if (ctx.target === "openapi-3.0") {
        json.type = "string";
        json.nullable = true;
        json.enum = [
            null
        ];
    } else json.type = "null";
};
const $fb6286dd552db993$export$9838a7ce212344b0 = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("Undefined cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$b5910bb267c78233 = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("Void cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$694b9cd80480ac33 = (_schema, _ctx, json, _params)=>{
    json.not = {};
};
const $fb6286dd552db993$export$a92de72ffd9087b5 = (_schema, _ctx, _json, _params)=>{
// empty schema accepts anything
};
const $fb6286dd552db993$export$4e1fea7b2e7474f = (_schema, _ctx, _json, _params)=>{
// empty schema accepts anything
};
const $fb6286dd552db993$export$d044e6246fe40d06 = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("Date cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$a0f7e3681bbe4f0b = (schema, _ctx, json, _params)=>{
    const def = schema._zod.def;
    const values = (0, $17ea3f861a2ff584$export$70a5d58ec00f3c11)(def.entries);
    // Number enums can have both string and number values
    if (values.every((v)=>typeof v === "number")) json.type = "number";
    if (values.every((v)=>typeof v === "string")) json.type = "string";
    json.enum = values;
};
const $fb6286dd552db993$export$b7a483a046d3a9b = (schema, ctx, json, _params)=>{
    const def = schema._zod.def;
    const vals = [];
    for (const val of def.values){
        if (val === undefined) {
            if (ctx.unrepresentable === "throw") throw new Error("Literal `undefined` cannot be represented in JSON Schema");
        } else if (typeof val === "bigint") {
            if (ctx.unrepresentable === "throw") throw new Error("BigInt literals cannot be represented in JSON Schema");
            else vals.push(Number(val));
        } else vals.push(val);
    }
    if (vals.length === 0) ;
    else if (vals.length === 1) {
        const val = vals[0];
        json.type = val === null ? "null" : typeof val;
        if (ctx.target === "draft-04" || ctx.target === "openapi-3.0") json.enum = [
            val
        ];
        else json.const = val;
    } else {
        if (vals.every((v)=>typeof v === "number")) json.type = "number";
        if (vals.every((v)=>typeof v === "string")) json.type = "string";
        if (vals.every((v)=>typeof v === "boolean")) json.type = "boolean";
        if (vals.every((v)=>v === null)) json.type = "null";
        json.enum = vals;
    }
};
const $fb6286dd552db993$export$f33d8739d51ecc4b = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("NaN cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$59812826ec9f1850 = (schema, _ctx, json, _params)=>{
    const _json = json;
    const pattern = schema._zod.pattern;
    if (!pattern) throw new Error("Pattern not found in template literal");
    _json.type = "string";
    _json.pattern = pattern.source;
};
const $fb6286dd552db993$export$62de47a40c7b42b0 = (schema, _ctx, json, _params)=>{
    const _json = json;
    const file = {
        type: "string",
        format: "binary",
        contentEncoding: "binary"
    };
    const { minimum: minimum, maximum: maximum, mime: mime } = schema._zod.bag;
    if (minimum !== undefined) file.minLength = minimum;
    if (maximum !== undefined) file.maxLength = maximum;
    if (mime) {
        if (mime.length === 1) {
            file.contentMediaType = mime[0];
            Object.assign(_json, file);
        } else {
            Object.assign(_json, file); // shared props at root
            _json.anyOf = mime.map((m)=>({
                    contentMediaType: m
                })); // only contentMediaType differs
        }
    } else Object.assign(_json, file);
};
const $fb6286dd552db993$export$1e296a49315ba27a = (_schema, _ctx, json, _params)=>{
    json.type = "boolean";
};
const $fb6286dd552db993$export$fe3af043a76e4dab = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("Custom types cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$654f185ba88226ab = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("Function types cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$707b17683f9c9ec0 = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("Transforms cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$5e912d1710885757 = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("Map cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$2ff44e7a32269271 = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("Set cannot be represented in JSON Schema");
};
const $fb6286dd552db993$export$afeff382d55f455b = (schema, ctx, _json, params)=>{
    const json = _json;
    const def = schema._zod.def;
    const { minimum: minimum, maximum: maximum } = schema._zod.bag;
    if (typeof minimum === "number") json.minItems = minimum;
    if (typeof maximum === "number") json.maxItems = maximum;
    json.type = "array";
    json.items = (0, $e78123e42965e820$export$e54fe5b0f43758f7)(def.element, ctx, {
        ...params,
        path: [
            ...params.path,
            "items"
        ]
    });
};
const $fb6286dd552db993$export$8cc078cf99794668 = (schema, ctx, _json, params)=>{
    const json = _json;
    const def = schema._zod.def;
    json.type = "object";
    json.properties = {};
    const shape = def.shape;
    for(const key in shape)json.properties[key] = (0, $e78123e42965e820$export$e54fe5b0f43758f7)(shape[key], ctx, {
        ...params,
        path: [
            ...params.path,
            "properties",
            key
        ]
    });
    // required keys
    const allKeys = new Set(Object.keys(shape));
    const requiredKeys = new Set([
        ...allKeys
    ].filter((key)=>{
        const v = def.shape[key]._zod;
        if (ctx.io === "input") return v.optin === undefined;
        else return v.optout === undefined;
    }));
    if (requiredKeys.size > 0) json.required = Array.from(requiredKeys);
    // catchall
    if (def.catchall?._zod.def.type === "never") // strict
    json.additionalProperties = false;
    else if (!def.catchall) // regular
    {
        if (ctx.io === "output") json.additionalProperties = false;
    } else if (def.catchall) json.additionalProperties = (0, $e78123e42965e820$export$e54fe5b0f43758f7)(def.catchall, ctx, {
        ...params,
        path: [
            ...params.path,
            "additionalProperties"
        ]
    });
};
const $fb6286dd552db993$export$f387dff1d8008b49 = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    // Exclusive unions (inclusive === false) use oneOf (exactly one match) instead of anyOf (one or more matches)
    // This includes both z.xor() and discriminated unions
    const isExclusive = def.inclusive === false;
    const options = def.options.map((x, i)=>(0, $e78123e42965e820$export$e54fe5b0f43758f7)(x, ctx, {
            ...params,
            path: [
                ...params.path,
                isExclusive ? "oneOf" : "anyOf",
                i
            ]
        }));
    if (isExclusive) json.oneOf = options;
    else json.anyOf = options;
};
const $fb6286dd552db993$export$2a29f9128b7167c3 = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    const a = (0, $e78123e42965e820$export$e54fe5b0f43758f7)(def.left, ctx, {
        ...params,
        path: [
            ...params.path,
            "allOf",
            0
        ]
    });
    const b = (0, $e78123e42965e820$export$e54fe5b0f43758f7)(def.right, ctx, {
        ...params,
        path: [
            ...params.path,
            "allOf",
            1
        ]
    });
    const isSimpleIntersection = (val)=>"allOf" in val && Object.keys(val).length === 1;
    const allOf = [
        ...isSimpleIntersection(a) ? a.allOf : [
            a
        ],
        ...isSimpleIntersection(b) ? b.allOf : [
            b
        ]
    ];
    json.allOf = allOf;
};
const $fb6286dd552db993$export$7767a398545ac85c = (schema, ctx, _json, params)=>{
    const json = _json;
    const def = schema._zod.def;
    json.type = "array";
    const prefixPath = ctx.target === "draft-2020-12" ? "prefixItems" : "items";
    const restPath = ctx.target === "draft-2020-12" ? "items" : ctx.target === "openapi-3.0" ? "items" : "additionalItems";
    const prefixItems = def.items.map((x, i)=>(0, $e78123e42965e820$export$e54fe5b0f43758f7)(x, ctx, {
            ...params,
            path: [
                ...params.path,
                prefixPath,
                i
            ]
        }));
    const rest = def.rest ? (0, $e78123e42965e820$export$e54fe5b0f43758f7)(def.rest, ctx, {
        ...params,
        path: [
            ...params.path,
            restPath,
            ...ctx.target === "openapi-3.0" ? [
                def.items.length
            ] : []
        ]
    }) : null;
    if (ctx.target === "draft-2020-12") {
        json.prefixItems = prefixItems;
        if (rest) json.items = rest;
    } else if (ctx.target === "openapi-3.0") {
        json.items = {
            anyOf: prefixItems
        };
        if (rest) json.items.anyOf.push(rest);
        json.minItems = prefixItems.length;
        if (!rest) json.maxItems = prefixItems.length;
    } else {
        json.items = prefixItems;
        if (rest) json.additionalItems = rest;
    }
    // length
    const { minimum: minimum, maximum: maximum } = schema._zod.bag;
    if (typeof minimum === "number") json.minItems = minimum;
    if (typeof maximum === "number") json.maxItems = maximum;
};
const $fb6286dd552db993$export$6cf7a4b4a95ef1a8 = (schema, ctx, _json, params)=>{
    const json = _json;
    const def = schema._zod.def;
    json.type = "object";
    // For looseRecord with regex patterns, use patternProperties
    // This correctly represents "only validate keys matching the pattern" semantics
    // and composes well with allOf (intersections)
    const keyType = def.keyType;
    const keyBag = keyType._zod.bag;
    const patterns = keyBag?.patterns;
    if (def.mode === "loose" && patterns && patterns.size > 0) {
        // Use patternProperties for looseRecord with regex patterns
        const valueSchema = (0, $e78123e42965e820$export$e54fe5b0f43758f7)(def.valueType, ctx, {
            ...params,
            path: [
                ...params.path,
                "patternProperties",
                "*"
            ]
        });
        json.patternProperties = {};
        for (const pattern of patterns)json.patternProperties[pattern.source] = valueSchema;
    } else {
        // Default behavior: use propertyNames + additionalProperties
        if (ctx.target === "draft-07" || ctx.target === "draft-2020-12") json.propertyNames = (0, $e78123e42965e820$export$e54fe5b0f43758f7)(def.keyType, ctx, {
            ...params,
            path: [
                ...params.path,
                "propertyNames"
            ]
        });
        json.additionalProperties = (0, $e78123e42965e820$export$e54fe5b0f43758f7)(def.valueType, ctx, {
            ...params,
            path: [
                ...params.path,
                "additionalProperties"
            ]
        });
    }
    // Add required for keys with discrete values (enum, literal, etc.)
    const keyValues = keyType._zod.values;
    if (keyValues) {
        const validKeyValues = [
            ...keyValues
        ].filter((v)=>typeof v === "string" || typeof v === "number");
        if (validKeyValues.length > 0) json.required = validKeyValues;
    }
};
const $fb6286dd552db993$export$452ce6f96b49219a = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    const inner = (0, $e78123e42965e820$export$e54fe5b0f43758f7)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    if (ctx.target === "openapi-3.0") {
        seen.ref = def.innerType;
        json.nullable = true;
    } else json.anyOf = [
        inner,
        {
            type: "null"
        }
    ];
};
const $fb6286dd552db993$export$7c6ac5b60b42bfc9 = (schema, ctx, _json, params)=>{
    const def = schema._zod.def;
    (0, $e78123e42965e820$export$e54fe5b0f43758f7)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
};
const $fb6286dd552db993$export$f76e6c36e8fb062b = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    (0, $e78123e42965e820$export$e54fe5b0f43758f7)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
    json.default = JSON.parse(JSON.stringify(def.defaultValue));
};
const $fb6286dd552db993$export$1ded4e432f286ac2 = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    (0, $e78123e42965e820$export$e54fe5b0f43758f7)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
    if (ctx.io === "input") json._prefault = JSON.parse(JSON.stringify(def.defaultValue));
};
const $fb6286dd552db993$export$3f81793c903cb504 = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    (0, $e78123e42965e820$export$e54fe5b0f43758f7)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
    let catchValue;
    try {
        catchValue = def.catchValue(undefined);
    } catch  {
        throw new Error("Dynamic catch values are not supported in JSON Schema");
    }
    json.default = catchValue;
};
const $fb6286dd552db993$export$3a3e6911d4012a24 = (schema, ctx, _json, params)=>{
    const def = schema._zod.def;
    const innerType = ctx.io === "input" ? def.in._zod.def.type === "transform" ? def.out : def.in : def.out;
    (0, $e78123e42965e820$export$e54fe5b0f43758f7)(innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = innerType;
};
const $fb6286dd552db993$export$dd90252c562e1d9 = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    (0, $e78123e42965e820$export$e54fe5b0f43758f7)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
    json.readOnly = true;
};
const $fb6286dd552db993$export$ecb899a95fe4bdc0 = (schema, ctx, _json, params)=>{
    const def = schema._zod.def;
    (0, $e78123e42965e820$export$e54fe5b0f43758f7)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
};
const $fb6286dd552db993$export$4b1db46aa3739c48 = (schema, ctx, _json, params)=>{
    const def = schema._zod.def;
    (0, $e78123e42965e820$export$e54fe5b0f43758f7)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
};
const $fb6286dd552db993$export$9980155f320c317b = (schema, ctx, _json, params)=>{
    const innerType = schema._zod.innerType;
    (0, $e78123e42965e820$export$e54fe5b0f43758f7)(innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = innerType;
};
const $fb6286dd552db993$export$e462eec3d35f5c06 = {
    string: $fb6286dd552db993$export$c6950985d9de996d,
    number: $fb6286dd552db993$export$afd08f475b2e134f,
    boolean: $fb6286dd552db993$export$f03e9163a5233fc4,
    bigint: $fb6286dd552db993$export$8810d61ae56edc9c,
    symbol: $fb6286dd552db993$export$fd2b3c73524160ce,
    null: $fb6286dd552db993$export$7667b76b86382b1f,
    undefined: $fb6286dd552db993$export$9838a7ce212344b0,
    void: $fb6286dd552db993$export$b5910bb267c78233,
    never: $fb6286dd552db993$export$694b9cd80480ac33,
    any: $fb6286dd552db993$export$a92de72ffd9087b5,
    unknown: $fb6286dd552db993$export$4e1fea7b2e7474f,
    date: $fb6286dd552db993$export$d044e6246fe40d06,
    enum: $fb6286dd552db993$export$a0f7e3681bbe4f0b,
    literal: $fb6286dd552db993$export$b7a483a046d3a9b,
    nan: $fb6286dd552db993$export$f33d8739d51ecc4b,
    template_literal: $fb6286dd552db993$export$59812826ec9f1850,
    file: $fb6286dd552db993$export$62de47a40c7b42b0,
    success: $fb6286dd552db993$export$1e296a49315ba27a,
    custom: $fb6286dd552db993$export$fe3af043a76e4dab,
    function: $fb6286dd552db993$export$654f185ba88226ab,
    transform: $fb6286dd552db993$export$707b17683f9c9ec0,
    map: $fb6286dd552db993$export$5e912d1710885757,
    set: $fb6286dd552db993$export$2ff44e7a32269271,
    array: $fb6286dd552db993$export$afeff382d55f455b,
    object: $fb6286dd552db993$export$8cc078cf99794668,
    union: $fb6286dd552db993$export$f387dff1d8008b49,
    intersection: $fb6286dd552db993$export$2a29f9128b7167c3,
    tuple: $fb6286dd552db993$export$7767a398545ac85c,
    record: $fb6286dd552db993$export$6cf7a4b4a95ef1a8,
    nullable: $fb6286dd552db993$export$452ce6f96b49219a,
    nonoptional: $fb6286dd552db993$export$7c6ac5b60b42bfc9,
    default: $fb6286dd552db993$export$f76e6c36e8fb062b,
    prefault: $fb6286dd552db993$export$1ded4e432f286ac2,
    catch: $fb6286dd552db993$export$3f81793c903cb504,
    pipe: $fb6286dd552db993$export$3a3e6911d4012a24,
    readonly: $fb6286dd552db993$export$dd90252c562e1d9,
    promise: $fb6286dd552db993$export$ecb899a95fe4bdc0,
    optional: $fb6286dd552db993$export$4b1db46aa3739c48,
    lazy: $fb6286dd552db993$export$9980155f320c317b
};
function $fb6286dd552db993$export$395d8e19463d4f49(input, params) {
    if ("_idmap" in input) {
        // Registry case
        const registry = input;
        const ctx = (0, $e78123e42965e820$export$881f7fb71351b304)({
            ...params,
            processors: $fb6286dd552db993$export$e462eec3d35f5c06
        });
        const defs = {};
        // First pass: process all schemas to build the seen map
        for (const entry of registry._idmap.entries()){
            const [_, schema] = entry;
            (0, $e78123e42965e820$export$e54fe5b0f43758f7)(schema, ctx);
        }
        const schemas = {};
        const external = {
            registry: registry,
            uri: params?.uri,
            defs: defs
        };
        // Update the context with external configuration
        ctx.external = external;
        // Second pass: emit each schema
        for (const entry of registry._idmap.entries()){
            const [key, schema] = entry;
            (0, $e78123e42965e820$export$ba2613251eadea93)(ctx, schema);
            schemas[key] = (0, $e78123e42965e820$export$578723aef62d92f5)(ctx, schema);
        }
        if (Object.keys(defs).length > 0) {
            const defsSegment = ctx.target === "draft-2020-12" ? "$defs" : "definitions";
            schemas.__shared = {
                [defsSegment]: defs
            };
        }
        return {
            schemas: schemas
        };
    }
    // Single schema case
    const ctx = (0, $e78123e42965e820$export$881f7fb71351b304)({
        ...params,
        processors: $fb6286dd552db993$export$e462eec3d35f5c06
    });
    (0, $e78123e42965e820$export$e54fe5b0f43758f7)(input, ctx);
    (0, $e78123e42965e820$export$ba2613251eadea93)(ctx, input);
    return (0, $e78123e42965e820$export$578723aef62d92f5)(ctx, input);
}




class $1d9ae53941015e0e$export$1b2196b107de679 {
    /** @deprecated Access via ctx instead */ get metadataRegistry() {
        return this.ctx.metadataRegistry;
    }
    /** @deprecated Access via ctx instead */ get target() {
        return this.ctx.target;
    }
    /** @deprecated Access via ctx instead */ get unrepresentable() {
        return this.ctx.unrepresentable;
    }
    /** @deprecated Access via ctx instead */ get override() {
        return this.ctx.override;
    }
    /** @deprecated Access via ctx instead */ get io() {
        return this.ctx.io;
    }
    /** @deprecated Access via ctx instead */ get counter() {
        return this.ctx.counter;
    }
    set counter(value) {
        this.ctx.counter = value;
    }
    /** @deprecated Access via ctx instead */ get seen() {
        return this.ctx.seen;
    }
    constructor(params){
        // Normalize target for internal context
        let normalizedTarget = params?.target ?? "draft-2020-12";
        if (normalizedTarget === "draft-4") normalizedTarget = "draft-04";
        if (normalizedTarget === "draft-7") normalizedTarget = "draft-07";
        this.ctx = (0, $e78123e42965e820$export$881f7fb71351b304)({
            processors: (0, $fb6286dd552db993$export$e462eec3d35f5c06),
            target: normalizedTarget,
            ...params?.metadata && {
                metadata: params.metadata
            },
            ...params?.unrepresentable && {
                unrepresentable: params.unrepresentable
            },
            ...params?.override && {
                override: params.override
            },
            ...params?.io && {
                io: params.io
            }
        });
    }
    /**
     * Process a schema to prepare it for JSON Schema generation.
     * This must be called before emit().
     */ process(schema, _params = {
        path: [],
        schemaPath: []
    }) {
        return (0, $e78123e42965e820$export$e54fe5b0f43758f7)(schema, this.ctx, _params);
    }
    /**
     * Emit the final JSON Schema after processing.
     * Must call process() first.
     */ emit(schema, _params) {
        // Apply emit params to the context
        if (_params) {
            if (_params.cycles) this.ctx.cycles = _params.cycles;
            if (_params.reused) this.ctx.reused = _params.reused;
            if (_params.external) this.ctx.external = _params.external;
        }
        (0, $e78123e42965e820$export$ba2613251eadea93)(this.ctx, schema);
        const result = (0, $e78123e42965e820$export$578723aef62d92f5)(this.ctx, schema);
        // Strip ~standard property to match old implementation's return type
        const { "~standard": _, ...plainResult } = result;
        return plainResult;
    }
}






function $0591fe66d7f046a7$var$t(r, e) {
    try {
        var o = r();
    } catch (r) {
        return e(r);
    }
    return o && o.then ? o.then(void 0, e) : o;
}
function $0591fe66d7f046a7$var$s(r, e) {
    for(var n = {}; r.length;){
        var t = r[0], s = t.code, i = t.message, a = t.path.join(".");
        if (!n[a]) {
            if ("unionErrors" in t) {
                var u = t.unionErrors[0].errors[0];
                n[a] = {
                    message: u.message,
                    type: u.code
                };
            } else n[a] = {
                message: i,
                type: s
            };
        }
        if ("unionErrors" in t && t.unionErrors.forEach(function(e) {
            return e.errors.forEach(function(e) {
                return r.push(e);
            });
        }), e) {
            var c = n[a].types, f = c && c[t.code];
            n[a] = (0, $0d70f179cf56e662$export$b196c2a4f765bd30)(a, e, n, s, f ? [].concat(f, t.message) : t.message);
        }
        r.shift();
    }
    return n;
}
function $0591fe66d7f046a7$var$i(r, e) {
    for(var n = {}; r.length;){
        var t = r[0], s = t.code, i = t.message, a = t.path.join(".");
        if (!n[a]) {
            if ("invalid_union" === t.code && t.errors.length > 0) {
                var u = t.errors[0][0];
                n[a] = {
                    message: u.message,
                    type: u.code
                };
            } else n[a] = {
                message: i,
                type: s
            };
        }
        if ("invalid_union" === t.code && t.errors.forEach(function(e) {
            return e.forEach(function(e) {
                return r.push(e);
            });
        }), e) {
            var c = n[a].types, f = c && c[t.code];
            n[a] = (0, $0d70f179cf56e662$export$b196c2a4f765bd30)(a, e, n, s, f ? [].concat(f, t.message) : t.message);
        }
        r.shift();
    }
    return n;
}
function $0591fe66d7f046a7$export$66b7b5879c70f722(o, a, u) {
    if (void 0 === u && (u = {}), function(r) {
        return "_def" in r && "object" == typeof r._def && "typeName" in r._def;
    }(o)) return function(n, i, c) {
        try {
            return Promise.resolve($0591fe66d7f046a7$var$t(function() {
                return Promise.resolve(o["sync" === u.mode ? "parse" : "parseAsync"](n, a)).then(function(e) {
                    return c.shouldUseNativeValidation && (0, $629af589066638cc$export$6bd436d70894afff)({}, c), {
                        errors: {},
                        values: u.raw ? Object.assign({}, n) : e
                    };
                });
            }, function(r) {
                if (function(r) {
                    return Array.isArray(null == r ? void 0 : r.issues);
                }(r)) return {
                    values: {},
                    errors: (0, $629af589066638cc$export$f0545b73a179e3a2)($0591fe66d7f046a7$var$s(r.errors, !c.shouldUseNativeValidation && "all" === c.criteriaMode), c)
                };
                throw r;
            }));
        } catch (r) {
            return Promise.reject(r);
        }
    };
    if (function(r) {
        return "_zod" in r && "object" == typeof r._zod;
    }(o)) return function(s, c, f) {
        try {
            return Promise.resolve($0591fe66d7f046a7$var$t(function() {
                return Promise.resolve(("sync" === u.mode ? $3bba9a623c1bec43$export$98e6a39c04603d36 : $3bba9a623c1bec43$export$59b6f938fbf579e3)(o, s, a)).then(function(e) {
                    return f.shouldUseNativeValidation && (0, $629af589066638cc$export$6bd436d70894afff)({}, f), {
                        errors: {},
                        values: u.raw ? Object.assign({}, s) : e
                    };
                });
            }, function(r) {
                if (function(r) {
                    return r instanceof $0b6c05566f4aeada$export$544878318730b1d8;
                }(r)) return {
                    values: {},
                    errors: (0, $629af589066638cc$export$f0545b73a179e3a2)($0591fe66d7f046a7$var$i(r.issues, !f.shouldUseNativeValidation && "all" === f.criteriaMode), f)
                };
                throw r;
            }));
        } catch (r) {
            return Promise.reject(r);
        }
    };
    throw new Error("Invalid input: not a Zod schema");
}


var $bebb5f3cb64a9781$exports = {};
!function(t, e) {
    $bebb5f3cb64a9781$exports = e();
}($bebb5f3cb64a9781$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


var $a05dabb57d62d821$exports = {};
!function(t, e) {
    $a05dabb57d62d821$exports = e();
}($a05dabb57d62d821$exports, function() {
    "use strict";
    var t = {
        year: 0,
        month: 1,
        day: 2,
        hour: 3,
        minute: 4,
        second: 5
    }, e = {};
    return function(n, i, o) {
        var r, a = function(t, n, i) {
            void 0 === i && (i = {});
            var o = new Date(t), r = function(t, n) {
                void 0 === n && (n = {});
                var i = n.timeZoneName || "short", o = t + "|" + i, r = e[o];
                return r || (r = new Intl.DateTimeFormat("en-US", {
                    hour12: !1,
                    timeZone: t,
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    timeZoneName: i
                }), e[o] = r), r;
            }(n, i);
            return r.formatToParts(o);
        }, u = function(e, n) {
            for(var i = a(e, n), r = [], u = 0; u < i.length; u += 1){
                var f = i[u], s = f.type, m = f.value, c = t[s];
                c >= 0 && (r[c] = parseInt(m, 10));
            }
            var d = r[3], l = 24 === d ? 0 : d, h = r[0] + "-" + r[1] + "-" + r[2] + " " + l + ":" + r[4] + ":" + r[5] + ":000", v = +e;
            return (o.utc(h).valueOf() - (v -= v % 1e3)) / 6e4;
        }, f = i.prototype;
        f.tz = function(t, e) {
            void 0 === t && (t = r);
            var n, i = this.utcOffset(), a = this.toDate(), u = a.toLocaleString("en-US", {
                timeZone: t
            }), f = Math.round((a - new Date(u)) / 1e3 / 60), s = 15 * -Math.round(a.getTimezoneOffset() / 15) - f;
            if (!Number(s)) n = this.utcOffset(0, e);
            else if (n = o(u, {
                locale: this.$L
            }).$set("millisecond", this.$ms).utcOffset(s, !0), e) {
                var m = n.utcOffset();
                n = n.add(i - m, "minute");
            }
            return n.$x.$timezone = t, n;
        }, f.offsetName = function(t) {
            var e = this.$x.$timezone || o.tz.guess(), n = a(this.valueOf(), e, {
                timeZoneName: t
            }).find(function(t) {
                return "timezonename" === t.type.toLowerCase();
            });
            return n && n.value;
        };
        var s = f.startOf;
        f.startOf = function(t, e) {
            if (!this.$x || !this.$x.$timezone) return s.call(this, t, e);
            var n = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), {
                locale: this.$L
            });
            return s.call(n, t, e).tz(this.$x.$timezone, !0);
        }, o.tz = function(t, e, n) {
            var i = n && e, a = n || e || r, f = u(+o(), a);
            if ("string" != typeof t) return o(t).tz(a);
            var s = function(t, e, n) {
                var i = t - 60 * e * 1e3, o = u(i, n);
                if (e === o) return [
                    i,
                    e
                ];
                var r = u(i -= 60 * (o - e) * 1e3, n);
                return o === r ? [
                    i,
                    o
                ] : [
                    t - 60 * Math.min(o, r) * 1e3,
                    Math.max(o, r)
                ];
            }(o.utc(t, i).valueOf(), f, a), m = s[0], c = s[1], d = o(m).utcOffset(c);
            return d.$x.$timezone = a, d;
        }, o.tz.guess = function() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function(t) {
            r = t;
        };
    };
});



parcelRequire("acw62");
const $579305e6f01660e1$var$SvgTimeGoneIcon = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 41,
        fill: "none",
        viewBox: "0 0 40 41",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M36 36.9c0-1.132-.895-2.05-2-2.05h-2.28l2.424-7.452-3.666-3.757c2.166-2.06 3.522-5 3.522-8.266C34 9.148 29.075 4.1 23 4.1S12 9.148 12 15.375c0 3.266 1.356 6.207 3.522 8.266L12.73 26.5 4 23.52v7.23c1.104 0 2-.917 2-2.05v-2.335l7.27 2.484 3.85-3.946A10.76 10.76 0 0 0 23 26.65c2.163 0 4.18-.643 5.88-1.748l2.976 3.05-2.91 8.948zM24 16.4h-6v-2.05h4V8.2h2z"
        })
    });
var $579305e6f01660e1$export$2e2bcd8739ae039 = $579305e6f01660e1$var$SvgTimeGoneIcon;



var $acw62 = parcelRequire("acw62");



var $09193e81812ba154$exports = {};

$parcel$export($09193e81812ba154$exports, "ZodType", () => $09193e81812ba154$export$2afb8ab49d4b92c0);
$parcel$export($09193e81812ba154$exports, "refine", () => $09193e81812ba154$export$edc9d475108b3212);
$parcel$export($09193e81812ba154$exports, "superRefine", () => $09193e81812ba154$export$e0f31df04c32a6bf);
$parcel$export($09193e81812ba154$exports, "optional", () => $09193e81812ba154$export$516e28dec6a4b6d4);
$parcel$export($09193e81812ba154$exports, "exactOptional", () => $09193e81812ba154$export$76092ad52134d3a0);
$parcel$export($09193e81812ba154$exports, "nullable", () => $09193e81812ba154$export$133fc36489ac9add);
$parcel$export($09193e81812ba154$exports, "nonoptional", () => $09193e81812ba154$export$e6aa51fdda6cd70d);
$parcel$export($09193e81812ba154$exports, "array", () => $09193e81812ba154$export$2f23118c22fb2630);
$parcel$export($09193e81812ba154$exports, "union", () => $09193e81812ba154$export$971dd5b0dfd021b6);
$parcel$export($09193e81812ba154$exports, "intersection", () => $09193e81812ba154$export$bc86dfbf7795668c);
$parcel$export($09193e81812ba154$exports, "pipe", () => $09193e81812ba154$export$a4627e546088548d);
$parcel$export($09193e81812ba154$exports, "transform", () => $09193e81812ba154$export$51186ad6e864892a);
$parcel$export($09193e81812ba154$exports, "_default", () => $09193e81812ba154$export$d4b0f68d0d916971);
$parcel$export($09193e81812ba154$exports, "prefault", () => $09193e81812ba154$export$569da376ae266d0a);
$parcel$export($09193e81812ba154$exports, "catch", () => $09193e81812ba154$export$e1d4808a6ac94c4c);
$parcel$export($09193e81812ba154$exports, "readonly", () => $09193e81812ba154$export$6ec456bd5b7b3c51);
$parcel$export($09193e81812ba154$exports, "_ZodString", () => $09193e81812ba154$export$f6d83ce3dacef2be);
$parcel$export($09193e81812ba154$exports, "ZodString", () => $09193e81812ba154$export$1230eb29b8d3b502);
$parcel$export($09193e81812ba154$exports, "ZodEmail", () => $09193e81812ba154$export$770096fb2a685237);
$parcel$export($09193e81812ba154$exports, "ZodURL", () => $09193e81812ba154$export$82127fa72e650526);
$parcel$export($09193e81812ba154$exports, "ZodJWT", () => $09193e81812ba154$export$5c0d807bd77507f);
$parcel$export($09193e81812ba154$exports, "ZodEmoji", () => $09193e81812ba154$export$f072c1a26a31d55b);
$parcel$export($09193e81812ba154$exports, "ZodGUID", () => $09193e81812ba154$export$2827a6bad660427b);
$parcel$export($09193e81812ba154$exports, "ZodUUID", () => $09193e81812ba154$export$7ee22ce365e4d3b5);
$parcel$export($09193e81812ba154$exports, "ZodNanoID", () => $09193e81812ba154$export$9e180e3f910c7773);
$parcel$export($09193e81812ba154$exports, "ZodCUID", () => $09193e81812ba154$export$c6b7c3c30ab9362e);
$parcel$export($09193e81812ba154$exports, "ZodCUID2", () => $09193e81812ba154$export$536dc9ce9eec8565);
$parcel$export($09193e81812ba154$exports, "ZodULID", () => $09193e81812ba154$export$a060914fca5da3d4);
$parcel$export($09193e81812ba154$exports, "ZodBase64", () => $09193e81812ba154$export$237b9f5cee85a1c1);
$parcel$export($09193e81812ba154$exports, "ZodBase64URL", () => $09193e81812ba154$export$62a2e9135a9e2356);
$parcel$export($09193e81812ba154$exports, "ZodXID", () => $09193e81812ba154$export$d53bc3b8251fa017);
$parcel$export($09193e81812ba154$exports, "ZodKSUID", () => $09193e81812ba154$export$1bbac5f87dca43e4);
$parcel$export($09193e81812ba154$exports, "ZodIPv4", () => $09193e81812ba154$export$567930edb18e0c3a);
$parcel$export($09193e81812ba154$exports, "ZodIPv6", () => $09193e81812ba154$export$75c5c5fd479ecddf);
$parcel$export($09193e81812ba154$exports, "ZodCIDRv4", () => $09193e81812ba154$export$ac524bc9ec5fac50);
$parcel$export($09193e81812ba154$exports, "ZodCIDRv6", () => $09193e81812ba154$export$b8cae7a616378f16);
$parcel$export($09193e81812ba154$exports, "ZodE164", () => $09193e81812ba154$export$fac79817565ec0f7);
$parcel$export($09193e81812ba154$exports, "string", () => $09193e81812ba154$export$22b082955e083ec3);
$parcel$export($09193e81812ba154$exports, "ZodStringFormat", () => $09193e81812ba154$export$6f00fc81f4be18e5);
$parcel$export($09193e81812ba154$exports, "email", () => $09193e81812ba154$export$d290fa47940df19d);
$parcel$export($09193e81812ba154$exports, "guid", () => $09193e81812ba154$export$46e8f25c7328f77e);
$parcel$export($09193e81812ba154$exports, "uuid", () => $09193e81812ba154$export$31b40729666a4ae0);
$parcel$export($09193e81812ba154$exports, "uuidv4", () => $09193e81812ba154$export$abe4376e1bf796d6);
$parcel$export($09193e81812ba154$exports, "uuidv6", () => $09193e81812ba154$export$b1fe4fcff87f98e5);
$parcel$export($09193e81812ba154$exports, "uuidv7", () => $09193e81812ba154$export$a7b512db306b38d7);
$parcel$export($09193e81812ba154$exports, "url", () => $09193e81812ba154$export$128fa18b7194ef);
$parcel$export($09193e81812ba154$exports, "httpUrl", () => $09193e81812ba154$export$cddedb4cb7866be8);
$parcel$export($09193e81812ba154$exports, "emoji", () => $09193e81812ba154$export$a19185d1233fc4b2);
$parcel$export($09193e81812ba154$exports, "nanoid", () => $09193e81812ba154$export$ac4959f4f1338dfc);
$parcel$export($09193e81812ba154$exports, "cuid", () => $09193e81812ba154$export$e057ec210c7d3443);
$parcel$export($09193e81812ba154$exports, "cuid2", () => $09193e81812ba154$export$af5866a6cccce9f0);
$parcel$export($09193e81812ba154$exports, "ulid", () => $09193e81812ba154$export$c34778236461ea95);
$parcel$export($09193e81812ba154$exports, "xid", () => $09193e81812ba154$export$5eecaf20006cb6cb);
$parcel$export($09193e81812ba154$exports, "ksuid", () => $09193e81812ba154$export$f49b11deeb9beb0f);
$parcel$export($09193e81812ba154$exports, "ipv4", () => $09193e81812ba154$export$291a17a16047f284);
$parcel$export($09193e81812ba154$exports, "ZodMAC", () => $09193e81812ba154$export$cb4c1bda006648e3);
$parcel$export($09193e81812ba154$exports, "mac", () => $09193e81812ba154$export$f8d11e097856efcf);
$parcel$export($09193e81812ba154$exports, "ipv6", () => $09193e81812ba154$export$4e0c86a59c658526);
$parcel$export($09193e81812ba154$exports, "cidrv4", () => $09193e81812ba154$export$fc96793d9715e5a1);
$parcel$export($09193e81812ba154$exports, "cidrv6", () => $09193e81812ba154$export$b6e650831cac87fb);
$parcel$export($09193e81812ba154$exports, "base64", () => $09193e81812ba154$export$b3b2de96497acc47);
$parcel$export($09193e81812ba154$exports, "base64url", () => $09193e81812ba154$export$7d21597c7bc64465);
$parcel$export($09193e81812ba154$exports, "e164", () => $09193e81812ba154$export$2fa5ed24c9ef198e);
$parcel$export($09193e81812ba154$exports, "jwt", () => $09193e81812ba154$export$6b49f0d0c2777fe9);
$parcel$export($09193e81812ba154$exports, "ZodCustomStringFormat", () => $09193e81812ba154$export$a75d00728843496d);
$parcel$export($09193e81812ba154$exports, "stringFormat", () => $09193e81812ba154$export$80ce5102b3890b72);
$parcel$export($09193e81812ba154$exports, "hostname", () => $09193e81812ba154$export$640106f6dc7d2706);
$parcel$export($09193e81812ba154$exports, "hex", () => $09193e81812ba154$export$834dfc94dde4b3d8);
$parcel$export($09193e81812ba154$exports, "hash", () => $09193e81812ba154$export$d6af199866bfb566);
$parcel$export($09193e81812ba154$exports, "ZodNumber", () => $09193e81812ba154$export$5b070a55c0c43e09);
$parcel$export($09193e81812ba154$exports, "int", () => $09193e81812ba154$export$7d260a2a5f8bc19e);
$parcel$export($09193e81812ba154$exports, "number", () => $09193e81812ba154$export$98e628dec113755e);
$parcel$export($09193e81812ba154$exports, "ZodNumberFormat", () => $09193e81812ba154$export$1d835e7a0f492f73);
$parcel$export($09193e81812ba154$exports, "float32", () => $09193e81812ba154$export$1a4bac2aea11f30e);
$parcel$export($09193e81812ba154$exports, "float64", () => $09193e81812ba154$export$76f82835c9736f87);
$parcel$export($09193e81812ba154$exports, "int32", () => $09193e81812ba154$export$1d95835383bb05a);
$parcel$export($09193e81812ba154$exports, "uint32", () => $09193e81812ba154$export$de9ffb9418dd7d0d);
$parcel$export($09193e81812ba154$exports, "ZodBoolean", () => $09193e81812ba154$export$723d146f80596191);
$parcel$export($09193e81812ba154$exports, "boolean", () => $09193e81812ba154$export$4a21f16c33752377);
$parcel$export($09193e81812ba154$exports, "ZodBigInt", () => $09193e81812ba154$export$67d741fd70ff98f4);
$parcel$export($09193e81812ba154$exports, "bigint", () => $09193e81812ba154$export$a0f65b52274bcc00);
$parcel$export($09193e81812ba154$exports, "ZodBigIntFormat", () => $09193e81812ba154$export$7483f4dc330f3456);
$parcel$export($09193e81812ba154$exports, "int64", () => $09193e81812ba154$export$af207e6076994812);
$parcel$export($09193e81812ba154$exports, "uint64", () => $09193e81812ba154$export$870002f71f6ee2de);
$parcel$export($09193e81812ba154$exports, "ZodSymbol", () => $09193e81812ba154$export$bcc3b40f6b638044);
$parcel$export($09193e81812ba154$exports, "symbol", () => $09193e81812ba154$export$8f701197936bc2a6);
$parcel$export($09193e81812ba154$exports, "ZodUndefined", () => $09193e81812ba154$export$4e780e961c30340d);
$parcel$export($09193e81812ba154$exports, "undefined", () => $09193e81812ba154$export$1db45310990710a5);
$parcel$export($09193e81812ba154$exports, "ZodNull", () => $09193e81812ba154$export$a96281f914484f2d);
$parcel$export($09193e81812ba154$exports, "null", () => $09193e81812ba154$export$7b1b591b262c240);
$parcel$export($09193e81812ba154$exports, "ZodAny", () => $09193e81812ba154$export$b9d1edb536b4e4eb);
$parcel$export($09193e81812ba154$exports, "any", () => $09193e81812ba154$export$4154a199d7d90455);
$parcel$export($09193e81812ba154$exports, "ZodUnknown", () => $09193e81812ba154$export$ef3b1bb1630977ae);
$parcel$export($09193e81812ba154$exports, "unknown", () => $09193e81812ba154$export$19282c40b967aec6);
$parcel$export($09193e81812ba154$exports, "ZodNever", () => $09193e81812ba154$export$1e576a20c3ce9fb5);
$parcel$export($09193e81812ba154$exports, "never", () => $09193e81812ba154$export$b3e22bcfd64c1022);
$parcel$export($09193e81812ba154$exports, "ZodVoid", () => $09193e81812ba154$export$7d39f5df85f21031);
$parcel$export($09193e81812ba154$exports, "void", () => $09193e81812ba154$export$490e536ee7389aeb);
$parcel$export($09193e81812ba154$exports, "ZodDate", () => $09193e81812ba154$export$e974be33bdc55521);
$parcel$export($09193e81812ba154$exports, "date", () => $09193e81812ba154$export$324d90190a8b822a);
$parcel$export($09193e81812ba154$exports, "ZodArray", () => $09193e81812ba154$export$7acfc3e64785411);
$parcel$export($09193e81812ba154$exports, "keyof", () => $09193e81812ba154$export$7e1278799275f68e);
$parcel$export($09193e81812ba154$exports, "enum", () => $09193e81812ba154$export$78a99c8d44d72635);
$parcel$export($09193e81812ba154$exports, "ZodObject", () => $09193e81812ba154$export$736315c5b55efbad);
$parcel$export($09193e81812ba154$exports, "ZodOptional", () => $09193e81812ba154$export$aa56fec1e9d629b8);
$parcel$export($09193e81812ba154$exports, "ZodNonOptional", () => $09193e81812ba154$export$eb04319818b4702e);
$parcel$export($09193e81812ba154$exports, "object", () => $09193e81812ba154$export$be5493f9613cbbe);
$parcel$export($09193e81812ba154$exports, "strictObject", () => $09193e81812ba154$export$8fb0df5f40d0b477);
$parcel$export($09193e81812ba154$exports, "looseObject", () => $09193e81812ba154$export$bc233bd5e67eecd);
$parcel$export($09193e81812ba154$exports, "ZodUnion", () => $09193e81812ba154$export$a8b236cb5070a311);
$parcel$export($09193e81812ba154$exports, "ZodXor", () => $09193e81812ba154$export$b87e6de7c4c8bfc7);
$parcel$export($09193e81812ba154$exports, "xor", () => $09193e81812ba154$export$6444ef5cd411280c);
$parcel$export($09193e81812ba154$exports, "ZodDiscriminatedUnion", () => $09193e81812ba154$export$5ef2424805ac76a3);
$parcel$export($09193e81812ba154$exports, "discriminatedUnion", () => $09193e81812ba154$export$4b888e40c4ee26dd);
$parcel$export($09193e81812ba154$exports, "ZodIntersection", () => $09193e81812ba154$export$c02deaf0bb5203d4);
$parcel$export($09193e81812ba154$exports, "ZodTuple", () => $09193e81812ba154$export$e2a18bb771d8e6a3);
$parcel$export($09193e81812ba154$exports, "tuple", () => $09193e81812ba154$export$65e3907585753458);
$parcel$export($09193e81812ba154$exports, "ZodRecord", () => $09193e81812ba154$export$a2acc09968cb4b7f);
$parcel$export($09193e81812ba154$exports, "record", () => $09193e81812ba154$export$e5185e241753e543);
$parcel$export($09193e81812ba154$exports, "partialRecord", () => $09193e81812ba154$export$669401d1edf671b3);
$parcel$export($09193e81812ba154$exports, "looseRecord", () => $09193e81812ba154$export$afe1641377ace256);
$parcel$export($09193e81812ba154$exports, "ZodMap", () => $09193e81812ba154$export$163b6a2b712d9542);
$parcel$export($09193e81812ba154$exports, "map", () => $09193e81812ba154$export$871de8747c9eaa88);
$parcel$export($09193e81812ba154$exports, "ZodSet", () => $09193e81812ba154$export$977057706f816712);
$parcel$export($09193e81812ba154$exports, "set", () => $09193e81812ba154$export$adaa4cf7ef1b65be);
$parcel$export($09193e81812ba154$exports, "ZodEnum", () => $09193e81812ba154$export$d325d1f0e1c20179);
$parcel$export($09193e81812ba154$exports, "nativeEnum", () => $09193e81812ba154$export$6fe7eca19ebe5199);
$parcel$export($09193e81812ba154$exports, "ZodLiteral", () => $09193e81812ba154$export$7e44096782a165d3);
$parcel$export($09193e81812ba154$exports, "literal", () => $09193e81812ba154$export$c8ec6e1ec9fefcb0);
$parcel$export($09193e81812ba154$exports, "ZodFile", () => $09193e81812ba154$export$1aa10ff06069e07d);
$parcel$export($09193e81812ba154$exports, "file", () => $09193e81812ba154$export$c2a28f090bb0afd6);
$parcel$export($09193e81812ba154$exports, "ZodTransform", () => $09193e81812ba154$export$cf1499e83869147b);
$parcel$export($09193e81812ba154$exports, "ZodExactOptional", () => $09193e81812ba154$export$af29c4375d3792a4);
$parcel$export($09193e81812ba154$exports, "ZodNullable", () => $09193e81812ba154$export$aaac0b8b429cef5);
$parcel$export($09193e81812ba154$exports, "nullish", () => $09193e81812ba154$export$69fd1b70ebae5687);
$parcel$export($09193e81812ba154$exports, "ZodDefault", () => $09193e81812ba154$export$bb19b37874861e7e);
$parcel$export($09193e81812ba154$exports, "ZodPrefault", () => $09193e81812ba154$export$b619aec225e4abe9);
$parcel$export($09193e81812ba154$exports, "ZodSuccess", () => $09193e81812ba154$export$89dfce00a343f317);
$parcel$export($09193e81812ba154$exports, "success", () => $09193e81812ba154$export$fe7c49d056ea1d88);
$parcel$export($09193e81812ba154$exports, "ZodCatch", () => $09193e81812ba154$export$75a44ec6249ac76b);
$parcel$export($09193e81812ba154$exports, "ZodNaN", () => $09193e81812ba154$export$26ccfa0145e8511f);
$parcel$export($09193e81812ba154$exports, "nan", () => $09193e81812ba154$export$9e06de0973666692);
$parcel$export($09193e81812ba154$exports, "ZodPipe", () => $09193e81812ba154$export$8c4c5c16b952637a);
$parcel$export($09193e81812ba154$exports, "ZodCodec", () => $09193e81812ba154$export$d2591c20339f7464);
$parcel$export($09193e81812ba154$exports, "codec", () => $09193e81812ba154$export$1c37c01eba8ed446);
$parcel$export($09193e81812ba154$exports, "ZodReadonly", () => $09193e81812ba154$export$5d1f7ef05c4e493a);
$parcel$export($09193e81812ba154$exports, "ZodTemplateLiteral", () => $09193e81812ba154$export$e6e9ee3f9fd7fdd9);
$parcel$export($09193e81812ba154$exports, "templateLiteral", () => $09193e81812ba154$export$859cd210a8f40722);
$parcel$export($09193e81812ba154$exports, "ZodLazy", () => $09193e81812ba154$export$378d0cfce37406e6);
$parcel$export($09193e81812ba154$exports, "lazy", () => $09193e81812ba154$export$488013bae63b21da);
$parcel$export($09193e81812ba154$exports, "ZodPromise", () => $09193e81812ba154$export$3f196b0127d6e50a);
$parcel$export($09193e81812ba154$exports, "promise", () => $09193e81812ba154$export$c957ef27a0ebfd4);
$parcel$export($09193e81812ba154$exports, "ZodFunction", () => $09193e81812ba154$export$d4602ba55673f53c);
$parcel$export($09193e81812ba154$exports, "_function", () => $09193e81812ba154$export$6e2aba165ec1f1d9);
$parcel$export($09193e81812ba154$exports, "function", () => $09193e81812ba154$export$6e2aba165ec1f1d9);
$parcel$export($09193e81812ba154$exports, "ZodCustom", () => $09193e81812ba154$export$76cf7569fb33e487);
$parcel$export($09193e81812ba154$exports, "check", () => $09193e81812ba154$export$35dc45686fc2dbd7);
$parcel$export($09193e81812ba154$exports, "custom", () => $09193e81812ba154$export$4c00f665f0d4b443);
$parcel$export($09193e81812ba154$exports, "describe", () => $09193e81812ba154$export$cd5450f3a47e3789);
$parcel$export($09193e81812ba154$exports, "meta", () => $09193e81812ba154$export$6990040ee07315);
$parcel$export($09193e81812ba154$exports, "instanceof", () => $09193e81812ba154$export$3d916e7c22dbd8b5);
$parcel$export($09193e81812ba154$exports, "stringbool", () => $09193e81812ba154$export$c1250768cb298588);
$parcel$export($09193e81812ba154$exports, "json", () => $09193e81812ba154$export$7b419323e6ed4f31);
$parcel$export($09193e81812ba154$exports, "preprocess", () => $09193e81812ba154$export$fc37fe19dfda43ee);



var $72150b10d982cc55$exports = {};

$parcel$export($72150b10d982cc55$exports, "lt", () => $57904f98be373a74$export$2a42c74e76a068a);
$parcel$export($72150b10d982cc55$exports, "lte", () => $57904f98be373a74$export$7a060cf3d60b84a6);
$parcel$export($72150b10d982cc55$exports, "gt", () => $57904f98be373a74$export$7582466e3ab4d25b);
$parcel$export($72150b10d982cc55$exports, "gte", () => $57904f98be373a74$export$a1c6d8834a3b19c9);
$parcel$export($72150b10d982cc55$exports, "positive", () => $57904f98be373a74$export$ddfc6f0a2e49a568);
$parcel$export($72150b10d982cc55$exports, "negative", () => $57904f98be373a74$export$d30568dda7134ca5);
$parcel$export($72150b10d982cc55$exports, "nonpositive", () => $57904f98be373a74$export$c3e51eea33419c94);
$parcel$export($72150b10d982cc55$exports, "nonnegative", () => $57904f98be373a74$export$93ec5f75848b1928);
$parcel$export($72150b10d982cc55$exports, "multipleOf", () => $57904f98be373a74$export$c41e40f80e978ab1);
$parcel$export($72150b10d982cc55$exports, "maxSize", () => $57904f98be373a74$export$3eed6ccb98bc18db);
$parcel$export($72150b10d982cc55$exports, "minSize", () => $57904f98be373a74$export$e379713268c2c18a);
$parcel$export($72150b10d982cc55$exports, "size", () => $57904f98be373a74$export$2621565b966a8d23);
$parcel$export($72150b10d982cc55$exports, "maxLength", () => $57904f98be373a74$export$ec76627108655a22);
$parcel$export($72150b10d982cc55$exports, "minLength", () => $57904f98be373a74$export$21f6711a906c1450);
$parcel$export($72150b10d982cc55$exports, "length", () => $57904f98be373a74$export$620b9f7ab17ff8a9);
$parcel$export($72150b10d982cc55$exports, "regex", () => $57904f98be373a74$export$c4768a1bd8f8393);
$parcel$export($72150b10d982cc55$exports, "lowercase", () => $57904f98be373a74$export$ea67c3edeec85c63);
$parcel$export($72150b10d982cc55$exports, "uppercase", () => $57904f98be373a74$export$2998381b41c6902a);
$parcel$export($72150b10d982cc55$exports, "includes", () => $57904f98be373a74$export$fccf016a6caa651d);
$parcel$export($72150b10d982cc55$exports, "startsWith", () => $57904f98be373a74$export$2f37aaf99060de76);
$parcel$export($72150b10d982cc55$exports, "endsWith", () => $57904f98be373a74$export$eaeaa2fcd833167e);
$parcel$export($72150b10d982cc55$exports, "property", () => $57904f98be373a74$export$537db06738ee7f1b);
$parcel$export($72150b10d982cc55$exports, "mime", () => $57904f98be373a74$export$267177285a1a8b37);
$parcel$export($72150b10d982cc55$exports, "overwrite", () => $57904f98be373a74$export$aeea8f004f34f8c2);
$parcel$export($72150b10d982cc55$exports, "normalize", () => $57904f98be373a74$export$2b99bb23a814f78e);
$parcel$export($72150b10d982cc55$exports, "trim", () => $57904f98be373a74$export$8be2de0b60774d1e);
$parcel$export($72150b10d982cc55$exports, "toLowerCase", () => $57904f98be373a74$export$d9cfe939403a2525);
$parcel$export($72150b10d982cc55$exports, "toUpperCase", () => $57904f98be373a74$export$cf76ef1ae9e9944e);
$parcel$export($72150b10d982cc55$exports, "slugify", () => $57904f98be373a74$export$2801993b93f3c232);



var $0c3f217e6a9cca3d$exports = {};

$parcel$export($0c3f217e6a9cca3d$exports, "ZodISODateTime", () => $0c3f217e6a9cca3d$export$8ceba53cbe6a272e);
$parcel$export($0c3f217e6a9cca3d$exports, "datetime", () => $0c3f217e6a9cca3d$export$7ba4466dbd0f07e1);
$parcel$export($0c3f217e6a9cca3d$exports, "ZodISODate", () => $0c3f217e6a9cca3d$export$e7f25b469dafa5ec);
$parcel$export($0c3f217e6a9cca3d$exports, "date", () => $0c3f217e6a9cca3d$export$324d90190a8b822a);
$parcel$export($0c3f217e6a9cca3d$exports, "ZodISOTime", () => $0c3f217e6a9cca3d$export$ee190fc7c4074018);
$parcel$export($0c3f217e6a9cca3d$exports, "time", () => $0c3f217e6a9cca3d$export$2da9be4cfdb689b1);
$parcel$export($0c3f217e6a9cca3d$exports, "ZodISODuration", () => $0c3f217e6a9cca3d$export$164bac5916a0e7e9);
$parcel$export($0c3f217e6a9cca3d$exports, "duration", () => $0c3f217e6a9cca3d$export$1f34108aa9eb96ab);


const $0c3f217e6a9cca3d$export$8ceba53cbe6a272e = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodISODateTime", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$3273e4d2df37774b.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $0c3f217e6a9cca3d$export$7ba4466dbd0f07e1(params) {
    return $57904f98be373a74$export$a62adeb27809351b($0c3f217e6a9cca3d$export$8ceba53cbe6a272e, params);
}
const $0c3f217e6a9cca3d$export$e7f25b469dafa5ec = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodISODate", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$75b9bf98f4d806dc.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $0c3f217e6a9cca3d$export$324d90190a8b822a(params) {
    return $57904f98be373a74$export$e4f19dd0a54e7a59($0c3f217e6a9cca3d$export$e7f25b469dafa5ec, params);
}
const $0c3f217e6a9cca3d$export$ee190fc7c4074018 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodISOTime", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$e9b9c3c2359a3ebc.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $0c3f217e6a9cca3d$export$2da9be4cfdb689b1(params) {
    return $57904f98be373a74$export$36f9f051d5e817c($0c3f217e6a9cca3d$export$ee190fc7c4074018, params);
}
const $0c3f217e6a9cca3d$export$164bac5916a0e7e9 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodISODuration", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$d9e850ab18e4b22e.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $0c3f217e6a9cca3d$export$1f34108aa9eb96ab(params) {
    return $57904f98be373a74$export$7d70539c76fbff4($0c3f217e6a9cca3d$export$164bac5916a0e7e9, params);
}





const $e16cd2eede213549$var$initializer = (inst, issues)=>{
    (0, $0b6c05566f4aeada$export$544878318730b1d8).init(inst, issues);
    inst.name = "ZodError";
    Object.defineProperties(inst, {
        format: {
            value: (mapper)=>$0b6c05566f4aeada$export$7b5b869ee98c16ab(inst, mapper)
        },
        flatten: {
            value: (mapper)=>$0b6c05566f4aeada$export$4d7e0dfd5ca8366f(inst, mapper)
        },
        addIssue: {
            value: (issue)=>{
                inst.issues.push(issue);
                inst.message = JSON.stringify(inst.issues, $17ea3f861a2ff584$export$f4defb13cab882b2, 2);
            }
        },
        addIssues: {
            value: (issues)=>{
                inst.issues.push(...issues);
                inst.message = JSON.stringify(inst.issues, $17ea3f861a2ff584$export$f4defb13cab882b2, 2);
            }
        },
        isEmpty: {
            get () {
                return inst.issues.length === 0;
            }
        }
    });
// Object.defineProperty(inst, "isEmpty", {
//   get() {
//     return inst.issues.length === 0;
//   },
// });
};
const $e16cd2eede213549$export$f98dac4b251ab333 = $4488038d123e8fa5$export$3122533d606194de("ZodError", $e16cd2eede213549$var$initializer);
const $e16cd2eede213549$export$42f76a3b4eb5449a = $4488038d123e8fa5$export$3122533d606194de("ZodError", $e16cd2eede213549$var$initializer, {
    Parent: Error
}); // /** @deprecated Use `z.core.$ZodErrorMapCtx` instead. */
 // export type ErrorMapCtx = core.$ZodErrorMapCtx;


const $fd7c03c13241ea63$export$98e6a39c04603d36 = /* @__PURE__ */ $3bba9a623c1bec43$export$dcd1bb9991b57edf((0, $e16cd2eede213549$export$42f76a3b4eb5449a));
const $fd7c03c13241ea63$export$59b6f938fbf579e3 = /* @__PURE__ */ $3bba9a623c1bec43$export$1fcca22dc6c780d0((0, $e16cd2eede213549$export$42f76a3b4eb5449a));
const $fd7c03c13241ea63$export$b48ee232557adc37 = /* @__PURE__ */ $3bba9a623c1bec43$export$5ec32605bf51e98e((0, $e16cd2eede213549$export$42f76a3b4eb5449a));
const $fd7c03c13241ea63$export$9b07b0d6e0389261 = /* @__PURE__ */ $3bba9a623c1bec43$export$c08c7322f5625faf((0, $e16cd2eede213549$export$42f76a3b4eb5449a));
const $fd7c03c13241ea63$export$c564cdbbe6da493 = /* @__PURE__ */ $3bba9a623c1bec43$export$50e4445ccc10715b((0, $e16cd2eede213549$export$42f76a3b4eb5449a));
const $fd7c03c13241ea63$export$2f872c0f2117be69 = /* @__PURE__ */ $3bba9a623c1bec43$export$bb4a21772f43c982((0, $e16cd2eede213549$export$42f76a3b4eb5449a));
const $fd7c03c13241ea63$export$1a62660bbffb8f11 = /* @__PURE__ */ $3bba9a623c1bec43$export$9954740a1a5eaaf1((0, $e16cd2eede213549$export$42f76a3b4eb5449a));
const $fd7c03c13241ea63$export$e4c183687a6ff9b = /* @__PURE__ */ $3bba9a623c1bec43$export$74b09e12c8956d91((0, $e16cd2eede213549$export$42f76a3b4eb5449a));
const $fd7c03c13241ea63$export$c094f85f253e4d7d = /* @__PURE__ */ $3bba9a623c1bec43$export$6d688d774257f486((0, $e16cd2eede213549$export$42f76a3b4eb5449a));
const $fd7c03c13241ea63$export$7a47376c130cfeac = /* @__PURE__ */ $3bba9a623c1bec43$export$b2ef531a734faad5((0, $e16cd2eede213549$export$42f76a3b4eb5449a));
const $fd7c03c13241ea63$export$ed163a34170fecc5 = /* @__PURE__ */ $3bba9a623c1bec43$export$fa2ac180d22758d6((0, $e16cd2eede213549$export$42f76a3b4eb5449a));
const $fd7c03c13241ea63$export$9f879005292a9bc9 = /* @__PURE__ */ $3bba9a623c1bec43$export$f66d2b402dc6318c((0, $e16cd2eede213549$export$42f76a3b4eb5449a));


const $09193e81812ba154$export$2afb8ab49d4b92c0 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodType", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f43a5c3966de8238.init(inst, def);
    Object.assign(inst["~standard"], {
        jsonSchema: {
            input: (0, $e78123e42965e820$export$b29c48d79372468a)(inst, "input"),
            output: (0, $e78123e42965e820$export$b29c48d79372468a)(inst, "output")
        }
    });
    inst.toJSONSchema = (0, $e78123e42965e820$export$d24eb8c1ef5f4df1)(inst, {});
    inst.def = def;
    inst.type = def.type;
    Object.defineProperty(inst, "_def", {
        value: def
    });
    // base methods
    inst.check = (...checks)=>{
        return inst.clone((0, $17ea3f861a2ff584$exports).mergeDefs(def, {
            checks: [
                ...def.checks ?? [],
                ...checks.map((ch)=>typeof ch === "function" ? {
                        _zod: {
                            check: ch,
                            def: {
                                check: "custom"
                            },
                            onattach: []
                        }
                    } : ch)
            ]
        }), {
            parent: true
        });
    };
    inst.with = inst.check;
    inst.clone = (def, params)=>$17ea3f861a2ff584$export$9cd59f9826255e47(inst, def, params);
    inst.brand = ()=>inst;
    inst.register = (reg, meta)=>{
        reg.add(inst, meta);
        return inst;
    };
    // parsing
    inst.parse = (data, params)=>$fd7c03c13241ea63$export$98e6a39c04603d36(inst, data, params, {
            callee: inst.parse
        });
    inst.safeParse = (data, params)=>$fd7c03c13241ea63$export$b48ee232557adc37(inst, data, params);
    inst.parseAsync = async (data, params)=>$fd7c03c13241ea63$export$59b6f938fbf579e3(inst, data, params, {
            callee: inst.parseAsync
        });
    inst.safeParseAsync = async (data, params)=>$fd7c03c13241ea63$export$9b07b0d6e0389261(inst, data, params);
    inst.spa = inst.safeParseAsync;
    // encoding/decoding
    inst.encode = (data, params)=>$fd7c03c13241ea63$export$c564cdbbe6da493(inst, data, params);
    inst.decode = (data, params)=>$fd7c03c13241ea63$export$2f872c0f2117be69(inst, data, params);
    inst.encodeAsync = async (data, params)=>$fd7c03c13241ea63$export$1a62660bbffb8f11(inst, data, params);
    inst.decodeAsync = async (data, params)=>$fd7c03c13241ea63$export$e4c183687a6ff9b(inst, data, params);
    inst.safeEncode = (data, params)=>$fd7c03c13241ea63$export$c094f85f253e4d7d(inst, data, params);
    inst.safeDecode = (data, params)=>$fd7c03c13241ea63$export$7a47376c130cfeac(inst, data, params);
    inst.safeEncodeAsync = async (data, params)=>$fd7c03c13241ea63$export$ed163a34170fecc5(inst, data, params);
    inst.safeDecodeAsync = async (data, params)=>$fd7c03c13241ea63$export$9f879005292a9bc9(inst, data, params);
    // refinements
    inst.refine = (check, params)=>inst.check($09193e81812ba154$export$edc9d475108b3212(check, params));
    inst.superRefine = (refinement)=>inst.check($09193e81812ba154$export$e0f31df04c32a6bf(refinement));
    inst.overwrite = (fn)=>inst.check($57904f98be373a74$export$aeea8f004f34f8c2(fn));
    // wrappers
    inst.optional = ()=>$09193e81812ba154$export$516e28dec6a4b6d4(inst);
    inst.exactOptional = ()=>$09193e81812ba154$export$76092ad52134d3a0(inst);
    inst.nullable = ()=>$09193e81812ba154$export$133fc36489ac9add(inst);
    inst.nullish = ()=>$09193e81812ba154$export$516e28dec6a4b6d4($09193e81812ba154$export$133fc36489ac9add(inst));
    inst.nonoptional = (params)=>$09193e81812ba154$export$e6aa51fdda6cd70d(inst, params);
    inst.array = ()=>$09193e81812ba154$export$2f23118c22fb2630(inst);
    inst.or = (arg)=>$09193e81812ba154$export$971dd5b0dfd021b6([
            inst,
            arg
        ]);
    inst.and = (arg)=>$09193e81812ba154$export$bc86dfbf7795668c(inst, arg);
    inst.transform = (tx)=>$09193e81812ba154$export$a4627e546088548d(inst, $09193e81812ba154$export$51186ad6e864892a(tx));
    inst.default = (def)=>$09193e81812ba154$export$d4b0f68d0d916971(inst, def);
    inst.prefault = (def)=>$09193e81812ba154$export$569da376ae266d0a(inst, def);
    // inst.coalesce = (def, params) => coalesce(inst, def, params);
    inst.catch = (params)=>$09193e81812ba154$export$e1d4808a6ac94c4c(inst, params);
    inst.pipe = (target)=>$09193e81812ba154$export$a4627e546088548d(inst, target);
    inst.readonly = ()=>$09193e81812ba154$export$6ec456bd5b7b3c51(inst);
    // meta
    inst.describe = (description)=>{
        const cl = inst.clone();
        $450977dbcfd5dec3$export$bc58ce2776ecdb6f.add(cl, {
            description: description
        });
        return cl;
    };
    Object.defineProperty(inst, "description", {
        get () {
            return $450977dbcfd5dec3$export$bc58ce2776ecdb6f.get(inst)?.description;
        },
        configurable: true
    });
    inst.meta = (...args)=>{
        if (args.length === 0) return $450977dbcfd5dec3$export$bc58ce2776ecdb6f.get(inst);
        const cl = inst.clone();
        $450977dbcfd5dec3$export$bc58ce2776ecdb6f.add(cl, args[0]);
        return cl;
    };
    // helpers
    inst.isOptional = ()=>inst.safeParse(undefined).success;
    inst.isNullable = ()=>inst.safeParse(null).success;
    inst.apply = (fn)=>fn(inst);
    return inst;
});
const $09193e81812ba154$export$f6d83ce3dacef2be = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("_ZodString", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$4342b4432d7b1471.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$c6950985d9de996d(inst, ctx, json, params);
    const bag = inst._zod.bag;
    inst.format = bag.format ?? null;
    inst.minLength = bag.minimum ?? null;
    inst.maxLength = bag.maximum ?? null;
    // validations
    inst.regex = (...args)=>inst.check($57904f98be373a74$export$c4768a1bd8f8393(...args));
    inst.includes = (...args)=>inst.check($57904f98be373a74$export$fccf016a6caa651d(...args));
    inst.startsWith = (...args)=>inst.check($57904f98be373a74$export$2f37aaf99060de76(...args));
    inst.endsWith = (...args)=>inst.check($57904f98be373a74$export$eaeaa2fcd833167e(...args));
    inst.min = (...args)=>inst.check($57904f98be373a74$export$21f6711a906c1450(...args));
    inst.max = (...args)=>inst.check($57904f98be373a74$export$ec76627108655a22(...args));
    inst.length = (...args)=>inst.check($57904f98be373a74$export$620b9f7ab17ff8a9(...args));
    inst.nonempty = (...args)=>inst.check($57904f98be373a74$export$21f6711a906c1450(1, ...args));
    inst.lowercase = (params)=>inst.check($57904f98be373a74$export$ea67c3edeec85c63(params));
    inst.uppercase = (params)=>inst.check($57904f98be373a74$export$2998381b41c6902a(params));
    // transforms
    inst.trim = ()=>inst.check($57904f98be373a74$export$8be2de0b60774d1e());
    inst.normalize = (...args)=>inst.check($57904f98be373a74$export$2b99bb23a814f78e(...args));
    inst.toLowerCase = ()=>inst.check($57904f98be373a74$export$d9cfe939403a2525());
    inst.toUpperCase = ()=>inst.check($57904f98be373a74$export$cf76ef1ae9e9944e());
    inst.slugify = ()=>inst.check($57904f98be373a74$export$2801993b93f3c232());
});
const $09193e81812ba154$export$1230eb29b8d3b502 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodString", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$4342b4432d7b1471.init(inst, def);
    $09193e81812ba154$export$f6d83ce3dacef2be.init(inst, def);
    inst.email = (params)=>inst.check($57904f98be373a74$export$471b39521bec3299($09193e81812ba154$export$770096fb2a685237, params));
    inst.url = (params)=>inst.check($57904f98be373a74$export$e3f203373341d39($09193e81812ba154$export$82127fa72e650526, params));
    inst.jwt = (params)=>inst.check($57904f98be373a74$export$4a9318e6b46f1aa1($09193e81812ba154$export$5c0d807bd77507f, params));
    inst.emoji = (params)=>inst.check($57904f98be373a74$export$936e26d261396f46($09193e81812ba154$export$f072c1a26a31d55b, params));
    inst.guid = (params)=>inst.check($57904f98be373a74$export$129b5399d64cccb0($09193e81812ba154$export$2827a6bad660427b, params));
    inst.uuid = (params)=>inst.check($57904f98be373a74$export$f2f3139038bea52c($09193e81812ba154$export$7ee22ce365e4d3b5, params));
    inst.uuidv4 = (params)=>inst.check($57904f98be373a74$export$a5559d7da37a112f($09193e81812ba154$export$7ee22ce365e4d3b5, params));
    inst.uuidv6 = (params)=>inst.check($57904f98be373a74$export$53b427a8173231a($09193e81812ba154$export$7ee22ce365e4d3b5, params));
    inst.uuidv7 = (params)=>inst.check($57904f98be373a74$export$588d23d6e9ec2ed5($09193e81812ba154$export$7ee22ce365e4d3b5, params));
    inst.nanoid = (params)=>inst.check($57904f98be373a74$export$a030949b19390ea0($09193e81812ba154$export$9e180e3f910c7773, params));
    inst.guid = (params)=>inst.check($57904f98be373a74$export$129b5399d64cccb0($09193e81812ba154$export$2827a6bad660427b, params));
    inst.cuid = (params)=>inst.check($57904f98be373a74$export$639125837b796148($09193e81812ba154$export$c6b7c3c30ab9362e, params));
    inst.cuid2 = (params)=>inst.check($57904f98be373a74$export$36b63ef9af7972c2($09193e81812ba154$export$536dc9ce9eec8565, params));
    inst.ulid = (params)=>inst.check($57904f98be373a74$export$95acf3b3fa11bdc9($09193e81812ba154$export$a060914fca5da3d4, params));
    inst.base64 = (params)=>inst.check($57904f98be373a74$export$9fdb09384fbc4988($09193e81812ba154$export$237b9f5cee85a1c1, params));
    inst.base64url = (params)=>inst.check($57904f98be373a74$export$178c70fb89c949fa($09193e81812ba154$export$62a2e9135a9e2356, params));
    inst.xid = (params)=>inst.check($57904f98be373a74$export$bbb0a2cfb079fa90($09193e81812ba154$export$d53bc3b8251fa017, params));
    inst.ksuid = (params)=>inst.check($57904f98be373a74$export$1306ede2f9ea153f($09193e81812ba154$export$1bbac5f87dca43e4, params));
    inst.ipv4 = (params)=>inst.check($57904f98be373a74$export$c77a1c80cebc2aad($09193e81812ba154$export$567930edb18e0c3a, params));
    inst.ipv6 = (params)=>inst.check($57904f98be373a74$export$964dfe0e2e4e8895($09193e81812ba154$export$75c5c5fd479ecddf, params));
    inst.cidrv4 = (params)=>inst.check($57904f98be373a74$export$feaac4e27a421ddc($09193e81812ba154$export$ac524bc9ec5fac50, params));
    inst.cidrv6 = (params)=>inst.check($57904f98be373a74$export$a0518ffc5273ec92($09193e81812ba154$export$b8cae7a616378f16, params));
    inst.e164 = (params)=>inst.check($57904f98be373a74$export$b8bf0b70d4bc7855($09193e81812ba154$export$fac79817565ec0f7, params));
    // iso
    inst.datetime = (params)=>inst.check($0c3f217e6a9cca3d$export$7ba4466dbd0f07e1(params));
    inst.date = (params)=>inst.check($0c3f217e6a9cca3d$export$324d90190a8b822a(params));
    inst.time = (params)=>inst.check($0c3f217e6a9cca3d$export$2da9be4cfdb689b1(params));
    inst.duration = (params)=>inst.check($0c3f217e6a9cca3d$export$1f34108aa9eb96ab(params));
});
function $09193e81812ba154$export$22b082955e083ec3(params) {
    return $57904f98be373a74$export$25986a84359f8f7f($09193e81812ba154$export$1230eb29b8d3b502, params);
}
const $09193e81812ba154$export$6f00fc81f4be18e5 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodStringFormat", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$2d69a0d3057a5c7d.init(inst, def);
    $09193e81812ba154$export$f6d83ce3dacef2be.init(inst, def);
});
const $09193e81812ba154$export$770096fb2a685237 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodEmail", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$a3726aadb6108cdc.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $09193e81812ba154$export$d290fa47940df19d(params) {
    return $57904f98be373a74$export$471b39521bec3299($09193e81812ba154$export$770096fb2a685237, params);
}
const $09193e81812ba154$export$2827a6bad660427b = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodGUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$4ca4397e3147da59.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $09193e81812ba154$export$46e8f25c7328f77e(params) {
    return $57904f98be373a74$export$129b5399d64cccb0($09193e81812ba154$export$2827a6bad660427b, params);
}
const $09193e81812ba154$export$7ee22ce365e4d3b5 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodUUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$8794aae384e3c177.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $09193e81812ba154$export$31b40729666a4ae0(params) {
    return $57904f98be373a74$export$f2f3139038bea52c($09193e81812ba154$export$7ee22ce365e4d3b5, params);
}
function $09193e81812ba154$export$abe4376e1bf796d6(params) {
    return $57904f98be373a74$export$a5559d7da37a112f($09193e81812ba154$export$7ee22ce365e4d3b5, params);
}
function $09193e81812ba154$export$b1fe4fcff87f98e5(params) {
    return $57904f98be373a74$export$53b427a8173231a($09193e81812ba154$export$7ee22ce365e4d3b5, params);
}
function $09193e81812ba154$export$a7b512db306b38d7(params) {
    return $57904f98be373a74$export$588d23d6e9ec2ed5($09193e81812ba154$export$7ee22ce365e4d3b5, params);
}
const $09193e81812ba154$export$82127fa72e650526 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodURL", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$7e12af57cac08b7a.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $09193e81812ba154$export$128fa18b7194ef(params) {
    return $57904f98be373a74$export$e3f203373341d39($09193e81812ba154$export$82127fa72e650526, params);
}
function $09193e81812ba154$export$cddedb4cb7866be8(params) {
    return $57904f98be373a74$export$e3f203373341d39($09193e81812ba154$export$82127fa72e650526, {
        protocol: /^https?$/,
        hostname: $a2fdfdb502fc74b8$exports.domain,
        ...(0, $17ea3f861a2ff584$exports).normalizeParams(params)
    });
}
const $09193e81812ba154$export$f072c1a26a31d55b = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodEmoji", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$154cd448b85bb5a3.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $09193e81812ba154$export$a19185d1233fc4b2(params) {
    return $57904f98be373a74$export$936e26d261396f46($09193e81812ba154$export$f072c1a26a31d55b, params);
}
const $09193e81812ba154$export$9e180e3f910c7773 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodNanoID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$5a160d28c6d62c88.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $09193e81812ba154$export$ac4959f4f1338dfc(params) {
    return $57904f98be373a74$export$a030949b19390ea0($09193e81812ba154$export$9e180e3f910c7773, params);
}
const $09193e81812ba154$export$c6b7c3c30ab9362e = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodCUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$f4f84bd3c6706e60.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $09193e81812ba154$export$e057ec210c7d3443(params) {
    return $57904f98be373a74$export$639125837b796148($09193e81812ba154$export$c6b7c3c30ab9362e, params);
}
const $09193e81812ba154$export$536dc9ce9eec8565 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodCUID2", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$faf1483c11362df6.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $09193e81812ba154$export$af5866a6cccce9f0(params) {
    return $57904f98be373a74$export$36b63ef9af7972c2($09193e81812ba154$export$536dc9ce9eec8565, params);
}
const $09193e81812ba154$export$a060914fca5da3d4 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodULID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$c5788701f4f55294.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $09193e81812ba154$export$c34778236461ea95(params) {
    return $57904f98be373a74$export$95acf3b3fa11bdc9($09193e81812ba154$export$a060914fca5da3d4, params);
}
const $09193e81812ba154$export$d53bc3b8251fa017 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodXID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$e721fd3317199b85.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $09193e81812ba154$export$5eecaf20006cb6cb(params) {
    return $57904f98be373a74$export$bbb0a2cfb079fa90($09193e81812ba154$export$d53bc3b8251fa017, params);
}
const $09193e81812ba154$export$1bbac5f87dca43e4 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodKSUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$baa9849ea82bee6e.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $09193e81812ba154$export$f49b11deeb9beb0f(params) {
    return $57904f98be373a74$export$1306ede2f9ea153f($09193e81812ba154$export$1bbac5f87dca43e4, params);
}
const $09193e81812ba154$export$567930edb18e0c3a = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodIPv4", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$93fc833bbf7ceb99.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $09193e81812ba154$export$291a17a16047f284(params) {
    return $57904f98be373a74$export$c77a1c80cebc2aad($09193e81812ba154$export$567930edb18e0c3a, params);
}
const $09193e81812ba154$export$cb4c1bda006648e3 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodMAC", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$747370108f97e6ea.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $09193e81812ba154$export$f8d11e097856efcf(params) {
    return $57904f98be373a74$export$84f8b3e041d8e7d9($09193e81812ba154$export$cb4c1bda006648e3, params);
}
const $09193e81812ba154$export$75c5c5fd479ecddf = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodIPv6", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$8c939a460418a1bf.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $09193e81812ba154$export$4e0c86a59c658526(params) {
    return $57904f98be373a74$export$964dfe0e2e4e8895($09193e81812ba154$export$75c5c5fd479ecddf, params);
}
const $09193e81812ba154$export$ac524bc9ec5fac50 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodCIDRv4", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$e164feaf5ae5296b.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $09193e81812ba154$export$fc96793d9715e5a1(params) {
    return $57904f98be373a74$export$feaac4e27a421ddc($09193e81812ba154$export$ac524bc9ec5fac50, params);
}
const $09193e81812ba154$export$b8cae7a616378f16 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodCIDRv6", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$3c3aacb740759234.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $09193e81812ba154$export$b6e650831cac87fb(params) {
    return $57904f98be373a74$export$a0518ffc5273ec92($09193e81812ba154$export$b8cae7a616378f16, params);
}
const $09193e81812ba154$export$237b9f5cee85a1c1 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodBase64", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$d7d4932079e2113d.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $09193e81812ba154$export$b3b2de96497acc47(params) {
    return $57904f98be373a74$export$9fdb09384fbc4988($09193e81812ba154$export$237b9f5cee85a1c1, params);
}
const $09193e81812ba154$export$62a2e9135a9e2356 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodBase64URL", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$f5c3c3bbec012fa6.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $09193e81812ba154$export$7d21597c7bc64465(params) {
    return $57904f98be373a74$export$178c70fb89c949fa($09193e81812ba154$export$62a2e9135a9e2356, params);
}
const $09193e81812ba154$export$fac79817565ec0f7 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodE164", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$46d3507e8483217.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $09193e81812ba154$export$2fa5ed24c9ef198e(params) {
    return $57904f98be373a74$export$b8bf0b70d4bc7855($09193e81812ba154$export$fac79817565ec0f7, params);
}
const $09193e81812ba154$export$5c0d807bd77507f = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodJWT", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$f515616cf0cda103.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $09193e81812ba154$export$6b49f0d0c2777fe9(params) {
    return $57904f98be373a74$export$4a9318e6b46f1aa1($09193e81812ba154$export$5c0d807bd77507f, params);
}
const $09193e81812ba154$export$a75d00728843496d = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodCustomStringFormat", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e32a9d04eaeb9d0c$export$9dde4397c7b8a192.init(inst, def);
    $09193e81812ba154$export$6f00fc81f4be18e5.init(inst, def);
});
function $09193e81812ba154$export$80ce5102b3890b72(format, fnOrRegex, _params = {}) {
    return $57904f98be373a74$export$e25dde89ba546b88($09193e81812ba154$export$a75d00728843496d, format, fnOrRegex, _params);
}
function $09193e81812ba154$export$640106f6dc7d2706(_params) {
    return $57904f98be373a74$export$e25dde89ba546b88($09193e81812ba154$export$a75d00728843496d, "hostname", $a2fdfdb502fc74b8$exports.hostname, _params);
}
function $09193e81812ba154$export$834dfc94dde4b3d8(_params) {
    return $57904f98be373a74$export$e25dde89ba546b88($09193e81812ba154$export$a75d00728843496d, "hex", $a2fdfdb502fc74b8$exports.hex, _params);
}
function $09193e81812ba154$export$d6af199866bfb566(alg, params) {
    const enc = params?.enc ?? "hex";
    const format = `${alg}_${enc}`;
    const regex = $a2fdfdb502fc74b8$exports[format];
    if (!regex) throw new Error(`Unrecognized hash format: ${format}`);
    return $57904f98be373a74$export$e25dde89ba546b88($09193e81812ba154$export$a75d00728843496d, format, regex, params);
}
const $09193e81812ba154$export$5b070a55c0c43e09 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodNumber", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$b7292ed81eaafd49.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$afd08f475b2e134f(inst, ctx, json, params);
    inst.gt = (value, params)=>inst.check($57904f98be373a74$export$7582466e3ab4d25b(value, params));
    inst.gte = (value, params)=>inst.check($57904f98be373a74$export$a1c6d8834a3b19c9(value, params));
    inst.min = (value, params)=>inst.check($57904f98be373a74$export$a1c6d8834a3b19c9(value, params));
    inst.lt = (value, params)=>inst.check($57904f98be373a74$export$2a42c74e76a068a(value, params));
    inst.lte = (value, params)=>inst.check($57904f98be373a74$export$7a060cf3d60b84a6(value, params));
    inst.max = (value, params)=>inst.check($57904f98be373a74$export$7a060cf3d60b84a6(value, params));
    inst.int = (params)=>inst.check($09193e81812ba154$export$7d260a2a5f8bc19e(params));
    inst.safe = (params)=>inst.check($09193e81812ba154$export$7d260a2a5f8bc19e(params));
    inst.positive = (params)=>inst.check($57904f98be373a74$export$7582466e3ab4d25b(0, params));
    inst.nonnegative = (params)=>inst.check($57904f98be373a74$export$a1c6d8834a3b19c9(0, params));
    inst.negative = (params)=>inst.check($57904f98be373a74$export$2a42c74e76a068a(0, params));
    inst.nonpositive = (params)=>inst.check($57904f98be373a74$export$7a060cf3d60b84a6(0, params));
    inst.multipleOf = (value, params)=>inst.check($57904f98be373a74$export$c41e40f80e978ab1(value, params));
    inst.step = (value, params)=>inst.check($57904f98be373a74$export$c41e40f80e978ab1(value, params));
    // inst.finite = (params) => inst.check(core.finite(params));
    inst.finite = ()=>inst;
    const bag = inst._zod.bag;
    inst.minValue = Math.max(bag.minimum ?? Number.NEGATIVE_INFINITY, bag.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null;
    inst.maxValue = Math.min(bag.maximum ?? Number.POSITIVE_INFINITY, bag.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null;
    inst.isInt = (bag.format ?? "").includes("int") || Number.isSafeInteger(bag.multipleOf ?? 0.5);
    inst.isFinite = true;
    inst.format = bag.format ?? null;
});
function $09193e81812ba154$export$98e628dec113755e(params) {
    return $57904f98be373a74$export$9249bb0b45639623($09193e81812ba154$export$5b070a55c0c43e09, params);
}
const $09193e81812ba154$export$1d835e7a0f492f73 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodNumberFormat", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$2cfebe79b769ec9.init(inst, def);
    $09193e81812ba154$export$5b070a55c0c43e09.init(inst, def);
});
function $09193e81812ba154$export$7d260a2a5f8bc19e(params) {
    return $57904f98be373a74$export$3d5b343b1f51efdd($09193e81812ba154$export$1d835e7a0f492f73, params);
}
function $09193e81812ba154$export$1a4bac2aea11f30e(params) {
    return $57904f98be373a74$export$656ad65d6cf64174($09193e81812ba154$export$1d835e7a0f492f73, params);
}
function $09193e81812ba154$export$76f82835c9736f87(params) {
    return $57904f98be373a74$export$9ddff8176107cc11($09193e81812ba154$export$1d835e7a0f492f73, params);
}
function $09193e81812ba154$export$1d95835383bb05a(params) {
    return $57904f98be373a74$export$5ec965fd114a2f9f($09193e81812ba154$export$1d835e7a0f492f73, params);
}
function $09193e81812ba154$export$de9ffb9418dd7d0d(params) {
    return $57904f98be373a74$export$a43c28c6e86e066e($09193e81812ba154$export$1d835e7a0f492f73, params);
}
const $09193e81812ba154$export$723d146f80596191 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodBoolean", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$828bf41e557d7dda.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$f03e9163a5233fc4(inst, ctx, json, params);
});
function $09193e81812ba154$export$4a21f16c33752377(params) {
    return $57904f98be373a74$export$e23c41ce5ce2db39($09193e81812ba154$export$723d146f80596191, params);
}
const $09193e81812ba154$export$67d741fd70ff98f4 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodBigInt", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$7600843f2a3baa73.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$8810d61ae56edc9c(inst, ctx, json, params);
    inst.gte = (value, params)=>inst.check($57904f98be373a74$export$a1c6d8834a3b19c9(value, params));
    inst.min = (value, params)=>inst.check($57904f98be373a74$export$a1c6d8834a3b19c9(value, params));
    inst.gt = (value, params)=>inst.check($57904f98be373a74$export$7582466e3ab4d25b(value, params));
    inst.gte = (value, params)=>inst.check($57904f98be373a74$export$a1c6d8834a3b19c9(value, params));
    inst.min = (value, params)=>inst.check($57904f98be373a74$export$a1c6d8834a3b19c9(value, params));
    inst.lt = (value, params)=>inst.check($57904f98be373a74$export$2a42c74e76a068a(value, params));
    inst.lte = (value, params)=>inst.check($57904f98be373a74$export$7a060cf3d60b84a6(value, params));
    inst.max = (value, params)=>inst.check($57904f98be373a74$export$7a060cf3d60b84a6(value, params));
    inst.positive = (params)=>inst.check($57904f98be373a74$export$7582466e3ab4d25b(BigInt(0), params));
    inst.negative = (params)=>inst.check($57904f98be373a74$export$2a42c74e76a068a(BigInt(0), params));
    inst.nonpositive = (params)=>inst.check($57904f98be373a74$export$7a060cf3d60b84a6(BigInt(0), params));
    inst.nonnegative = (params)=>inst.check($57904f98be373a74$export$a1c6d8834a3b19c9(BigInt(0), params));
    inst.multipleOf = (value, params)=>inst.check($57904f98be373a74$export$c41e40f80e978ab1(value, params));
    const bag = inst._zod.bag;
    inst.minValue = bag.minimum ?? null;
    inst.maxValue = bag.maximum ?? null;
    inst.format = bag.format ?? null;
});
function $09193e81812ba154$export$a0f65b52274bcc00(params) {
    return $57904f98be373a74$export$c96ff33878177e4c($09193e81812ba154$export$67d741fd70ff98f4, params);
}
const $09193e81812ba154$export$7483f4dc330f3456 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodBigIntFormat", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$487194b75209a5dd.init(inst, def);
    $09193e81812ba154$export$67d741fd70ff98f4.init(inst, def);
});
function $09193e81812ba154$export$af207e6076994812(params) {
    return $57904f98be373a74$export$cb7d3ec922804f3f($09193e81812ba154$export$7483f4dc330f3456, params);
}
function $09193e81812ba154$export$870002f71f6ee2de(params) {
    return $57904f98be373a74$export$c51606f0dfa0f5a1($09193e81812ba154$export$7483f4dc330f3456, params);
}
const $09193e81812ba154$export$bcc3b40f6b638044 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodSymbol", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$c9e7e1831bb8dd12.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$fd2b3c73524160ce(inst, ctx, json, params);
});
function $09193e81812ba154$export$8f701197936bc2a6(params) {
    return $57904f98be373a74$export$a8f93f5b7c030e84($09193e81812ba154$export$bcc3b40f6b638044, params);
}
const $09193e81812ba154$export$4e780e961c30340d = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodUndefined", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$379ccf61f9830869.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$9838a7ce212344b0(inst, ctx, json, params);
});
function $09193e81812ba154$export$1db45310990710a5(params) {
    return $57904f98be373a74$export$60e4c9fe67803d40($09193e81812ba154$export$4e780e961c30340d, params);
}
const $09193e81812ba154$export$a96281f914484f2d = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodNull", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$d05db4d7bc9da27d.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$7667b76b86382b1f(inst, ctx, json, params);
});
function $09193e81812ba154$export$7b1b591b262c240(params) {
    return $57904f98be373a74$export$a2cbb38cda512d16($09193e81812ba154$export$a96281f914484f2d, params);
}
const $09193e81812ba154$export$b9d1edb536b4e4eb = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodAny", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$de3a83ac65a18f35.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$a92de72ffd9087b5(inst, ctx, json, params);
});
function $09193e81812ba154$export$4154a199d7d90455() {
    return $57904f98be373a74$export$4678886173313220($09193e81812ba154$export$b9d1edb536b4e4eb);
}
const $09193e81812ba154$export$ef3b1bb1630977ae = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodUnknown", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$37ea092643879ea0.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$4e1fea7b2e7474f(inst, ctx, json, params);
});
function $09193e81812ba154$export$19282c40b967aec6() {
    return $57904f98be373a74$export$e0ed508a47e00801($09193e81812ba154$export$ef3b1bb1630977ae);
}
const $09193e81812ba154$export$1e576a20c3ce9fb5 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodNever", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$4b2a18191b39c3b4.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$694b9cd80480ac33(inst, ctx, json, params);
});
function $09193e81812ba154$export$b3e22bcfd64c1022(params) {
    return $57904f98be373a74$export$887f43204ffc2a69($09193e81812ba154$export$1e576a20c3ce9fb5, params);
}
const $09193e81812ba154$export$7d39f5df85f21031 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodVoid", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$6fd82db70787afbb.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$b5910bb267c78233(inst, ctx, json, params);
});
function $09193e81812ba154$export$490e536ee7389aeb(params) {
    return $57904f98be373a74$export$9480825d3c8e9ad6($09193e81812ba154$export$7d39f5df85f21031, params);
}
const $09193e81812ba154$export$e974be33bdc55521 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodDate", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$9a0ab9fbd61629f8.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$d044e6246fe40d06(inst, ctx, json, params);
    inst.min = (value, params)=>inst.check($57904f98be373a74$export$a1c6d8834a3b19c9(value, params));
    inst.max = (value, params)=>inst.check($57904f98be373a74$export$7a060cf3d60b84a6(value, params));
    const c = inst._zod.bag;
    inst.minDate = c.minimum ? new Date(c.minimum) : null;
    inst.maxDate = c.maximum ? new Date(c.maximum) : null;
});
function $09193e81812ba154$export$324d90190a8b822a(params) {
    return $57904f98be373a74$export$da799735c76175a($09193e81812ba154$export$e974be33bdc55521, params);
}
const $09193e81812ba154$export$7acfc3e64785411 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodArray", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$fd77bdade7d2292b.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$afeff382d55f455b(inst, ctx, json, params);
    inst.element = def.element;
    inst.min = (minLength, params)=>inst.check($57904f98be373a74$export$21f6711a906c1450(minLength, params));
    inst.nonempty = (params)=>inst.check($57904f98be373a74$export$21f6711a906c1450(1, params));
    inst.max = (maxLength, params)=>inst.check($57904f98be373a74$export$ec76627108655a22(maxLength, params));
    inst.length = (len, params)=>inst.check($57904f98be373a74$export$620b9f7ab17ff8a9(len, params));
    inst.unwrap = ()=>inst.element;
});
function $09193e81812ba154$export$2f23118c22fb2630(element, params) {
    return $57904f98be373a74$export$4ea446333e3db634($09193e81812ba154$export$7acfc3e64785411, element, params);
}
function $09193e81812ba154$export$7e1278799275f68e(schema) {
    const shape = schema._zod.def.shape;
    return $09193e81812ba154$export$78a99c8d44d72635(Object.keys(shape));
}
const $09193e81812ba154$export$736315c5b55efbad = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodObject", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$330feb3f8e03c085.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$8cc078cf99794668(inst, ctx, json, params);
    (0, $17ea3f861a2ff584$exports).defineLazy(inst, "shape", ()=>{
        return def.shape;
    });
    inst.keyof = ()=>$09193e81812ba154$export$78a99c8d44d72635(Object.keys(inst._zod.def.shape));
    inst.catchall = (catchall)=>inst.clone({
            ...inst._zod.def,
            catchall: catchall
        });
    inst.passthrough = ()=>inst.clone({
            ...inst._zod.def,
            catchall: $09193e81812ba154$export$19282c40b967aec6()
        });
    inst.loose = ()=>inst.clone({
            ...inst._zod.def,
            catchall: $09193e81812ba154$export$19282c40b967aec6()
        });
    inst.strict = ()=>inst.clone({
            ...inst._zod.def,
            catchall: $09193e81812ba154$export$b3e22bcfd64c1022()
        });
    inst.strip = ()=>inst.clone({
            ...inst._zod.def,
            catchall: undefined
        });
    inst.extend = (incoming)=>{
        return (0, $17ea3f861a2ff584$exports).extend(inst, incoming);
    };
    inst.safeExtend = (incoming)=>{
        return (0, $17ea3f861a2ff584$exports).safeExtend(inst, incoming);
    };
    inst.merge = (other)=>(0, $17ea3f861a2ff584$exports).merge(inst, other);
    inst.pick = (mask)=>(0, $17ea3f861a2ff584$exports).pick(inst, mask);
    inst.omit = (mask)=>(0, $17ea3f861a2ff584$exports).omit(inst, mask);
    inst.partial = (...args)=>(0, $17ea3f861a2ff584$exports).partial($09193e81812ba154$export$aa56fec1e9d629b8, inst, args[0]);
    inst.required = (...args)=>(0, $17ea3f861a2ff584$exports).required($09193e81812ba154$export$eb04319818b4702e, inst, args[0]);
});
function $09193e81812ba154$export$be5493f9613cbbe(shape, params) {
    const def = {
        type: "object",
        shape: shape ?? {},
        ...(0, $17ea3f861a2ff584$exports).normalizeParams(params)
    };
    return new $09193e81812ba154$export$736315c5b55efbad(def);
}
function $09193e81812ba154$export$8fb0df5f40d0b477(shape, params) {
    return new $09193e81812ba154$export$736315c5b55efbad({
        type: "object",
        shape: shape,
        catchall: $09193e81812ba154$export$b3e22bcfd64c1022(),
        ...(0, $17ea3f861a2ff584$exports).normalizeParams(params)
    });
}
function $09193e81812ba154$export$bc233bd5e67eecd(shape, params) {
    return new $09193e81812ba154$export$736315c5b55efbad({
        type: "object",
        shape: shape,
        catchall: $09193e81812ba154$export$19282c40b967aec6(),
        ...(0, $17ea3f861a2ff584$exports).normalizeParams(params)
    });
}
const $09193e81812ba154$export$a8b236cb5070a311 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodUnion", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$37a2350ef0bd638c.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$f387dff1d8008b49(inst, ctx, json, params);
    inst.options = def.options;
});
function $09193e81812ba154$export$971dd5b0dfd021b6(options, params) {
    return new $09193e81812ba154$export$a8b236cb5070a311({
        type: "union",
        options: options,
        ...(0, $17ea3f861a2ff584$exports).normalizeParams(params)
    });
}
const $09193e81812ba154$export$b87e6de7c4c8bfc7 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodXor", (inst, def)=>{
    $09193e81812ba154$export$a8b236cb5070a311.init(inst, def);
    $e32a9d04eaeb9d0c$export$b04ced974a46c0b4.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$f387dff1d8008b49(inst, ctx, json, params);
    inst.options = def.options;
});
function $09193e81812ba154$export$6444ef5cd411280c(options, params) {
    return new $09193e81812ba154$export$b87e6de7c4c8bfc7({
        type: "union",
        options: options,
        inclusive: false,
        ...(0, $17ea3f861a2ff584$exports).normalizeParams(params)
    });
}
const $09193e81812ba154$export$5ef2424805ac76a3 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodDiscriminatedUnion", (inst, def)=>{
    $09193e81812ba154$export$a8b236cb5070a311.init(inst, def);
    $e32a9d04eaeb9d0c$export$aad4f17edfb83795.init(inst, def);
});
function $09193e81812ba154$export$4b888e40c4ee26dd(discriminator, options, params) {
    // const [options, params] = args;
    return new $09193e81812ba154$export$5ef2424805ac76a3({
        type: "union",
        options: options,
        discriminator: discriminator,
        ...(0, $17ea3f861a2ff584$exports).normalizeParams(params)
    });
}
const $09193e81812ba154$export$c02deaf0bb5203d4 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodIntersection", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$2299250b426aba4b.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$2a29f9128b7167c3(inst, ctx, json, params);
});
function $09193e81812ba154$export$bc86dfbf7795668c(left, right) {
    return new $09193e81812ba154$export$c02deaf0bb5203d4({
        type: "intersection",
        left: left,
        right: right
    });
}
const $09193e81812ba154$export$e2a18bb771d8e6a3 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodTuple", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$bba1b90a721dbd94.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$7767a398545ac85c(inst, ctx, json, params);
    inst.rest = (rest)=>inst.clone({
            ...inst._zod.def,
            rest: rest
        });
});
function $09193e81812ba154$export$65e3907585753458(items, _paramsOrRest, _params) {
    const hasRest = _paramsOrRest instanceof $e32a9d04eaeb9d0c$export$f43a5c3966de8238;
    const params = hasRest ? _params : _paramsOrRest;
    const rest = hasRest ? _paramsOrRest : null;
    return new $09193e81812ba154$export$e2a18bb771d8e6a3({
        type: "tuple",
        items: items,
        rest: rest,
        ...(0, $17ea3f861a2ff584$exports).normalizeParams(params)
    });
}
const $09193e81812ba154$export$a2acc09968cb4b7f = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodRecord", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$cc20b90ec1a8c208.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$6cf7a4b4a95ef1a8(inst, ctx, json, params);
    inst.keyType = def.keyType;
    inst.valueType = def.valueType;
});
function $09193e81812ba154$export$e5185e241753e543(keyType, valueType, params) {
    return new $09193e81812ba154$export$a2acc09968cb4b7f({
        type: "record",
        keyType: keyType,
        valueType: valueType,
        ...(0, $17ea3f861a2ff584$exports).normalizeParams(params)
    });
}
function $09193e81812ba154$export$669401d1edf671b3(keyType, valueType, params) {
    const k = $17ea3f861a2ff584$export$9cd59f9826255e47(keyType);
    k._zod.values = undefined;
    return new $09193e81812ba154$export$a2acc09968cb4b7f({
        type: "record",
        keyType: k,
        valueType: valueType,
        ...(0, $17ea3f861a2ff584$exports).normalizeParams(params)
    });
}
function $09193e81812ba154$export$afe1641377ace256(keyType, valueType, params) {
    return new $09193e81812ba154$export$a2acc09968cb4b7f({
        type: "record",
        keyType: keyType,
        valueType: valueType,
        mode: "loose",
        ...(0, $17ea3f861a2ff584$exports).normalizeParams(params)
    });
}
const $09193e81812ba154$export$163b6a2b712d9542 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodMap", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$5ccfd30a7e358409.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$5e912d1710885757(inst, ctx, json, params);
    inst.keyType = def.keyType;
    inst.valueType = def.valueType;
    inst.min = (...args)=>inst.check($57904f98be373a74$export$e379713268c2c18a(...args));
    inst.nonempty = (params)=>inst.check($57904f98be373a74$export$e379713268c2c18a(1, params));
    inst.max = (...args)=>inst.check($57904f98be373a74$export$3eed6ccb98bc18db(...args));
    inst.size = (...args)=>inst.check($57904f98be373a74$export$2621565b966a8d23(...args));
});
function $09193e81812ba154$export$871de8747c9eaa88(keyType, valueType, params) {
    return new $09193e81812ba154$export$163b6a2b712d9542({
        type: "map",
        keyType: keyType,
        valueType: valueType,
        ...(0, $17ea3f861a2ff584$exports).normalizeParams(params)
    });
}
const $09193e81812ba154$export$977057706f816712 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodSet", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$20cf27bc33a30268.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$2ff44e7a32269271(inst, ctx, json, params);
    inst.min = (...args)=>inst.check($57904f98be373a74$export$e379713268c2c18a(...args));
    inst.nonempty = (params)=>inst.check($57904f98be373a74$export$e379713268c2c18a(1, params));
    inst.max = (...args)=>inst.check($57904f98be373a74$export$3eed6ccb98bc18db(...args));
    inst.size = (...args)=>inst.check($57904f98be373a74$export$2621565b966a8d23(...args));
});
function $09193e81812ba154$export$adaa4cf7ef1b65be(valueType, params) {
    return new $09193e81812ba154$export$977057706f816712({
        type: "set",
        valueType: valueType,
        ...(0, $17ea3f861a2ff584$exports).normalizeParams(params)
    });
}
const $09193e81812ba154$export$d325d1f0e1c20179 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodEnum", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$31462b6e6c50b618.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$a0f7e3681bbe4f0b(inst, ctx, json, params);
    inst.enum = def.entries;
    inst.options = Object.values(def.entries);
    const keys = new Set(Object.keys(def.entries));
    inst.extract = (values, params)=>{
        const newEntries = {};
        for (const value of values){
            if (keys.has(value)) newEntries[value] = def.entries[value];
            else throw new Error(`Key ${value} not found in enum`);
        }
        return new $09193e81812ba154$export$d325d1f0e1c20179({
            ...def,
            checks: [],
            ...(0, $17ea3f861a2ff584$exports).normalizeParams(params),
            entries: newEntries
        });
    };
    inst.exclude = (values, params)=>{
        const newEntries = {
            ...def.entries
        };
        for (const value of values){
            if (keys.has(value)) delete newEntries[value];
            else throw new Error(`Key ${value} not found in enum`);
        }
        return new $09193e81812ba154$export$d325d1f0e1c20179({
            ...def,
            checks: [],
            ...(0, $17ea3f861a2ff584$exports).normalizeParams(params),
            entries: newEntries
        });
    };
});
function $09193e81812ba154$export$78a99c8d44d72635(values, params) {
    const entries = Array.isArray(values) ? Object.fromEntries(values.map((v)=>[
            v,
            v
        ])) : values;
    return new $09193e81812ba154$export$d325d1f0e1c20179({
        type: "enum",
        entries: entries,
        ...(0, $17ea3f861a2ff584$exports).normalizeParams(params)
    });
}
function $09193e81812ba154$export$6fe7eca19ebe5199(entries, params) {
    return new $09193e81812ba154$export$d325d1f0e1c20179({
        type: "enum",
        entries: entries,
        ...(0, $17ea3f861a2ff584$exports).normalizeParams(params)
    });
}
const $09193e81812ba154$export$7e44096782a165d3 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodLiteral", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$86699355265fa258.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$b7a483a046d3a9b(inst, ctx, json, params);
    inst.values = new Set(def.values);
    Object.defineProperty(inst, "value", {
        get () {
            if (def.values.length > 1) throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
            return def.values[0];
        }
    });
});
function $09193e81812ba154$export$c8ec6e1ec9fefcb0(value, params) {
    return new $09193e81812ba154$export$7e44096782a165d3({
        type: "literal",
        values: Array.isArray(value) ? value : [
            value
        ],
        ...(0, $17ea3f861a2ff584$exports).normalizeParams(params)
    });
}
const $09193e81812ba154$export$1aa10ff06069e07d = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodFile", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$1997de0576a81377.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$62de47a40c7b42b0(inst, ctx, json, params);
    inst.min = (size, params)=>inst.check($57904f98be373a74$export$e379713268c2c18a(size, params));
    inst.max = (size, params)=>inst.check($57904f98be373a74$export$3eed6ccb98bc18db(size, params));
    inst.mime = (types, params)=>inst.check($57904f98be373a74$export$267177285a1a8b37(Array.isArray(types) ? types : [
            types
        ], params));
});
function $09193e81812ba154$export$c2a28f090bb0afd6(params) {
    return $57904f98be373a74$export$e335cd0b9f8bab1e($09193e81812ba154$export$1aa10ff06069e07d, params);
}
const $09193e81812ba154$export$cf1499e83869147b = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodTransform", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$14b591f873519189.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$707b17683f9c9ec0(inst, ctx, json, params);
    inst._zod.parse = (payload, _ctx)=>{
        if (_ctx.direction === "backward") throw new $4488038d123e8fa5$export$a36d4c29b1151bde(inst.constructor.name);
        payload.addIssue = (issue)=>{
            if (typeof issue === "string") payload.issues.push((0, $17ea3f861a2ff584$exports).issue(issue, payload.value, def));
            else {
                // for Zod 3 backwards compatibility
                const _issue = issue;
                if (_issue.fatal) _issue.continue = false;
                _issue.code ?? (_issue.code = "custom");
                _issue.input ?? (_issue.input = payload.value);
                _issue.inst ?? (_issue.inst = inst);
                // _issue.continue ??= true;
                payload.issues.push((0, $17ea3f861a2ff584$exports).issue(_issue));
            }
        };
        const output = def.transform(payload.value, payload);
        if (output instanceof Promise) return output.then((output)=>{
            payload.value = output;
            return payload;
        });
        payload.value = output;
        return payload;
    };
});
function $09193e81812ba154$export$51186ad6e864892a(fn) {
    return new $09193e81812ba154$export$cf1499e83869147b({
        type: "transform",
        transform: fn
    });
}
const $09193e81812ba154$export$aa56fec1e9d629b8 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodOptional", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$980e9af565c4d7aa.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$4b1db46aa3739c48(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $09193e81812ba154$export$516e28dec6a4b6d4(innerType) {
    return new $09193e81812ba154$export$aa56fec1e9d629b8({
        type: "optional",
        innerType: innerType
    });
}
const $09193e81812ba154$export$af29c4375d3792a4 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodExactOptional", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$384d083c2a6b693f.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$4b1db46aa3739c48(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $09193e81812ba154$export$76092ad52134d3a0(innerType) {
    return new $09193e81812ba154$export$af29c4375d3792a4({
        type: "optional",
        innerType: innerType
    });
}
const $09193e81812ba154$export$aaac0b8b429cef5 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodNullable", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$7994573b6604ec66.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$452ce6f96b49219a(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $09193e81812ba154$export$133fc36489ac9add(innerType) {
    return new $09193e81812ba154$export$aaac0b8b429cef5({
        type: "nullable",
        innerType: innerType
    });
}
function $09193e81812ba154$export$69fd1b70ebae5687(innerType) {
    return $09193e81812ba154$export$516e28dec6a4b6d4($09193e81812ba154$export$133fc36489ac9add(innerType));
}
const $09193e81812ba154$export$bb19b37874861e7e = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodDefault", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$ae2d21004b7243f7.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$f76e6c36e8fb062b(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
    inst.removeDefault = inst.unwrap;
});
function $09193e81812ba154$export$d4b0f68d0d916971(innerType, defaultValue) {
    return new $09193e81812ba154$export$bb19b37874861e7e({
        type: "default",
        innerType: innerType,
        get defaultValue () {
            return typeof defaultValue === "function" ? defaultValue() : (0, $17ea3f861a2ff584$exports).shallowClone(defaultValue);
        }
    });
}
const $09193e81812ba154$export$b619aec225e4abe9 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodPrefault", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$29a8d757258be679.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$1ded4e432f286ac2(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $09193e81812ba154$export$569da376ae266d0a(innerType, defaultValue) {
    return new $09193e81812ba154$export$b619aec225e4abe9({
        type: "prefault",
        innerType: innerType,
        get defaultValue () {
            return typeof defaultValue === "function" ? defaultValue() : (0, $17ea3f861a2ff584$exports).shallowClone(defaultValue);
        }
    });
}
const $09193e81812ba154$export$eb04319818b4702e = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodNonOptional", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$30ca726c4c50a6d7.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$7c6ac5b60b42bfc9(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $09193e81812ba154$export$e6aa51fdda6cd70d(innerType, params) {
    return new $09193e81812ba154$export$eb04319818b4702e({
        type: "nonoptional",
        innerType: innerType,
        ...(0, $17ea3f861a2ff584$exports).normalizeParams(params)
    });
}
const $09193e81812ba154$export$89dfce00a343f317 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodSuccess", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$3cc4d03e729326ea.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$1e296a49315ba27a(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $09193e81812ba154$export$fe7c49d056ea1d88(innerType) {
    return new $09193e81812ba154$export$89dfce00a343f317({
        type: "success",
        innerType: innerType
    });
}
const $09193e81812ba154$export$75a44ec6249ac76b = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodCatch", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$d6f8b228374f6d37.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$3f81793c903cb504(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
    inst.removeCatch = inst.unwrap;
});
function $09193e81812ba154$export$e1d4808a6ac94c4c(innerType, catchValue) {
    return new $09193e81812ba154$export$75a44ec6249ac76b({
        type: "catch",
        innerType: innerType,
        catchValue: typeof catchValue === "function" ? catchValue : ()=>catchValue
    });
}
const $09193e81812ba154$export$26ccfa0145e8511f = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodNaN", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$528f71701e6a7aee.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$f33d8739d51ecc4b(inst, ctx, json, params);
});
function $09193e81812ba154$export$9e06de0973666692(params) {
    return $57904f98be373a74$export$a5e7e1f8491a5e50($09193e81812ba154$export$26ccfa0145e8511f, params);
}
const $09193e81812ba154$export$8c4c5c16b952637a = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodPipe", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$4cb25cfde430326c.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$3a3e6911d4012a24(inst, ctx, json, params);
    inst.in = def.in;
    inst.out = def.out;
});
function $09193e81812ba154$export$a4627e546088548d(in_, out) {
    return new $09193e81812ba154$export$8c4c5c16b952637a({
        type: "pipe",
        in: in_,
        out: out
    });
}
const $09193e81812ba154$export$d2591c20339f7464 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodCodec", (inst, def)=>{
    $09193e81812ba154$export$8c4c5c16b952637a.init(inst, def);
    $e32a9d04eaeb9d0c$export$c622e07db8a40b53.init(inst, def);
});
function $09193e81812ba154$export$1c37c01eba8ed446(in_, out, params) {
    return new $09193e81812ba154$export$d2591c20339f7464({
        type: "pipe",
        in: in_,
        out: out,
        transform: params.decode,
        reverseTransform: params.encode
    });
}
const $09193e81812ba154$export$5d1f7ef05c4e493a = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodReadonly", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$f9f268f3fbb1601b.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$dd90252c562e1d9(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $09193e81812ba154$export$6ec456bd5b7b3c51(innerType) {
    return new $09193e81812ba154$export$5d1f7ef05c4e493a({
        type: "readonly",
        innerType: innerType
    });
}
const $09193e81812ba154$export$e6e9ee3f9fd7fdd9 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodTemplateLiteral", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$37ea86c57a77af54.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$59812826ec9f1850(inst, ctx, json, params);
});
function $09193e81812ba154$export$859cd210a8f40722(parts, params) {
    return new $09193e81812ba154$export$e6e9ee3f9fd7fdd9({
        type: "template_literal",
        parts: parts,
        ...(0, $17ea3f861a2ff584$exports).normalizeParams(params)
    });
}
const $09193e81812ba154$export$378d0cfce37406e6 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodLazy", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$662fecee2efa1a66.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$9980155f320c317b(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.getter();
});
function $09193e81812ba154$export$488013bae63b21da(getter) {
    return new $09193e81812ba154$export$378d0cfce37406e6({
        type: "lazy",
        getter: getter
    });
}
const $09193e81812ba154$export$3f196b0127d6e50a = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodPromise", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$bdefabff0dd84ca4.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$ecb899a95fe4bdc0(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $09193e81812ba154$export$c957ef27a0ebfd4(innerType) {
    return new $09193e81812ba154$export$3f196b0127d6e50a({
        type: "promise",
        innerType: innerType
    });
}
const $09193e81812ba154$export$d4602ba55673f53c = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodFunction", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$877c6e9c05ede764.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$654f185ba88226ab(inst, ctx, json, params);
});
function $09193e81812ba154$export$6e2aba165ec1f1d9(params) {
    return new $09193e81812ba154$export$d4602ba55673f53c({
        type: "function",
        input: Array.isArray(params?.input) ? $09193e81812ba154$export$65e3907585753458(params?.input) : params?.input ?? $09193e81812ba154$export$2f23118c22fb2630($09193e81812ba154$export$19282c40b967aec6()),
        output: params?.output ?? $09193e81812ba154$export$19282c40b967aec6()
    });
}
const $09193e81812ba154$export$76cf7569fb33e487 = /*@__PURE__*/ $4488038d123e8fa5$export$3122533d606194de("ZodCustom", (inst, def)=>{
    $e32a9d04eaeb9d0c$export$3a5d0e5e098b79ba.init(inst, def);
    $09193e81812ba154$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$fb6286dd552db993$export$fe3af043a76e4dab(inst, ctx, json, params);
});
function $09193e81812ba154$export$35dc45686fc2dbd7(fn) {
    const ch = new $bd6e402f1568d28b$export$c05d9110ef20bb2c({
        check: "custom"
    });
    ch._zod.check = fn;
    return ch;
}
function $09193e81812ba154$export$4c00f665f0d4b443(fn, _params) {
    return $57904f98be373a74$export$8bfc2ce1398e3071($09193e81812ba154$export$76cf7569fb33e487, fn ?? (()=>true), _params);
}
function $09193e81812ba154$export$edc9d475108b3212(fn, _params = {}) {
    return $57904f98be373a74$export$ac822e05051812e1($09193e81812ba154$export$76cf7569fb33e487, fn, _params);
}
function $09193e81812ba154$export$e0f31df04c32a6bf(fn) {
    return $57904f98be373a74$export$f2b01ecb843d7ab9(fn);
}
const $09193e81812ba154$export$cd5450f3a47e3789 = $57904f98be373a74$export$cd5450f3a47e3789;
const $09193e81812ba154$export$6990040ee07315 = $57904f98be373a74$export$6990040ee07315;
function $09193e81812ba154$export$3d916e7c22dbd8b5(cls, params = {}) {
    const inst = new $09193e81812ba154$export$76cf7569fb33e487({
        type: "custom",
        check: "custom",
        fn: (data)=>data instanceof cls,
        abort: true,
        ...(0, $17ea3f861a2ff584$exports).normalizeParams(params)
    });
    inst._zod.bag.Class = cls;
    // Override check to emit invalid_type instead of custom
    inst._zod.check = (payload)=>{
        if (!(payload.value instanceof cls)) payload.issues.push({
            code: "invalid_type",
            expected: cls.name,
            input: payload.value,
            inst: inst,
            path: [
                ...inst._zod.def.path ?? []
            ]
        });
    };
    return inst;
}
const $09193e81812ba154$export$c1250768cb298588 = (...args)=>$57904f98be373a74$export$a75528509e3a7006({
        Codec: $09193e81812ba154$export$d2591c20339f7464,
        Boolean: $09193e81812ba154$export$723d146f80596191,
        String: $09193e81812ba154$export$1230eb29b8d3b502
    }, ...args);
function $09193e81812ba154$export$7b419323e6ed4f31(params) {
    const jsonSchema = $09193e81812ba154$export$488013bae63b21da(()=>{
        return $09193e81812ba154$export$971dd5b0dfd021b6([
            $09193e81812ba154$export$22b082955e083ec3(params),
            $09193e81812ba154$export$98e628dec113755e(),
            $09193e81812ba154$export$4a21f16c33752377(),
            $09193e81812ba154$export$7b1b591b262c240(),
            $09193e81812ba154$export$2f23118c22fb2630(jsonSchema),
            $09193e81812ba154$export$e5185e241753e543($09193e81812ba154$export$22b082955e083ec3(), jsonSchema)
        ]);
    });
    return jsonSchema;
}
function $09193e81812ba154$export$fc37fe19dfda43ee(fn, schema) {
    return $09193e81812ba154$export$a4627e546088548d($09193e81812ba154$export$51186ad6e864892a(fn), schema);
}





// Zod 3 compat layer

const $25bed8b83da1f41f$export$5ba560653e4a1035 = {
    invalid_type: "invalid_type",
    too_big: "too_big",
    too_small: "too_small",
    invalid_format: "invalid_format",
    not_multiple_of: "not_multiple_of",
    unrecognized_keys: "unrecognized_keys",
    invalid_union: "invalid_union",
    invalid_key: "invalid_key",
    invalid_element: "invalid_element",
    invalid_value: "invalid_value",
    custom: "custom"
};
function $25bed8b83da1f41f$export$1097a8289cfd22d7(map) {
    $4488038d123e8fa5$export$e506a1d27d1eaa20({
        customError: map
    });
}
function $25bed8b83da1f41f$export$32f27c719778d4c4() {
    return $4488038d123e8fa5$export$e506a1d27d1eaa20().customError;
}
var $25bed8b83da1f41f$export$558106ce543bd011;
$25bed8b83da1f41f$export$558106ce543bd011 || ($25bed8b83da1f41f$export$558106ce543bd011 = {});








// Local z object to avoid circular dependency with ../index.js
const $dd0132d0138d3dd8$var$z = {
    ...$09193e81812ba154$exports,
    ...$72150b10d982cc55$exports,
    iso: $0c3f217e6a9cca3d$exports
};
// Keys that are recognized and handled by the conversion logic
const $dd0132d0138d3dd8$var$RECOGNIZED_KEYS = new Set([
    // Schema identification
    "$schema",
    "$ref",
    "$defs",
    "definitions",
    // Core schema keywords
    "$id",
    "id",
    "$comment",
    "$anchor",
    "$vocabulary",
    "$dynamicRef",
    "$dynamicAnchor",
    // Type
    "type",
    "enum",
    "const",
    // Composition
    "anyOf",
    "oneOf",
    "allOf",
    "not",
    // Object
    "properties",
    "required",
    "additionalProperties",
    "patternProperties",
    "propertyNames",
    "minProperties",
    "maxProperties",
    // Array
    "items",
    "prefixItems",
    "additionalItems",
    "minItems",
    "maxItems",
    "uniqueItems",
    "contains",
    "minContains",
    "maxContains",
    // String
    "minLength",
    "maxLength",
    "pattern",
    "format",
    // Number
    "minimum",
    "maximum",
    "exclusiveMinimum",
    "exclusiveMaximum",
    "multipleOf",
    // Already handled metadata
    "description",
    "default",
    // Content
    "contentEncoding",
    "contentMediaType",
    "contentSchema",
    // Unsupported (error-throwing)
    "unevaluatedItems",
    "unevaluatedProperties",
    "if",
    "then",
    "else",
    "dependentSchemas",
    "dependentRequired",
    // OpenAPI
    "nullable",
    "readOnly"
]);
function $dd0132d0138d3dd8$var$detectVersion(schema, defaultTarget) {
    const $schema = schema.$schema;
    if ($schema === "https://json-schema.org/draft/2020-12/schema") return "draft-2020-12";
    if ($schema === "http://json-schema.org/draft-07/schema#") return "draft-7";
    if ($schema === "http://json-schema.org/draft-04/schema#") return "draft-4";
    // Use defaultTarget if provided, otherwise default to draft-2020-12
    return defaultTarget ?? "draft-2020-12";
}
function $dd0132d0138d3dd8$var$resolveRef(ref, ctx) {
    if (!ref.startsWith("#")) throw new Error("External $ref is not supported, only local refs (#/...) are allowed");
    const path = ref.slice(1).split("/").filter(Boolean);
    // Handle root reference "#"
    if (path.length === 0) return ctx.rootSchema;
    const defsKey = ctx.version === "draft-2020-12" ? "$defs" : "definitions";
    if (path[0] === defsKey) {
        const key = path[1];
        if (!key || !ctx.defs[key]) throw new Error(`Reference not found: ${ref}`);
        return ctx.defs[key];
    }
    throw new Error(`Reference not found: ${ref}`);
}
function $dd0132d0138d3dd8$var$convertBaseSchema(schema, ctx) {
    // Handle unsupported features
    if (schema.not !== undefined) {
        // Special case: { not: {} } represents never
        if (typeof schema.not === "object" && Object.keys(schema.not).length === 0) return $dd0132d0138d3dd8$var$z.never();
        throw new Error("not is not supported in Zod (except { not: {} } for never)");
    }
    if (schema.unevaluatedItems !== undefined) throw new Error("unevaluatedItems is not supported");
    if (schema.unevaluatedProperties !== undefined) throw new Error("unevaluatedProperties is not supported");
    if (schema.if !== undefined || schema.then !== undefined || schema.else !== undefined) throw new Error("Conditional schemas (if/then/else) are not supported");
    if (schema.dependentSchemas !== undefined || schema.dependentRequired !== undefined) throw new Error("dependentSchemas and dependentRequired are not supported");
    // Handle $ref
    if (schema.$ref) {
        const refPath = schema.$ref;
        if (ctx.refs.has(refPath)) return ctx.refs.get(refPath);
        if (ctx.processing.has(refPath)) // Circular reference - use lazy
        return $dd0132d0138d3dd8$var$z.lazy(()=>{
            if (!ctx.refs.has(refPath)) throw new Error(`Circular reference not resolved: ${refPath}`);
            return ctx.refs.get(refPath);
        });
        ctx.processing.add(refPath);
        const resolved = $dd0132d0138d3dd8$var$resolveRef(refPath, ctx);
        const zodSchema = $dd0132d0138d3dd8$var$convertSchema(resolved, ctx);
        ctx.refs.set(refPath, zodSchema);
        ctx.processing.delete(refPath);
        return zodSchema;
    }
    // Handle enum
    if (schema.enum !== undefined) {
        const enumValues = schema.enum;
        // Special case: OpenAPI 3.0 null representation { type: "string", nullable: true, enum: [null] }
        if (ctx.version === "openapi-3.0" && schema.nullable === true && enumValues.length === 1 && enumValues[0] === null) return $dd0132d0138d3dd8$var$z.null();
        if (enumValues.length === 0) return $dd0132d0138d3dd8$var$z.never();
        if (enumValues.length === 1) return $dd0132d0138d3dd8$var$z.literal(enumValues[0]);
        // Check if all values are strings
        if (enumValues.every((v)=>typeof v === "string")) return $dd0132d0138d3dd8$var$z.enum(enumValues);
        // Mixed types - use union of literals
        const literalSchemas = enumValues.map((v)=>$dd0132d0138d3dd8$var$z.literal(v));
        if (literalSchemas.length < 2) return literalSchemas[0];
        return $dd0132d0138d3dd8$var$z.union([
            literalSchemas[0],
            literalSchemas[1],
            ...literalSchemas.slice(2)
        ]);
    }
    // Handle const
    if (schema.const !== undefined) return $dd0132d0138d3dd8$var$z.literal(schema.const);
    // Handle type
    const type = schema.type;
    if (Array.isArray(type)) {
        // Expand type array into anyOf union
        const typeSchemas = type.map((t)=>{
            const typeSchema = {
                ...schema,
                type: t
            };
            return $dd0132d0138d3dd8$var$convertBaseSchema(typeSchema, ctx);
        });
        if (typeSchemas.length === 0) return $dd0132d0138d3dd8$var$z.never();
        if (typeSchemas.length === 1) return typeSchemas[0];
        return $dd0132d0138d3dd8$var$z.union(typeSchemas);
    }
    if (!type) // No type specified - empty schema (any)
    return $dd0132d0138d3dd8$var$z.any();
    let zodSchema;
    switch(type){
        case "string":
            {
                let stringSchema = $dd0132d0138d3dd8$var$z.string();
                // Apply format using .check() with Zod format functions
                if (schema.format) {
                    const format = schema.format;
                    // Map common formats to Zod check functions
                    if (format === "email") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.email());
                    else if (format === "uri" || format === "uri-reference") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.url());
                    else if (format === "uuid" || format === "guid") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.uuid());
                    else if (format === "date-time") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.iso.datetime());
                    else if (format === "date") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.iso.date());
                    else if (format === "time") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.iso.time());
                    else if (format === "duration") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.iso.duration());
                    else if (format === "ipv4") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.ipv4());
                    else if (format === "ipv6") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.ipv6());
                    else if (format === "mac") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.mac());
                    else if (format === "cidr") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.cidrv4());
                    else if (format === "cidr-v6") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.cidrv6());
                    else if (format === "base64") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.base64());
                    else if (format === "base64url") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.base64url());
                    else if (format === "e164") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.e164());
                    else if (format === "jwt") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.jwt());
                    else if (format === "emoji") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.emoji());
                    else if (format === "nanoid") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.nanoid());
                    else if (format === "cuid") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.cuid());
                    else if (format === "cuid2") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.cuid2());
                    else if (format === "ulid") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.ulid());
                    else if (format === "xid") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.xid());
                    else if (format === "ksuid") stringSchema = stringSchema.check($dd0132d0138d3dd8$var$z.ksuid());
                // Note: json-string format is not currently supported by Zod
                // Custom formats are ignored - keep as plain string
                }
                // Apply constraints
                if (typeof schema.minLength === "number") stringSchema = stringSchema.min(schema.minLength);
                if (typeof schema.maxLength === "number") stringSchema = stringSchema.max(schema.maxLength);
                if (schema.pattern) // JSON Schema patterns are not implicitly anchored (match anywhere in string)
                stringSchema = stringSchema.regex(new RegExp(schema.pattern));
                zodSchema = stringSchema;
                break;
            }
        case "number":
        case "integer":
            {
                let numberSchema = type === "integer" ? $dd0132d0138d3dd8$var$z.number().int() : $dd0132d0138d3dd8$var$z.number();
                // Apply constraints
                if (typeof schema.minimum === "number") numberSchema = numberSchema.min(schema.minimum);
                if (typeof schema.maximum === "number") numberSchema = numberSchema.max(schema.maximum);
                if (typeof schema.exclusiveMinimum === "number") numberSchema = numberSchema.gt(schema.exclusiveMinimum);
                else if (schema.exclusiveMinimum === true && typeof schema.minimum === "number") numberSchema = numberSchema.gt(schema.minimum);
                if (typeof schema.exclusiveMaximum === "number") numberSchema = numberSchema.lt(schema.exclusiveMaximum);
                else if (schema.exclusiveMaximum === true && typeof schema.maximum === "number") numberSchema = numberSchema.lt(schema.maximum);
                if (typeof schema.multipleOf === "number") numberSchema = numberSchema.multipleOf(schema.multipleOf);
                zodSchema = numberSchema;
                break;
            }
        case "boolean":
            zodSchema = $dd0132d0138d3dd8$var$z.boolean();
            break;
        case "null":
            zodSchema = $dd0132d0138d3dd8$var$z.null();
            break;
        case "object":
            {
                const shape = {};
                const properties = schema.properties || {};
                const requiredSet = new Set(schema.required || []);
                // Convert properties - mark optional ones
                for (const [key, propSchema] of Object.entries(properties)){
                    const propZodSchema = $dd0132d0138d3dd8$var$convertSchema(propSchema, ctx);
                    // If not in required array, make it optional
                    shape[key] = requiredSet.has(key) ? propZodSchema : propZodSchema.optional();
                }
                // Handle propertyNames
                if (schema.propertyNames) {
                    const keySchema = $dd0132d0138d3dd8$var$convertSchema(schema.propertyNames, ctx);
                    const valueSchema = schema.additionalProperties && typeof schema.additionalProperties === "object" ? $dd0132d0138d3dd8$var$convertSchema(schema.additionalProperties, ctx) : $dd0132d0138d3dd8$var$z.any();
                    // Case A: No properties (pure record)
                    if (Object.keys(shape).length === 0) {
                        zodSchema = $dd0132d0138d3dd8$var$z.record(keySchema, valueSchema);
                        break;
                    }
                    // Case B: With properties (intersection of object and looseRecord)
                    const objectSchema = $dd0132d0138d3dd8$var$z.object(shape).passthrough();
                    const recordSchema = $dd0132d0138d3dd8$var$z.looseRecord(keySchema, valueSchema);
                    zodSchema = $dd0132d0138d3dd8$var$z.intersection(objectSchema, recordSchema);
                    break;
                }
                // Handle patternProperties
                if (schema.patternProperties) {
                    // patternProperties: keys matching pattern must satisfy corresponding schema
                    // Use loose records so non-matching keys pass through
                    const patternProps = schema.patternProperties;
                    const patternKeys = Object.keys(patternProps);
                    const looseRecords = [];
                    for (const pattern of patternKeys){
                        const patternValue = $dd0132d0138d3dd8$var$convertSchema(patternProps[pattern], ctx);
                        const keySchema = $dd0132d0138d3dd8$var$z.string().regex(new RegExp(pattern));
                        looseRecords.push($dd0132d0138d3dd8$var$z.looseRecord(keySchema, patternValue));
                    }
                    // Build intersection: object schema + all pattern property records
                    const schemasToIntersect = [];
                    if (Object.keys(shape).length > 0) // Use passthrough so patternProperties can validate additional keys
                    schemasToIntersect.push($dd0132d0138d3dd8$var$z.object(shape).passthrough());
                    schemasToIntersect.push(...looseRecords);
                    if (schemasToIntersect.length === 0) zodSchema = $dd0132d0138d3dd8$var$z.object({}).passthrough();
                    else if (schemasToIntersect.length === 1) zodSchema = schemasToIntersect[0];
                    else {
                        // Chain intersections: (A & B) & C & D ...
                        let result = $dd0132d0138d3dd8$var$z.intersection(schemasToIntersect[0], schemasToIntersect[1]);
                        for(let i = 2; i < schemasToIntersect.length; i++)result = $dd0132d0138d3dd8$var$z.intersection(result, schemasToIntersect[i]);
                        zodSchema = result;
                    }
                    break;
                }
                // Handle additionalProperties
                // In JSON Schema, additionalProperties defaults to true (allow any extra properties)
                // In Zod, objects strip unknown keys by default, so we need to handle this explicitly
                const objectSchema = $dd0132d0138d3dd8$var$z.object(shape);
                if (schema.additionalProperties === false) // Strict mode - no extra properties allowed
                zodSchema = objectSchema.strict();
                else if (typeof schema.additionalProperties === "object") // Extra properties must match the specified schema
                zodSchema = objectSchema.catchall($dd0132d0138d3dd8$var$convertSchema(schema.additionalProperties, ctx));
                else // additionalProperties is true or undefined - allow any extra properties (passthrough)
                zodSchema = objectSchema.passthrough();
                break;
            }
        case "array":
            {
                // TODO: uniqueItems is not supported
                // TODO: contains/minContains/maxContains are not supported
                // Check if this is a tuple (prefixItems or items as array)
                const prefixItems = schema.prefixItems;
                const items = schema.items;
                if (prefixItems && Array.isArray(prefixItems)) {
                    // Tuple with prefixItems (draft-2020-12)
                    const tupleItems = prefixItems.map((item)=>$dd0132d0138d3dd8$var$convertSchema(item, ctx));
                    const rest = items && typeof items === "object" && !Array.isArray(items) ? $dd0132d0138d3dd8$var$convertSchema(items, ctx) : undefined;
                    if (rest) zodSchema = $dd0132d0138d3dd8$var$z.tuple(tupleItems).rest(rest);
                    else zodSchema = $dd0132d0138d3dd8$var$z.tuple(tupleItems);
                    // Apply minItems/maxItems constraints to tuples
                    if (typeof schema.minItems === "number") zodSchema = zodSchema.check($dd0132d0138d3dd8$var$z.minLength(schema.minItems));
                    if (typeof schema.maxItems === "number") zodSchema = zodSchema.check($dd0132d0138d3dd8$var$z.maxLength(schema.maxItems));
                } else if (Array.isArray(items)) {
                    // Tuple with items array (draft-7)
                    const tupleItems = items.map((item)=>$dd0132d0138d3dd8$var$convertSchema(item, ctx));
                    const rest = schema.additionalItems && typeof schema.additionalItems === "object" ? $dd0132d0138d3dd8$var$convertSchema(schema.additionalItems, ctx) : undefined; // additionalItems: false means no rest, handled by default tuple behavior
                    if (rest) zodSchema = $dd0132d0138d3dd8$var$z.tuple(tupleItems).rest(rest);
                    else zodSchema = $dd0132d0138d3dd8$var$z.tuple(tupleItems);
                    // Apply minItems/maxItems constraints to tuples
                    if (typeof schema.minItems === "number") zodSchema = zodSchema.check($dd0132d0138d3dd8$var$z.minLength(schema.minItems));
                    if (typeof schema.maxItems === "number") zodSchema = zodSchema.check($dd0132d0138d3dd8$var$z.maxLength(schema.maxItems));
                } else if (items !== undefined) {
                    // Regular array
                    const element = $dd0132d0138d3dd8$var$convertSchema(items, ctx);
                    let arraySchema = $dd0132d0138d3dd8$var$z.array(element);
                    // Apply constraints
                    if (typeof schema.minItems === "number") arraySchema = arraySchema.min(schema.minItems);
                    if (typeof schema.maxItems === "number") arraySchema = arraySchema.max(schema.maxItems);
                    zodSchema = arraySchema;
                } else // No items specified - array of any
                zodSchema = $dd0132d0138d3dd8$var$z.array($dd0132d0138d3dd8$var$z.any());
                break;
            }
        default:
            throw new Error(`Unsupported type: ${type}`);
    }
    // Apply metadata
    if (schema.description) zodSchema = zodSchema.describe(schema.description);
    if (schema.default !== undefined) zodSchema = zodSchema.default(schema.default);
    return zodSchema;
}
function $dd0132d0138d3dd8$var$convertSchema(schema, ctx) {
    if (typeof schema === "boolean") return schema ? $dd0132d0138d3dd8$var$z.any() : $dd0132d0138d3dd8$var$z.never();
    // Convert base schema first (ignoring composition keywords)
    let baseSchema = $dd0132d0138d3dd8$var$convertBaseSchema(schema, ctx);
    const hasExplicitType = schema.type || schema.enum !== undefined || schema.const !== undefined;
    // Process composition keywords LAST (they can appear together)
    // Handle anyOf - wrap base schema with union
    if (schema.anyOf && Array.isArray(schema.anyOf)) {
        const options = schema.anyOf.map((s)=>$dd0132d0138d3dd8$var$convertSchema(s, ctx));
        const anyOfUnion = $dd0132d0138d3dd8$var$z.union(options);
        baseSchema = hasExplicitType ? $dd0132d0138d3dd8$var$z.intersection(baseSchema, anyOfUnion) : anyOfUnion;
    }
    // Handle oneOf - exclusive union (exactly one must match)
    if (schema.oneOf && Array.isArray(schema.oneOf)) {
        const options = schema.oneOf.map((s)=>$dd0132d0138d3dd8$var$convertSchema(s, ctx));
        const oneOfUnion = $dd0132d0138d3dd8$var$z.xor(options);
        baseSchema = hasExplicitType ? $dd0132d0138d3dd8$var$z.intersection(baseSchema, oneOfUnion) : oneOfUnion;
    }
    // Handle allOf - wrap base schema with intersection
    if (schema.allOf && Array.isArray(schema.allOf)) {
        if (schema.allOf.length === 0) baseSchema = hasExplicitType ? baseSchema : $dd0132d0138d3dd8$var$z.any();
        else {
            let result = hasExplicitType ? baseSchema : $dd0132d0138d3dd8$var$convertSchema(schema.allOf[0], ctx);
            const startIdx = hasExplicitType ? 0 : 1;
            for(let i = startIdx; i < schema.allOf.length; i++)result = $dd0132d0138d3dd8$var$z.intersection(result, $dd0132d0138d3dd8$var$convertSchema(schema.allOf[i], ctx));
            baseSchema = result;
        }
    }
    // Handle nullable (OpenAPI 3.0)
    if (schema.nullable === true && ctx.version === "openapi-3.0") baseSchema = $dd0132d0138d3dd8$var$z.nullable(baseSchema);
    // Handle readOnly
    if (schema.readOnly === true) baseSchema = $dd0132d0138d3dd8$var$z.readonly(baseSchema);
    // Collect metadata: core schema keywords and unrecognized keys
    const extraMeta = {};
    // Core schema keywords that should be captured as metadata
    const coreMetadataKeys = [
        "$id",
        "id",
        "$comment",
        "$anchor",
        "$vocabulary",
        "$dynamicRef",
        "$dynamicAnchor"
    ];
    for (const key of coreMetadataKeys)if (key in schema) extraMeta[key] = schema[key];
    // Content keywords - store as metadata
    const contentMetadataKeys = [
        "contentEncoding",
        "contentMediaType",
        "contentSchema"
    ];
    for (const key of contentMetadataKeys)if (key in schema) extraMeta[key] = schema[key];
    // Unrecognized keys (custom metadata)
    for (const key of Object.keys(schema))if (!$dd0132d0138d3dd8$var$RECOGNIZED_KEYS.has(key)) extraMeta[key] = schema[key];
    if (Object.keys(extraMeta).length > 0) ctx.registry.add(baseSchema, extraMeta);
    return baseSchema;
}
function $dd0132d0138d3dd8$export$84d021ebf365dade(schema, params) {
    // Handle boolean schemas
    if (typeof schema === "boolean") return schema ? $dd0132d0138d3dd8$var$z.any() : $dd0132d0138d3dd8$var$z.never();
    const version = $dd0132d0138d3dd8$var$detectVersion(schema, params?.defaultTarget);
    const defs = schema.$defs || schema.definitions || {};
    const ctx = {
        version: version,
        defs: defs,
        refs: new Map(),
        processing: new Set(),
        rootSchema: schema,
        registry: params?.registry ?? (0, $450977dbcfd5dec3$export$bc58ce2776ecdb6f)
    };
    return $dd0132d0138d3dd8$var$convertSchema(schema, ctx);
}




var $42c0b73bfe598b38$exports = {};

$parcel$export($42c0b73bfe598b38$exports, "string", () => $42c0b73bfe598b38$export$22b082955e083ec3);
$parcel$export($42c0b73bfe598b38$exports, "number", () => $42c0b73bfe598b38$export$98e628dec113755e);
$parcel$export($42c0b73bfe598b38$exports, "boolean", () => $42c0b73bfe598b38$export$4a21f16c33752377);
$parcel$export($42c0b73bfe598b38$exports, "bigint", () => $42c0b73bfe598b38$export$a0f65b52274bcc00);
$parcel$export($42c0b73bfe598b38$exports, "date", () => $42c0b73bfe598b38$export$324d90190a8b822a);


function $42c0b73bfe598b38$export$22b082955e083ec3(params) {
    return $57904f98be373a74$export$614049477c642ce0($09193e81812ba154$export$1230eb29b8d3b502, params);
}
function $42c0b73bfe598b38$export$98e628dec113755e(params) {
    return $57904f98be373a74$export$272511620e4661dd($09193e81812ba154$export$5b070a55c0c43e09, params);
}
function $42c0b73bfe598b38$export$4a21f16c33752377(params) {
    return $57904f98be373a74$export$c3eb0e1c7c887e5c($09193e81812ba154$export$723d146f80596191, params);
}
function $42c0b73bfe598b38$export$a0f65b52274bcc00(params) {
    return $57904f98be373a74$export$8ff745acc355d077($09193e81812ba154$export$67d741fd70ff98f4, params);
}
function $42c0b73bfe598b38$export$324d90190a8b822a(params) {
    return $57904f98be373a74$export$2efeac445ea43f33($09193e81812ba154$export$e974be33bdc55521, params);
}


(0, $4488038d123e8fa5$export$e506a1d27d1eaa20)((0, $f94f9f481fcdc5e7$export$2e2bcd8739ae039)());



function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;


function $24192cf7d8ba7168$export$ed9ea036f41d9d59({ availability: availability }) {
    if (availability) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-row flex-nowrap space-x-0.5",
        children: availability.map((status, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24192cf7d8ba7168$var$AvailabilityDot, {
                status: status
            }, index))
    });
    else return null;
}
function $24192cf7d8ba7168$var$AvailabilityDot({ status: status }) {
    let style = 'bg-gray-300';
    switch(status){
        case 'green':
            style = 'bg-green-400';
            break;
        case 'orange':
            style = 'bg-orange-400';
            break;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('rounded-full size-1.25', style)
    });
}






var $acw62 = parcelRequire("acw62");

(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($a05dabb57d62d821$exports))));
function $aade598d94459724$export$82f9ebd9adeba146({ t: t, format: format = 'dddd, MMM D', className: className = 'whitespace-nowrap', timezone: timezone = (0, $2bd9d04ce55ef2a0$export$6f5c75afcb5ad5cc) }) {
    const text = (0, $acw62.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(t).tz(timezone).format(format), [
        format,
        t,
        timezone
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("time", {
        className: className,
        children: text
    });
}




var $acw62 = parcelRequire("acw62");


var $beebfe2969c5cd79$exports = {};
!function(t, i) {
    $beebfe2969c5cd79$exports = i();
}($beebfe2969c5cd79$exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var o = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), o.call(this, t);
        };
        var r = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else r.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s, o = this;
            if (f) return o.$offset = u, o.$u = 0 === s, o;
            if (0 !== s) {
                var r = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                (o = this.local().add(u + r, t)).$offset = u, o.$x.$localOffset = r;
            } else o = this.utc();
            return o;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});



var $acw62 = parcelRequire("acw62");
function $7b6704a6d7dd640a$export$f4b266cd2aae9cb1(func, interval) {
    const [value, setValue] = (0, $acw62.useState)(func);
    const funcRef = (0, $acw62.useRef)();
    funcRef.current = func;
    (0, $acw62.useEffect)(()=>{
        const timer = setInterval(()=>{
            setValue((current)=>funcRef.current(current));
        }, interval);
        return ()=>clearInterval(timer);
    }, [
        interval
    ]);
    return value;
}


(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($beebfe2969c5cd79$exports))));
function $ada6a062d2ca6395$export$3a404aece3dff2fa({ offset: offset = 0, delay: delay = 60000 } = {}) {
    return (0, $7b6704a6d7dd640a$export$f4b266cd2aae9cb1)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).utc().add(offset, 'ms'), delay);
}


function $a0555542f484e05c$export$6d84255ad587f3b5(timezone = (0, $2bd9d04ce55ef2a0$export$6f5c75afcb5ad5cc)) {
    const now = (0, $ada6a062d2ca6395$export$3a404aece3dff2fa)();
    const today = now.tz(timezone).startOf('day');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $acw62.useMemo)(()=>today, [
        today.toISOString()
    ]);
}



var $acw62 = parcelRequire("acw62");
function $36464e4be8053fb8$var$_extends() {
    $36464e4be8053fb8$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $36464e4be8053fb8$var$_extends.apply(this, arguments);
}
// A type of promise-like that resolves synchronously and supports only one observer
const $36464e4be8053fb8$var$_iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";
const $36464e4be8053fb8$var$_asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")) : "@@asyncIterator";
// Asynchronously await a promise and pass the result to a finally continuation
function $36464e4be8053fb8$var$_finallyRethrows(body, finalizer) {
    try {
        var result = body();
    } catch (e) {
        return finalizer(true, e);
    }
    if (result && result.then) return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
    return finalizer(false, value);
}
var $36464e4be8053fb8$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect); // Assign current value to a ref and returns a stable getter to get the latest value.
// This way we are sure to always get latest value provided to hook and
// avoid weird issues due to closures capturing stale values...
// See https://github.com/facebook/react/issues/16956
// See https://overreacted.io/making-setinterval-declarative-with-react-hooks/
var $36464e4be8053fb8$var$useGetter = function useGetter(t) {
    var ref = (0, $acw62.useRef)(t);
    $36464e4be8053fb8$var$useIsomorphicLayoutEffect(function() {
        ref.current = t;
    });
    return (0, $acw62.useCallback)(function() {
        return ref.current;
    }, [
        ref
    ]);
};
var $36464e4be8053fb8$var$InitialAsyncState = {
    status: 'not-requested',
    loading: false,
    result: undefined,
    error: undefined
};
var $36464e4be8053fb8$var$InitialAsyncLoadingState = {
    status: 'loading',
    loading: true,
    result: undefined,
    error: undefined
};
var $36464e4be8053fb8$var$defaultSetLoading = function defaultSetLoading(_asyncState) {
    return $36464e4be8053fb8$var$InitialAsyncLoadingState;
};
var $36464e4be8053fb8$var$defaultSetResult = function defaultSetResult(result, _asyncState) {
    return {
        status: 'success',
        loading: false,
        result: result,
        error: undefined
    };
};
var $36464e4be8053fb8$var$defaultSetError = function defaultSetError(error, _asyncState) {
    return {
        status: 'error',
        loading: false,
        result: undefined,
        error: error
    };
};
var $36464e4be8053fb8$var$noop = function noop() {};
var $36464e4be8053fb8$var$DefaultOptions = {
    initialState: function initialState(options) {
        return options && options.executeOnMount ? $36464e4be8053fb8$var$InitialAsyncLoadingState : $36464e4be8053fb8$var$InitialAsyncState;
    },
    executeOnMount: true,
    executeOnUpdate: true,
    setLoading: $36464e4be8053fb8$var$defaultSetLoading,
    setResult: $36464e4be8053fb8$var$defaultSetResult,
    setError: $36464e4be8053fb8$var$defaultSetError,
    onSuccess: $36464e4be8053fb8$var$noop,
    onError: $36464e4be8053fb8$var$noop
};
var $36464e4be8053fb8$var$normalizeOptions = function normalizeOptions(options) {
    return $36464e4be8053fb8$var$_extends({}, $36464e4be8053fb8$var$DefaultOptions, {}, options);
};
var $36464e4be8053fb8$var$useAsyncState = function useAsyncState(options) {
    var _useState = (0, $acw62.useState)(function() {
        return options.initialState(options);
    }), value1 = _useState[0], setValue = _useState[1];
    var reset = (0, $acw62.useCallback)(function() {
        return setValue(options.initialState(options));
    }, [
        setValue,
        options
    ]);
    var setLoading = (0, $acw62.useCallback)(function() {
        return setValue(options.setLoading(value1));
    }, [
        value1,
        setValue
    ]);
    var setResult = (0, $acw62.useCallback)(function(result) {
        return setValue(options.setResult(result, value1));
    }, [
        value1,
        setValue
    ]);
    var setError = (0, $acw62.useCallback)(function(error) {
        return setValue(options.setError(error, value1));
    }, [
        value1,
        setValue
    ]);
    var merge = (0, $acw62.useCallback)(function(state) {
        return setValue($36464e4be8053fb8$var$_extends({}, value1, {}, state));
    }, [
        value1,
        setValue
    ]);
    return {
        value: value1,
        set: setValue,
        merge: merge,
        reset: reset,
        setLoading: setLoading,
        setResult: setResult,
        setError: setError
    };
};
var $36464e4be8053fb8$var$useIsMounted = function useIsMounted() {
    var ref = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(function() {
        ref.current = true;
        return function() {
            ref.current = false;
        };
    }, []);
    return function() {
        return ref.current;
    };
};
var $36464e4be8053fb8$var$useCurrentPromise = function useCurrentPromise() {
    var ref = (0, $acw62.useRef)(null);
    return {
        set: function set(promise) {
            return ref.current = promise;
        },
        get: function get() {
            return ref.current;
        },
        is: function is(promise) {
            return ref.current === promise;
        }
    };
}; // Relaxed interface which accept both async and sync functions
// Accepting sync function is convenient for useAsyncCallback
var $36464e4be8053fb8$var$useAsyncInternal = function useAsyncInternal(asyncFunction, params, options) {
    // Fallback missing params, only for JS users forgetting the deps array, to prevent infinite loops
    // https://github.com/slorber/react-async-hook/issues/27
    // @ts-ignore
    !params && (params = []);
    var normalizedOptions = $36464e4be8053fb8$var$normalizeOptions(options);
    var _useState2 = (0, $acw62.useState)(null), currentParams = _useState2[0], setCurrentParams = _useState2[1];
    var AsyncState = $36464e4be8053fb8$var$useAsyncState(normalizedOptions);
    var isMounted = $36464e4be8053fb8$var$useIsMounted();
    var CurrentPromise = $36464e4be8053fb8$var$useCurrentPromise(); // We only want to handle the promise result/error
    // if it is the last operation and the comp is still mounted
    var shouldHandlePromise = function shouldHandlePromise(p) {
        return isMounted() && CurrentPromise.is(p);
    };
    var executeAsyncOperation = function executeAsyncOperation() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // async ensures errors thrown synchronously are caught (ie, bug when formatting api payloads)
        // async ensures promise-like and synchronous functions are handled correctly too
        // see https://github.com/slorber/react-async-hook/issues/24
        var promise = function() {
            try {
                return Promise.resolve(asyncFunction.apply(void 0, args));
            } catch (e) {
                return Promise.reject(e);
            }
        }();
        setCurrentParams(args);
        CurrentPromise.set(promise);
        AsyncState.setLoading();
        promise.then(function(result) {
            if (shouldHandlePromise(promise)) AsyncState.setResult(result);
            normalizedOptions.onSuccess(result, {
                isCurrent: function isCurrent() {
                    return CurrentPromise.is(promise);
                }
            });
        }, function(error) {
            if (shouldHandlePromise(promise)) AsyncState.setError(error);
            normalizedOptions.onError(error, {
                isCurrent: function isCurrent() {
                    return CurrentPromise.is(promise);
                }
            });
        });
        return promise;
    };
    var getLatestExecuteAsyncOperation = $36464e4be8053fb8$var$useGetter(executeAsyncOperation);
    var executeAsyncOperationMemo = (0, $acw62.useCallback)(function() {
        return getLatestExecuteAsyncOperation().apply(void 0, arguments);
    }, [
        getLatestExecuteAsyncOperation
    ]); // Keep this outside useEffect, because inside isMounted()
    // will be true as the component is already mounted when it's run
    var isMounting = !isMounted();
    (0, $acw62.useEffect)(function() {
        var execute = function execute() {
            return getLatestExecuteAsyncOperation().apply(void 0, params);
        };
        isMounting && normalizedOptions.executeOnMount && execute();
        !isMounting && normalizedOptions.executeOnUpdate && execute();
    }, params);
    return $36464e4be8053fb8$var$_extends({}, AsyncState.value, {
        set: AsyncState.set,
        merge: AsyncState.merge,
        reset: AsyncState.reset,
        execute: executeAsyncOperationMemo,
        currentPromise: CurrentPromise.get(),
        currentParams: currentParams
    });
};
function $36464e4be8053fb8$export$cdf1dc76b55502e3(asyncFunction, params, options) {
    return $36464e4be8053fb8$var$useAsyncInternal(asyncFunction, params, options);
}
var $36464e4be8053fb8$export$a4c3459d1b3dd407 = function useAsyncAbortable(asyncFunction, params, options) {
    var abortControllerRef = (0, $acw62.useRef)(); // Wrap the original async function and enhance it with abortion login
    var asyncFunctionWrapper = function asyncFunctionWrapper() {
        for(var _len2 = arguments.length, p = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)p[_key2] = arguments[_key2];
        try {
            // Cancel previous async call
            if (abortControllerRef.current) abortControllerRef.current.abort();
             // Create/store new abort controller for next async call
            var abortController = new AbortController();
            abortControllerRef.current = abortController;
            return Promise.resolve($36464e4be8053fb8$var$_finallyRethrows(function() {
                // @ts-ignore // TODO how to type this?
                return Promise.resolve(asyncFunction.apply(void 0, [
                    abortController.signal
                ].concat(p)));
            }, function(_wasThrown, _result) {
                // Unset abortController ref if response is already there,
                // as it's not needed anymore to try to abort it (would it be no-op?)
                if (abortControllerRef.current === abortController) abortControllerRef.current = undefined;
                if (_wasThrown) throw _result;
                return _result;
            }));
        } catch (e) {
            return Promise.reject(e);
        }
    };
    return $36464e4be8053fb8$export$cdf1dc76b55502e3(asyncFunctionWrapper, params, options);
};
var $36464e4be8053fb8$export$fbeb804c371ac8d = function useAsyncCallback(asyncFunction, options) {
    return $36464e4be8053fb8$var$useAsyncInternal(asyncFunction, // because async function is only executed manually
    [], $36464e4be8053fb8$var$_extends({}, options, {
        executeOnMount: false,
        executeOnUpdate: false
    }));
};



var $acw62 = parcelRequire("acw62");
const $ba760e6e9b761400$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $ba760e6e9b761400$export$f51a9068ac82ea43 = (createState)=>createState ? $ba760e6e9b761400$var$createStoreImpl(createState) : $ba760e6e9b761400$var$createStoreImpl;


const $bd07366b96e7d92e$var$identity = (arg)=>arg;
function $bd07366b96e7d92e$export$6ccbb43953eebf8(api, selector = $bd07366b96e7d92e$var$identity) {
    const slice = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useSyncExternalStore(api.subscribe, ()=>selector(api.getState()), ()=>selector(api.getInitialState()));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useDebugValue(slice);
    return slice;
}
const $bd07366b96e7d92e$var$createImpl = (createState)=>{
    const api = (0, $ba760e6e9b761400$export$f51a9068ac82ea43)(createState);
    const useBoundStore = (selector)=>$bd07366b96e7d92e$export$6ccbb43953eebf8(api, selector);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $bd07366b96e7d92e$export$185802fd694ee1f5 = (createState)=>createState ? $bd07366b96e7d92e$var$createImpl(createState) : $bd07366b96e7d92e$var$createImpl;


var $758e72b974398848$exports = {};
"use strict";
Object.defineProperty($758e72b974398848$exports, Symbol.toStringTag, {
    value: "Module"
});
const $758e72b974398848$var$isIterable = (obj)=>Symbol.iterator in obj;
const $758e72b974398848$var$hasIterableEntries = (value)=>// HACK: avoid checking entries type
    "entries" in value;
const $758e72b974398848$var$compareEntries = (valueA, valueB)=>{
    const mapA = valueA instanceof Map ? valueA : new Map(valueA.entries());
    const mapB = valueB instanceof Map ? valueB : new Map(valueB.entries());
    if (mapA.size !== mapB.size) return false;
    for (const [key, value] of mapA){
        if (!Object.is(value, mapB.get(key))) return false;
    }
    return true;
};
const $758e72b974398848$var$compareIterables = (valueA, valueB)=>{
    const iteratorA = valueA[Symbol.iterator]();
    const iteratorB = valueB[Symbol.iterator]();
    let nextA = iteratorA.next();
    let nextB = iteratorB.next();
    while(!nextA.done && !nextB.done){
        if (!Object.is(nextA.value, nextB.value)) return false;
        nextA = iteratorA.next();
        nextB = iteratorB.next();
    }
    return !!nextA.done && !!nextB.done;
};
function $758e72b974398848$var$shallow(valueA, valueB) {
    if (Object.is(valueA, valueB)) return true;
    if (typeof valueA !== "object" || valueA === null || typeof valueB !== "object" || valueB === null) return false;
    if (!$758e72b974398848$var$isIterable(valueA) || !$758e72b974398848$var$isIterable(valueB)) return $758e72b974398848$var$compareEntries({
        entries: ()=>Object.entries(valueA)
    }, {
        entries: ()=>Object.entries(valueB)
    });
    if ($758e72b974398848$var$hasIterableEntries(valueA) && $758e72b974398848$var$hasIterableEntries(valueB)) return $758e72b974398848$var$compareEntries(valueA, valueB);
    return $758e72b974398848$var$compareIterables(valueA, valueB);
}
const $758e72b974398848$var$computedImpl = (compute, opts)=>(f)=>{
        const optsKeys = !opts || !("keys" in opts) || opts.keys == null ? void 0 : opts.keys;
        const keysSet = optsKeys ? new Set(optsKeys) : void 0;
        function defaultShouldRecomputeFn(_, nextState) {
            if (!keysSet || nextState == null) return true;
            return Object.keys(nextState).some((k)=>keysSet.has(k));
        }
        const shouldRecomputeFn = opts && "shouldRecompute" in opts ? opts.shouldRecompute ?? defaultShouldRecomputeFn : defaultShouldRecomputeFn;
        return (set, get, api)=>{
            const equalityFn = (opts == null ? void 0 : opts.equalityFn) ?? $758e72b974398848$var$shallow;
            const computeAndMerge = (state)=>{
                const computedState = compute({
                    ...state
                });
                for (const k of Object.keys(computedState))if (equalityFn(computedState[k], state[k])) delete computedState[k];
                return {
                    ...state,
                    ...computedState
                };
            };
            const setWithComputed = (update, replace, ...args)=>{
                set((state)=>{
                    const updated = typeof update === "object" ? update : update(state);
                    if (!(shouldRecomputeFn == null ? void 0 : shouldRecomputeFn(state, updated))) return {
                        ...state,
                        ...updated
                    };
                    return computeAndMerge({
                        ...state,
                        ...updated
                    });
                }, replace, ...args);
            };
            const _api = api;
            _api.setState = setWithComputed;
            const st = f(setWithComputed, get, _api);
            return Object.assign({}, st, compute(st));
        };
    };
const $758e72b974398848$var$createComputed = $758e72b974398848$var$computedImpl;
$758e72b974398848$exports.createComputed = $758e72b974398848$var$createComputed;


var $db1029f36b931e86$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $db1029f36b931e86$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...args)=>api.dispatch(...args),
            ...initial
        };
    };
const $db1029f36b931e86$export$4feba8a1bc8e9afd = $db1029f36b931e86$var$reduxImpl;
const $db1029f36b931e86$var$trackedConnections = /* @__PURE__ */ new Map();
const $db1029f36b931e86$var$getTrackedConnectionState = (name)=>{
    const api = $db1029f36b931e86$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $db1029f36b931e86$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $db1029f36b931e86$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $db1029f36b931e86$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $db1029f36b931e86$var$removeStoreFromTrackedConnections = (name, store)=>{
    if (store === void 0) return;
    const connectionInfo = $db1029f36b931e86$var$trackedConnections.get(name);
    if (!connectionInfo) return;
    delete connectionInfo.stores[store];
    if (Object.keys(connectionInfo.stores).length === 0) $db1029f36b931e86$var$trackedConnections.delete(name);
};
const $db1029f36b931e86$var$findCallerName = (stack)=>{
    var _a, _b;
    if (!stack) return void 0;
    const traceLines = stack.split("\n");
    const apiSetStateLineIndex = traceLines.findIndex((traceLine)=>traceLine.includes("api.setState"));
    if (apiSetStateLineIndex < 0) return void 0;
    const callerLine = ((_a = traceLines[apiSetStateLineIndex + 1]) == null ? void 0 : _a.trim()) || "";
    return (_b = /.+ (.+) .+/.exec(callerLine)) == null ? void 0 : _b[1];
};
const $db1029f36b931e86$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($db1029f36b931e86$import_meta.env ? $db1029f36b931e86$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) return fn(set, get, api);
        const { connection: connection, ...connectionInformation } = $db1029f36b931e86$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || $db1029f36b931e86$var$findCallerName(new Error().stack) || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$db1029f36b931e86$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        api.devtools = {
            cleanup: ()=>{
                if (connection && typeof connection.unsubscribe === "function") connection.unsubscribe();
                $db1029f36b931e86$var$removeStoreFromTrackedConnections(options.name, store);
            }
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...args)=>{
                if (($db1029f36b931e86$import_meta.env ? $db1029f36b931e86$import_meta.env.MODE : void 0) !== "production" && args[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...args);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $db1029f36b931e86$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format.
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($db1029f36b931e86$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($db1029f36b931e86$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $db1029f36b931e86$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($db1029f36b931e86$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $db1029f36b931e86$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $db1029f36b931e86$export$6922d3b3a607469e = $db1029f36b931e86$var$devtoolsImpl;
const $db1029f36b931e86$var$parseJsonThen = (stringified, fn)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) fn(parsed);
};
const $db1029f36b931e86$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $db1029f36b931e86$export$5c593627aef9f076 = $db1029f36b931e86$var$subscribeWithSelectorImpl;
function $db1029f36b931e86$export$1be1fc439b849fdf(initialState, create) {
    return (...args)=>Object.assign({}, initialState, create(...args));
}
function $db1029f36b931e86$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $db1029f36b931e86$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $db1029f36b931e86$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $db1029f36b931e86$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $db1029f36b931e86$var$persistImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $db1029f36b931e86$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $db1029f36b931e86$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) {
                            const migration = options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                            if (migration instanceof Promise) return migration.then((result)=>[
                                    true,
                                    result
                                ]);
                            return [
                                true,
                                migration
                            ];
                        }
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    void 0
                ];
            }).then((migrationResult)=>{
                var _a2;
                const [migrated, migratedState] = migrationResult;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $db1029f36b931e86$export$9a6132153fba2e0 = $db1029f36b931e86$var$persistImpl;



var $acw62 = parcelRequire("acw62");
const $6a1cc35f3c453de7$var$isIterable = (obj)=>Symbol.iterator in obj;
const $6a1cc35f3c453de7$var$hasIterableEntries = (value)=>// HACK: avoid checking entries type
    "entries" in value;
const $6a1cc35f3c453de7$var$compareEntries = (valueA, valueB)=>{
    const mapA = valueA instanceof Map ? valueA : new Map(valueA.entries());
    const mapB = valueB instanceof Map ? valueB : new Map(valueB.entries());
    if (mapA.size !== mapB.size) return false;
    for (const [key, value] of mapA){
        if (!Object.is(value, mapB.get(key))) return false;
    }
    return true;
};
const $6a1cc35f3c453de7$var$compareIterables = (valueA, valueB)=>{
    const iteratorA = valueA[Symbol.iterator]();
    const iteratorB = valueB[Symbol.iterator]();
    let nextA = iteratorA.next();
    let nextB = iteratorB.next();
    while(!nextA.done && !nextB.done){
        if (!Object.is(nextA.value, nextB.value)) return false;
        nextA = iteratorA.next();
        nextB = iteratorB.next();
    }
    return !!nextA.done && !!nextB.done;
};
function $6a1cc35f3c453de7$export$26c89aaec4eb1d2e(valueA, valueB) {
    if (Object.is(valueA, valueB)) return true;
    if (typeof valueA !== "object" || valueA === null || typeof valueB !== "object" || valueB === null) return false;
    if (Object.getPrototypeOf(valueA) !== Object.getPrototypeOf(valueB)) return false;
    if ($6a1cc35f3c453de7$var$isIterable(valueA) && $6a1cc35f3c453de7$var$isIterable(valueB)) {
        if ($6a1cc35f3c453de7$var$hasIterableEntries(valueA) && $6a1cc35f3c453de7$var$hasIterableEntries(valueB)) return $6a1cc35f3c453de7$var$compareEntries(valueA, valueB);
        return $6a1cc35f3c453de7$var$compareIterables(valueA, valueB);
    }
    return $6a1cc35f3c453de7$var$compareEntries({
        entries: ()=>Object.entries(valueA)
    }, {
        entries: ()=>Object.entries(valueB)
    });
}


function $66c46395b12fba47$export$180f5a427f17c0fe(selector) {
    const prev = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(void 0);
    return (state)=>{
        const next = selector(state);
        return (0, $6a1cc35f3c453de7$export$26c89aaec4eb1d2e)(prev.current, next) ? prev.current : prev.current = next;
    };
}



var $5Gn6I = parcelRequire("5Gn6I");
function $2cfbe4d1e444ba23$export$e4d1d359df9812d2(bool) {
    return bool === true ? 'yes' : bool === false ? 'no' : '';
}
const $2cfbe4d1e444ba23$var$replaceArrays = (objValue, srcValue)=>{
    if (Array.isArray(objValue) && Array.isArray(srcValue)) return srcValue;
};
function $2cfbe4d1e444ba23$export$6969335ea1e4e77c(base, patch) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, base, patch, $2cfbe4d1e444ba23$var$replaceArrays);
}


const $9dfc7fe3975de14a$export$8dffa4efb9fbc37b = Object.freeze({
    CREATED: 'created',
    STARTED: 'inprogress',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled',
    INVALID: 'invalid',
    EXPIRED: 'expired',
    LOCKED: 'locked'
});
const $9dfc7fe3975de14a$export$f24af7fbd92c164a = [
    $9dfc7fe3975de14a$export$8dffa4efb9fbc37b.COMPLETED,
    $9dfc7fe3975de14a$export$8dffa4efb9fbc37b.CANCELLED,
    $9dfc7fe3975de14a$export$8dffa4efb9fbc37b.LOCKED,
    $9dfc7fe3975de14a$export$8dffa4efb9fbc37b.EXPIRED,
    $9dfc7fe3975de14a$export$8dffa4efb9fbc37b.INVALID
];
function $9dfc7fe3975de14a$var$loadCookieInviteState() {
    try {
        const json = document.cookie.split('; ').find((row)=>row.startsWith('soopa-invite='))?.split('=')?.at(1) ?? 'e30=';
        const cookie = JSON.parse(atob(decodeURIComponent(json)));
        // TODO: remove backward compatibility when api id updated
        if (cookie.id) {
            cookie.reference = cookie.id;
            delete cookie.id;
        }
        return {
            cookie: cookie,
            api: null
        };
    } catch (error) {
        console.error('Invite cookie is not valid', error);
        return {
            cookie: {
                cookie: {
                    reference: '',
                    status: $9dfc7fe3975de14a$export$8dffa4efb9fbc37b.INVALID
                },
                api: null
            }
        };
    }
}
const $9dfc7fe3975de14a$var$computed = (0, $758e72b974398848$exports.createComputed)((state)=>{
    return {
        invite: state.api ? {
            ...state.cookie,
            ...state.api
        } : state.cookie,
        partial: !state.api
    };
});
const $9dfc7fe3975de14a$export$b7f2c41423608aeb = (0, $bd07366b96e7d92e$export$185802fd694ee1f5)((0, $db1029f36b931e86$export$6922d3b3a607469e)($9dfc7fe3975de14a$var$computed((0, $db1029f36b931e86$export$1be1fc439b849fdf)($9dfc7fe3975de14a$var$loadCookieInviteState(), (set, get)=>({
        setInvite: (api)=>set((state)=>({
                    ...state,
                    api: api
                }), true, 'INVITE/SET'),
        patchInvite: (payload)=>{
            set((state)=>({
                    ...state,
                    api: {
                        ...state.api,
                        onlineBookingData: (0, $2cfbe4d1e444ba23$export$6969335ea1e4e77c)(state.api?.onlineBookingData ?? {}, payload)
                    }
                }), true, 'INVITE/PATCH');
            return get().invite.onlineBookingData;
        },
        removeSlot: (slotId)=>set((state)=>{
                return {
                    ...state,
                    api: {
                        ...state.api,
                        practitioners: state.api.practitioners.map((practitioner)=>{
                            const shouldRemove = (slot)=>slot.slotId !== slotId;
                            const filteredSlots = practitioner.calendarSlots.filter(shouldRemove);
                            return filteredSlots.length === practitioner.calendarSlots.length ? practitioner : {
                                ...practitioner,
                                calendarSlots: filteredSlots
                            };
                        })
                    }
                };
            }, false, 'INVITE/REMOVE_SLOT'),
        addAttachment: (attachment)=>set((state)=>{
                return {
                    ...state,
                    api: {
                        ...state.api,
                        attachments: [
                            ...state.api.attachments,
                            attachment
                        ]
                    }
                };
            }, false, 'INVITE/ADD_ATTACHMENT'),
        removeAttachment: (attachmentId)=>set((state)=>{
                return {
                    ...state,
                    api: {
                        ...state.api,
                        attachments: state.api.attachments.filter((x)=>x.attachmentId !== attachmentId)
                    }
                };
            }, false, 'INVITE/REMOVE_ATTACHMENT')
    }))), {
    name: 'InviteStore'
}));
function $9dfc7fe3975de14a$export$9074eb99b058a8d5() {
    return $9dfc7fe3975de14a$export$b7f2c41423608aeb((0, $66c46395b12fba47$export$180f5a427f17c0fe)((state)=>{
        const { invite: { reference: reference, status: status }, partial: partial } = state;
        return {
            reference: reference,
            status: status,
            partial: partial
        };
    }));
}


/*! MIT License © Sindre Sorhus */ class $36b67ef8a3cfb321$export$aa9d629c530f62a7 extends Error {
    response;
    request;
    options;
    constructor(response, request, options){
        const code = response.status || response.status === 0 ? response.status : '';
        const title = response.statusText ?? '';
        const status = `${code} ${title}`.trim();
        const reason = status ? `status code ${status}` : 'an unknown error';
        super(`Request failed with ${reason}: ${request.method} ${request.url}`);
        this.name = 'HTTPError';
        this.response = response;
        this.request = request;
        this.options = options;
    }
}


/**
Wrapper for non-Error values that were thrown.

In JavaScript, any value can be thrown (not just Error instances). This class wraps such values to ensure consistent error handling.
*/ class $1438cfb207618e38$export$5bbe4213615fafb9 extends Error {
    name = 'NonError';
    value;
    constructor(value){
        let message = 'Non-error value was thrown';
        // Intentionally minimal as this error is just an edge-case.
        try {
            if (typeof value === 'string') message = value;
            else if (value && typeof value === 'object' && 'message' in value && typeof value.message === 'string') message = value.message;
        } catch  {
        // Use default message if accessing properties throws
        }
        super(message);
        this.value = value;
    }
}



class $73486797945dd84e$export$58136d16d4327abc extends Error {
    name = 'ForceRetryError';
    customDelay;
    code;
    customRequest;
    constructor(options){
        // Runtime protection: wrap non-Error causes in NonError
        // TypeScript type is Error for guidance, but JS users can pass anything
        const cause = options?.cause ? options.cause instanceof Error ? options.cause : new (0, $1438cfb207618e38$export$5bbe4213615fafb9)(options.cause) : undefined;
        super(options?.code ? `Forced retry: ${options.code}` : 'Forced retry', cause ? {
            cause: cause
        } : undefined);
        this.customDelay = options?.delay;
        this.code = options?.code;
        this.customRequest = options?.request;
    }
}


const $1ff2fea6a6c86f37$export$d8618555562b76b7 = (()=>{
    let duplexAccessed = false;
    let hasContentType = false;
    const supportsReadableStream = typeof globalThis.ReadableStream === 'function';
    const supportsRequest = typeof globalThis.Request === 'function';
    if (supportsReadableStream && supportsRequest) try {
        hasContentType = new globalThis.Request('https://empty.invalid', {
            body: new globalThis.ReadableStream(),
            method: 'POST',
            // @ts-expect-error - Types are outdated.
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
    } catch (error) {
        // QQBrowser on iOS throws "unsupported BodyInit type" error (see issue #581)
        if (error instanceof Error && error.message === 'unsupported BodyInit type') return false;
        throw error;
    }
    return duplexAccessed && !hasContentType;
})();
const $1ff2fea6a6c86f37$export$6c0aacaed85a4966 = typeof globalThis.AbortController === 'function';
const $1ff2fea6a6c86f37$export$f5861fb6f4de6531 = typeof globalThis.AbortSignal === 'function' && typeof globalThis.AbortSignal.any === 'function';
const $1ff2fea6a6c86f37$export$135162ac70ac2b21 = typeof globalThis.ReadableStream === 'function';
const $1ff2fea6a6c86f37$export$f1525fa7979d0aa9 = typeof globalThis.FormData === 'function';
const $1ff2fea6a6c86f37$export$fb003dbd6df95edb = [
    'get',
    'post',
    'put',
    'patch',
    'head',
    'delete'
];
const $1ff2fea6a6c86f37$var$validate = ()=>undefined;
$1ff2fea6a6c86f37$var$validate();
const $1ff2fea6a6c86f37$export$a6f212d4ee888d8c = {
    json: 'application/json',
    text: 'text/*',
    formData: 'multipart/form-data',
    arrayBuffer: '*/*',
    blob: '*/*',
    // Supported in modern Fetch implementations (for example, browsers and recent Node.js/undici).
    // We still feature-check at runtime before exposing the shortcut.
    bytes: '*/*'
};
const $1ff2fea6a6c86f37$export$9b60a72e3f70a1d2 = 2147483647;
const $1ff2fea6a6c86f37$export$23af28b03ba58178 = new TextEncoder().encode('------WebKitFormBoundaryaxpyiPgbbPti10Rw').length;
const $1ff2fea6a6c86f37$export$fa6813432f753b0d = Symbol('stop');
class $1ff2fea6a6c86f37$export$7a1448c150fd4a2a {
    options;
    constructor(options){
        this.options = options;
    }
}
const $1ff2fea6a6c86f37$export$9369b12211e1fce4 = (options)=>new $1ff2fea6a6c86f37$export$7a1448c150fd4a2a(options);
const $1ff2fea6a6c86f37$export$601fffa09f19102d = {
    json: true,
    parseJson: true,
    stringifyJson: true,
    searchParams: true,
    prefixUrl: true,
    retry: true,
    timeout: true,
    hooks: true,
    throwHttpErrors: true,
    onDownloadProgress: true,
    onUploadProgress: true,
    fetch: true,
    context: true
};
const $1ff2fea6a6c86f37$export$f6ff4da7aa12f3ef = {
    next: true
};
const $1ff2fea6a6c86f37$export$b2ec467665ae937d = {
    method: true,
    headers: true,
    body: true,
    mode: true,
    credentials: true,
    cache: true,
    redirect: true,
    referrer: true,
    referrerPolicy: true,
    integrity: true,
    keepalive: true,
    signal: true,
    window: true,
    duplex: true
};


const $eac7b30d3c5d45f3$export$cefbc488a81111a3 = (body)=>{
    if (!body) return 0;
    if (body instanceof FormData) {
        // This is an approximation, as FormData size calculation is not straightforward
        let size = 0;
        for (const [key, value] of body){
            size += (0, $1ff2fea6a6c86f37$export$23af28b03ba58178);
            size += new TextEncoder().encode(`Content-Disposition: form-data; name="${key}"`).length;
            size += typeof value === 'string' ? new TextEncoder().encode(value).length : value.size;
        }
        return size;
    }
    if (body instanceof Blob) return body.size;
    if (body instanceof ArrayBuffer) return body.byteLength;
    if (typeof body === 'string') return new TextEncoder().encode(body).length;
    if (body instanceof URLSearchParams) return new TextEncoder().encode(body.toString()).length;
    if ('byteLength' in body) return body.byteLength;
    if (typeof body === 'object' && body !== null) try {
        const jsonString = JSON.stringify(body);
        return new TextEncoder().encode(jsonString).length;
    } catch  {
        return 0;
    }
    return 0; // Default case, unable to determine size
};
const $eac7b30d3c5d45f3$var$withProgress = (stream, totalBytes, onProgress)=>{
    let previousChunk;
    let transferredBytes = 0;
    return stream.pipeThrough(new TransformStream({
        transform (currentChunk, controller) {
            controller.enqueue(currentChunk);
            if (previousChunk) {
                transferredBytes += previousChunk.byteLength;
                let percent = totalBytes === 0 ? 0 : transferredBytes / totalBytes;
                // Avoid reporting 100% progress before the stream is actually finished (in case totalBytes is inaccurate)
                if (percent >= 1) // Epsilon is used here to get as close as possible to 100% without reaching it.
                // If we were to use 0.99 here, percent could potentially go backwards.
                percent = 1 - Number.EPSILON;
                onProgress?.({
                    percent: percent,
                    totalBytes: Math.max(totalBytes, transferredBytes),
                    transferredBytes: transferredBytes
                }, previousChunk);
            }
            previousChunk = currentChunk;
        },
        flush () {
            if (previousChunk) {
                transferredBytes += previousChunk.byteLength;
                onProgress?.({
                    percent: 1,
                    totalBytes: Math.max(totalBytes, transferredBytes),
                    transferredBytes: transferredBytes
                }, previousChunk);
            }
        }
    }));
};
const $eac7b30d3c5d45f3$export$2e6c793c88b27395 = (response, onDownloadProgress)=>{
    if (!response.body) return response;
    if (response.status === 204) return new Response(null, {
        status: response.status,
        statusText: response.statusText,
        headers: response.headers
    });
    const totalBytes = Math.max(0, Number(response.headers.get('content-length')) || 0);
    return new Response($eac7b30d3c5d45f3$var$withProgress(response.body, totalBytes, onDownloadProgress), {
        status: response.status,
        statusText: response.statusText,
        headers: response.headers
    });
};
const $eac7b30d3c5d45f3$export$99096e10de875468 = (request, onUploadProgress, originalBody)=>{
    if (!request.body) return request;
    // Use original body for size calculation since request.body is already a stream
    const totalBytes = $eac7b30d3c5d45f3$export$cefbc488a81111a3(originalBody ?? request.body);
    return new Request(request, {
        // @ts-expect-error - Types are outdated.
        duplex: 'half',
        body: $eac7b30d3c5d45f3$var$withProgress(request.body, totalBytes, onUploadProgress)
    });
};



// eslint-disable-next-line @typescript-eslint/ban-types
const $8c078d120c1f3882$export$a6cdc56e425d0d0a = (value)=>value !== null && typeof value === 'object';


const $1354e4c7c55c83be$export$8886f5ba30bd5e0 = (...sources)=>{
    for (const source of sources){
        if ((!(0, $8c078d120c1f3882$export$a6cdc56e425d0d0a)(source) || Array.isArray(source)) && source !== undefined) throw new TypeError('The `options` argument must be an object');
    }
    return $1354e4c7c55c83be$export$6969335ea1e4e77c({}, ...sources);
};
const $1354e4c7c55c83be$export$eee1781d075786ae = (source1 = {}, source2 = {})=>{
    const result = new globalThis.Headers(source1);
    const isHeadersInstance = source2 instanceof globalThis.Headers;
    const source = new globalThis.Headers(source2);
    for (const [key, value] of source.entries())if (isHeadersInstance && value === 'undefined' || value === undefined) result.delete(key);
    else result.set(key, value);
    return result;
};
function $1354e4c7c55c83be$var$newHookValue(original, incoming, property) {
    return Object.hasOwn(incoming, property) && incoming[property] === undefined ? [] : $1354e4c7c55c83be$export$6969335ea1e4e77c(original[property] ?? [], incoming[property] ?? []);
}
const $1354e4c7c55c83be$export$3de1ffbf114b9f2d = (original = {}, incoming = {})=>({
        beforeRequest: $1354e4c7c55c83be$var$newHookValue(original, incoming, 'beforeRequest'),
        beforeRetry: $1354e4c7c55c83be$var$newHookValue(original, incoming, 'beforeRetry'),
        afterResponse: $1354e4c7c55c83be$var$newHookValue(original, incoming, 'afterResponse'),
        beforeError: $1354e4c7c55c83be$var$newHookValue(original, incoming, 'beforeError')
    });
const $1354e4c7c55c83be$var$appendSearchParameters = (target, source)=>{
    const result = new URLSearchParams();
    for (const input of [
        target,
        source
    ]){
        if (input === undefined) continue;
        if (input instanceof URLSearchParams) for (const [key, value] of input.entries())result.append(key, value);
        else if (Array.isArray(input)) for (const pair of input){
            if (!Array.isArray(pair) || pair.length !== 2) throw new TypeError('Array search parameters must be provided in [[key, value], ...] format');
            result.append(String(pair[0]), String(pair[1]));
        }
        else if ((0, $8c078d120c1f3882$export$a6cdc56e425d0d0a)(input)) {
            for (const [key, value] of Object.entries(input))if (value !== undefined) result.append(key, String(value));
        } else {
            // String
            const parameters = new URLSearchParams(input);
            for (const [key, value] of parameters.entries())result.append(key, value);
        }
    }
    return result;
};
const $1354e4c7c55c83be$export$6969335ea1e4e77c = (...sources)=>{
    let returnValue = {};
    let headers = {};
    let hooks = {};
    let searchParameters;
    const signals = [];
    for (const source of sources){
        if (Array.isArray(source)) {
            if (!Array.isArray(returnValue)) returnValue = [];
            returnValue = [
                ...returnValue,
                ...source
            ];
        } else if ((0, $8c078d120c1f3882$export$a6cdc56e425d0d0a)(source)) {
            for (let [key, value] of Object.entries(source)){
                // Special handling for AbortSignal instances
                if (key === 'signal' && value instanceof globalThis.AbortSignal) {
                    signals.push(value);
                    continue;
                }
                // Special handling for context - shallow merge only
                if (key === 'context') {
                    if (value !== undefined && value !== null && (!(0, $8c078d120c1f3882$export$a6cdc56e425d0d0a)(value) || Array.isArray(value))) throw new TypeError('The `context` option must be an object');
                    // Shallow merge: always create a new object to prevent mutation bugs
                    returnValue = {
                        ...returnValue,
                        context: value === undefined || value === null ? {} : {
                            ...returnValue.context,
                            ...value
                        }
                    };
                    continue;
                }
                // Special handling for searchParams
                if (key === 'searchParams') {
                    if (value === undefined || value === null) // Explicit undefined or null removes searchParams
                    searchParameters = undefined;
                    else // First source: keep as-is to preserve type (string/object/URLSearchParams)
                    // Subsequent sources: merge and convert to URLSearchParams
                    searchParameters = searchParameters === undefined ? value : $1354e4c7c55c83be$var$appendSearchParameters(searchParameters, value);
                    continue;
                }
                if ((0, $8c078d120c1f3882$export$a6cdc56e425d0d0a)(value) && key in returnValue) value = $1354e4c7c55c83be$export$6969335ea1e4e77c(returnValue[key], value);
                returnValue = {
                    ...returnValue,
                    [key]: value
                };
            }
            if ((0, $8c078d120c1f3882$export$a6cdc56e425d0d0a)(source.hooks)) {
                hooks = $1354e4c7c55c83be$export$3de1ffbf114b9f2d(hooks, source.hooks);
                returnValue.hooks = hooks;
            }
            if ((0, $8c078d120c1f3882$export$a6cdc56e425d0d0a)(source.headers)) {
                headers = $1354e4c7c55c83be$export$eee1781d075786ae(headers, source.headers);
                returnValue.headers = headers;
            }
        }
    }
    if (searchParameters !== undefined) returnValue.searchParams = searchParameters;
    if (signals.length > 0) {
        if (signals.length === 1) returnValue.signal = signals[0];
        else if (0, $1ff2fea6a6c86f37$export$f5861fb6f4de6531) returnValue.signal = AbortSignal.any(signals);
        else // When AbortSignal.any is not available, use the last signal
        // This maintains the previous behavior before signal merging was added
        // This can be remove when the `supportsAbortSignal` check is removed.`
        returnValue.signal = signals.at(-1);
    }
    if (returnValue.context === undefined) returnValue.context = {};
    return returnValue;
};



const $0f62514eee248549$export$d585027d4667ffce = (input)=>(0, $1ff2fea6a6c86f37$export$fb003dbd6df95edb).includes(input) ? input.toUpperCase() : input;
const $0f62514eee248549$var$retryMethods = [
    'get',
    'put',
    'head',
    'delete',
    'options',
    'trace'
];
const $0f62514eee248549$var$retryStatusCodes = [
    408,
    413,
    429,
    500,
    502,
    503,
    504
];
const $0f62514eee248549$var$retryAfterStatusCodes = [
    413,
    429,
    503
];
const $0f62514eee248549$var$defaultRetryOptions = {
    limit: 2,
    methods: $0f62514eee248549$var$retryMethods,
    statusCodes: $0f62514eee248549$var$retryStatusCodes,
    afterStatusCodes: $0f62514eee248549$var$retryAfterStatusCodes,
    maxRetryAfter: Number.POSITIVE_INFINITY,
    backoffLimit: Number.POSITIVE_INFINITY,
    delay: (attemptCount)=>0.3 * 2 ** (attemptCount - 1) * 1000,
    jitter: undefined,
    retryOnTimeout: false
};
const $0f62514eee248549$export$3e5471bb9440c9c1 = (retry = {})=>{
    if (typeof retry === 'number') return {
        ...$0f62514eee248549$var$defaultRetryOptions,
        limit: retry
    };
    if (retry.methods && !Array.isArray(retry.methods)) throw new Error('retry.methods must be an array');
    if (retry.statusCodes && !Array.isArray(retry.statusCodes)) throw new Error('retry.statusCodes must be an array');
    return {
        ...$0f62514eee248549$var$defaultRetryOptions,
        ...retry
    };
};


class $b23217586c9b8e5d$export$66d311bf29d5c89c extends Error {
    request;
    constructor(request){
        super(`Request timed out: ${request.method} ${request.url}`);
        this.name = 'TimeoutError';
        this.request = request;
    }
}


async function $f071b3ea9e26abc5$export$2e2bcd8739ae039(request, init, abortController, options) {
    return new Promise((resolve, reject)=>{
        const timeoutId = setTimeout(()=>{
            if (abortController) abortController.abort();
            reject(new (0, $b23217586c9b8e5d$export$66d311bf29d5c89c)(request));
        }, options.timeout);
        options.fetch(request, init).then(resolve).catch(reject).then(()=>{
            clearTimeout(timeoutId);
        });
    });
}


// https://github.com/sindresorhus/delay/tree/ab98ae8dfcb38e1593286c94d934e70d14a4e111
async function $089f0b9783120894$export$2e2bcd8739ae039(ms, { signal: signal }) {
    return new Promise((resolve, reject)=>{
        if (signal) {
            signal.throwIfAborted();
            signal.addEventListener('abort', abortHandler, {
                once: true
            });
        }
        function abortHandler() {
            clearTimeout(timeoutId);
            reject(signal.reason);
        }
        const timeoutId = setTimeout(()=>{
            signal?.removeEventListener('abort', abortHandler);
            resolve();
        }, ms);
    });
}



const $9336c4545dcaac68$export$95d8775889ec941f = (request, options)=>{
    const unknownOptions = {};
    for(const key in options){
        // Skip inherited properties
        if (!Object.hasOwn(options, key)) continue;
        // An option is passed to fetch() if:
        // 1. It's not a standard RequestInit option (not in requestOptionsRegistry)
        // 2. It's not a ky-specific option (not in kyOptionKeys)
        // 3. Either:
        //    a. It's not on the Request object, OR
        //    b. It's a vendor-specific option that should always be passed (in vendorSpecificOptions)
        if (!(key in (0, $1ff2fea6a6c86f37$export$b2ec467665ae937d)) && !(key in (0, $1ff2fea6a6c86f37$export$601fffa09f19102d)) && (!(key in request) || key in (0, $1ff2fea6a6c86f37$export$f6ff4da7aa12f3ef))) unknownOptions[key] = options[key];
    }
    return unknownOptions;
};
const $9336c4545dcaac68$export$38f5a1f81179632e = (search)=>{
    if (search === undefined) return false;
    // The `typeof array` still gives "object", so we need different checking for array.
    if (Array.isArray(search)) return search.length > 0;
    if (search instanceof URLSearchParams) return search.size > 0;
    // Record
    if (typeof search === 'object') return Object.keys(search).length > 0;
    if (typeof search === 'string') return search.trim().length > 0;
    return Boolean(search);
};





function $e51e516e1817b0ab$export$190bbe5cae387f63(error) {
    return $e51e516e1817b0ab$export$6b7a49ce9c98a2f(error) || $e51e516e1817b0ab$export$f47339bf28a93789(error);
}
function $e51e516e1817b0ab$export$6b7a49ce9c98a2f(error) {
    return error instanceof (0, $36b67ef8a3cfb321$export$aa9d629c530f62a7) || error?.name === (0, $36b67ef8a3cfb321$export$aa9d629c530f62a7).name;
}
function $e51e516e1817b0ab$export$f47339bf28a93789(error) {
    return error instanceof (0, $b23217586c9b8e5d$export$66d311bf29d5c89c) || error?.name === (0, $b23217586c9b8e5d$export$66d311bf29d5c89c).name;
}
function $e51e516e1817b0ab$export$d767c37d6a807ed0(error) {
    return error instanceof (0, $73486797945dd84e$export$58136d16d4327abc) || error?.name === (0, $73486797945dd84e$export$58136d16d4327abc).name;
}



class $423bd113d368b878$export$c482d6f00e170af3 {
    static create(input, options) {
        const ky = new $423bd113d368b878$export$c482d6f00e170af3(input, options);
        const function_ = async ()=>{
            if (typeof ky.#options.timeout === 'number' && ky.#options.timeout > (0, $1ff2fea6a6c86f37$export$9b60a72e3f70a1d2)) throw new RangeError(`The \`timeout\` option cannot be greater than ${(0, $1ff2fea6a6c86f37$export$9b60a72e3f70a1d2)}`);
            // Delay the fetch so that body method shortcuts can set the Accept header
            await Promise.resolve();
            // Before using ky.request, _fetch clones it and saves the clone for future retries to use.
            // If retry is not needed, close the cloned request's ReadableStream for memory safety.
            let response = await ky.#fetch();
            for (const hook of ky.#options.hooks.afterResponse){
                // Clone the response before passing to hook so we can cancel it if needed
                const clonedResponse = ky.#decorateResponse(response.clone());
                // eslint-disable-next-line no-await-in-loop
                const modifiedResponse = await hook(ky.request, ky.#getNormalizedOptions(), clonedResponse, {
                    retryCount: ky.#retryCount
                });
                if (modifiedResponse instanceof globalThis.Response) response = modifiedResponse;
                if (modifiedResponse instanceof (0, $1ff2fea6a6c86f37$export$7a1448c150fd4a2a)) {
                    // Cancel both the cloned response passed to the hook and the current response
                    // to prevent resource leaks (especially important in Deno/Bun)
                    // eslint-disable-next-line no-await-in-loop
                    await Promise.all([
                        clonedResponse.body?.cancel(),
                        response.body?.cancel()
                    ]);
                    throw new (0, $73486797945dd84e$export$58136d16d4327abc)(modifiedResponse.options);
                }
            }
            ky.#decorateResponse(response);
            if (!response.ok && (typeof ky.#options.throwHttpErrors === 'function' ? ky.#options.throwHttpErrors(response.status) : ky.#options.throwHttpErrors)) {
                let error = new (0, $36b67ef8a3cfb321$export$aa9d629c530f62a7)(response, ky.request, ky.#getNormalizedOptions());
                for (const hook of ky.#options.hooks.beforeError)// eslint-disable-next-line no-await-in-loop
                error = await hook(error, {
                    retryCount: ky.#retryCount
                });
                throw error;
            }
            // If `onDownloadProgress` is passed, it uses the stream API internally
            if (ky.#options.onDownloadProgress) {
                if (typeof ky.#options.onDownloadProgress !== 'function') throw new TypeError('The `onDownloadProgress` option must be a function');
                if (!(0, $1ff2fea6a6c86f37$export$135162ac70ac2b21)) throw new Error('Streams are not supported in your environment. `ReadableStream` is missing.');
                return (0, $eac7b30d3c5d45f3$export$2e6c793c88b27395)(response.clone(), ky.#options.onDownloadProgress);
            }
            return response;
        };
        // Always wrap in #retry to catch forced retries from afterResponse hooks
        // Method retriability is checked in #calculateRetryDelay for non-forced retries
        const result = ky.#retry(function_).finally(async ()=>{
            const originalRequest = ky.#originalRequest;
            const cleanupPromises = [];
            if (originalRequest && !originalRequest.bodyUsed) cleanupPromises.push(originalRequest.body?.cancel());
            if (!ky.request.bodyUsed) cleanupPromises.push(ky.request.body?.cancel());
            await Promise.all(cleanupPromises);
        });
        for (const [type, mimeType] of Object.entries((0, $1ff2fea6a6c86f37$export$a6f212d4ee888d8c))){
            // Only expose `.bytes()` when the environment implements it.
            if (type === 'bytes' && typeof globalThis.Response?.prototype?.bytes !== 'function') continue;
            result[type] = async ()=>{
                // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                ky.request.headers.set('accept', ky.request.headers.get('accept') || mimeType);
                const response = await result;
                if (type === 'json') {
                    if (response.status === 204) return '';
                    const text = await response.text();
                    if (text === '') return '';
                    if (options.parseJson) return options.parseJson(text);
                    return JSON.parse(text);
                }
                return response[type]();
            };
        }
        return result;
    }
    // eslint-disable-next-line unicorn/prevent-abbreviations
    static #normalizeSearchParams(searchParams) {
        // Filter out undefined values from plain objects
        if (searchParams && typeof searchParams === 'object' && !Array.isArray(searchParams) && !(searchParams instanceof URLSearchParams)) return Object.fromEntries(Object.entries(searchParams).filter(([, value])=>value !== undefined));
        return searchParams;
    }
    request;
    #abortController;
    #retryCount = 0;
    // eslint-disable-next-line @typescript-eslint/prefer-readonly -- False positive: #input is reassigned on line 202
    #input;
    #options;
    #originalRequest;
    #userProvidedAbortSignal;
    #cachedNormalizedOptions;
    // eslint-disable-next-line complexity
    constructor(input, options = {}){
        this.#input = input;
        this.#options = {
            ...options,
            headers: (0, $1354e4c7c55c83be$export$eee1781d075786ae)(this.#input.headers, options.headers),
            hooks: (0, $1354e4c7c55c83be$export$3de1ffbf114b9f2d)({
                beforeRequest: [],
                beforeRetry: [],
                beforeError: [],
                afterResponse: []
            }, options.hooks),
            method: (0, $0f62514eee248549$export$d585027d4667ffce)(options.method ?? this.#input.method ?? 'GET'),
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            prefixUrl: String(options.prefixUrl || ''),
            retry: (0, $0f62514eee248549$export$3e5471bb9440c9c1)(options.retry),
            throwHttpErrors: options.throwHttpErrors ?? true,
            timeout: options.timeout ?? 10000,
            fetch: options.fetch ?? globalThis.fetch.bind(globalThis),
            context: options.context ?? {}
        };
        if (typeof this.#input !== 'string' && !(this.#input instanceof URL || this.#input instanceof globalThis.Request)) throw new TypeError('`input` must be a string, URL, or Request');
        if (this.#options.prefixUrl && typeof this.#input === 'string') {
            if (this.#input.startsWith('/')) throw new Error('`input` must not begin with a slash when using `prefixUrl`');
            if (!this.#options.prefixUrl.endsWith('/')) this.#options.prefixUrl += '/';
            this.#input = this.#options.prefixUrl + this.#input;
        }
        if ((0, $1ff2fea6a6c86f37$export$6c0aacaed85a4966) && (0, $1ff2fea6a6c86f37$export$f5861fb6f4de6531)) {
            this.#userProvidedAbortSignal = this.#options.signal ?? this.#input.signal;
            this.#abortController = new globalThis.AbortController();
            this.#options.signal = this.#userProvidedAbortSignal ? AbortSignal.any([
                this.#userProvidedAbortSignal,
                this.#abortController.signal
            ]) : this.#abortController.signal;
        }
        if (0, $1ff2fea6a6c86f37$export$d8618555562b76b7) // @ts-expect-error - Types are outdated.
        this.#options.duplex = 'half';
        if (this.#options.json !== undefined) {
            this.#options.body = this.#options.stringifyJson?.(this.#options.json) ?? JSON.stringify(this.#options.json);
            this.#options.headers.set('content-type', this.#options.headers.get('content-type') ?? 'application/json');
        }
        // To provide correct form boundary, Content-Type header should be deleted when creating Request from another Request with FormData/URLSearchParams body
        // Only delete if user didn't explicitly provide a custom content-type
        const userProvidedContentType = options.headers && new globalThis.Headers(options.headers).has('content-type');
        if (this.#input instanceof globalThis.Request && ((0, $1ff2fea6a6c86f37$export$f1525fa7979d0aa9) && this.#options.body instanceof globalThis.FormData || this.#options.body instanceof URLSearchParams) && !userProvidedContentType) this.#options.headers.delete('content-type');
        this.request = new globalThis.Request(this.#input, this.#options);
        if ((0, $9336c4545dcaac68$export$38f5a1f81179632e)(this.#options.searchParams)) {
            // eslint-disable-next-line unicorn/prevent-abbreviations
            const textSearchParams = typeof this.#options.searchParams === 'string' ? this.#options.searchParams.replace(/^\?/, '') : new URLSearchParams($423bd113d368b878$export$c482d6f00e170af3.#normalizeSearchParams(this.#options.searchParams)).toString();
            // eslint-disable-next-line unicorn/prevent-abbreviations
            const searchParams = '?' + textSearchParams;
            const url = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, searchParams);
            // Recreate request with the updated URL. We already have all options in this.#options, including duplex.
            this.request = new globalThis.Request(url, this.#options);
        }
        // If `onUploadProgress` is passed, it uses the stream API internally
        if (this.#options.onUploadProgress) {
            if (typeof this.#options.onUploadProgress !== 'function') throw new TypeError('The `onUploadProgress` option must be a function');
            if (!(0, $1ff2fea6a6c86f37$export$d8618555562b76b7)) throw new Error('Request streams are not supported in your environment. The `duplex` option for `Request` is not available.');
            this.request = this.#wrapRequestWithUploadProgress(this.request, this.#options.body ?? undefined);
        }
    }
    #calculateDelay() {
        const retryDelay = this.#options.retry.delay(this.#retryCount);
        let jitteredDelay = retryDelay;
        if (this.#options.retry.jitter === true) jitteredDelay = Math.random() * retryDelay;
        else if (typeof this.#options.retry.jitter === 'function') {
            jitteredDelay = this.#options.retry.jitter(retryDelay);
            if (!Number.isFinite(jitteredDelay) || jitteredDelay < 0) jitteredDelay = retryDelay;
        }
        return Math.min(this.#options.retry.backoffLimit, jitteredDelay);
    }
    async #calculateRetryDelay(error) {
        this.#retryCount++;
        if (this.#retryCount > this.#options.retry.limit) throw error;
        // Wrap non-Error throws to ensure consistent error handling
        const errorObject = error instanceof Error ? error : new (0, $1438cfb207618e38$export$5bbe4213615fafb9)(error);
        // Handle forced retry from afterResponse hook - skip method check and shouldRetry
        if (errorObject instanceof (0, $73486797945dd84e$export$58136d16d4327abc)) return errorObject.customDelay ?? this.#calculateDelay();
        // Check if method is retriable for non-forced retries
        if (!this.#options.retry.methods.includes(this.request.method.toLowerCase())) throw error;
        // User-provided shouldRetry function takes precedence over all other checks
        if (this.#options.retry.shouldRetry !== undefined) {
            const result = await this.#options.retry.shouldRetry({
                error: errorObject,
                retryCount: this.#retryCount
            });
            // Strict boolean checking - only exact true/false are handled specially
            if (result === false) throw error;
            if (result === true) // Force retry - skip all other validation and return delay
            return this.#calculateDelay();
        // If undefined or any other value, fall through to default behavior
        }
        // Default timeout behavior
        if ((0, $e51e516e1817b0ab$export$f47339bf28a93789)(error) && !this.#options.retry.retryOnTimeout) throw error;
        if ((0, $e51e516e1817b0ab$export$6b7a49ce9c98a2f)(error)) {
            if (!this.#options.retry.statusCodes.includes(error.response.status)) throw error;
            const retryAfter = error.response.headers.get('Retry-After') ?? error.response.headers.get('RateLimit-Reset') ?? error.response.headers.get('X-RateLimit-Retry-After') // Symfony-based services
             ?? error.response.headers.get('X-RateLimit-Reset') // GitHub
             ?? error.response.headers.get('X-Rate-Limit-Reset'); // Twitter
            if (retryAfter && this.#options.retry.afterStatusCodes.includes(error.response.status)) {
                let after = Number(retryAfter) * 1000;
                if (Number.isNaN(after)) after = Date.parse(retryAfter) - Date.now();
                else if (after >= Date.parse('2024-01-01')) // A large number is treated as a timestamp (fixed threshold protects against clock skew)
                after -= Date.now();
                const max = this.#options.retry.maxRetryAfter ?? after;
                // Don't apply jitter when server provides explicit retry timing
                return after < max ? after : max;
            }
            if (error.response.status === 413) throw error;
        }
        return this.#calculateDelay();
    }
    #decorateResponse(response) {
        if (this.#options.parseJson) response.json = async ()=>this.#options.parseJson(await response.text());
        return response;
    }
    async #retry(function_) {
        try {
            return await function_();
        } catch (error) {
            const ms = Math.min(await this.#calculateRetryDelay(error), (0, $1ff2fea6a6c86f37$export$9b60a72e3f70a1d2));
            if (this.#retryCount < 1) throw error;
            // Only use user-provided signal for delay, not our internal abortController
            await (0, $089f0b9783120894$export$2e2bcd8739ae039)(ms, this.#userProvidedAbortSignal ? {
                signal: this.#userProvidedAbortSignal
            } : {});
            // Apply custom request from forced retry before beforeRetry hooks
            // Ensure the custom request has the correct managed signal for timeouts and user aborts
            if (error instanceof (0, $73486797945dd84e$export$58136d16d4327abc) && error.customRequest) {
                const managedRequest = this.#options.signal ? new globalThis.Request(error.customRequest, {
                    signal: this.#options.signal
                }) : new globalThis.Request(error.customRequest);
                this.#assignRequest(managedRequest);
            }
            for (const hook of this.#options.hooks.beforeRetry){
                // eslint-disable-next-line no-await-in-loop
                const hookResult = await hook({
                    request: this.request,
                    options: this.#getNormalizedOptions(),
                    error: error,
                    retryCount: this.#retryCount
                });
                if (hookResult instanceof globalThis.Request) {
                    this.#assignRequest(hookResult);
                    break;
                }
                // If a Response is returned, use it and skip the retry
                if (hookResult instanceof globalThis.Response) return hookResult;
                // If `stop` is returned from the hook, the retry process is stopped
                if (hookResult === (0, $1ff2fea6a6c86f37$export$fa6813432f753b0d)) return;
            }
            return this.#retry(function_);
        }
    }
    async #fetch() {
        // Reset abortController if it was aborted (happens on timeout retry)
        if (this.#abortController?.signal.aborted) {
            this.#abortController = new globalThis.AbortController();
            this.#options.signal = this.#userProvidedAbortSignal ? AbortSignal.any([
                this.#userProvidedAbortSignal,
                this.#abortController.signal
            ]) : this.#abortController.signal;
            // Recreate request with new signal
            this.request = new globalThis.Request(this.request, {
                signal: this.#options.signal
            });
        }
        for (const hook of this.#options.hooks.beforeRequest){
            // eslint-disable-next-line no-await-in-loop
            const result = await hook(this.request, this.#getNormalizedOptions(), {
                retryCount: this.#retryCount
            });
            if (result instanceof Response) return result;
            if (result instanceof globalThis.Request) {
                this.#assignRequest(result);
                break;
            }
        }
        const nonRequestOptions = (0, $9336c4545dcaac68$export$95d8775889ec941f)(this.request, this.#options);
        // Cloning is done here to prepare in advance for retries
        this.#originalRequest = this.request;
        this.request = this.#originalRequest.clone();
        if (this.#options.timeout === false) return this.#options.fetch(this.#originalRequest, nonRequestOptions);
        return (0, $f071b3ea9e26abc5$export$2e2bcd8739ae039)(this.#originalRequest, nonRequestOptions, this.#abortController, this.#options);
    }
    #getNormalizedOptions() {
        if (!this.#cachedNormalizedOptions) {
            const { hooks: hooks, ...normalizedOptions } = this.#options;
            this.#cachedNormalizedOptions = Object.freeze(normalizedOptions);
        }
        return this.#cachedNormalizedOptions;
    }
    #assignRequest(request) {
        this.#cachedNormalizedOptions = undefined;
        this.request = this.#wrapRequestWithUploadProgress(request);
    }
    #wrapRequestWithUploadProgress(request, originalBody) {
        if (!this.#options.onUploadProgress || !request.body) return request;
        return (0, $eac7b30d3c5d45f3$export$99096e10de875468)(request, this.#options.onUploadProgress, originalBody ?? this.#options.body ?? undefined);
    }
}








const $1a4d2bbfb6ba7df3$var$createInstance = (defaults)=>{
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    const ky = (input, options)=>(0, $423bd113d368b878$export$c482d6f00e170af3).create(input, (0, $1354e4c7c55c83be$export$8886f5ba30bd5e0)(defaults, options));
    for (const method of (0, $1ff2fea6a6c86f37$export$fb003dbd6df95edb))// eslint-disable-next-line @typescript-eslint/promise-function-async
    ky[method] = (input, options)=>(0, $423bd113d368b878$export$c482d6f00e170af3).create(input, (0, $1354e4c7c55c83be$export$8886f5ba30bd5e0)(defaults, options, {
            method: method
        }));
    ky.create = (newDefaults)=>$1a4d2bbfb6ba7df3$var$createInstance((0, $1354e4c7c55c83be$export$8886f5ba30bd5e0)(newDefaults));
    ky.extend = (newDefaults)=>{
        if (typeof newDefaults === 'function') newDefaults = newDefaults(defaults ?? {});
        return $1a4d2bbfb6ba7df3$var$createInstance((0, $1354e4c7c55c83be$export$8886f5ba30bd5e0)(defaults, newDefaults));
    };
    ky.stop = (0, $1ff2fea6a6c86f37$export$fa6813432f753b0d);
    ky.retry = (0, $1ff2fea6a6c86f37$export$9369b12211e1fce4);
    return ky;
};
const $1a4d2bbfb6ba7df3$var$ky = $1a4d2bbfb6ba7df3$var$createInstance();
var $1a4d2bbfb6ba7df3$export$2e2bcd8739ae039 = $1a4d2bbfb6ba7df3$var$ky;
 // Intentionally not exporting this for now as it's just an implementation detail and we don't want to commit to a certain API yet at least.
 // export {NonError} from './errors/NonError.js';





const $faff77658948d155$export$650ce9f0b4df82fd = (0, $bd07366b96e7d92e$export$185802fd694ee1f5)((0, $db1029f36b931e86$export$6922d3b3a607469e)((set)=>({
        jwt: null,
        setJwt: (jwt)=>{
            set({
                jwt: jwt
            }, false, 'AUTH/SET_JWT');
        }
    }), {
    name: 'AuthStore'
}));


const $56ff6b9a4ee43a2e$var$publicApi = (0, $1a4d2bbfb6ba7df3$export$2e2bcd8739ae039).create({
    prefixUrl: (0, $2bd9d04ce55ef2a0$export$923ea8233b386e99)
});
const $56ff6b9a4ee43a2e$var$authApi = (0, $1a4d2bbfb6ba7df3$export$2e2bcd8739ae039).create({
    prefixUrl: (0, $2bd9d04ce55ef2a0$export$923ea8233b386e99),
    hooks: {
        beforeRequest: [
            (request, options, { retryCount: retryCount })=>{
                // Only set default auth header on initial request, not on retries
                // (retries may have refreshed token set by beforeRetry)
                if (retryCount === 0) {
                    const { jwt: jwt } = (0, $faff77658948d155$export$650ce9f0b4df82fd).getState();
                    if (jwt) request.headers.set('Authorization', `Bearer ${jwt}`);
                }
            }
        ]
    }
});
const $56ff6b9a4ee43a2e$export$644d8ea042df96a6 = {
    public: $56ff6b9a4ee43a2e$var$publicApi,
    auth: $56ff6b9a4ee43a2e$var$authApi
};


function $ad23f5e3326fb0ee$export$547fac850f50d49b(e, title, details) {
    const error = e.response?.data?.message ? new Error(e.response.data.message) : e;
    error.title = title;
    error.details = details;
    return error;
}
function $ad23f5e3326fb0ee$export$6e3cb9320fb61c26(raw) {
    // Rename the bookingReference to id as that is what this site is build on.
    const { bookingReference: bookingReference, onlineBookingId: onlineBookingId, ...clone } = raw;
    clone.id = onlineBookingId.toLowerCase();
    clone.reference = bookingReference.toLowerCase();
    if (Array.isArray(clone.practitioners)) clone.practitioners = clone.practitioners.map((practitioner)=>({
            ...practitioner,
            calendarSlots: practitioner.calendarSlots ?? practitioner.calendarListSlots ?? []
        }));
    if (clone.appointment) clone.appointment = {
        ...clone.appointment,
        calendarListSlotId: clone.appointment.calendarListSlotId ?? clone.appointment.calendarSlotId ?? ''
    };
    return clone;
}


function $e88c134850f84ce4$export$b13b809beebfb74d() {
    const { removeSlot: removeSlot, setInvite: setInvite, invite: invite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    return (0, $36464e4be8053fb8$export$fbeb804c371ac8d)(async (calendarSlotId)=>{
        try {
            const skip = (invite.appointment?.calendarListSlotId ?? invite.appointment?.calendarSlotId) === calendarSlotId;
            if (!skip) {
                const data = await (0, $56ff6b9a4ee43a2e$export$644d8ea042df96a6).auth.post('onlinebooking/confirm-appointment', {
                    json: {
                        bookingReference: invite.reference,
                        calendarListSlotId: calendarSlotId
                    }
                }).json();
                const transformed = (0, $ad23f5e3326fb0ee$export$6e3cb9320fb61c26)(data);
                setInvite(transformed);
                return transformed;
            } else return invite;
        } catch (error) {
            console.log(error);
            // TODO: check error code before removing slot
            removeSlot(calendarSlotId);
            throw error;
        }
    });
}




var $acw62 = parcelRequire("acw62");
function $e62a6cddb6964319$var$ChevronLeftIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z",
        clipRule: "evenodd"
    }));
}
const $e62a6cddb6964319$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($e62a6cddb6964319$var$ChevronLeftIcon);
var $e62a6cddb6964319$export$2e2bcd8739ae039 = $e62a6cddb6964319$var$ForwardRef;



var $acw62 = parcelRequire("acw62");
function $09cf89676d665655$var$ChevronRightIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z",
        clipRule: "evenodd"
    }));
}
const $09cf89676d665655$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($09cf89676d665655$var$ChevronRightIcon);
var $09cf89676d665655$export$2e2bcd8739ae039 = $09cf89676d665655$var$ForwardRef;



var $99edfed1e9ae6677$exports = {};
!function(e, t) {
    $99edfed1e9ae6677$exports = t();
}($99edfed1e9ae6677$exports, function() {
    "use strict";
    var e = "day";
    return function(t, i, s) {
        var a = function(t) {
            return t.add(4 - t.isoWeekday(), e);
        }, d = i.prototype;
        d.isoWeekYear = function() {
            return a(this).year();
        }, d.isoWeek = function(t) {
            if (!this.$utils().u(t)) return this.add(7 * (t - this.isoWeek()), e);
            var i, d, n, o, r = a(this), u = (i = this.isoWeekYear(), d = this.$u, n = (d ? s.utc : s)().year(i).startOf("year"), o = 4 - n.isoWeekday(), n.isoWeekday() > 4 && (o += 7), n.add(o, e));
            return r.diff(u, "week") + 1;
        }, d.isoWeekday = function(e) {
            return this.$utils().u(e) ? this.day() || 7 : this.day(this.day() % 7 ? e : e - 7);
        };
        var n = d.startOf;
        d.startOf = function(e, t) {
            var i = this.$utils(), s = !!i.u(t) || t;
            return "isoweek" === i.p(e) ? s ? this.date(this.date() - (this.isoWeekday() - 1)).startOf("day") : this.date(this.date() - 1 - (this.isoWeekday() - 1) + 7).endOf("day") : n.bind(this)(e, t);
        };
    };
});




var $acw62 = parcelRequire("acw62");




const $e464564ddd12cbba$export$a51eaa568b139b5f = 'dddd, D MMMM';
const $e464564ddd12cbba$export$1c7e091ec2afac0f = 'ddd, D MMM';
const $e464564ddd12cbba$export$26148d4b363fecad = 'h:mm A';
const $e464564ddd12cbba$export$5188c7cace6b4075 = /^(?:([+]\d{1,4})[-.\s]?)?(?:[(](\d+)[)][-.\s]?)?(\d([-.\s]?\d+)+)$/;


(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($99edfed1e9ae6677$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($a05dabb57d62d821$exports))));
function $5272f7244e8a5255$export$e1aef45b828286de({ initialDate: initialDate, DayComponent: DayComponent }) {
    const today = (0, $a0555542f484e05c$export$6d84255ad587f3b5)();
    const [currentWeekStart, setCurrentWeekStart] = (0, $acw62.useState)(()=>(initialDate ? (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).tz(initialDate, (0, $2bd9d04ce55ef2a0$export$6f5c75afcb5ad5cc)) : today).startOf('isoWeek'));
    const days = (0, $acw62.useMemo)(()=>Array.from({
            length: 7
        }).map((_, i)=>currentWeekStart.add(i, 'day')), [
        currentWeekStart
    ]);
    const navigationLabel = (0, $acw62.useMemo)(()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aade598d94459724$export$82f9ebd9adeba146), {
                    t: days.at(0),
                    format: (0, $e464564ddd12cbba$export$1c7e091ec2afac0f)
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "p-2",
                    children: "-"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aade598d94459724$export$82f9ebd9adeba146), {
                    t: days.at(-1),
                    format: (0, $e464564ddd12cbba$export$1c7e091ec2afac0f)
                })
            ]
        }), [
        days
    ]);
    const handlePrev = ()=>setCurrentWeekStart((cw)=>cw.subtract(7, 'day'));
    const handleNext = ()=>setCurrentWeekStart((cw)=>cw.add(7, 'day'));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative z-1 -mx-5 sm:mx-0 mb-4.5 last:mb-0 pt-2 pb-4 before:absolute before:-z-1 before:top-0 before:-left-[9999px] before:bottom-0 before:-right-[9999px] before:bg-gray-50 lg:bg-gray-50 lg:before:hidden",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5272f7244e8a5255$var$CalendarNavigation, {
                onPrev: handlePrev,
                onNext: handleNext,
                label: navigationLabel
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid grid-cols-7 gap-x-2 px-2",
                children: days.map((day)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(DayComponent, {
                        day: day
                    }, day.toISOString()))
            })
        ]
    });
}
function $5272f7244e8a5255$var$CalendarNavigation({ label: label, isPrevDisabled: isPrevDisabled, isNextDisabled: isNextDisabled, onPrev: onPrev, onNext: onNext }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('common');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex items-center gap-2 mb-2.5 px-3.5",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                disabled: isPrevDisabled,
                onClick: onPrev,
                className: "text-primary hover:text-primary-hover disabled:text-gray-400",
                "aria-label": t('prevWeek'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e62a6cddb6964319$export$2e2bcd8739ae039), {
                    className: "size-5",
                    "aria-hidden": "true"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "font-medium text-body-dark",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                disabled: isNextDisabled,
                onClick: onNext,
                className: "text-primary hover:text-primary-hover disabled:text-gray-400",
                "aria-label": t('nextWeek'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09cf89676d665655$export$2e2bcd8739ae039), {
                    className: "size-5",
                    "aria-hidden": true
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");
function $c51400d9a81fca36$export$651544f548703224(node) {
    if ($c51400d9a81fca36$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $c51400d9a81fca36$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $c51400d9a81fca36$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($c51400d9a81fca36$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $c51400d9a81fca36$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).Node;
}
function $c51400d9a81fca36$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).Element;
}
function $c51400d9a81fca36$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).HTMLElement;
}
function $c51400d9a81fca36$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $c51400d9a81fca36$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $c51400d9a81fca36$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $c51400d9a81fca36$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($c51400d9a81fca36$export$651544f548703224(element));
}
function $c51400d9a81fca36$export$d6c4e8150c35fed1(element) {
    const webkit = $c51400d9a81fca36$export$78551043582a6a98();
    const css = $c51400d9a81fca36$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $c51400d9a81fca36$export$940d8225183e1404(element) {
    let currentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(element);
    while($c51400d9a81fca36$export$1b3bfaa9684536aa(currentNode) && !$c51400d9a81fca36$export$d1162fb0b6d4cd51(currentNode)){
        if ($c51400d9a81fca36$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        currentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $c51400d9a81fca36$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $c51400d9a81fca36$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($c51400d9a81fca36$export$651544f548703224(node));
}
function $c51400d9a81fca36$export$3735103072e4a80(element) {
    return $c51400d9a81fca36$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $c51400d9a81fca36$export$dc8fc79fa2800137(element) {
    if ($c51400d9a81fca36$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $c51400d9a81fca36$export$4e12058fc4d51d56(node) {
    if ($c51400d9a81fca36$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $c51400d9a81fca36$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $c51400d9a81fca36$export$e495491855dc5418(node);
    return $c51400d9a81fca36$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $c51400d9a81fca36$export$7cd01a57c8ca906c(node) {
    const parentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(node);
    if ($c51400d9a81fca36$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($c51400d9a81fca36$export$1b3bfaa9684536aa(parentNode) && $c51400d9a81fca36$export$989e911fa9af580a(parentNode)) return parentNode;
    return $c51400d9a81fca36$export$7cd01a57c8ca906c(parentNode);
}
function $c51400d9a81fca36$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $c51400d9a81fca36$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $c51400d9a81fca36$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $c51400d9a81fca36$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $c51400d9a81fca36$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $c51400d9a81fca36$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}


function $85ea27aada64f9e6$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $85ea27aada64f9e6$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $c51400d9a81fca36$export$af51f0f06c0f328a)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
// Avoid Chrome DevTools blue warning.
function $85ea27aada64f9e6$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $85ea27aada64f9e6$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(' ');
    return navigator.userAgent;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $85ea27aada64f9e6$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($85ea27aada64f9e6$export$a11b0059900ceec8() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $85ea27aada64f9e6$export$29bf1b5f2c56cf63(event) {
    if ($85ea27aada64f9e6$export$c8f880a2d81914c4()) return false;
    return !$85ea27aada64f9e6$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $85ea27aada64f9e6$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function $85ea27aada64f9e6$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $85ea27aada64f9e6$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($85ea27aada64f9e6$export$867a782338812cb4()) || re.test($85ea27aada64f9e6$export$7935961ef7719cb0());
}
function $85ea27aada64f9e6$export$9ac100e40613ea10() {
    return $85ea27aada64f9e6$export$867a782338812cb4().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function $85ea27aada64f9e6$export$c8f880a2d81914c4() {
    return $85ea27aada64f9e6$export$7935961ef7719cb0().includes('jsdom/');
}
function $85ea27aada64f9e6$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        'mouse',
        'pen'
    ];
    if (!strict) values.push('', undefined);
    return values.includes(pointerType);
}
function $85ea27aada64f9e6$export$94781ce41a161222(event) {
    return 'nativeEvent' in event;
}
function $85ea27aada64f9e6$export$7b296c28e0fa3aed(element) {
    return element.matches('html,body');
}
function $85ea27aada64f9e6$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $85ea27aada64f9e6$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ('composedPath' in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $85ea27aada64f9e6$export$c22522a4dfa48e9c(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
const $85ea27aada64f9e6$export$78b3d091ff376bc = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function $85ea27aada64f9e6$export$42ad131c32f0fb8d(element) {
    return (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element) && element.matches($85ea27aada64f9e6$export$78b3d091ff376bc);
}
function $85ea27aada64f9e6$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $85ea27aada64f9e6$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute('role') === 'combobox' && $85ea27aada64f9e6$export$42ad131c32f0fb8d(element);
}


/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $204931a4986f463b$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $204931a4986f463b$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $204931a4986f463b$export$803cd8101b6c182b = /*#__PURE__*/ $204931a4986f463b$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $204931a4986f463b$export$27b07d8a310ed8b5[0], side + "-" + $204931a4986f463b$export$27b07d8a310ed8b5[1]), []);
const $204931a4986f463b$export$96ec731ed4dcb222 = Math.min;
const $204931a4986f463b$export$8960430cfd85939f = Math.max;
const $204931a4986f463b$export$2077e0241d6afd3c = Math.round;
const $204931a4986f463b$export$a3fe094919f356fd = Math.floor;
const $204931a4986f463b$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $204931a4986f463b$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $204931a4986f463b$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $204931a4986f463b$export$7d15b64cf5a3a4c4(start, value, end) {
    return $204931a4986f463b$export$8960430cfd85939f(start, $204931a4986f463b$export$96ec731ed4dcb222(value, end));
}
function $204931a4986f463b$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $204931a4986f463b$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $204931a4986f463b$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $204931a4986f463b$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $204931a4986f463b$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $204931a4986f463b$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($204931a4986f463b$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $204931a4986f463b$export$2b57e0052a6d6d4c(placement) {
    return $204931a4986f463b$export$8a000a963141ac32($204931a4986f463b$export$f28e8f882010718a(placement));
}
function $204931a4986f463b$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $204931a4986f463b$export$f0989780f32bfcda(placement);
    const alignmentAxis = $204931a4986f463b$export$2b57e0052a6d6d4c(placement);
    const length = $204931a4986f463b$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $204931a4986f463b$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $204931a4986f463b$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $204931a4986f463b$export$496432a3699e50b1(placement) {
    const oppositePlacement = $204931a4986f463b$export$9c5e28bad23365fa(placement);
    return [
        $204931a4986f463b$export$2b182c584985588b(placement),
        oppositePlacement,
        $204931a4986f463b$export$2b182c584985588b(oppositePlacement)
    ];
}
function $204931a4986f463b$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$204931a4986f463b$var$oppositeAlignmentMap[alignment]);
}
function $204931a4986f463b$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $204931a4986f463b$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $204931a4986f463b$export$f0989780f32bfcda(placement);
    let list = $204931a4986f463b$var$getSideList($204931a4986f463b$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($204931a4986f463b$export$2b182c584985588b));
    }
    return list;
}
function $204931a4986f463b$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$204931a4986f463b$var$oppositeSideMap[side]);
}
function $204931a4986f463b$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $204931a4986f463b$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $204931a4986f463b$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $204931a4986f463b$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}



function $9dccb9a8753b0e86$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $204931a4986f463b$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $204931a4986f463b$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $204931a4986f463b$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $9dccb9a8753b0e86$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $9dccb9a8753b0e86$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $9dccb9a8753b0e86$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $204931a4986f463b$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $204931a4986f463b$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9dccb9a8753b0e86$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $204931a4986f463b$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $204931a4986f463b$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $204931a4986f463b$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $204931a4986f463b$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $204931a4986f463b$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $9dccb9a8753b0e86$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $204931a4986f463b$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $204931a4986f463b$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9dccb9a8753b0e86$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $204931a4986f463b$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $204931a4986f463b$export$803cd8101b6c182b) ? $9dccb9a8753b0e86$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $204931a4986f463b$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $204931a4986f463b$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $204931a4986f463b$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9dccb9a8753b0e86$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $204931a4986f463b$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $204931a4986f463b$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $204931a4986f463b$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== 'none') fallbackPlacements.push(...(0, $204931a4986f463b$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $204931a4986f463b$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $9dccb9a8753b0e86$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $9dccb9a8753b0e86$var$isAnySideFullyClipped(overflow) {
    return (0, $204931a4986f463b$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9dccb9a8753b0e86$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $9dccb9a8753b0e86$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $9dccb9a8753b0e86$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $9dccb9a8753b0e86$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $9dccb9a8753b0e86$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $9dccb9a8753b0e86$var$getBoundingRect(rects) {
    const minX = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $204931a4986f463b$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $204931a4986f463b$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $9dccb9a8753b0e86$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $204931a4986f463b$export$ee05aea0aeecbad4)($9dccb9a8753b0e86$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9dccb9a8753b0e86$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $9dccb9a8753b0e86$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $204931a4986f463b$export$ee05aea0aeecbad4)($9dccb9a8753b0e86$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $204931a4986f463b$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $204931a4986f463b$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $9dccb9a8753b0e86$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $204931a4986f463b$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9dccb9a8753b0e86$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $9dccb9a8753b0e86$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9dccb9a8753b0e86$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $204931a4986f463b$export$f28e8f882010718a)((0, $204931a4986f463b$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $204931a4986f463b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9dccb9a8753b0e86$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $204931a4986f463b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $204931a4986f463b$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $204931a4986f463b$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9dccb9a8753b0e86$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $204931a4986f463b$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $204931a4986f463b$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};




function $bede215d88ec3aee$var$getCssDimensions(element) {
    const css = (0, $c51400d9a81fca36$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $204931a4986f463b$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $204931a4986f463b$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $bede215d88ec3aee$var$unwrapElement(element) {
    return !(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $bede215d88ec3aee$var$getScale(element) {
    const domElement = $bede215d88ec3aee$var$unwrapElement(element);
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(domElement)) return (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $bede215d88ec3aee$var$getCssDimensions(domElement);
    let x = ($ ? (0, $204931a4986f463b$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $204931a4986f463b$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $bede215d88ec3aee$var$noOffsets = /*#__PURE__*/ (0, $204931a4986f463b$export$a397704b5e280835)(0);
function $bede215d88ec3aee$var$getVisualOffsets(element) {
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    if (!(0, $c51400d9a81fca36$export$78551043582a6a98)() || !win.visualViewport) return $bede215d88ec3aee$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $bede215d88ec3aee$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $bede215d88ec3aee$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $bede215d88ec3aee$var$unwrapElement(element);
    let scale = (0, $204931a4986f463b$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(offsetParent)) scale = $bede215d88ec3aee$var$getScale(offsetParent);
        } else scale = $bede215d88ec3aee$var$getScale(element);
    }
    const visualOffsets = $bede215d88ec3aee$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bede215d88ec3aee$var$getVisualOffsets(domElement) : (0, $204931a4986f463b$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = currentWin.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $bede215d88ec3aee$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $c51400d9a81fca36$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = currentWin.frameElement;
        }
    }
    return (0, $204931a4986f463b$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
const $bede215d88ec3aee$var$topLayerSelectors = [
    ':popover-open',
    ':modal'
];
function $bede215d88ec3aee$var$isTopLayer(element) {
    return $bede215d88ec3aee$var$topLayerSelectors.some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $bede215d88ec3aee$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $c51400d9a81fca36$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? $bede215d88ec3aee$var$isTopLayer(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const offsets = (0, $204931a4986f463b$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $c51400d9a81fca36$export$651544f548703224)(offsetParent) !== 'body' || (0, $c51400d9a81fca36$export$989e911fa9af580a)(documentElement)) scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $bede215d88ec3aee$var$getBoundingClientRect(offsetParent);
            scale = $bede215d88ec3aee$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $bede215d88ec3aee$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $bede215d88ec3aee$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $bede215d88ec3aee$var$getBoundingClientRect((0, $c51400d9a81fca36$export$e495491855dc5418)(element)).left + (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $bede215d88ec3aee$var$getDocumentRect(element) {
    const html = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    const scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $204931a4986f463b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $204931a4986f463b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $bede215d88ec3aee$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $c51400d9a81fca36$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $204931a4986f463b$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bede215d88ec3aee$var$getViewportRect(element, strategy) {
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    const html = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $c51400d9a81fca36$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $bede215d88ec3aee$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $bede215d88ec3aee$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element) ? $bede215d88ec3aee$var$getScale(element) : (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $bede215d88ec3aee$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $bede215d88ec3aee$var$getDocumentRect((0, $c51400d9a81fca36$export$e495491855dc5418)(element));
    else if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $bede215d88ec3aee$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $bede215d88ec3aee$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $204931a4986f463b$export$ee05aea0aeecbad4)(rect);
}
function $bede215d88ec3aee$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(parentNode) || (0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $c51400d9a81fca36$export$3735103072e4a80)(parentNode).position === 'fixed' || $bede215d88ec3aee$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $bede215d88ec3aee$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $c51400d9a81fca36$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(el) && (0, $c51400d9a81fca36$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(currentNode) && !(0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $c51400d9a81fca36$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $c51400d9a81fca36$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $c51400d9a81fca36$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $bede215d88ec3aee$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $bede215d88ec3aee$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? $bede215d88ec3aee$var$isTopLayer(element) ? [] : $bede215d88ec3aee$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $204931a4986f463b$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $204931a4986f463b$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $204931a4986f463b$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $204931a4986f463b$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $bede215d88ec3aee$var$getDimensions(element) {
    const { width: width, height: height } = $bede215d88ec3aee$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $bede215d88ec3aee$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $c51400d9a81fca36$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $bede215d88ec3aee$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $204931a4986f463b$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $c51400d9a81fca36$export$651544f548703224)(offsetParent) !== 'body' || (0, $c51400d9a81fca36$export$989e911fa9af580a)(documentElement)) scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $bede215d88ec3aee$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $bede215d88ec3aee$var$getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $bede215d88ec3aee$var$isStaticPositioned(element) {
    return (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === 'static';
}
function $bede215d88ec3aee$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element) || (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $bede215d88ec3aee$var$getOffsetParent(element, polyfill) {
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    if ($bede215d88ec3aee$var$isTopLayer(element)) return win;
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$bede215d88ec3aee$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $bede215d88ec3aee$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $c51400d9a81fca36$export$71535ffaa902797f)(offsetParent) && $bede215d88ec3aee$var$isStaticPositioned(offsetParent))offsetParent = $bede215d88ec3aee$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(offsetParent) && $bede215d88ec3aee$var$isStaticPositioned(offsetParent) && !(0, $c51400d9a81fca36$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $c51400d9a81fca36$export$940d8225183e1404)(element) || win;
}
const $bede215d88ec3aee$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $bede215d88ec3aee$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $bede215d88ec3aee$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $bede215d88ec3aee$var$isRTL(element) {
    return (0, $c51400d9a81fca36$export$3735103072e4a80)(element).direction === 'rtl';
}
const $bede215d88ec3aee$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $bede215d88ec3aee$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $c51400d9a81fca36$export$e495491855dc5418,
    getClippingRect: $bede215d88ec3aee$var$getClippingRect,
    getOffsetParent: $bede215d88ec3aee$var$getOffsetParent,
    getElementRects: $bede215d88ec3aee$var$getElementRects,
    getClientRects: $bede215d88ec3aee$var$getClientRects,
    getDimensions: $bede215d88ec3aee$var$getDimensions,
    getScale: $bede215d88ec3aee$var$getScale,
    isElement: $c51400d9a81fca36$export$45a5e7f76e0caa8d,
    isRTL: $bede215d88ec3aee$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $bede215d88ec3aee$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $204931a4986f463b$export$a3fe094919f356fd)(top);
        const insetRight = (0, $204931a4986f463b$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $204931a4986f463b$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $204931a4986f463b$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $204931a4986f463b$export$8960430cfd85939f)(0, (0, $204931a4986f463b$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $bede215d88ec3aee$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $bede215d88ec3aee$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $c51400d9a81fca36$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $c51400d9a81fca36$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $bede215d88ec3aee$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $bede215d88ec3aee$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $bede215d88ec3aee$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $bede215d88ec3aee$export$37b6bde19b108ecc = (0, $9dccb9a8753b0e86$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $bede215d88ec3aee$export$cc800923e997bb8 = (0, $9dccb9a8753b0e86$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $bede215d88ec3aee$export$91fb6ecbd551914 = (0, $9dccb9a8753b0e86$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $bede215d88ec3aee$export$fba63a578e423eb = (0, $9dccb9a8753b0e86$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $bede215d88ec3aee$export$8a83211c878a3f1f = (0, $9dccb9a8753b0e86$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $bede215d88ec3aee$export$346677f925de839c = (0, $9dccb9a8753b0e86$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $bede215d88ec3aee$export$fe8985bb6374093c = (0, $9dccb9a8753b0e86$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $bede215d88ec3aee$export$f2120bbfa5450bd2 = (0, $9dccb9a8753b0e86$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $bede215d88ec3aee$export$18c8ad048e32c7d5 = (0, $9dccb9a8753b0e86$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $bede215d88ec3aee$export$7bf07e38f3dc4b69 = (0, $9dccb9a8753b0e86$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $bede215d88ec3aee$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $bede215d88ec3aee$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $9dccb9a8753b0e86$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $acw62 = parcelRequire("acw62");

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $a4fc732b2bdc2bd6$export$f2120bbfa5450bd2 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $bede215d88ec3aee$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $bede215d88ec3aee$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
var $a4fc732b2bdc2bd6$var$index = typeof document !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $a4fc732b2bdc2bd6$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$a4fc732b2bdc2bd6$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$a4fc732b2bdc2bd6$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $a4fc732b2bdc2bd6$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $a4fc732b2bdc2bd6$var$roundByDPR(element, value) {
    const dpr = $a4fc732b2bdc2bd6$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $a4fc732b2bdc2bd6$var$useLatestRef(value) {
    const ref = $acw62.useRef(value);
    $a4fc732b2bdc2bd6$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $a4fc732b2bdc2bd6$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $acw62.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $acw62.useState(middleware);
    if (!$a4fc732b2bdc2bd6$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $acw62.useState(null);
    const [_floating, _setFloating] = $acw62.useState(null);
    const setReference = $acw62.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $acw62.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $acw62.useRef(null);
    const floatingRef = $acw62.useRef(null);
    const dataRef = $acw62.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $a4fc732b2bdc2bd6$var$useLatestRef(whileElementsMounted);
    const platformRef = $a4fc732b2bdc2bd6$var$useLatestRef(platform);
    const update = $acw62.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $bede215d88ec3aee$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                isPositioned: true
            };
            if (isMountedRef.current && !$a4fc732b2bdc2bd6$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $11492dca620dcaa5$exports.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    $a4fc732b2bdc2bd6$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $acw62.useRef(false);
    $a4fc732b2bdc2bd6$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $a4fc732b2bdc2bd6$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $acw62.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $acw62.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $acw62.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $a4fc732b2bdc2bd6$var$roundByDPR(elements.floating, data.x);
        const y = $a4fc732b2bdc2bd6$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$a4fc732b2bdc2bd6$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $acw62.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}



/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $a4b3b7902c9a987d$var$candidateSelectors = [
    'input:not([inert])',
    'select:not([inert])',
    'textarea:not([inert])',
    'a[href]:not([inert])',
    'button:not([inert])',
    '[tabindex]:not(slot):not([inert])',
    'audio[controls]:not([inert])',
    'video[controls]:not([inert])',
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    'details>summary:first-of-type:not([inert])',
    'details:not([inert])'
];
var $a4b3b7902c9a987d$var$candidateSelector = /* #__PURE__ */ $a4b3b7902c9a987d$var$candidateSelectors.join(',');
var $a4b3b7902c9a987d$var$NoElement = typeof Element === 'undefined';
var $a4b3b7902c9a987d$var$matches = $a4b3b7902c9a987d$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $a4b3b7902c9a987d$var$getRootNode = !$a4b3b7902c9a987d$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $a4b3b7902c9a987d$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $a4b3b7902c9a987d$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $a4b3b7902c9a987d$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($a4b3b7902c9a987d$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($a4b3b7902c9a987d$var$candidateSelector));
    if (includeContainer && $a4b3b7902c9a987d$var$matches.call(el, $a4b3b7902c9a987d$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $a4b3b7902c9a987d$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($a4b3b7902c9a987d$var$isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $a4b3b7902c9a987d$var$matches.call(element, $a4b3b7902c9a987d$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$a4b3b7902c9a987d$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $a4b3b7902c9a987d$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $a4b3b7902c9a987d$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $a4b3b7902c9a987d$var$isContentEditable(node)) && !$a4b3b7902c9a987d$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $a4b3b7902c9a987d$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $a4b3b7902c9a987d$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$a4b3b7902c9a987d$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $a4b3b7902c9a987d$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $a4b3b7902c9a987d$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $a4b3b7902c9a987d$var$isHiddenInput = function isHiddenInput(node) {
    return $a4b3b7902c9a987d$var$isInput(node) && node.type === 'hidden';
};
var $a4b3b7902c9a987d$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $a4b3b7902c9a987d$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $a4b3b7902c9a987d$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $a4b3b7902c9a987d$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $a4b3b7902c9a987d$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $a4b3b7902c9a987d$var$isRadio = function isRadio(node) {
    return $a4b3b7902c9a987d$var$isInput(node) && node.type === 'radio';
};
var $a4b3b7902c9a987d$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $a4b3b7902c9a987d$var$isRadio(node) && !$a4b3b7902c9a987d$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $a4b3b7902c9a987d$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $a4b3b7902c9a987d$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $a4b3b7902c9a987d$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $a4b3b7902c9a987d$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $a4b3b7902c9a987d$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === 'hidden') return true;
    var isDirectSummary = $a4b3b7902c9a987d$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($a4b3b7902c9a987d$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $a4b3b7902c9a987d$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $a4b3b7902c9a987d$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($a4b3b7902c9a987d$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $a4b3b7902c9a987d$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $a4b3b7902c9a987d$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $a4b3b7902c9a987d$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $a4b3b7902c9a987d$var$isInert(node) || $a4b3b7902c9a987d$var$isHiddenInput(node) || $a4b3b7902c9a987d$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $a4b3b7902c9a987d$var$isDetailsWithSummary(node) || $a4b3b7902c9a987d$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($a4b3b7902c9a987d$var$isNonTabbableRadio(node) || $a4b3b7902c9a987d$export$a4672efddb4181b8(node) < 0 || !$a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $a4b3b7902c9a987d$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $a4b3b7902c9a987d$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $a4b3b7902c9a987d$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($a4b3b7902c9a987d$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $a4b3b7902c9a987d$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $a4b3b7902c9a987d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $a4b3b7902c9a987d$var$isValidShadowRootTabbable
    });
    else candidates = $a4b3b7902c9a987d$var$getCandidates(container, options.includeContainer, $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $a4b3b7902c9a987d$var$sortByOrder(candidates);
};
var $a4b3b7902c9a987d$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $a4b3b7902c9a987d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $a4b3b7902c9a987d$var$getCandidates(container, options.includeContainer, $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $a4b3b7902c9a987d$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($a4b3b7902c9a987d$var$matches.call(node, $a4b3b7902c9a987d$var$candidateSelector) === false) return false;
    return $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable(options, node);
};
var $a4b3b7902c9a987d$var$focusableCandidateSelector = /* #__PURE__ */ $a4b3b7902c9a987d$var$candidateSelectors.concat('iframe').join(',');
var $a4b3b7902c9a987d$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($a4b3b7902c9a987d$var$matches.call(node, $a4b3b7902c9a987d$var$focusableCandidateSelector) === false) return false;
    return $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable(options, node);
};



/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $1923ad12705fb717$export$74665b213cb5c4cf(refs) {
    return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === 'function') ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $1923ad12705fb717$var$SafeReact = {
    ...$acw62
};
const $1923ad12705fb717$var$useInsertionEffect = $1923ad12705fb717$var$SafeReact.useInsertionEffect;
const $1923ad12705fb717$var$useSafeInsertionEffect = $1923ad12705fb717$var$useInsertionEffect || ((fn)=>fn());
function $1923ad12705fb717$var$useEffectEvent(callback) {
    const ref = $acw62.useRef(()=>{});
    $1923ad12705fb717$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $acw62.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
const $1923ad12705fb717$var$ARROW_UP = 'ArrowUp';
const $1923ad12705fb717$var$ARROW_DOWN = 'ArrowDown';
const $1923ad12705fb717$var$ARROW_LEFT = 'ArrowLeft';
const $1923ad12705fb717$var$ARROW_RIGHT = 'ArrowRight';
function $1923ad12705fb717$var$isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $1923ad12705fb717$var$isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $1923ad12705fb717$var$getMinIndex(listRef, disabledIndices) {
    return $1923ad12705fb717$var$findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function $1923ad12705fb717$var$getMaxIndex(listRef, disabledIndices) {
    return $1923ad12705fb717$var$findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $1923ad12705fb717$var$findNonDisabledIndex(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    const list = listRef.current;
    const isDisabledIndex = disabledIndices ? (index)=>disabledIndices.includes(index) : (index)=>{
        const element = list[index];
        return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
    };
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= list.length - 1 && isDisabledIndex(index));
    return index;
}
function $1923ad12705fb717$var$getGridNavigatedIndex(elementsRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $1923ad12705fb717$var$ARROW_UP) {
        stop && (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $1923ad12705fb717$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($1923ad12705fb717$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $1923ad12705fb717$var$ARROW_DOWN) {
        stop && (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $1923ad12705fb717$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $1923ad12705fb717$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($1923ad12705fb717$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === 'both') {
        const prevRow = (0, $204931a4986f463b$export$a3fe094919f356fd)(prevIndex / cols);
        if (event.key === $1923ad12705fb717$var$ARROW_RIGHT) {
            stop && (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $1923ad12705fb717$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $1923ad12705fb717$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $1923ad12705fb717$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $1923ad12705fb717$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($1923ad12705fb717$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === $1923ad12705fb717$var$ARROW_LEFT) {
            stop && (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $1923ad12705fb717$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices,
                    decrement: true
                });
                if (loop && $1923ad12705fb717$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $1923ad12705fb717$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $1923ad12705fb717$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($1923ad12705fb717$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $204931a4986f463b$export$a3fe094919f356fd)(maxIndex / cols) === prevRow;
        if ($1923ad12705fb717$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === $1923ad12705fb717$var$ARROW_LEFT ? maxIndex : $1923ad12705fb717$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $1923ad12705fb717$var$buildCellMap(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $1923ad12705fb717$var$getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    switch(corner){
        case 'tl':
            return firstCellIndex;
        case 'tr':
            return firstCellIndex + sizes[index].width - 1;
        case 'bl':
            return firstCellIndex + (sizes[index].height - 1) * cols;
        case 'br':
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $1923ad12705fb717$var$getCellIndices(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
let $1923ad12705fb717$var$rafId = 0;
function $1923ad12705fb717$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($1923ad12705fb717$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $1923ad12705fb717$var$rafId = requestAnimationFrame(exec);
}
var $1923ad12705fb717$var$index = typeof document !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function $1923ad12705fb717$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
function $1923ad12705fb717$var$areMapsEqual(map1, map2) {
    if (map1.size !== map2.size) return false;
    for (const [key, value] of map1.entries()){
        if (value !== map2.get(key)) return false;
    }
    return true;
}
const $1923ad12705fb717$var$FloatingListContext = /*#__PURE__*/ $acw62.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $1923ad12705fb717$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [map, setMap] = $acw62.useState(()=>new Map());
    const register = $acw62.useCallback((node)=>{
        setMap((prevMap)=>new Map(prevMap).set(node, null));
    }, []);
    const unregister = $acw62.useCallback((node)=>{
        setMap((prevMap)=>{
            const map = new Map(prevMap);
            map.delete(node);
            return map;
        });
    }, []);
    $1923ad12705fb717$var$index(()=>{
        const newMap = new Map(map);
        const nodes = Array.from(newMap.keys()).sort($1923ad12705fb717$var$sortByDocumentPosition);
        nodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        if (!$1923ad12705fb717$var$areMapsEqual(map, newMap)) setMap(newMap);
    }, [
        map
    ]);
    return /*#__PURE__*/ $acw62.createElement($1923ad12705fb717$var$FloatingListContext.Provider, {
        value: $acw62.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ])
    }, children);
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $1923ad12705fb717$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $acw62.useContext($1923ad12705fb717$var$FloatingListContext);
    const [index$1, setIndex] = $acw62.useState(null);
    const componentRef = $acw62.useRef(null);
    const ref = $acw62.useCallback((node)=>{
        componentRef.current = node;
        if (index$1 !== null) {
            elementsRef.current[index$1] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index$1,
        elementsRef,
        labelsRef,
        label
    ]);
    $1923ad12705fb717$var$index(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    $1923ad12705fb717$var$index(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $acw62.useMemo(()=>({
            ref: ref,
            index: index$1 == null ? -1 : index$1
        }), [
        index$1,
        ref
    ]);
}
function $1923ad12705fb717$var$renderJsx(render, computedProps) {
    if (typeof render === 'function') return render(computedProps);
    if (render) return /*#__PURE__*/ $acw62.cloneElement(render, computedProps);
    return /*#__PURE__*/ $acw62.createElement("div", computedProps);
}
const $1923ad12705fb717$var$CompositeContext = /*#__PURE__*/ $acw62.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $1923ad12705fb717$var$horizontalKeys = [
    $1923ad12705fb717$var$ARROW_LEFT,
    $1923ad12705fb717$var$ARROW_RIGHT
];
const $1923ad12705fb717$var$verticalKeys = [
    $1923ad12705fb717$var$ARROW_UP,
    $1923ad12705fb717$var$ARROW_DOWN
];
const $1923ad12705fb717$var$allKeys = [
    ...$1923ad12705fb717$var$horizontalKeys,
    ...$1923ad12705fb717$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $1923ad12705fb717$export$43586241d9db0c6d = /*#__PURE__*/ $acw62.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = 'both', loop: loop = true, cols: cols = 1, disabledIndices: disabledIndices = [], activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $acw62.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = $1923ad12705fb717$var$useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $acw62.useRef([]);
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const contextValue = $acw62.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$1923ad12705fb717$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $1923ad12705fb717$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !disabledIndices.includes(index));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(disabledIndices != null && disabledIndices.includes(index)) ? cellIndex : foundIndex, -1);
            nextIndex = cellMap[$1923ad12705fb717$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $1923ad12705fb717$var$getCellIndices([
                    ...disabledIndices,
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $1923ad12705fb717$var$getCellIndexOfCorner(activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $1923ad12705fb717$var$ARROW_DOWN ? 'bl' : event.key === $1923ad12705fb717$var$ARROW_RIGHT ? 'tr' : 'tl')
            })]; // navigated cell will never be nullish
        }
        const minIndex = $1923ad12705fb717$var$getMinIndex(elementsRef, disabledIndices);
        const maxIndex = $1923ad12705fb717$var$getMaxIndex(elementsRef, disabledIndices);
        const toEndKeys = {
            horizontal: [
                $1923ad12705fb717$var$ARROW_RIGHT
            ],
            vertical: [
                $1923ad12705fb717$var$ARROW_DOWN
            ],
            both: [
                $1923ad12705fb717$var$ARROW_RIGHT,
                $1923ad12705fb717$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                $1923ad12705fb717$var$ARROW_LEFT
            ],
            vertical: [
                $1923ad12705fb717$var$ARROW_UP
            ],
            both: [
                $1923ad12705fb717$var$ARROW_LEFT,
                $1923ad12705fb717$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $1923ad12705fb717$var$allKeys : ({
            horizontal: $1923ad12705fb717$var$horizontalKeys,
            vertical: $1923ad12705fb717$var$verticalKeys,
            both: $1923ad12705fb717$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = $1923ad12705fb717$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !$1923ad12705fb717$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            // Wait for FocusManager `returnFocus` to execute.
            queueMicrotask(()=>{
                $1923ad12705fb717$var$enqueueFocus(elementsRef.current[nextIndex]);
            });
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ $acw62.createElement($1923ad12705fb717$var$CompositeContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $acw62.createElement($1923ad12705fb717$export$ffe15b0e64951704, {
        elementsRef: elementsRef
    }, $1923ad12705fb717$var$renderJsx(render, computedProps)));
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $1923ad12705fb717$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $acw62.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $acw62.useContext($1923ad12705fb717$var$CompositeContext);
    const { ref: ref, index: index } = $1923ad12705fb717$export$dcdc7ff5149f7d1a();
    const mergedRef = $1923ad12705fb717$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        'data-active': isActive ? '' : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $1923ad12705fb717$var$renderJsx(render, computedProps);
});
function $1923ad12705fb717$var$_extends() {
    $1923ad12705fb717$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1923ad12705fb717$var$_extends.apply(this, arguments);
}
let $1923ad12705fb717$var$serverHandoffComplete = false;
let $1923ad12705fb717$var$count = 0;
const $1923ad12705fb717$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $1923ad12705fb717$var$count++;
function $1923ad12705fb717$var$useFloatingId() {
    const [id, setId] = $acw62.useState(()=>$1923ad12705fb717$var$serverHandoffComplete ? $1923ad12705fb717$var$genId() : undefined);
    $1923ad12705fb717$var$index(()=>{
        if (id == null) setId($1923ad12705fb717$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $acw62.useEffect(()=>{
        $1923ad12705fb717$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $1923ad12705fb717$var$useReactId = $1923ad12705fb717$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $1923ad12705fb717$export$f680877a34711e37 = $1923ad12705fb717$var$useReactId || $1923ad12705fb717$var$useFloatingId;
let $1923ad12705fb717$var$devMessageSet;
function $1923ad12705fb717$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet = $1923ad12705fb717$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $1923ad12705fb717$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $1923ad12705fb717$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet3 = $1923ad12705fb717$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $1923ad12705fb717$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $1923ad12705fb717$export$33511391554732bc = /*#__PURE__*/ $acw62.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = $1923ad12705fb717$export$f680877a34711e37();
    if (!floating) return null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const [side, alignment] = placement.split('-');
    const isRTL = (0, $bede215d88ec3aee$export$722a64dea1b767dc).isRTL(floating);
    const isCustomShape = !!d;
    const isVerticalSide = side === 'top' || side === 'bottom';
    const yOffsetProp = staticOffset && alignment === 'end' ? 'bottom' : 'top';
    let xOffsetProp = staticOffset && alignment === 'end' ? 'right' : 'left';
    if (staticOffset && isRTL) xOffsetProp = alignment === 'end' ? 'left' : 'right';
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? staticOffset || arrow.x : '';
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? staticOffset || arrow.y : '';
    const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
    const rotation = {
        top: isCustomShape ? 'rotate(180deg)' : '',
        left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
        bottom: isCustomShape ? '' : 'rotate(180deg)',
        right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
    }[side];
    return /*#__PURE__*/ $acw62.createElement("svg", $1923ad12705fb717$var$_extends({}, rest, {
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: "" + rotation + (transform != null ? transform : ''),
            ...restStyle
        }
    }), computedStrokeWidth > 0 && /*#__PURE__*/ $acw62.createElement("path", {
        clipPath: "url(#" + clipPathId + ")",
        fill: "none",
        stroke: stroke,
        strokeWidth: computedStrokeWidth + (d ? 0 : 1),
        d: dValue
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: computedStrokeWidth && !d ? rest.fill : 'none',
        d: dValue
    }), /*#__PURE__*/ $acw62.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $acw62.createElement("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + computedStrokeWidth,
        height: width
    })));
});
function $1923ad12705fb717$var$createPubSub() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((handler)=>handler(data));
        },
        on (event, listener) {
            map.set(event, [
                ...map.get(event) || [],
                listener
            ]);
        },
        off (event, listener) {
            var _map$get2;
            map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l)=>l !== listener)) || []);
        }
    };
}
const $1923ad12705fb717$var$FloatingNodeContext = /*#__PURE__*/ $acw62.createContext(null);
const $1923ad12705fb717$var$FloatingTreeContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $1923ad12705fb717$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $acw62.useContext($1923ad12705fb717$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $1923ad12705fb717$export$db0c2a7c7a2a4f69 = ()=>$acw62.useContext($1923ad12705fb717$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $1923ad12705fb717$export$9b136e0e758a42f4(customParentId) {
    const id = $1923ad12705fb717$export$f680877a34711e37();
    const tree = $1923ad12705fb717$export$db0c2a7c7a2a4f69();
    const reactParentId = $1923ad12705fb717$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    $1923ad12705fb717$var$index(()=>{
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $1923ad12705fb717$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $1923ad12705fb717$export$165209eae06d3488();
    return /*#__PURE__*/ $acw62.createElement($1923ad12705fb717$var$FloatingNodeContext.Provider, {
        value: $acw62.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ])
    }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $1923ad12705fb717$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $acw62.useRef([]);
    const addNode = $acw62.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $acw62.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const events = $acw62.useState(()=>$1923ad12705fb717$var$createPubSub())[0];
    return /*#__PURE__*/ $acw62.createElement($1923ad12705fb717$var$FloatingTreeContext.Provider, {
        value: $acw62.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ])
    }, children);
}
function $1923ad12705fb717$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $1923ad12705fb717$var$useLatestRef(value) {
    const ref = (0, $acw62.useRef)(value);
    $1923ad12705fb717$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
const $1923ad12705fb717$var$safePolygonIdentifier = /*#__PURE__*/ $1923ad12705fb717$var$createAttribute('safe-polygon');
function $1923ad12705fb717$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $85ea27aada64f9e6$export$81cf264172d31e51)(pointerType)) return 0;
    if (typeof value === 'number') return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $1923ad12705fb717$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: { domReference: domReference, floating: floating }, refs: refs } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $1923ad12705fb717$export$db0c2a7c7a2a4f69();
    const parentId = $1923ad12705fb717$export$165209eae06d3488();
    const handleCloseRef = $1923ad12705fb717$var$useLatestRef(handleClose);
    const delayRef = $1923ad12705fb717$var$useLatestRef(delay);
    const pointerTypeRef = $acw62.useRef();
    const timeoutRef = $acw62.useRef(-1);
    const handlerRef = $acw62.useRef();
    const restTimeoutRef = $acw62.useRef(-1);
    const blockMouseMoveRef = $acw62.useRef(true);
    const performedPointerEventsMutationRef = $acw62.useRef(false);
    const unbindMouseMoveRef = $acw62.useRef(()=>{});
    const isHoverOpen = $acw62.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
    }, [
        dataRef
    ]);
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                clearTimeout(timeoutRef.current);
                clearTimeout(restTimeoutRef.current);
                blockMouseMoveRef.current = true;
            }
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $acw62.useEffect(()=>{
        if (!enabled || !handleCloseRef.current || !open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, 'hover');
        }
        const html = (0, $85ea27aada64f9e6$export$f65ca476c09acec0)(floating).documentElement;
        html.addEventListener('mouseleave', onLeave);
        return ()=>{
            html.removeEventListener('mouseleave', onLeave);
        };
    }, [
        floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $acw62.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = 'hover';
        const closeDelay = $1923ad12705fb717$var$getDelay(delayRef.current, 'close', pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = $acw62.useCallback(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    }, []);
    const clearPointerEvents = $acw62.useCallback(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $85ea27aada64f9e6$export$f65ca476c09acec0)(refs.floating.current).body;
            body.style.pointerEvents = '';
            body.removeAttribute($1923ad12705fb717$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    }, [
        refs
    ]);
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function isClickLikeOpenEvent() {
            return dataRef.current.openEvent ? [
                'click',
                'mousedown'
            ].includes(dataRef.current.openEvent.type) : false;
        }
        function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $85ea27aada64f9e6$export$81cf264172d31e51)(pointerTypeRef.current) || restMs > 0 && !$1923ad12705fb717$var$getDelay(delayRef.current, 'open')) return;
            const openDelay = $1923ad12705fb717$var$getDelay(delayRef.current, 'open', pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                onOpenChange(true, event, 'hover');
            }, openDelay);
            else onOpenChange(true, event, 'hover');
        }
        function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            const doc = (0, $85ea27aada64f9e6$export$f65ca476c09acec0)(floating);
            clearTimeout(restTimeoutRef.current);
            if (handleCloseRef.current) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current({
                    ...context,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        closeWithDelay(event, true, 'safe-polygon');
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener('mousemove', handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener('mousemove', handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === 'touch' ? !(0, $85ea27aada64f9e6$export$2344b14b097df817)(floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...context,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    closeWithDelay(event);
                }
            })(event);
        }
        if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(domReference)) {
            const ref = domReference;
            open && ref.addEventListener('mouseleave', onScrollMouseLeave);
            floating == null || floating.addEventListener('mouseleave', onScrollMouseLeave);
            move && ref.addEventListener('mousemove', onMouseEnter, {
                once: true
            });
            ref.addEventListener('mouseenter', onMouseEnter);
            ref.addEventListener('mouseleave', onMouseLeave);
            return ()=>{
                open && ref.removeEventListener('mouseleave', onScrollMouseLeave);
                floating == null || floating.removeEventListener('mouseleave', onScrollMouseLeave);
                move && ref.removeEventListener('mousemove', onMouseEnter);
                ref.removeEventListener('mouseenter', onMouseEnter);
                ref.removeEventListener('mouseleave', onMouseLeave);
            };
        }
    }, [
        domReference,
        floating,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        tree,
        delayRef,
        handleCloseRef,
        dataRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    $1923ad12705fb717$var$index(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            const body = (0, $85ea27aada64f9e6$export$f65ca476c09acec0)(floating).body;
            body.setAttribute($1923ad12705fb717$var$safePolygonIdentifier, '');
            body.style.pointerEvents = 'none';
            performedPointerEventsMutationRef.current = true;
            if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(domReference) && floating) {
                var _tree$nodesRef$curren;
                const ref = domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = '';
                ref.style.pointerEvents = 'auto';
                floating.style.pointerEvents = 'auto';
                return ()=>{
                    ref.style.pointerEvents = '';
                    floating.style.pointerEvents = '';
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        floating,
        domReference,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    $1923ad12705fb717$var$index(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            reference: {
                onPointerDown: setPointerRef,
                onPointerEnter: setPointerRef,
                onMouseMove (event) {
                    function handleMouseMove() {
                        if (!blockMouseMoveRef.current) onOpenChange(true, event.nativeEvent, 'hover');
                    }
                    if (mouseOnly && !(0, $85ea27aada64f9e6$export$81cf264172d31e51)(pointerTypeRef.current)) return;
                    if (open || restMs === 0) return;
                    clearTimeout(restTimeoutRef.current);
                    if (pointerTypeRef.current === 'touch') handleMouseMove();
                    else restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
                }
            },
            floating: {
                onMouseEnter () {
                    clearTimeout(timeoutRef.current);
                },
                onMouseLeave (event) {
                    closeWithDelay(event.nativeEvent, false);
                }
            }
        };
    }, [
        enabled,
        mouseOnly,
        open,
        restMs,
        onOpenChange,
        closeWithDelay
    ]);
}
const $1923ad12705fb717$var$NOOP = ()=>{};
const $1923ad12705fb717$var$FloatingDelayGroupContext = /*#__PURE__*/ $acw62.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $1923ad12705fb717$var$NOOP,
    setState: $1923ad12705fb717$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $1923ad12705fb717$export$e2411914b150383d = ()=>$acw62.useContext($1923ad12705fb717$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $1923ad12705fb717$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $acw62.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $acw62.useRef(null);
    const setCurrentId = $acw62.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    $1923ad12705fb717$var$index(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else setState({
                isInstantPhase: true
            });
        } else {
            setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId
    ]);
    return /*#__PURE__*/ $acw62.createElement($1923ad12705fb717$var$FloatingDelayGroupContext.Provider, {
        value: $acw62.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ])
    }, children);
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $1923ad12705fb717$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $1923ad12705fb717$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    $1923ad12705fb717$var$index(()=>{
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $1923ad12705fb717$var$getDelay(initialDelay, 'close')
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    $1923ad12705fb717$var$index(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    $1923ad12705fb717$var$index(()=>{
        if (setCurrentId === $1923ad12705fb717$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
function $1923ad12705fb717$var$getAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $1923ad12705fb717$var$getChildren(nodes, id) {
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        });
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $1923ad12705fb717$var$getDeepestNode(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $1923ad12705fb717$var$getChildren(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
let $1923ad12705fb717$var$counterMap = /*#__PURE__*/ new WeakMap();
let $1923ad12705fb717$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $1923ad12705fb717$var$markerMap = {};
let $1923ad12705fb717$var$lockCount = 0;
const $1923ad12705fb717$var$supportsInert = ()=>typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
const $1923ad12705fb717$var$unwrapHost = (node)=>node && (node.host || $1923ad12705fb717$var$unwrapHost(node.parentNode));
const $1923ad12705fb717$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $1923ad12705fb717$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $1923ad12705fb717$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = 'data-floating-ui-inert';
    const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
    const avoidElements = $1923ad12705fb717$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$1923ad12705fb717$var$markerMap[markerName]) $1923ad12705fb717$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $1923ad12705fb717$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, (node)=>{
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== 'false';
                const counterValue = ($1923ad12705fb717$var$counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                $1923ad12705fb717$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $1923ad12705fb717$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, '');
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, 'true');
            }
        });
    }
    $1923ad12705fb717$var$lockCount++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterValue = ($1923ad12705fb717$var$counterMap.get(element) || 0) - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            $1923ad12705fb717$var$counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$1923ad12705fb717$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $1923ad12705fb717$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $1923ad12705fb717$var$lockCount--;
        if (!$1923ad12705fb717$var$lockCount) {
            $1923ad12705fb717$var$counterMap = new WeakMap();
            $1923ad12705fb717$var$counterMap = new WeakMap();
            $1923ad12705fb717$var$uncontrolledElementsSet = new WeakSet();
            $1923ad12705fb717$var$markerMap = {};
        }
    };
}
function $1923ad12705fb717$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = (0, $85ea27aada64f9e6$export$f65ca476c09acec0)(avoidElements[0]).body;
    return $1923ad12705fb717$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live]'))), body, ariaHidden, inert);
}
const $1923ad12705fb717$var$getTabbableOptions = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
    });
function $1923ad12705fb717$var$getTabbableIn(container, direction) {
    const allTabbable = (0, $a4b3b7902c9a987d$export$17100aea90429aa7)(container, $1923ad12705fb717$var$getTabbableOptions());
    if (direction === 'prev') allTabbable.reverse();
    const activeIndex = allTabbable.indexOf((0, $85ea27aada64f9e6$export$da980962bd2147a4)((0, $85ea27aada64f9e6$export$f65ca476c09acec0)(container)));
    const nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function $1923ad12705fb717$var$getNextTabbable() {
    return $1923ad12705fb717$var$getTabbableIn(document.body, 'next');
}
function $1923ad12705fb717$var$getPreviousTabbable() {
    return $1923ad12705fb717$var$getTabbableIn(document.body, 'prev');
}
function $1923ad12705fb717$var$isOutsideEvent(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !(0, $85ea27aada64f9e6$export$2344b14b097df817)(containerElement, relatedTarget);
}
function $1923ad12705fb717$var$disableFocusInside(container) {
    const tabbableElements = (0, $a4b3b7902c9a987d$export$17100aea90429aa7)(container, $1923ad12705fb717$var$getTabbableOptions());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute('tabindex') || '';
        element.setAttribute('tabindex', '-1');
    });
}
function $1923ad12705fb717$var$enableFocusInside(container) {
    const elements = container.querySelectorAll('[data-tabindex]');
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute('tabindex', tabindex);
        else element.removeAttribute('tabindex');
    });
}
// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx
const $1923ad12705fb717$var$HIDDEN_STYLES = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: '1px',
    top: 0,
    left: 0
};
let $1923ad12705fb717$var$timeoutId;
function $1923ad12705fb717$var$setActiveElementOnTab(event) {
    if (event.key === 'Tab') {
        event.target;
        clearTimeout($1923ad12705fb717$var$timeoutId);
    }
}
const $1923ad12705fb717$var$FocusGuard = /*#__PURE__*/ $acw62.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $acw62.useState();
    $1923ad12705fb717$var$index(()=>{
        if ((0, $85ea27aada64f9e6$export$95df08bae54cb4df)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole('button');
        document.addEventListener('keydown', $1923ad12705fb717$var$setActiveElementOnTab);
        return ()=>{
            document.removeEventListener('keydown', $1923ad12705fb717$var$setActiveElementOnTab);
        };
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        'aria-hidden': role ? undefined : true,
        [$1923ad12705fb717$var$createAttribute('focus-guard')]: '',
        style: $1923ad12705fb717$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ $acw62.createElement("span", $1923ad12705fb717$var$_extends({}, props, restProps));
});
const $1923ad12705fb717$var$PortalContext = /*#__PURE__*/ $acw62.createContext(null);
const $1923ad12705fb717$var$attr = /*#__PURE__*/ $1923ad12705fb717$var$createAttribute('portal');
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $1923ad12705fb717$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $1923ad12705fb717$export$f680877a34711e37();
    const portalContext = $1923ad12705fb717$var$usePortalContext();
    const [portalNode, setPortalNode] = $acw62.useState(null);
    const portalNodeRef = $acw62.useRef(null);
    $1923ad12705fb717$var$index(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    $1923ad12705fb717$var$index(()=>{
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($1923ad12705fb717$var$attr, '');
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    $1923ad12705fb717$var$index(()=>{
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement('div');
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($1923ad12705fb717$var$attr, '');
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $1923ad12705fb717$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root = null, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $1923ad12705fb717$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $acw62.useState(null);
    const beforeOutsideRef = $acw62.useRef(null);
    const afterOutsideRef = $acw62.useRef(null);
    const beforeInsideRef = $acw62.useRef(null);
    const afterInsideRef = $acw62.useRef(null);
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $acw62.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || focusManagerState != null && focusManagerState.modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && $1923ad12705fb717$var$isOutsideEvent(event)) {
                const focusing = event.type === 'focusin';
                const manageFocus = focusing ? $1923ad12705fb717$var$enableFocusInside : $1923ad12705fb717$var$disableFocusInside;
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener('focusin', onFocus, true);
        portalNode.addEventListener('focusout', onFocus, true);
        return ()=>{
            portalNode.removeEventListener('focusin', onFocus, true);
            portalNode.removeEventListener('focusout', onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        focusManagerState == null ? void 0 : focusManagerState.modal
    ]);
    return /*#__PURE__*/ $acw62.createElement($1923ad12705fb717$var$PortalContext.Provider, {
        value: $acw62.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ])
    }, shouldRenderGuards && portalNode && /*#__PURE__*/ $acw62.createElement($1923ad12705fb717$var$FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: (event)=>{
            if ($1923ad12705fb717$var$isOutsideEvent(event, portalNode)) {
                var _beforeInsideRef$curr;
                (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
            } else {
                const prevTabbable = $1923ad12705fb717$var$getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                prevTabbable == null || prevTabbable.focus();
            }
        }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/ $acw62.createElement("span", {
        "aria-owns": portalNode.id,
        style: $1923ad12705fb717$var$HIDDEN_STYLES
    }), portalNode && /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/ $acw62.createElement($1923ad12705fb717$var$FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: (event)=>{
            if ($1923ad12705fb717$var$isOutsideEvent(event, portalNode)) {
                var _afterInsideRef$curre;
                (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
            } else {
                const nextTabbable = $1923ad12705fb717$var$getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                nextTabbable == null || nextTabbable.focus();
                (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent));
            }
        }
    }));
}
const $1923ad12705fb717$var$usePortalContext = ()=>$acw62.useContext($1923ad12705fb717$var$PortalContext);
const $1923ad12705fb717$var$LIST_LIMIT = 20;
let $1923ad12705fb717$var$previouslyFocusedElements = [];
function $1923ad12705fb717$var$addPreviouslyFocusedElement(element) {
    $1923ad12705fb717$var$previouslyFocusedElements = $1923ad12705fb717$var$previouslyFocusedElements.filter((el)=>el.isConnected);
    let tabbableEl = element;
    if (!tabbableEl || (0, $c51400d9a81fca36$export$651544f548703224)(tabbableEl) === 'body') return;
    if (!(0, $a4b3b7902c9a987d$export$bebd5a1431fec25d)(tabbableEl, $1923ad12705fb717$var$getTabbableOptions())) {
        const tabbableChild = (0, $a4b3b7902c9a987d$export$17100aea90429aa7)(tabbableEl, $1923ad12705fb717$var$getTabbableOptions())[0];
        if (tabbableChild) tabbableEl = tabbableChild;
    }
    $1923ad12705fb717$var$previouslyFocusedElements.push(tabbableEl);
    if ($1923ad12705fb717$var$previouslyFocusedElements.length > $1923ad12705fb717$var$LIST_LIMIT) $1923ad12705fb717$var$previouslyFocusedElements = $1923ad12705fb717$var$previouslyFocusedElements.slice(-$1923ad12705fb717$var$LIST_LIMIT);
}
function $1923ad12705fb717$var$getPreviouslyFocusedElement() {
    return $1923ad12705fb717$var$previouslyFocusedElements.slice().reverse().find((el)=>el.isConnected);
}
const $1923ad12705fb717$var$VisuallyHiddenDismiss = /*#__PURE__*/ $acw62.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ $acw62.createElement("button", $1923ad12705fb717$var$_extends({}, props, {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $1923ad12705fb717$var$HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $1923ad12705fb717$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        'content'
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true } = props;
    const { open: open, refs: refs, nodeId: nodeId, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: { domReference: domReference, floating: floating } } = context;
    const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $85ea27aada64f9e6$export$259ba5ae38188551)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const guards = $1923ad12705fb717$var$supportsInert() ? _guards : true;
    const orderRef = $1923ad12705fb717$var$useLatestRef(order);
    const initialFocusRef = $1923ad12705fb717$var$useLatestRef(initialFocus);
    const returnFocusRef = $1923ad12705fb717$var$useLatestRef(returnFocus);
    const tree = $1923ad12705fb717$export$db0c2a7c7a2a4f69();
    const portalContext = $1923ad12705fb717$var$usePortalContext();
    const startDismissButtonRef = $acw62.useRef(null);
    const endDismissButtonRef = $acw62.useRef(null);
    const preventReturnFocusRef = $acw62.useRef(false);
    const isPointerDownRef = $acw62.useRef(false);
    const isInsidePortal = portalContext != null;
    const getTabbableContent = $acw62.useCallback(function(container) {
        if (container === void 0) container = floating;
        return container ? (0, $a4b3b7902c9a987d$export$17100aea90429aa7)(container, $1923ad12705fb717$var$getTabbableOptions()) : [];
    }, [
        floating
    ]);
    const getTabbableElements = $acw62.useCallback((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === 'reference') return domReference;
            if (floating && type === 'floating') return floating;
            return content;
        }).filter(Boolean).flat();
    }, [
        domReference,
        floating,
        orderRef,
        getTabbableContent
    ]);
    $acw62.useEffect(()=>{
        if (disabled || !modal) return;
        function onKeyDown(event) {
            if (event.key === 'Tab') {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $85ea27aada64f9e6$export$2344b14b097df817)(floating, (0, $85ea27aada64f9e6$export$da980962bd2147a4)((0, $85ea27aada64f9e6$export$f65ca476c09acec0)(floating))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
                const els = getTabbableElements();
                const target = (0, $85ea27aada64f9e6$export$c22522a4dfa48e9c)(event);
                if (orderRef.current[0] === 'reference' && target === domReference) {
                    (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
                    if (event.shiftKey) $1923ad12705fb717$var$enqueueFocus(els[els.length - 1]);
                    else $1923ad12705fb717$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === 'floating' && target === floating && event.shiftKey) {
                    (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
                    $1923ad12705fb717$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $85ea27aada64f9e6$export$f65ca476c09acec0)(floating);
        doc.addEventListener('keydown', onKeyDown);
        return ()=>{
            doc.removeEventListener('keydown', onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $acw62.useEffect(()=>{
        if (disabled || !closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            queueMicrotask(()=>{
                const movedToUnrelatedNode = !((0, $85ea27aada64f9e6$export$2344b14b097df817)(domReference, relatedTarget) || (0, $85ea27aada64f9e6$export$2344b14b097df817)(floating, relatedTarget) || (0, $85ea27aada64f9e6$export$2344b14b097df817)(relatedTarget, floating) || (0, $85ea27aada64f9e6$export$2344b14b097df817)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($1923ad12705fb717$var$createAttribute('focus-guard')) || tree && ($1923ad12705fb717$var$getChildren(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $85ea27aada64f9e6$export$2344b14b097df817)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $85ea27aada64f9e6$export$2344b14b097df817)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || $1923ad12705fb717$var$getAncestors(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4;
                    return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
                })));
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if (relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $1923ad12705fb717$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event);
                }
            });
        }
        if (floating && (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(domReference)) {
            domReference.addEventListener('focusout', handleFocusOutside);
            domReference.addEventListener('pointerdown', handlePointerDown);
            !modal && floating.addEventListener('focusout', handleFocusOutside);
            return ()=>{
                domReference.removeEventListener('focusout', handleFocusOutside);
                domReference.removeEventListener('pointerdown', handlePointerDown);
                !modal && floating.removeEventListener('focusout', handleFocusOutside);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        nodeId,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut
    ]);
    $acw62.useEffect(()=>{
        var _portalContext$portal;
        if (disabled) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $1923ad12705fb717$var$createAttribute('portal') + "]")) || []);
        if (floating) {
            const insideElements = [
                floating,
                ...portalNodes,
                startDismissButtonRef.current,
                endDismissButtonRef.current,
                orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null
            ].filter((x)=>x != null);
            const cleanup = modal || isUntrappedTypeableCombobox ? $1923ad12705fb717$var$markOthers(insideElements, guards, !guards) : $1923ad12705fb717$var$markOthers(insideElements);
            return ()=>{
                cleanup();
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards
    ]);
    $1923ad12705fb717$var$index(()=>{
        if (disabled || !floating) return;
        const doc = (0, $85ea27aada64f9e6$export$f65ca476c09acec0)(floating);
        const previouslyFocusedElement = (0, $85ea27aada64f9e6$export$da980962bd2147a4)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floating);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floating;
            const focusAlreadyInsideFloatingEl = (0, $85ea27aada64f9e6$export$2344b14b097df817)(floating, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $1923ad12705fb717$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floating
            });
        });
    }, [
        disabled,
        open,
        floating,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    $1923ad12705fb717$var$index(()=>{
        if (disabled || !floating) return;
        let preventReturnFocusScroll = false;
        const doc = (0, $85ea27aada64f9e6$export$f65ca476c09acec0)(floating);
        const previouslyFocusedElement = (0, $85ea27aada64f9e6$export$da980962bd2147a4)(doc);
        const contextData = dataRef.current;
        let openEvent = contextData.openEvent;
        $1923ad12705fb717$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { open: open, reason: reason, event: event, nested: nested } = _ref;
            if (open) openEvent = event;
            if (reason === 'escape-key' && refs.domReference.current) $1923ad12705fb717$var$addPreviouslyFocusedElement(refs.domReference.current);
            if (reason === 'hover' && event.type === 'mouseleave') preventReturnFocusRef.current = true;
            if (reason !== 'outside-press') return;
            if (nested) {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = true;
            } else preventReturnFocusRef.current = !((0, $85ea27aada64f9e6$export$60278871457622de)(event) || (0, $85ea27aada64f9e6$export$29bf1b5f2c56cf63)(event));
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
            const activeEl = (0, $85ea27aada64f9e6$export$da980962bd2147a4)(doc);
            const isFocusInsideFloatingTree = (0, $85ea27aada64f9e6$export$2344b14b097df817)(floating, activeEl) || tree && $1923ad12705fb717$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
                var _node$context5;
                return (0, $85ea27aada64f9e6$export$2344b14b097df817)((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
            });
            const shouldFocusReference = isFocusInsideFloatingTree || openEvent && [
                'click',
                'mousedown'
            ].includes(openEvent.type);
            if (shouldFocusReference && refs.domReference.current) $1923ad12705fb717$var$addPreviouslyFocusedElement(refs.domReference.current);
            const returnElement = $1923ad12705fb717$var$getPreviouslyFocusedElement();
            if (// eslint-disable-next-line react-hooks/exhaustive-deps
            returnFocusRef.current && !preventReturnFocusRef.current && (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(returnElement) && // If the focus moved somewhere else after mount, avoid returning focus
            // since it likely entered a different element which should be
            // respected: https://github.com/floating-ui/floating-ui/issues/2607
            (returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) $1923ad12705fb717$var$enqueueFocus(returnElement, {
                // When dismissing nested floating elements, by the time the rAF has
                // executed, the menus will all have been unmounted. When they try
                // to get focused, the calls get ignored — leaving the root
                // reference focused as desired.
                cancelPrevious: false,
                preventScroll: preventReturnFocusScroll
            });
        };
    }, [
        disabled,
        floating,
        returnFocusRef,
        dataRef,
        refs,
        events,
        tree,
        nodeId
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    $1923ad12705fb717$var$index(()=>{
        if (disabled || !portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            refs: refs
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        refs,
        closeOnFocusOut
    ]);
    $1923ad12705fb717$var$index(()=>{
        if (disabled || !floating || typeof MutationObserver !== 'function' || ignoreInitialFocus) return;
        const handleMutation = ()=>{
            const tabIndex = floating.getAttribute('tabindex');
            if (orderRef.current.includes('floating') || (0, $85ea27aada64f9e6$export$da980962bd2147a4)((0, $85ea27aada64f9e6$export$f65ca476c09acec0)(floating)) !== refs.domReference.current && getTabbableContent().length === 0) {
                if (tabIndex !== '0') floating.setAttribute('tabindex', '0');
            } else if (tabIndex !== '-1') floating.setAttribute('tabindex', '-1');
        };
        handleMutation();
        const observer = new MutationObserver(handleMutation);
        observer.observe(floating, {
            childList: true,
            subtree: true,
            attributes: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        disabled,
        floating,
        refs,
        orderRef,
        getTabbableContent,
        ignoreInitialFocus
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ $acw62.createElement($1923ad12705fb717$var$VisuallyHiddenDismiss, {
            ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent)
        }, typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss');
    }
    const shouldRenderGuards = !disabled && guards && (isInsidePortal || modal);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, shouldRenderGuards && /*#__PURE__*/ $acw62.createElement($1923ad12705fb717$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
        onFocus: (event)=>{
            if (modal) {
                const els = getTabbableElements();
                $1923ad12705fb717$var$enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
            } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = false;
                if ($1923ad12705fb717$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const nextTabbable = $1923ad12705fb717$var$getNextTabbable() || domReference;
                    nextTabbable == null || nextTabbable.focus();
                } else {
                    var _portalContext$before;
                    (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                }
            }
        }
    }), !isUntrappedTypeableCombobox && renderDismissButton('start'), children, renderDismissButton('end'), shouldRenderGuards && /*#__PURE__*/ $acw62.createElement($1923ad12705fb717$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
        onFocus: (event)=>{
            if (modal) $1923ad12705fb717$var$enqueueFocus(getTabbableElements()[0]);
            else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                if (closeOnFocusOut) preventReturnFocusRef.current = true;
                if ($1923ad12705fb717$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const prevTabbable = $1923ad12705fb717$var$getPreviousTabbable() || domReference;
                    prevTabbable == null || prevTabbable.focus();
                } else {
                    var _portalContext$afterO;
                    (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                }
            }
        }
    }));
}
const $1923ad12705fb717$var$activeLocks = /*#__PURE__*/ new Set();
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $1923ad12705fb717$export$a35954495955337b = /*#__PURE__*/ $acw62.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    const lockId = $1923ad12705fb717$export$f680877a34711e37();
    $1923ad12705fb717$var$index(()=>{
        if (!lockScroll) return;
        $1923ad12705fb717$var$activeLocks.add(lockId);
        const isIOS = /iP(hone|ad|od)|iOS/.test((0, $85ea27aada64f9e6$export$867a782338812cb4)());
        const bodyStyle = document.body.style;
        // RTL <body> scrollbar
        const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
        const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.pageXOffset;
        const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.pageYOffset;
        bodyStyle.overflow = 'hidden';
        if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
        // Only iOS doesn't respect `overflow: hidden` on document.body, and this
        // technique has fewer side effects.
        if (isIOS) {
            var _window$visualViewpor, _window$visualViewpor2;
            // iOS 12 does not support `visualViewport`.
            const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
            const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
            Object.assign(bodyStyle, {
                position: 'fixed',
                top: -(scrollY - Math.floor(offsetTop)) + "px",
                left: -(scrollX - Math.floor(offsetLeft)) + "px",
                right: '0'
            });
        }
        return ()=>{
            $1923ad12705fb717$var$activeLocks.delete(lockId);
            if ($1923ad12705fb717$var$activeLocks.size === 0) {
                Object.assign(bodyStyle, {
                    overflow: '',
                    [paddingProp]: ''
                });
                if (isIOS) {
                    Object.assign(bodyStyle, {
                        position: '',
                        top: '',
                        left: '',
                        right: ''
                    });
                    window.scrollTo(scrollX, scrollY);
                }
            }
        };
    }, [
        lockId,
        lockScroll
    ]);
    return /*#__PURE__*/ $acw62.createElement("div", $1923ad12705fb717$var$_extends({
        ref: ref
    }, rest, {
        style: {
            position: 'fixed',
            overflow: 'auto',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    }));
});
function $1923ad12705fb717$var$isButtonTarget(event) {
    return (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(event.target) && event.target.tagName === 'BUTTON';
}
function $1923ad12705fb717$var$isSpaceIgnored(element) {
    return (0, $85ea27aada64f9e6$export$42ad131c32f0fb8d)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $1923ad12705fb717$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = 'click', toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true } = props;
    const pointerTypeRef = $acw62.useRef();
    const didKeyDownRef = $acw62.useRef(false);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        return {
            reference: {
                onPointerDown (event) {
                    pointerTypeRef.current = event.pointerType;
                },
                onMouseDown (event) {
                    // Ignore all buttons except for the "main" button.
                    // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                    if (event.button !== 0) return;
                    if ((0, $85ea27aada64f9e6$export$81cf264172d31e51)(pointerTypeRef.current, true) && ignoreMouse) return;
                    if (eventOption === 'click') return;
                    if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'mousedown' : true)) onOpenChange(false, event.nativeEvent, 'click');
                    else {
                        // Prevent stealing focus from the floating element
                        event.preventDefault();
                        onOpenChange(true, event.nativeEvent, 'click');
                    }
                },
                onClick (event) {
                    if (eventOption === 'mousedown' && pointerTypeRef.current) {
                        pointerTypeRef.current = undefined;
                        return;
                    }
                    if ((0, $85ea27aada64f9e6$export$81cf264172d31e51)(pointerTypeRef.current, true) && ignoreMouse) return;
                    if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'click' : true)) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                },
                onKeyDown (event) {
                    pointerTypeRef.current = undefined;
                    if (event.defaultPrevented || !keyboardHandlers || $1923ad12705fb717$var$isButtonTarget(event)) return;
                    if (event.key === ' ' && !$1923ad12705fb717$var$isSpaceIgnored(domReference)) {
                        // Prevent scrolling
                        event.preventDefault();
                        didKeyDownRef.current = true;
                    }
                    if (event.key === 'Enter') {
                        if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                        else onOpenChange(true, event.nativeEvent, 'click');
                    }
                },
                onKeyUp (event) {
                    if (event.defaultPrevented || !keyboardHandlers || $1923ad12705fb717$var$isButtonTarget(event) || $1923ad12705fb717$var$isSpaceIgnored(domReference)) return;
                    if (event.key === ' ' && didKeyDownRef.current) {
                        didKeyDownRef.current = false;
                        if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                        else onOpenChange(true, event.nativeEvent, 'click');
                    }
                }
            }
        };
    }, [
        enabled,
        dataRef,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        domReference,
        toggle,
        open,
        onOpenChange
    ]);
}
function $1923ad12705fb717$var$createVirtualElement(domRef, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domRef.current || undefined,
        getBoundingClientRect () {
            var _domRef$current, _data$dataRef$current;
            const domRect = ((_domRef$current = domRef.current) == null ? void 0 : _domRef$current.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === 'x' || data.axis === 'both';
            const isYAxis = data.axis === 'y' || data.axis === 'both';
            const canTrackCursorOnAutoUpdate = [
                'mouseenter',
                'mousemove'
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === 'y' ? domRect.width : 0;
                height = data.axis === 'x' ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === 'x' ? domRect.height : height;
                width = data.axis === 'y' ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $1923ad12705fb717$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $1923ad12705fb717$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, refs: refs, dataRef: dataRef, elements: { floating: floating } } = context;
    const { enabled: enabled = true, axis: axis = 'both', x: x = null, y: y = null } = props;
    const initialRef = $acw62.useRef(false);
    const cleanupListenerRef = $acw62.useRef(null);
    const [pointerType, setPointerType] = $acw62.useState();
    const [reactive, setReactive] = $acw62.useState([]);
    const setReference = $1923ad12705fb717$var$useEffectEvent((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$1923ad12705fb717$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($1923ad12705fb717$var$createVirtualElement(refs.domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = $1923ad12705fb717$var$useEffectEvent((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $85ea27aada64f9e6$export$81cf264172d31e51)(pointerType) ? floating : open;
    const addListener = $acw62.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(refs.floating.current);
        function handleMouseMove(event) {
            const target = (0, $85ea27aada64f9e6$export$c22522a4dfa48e9c)(event);
            if (!(0, $85ea27aada64f9e6$export$2344b14b097df817)(refs.floating.current, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $1923ad12705fb717$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener('mousemove', handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(refs.domReference.current);
    }, [
        dataRef,
        enabled,
        openCheck,
        refs,
        setReference,
        x,
        y
    ]);
    $acw62.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $acw62.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $acw62.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    $1923ad12705fb717$var$index(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            reference: {
                onPointerDown: setPointerTypeRef,
                onPointerEnter: setPointerTypeRef,
                onMouseMove: handleReferenceEnterOrMove,
                onMouseEnter: handleReferenceEnterOrMove
            }
        };
    }, [
        enabled,
        handleReferenceEnterOrMove
    ]);
}
const $1923ad12705fb717$var$bubbleHandlerKeys = {
    pointerdown: 'onPointerDown',
    mousedown: 'onMouseDown',
    click: 'onClick'
};
const $1923ad12705fb717$var$captureHandlerKeys = {
    pointerdown: 'onPointerDownCapture',
    mousedown: 'onMouseDownCapture',
    click: 'onClickCapture'
};
const $1923ad12705fb717$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $1923ad12705fb717$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, nodeId: nodeId, elements: { reference: reference, domReference: domReference, floating: floating }, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = 'pointerdown', referencePress: referencePress = false, referencePressEvent: referencePressEvent = 'pointerdown', ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $1923ad12705fb717$export$db0c2a7c7a2a4f69();
    const outsidePressFn = $1923ad12705fb717$var$useEffectEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
    const insideReactTreeRef = $acw62.useRef(false);
    const endedOrStartedInsideRef = $acw62.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $1923ad12705fb717$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $1923ad12705fb717$var$normalizeProp(capture);
    const closeOnEscapeKeyDown = $1923ad12705fb717$var$useEffectEvent((event)=>{
        if (!open || !enabled || !escapeKey || event.key !== 'Escape') return;
        const children = tree ? $1923ad12705fb717$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $85ea27aada64f9e6$export$94781ce41a161222)(event) ? event.nativeEvent : event, 'escape-key');
    });
    const closeOnEscapeKeyDownCapture = $1923ad12705fb717$var$useEffectEvent((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $85ea27aada64f9e6$export$c22522a4dfa48e9c)(event)) == null || _getTarget.removeEventListener('keydown', callback);
        };
        (_getTarget2 = (0, $85ea27aada64f9e6$export$c22522a4dfa48e9c)(event)) == null || _getTarget2.addEventListener('keydown', callback);
    });
    const closeOnPressOutside = $1923ad12705fb717$var$useEffectEvent((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === 'click' && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === 'function' && !outsidePress(event)) return;
        const target = (0, $85ea27aada64f9e6$export$c22522a4dfa48e9c)(event);
        const inertSelector = "[" + $1923ad12705fb717$var$createAttribute('inert') + "]";
        const markers = (0, $85ea27aada64f9e6$export$f65ca476c09acec0)(floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(target) ? target : null;
        while(targetRootAncestor && !(0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(targetRootAncestor)){
            const nextParent = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(targetRootAncestor);
            if ((0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(nextParent) || !(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(target) && !(0, $85ea27aada64f9e6$export$7b296c28e0fa3aed)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $85ea27aada64f9e6$export$2344b14b097df817)(target, floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $85ea27aada64f9e6$export$2344b14b097df817)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(target) && floating) {
            // In Firefox, `target.scrollWidth > target.clientWidth` for inline
            // elements.
            const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            let xCond = canScrollY && event.offsetX > target.clientWidth;
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            if (canScrollY) {
                const isRTL = (0, $c51400d9a81fca36$export$3735103072e4a80)(target).direction === 'rtl';
                if (isRTL) xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
            }
            if (xCond || canScrollX && event.offsetY > target.clientHeight) return;
        }
        const targetIsInsideChildren = tree && $1923ad12705fb717$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $85ea27aada64f9e6$export$43c3154d5bf2c6c2)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $85ea27aada64f9e6$export$43c3154d5bf2c6c2)(event, floating) || (0, $85ea27aada64f9e6$export$43c3154d5bf2c6c2)(event, domReference) || targetIsInsideChildren) return;
        const children = tree ? $1923ad12705fb717$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, 'outside-press');
    });
    const closeOnPressOutsideCapture = $1923ad12705fb717$var$useEffectEvent((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $85ea27aada64f9e6$export$c22522a4dfa48e9c)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $85ea27aada64f9e6$export$c22522a4dfa48e9c)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $acw62.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        function onScroll(event) {
            onOpenChange(false, event, 'ancestor-scroll');
        }
        const doc = (0, $85ea27aada64f9e6$export$f65ca476c09acec0)(floating);
        escapeKey && doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(domReference)) ancestors = (0, $c51400d9a81fca36$export$3b57c1601291186b)(domReference);
            if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(floating)) ancestors = ancestors.concat((0, $c51400d9a81fca36$export$3b57c1601291186b)(floating));
            if (!(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(reference) && reference && reference.contextElement) ancestors = ancestors.concat((0, $c51400d9a81fca36$export$3b57c1601291186b)(reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener('scroll', onScroll, {
                passive: true
            });
        });
        return ()=>{
            escapeKey && doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener('scroll', onScroll);
            });
        };
    }, [
        dataRef,
        floating,
        domReference,
        reference,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $acw62.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        return {
            reference: {
                onKeyDown: closeOnEscapeKeyDown,
                [$1923ad12705fb717$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                    if (referencePress) onOpenChange(false, event.nativeEvent, 'reference-press');
                }
            },
            floating: {
                onKeyDown: closeOnEscapeKeyDown,
                onMouseDown () {
                    endedOrStartedInsideRef.current = true;
                },
                onMouseUp () {
                    endedOrStartedInsideRef.current = true;
                },
                [$1923ad12705fb717$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                    insideReactTreeRef.current = true;
                }
            }
        };
    }, [
        enabled,
        referencePress,
        outsidePressEvent,
        referencePressEvent,
        onOpenChange,
        closeOnEscapeKeyDown
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $1923ad12705fb717$export$4e02a5c1d08bac65(options) {
    var _options$elements;
    if (options === void 0) options = {};
    const { open: open = false, onOpenChange: unstable_onOpenChange, nodeId: nodeId } = options;
    const [_domReference, setDomReference] = $acw62.useState(null);
    const [positionReference, _setPositionReference] = $acw62.useState(null);
    const optionDomReference = (_options$elements = options.elements) == null ? void 0 : _options$elements.reference;
    const domReference = optionDomReference || _domReference;
    $1923ad12705fb717$var$index(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $a4fc732b2bdc2bd6$export$4e02a5c1d08bac65)({
        ...options,
        elements: {
            ...options.elements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const tree = $1923ad12705fb717$export$db0c2a7c7a2a4f69();
    const nested = $1923ad12705fb717$export$165209eae06d3488() != null;
    const onOpenChange = $1923ad12705fb717$var$useEffectEvent((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit('openchange', {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        unstable_onOpenChange == null || unstable_onOpenChange(open, event, reason);
    });
    const domReferenceRef = $acw62.useRef(null);
    const dataRef = $acw62.useRef({});
    const events = $acw62.useState(()=>$1923ad12705fb717$var$createPubSub())[0];
    const floatingId = $1923ad12705fb717$export$f680877a34711e37();
    const setPositionReference = $acw62.useCallback((node)=>{
        const computedPositionReference = (0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $acw62.useCallback((node)=>{
        if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $acw62.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $acw62.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $acw62.useMemo(()=>({
            ...position,
            refs: refs,
            elements: elements,
            dataRef: dataRef,
            nodeId: nodeId,
            floatingId: floatingId,
            events: events,
            open: open,
            onOpenChange: onOpenChange
        }), [
        position,
        nodeId,
        floatingId,
        events,
        open,
        onOpenChange,
        refs,
        elements
    ]);
    $1923ad12705fb717$var$index(()=>{
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $acw62.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $1923ad12705fb717$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, refs: refs, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $acw62.useRef(false);
    const timeoutRef = $acw62.useRef();
    const keyboardModalityRef = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(domReference) && domReference === (0, $85ea27aada64f9e6$export$da980962bd2147a4)((0, $85ea27aada64f9e6$export$f65ca476c09acec0)(domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        win.addEventListener('blur', onBlur);
        win.addEventListener('keydown', onKeyDown, true);
        return ()=>{
            win.removeEventListener('blur', onBlur);
            win.removeEventListener('keydown', onKeyDown, true);
        };
    }, [
        domReference,
        open,
        enabled
    ]);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === 'reference-press' || reason === 'escape-key') blockFocusRef.current = true;
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        return {
            reference: {
                onPointerDown (event) {
                    if ((0, $85ea27aada64f9e6$export$29bf1b5f2c56cf63)(event.nativeEvent)) return;
                    keyboardModalityRef.current = false;
                },
                onMouseLeave () {
                    blockFocusRef.current = false;
                },
                onFocus (event) {
                    if (blockFocusRef.current) return;
                    const target = (0, $85ea27aada64f9e6$export$c22522a4dfa48e9c)(event.nativeEvent);
                    if (visibleOnly && (0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(target)) try {
                        // Mac Safari unreliably matches `:focus-visible` on the reference
                        // if focus was outside the page initially - use the fallback
                        // instead.
                        if ((0, $85ea27aada64f9e6$export$95df08bae54cb4df)() && (0, $85ea27aada64f9e6$export$9ac100e40613ea10)()) throw Error();
                        if (!target.matches(':focus-visible')) return;
                    } catch (e) {
                        // Old browsers will throw an error when using `:focus-visible`.
                        if (!keyboardModalityRef.current && !(0, $85ea27aada64f9e6$export$42ad131c32f0fb8d)(target)) return;
                    }
                    onOpenChange(true, event.nativeEvent, 'focus');
                },
                onBlur (event) {
                    blockFocusRef.current = false;
                    const relatedTarget = event.relatedTarget;
                    // Hit the non-modal focus management portal guard. Focus will be
                    // moved into the floating element immediately after.
                    const movedToFocusGuard = (0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(relatedTarget) && relatedTarget.hasAttribute($1923ad12705fb717$var$createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';
                    // Wait for the window blur listener to fire.
                    timeoutRef.current = window.setTimeout(()=>{
                        const activeEl = (0, $85ea27aada64f9e6$export$da980962bd2147a4)(domReference ? domReference.ownerDocument : document);
                        // Focus left the page, keep it open.
                        if (!relatedTarget && activeEl === domReference) return;
                        // When focusing the reference element (e.g. regular click), then
                        // clicking into the floating element, prevent it from hiding.
                        // Note: it must be focusable, e.g. `tabindex="-1"`.
                        // We can not rely on relatedTarget to point to the correct element
                        // as it will only point to the shadow host of the newly focused element
                        // and not the element that actually has received focus if it is located
                        // inside a shadow root.
                        if ((0, $85ea27aada64f9e6$export$2344b14b097df817)(refs.floating.current, activeEl) || (0, $85ea27aada64f9e6$export$2344b14b097df817)(domReference, activeEl) || movedToFocusGuard) return;
                        onOpenChange(false, event.nativeEvent, 'focus');
                    });
                }
            }
        };
    }, [
        enabled,
        visibleOnly,
        domReference,
        refs,
        onOpenChange
    ]);
}
const $1923ad12705fb717$var$ACTIVE_KEY = 'active';
const $1923ad12705fb717$var$SELECTED_KEY = 'selected';
function $1923ad12705fb717$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === 'item';
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$1923ad12705fb717$var$ACTIVE_KEY]: _, [$1923ad12705fb717$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === 'floating' && {
            tabIndex: -1
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === 'function') return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $1923ad12705fb717$var$ACTIVE_KEY,
                    $1923ad12705fb717$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf('on') === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === 'function') {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $1923ad12705fb717$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    // The dependencies are a dynamic array, so we can't use the linter's
    // suggestion to add it to the deps array.
    const deps = propsList;
    const getReferenceProps = $acw62.useCallback((userProps)=>$1923ad12705fb717$var$mergeProps(userProps, propsList, 'reference'), // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
    const getFloatingProps = $acw62.useCallback((userProps)=>$1923ad12705fb717$var$mergeProps(userProps, propsList, 'floating'), // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
    const getItemProps = $acw62.useCallback((userProps)=>$1923ad12705fb717$var$mergeProps(userProps, propsList, 'item'), // Granularly check for `item` changes, because the `getItemProps` getter
    // should be as referentially stable as possible since it may be passed as
    // a prop to many components. All `item` key values must therefore be
    // memoized.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    propsList.map((key)=>key == null ? void 0 : key.item));
    return $acw62.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
let $1923ad12705fb717$var$isPreventScrollSupported = false;
function $1923ad12705fb717$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case 'vertical':
            return vertical;
        case 'horizontal':
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $1923ad12705fb717$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $1923ad12705fb717$var$ARROW_UP || key === $1923ad12705fb717$var$ARROW_DOWN;
    const horizontal = key === $1923ad12705fb717$var$ARROW_LEFT || key === $1923ad12705fb717$var$ARROW_RIGHT;
    return $1923ad12705fb717$var$doSwitch(orientation, vertical, horizontal);
}
function $1923ad12705fb717$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $1923ad12705fb717$var$ARROW_DOWN;
    const horizontal = rtl ? key === $1923ad12705fb717$var$ARROW_LEFT : key === $1923ad12705fb717$var$ARROW_RIGHT;
    return $1923ad12705fb717$var$doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function $1923ad12705fb717$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $1923ad12705fb717$var$ARROW_LEFT : key === $1923ad12705fb717$var$ARROW_RIGHT;
    const horizontal = key === $1923ad12705fb717$var$ARROW_DOWN;
    return $1923ad12705fb717$var$doSwitch(orientation, vertical, horizontal);
}
function $1923ad12705fb717$var$isCrossOrientationCloseKey(key, orientation, rtl) {
    const vertical = rtl ? key === $1923ad12705fb717$var$ARROW_RIGHT : key === $1923ad12705fb717$var$ARROW_LEFT;
    const horizontal = key === $1923ad12705fb717$var$ARROW_UP;
    return $1923ad12705fb717$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $1923ad12705fb717$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, refs: refs, elements: { domReference: domReference, floating: floating } } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = 'auto', focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = 'vertical', cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const parentId = $1923ad12705fb717$export$165209eae06d3488();
    const tree = $1923ad12705fb717$export$db0c2a7c7a2a4f69();
    const onNavigate = $1923ad12705fb717$var$useEffectEvent(unstable_onNavigate);
    const focusItemOnOpenRef = $acw62.useRef(focusItemOnOpen);
    const indexRef = $acw62.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $acw62.useRef(null);
    const isPointerModalityRef = $acw62.useRef(true);
    const previousOnNavigateRef = $acw62.useRef(onNavigate);
    const previousMountedRef = $acw62.useRef(!!floating);
    const forceSyncFocus = $acw62.useRef(false);
    const forceScrollIntoViewRef = $acw62.useRef(false);
    const disabledIndicesRef = $1923ad12705fb717$var$useLatestRef(disabledIndices);
    const latestOpenRef = $1923ad12705fb717$var$useLatestRef(open);
    const scrollItemIntoViewRef = $1923ad12705fb717$var$useLatestRef(scrollItemIntoView);
    const [activeId, setActiveId] = $acw62.useState();
    const [virtualId, setVirtualId] = $acw62.useState();
    const focusItem = $1923ad12705fb717$var$useEffectEvent(function(listRef, indexRef, forceScrollIntoView) {
        if (forceScrollIntoView === void 0) forceScrollIntoView = false;
        const item = listRef.current[indexRef.current];
        if (!item) return;
        if (virtual) {
            setActiveId(item.id);
            tree == null || tree.events.emit('virtualfocus', item);
            if (virtualItemRef) virtualItemRef.current = item;
        } else $1923ad12705fb717$var$enqueueFocus(item, {
            preventScroll: true,
            // Mac Safari does not move the virtual cursor unless the focus call
            // is sync. However, for the very first focus call, we need to wait
            // for the position to be ready in order to prevent unwanted
            // scrolling. This means the virtual cursor will not move to the first
            // item when first opening the floating element, but will on
            // subsequent calls. `preventScroll` is supported in modern Safari,
            // so we can use that instead.
            // iOS Safari must be async or the first item will not be focused.
            sync: (0, $85ea27aada64f9e6$export$9ac100e40613ea10)() && (0, $85ea27aada64f9e6$export$95df08bae54cb4df)() ? $1923ad12705fb717$var$isPreventScrollSupported || forceSyncFocus.current : false
        });
        requestAnimationFrame(()=>{
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            item.scrollIntoView == null || item.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
                block: 'nearest',
                inline: 'nearest'
            } : scrollIntoViewOptions);
        });
    });
    $1923ad12705fb717$var$index(()=>{
        document.createElement('div').focus({
            get preventScroll () {
                $1923ad12705fb717$var$isPreventScrollSupported = true;
                return false;
            }
        });
    }, []);
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    $1923ad12705fb717$var$index(()=>{
        if (!enabled) return;
        if (open && floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate(selectedIndex);
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current(null);
        }
    }, [
        enabled,
        open,
        floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    $1923ad12705fb717$var$index(()=>{
        if (!enabled) return;
        if (open && floating) {
            if (activeIndex == null) {
                forceSyncFocus.current = false;
                if (selectedIndex != null) return;
                // Reset while the floating element was open (e.g. the list changed).
                if (previousMountedRef.current) {
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                }
                // Initial sync.
                if (!previousMountedRef.current && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                    let runs = 0;
                    const waitForListPopulated = ()=>{
                        if (listRef.current[0] == null) {
                            // Avoid letting the browser paint if possible on the first try,
                            // otherwise use rAF. Don't try more than twice, since something
                            // is wrong otherwise.
                            if (runs < 2) {
                                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                                scheduler(waitForListPopulated);
                            }
                            runs++;
                        } else {
                            indexRef.current = keyRef.current == null || $1923ad12705fb717$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? $1923ad12705fb717$var$getMinIndex(listRef, disabledIndicesRef.current) : $1923ad12705fb717$var$getMaxIndex(listRef, disabledIndicesRef.current);
                            keyRef.current = null;
                            onNavigate(indexRef.current);
                        }
                    };
                    waitForListPopulated();
                }
            } else if (!$1923ad12705fb717$var$isIndexOutOfBounds(listRef, activeIndex)) {
                indexRef.current = activeIndex;
                focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
                forceScrollIntoViewRef.current = false;
            }
        }
    }, [
        enabled,
        open,
        floating,
        activeIndex,
        selectedIndex,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    $1923ad12705fb717$var$index(()=>{
        var _nodes$find;
        if (!enabled || floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $85ea27aada64f9e6$export$da980962bd2147a4)((0, $85ea27aada64f9e6$export$f65ca476c09acec0)(floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $85ea27aada64f9e6$export$2344b14b097df817)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        floating,
        tree,
        parentId,
        virtual
    ]);
    $1923ad12705fb717$var$index(()=>{
        if (!enabled || !tree || !virtual || parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on('virtualfocus', handleVirtualFocus);
        return ()=>{
            tree.events.off('virtualfocus', handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    $1923ad12705fb717$var$index(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousMountedRef.current = !!floating;
    });
    $1923ad12705fb717$var$index(()=>{
        if (!open) keyRef.current = null;
    }, [
        open
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $acw62.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!open) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1) onNavigate(index);
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            ...focusItemOnHover && {
                onMouseMove (_ref3) {
                    let { currentTarget: currentTarget } = _ref3;
                    syncCurrentTarget(currentTarget);
                },
                onPointerLeave (_ref4) {
                    let { pointerType: pointerType } = _ref4;
                    if (!isPointerModalityRef.current || pointerType === 'touch') return;
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                    onNavigate(null);
                    if (!virtual) $1923ad12705fb717$var$enqueueFocus(refs.floating.current, {
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        open,
        refs,
        focusItem,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        const disabledIndices = disabledIndicesRef.current;
        function onKeyDown(event) {
            isPointerModalityRef.current = false;
            forceSyncFocus.current = true;
            // If the floating element is animating out, ignore navigation. Otherwise,
            // the `activeIndex` gets set to 0 despite not being open so the next time
            // the user ArrowDowns, the first item won't be focused.
            if (!latestOpenRef.current && event.currentTarget === refs.floating.current) return;
            if (nested && $1923ad12705fb717$var$isCrossOrientationCloseKey(event.key, orientation, rtl)) {
                (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
                onOpenChange(false, event.nativeEvent, 'list-navigation');
                if ((0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(domReference) && !virtual) domReference.focus();
                return;
            }
            const currentIndex = indexRef.current;
            const minIndex = $1923ad12705fb717$var$getMinIndex(listRef, disabledIndices);
            const maxIndex = $1923ad12705fb717$var$getMaxIndex(listRef, disabledIndices);
            if (event.key === 'Home') {
                (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
                indexRef.current = minIndex;
                onNavigate(indexRef.current);
            }
            if (event.key === 'End') {
                (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
                indexRef.current = maxIndex;
                onNavigate(indexRef.current);
            }
            // Grid navigation.
            if (cols > 1) {
                const sizes = itemSizes || Array.from({
                    length: listRef.current.length
                }, ()=>({
                        width: 1,
                        height: 1
                    }));
                // To calculate movements on the grid, we use hypothetical cell indices
                // as if every item was 1x1, then convert back to real indices.
                const cellMap = $1923ad12705fb717$var$buildCellMap(sizes, cols, dense);
                const minGridIndex = cellMap.findIndex((index)=>index != null && !(disabledIndices != null && disabledIndices.includes(index)));
                // last enabled index
                const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(disabledIndices != null && disabledIndices.includes(index)) ? cellIndex : foundIndex, -1);
                indexRef.current = cellMap[$1923ad12705fb717$var$getGridNavigatedIndex({
                    current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
                }, {
                    event: event,
                    orientation: orientation,
                    loop: loop,
                    cols: cols,
                    // treat undefined (empty grid spaces) as disabled indices so we
                    // don't end up in them
                    disabledIndices: $1923ad12705fb717$var$getCellIndices([
                        ...disabledIndices || [],
                        undefined
                    ], cellMap),
                    minIndex: minGridIndex,
                    maxIndex: maxGridIndex,
                    prevIndex: $1923ad12705fb717$var$getCellIndexOfCorner(indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                    // we're moving in so we don't end up in the same item. Prefer
                    // top/left over bottom/right.
                    event.key === $1923ad12705fb717$var$ARROW_DOWN ? 'bl' : event.key === $1923ad12705fb717$var$ARROW_RIGHT ? 'tr' : 'tl'),
                    stopEvent: true
                })]; // navigated cell will never be nullish
                onNavigate(indexRef.current);
                if (orientation === 'both') return;
            }
            if ($1923ad12705fb717$var$isMainOrientationKey(event.key, orientation)) {
                (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
                // Reset the index if no item is focused.
                if (open && !virtual && (0, $85ea27aada64f9e6$export$da980962bd2147a4)(event.currentTarget.ownerDocument) === event.currentTarget) {
                    indexRef.current = $1923ad12705fb717$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                    onNavigate(indexRef.current);
                    return;
                }
                if ($1923ad12705fb717$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                    if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : $1923ad12705fb717$var$findNonDisabledIndex(listRef, {
                        startingIndex: currentIndex,
                        disabledIndices: disabledIndices
                    });
                    else indexRef.current = Math.min(maxIndex, $1923ad12705fb717$var$findNonDisabledIndex(listRef, {
                        startingIndex: currentIndex,
                        disabledIndices: disabledIndices
                    }));
                } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : $1923ad12705fb717$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.max(minIndex, $1923ad12705fb717$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                }));
                if ($1923ad12705fb717$var$isIndexOutOfBounds(listRef, indexRef.current)) onNavigate(null);
                else onNavigate(indexRef.current);
            }
        }
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === 'auto' && (0, $85ea27aada64f9e6$export$60278871457622de)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === 'auto' && (0, $85ea27aada64f9e6$export$29bf1b5f2c56cf63)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        const ariaActiveDescendantProp = virtual && open && hasActiveIndex && {
            'aria-activedescendant': virtualId || activeId
        };
        const activeItem = listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId);
        return {
            reference: {
                ...ariaActiveDescendantProp,
                onKeyDown (event) {
                    isPointerModalityRef.current = false;
                    const isArrowKey = event.key.indexOf('Arrow') === 0;
                    const isCrossOpenKey = $1923ad12705fb717$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                    const isCrossCloseKey = $1923ad12705fb717$var$isCrossOrientationCloseKey(event.key, orientation, rtl);
                    const isMainKey = $1923ad12705fb717$var$isMainOrientationKey(event.key, orientation);
                    const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
                    if (virtual && open) {
                        const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                        const deepestNode = tree && rootNode ? $1923ad12705fb717$var$getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
                        if (isArrowKey && deepestNode && virtualItemRef) {
                            const eventObject = new KeyboardEvent('keydown', {
                                key: event.key,
                                bubbles: true
                            });
                            if (isCrossOpenKey || isCrossCloseKey) {
                                var _deepestNode$context, _deepestNode$context2;
                                const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                                const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? activeItem : null;
                                if (dispatchItem) {
                                    (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
                                    dispatchItem.dispatchEvent(eventObject);
                                    setVirtualId(undefined);
                                }
                            }
                            if (isMainKey && deepestNode.context) {
                                if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                    var _deepestNode$context$;
                                    (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
                                    (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                    return;
                                }
                            }
                        }
                        return onKeyDown(event);
                    }
                    // If a floating element should not open on arrow key down, avoid
                    // setting `activeIndex` while it's closed.
                    if (!open && !openOnArrowKeyDown && isArrowKey) return;
                    if (isNavigationKey) keyRef.current = nested && isMainKey ? null : event.key;
                    if (nested) {
                        if (isCrossOpenKey) {
                            (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
                            if (open) {
                                indexRef.current = $1923ad12705fb717$var$getMinIndex(listRef, disabledIndices);
                                onNavigate(indexRef.current);
                            } else onOpenChange(true, event.nativeEvent, 'list-navigation');
                        }
                        return;
                    }
                    if (isMainKey) {
                        if (selectedIndex != null) indexRef.current = selectedIndex;
                        (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
                        if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, 'list-navigation');
                        else onKeyDown(event);
                        if (open) onNavigate(indexRef.current);
                    }
                },
                onFocus () {
                    if (open) onNavigate(null);
                },
                onPointerDown: checkVirtualPointer,
                onMouseDown: checkVirtualMouse,
                onClick: checkVirtualMouse
            },
            floating: {
                'aria-orientation': orientation === 'both' ? undefined : orientation,
                ...!(0, $85ea27aada64f9e6$export$259ba5ae38188551)(domReference) && ariaActiveDescendantProp,
                onKeyDown: onKeyDown,
                onPointerMove () {
                    isPointerModalityRef.current = true;
                }
            },
            item: item
        };
    }, [
        domReference,
        refs,
        activeId,
        virtualId,
        disabledIndicesRef,
        latestOpenRef,
        listRef,
        enabled,
        orientation,
        rtl,
        virtual,
        open,
        hasActiveIndex,
        nested,
        selectedIndex,
        openOnArrowKeyDown,
        allowEscape,
        cols,
        loop,
        focusItemOnOpen,
        onNavigate,
        onOpenChange,
        item,
        tree,
        virtualItemRef,
        itemSizes,
        dense
    ]);
}
const $1923ad12705fb717$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        'select',
        'listbox'
    ],
    [
        'combobox',
        'listbox'
    ],
    [
        'label',
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $1923ad12705fb717$export$f66572793fa256a1(context, props) {
    var _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, floatingId: floatingId } = context;
    const { enabled: enabled = true, role: role = 'dialog' } = props;
    const ariaRole = (_componentRoleToAriaR = $1923ad12705fb717$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const referenceId = $1923ad12705fb717$export$f680877a34711e37();
    const parentId = $1923ad12705fb717$export$165209eae06d3488();
    const isNested = parentId != null;
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === 'tooltip' || role === 'label') return {
            reference: {
                ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
            },
            floating: floatingProps
        };
        return {
            reference: {
                'aria-expanded': open ? 'true' : 'false',
                'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
                'aria-controls': open ? floatingId : undefined,
                ...ariaRole === 'listbox' && {
                    role: 'combobox'
                },
                ...ariaRole === 'menu' && {
                    id: referenceId
                },
                ...ariaRole === 'menu' && isNested && {
                    role: 'menuitem'
                },
                ...role === 'select' && {
                    'aria-autocomplete': 'none'
                },
                ...role === 'combobox' && {
                    'aria-autocomplete': 'list'
                }
            },
            floating: {
                ...floatingProps,
                ...ariaRole === 'menu' && {
                    'aria-labelledby': referenceId
                }
            },
            item (_ref) {
                let { active: active, selected: selected } = _ref;
                const commonProps = {
                    role: 'option',
                    ...active && {
                        id: floatingId + "-option"
                    }
                };
                // For `menu`, we are unable to tell if the item is a `menuitemradio`
                // or `menuitemcheckbox`. For backwards-compatibility reasons, also
                // avoid defaulting to `menuitem` as it may overwrite custom role props.
                switch(role){
                    case 'select':
                        return {
                            ...commonProps,
                            'aria-selected': active && selected
                        };
                    case 'combobox':
                        return {
                            ...commonProps,
                            ...active && {
                                'aria-selected': true
                            }
                        };
                }
                return {};
            }
        };
    }, [
        enabled,
        role,
        ariaRole,
        open,
        floatingId,
        referenceId,
        isNested
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $1923ad12705fb717$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? '-' : '') + $.toLowerCase());
function $1923ad12705fb717$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function $1923ad12705fb717$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $acw62.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $acw62.useEffect(()=>{
        if (!open) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $1923ad12705fb717$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === 'number';
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [initiated, setInitiated] = $acw62.useState(false);
    const [status, setStatus] = $acw62.useState('unmounted');
    const isMounted = $1923ad12705fb717$var$useDelayUnmount(open, closeDuration);
    // `initiated` check prevents this `setState` call from breaking
    // <FloatingPortal />. This call is necessary to ensure subsequent opens
    // after the initial one allows the correct side animation to play when the
    // placement has changed.
    $1923ad12705fb717$var$index(()=>{
        if (initiated && !isMounted) setStatus('unmounted');
    }, [
        initiated,
        isMounted
    ]);
    $1923ad12705fb717$var$index(()=>{
        if (!floating) return;
        if (open) {
            setStatus('initial');
            const frame = requestAnimationFrame(()=>{
                setStatus('open');
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setInitiated(true);
        setStatus('close');
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $1923ad12705fb717$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split('-')[0];
    const fnArgs = $acw62.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === 'number';
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $acw62.useState(()=>({
            ...$1923ad12705fb717$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$1923ad12705fb717$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $1923ad12705fb717$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = $1923ad12705fb717$var$useLatestRef(unstable_initial);
    const openRef = $1923ad12705fb717$var$useLatestRef(unstable_open);
    const closeRef = $1923ad12705fb717$var$useLatestRef(unstable_close);
    const commonRef = $1923ad12705fb717$var$useLatestRef(unstable_common);
    $1923ad12705fb717$var$index(()=>{
        const initialStyles = $1923ad12705fb717$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $1923ad12705fb717$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $1923ad12705fb717$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $1923ad12705fb717$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = '';
            return acc;
        }, {});
        if (status === 'initial') setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === 'open') setStyles({
            transitionProperty: Object.keys(openStyles).map($1923ad12705fb717$var$camelCaseToKebabCase).join(','),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === 'close') {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($1923ad12705fb717$var$camelCaseToKebabCase).join(','),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $1923ad12705fb717$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $acw62.useRef();
    const stringRef = $acw62.useRef('');
    const prevIndexRef = $acw62.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $acw62.useRef(null);
    const onMatch = $1923ad12705fb717$var$useEffectEvent(unstable_onMatch);
    const onTypingChange = $1923ad12705fb717$var$useEffectEvent(unstable_onTypingChange);
    const findMatchRef = $1923ad12705fb717$var$useLatestRef(findMatch);
    const ignoreKeysRef = $1923ad12705fb717$var$useLatestRef(ignoreKeys);
    $1923ad12705fb717$var$index(()=>{
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = '';
        }
    }, [
        open
    ]);
    $1923ad12705fb717$var$index(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === '') {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        function setTypingChange(value) {
            if (value) {
                if (!dataRef.current.typing) {
                    dataRef.current.typing = value;
                    onTypingChange(value);
                }
            } else if (dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        }
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        function onKeyDown(event) {
            const listContent = listRef.current;
            if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
                if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
                else if (event.key === ' ') (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
            }
            if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
            event.key.length !== 1 || // Modifier key.
            event.ctrlKey || event.metaKey || event.altKey) return;
            if (open && event.key !== ' ') {
                (0, $85ea27aada64f9e6$export$7ae4cd3a66c1e050)(event);
                setTypingChange(true);
            }
            // Bail out if the list contains a word like "llama" or "aaron". TODO:
            // allow it in this case, too.
            const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
                var _text$, _text$2;
                return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
            });
            // Allows the user to cycle through items that start with the same letter
            // in rapid succession.
            if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
                stringRef.current = '';
                prevIndexRef.current = matchIndexRef.current;
            }
            stringRef.current += event.key;
            clearTimeout(timeoutIdRef.current);
            timeoutIdRef.current = setTimeout(()=>{
                stringRef.current = '';
                prevIndexRef.current = matchIndexRef.current;
                setTypingChange(false);
            }, resetMs);
            const prevIndex = prevIndexRef.current;
            const index = getMatchingIndex(listContent, [
                ...listContent.slice((prevIndex || 0) + 1),
                ...listContent.slice(0, (prevIndex || 0) + 1)
            ], stringRef.current);
            if (index !== -1) {
                onMatch(index);
                matchIndexRef.current = index;
            } else if (event.key !== ' ') {
                stringRef.current = '';
                setTypingChange(false);
            }
        }
        return {
            reference: {
                onKeyDown: onKeyDown
            },
            floating: {
                onKeyDown: onKeyDown,
                onKeyUp (event) {
                    if (event.key === ' ') setTypingChange(false);
                }
            }
        };
    }, [
        enabled,
        open,
        dataRef,
        listRef,
        resetMs,
        ignoreKeysRef,
        findMatchRef,
        onMatch,
        onTypingChange
    ]);
}
function $1923ad12705fb717$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside
 * of it is anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */ const $1923ad12705fb717$export$4ae363f1d88fb658 = (props)=>({
        name: 'inner',
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = props;
            const { rects: rects, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $bede215d88ec3aee$export$cc800923e997bb8)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const el = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            const overflow = await (0, $bede215d88ec3aee$export$37b6bde19b108ecc)($1923ad12705fb717$var$getArgsWithCustomFloatingHeight(nextArgs, el.scrollHeight), detectOverflowOptions);
            const refOverflow = await (0, $bede215d88ec3aee$export$37b6bde19b108ecc)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: 'reference'
            });
            const diffY = Math.max(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const maxHeight = Math.max(0, el.scrollHeight - diffY - Math.max(0, overflow.bottom));
            el.style.maxHeight = maxHeight + "px";
            el.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                if (el.offsetHeight < item.offsetHeight * Math.min(minItemsVisible, listRef.current.length - 1) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold) (0, $11492dca620dcaa5$exports.flushSync)(()=>onFallbackChange(true));
                else (0, $11492dca620dcaa5$exports.flushSync)(()=>onFallbackChange(false));
            }
            if (overflowRef) overflowRef.current = await (0, $bede215d88ec3aee$export$37b6bde19b108ecc)($1923ad12705fb717$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, el.offsetHeight), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */ function $1923ad12705fb717$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = $1923ad12705fb717$var$useEffectEvent(unstable_onChange);
    const controlledScrollingRef = $acw62.useRef(false);
    const prevScrollTopRef = $acw62.useRef(null);
    const initialOverflowRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? 'max' : 'min';
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                (0, $11492dca620dcaa5$exports.flushSync)(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $85ea27aada64f9e6$export$7935961ef7719cb0)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener('wheel', onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener('wheel', onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        return {
            floating: {
                onKeyDown () {
                    controlledScrollingRef.current = true;
                },
                onWheel () {
                    controlledScrollingRef.current = false;
                },
                onPointerMove () {
                    controlledScrollingRef.current = false;
                },
                onScroll () {
                    const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                    if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                    if (prevScrollTopRef.current !== null) {
                        const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                        if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) (0, $11492dca620dcaa5$exports.flushSync)(()=>onChange((d)=>d + scrollDiff));
                    }
                    // [Firefox] Wait for the height change to have been applied.
                    requestAnimationFrame(()=>{
                        prevScrollTopRef.current = el.scrollTop;
                    });
                }
            }
        };
    }, [
        enabled,
        overflowRef,
        elements.floating,
        scrollRef,
        onChange
    ]);
}
function $1923ad12705fb717$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $1923ad12705fb717$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $1923ad12705fb717$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    let timeoutId;
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = performance.now();
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = (0, $85ea27aada64f9e6$export$c22522a4dfa48e9c)(event);
            const isLeave = event.type === 'mouseleave';
            const isOverFloatingEl = (0, $85ea27aada64f9e6$export$2344b14b097df817)(elements.floating, target);
            const isOverReferenceEl = (0, $85ea27aada64f9e6$export$2344b14b097df817)(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split('-')[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $1923ad12705fb717$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(event.relatedTarget) && (0, $85ea27aada64f9e6$export$2344b14b097df817)(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $1923ad12705fb717$var$getChildren(tree.nodesRef.current, nodeId).some((_ref2)=>{
                let { context: context } = _ref2;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case 'top':
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case 'bottom':
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case 'left':
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case 'right':
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref3) {
                let [x, y] = _ref3;
                switch(side){
                    case 'top':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'bottom':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'left':
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case 'right':
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($1923ad12705fb717$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$1923ad12705fb717$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $8fbf4903a216a932$export$32d5543ab307c01(query) {
    const [matches, setMatches] = (0, $acw62.useState)(()=>matchMedia(query).matches);
    (0, $acw62.useEffect)(()=>{
        const media = matchMedia(query);
        const handler = ()=>setMatches(media.matches);
        handler();
        media.addEventListener('change', handler);
        return ()=>media.removeEventListener('change', handler);
    }, [
        query
    ]);
    return matches;
}


function $11a90cea0cc9744a$export$d55e7ee900f34e93({ initialOpen: initialOpen = false, open: controlledOpen, onOpenChange: setControlledOpen, className: className }) {
    const [uncontrolledOpen, setUncontrolledOpen] = $acw62.useState(initialOpen);
    const [labelId, setLabelId] = $acw62.useState();
    const [descriptionId, setDescriptionId] = $acw62.useState();
    const open = controlledOpen ?? uncontrolledOpen;
    const setOpen = setControlledOpen ?? setUncontrolledOpen;
    const data = (0, $1923ad12705fb717$export$4e02a5c1d08bac65)({
        open: open,
        onOpenChange: setOpen
    });
    const context = data.context;
    const click = (0, $1923ad12705fb717$export$98524f11226063fc)(context, {
        enabled: controlledOpen == null
    });
    const dismiss = (0, $1923ad12705fb717$export$fcdf1ba5fafc089b)(context, {
        outsidePressEvent: 'mousedown'
    });
    const role = (0, $1923ad12705fb717$export$f66572793fa256a1)(context);
    const interactions = (0, $1923ad12705fb717$export$a519f7794e446ddd)([
        click,
        dismiss,
        role
    ]);
    return $acw62.useMemo(()=>({
            open: open,
            setOpen: setOpen,
            ...interactions,
            ...data,
            labelId: labelId,
            descriptionId: descriptionId,
            setLabelId: setLabelId,
            setDescriptionId: setDescriptionId,
            className: className
        }), [
        open,
        setOpen,
        interactions,
        data,
        labelId,
        descriptionId,
        className
    ]);
}
const $11a90cea0cc9744a$var$DialogContext = /*#__PURE__*/ $acw62.createContext(null);
const $11a90cea0cc9744a$export$898e461c0669e62d = ()=>{
    const context = $acw62.useContext($11a90cea0cc9744a$var$DialogContext);
    if (context == null) throw new Error('Dialog components must be wrapped in <Dialog />');
    return context;
};
function $11a90cea0cc9744a$export$3ddf2d174ce01153({ children: children, ...options }) {
    const dialog = $11a90cea0cc9744a$export$d55e7ee900f34e93(options);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($11a90cea0cc9744a$var$DialogContext.Provider, {
        value: dialog,
        children: children
    });
}
const $11a90cea0cc9744a$export$2e1e1122cf0cba88 = /*#__PURE__*/ $acw62.forwardRef(function DialogTrigger({ children: children, asChild: asChild = false, ...props }, propRef) {
    const context = $11a90cea0cc9744a$export$898e461c0669e62d();
    const childrenRef = ref;
    const ref = (0, $1923ad12705fb717$export$74665b213cb5c4cf)([
        context.refs.setReference,
        propRef,
        childrenRef
    ]);
    // `asChild` allows the user to pass any element as the anchor
    if (asChild && /*#__PURE__*/ $acw62.isValidElement(children)) return /*#__PURE__*/ $acw62.cloneElement(children, context.getReferenceProps({
        ref: ref,
        ...props,
        ...children.props,
        'data-state': context.open ? 'open' : 'closed'
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        ref: ref,
        // The user can style the trigger based on the state
        "data-state": context.open ? 'open' : 'closed',
        ...context.getReferenceProps(props),
        children: children
    });
});
const $11a90cea0cc9744a$export$b6d9565de1e068cf = /*#__PURE__*/ $acw62.forwardRef(function DialogContent({ direction: direction = 'auto', ...props }, propRef) {
    const { context: floatingContext, ...context } = $11a90cea0cc9744a$export$898e461c0669e62d();
    const ref = (0, $1923ad12705fb717$export$74665b213cb5c4cf)([
        context.refs.setFloating,
        propRef
    ]);
    const isDesktop = (0, $8fbf4903a216a932$export$32d5543ab307c01)('(min-width: 640px)');
    const effectiveDirection = direction === 'auto' ? isDesktop ? 'left' : 'right' : direction;
    const transforms = {
        left: {
            initial: 'translateX(-100%)',
            open: 'translateX(0)',
            close: 'translateX(-100%)'
        },
        right: {
            initial: 'translateX(100%)',
            open: 'translateX(0)',
            close: 'translateX(100%)'
        },
        bottom: {
            initial: 'translateY(100%)',
            open: 'translateY(0)',
            close: 'translateY(100%)'
        }
    };
    const { isMounted: isMounted, styles: styles } = (0, $1923ad12705fb717$export$769fba13884bc2f4)(floatingContext, {
        duration: 700,
        easing: 'cubic-bezier(.4,0,.2,1)',
        initial: {
            opacity: direction === 'auto' ? 1 : 0,
            transform: transforms[effectiveDirection].initial
        },
        open: {
            opacity: 1,
            transform: transforms[effectiveDirection].open
        },
        close: {
            opacity: direction === 'auto' ? 1 : 0,
            transform: transforms[effectiveDirection].close
        }
    });
    const { styles: overlayStyles } = (0, $1923ad12705fb717$export$769fba13884bc2f4)(floatingContext, {
        duration: 700,
        easing: 'cubic-bezier(.4,0,.2,1)',
        initial: {
            backgroundColor: 'rgba(0,0,0,0)'
        },
        open: {
            backgroundColor: 'rgba(17,24,39,0.75)'
        },
        close: {
            backgroundColor: 'rgba(0,0,0,0)'
        }
    });
    if (!isMounted) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1923ad12705fb717$export$31fa5d718fa2ac09), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1923ad12705fb717$export$a35954495955337b), {
            style: isDesktop ? overlayStyles : null,
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('size-full z-100 flex justify-center items-center !overflow-hidden', context?.className),
            lockScroll: true,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1923ad12705fb717$export$8aeee49171ded61a), {
                context: floatingContext,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    ref: ref,
                    role: "dialog",
                    "aria-modal": "true",
                    style: styles,
                    "aria-labelledby": context.labelId,
                    "aria-describedby": context.descriptionId,
                    ...context.getFloatingProps(props),
                    children: props.children
                })
            })
        })
    });
});
const $11a90cea0cc9744a$export$2cd93e047c5f0909 = /*#__PURE__*/ $acw62.forwardRef(function DialogHeading({ children: children, ...props }, ref) {
    const { setLabelId: setLabelId } = $11a90cea0cc9744a$export$898e461c0669e62d();
    const id = (0, $1923ad12705fb717$export$f680877a34711e37)();
    // Only sets `aria-labelledby` on the Dialog root element
    // if this component is mounted inside it.
    $acw62.useLayoutEffect(()=>{
        setLabelId(id);
        return ()=>setLabelId(undefined);
    }, [
        id,
        setLabelId
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
        ...props,
        ref: ref,
        id: id,
        children: children
    });
});
const $11a90cea0cc9744a$export$94e94c2ec2c954d5 = /*#__PURE__*/ $acw62.forwardRef(function DialogDescription({ children: children, ...props }, ref) {
    const { setDescriptionId: setDescriptionId } = $11a90cea0cc9744a$export$898e461c0669e62d();
    const id = (0, $1923ad12705fb717$export$f680877a34711e37)();
    // Only sets `aria-describedby` on the Dialog root element
    // if this component is mounted inside it.
    $acw62.useLayoutEffect(()=>{
        setDescriptionId(id);
        return ()=>setDescriptionId(undefined);
    }, [
        id,
        setDescriptionId
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        ...props,
        ref: ref,
        id: id,
        children: children
    });
});
const $11a90cea0cc9744a$export$fba2fb7cd781b7ac = /*#__PURE__*/ $acw62.forwardRef(function DialogClose(props, ref) {
    const { setOpen: setOpen } = $11a90cea0cc9744a$export$898e461c0669e62d();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        type: "button",
        ...props,
        ref: ref,
        onClick: ()=>setOpen(false)
    });
});




var $acw62 = parcelRequire("acw62");
function $d7ede180b94f21b8$var$ArrowLeftIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M14 8a.75.75 0 0 1-.75.75H4.56l3.22 3.22a.75.75 0 1 1-1.06 1.06l-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5a.75.75 0 0 1 1.06 1.06L4.56 7.25h8.69A.75.75 0 0 1 14 8Z",
        clipRule: "evenodd"
    }));
}
const $d7ede180b94f21b8$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($d7ede180b94f21b8$var$ArrowLeftIcon);
var $d7ede180b94f21b8$export$2e2bcd8739ae039 = $d7ede180b94f21b8$var$ForwardRef;





var $acw62 = parcelRequire("acw62");
function $1be71097818d26ed$var$XMarkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z"
    }));
}
const $1be71097818d26ed$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($1be71097818d26ed$var$XMarkIcon);
var $1be71097818d26ed$export$2e2bcd8739ae039 = $1be71097818d26ed$var$ForwardRef;



var $acw62 = parcelRequire("acw62");
function $8faef5e48f16404b$var$CheckIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z",
        clipRule: "evenodd"
    }));
}
const $8faef5e48f16404b$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($8faef5e48f16404b$var$CheckIcon);
var $8faef5e48f16404b$export$2e2bcd8739ae039 = $8faef5e48f16404b$var$ForwardRef;



var $acw62 = parcelRequire("acw62");
function $2f828eed5b069fd9$var$Bars3Icon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M2 4.75A.75.75 0 0 1 2.75 4h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75ZM2 10a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 10Zm0 5.25a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Z",
        clipRule: "evenodd"
    }));
}
const $2f828eed5b069fd9$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($2f828eed5b069fd9$var$Bars3Icon);
var $2f828eed5b069fd9$export$2e2bcd8739ae039 = $2f828eed5b069fd9$var$ForwardRef;





var $acw62 = parcelRequire("acw62");










var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
var $2c66e6b8a5e43435$var$useLatest = function(value) {
    var ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
};
var $2c66e6b8a5e43435$export$2e2bcd8739ae039 = $2c66e6b8a5e43435$var$useLatest;


var $6f8168000b5a66a3$exports = {};
'use strict';
const { hasOwnProperty: $6f8168000b5a66a3$var$hasOwnProperty } = Object.prototype;
const $6f8168000b5a66a3$var$stringify = $6f8168000b5a66a3$var$configure();
// @ts-expect-error
$6f8168000b5a66a3$var$stringify.configure = $6f8168000b5a66a3$var$configure;
// @ts-expect-error
$6f8168000b5a66a3$var$stringify.stringify = $6f8168000b5a66a3$var$stringify;
// @ts-expect-error
$6f8168000b5a66a3$var$stringify.default = $6f8168000b5a66a3$var$stringify;
// @ts-expect-error used for named export
$6f8168000b5a66a3$exports.stringify = $6f8168000b5a66a3$var$stringify;
// @ts-expect-error used for named export
$6f8168000b5a66a3$exports.configure = $6f8168000b5a66a3$var$configure;
$6f8168000b5a66a3$exports = $6f8168000b5a66a3$var$stringify;
// eslint-disable-next-line no-control-regex
const $6f8168000b5a66a3$var$strEscapeSequencesRegExp = /[\u0000-\u001f\u0022\u005c\ud800-\udfff]/;
// Escape C0 control characters, double quotes, the backslash and every code
// unit with a numeric value in the inclusive range 0xD800 to 0xDFFF.
function $6f8168000b5a66a3$var$strEscape(str) {
    // Some magic numbers that worked out fine while benchmarking with v8 8.0
    if (str.length < 5000 && !$6f8168000b5a66a3$var$strEscapeSequencesRegExp.test(str)) return `"${str}"`;
    return JSON.stringify(str);
}
function $6f8168000b5a66a3$var$sort(array, comparator) {
    // Insertion sort is very efficient for small input sizes, but it has a bad
    // worst case complexity. Thus, use native array sort for bigger values.
    if (array.length > 2e2 || comparator) return array.sort(comparator);
    for(let i = 1; i < array.length; i++){
        const currentValue = array[i];
        let position = i;
        while(position !== 0 && array[position - 1] > currentValue){
            array[position] = array[position - 1];
            position--;
        }
        array[position] = currentValue;
    }
    return array;
}
const $6f8168000b5a66a3$var$typedArrayPrototypeGetSymbolToStringTag = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(Object.getPrototypeOf(new Int8Array())), Symbol.toStringTag).get;
function $6f8168000b5a66a3$var$isTypedArrayWithEntries(value) {
    return $6f8168000b5a66a3$var$typedArrayPrototypeGetSymbolToStringTag.call(value) !== undefined && value.length !== 0;
}
function $6f8168000b5a66a3$var$stringifyTypedArray(array, separator, maximumBreadth) {
    if (array.length < maximumBreadth) maximumBreadth = array.length;
    const whitespace = separator === ',' ? '' : ' ';
    let res = `"0":${whitespace}${array[0]}`;
    for(let i = 1; i < maximumBreadth; i++)res += `${separator}"${i}":${whitespace}${array[i]}`;
    return res;
}
function $6f8168000b5a66a3$var$getCircularValueOption(options) {
    if ($6f8168000b5a66a3$var$hasOwnProperty.call(options, 'circularValue')) {
        const circularValue = options.circularValue;
        if (typeof circularValue === 'string') return `"${circularValue}"`;
        if (circularValue == null) return circularValue;
        if (circularValue === Error || circularValue === TypeError) return {
            toString () {
                throw new TypeError('Converting circular structure to JSON');
            }
        };
        throw new TypeError('The "circularValue" argument must be of type string or the value null or undefined');
    }
    return '"[Circular]"';
}
function $6f8168000b5a66a3$var$getDeterministicOption(options) {
    let value;
    if ($6f8168000b5a66a3$var$hasOwnProperty.call(options, 'deterministic')) {
        value = options.deterministic;
        if (typeof value !== 'boolean' && typeof value !== 'function') throw new TypeError('The "deterministic" argument must be of type boolean or comparator function');
    }
    return value === undefined ? true : value;
}
function $6f8168000b5a66a3$var$getBooleanOption(options, key) {
    let value;
    if ($6f8168000b5a66a3$var$hasOwnProperty.call(options, key)) {
        value = options[key];
        if (typeof value !== 'boolean') throw new TypeError(`The "${key}" argument must be of type boolean`);
    }
    return value === undefined ? true : value;
}
function $6f8168000b5a66a3$var$getPositiveIntegerOption(options, key) {
    let value;
    if ($6f8168000b5a66a3$var$hasOwnProperty.call(options, key)) {
        value = options[key];
        if (typeof value !== 'number') throw new TypeError(`The "${key}" argument must be of type number`);
        if (!Number.isInteger(value)) throw new TypeError(`The "${key}" argument must be an integer`);
        if (value < 1) throw new RangeError(`The "${key}" argument must be >= 1`);
    }
    return value === undefined ? Infinity : value;
}
function $6f8168000b5a66a3$var$getItemCount(number) {
    if (number === 1) return '1 item';
    return `${number} items`;
}
function $6f8168000b5a66a3$var$getUniqueReplacerSet(replacerArray) {
    const replacerSet = new Set();
    for (const value of replacerArray)if (typeof value === 'string' || typeof value === 'number') replacerSet.add(String(value));
    return replacerSet;
}
function $6f8168000b5a66a3$var$getStrictOption(options) {
    if ($6f8168000b5a66a3$var$hasOwnProperty.call(options, 'strict')) {
        const value = options.strict;
        if (typeof value !== 'boolean') throw new TypeError('The "strict" argument must be of type boolean');
        if (value) return (value)=>{
            let message = `Object can not safely be stringified. Received type ${typeof value}`;
            if (typeof value !== 'function') message += ` (${value.toString()})`;
            throw new Error(message);
        };
    }
}
function $6f8168000b5a66a3$var$configure(options) {
    options = {
        ...options
    };
    const fail = $6f8168000b5a66a3$var$getStrictOption(options);
    if (fail) {
        if (options.bigint === undefined) options.bigint = false;
        if (!('circularValue' in options)) options.circularValue = Error;
    }
    const circularValue = $6f8168000b5a66a3$var$getCircularValueOption(options);
    const bigint = $6f8168000b5a66a3$var$getBooleanOption(options, 'bigint');
    const deterministic = $6f8168000b5a66a3$var$getDeterministicOption(options);
    const comparator = typeof deterministic === 'function' ? deterministic : undefined;
    const maximumDepth = $6f8168000b5a66a3$var$getPositiveIntegerOption(options, 'maximumDepth');
    const maximumBreadth = $6f8168000b5a66a3$var$getPositiveIntegerOption(options, 'maximumBreadth');
    function stringifyFnReplacer(key, parent, stack, replacer, spacer, indentation) {
        let value = parent[key];
        if (typeof value === 'object' && value !== null && typeof value.toJSON === 'function') value = value.toJSON(key);
        value = replacer.call(parent, key, value);
        switch(typeof value){
            case 'string':
                return $6f8168000b5a66a3$var$strEscape(value);
            case 'object':
                {
                    if (value === null) return 'null';
                    if (stack.indexOf(value) !== -1) return circularValue;
                    let res = '';
                    let join = ',';
                    const originalIndentation = indentation;
                    if (Array.isArray(value)) {
                        if (value.length === 0) return '[]';
                        if (maximumDepth < stack.length + 1) return '"[Array]"';
                        stack.push(value);
                        if (spacer !== '') {
                            indentation += spacer;
                            res += `\n${indentation}`;
                            join = `,\n${indentation}`;
                        }
                        const maximumValuesToStringify = Math.min(value.length, maximumBreadth);
                        let i = 0;
                        for(; i < maximumValuesToStringify - 1; i++){
                            const tmp = stringifyFnReplacer(String(i), value, stack, replacer, spacer, indentation);
                            res += tmp !== undefined ? tmp : 'null';
                            res += join;
                        }
                        const tmp = stringifyFnReplacer(String(i), value, stack, replacer, spacer, indentation);
                        res += tmp !== undefined ? tmp : 'null';
                        if (value.length - 1 > maximumBreadth) {
                            const removedKeys = value.length - maximumBreadth - 1;
                            res += `${join}"... ${$6f8168000b5a66a3$var$getItemCount(removedKeys)} not stringified"`;
                        }
                        if (spacer !== '') res += `\n${originalIndentation}`;
                        stack.pop();
                        return `[${res}]`;
                    }
                    let keys = Object.keys(value);
                    const keyLength = keys.length;
                    if (keyLength === 0) return '{}';
                    if (maximumDepth < stack.length + 1) return '"[Object]"';
                    let whitespace = '';
                    let separator = '';
                    if (spacer !== '') {
                        indentation += spacer;
                        join = `,\n${indentation}`;
                        whitespace = ' ';
                    }
                    const maximumPropertiesToStringify = Math.min(keyLength, maximumBreadth);
                    if (deterministic && !$6f8168000b5a66a3$var$isTypedArrayWithEntries(value)) keys = $6f8168000b5a66a3$var$sort(keys, comparator);
                    stack.push(value);
                    for(let i = 0; i < maximumPropertiesToStringify; i++){
                        const key = keys[i];
                        const tmp = stringifyFnReplacer(key, value, stack, replacer, spacer, indentation);
                        if (tmp !== undefined) {
                            res += `${separator}${$6f8168000b5a66a3$var$strEscape(key)}:${whitespace}${tmp}`;
                            separator = join;
                        }
                    }
                    if (keyLength > maximumBreadth) {
                        const removedKeys = keyLength - maximumBreadth;
                        res += `${separator}"...":${whitespace}"${$6f8168000b5a66a3$var$getItemCount(removedKeys)} not stringified"`;
                        separator = join;
                    }
                    if (spacer !== '' && separator.length > 1) res = `\n${indentation}${res}\n${originalIndentation}`;
                    stack.pop();
                    return `{${res}}`;
                }
            case 'number':
                return isFinite(value) ? String(value) : fail ? fail(value) : 'null';
            case 'boolean':
                return value === true ? 'true' : 'false';
            case 'undefined':
                return undefined;
            case 'bigint':
                if (bigint) return String(value);
            // fallthrough
            default:
                return fail ? fail(value) : undefined;
        }
    }
    function stringifyArrayReplacer(key, value, stack, replacer, spacer, indentation) {
        if (typeof value === 'object' && value !== null && typeof value.toJSON === 'function') value = value.toJSON(key);
        switch(typeof value){
            case 'string':
                return $6f8168000b5a66a3$var$strEscape(value);
            case 'object':
                {
                    if (value === null) return 'null';
                    if (stack.indexOf(value) !== -1) return circularValue;
                    const originalIndentation = indentation;
                    let res = '';
                    let join = ',';
                    if (Array.isArray(value)) {
                        if (value.length === 0) return '[]';
                        if (maximumDepth < stack.length + 1) return '"[Array]"';
                        stack.push(value);
                        if (spacer !== '') {
                            indentation += spacer;
                            res += `\n${indentation}`;
                            join = `,\n${indentation}`;
                        }
                        const maximumValuesToStringify = Math.min(value.length, maximumBreadth);
                        let i = 0;
                        for(; i < maximumValuesToStringify - 1; i++){
                            const tmp = stringifyArrayReplacer(String(i), value[i], stack, replacer, spacer, indentation);
                            res += tmp !== undefined ? tmp : 'null';
                            res += join;
                        }
                        const tmp = stringifyArrayReplacer(String(i), value[i], stack, replacer, spacer, indentation);
                        res += tmp !== undefined ? tmp : 'null';
                        if (value.length - 1 > maximumBreadth) {
                            const removedKeys = value.length - maximumBreadth - 1;
                            res += `${join}"... ${$6f8168000b5a66a3$var$getItemCount(removedKeys)} not stringified"`;
                        }
                        if (spacer !== '') res += `\n${originalIndentation}`;
                        stack.pop();
                        return `[${res}]`;
                    }
                    stack.push(value);
                    let whitespace = '';
                    if (spacer !== '') {
                        indentation += spacer;
                        join = `,\n${indentation}`;
                        whitespace = ' ';
                    }
                    let separator = '';
                    for (const key of replacer){
                        const tmp = stringifyArrayReplacer(key, value[key], stack, replacer, spacer, indentation);
                        if (tmp !== undefined) {
                            res += `${separator}${$6f8168000b5a66a3$var$strEscape(key)}:${whitespace}${tmp}`;
                            separator = join;
                        }
                    }
                    if (spacer !== '' && separator.length > 1) res = `\n${indentation}${res}\n${originalIndentation}`;
                    stack.pop();
                    return `{${res}}`;
                }
            case 'number':
                return isFinite(value) ? String(value) : fail ? fail(value) : 'null';
            case 'boolean':
                return value === true ? 'true' : 'false';
            case 'undefined':
                return undefined;
            case 'bigint':
                if (bigint) return String(value);
            // fallthrough
            default:
                return fail ? fail(value) : undefined;
        }
    }
    function stringifyIndent(key, value, stack, spacer, indentation) {
        switch(typeof value){
            case 'string':
                return $6f8168000b5a66a3$var$strEscape(value);
            case 'object':
                {
                    if (value === null) return 'null';
                    if (typeof value.toJSON === 'function') {
                        value = value.toJSON(key);
                        // Prevent calling `toJSON` again.
                        if (typeof value !== 'object') return stringifyIndent(key, value, stack, spacer, indentation);
                        if (value === null) return 'null';
                    }
                    if (stack.indexOf(value) !== -1) return circularValue;
                    const originalIndentation = indentation;
                    if (Array.isArray(value)) {
                        if (value.length === 0) return '[]';
                        if (maximumDepth < stack.length + 1) return '"[Array]"';
                        stack.push(value);
                        indentation += spacer;
                        let res = `\n${indentation}`;
                        const join = `,\n${indentation}`;
                        const maximumValuesToStringify = Math.min(value.length, maximumBreadth);
                        let i = 0;
                        for(; i < maximumValuesToStringify - 1; i++){
                            const tmp = stringifyIndent(String(i), value[i], stack, spacer, indentation);
                            res += tmp !== undefined ? tmp : 'null';
                            res += join;
                        }
                        const tmp = stringifyIndent(String(i), value[i], stack, spacer, indentation);
                        res += tmp !== undefined ? tmp : 'null';
                        if (value.length - 1 > maximumBreadth) {
                            const removedKeys = value.length - maximumBreadth - 1;
                            res += `${join}"... ${$6f8168000b5a66a3$var$getItemCount(removedKeys)} not stringified"`;
                        }
                        res += `\n${originalIndentation}`;
                        stack.pop();
                        return `[${res}]`;
                    }
                    let keys = Object.keys(value);
                    const keyLength = keys.length;
                    if (keyLength === 0) return '{}';
                    if (maximumDepth < stack.length + 1) return '"[Object]"';
                    indentation += spacer;
                    const join = `,\n${indentation}`;
                    let res = '';
                    let separator = '';
                    let maximumPropertiesToStringify = Math.min(keyLength, maximumBreadth);
                    if ($6f8168000b5a66a3$var$isTypedArrayWithEntries(value)) {
                        res += $6f8168000b5a66a3$var$stringifyTypedArray(value, join, maximumBreadth);
                        keys = keys.slice(value.length);
                        maximumPropertiesToStringify -= value.length;
                        separator = join;
                    }
                    if (deterministic) keys = $6f8168000b5a66a3$var$sort(keys, comparator);
                    stack.push(value);
                    for(let i = 0; i < maximumPropertiesToStringify; i++){
                        const key = keys[i];
                        const tmp = stringifyIndent(key, value[key], stack, spacer, indentation);
                        if (tmp !== undefined) {
                            res += `${separator}${$6f8168000b5a66a3$var$strEscape(key)}: ${tmp}`;
                            separator = join;
                        }
                    }
                    if (keyLength > maximumBreadth) {
                        const removedKeys = keyLength - maximumBreadth;
                        res += `${separator}"...": "${$6f8168000b5a66a3$var$getItemCount(removedKeys)} not stringified"`;
                        separator = join;
                    }
                    if (separator !== '') res = `\n${indentation}${res}\n${originalIndentation}`;
                    stack.pop();
                    return `{${res}}`;
                }
            case 'number':
                return isFinite(value) ? String(value) : fail ? fail(value) : 'null';
            case 'boolean':
                return value === true ? 'true' : 'false';
            case 'undefined':
                return undefined;
            case 'bigint':
                if (bigint) return String(value);
            // fallthrough
            default:
                return fail ? fail(value) : undefined;
        }
    }
    function stringifySimple(key, value, stack) {
        switch(typeof value){
            case 'string':
                return $6f8168000b5a66a3$var$strEscape(value);
            case 'object':
                {
                    if (value === null) return 'null';
                    if (typeof value.toJSON === 'function') {
                        value = value.toJSON(key);
                        // Prevent calling `toJSON` again
                        if (typeof value !== 'object') return stringifySimple(key, value, stack);
                        if (value === null) return 'null';
                    }
                    if (stack.indexOf(value) !== -1) return circularValue;
                    let res = '';
                    const hasLength = value.length !== undefined;
                    if (hasLength && Array.isArray(value)) {
                        if (value.length === 0) return '[]';
                        if (maximumDepth < stack.length + 1) return '"[Array]"';
                        stack.push(value);
                        const maximumValuesToStringify = Math.min(value.length, maximumBreadth);
                        let i = 0;
                        for(; i < maximumValuesToStringify - 1; i++){
                            const tmp = stringifySimple(String(i), value[i], stack);
                            res += tmp !== undefined ? tmp : 'null';
                            res += ',';
                        }
                        const tmp = stringifySimple(String(i), value[i], stack);
                        res += tmp !== undefined ? tmp : 'null';
                        if (value.length - 1 > maximumBreadth) {
                            const removedKeys = value.length - maximumBreadth - 1;
                            res += `,"... ${$6f8168000b5a66a3$var$getItemCount(removedKeys)} not stringified"`;
                        }
                        stack.pop();
                        return `[${res}]`;
                    }
                    let keys = Object.keys(value);
                    const keyLength = keys.length;
                    if (keyLength === 0) return '{}';
                    if (maximumDepth < stack.length + 1) return '"[Object]"';
                    let separator = '';
                    let maximumPropertiesToStringify = Math.min(keyLength, maximumBreadth);
                    if (hasLength && $6f8168000b5a66a3$var$isTypedArrayWithEntries(value)) {
                        res += $6f8168000b5a66a3$var$stringifyTypedArray(value, ',', maximumBreadth);
                        keys = keys.slice(value.length);
                        maximumPropertiesToStringify -= value.length;
                        separator = ',';
                    }
                    if (deterministic) keys = $6f8168000b5a66a3$var$sort(keys, comparator);
                    stack.push(value);
                    for(let i = 0; i < maximumPropertiesToStringify; i++){
                        const key = keys[i];
                        const tmp = stringifySimple(key, value[key], stack);
                        if (tmp !== undefined) {
                            res += `${separator}${$6f8168000b5a66a3$var$strEscape(key)}:${tmp}`;
                            separator = ',';
                        }
                    }
                    if (keyLength > maximumBreadth) {
                        const removedKeys = keyLength - maximumBreadth;
                        res += `${separator}"...":"${$6f8168000b5a66a3$var$getItemCount(removedKeys)} not stringified"`;
                    }
                    stack.pop();
                    return `{${res}}`;
                }
            case 'number':
                return isFinite(value) ? String(value) : fail ? fail(value) : 'null';
            case 'boolean':
                return value === true ? 'true' : 'false';
            case 'undefined':
                return undefined;
            case 'bigint':
                if (bigint) return String(value);
            // fallthrough
            default:
                return fail ? fail(value) : undefined;
        }
    }
    function stringify(value, replacer, space) {
        if (arguments.length > 1) {
            let spacer = '';
            if (typeof space === 'number') spacer = ' '.repeat(Math.min(space, 10));
            else if (typeof space === 'string') spacer = space.slice(0, 10);
            if (replacer != null) {
                if (typeof replacer === 'function') return stringifyFnReplacer('', {
                    '': value
                }, [], replacer, spacer, '');
                if (Array.isArray(replacer)) return stringifyArrayReplacer('', value, [], $6f8168000b5a66a3$var$getUniqueReplacerSet(replacer), spacer, '');
            }
            if (spacer.length !== 0) return stringifyIndent('', value, [], spacer, '');
        }
        return stringifySimple('', value, []);
    }
    return stringify;
}


const $22327ae61d67c373$export$8d21e34596265fa2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f8168000b5a66a3$exports))).configure;
const $22327ae61d67c373$export$fac44ee5b035f737 = (0, (/*@__PURE__*/$parcel$interopDefault($6f8168000b5a66a3$exports)));
var $22327ae61d67c373$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($6f8168000b5a66a3$exports)));





function $9096ea47e55f3ae1$export$496d927b06422053() {
    const { patchInvite: patchInvite, invite: invite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    const latestInvite = (0, $2c66e6b8a5e43435$export$2e2bcd8739ae039)(invite);
    return (0, $36464e4be8053fb8$export$fbeb804c371ac8d)(async (patchData)=>{
        const { reference: reference, onlineBookingData: currentData } = latestInvite.current;
        const onlineBookingData = (0, $2cfbe4d1e444ba23$export$6969335ea1e4e77c)(currentData, patchData);
        if ((0, $22327ae61d67c373$export$2e2bcd8739ae039)(onlineBookingData) !== (0, $22327ae61d67c373$export$2e2bcd8739ae039)(currentData)) {
            await (0, $56ff6b9a4ee43a2e$export$644d8ea042df96a6).auth.post('onlinebooking/update-data', {
                json: {
                    bookingReference: reference,
                    onlineBookingData: onlineBookingData
                }
            });
            patchInvite(patchData);
            return true;
        } else return true;
    });
}



const $dea25ad601eb8263$var$DEFAULT_EXTRACT_DEFAULTS = ()=>({});
const $dea25ad601eb8263$var$DEFAULT_TRANSFORM_VALUES = (x)=>x;
const $dea25ad601eb8263$export$70aabb5da7e125f8 = /*#__PURE__*/ (0, $acw62.forwardRef)(function PatchInviteForm({ extractDefaults: extractDefaults = $dea25ad601eb8263$var$DEFAULT_EXTRACT_DEFAULTS, transformValues: transformValues = $dea25ad601eb8263$var$DEFAULT_TRANSFORM_VALUES, schema: schema, nextPath: nextPath, children: children }, ref) {
    const { invite: invite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    const form = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        defaultValues: extractDefaults(invite.onlineBookingData, invite),
        resolver: schema ? (0, $0591fe66d7f046a7$export$66b7b5879c70f722)(schema) : undefined,
        mode: 'onChange'
    });
    const patchInvite = (0, $9096ea47e55f3ae1$export$496d927b06422053)();
    const navigate = (0, $618a07bedf38a2ba$export$9770f232ac06a008)();
    const transformValuesRef = (0, $acw62.useRef)(transformValues);
    transformValuesRef.current = transformValues;
    const handleSubmit = (0, $acw62.useCallback)(async (values)=>{
        const transformed = transformValuesRef.current(values);
        const success = await patchInvite.execute(transformed);
        if (success && nextPath) navigate(`/${invite.reference}/${nextPath}`);
    }, [
        invite,
        navigate,
        nextPath,
        patchInvite
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
        ...form,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
            id: "patch-invite-form",
            className: "contents",
            ref: ref,
            onSubmit: form.handleSubmit(handleSubmit),
            children: children
        })
    });
});





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Calls all functions in the order they were chained with the same arguments.
 */ function $366a72b5d02721fb$export$e08e3b67e392101e(...callbacks) {
    return (...args)=>{
        for (let callback of callbacks)if (typeof callback === 'function') callback(...args);
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $38781589fd33010c$export$e5c5a5f917a5871c = typeof document !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect : ()=>{};




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a1a17f9e7799d63b$export$14d238f342723f25(defaultValue) {
    let [value, setValue] = (0, $acw62.useState)(defaultValue);
    // Keep an up to date copy of value in a ref so we can access the current value in the generator.
    // This allows us to maintain a stable queue function.
    let currValue = (0, $acw62.useRef)(value);
    let effect = (0, $acw62.useRef)(null);
    // Store the function in a ref so we can always access the current version
    // which has the proper `value` in scope.
    let nextRef = (0, $acw62.useRef)(()=>{
        if (!effect.current) return;
        // Run the generator to the next yield.
        let newValue = effect.current.next();
        // If the generator is done, reset the effect.
        if (newValue.done) {
            effect.current = null;
            return;
        }
        // If the value is the same as the current value,
        // then continue to the next yield. Otherwise,
        // set the value in state and wait for the next layout effect.
        if (currValue.current === newValue.value) nextRef.current();
        else setValue(newValue.value);
    });
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        currValue.current = value;
        // If there is an effect currently running, continue to the next yield.
        if (effect.current) nextRef.current();
    });
    let queue = (0, $acw62.useCallback)((fn)=>{
        effect.current = fn(currValue.current);
        nextRef.current();
    }, [
        nextRef
    ]);
    return [
        value,
        queue
    ];
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $3355288d61aeabc2$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $3355288d61aeabc2$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($3355288d61aeabc2$var$$b5e257d569688ac6$var$defaultContext);
const $3355288d61aeabc2$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(false);
// This is only used in React < 18.
function $3355288d61aeabc2$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $acw62.useContext)($3355288d61aeabc2$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $3355288d61aeabc2$var$$b5e257d569688ac6$var$useCounter(cur === $3355288d61aeabc2$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $acw62.useState)(true);
    let value = (0, $acw62.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $3355288d61aeabc2$var$$b5e257d569688ac6$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $acw62.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3355288d61aeabc2$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3355288d61aeabc2$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $3355288d61aeabc2$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $3355288d61aeabc2$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useId'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, props.children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3355288d61aeabc2$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $3355288d61aeabc2$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $3355288d61aeabc2$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $3355288d61aeabc2$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $acw62.useContext)($3355288d61aeabc2$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $acw62.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $3355288d61aeabc2$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $3355288d61aeabc2$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $3355288d61aeabc2$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $3355288d61aeabc2$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $acw62.useContext)($3355288d61aeabc2$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    ctx === $3355288d61aeabc2$var$$b5e257d569688ac6$var$defaultContext && $3355288d61aeabc2$var$$b5e257d569688ac6$var$canUseDOM;
    let counter = $3355288d61aeabc2$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $3355288d61aeabc2$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    let [didSSR] = (0, $acw62.useState)($3355288d61aeabc2$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$3355288d61aeabc2$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $3355288d61aeabc2$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useId'] === 'function' ? $3355288d61aeabc2$var$$b5e257d569688ac6$var$useModernSSRSafeId : $3355288d61aeabc2$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $3355288d61aeabc2$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $3355288d61aeabc2$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $3355288d61aeabc2$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $3355288d61aeabc2$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useSyncExternalStore']($3355288d61aeabc2$var$$b5e257d569688ac6$var$subscribe, $3355288d61aeabc2$var$$b5e257d569688ac6$var$getSnapshot, $3355288d61aeabc2$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $acw62.useContext)($3355288d61aeabc2$var$$b5e257d569688ac6$var$IsSSRContext);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // copied from SSRProvider.tsx to reduce exports, if needed again, consider sharing
let $855de91ebb07800c$var$$bdb11010cef70236$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $855de91ebb07800c$export$d41a04c74483c6ef = new Map();
// This allows us to clean up the idsUpdaterMap when the id is no longer used.
// Map is a strong reference, so unused ids wouldn't be cleaned up otherwise.
// This can happen in suspended components where mount/unmount is not called.
let $855de91ebb07800c$var$$bdb11010cef70236$var$registry;
if (typeof FinalizationRegistry !== 'undefined') $855de91ebb07800c$var$$bdb11010cef70236$var$registry = new FinalizationRegistry((heldValue)=>{
    $855de91ebb07800c$export$d41a04c74483c6ef.delete(heldValue);
});
function $855de91ebb07800c$export$f680877a34711e37(defaultId) {
    let [value, setValue] = (0, $acw62.useState)(defaultId);
    let nextId = (0, $acw62.useRef)(null);
    let res = (0, $3355288d61aeabc2$export$619500959fc48b26)(value);
    let cleanupRef = (0, $acw62.useRef)(null);
    if ($855de91ebb07800c$var$$bdb11010cef70236$var$registry) $855de91ebb07800c$var$$bdb11010cef70236$var$registry.register(cleanupRef, res);
    if ($855de91ebb07800c$var$$bdb11010cef70236$var$canUseDOM) {
        const cacheIdRef = $855de91ebb07800c$export$d41a04c74483c6ef.get(res);
        if (cacheIdRef && !cacheIdRef.includes(nextId)) cacheIdRef.push(nextId);
        else $855de91ebb07800c$export$d41a04c74483c6ef.set(res, [
            nextId
        ]);
    }
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        let r = res;
        return ()=>{
            // In Suspense, the cleanup function may be not called
            // when it is though, also remove it from the finalization registry.
            if ($855de91ebb07800c$var$$bdb11010cef70236$var$registry) $855de91ebb07800c$var$$bdb11010cef70236$var$registry.unregister(cleanupRef);
            $855de91ebb07800c$export$d41a04c74483c6ef.delete(r);
        };
    }, [
        res
    ]);
    (0, $acw62.useEffect)(()=>{
        let newId = nextId.current;
        if (newId) setValue(newId);
        return ()=>{
            if (newId) nextId.current = null;
        };
    });
    return res;
}
function $855de91ebb07800c$export$cd8c9cb68f842629(idA, idB) {
    if (idA === idB) return idA;
    let setIdsA = $855de91ebb07800c$export$d41a04c74483c6ef.get(idA);
    if (setIdsA) {
        setIdsA.forEach((ref)=>ref.current = idB);
        return idB;
    }
    let setIdsB = $855de91ebb07800c$export$d41a04c74483c6ef.get(idB);
    if (setIdsB) {
        setIdsB.forEach((ref)=>ref.current = idA);
        return idA;
    }
    return idB;
}
function $855de91ebb07800c$export$b4cc09c592e8fdb8(depArray = []) {
    let id = $855de91ebb07800c$export$f680877a34711e37();
    let [resolvedId, setResolvedId] = (0, $a1a17f9e7799d63b$export$14d238f342723f25)(id);
    let updateId = (0, $acw62.useCallback)(()=>{
        setResolvedId(function*() {
            yield id;
            yield document.getElementById(id) ? id : undefined;
        });
    }, [
        id,
        setResolvedId
    ]);
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(updateId, [
        id,
        updateId,
        ...depArray
    ]);
    return resolvedId;
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e611552c564dfe1f$export$9d1611c77c2fe928(...args) {
    // Start with a base clone of the first argument. This is a lot faster than starting
    // with an empty object and adding properties as we go.
    let result = {
        ...args[0]
    };
    for(let i = 1; i < args.length; i++){
        let props = args[i];
        for(let key in props){
            let a = result[key];
            let b = props[key];
            // Chain events
            if (typeof a === 'function' && typeof b === 'function' && // This is a lot faster than a regex.
            key[0] === 'o' && key[1] === 'n' && key.charCodeAt(2) >= /* 'A' */ 65 && key.charCodeAt(2) <= /* 'Z' */ 90) result[key] = (0, $366a72b5d02721fb$export$e08e3b67e392101e)(a, b);
            else if ((key === 'className' || key === 'UNSAFE_className') && typeof a === 'string' && typeof b === 'string') result[key] = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(a, b);
            else if (key === 'id' && a && b) result.id = (0, $855de91ebb07800c$export$cd8c9cb68f842629)(a, b);
            else result[key] = b !== undefined ? b : a;
        }
    }
    return result;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $27215adb76b33250$export$c9058316764c140e(...refs) {
    if (refs.length === 1 && refs[0]) return refs[0];
    return (value)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $27215adb76b33250$var$$5dc95899b306f630$var$setRef(ref, value);
            hasCleanup || (hasCleanup = typeof cleanup == 'function');
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            cleanups.forEach((cleanup, i)=>{
                if (typeof cleanup === 'function') cleanup();
                else $27215adb76b33250$var$$5dc95899b306f630$var$setRef(refs[i], null);
            });
        };
    };
}
function $27215adb76b33250$var$$5dc95899b306f630$var$setRef(ref, value) {
    if (typeof ref === 'function') return ref(value);
    else if (ref != null) ref.current = value;
}


var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $426ce7b4b2df0896$export$4338b53315abf666(ref) {
    const objRef = (0, $acw62.useRef)(null);
    const cleanupRef = (0, $acw62.useRef)(undefined);
    const refEffect = (0, $acw62.useCallback)((instance)=>{
        if (typeof ref === 'function') {
            const refCallback = ref;
            const refCleanup = refCallback(instance);
            return ()=>{
                if (typeof refCleanup === 'function') refCleanup();
                else refCallback(null);
            };
        } else if (ref) {
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        }
    }, [
        ref
    ]);
    return (0, $acw62.useMemo)(()=>({
            get current () {
                return objRef.current;
            },
            set current (value){
                objRef.current = value;
                if (cleanupRef.current) {
                    cleanupRef.current();
                    cleanupRef.current = undefined;
                }
                if (value != null) cleanupRef.current = refEffect(value);
            }
        }), [
        refEffect
    ]);
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $12ee5c1d62d6b2e5$export$c62b8e45d58ddad9 = Symbol('default');
function $12ee5c1d62d6b2e5$export$2881499e37b75b9a({ values: values, children: children }) {
    for (let [Context, value] of values)children = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Context.Provider, {
        value: value
    }, children);
    return children;
}
function $12ee5c1d62d6b2e5$export$4d86445c2cf5e3(props) {
    let { className: className, style: style, children: children, defaultClassName: defaultClassName, defaultChildren: defaultChildren, defaultStyle: defaultStyle, values: values } = props;
    return (0, $acw62.useMemo)(()=>{
        let computedClassName;
        let computedStyle;
        let computedChildren;
        if (typeof className === 'function') computedClassName = className({
            ...values,
            defaultClassName: defaultClassName
        });
        else computedClassName = className;
        if (typeof style === 'function') computedStyle = style({
            ...values,
            defaultStyle: defaultStyle || {}
        });
        else computedStyle = style;
        if (typeof children === 'function') computedChildren = children({
            ...values,
            defaultChildren: defaultChildren
        });
        else if (children == null) computedChildren = defaultChildren;
        else computedChildren = children;
        return {
            className: computedClassName !== null && computedClassName !== void 0 ? computedClassName : defaultClassName,
            style: computedStyle || defaultStyle ? {
                ...defaultStyle,
                ...computedStyle
            } : undefined,
            children: computedChildren !== null && computedChildren !== void 0 ? computedChildren : defaultChildren,
            'data-rac': ''
        };
    }, [
        className,
        style,
        children,
        defaultClassName,
        defaultChildren,
        defaultStyle,
        values
    ]);
}
function $12ee5c1d62d6b2e5$export$c245e6201fed2f75(value, wrap) {
    return (renderProps)=>wrap(typeof value === 'function' ? value(renderProps) : value, renderProps);
}
function $12ee5c1d62d6b2e5$export$fabf2dc03a41866e(context, slot) {
    let ctx = (0, $acw62.useContext)(context);
    if (slot === null) return null;
    if (ctx && typeof ctx === 'object' && 'slots' in ctx && ctx.slots) {
        let slotKey = slot || $12ee5c1d62d6b2e5$export$c62b8e45d58ddad9;
        if (!ctx.slots[slotKey]) {
            let availableSlots = new Intl.ListFormat().format(Object.keys(ctx.slots).map((p)=>`"${p}"`));
            let errorMessage = slot ? `Invalid slot "${slot}".` : 'A slot prop is required.';
            throw new Error(`${errorMessage} Valid slot names are ${availableSlots}.`);
        }
        return ctx.slots[slotKey];
    }
    // @ts-ignore
    return ctx;
}
function $12ee5c1d62d6b2e5$export$29f1550f4b0d4415(props, ref, context) {
    let ctx = $12ee5c1d62d6b2e5$export$fabf2dc03a41866e(context, props.slot) || {};
    let { ref: contextRef, ...contextProps } = ctx;
    let mergedRef = (0, $426ce7b4b2df0896$export$4338b53315abf666)((0, $acw62.useMemo)(()=>(0, $27215adb76b33250$export$c9058316764c140e)(ref, contextRef), [
        ref,
        contextRef
    ]));
    let mergedProps = (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(contextProps, props);
    // mergeProps does not merge `style`. Adding this there might be a breaking change.
    if ('style' in contextProps && contextProps.style && 'style' in props && props.style) {
        if (typeof contextProps.style === 'function' || typeof props.style === 'function') mergedProps.style = (renderProps)=>{
            let contextStyle = typeof contextProps.style === 'function' ? contextProps.style(renderProps) : contextProps.style;
            let defaultStyle = {
                ...renderProps.defaultStyle,
                ...contextStyle
            };
            let style = typeof props.style === 'function' ? props.style({
                ...renderProps,
                defaultStyle: defaultStyle
            }) : props.style;
            return {
                ...defaultStyle,
                ...style
            };
        };
        else mergedProps.style = {
            ...contextProps.style,
            ...props.style
        };
    }
    return [
        mergedProps,
        mergedRef
    ];
}
function $12ee5c1d62d6b2e5$export$9d4c57ee4c6ffdd8(initialState = true) {
    // Initial state is typically based on the parent having an aria-label or aria-labelledby.
    // If it does, this value should be false so that we don't update the state and cause a rerender when we go through the layoutEffect
    let [hasSlot, setHasSlot] = (0, $acw62.useState)(initialState);
    let hasRun = (0, $acw62.useRef)(false);
    // A callback ref which will run when the slotted element mounts.
    // This should happen before the useLayoutEffect below.
    let ref = (0, $acw62.useCallback)((el)=>{
        hasRun.current = true;
        setHasSlot(!!el);
    }, []);
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        if (!hasRun.current) setHasSlot(false);
    }, []);
    return [
        ref,
        hasSlot
    ];
}
function $12ee5c1d62d6b2e5$export$ef03459518577ad4(props) {
    const prefix = /^(data-.*)$/;
    let filteredProps = {};
    for(const prop in props)if (!prefix.test(prop)) filteredProps[prop] = props[prop];
    return filteredProps;
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // React doesn't understand the <template> element, which doesn't have children like a normal element.
// It will throw an error during hydration when it expects the firstChild to contain content rendered
// on the server, when in reality, the browser will have placed this inside the `content` document fragment.
// This monkey patches the firstChild property for our special hidden template elements to work around this error.
// See https://github.com/facebook/react/issues/19932
if (typeof HTMLTemplateElement !== 'undefined') {
    const getFirstChild = Object.getOwnPropertyDescriptor(Node.prototype, 'firstChild').get;
    Object.defineProperty(HTMLTemplateElement.prototype, 'firstChild', {
        configurable: true,
        enumerable: true,
        get: function() {
            if (this.dataset.reactAriaHidden) return this.content.firstChild;
            else return getFirstChild.call(this);
        }
    });
}
const $73addfbf71cdc088$export$94b6d0abf7d33e8c = (0, $acw62.createContext)(false);
function $73addfbf71cdc088$export$8dc98ba7eadeaa56(props) {
    let isHidden = (0, $acw62.useContext)($73addfbf71cdc088$export$94b6d0abf7d33e8c);
    if (isHidden) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, props.children);
    let children = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($73addfbf71cdc088$export$94b6d0abf7d33e8c.Provider, {
        value: true
    }, props.children);
    // In SSR, portals are not supported by React. Instead, always render into a <template>
    // element, which the browser will never display to the user. In addition, the
    // content is not part of the accessible DOM tree, so it won't affect ids or other accessibility attributes.
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("template", {
        "data-react-aria-hidden": true
    }, children);
}
function $73addfbf71cdc088$export$86427a43e3e48ebb(fn) {
    let Wrapper = (props, ref)=>{
        let isHidden = (0, $acw62.useContext)($73addfbf71cdc088$export$94b6d0abf7d33e8c);
        if (isHidden) return null;
        return fn(props, ref);
    };
    // @ts-ignore - for react dev tools
    Wrapper.displayName = fn.displayName || fn.name;
    return (0, $acw62.forwardRef)(Wrapper);
}
function $73addfbf71cdc088$export$b5d7cc18bb8d2b59() {
    return (0, $acw62.useContext)($73addfbf71cdc088$export$94b6d0abf7d33e8c);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4623aa9f87f28cd4$export$de79e2c695e052f3(element) {
    if ($4623aa9f87f28cd4$var$$7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        let scrollableElements = $4623aa9f87f28cd4$var$$7215afc6de606d6b$var$getScrollableElements(element);
        element.focus();
        $4623aa9f87f28cd4$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
    }
}
let $4623aa9f87f28cd4$var$$7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $4623aa9f87f28cd4$var$$7215afc6de606d6b$var$supportsPreventScroll() {
    if ($4623aa9f87f28cd4$var$$7215afc6de606d6b$var$supportsPreventScrollCached == null) {
        $4623aa9f87f28cd4$var$$7215afc6de606d6b$var$supportsPreventScrollCached = false;
        try {
            let focusElem = document.createElement('div');
            focusElem.focus({
                get preventScroll () {
                    $4623aa9f87f28cd4$var$$7215afc6de606d6b$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch  {
        // Ignore
        }
    }
    return $4623aa9f87f28cd4$var$$7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $4623aa9f87f28cd4$var$$7215afc6de606d6b$var$getScrollableElements(element) {
    let parent = element.parentNode;
    let scrollableElements = [];
    let rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $4623aa9f87f28cd4$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
    for (let { element: element, scrollTop: scrollTop, scrollLeft: scrollLeft } of scrollableElements){
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}

const $48852fd65b79e251$export$b204af158042fbac = (el)=>{
    var _el_ownerDocument;
    return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const $48852fd65b79e251$export$f21a1ffae260145a = (el)=>{
    if (el && 'window' in el && el.window === el) return el;
    const doc = $48852fd65b79e251$export$b204af158042fbac(el);
    return doc.defaultView || window;
};
/**
 * Type guard that checks if a value is a Node. Verifies the presence and type of the nodeType property.
 */ function $48852fd65b79e251$var$$431fbd86ca7dc216$var$isNode(value) {
    return value !== null && typeof value === 'object' && 'nodeType' in value && typeof value.nodeType === 'number';
}
function $48852fd65b79e251$export$af51f0f06c0f328a(node) {
    return $48852fd65b79e251$var$$431fbd86ca7dc216$var$isNode(node) && node.nodeType === Node.DOCUMENT_FRAGMENT_NODE && 'host' in node;
}


/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $eb52f5aa01dfaab7$var$$7d2416ea0959daaa$var$supportsCheckVisibility = typeof Element !== 'undefined' && 'checkVisibility' in Element.prototype;
function $eb52f5aa01dfaab7$var$$7d2416ea0959daaa$var$isStyleVisible(element) {
    const windowObject = (0, $48852fd65b79e251$export$f21a1ffae260145a)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== 'none' && visibility !== 'hidden' && visibility !== 'collapse';
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== 'none' && computedVisibility !== 'hidden' && computedVisibility !== 'collapse';
    }
    return isVisible;
}
function $eb52f5aa01dfaab7$var$$7d2416ea0959daaa$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute('hidden') && // Ignore HiddenSelect when tree walking.
    !element.hasAttribute('data-react-aria-prevent-focus') && (element.nodeName === 'DETAILS' && childElement && childElement.nodeName !== 'SUMMARY' ? element.hasAttribute('open') : true);
}
function $eb52f5aa01dfaab7$export$e989c0fffaa6b27a(element, childElement) {
    if ($eb52f5aa01dfaab7$var$$7d2416ea0959daaa$var$supportsCheckVisibility) return element.checkVisibility({
        visibilityProperty: true
    }) && !element.closest('[data-react-aria-prevent-focus]');
    return element.nodeName !== '#comment' && $eb52f5aa01dfaab7$var$$7d2416ea0959daaa$var$isStyleVisible(element) && $eb52f5aa01dfaab7$var$$7d2416ea0959daaa$var$isAttributeVisible(element, childElement) && (!element.parentElement || $eb52f5aa01dfaab7$export$e989c0fffaa6b27a(element.parentElement, element));
}


/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $5c8550b2a03c9d44$var$$b4b717babfbb907b$var$focusableElements = [
    'input:not([disabled]):not([type=hidden])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable^="false"])',
    'permission'
];
const $5c8550b2a03c9d44$var$$b4b717babfbb907b$var$FOCUSABLE_ELEMENT_SELECTOR = $5c8550b2a03c9d44$var$$b4b717babfbb907b$var$focusableElements.join(':not([hidden]),') + ',[tabindex]:not([disabled]):not([hidden])';
$5c8550b2a03c9d44$var$$b4b717babfbb907b$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $5c8550b2a03c9d44$var$$b4b717babfbb907b$var$TABBABLE_ELEMENT_SELECTOR = $5c8550b2a03c9d44$var$$b4b717babfbb907b$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $5c8550b2a03c9d44$export$4c063cf1350e6fed(element) {
    return element.matches($5c8550b2a03c9d44$var$$b4b717babfbb907b$var$FOCUSABLE_ELEMENT_SELECTOR) && (0, $eb52f5aa01dfaab7$export$e989c0fffaa6b27a)(element) && !$5c8550b2a03c9d44$var$$b4b717babfbb907b$var$isInert(element);
}
function $5c8550b2a03c9d44$export$bebd5a1431fec25d(element) {
    return element.matches($5c8550b2a03c9d44$var$$b4b717babfbb907b$var$TABBABLE_ELEMENT_SELECTOR) && (0, $eb52f5aa01dfaab7$export$e989c0fffaa6b27a)(element) && !$5c8550b2a03c9d44$var$$b4b717babfbb907b$var$isInert(element);
}
function $5c8550b2a03c9d44$var$$b4b717babfbb907b$var$isInert(element) {
    let node = element;
    while(node != null){
        if (node instanceof node.ownerDocument.defaultView.HTMLElement && node.inert) return true;
        node = node.parentElement;
    }
    return false;
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7fc007d8fdcfe19c$export$525bc4921d56d4a(nativeEvent) {
    let event = nativeEvent;
    event.nativeEvent = nativeEvent;
    event.isDefaultPrevented = ()=>event.defaultPrevented;
    // cancelBubble is technically deprecated in the spec, but still supported in all browsers.
    event.isPropagationStopped = ()=>event.cancelBubble;
    event.persist = ()=>{};
    return event;
}
function $7fc007d8fdcfe19c$export$c2b7abe5d61ec696(event, target) {
    Object.defineProperty(event, 'target', {
        value: target
    });
    Object.defineProperty(event, 'currentTarget', {
        value: target
    });
}
function $7fc007d8fdcfe19c$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $acw62.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    // This function is called during a React onFocus event.
    return (0, $acw62.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) {
                    // For backward compatibility, dispatch a (fake) React synthetic event.
                    let event = $7fc007d8fdcfe19c$export$525bc4921d56d4a(e);
                    onBlur === null || onBlur === void 0 || onBlur(event);
                }
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener('focusout', onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent('blur', {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent('focusout', {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    'disabled'
                ]
            });
        }
    }, [
        onBlur
    ]);
}
let $7fc007d8fdcfe19c$export$fda7da73ab5d4c48 = false;
function $7fc007d8fdcfe19c$export$cabe61c495ee3649(target) {
    // The browser will focus the nearest focusable ancestor of our target.
    while(target && !(0, $5c8550b2a03c9d44$export$4c063cf1350e6fed)(target))target = target.parentElement;
    let window = (0, $48852fd65b79e251$export$f21a1ffae260145a)(target);
    let activeElement = window.document.activeElement;
    if (!activeElement || activeElement === target) return;
    $7fc007d8fdcfe19c$export$fda7da73ab5d4c48 = true;
    let isRefocusing = false;
    let onBlur = (e)=>{
        if (e.target === activeElement || isRefocusing) e.stopImmediatePropagation();
    };
    let onFocusOut = (e)=>{
        if (e.target === activeElement || isRefocusing) {
            e.stopImmediatePropagation();
            // If there was no focusable ancestor, we don't expect a focus event.
            // Re-focus the original active element here.
            if (!target && !isRefocusing) {
                isRefocusing = true;
                (0, $4623aa9f87f28cd4$export$de79e2c695e052f3)(activeElement);
                cleanup();
            }
        }
    };
    let onFocus = (e)=>{
        if (e.target === target || isRefocusing) e.stopImmediatePropagation();
    };
    let onFocusIn = (e)=>{
        if (e.target === target || isRefocusing) {
            e.stopImmediatePropagation();
            if (!isRefocusing) {
                isRefocusing = true;
                (0, $4623aa9f87f28cd4$export$de79e2c695e052f3)(activeElement);
                cleanup();
            }
        }
    };
    window.addEventListener('blur', onBlur, true);
    window.addEventListener('focusout', onFocusOut, true);
    window.addEventListener('focusin', onFocusIn, true);
    window.addEventListener('focus', onFocus, true);
    let cleanup = ()=>{
        cancelAnimationFrame(raf);
        window.removeEventListener('blur', onBlur, true);
        window.removeEventListener('focusout', onFocusOut, true);
        window.removeEventListener('focusin', onFocusIn, true);
        window.removeEventListener('focus', onFocus, true);
        $7fc007d8fdcfe19c$export$fda7da73ab5d4c48 = false;
        isRefocusing = false;
    };
    let raf = requestAnimationFrame(cleanup);
    return cleanup;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c0699bc5a0b3191f$var$$c87311424ea30a05$var$testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === 'undefined' || window.navigator == null) return false;
    let brands = (_window_navigator_userAgentData = window.navigator['userAgentData']) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands;
    return Array.isArray(brands) && brands.some((brand)=>re.test(brand.brand)) || re.test(window.navigator.userAgent);
}
function $c0699bc5a0b3191f$var$$c87311424ea30a05$var$testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator['userAgentData']) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $c0699bc5a0b3191f$var$$c87311424ea30a05$var$cached(fn) {
    let res = null;
    return ()=>{
        if (res == null) res = fn();
        return res;
    };
}
const $c0699bc5a0b3191f$export$9ac100e40613ea10 = $c0699bc5a0b3191f$var$$c87311424ea30a05$var$cached(function() {
    return $c0699bc5a0b3191f$var$$c87311424ea30a05$var$testPlatform(/^Mac/i);
});
const $c0699bc5a0b3191f$export$186c6964ca17d99 = $c0699bc5a0b3191f$var$$c87311424ea30a05$var$cached(function() {
    return $c0699bc5a0b3191f$var$$c87311424ea30a05$var$testPlatform(/^iPhone/i);
});
const $c0699bc5a0b3191f$export$7bef049ce92e4224 = $c0699bc5a0b3191f$var$$c87311424ea30a05$var$cached(function() {
    return $c0699bc5a0b3191f$var$$c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $c0699bc5a0b3191f$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
});
const $c0699bc5a0b3191f$export$fedb369cb70207f1 = $c0699bc5a0b3191f$var$$c87311424ea30a05$var$cached(function() {
    return $c0699bc5a0b3191f$export$186c6964ca17d99() || $c0699bc5a0b3191f$export$7bef049ce92e4224();
});
const $c0699bc5a0b3191f$export$e1865c3bedcd822b = $c0699bc5a0b3191f$var$$c87311424ea30a05$var$cached(function() {
    return $c0699bc5a0b3191f$export$9ac100e40613ea10() || $c0699bc5a0b3191f$export$fedb369cb70207f1();
});
const $c0699bc5a0b3191f$export$78551043582a6a98 = $c0699bc5a0b3191f$var$$c87311424ea30a05$var$cached(function() {
    return $c0699bc5a0b3191f$var$$c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$c0699bc5a0b3191f$export$6446a186d09e379e();
});
const $c0699bc5a0b3191f$export$6446a186d09e379e = $c0699bc5a0b3191f$var$$c87311424ea30a05$var$cached(function() {
    return $c0699bc5a0b3191f$var$$c87311424ea30a05$var$testUserAgent(/Chrome/i);
});
const $c0699bc5a0b3191f$export$a11b0059900ceec8 = $c0699bc5a0b3191f$var$$c87311424ea30a05$var$cached(function() {
    return $c0699bc5a0b3191f$var$$c87311424ea30a05$var$testUserAgent(/Android/i);
});
const $c0699bc5a0b3191f$export$b7d78993b74f766d = $c0699bc5a0b3191f$var$$c87311424ea30a05$var$cached(function() {
    return $c0699bc5a0b3191f$var$$c87311424ea30a05$var$testUserAgent(/Firefox/i);
});


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6fcd80e55e680740$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.pointerType === '' && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ((0, $c0699bc5a0b3191f$export$a11b0059900ceec8)() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $6fcd80e55e680740$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !(0, $c0699bc5a0b3191f$export$a11b0059900ceec8)() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse';
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c9b835cc9e261550$var$$ea8dcbcb9ea1b556$var$RouterContext = (0, $acw62.createContext)({
    isNative: true,
    open: $c9b835cc9e261550$var$$ea8dcbcb9ea1b556$var$openSyntheticLink,
    useHref: (href)=>href
});
function $c9b835cc9e261550$export$323e4fc2fa4753fb(props) {
    let { children: children, navigate: navigate, useHref: useHref } = props;
    let ctx = (0, $acw62.useMemo)(()=>({
            isNative: false,
            open: (target, modifiers, href, routerOptions)=>{
                $c9b835cc9e261550$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, (link)=>{
                    if ($c9b835cc9e261550$export$efa8c9099e530235(link, modifiers)) navigate(href, routerOptions);
                    else $c9b835cc9e261550$export$95185d699e05d4d7(link, modifiers);
                });
            },
            useHref: useHref || ((href)=>href)
        }), [
        navigate,
        useHref
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c9b835cc9e261550$var$$ea8dcbcb9ea1b556$var$RouterContext.Provider, {
        value: ctx
    }, children);
}
function $c9b835cc9e261550$export$9a302a45f65d0572() {
    return (0, $acw62.useContext)($c9b835cc9e261550$var$$ea8dcbcb9ea1b556$var$RouterContext);
}
function $c9b835cc9e261550$export$efa8c9099e530235(link, modifiers) {
    // Use getAttribute here instead of link.target. Firefox will default link.target to "_parent" when inside an iframe.
    let target = link.getAttribute('target');
    return (!target || target === '_self') && link.origin === location.origin && !link.hasAttribute('download') && !modifiers.metaKey && // open in new tab (mac)
    !modifiers.ctrlKey && // open in new tab (windows)
    !modifiers.altKey && // download
    !modifiers.shiftKey;
}
function $c9b835cc9e261550$export$95185d699e05d4d7(target, modifiers, setOpening = true) {
    var _window_event_type, _window_event;
    let { metaKey: metaKey, ctrlKey: ctrlKey, altKey: altKey, shiftKey: shiftKey } = modifiers;
    // Firefox does not recognize keyboard events as a user action by default, and the popup blocker
    // will prevent links with target="_blank" from opening. However, it does allow the event if the
    // Command/Control key is held, which opens the link in a background tab. This seems like the best we can do.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=257870 and https://bugzilla.mozilla.org/show_bug.cgi?id=746640.
    if ((0, $c0699bc5a0b3191f$export$b7d78993b74f766d)() && ((_window_event = window.event) === null || _window_event === void 0 ? void 0 : (_window_event_type = _window_event.type) === null || _window_event_type === void 0 ? void 0 : _window_event_type.startsWith('key')) && target.target === '_blank') {
        if ((0, $c0699bc5a0b3191f$export$9ac100e40613ea10)()) metaKey = true;
        else ctrlKey = true;
    }
    // WebKit does not support firing click events with modifier keys, but does support keyboard events.
    // https://github.com/WebKit/WebKit/blob/c03d0ac6e6db178f90923a0a63080b5ca210d25f/Source/WebCore/html/HTMLAnchorElement.cpp#L184
    let event = (0, $c0699bc5a0b3191f$export$78551043582a6a98)() && (0, $c0699bc5a0b3191f$export$9ac100e40613ea10)() && !(0, $c0699bc5a0b3191f$export$7bef049ce92e4224)() && true ? new KeyboardEvent('keydown', {
        keyIdentifier: 'Enter',
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey
    }) : new MouseEvent('click', {
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey,
        detail: 1,
        bubbles: true,
        cancelable: true
    });
    $c9b835cc9e261550$export$95185d699e05d4d7.isOpening = setOpening;
    (0, $4623aa9f87f28cd4$export$de79e2c695e052f3)(target);
    target.dispatchEvent(event);
    $c9b835cc9e261550$export$95185d699e05d4d7.isOpening = false;
}
// https://github.com/parcel-bundler/parcel/issues/8724
$c9b835cc9e261550$export$95185d699e05d4d7.isOpening = false;
function $c9b835cc9e261550$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, open) {
    if (target instanceof HTMLAnchorElement) open(target);
    else if (target.hasAttribute('data-href')) {
        let link = document.createElement('a');
        link.href = target.getAttribute('data-href');
        if (target.hasAttribute('data-target')) link.target = target.getAttribute('data-target');
        if (target.hasAttribute('data-rel')) link.rel = target.getAttribute('data-rel');
        if (target.hasAttribute('data-download')) link.download = target.getAttribute('data-download');
        if (target.hasAttribute('data-ping')) link.ping = target.getAttribute('data-ping');
        if (target.hasAttribute('data-referrer-policy')) link.referrerPolicy = target.getAttribute('data-referrer-policy');
        target.appendChild(link);
        open(link);
        target.removeChild(link);
    }
}
function $c9b835cc9e261550$var$$ea8dcbcb9ea1b556$var$openSyntheticLink(target, modifiers) {
    $c9b835cc9e261550$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, (link)=>$c9b835cc9e261550$export$95185d699e05d4d7(link, modifiers));
}
function $c9b835cc9e261550$export$bdc77b0c0a3a85d6(props) {
    let router = $c9b835cc9e261550$export$9a302a45f65d0572();
    var _props_href;
    const href = router.useHref((_props_href = props.href) !== null && _props_href !== void 0 ? _props_href : '');
    return {
        'data-href': props.href ? href : undefined,
        'data-target': props.target,
        'data-rel': props.rel,
        'data-download': props.download,
        'data-ping': props.ping,
        'data-referrer-policy': props.referrerPolicy
    };
}
function $c9b835cc9e261550$export$51437d503373d223(props) {
    return {
        'data-href': props.href,
        'data-target': props.target,
        'data-rel': props.rel,
        'data-download': props.download,
        'data-ping': props.ping,
        'data-referrer-policy': props.referrerPolicy
    };
}
function $c9b835cc9e261550$export$7e924b3091a3bd18(props) {
    let router = $c9b835cc9e261550$export$9a302a45f65d0572();
    var _props_href;
    const href = router.useHref((_props_href = props === null || props === void 0 ? void 0 : props.href) !== null && _props_href !== void 0 ? _props_href : '');
    return {
        href: (props === null || props === void 0 ? void 0 : props.href) ? href : undefined,
        target: props === null || props === void 0 ? void 0 : props.target,
        rel: props === null || props === void 0 ? void 0 : props.rel,
        download: props === null || props === void 0 ? void 0 : props.download,
        ping: props === null || props === void 0 ? void 0 : props.ping,
        referrerPolicy: props === null || props === void 0 ? void 0 : props.referrerPolicy
    };
}
function $c9b835cc9e261550$export$13aea1a3cb5e3f1f(e, router, href, routerOptions) {
    // If a custom router is provided, prevent default and forward if this link should client navigate.
    if (!router.isNative && e.currentTarget instanceof HTMLAnchorElement && e.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
    !e.isDefaultPrevented() && $c9b835cc9e261550$export$efa8c9099e530235(e.currentTarget, e) && href) {
        e.preventDefault();
        router.open(e.currentTarget, e, href, routerOptions);
    }
}



var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$currentModality = null;
let $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$currentPointerType = 'keyboard';
let $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $77c8ff0a3cb27e18$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $c0699bc5a0b3191f$export$9ac100e40613ea10)() && e.altKey || e.ctrlKey || e.key === 'Control' || e.key === 'Shift' || e.key === 'Meta');
}
function $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if (!(0, $c9b835cc9e261550$export$95185d699e05d4d7).isOpening && $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$currentModality = 'keyboard';
        $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$currentPointerType = 'keyboard';
        $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$triggerChangeHandlers('keyboard', e);
    }
}
function $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$currentModality = 'pointer';
    $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$currentPointerType = 'pointerType' in e ? e.pointerType : 'mouse';
    if (e.type === 'mousedown' || e.type === 'pointerdown') {
        $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$triggerChangeHandlers('pointer', e);
    }
}
function $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if (!(0, $c9b835cc9e261550$export$95185d699e05d4d7).isOpening && (0, $6fcd80e55e680740$export$60278871457622de)(e)) {
        $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$currentModality = 'virtual';
        $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$currentPointerType = 'virtual';
    }
}
function $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document || (0, $7fc007d8fdcfe19c$export$fda7da73ab5d4c48) || !e.isTrusted) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$currentModality = 'virtual';
        $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$currentPointerType = 'virtual';
        $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$triggerChangeHandlers('virtual', e);
    }
    $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    if (0, $7fc007d8fdcfe19c$export$fda7da73ab5d4c48) return;
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === 'undefined' || typeof document === 'undefined' || $77c8ff0a3cb27e18$export$d90243b58daecda7.get((0, $48852fd65b79e251$export$f21a1ffae260145a)(element))) return;
    const windowObject = (0, $48852fd65b79e251$export$f21a1ffae260145a)(element);
    const documentObject = (0, $48852fd65b79e251$export$b204af158042fbac)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener('keydown', $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener('keyup', $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener('click', $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener('focus', $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener('blur', $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        documentObject.addEventListener('pointerdown', $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener('pointermove', $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener('pointerup', $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener('beforeunload', ()=>{
        $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $77c8ff0a3cb27e18$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $48852fd65b79e251$export$f21a1ffae260145a)(element);
    const documentObject = (0, $48852fd65b79e251$export$b204af158042fbac)(element);
    if (loadListener) documentObject.removeEventListener('DOMContentLoaded', loadListener);
    if (!$77c8ff0a3cb27e18$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $77c8ff0a3cb27e18$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener('keydown', $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener('keyup', $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener('click', $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener('focus', $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener('blur', $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        documentObject.removeEventListener('pointerdown', $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener('pointermove', $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener('pointerup', $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $77c8ff0a3cb27e18$export$d90243b58daecda7.delete(windowObject);
};
function $77c8ff0a3cb27e18$export$2f1888112f558a7d(element) {
    const documentObject = (0, $48852fd65b79e251$export$b204af158042fbac)(element);
    let loadListener;
    if (documentObject.readyState !== 'loading') $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener('DOMContentLoaded', loadListener);
    }
    return ()=>$77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== 'undefined') $77c8ff0a3cb27e18$export$2f1888112f558a7d();
function $77c8ff0a3cb27e18$export$b9b3dfddab17db27() {
    return $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$currentModality !== 'pointer';
}
function $77c8ff0a3cb27e18$export$630ff653c5ada6a9() {
    return $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$currentModality;
}
function $77c8ff0a3cb27e18$export$8397ddfc504fdb9a(modality) {
    $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$currentModality = modality;
    $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$currentPointerType = modality === 'pointer' ? 'mouse' : modality;
    $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $77c8ff0a3cb27e18$export$887a228355cf7d95() {
    return $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$currentPointerType;
}
function $77c8ff0a3cb27e18$export$98e20ec92f614cfe() {
    $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $acw62.useState)($77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$currentModality);
    (0, $acw62.useEffect)(()=>{
        let handler = ()=>{
            setModality($77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$currentModality);
        };
        $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $3355288d61aeabc2$export$535bd6ca7f90a273)() ? null : modality;
}
const $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    let document1 = (0, $48852fd65b79e251$export$b204af158042fbac)(e === null || e === void 0 ? void 0 : e.target);
    const IHTMLInputElement = typeof window !== 'undefined' ? (0, $48852fd65b79e251$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== 'undefined' ? (0, $48852fd65b79e251$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== 'undefined' ? (0, $48852fd65b79e251$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== 'undefined' ? (0, $48852fd65b79e251$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    // For keyboard events that occur on a non-input element that will move focus into input element (aka ArrowLeft going from Datepicker button to the main input group)
    // we need to rely on the user passing isTextInput into here. This way we can skip toggling focus visiblity for said input element
    isTextInput = isTextInput || document1.activeElement instanceof IHTMLInputElement && !$77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(document1.activeElement.type) || document1.activeElement instanceof IHTMLTextAreaElement || document1.activeElement instanceof IHTMLElement && document1.activeElement.isContentEditable;
    return !(isTextInput && modality === 'keyboard' && e instanceof IKeyboardEvent && !$77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $77c8ff0a3cb27e18$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $acw62.useState)(autoFocus || $77c8ff0a3cb27e18$export$b9b3dfddab17db27());
    $77c8ff0a3cb27e18$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $77c8ff0a3cb27e18$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $acw62.useEffect)(()=>{
        let handler = (modality, e)=>{
            // We want to early return for any keyboard events that occur inside text inputs EXCEPT for Tab and Escape
            if (!$77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($77c8ff0a3cb27e18$export$b9b3dfddab17db27());
        };
        $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $77c8ff0a3cb27e18$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}



var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $9a3b4c8fe6846e35$var$$f4e2df6bd15f8569$var$_tableNestedRows = false;
let $9a3b4c8fe6846e35$var$$f4e2df6bd15f8569$var$_shadowDOM = false;
function $9a3b4c8fe6846e35$export$d9d8a0f82de49530() {
    $9a3b4c8fe6846e35$var$$f4e2df6bd15f8569$var$_tableNestedRows = true;
}
function $9a3b4c8fe6846e35$export$1b00cb14a96194e6() {
    return $9a3b4c8fe6846e35$var$$f4e2df6bd15f8569$var$_tableNestedRows;
}
function $9a3b4c8fe6846e35$export$12b151d9882e9985() {
    $9a3b4c8fe6846e35$var$$f4e2df6bd15f8569$var$_shadowDOM = true;
}
function $9a3b4c8fe6846e35$export$98658e8c59125e6a() {
    return $9a3b4c8fe6846e35$var$$f4e2df6bd15f8569$var$_shadowDOM;
}


// Source: https://github.com/microsoft/tabster/blob/a89fc5d7e332d48f68d03b1ca6e344489d1c3898/src/Shadowdomize/DOMFunctions.ts#L16
function $bc46b52522f8f24d$export$4282f70798064fe0(node, otherNode) {
    if (!(0, $9a3b4c8fe6846e35$export$98658e8c59125e6a)()) return otherNode && node ? node.contains(otherNode) : false;
    if (!node || !otherNode) return false;
    let currentNode = otherNode;
    while(currentNode !== null){
        if (currentNode === node) return true;
        if (currentNode.tagName === 'SLOT' && currentNode.assignedSlot) currentNode = currentNode.assignedSlot.parentNode;
        else if ((0, $48852fd65b79e251$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
        else currentNode = currentNode.parentNode;
    }
    return false;
}
const $bc46b52522f8f24d$export$cd4e5573fbe2b576 = (doc = document)=>{
    var _activeElement_shadowRoot;
    if (!(0, $9a3b4c8fe6846e35$export$98658e8c59125e6a)()) return doc.activeElement;
    let activeElement = doc.activeElement;
    while(activeElement && 'shadowRoot' in activeElement && ((_activeElement_shadowRoot = activeElement.shadowRoot) === null || _activeElement_shadowRoot === void 0 ? void 0 : _activeElement_shadowRoot.activeElement))activeElement = activeElement.shadowRoot.activeElement;
    return activeElement;
};
function $bc46b52522f8f24d$export$e58f029f0fbfdb29(event) {
    if ((0, $9a3b4c8fe6846e35$export$98658e8c59125e6a)() && event.target.shadowRoot) {
        if (event.composedPath) return event.composedPath()[0];
    }
    return event.target;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $7cd244a03c8a5e7a$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $acw62.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $7fc007d8fdcfe19c$export$715c682d09d639cc)(onBlur);
    const onFocus = (0, $acw62.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $48852fd65b79e251$export$b204af158042fbac)(e.target);
        const activeElement = ownerDocument ? (0, $bc46b52522f8f24d$export$cd4e5573fbe2b576)(ownerDocument) : (0, $bc46b52522f8f24d$export$cd4e5573fbe2b576)();
        if (e.target === e.currentTarget && activeElement === (0, $bc46b52522f8f24d$export$e58f029f0fbfdb29)(e.nativeEvent)) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2dd678e31a4cc7e0$export$4eaf04e54aa8eed6() {
    let globalListeners = (0, $acw62.useRef)(new Map());
    let addGlobalListener = (0, $acw62.useCallback)((eventTarget, type, listener, options)=>{
        // Make sure we remove the listener after it is called with the `once` option.
        let fn = (options === null || options === void 0 ? void 0 : options.once) ? (...args)=>{
            globalListeners.current.delete(listener);
            listener(...args);
        } : listener;
        globalListeners.current.set(listener, {
            type: type,
            eventTarget: eventTarget,
            fn: fn,
            options: options
        });
        eventTarget.addEventListener(type, fn, options);
    }, []);
    let removeGlobalListener = (0, $acw62.useCallback)((eventTarget, type, listener, options)=>{
        var _globalListeners_current_get;
        let fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    let removeAllGlobalListeners = (0, $acw62.useCallback)(()=>{
        globalListeners.current.forEach((value, key)=>{
            removeGlobalListener(value.eventTarget, value.type, key, value.options);
        });
    }, [
        removeGlobalListener
    ]);
    (0, $acw62.useEffect)(()=>{
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener: addGlobalListener,
        removeGlobalListener: removeGlobalListener,
        removeAllGlobalListeners: removeAllGlobalListeners
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $02fb4773760e27fa$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $acw62.useRef)({
        isFocusWithin: false
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $2dd678e31a4cc7e0$export$4eaf04e54aa8eed6)();
    let onBlur = (0, $acw62.useCallback)((e)=>{
        // Ignore events bubbling through portals.
        if (!e.currentTarget.contains(e.target)) return;
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            removeAllGlobalListeners();
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state,
        removeAllGlobalListeners
    ]);
    let onSyntheticFocus = (0, $7fc007d8fdcfe19c$export$715c682d09d639cc)(onBlur);
    let onFocus = (0, $acw62.useCallback)((e)=>{
        // Ignore events bubbling through portals.
        if (!e.currentTarget.contains(e.target)) return;
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $48852fd65b79e251$export$b204af158042fbac)(e.target);
        const activeElement = (0, $bc46b52522f8f24d$export$cd4e5573fbe2b576)(ownerDocument);
        if (!state.current.isFocusWithin && activeElement === (0, $bc46b52522f8f24d$export$e58f029f0fbfdb29)(e.nativeEvent)) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
            // Browsers don't fire blur events when elements are removed from the DOM.
            // However, if a focus event occurs outside the element we're tracking, we
            // can manually fire onBlur.
            let currentTarget = e.currentTarget;
            addGlobalListener(ownerDocument, 'focus', (e)=>{
                if (state.current.isFocusWithin && !(0, $bc46b52522f8f24d$export$4282f70798064fe0)(currentTarget, e.target)) {
                    let nativeEvent = new ownerDocument.defaultView.FocusEvent('blur', {
                        relatedTarget: e.target
                    });
                    (0, $7fc007d8fdcfe19c$export$c2b7abe5d61ec696)(nativeEvent, currentTarget);
                    let event = (0, $7fc007d8fdcfe19c$export$525bc4921d56d4a)(nativeEvent);
                    onBlur(event);
                }
            }, {
                capture: true
            });
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus,
        addGlobalListener,
        onBlur
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These cannot be null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}



var $acw62 = parcelRequire("acw62");
function $da27ef38ba6b0ce3$export$4e328f61c538687f(props = {}) {
    let { autoFocus: autoFocus = false, isTextInput: isTextInput, within: within } = props;
    let state = (0, $acw62.useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || (0, $77c8ff0a3cb27e18$export$b9b3dfddab17db27)()
    });
    let [isFocused, setFocused] = (0, $acw62.useState)(false);
    let [isFocusVisibleState, setFocusVisible] = (0, $acw62.useState)(()=>state.current.isFocused && state.current.isFocusVisible);
    let updateState = (0, $acw62.useCallback)(()=>setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
    let onFocusChange = (0, $acw62.useCallback)((isFocused)=>{
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    (0, $77c8ff0a3cb27e18$export$ec71b4b83ac08ec3)((isFocusVisible)=>{
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput: isTextInput
    });
    let { focusProps: focusProps } = (0, $7cd244a03c8a5e7a$export$f8168d8dd8fd66e6)({
        isDisabled: within,
        onFocusChange: onFocusChange
    });
    let { focusWithinProps: focusWithinProps } = (0, $02fb4773760e27fa$export$420e68273165f4ec)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused: isFocused,
        isFocusVisible: isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $8d62ff0ac4dc2be2$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $8d62ff0ac4dc2be2$var$$6179b936705e76d3$var$hoverCount = 0;
function $8d62ff0ac4dc2be2$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $8d62ff0ac4dc2be2$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $8d62ff0ac4dc2be2$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $8d62ff0ac4dc2be2$var$$6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === 'touch') $8d62ff0ac4dc2be2$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $8d62ff0ac4dc2be2$var$$6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === 'undefined') return;
    if ($8d62ff0ac4dc2be2$var$$6179b936705e76d3$var$hoverCount === 0) {
        if (typeof PointerEvent !== 'undefined') document.addEventListener('pointerup', $8d62ff0ac4dc2be2$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    }
    $8d62ff0ac4dc2be2$var$$6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $8d62ff0ac4dc2be2$var$$6179b936705e76d3$var$hoverCount--;
        if ($8d62ff0ac4dc2be2$var$$6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== 'undefined') document.removeEventListener('pointerup', $8d62ff0ac4dc2be2$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    };
}
function $8d62ff0ac4dc2be2$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $acw62.useState)(false);
    let state = (0, $acw62.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: '',
        target: null
    }).current;
    (0, $acw62.useEffect)($8d62ff0ac4dc2be2$var$$6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $2dd678e31a4cc7e0$export$4eaf04e54aa8eed6)();
    let { hoverProps: hoverProps, triggerHoverEnd: triggerHoverEnd } = (0, $acw62.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === 'touch' || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            // When an element that is hovered over is removed, no pointerleave event is fired by the browser,
            // even though the originally hovered target may have shrunk in size so it is no longer hovered.
            // However, a pointerover event will be fired on the new target the mouse is over.
            // In Chrome this happens immediately. In Safari and Firefox, it happens upon moving the mouse one pixel.
            addGlobalListener((0, $48852fd65b79e251$export$b204af158042fbac)(event.target), 'pointerover', (e)=>{
                if (state.isHovered && state.target && !(0, $bc46b52522f8f24d$export$4282f70798064fe0)(state.target, e.target)) triggerHoverEnd(e, e.pointerType);
            }, {
                capture: true
            });
            if (onHoverStart) onHoverStart({
                type: 'hoverstart',
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            let target = state.target;
            state.pointerType = '';
            state.target = null;
            if (pointerType === 'touch' || !state.isHovered || !target) return;
            state.isHovered = false;
            removeAllGlobalListeners();
            if (onHoverEnd) onHoverEnd({
                type: 'hoverend',
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== 'undefined') {
            hoverProps.onPointerEnter = (e)=>{
                if ($8d62ff0ac4dc2be2$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === 'mouse') return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else var e, e1;
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state,
        addGlobalListener,
        removeAllGlobalListeners
    ]);
    (0, $acw62.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $ccd48495800651c4$export$37fb8590cf2c088c = (0, $acw62.createContext)({});
let $ccd48495800651c4$var$$3985021b0ad6602f$var$filterHoverProps = (props)=>{
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, ...otherProps } = props;
    return otherProps;
};
const $ccd48495800651c4$export$f5b8910cec6cf069 = (0, $73addfbf71cdc088$export$86427a43e3e48ebb)(function Input(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $ccd48495800651c4$export$37fb8590cf2c088c);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $8d62ff0ac4dc2be2$export$ae780daf29e6d456)({
        ...props,
        isDisabled: props.disabled
    });
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $da27ef38ba6b0ce3$export$4e328f61c538687f)({
        isTextInput: true,
        autoFocus: props.autoFocus
    });
    let isInvalid = !!props['aria-invalid'] && props['aria-invalid'] !== 'false';
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        ...props,
        values: {
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: props.disabled || false,
            isInvalid: isInvalid
        },
        defaultClassName: 'react-aria-Input'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)($ccd48495800651c4$var$$3985021b0ad6602f$var$filterHoverProps(props), focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        "data-focused": isFocused || undefined,
        "data-disabled": props.disabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-invalid": isInvalid || undefined
    });
});





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $424592b5daddcd29$export$9afb8bc826b033ea = (0, $acw62.createContext)({});
const $424592b5daddcd29$export$5f1af8db9871e1d6 = (0, $acw62.forwardRef)(function Text(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $424592b5daddcd29$export$9afb8bc826b033ea);
    let { elementType: ElementType = 'span', ...domProps } = props;
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ElementType, {
        className: "react-aria-Text",
        ...domProps,
        ref: ref
    });
});


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c2bab733f68d1f9c$var$$65484d02dcb7eb3e$var$DOMPropNames = new Set([
    'id'
]);
const $c2bab733f68d1f9c$var$$65484d02dcb7eb3e$var$labelablePropNames = new Set([
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-details'
]);
// See LinkDOMProps in dom.d.ts.
const $c2bab733f68d1f9c$var$$65484d02dcb7eb3e$var$linkPropNames = new Set([
    'href',
    'hrefLang',
    'target',
    'rel',
    'download',
    'ping',
    'referrerPolicy'
]);
const $c2bab733f68d1f9c$var$$65484d02dcb7eb3e$var$globalAttrs = new Set([
    'dir',
    'lang',
    'hidden',
    'inert',
    'translate'
]);
const $c2bab733f68d1f9c$var$$65484d02dcb7eb3e$var$globalEvents = new Set([
    'onClick',
    'onAuxClick',
    'onContextMenu',
    'onDoubleClick',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp',
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart',
    'onPointerDown',
    'onPointerMove',
    'onPointerUp',
    'onPointerCancel',
    'onPointerEnter',
    'onPointerLeave',
    'onPointerOver',
    'onPointerOut',
    'onGotPointerCapture',
    'onLostPointerCapture',
    'onScroll',
    'onWheel',
    'onAnimationStart',
    'onAnimationEnd',
    'onAnimationIteration',
    'onTransitionCancel',
    'onTransitionEnd',
    'onTransitionRun',
    'onTransitionStart'
]);
const $c2bab733f68d1f9c$var$$65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $c2bab733f68d1f9c$export$457c3d6518dd4c6f(props, opts = {}) {
    let { labelable: labelable, isLink: isLink, global: global, events: events = global, propNames: propNames } = opts;
    let filteredProps = {};
    for(const prop in props)if (Object.prototype.hasOwnProperty.call(props, prop) && ($c2bab733f68d1f9c$var$$65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $c2bab733f68d1f9c$var$$65484d02dcb7eb3e$var$labelablePropNames.has(prop) || isLink && $c2bab733f68d1f9c$var$$65484d02dcb7eb3e$var$linkPropNames.has(prop) || global && $c2bab733f68d1f9c$var$$65484d02dcb7eb3e$var$globalAttrs.has(prop) || events && ($c2bab733f68d1f9c$var$$65484d02dcb7eb3e$var$globalEvents.has(prop) || prop.endsWith('Capture') && $c2bab733f68d1f9c$var$$65484d02dcb7eb3e$var$globalEvents.has(prop.slice(0, -7))) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $c2bab733f68d1f9c$var$$65484d02dcb7eb3e$var$propRe.test(prop))) filteredProps[prop] = props[prop];
    return filteredProps;
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $7dd8b2fec65d8b6a$export$ff05c3ac10437e03 = (0, $acw62.createContext)(null);
const $7dd8b2fec65d8b6a$export$f551688fc98f2e09 = (0, $acw62.forwardRef)(function FieldError(props, ref) {
    let validation = (0, $acw62.useContext)($7dd8b2fec65d8b6a$export$ff05c3ac10437e03);
    if (!(validation === null || validation === void 0 ? void 0 : validation.isInvalid)) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7dd8b2fec65d8b6a$var$$ee014567cb39d3f0$var$FieldErrorInner, {
        ...props,
        ref: ref
    });
});
const $7dd8b2fec65d8b6a$var$$ee014567cb39d3f0$var$FieldErrorInner = (0, $acw62.forwardRef)((props, ref)=>{
    let validation = (0, $acw62.useContext)($7dd8b2fec65d8b6a$export$ff05c3ac10437e03);
    let domProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        ...props,
        defaultClassName: 'react-aria-FieldError',
        defaultChildren: validation.validationErrors.length === 0 ? undefined : validation.validationErrors.join(' '),
        values: validation
    });
    if (renderProps.children == null) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $424592b5daddcd29$export$5f1af8db9871e1d6), {
        slot: "errorMessage",
        ...domProps,
        ...renderProps,
        ref: ref
    });
});



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $11cc862e572cddbb$export$b085522c77523c51 = (0, $acw62.createContext)(null);
const $11cc862e572cddbb$export$ebe63fadcdce34ed = (0, $acw62.createContext)(null);
const $11cc862e572cddbb$export$44644b8a16031b5b = (0, $acw62.createContext)(null);
const $11cc862e572cddbb$export$717b2c0a523a0b53 = (0, $acw62.createContext)(null);
const $11cc862e572cddbb$export$265015d6dc85bf21 = (0, $acw62.createContext)(null);
const $11cc862e572cddbb$export$d688439359537581 = (0, $acw62.createContext)({});
const $11cc862e572cddbb$export$b0d3ecf7112093a7 = (0, $acw62.createContext)(null);
const $11cc862e572cddbb$export$698f465ec27e93df = (0, $acw62.createContext)(null);




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $bf01417b417639db$export$aca958c65c314e6c = {
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valueMissing: false,
    valid: true
};
const $bf01417b417639db$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE = {
    ...$bf01417b417639db$export$aca958c65c314e6c,
    customError: true,
    valid: false
};
const $bf01417b417639db$export$dad6ae84456c676a = {
    isInvalid: false,
    validationDetails: $bf01417b417639db$export$aca958c65c314e6c,
    validationErrors: []
};
const $bf01417b417639db$export$571b5131b7e65c11 = (0, $acw62.createContext)({});
const $bf01417b417639db$export$a763b9476acd3eb = '__formValidationState' + Date.now();
function $bf01417b417639db$export$fc1a364ae1f3ff10(props) {
    // Private prop for parent components to pass state to children.
    if (props[$bf01417b417639db$export$a763b9476acd3eb]) {
        let { realtimeValidation: realtimeValidation, displayValidation: displayValidation, updateValidation: updateValidation, resetValidation: resetValidation, commitValidation: commitValidation } = props[$bf01417b417639db$export$a763b9476acd3eb];
        return {
            realtimeValidation: realtimeValidation,
            displayValidation: displayValidation,
            updateValidation: updateValidation,
            resetValidation: resetValidation,
            commitValidation: commitValidation
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return $bf01417b417639db$var$$e5be200c675c3b3a$var$useFormValidationStateImpl(props);
}
function $bf01417b417639db$var$$e5be200c675c3b3a$var$useFormValidationStateImpl(props) {
    let { isInvalid: isInvalid, validationState: validationState, name: name, value: value, builtinValidation: builtinValidation, validate: validate, validationBehavior: validationBehavior = 'aria' } = props;
    // backward compatibility.
    if (validationState) isInvalid || (isInvalid = validationState === 'invalid');
    // If the isInvalid prop is controlled, update validation result in realtime.
    let controlledError = isInvalid !== undefined ? {
        isInvalid: isInvalid,
        validationErrors: [],
        validationDetails: $bf01417b417639db$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
    // Perform custom client side validation.
    let clientError = (0, $acw62.useMemo)(()=>{
        if (!validate || value == null) return null;
        let validateErrors = $bf01417b417639db$var$$e5be200c675c3b3a$var$runValidate(validate, value);
        return $bf01417b417639db$var$$e5be200c675c3b3a$var$getValidationResult(validateErrors);
    }, [
        validate,
        value
    ]);
    if (builtinValidation === null || builtinValidation === void 0 ? void 0 : builtinValidation.validationDetails.valid) builtinValidation = undefined;
    // Get relevant server errors from the form.
    let serverErrors = (0, $acw62.useContext)($bf01417b417639db$export$571b5131b7e65c11);
    let serverErrorMessages = (0, $acw62.useMemo)(()=>{
        if (name) return Array.isArray(name) ? name.flatMap((name)=>$bf01417b417639db$var$$e5be200c675c3b3a$var$asArray(serverErrors[name])) : $bf01417b417639db$var$$e5be200c675c3b3a$var$asArray(serverErrors[name]);
        return [];
    }, [
        serverErrors,
        name
    ]);
    // Show server errors when the form gets a new value, and clear when the user changes the value.
    let [lastServerErrors, setLastServerErrors] = (0, $acw62.useState)(serverErrors);
    let [isServerErrorCleared, setServerErrorCleared] = (0, $acw62.useState)(false);
    if (serverErrors !== lastServerErrors) {
        setLastServerErrors(serverErrors);
        setServerErrorCleared(false);
    }
    let serverError = (0, $acw62.useMemo)(()=>$bf01417b417639db$var$$e5be200c675c3b3a$var$getValidationResult(isServerErrorCleared ? [] : serverErrorMessages), [
        isServerErrorCleared,
        serverErrorMessages
    ]);
    // Track the next validation state in a ref until commitValidation is called.
    let nextValidation = (0, $acw62.useRef)($bf01417b417639db$export$dad6ae84456c676a);
    let [currentValidity, setCurrentValidity] = (0, $acw62.useState)($bf01417b417639db$export$dad6ae84456c676a);
    let lastError = (0, $acw62.useRef)($bf01417b417639db$export$dad6ae84456c676a);
    let commitValidation = ()=>{
        if (!commitQueued) return;
        setCommitQueued(false);
        let error = clientError || builtinValidation || nextValidation.current;
        if (!$bf01417b417639db$var$$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
            lastError.current = error;
            setCurrentValidity(error);
        }
    };
    let [commitQueued, setCommitQueued] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(commitValidation);
    // realtimeValidation is used to update the native input element's state based on custom validation logic.
    // displayValidation is the currently displayed validation state that the user sees (e.g. on input change/form submit).
    // With validationBehavior="aria", all errors are displayed in realtime rather than on submit.
    let realtimeValidation = controlledError || serverError || clientError || builtinValidation || $bf01417b417639db$export$dad6ae84456c676a;
    let displayValidation = validationBehavior === 'native' ? controlledError || serverError || currentValidity : controlledError || serverError || clientError || builtinValidation || currentValidity;
    return {
        realtimeValidation: realtimeValidation,
        displayValidation: displayValidation,
        updateValidation (value) {
            // If validationBehavior is 'aria', update in realtime. Otherwise, store in a ref until commit.
            if (validationBehavior === 'aria' && !$bf01417b417639db$var$$e5be200c675c3b3a$var$isEqualValidation(currentValidity, value)) setCurrentValidity(value);
            else nextValidation.current = value;
        },
        resetValidation () {
            // Update the currently displayed validation state to valid on form reset,
            // even if the native validity says it isn't. It'll show again on the next form submit.
            let error = $bf01417b417639db$export$dad6ae84456c676a;
            if (!$bf01417b417639db$var$$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
                lastError.current = error;
                setCurrentValidity(error);
            }
            // Do not commit validation after the next render. This avoids a condition where
            // useSelect calls commitValidation inside an onReset handler.
            if (validationBehavior === 'native') setCommitQueued(false);
            setServerErrorCleared(true);
        },
        commitValidation () {
            // Commit validation state so the user sees it on blur/change/submit. Also clear any server errors.
            // Wait until after the next render to commit so that the latest value has been validated.
            if (validationBehavior === 'native') setCommitQueued(true);
            setServerErrorCleared(true);
        }
    };
}
function $bf01417b417639db$var$$e5be200c675c3b3a$var$asArray(v) {
    if (!v) return [];
    return Array.isArray(v) ? v : [
        v
    ];
}
function $bf01417b417639db$var$$e5be200c675c3b3a$var$runValidate(validate, value) {
    if (typeof validate === 'function') {
        let e = validate(value);
        if (e && typeof e !== 'boolean') return $bf01417b417639db$var$$e5be200c675c3b3a$var$asArray(e);
    }
    return [];
}
function $bf01417b417639db$var$$e5be200c675c3b3a$var$getValidationResult(errors) {
    return errors.length ? {
        isInvalid: true,
        validationErrors: errors,
        validationDetails: $bf01417b417639db$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
}
function $bf01417b417639db$var$$e5be200c675c3b3a$var$isEqualValidation(a, b) {
    if (a === b) return true;
    return !!a && !!b && a.isInvalid === b.isInvalid && a.validationErrors.length === b.validationErrors.length && a.validationErrors.every((a, i)=>a === b.validationErrors[i]) && Object.entries(a.validationDetails).every(([k, v])=>b.validationDetails[k] === v);
}
function $bf01417b417639db$export$75ee7c75d68f5b0e(...results) {
    let errors = new Set();
    let isInvalid = false;
    let validationDetails = {
        ...$bf01417b417639db$export$aca958c65c314e6c
    };
    for (let v of results){
        var _validationDetails, _key;
        for (let e of v.validationErrors)errors.add(e);
        // Only these properties apply for checkboxes.
        isInvalid || (isInvalid = v.isInvalid);
        for(let key in validationDetails)(_validationDetails = validationDetails)[_key = key] || (_validationDetails[_key] = v.validationDetails[key]);
    }
    validationDetails.valid = !isInvalid;
    return {
        isInvalid: isInvalid,
        validationErrors: [
            ...errors
        ],
        validationDetails: validationDetails
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $99b9335b6cbca82a$export$c24727297075ec6a = (0, $acw62.createContext)(null);
const $99b9335b6cbca82a$export$a7fed597f4b8afd8 = (0, $acw62.forwardRef)(function Form(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $99b9335b6cbca82a$export$c24727297075ec6a);
    let { validationErrors: validationErrors, validationBehavior: validationBehavior = 'native', children: children, className: className, ...domProps } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        noValidate: validationBehavior !== 'native',
        ...domProps,
        ref: ref,
        className: className || 'react-aria-Form'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($99b9335b6cbca82a$export$c24727297075ec6a.Provider, {
        value: {
            ...props,
            validationBehavior: validationBehavior
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bf01417b417639db$export$571b5131b7e65c11).Provider, {
        value: validationErrors !== null && validationErrors !== void 0 ? validationErrors : {}
    }, children)));
});





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c1367d7afc3d8fbe$export$f9c6924e160136d1 = (0, $acw62.createContext)({});
const $c1367d7afc3d8fbe$export$eb2fcfdbd7ba97d4 = (0, $acw62.forwardRef)(function Group(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $c1367d7afc3d8fbe$export$f9c6924e160136d1);
    let { isDisabled: isDisabled, isInvalid: isInvalid, isReadOnly: isReadOnly, onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, ...otherProps } = props;
    isDisabled !== null && isDisabled !== void 0 ? isDisabled : isDisabled = !!props['aria-disabled'] && props['aria-disabled'] !== 'false';
    isInvalid !== null && isInvalid !== void 0 ? isInvalid : isInvalid = !!props['aria-invalid'] && props['aria-invalid'] !== 'false';
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $8d62ff0ac4dc2be2$export$ae780daf29e6d456)({
        onHoverStart: onHoverStart,
        onHoverChange: onHoverChange,
        onHoverEnd: onHoverEnd,
        isDisabled: isDisabled
    });
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $da27ef38ba6b0ce3$export$4e328f61c538687f)({
        within: true
    });
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        ...props,
        values: {
            isHovered: isHovered,
            isFocusWithin: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: isDisabled,
            isInvalid: isInvalid
        },
        defaultClassName: 'react-aria-Group'
    });
    var _props_role, _props_slot;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)(otherProps, focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        role: (_props_role = props.role) !== null && _props_role !== void 0 ? _props_role : 'group',
        slot: (_props_slot = props.slot) !== null && _props_slot !== void 0 ? _props_slot : undefined,
        "data-focus-within": isFocused || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined,
        "data-invalid": isInvalid || undefined,
        "data-readonly": isReadOnly || undefined
    }, renderProps.children);
});






var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $794346013ab6e680$export$75b6ee27786ba447 = (0, $acw62.createContext)({});
const $794346013ab6e680$export$b04be29aa201d4f5 = (0, $73addfbf71cdc088$export$86427a43e3e48ebb)(function Label(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $794346013ab6e680$export$75b6ee27786ba447);
    let { elementType: ElementType = 'label', ...labelProps } = props;
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ElementType, {
        className: "react-aria-Label",
        ...labelProps,
        ref: ref
    });
});





var $acw62 = parcelRequire("acw62");
const $cb65690869e135e6$export$2dc6166a7e65358c = (0, $acw62.createContext)({});
let $cb65690869e135e6$var$$216918bed6669f72$var$filterHoverProps = (props)=>{
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, ...otherProps } = props;
    return otherProps;
};
const $cb65690869e135e6$export$f5c9f3c2c4054eec = (0, $acw62.forwardRef)(function TextArea(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $cb65690869e135e6$export$2dc6166a7e65358c);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $8d62ff0ac4dc2be2$export$ae780daf29e6d456)(props);
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $da27ef38ba6b0ce3$export$4e328f61c538687f)({
        isTextInput: true,
        autoFocus: props.autoFocus
    });
    let isInvalid = !!props['aria-invalid'] && props['aria-invalid'] !== 'false';
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        ...props,
        values: {
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: props.disabled || false,
            isInvalid: isInvalid
        },
        defaultClassName: 'react-aria-TextArea'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
        ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)($cb65690869e135e6$var$$216918bed6669f72$var$filterHoverProps(props), focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        "data-focused": isFocused || undefined,
        "data-disabled": props.disabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-invalid": isInvalid || undefined
    });
});





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $92fff981738f62fe$var$$8ae05eaa5c114e9c$var$_React_useInsertionEffect;
// Use the earliest effect type possible. useInsertionEffect runs during the mutation phase,
// before all layout effects, but is available only in React 18 and later.
const $92fff981738f62fe$var$$8ae05eaa5c114e9c$var$useEarlyEffect = ($92fff981738f62fe$var$$8ae05eaa5c114e9c$var$_React_useInsertionEffect = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useInsertionEffect']) !== null && $92fff981738f62fe$var$$8ae05eaa5c114e9c$var$_React_useInsertionEffect !== void 0 ? $92fff981738f62fe$var$$8ae05eaa5c114e9c$var$_React_useInsertionEffect : (0, $38781589fd33010c$export$e5c5a5f917a5871c);
function $92fff981738f62fe$export$7f54fc3180508a52(fn) {
    const ref = (0, $acw62.useRef)(null);
    $92fff981738f62fe$var$$8ae05eaa5c114e9c$var$useEarlyEffect(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    // @ts-ignore
    return (0, $acw62.useCallback)((...args)=>{
        const f = ref.current;
        return f === null || f === void 0 ? void 0 : f(...args);
    }, []);
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7f099d759e9c1e4d$export$5add1d006293d136(ref, initialValue, onReset) {
    let handleReset = (0, $92fff981738f62fe$export$7f54fc3180508a52)(()=>{
        if (onReset) onReset(initialValue);
    });
    (0, $acw62.useEffect)(()=>{
        var _ref_current;
        let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        form === null || form === void 0 || form.addEventListener('reset', handleReset);
        return ()=>{
            form === null || form === void 0 || form.removeEventListener('reset', handleReset);
        };
    }, [
        ref
    ]);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $3316814d6906df5c$var$$458b0a5536c1a7cf$var$_React_useInsertionEffect;
// Use the earliest effect possible to reset the ref below.
const $3316814d6906df5c$var$$458b0a5536c1a7cf$var$useEarlyEffect = typeof document !== 'undefined' ? ($3316814d6906df5c$var$$458b0a5536c1a7cf$var$_React_useInsertionEffect = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useInsertionEffect']) !== null && $3316814d6906df5c$var$$458b0a5536c1a7cf$var$_React_useInsertionEffect !== void 0 ? $3316814d6906df5c$var$$458b0a5536c1a7cf$var$_React_useInsertionEffect : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect : ()=>{};
function $3316814d6906df5c$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    // Store the value in both state and a ref. The state value will only be used when uncontrolled.
    // The ref is used to track the most current value, which is passed to the function setState callback.
    let [stateValue, setStateValue] = (0, $acw62.useState)(value || defaultValue);
    let valueRef = (0, $acw62.useRef)(stateValue);
    let isControlledRef = (0, $acw62.useRef)(value !== undefined);
    let isControlled = value !== undefined;
    (0, $acw62.useEffect)(()=>{
        let wasControlled = isControlledRef.current;
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    // After each render, update the ref to the current value.
    // This ensures that the setState callback argument is reset.
    // Note: the effect should not have any dependencies so that controlled values always reset.
    let currentValue = isControlled ? value : stateValue;
    $3316814d6906df5c$var$$458b0a5536c1a7cf$var$useEarlyEffect(()=>{
        valueRef.current = currentValue;
    });
    let [, forceUpdate] = (0, $acw62.useReducer)(()=>({}), {});
    let setValue = (0, $acw62.useCallback)((value, ...args)=>{
        // @ts-ignore - TS doesn't know that T cannot be a function.
        let newValue = typeof value === 'function' ? value(valueRef.current) : value;
        if (!Object.is(valueRef.current, newValue)) {
            // Update the ref so that the next setState callback has the most recent value.
            valueRef.current = newValue;
            setStateValue(newValue);
            // Always trigger a re-render, even when controlled, so that the layout effect above runs to reset the value.
            forceUpdate();
            // Trigger onChange. Note that if setState is called multiple times in a single event,
            // onChange will be called for each one instead of only once.
            onChange === null || onChange === void 0 || onChange(newValue, ...args);
        }
    }, [
        onChange
    ]);
    return [
        currentValue,
        setValue
    ];
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ad7d494fae923873$export$d6875122194c7b44(props, defaultLabel) {
    let { id: id, 'aria-label': label, 'aria-labelledby': labelledBy } = props;
    // If there is both an aria-label and aria-labelledby,
    // combine them by pointing to the element itself.
    id = (0, $855de91ebb07800c$export$f680877a34711e37)(id);
    if (labelledBy && label) {
        let ids = new Set([
            id,
            ...labelledBy.trim().split(/\s+/)
        ]);
        labelledBy = [
            ...ids
        ].join(' ');
    } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(' ');
    // If no labels are provided, use the default
    if (!label && !labelledBy && defaultLabel) label = defaultLabel;
    return {
        id: id,
        'aria-label': label,
        'aria-labelledby': labelledBy
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7db7643eb43655f9$export$8467354a121f1b9f(props) {
    let { id: id, label: label, 'aria-labelledby': ariaLabelledby, 'aria-label': ariaLabel, labelElementType: labelElementType = 'label' } = props;
    id = (0, $855de91ebb07800c$export$f680877a34711e37)(id);
    let labelId = (0, $855de91ebb07800c$export$f680877a34711e37)();
    let labelProps = {};
    if (label) {
        ariaLabelledby = ariaLabelledby ? `${labelId} ${ariaLabelledby}` : labelId;
        labelProps = {
            id: labelId,
            htmlFor: labelElementType === 'label' ? id : undefined
        };
    } else !ariaLabelledby && ariaLabel;
    let fieldProps = (0, $ad7d494fae923873$export$d6875122194c7b44)({
        id: id,
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledby
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps
    };
}



/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $54c383c3558c03c1$export$294aa081a6c6f55d(props) {
    let { description: description, errorMessage: errorMessage, isInvalid: isInvalid, validationState: validationState } = props;
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $7db7643eb43655f9$export$8467354a121f1b9f)(props);
    let descriptionId = (0, $855de91ebb07800c$export$b4cc09c592e8fdb8)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    let errorMessageId = (0, $855de91ebb07800c$export$b4cc09c592e8fdb8)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    fieldProps = (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(fieldProps, {
        'aria-describedby': [
            descriptionId,
            // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
            errorMessageId,
            props['aria-describedby']
        ].filter(Boolean).join(' ') || undefined
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps,
        descriptionProps: {
            id: descriptionId
        },
        errorMessageProps: {
            id: errorMessageId
        }
    };
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
let $2ce58204783d6986$var$$bbed8b41f857bcc0$var$transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
let $2ce58204783d6986$var$$bbed8b41f857bcc0$var$transitionCallbacks = new Set();
function $2ce58204783d6986$var$$bbed8b41f857bcc0$var$setupGlobalEvents() {
    if (typeof window === 'undefined') return;
    function isTransitionEvent(event) {
        return 'propertyName' in event;
    }
    let onTransitionStart = (e)=>{
        if (!isTransitionEvent(e) || !e.target) return;
        // Add the transitioning property to the list for this element.
        let transitions = $2ce58204783d6986$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!transitions) {
            transitions = new Set();
            $2ce58204783d6986$var$$bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions);
            // The transitioncancel event must be registered on the element itself, rather than as a global
            // event. This enables us to handle when the node is deleted from the document while it is transitioning.
            // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
            e.target.addEventListener('transitioncancel', onTransitionEnd, {
                once: true
            });
        }
        transitions.add(e.propertyName);
    };
    let onTransitionEnd = (e)=>{
        if (!isTransitionEvent(e) || !e.target) return;
        // Remove property from list of transitioning properties.
        let properties = $2ce58204783d6986$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!properties) return;
        properties.delete(e.propertyName);
        // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
        if (properties.size === 0) {
            e.target.removeEventListener('transitioncancel', onTransitionEnd);
            $2ce58204783d6986$var$$bbed8b41f857bcc0$var$transitionsByElement.delete(e.target);
        }
        // If no transitioning elements, call all of the queued callbacks.
        if ($2ce58204783d6986$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
            for (let cb of $2ce58204783d6986$var$$bbed8b41f857bcc0$var$transitionCallbacks)cb();
            $2ce58204783d6986$var$$bbed8b41f857bcc0$var$transitionCallbacks.clear();
        }
    };
    document.body.addEventListener('transitionrun', onTransitionStart);
    document.body.addEventListener('transitionend', onTransitionEnd);
}
if (typeof document !== 'undefined') {
    if (document.readyState !== 'loading') $2ce58204783d6986$var$$bbed8b41f857bcc0$var$setupGlobalEvents();
    else document.addEventListener('DOMContentLoaded', $2ce58204783d6986$var$$bbed8b41f857bcc0$var$setupGlobalEvents);
}
/**
 * Cleans up any elements that are no longer in the document.
 * This is necessary because we can't rely on transitionend events to fire
 * for elements that are removed from the document while transitioning.
 */ function $2ce58204783d6986$var$$bbed8b41f857bcc0$var$cleanupDetachedElements() {
    for (const [eventTarget] of $2ce58204783d6986$var$$bbed8b41f857bcc0$var$transitionsByElement)// the explicit instanceof check, since it may be different in different contexts.
    if ('isConnected' in eventTarget && !eventTarget.isConnected) $2ce58204783d6986$var$$bbed8b41f857bcc0$var$transitionsByElement.delete(eventTarget);
}
function $2ce58204783d6986$export$24490316f764c430(fn) {
    // Wait one frame to see if an animation starts, e.g. a transition on mount.
    requestAnimationFrame(()=>{
        $2ce58204783d6986$var$$bbed8b41f857bcc0$var$cleanupDetachedElements();
        // If no transitions are running, call the function immediately.
        // Otherwise, add it to a list of callbacks to run at the end of the animation.
        if ($2ce58204783d6986$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();
        else $2ce58204783d6986$var$$bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
    });
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f84e6bd16978dcef$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $48852fd65b79e251$export$b204af158042fbac)(element);
    if ((0, $77c8ff0a3cb27e18$export$630ff653c5ada6a9)() === 'virtual') {
        let lastFocusedElement = (0, $bc46b52522f8f24d$export$cd4e5573fbe2b576)(ownerDocument);
        (0, $2ce58204783d6986$export$24490316f764c430)(()=>{
            const activeElement = (0, $bc46b52522f8f24d$export$cd4e5573fbe2b576)(ownerDocument);
            // If focus did not move or focus was lost to the body, and the element is still in the document, focus it.
            if ((activeElement === lastFocusedElement || activeElement === ownerDocument.body) && element.isConnected) (0, $4623aa9f87f28cd4$export$de79e2c695e052f3)(element);
        });
    } else (0, $4623aa9f87f28cd4$export$de79e2c695e052f3)(element);
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $911ec5368a921f1f$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                shouldStopPropagation = true;
            },
            continuePropagation () {
                shouldStopPropagation = false;
            },
            isPropagationStopped () {
                return shouldStopPropagation;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $72b9a5e52bb6271d$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: (0, $911ec5368a921f1f$export$48d1ea6320830260)(props.onKeyDown),
            onKeyUp: (0, $911ec5368a921f1f$export$48d1ea6320830260)(props.onKeyUp)
        }
    };
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6a29d2bb7f5a367f$export$4debdb1a3f0fa79e(context, ref) {
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        if (context && context.ref && ref) {
            context.ref.current = ref.current;
            return ()=>{
                if (context.ref) context.ref.current = null;
            };
        }
    });
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $daedc3252d285a56$export$f9762fab77588ecb = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $daedc3252d285a56$var$$f645667febf57a63$var$useFocusableContext(ref) {
    let context = (0, $acw62.useContext)($daedc3252d285a56$export$f9762fab77588ecb) || {};
    (0, $6a29d2bb7f5a367f$export$4debdb1a3f0fa79e)(context, ref);
    // eslint-disable-next-line
    let { ref: _, ...otherProps } = context;
    return otherProps;
}
const $daedc3252d285a56$export$13f3202a3e5ddd5 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function FocusableProvider(props, ref) {
    let { children: children, ...otherProps } = props;
    let objRef = (0, $426ce7b4b2df0896$export$4338b53315abf666)(ref);
    let context = {
        ...otherProps,
        ref: objRef
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($daedc3252d285a56$export$f9762fab77588ecb.Provider, {
        value: context
    }, children);
});
function $daedc3252d285a56$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps } = (0, $7cd244a03c8a5e7a$export$f8168d8dd8fd66e6)(props);
    let { keyboardProps: keyboardProps } = (0, $72b9a5e52bb6271d$export$8f71654801c2f7cd)(props);
    let interactions = (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(focusProps, keyboardProps);
    let domProps = $daedc3252d285a56$var$$f645667febf57a63$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (0, $acw62.useRef)(props.autoFocus);
    (0, $acw62.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) (0, $f84e6bd16978dcef$export$80f3e147d781571c)(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    // Always set a tabIndex so that Safari allows focusing native buttons and inputs.
    let tabIndex = props.excludeFromTabOrder ? -1 : 0;
    if (props.isDisabled) tabIndex = undefined;
    return {
        focusableProps: (0, $e611552c564dfe1f$export$9d1611c77c2fe928)({
            ...interactions,
            tabIndex: tabIndex
        }, interactionProps)
    };
}
const $daedc3252d285a56$export$35a3bebf7ef2d934 = (0, $acw62.forwardRef)(({ children: children, ...props }, ref)=>{
    ref = (0, $426ce7b4b2df0896$export$4338b53315abf666)(ref);
    let { focusableProps: focusableProps } = $daedc3252d285a56$export$4c014de7c8940b4c(props, ref);
    let child = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children);
    (0, $acw62.useEffect)(()=>{
        return;
    }, [
        ref,
        props.isDisabled
    ]);
    // @ts-ignore
    let childRef = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version, 10) < 19 ? child.ref : child.props.ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
        ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)(focusableProps, child.props),
        // @ts-ignore
        ref: (0, $27215adb76b33250$export$c9058316764c140e)(childRef, ref)
    });
});




var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $13ce3eede8664ea0$export$b8473d3665f3a75a(props, state, ref) {
    let { validationBehavior: validationBehavior, focus: focus } = props;
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        if (validationBehavior === 'native' && (ref === null || ref === void 0 ? void 0 : ref.current) && !ref.current.disabled) {
            let errorMessage = state.realtimeValidation.isInvalid ? state.realtimeValidation.validationErrors.join(' ') || 'Invalid value.' : '';
            ref.current.setCustomValidity(errorMessage);
            // Prevent default tooltip for validation message.
            // https://bugzilla.mozilla.org/show_bug.cgi?id=605277
            if (!ref.current.hasAttribute('title')) ref.current.title = '';
            if (!state.realtimeValidation.isInvalid) state.updateValidation($13ce3eede8664ea0$var$$e93e671b31057976$var$getNativeValidity(ref.current));
        }
    });
    let isIgnoredReset = (0, $acw62.useRef)(false);
    let onReset = (0, $92fff981738f62fe$export$7f54fc3180508a52)(()=>{
        if (!isIgnoredReset.current) state.resetValidation();
    });
    let onInvalid = (0, $92fff981738f62fe$export$7f54fc3180508a52)((e)=>{
        var _ref_current;
        // Only commit validation if we are not already displaying one.
        // This avoids clearing server errors that the user didn't actually fix.
        if (!state.displayValidation.isInvalid) state.commitValidation();
        // Auto focus the first invalid input in a form, unless the error already had its default prevented.
        let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        if (!e.defaultPrevented && ref && form && $13ce3eede8664ea0$var$$e93e671b31057976$var$getFirstInvalidInput(form) === ref.current) {
            var _ref_current1;
            if (focus) focus();
            else (_ref_current1 = ref.current) === null || _ref_current1 === void 0 || _ref_current1.focus();
            (0, $77c8ff0a3cb27e18$export$8397ddfc504fdb9a)('keyboard');
        }
        // Prevent default browser error UI from appearing.
        e.preventDefault();
    });
    let onChange = (0, $92fff981738f62fe$export$7f54fc3180508a52)(()=>{
        state.commitValidation();
    });
    (0, $acw62.useEffect)(()=>{
        let input = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!input) return;
        let form = input.form;
        let reset = form === null || form === void 0 ? void 0 : form.reset;
        if (form) // validation errors that are returned by server actions.
        // To do this, we ignore programmatic form resets that occur outside a user event.
        // This is best-effort. There may be false positives, e.g. setTimeout.
        form.reset = ()=>{
            // React uses MessageChannel for scheduling, so ignore 'message' events.
            isIgnoredReset.current = !window.event || window.event.type === 'message' && window.event.target instanceof MessagePort;
            reset === null || reset === void 0 || reset.call(form);
            isIgnoredReset.current = false;
        };
        input.addEventListener('invalid', onInvalid);
        input.addEventListener('change', onChange);
        form === null || form === void 0 || form.addEventListener('reset', onReset);
        return ()=>{
            input.removeEventListener('invalid', onInvalid);
            input.removeEventListener('change', onChange);
            form === null || form === void 0 || form.removeEventListener('reset', onReset);
            if (form) form.reset = reset;
        };
    }, [
        ref,
        validationBehavior
    ]);
}
function $13ce3eede8664ea0$var$$e93e671b31057976$var$getValidity(input) {
    // The native ValidityState object is live, meaning each property is a getter that returns the current state.
    // We need to create a snapshot of the validity state at the time this function is called to avoid unpredictable React renders.
    let validity = input.validity;
    return {
        badInput: validity.badInput,
        customError: validity.customError,
        patternMismatch: validity.patternMismatch,
        rangeOverflow: validity.rangeOverflow,
        rangeUnderflow: validity.rangeUnderflow,
        stepMismatch: validity.stepMismatch,
        tooLong: validity.tooLong,
        tooShort: validity.tooShort,
        typeMismatch: validity.typeMismatch,
        valueMissing: validity.valueMissing,
        valid: validity.valid
    };
}
function $13ce3eede8664ea0$var$$e93e671b31057976$var$getNativeValidity(input) {
    return {
        isInvalid: !input.validity.valid,
        validationDetails: $13ce3eede8664ea0$var$$e93e671b31057976$var$getValidity(input),
        validationErrors: input.validationMessage ? [
            input.validationMessage
        ] : []
    };
}
function $13ce3eede8664ea0$var$$e93e671b31057976$var$getFirstInvalidInput(form) {
    for(let i = 0; i < form.elements.length; i++){
        let element = form.elements[i];
        if (!element.validity.valid) return element;
    }
    return null;
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $731c2f30442e44c3$export$712718f7aec83d5(props, ref) {
    let { inputElementType: inputElementType = 'input', isDisabled: isDisabled = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, type: type = 'text', validationBehavior: validationBehavior = 'aria' } = props;
    let [value, setValue] = (0, $3316814d6906df5c$export$40bfa8c7b0832715)(props.value, props.defaultValue || '', props.onChange);
    let { focusableProps: focusableProps } = (0, $daedc3252d285a56$export$4c014de7c8940b4c)(props, ref);
    let validationState = (0, $bf01417b417639db$export$fc1a364ae1f3ff10)({
        ...props,
        value: value
    });
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = validationState.displayValidation;
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $54c383c3558c03c1$export$294aa081a6c6f55d)({
        ...props,
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let domProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    const inputOnlyProps = {
        type: type,
        pattern: props.pattern
    };
    let [initialValue] = (0, $acw62.useState)(value);
    var _props_defaultValue;
    (0, $7f099d759e9c1e4d$export$5add1d006293d136)(ref, (_props_defaultValue = props.defaultValue) !== null && _props_defaultValue !== void 0 ? _props_defaultValue : initialValue, setValue);
    (0, $13ce3eede8664ea0$export$b8473d3665f3a75a)(props, validationState, ref);
    return {
        labelProps: labelProps,
        inputProps: (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(domProps, inputElementType === 'input' ? inputOnlyProps : undefined, {
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired && validationBehavior === 'native',
            'aria-required': isRequired && validationBehavior === 'aria' || undefined,
            'aria-invalid': isInvalid || undefined,
            'aria-errormessage': props['aria-errormessage'],
            'aria-activedescendant': props['aria-activedescendant'],
            'aria-autocomplete': props['aria-autocomplete'],
            'aria-haspopup': props['aria-haspopup'],
            'aria-controls': props['aria-controls'],
            value: value,
            onChange: (e)=>setValue(e.target.value),
            autoComplete: props.autoComplete,
            autoCapitalize: props.autoCapitalize,
            maxLength: props.maxLength,
            minLength: props.minLength,
            name: props.name,
            form: props.form,
            placeholder: props.placeholder,
            inputMode: props.inputMode,
            autoCorrect: props.autoCorrect,
            spellCheck: props.spellCheck,
            [parseInt((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version, 10) >= 17 ? 'enterKeyHint' : 'enterkeyhint']: props.enterKeyHint,
            // Clipboard events
            onCopy: props.onCopy,
            onCut: props.onCut,
            onPaste: props.onPaste,
            // Composition events
            onCompositionEnd: props.onCompositionEnd,
            onCompositionStart: props.onCompositionStart,
            onCompositionUpdate: props.onCompositionUpdate,
            // Selection events
            onSelect: props.onSelect,
            // Input events
            onBeforeInput: props.onBeforeInput,
            onInput: props.onInput,
            ...focusableProps,
            ...fieldProps
        }),
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $493e4c59f76a0606$export$2129e27b3ef0d483 = (0, $acw62.createContext)(null);
const $493e4c59f76a0606$export$2c73285ae9390cec = (0, $73addfbf71cdc088$export$86427a43e3e48ebb)(function TextField(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $493e4c59f76a0606$export$2129e27b3ef0d483);
    let { validationBehavior: formValidationBehavior } = (0, $12ee5c1d62d6b2e5$export$fabf2dc03a41866e)((0, $99b9335b6cbca82a$export$c24727297075ec6a)) || {};
    var _props_validationBehavior, _ref;
    let validationBehavior = (_ref = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : formValidationBehavior) !== null && _ref !== void 0 ? _ref : 'native';
    let inputRef = (0, $acw62.useRef)(null);
    [props, inputRef] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, inputRef, (0, $11cc862e572cddbb$export$698f465ec27e93df));
    let [labelRef, label] = (0, $12ee5c1d62d6b2e5$export$9d4c57ee4c6ffdd8)(!props['aria-label'] && !props['aria-labelledby']);
    let [inputElementType, setInputElementType] = (0, $acw62.useState)('input');
    let { labelProps: labelProps, inputProps: inputProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $731c2f30442e44c3$export$712718f7aec83d5)({
        ...(0, $12ee5c1d62d6b2e5$export$ef03459518577ad4)(props),
        inputElementType: inputElementType,
        label: label,
        validationBehavior: validationBehavior
    }, inputRef);
    // Intercept setting the input ref so we can determine what kind of element we have.
    // useTextField uses this to determine what props to include.
    let inputOrTextAreaRef = (0, $acw62.useCallback)((el)=>{
        inputRef.current = el;
        if (el) setInputElementType(el instanceof HTMLTextAreaElement ? 'textarea' : 'input');
    }, [
        inputRef
    ]);
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        ...props,
        values: {
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid,
            isReadOnly: props.isReadOnly || false,
            isRequired: props.isRequired || false
        },
        defaultClassName: 'react-aria-TextField'
    });
    let DOMProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined,
        "data-readonly": props.isReadOnly || undefined,
        "data-required": props.isRequired || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $12ee5c1d62d6b2e5$export$2881499e37b75b9a), {
        values: [
            [
                (0, $794346013ab6e680$export$75b6ee27786ba447),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ],
            [
                (0, $ccd48495800651c4$export$37fb8590cf2c088c),
                {
                    ...inputProps,
                    ref: inputOrTextAreaRef
                }
            ],
            [
                (0, $cb65690869e135e6$export$2dc6166a7e65358c),
                {
                    ...inputProps,
                    ref: inputOrTextAreaRef
                }
            ],
            [
                (0, $c1367d7afc3d8fbe$export$f9c6924e160136d1),
                {
                    role: 'presentation',
                    isInvalid: validation.isInvalid,
                    isDisabled: props.isDisabled || false
                }
            ],
            [
                (0, $424592b5daddcd29$export$9afb8bc826b033ea),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $7dd8b2fec65d8b6a$export$ff05c3ac10437e03),
                validation
            ]
        ]
    }, renderProps.children));
});





function $e29ab1100b9991a4$export$b04be29aa201d4f5({ children: children, ...props }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $794346013ab6e680$export$b04be29aa201d4f5), {
        ...props,
        className: "empty:hidden mb-1 font-medium text-body-dark text-sm",
        elementType: "label",
        children: children
    });
}


const $ba2139d830a3ba4d$export$5d282921e6183ab5 = /*#__PURE__*/ (0, $acw62.forwardRef)(function Input({ label: label, className: className, suffix: suffix, ...props }, ref) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $493e4c59f76a0606$export$2c73285ae9390cec), {
        ...props,
        ref: ref,
        className: "group/input flex flex-col gap-1",
        "data-size": props.size ?? '',
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e29ab1100b9991a4$export$b04be29aa201d4f5), {
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "relative after:absolute after:right-4 after:top-1/2 after:-translate-y-3 after:leading-0 after:content-[attr(data-suffix)] after:text-light-500",
                "data-suffix": suffix,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ccd48495800651c4$export$f5b8910cec6cf069), {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(className, 'w-full px-3 py-2 group-data-[size=lg]/input:text-lg group-data-[size=lg]/input:p-4 text-body-dark rounded-md border border-solid border-300 shadow-sm placeholder:text-light-500 data-[suffix=true]:pr-11 focus-within:ring-1 ring-primary focus:ring-primary focus:border-primary focus-within:border-primary')
                })
            })
        ]
    });
});
function $ba2139d830a3ba4d$export$f5b8910cec6cf069(props) {
    const { field: field } = (0, $0d70f179cf56e662$export$e8c786024a2b0a79)({
        name: props.name
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ba2139d830a3ba4d$export$5d282921e6183ab5, {
        ...props,
        ...field,
        isDisabled: props.disabled
    });
}


const $a332dd0821b6767c$var$schema = $09193e81812ba154$export$be5493f9613cbbe({
    weight: $42c0b73bfe598b38$exports.number().min(1),
    height: $42c0b73bfe598b38$exports.number().min(1)
});
function $a332dd0821b6767c$var$extractDefaults({ healthQuestionWeightHeight: healthQuestionWeightHeight }) {
    return {
        weight: healthQuestionWeightHeight?.weight ?? '',
        height: healthQuestionWeightHeight?.height ?? ''
    };
}
function $a332dd0821b6767c$var$transformValues(values) {
    return {
        healthQuestionWeightHeight: values
    };
}
function $a332dd0821b6767c$export$9dc49afca840728d(props) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)([
        'page.health-questions',
        'common'
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dea25ad601eb8263$export$70aabb5da7e125f8), {
        extractDefaults: $a332dd0821b6767c$var$extractDefaults,
        transformValues: $a332dd0821b6767c$var$transformValues,
        schema: $a332dd0821b6767c$var$schema,
        nextPath: props.next.path,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4777412ac24f8fdf$export$8becf861e7fda17d), {
            ...props,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    t: t,
                    i18nKey: "questions.weightHeight.title",
                    components: {
                        h3: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "title"
                        }),
                        p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {})
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-start flex-nowrap gap-5 sm:gap-8.75",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                            inputMode: "numeric",
                            name: "weight",
                            label: t('questions.weightHeight.weight'),
                            suffix: t('questions.weightHeight.kg'),
                            size: "lg"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                            inputMode: "numeric",
                            name: "height",
                            label: t('questions.weightHeight.height'),
                            suffix: t('questions.weightHeight.cm'),
                            size: "lg"
                        })
                    ]
                })
            ]
        })
    });
}



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


// eslint-disable-next-line import/no-unresolved

var $22c4bfea680558f2$export$2e2bcd8739ae039 = {
    company: 'Lighthouse Bay Endoscopy',
    companyShort: 'Lighthouse Bay',
    phone: '(09) 000 1234'
};



var $acw62 = parcelRequire("acw62");

const $197b6000c0ecf0dd$var$COMPONENTS = {
    p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "text-sm text-gray-500"
    }),
    i: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "italic"
    }),
    b: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "font-medium"
    }),
    u: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "underline"
    }),
    h1: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "title"
    }),
    h2: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "title"
    }),
    h3: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "title"
    }),
    label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-base font-medium text-gray-900"
    })
};
function $197b6000c0ecf0dd$export$ad924bcafd0618eb({ values: values, ...props }) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const stableValues = (0, $acw62.useMemo)(()=>({
            ...(0, $22c4bfea680558f2$export$2e2bcd8739ae039),
            values: values
        }), [
        JSON.stringify(values)
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
        ...props,
        components: $197b6000c0ecf0dd$var$COMPONENTS,
        values: stableValues
    });
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $aba927e9b3929756$export$a5ff0d6a738703ca(e) {
    typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((o)=>setTimeout(()=>{
            throw o;
        }));
}


function $12f0e1633d904536$export$12b26c28a05aa001() {
    let n = [], r = {
        addEventListener (e, t, s, a) {
            return e.addEventListener(t, s, a), r.add(()=>e.removeEventListener(t, s, a));
        },
        requestAnimationFrame (...e) {
            let t = requestAnimationFrame(...e);
            return r.add(()=>cancelAnimationFrame(t));
        },
        nextFrame (...e) {
            return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e));
        },
        setTimeout (...e) {
            let t = setTimeout(...e);
            return r.add(()=>clearTimeout(t));
        },
        microTask (...e) {
            let t = {
                current: !0
            };
            return (0, $aba927e9b3929756$export$a5ff0d6a738703ca)(()=>{
                t.current && e[0]();
            }), r.add(()=>{
                t.current = !1;
            });
        },
        style (e, t, s) {
            let a = e.style.getPropertyValue(t);
            return Object.assign(e.style, {
                [t]: s
            }), this.add(()=>{
                Object.assign(e.style, {
                    [t]: a
                });
            });
        },
        group (e) {
            let t = $12f0e1633d904536$export$12b26c28a05aa001();
            return e(t), this.add(()=>t.dispose());
        },
        add (e) {
            return n.push(e), ()=>{
                let t = n.indexOf(e);
                if (t >= 0) for (let s of n.splice(t, 1))s();
            };
        },
        dispose () {
            for (let e of n.splice(0))e();
        }
    };
    return r;
}


function $410e668b7f520622$export$fd183955ff4b45d9() {
    let [e] = (0, $acw62.useState)((0, $12f0e1633d904536$export$12b26c28a05aa001));
    return (0, $acw62.useEffect)(()=>()=>e.dispose(), [
        e
    ]), e;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $085e96034c813fbf$var$i = Object.defineProperty;
var $085e96034c813fbf$var$d = (t, e, n)=>e in t ? $085e96034c813fbf$var$i(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n;
var $085e96034c813fbf$var$r = (t, e, n)=>($085e96034c813fbf$var$d(t, typeof e != "symbol" ? e + "" : e, n), n);
class $085e96034c813fbf$var$o {
    constructor(){
        $085e96034c813fbf$var$r(this, "current", this.detect());
        $085e96034c813fbf$var$r(this, "handoffState", "pending");
        $085e96034c813fbf$var$r(this, "currentId", 0);
    }
    set(e) {
        this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
    }
    reset() {
        this.set(this.detect());
    }
    nextId() {
        return ++this.currentId;
    }
    get isServer() {
        return this.current === "server";
    }
    get isClient() {
        return this.current === "client";
    }
    detect() {
        return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
    }
    handoff() {
        this.handoffState === "pending" && (this.handoffState = "complete");
    }
    get isHandoffComplete() {
        return this.handoffState === "complete";
    }
}
let $085e96034c813fbf$export$a7b6bc01c63cdfc3 = new $085e96034c813fbf$var$o;


let $65df95ec9b1bb6a8$export$ce5ed857c741fd71 = (e, f)=>{
    (0, $085e96034c813fbf$export$a7b6bc01c63cdfc3).isServer ? (0, $acw62.useEffect)(e, f) : (0, $acw62.useLayoutEffect)(e, f);
};


function $fa1923261638cacc$export$86c4283a11f23f95(e) {
    let r = (0, $acw62.useRef)(e);
    return (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        r.current = e;
    }, [
        e
    ]), r;
}


let $0bd9972698c32399$export$90fc3a17d93f704c = function(t) {
    let e = (0, $fa1923261638cacc$export$86c4283a11f23f95)(t);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((...r)=>e.current(...r), [
        e
    ]);
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

function $854f77de70ff8db2$export$80c2a3957bcb42ea() {
    let e = (0, $acw62.useRef)(!1);
    return (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>(e.current = !0, ()=>{
            e.current = !1;
        }), []), e;
}


function $805c30fc151c4831$export$2879604e6aec4ab(a = 0) {
    let [l, r] = (0, $acw62.useState)(a), t = (0, $854f77de70ff8db2$export$80c2a3957bcb42ea)(), o = (0, $acw62.useCallback)((e)=>{
        t.current && r((u)=>u | e);
    }, [
        l,
        t
    ]), m = (0, $acw62.useCallback)((e)=>Boolean(l & e), [
        l
    ]), s = (0, $acw62.useCallback)((e)=>{
        t.current && r((u)=>u & ~e);
    }, [
        r,
        t
    ]), g = (0, $acw62.useCallback)((e)=>{
        t.current && r((u)=>u ^ e);
    }, [
        r
    ]);
    return {
        flags: l,
        addFlag: o,
        hasFlag: m,
        removeFlag: s,
        toggleFlag: g
    };
}






var $acw62 = parcelRequire("acw62");

function $81b1abbf8717f9cc$var$s() {
    let r = typeof document == "undefined";
    return "useSyncExternalStore" in $acw62 ? ((o)=>o.useSyncExternalStore)($acw62)(()=>()=>{}, ()=>!1, ()=>!r) : !1;
}
function $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa() {
    let r = $81b1abbf8717f9cc$var$s(), [e, n] = $acw62.useState((0, $085e96034c813fbf$export$a7b6bc01c63cdfc3).isHandoffComplete);
    return e && (0, $085e96034c813fbf$export$a7b6bc01c63cdfc3).isHandoffComplete === !1 && n(!1), $acw62.useEffect(()=>{
        e !== !0 && n(!0);
    }, [
        e
    ]), $acw62.useEffect(()=>(0, $085e96034c813fbf$export$a7b6bc01c63cdfc3).handoff(), []), r ? !1 : e;
}



var $acw62 = parcelRequire("acw62");

let $4a1854c6a3ad5196$var$u = Symbol();
function $4a1854c6a3ad5196$export$7029785b750eb74(t, n = !0) {
    return Object.assign(t, {
        [$4a1854c6a3ad5196$var$u]: n
    });
}
function $4a1854c6a3ad5196$export$f6a25a78204acc7e(...t) {
    let n = (0, $acw62.useRef)(t);
    (0, $acw62.useEffect)(()=>{
        n.current = t;
    }, [
        t
    ]);
    let c = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((e)=>{
        for (let o of n.current)o != null && (typeof o == "function" ? o(e) : o.current = e);
    });
    return t.every((e)=>e == null || (e == null ? void 0 : e[$4a1854c6a3ad5196$var$u])) ? void 0 : c;
}



function $4f240e1aafd2c298$export$4659b591c19bdf3d(r, n, ...a) {
    if (r in n) {
        let e = n[r];
        return typeof e == "function" ? e(...a) : e;
    }
    let t = new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((e)=>`"${e}"`).join(", ")}.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, $4f240e1aafd2c298$export$4659b591c19bdf3d), t;
}


function $7716801ecfdbcff6$export$d2de3aaeafa91619(r) {
    let e = {
        called: !1
    };
    return (...t)=>{
        if (!e.called) return e.called = !0, r(...t);
    };
}


function $d94e61505c2ccd73$var$g(t, ...e) {
    t && e.length > 0 && t.classList.add(...e);
}
function $d94e61505c2ccd73$var$v(t, ...e) {
    t && e.length > 0 && t.classList.remove(...e);
}
function $d94e61505c2ccd73$var$b(t, e) {
    let n = (0, $12f0e1633d904536$export$12b26c28a05aa001)();
    if (!t) return n.dispose;
    let { transitionDuration: m, transitionDelay: a } = getComputedStyle(t), [u, p] = [
        m,
        a
    ].map((l)=>{
        let [r = 0] = l.split(",").filter(Boolean).map((i)=>i.includes("ms") ? parseFloat(i) : parseFloat(i) * 1e3).sort((i, T)=>T - i);
        return r;
    }), o = u + p;
    if (o !== 0) {
        n.group((r)=>{
            r.setTimeout(()=>{
                e(), r.dispose();
            }, o), r.addEventListener(t, "transitionrun", (i)=>{
                i.target === i.currentTarget && r.dispose();
            });
        });
        let l = n.addEventListener(t, "transitionend", (r)=>{
            r.target === r.currentTarget && (e(), l());
        });
    } else e();
    return n.add(()=>e()), n.dispose;
}
function $d94e61505c2ccd73$export$66bb15e2994e6a26(t, e, n, m) {
    let a = n ? "enter" : "leave", u = (0, $12f0e1633d904536$export$12b26c28a05aa001)(), p = m !== void 0 ? (0, $7716801ecfdbcff6$export$d2de3aaeafa91619)(m) : ()=>{};
    a === "enter" && (t.removeAttribute("hidden"), t.style.display = "");
    let o = (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(a, {
        enter: ()=>e.enter,
        leave: ()=>e.leave
    }), l = (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(a, {
        enter: ()=>e.enterTo,
        leave: ()=>e.leaveTo
    }), r = (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(a, {
        enter: ()=>e.enterFrom,
        leave: ()=>e.leaveFrom
    });
    return $d94e61505c2ccd73$var$v(t, ...e.base, ...e.enter, ...e.enterTo, ...e.enterFrom, ...e.leave, ...e.leaveFrom, ...e.leaveTo, ...e.entered), $d94e61505c2ccd73$var$g(t, ...e.base, ...o, ...r), u.nextFrame(()=>{
        $d94e61505c2ccd73$var$v(t, ...e.base, ...o, ...r), $d94e61505c2ccd73$var$g(t, ...e.base, ...o, ...l), $d94e61505c2ccd73$var$b(t, ()=>($d94e61505c2ccd73$var$v(t, ...e.base, ...o), $d94e61505c2ccd73$var$g(t, ...e.base, ...e.entered), p()));
    }), u.dispose;
}







function $82a0b6c20b323075$export$7b286972b8d8ccbf({ immediate: t, container: s, direction: n, classes: u, onStart: a, onStop: c }) {
    let l = (0, $854f77de70ff8db2$export$80c2a3957bcb42ea)(), d = (0, $410e668b7f520622$export$fd183955ff4b45d9)(), e = (0, $fa1923261638cacc$export$86c4283a11f23f95)(n);
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        t && (e.current = "enter");
    }, [
        t
    ]), (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        let r = (0, $12f0e1633d904536$export$12b26c28a05aa001)();
        d.add(r.dispose);
        let i = s.current;
        if (i && e.current !== "idle" && l.current) return r.dispose(), a.current(e.current), r.add((0, $d94e61505c2ccd73$export$66bb15e2994e6a26)(i, u.current, e.current === "enter", ()=>{
            r.dispose(), c.current(e.current);
        })), r.dispose;
    }, [
        n
    ]);
}



var $acw62 = parcelRequire("acw62");
let $7a3499b4b3c6f184$var$n = (0, $acw62.createContext)(null);
$7a3499b4b3c6f184$var$n.displayName = "OpenClosedContext";
var $7a3499b4b3c6f184$export$7254cc27399e90bd = ((e)=>(e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))($7a3499b4b3c6f184$export$7254cc27399e90bd || {});
function $7a3499b4b3c6f184$export$fc6fdf0ecf360e() {
    return (0, $acw62.useContext)($7a3499b4b3c6f184$var$n);
}
function $7a3499b4b3c6f184$export$2a0ed818b175f558({ value: o, children: r }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7a3499b4b3c6f184$var$n.Provider, {
        value: o
    }, r);
}


function $37ab6efe1f53a2e0$export$ce4ab0c55987d1ff(...r) {
    return Array.from(new Set(r.flatMap((n)=>typeof n == "string" ? n.split(" ") : []))).filter(Boolean).join(" ");
}




var $acw62 = parcelRequire("acw62");


var $a54bdd13402af126$export$617d79dae526d2cf = ((n)=>(n[n.None = 0] = "None", n[n.RenderStrategy = 1] = "RenderStrategy", n[n.Static = 2] = "Static", n))($a54bdd13402af126$export$617d79dae526d2cf || {}), $a54bdd13402af126$export$80c0a745e59f7989 = ((e)=>(e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))($a54bdd13402af126$export$80c0a745e59f7989 || {});
function $a54bdd13402af126$export$b3890eb0ae9dca99({ ourProps: r, theirProps: t, slot: e, defaultTag: n, features: o, visible: a = !0, name: f, mergeRefs: l }) {
    l = l != null ? l : $a54bdd13402af126$var$k;
    let s = $a54bdd13402af126$var$R(t, r);
    if (a) return $a54bdd13402af126$var$m(s, e, n, f, l);
    let y = o != null ? o : 0;
    if (y & 2) {
        let { static: u = !1, ...d } = s;
        if (u) return $a54bdd13402af126$var$m(d, e, n, f, l);
    }
    if (y & 1) {
        let { unmount: u = !0, ...d } = s;
        return (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(u ? 0 : 1, {
            [0] () {
                return null;
            },
            [1] () {
                return $a54bdd13402af126$var$m({
                    ...d,
                    hidden: !0,
                    style: {
                        display: "none"
                    }
                }, e, n, f, l);
            }
        });
    }
    return $a54bdd13402af126$var$m(s, e, n, f, l);
}
function $a54bdd13402af126$var$m(r, t = {}, e, n, o) {
    let { as: a = e, children: f, refName: l = "ref", ...s } = $a54bdd13402af126$var$F(r, [
        "unmount",
        "static"
    ]), y = r.ref !== void 0 ? {
        [l]: r.ref
    } : {}, u = typeof f == "function" ? f(t) : f;
    "className" in s && s.className && typeof s.className == "function" && (s.className = s.className(t));
    let d = {};
    if (t) {
        let i = !1, c = [];
        for (let [T, p] of Object.entries(t))typeof p == "boolean" && (i = !0), p === !0 && c.push(T);
        i && (d["data-headlessui-state"] = c.join(" "));
    }
    if (a === (0, $acw62.Fragment) && Object.keys($a54bdd13402af126$export$8e16b83750b44988(s)).length > 0) {
        if (!(0, $acw62.isValidElement)(u) || Array.isArray(u) && u.length > 1) throw new Error([
            'Passing props on "Fragment"!',
            "",
            `The current component <${n} /> is rendering a "Fragment".`,
            "However we need to passthrough the following props:",
            Object.keys(s).map((p)=>`  - ${p}`).join(`
`),
            "",
            "You can apply a few solutions:",
            [
                'Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',
                "Render a single element as the child so that we can forward the props onto that element."
            ].map((p)=>`  - ${p}`).join(`
`)
        ].join(`
`));
        let i = u.props, c = typeof (i == null ? void 0 : i.className) == "function" ? (...p)=>(0, $37ab6efe1f53a2e0$export$ce4ab0c55987d1ff)(i == null ? void 0 : i.className(...p), s.className) : (0, $37ab6efe1f53a2e0$export$ce4ab0c55987d1ff)(i == null ? void 0 : i.className, s.className), T = c ? {
            className: c
        } : {};
        return (0, $acw62.cloneElement)(u, Object.assign({}, $a54bdd13402af126$var$R(u.props, $a54bdd13402af126$export$8e16b83750b44988($a54bdd13402af126$var$F(s, [
            "ref"
        ]))), d, y, {
            ref: o(u.ref, y.ref)
        }, T));
    }
    return (0, $acw62.createElement)(a, Object.assign({}, $a54bdd13402af126$var$F(s, [
        "ref"
    ]), a !== (0, $acw62.Fragment) && y, a !== (0, $acw62.Fragment) && d), u);
}
function $a54bdd13402af126$export$81218df071161f0a() {
    let r = (0, $acw62.useRef)([]), t = (0, $acw62.useCallback)((e)=>{
        for (let n of r.current)n != null && (typeof n == "function" ? n(e) : n.current = e);
    }, []);
    return (...e)=>{
        if (!e.every((n)=>n == null)) return r.current = e, t;
    };
}
function $a54bdd13402af126$var$k(...r) {
    return r.every((t)=>t == null) ? void 0 : (t)=>{
        for (let e of r)e != null && (typeof e == "function" ? e(t) : e.current = t);
    };
}
function $a54bdd13402af126$var$R(...r) {
    var n;
    if (r.length === 0) return {};
    if (r.length === 1) return r[0];
    let t = {}, e = {};
    for (let o of r)for(let a in o)a.startsWith("on") && typeof o[a] == "function" ? ((n = e[a]) != null || (e[a] = []), e[a].push(o[a])) : t[a] = o[a];
    if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(e).map((o)=>[
            o,
            void 0
        ])));
    for(let o in e)Object.assign(t, {
        [o] (a, ...f) {
            let l = e[o];
            for (let s of l){
                if ((a instanceof Event || (a == null ? void 0 : a.nativeEvent) instanceof Event) && a.defaultPrevented) return;
                s(a, ...f);
            }
        }
    });
    return t;
}
function $a54bdd13402af126$export$e43f39796049410c(r) {
    var t;
    return Object.assign((0, $acw62.forwardRef)(r), {
        displayName: (t = r.displayName) != null ? t : r.name
    });
}
function $a54bdd13402af126$export$8e16b83750b44988(r) {
    let t = Object.assign({}, r);
    for(let e in t)t[e] === void 0 && delete t[e];
    return t;
}
function $a54bdd13402af126$var$F(r, t = []) {
    let e = Object.assign({}, r);
    for (let n of t)n in e && delete e[n];
    return e;
}


function $030a82c6b2bb6f00$var$S(t = "") {
    return t.split(/\s+/).filter((n)=>n.length > 1);
}
let $030a82c6b2bb6f00$var$I = (0, $acw62.createContext)(null);
$030a82c6b2bb6f00$var$I.displayName = "TransitionContext";
var $030a82c6b2bb6f00$var$Se = ((r)=>(r.Visible = "visible", r.Hidden = "hidden", r))($030a82c6b2bb6f00$var$Se || {});
function $030a82c6b2bb6f00$var$ye() {
    let t = (0, $acw62.useContext)($030a82c6b2bb6f00$var$I);
    if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return t;
}
function $030a82c6b2bb6f00$var$xe() {
    let t = (0, $acw62.useContext)($030a82c6b2bb6f00$var$M);
    if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return t;
}
let $030a82c6b2bb6f00$var$M = (0, $acw62.createContext)(null);
$030a82c6b2bb6f00$var$M.displayName = "NestingContext";
function $030a82c6b2bb6f00$var$U(t) {
    return "children" in t ? $030a82c6b2bb6f00$var$U(t.children) : t.current.filter(({ el: n })=>n.current !== null).filter(({ state: n })=>n === "visible").length > 0;
}
function $030a82c6b2bb6f00$var$se(t, n) {
    let r = (0, $fa1923261638cacc$export$86c4283a11f23f95)(t), s = (0, $acw62.useRef)([]), R = (0, $854f77de70ff8db2$export$80c2a3957bcb42ea)(), D = (0, $410e668b7f520622$export$fd183955ff4b45d9)(), p = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((i, e = (0, $a54bdd13402af126$export$80c0a745e59f7989).Hidden)=>{
        let a = s.current.findIndex(({ el: o })=>o === i);
        a !== -1 && ((0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(e, {
            [(0, $a54bdd13402af126$export$80c0a745e59f7989).Unmount] () {
                s.current.splice(a, 1);
            },
            [(0, $a54bdd13402af126$export$80c0a745e59f7989).Hidden] () {
                s.current[a].state = "hidden";
            }
        }), D.microTask(()=>{
            var o;
            !$030a82c6b2bb6f00$var$U(s) && R.current && ((o = r.current) == null || o.call(r));
        }));
    }), x = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((i)=>{
        let e = s.current.find(({ el: a })=>a === i);
        return e ? e.state !== "visible" && (e.state = "visible") : s.current.push({
            el: i,
            state: "visible"
        }), ()=>p(i, (0, $a54bdd13402af126$export$80c0a745e59f7989).Unmount);
    }), h = (0, $acw62.useRef)([]), v = (0, $acw62.useRef)(Promise.resolve()), u = (0, $acw62.useRef)({
        enter: [],
        leave: [],
        idle: []
    }), g = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((i, e, a)=>{
        h.current.splice(0), n && (n.chains.current[e] = n.chains.current[e].filter(([o])=>o !== i)), n == null || n.chains.current[e].push([
            i,
            new Promise((o)=>{
                h.current.push(o);
            })
        ]), n == null || n.chains.current[e].push([
            i,
            new Promise((o)=>{
                Promise.all(u.current[e].map(([f, N])=>N)).then(()=>o());
            })
        ]), e === "enter" ? v.current = v.current.then(()=>n == null ? void 0 : n.wait.current).then(()=>a(e)) : a(e);
    }), d = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((i, e, a)=>{
        Promise.all(u.current[e].splice(0).map(([o, f])=>f)).then(()=>{
            var o;
            (o = h.current.shift()) == null || o();
        }).then(()=>a(e));
    });
    return (0, $acw62.useMemo)(()=>({
            children: s,
            register: x,
            unregister: p,
            onStart: g,
            onStop: d,
            wait: v,
            chains: u
        }), [
        x,
        p,
        s,
        g,
        d,
        u,
        v
    ]);
}
function $030a82c6b2bb6f00$var$Ne() {}
let $030a82c6b2bb6f00$var$Pe = [
    "beforeEnter",
    "afterEnter",
    "beforeLeave",
    "afterLeave"
];
function $030a82c6b2bb6f00$var$ae(t) {
    var r;
    let n = {};
    for (let s of $030a82c6b2bb6f00$var$Pe)n[s] = (r = t[s]) != null ? r : $030a82c6b2bb6f00$var$Ne;
    return n;
}
function $030a82c6b2bb6f00$var$Re(t) {
    let n = (0, $acw62.useRef)($030a82c6b2bb6f00$var$ae(t));
    return (0, $acw62.useEffect)(()=>{
        n.current = $030a82c6b2bb6f00$var$ae(t);
    }, [
        t
    ]), n;
}
let $030a82c6b2bb6f00$var$De = "div", $030a82c6b2bb6f00$var$le = (0, $a54bdd13402af126$export$617d79dae526d2cf).RenderStrategy;
function $030a82c6b2bb6f00$var$He(t, n) {
    var Q, Y;
    let { beforeEnter: r, afterEnter: s, beforeLeave: R, afterLeave: D, enter: p, enterFrom: x, enterTo: h, entered: v, leave: u, leaveFrom: g, leaveTo: d, ...i } = t, e = (0, $acw62.useRef)(null), a = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(e, n), o = (Q = i.unmount) == null || Q ? (0, $a54bdd13402af126$export$80c0a745e59f7989).Unmount : (0, $a54bdd13402af126$export$80c0a745e59f7989).Hidden, { show: f, appear: N, initial: T } = $030a82c6b2bb6f00$var$ye(), [l, j] = (0, $acw62.useState)(f ? "visible" : "hidden"), z = $030a82c6b2bb6f00$var$xe(), { register: L, unregister: O } = z;
    (0, $acw62.useEffect)(()=>L(e), [
        L,
        e
    ]), (0, $acw62.useEffect)(()=>{
        if (o === (0, $a54bdd13402af126$export$80c0a745e59f7989).Hidden && e.current) {
            if (f && l !== "visible") {
                j("visible");
                return;
            }
            return (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(l, {
                ["hidden"]: ()=>O(e),
                ["visible"]: ()=>L(e)
            });
        }
    }, [
        l,
        e,
        L,
        O,
        f,
        o
    ]);
    let k = (0, $fa1923261638cacc$export$86c4283a11f23f95)({
        base: $030a82c6b2bb6f00$var$S(i.className),
        enter: $030a82c6b2bb6f00$var$S(p),
        enterFrom: $030a82c6b2bb6f00$var$S(x),
        enterTo: $030a82c6b2bb6f00$var$S(h),
        entered: $030a82c6b2bb6f00$var$S(v),
        leave: $030a82c6b2bb6f00$var$S(u),
        leaveFrom: $030a82c6b2bb6f00$var$S(g),
        leaveTo: $030a82c6b2bb6f00$var$S(d)
    }), V = $030a82c6b2bb6f00$var$Re({
        beforeEnter: r,
        afterEnter: s,
        beforeLeave: R,
        afterLeave: D
    }), G = (0, $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa)();
    (0, $acw62.useEffect)(()=>{
        if (G && l === "visible" && e.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
    }, [
        e,
        l,
        G
    ]);
    let Te = T && !N, K = N && f && T, de = (()=>!G || Te ? "idle" : f ? "enter" : "leave")(), H = (0, $805c30fc151c4831$export$2879604e6aec4ab)(0), fe = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((C)=>(0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(C, {
            enter: ()=>{
                H.addFlag((0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Opening), V.current.beforeEnter();
            },
            leave: ()=>{
                H.addFlag((0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Closing), V.current.beforeLeave();
            },
            idle: ()=>{}
        })), me = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((C)=>(0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(C, {
            enter: ()=>{
                H.removeFlag((0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Opening), V.current.afterEnter();
            },
            leave: ()=>{
                H.removeFlag((0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Closing), V.current.afterLeave();
            },
            idle: ()=>{}
        })), w = $030a82c6b2bb6f00$var$se(()=>{
        j("hidden"), O(e);
    }, z), B = (0, $acw62.useRef)(!1);
    (0, $82a0b6c20b323075$export$7b286972b8d8ccbf)({
        immediate: K,
        container: e,
        classes: k,
        direction: de,
        onStart: (0, $fa1923261638cacc$export$86c4283a11f23f95)((C)=>{
            B.current = !0, w.onStart(e, C, fe);
        }),
        onStop: (0, $fa1923261638cacc$export$86c4283a11f23f95)((C)=>{
            B.current = !1, w.onStop(e, C, me), C === "leave" && !$030a82c6b2bb6f00$var$U(w) && (j("hidden"), O(e));
        })
    });
    let P = i, ce = {
        ref: a
    };
    return K ? P = {
        ...P,
        className: (0, $37ab6efe1f53a2e0$export$ce4ab0c55987d1ff)(i.className, ...k.current.enter, ...k.current.enterFrom)
    } : B.current && (P.className = (0, $37ab6efe1f53a2e0$export$ce4ab0c55987d1ff)(i.className, (Y = e.current) == null ? void 0 : Y.className), P.className === "" && delete P.className), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($030a82c6b2bb6f00$var$M.Provider, {
        value: w
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a3499b4b3c6f184$export$2a0ed818b175f558), {
        value: (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(l, {
            ["visible"]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open,
            ["hidden"]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Closed
        }) | H.flags
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: ce,
        theirProps: P,
        defaultTag: $030a82c6b2bb6f00$var$De,
        features: $030a82c6b2bb6f00$var$le,
        visible: l === "visible",
        name: "Transition.Child"
    })));
}
function $030a82c6b2bb6f00$var$Fe(t, n) {
    let { show: r, appear: s = !1, unmount: R = !0, ...D } = t, p = (0, $acw62.useRef)(null), x = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(p, n);
    (0, $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa)();
    let h = (0, $7a3499b4b3c6f184$export$fc6fdf0ecf360e)();
    if (r === void 0 && h !== null && (r = (h & (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open) === (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open), ![
        !0,
        !1
    ].includes(r)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
    let [v, u] = (0, $acw62.useState)(r ? "visible" : "hidden"), g = $030a82c6b2bb6f00$var$se(()=>{
        u("hidden");
    }), [d, i] = (0, $acw62.useState)(!0), e = (0, $acw62.useRef)([
        r
    ]);
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        d !== !1 && e.current[e.current.length - 1] !== r && (e.current.push(r), i(!1));
    }, [
        e,
        r
    ]);
    let a = (0, $acw62.useMemo)(()=>({
            show: r,
            appear: s,
            initial: d
        }), [
        r,
        s,
        d
    ]);
    (0, $acw62.useEffect)(()=>{
        if (r) u("visible");
        else if (!$030a82c6b2bb6f00$var$U(g)) u("hidden");
        else {
            let T = p.current;
            if (!T) return;
            let l = T.getBoundingClientRect();
            l.x === 0 && l.y === 0 && l.width === 0 && l.height === 0 && u("hidden");
        }
    }, [
        r,
        g
    ]);
    let o = {
        unmount: R
    }, f = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        var T;
        d && i(!1), (T = t.beforeEnter) == null || T.call(t);
    }), N = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        var T;
        d && i(!1), (T = t.beforeLeave) == null || T.call(t);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($030a82c6b2bb6f00$var$M.Provider, {
        value: g
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($030a82c6b2bb6f00$var$I.Provider, {
        value: a
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            ...o,
            as: (0, $acw62.Fragment),
            children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($030a82c6b2bb6f00$var$ue, {
                ref: x,
                ...o,
                ...D,
                beforeEnter: f,
                beforeLeave: N
            })
        },
        theirProps: {},
        defaultTag: (0, $acw62.Fragment),
        features: $030a82c6b2bb6f00$var$le,
        visible: v === "visible",
        name: "Transition"
    })));
}
function $030a82c6b2bb6f00$var$_e(t, n) {
    let r = (0, $acw62.useContext)($030a82c6b2bb6f00$var$I) !== null, s = (0, $7a3499b4b3c6f184$export$fc6fdf0ecf360e)() !== null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, !r && s ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($030a82c6b2bb6f00$var$q, {
        ref: n,
        ...t
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($030a82c6b2bb6f00$var$ue, {
        ref: n,
        ...t
    }));
}
let $030a82c6b2bb6f00$var$q = (0, $a54bdd13402af126$export$e43f39796049410c)($030a82c6b2bb6f00$var$Fe), $030a82c6b2bb6f00$var$ue = (0, $a54bdd13402af126$export$e43f39796049410c)($030a82c6b2bb6f00$var$He), $030a82c6b2bb6f00$var$Le = (0, $a54bdd13402af126$export$e43f39796049410c)($030a82c6b2bb6f00$var$_e), $030a82c6b2bb6f00$export$be58926105124dd4 = Object.assign($030a82c6b2bb6f00$var$q, {
    Child: $030a82c6b2bb6f00$var$Le,
    Root: $030a82c6b2bb6f00$var$q
});


function $a253e8a9807820d2$export$be5b6c6ac24b4683({ children: children, show: show = true, ...props }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4), {
        ...props,
        show: show,
        enter: "transition-opacity duration-150",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "transition-opacity duration-0",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: children
    });
}






var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");


/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $77f6c3892c21261c$var$$c8a5a149f625efcf$var$SharedElementContext = (0, $acw62.createContext)(null);
function $77f6c3892c21261c$export$758399f318e6385a(props) {
    let ref = (0, $acw62.useRef)({});
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77f6c3892c21261c$var$$c8a5a149f625efcf$var$SharedElementContext.Provider, {
        value: ref
    }, props.children);
}
const $77f6c3892c21261c$export$c34620ff8881d89f = (0, $acw62.forwardRef)(function SharedElement(props, ref) {
    let { name: name, isVisible: isVisible = true, children: children, className: className, style: style, ...divProps } = props;
    let [state, setState] = (0, $acw62.useState)(isVisible ? 'visible' : 'hidden');
    let scopeRef = (0, $acw62.useContext)($77f6c3892c21261c$var$$c8a5a149f625efcf$var$SharedElementContext);
    if (!scopeRef) throw new Error('<SharedElement> must be rendered inside a <SharedElementTransition>');
    if (isVisible && state === 'hidden') setState('visible');
    ref = (0, $426ce7b4b2df0896$export$4338b53315abf666)(ref);
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        let element = ref.current;
        let scope = scopeRef.current;
        let prevSnapshot = scope[name];
        let frame = null;
        if (element && isVisible && prevSnapshot) {
            // Element is transitioning from a previous instance.
            setState('visible');
            let animations = element.getAnimations();
            // Set properties to animate from.
            let values = prevSnapshot.style.map(([property, prevValue])=>{
                let value = element.style[property];
                if (property === 'translate') {
                    let prevRect = prevSnapshot.rect;
                    let currentItem = element.getBoundingClientRect();
                    let deltaX = prevRect.left - (currentItem === null || currentItem === void 0 ? void 0 : currentItem.left);
                    let deltaY = prevRect.top - (currentItem === null || currentItem === void 0 ? void 0 : currentItem.top);
                    element.style.translate = `${deltaX}px ${deltaY}px`;
                } else element.style[property] = prevValue;
                return [
                    property,
                    value
                ];
            });
            // Cancel any new animations triggered by these properties.
            for (let a of element.getAnimations())if (!animations.includes(a)) a.cancel();
            // Remove overrides after one frame to animate to the current values.
            frame = requestAnimationFrame(()=>{
                frame = null;
                for (let [property, value] of values)element.style[property] = value;
            });
            delete scope[name];
        } else if (element && isVisible && !prevSnapshot) {
            // No previous instance exists, apply the entering state.
            queueMicrotask(()=>(0, $11492dca620dcaa5$exports.flushSync)(()=>setState('entering')));
            frame = requestAnimationFrame(()=>{
                frame = null;
                setState('visible');
            });
        } else if (element && !isVisible) // If so, no new SharedElement consumed it, so enter the exiting state.
        queueMicrotask(()=>{
            if (scope[name]) {
                delete scope[name];
                (0, $11492dca620dcaa5$exports.flushSync)(()=>setState('exiting'));
                Promise.all(element.getAnimations().map((a)=>a.finished)).then(()=>setState('hidden')).catch(()=>{});
            } else setState('hidden');
        });
        return ()=>{
            if (frame != null) cancelAnimationFrame(frame);
            if (element && element.isConnected && !element.hasAttribute('data-exiting')) {
                // On unmount, store a snapshot of the rectangle and computed style for transitioning properties.
                let style = window.getComputedStyle(element);
                if (style.transitionProperty !== 'none') {
                    let transitionProperty = style.transitionProperty.split(/\s*,\s*/);
                    scope[name] = {
                        rect: element.getBoundingClientRect(),
                        style: transitionProperty.map((p)=>[
                                p,
                                style[p]
                            ])
                    };
                }
            }
        };
    }, [
        ref,
        scopeRef,
        name,
        isVisible
    ]);
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        children: children,
        className: className,
        style: style,
        values: {
            isEntering: state === 'entering',
            isExiting: state === 'exiting'
        }
    });
    if (state === 'hidden') return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...divProps,
        ...renderProps,
        ref: ref,
        "data-entering": state === 'entering' || undefined,
        "data-exiting": state === 'exiting' || undefined
    });
});



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $50e2ea1c2adde70a$export$c9549807523555e0 = (0, $acw62.createContext)({
    isSelected: false
});
const $50e2ea1c2adde70a$export$17f80983afe4e444 = (0, $acw62.forwardRef)(function SelectionIndicator(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $50e2ea1c2adde70a$export$c9549807523555e0);
    let { isSelected: isSelected, ...otherProps } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $77f6c3892c21261c$export$c34620ff8881d89f), {
        ...otherProps,
        ref: ref,
        className: props.className || 'react-aria-SelectionIndicator',
        name: "SelectionIndicator",
        isVisible: isSelected
    });
});




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $27196c7c765c8a8e$export$37b65e5b5444d35c = new WeakMap();




var $acw62 = parcelRequire("acw62");


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $440ff080e030ab26$var$$14c0b72509d70225$var$state = 'default';
let $440ff080e030ab26$var$$14c0b72509d70225$var$savedUserSelect = '';
let $440ff080e030ab26$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $440ff080e030ab26$export$16a4697467175487(target) {
    if ((0, $c0699bc5a0b3191f$export$fedb369cb70207f1)()) {
        if ($440ff080e030ab26$var$$14c0b72509d70225$var$state === 'default') {
            const documentObject = (0, $48852fd65b79e251$export$b204af158042fbac)(target);
            $440ff080e030ab26$var$$14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = 'none';
        }
        $440ff080e030ab26$var$$14c0b72509d70225$var$state = 'disabled';
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        let property = 'userSelect' in target.style ? 'userSelect' : 'webkitUserSelect';
        $440ff080e030ab26$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style[property]);
        target.style[property] = 'none';
    }
}
function $440ff080e030ab26$export$b0d6fa1ab32e3295(target) {
    if ((0, $c0699bc5a0b3191f$export$fedb369cb70207f1)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($440ff080e030ab26$var$$14c0b72509d70225$var$state !== 'disabled') return;
        $440ff080e030ab26$var$$14c0b72509d70225$var$state = 'restoring';
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $2ce58204783d6986$export$24490316f764c430)(()=>{
                // Avoid race conditions
                if ($440ff080e030ab26$var$$14c0b72509d70225$var$state === 'restoring') {
                    const documentObject = (0, $48852fd65b79e251$export$b204af158042fbac)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === 'none') documentObject.documentElement.style.webkitUserSelect = $440ff080e030ab26$var$$14c0b72509d70225$var$savedUserSelect || '';
                    $440ff080e030ab26$var$$14c0b72509d70225$var$savedUserSelect = '';
                    $440ff080e030ab26$var$$14c0b72509d70225$var$state = 'default';
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $440ff080e030ab26$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $440ff080e030ab26$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
            let property = 'userSelect' in target.style ? 'userSelect' : 'webkitUserSelect';
            if (target.style[property] === 'none') target.style[property] = targetOldUserSelect;
            if (target.getAttribute('style') === '') target.removeAttribute('style');
            $440ff080e030ab26$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c8e06b8dad0b260d$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    register: ()=>{}
});
$c8e06b8dad0b260d$export$5165eccb35aaadb5.displayName = 'PressResponderContext';


function $9d532a50f1a1542f$export$184ff5d81c0e5775(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}


function $b7922a8e24efe587$export$20c20a422940e173(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}


function $c6097939c16c8ec7$export$5a67b255b80ee4f2(receiver, privateMap) {
    var descriptor = (0, $b7922a8e24efe587$export$20c20a422940e173)(receiver, privateMap, "get");
    return (0, $9d532a50f1a1542f$export$184ff5d81c0e5775)(receiver, descriptor);
}


function $e7a1afa872b987c0$export$6b10452b5ac97eba(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $01f13bd32e43989c$export$e235798705076415(obj, privateMap, value) {
    (0, $e7a1afa872b987c0$export$6b10452b5ac97eba)(obj, privateMap);
    privateMap.set(obj, value);
}


function $fbd8018b480a0a1b$export$b7b24cdba6bcb11c(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}



function $36ba9b20eda67744$export$268446c9779b3a21(receiver, privateMap, value) {
    var descriptor = (0, $b7922a8e24efe587$export$20c20a422940e173)(receiver, privateMap, "set");
    (0, $fbd8018b480a0a1b$export$b7b24cdba6bcb11c)(receiver, descriptor, value);
    return value;
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $6c43aa319e86785e$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $acw62.useContext)((0, $c8e06b8dad0b260d$export$5165eccb35aaadb5));
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(contextProps, props);
        register();
    }
    (0, $6a29d2bb7f5a367f$export$4debdb1a3f0fa79e)(context, props.ref);
    return props;
}
var $6c43aa319e86785e$var$$f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
class $6c43aa319e86785e$var$$f6c31cce2adf654f$var$PressEvent {
    continuePropagation() {
        (0, $36ba9b20eda67744$export$268446c9779b3a21)(this, $6c43aa319e86785e$var$$f6c31cce2adf654f$var$_shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, $c6097939c16c8ec7$export$5a67b255b80ee4f2)(this, $6c43aa319e86785e$var$$f6c31cce2adf654f$var$_shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent, state){
        (0, $01f13bd32e43989c$export$e235798705076415)(this, $6c43aa319e86785e$var$$f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, $36ba9b20eda67744$export$268446c9779b3a21)(this, $6c43aa319e86785e$var$$f6c31cce2adf654f$var$_shouldStopPropagation, true);
        var _state_target;
        let currentTarget = (_state_target = state === null || state === void 0 ? void 0 : state.target) !== null && _state_target !== void 0 ? _state_target : originalEvent.currentTarget;
        const rect = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.getBoundingClientRect();
        let x, y = 0;
        let clientX, clientY = null;
        if (originalEvent.clientX != null && originalEvent.clientY != null) {
            clientX = originalEvent.clientX;
            clientY = originalEvent.clientY;
        }
        if (rect) {
            if (clientX != null && clientY != null) {
                x = clientX - rect.left;
                y = clientY - rect.top;
            } else {
                x = rect.width / 2;
                y = rect.height / 2;
            }
        }
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
        this.x = x;
        this.y = y;
    }
}
const $6c43aa319e86785e$var$$f6c31cce2adf654f$var$LINK_CLICKED = Symbol('linkClicked');
const $6c43aa319e86785e$var$$f6c31cce2adf654f$var$STYLE_ID = 'react-aria-pressable-style';
const $6c43aa319e86785e$var$$f6c31cce2adf654f$var$PRESSABLE_ATTRIBUTE = 'data-react-aria-pressable';
function $6c43aa319e86785e$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, onClick: onClick, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: domRef, ...domProps } = $6c43aa319e86785e$var$$f6c31cce2adf654f$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $acw62.useState)(false);
    let ref = (0, $acw62.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null,
        disposables: []
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners, removeGlobalListener: removeGlobalListener } = (0, $2dd678e31a4cc7e0$export$4eaf04e54aa8eed6)();
    let triggerPressStart = (0, $acw62.useCallback)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $6c43aa319e86785e$var$$f6c31cce2adf654f$var$PressEvent('pressstart', pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    }, [
        isDisabled,
        onPressStart,
        onPressChange
    ]);
    let triggerPressEnd = (0, $acw62.useCallback)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $6c43aa319e86785e$var$$f6c31cce2adf654f$var$PressEvent('pressend', pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $6c43aa319e86785e$var$$f6c31cce2adf654f$var$PressEvent('press', pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    }, [
        isDisabled,
        onPressEnd,
        onPressChange,
        onPress
    ]);
    let triggerPressEndEvent = (0, $92fff981738f62fe$export$7f54fc3180508a52)(triggerPressEnd);
    let triggerPressUp = (0, $acw62.useCallback)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $6c43aa319e86785e$var$$f6c31cce2adf654f$var$PressEvent('pressup', pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    }, [
        isDisabled,
        onPressUp
    ]);
    let triggerPressUpEvent = (0, $92fff981738f62fe$export$7f54fc3180508a52)(triggerPressUp);
    let cancel = (0, $acw62.useCallback)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.didFirePressStart && state.pointerType != null) triggerPressEnd($6c43aa319e86785e$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            setIsPointerPressed(null);
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) (0, $440ff080e030ab26$export$b0d6fa1ab32e3295)(state.target);
            for (let dispose of state.disposables)dispose();
            state.disposables = [];
        }
    }, [
        allowTextSelectionOnPress,
        removeAllGlobalListeners,
        triggerPressEnd
    ]);
    let cancelEvent = (0, $92fff981738f62fe$export$7f54fc3180508a52)(cancel);
    let cancelOnPointerExit = (0, $acw62.useCallback)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    }, [
        shouldCancelOnPointerExit,
        cancel
    ]);
    let triggerClick = (0, $acw62.useCallback)((e)=>{
        if (isDisabled) return;
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        isDisabled,
        onClick
    ]);
    let triggerSyntheticClick = (0, $acw62.useCallback)((e, target)=>{
        if (isDisabled) return;
        // Some third-party libraries pass in onClick instead of onPress.
        // Create a fake mouse event and trigger onClick as well.
        // This matches the browser's native activation behavior for certain elements (e.g. button).
        // https://html.spec.whatwg.org/#activation
        // https://html.spec.whatwg.org/#fire-a-synthetic-pointer-event
        if (onClick) {
            let event = new MouseEvent('click', e);
            (0, $7fc007d8fdcfe19c$export$c2b7abe5d61ec696)(event, target);
            onClick((0, $7fc007d8fdcfe19c$export$525bc4921d56d4a)(event));
        }
    }, [
        isDisabled,
        onClick
    ]);
    let triggerSyntheticClickEvent = (0, $92fff981738f62fe$export$7f54fc3180508a52)(triggerSyntheticClick);
    let [isElemKeyPressed, setIsElemKeyPressed] = (0, $acw62.useState)(false);
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        let state = ref.current;
        if (isElemKeyPressed) {
            let onKeyUp = (e)=>{
                var _state_metaKeyEvents;
                if (state.isPressed && state.target && $6c43aa319e86785e$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                    var _state_metaKeyEvents1;
                    if ($6c43aa319e86785e$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard((0, $bc46b52522f8f24d$export$e58f029f0fbfdb29)(e), e.key)) e.preventDefault();
                    let target = (0, $bc46b52522f8f24d$export$e58f029f0fbfdb29)(e);
                    let wasPressed = (0, $bc46b52522f8f24d$export$4282f70798064fe0)(state.target, (0, $bc46b52522f8f24d$export$e58f029f0fbfdb29)(e));
                    triggerPressEndEvent($6c43aa319e86785e$var$$f6c31cce2adf654f$var$createEvent(state.target, e), 'keyboard', wasPressed);
                    if (wasPressed) triggerSyntheticClickEvent(e, state.target);
                    removeAllGlobalListeners();
                    // If a link was triggered with a key other than Enter, open the URL ourselves.
                    // This means the link has a role override, and the default browser behavior
                    // only applies when using the Enter key.
                    if (e.key !== 'Enter' && $6c43aa319e86785e$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && (0, $bc46b52522f8f24d$export$4282f70798064fe0)(state.target, target) && !e[$6c43aa319e86785e$var$$f6c31cce2adf654f$var$LINK_CLICKED]) {
                        // Store a hidden property on the event so we only trigger link click once,
                        // even if there are multiple usePress instances attached to the element.
                        e[$6c43aa319e86785e$var$$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                        (0, $c9b835cc9e261550$export$95185d699e05d4d7)(state.target, e, false);
                    }
                    state.isPressed = false;
                    setIsElemKeyPressed(false);
                    (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
                } else if (e.key === 'Meta' && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                    var _state_target;
                    // If we recorded keydown events that occurred while the Meta key was pressed,
                    // and those haven't received keyup events already, fire keyup events ourselves.
                    // See comment above for more info about the macOS bug causing this.
                    let events = state.metaKeyEvents;
                    state.metaKeyEvents = undefined;
                    for (let event of events.values())(_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent('keyup', event));
                }
            };
            // Focus may move before the key up event, so register the event on the document
            // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
            // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
            let originalTarget = state.target;
            let pressUp = (e)=>{
                if (originalTarget && $6c43aa319e86785e$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && (0, $bc46b52522f8f24d$export$4282f70798064fe0)(originalTarget, (0, $bc46b52522f8f24d$export$e58f029f0fbfdb29)(e)) && state.target) triggerPressUpEvent($6c43aa319e86785e$var$$f6c31cce2adf654f$var$createEvent(state.target, e), 'keyboard');
            };
            let listener = (0, $366a72b5d02721fb$export$e08e3b67e392101e)(pressUp, onKeyUp);
            addGlobalListener((0, $48852fd65b79e251$export$b204af158042fbac)(state.target), 'keyup', listener, true);
            return ()=>{
                removeGlobalListener((0, $48852fd65b79e251$export$b204af158042fbac)(state.target), 'keyup', listener, true);
            };
        }
    }, [
        isElemKeyPressed,
        addGlobalListener,
        removeAllGlobalListeners,
        removeGlobalListener
    ]);
    let [isPointerPressed, setIsPointerPressed] = (0, $acw62.useState)(null);
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        let state = ref.current;
        if (isPointerPressed === 'pointer') {
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ((0, $bc46b52522f8f24d$export$4282f70798064fe0)(state.target, (0, $bc46b52522f8f24d$export$e58f029f0fbfdb29)(e)) && state.pointerType != null) {
                        // Wait for onClick to fire onPress. This avoids browser issues when the DOM
                        // is mutated between onPointerUp and onClick, and is more compatible with third party libraries.
                        // https://github.com/adobe/react-spectrum/issues/1513
                        // https://issues.chromium.org/issues/40732224
                        // However, iOS and Android do not focus or fire onClick after a long press.
                        // We work around this by triggering a click ourselves after a timeout.
                        // This timeout is canceled during the click event in case the real one fires first.
                        // The timeout must be at least 32ms, because Safari on iOS delays the click event on
                        // non-form elements without certain ARIA roles (for hover emulation).
                        // https://github.com/WebKit/WebKit/blob/dccfae42bb29bd4bdef052e469f604a9387241c0/Source/WebKit/WebProcess/WebPage/ios/WebPageIOS.mm#L875-L892
                        let clicked = false;
                        let timeout = setTimeout(()=>{
                            if (state.isPressed && state.target instanceof HTMLElement) {
                                if (clicked) cancelEvent(e);
                                else {
                                    (0, $4623aa9f87f28cd4$export$de79e2c695e052f3)(state.target);
                                    state.target.click();
                                }
                            }
                        }, 80);
                        // Use a capturing listener to track if a click occurred.
                        // If stopPropagation is called it may never reach our handler.
                        addGlobalListener(e.currentTarget, 'click', ()=>clicked = true, true);
                        state.disposables.push(()=>clearTimeout(timeout));
                    } else cancelEvent(e);
                    // Ignore subsequent onPointerLeave event before onClick on touch devices.
                    state.isOverTarget = false;
                }
            };
            let onPointerCancel = (e)=>{
                cancelEvent(e);
            };
            addGlobalListener((0, $48852fd65b79e251$export$b204af158042fbac)(state.target), 'pointerup', onPointerUp, false);
            addGlobalListener((0, $48852fd65b79e251$export$b204af158042fbac)(state.target), 'pointercancel', onPointerCancel, false);
            return ()=>{
                removeGlobalListener((0, $48852fd65b79e251$export$b204af158042fbac)(state.target), 'pointerup', onPointerUp, false);
                removeGlobalListener((0, $48852fd65b79e251$export$b204af158042fbac)(state.target), 'pointercancel', onPointerCancel, false);
            };
        } else {
            isPointerPressed;
            isPointerPressed;
        }
    }, [
        isPointerPressed,
        addGlobalListener,
        removeGlobalListener
    ]);
    let pressProps = (0, $acw62.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($6c43aa319e86785e$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && (0, $bc46b52522f8f24d$export$4282f70798064fe0)(e.currentTarget, (0, $bc46b52522f8f24d$export$e58f029f0fbfdb29)(e.nativeEvent))) {
                    var _state_metaKeyEvents;
                    if ($6c43aa319e86785e$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard((0, $bc46b52522f8f24d$export$e58f029f0fbfdb29)(e.nativeEvent), e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        setIsElemKeyPressed(true);
                        state.pointerType = 'keyboard';
                        shouldStopPropagation = triggerPressStart(e, 'keyboard');
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $c0699bc5a0b3191f$export$9ac100e40613ea10)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === 'Meta') state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !(0, $bc46b52522f8f24d$export$4282f70798064fe0)(e.currentTarget, (0, $bc46b52522f8f24d$export$e58f029f0fbfdb29)(e.nativeEvent))) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $c9b835cc9e261550$export$95185d699e05d4d7).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === 'virtual' || (0, $6fcd80e55e680740$export$60278871457622de)(e.nativeEvent))) {
                        let stopPressStart = triggerPressStart(e, 'virtual');
                        let stopPressUp = triggerPressUp(e, 'virtual');
                        let stopPressEnd = triggerPressEnd(e, 'virtual');
                        triggerClick(e);
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    } else if (state.isPressed && state.pointerType !== 'keyboard') {
                        let pointerType = state.pointerType || e.nativeEvent.pointerType || 'virtual';
                        let stopPressUp = triggerPressUp($6c43aa319e86785e$var$$f6c31cce2adf654f$var$createEvent(e.currentTarget, e), pointerType);
                        let stopPressEnd = triggerPressEnd($6c43aa319e86785e$var$$f6c31cce2adf654f$var$createEvent(e.currentTarget, e), pointerType, true);
                        shouldStopPropagation = stopPressUp && stopPressEnd;
                        state.isOverTarget = false;
                        triggerClick(e);
                        cancel(e);
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        if (typeof PointerEvent !== 'undefined') {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !(0, $bc46b52522f8f24d$export$4282f70798064fe0)(e.currentTarget, (0, $bc46b52522f8f24d$export$e58f029f0fbfdb29)(e.nativeEvent))) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $6fcd80e55e680740$export$29bf1b5f2c56cf63)(e.nativeEvent)) {
                    state.pointerType = 'virtual';
                    return;
                }
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    setIsPointerPressed('pointer');
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!allowTextSelectionOnPress) (0, $440ff080e030ab26$export$16a4697467175487)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    // Release pointer capture so that touch interactions can leave the original target.
                    // This enables onPointerLeave and onPointerEnter to fire.
                    let target = (0, $bc46b52522f8f24d$export$e58f029f0fbfdb29)(e.nativeEvent);
                    if ('releasePointerCapture' in target) target.releasePointerCapture(e.pointerId);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!(0, $bc46b52522f8f24d$export$4282f70798064fe0)(e.currentTarget, (0, $bc46b52522f8f24d$export$e58f029f0fbfdb29)(e.nativeEvent))) return;
                if (e.button === 0) {
                    if (preventFocusOnPress) {
                        let dispose = (0, $7fc007d8fdcfe19c$export$cabe61c495ee3649)(e.target);
                        if (dispose) state.disposables.push(dispose);
                    }
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!(0, $bc46b52522f8f24d$export$4282f70798064fe0)(e.currentTarget, (0, $bc46b52522f8f24d$export$e58f029f0fbfdb29)(e.nativeEvent)) || state.pointerType === 'virtual') return;
                // Only handle left clicks. If isPressed is true, delay until onClick.
                if (e.button === 0 && !state.isPressed) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            pressProps.onPointerEnter = (e)=>{
                if (e.pointerId === state.activePointerId && state.target && !state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = true;
                    triggerPressStart($6c43aa319e86785e$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                }
            };
            pressProps.onPointerLeave = (e)=>{
                if (e.pointerId === state.activePointerId && state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($6c43aa319e86785e$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            pressProps.onDragStart = (e)=>{
                if (!(0, $bc46b52522f8f24d$export$4282f70798064fe0)(e.currentTarget, (0, $bc46b52522f8f24d$export$e58f029f0fbfdb29)(e.nativeEvent))) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else var e, e1, e2, e3, e4, e5, e6, e7, e8;
        return pressProps;
    }, [
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp,
        triggerClick,
        triggerSyntheticClick
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!domRef || false) return;
        const ownerDocument = (0, $48852fd65b79e251$export$b204af158042fbac)(domRef.current);
        if (!ownerDocument || !ownerDocument.head || ownerDocument.getElementById($6c43aa319e86785e$var$$f6c31cce2adf654f$var$STYLE_ID)) return;
        const style = ownerDocument.createElement('style');
        style.id = $6c43aa319e86785e$var$$f6c31cce2adf654f$var$STYLE_ID;
        // touchAction: 'manipulation' is supposed to be equivalent, but in
        // Safari it causes onPointerCancel not to fire on scroll.
        // https://bugs.webkit.org/show_bug.cgi?id=240917
        style.textContent = `
@layer {
  [${$6c43aa319e86785e$var$$f6c31cce2adf654f$var$PRESSABLE_ATTRIBUTE}] {
    touch-action: pan-x pan-y pinch-zoom;
  }
}
    `.trim();
        ownerDocument.head.prepend(style);
    }, [
        domRef
    ]);
    (0, $acw62.useEffect)(()=>{
        let state = ref.current;
        return ()=>{
            var _state_target;
            if (!allowTextSelectionOnPress) (0, $440ff080e030ab26$export$b0d6fa1ab32e3295)((_state_target = state.target) !== null && _state_target !== void 0 ? _state_target : undefined);
            for (let dispose of state.disposables)dispose();
            state.disposables = [];
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(domProps, pressProps, {
            [$6c43aa319e86785e$var$$f6c31cce2adf654f$var$PRESSABLE_ATTRIBUTE]: true
        })
    };
}
function $6c43aa319e86785e$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === 'A' && target.hasAttribute('href');
}
function $6c43aa319e86785e$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute('role');
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === 'Enter' || key === ' ' || key === 'Spacebar' || code === 'Space') && !(element instanceof (0, $48852fd65b79e251$export$f21a1ffae260145a)(element).HTMLInputElement && !$6c43aa319e86785e$var$$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, $48852fd65b79e251$export$f21a1ffae260145a)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === 'link' || !role && $6c43aa319e86785e$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== 'Enter');
}
function $6c43aa319e86785e$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $6c43aa319e86785e$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $6c43aa319e86785e$var$$f6c31cce2adf654f$var$createTouchEvent(target, e) {
    let clientX = 0;
    let clientY = 0;
    if (e.targetTouches && e.targetTouches.length === 1) {
        clientX = e.targetTouches[0].clientX;
        clientY = e.targetTouches[0].clientY;
    }
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey,
        clientX: clientX,
        clientY: clientY
    };
}
function $6c43aa319e86785e$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    let clientX = e.clientX;
    let clientY = e.clientY;
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey,
        clientX: clientX,
        clientY: clientY
    };
}
function $6c43aa319e86785e$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $6c43aa319e86785e$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $6c43aa319e86785e$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $6c43aa319e86785e$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $6c43aa319e86785e$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $6c43aa319e86785e$var$$f6c31cce2adf654f$var$shouldPreventDefaultUp(target) {
    if (target instanceof HTMLInputElement) return false;
    if (target instanceof HTMLButtonElement) return target.type !== 'submit' && target.type !== 'reset';
    if ($6c43aa319e86785e$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
function $6c43aa319e86785e$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$6c43aa319e86785e$var$$f6c31cce2adf654f$var$isValidInputKey(target, key);
    return $6c43aa319e86785e$var$$f6c31cce2adf654f$var$shouldPreventDefaultUp(target);
}
const $6c43aa319e86785e$var$$f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
function $6c43aa319e86785e$var$$f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === 'checkbox' || target.type === 'radio' ? key === ' ' : $6c43aa319e86785e$var$$f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $85c02a989ed6495e$export$37b0961d2f4751e2(props, state, ref) {
    let { value: value, children: children, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressChange: onPressChange, onPress: onPress, onPressUp: onPressUp, onClick: onClick } = props;
    const isDisabled = props.isDisabled || state.isDisabled;
    let hasChildren = children != null;
    let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    !hasChildren && hasAriaLabel;
    let checked = state.selectedValue === value;
    let onChange = (e)=>{
        e.stopPropagation();
        state.setSelectedValue(value);
    };
    // Handle press state for keyboard interactions and cases where labelProps is not used.
    let { pressProps: pressProps, isPressed: isPressed } = (0, $6c43aa319e86785e$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        onPressUp: onPressUp,
        onClick: onClick,
        isDisabled: isDisabled
    });
    // Handle press state on the label.
    let { pressProps: labelProps, isPressed: isLabelPressed } = (0, $6c43aa319e86785e$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPressUp: onPressUp,
        onClick: onClick,
        isDisabled: isDisabled,
        onPress (e) {
            var _ref_current;
            onPress === null || onPress === void 0 || onPress(e);
            state.setSelectedValue(value);
            (_ref_current = ref.current) === null || _ref_current === void 0 || _ref_current.focus();
        }
    });
    let { focusableProps: focusableProps } = (0, $daedc3252d285a56$export$4c014de7c8940b4c)((0, $e611552c564dfe1f$export$9d1611c77c2fe928)(props, {
        onFocus: ()=>state.setLastFocusedValue(value)
    }), ref);
    let interactions = (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(pressProps, focusableProps);
    let domProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let tabIndex = -1;
    if (state.selectedValue != null) {
        if (state.selectedValue === value) tabIndex = 0;
    } else if (state.lastFocusedValue === value || state.lastFocusedValue == null) tabIndex = 0;
    if (isDisabled) tabIndex = undefined;
    let { name: name, form: form, descriptionId: descriptionId, errorMessageId: errorMessageId, validationBehavior: validationBehavior } = (0, $27196c7c765c8a8e$export$37b65e5b5444d35c).get(state);
    (0, $7f099d759e9c1e4d$export$5add1d006293d136)(ref, state.defaultSelectedValue, state.setSelectedValue);
    (0, $13ce3eede8664ea0$export$b8473d3665f3a75a)({
        validationBehavior: validationBehavior
    }, state, ref);
    return {
        labelProps: (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(labelProps, (0, $acw62.useMemo)(()=>({
                onClick: (e)=>e.preventDefault(),
                // Prevent label from being focused when mouse down on it.
                // Note, this does not prevent the input from being focused in the `click` event.
                onMouseDown: (e)=>e.preventDefault()
            }), [])),
        inputProps: (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(domProps, {
            ...interactions,
            type: 'radio',
            name: name,
            form: form,
            tabIndex: tabIndex,
            disabled: isDisabled,
            required: state.isRequired && validationBehavior === 'native',
            checked: checked,
            value: value,
            onChange: onChange,
            'aria-describedby': [
                props['aria-describedby'],
                state.isInvalid ? errorMessageId : null,
                descriptionId
            ].filter(Boolean).join(' ') || undefined
        }),
        isDisabled: isDisabled,
        isSelected: checked,
        isPressed: isPressed || isLabelPressed
    };
}





// https://github.com/microsoft/tabster/blob/a89fc5d7e332d48f68d03b1ca6e344489d1c3898/src/Shadowdomize/ShadowTreeWalker.ts
class $387c4108f5df8f1f$export$63eb3ababa9c55c4 {
    get currentNode() {
        return this._currentNode;
    }
    set currentNode(node) {
        if (!(0, $bc46b52522f8f24d$export$4282f70798064fe0)(this.root, node)) throw new Error('Cannot set currentNode to a node that is not contained by the root node.');
        const walkers = [];
        let curNode = node;
        let currentWalkerCurrentNode = node;
        this._currentNode = node;
        while(curNode && curNode !== this.root)if (curNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
            const shadowRoot = curNode;
            const walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
                acceptNode: this._acceptNode
            });
            walkers.push(walker);
            walker.currentNode = currentWalkerCurrentNode;
            this._currentSetFor.add(walker);
            curNode = currentWalkerCurrentNode = shadowRoot.host;
        } else curNode = curNode.parentNode;
        const walker = this._doc.createTreeWalker(this.root, this.whatToShow, {
            acceptNode: this._acceptNode
        });
        walkers.push(walker);
        walker.currentNode = currentWalkerCurrentNode;
        this._currentSetFor.add(walker);
        this._walkerStack = walkers;
    }
    get doc() {
        return this._doc;
    }
    firstChild() {
        let currentNode = this.currentNode;
        let newNode = this.nextNode();
        if (!(0, $bc46b52522f8f24d$export$4282f70798064fe0)(currentNode, newNode)) {
            this.currentNode = currentNode;
            return null;
        }
        if (newNode) this.currentNode = newNode;
        return newNode;
    }
    lastChild() {
        let walker = this._walkerStack[0];
        let newNode = walker.lastChild();
        if (newNode) this.currentNode = newNode;
        return newNode;
    }
    nextNode() {
        const nextNode = this._walkerStack[0].nextNode();
        if (nextNode) {
            const shadowRoot = nextNode.shadowRoot;
            if (shadowRoot) {
                var _this_filter;
                let nodeResult;
                if (typeof this.filter === 'function') nodeResult = this.filter(nextNode);
                else if ((_this_filter = this.filter) === null || _this_filter === void 0 ? void 0 : _this_filter.acceptNode) nodeResult = this.filter.acceptNode(nextNode);
                if (nodeResult === NodeFilter.FILTER_ACCEPT) {
                    this.currentNode = nextNode;
                    return nextNode;
                }
                // _acceptNode should have added new walker for this shadow,
                // go in recursively.
                let newNode = this.nextNode();
                if (newNode) this.currentNode = newNode;
                return newNode;
            }
            if (nextNode) this.currentNode = nextNode;
            return nextNode;
        } else {
            if (this._walkerStack.length > 1) {
                this._walkerStack.shift();
                let newNode = this.nextNode();
                if (newNode) this.currentNode = newNode;
                return newNode;
            } else return null;
        }
    }
    previousNode() {
        const currentWalker = this._walkerStack[0];
        if (currentWalker.currentNode === currentWalker.root) {
            if (this._currentSetFor.has(currentWalker)) {
                this._currentSetFor.delete(currentWalker);
                if (this._walkerStack.length > 1) {
                    this._walkerStack.shift();
                    let newNode = this.previousNode();
                    if (newNode) this.currentNode = newNode;
                    return newNode;
                } else return null;
            }
            return null;
        }
        const previousNode = currentWalker.previousNode();
        if (previousNode) {
            const shadowRoot = previousNode.shadowRoot;
            if (shadowRoot) {
                var _this_filter;
                let nodeResult;
                if (typeof this.filter === 'function') nodeResult = this.filter(previousNode);
                else if ((_this_filter = this.filter) === null || _this_filter === void 0 ? void 0 : _this_filter.acceptNode) nodeResult = this.filter.acceptNode(previousNode);
                if (nodeResult === NodeFilter.FILTER_ACCEPT) {
                    if (previousNode) this.currentNode = previousNode;
                    return previousNode;
                }
                // _acceptNode should have added new walker for this shadow,
                // go in recursively.
                let newNode = this.lastChild();
                if (newNode) this.currentNode = newNode;
                return newNode;
            }
            if (previousNode) this.currentNode = previousNode;
            return previousNode;
        } else {
            if (this._walkerStack.length > 1) {
                this._walkerStack.shift();
                let newNode = this.previousNode();
                if (newNode) this.currentNode = newNode;
                return newNode;
            } else return null;
        }
    }
    /**
     * @deprecated
     */ nextSibling() {
        // if (__DEV__) {
        //     throw new Error("Method not implemented.");
        // }
        return null;
    }
    /**
     * @deprecated
     */ previousSibling() {
        // if (__DEV__) {
        //     throw new Error("Method not implemented.");
        // }
        return null;
    }
    /**
     * @deprecated
     */ parentNode() {
        // if (__DEV__) {
        //     throw new Error("Method not implemented.");
        // }
        return null;
    }
    constructor(doc, root, whatToShow, filter){
        this._walkerStack = [];
        this._currentSetFor = new Set();
        this._acceptNode = (node)=>{
            if (node.nodeType === Node.ELEMENT_NODE) {
                const shadowRoot = node.shadowRoot;
                if (shadowRoot) {
                    const walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
                        acceptNode: this._acceptNode
                    });
                    this._walkerStack.unshift(walker);
                    return NodeFilter.FILTER_ACCEPT;
                } else {
                    var _this_filter;
                    if (typeof this.filter === 'function') return this.filter(node);
                    else if ((_this_filter = this.filter) === null || _this_filter === void 0 ? void 0 : _this_filter.acceptNode) return this.filter.acceptNode(node);
                    else if (this.filter === null) return NodeFilter.FILTER_ACCEPT;
                }
            }
            return NodeFilter.FILTER_SKIP;
        };
        this._doc = doc;
        this.root = root;
        this.filter = filter !== null && filter !== void 0 ? filter : null;
        this.whatToShow = whatToShow !== null && whatToShow !== void 0 ? whatToShow : NodeFilter.SHOW_ALL;
        this._currentNode = root;
        this._walkerStack.unshift(doc.createTreeWalker(root, whatToShow, this._acceptNode));
        const shadowRoot = root.shadowRoot;
        if (shadowRoot) {
            const walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
                acceptNode: this._acceptNode
            });
            this._walkerStack.unshift(walker);
        }
    }
}
function $387c4108f5df8f1f$export$4d0f8be8b12a7ef6(doc, root, whatToShow, filter) {
    if ((0, $9a3b4c8fe6846e35$export$98658e8c59125e6a)()) return new $387c4108f5df8f1f$export$63eb3ababa9c55c4(doc, root, whatToShow, filter);
    return doc.createTreeWalker(root, whatToShow, filter);
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $dd1b249b49caa281$var$$9bf71ea28793e738$var$FocusContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
const $dd1b249b49caa281$var$$9bf71ea28793e738$var$RESTORE_FOCUS_EVENT = 'react-aria-focus-scope-restore';
let $dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope = null;
function $dd1b249b49caa281$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $acw62.useRef)(null);
    let endRef = (0, $acw62.useRef)(null);
    let scopeRef = (0, $acw62.useRef)([]);
    let { parentNode: parentNode } = (0, $acw62.useContext)($dd1b249b49caa281$var$$9bf71ea28793e738$var$FocusContext) || {};
    // Create a tree node here so we can add children to it even before it is added to the tree.
    let node = (0, $acw62.useMemo)(()=>new $dd1b249b49caa281$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        }), [
        scopeRef
    ]);
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        let parent = parentNode || $dd1b249b49caa281$export$d06fae2ee68b101e.root;
        if ($dd1b249b49caa281$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope && !$dd1b249b49caa281$var$$9bf71ea28793e738$var$isAncestorScope($dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
            let activeNode = $dd1b249b49caa281$export$d06fae2ee68b101e.getTreeNode($dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $dd1b249b49caa281$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        let node = $dd1b249b49caa281$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        let nodes = [];
        let stopPropagation = (e)=>e.stopPropagation();
        while(node && node !== endRef.current){
            nodes.push(node);
            // Stop custom restore focus event from propagating to parent focus scopes.
            node.addEventListener($dd1b249b49caa281$var$$9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, stopPropagation);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
        return ()=>{
            for (let node of nodes)node.removeEventListener($dd1b249b49caa281$var$$9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, stopPropagation);
        };
    }, [
        children
    ]);
    $dd1b249b49caa281$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $dd1b249b49caa281$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $dd1b249b49caa281$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $dd1b249b49caa281$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    (0, $acw62.useEffect)(()=>{
        const activeElement = (0, $bc46b52522f8f24d$export$cd4e5573fbe2b576)((0, $48852fd65b79e251$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined));
        let scope = null;
        if ($dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
            // We need to traverse the focusScope tree and find the bottom most scope that
            // contains the active element and set that as the activeScope.
            for (let node of $dd1b249b49caa281$export$d06fae2ee68b101e.traverse())if (node.scopeRef && $dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
            if (scope === $dd1b249b49caa281$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        return ()=>{
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $dd1b249b49caa281$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === $dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope || $dd1b249b49caa281$var$$9bf71ea28793e738$var$isAncestorScope(scopeRef, $dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope)) && (!parentScope || $dd1b249b49caa281$export$d06fae2ee68b101e.getTreeNode(parentScope))) $dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope = parentScope;
            $dd1b249b49caa281$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    let focusManager = (0, $acw62.useMemo)(()=>$dd1b249b49caa281$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef), []);
    let value = (0, $acw62.useMemo)(()=>({
            focusManager: focusManager,
            parentNode: node
        }), [
        node,
        focusManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dd1b249b49caa281$var$$9bf71ea28793e738$var$FocusContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $dd1b249b49caa281$export$10c5169755ce7bd7() {
    var _useContext;
    return (_useContext = (0, $acw62.useContext)($dd1b249b49caa281$var$$9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $dd1b249b49caa281$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            var _scope_;
            let node = from || (0, $bc46b52522f8f24d$export$cd4e5573fbe2b576)((0, $48852fd65b79e251$export$b204af158042fbac)((_scope_ = scope[0]) !== null && _scope_ !== void 0 ? _scope_ : undefined));
            let sentinel = scope[0].previousElementSibling;
            let scopeRoot = $dd1b249b49caa281$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $dd1b249b49caa281$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $dd1b249b49caa281$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            var _scope_;
            let node = from || (0, $bc46b52522f8f24d$export$cd4e5573fbe2b576)((0, $48852fd65b79e251$export$b204af158042fbac)((_scope_ = scope[0]) !== null && _scope_ !== void 0 ? _scope_ : undefined));
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let scopeRoot = $dd1b249b49caa281$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $dd1b249b49caa281$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $dd1b249b49caa281$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $dd1b249b49caa281$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $dd1b249b49caa281$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $dd1b249b49caa281$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $dd1b249b49caa281$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $dd1b249b49caa281$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $dd1b249b49caa281$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
function $dd1b249b49caa281$var$$9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $dd1b249b49caa281$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    let scope = $dd1b249b49caa281$export$d06fae2ee68b101e.getTreeNode($dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $dd1b249b49caa281$var$$9bf71ea28793e738$var$isTabbableRadio(element) {
    if (element.checked) return true;
    let radios = [];
    if (!element.form) radios = [
        ...(0, $48852fd65b79e251$export$b204af158042fbac)(element).querySelectorAll(`input[type="radio"][name="${CSS.escape(element.name)}"]`)
    ].filter((radio)=>!radio.form);
    else {
        var _element_form_elements, _element_form;
        let radioList = (_element_form = element.form) === null || _element_form === void 0 ? void 0 : (_element_form_elements = _element_form.elements) === null || _element_form_elements === void 0 ? void 0 : _element_form_elements.namedItem(element.name);
        radios = [
            ...radioList !== null && radioList !== void 0 ? radioList : []
        ];
    }
    if (!radios) return false;
    let anyChecked = radios.some((radio)=>radio.checked);
    return !anyChecked;
}
function $dd1b249b49caa281$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $acw62.useRef)(undefined);
    let raf = (0, $acw62.useRef)(undefined);
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        const ownerDocument = (0, $48852fd65b79e251$export$b204af158042fbac)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey || !$dd1b249b49caa281$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = (0, $bc46b52522f8f24d$export$cd4e5573fbe2b576)(ownerDocument);
            let scope = scopeRef.current;
            if (!scope || !$dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let scopeRoot = $dd1b249b49caa281$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $dd1b249b49caa281$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $dd1b249b49caa281$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope || $dd1b249b49caa281$var$$9bf71ea28793e738$var$isAncestorScope($dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInScope((0, $bc46b52522f8f24d$export$e58f029f0fbfdb29)(e), scopeRef.current)) {
                $dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = (0, $bc46b52522f8f24d$export$e58f029f0fbfdb29)(e);
            } else if ($dd1b249b49caa281$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInChildScope((0, $bc46b52522f8f24d$export$e58f029f0fbfdb29)(e), scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope && $dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope.current) $dd1b249b49caa281$var$$9bf71ea28793e738$var$focusFirstInScope($dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope.current);
            } else if ($dd1b249b49caa281$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = (0, $bc46b52522f8f24d$export$e58f029f0fbfdb29)(e);
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(()=>{
                // Patches infinite focus coersion loop for Android Talkback where the user isn't able to move the virtual cursor
                // if within a containing focus scope. Bug filed against Chrome: https://issuetracker.google.com/issues/384844019.
                // Note that this means focus can leave focus containing modals due to this, but it is isolated to Chrome Talkback.
                let modality = (0, $77c8ff0a3cb27e18$export$630ff653c5ada6a9)();
                let shouldSkipFocusRestore = (modality === 'virtual' || modality === null) && (0, $c0699bc5a0b3191f$export$a11b0059900ceec8)() && (0, $c0699bc5a0b3191f$export$6446a186d09e379e)();
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                let activeElement = (0, $bc46b52522f8f24d$export$cd4e5573fbe2b576)(ownerDocument);
                if (!shouldSkipFocusRestore && activeElement && $dd1b249b49caa281$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInChildScope(activeElement, scopeRef)) {
                    $dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                    let target = (0, $bc46b52522f8f24d$export$e58f029f0fbfdb29)(e);
                    if (target && target.isConnected) {
                        var _focusedNode_current;
                        focusedNode.current = target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 || _focusedNode_current.focus();
                    } else if ($dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope.current) $dd1b249b49caa281$var$$9bf71ea28793e738$var$focusFirstInScope($dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener('keydown', onKeyDown, false);
        ownerDocument.addEventListener('focusin', onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener('focusin', onFocus, false));
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener('focusout', onBlur, false));
        return ()=>{
            ownerDocument.removeEventListener('keydown', onKeyDown, false);
            ownerDocument.removeEventListener('focusin', onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener('focusin', onFocus, false));
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener('focusout', onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInChildScope(element);
}
function $dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some((node)=>node.contains(element));
}
function $dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest('[data-react-aria-top-layer]')) return true;
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s } of $dd1b249b49caa281$export$d06fae2ee68b101e.traverse($dd1b249b49caa281$export$d06fae2ee68b101e.getTreeNode(scope))){
        if (s && $dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $dd1b249b49caa281$export$1258395f99bf9cbf(element) {
    return $dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInChildScope(element, $dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope);
}
function $dd1b249b49caa281$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    let parent = (_focusScopeTree_getTreeNode = $dd1b249b49caa281$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $dd1b249b49caa281$var$$9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        (0, $f84e6bd16978dcef$export$80f3e147d781571c)(element);
    } catch  {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch  {
    // ignore
    }
}
function $dd1b249b49caa281$var$$9bf71ea28793e738$var$getFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let scopeRoot = $dd1b249b49caa281$var$$9bf71ea28793e738$var$getScopeRoot(scope);
    let walker = $dd1b249b49caa281$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $dd1b249b49caa281$var$$9bf71ea28793e738$var$getScopeRoot(scope);
        walker = $dd1b249b49caa281$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    return nextNode;
}
function $dd1b249b49caa281$var$$9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
    $dd1b249b49caa281$var$$9bf71ea28793e738$var$focusElement($dd1b249b49caa281$var$$9bf71ea28793e738$var$getFirstInScope(scope, tabbable));
}
function $dd1b249b49caa281$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(autoFocus);
    (0, $acw62.useEffect)(()=>{
        if (autoFocusRef.current) {
            $dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            const ownerDocument = (0, $48852fd65b79e251$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInScope((0, $bc46b52522f8f24d$export$cd4e5573fbe2b576)(ownerDocument), $dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $dd1b249b49caa281$var$$9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $dd1b249b49caa281$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        const ownerDocument = (0, $48852fd65b79e251$export$b204af158042fbac)(scope ? scope[0] : undefined);
        let onFocus = (e)=>{
            let target = (0, $bc46b52522f8f24d$export$e58f029f0fbfdb29)(e);
            if ($dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInAnyScope(target)) $dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope = null;
        };
        ownerDocument.addEventListener('focusin', onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener('focusin', onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener('focusin', onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener('focusin', onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $dd1b249b49caa281$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    let scope = $dd1b249b49caa281$export$d06fae2ee68b101e.getTreeNode($dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $dd1b249b49caa281$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    // eslint-disable-next-line no-restricted-globals
    const nodeToRestoreRef = (0, $acw62.useRef)(typeof document !== 'undefined' ? (0, $bc46b52522f8f24d$export$cd4e5573fbe2b576)((0, $48852fd65b79e251$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined)) : null);
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        let scope = scopeRef.current;
        const ownerDocument = (0, $48852fd65b79e251$export$b204af158042fbac)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope || $dd1b249b49caa281$var$$9bf71ea28793e738$var$isAncestorScope($dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInScope((0, $bc46b52522f8f24d$export$cd4e5573fbe2b576)(ownerDocument), scopeRef.current)) $dd1b249b49caa281$var$$9bf71ea28793e738$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener('focusin', onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener('focusin', onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener('focusin', onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener('focusin', onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        const ownerDocument = (0, $48852fd65b79e251$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey || !$dd1b249b49caa281$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            if (!$dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInChildScope(focusedElement, scopeRef) || !$dd1b249b49caa281$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef)) return;
            let treeNode = $dd1b249b49caa281$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $dd1b249b49caa281$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !nodeToRestore.isConnected || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInChildScope(nextElement, scopeRef)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInChildScope(nextElement, scopeRef));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $dd1b249b49caa281$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $dd1b249b49caa281$var$$9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener('keydown', onKeyDown, true);
        return ()=>{
            if (!contain) ownerDocument.removeEventListener('keydown', onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        const ownerDocument = (0, $48852fd65b79e251$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        let treeNode = $dd1b249b49caa281$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return ()=>{
            let treeNode = $dd1b249b49caa281$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            let activeElement = (0, $bc46b52522f8f24d$export$cd4e5573fbe2b576)(ownerDocument);
            if (restoreFocus && nodeToRestore && (activeElement && $dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInChildScope(activeElement, scopeRef) || activeElement === ownerDocument.body && $dd1b249b49caa281$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $dd1b249b49caa281$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $dd1b249b49caa281$var$$9bf71ea28793e738$var$restoreFocusToElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $dd1b249b49caa281$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                let node = $dd1b249b49caa281$var$$9bf71ea28793e738$var$getFirstInScope(treeNode.scopeRef.current, true);
                                $dd1b249b49caa281$var$$9bf71ea28793e738$var$restoreFocusToElement(node);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $dd1b249b49caa281$var$$9bf71ea28793e738$var$restoreFocusToElement(node) {
    // Dispatch a custom event that parent elements can intercept to customize focus restoration.
    // For example, virtualized collection components reuse DOM elements, so the original element
    // might still exist in the DOM but representing a different item.
    if (node.dispatchEvent(new CustomEvent($dd1b249b49caa281$var$$9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, {
        bubbles: true,
        cancelable: true
    }))) $dd1b249b49caa281$var$$9bf71ea28793e738$var$focusElement(node);
}
function $dd1b249b49caa281$export$2d6ec8fc375ceafa(root, opts, scope) {
    let filter = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? (0, $5c8550b2a03c9d44$export$bebd5a1431fec25d) : (0, $5c8550b2a03c9d44$export$4c063cf1350e6fed);
    // Ensure that root is an Element or fall back appropriately
    let rootElement = (root === null || root === void 0 ? void 0 : root.nodeType) === Node.ELEMENT_NODE ? root : null;
    // Determine the document to use
    let doc = (0, $48852fd65b79e251$export$b204af158042fbac)(rootElement);
    // Create a TreeWalker, ensuring the root is an Element or Document
    let walker = (0, $387c4108f5df8f1f$export$4d0f8be8b12a7ef6)(doc, root || doc, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if ((opts === null || opts === void 0 ? void 0 : opts.tabbable) && node.tagName === 'INPUT' && node.getAttribute('type') === 'radio') {
                // If the radio is in a form, we can get all the other radios by name
                if (!$dd1b249b49caa281$var$$9bf71ea28793e738$var$isTabbableRadio(node)) return NodeFilter.FILTER_REJECT;
                // If the radio is in the same group as the current node and none are selected, we can skip it
                if (walker.currentNode.tagName === 'INPUT' && walker.currentNode.type === 'radio' && walker.currentNode.name === node.name) return NodeFilter.FILTER_REJECT;
            }
            if (filter(node) && (!scope || $dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $dd1b249b49caa281$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $bc46b52522f8f24d$export$cd4e5573fbe2b576)((0, $48852fd65b79e251$export$b204af158042fbac)(root));
            let walker = $dd1b249b49caa281$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $dd1b249b49caa281$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $bc46b52522f8f24d$export$cd4e5573fbe2b576)((0, $48852fd65b79e251$export$b204af158042fbac)(root));
            let walker = $dd1b249b49caa281$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                let next = $dd1b249b49caa281$var$$9bf71ea28793e738$var$last(walker);
                if (next) $dd1b249b49caa281$var$$9bf71ea28793e738$var$focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                let lastNode = $dd1b249b49caa281$var$$9bf71ea28793e738$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $dd1b249b49caa281$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $dd1b249b49caa281$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $dd1b249b49caa281$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $dd1b249b49caa281$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $dd1b249b49caa281$var$$9bf71ea28793e738$var$last(walker);
            if (next) $dd1b249b49caa281$var$$9bf71ea28793e738$var$focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function $dd1b249b49caa281$var$$9bf71ea28793e738$var$last(walker) {
    let next = undefined;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
class $dd1b249b49caa281$var$$9bf71ea28793e738$var$Tree {
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
        if (!parentNode) return;
        let node = new $dd1b249b49caa281$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    addNode(node) {
        this.fastMap.set(node.scopeRef, node);
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        if (!node) return;
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $dd1b249b49caa281$var$$9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        if (parentNode) {
            parentNode.removeChild(node);
            if (children.size > 0) children.forEach((child)=>parentNode && parentNode.addChild(child));
        }
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.size > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        var _node_parent;
        let newTree = new $dd1b249b49caa281$var$$9bf71ea28793e738$var$Tree();
        var _node_parent_scopeRef;
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
        return newTree;
    }
    constructor(){
        this.fastMap = new Map();
        this.root = new $dd1b249b49caa281$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
}
class $dd1b249b49caa281$var$$9bf71ea28793e738$var$TreeNode {
    addChild(node) {
        this.children.add(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.delete(node);
        node.parent = undefined;
    }
    constructor(props){
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
}
let $dd1b249b49caa281$export$d06fae2ee68b101e = new $dd1b249b49caa281$var$$9bf71ea28793e738$var$Tree();




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
const $5bbf0c417d27c300$var$$148a7a147e38ea7f$var$RTL_SCRIPTS = new Set([
    'Arab',
    'Syrc',
    'Samr',
    'Mand',
    'Thaa',
    'Mend',
    'Nkoo',
    'Adlm',
    'Rohg',
    'Hebr'
]);
const $5bbf0c417d27c300$var$$148a7a147e38ea7f$var$RTL_LANGS = new Set([
    'ae',
    'ar',
    'arc',
    'bcc',
    'bqi',
    'ckb',
    'dv',
    'fa',
    'glk',
    'he',
    'ku',
    'mzn',
    'nqo',
    'pnb',
    'ps',
    'sd',
    'ug',
    'ur',
    'yi'
]);
function $5bbf0c417d27c300$export$702d680b21cbd764(localeString) {
    // If the Intl.Locale API is available, use it to get the locale's text direction.
    if (Intl.Locale) {
        let locale = new Intl.Locale(localeString).maximize();
        // Use the text info object to get the direction if possible.
        // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getTextInfo
        let textInfo = typeof locale.getTextInfo === 'function' ? locale.getTextInfo() : locale.textInfo;
        if (textInfo) return textInfo.direction === 'rtl';
        // Fallback: guess using the script.
        // This is more accurate than guessing by language, since languages can be written in multiple scripts.
        if (locale.script) return $5bbf0c417d27c300$var$$148a7a147e38ea7f$var$RTL_SCRIPTS.has(locale.script);
    }
    // If not, just guess by the language (first part of the locale)
    let lang = localeString.split('-')[0];
    return $5bbf0c417d27c300$var$$148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}




var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Locale passed from server by PackageLocalizationProvider.
const $d46432226f2a5488$var$$1e5a04cdaf7d1af8$var$localeSymbol = Symbol.for('react-aria.i18n.locale');
function $d46432226f2a5488$export$f09106e7c6677ec5() {
    let locale = typeof window !== 'undefined' && window[$d46432226f2a5488$var$$1e5a04cdaf7d1af8$var$localeSymbol] || typeof navigator !== 'undefined' && (navigator.language || navigator.userLanguage) || 'en-US';
    try {
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch  {
        locale = 'en-US';
    }
    return {
        locale: locale,
        direction: (0, $5bbf0c417d27c300$export$702d680b21cbd764)(locale) ? 'rtl' : 'ltr'
    };
}
let $d46432226f2a5488$var$$1e5a04cdaf7d1af8$var$currentLocale = $d46432226f2a5488$export$f09106e7c6677ec5();
let $d46432226f2a5488$var$$1e5a04cdaf7d1af8$var$listeners = new Set();
function $d46432226f2a5488$var$$1e5a04cdaf7d1af8$var$updateLocale() {
    $d46432226f2a5488$var$$1e5a04cdaf7d1af8$var$currentLocale = $d46432226f2a5488$export$f09106e7c6677ec5();
    for (let listener of $d46432226f2a5488$var$$1e5a04cdaf7d1af8$var$listeners)listener($d46432226f2a5488$var$$1e5a04cdaf7d1af8$var$currentLocale);
}
function $d46432226f2a5488$export$188ec29ebc2bdc3a() {
    let isSSR = (0, $3355288d61aeabc2$export$535bd6ca7f90a273)();
    let [defaultLocale, setDefaultLocale] = (0, $acw62.useState)($d46432226f2a5488$var$$1e5a04cdaf7d1af8$var$currentLocale);
    (0, $acw62.useEffect)(()=>{
        if ($d46432226f2a5488$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.addEventListener('languagechange', $d46432226f2a5488$var$$1e5a04cdaf7d1af8$var$updateLocale);
        $d46432226f2a5488$var$$1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
        return ()=>{
            $d46432226f2a5488$var$$1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
            if ($d46432226f2a5488$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.removeEventListener('languagechange', $d46432226f2a5488$var$$1e5a04cdaf7d1af8$var$updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) {
        let locale = typeof window !== 'undefined' && window[$d46432226f2a5488$var$$1e5a04cdaf7d1af8$var$localeSymbol];
        return {
            locale: locale || 'en-US',
            direction: 'ltr'
        };
    }
    return defaultLocale;
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $a7e3b1109bf64033$var$$18f2051aff69b9bf$var$I18nContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
/**
 * Internal component that handles the case when locale is provided.
 */ function $a7e3b1109bf64033$var$$18f2051aff69b9bf$var$I18nProviderWithLocale(props) {
    let { locale: locale, children: children } = props;
    let value = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            locale: locale,
            direction: (0, $5bbf0c417d27c300$export$702d680b21cbd764)(locale) ? 'rtl' : 'ltr'
        }), [
        locale
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a7e3b1109bf64033$var$$18f2051aff69b9bf$var$I18nContext.Provider, {
        value: value
    }, children);
}
/**
 * Internal component that handles the case when no locale is provided.
 */ function $a7e3b1109bf64033$var$$18f2051aff69b9bf$var$I18nProviderWithDefaultLocale(props) {
    let { children: children } = props;
    let defaultLocale = (0, $d46432226f2a5488$export$188ec29ebc2bdc3a)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a7e3b1109bf64033$var$$18f2051aff69b9bf$var$I18nContext.Provider, {
        value: defaultLocale
    }, children);
}
function $a7e3b1109bf64033$export$a54013f0d02a8f82(props) {
    let { locale: locale, children: children } = props;
    // Conditionally render different components to avoid calling useDefaultLocale.
    // This is necessary because useDefaultLocale triggers a re-render.
    if (locale) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a7e3b1109bf64033$var$$18f2051aff69b9bf$var$I18nProviderWithLocale, {
        locale: locale,
        children: children
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a7e3b1109bf64033$var$$18f2051aff69b9bf$var$I18nProviderWithDefaultLocale, {
        children: children
    });
}
function $a7e3b1109bf64033$export$43bb16f9c6d9e3f7() {
    let defaultLocale = (0, $d46432226f2a5488$export$188ec29ebc2bdc3a)();
    let context = (0, $acw62.useContext)($a7e3b1109bf64033$var$$18f2051aff69b9bf$var$I18nContext);
    return context || defaultLocale;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b6126734e5187be9$export$62b9571f283ff5c2(props, state) {
    let { name: name, form: form, isReadOnly: isReadOnly, isRequired: isRequired, isDisabled: isDisabled, orientation: orientation = 'vertical', validationBehavior: validationBehavior = 'aria' } = props;
    let { direction: direction } = (0, $a7e3b1109bf64033$export$43bb16f9c6d9e3f7)();
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $54c383c3558c03c1$export$294aa081a6c6f55d)({
        ...props,
        // Radio group is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span',
        isInvalid: state.isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let domProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    // When the radio group loses focus, reset the focusable radio to null if
    // there is no selection. This allows tabbing into the group from either
    // direction to go to the first or last radio.
    let { focusWithinProps: focusWithinProps } = (0, $02fb4773760e27fa$export$420e68273165f4ec)({
        onBlurWithin (e) {
            var _props_onBlur;
            (_props_onBlur = props.onBlur) === null || _props_onBlur === void 0 || _props_onBlur.call(props, e);
            if (!state.selectedValue) state.setLastFocusedValue(null);
        },
        onFocusWithin: props.onFocus,
        onFocusWithinChange: props.onFocusChange
    });
    let onKeyDown = (e)=>{
        let nextDir;
        switch(e.key){
            case 'ArrowRight':
                if (direction === 'rtl' && orientation !== 'vertical') nextDir = 'prev';
                else nextDir = 'next';
                break;
            case 'ArrowLeft':
                if (direction === 'rtl' && orientation !== 'vertical') nextDir = 'next';
                else nextDir = 'prev';
                break;
            case 'ArrowDown':
                nextDir = 'next';
                break;
            case 'ArrowUp':
                nextDir = 'prev';
                break;
            default:
                return;
        }
        e.preventDefault();
        let walker = (0, $dd1b249b49caa281$export$2d6ec8fc375ceafa)(e.currentTarget, {
            from: e.target,
            accept: (node)=>node instanceof (0, $48852fd65b79e251$export$f21a1ffae260145a)(node).HTMLInputElement && node.type === 'radio'
        });
        let nextElem;
        if (nextDir === 'next') {
            nextElem = walker.nextNode();
            if (!nextElem) {
                walker.currentNode = e.currentTarget;
                nextElem = walker.firstChild();
            }
        } else {
            nextElem = walker.previousNode();
            if (!nextElem) {
                walker.currentNode = e.currentTarget;
                nextElem = walker.lastChild();
            }
        }
        if (nextElem) {
            // Call focus on nextElem so that keyboard navigation scrolls the radio into view
            nextElem.focus();
            state.setSelectedValue(nextElem.value);
        }
    };
    let groupName = (0, $855de91ebb07800c$export$f680877a34711e37)(name);
    (0, $27196c7c765c8a8e$export$37b65e5b5444d35c).set(state, {
        name: groupName,
        form: form,
        descriptionId: descriptionProps.id,
        errorMessageId: errorMessageProps.id,
        validationBehavior: validationBehavior
    });
    return {
        radioGroupProps: (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(domProps, {
            // https://www.w3.org/TR/wai-aria-1.2/#radiogroup
            role: 'radiogroup',
            onKeyDown: onKeyDown,
            'aria-invalid': state.isInvalid || undefined,
            'aria-errormessage': props['aria-errormessage'],
            'aria-readonly': isReadOnly || undefined,
            'aria-required': isRequired || undefined,
            'aria-disabled': isDisabled || undefined,
            'aria-orientation': orientation,
            ...fieldProps,
            ...focusWithinProps
        }),
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}



var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $2b6fccd6bf1aab09$var$$5c3e21d68f1c4674$var$styles = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: '1px',
    whiteSpace: 'nowrap'
};
function $2b6fccd6bf1aab09$export$a966af930f325cab(props = {}) {
    let { style: style, isFocusable: isFocusable } = props;
    let [isFocused, setFocused] = (0, $acw62.useState)(false);
    let { focusWithinProps: focusWithinProps } = (0, $02fb4773760e27fa$export$420e68273165f4ec)({
        isDisabled: !isFocusable,
        onFocusWithinChange: (val)=>setFocused(val)
    });
    // If focused, don't hide the element.
    let combinedStyles = (0, $acw62.useMemo)(()=>{
        if (isFocused) return style;
        else if (style) return {
            ...$2b6fccd6bf1aab09$var$$5c3e21d68f1c4674$var$styles,
            ...style
        };
        else return $2b6fccd6bf1aab09$var$$5c3e21d68f1c4674$var$styles;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFocused
    ]);
    return {
        visuallyHiddenProps: {
            ...focusWithinProps,
            style: combinedStyles
        }
    };
}
function $2b6fccd6bf1aab09$export$439d29a4e110a164(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { children: children, elementType: Element = 'div', isFocusable: isFocusable, style: style, ...otherProps } = props;
    let { visuallyHiddenProps: visuallyHiddenProps } = $2b6fccd6bf1aab09$export$a966af930f325cab(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Element, (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(otherProps, visuallyHiddenProps), children);
}






var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $87fd95999d561db6$var$$a54cdc5c1942b639$var$instance = Math.round(Math.random() * 10000000000);
let $87fd95999d561db6$var$$a54cdc5c1942b639$var$i = 0;
function $87fd95999d561db6$export$bca9d026f8e704eb(props) {
    // Preserved here for backward compatibility. React Aria now generates the name instead of stately.
    let name = (0, $acw62.useMemo)(()=>props.name || `radio-group-${$87fd95999d561db6$var$$a54cdc5c1942b639$var$instance}-${++$87fd95999d561db6$var$$a54cdc5c1942b639$var$i}`, [
        props.name
    ]);
    var _props_defaultValue;
    let [selectedValue, setSelected] = (0, $3316814d6906df5c$export$40bfa8c7b0832715)(props.value, (_props_defaultValue = props.defaultValue) !== null && _props_defaultValue !== void 0 ? _props_defaultValue : null, props.onChange);
    let [initialValue] = (0, $acw62.useState)(selectedValue);
    let [lastFocusedValue, setLastFocusedValue] = (0, $acw62.useState)(null);
    let validation = (0, $bf01417b417639db$export$fc1a364ae1f3ff10)({
        ...props,
        value: selectedValue
    });
    let setSelectedValue = (value)=>{
        if (!props.isReadOnly && !props.isDisabled) {
            setSelected(value);
            validation.commitValidation();
        }
    };
    let isInvalid = validation.displayValidation.isInvalid;
    var _props_defaultValue1;
    return {
        ...validation,
        name: name,
        selectedValue: selectedValue,
        defaultSelectedValue: props.value !== undefined ? initialValue : (_props_defaultValue1 = props.defaultValue) !== null && _props_defaultValue1 !== void 0 ? _props_defaultValue1 : null,
        setSelectedValue: setSelectedValue,
        lastFocusedValue: lastFocusedValue,
        setLastFocusedValue: setLastFocusedValue,
        isDisabled: props.isDisabled || false,
        isReadOnly: props.isReadOnly || false,
        isRequired: props.isRequired || false,
        validationState: props.validationState || (isInvalid ? 'invalid' : null),
        isInvalid: isInvalid
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $cacd038c57d401bf$export$a79eda4ff50e30b6 = (0, $acw62.createContext)(null);
const $cacd038c57d401bf$export$b118023277d4a5c3 = (0, $acw62.createContext)(null);
const $cacd038c57d401bf$export$29d84393af70866c = (0, $acw62.createContext)(null);
const $cacd038c57d401bf$export$a98f0dcb43a68a25 = (0, $acw62.forwardRef)(function RadioGroup(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $cacd038c57d401bf$export$a79eda4ff50e30b6);
    let { validationBehavior: formValidationBehavior } = (0, $12ee5c1d62d6b2e5$export$fabf2dc03a41866e)((0, $99b9335b6cbca82a$export$c24727297075ec6a)) || {};
    var _props_validationBehavior, _ref;
    let validationBehavior = (_ref = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : formValidationBehavior) !== null && _ref !== void 0 ? _ref : 'native';
    let state = (0, $87fd95999d561db6$export$bca9d026f8e704eb)({
        ...props,
        validationBehavior: validationBehavior
    });
    let [labelRef, label] = (0, $12ee5c1d62d6b2e5$export$9d4c57ee4c6ffdd8)(!props['aria-label'] && !props['aria-labelledby']);
    let { radioGroupProps: radioGroupProps, labelProps: labelProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $b6126734e5187be9$export$62b9571f283ff5c2)({
        ...props,
        label: label,
        validationBehavior: validationBehavior
    }, state);
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        ...props,
        values: {
            orientation: props.orientation || 'vertical',
            isDisabled: state.isDisabled,
            isReadOnly: state.isReadOnly,
            isRequired: state.isRequired,
            isInvalid: state.isInvalid,
            state: state
        },
        defaultClassName: 'react-aria-RadioGroup'
    });
    let DOMProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)(DOMProps, renderProps, radioGroupProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-orientation": props.orientation || 'vertical',
        "data-invalid": state.isInvalid || undefined,
        "data-disabled": state.isDisabled || undefined,
        "data-readonly": state.isReadOnly || undefined,
        "data-required": state.isRequired || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $12ee5c1d62d6b2e5$export$2881499e37b75b9a), {
        values: [
            [
                $cacd038c57d401bf$export$29d84393af70866c,
                state
            ],
            [
                (0, $794346013ab6e680$export$75b6ee27786ba447),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: 'span'
                }
            ],
            [
                (0, $424592b5daddcd29$export$9afb8bc826b033ea),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $7dd8b2fec65d8b6a$export$ff05c3ac10437e03),
                validation
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $77f6c3892c21261c$export$758399f318e6385a), null, renderProps.children)));
});
const $cacd038c57d401bf$export$d7b12c4107be0d61 = (0, $acw62.forwardRef)(function Radio(props, ref) {
    let { inputRef: userProvidedInputRef = null, ...otherProps } = props;
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(otherProps, ref, $cacd038c57d401bf$export$b118023277d4a5c3);
    let state = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($cacd038c57d401bf$export$29d84393af70866c);
    let inputRef = (0, $426ce7b4b2df0896$export$4338b53315abf666)((0, $acw62.useMemo)(()=>(0, $27215adb76b33250$export$c9058316764c140e)(userProvidedInputRef, props.inputRef !== undefined ? props.inputRef : null), [
        userProvidedInputRef,
        props.inputRef
    ]));
    let { labelProps: labelProps, inputProps: inputProps, isSelected: isSelected, isDisabled: isDisabled, isPressed: isPressed } = (0, $85c02a989ed6495e$export$37b0961d2f4751e2)({
        ...(0, $12ee5c1d62d6b2e5$export$ef03459518577ad4)(props),
        // ReactNode type doesn't allow function children.
        children: typeof props.children === 'function' ? true : props.children
    }, state, inputRef);
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $da27ef38ba6b0ce3$export$4e328f61c538687f)();
    let interactionDisabled = isDisabled || state.isReadOnly;
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $8d62ff0ac4dc2be2$export$ae780daf29e6d456)({
        ...props,
        isDisabled: interactionDisabled
    });
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        ...props,
        defaultClassName: 'react-aria-Radio',
        values: {
            isSelected: isSelected,
            isPressed: isPressed,
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: isDisabled,
            isReadOnly: state.isReadOnly,
            isInvalid: state.isInvalid,
            isRequired: state.isRequired
        }
    });
    let DOMProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)(DOMProps, labelProps, hoverProps, renderProps),
        ref: ref,
        "data-selected": isSelected || undefined,
        "data-pressed": isPressed || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined,
        "data-readonly": state.isReadOnly || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-required": state.isRequired || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2b6fccd6bf1aab09$export$439d29a4e110a164), {
        elementType: "span"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)(inputProps, focusProps),
        ref: inputRef
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $50e2ea1c2adde70a$export$c9549807523555e0).Provider, {
        value: {
            isSelected: isSelected
        }
    }, renderProps.children));
});




const $41015efefa2d03bc$export$db143058563e2c63 = /*#__PURE__*/ (0, $acw62.forwardRef)(function UncontrolledRadioGroup({ label: label, layout: layout = 'flex', options: options, Component: Component = $41015efefa2d03bc$export$f8afaea2e9656b91, ...props }, ref) {
    const radioOptions = (0, $acw62.useMemo)(()=>options.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
                value: option.value,
                "data-value": option.value,
                children: option.label
            }, option.value)), [
        options
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cacd038c57d401bf$export$a98f0dcb43a68a25), {
        ...props,
        className: "group/radio flex flex-col gap-1",
        ref: ref,
        "data-name": props.name,
        "data-size": props.size ?? '',
        "data-layout": layout,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e29ab1100b9991a4$export$b04be29aa201d4f5), {
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex group-data-[orientation=vertical]/radio:flex-col group-data-[orientation=horizontal]/radio:flex-row group-data-[layout=grid]/radio:grid group-data-[layout=grid]/radio:grid-cols-3 sm:group-data-[layout=grid]/radio:grid-cols-5 group-data-[layout=grid]/radio:gap-4",
                children: radioOptions
            })
        ]
    });
});
function $41015efefa2d03bc$export$a98f0dcb43a68a25({ onInteraction: onInteraction, ...props }) {
    const { field: field } = (0, $0d70f179cf56e662$export$e8c786024a2b0a79)({
        name: props.name
    });
    const onChange = (...args)=>{
        onInteraction?.();
        field.onChange(...args);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($41015efefa2d03bc$export$db143058563e2c63, {
        ...props,
        ...field,
        onChange: onChange,
        isDisabled: props.disabled
    });
}
function $41015efefa2d03bc$export$371ab307eab489c0(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cacd038c57d401bf$export$d7b12c4107be0d61), {
        ...props,
        role: "radio",
        className: "group px-3 py-4 flex relative gap-x-3 cursor-pointer items-center text-neutral-800 disabled:text-neutral-300 font-medium -mt-[1px] border-y border-solid last:border-b-0 border-t-transparent data-[selected]:bg-primary-50 data-[selected]:border-y-primary-light",
        children: (0, $12ee5c1d62d6b2e5$export$c245e6201fed2f75)(props.children, (children)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "size-4.5 box-border rounded-full border border-gray-300 bg-white dark:bg-neutral-900 transition-all group-data-[hovered=true]:border-primary group-data-[selected=true]:border-primary group-data-[selected=true]:border-[0.33rem]"
                    }),
                    children
                ]
            }))
    });
}
function $41015efefa2d03bc$export$f8afaea2e9656b91(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cacd038c57d401bf$export$d7b12c4107be0d61), {
        ...props,
        role: "radio",
        className: "group p-2 min-w-24 text-base group-data-[size=lg]/radio:text-lg group-data-[size=lg]/radio:py-4 group-data-[size=lg]/radio:px-2 group-data-[size=lg]/radio:min-w-30 group-data-[layout=flex]/radio:group-data-[orientation=vertical]/radio:mb-4 group-data-[layout=flex]/radio:group-data-[orientation=horizontal]/radio:mr-4 last:mb-0 last:mr-0 flex relative gap-x-3 cursor-pointer items-center text-neutral-800 disabled:text-neutral-300 rounded-md border border-solid border-300 data-[hovered=true]:border-primary data-[selected=true]:bg-primary-50 data-[selected]:border-primary data-[focused]:ring-1 ring-primary",
        children: (0, $12ee5c1d62d6b2e5$export$c245e6201fed2f75)(props.children, (children)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "size-4.5 box-border rounded-full border border-gray-300 bg-white dark:bg-neutral-900 transition-all group-data-[hovered=true]:border-primary group-data-[selected=true]:border-primary group-data-[selected=true]:border-[0.33rem]"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: children
                    })
                ]
            }))
    });
}




var $acw62 = parcelRequire("acw62");



const $821173ef8b3171e0$var$UncontrolledTextArea = /*#__PURE__*/ (0, $acw62.forwardRef)(function Input({ label: label, className: className, ...props }, ref) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $493e4c59f76a0606$export$2c73285ae9390cec), {
        ...props,
        ref: ref,
        className: "flex flex-col gap-1",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e29ab1100b9991a4$export$b04be29aa201d4f5), {
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb65690869e135e6$export$f5c9f3c2c4054eec), {
                className: "w-full px-3 py-2 min-h-30 text-body-dark rounded-md border border-solid border-300 shadow-sm resize-none placeholder:text-light-500 data-[suffix=true]:pr-11  focus-within:ring-1 ring-primary focus:ring-primary focus:border-primary focus-within:border-primary"
            })
        ]
    });
});
function $821173ef8b3171e0$export$f5c9f3c2c4054eec({ name: name, ...props }) {
    const { field: field } = (0, $0d70f179cf56e662$export$e8c786024a2b0a79)({
        name: name
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($821173ef8b3171e0$var$UncontrolledTextArea, {
        ...props,
        ...field,
        isDisabled: props.disabled
    });
}


function $98959ad41c534e4d$export$b80bc5715b20f15a({ extractDefaults: extractDefaults, transformValues: transformValues, schema: schema, translationNamespace: translationNamespace, translationKey: translationKey, ...props }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)([
        translationNamespace,
        'common'
    ], {
        keyPrefix: translationKey
    });
    const formRef = (0, $acw62.useRef)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dea25ad601eb8263$export$70aabb5da7e125f8), {
        extractDefaults: extractDefaults,
        transformValues: transformValues,
        schema: schema,
        nextPath: props.next.path,
        ref: formRef,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4777412ac24f8fdf$export$8becf861e7fda17d), {
            ...props,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    t: t,
                    i18nKey: "title",
                    components: {
                        h3: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "title"
                        }),
                        p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {})
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($98959ad41c534e4d$var$QuestionType, {
                    ...props,
                    t: t,
                    formRef: formRef
                })
            ]
        })
    });
}
function $98959ad41c534e4d$var$shouldShowDetails(primary) {
    return primary.length > 0 && primary !== 'no' ? primary : null;
}
function $98959ad41c534e4d$var$QuestionType(props) {
    const { formRef: formRef } = props;
    const { subscribe: subscribe, getValues: getValues } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const [showDetails, setShowDetails] = (0, $acw62.useState)(()=>$98959ad41c534e4d$var$shouldShowDetails(getValues('primary')));
    const interactionsRef = (0, $acw62.useRef)(0);
    const onInteraction = ()=>interactionsRef.current += 1;
    // Detect changes to the primary value and show/hide details or submit the
    // form.
    (0, $acw62.useEffect)(()=>subscribe({
            name: 'primary',
            formState: {
                values: true,
                isSubmitted: true,
                isSubmitting: true,
                isValid: true
            },
            callback: ({ values: values, isSubmitted: isSubmitted, isSubmitting: isSubmitting, isValid: isValid })=>{
                // Auto submit. Only when the first interaction is choosing "no".
                if (values.primary === 'no' && interactionsRef.current === 1 && !isSubmitted && !isSubmitting && isValid) formRef.current?.requestSubmit();
                setShowDetails($98959ad41c534e4d$var$shouldShowDetails(values.primary));
            }
        }), [
        formRef,
        subscribe
    ]);
    return props.options?.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($98959ad41c534e4d$var$QuestionTypeRadioGroup, {
        ...props,
        showDetails: showDetails,
        onInteraction: onInteraction
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($98959ad41c534e4d$var$QuestionTypeYesNo, {
        ...props,
        showDetails: showDetails,
        onInteraction: onInteraction
    });
}
function $98959ad41c534e4d$var$QuestionTypeYesNo({ onInteraction: onInteraction, ...props }) {
    const { t: t } = props;
    const { t: tCommon } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('common');
    const radioOptions = (0, $acw62.useMemo)(()=>[
            {
                value: 'yes',
                label: tCommon('yes')
            },
            {
                value: 'no',
                label: tCommon('no')
            }
        ], [
        tCommon
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: t('label')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41015efefa2d03bc$export$a98f0dcb43a68a25), {
                orientation: "horizontal",
                name: "primary",
                options: radioOptions,
                size: "lg",
                onInteraction: onInteraction
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($98959ad41c534e4d$var$DetailsField, {
                ...props
            })
        ]
    });
}
function $98959ad41c534e4d$var$useOptions(options, t) {
    return (0, $acw62.useMemo)(()=>options?.map((option)=>({
                value: option,
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $197b6000c0ecf0dd$export$ad924bcafd0618eb), {
                    t: t,
                    i18nKey: option
                })
            })) ?? [], [
        options,
        t
    ]);
}
function $98959ad41c534e4d$var$QuestionTypeRadioGroup({ onInteraction: onInteraction, ...props }) {
    const { t: t, options: options } = props;
    const radioOptions = $98959ad41c534e4d$var$useOptions(options, t);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: t('label')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41015efefa2d03bc$export$a98f0dcb43a68a25), {
                name: "primary",
                options: radioOptions,
                size: "lg",
                onInteraction: onInteraction
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($98959ad41c534e4d$var$DetailsField, {
                ...props
            })
        ]
    });
}
function $98959ad41c534e4d$var$DetailsField({ details: details, secondaryOptions: secondaryOptions, t: t, showDetails: showDetails }) {
    const { t: tCommon } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('common');
    const radioOptions = $98959ad41c534e4d$var$useOptions(secondaryOptions?.[showDetails], t);
    const hasDetails = !!details || radioOptions.length > 0;
    const detailsLabel = t('detailsLabel', {
        defaultValue: tCommon('details')
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a253e8a9807820d2$export$be5b6c6ac24b4683), {
        show: !!(hasDetails && showDetails),
        className: "mt-5 pt-1.25",
        children: [
            radioOptions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: detailsLabel
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41015efefa2d03bc$export$a98f0dcb43a68a25), {
                        name: "secondary",
                        options: radioOptions,
                        size: "lg"
                    })
                ]
            }),
            details && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $821173ef8b3171e0$export$f5c9f3c2c4054eec), {
                name: "details",
                label: detailsLabel,
                placeholder: t('detailsPlaceholder')
            })
        ]
    });
}


function $877ef6a617b19c02$export$533119893f4e5961(pathPrefix, progressPrefix, translationNamespace) {
    return (step)=>{
        const props = {
            ...step.props
        };
        const name = props.name;
        const path = `${pathPrefix}-${name.replaceAll(/[a-z0-9][A-Z]/g, (x)=>`${x[0]}-${x[1].toLowerCase()}`)}`;
        const progressKey = `${progressPrefix}${name[0].toUpperCase()}${name.slice(1)}`;
        props.translationNamespace = translationNamespace;
        props.translationKey = `questions.${props.name.replaceAll(/-[a-z]/g, (x)=>x[1].toUpperCase())}`;
        const schema = $09193e81812ba154$export$971dd5b0dfd021b6([
            $09193e81812ba154$export$be5493f9613cbbe({
                primary: $09193e81812ba154$export$c8ec6e1ec9fefcb0('no')
            }),
            $09193e81812ba154$export$be5493f9613cbbe({
                primary: $09193e81812ba154$export$22b082955e083ec3().trim().min(2),
                secondary: $09193e81812ba154$export$22b082955e083ec3(),
                details: props.details ? $09193e81812ba154$export$22b082955e083ec3().trim().min(1) : $09193e81812ba154$export$c8ec6e1ec9fefcb0('')
            }).superRefine(({ primary: primary, secondary: secondary }, context)=>{
                const hasSecondaryOptions = Object.hasOwn(props.secondaryOptions ?? {}, primary);
                if (hasSecondaryOptions && secondary.trim().length === 0) context.addIssue({
                    code: 'too_small',
                    message: 'Required',
                    path: [
                        'secondary'
                    ]
                });
            })
        ]);
        const extractDefaults = (progress)=>{
            const current = progress[progressKey];
            return {
                primary: current?.primary ?? '',
                secondary: current?.secondary ?? '',
                details: current?.details ?? ''
            };
        };
        const transformValues = ({ primary: primary, secondary: secondary, details: details })=>{
            const values = {
                primary: primary
            };
            if (secondary) values.secondary = secondary;
            if (details) values.details = details;
            return {
                [progressKey]: values
            };
        };
        const answer = (progress)=>progress[progressKey];
        return {
            path: path,
            component: (props)=>/*#__PURE__*/ (0, $acw62.createElement)((0, $98959ad41c534e4d$export$b80bc5715b20f15a), {
                    ...props,
                    key: path,
                    extractDefaults: extractDefaults,
                    transformValues: transformValues,
                    schema: schema
                }),
            answer: answer,
            done: (progress)=>!!answer(progress),
            nextLabel: `${translationNamespace}:questions.${name}.nextLabel`,
            ...step,
            props: props
        };
    };
}


const $e5c7a076ba516446$var$healthQuestionBuilder = (0, $877ef6a617b19c02$export$533119893f4e5961)('health', 'healthQuestion', 'page.health-questions');
const $e5c7a076ba516446$export$64e7b4513fce920 = [
    {
        props: {
            name: 'allergies',
            details: true,
            progress: 0.53
        }
    },
    {
        component: (0, $a332dd0821b6767c$export$9dc49afca840728d),
        props: {
            name: 'weightHeight',
            progress: 0.56
        }
    },
    {
        props: {
            name: 'metalImplants',
            details: true,
            progress: 0.59
        }
    },
    {
        props: {
            name: 'diabetes',
            options: [
                'no',
                'yes-type-1',
                'yes-type-2'
            ],
            secondaryOptions: {
                'yes-type-2': [
                    'diet-controlled',
                    'tablets',
                    'insulin'
                ]
            },
            progress: 0.62
        }
    },
    {
        props: {
            name: 'highBloodPressure',
            progress: 0.65
        }
    },
    {
        props: {
            name: 'arrhythmias',
            details: true,
            progress: 0.68
        }
    },
    {
        props: {
            name: 'pacemaker',
            secondaryOptions: {
                yes: [
                    'pacing',
                    'defibrillator',
                    'not-sure'
                ]
            },
            progress: 0.71
        }
    },
    {
        props: {
            name: 'bloodThinningMedication',
            details: true,
            progress: 0.74
        }
    },
    {
        props: {
            name: 'heartConditions',
            details: true,
            progress: 0.77
        }
    },
    {
        props: {
            name: 'stroke',
            details: true,
            progress: 0.8
        }
    },
    {
        props: {
            name: 'epilepsy',
            details: true,
            progress: 0.83
        }
    },
    {
        props: {
            name: 'obstructiveSleepApnoea',
            details: true,
            progress: 0.845
        }
    },
    {
        props: {
            name: 'asthmaLungConditions',
            details: true,
            progress: 0.86
        }
    },
    {
        props: {
            name: 'digestiveConditions',
            details: true,
            progress: 0.89
        }
    },
    {
        props: {
            name: 'bloodProblems',
            details: true,
            progress: 0.9
        }
    },
    {
        props: {
            name: 'organTransplant',
            details: true,
            progress: 0.91
        }
    },
    {
        props: {
            name: 'cancerTreatment',
            details: true,
            progress: 0.92
        }
    },
    {
        props: {
            name: 'infectiousDiseases',
            details: true,
            progress: 0.95
        }
    },
    {
        props: {
            name: 'pregnancy',
            details: true,
            progress: 0.98
        }
    },
    {
        props: {
            name: 'otherHealthConditions',
            details: true,
            progress: 0.99
        }
    },
    {
        props: {
            name: 'glp1Medications',
            details: true,
            progress: 0.995
        }
    }
]// TODO: ideally we would do this at build time.
.map($e5c7a076ba516446$var$healthQuestionBuilder);




const $403b1d2dd4bc76fe$var$preferenceQuestionBuilder = (0, $877ef6a617b19c02$export$533119893f4e5961)('preference', 'preferenceQuestion', 'page.preference-questions');
const $403b1d2dd4bc76fe$export$b789f320c0d06368 = [
    {
        props: {
            name: 'mobility',
            details: true,
            progress: 0.99
        }
    },
    {
        props: {
            name: 'language',
            details: false,
            secondaryOptions: {
                yes: [
                    'mi',
                    'zh',
                    'fj',
                    'fr',
                    'de',
                    'ja',
                    'ko',
                    'ms',
                    'pt',
                    'sm',
                    'tl',
                    'ta',
                    'to',
                    'other'
                ]
            },
            progress: 0.99
        }
    },
    {
        props: {
            name: 'religion',
            details: true,
            progress: 0.99
        }
    },
    {
        props: {
            name: 'culture',
            details: true,
            progress: 0.99
        }
    },
    {
        props: {
            name: 'diet',
            details: true,
            progress: 0.99
        }
    },
    {
        props: {
            name: 'other',
            details: true,
            progress: 0.99
        }
    },
    {
        props: {
            name: 'prep',
            options: [
                'pick-up-from-hospital',
                'pick-up-from-local-pharmacy',
                'receive-by-mail'
            ],
            progress: 0.99
        }
    }
]// TODO: ideally we would do this at build time.
.map($403b1d2dd4bc76fe$var$preferenceQuestionBuilder);






var $acw62 = parcelRequire("acw62");
function $614059298377f061$var$ArrowRightIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M2 8a.75.75 0 0 1 .75-.75h8.69L8.22 4.03a.75.75 0 0 1 1.06-1.06l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06-1.06l3.22-3.22H2.75A.75.75 0 0 1 2 8Z",
        clipRule: "evenodd"
    }));
}
const $614059298377f061$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($614059298377f061$var$ArrowRightIcon);
var $614059298377f061$export$2e2bcd8739ae039 = $614059298377f061$var$ForwardRef;





const $be79a52cbffa2be6$export$f32f6ef648fb680f = (0, $bd07366b96e7d92e$export$185802fd694ee1f5)((set, get)=>({
        count: 0,
        start: ()=>set({
                count: get().count + 1
            }),
        stop: ()=>set({
                count: Math.max(0, get().count - 1)
            })
    }));


function $ef08a5ee29d75f65$export$b03061e17dddb512({ label: label }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { isValid: isValid, isSubmitting: isSubmitting } = (0, $0d70f179cf56e662$export$606f11b2eb45ecc6)();
    const isBusy = (0, $be79a52cbffa2be6$export$f32f6ef648fb680f)((s)=>s.count > 0);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "submit",
        form: "patch-invite-form",
        className: "pl-5 flex-grow flex items-center justify-between gap-4 font-medium text-white bg-primary hover:text-white hover:bg-primary-hover active:bg-primary-active disabled:opacity-60 disabled:pointer-events-none transition-all",
        disabled: !isValid || isSubmitting || isBusy,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: isSubmitting ? t('loading') : label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "size-12.5 flex items-center justify-center",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $614059298377f061$export$2e2bcd8739ae039), {
                    className: "size-6"
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");
function $dcddf554cab09b71$var$ChevronDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z",
        clipRule: "evenodd"
    }));
}
const $dcddf554cab09b71$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($dcddf554cab09b71$var$ChevronDownIcon);
var $dcddf554cab09b71$export$2e2bcd8739ae039 = $dcddf554cab09b71$var$ForwardRef;



var $acw62 = parcelRequire("acw62");



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Takes a value and forces it to the closest min/max if it's outside. Also forces it to the closest valid step.
 */ function $bd1873f619f62ffd$export$7d15b64cf5a3a4c4(value, min = -Infinity, max = Infinity) {
    let newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $bd1873f619f62ffd$export$e1a7b8e69ef6c52f(value, step) {
    let roundedValue = value;
    let precision = 0;
    let stepString = step.toString();
    // Handle negative exponents in exponential notation (e.g., "1e-7" → precision 8)
    let eIndex = stepString.toLowerCase().indexOf('e-');
    if (eIndex > 0) precision = Math.abs(Math.floor(Math.log10(Math.abs(step)))) + eIndex;
    else {
        let pointIndex = stepString.indexOf('.');
        if (pointIndex >= 0) precision = stepString.length - pointIndex;
    }
    if (precision > 0) {
        let pow = Math.pow(10, precision);
        roundedValue = Math.round(roundedValue * pow) / pow;
    }
    return roundedValue;
}
function $bd1873f619f62ffd$export$cb6e0bb50bc19463(value, min, max, step) {
    min = Number(min);
    max = Number(max);
    let remainder = (value - (isNaN(min) ? 0 : min)) % step;
    let snappedValue = $bd1873f619f62ffd$export$e1a7b8e69ef6c52f(Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder, step);
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor($bd1873f619f62ffd$export$e1a7b8e69ef6c52f((max - min) / step, step)) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor($bd1873f619f62ffd$export$e1a7b8e69ef6c52f(max / step, step)) * step;
    // correct floating point behavior by rounding to step precision
    snappedValue = $bd1873f619f62ffd$export$e1a7b8e69ef6c52f(snappedValue, step);
    return snappedValue;
}
function $bd1873f619f62ffd$export$b6268554fba451f(value, digits, base = 10) {
    const pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$formatterCache = new Map();
let $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$supportsSignDisplay = false;
try {
    $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$supportsSignDisplay = new Intl.NumberFormat('de-DE', {
        signDisplay: 'exceptZero'
    }).resolvedOptions().signDisplay === 'exceptZero';
// eslint-disable-next-line no-empty
} catch  {}
let $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$supportsUnit = false;
try {
    $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$supportsUnit = new Intl.NumberFormat('de-DE', {
        style: 'unit',
        unit: 'degree'
    }).resolvedOptions().style === 'unit';
// eslint-disable-next-line no-empty
} catch  {}
// Polyfill for units since Safari doesn't support them yet. See https://bugs.webkit.org/show_bug.cgi?id=215438.
// Currently only polyfilling the unit degree in narrow format for ColorSlider in our supported locales.
// Values were determined by switching to each locale manually in Chrome.
const $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$UNITS = {
    degree: {
        narrow: {
            default: "\xb0",
            'ja-JP': " \u5EA6",
            'zh-TW': "\u5EA6",
            'sl-SI': " \xb0"
        }
    }
};
class $14359adf615d4bd8$export$cc77c4ff7e8673c5 {
    /** Formats a number value as a string, according to the locale and options provided to the constructor. */ format(value) {
        let res = '';
        if (!$14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) res = $14359adf615d4bd8$export$711b50b3c525e0f2(this.numberFormatter, this.options.signDisplay, value);
        else res = this.numberFormatter.format(value);
        if (this.options.style === 'unit' && !$14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$supportsUnit) {
            var _UNITS_unit;
            let { unit: unit, unitDisplay: unitDisplay = 'short', locale: locale } = this.resolvedOptions();
            if (!unit) return res;
            let values = (_UNITS_unit = $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay];
            res += values[locale] || values.default;
        }
        return res;
    }
    /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */ formatToParts(value) {
        // TODO: implement signDisplay for formatToParts
        return this.numberFormatter.formatToParts(value);
    }
    /** Formats a number range as a string. */ formatRange(start, end) {
        if (typeof this.numberFormatter.formatRange === 'function') return this.numberFormatter.formatRange(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        // Very basic fallback for old browsers.
        return `${this.format(start)} \u{2013} ${this.format(end)}`;
    }
    /** Formats a number range as an array of parts. */ formatRangeToParts(start, end) {
        if (typeof this.numberFormatter.formatRangeToParts === 'function') return this.numberFormatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        let startParts = this.numberFormatter.formatToParts(start);
        let endParts = this.numberFormatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: 'startRange'
                })),
            {
                type: 'literal',
                value: " \u2013 ",
                source: 'shared'
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: 'endRange'
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let options = this.numberFormatter.resolvedOptions();
        if (!$14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) options = {
            ...options,
            signDisplay: this.options.signDisplay
        };
        if (!$14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$supportsUnit && this.options.style === 'unit') options = {
            ...options,
            style: 'unit',
            unit: this.options.unit,
            unitDisplay: this.options.unitDisplay
        };
        return options;
    }
    constructor(locale, options = {}){
        this.numberFormatter = $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options);
        this.options = options;
    }
}
function $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options = {}) {
    let { numberingSystem: numberingSystem } = options;
    if (numberingSystem && locale.includes('-nu-')) {
        if (!locale.includes('-u-')) locale += '-u-';
        locale += `-nu-${numberingSystem}`;
    }
    if (options.style === 'unit' && !$14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$supportsUnit) {
        var _UNITS_unit;
        let { unit: unit, unitDisplay: unitDisplay = 'short' } = options;
        if (!unit) throw new Error('unit option must be provided with style: "unit"');
        if (!((_UNITS_unit = $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay])) throw new Error(`Unsupported unit ${unit} with unitDisplay = ${unitDisplay}`);
        options = {
            ...options,
            style: 'decimal'
        };
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : '');
    if ($14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$formatterCache.has(cacheKey)) return $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.NumberFormat(locale, options);
    $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
function $14359adf615d4bd8$export$711b50b3c525e0f2(numberFormat, signDisplay, num) {
    if (signDisplay === 'auto') return numberFormat.format(num);
    else if (signDisplay === 'never') return numberFormat.format(Math.abs(num));
    else {
        let needsPositiveSign = false;
        if (signDisplay === 'always') needsPositiveSign = num > 0 || Object.is(num, 0);
        else if (signDisplay === 'exceptZero') {
            if (Object.is(num, -0) || Object.is(num, 0)) num = Math.abs(num);
            else needsPositiveSign = num > 0;
        }
        if (needsPositiveSign) {
            let negative = numberFormat.format(-num);
            let noSign = numberFormat.format(num);
            // ignore RTL/LTR marker character
            let minus = negative.replace(noSign, '').replace(/\u200e|\u061C/, '');
            if ([
                ...minus
            ].length !== 1) console.warn('@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case');
            let positive = negative.replace(noSign, '!!!').replace(minus, '+').replace('!!!', noSign);
            return positive;
        } else return numberFormat.format(num);
    }
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e842418385a7cefe$export$b7a616150fdb9f44(options = {}) {
    let { locale: locale } = (0, $a7e3b1109bf64033$export$43bb16f9c6d9e3f7)();
    return (0, $acw62.useMemo)(()=>new (0, $14359adf615d4bd8$export$cc77c4ff7e8673c5)(locale, options), [
        locale,
        options
    ]);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2906415360802f59$export$ed5abd763a836edc(props) {
    let { value: value = 0, minValue: minValue = 0, maxValue: maxValue = 100, valueLabel: valueLabel, isIndeterminate: isIndeterminate, formatOptions: formatOptions = {
        style: 'percent'
    } } = props;
    let domProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $7db7643eb43655f9$export$8467354a121f1b9f)({
        ...props,
        // Progress bar is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span'
    });
    value = (0, $bd1873f619f62ffd$export$7d15b64cf5a3a4c4)(value, minValue, maxValue);
    let percentage = (value - minValue) / (maxValue - minValue);
    let formatter = (0, $e842418385a7cefe$export$b7a616150fdb9f44)(formatOptions);
    if (!isIndeterminate && !valueLabel) {
        let valueToFormat = formatOptions.style === 'percent' ? percentage : value;
        valueLabel = formatter.format(valueToFormat);
    }
    return {
        progressBarProps: (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(domProps, {
            ...fieldProps,
            'aria-valuenow': isIndeterminate ? undefined : value,
            'aria-valuemin': minValue,
            'aria-valuemax': maxValue,
            'aria-valuetext': isIndeterminate ? undefined : valueLabel,
            role: 'progressbar'
        }),
        labelProps: labelProps
    };
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b3d70e2df2ba8563$export$e9f3bf65a26ce129 = (0, $acw62.createContext)(null);
const $b3d70e2df2ba8563$export$c17561cb55d4db30 = (0, $acw62.forwardRef)(function ProgressBar(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $b3d70e2df2ba8563$export$e9f3bf65a26ce129);
    let { value: value = 0, minValue: minValue = 0, maxValue: maxValue = 100, isIndeterminate: isIndeterminate = false } = props;
    value = (0, $bd1873f619f62ffd$export$7d15b64cf5a3a4c4)(value, minValue, maxValue);
    let [labelRef, label] = (0, $12ee5c1d62d6b2e5$export$9d4c57ee4c6ffdd8)(!props['aria-label'] && !props['aria-labelledby']);
    let { progressBarProps: progressBarProps, labelProps: labelProps } = (0, $2906415360802f59$export$ed5abd763a836edc)({
        ...props,
        label: label
    });
    // Calculate the width of the progress bar as a percentage
    let percentage = isIndeterminate ? undefined : (value - minValue) / (maxValue - minValue) * 100;
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        ...props,
        defaultClassName: 'react-aria-ProgressBar',
        values: {
            percentage: percentage,
            valueText: progressBarProps['aria-valuetext'],
            isIndeterminate: isIndeterminate
        }
    });
    let DOMProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)(DOMProps, renderProps, progressBarProps),
        ref: ref,
        slot: props.slot || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $794346013ab6e680$export$75b6ee27786ba447).Provider, {
        value: {
            ...labelProps,
            ref: labelRef,
            elementType: 'span'
        }
    }, renderProps.children));
});


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* Inspired by https://github.com/AlmeroSteyn/react-aria-live */ const $19250283ca240c8f$var$$319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY = 7000;
let $19250283ca240c8f$var$$319e236875307eab$var$liveAnnouncer = null;
function $19250283ca240c8f$export$a9b970dcc4ae71a9(message, assertiveness = 'assertive', timeout = $19250283ca240c8f$var$$319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY) {
    if (!$19250283ca240c8f$var$$319e236875307eab$var$liveAnnouncer) {
        $19250283ca240c8f$var$$319e236875307eab$var$liveAnnouncer = new $19250283ca240c8f$var$$319e236875307eab$var$LiveAnnouncer();
        // wait for the live announcer regions to be added to the dom, then announce
        // otherwise Safari won't announce the message if it's added too quickly
        // found most times less than 100ms were not consistent when announcing with Safari
        // IS_REACT_ACT_ENVIRONMENT is used by React 18. Previous versions checked for the `jest` global.
        // https://github.com/reactwg/react-18/discussions/102
        // if we're in a test environment, announce without waiting
        // @ts-ignore
        if (!(typeof IS_REACT_ACT_ENVIRONMENT === 'boolean' ? IS_REACT_ACT_ENVIRONMENT : typeof jest !== 'undefined')) setTimeout(()=>{
            if ($19250283ca240c8f$var$$319e236875307eab$var$liveAnnouncer === null || $19250283ca240c8f$var$$319e236875307eab$var$liveAnnouncer === void 0 ? void 0 : $19250283ca240c8f$var$$319e236875307eab$var$liveAnnouncer.isAttached()) $19250283ca240c8f$var$$319e236875307eab$var$liveAnnouncer === null || $19250283ca240c8f$var$$319e236875307eab$var$liveAnnouncer === void 0 || $19250283ca240c8f$var$$319e236875307eab$var$liveAnnouncer.announce(message, assertiveness, timeout);
        }, 100);
        else $19250283ca240c8f$var$$319e236875307eab$var$liveAnnouncer.announce(message, assertiveness, timeout);
    } else $19250283ca240c8f$var$$319e236875307eab$var$liveAnnouncer.announce(message, assertiveness, timeout);
}
function $19250283ca240c8f$export$d10ae4f68404609a(assertiveness) {
    if ($19250283ca240c8f$var$$319e236875307eab$var$liveAnnouncer) $19250283ca240c8f$var$$319e236875307eab$var$liveAnnouncer.clear(assertiveness);
}
function $19250283ca240c8f$export$d8686216b8b81b2f() {
    if ($19250283ca240c8f$var$$319e236875307eab$var$liveAnnouncer) {
        $19250283ca240c8f$var$$319e236875307eab$var$liveAnnouncer.destroy();
        $19250283ca240c8f$var$$319e236875307eab$var$liveAnnouncer = null;
    }
}
// LiveAnnouncer is implemented using vanilla DOM, not React. That's because as of React 18
// ReactDOM.render is deprecated, and the replacement, ReactDOM.createRoot is moved into a
// subpath import `react-dom/client`. That makes it hard for us to support multiple React versions.
// As a global API, we can't use portals without introducing a breaking API change. LiveAnnouncer
// is simple enough to implement without React, so that's what we do here.
// See this discussion for more details: https://github.com/reactwg/react-18/discussions/125#discussioncomment-2382638
class $19250283ca240c8f$var$$319e236875307eab$var$LiveAnnouncer {
    isAttached() {
        var _this_node;
        return (_this_node = this.node) === null || _this_node === void 0 ? void 0 : _this_node.isConnected;
    }
    createLog(ariaLive) {
        let node = document.createElement('div');
        node.setAttribute('role', 'log');
        node.setAttribute('aria-live', ariaLive);
        node.setAttribute('aria-relevant', 'additions');
        return node;
    }
    destroy() {
        if (!this.node) return;
        document.body.removeChild(this.node);
        this.node = null;
    }
    announce(message, assertiveness = 'assertive', timeout = $19250283ca240c8f$var$$319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY) {
        var _this_assertiveLog, _this_politeLog;
        if (!this.node) return;
        let node = document.createElement('div');
        if (typeof message === 'object') {
            // To read an aria-labelledby, the element must have an appropriate role, such as img.
            node.setAttribute('role', 'img');
            node.setAttribute('aria-labelledby', message['aria-labelledby']);
        } else node.textContent = message;
        if (assertiveness === 'assertive') (_this_assertiveLog = this.assertiveLog) === null || _this_assertiveLog === void 0 || _this_assertiveLog.appendChild(node);
        else (_this_politeLog = this.politeLog) === null || _this_politeLog === void 0 || _this_politeLog.appendChild(node);
        if (message !== '') setTimeout(()=>{
            node.remove();
        }, timeout);
    }
    clear(assertiveness) {
        if (!this.node) return;
        if ((!assertiveness || assertiveness === 'assertive') && this.assertiveLog) this.assertiveLog.innerHTML = '';
        if ((!assertiveness || assertiveness === 'polite') && this.politeLog) this.politeLog.innerHTML = '';
    }
    constructor(){
        this.node = null;
        this.assertiveLog = null;
        this.politeLog = null;
        if (typeof document !== 'undefined') {
            this.node = document.createElement('div');
            this.node.dataset.liveAnnouncer = 'true';
            // copied from VisuallyHidden
            Object.assign(this.node.style, {
                border: 0,
                clip: 'rect(0 0 0 0)',
                clipPath: 'inset(50%)',
                height: '1px',
                margin: '-1px',
                overflow: 'hidden',
                padding: 0,
                position: 'absolute',
                width: '1px',
                whiteSpace: 'nowrap'
            });
            this.assertiveLog = this.createLog('assertive');
            this.node.appendChild(this.assertiveLog);
            this.politeLog = this.createLog('polite');
            this.node.appendChild(this.politeLog);
            document.body.prepend(this.node);
        }
    }
}




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c50a237b1f29b340$export$ea18c227d4417cc3(props, ref) {
    let { elementType: elementType = 'button', isDisabled: isDisabled, onPress: onPress, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, onPressChange: onPressChange, preventFocusOnPress: preventFocusOnPress, allowFocusWhenDisabled: allowFocusWhenDisabled, onClick: onClick, href: href, target: target, rel: rel, type: type = 'button' } = props;
    let additionalProps;
    if (elementType === 'button') additionalProps = {
        type: type,
        disabled: isDisabled,
        form: props.form,
        formAction: props.formAction,
        formEncType: props.formEncType,
        formMethod: props.formMethod,
        formNoValidate: props.formNoValidate,
        formTarget: props.formTarget,
        name: props.name,
        value: props.value
    };
    else additionalProps = {
        role: 'button',
        href: elementType === 'a' && !isDisabled ? href : undefined,
        target: elementType === 'a' ? target : undefined,
        type: elementType === 'input' ? type : undefined,
        disabled: elementType === 'input' ? isDisabled : undefined,
        'aria-disabled': !isDisabled || elementType === 'input' ? undefined : isDisabled,
        rel: elementType === 'a' ? rel : undefined
    };
    let { pressProps: pressProps, isPressed: isPressed } = (0, $6c43aa319e86785e$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        onPressUp: onPressUp,
        onClick: onClick,
        isDisabled: isDisabled,
        preventFocusOnPress: preventFocusOnPress,
        ref: ref
    });
    let { focusableProps: focusableProps } = (0, $daedc3252d285a56$export$4c014de7c8940b4c)(props, ref);
    if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
    let buttonProps = (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(focusableProps, pressProps, (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        labelable: true
    }));
    return {
        isPressed: isPressed,
        buttonProps: (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(additionalProps, buttonProps, {
            'aria-haspopup': props['aria-haspopup'],
            'aria-expanded': props['aria-expanded'],
            'aria-controls': props['aria-controls'],
            'aria-pressed': props['aria-pressed'],
            'aria-current': props['aria-current'],
            'aria-disabled': props['aria-disabled']
        })
    };
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $541712d7db8b7c7b$export$24d547caef80ccd1 = (0, $acw62.createContext)({});
const $541712d7db8b7c7b$export$353f5b6fc5456de1 = (0, $73addfbf71cdc088$export$86427a43e3e48ebb)(function Button(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $541712d7db8b7c7b$export$24d547caef80ccd1);
    let ctx = props;
    let { isPending: isPending } = ctx;
    let { buttonProps: buttonProps, isPressed: isPressed } = (0, $c50a237b1f29b340$export$ea18c227d4417cc3)(props, ref);
    buttonProps = $541712d7db8b7c7b$var$$d2b4bc8c273e7be6$var$useDisableInteractions(buttonProps, isPending);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $da27ef38ba6b0ce3$export$4e328f61c538687f)(props);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $8d62ff0ac4dc2be2$export$ae780daf29e6d456)({
        ...props,
        isDisabled: props.isDisabled || isPending
    });
    let renderValues = {
        isHovered: isHovered,
        isPressed: (ctx.isPressed || isPressed) && !isPending,
        isFocused: isFocused,
        isFocusVisible: isFocusVisible,
        isDisabled: props.isDisabled || false,
        isPending: isPending !== null && isPending !== void 0 ? isPending : false
    };
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        ...props,
        values: renderValues,
        defaultClassName: 'react-aria-Button'
    });
    let buttonId = (0, $855de91ebb07800c$export$f680877a34711e37)(buttonProps.id);
    let progressId = (0, $855de91ebb07800c$export$f680877a34711e37)();
    let ariaLabelledby = buttonProps['aria-labelledby'];
    if (isPending) {
        // aria-labelledby wins over aria-label
        // https://www.w3.org/TR/accname-1.2/#computation-steps
        if (ariaLabelledby) ariaLabelledby = `${ariaLabelledby} ${progressId}`;
        else if (buttonProps['aria-label']) ariaLabelledby = `${buttonId} ${progressId}`;
    }
    let wasPending = (0, $acw62.useRef)(isPending);
    (0, $acw62.useEffect)(()=>{
        let message = {
            'aria-labelledby': ariaLabelledby || buttonId
        };
        if (!wasPending.current && isFocused && isPending) (0, $19250283ca240c8f$export$a9b970dcc4ae71a9)(message, 'assertive');
        else if (wasPending.current && isFocused && !isPending) (0, $19250283ca240c8f$export$a9b970dcc4ae71a9)(message, 'assertive');
        wasPending.current = isPending;
    }, [
        isPending,
        isFocused,
        ariaLabelledby,
        buttonId
    ]);
    let DOMProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)(DOMProps, renderProps, buttonProps, focusProps, hoverProps),
        // When the button is in a pending state, we want to stop implicit form submission (ie. when the user presses enter on a text input).
        // We do this by changing the button's type to button.
        type: buttonProps.type === 'submit' && isPending ? 'button' : buttonProps.type,
        id: buttonId,
        ref: ref,
        "aria-labelledby": ariaLabelledby,
        slot: props.slot || undefined,
        "aria-disabled": isPending ? 'true' : buttonProps['aria-disabled'],
        "data-disabled": props.isDisabled || undefined,
        "data-pressed": renderValues.isPressed || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-pending": isPending || undefined,
        "data-focus-visible": isFocusVisible || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b3d70e2df2ba8563$export$e9f3bf65a26ce129).Provider, {
        value: {
            id: progressId
        }
    }, renderProps.children));
});
function $541712d7db8b7c7b$var$$d2b4bc8c273e7be6$var$useDisableInteractions(props, isPending) {
    // Don't allow interaction while isPending is true
    if (isPending) {
        for(const key in props)if (key.startsWith('on') && !(key.includes('Focus') || key.includes('Blur'))) props[key] = undefined;
        props.href = undefined;
        props.target = undefined;
    }
    return props;
}





var $30972684ba5f6f6c$export$2e2bcd8739ae039 = {};
$30972684ba5f6f6c$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{62A}\u{63A}\u{64A}\u{64A}\u{631}\u{627}\u{62A} \u{627}\u{644}\u{623}\u{644}\u{648}\u{627}\u{646}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{62D}\u{62F}\u{62F} \u{639}\u{646}\u{635}\u{631}\u{64B}\u{627}`,
    "tableResizer": `\u{623}\u{62F}\u{627}\u{629} \u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{627}\u{644}\u{62D}\u{62C}\u{645}`
};


var $c6f8a1181a0cc467$export$2e2bcd8739ae039 = {};
$c6f8a1181a0cc467$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{426}\u{432}\u{435}\u{442}\u{43E}\u{432}\u{438} \u{43C}\u{43E}\u{441}\u{442}\u{440}\u{438}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435} \u{43F}\u{440}\u{435}\u{434}\u{43C}\u{435}\u{442}`,
    "tableResizer": `\u{41F}\u{440}\u{435}\u{43E}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{438}\u{442}\u{435}\u{43B}`
};


var $f130583cb08ae2d9$export$2e2bcd8739ae039 = {};
$f130583cb08ae2d9$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Vzorky barev`,
    "dropzoneLabel": `M\xedsto pro p\u{159}eta\u{17E}en\xed`,
    "selectPlaceholder": `Vyberte polo\u{17E}ku`,
    "tableResizer": `Zm\u{11B}na velikosti`
};


var $b2d6a5210f7e0a7e$export$2e2bcd8739ae039 = {};
$b2d6a5210f7e0a7e$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Farvepr\xf8ver`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `V\xe6lg et element`,
    "tableResizer": `St\xf8rrelses\xe6ndring`
};


var $4f7d80e0f34c4721$export$2e2bcd8739ae039 = {};
$4f7d80e0f34c4721$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Farbfelder`,
    "dropzoneLabel": `Ablegebereich`,
    "selectPlaceholder": `Element w\xe4hlen`,
    "tableResizer": `Gr\xf6\xdfenanpassung`
};


var $04c726ff32cae5e7$export$2e2bcd8739ae039 = {};
$04c726ff32cae5e7$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{3A7}\u{3C1}\u{3C9}\u{3BC}\u{3B1}\u{3C4}\u{3B9}\u{3BA}\u{3AC} \u{3B4}\u{3B5}\u{3AF}\u{3B3}\u{3BC}\u{3B1}\u{3C4}\u{3B1}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3BE}\u{3C4}\u{3B5} \u{3AD}\u{3BD}\u{3B1} \u{3B1}\u{3BD}\u{3C4}\u{3B9}\u{3BA}\u{3B5}\u{3AF}\u{3BC}\u{3B5}\u{3BD}\u{3BF}`,
    "tableResizer": `\u{391}\u{3BB}\u{3BB}\u{3B1}\u{3B3}\u{3AE} \u{3BC}\u{3B5}\u{3B3}\u{3AD}\u{3B8}\u{3BF}\u{3C5}\u{3C2}`
};


var $112c160b3e9f2437$export$2e2bcd8739ae039 = {};
$112c160b3e9f2437$export$2e2bcd8739ae039 = {
    "selectPlaceholder": `Select an item`,
    "tableResizer": `Resizer`,
    "dropzoneLabel": `DropZone`,
    "colorSwatchPicker": `Color swatches`
};


var $6e9baf223712471c$export$2e2bcd8739ae039 = {};
$6e9baf223712471c$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Muestras de colores`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Seleccionar un art\xedculo`,
    "tableResizer": `Cambiador de tama\xf1o`
};


var $593b3e68df07b8ed$export$2e2bcd8739ae039 = {};
$593b3e68df07b8ed$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `V\xe4rvin\xe4idised`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Valige \xfcksus`,
    "tableResizer": `Suuruse muutja`
};


var $9a5babbb15b626f4$export$2e2bcd8739ae039 = {};
$9a5babbb15b626f4$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `V\xe4rimallit`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Valitse kohde`,
    "tableResizer": `Koon muuttaja`
};


var $d59afdd75e3d0bda$export$2e2bcd8739ae039 = {};
$d59afdd75e3d0bda$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\xc9chantillons de couleurs`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `S\xe9lectionner un \xe9l\xe9ment`,
    "tableResizer": `Redimensionneur`
};


var $9230a1e3d7583e90$export$2e2bcd8739ae039 = {};
$9230a1e3d7583e90$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{5D3}\u{5D5}\u{5D2}\u{5DE}\u{5D9}\u{5D5}\u{5EA} \u{5E6}\u{5D1}\u{5E2}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{5D1}\u{5D7}\u{5E8} \u{5E4}\u{5E8}\u{5D9}\u{5D8}`,
    "tableResizer": `\u{5E9}\u{5D9}\u{5E0}\u{5D5}\u{5D9} \u{5D2}\u{5D5}\u{5D3}\u{5DC}`
};


var $fa51ab2101c6fcb9$export$2e2bcd8739ae039 = {};
$fa51ab2101c6fcb9$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Uzorci boja`,
    "dropzoneLabel": `Zona spu\u{161}tanja`,
    "selectPlaceholder": `Odaberite stavku`,
    "tableResizer": `Promjena veli\u{10D}ine`
};


var $bc4186a4fd971700$export$2e2bcd8739ae039 = {};
$bc4186a4fd971700$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Sz\xednt\xe1rak`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `V\xe1lasszon ki egy elemet`,
    "tableResizer": `\xc1tm\xe9retez\u{151}`
};


var $afe93d4c43a3fe68$export$2e2bcd8739ae039 = {};
$afe93d4c43a3fe68$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Campioni di colore`,
    "dropzoneLabel": `Zona di rilascio`,
    "selectPlaceholder": `Seleziona un elemento`,
    "tableResizer": `Ridimensionamento`
};


var $8c2bf3426725589e$export$2e2bcd8739ae039 = {};
$8c2bf3426725589e$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{30AB}\u{30E9}\u{30FC}\u{30B9}\u{30A6}\u{30A9}\u{30C3}\u{30C1}`,
    "dropzoneLabel": `\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{30BE}\u{30FC}\u{30F3}`,
    "selectPlaceholder": `\u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}`,
    "tableResizer": `\u{30B5}\u{30A4}\u{30BA}\u{5909}\u{66F4}\u{30C4}\u{30FC}\u{30EB}`
};


var $c3fe2da71665b421$export$2e2bcd8739ae039 = {};
$c3fe2da71665b421$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{C0C9}\u{C0C1} \u{ACAC}\u{BCF8}`,
    "dropzoneLabel": `\u{B4DC}\u{B86D} \u{C601}\u{C5ED}`,
    "selectPlaceholder": `\u{D56D}\u{BAA9} \u{C120}\u{D0DD}`,
    "tableResizer": `\u{D06C}\u{AE30} \u{C870}\u{C815}\u{AE30}`
};


var $1ea9ab78bfa56509$export$2e2bcd8739ae039 = {};
$1ea9ab78bfa56509$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Spalv\u{173} pavyzd\u{17E}iai`,
    "dropzoneLabel": `\u{201E}DropZone\u{201C}`,
    "selectPlaceholder": `Pasirinkite element\u{105}`,
    "tableResizer": `Dyd\u{17E}io keitiklis`
};


var $9638cad40c64fad2$export$2e2bcd8739ae039 = {};
$9638cad40c64fad2$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Kr\u{101}su paraugi`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Izv\u{113}l\u{113}ties vienumu`,
    "tableResizer": `Izm\u{113}ra main\u{12B}t\u{101}js`
};


var $5b98ba93e4201e76$export$2e2bcd8739ae039 = {};
$5b98ba93e4201e76$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Fargekart`,
    "dropzoneLabel": `Droppsone`,
    "selectPlaceholder": `Velg et element`,
    "tableResizer": `St\xf8rrelsesendrer`
};


var $82f297db20935be7$export$2e2bcd8739ae039 = {};
$82f297db20935be7$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `kleurstalen`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Selecteer een item`,
    "tableResizer": `Resizer`
};


var $7ea192b6308d7e85$export$2e2bcd8739ae039 = {};
$7ea192b6308d7e85$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Pr\xf3bki kolor\xf3w`,
    "dropzoneLabel": `Strefa upuszczania`,
    "selectPlaceholder": `Wybierz element`,
    "tableResizer": `Zmiana rozmiaru`
};


var $a69f30443652900d$export$2e2bcd8739ae039 = {};
$a69f30443652900d$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Amostras de cores`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Selecione um item`,
    "tableResizer": `Redimensionador`
};


var $2d621c3464d8fc5b$export$2e2bcd8739ae039 = {};
$2d621c3464d8fc5b$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Amostras de cores`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Selecione um item`,
    "tableResizer": `Redimensionador`
};


var $4c6c576f61f12279$export$2e2bcd8739ae039 = {};
$4c6c576f61f12279$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Specimene de culoare`,
    "dropzoneLabel": `Zon\u{103} de plasare`,
    "selectPlaceholder": `Selecta\u{21B}i un element`,
    "tableResizer": `Instrument de redimensionare`
};


var $6926d9d8bd674ad0$export$2e2bcd8739ae039 = {};
$6926d9d8bd674ad0$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{426}\u{432}\u{435}\u{442}\u{43E}\u{432}\u{44B}\u{435} \u{43E}\u{431}\u{440}\u{430}\u{437}\u{446}\u{44B}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
    "tableResizer": `\u{421}\u{440}\u{435}\u{434}\u{441}\u{442}\u{432}\u{43E} \u{438}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{430}`
};


var $88df2c5d411be9df$export$2e2bcd8739ae039 = {};
$88df2c5d411be9df$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Vzorkovn\xedky farieb`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Vyberte polo\u{17E}ku`,
    "tableResizer": `N\xe1stroj na zmenu ve\u{13E}kosti`
};


var $f14ccea2ecc3ec5f$export$2e2bcd8739ae039 = {};
$f14ccea2ecc3ec5f$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Barvne palete`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Izberite element`,
    "tableResizer": `Spreminjanje velikosti`
};


var $8ab986528674b5d6$export$2e2bcd8739ae039 = {};
$8ab986528674b5d6$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Uzorci boje`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Izaberite stavku`,
    "tableResizer": `Promena veli\u{10D}ine`
};


var $d45500d55325f120$export$2e2bcd8739ae039 = {};
$d45500d55325f120$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `F\xe4rgrutor`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `V\xe4lj en artikel`,
    "tableResizer": `Storleks\xe4ndrare`
};


var $400e93ddbc83631c$export$2e2bcd8739ae039 = {};
$400e93ddbc83631c$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Renk \xf6rnekleri`,
    "dropzoneLabel": `B\u{131}rakma B\xf6lgesi`,
    "selectPlaceholder": `Bir \xf6\u{11F}e se\xe7in`,
    "tableResizer": `Yeniden boyutland\u{131}r\u{131}c\u{131}`
};


var $da93ff59eff8421d$export$2e2bcd8739ae039 = {};
$da93ff59eff8421d$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{417}\u{440}\u{430}\u{437}\u{43A}\u{438} \u{43A}\u{43E}\u{43B}\u{44C}\u{43E}\u{440}\u{456}\u{432}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{412}\u{438}\u{431}\u{435}\u{440}\u{456}\u{442}\u{44C} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
    "tableResizer": `\u{417}\u{430}\u{441}\u{456}\u{431} \u{437}\u{43C}\u{456}\u{43D}\u{435}\u{43D}\u{43D}\u{44F} \u{440}\u{43E}\u{437}\u{43C}\u{456}\u{440}\u{443}`
};


var $96c14d8c687c0229$export$2e2bcd8739ae039 = {};
$96c14d8c687c0229$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{989C}\u{8272}\u{8272}\u{677F}`,
    "dropzoneLabel": `\u{653E}\u{7F6E}\u{533A}\u{57DF}`,
    "selectPlaceholder": `\u{9009}\u{62E9}\u{4E00}\u{4E2A}\u{9879}\u{76EE}`,
    "tableResizer": `\u{5C3A}\u{5BF8}\u{8C03}\u{6574}\u{5668}`
};


var $a07e80fecd52eebd$export$2e2bcd8739ae039 = {};
$a07e80fecd52eebd$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{8272}\u{7968}`,
    "dropzoneLabel": `\u{653E}\u{7F6E}\u{5340}`,
    "selectPlaceholder": `\u{9078}\u{53D6}\u{9805}\u{76EE}`,
    "tableResizer": `\u{5927}\u{5C0F}\u{8ABF}\u{6574}\u{5668}`
};


var $b17b813572a3b535$export$2e2bcd8739ae039 = {};
$b17b813572a3b535$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $30972684ba5f6f6c$export$2e2bcd8739ae039),
    "bg-BG": (0, $c6f8a1181a0cc467$export$2e2bcd8739ae039),
    "cs-CZ": (0, $f130583cb08ae2d9$export$2e2bcd8739ae039),
    "da-DK": (0, $b2d6a5210f7e0a7e$export$2e2bcd8739ae039),
    "de-DE": (0, $4f7d80e0f34c4721$export$2e2bcd8739ae039),
    "el-GR": (0, $04c726ff32cae5e7$export$2e2bcd8739ae039),
    "en-US": (0, $112c160b3e9f2437$export$2e2bcd8739ae039),
    "es-ES": (0, $6e9baf223712471c$export$2e2bcd8739ae039),
    "et-EE": (0, $593b3e68df07b8ed$export$2e2bcd8739ae039),
    "fi-FI": (0, $9a5babbb15b626f4$export$2e2bcd8739ae039),
    "fr-FR": (0, $d59afdd75e3d0bda$export$2e2bcd8739ae039),
    "he-IL": (0, $9230a1e3d7583e90$export$2e2bcd8739ae039),
    "hr-HR": (0, $fa51ab2101c6fcb9$export$2e2bcd8739ae039),
    "hu-HU": (0, $bc4186a4fd971700$export$2e2bcd8739ae039),
    "it-IT": (0, $afe93d4c43a3fe68$export$2e2bcd8739ae039),
    "ja-JP": (0, $8c2bf3426725589e$export$2e2bcd8739ae039),
    "ko-KR": (0, $c3fe2da71665b421$export$2e2bcd8739ae039),
    "lt-LT": (0, $1ea9ab78bfa56509$export$2e2bcd8739ae039),
    "lv-LV": (0, $9638cad40c64fad2$export$2e2bcd8739ae039),
    "nb-NO": (0, $5b98ba93e4201e76$export$2e2bcd8739ae039),
    "nl-NL": (0, $82f297db20935be7$export$2e2bcd8739ae039),
    "pl-PL": (0, $7ea192b6308d7e85$export$2e2bcd8739ae039),
    "pt-BR": (0, $a69f30443652900d$export$2e2bcd8739ae039),
    "pt-PT": (0, $2d621c3464d8fc5b$export$2e2bcd8739ae039),
    "ro-RO": (0, $4c6c576f61f12279$export$2e2bcd8739ae039),
    "ru-RU": (0, $6926d9d8bd674ad0$export$2e2bcd8739ae039),
    "sk-SK": (0, $88df2c5d411be9df$export$2e2bcd8739ae039),
    "sl-SI": (0, $f14ccea2ecc3ec5f$export$2e2bcd8739ae039),
    "sr-SP": (0, $8ab986528674b5d6$export$2e2bcd8739ae039),
    "sv-SE": (0, $d45500d55325f120$export$2e2bcd8739ae039),
    "tr-TR": (0, $400e93ddbc83631c$export$2e2bcd8739ae039),
    "uk-UA": (0, $da93ff59eff8421d$export$2e2bcd8739ae039),
    "zh-CN": (0, $96c14d8c687c0229$export$2e2bcd8739ae039),
    "zh-TW": (0, $a07e80fecd52eebd$export$2e2bcd8739ae039)
};




/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $168b0e08d3f28116$export$d68d59712b04d9d1 {
    get childNodes() {
        throw new Error('childNodes is not supported');
    }
    clone() {
        let node = new this.constructor(this.key);
        node.value = this.value;
        node.level = this.level;
        node.hasChildNodes = this.hasChildNodes;
        node.rendered = this.rendered;
        node.textValue = this.textValue;
        node['aria-label'] = this['aria-label'];
        node.index = this.index;
        node.parentKey = this.parentKey;
        node.prevKey = this.prevKey;
        node.nextKey = this.nextKey;
        node.firstChildKey = this.firstChildKey;
        node.lastChildKey = this.lastChildKey;
        node.props = this.props;
        node.render = this.render;
        node.colSpan = this.colSpan;
        node.colIndex = this.colIndex;
        return node;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    filter(collection, newCollection, filterFn) {
        let clone = this.clone();
        newCollection.addDescendants(clone, collection);
        return clone;
    }
    constructor(key){
        this.value = null;
        this.level = 0;
        this.hasChildNodes = false;
        this.rendered = null;
        this.textValue = '';
        this['aria-label'] = undefined;
        this.index = 0;
        this.parentKey = null;
        this.prevKey = null;
        this.nextKey = null;
        this.firstChildKey = null;
        this.lastChildKey = null;
        this.props = {};
        this.colSpan = null;
        this.colIndex = null;
        this.type = this.constructor.type;
        this.key = key;
    }
}
class $168b0e08d3f28116$export$b1918e978f1ee46f extends $168b0e08d3f28116$export$d68d59712b04d9d1 {
    filter(collection, newCollection, filterFn) {
        let [firstKey, lastKey] = $168b0e08d3f28116$var$$23b9f4fcf0fe224b$var$filterChildren(collection, newCollection, this.firstChildKey, filterFn);
        let newNode = this.clone();
        newNode.firstChildKey = firstKey;
        newNode.lastChildKey = lastKey;
        return newNode;
    }
}
class $168b0e08d3f28116$export$5ae2504e948afce5 extends $168b0e08d3f28116$export$d68d59712b04d9d1 {
}
$168b0e08d3f28116$export$5ae2504e948afce5.type = 'header';
class $168b0e08d3f28116$export$8258a0665a675899 extends $168b0e08d3f28116$export$d68d59712b04d9d1 {
}
$168b0e08d3f28116$export$8258a0665a675899.type = 'loader';
class $168b0e08d3f28116$export$fd11f34e1d07f134 extends $168b0e08d3f28116$export$b1918e978f1ee46f {
    filter(collection, newCollection, filterFn) {
        if (filterFn(this.textValue, this)) {
            let clone = this.clone();
            newCollection.addDescendants(clone, collection);
            return clone;
        }
        return null;
    }
}
$168b0e08d3f28116$export$fd11f34e1d07f134.type = 'item';
class $168b0e08d3f28116$export$437f11dc9b403b78 extends $168b0e08d3f28116$export$b1918e978f1ee46f {
    filter(collection, newCollection, filterFn) {
        let filteredSection = super.filter(collection, newCollection, filterFn);
        if (filteredSection) {
            if (filteredSection.lastChildKey !== null) {
                let lastChild = collection.getItem(filteredSection.lastChildKey);
                if (lastChild && lastChild.type !== 'header') return filteredSection;
            }
        }
        return null;
    }
}
$168b0e08d3f28116$export$437f11dc9b403b78.type = 'section';
class $168b0e08d3f28116$export$408d25a4e12db025 {
    get size() {
        return this.itemCount;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    *[Symbol.iterator]() {
        let node = this.firstKey != null ? this.keyMap.get(this.firstKey) : undefined;
        while(node){
            yield node;
            node = node.nextKey != null ? this.keyMap.get(node.nextKey) : undefined;
        }
    }
    getChildren(key) {
        let keyMap = this.keyMap;
        return {
            *[Symbol.iterator] () {
                let parent = keyMap.get(key);
                let node = (parent === null || parent === void 0 ? void 0 : parent.firstChildKey) != null ? keyMap.get(parent.firstChildKey) : null;
                while(node){
                    yield node;
                    node = node.nextKey != null ? keyMap.get(node.nextKey) : undefined;
                }
            }
        };
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        if (!node) return null;
        if (node.prevKey != null) {
            node = this.keyMap.get(node.prevKey);
            while(node && node.type !== 'item' && node.lastChildKey != null)node = this.keyMap.get(node.lastChildKey);
            var _node_key;
            return (_node_key = node === null || node === void 0 ? void 0 : node.key) !== null && _node_key !== void 0 ? _node_key : null;
        }
        return node.parentKey;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        if (!node) return null;
        if (node.type !== 'item' && node.firstChildKey != null) return node.firstChildKey;
        while(node){
            if (node.nextKey != null) return node.nextKey;
            if (node.parentKey != null) node = this.keyMap.get(node.parentKey);
            else return null;
        }
        return null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        let node = this.lastKey != null ? this.keyMap.get(this.lastKey) : null;
        while((node === null || node === void 0 ? void 0 : node.lastChildKey) != null)node = this.keyMap.get(node.lastChildKey);
        var _node_key;
        return (_node_key = node === null || node === void 0 ? void 0 : node.key) !== null && _node_key !== void 0 ? _node_key : null;
    }
    getItem(key) {
        var _this_keyMap_get;
        return (_this_keyMap_get = this.keyMap.get(key)) !== null && _this_keyMap_get !== void 0 ? _this_keyMap_get : null;
    }
    at() {
        throw new Error('Not implemented');
    }
    clone() {
        // We need to clone using this.constructor so that subclasses have the right prototype.
        // TypeScript isn't happy about this yet.
        // https://github.com/microsoft/TypeScript/issues/3841
        let Constructor = this.constructor;
        let collection = new Constructor();
        collection.keyMap = new Map(this.keyMap);
        collection.firstKey = this.firstKey;
        collection.lastKey = this.lastKey;
        collection.itemCount = this.itemCount;
        return collection;
    }
    addNode(node) {
        if (this.frozen) throw new Error('Cannot add a node to a frozen collection');
        if (node.type === 'item' && this.keyMap.get(node.key) == null) this.itemCount++;
        this.keyMap.set(node.key, node);
    }
    // Deeply add a node and its children to the collection from another collection, primarily used when filtering a collection
    addDescendants(node, oldCollection) {
        this.addNode(node);
        let children = oldCollection.getChildren(node.key);
        for (let child of children)this.addDescendants(child, oldCollection);
    }
    removeNode(key) {
        if (this.frozen) throw new Error('Cannot remove a node to a frozen collection');
        let node = this.keyMap.get(key);
        if (node != null && node.type === 'item') this.itemCount--;
        this.keyMap.delete(key);
    }
    commit(firstKey, lastKey, isSSR = false) {
        if (this.frozen) throw new Error('Cannot commit a frozen collection');
        this.firstKey = firstKey;
        this.lastKey = lastKey;
        this.frozen = !isSSR;
    }
    filter(filterFn) {
        let newCollection = new this.constructor();
        let [firstKey, lastKey] = $168b0e08d3f28116$var$$23b9f4fcf0fe224b$var$filterChildren(this, newCollection, this.firstKey, filterFn);
        newCollection === null || newCollection === void 0 || newCollection.commit(firstKey, lastKey);
        return newCollection;
    }
    constructor(){
        this.keyMap = new Map();
        this.firstKey = null;
        this.lastKey = null;
        this.frozen = false;
        this.itemCount = 0;
    }
}
function $168b0e08d3f28116$var$$23b9f4fcf0fe224b$var$filterChildren(collection, newCollection, firstChildKey, filterFn) {
    // loop over the siblings for firstChildKey
    // create new nodes based on calling node.filter for each child
    // if it returns null then don't include it, otherwise update its prev/next keys
    // add them to the newCollection
    if (firstChildKey == null) return [
        null,
        null
    ];
    let firstNode = null;
    let lastNode = null;
    let currentNode = collection.getItem(firstChildKey);
    while(currentNode != null){
        let newNode = currentNode.filter(collection, newCollection, filterFn);
        if (newNode != null) {
            newNode.nextKey = null;
            if (lastNode) {
                newNode.prevKey = lastNode.key;
                lastNode.nextKey = newNode.key;
            }
            if (firstNode == null) firstNode = newNode;
            newCollection.addNode(newNode);
            lastNode = newNode;
        }
        currentNode = currentNode.nextKey ? collection.getItem(currentNode.nextKey) : null;
    }
    // TODO: this is pretty specific to dividers but doesn't feel like there is a good way to get around it since we only can know
    // to filter the last separator in a collection only after performing a filter for the rest of the contents after it
    // Its gross that it needs to live here, might be nice if somehow we could have this live in the separator code
    if (lastNode && lastNode.type === 'separator') {
        let prevKey = lastNode.prevKey;
        newCollection.removeNode(lastNode.key);
        if (prevKey) {
            lastNode = newCollection.getItem(prevKey);
            lastNode.nextKey = null;
        } else lastNode = null;
    }
    var _firstNode_key, _lastNode_key;
    return [
        (_firstNode_key = firstNode === null || firstNode === void 0 ? void 0 : firstNode.key) !== null && _firstNode_key !== void 0 ? _firstNode_key : null,
        (_lastNode_key = lastNode === null || lastNode === void 0 ? void 0 : lastNode.key) !== null && _lastNode_key !== void 0 ? _lastNode_key : null
    ];
}


/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $911fdb21b09cfb8e$export$410b0c854570d131 {
    *[Symbol.iterator]() {
        let node = this.firstChild;
        while(node){
            yield node;
            node = node.nextSibling;
        }
    }
    get firstChild() {
        return this._firstChild;
    }
    set firstChild(firstChild) {
        this._firstChild = firstChild;
        this.ownerDocument.markDirty(this);
    }
    get lastChild() {
        return this._lastChild;
    }
    set lastChild(lastChild) {
        this._lastChild = lastChild;
        this.ownerDocument.markDirty(this);
    }
    get previousSibling() {
        return this._previousSibling;
    }
    set previousSibling(previousSibling) {
        this._previousSibling = previousSibling;
        this.ownerDocument.markDirty(this);
    }
    get nextSibling() {
        return this._nextSibling;
    }
    set nextSibling(nextSibling) {
        this._nextSibling = nextSibling;
        this.ownerDocument.markDirty(this);
    }
    get parentNode() {
        return this._parentNode;
    }
    set parentNode(parentNode) {
        this._parentNode = parentNode;
        this.ownerDocument.markDirty(this);
    }
    get isConnected() {
        var _this_parentNode;
        return ((_this_parentNode = this.parentNode) === null || _this_parentNode === void 0 ? void 0 : _this_parentNode.isConnected) || false;
    }
    invalidateChildIndices(child) {
        if (this._minInvalidChildIndex == null || !this._minInvalidChildIndex.isConnected || child.index < this._minInvalidChildIndex.index) {
            this._minInvalidChildIndex = child;
            this.ownerDocument.markDirty(this);
        }
    }
    updateChildIndices() {
        let node = this._minInvalidChildIndex;
        while(node){
            node.index = node.previousSibling ? node.previousSibling.index + 1 : 0;
            node = node.nextSibling;
        }
        this._minInvalidChildIndex = null;
    }
    appendChild(child) {
        if (child.parentNode) child.parentNode.removeChild(child);
        if (this.firstChild == null) this.firstChild = child;
        if (this.lastChild) {
            this.lastChild.nextSibling = child;
            child.index = this.lastChild.index + 1;
            child.previousSibling = this.lastChild;
        } else {
            child.previousSibling = null;
            child.index = 0;
        }
        child.parentNode = this;
        child.nextSibling = null;
        this.lastChild = child;
        this.ownerDocument.markDirty(this);
        if (this.isConnected) this.ownerDocument.queueUpdate();
    }
    insertBefore(newNode, referenceNode) {
        if (referenceNode == null) return this.appendChild(newNode);
        if (newNode.parentNode) newNode.parentNode.removeChild(newNode);
        newNode.nextSibling = referenceNode;
        newNode.previousSibling = referenceNode.previousSibling;
        // Ensure that the newNode's index is less than that of the reference node so that
        // invalidateChildIndices will properly use the newNode as the _minInvalidChildIndex, thus making sure
        // we will properly update the indexes of all sibiling nodes after the newNode. The value here doesn't matter
        // since updateChildIndices should calculate the proper indexes.
        newNode.index = referenceNode.index - 1;
        if (this.firstChild === referenceNode) this.firstChild = newNode;
        else if (referenceNode.previousSibling) referenceNode.previousSibling.nextSibling = newNode;
        referenceNode.previousSibling = newNode;
        newNode.parentNode = referenceNode.parentNode;
        this.invalidateChildIndices(newNode);
        if (this.isConnected) this.ownerDocument.queueUpdate();
    }
    removeChild(child) {
        if (child.parentNode !== this) return;
        if (this._minInvalidChildIndex === child) this._minInvalidChildIndex = null;
        if (child.nextSibling) {
            this.invalidateChildIndices(child.nextSibling);
            child.nextSibling.previousSibling = child.previousSibling;
        }
        if (child.previousSibling) child.previousSibling.nextSibling = child.nextSibling;
        if (this.firstChild === child) this.firstChild = child.nextSibling;
        if (this.lastChild === child) this.lastChild = child.previousSibling;
        child.parentNode = null;
        child.nextSibling = null;
        child.previousSibling = null;
        child.index = 0;
        this.ownerDocument.markDirty(child);
        if (this.isConnected) this.ownerDocument.queueUpdate();
    }
    addEventListener() {}
    removeEventListener() {}
    get previousVisibleSibling() {
        let node = this.previousSibling;
        while(node && node.isHidden)node = node.previousSibling;
        return node;
    }
    get nextVisibleSibling() {
        let node = this.nextSibling;
        while(node && node.isHidden)node = node.nextSibling;
        return node;
    }
    get firstVisibleChild() {
        let node = this.firstChild;
        while(node && node.isHidden)node = node.nextSibling;
        return node;
    }
    get lastVisibleChild() {
        let node = this.lastChild;
        while(node && node.isHidden)node = node.previousSibling;
        return node;
    }
    constructor(ownerDocument){
        this._firstChild = null;
        this._lastChild = null;
        this._previousSibling = null;
        this._nextSibling = null;
        this._parentNode = null;
        this._minInvalidChildIndex = null;
        this.ownerDocument = ownerDocument;
    }
}
class $911fdb21b09cfb8e$export$dc064fe9e59310fd extends $911fdb21b09cfb8e$export$410b0c854570d131 {
    get index() {
        return this._index;
    }
    set index(index) {
        this._index = index;
        this.ownerDocument.markDirty(this);
    }
    get level() {
        var _this_node;
        if (this.parentNode instanceof $911fdb21b09cfb8e$export$dc064fe9e59310fd) return this.parentNode.level + (((_this_node = this.node) === null || _this_node === void 0 ? void 0 : _this_node.type) === 'item' ? 1 : 0);
        return 0;
    }
    /**
   * Lazily gets a mutable instance of a Node. If the node has already
   * been cloned during this update cycle, it just returns the existing one.
   */ getMutableNode() {
        if (this.node == null) return null;
        if (!this.isMutated) {
            this.node = this.node.clone();
            this.isMutated = true;
        }
        this.ownerDocument.markDirty(this);
        return this.node;
    }
    updateNode() {
        var _this_parentNode_node, _this_previousVisibleSibling_node, _this_previousVisibleSibling, _nextSibling_node, _this_firstVisibleChild_node, _this_firstVisibleChild, _this_lastVisibleChild_node, _this_lastVisibleChild;
        let nextSibling = this.nextVisibleSibling;
        let node = this.getMutableNode();
        if (node == null) return;
        node.index = this.index;
        node.level = this.level;
        var _this_parentNode_node_key;
        node.parentKey = this.parentNode instanceof $911fdb21b09cfb8e$export$dc064fe9e59310fd ? (_this_parentNode_node_key = (_this_parentNode_node = this.parentNode.node) === null || _this_parentNode_node === void 0 ? void 0 : _this_parentNode_node.key) !== null && _this_parentNode_node_key !== void 0 ? _this_parentNode_node_key : null : null;
        var _this_previousVisibleSibling_node_key;
        node.prevKey = (_this_previousVisibleSibling_node_key = (_this_previousVisibleSibling = this.previousVisibleSibling) === null || _this_previousVisibleSibling === void 0 ? void 0 : (_this_previousVisibleSibling_node = _this_previousVisibleSibling.node) === null || _this_previousVisibleSibling_node === void 0 ? void 0 : _this_previousVisibleSibling_node.key) !== null && _this_previousVisibleSibling_node_key !== void 0 ? _this_previousVisibleSibling_node_key : null;
        var _nextSibling_node_key;
        node.nextKey = (_nextSibling_node_key = nextSibling === null || nextSibling === void 0 ? void 0 : (_nextSibling_node = nextSibling.node) === null || _nextSibling_node === void 0 ? void 0 : _nextSibling_node.key) !== null && _nextSibling_node_key !== void 0 ? _nextSibling_node_key : null;
        node.hasChildNodes = !!this.firstChild;
        var _this_firstVisibleChild_node_key;
        node.firstChildKey = (_this_firstVisibleChild_node_key = (_this_firstVisibleChild = this.firstVisibleChild) === null || _this_firstVisibleChild === void 0 ? void 0 : (_this_firstVisibleChild_node = _this_firstVisibleChild.node) === null || _this_firstVisibleChild_node === void 0 ? void 0 : _this_firstVisibleChild_node.key) !== null && _this_firstVisibleChild_node_key !== void 0 ? _this_firstVisibleChild_node_key : null;
        var _this_lastVisibleChild_node_key;
        node.lastChildKey = (_this_lastVisibleChild_node_key = (_this_lastVisibleChild = this.lastVisibleChild) === null || _this_lastVisibleChild === void 0 ? void 0 : (_this_lastVisibleChild_node = _this_lastVisibleChild.node) === null || _this_lastVisibleChild_node === void 0 ? void 0 : _this_lastVisibleChild_node.key) !== null && _this_lastVisibleChild_node_key !== void 0 ? _this_lastVisibleChild_node_key : null;
        // Update the colIndex of sibling nodes if this node has a colSpan.
        if ((node.colSpan != null || node.colIndex != null) && nextSibling) {
            var _node_colIndex, _node_colSpan;
            // This queues the next sibling for update, which means this happens recursively.
            let nextColIndex = ((_node_colIndex = node.colIndex) !== null && _node_colIndex !== void 0 ? _node_colIndex : node.index) + ((_node_colSpan = node.colSpan) !== null && _node_colSpan !== void 0 ? _node_colSpan : 1);
            if (nextSibling.node != null && nextColIndex !== nextSibling.node.colIndex) {
                let siblingNode = nextSibling.getMutableNode();
                siblingNode.colIndex = nextColIndex;
            }
        }
    }
    setProps(obj, ref, CollectionNodeClass, rendered, render) {
        let node;
        let { value: value1, textValue: textValue, id: id, ...props } = obj;
        if (this.node == null) {
            node = new CollectionNodeClass(id !== null && id !== void 0 ? id : `react-aria-${++this.ownerDocument.nodeId}`);
            this.node = node;
        } else node = this.getMutableNode();
        props.ref = ref;
        node.props = props;
        node.rendered = rendered;
        node.render = render;
        node.value = value1;
        if (obj['aria-label']) node['aria-label'] = obj['aria-label'];
        node.textValue = textValue || (typeof props.children === 'string' ? props.children : '') || obj['aria-label'] || '';
        if (id != null && id !== node.key) throw new Error('Cannot change the id of an item');
        if (props.colSpan != null) node.colSpan = props.colSpan;
        if (this.isConnected) this.ownerDocument.queueUpdate();
    }
    get style() {
        // React sets display: none to hide elements during Suspense.
        // We'll handle this by setting the element to hidden and invalidating
        // its siblings/parent. Hidden elements remain in the Document, but
        // are removed from the Collection.
        let element = this;
        return {
            get display () {
                return element.isHidden ? 'none' : '';
            },
            set display (value){
                let isHidden = value === 'none';
                if (element.isHidden !== isHidden) {
                    var _element_parentNode, _element_parentNode1;
                    // Mark parent node dirty if this element is currently the first or last visible child.
                    if (((_element_parentNode = element.parentNode) === null || _element_parentNode === void 0 ? void 0 : _element_parentNode.firstVisibleChild) === element || ((_element_parentNode1 = element.parentNode) === null || _element_parentNode1 === void 0 ? void 0 : _element_parentNode1.lastVisibleChild) === element) element.ownerDocument.markDirty(element.parentNode);
                    // Mark sibling visible elements dirty.
                    let prev = element.previousVisibleSibling;
                    let next = element.nextVisibleSibling;
                    if (prev) element.ownerDocument.markDirty(prev);
                    if (next) element.ownerDocument.markDirty(next);
                    // Mark self dirty.
                    element.isHidden = isHidden;
                    element.ownerDocument.markDirty(element);
                }
            }
        };
    }
    hasAttribute() {}
    setAttribute() {}
    setAttributeNS() {}
    removeAttribute() {}
    constructor(type, ownerDocument){
        super(ownerDocument), this.nodeType = 8 // COMMENT_NODE (we'd use ELEMENT_NODE but React DevTools will fail to get its dimensions)
        , this.isMutated = true, this._index = 0, this.isHidden = false;
        this.node = null;
    }
}
class $911fdb21b09cfb8e$export$b34a105447964f9f extends $911fdb21b09cfb8e$export$410b0c854570d131 {
    get isConnected() {
        return true;
    }
    createElement(type) {
        return new $911fdb21b09cfb8e$export$dc064fe9e59310fd(type, this);
    }
    getMutableCollection() {
        if (!this.nextCollection) this.nextCollection = this.collection.clone();
        return this.nextCollection;
    }
    markDirty(node) {
        this.dirtyNodes.add(node);
    }
    addNode(element) {
        if (element.isHidden || element.node == null) return;
        let collection = this.getMutableCollection();
        if (!collection.getItem(element.node.key)) for (let child of element)this.addNode(child);
        collection.addNode(element.node);
    }
    removeNode(node) {
        for (let child of node)this.removeNode(child);
        if (node.node) {
            let collection = this.getMutableCollection();
            collection.removeNode(node.node.key);
        }
    }
    /** Finalizes the collection update, updating all nodes and freezing the collection. */ getCollection() {
        // If in a subscription update, return a clone of the existing collection.
        // This ensures React will queue a render. React will call getCollection again
        // during render, at which point all the updates will be complete and we can return
        // the new collection.
        if (this.inSubscription) return this.collection.clone();
        // Reset queuedRender to false when getCollection is called during render.
        this.queuedRender = false;
        this.updateCollection();
        return this.collection;
    }
    updateCollection() {
        // First, remove disconnected nodes and update the indices of dirty element children.
        for (let element of this.dirtyNodes)if (element instanceof $911fdb21b09cfb8e$export$dc064fe9e59310fd && (!element.isConnected || element.isHidden)) this.removeNode(element);
        else element.updateChildIndices();
        // Next, update dirty collection nodes.
        for (let element of this.dirtyNodes)if (element instanceof $911fdb21b09cfb8e$export$dc064fe9e59310fd) {
            if (element.isConnected && !element.isHidden) {
                element.updateNode();
                this.addNode(element);
            }
            if (element.node) this.dirtyNodes.delete(element);
            element.isMutated = false;
        } else this.dirtyNodes.delete(element);
        // Finally, update the collection.
        if (this.nextCollection) {
            var _this_firstVisibleChild_node, _this_firstVisibleChild, _this_lastVisibleChild_node, _this_lastVisibleChild;
            var _this_firstVisibleChild_node_key, _this_lastVisibleChild_node_key;
            this.nextCollection.commit((_this_firstVisibleChild_node_key = (_this_firstVisibleChild = this.firstVisibleChild) === null || _this_firstVisibleChild === void 0 ? void 0 : (_this_firstVisibleChild_node = _this_firstVisibleChild.node) === null || _this_firstVisibleChild_node === void 0 ? void 0 : _this_firstVisibleChild_node.key) !== null && _this_firstVisibleChild_node_key !== void 0 ? _this_firstVisibleChild_node_key : null, (_this_lastVisibleChild_node_key = (_this_lastVisibleChild = this.lastVisibleChild) === null || _this_lastVisibleChild === void 0 ? void 0 : (_this_lastVisibleChild_node = _this_lastVisibleChild.node) === null || _this_lastVisibleChild_node === void 0 ? void 0 : _this_lastVisibleChild_node.key) !== null && _this_lastVisibleChild_node_key !== void 0 ? _this_lastVisibleChild_node_key : null, this.isSSR);
            if (!this.isSSR) {
                this.collection = this.nextCollection;
                this.nextCollection = null;
            }
        }
    }
    queueUpdate() {
        if (this.dirtyNodes.size === 0 || this.queuedRender) return;
        // Only trigger subscriptions once during an update, when the first item changes.
        // React's useSyncExternalStore will call getCollection immediately, to check whether the snapshot changed.
        // If so, React will queue a render to happen after the current commit to our fake DOM finishes.
        // We track whether getCollection is called in a subscription, and once it is called during render,
        // we reset queuedRender back to false.
        this.queuedRender = true;
        this.inSubscription = true;
        for (let fn of this.subscriptions)fn();
        this.inSubscription = false;
    }
    subscribe(fn) {
        this.subscriptions.add(fn);
        return ()=>this.subscriptions.delete(fn);
    }
    resetAfterSSR() {
        if (this.isSSR) {
            this.isSSR = false;
            this.firstChild = null;
            this.lastChild = null;
            this.nodeId = 0;
        }
    }
    constructor(collection){
        // @ts-ignore
        super(null), this.nodeType = 11 // DOCUMENT_FRAGMENT_NODE
        , this.ownerDocument = this, this.dirtyNodes = new Set(), this.isSSR = false, this.nodeId = 0, this.nodesByProps = new WeakMap(), this.nextCollection = null, this.subscriptions = new Set(), this.queuedRender = false, this.inSubscription = false;
        this.collection = collection;
        this.nextCollection = collection;
    }
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4848fcbc366bc773$export$727c8fc270210f13(props) {
    let { children: children, items: items, idScope: idScope, addIdAndValue: addIdAndValue, dependencies: dependencies = [] } = props;
    // Invalidate the cache whenever the parent value changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    let cache = (0, $acw62.useMemo)(()=>new WeakMap(), dependencies);
    return (0, $acw62.useMemo)(()=>{
        if (items && typeof children === 'function') {
            let res = [];
            for (let item of items){
                let rendered = cache.get(item);
                if (!rendered) {
                    rendered = children(item);
                    var _rendered_props_id, _ref;
                    // @ts-ignore
                    let key = (_ref = (_rendered_props_id = rendered.props.id) !== null && _rendered_props_id !== void 0 ? _rendered_props_id : item.key) !== null && _ref !== void 0 ? _ref : item.id;
                    if (key == null) throw new Error('Could not determine key for item');
                    if (idScope != null) key = idScope + ':' + key;
                    // Note: only works if wrapped Item passes through id...
                    rendered = (0, $acw62.cloneElement)(rendered, addIdAndValue ? {
                        key: key,
                        id: key,
                        value: item
                    } : {
                        key: key
                    });
                    cache.set(item, rendered);
                }
                res.push(rendered);
            }
            return res;
        } else if (typeof children !== 'function') return children;
    }, [
        children,
        items,
        cache,
        idScope,
        addIdAndValue
    ]);
}






var $acw62 = parcelRequire("acw62");

var $c8e45c4daa4b95cb$exports = {};
'use strict';

$c8e45c4daa4b95cb$exports = (parcelRequire("hkKGc"));


/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $5fe83fb7b4e6e89f$var$$e1995378a142960e$var$ShallowRenderContext = (0, $acw62.createContext)(false);
const $5fe83fb7b4e6e89f$var$$e1995378a142960e$var$CollectionDocumentContext = (0, $acw62.createContext)(null);
function $5fe83fb7b4e6e89f$export$bf788dd355e3a401(props) {
    // If a document was provided above us, we're already in a hidden tree. Just render the content.
    let doc = (0, $acw62.useContext)($5fe83fb7b4e6e89f$var$$e1995378a142960e$var$CollectionDocumentContext);
    if (doc) // even though the actual implementation since React 16 did.
    // We must return ReactElement so that TS does not complain that <CollectionBuilder>
    // is not a valid JSX element with React 16 and 17 types.
    // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/20544
    return props.content;
    // Otherwise, render a hidden copy of the children so that we can build the collection before constructing the state.
    // This should always come before the real DOM content so we have built the collection by the time it renders during SSR.
    // This is fine. CollectionDocumentContext never changes after mounting.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let { collection: collection, document: document } = $5fe83fb7b4e6e89f$var$$e1995378a142960e$var$useCollectionDocument(props.createCollection);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $73addfbf71cdc088$export$8dc98ba7eadeaa56), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5fe83fb7b4e6e89f$var$$e1995378a142960e$var$CollectionDocumentContext.Provider, {
        value: document
    }, props.content)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5fe83fb7b4e6e89f$var$$e1995378a142960e$var$CollectionInner, {
        render: props.children,
        collection: collection
    }));
}
function $5fe83fb7b4e6e89f$var$$e1995378a142960e$var$CollectionInner({ collection: collection, render: render }) {
    return render(collection);
}
// React 16 and 17 don't support useSyncExternalStore natively, and the shim provided by React does not support getServerSnapshot.
// This wrapper uses the shim, but additionally calls getServerSnapshot during SSR (according to SSRProvider).
function $5fe83fb7b4e6e89f$var$$e1995378a142960e$var$useSyncExternalStoreFallback(subscribe, getSnapshot, getServerSnapshot) {
    let isSSR = (0, $3355288d61aeabc2$export$535bd6ca7f90a273)();
    let isSSRRef = (0, $acw62.useRef)(isSSR);
    // This is read immediately inside the wrapper, which also runs during render.
    // We just need a ref to avoid invalidating the callback itself, which
    // would cause React to re-run the callback more than necessary.
    // eslint-disable-next-line rulesdir/pure-render
    isSSRRef.current = isSSR;
    let getSnapshotWrapper = (0, $acw62.useCallback)(()=>{
        return isSSRRef.current ? getServerSnapshot() : getSnapshot();
    }, [
        getSnapshot,
        getServerSnapshot
    ]);
    return (0, $c8e45c4daa4b95cb$exports.useSyncExternalStore)(subscribe, getSnapshotWrapper);
}
const $5fe83fb7b4e6e89f$var$$e1995378a142960e$var$useSyncExternalStore = typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useSyncExternalStore'] === 'function' ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useSyncExternalStore'] : $5fe83fb7b4e6e89f$var$$e1995378a142960e$var$useSyncExternalStoreFallback;
function $5fe83fb7b4e6e89f$var$$e1995378a142960e$var$useCollectionDocument(createCollection) {
    // The document instance is mutable, and should never change between renders.
    // useSyncExternalStore is used to subscribe to updates, which vends immutable Collection objects.
    let [document] = (0, $acw62.useState)(()=>new (0, $911fdb21b09cfb8e$export$b34a105447964f9f)((createCollection === null || createCollection === void 0 ? void 0 : createCollection()) || new (0, $168b0e08d3f28116$export$408d25a4e12db025)()));
    let subscribe = (0, $acw62.useCallback)((fn)=>document.subscribe(fn), [
        document
    ]);
    let getSnapshot = (0, $acw62.useCallback)(()=>{
        let collection = document.getCollection();
        if (document.isSSR) // We do this _after_ getting the collection above so that the collection still has content in it from SSR
        // during the current render, before React has finished the client render.
        document.resetAfterSSR();
        return collection;
    }, [
        document
    ]);
    let getServerSnapshot = (0, $acw62.useCallback)(()=>{
        document.isSSR = true;
        return document.getCollection();
    }, [
        document
    ]);
    let collection = $5fe83fb7b4e6e89f$var$$e1995378a142960e$var$useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return {
        collection: collection,
        document: document
    };
}
const $5fe83fb7b4e6e89f$var$$e1995378a142960e$var$SSRContext = (0, $acw62.createContext)(null);
function $5fe83fb7b4e6e89f$var$$e1995378a142960e$var$createCollectionNodeClass(type) {
    var _class;
    let NodeClass = (_class = class extends (0, $168b0e08d3f28116$export$d68d59712b04d9d1) {
    }, _class.type = type, _class);
    return NodeClass;
}
function $5fe83fb7b4e6e89f$var$$e1995378a142960e$var$useSSRCollectionNode(CollectionNodeClass, props, ref, rendered, children, render) {
    // To prevent breaking change, if CollectionNodeClass is a string, create a CollectionNodeClass using the string as the type
    if (typeof CollectionNodeClass === 'string') CollectionNodeClass = $5fe83fb7b4e6e89f$var$$e1995378a142960e$var$createCollectionNodeClass(CollectionNodeClass);
    // During SSR, portals are not supported, so the collection children will be wrapped in an SSRContext.
    // Since SSR occurs only once, we assume that the elements are rendered in order and never re-render.
    // Therefore we can create elements in our collection document during render so that they are in the
    // collection by the time we need to use the collection to render to the real DOM.
    // After hydration, we switch to client rendering using the portal.
    let itemRef = (0, $acw62.useCallback)((element)=>{
        element === null || element === void 0 || element.setProps(props, ref, CollectionNodeClass, rendered, render);
    }, [
        props,
        ref,
        rendered,
        render,
        CollectionNodeClass
    ]);
    let parentNode = (0, $acw62.useContext)($5fe83fb7b4e6e89f$var$$e1995378a142960e$var$SSRContext);
    if (parentNode) {
        // Guard against double rendering in strict mode.
        let element = parentNode.ownerDocument.nodesByProps.get(props);
        if (!element) {
            element = parentNode.ownerDocument.createElement(CollectionNodeClass.type);
            element.setProps(props, ref, CollectionNodeClass, rendered, render);
            parentNode.appendChild(element);
            parentNode.ownerDocument.updateCollection();
            parentNode.ownerDocument.nodesByProps.set(props, element);
        }
        return children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5fe83fb7b4e6e89f$var$$e1995378a142960e$var$SSRContext.Provider, {
            value: element
        }, children) : null;
    }
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CollectionNodeClass.type, {
        ref: itemRef
    }, children);
}
function $5fe83fb7b4e6e89f$export$18af5c7a9e9b3664(CollectionNodeClass, render) {
    let Component = ({ node: node })=>render(node.props, node.props.ref, node);
    let Result = (0, $acw62.forwardRef)((props, ref)=>{
        let focusableProps = (0, $acw62.useContext)((0, $daedc3252d285a56$export$f9762fab77588ecb));
        let isShallow = (0, $acw62.useContext)($5fe83fb7b4e6e89f$var$$e1995378a142960e$var$ShallowRenderContext);
        if (!isShallow) {
            if (render.length >= 3) throw new Error(render.name + ' cannot be rendered outside a collection.');
            return render(props, ref);
        }
        return $5fe83fb7b4e6e89f$var$$e1995378a142960e$var$useSSRCollectionNode(CollectionNodeClass, props, ref, 'children' in props ? props.children : null, null, (node)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $daedc3252d285a56$export$f9762fab77588ecb).Provider, {
                value: focusableProps
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, {
                node: node
            })));
    });
    // @ts-ignore
    Result.displayName = render.name;
    return Result;
}
function $5fe83fb7b4e6e89f$export$e953bb1cd0f19726(CollectionNodeClass, render, useChildren = $5fe83fb7b4e6e89f$var$$e1995378a142960e$var$useCollectionChildren) {
    let Component = ({ node: node })=>render(node.props, node.props.ref, node);
    let Result = (0, $acw62.forwardRef)((props, ref)=>{
        let children = useChildren(props);
        var _useSSRCollectionNode;
        return (_useSSRCollectionNode = $5fe83fb7b4e6e89f$var$$e1995378a142960e$var$useSSRCollectionNode(CollectionNodeClass, props, ref, null, children, (node)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, {
                node: node
            }))) !== null && _useSSRCollectionNode !== void 0 ? _useSSRCollectionNode : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    });
    // @ts-ignore
    Result.displayName = render.name;
    return Result;
}
function $5fe83fb7b4e6e89f$var$$e1995378a142960e$var$useCollectionChildren(options) {
    return (0, $4848fcbc366bc773$export$727c8fc270210f13)({
        ...options,
        addIdAndValue: true
    });
}
const $5fe83fb7b4e6e89f$var$$e1995378a142960e$var$CollectionContext = (0, $acw62.createContext)(null);
function $5fe83fb7b4e6e89f$export$fb8073518f34e6ec(props) {
    let ctx = (0, $acw62.useContext)($5fe83fb7b4e6e89f$var$$e1995378a142960e$var$CollectionContext);
    let dependencies = ((ctx === null || ctx === void 0 ? void 0 : ctx.dependencies) || []).concat(props.dependencies);
    var _props_idScope;
    let idScope = (_props_idScope = props.idScope) !== null && _props_idScope !== void 0 ? _props_idScope : ctx === null || ctx === void 0 ? void 0 : ctx.idScope;
    let children = $5fe83fb7b4e6e89f$var$$e1995378a142960e$var$useCollectionChildren({
        ...props,
        idScope: idScope,
        dependencies: dependencies
    });
    let doc = (0, $acw62.useContext)($5fe83fb7b4e6e89f$var$$e1995378a142960e$var$CollectionDocumentContext);
    if (doc) children = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5fe83fb7b4e6e89f$var$$e1995378a142960e$var$CollectionRoot, null, children);
    // Propagate dependencies and idScope to child collections.
    ctx = (0, $acw62.useMemo)(()=>({
            dependencies: dependencies,
            idScope: idScope
        }), [
        idScope,
        ...dependencies
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5fe83fb7b4e6e89f$var$$e1995378a142960e$var$CollectionContext.Provider, {
        value: ctx
    }, children);
}
function $5fe83fb7b4e6e89f$var$$e1995378a142960e$var$CollectionRoot({ children: children }) {
    let doc = (0, $acw62.useContext)($5fe83fb7b4e6e89f$var$$e1995378a142960e$var$CollectionDocumentContext);
    let wrappedChildren = (0, $acw62.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5fe83fb7b4e6e89f$var$$e1995378a142960e$var$CollectionDocumentContext.Provider, {
            value: null
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5fe83fb7b4e6e89f$var$$e1995378a142960e$var$ShallowRenderContext.Provider, {
            value: true
        }, children)), [
        children
    ]);
    // During SSR, we render the content directly, and append nodes to the document during render.
    // The collection children return null so that nothing is actually rendered into the HTML.
    return (0, $3355288d61aeabc2$export$535bd6ca7f90a273)() ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5fe83fb7b4e6e89f$var$$e1995378a142960e$var$SSRContext.Provider, {
        value: doc
    }, wrappedChildren) : (0, $11492dca620dcaa5$exports.createPortal)(wrappedChildren, doc);
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $0152a93b06da2b96$export$d40e14dec8b060a8 = (0, $acw62.createContext)(null);
const $0152a93b06da2b96$export$6e2c8f0811a474ce = (0, $5fe83fb7b4e6e89f$export$e953bb1cd0f19726)('section', (props, ref, section)=>{
    let { name: name, render: render } = (0, $acw62.useContext)($0152a93b06da2b96$export$d40e14dec8b060a8);
    return render(props, ref, section, 'react-aria-Section');
});
const $0152a93b06da2b96$export$a164736487e3f0ae = {
    CollectionRoot ({ collection: collection, renderDropIndicator: renderDropIndicator }) {
        return $0152a93b06da2b96$var$$7135fc7d473fd974$var$useCollectionRender(collection, null, renderDropIndicator);
    },
    CollectionBranch ({ collection: collection, parent: parent, renderDropIndicator: renderDropIndicator }) {
        return $0152a93b06da2b96$var$$7135fc7d473fd974$var$useCollectionRender(collection, parent, renderDropIndicator);
    }
};
function $0152a93b06da2b96$var$$7135fc7d473fd974$var$useCollectionRender(collection, parent, renderDropIndicator) {
    return (0, $4848fcbc366bc773$export$727c8fc270210f13)({
        items: parent ? collection.getChildren(parent.key) : collection,
        dependencies: [
            renderDropIndicator
        ],
        children (node) {
            let rendered = node.render(node);
            if (!renderDropIndicator || node.type !== 'item') return rendered;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, renderDropIndicator({
                type: 'item',
                key: node.key,
                dropPosition: 'before'
            }), rendered, $0152a93b06da2b96$export$2dbbd341daed716d(collection, node, renderDropIndicator));
        }
    });
}
function $0152a93b06da2b96$export$2dbbd341daed716d(collection, node, renderDropIndicator) {
    let key = node.key;
    let keyAfter = collection.getKeyAfter(key);
    let nextItemInFlattenedCollection = keyAfter != null ? collection.getItem(keyAfter) : null;
    while(nextItemInFlattenedCollection != null && nextItemInFlattenedCollection.type !== 'item'){
        keyAfter = collection.getKeyAfter(nextItemInFlattenedCollection.key);
        nextItemInFlattenedCollection = keyAfter != null ? collection.getItem(keyAfter) : null;
    }
    let nextItemInSameLevel = node.nextKey != null ? collection.getItem(node.nextKey) : null;
    while(nextItemInSameLevel != null && nextItemInSameLevel.type !== 'item')nextItemInSameLevel = nextItemInSameLevel.nextKey != null ? collection.getItem(nextItemInSameLevel.nextKey) : null;
    // Render one or more "after" drop indicators when the next item in the flattened collection
    // has a smaller level, is not an item, or there are no more items in the collection.
    // Otherwise, the "after" position is equivalent to the next item's "before" position.
    let afterIndicators = [];
    if (nextItemInSameLevel == null) {
        let current = node;
        while((current === null || current === void 0 ? void 0 : current.type) === 'item' && (!nextItemInFlattenedCollection || current.parentKey !== nextItemInFlattenedCollection.parentKey && nextItemInFlattenedCollection.level < current.level)){
            let indicator = renderDropIndicator({
                type: 'item',
                key: current.key,
                dropPosition: 'after'
            });
            if ((0, $acw62.isValidElement)(indicator)) afterIndicators.push((0, $acw62.cloneElement)(indicator, {
                key: `${current.key}-after`
            }));
            current = current.parentKey != null ? collection.getItem(current.parentKey) : null;
        }
    }
    return afterIndicators;
}
const $0152a93b06da2b96$export$4feb769f8ddf26c5 = (0, $acw62.createContext)($0152a93b06da2b96$export$a164736487e3f0ae);
function $0152a93b06da2b96$export$90e00781bc59d8f9(focusedKey) {
    return (0, $acw62.useMemo)(()=>focusedKey != null ? new Set([
            focusedKey
        ]) : null, [
        focusedKey
    ]);
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $ff9bfcb76836598c$export$d188a835a7bc5783 = (0, $acw62.createContext)({});
const $ff9bfcb76836598c$export$f55761759794cf55 = (0, $acw62.createContext)(null);
const $ff9bfcb76836598c$export$62ed72bc21f6b8a6 = (0, $acw62.forwardRef)(function DropIndicator(props, ref) {
    let { render: render } = (0, $acw62.useContext)($ff9bfcb76836598c$export$f55761759794cf55);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, render(props, ref));
});
function $ff9bfcb76836598c$export$971707d8a129a1f7(dragAndDropHooks, dropState) {
    var _dragAndDropHooks_isVirtualDragging;
    let renderDropIndicator = dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.renderDropIndicator;
    let isVirtualDragging = dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : (_dragAndDropHooks_isVirtualDragging = dragAndDropHooks.isVirtualDragging) === null || _dragAndDropHooks_isVirtualDragging === void 0 ? void 0 : _dragAndDropHooks_isVirtualDragging.call(dragAndDropHooks);
    let fn = (0, $acw62.useCallback)((target)=>{
        // Only show drop indicators when virtual dragging or this is the current drop target.
        if (isVirtualDragging || (dropState === null || dropState === void 0 ? void 0 : dropState.isDropTarget(target))) return renderDropIndicator ? renderDropIndicator(target) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ff9bfcb76836598c$export$62ed72bc21f6b8a6, {
            target: target
        });
    // We invalidate whenever the target changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dropState === null || dropState === void 0 ? void 0 : dropState.target,
        isVirtualDragging,
        renderDropIndicator
    ]);
    return (dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDropIndicator) ? fn : undefined;
}
function $ff9bfcb76836598c$export$d1e8e3fbb7461f6(selectionManager, dragAndDropHooks, dropState) {
    var _dragAndDropHooks_isVirtualDragging, _dropState_target;
    // Persist the focused key and the drop target key.
    let focusedKey = selectionManager.focusedKey;
    let dropTargetKey = null;
    if ((dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : (_dragAndDropHooks_isVirtualDragging = dragAndDropHooks.isVirtualDragging) === null || _dragAndDropHooks_isVirtualDragging === void 0 ? void 0 : _dragAndDropHooks_isVirtualDragging.call(dragAndDropHooks)) && (dropState === null || dropState === void 0 ? void 0 : (_dropState_target = dropState.target) === null || _dropState_target === void 0 ? void 0 : _dropState_target.type) === 'item') {
        dropTargetKey = dropState.target.key;
        if (dropState.target.dropPosition === 'after') {
            // Normalize to the "before" drop position since we only render those to the DOM.
            let nextKey = dropState.collection.getKeyAfter(dropTargetKey);
            let lastDescendantKey = null;
            if (nextKey != null) {
                var _dropState_collection_getItem;
                var _dropState_collection_getItem_level;
                let targetLevel = (_dropState_collection_getItem_level = (_dropState_collection_getItem = dropState.collection.getItem(dropTargetKey)) === null || _dropState_collection_getItem === void 0 ? void 0 : _dropState_collection_getItem.level) !== null && _dropState_collection_getItem_level !== void 0 ? _dropState_collection_getItem_level : 0;
                // Skip over any rows that are descendants of the target ("after" position should be after all children)
                while(nextKey){
                    let node = dropState.collection.getItem(nextKey);
                    // eslint-disable-next-line max-depth
                    if (!node) break;
                    // Skip over non-item nodes (e.g., loaders) since they can't be drop targets.
                    // eslint-disable-next-line max-depth
                    if (node.type !== 'item') {
                        nextKey = dropState.collection.getKeyAfter(nextKey);
                        continue;
                    }
                    var _node_level;
                    // Stop once we find an item at the same level or higher
                    // eslint-disable-next-line max-depth
                    if (((_node_level = node.level) !== null && _node_level !== void 0 ? _node_level : 0) <= targetLevel) break;
                    lastDescendantKey = nextKey;
                    nextKey = dropState.collection.getKeyAfter(nextKey);
                }
            }
            var _ref;
            // If nextKey is null (end of collection), use the last descendant
            dropTargetKey = (_ref = nextKey !== null && nextKey !== void 0 ? nextKey : lastDescendantKey) !== null && _ref !== void 0 ? _ref : dropTargetKey;
        }
    }
    return (0, $acw62.useMemo)(()=>{
        return new Set([
            focusedKey,
            dropTargetKey
        ].filter((k)=>k != null));
    }, [
        focusedKey,
        dropTargetKey
    ]);
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c879a8de1219885d$export$e0e4026c12a8bdbb = (0, $acw62.createContext)({});
const $c879a8de1219885d$export$8b251419efc915eb = (0, $5fe83fb7b4e6e89f$export$18af5c7a9e9b3664)((0, $168b0e08d3f28116$export$5ae2504e948afce5), function Header(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $c879a8de1219885d$export$e0e4026c12a8bdbb);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        className: "react-aria-Header",
        ...props,
        ref: ref
    }, props.children);
});






/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $db70544c5e5aa3ee$export$52210f68a14655d0(props) {
    let domProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let ariaOrientation;
    // if orientation is horizontal, aria-orientation default is horizontal, so we leave it undefined
    // if it's vertical, we need to specify it
    if (props.orientation === 'vertical') ariaOrientation = 'vertical';
    // hr elements implicitly have role = separator and a horizontal orientation
    if (props.elementType !== 'hr') return {
        separatorProps: {
            ...domProps,
            role: 'separator',
            'aria-orientation': ariaOrientation
        }
    };
    return {
        separatorProps: domProps
    };
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c59ca94960be2e1f$export$6615d83f6de245ce = (0, $acw62.createContext)({});
class $c59ca94960be2e1f$export$7750289ca694c0b5 extends (0, $168b0e08d3f28116$export$d68d59712b04d9d1) {
    filter(collection, newCollection) {
        let prevItem = newCollection.getItem(this.prevKey);
        if (prevItem && prevItem.type !== 'separator') {
            let clone = this.clone();
            newCollection.addDescendants(clone, collection);
            return clone;
        }
        return null;
    }
}
$c59ca94960be2e1f$export$7750289ca694c0b5.type = 'separator';
const $c59ca94960be2e1f$export$1ff3c3f08ae963c0 = (0, $5fe83fb7b4e6e89f$export$18af5c7a9e9b3664)($c59ca94960be2e1f$export$7750289ca694c0b5, function Separator(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $c59ca94960be2e1f$export$6615d83f6de245ce);
    let { elementType: elementType, orientation: orientation, style: style, className: className, slot: slot, ...otherProps } = props;
    let Element = elementType || 'hr';
    if (Element === 'hr' && orientation === 'vertical') Element = 'div';
    let { separatorProps: separatorProps } = (0, $db70544c5e5aa3ee$export$52210f68a14655d0)({
        ...otherProps,
        elementType: elementType,
        orientation: orientation
    });
    let DOMProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Element, {
        ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)(DOMProps, separatorProps),
        style: style,
        className: className !== null && className !== void 0 ? className : 'react-aria-Separator',
        ref: ref,
        slot: slot || undefined
    });
});





/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5a602a729cf93351$export$d3e3bd3e26688c04(e) {
    // Ctrl + Arrow Up/Arrow Down has a system wide meaning on macOS, so use Alt instead.
    // On Windows and Ubuntu, Alt + Space has a system wide meaning.
    return (0, $c0699bc5a0b3191f$export$e1865c3bedcd822b)() ? e.altKey : e.ctrlKey;
}
function $5a602a729cf93351$export$c3d8340acf92597f(collectionRef, key) {
    var _collectionRef_current, _collectionRef_current1;
    let selector = `[data-key="${CSS.escape(String(key))}"]`;
    let collection = (_collectionRef_current = collectionRef.current) === null || _collectionRef_current === void 0 ? void 0 : _collectionRef_current.dataset.collection;
    if (collection) selector = `[data-collection="${CSS.escape(collection)}"]${selector}`;
    return (_collectionRef_current1 = collectionRef.current) === null || _collectionRef_current1 === void 0 ? void 0 : _collectionRef_current1.querySelector(selector);
}
const $5a602a729cf93351$var$$feb5ffebff200149$var$collectionMap = new WeakMap();
function $5a602a729cf93351$export$881eb0d9f3605d9d(collection) {
    let id = (0, $855de91ebb07800c$export$f680877a34711e37)();
    $5a602a729cf93351$var$$feb5ffebff200149$var$collectionMap.set(collection, id);
    return id;
}
function $5a602a729cf93351$export$6aeb1680a0ae8741(collection) {
    return $5a602a729cf93351$var$$feb5ffebff200149$var$collectionMap.get(collection);
}


/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $f2ab001b6bc668d6$export$8f5ed9ff9f511381 {
    getItemRect(key) {
        let container = this.ref.current;
        if (!container) return null;
        let item = key != null ? (0, $5a602a729cf93351$export$c3d8340acf92597f)(this.ref, key) : null;
        if (!item) return null;
        let containerRect = container.getBoundingClientRect();
        let itemRect = item.getBoundingClientRect();
        return {
            x: itemRect.left - containerRect.left - container.clientLeft + container.scrollLeft,
            y: itemRect.top - containerRect.top - container.clientTop + container.scrollTop,
            width: itemRect.width,
            height: itemRect.height
        };
    }
    getContentSize() {
        let container = this.ref.current;
        var _container_scrollWidth, _container_scrollHeight;
        return {
            width: (_container_scrollWidth = container === null || container === void 0 ? void 0 : container.scrollWidth) !== null && _container_scrollWidth !== void 0 ? _container_scrollWidth : 0,
            height: (_container_scrollHeight = container === null || container === void 0 ? void 0 : container.scrollHeight) !== null && _container_scrollHeight !== void 0 ? _container_scrollHeight : 0
        };
    }
    getVisibleRect() {
        let container = this.ref.current;
        var _container_scrollLeft, _container_scrollTop, _container_clientWidth, _container_clientHeight;
        return {
            x: (_container_scrollLeft = container === null || container === void 0 ? void 0 : container.scrollLeft) !== null && _container_scrollLeft !== void 0 ? _container_scrollLeft : 0,
            y: (_container_scrollTop = container === null || container === void 0 ? void 0 : container.scrollTop) !== null && _container_scrollTop !== void 0 ? _container_scrollTop : 0,
            width: (_container_clientWidth = container === null || container === void 0 ? void 0 : container.clientWidth) !== null && _container_clientWidth !== void 0 ? _container_clientWidth : 0,
            height: (_container_clientHeight = container === null || container === void 0 ? void 0 : container.clientHeight) !== null && _container_clientHeight !== void 0 ? _container_clientHeight : 0
        };
    }
    constructor(ref){
        this.ref = ref;
    }
}


/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6468d10c4b206c14$export$2bb74740c4e19def(node, checkForOverflow) {
    if (!node) return false;
    let style = window.getComputedStyle(node);
    let isScrollable = /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
    if (isScrollable && checkForOverflow) isScrollable = node.scrollHeight !== node.clientHeight || node.scrollWidth !== node.clientWidth;
    return isScrollable;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $afe5b32ffd8dcd97$export$a05409b8bb224a5a {
    isDisabled(item) {
        var _item_props;
        return this.disabledBehavior === 'all' && (((_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.isDisabled) || this.disabledKeys.has(item.key));
    }
    findNextNonDisabled(key, getNext) {
        let nextKey = key;
        while(nextKey != null){
            let item = this.collection.getItem(nextKey);
            if ((item === null || item === void 0 ? void 0 : item.type) === 'item' && !this.isDisabled(item)) return nextKey;
            nextKey = getNext(nextKey);
        }
        return null;
    }
    getNextKey(key) {
        let nextKey = key;
        nextKey = this.collection.getKeyAfter(nextKey);
        return this.findNextNonDisabled(nextKey, (key)=>this.collection.getKeyAfter(key));
    }
    getPreviousKey(key) {
        let nextKey = key;
        nextKey = this.collection.getKeyBefore(nextKey);
        return this.findNextNonDisabled(nextKey, (key)=>this.collection.getKeyBefore(key));
    }
    findKey(key, nextKey, shouldSkip) {
        let tempKey = key;
        let itemRect = this.layoutDelegate.getItemRect(tempKey);
        if (!itemRect || tempKey == null) return null;
        // Find the item above or below in the same column.
        let prevRect = itemRect;
        do {
            tempKey = nextKey(tempKey);
            if (tempKey == null) break;
            itemRect = this.layoutDelegate.getItemRect(tempKey);
        }while (itemRect && shouldSkip(prevRect, itemRect) && tempKey != null);
        return tempKey;
    }
    isSameRow(prevRect, itemRect) {
        return prevRect.y === itemRect.y || prevRect.x !== itemRect.x;
    }
    isSameColumn(prevRect, itemRect) {
        return prevRect.x === itemRect.x || prevRect.y !== itemRect.y;
    }
    getKeyBelow(key) {
        if (this.layout === 'grid' && this.orientation === 'vertical') return this.findKey(key, (key)=>this.getNextKey(key), this.isSameRow);
        else return this.getNextKey(key);
    }
    getKeyAbove(key) {
        if (this.layout === 'grid' && this.orientation === 'vertical') return this.findKey(key, (key)=>this.getPreviousKey(key), this.isSameRow);
        else return this.getPreviousKey(key);
    }
    getNextColumn(key, right) {
        return right ? this.getPreviousKey(key) : this.getNextKey(key);
    }
    getKeyRightOf(key) {
        // This is a temporary solution for CardView until we refactor useSelectableCollection.
        // https://github.com/orgs/adobe/projects/19/views/32?pane=issue&itemId=77825042
        let layoutDelegateMethod = this.direction === 'ltr' ? 'getKeyRightOf' : 'getKeyLeftOf';
        if (this.layoutDelegate[layoutDelegateMethod]) {
            key = this.layoutDelegate[layoutDelegateMethod](key);
            return this.findNextNonDisabled(key, (key)=>this.layoutDelegate[layoutDelegateMethod](key));
        }
        if (this.layout === 'grid') {
            if (this.orientation === 'vertical') return this.getNextColumn(key, this.direction === 'rtl');
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === 'rtl'), this.isSameColumn);
        } else if (this.orientation === 'horizontal') return this.getNextColumn(key, this.direction === 'rtl');
        return null;
    }
    getKeyLeftOf(key) {
        let layoutDelegateMethod = this.direction === 'ltr' ? 'getKeyLeftOf' : 'getKeyRightOf';
        if (this.layoutDelegate[layoutDelegateMethod]) {
            key = this.layoutDelegate[layoutDelegateMethod](key);
            return this.findNextNonDisabled(key, (key)=>this.layoutDelegate[layoutDelegateMethod](key));
        }
        if (this.layout === 'grid') {
            if (this.orientation === 'vertical') return this.getNextColumn(key, this.direction === 'ltr');
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === 'ltr'), this.isSameColumn);
        } else if (this.orientation === 'horizontal') return this.getNextColumn(key, this.direction === 'ltr');
        return null;
    }
    getFirstKey() {
        let key = this.collection.getFirstKey();
        return this.findNextNonDisabled(key, (key)=>this.collection.getKeyAfter(key));
    }
    getLastKey() {
        let key = this.collection.getLastKey();
        return this.findNextNonDisabled(key, (key)=>this.collection.getKeyBefore(key));
    }
    getKeyPageAbove(key) {
        let menu = this.ref.current;
        let itemRect = this.layoutDelegate.getItemRect(key);
        if (!itemRect) return null;
        if (menu && !(0, $6468d10c4b206c14$export$2bb74740c4e19def)(menu)) return this.getFirstKey();
        let nextKey = key;
        if (this.orientation === 'horizontal') {
            let pageX = Math.max(0, itemRect.x + itemRect.width - this.layoutDelegate.getVisibleRect().width);
            while(itemRect && itemRect.x > pageX && nextKey != null){
                nextKey = this.getKeyAbove(nextKey);
                itemRect = nextKey == null ? null : this.layoutDelegate.getItemRect(nextKey);
            }
        } else {
            let pageY = Math.max(0, itemRect.y + itemRect.height - this.layoutDelegate.getVisibleRect().height);
            while(itemRect && itemRect.y > pageY && nextKey != null){
                nextKey = this.getKeyAbove(nextKey);
                itemRect = nextKey == null ? null : this.layoutDelegate.getItemRect(nextKey);
            }
        }
        return nextKey !== null && nextKey !== void 0 ? nextKey : this.getFirstKey();
    }
    getKeyPageBelow(key) {
        let menu = this.ref.current;
        let itemRect = this.layoutDelegate.getItemRect(key);
        if (!itemRect) return null;
        if (menu && !(0, $6468d10c4b206c14$export$2bb74740c4e19def)(menu)) return this.getLastKey();
        let nextKey = key;
        if (this.orientation === 'horizontal') {
            let pageX = Math.min(this.layoutDelegate.getContentSize().width, itemRect.y - itemRect.width + this.layoutDelegate.getVisibleRect().width);
            while(itemRect && itemRect.x < pageX && nextKey != null){
                nextKey = this.getKeyBelow(nextKey);
                itemRect = nextKey == null ? null : this.layoutDelegate.getItemRect(nextKey);
            }
        } else {
            let pageY = Math.min(this.layoutDelegate.getContentSize().height, itemRect.y - itemRect.height + this.layoutDelegate.getVisibleRect().height);
            while(itemRect && itemRect.y < pageY && nextKey != null){
                nextKey = this.getKeyBelow(nextKey);
                itemRect = nextKey == null ? null : this.layoutDelegate.getItemRect(nextKey);
            }
        }
        return nextKey !== null && nextKey !== void 0 ? nextKey : this.getLastKey();
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey || this.getFirstKey();
        while(key != null){
            let item = collection.getItem(key);
            if (!item) return null;
            let substring = item.textValue.slice(0, search.length);
            if (item.textValue && this.collator.compare(substring, search) === 0) return key;
            key = this.getNextKey(key);
        }
        return null;
    }
    constructor(...args){
        if (args.length === 1) {
            let opts = args[0];
            this.collection = opts.collection;
            this.ref = opts.ref;
            this.collator = opts.collator;
            this.disabledKeys = opts.disabledKeys || new Set();
            this.disabledBehavior = opts.disabledBehavior || 'all';
            this.orientation = opts.orientation || 'vertical';
            this.direction = opts.direction;
            this.layout = opts.layout || 'stack';
            this.layoutDelegate = opts.layoutDelegate || new (0, $f2ab001b6bc668d6$export$8f5ed9ff9f511381)(opts.ref);
        } else {
            this.collection = args[0];
            this.disabledKeys = args[1];
            this.ref = args[2];
            this.collator = args[3];
            this.layout = 'stack';
            this.orientation = 'vertical';
            this.disabledBehavior = 'all';
            this.layoutDelegate = new (0, $f2ab001b6bc668d6$export$8f5ed9ff9f511381)(this.ref);
        }
        // If this is a vertical stack, remove the left/right methods completely
        // so they aren't called by useDroppableCollection.
        if (this.layout === 'stack' && this.orientation === 'vertical') {
            this.getKeyLeftOf = undefined;
            this.getKeyRightOf = undefined;
        }
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $b66e5976a4251b0c$var$$325a3faab7a68acd$var$cache = new Map();
function $b66e5976a4251b0c$export$a16aca283550c30d(options) {
    let { locale: locale } = (0, $a7e3b1109bf64033$export$43bb16f9c6d9e3f7)();
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : '');
    if ($b66e5976a4251b0c$var$$325a3faab7a68acd$var$cache.has(cacheKey)) return $b66e5976a4251b0c$var$$325a3faab7a68acd$var$cache.get(cacheKey);
    let formatter = new Intl.Collator(locale, options);
    $b66e5976a4251b0c$var$$325a3faab7a68acd$var$cache.set(cacheKey, formatter);
    return formatter;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $a5549fa17747a039$export$3585ede4d035bf14 = new WeakMap();
function $a5549fa17747a039$var$$b1f0cad8af73213b$var$normalizeKey(key) {
    if (typeof key === 'string') return key.replace(/\s*/g, '');
    return '' + key;
}
function $a5549fa17747a039$export$9145995848b05025(state, itemKey) {
    let data = $a5549fa17747a039$export$3585ede4d035bf14.get(state);
    if (!data) throw new Error('Unknown list');
    return `${data.id}-option-${$a5549fa17747a039$var$$b1f0cad8af73213b$var$normalizeKey(itemKey)}`;
}







var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Controls how long to wait before clearing the typeahead buffer.
 */ const $03cc76e981c32a49$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS = 1000; // 1 second
function $03cc76e981c32a49$export$e32c88dfddc6e1d8(options) {
    let { keyboardDelegate: keyboardDelegate, selectionManager: selectionManager, onTypeSelect: onTypeSelect } = options;
    let state = (0, $acw62.useRef)({
        search: '',
        timeout: undefined
    }).current;
    let onKeyDown = (e)=>{
        let character = $03cc76e981c32a49$var$$fb3050f43d946246$var$getStringForKey(e.key);
        if (!character || e.ctrlKey || e.metaKey || !e.currentTarget.contains(e.target) || state.search.length === 0 && character === ' ') return;
        // Do not propagate the Spacebar event if it's meant to be part of the search.
        // When we time out, the search term becomes empty, hence the check on length.
        // Trimming is to account for the case of pressing the Spacebar more than once,
        // which should cycle through the selection/deselection of the focused item.
        if (character === ' ' && state.search.trim().length > 0) {
            e.preventDefault();
            if (!('continuePropagation' in e)) e.stopPropagation();
        }
        state.search += character;
        if (keyboardDelegate.getKeyForSearch != null) {
            // Use the delegate to find a key to focus.
            // Prioritize items after the currently focused item, falling back to searching the whole list.
            let key = keyboardDelegate.getKeyForSearch(state.search, selectionManager.focusedKey);
            // If no key found, search from the top.
            if (key == null) key = keyboardDelegate.getKeyForSearch(state.search);
            if (key != null) {
                selectionManager.setFocusedKey(key);
                if (onTypeSelect) onTypeSelect(key);
            }
        }
        clearTimeout(state.timeout);
        state.timeout = setTimeout(()=>{
            state.search = '';
        }, $03cc76e981c32a49$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS);
    };
    return {
        typeSelectProps: {
            // Using a capturing listener to catch the keydown event before
            // other hooks in order to handle the Spacebar event.
            onKeyDownCapture: keyboardDelegate.getKeyForSearch ? onKeyDown : undefined
        }
    };
}
function $03cc76e981c32a49$var$$fb3050f43d946246$var$getStringForKey(key) {
    // If the key is of length 1, it is an ASCII value.
    // Otherwise, if there are no ASCII characters in the key name,
    // it is a Unicode character.
    // See https://www.w3.org/TR/uievents-key/
    if (key.length === 1 || !/^[A-Z]/i.test(key)) return key;
    return '';
}


/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Custom event names for updating the autocomplete's aria-activedecendant.
const $ea864a57d520f50b$export$447a38995de2c711 = 'react-aria-clear-focus';
const $ea864a57d520f50b$export$831c820ad60f9d12 = 'react-aria-focus';


/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8a16f7e89990868c$export$16792effe837dba3(e) {
    if ((0, $c0699bc5a0b3191f$export$9ac100e40613ea10)()) return e.metaKey;
    return e.ctrlKey;
}
// HTML input types that do not cause the software keyboard to appear.
const $8a16f7e89990868c$var$$21f1aa98acb08317$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
function $8a16f7e89990868c$export$c57958e35f31ed73(target) {
    return target instanceof HTMLInputElement && !$8a16f7e89990868c$var$$21f1aa98acb08317$var$nonTextInputTypes.has(target.type) || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
}


/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9c382eb2e4b7869f$export$94ed1c92c7beeb22(node, checkForOverflow) {
    const scrollParents = [];
    while(node && node !== document.documentElement){
        if ((0, $6468d10c4b206c14$export$2bb74740c4e19def)(node, checkForOverflow)) scrollParents.push(node);
        node = node.parentElement;
    }
    return scrollParents;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9508892f11ae5828$export$53a0910f038337bd(scrollView, element) {
    let offsetX = $9508892f11ae5828$var$$2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, 'left');
    let offsetY = $9508892f11ae5828$var$$2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, 'top');
    let width = element.offsetWidth;
    let height = element.offsetHeight;
    let x = scrollView.scrollLeft;
    let y = scrollView.scrollTop;
    // Account for top/left border offsetting the scroll top/Left + scroll padding
    let { borderTopWidth: borderTopWidth, borderLeftWidth: borderLeftWidth, scrollPaddingTop: scrollPaddingTop, scrollPaddingRight: scrollPaddingRight, scrollPaddingBottom: scrollPaddingBottom, scrollPaddingLeft: scrollPaddingLeft } = getComputedStyle(scrollView);
    let borderAdjustedX = x + parseInt(borderLeftWidth, 10);
    let borderAdjustedY = y + parseInt(borderTopWidth, 10);
    // Ignore end/bottom border via clientHeight/Width instead of offsetHeight/Width
    let maxX = borderAdjustedX + scrollView.clientWidth;
    let maxY = borderAdjustedY + scrollView.clientHeight;
    // Get scroll padding values as pixels - defaults to 0 if no scroll padding
    // is used.
    let scrollPaddingTopNumber = parseInt(scrollPaddingTop, 10) || 0;
    let scrollPaddingBottomNumber = parseInt(scrollPaddingBottom, 10) || 0;
    let scrollPaddingRightNumber = parseInt(scrollPaddingRight, 10) || 0;
    let scrollPaddingLeftNumber = parseInt(scrollPaddingLeft, 10) || 0;
    if (offsetX <= x + scrollPaddingLeftNumber) x = offsetX - parseInt(borderLeftWidth, 10) - scrollPaddingLeftNumber;
    else if (offsetX + width > maxX - scrollPaddingRightNumber) x += offsetX + width - maxX + scrollPaddingRightNumber;
    if (offsetY <= borderAdjustedY + scrollPaddingTopNumber) y = offsetY - parseInt(borderTopWidth, 10) - scrollPaddingTopNumber;
    else if (offsetY + height > maxY - scrollPaddingBottomNumber) y += offsetY + height - maxY + scrollPaddingBottomNumber;
    scrollView.scrollLeft = x;
    scrollView.scrollTop = y;
}
/**
 * Computes the offset left or top from child to ancestor by accumulating
 * offsetLeft or offsetTop through intervening offsetParents.
 */ function $9508892f11ae5828$var$$2f04cbc44ee30ce0$var$relativeOffset(ancestor, child, axis) {
    const prop = axis === 'left' ? 'offsetLeft' : 'offsetTop';
    let sum = 0;
    while(child.offsetParent){
        sum += child[prop];
        if (child.offsetParent === ancestor) break;
        else if (child.offsetParent.contains(ancestor)) {
            // If the ancestor is not `position:relative`, then we stop at
            // _its_ offset parent, and we subtract off _its_ offset, so that
            // we end up with the proper offset from child to ancestor.
            sum -= ancestor[prop];
            break;
        }
        child = child.offsetParent;
    }
    return sum;
}
function $9508892f11ae5828$export$c826860796309d1b(targetElement, opts) {
    if (targetElement && document.contains(targetElement)) {
        let root = document.scrollingElement || document.documentElement;
        let isScrollPrevented = window.getComputedStyle(root).overflow === 'hidden';
        // If scrolling is not currently prevented then we aren’t in a overlay nor is a overlay open, just use element.scrollIntoView to bring the element into view
        if (!isScrollPrevented) {
            var // won't cause a scroll if the element is already focused and doesn't behave consistently when an element is partially out of view horizontally vs vertically
            _targetElement_scrollIntoView;
            let { left: originalLeft, top: originalTop } = targetElement.getBoundingClientRect();
            targetElement === null || targetElement === void 0 || (_targetElement_scrollIntoView = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView === void 0 || _targetElement_scrollIntoView.call(targetElement, {
                block: 'nearest'
            });
            let { left: newLeft, top: newTop } = targetElement.getBoundingClientRect();
            // Account for sub pixel differences from rounding
            if (Math.abs(originalLeft - newLeft) > 1 || Math.abs(originalTop - newTop) > 1) {
                var _opts_containingElement_scrollIntoView, _opts_containingElement, _targetElement_scrollIntoView1;
                opts === null || opts === void 0 || (_opts_containingElement = opts.containingElement) === null || _opts_containingElement === void 0 || (_opts_containingElement_scrollIntoView = _opts_containingElement.scrollIntoView) === null || _opts_containingElement_scrollIntoView === void 0 || _opts_containingElement_scrollIntoView.call(_opts_containingElement, {
                    block: 'center',
                    inline: 'center'
                });
                (_targetElement_scrollIntoView1 = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView1 === void 0 || _targetElement_scrollIntoView1.call(targetElement, {
                    block: 'nearest'
                });
            }
        } else {
            let scrollParents = (0, $9c382eb2e4b7869f$export$94ed1c92c7beeb22)(targetElement);
            // If scrolling is prevented, we don't want to scroll the body since it might move the overlay partially offscreen and the user can't scroll it back into view.
            if (!isScrollPrevented) scrollParents.push(root);
            for (let scrollParent of scrollParents)$9508892f11ae5828$export$53a0910f038337bd(scrollParent, targetElement);
        }
    }
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b95c9737ad40d7c7$export$90fc3a17d93f704c(ref, event, handler, options) {
    let handleEvent = (0, $92fff981738f62fe$export$7f54fc3180508a52)(handler);
    let isDisabled = handler == null;
    (0, $acw62.useEffect)(()=>{
        if (isDisabled || !ref.current) return;
        let element = ref.current;
        element.addEventListener(event, handleEvent, options);
        return ()=>{
            element.removeEventListener(event, handleEvent, options);
        };
    }, [
        ref,
        event,
        options,
        isDisabled
    ]);
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b39a28f8939ed970$export$72ef708ab07251f1(effect, dependencies) {
    const isInitialMount = (0, $acw62.useRef)(true);
    const lastDeps = (0, $acw62.useRef)(null);
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        isInitialMount.current = true;
        return ()=>{
            isInitialMount.current = false;
        };
    }, []);
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        if (isInitialMount.current) isInitialMount.current = false;
        else if (!lastDeps.current || dependencies.some((dep, i)=>!Object.is(dep, lastDeps[i]))) effect();
        lastDeps.current = dependencies;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}



function $12dcf8f3b90d8ae0$export$76e4e37e5339496d(to) {
    let from = $12dcf8f3b90d8ae0$export$759df0d867455a91((0, $48852fd65b79e251$export$b204af158042fbac)(to));
    if (from !== to) {
        if (from) $12dcf8f3b90d8ae0$export$6c5dc7e81d2cc29a(from, to);
        if (to) $12dcf8f3b90d8ae0$export$2b35b76d2e30e129(to, from);
    }
}
function $12dcf8f3b90d8ae0$export$6c5dc7e81d2cc29a(from, to) {
    from.dispatchEvent(new FocusEvent('blur', {
        relatedTarget: to
    }));
    from.dispatchEvent(new FocusEvent('focusout', {
        bubbles: true,
        relatedTarget: to
    }));
}
function $12dcf8f3b90d8ae0$export$2b35b76d2e30e129(to, from) {
    to.dispatchEvent(new FocusEvent('focus', {
        relatedTarget: from
    }));
    to.dispatchEvent(new FocusEvent('focusin', {
        bubbles: true,
        relatedTarget: from
    }));
}
function $12dcf8f3b90d8ae0$export$759df0d867455a91(document) {
    let activeElement = (0, $bc46b52522f8f24d$export$cd4e5573fbe2b576)(document);
    let activeDescendant = activeElement === null || activeElement === void 0 ? void 0 : activeElement.getAttribute('aria-activedescendant');
    if (activeDescendant) return document.getElementById(activeDescendant) || activeElement;
    return activeElement;
}




var $acw62 = parcelRequire("acw62");


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5d42d73b717d1d8d$export$d6daf82dcd84e87c(options) {
    let { selectionManager: manager, keyboardDelegate: delegate, ref: ref, autoFocus: autoFocus = false, shouldFocusWrap: shouldFocusWrap = false, disallowEmptySelection: disallowEmptySelection = false, disallowSelectAll: disallowSelectAll = false, escapeKeyBehavior: escapeKeyBehavior = 'clearSelection', selectOnFocus: selectOnFocus = manager.selectionBehavior === 'replace', disallowTypeAhead: disallowTypeAhead = false, shouldUseVirtualFocus: shouldUseVirtualFocus, allowsTabNavigation: allowsTabNavigation = false, isVirtualized: isVirtualized, scrollRef: scrollRef = ref, linkBehavior: linkBehavior = 'action' } = options;
    let { direction: direction } = (0, $a7e3b1109bf64033$export$43bb16f9c6d9e3f7)();
    let router = (0, $c9b835cc9e261550$export$9a302a45f65d0572)();
    let onKeyDown = (e)=>{
        var _ref_current;
        // Prevent option + tab from doing anything since it doesn't move focus to the cells, only buttons/checkboxes
        if (e.altKey && e.key === 'Tab') e.preventDefault();
        // Keyboard events bubble through portals. Don't handle keyboard events
        // for elements outside the collection (e.g. menus).
        if (!((_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.contains(e.target))) return;
        const navigateToKey = (key, childFocus)=>{
            if (key != null) {
                if (manager.isLink(key) && linkBehavior === 'selection' && selectOnFocus && !(0, $5a602a729cf93351$export$d3e3bd3e26688c04)(e)) {
                    (0, $11492dca620dcaa5$exports.flushSync)(()=>{
                        manager.setFocusedKey(key, childFocus);
                    });
                    let item = (0, $5a602a729cf93351$export$c3d8340acf92597f)(ref, key);
                    let itemProps = manager.getItemProps(key);
                    if (item) router.open(item, e, itemProps.href, itemProps.routerOptions);
                    return;
                }
                manager.setFocusedKey(key, childFocus);
                if (manager.isLink(key) && linkBehavior === 'override') return;
                if (e.shiftKey && manager.selectionMode === 'multiple') manager.extendSelection(key);
                else if (selectOnFocus && !(0, $5a602a729cf93351$export$d3e3bd3e26688c04)(e)) manager.replaceSelection(key);
            }
        };
        switch(e.key){
            case 'ArrowDown':
                if (delegate.getKeyBelow) {
                    var _delegate_getKeyBelow, _delegate_getFirstKey, _delegate_getFirstKey1;
                    let nextKey = manager.focusedKey != null ? (_delegate_getKeyBelow = delegate.getKeyBelow) === null || _delegate_getKeyBelow === void 0 ? void 0 : _delegate_getKeyBelow.call(delegate, manager.focusedKey) : (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getFirstKey1 = delegate.getFirstKey) === null || _delegate_getFirstKey1 === void 0 ? void 0 : _delegate_getFirstKey1.call(delegate, manager.focusedKey);
                    if (nextKey != null) {
                        e.preventDefault();
                        navigateToKey(nextKey);
                    }
                }
                break;
            case 'ArrowUp':
                if (delegate.getKeyAbove) {
                    var _delegate_getKeyAbove, _delegate_getLastKey, _delegate_getLastKey1;
                    let nextKey = manager.focusedKey != null ? (_delegate_getKeyAbove = delegate.getKeyAbove) === null || _delegate_getKeyAbove === void 0 ? void 0 : _delegate_getKeyAbove.call(delegate, manager.focusedKey) : (_delegate_getLastKey = delegate.getLastKey) === null || _delegate_getLastKey === void 0 ? void 0 : _delegate_getLastKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getLastKey1 = delegate.getLastKey) === null || _delegate_getLastKey1 === void 0 ? void 0 : _delegate_getLastKey1.call(delegate, manager.focusedKey);
                    if (nextKey != null) {
                        e.preventDefault();
                        navigateToKey(nextKey);
                    }
                }
                break;
            case 'ArrowLeft':
                if (delegate.getKeyLeftOf) {
                    var _delegate_getKeyLeftOf, _delegate_getFirstKey2, _delegate_getLastKey2;
                    let nextKey = manager.focusedKey != null ? (_delegate_getKeyLeftOf = delegate.getKeyLeftOf) === null || _delegate_getKeyLeftOf === void 0 ? void 0 : _delegate_getKeyLeftOf.call(delegate, manager.focusedKey) : null;
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === 'rtl' ? (_delegate_getFirstKey2 = delegate.getFirstKey) === null || _delegate_getFirstKey2 === void 0 ? void 0 : _delegate_getFirstKey2.call(delegate, manager.focusedKey) : (_delegate_getLastKey2 = delegate.getLastKey) === null || _delegate_getLastKey2 === void 0 ? void 0 : _delegate_getLastKey2.call(delegate, manager.focusedKey);
                    if (nextKey != null) {
                        e.preventDefault();
                        navigateToKey(nextKey, direction === 'rtl' ? 'first' : 'last');
                    }
                }
                break;
            case 'ArrowRight':
                if (delegate.getKeyRightOf) {
                    var _delegate_getKeyRightOf, _delegate_getLastKey3, _delegate_getFirstKey3;
                    let nextKey = manager.focusedKey != null ? (_delegate_getKeyRightOf = delegate.getKeyRightOf) === null || _delegate_getKeyRightOf === void 0 ? void 0 : _delegate_getKeyRightOf.call(delegate, manager.focusedKey) : null;
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === 'rtl' ? (_delegate_getLastKey3 = delegate.getLastKey) === null || _delegate_getLastKey3 === void 0 ? void 0 : _delegate_getLastKey3.call(delegate, manager.focusedKey) : (_delegate_getFirstKey3 = delegate.getFirstKey) === null || _delegate_getFirstKey3 === void 0 ? void 0 : _delegate_getFirstKey3.call(delegate, manager.focusedKey);
                    if (nextKey != null) {
                        e.preventDefault();
                        navigateToKey(nextKey, direction === 'rtl' ? 'last' : 'first');
                    }
                }
                break;
            case 'Home':
                if (delegate.getFirstKey) {
                    if (manager.focusedKey === null && e.shiftKey) return;
                    e.preventDefault();
                    let firstKey = delegate.getFirstKey(manager.focusedKey, (0, $8a16f7e89990868c$export$16792effe837dba3)(e));
                    manager.setFocusedKey(firstKey);
                    if (firstKey != null) {
                        if ((0, $8a16f7e89990868c$export$16792effe837dba3)(e) && e.shiftKey && manager.selectionMode === 'multiple') manager.extendSelection(firstKey);
                        else if (selectOnFocus) manager.replaceSelection(firstKey);
                    }
                }
                break;
            case 'End':
                if (delegate.getLastKey) {
                    if (manager.focusedKey === null && e.shiftKey) return;
                    e.preventDefault();
                    let lastKey = delegate.getLastKey(manager.focusedKey, (0, $8a16f7e89990868c$export$16792effe837dba3)(e));
                    manager.setFocusedKey(lastKey);
                    if (lastKey != null) {
                        if ((0, $8a16f7e89990868c$export$16792effe837dba3)(e) && e.shiftKey && manager.selectionMode === 'multiple') manager.extendSelection(lastKey);
                        else if (selectOnFocus) manager.replaceSelection(lastKey);
                    }
                }
                break;
            case 'PageDown':
                if (delegate.getKeyPageBelow && manager.focusedKey != null) {
                    let nextKey = delegate.getKeyPageBelow(manager.focusedKey);
                    if (nextKey != null) {
                        e.preventDefault();
                        navigateToKey(nextKey);
                    }
                }
                break;
            case 'PageUp':
                if (delegate.getKeyPageAbove && manager.focusedKey != null) {
                    let nextKey = delegate.getKeyPageAbove(manager.focusedKey);
                    if (nextKey != null) {
                        e.preventDefault();
                        navigateToKey(nextKey);
                    }
                }
                break;
            case 'a':
                if ((0, $8a16f7e89990868c$export$16792effe837dba3)(e) && manager.selectionMode === 'multiple' && disallowSelectAll !== true) {
                    e.preventDefault();
                    manager.selectAll();
                }
                break;
            case 'Escape':
                if (escapeKeyBehavior === 'clearSelection' && !disallowEmptySelection && manager.selectedKeys.size !== 0) {
                    e.stopPropagation();
                    e.preventDefault();
                    manager.clearSelection();
                }
                break;
            case 'Tab':
                if (!allowsTabNavigation) {
                    // There may be elements that are "tabbable" inside a collection (e.g. in a grid cell).
                    // However, collections should be treated as a single tab stop, with arrow key navigation internally.
                    // We don't control the rendering of these, so we can't override the tabIndex to prevent tabbing.
                    // Instead, we handle the Tab key, and move focus manually to the first/last tabbable element
                    // in the collection, so that the browser default behavior will apply starting from that element
                    // rather than the currently focused one.
                    if (e.shiftKey) ref.current.focus();
                    else {
                        let walker = (0, $dd1b249b49caa281$export$2d6ec8fc375ceafa)(ref.current, {
                            tabbable: true
                        });
                        let next = undefined;
                        let last;
                        do {
                            last = walker.lastChild();
                            if (last) next = last;
                        }while (last);
                        // If the active element is NOT tabbable but is contained by an element that IS tabbable (aka the cell), the browser will actually move focus to
                        // the containing element. We need to special case this so that tab will move focus out of the grid instead of looping between
                        // focusing the containing cell and back to the non-tabbable child element
                        if (next && (!next.contains(document.activeElement) || document.activeElement && !(0, $5c8550b2a03c9d44$export$bebd5a1431fec25d)(document.activeElement))) (0, $4623aa9f87f28cd4$export$de79e2c695e052f3)(next);
                    }
                    break;
                }
        }
    };
    // Store the scroll position so we can restore it later.
    /// TODO: should this happen all the time??
    let scrollPos = (0, $acw62.useRef)({
        top: 0,
        left: 0
    });
    (0, $b95c9737ad40d7c7$export$90fc3a17d93f704c)(scrollRef, 'scroll', isVirtualized ? undefined : ()=>{
        var _scrollRef_current, _scrollRef_current1;
        var _scrollRef_current_scrollTop, _scrollRef_current_scrollLeft;
        scrollPos.current = {
            top: (_scrollRef_current_scrollTop = (_scrollRef_current = scrollRef.current) === null || _scrollRef_current === void 0 ? void 0 : _scrollRef_current.scrollTop) !== null && _scrollRef_current_scrollTop !== void 0 ? _scrollRef_current_scrollTop : 0,
            left: (_scrollRef_current_scrollLeft = (_scrollRef_current1 = scrollRef.current) === null || _scrollRef_current1 === void 0 ? void 0 : _scrollRef_current1.scrollLeft) !== null && _scrollRef_current_scrollLeft !== void 0 ? _scrollRef_current_scrollLeft : 0
        };
    });
    let onFocus = (e)=>{
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!e.currentTarget.contains(e.target)) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!e.currentTarget.contains(e.target)) return;
        manager.setFocused(true);
        if (manager.focusedKey == null) {
            var _delegate_getLastKey, _delegate_getFirstKey;
            let navigateToKey = (key)=>{
                if (key != null) {
                    manager.setFocusedKey(key);
                    if (selectOnFocus && !manager.isSelected(key)) manager.replaceSelection(key);
                }
            };
            // If the user hasn't yet interacted with the collection, there will be no focusedKey set.
            // Attempt to detect whether the user is tabbing forward or backward into the collection
            // and either focus the first or last item accordingly.
            let relatedTarget = e.relatedTarget;
            var _manager_lastSelectedKey, _manager_firstSelectedKey;
            if (relatedTarget && e.currentTarget.compareDocumentPosition(relatedTarget) & Node.DOCUMENT_POSITION_FOLLOWING) navigateToKey((_manager_lastSelectedKey = manager.lastSelectedKey) !== null && _manager_lastSelectedKey !== void 0 ? _manager_lastSelectedKey : (_delegate_getLastKey = delegate.getLastKey) === null || _delegate_getLastKey === void 0 ? void 0 : _delegate_getLastKey.call(delegate));
            else navigateToKey((_manager_firstSelectedKey = manager.firstSelectedKey) !== null && _manager_firstSelectedKey !== void 0 ? _manager_firstSelectedKey : (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate));
        } else if (!isVirtualized && scrollRef.current) {
            // Restore the scroll position to what it was before.
            scrollRef.current.scrollTop = scrollPos.current.top;
            scrollRef.current.scrollLeft = scrollPos.current.left;
        }
        if (manager.focusedKey != null && scrollRef.current) {
            // Refocus and scroll the focused item into view if it exists within the scrollable region.
            let element = (0, $5a602a729cf93351$export$c3d8340acf92597f)(ref, manager.focusedKey);
            if (element instanceof HTMLElement) {
                // This prevents a flash of focus on the first/last element in the collection, or the collection itself.
                if (!element.contains(document.activeElement) && !shouldUseVirtualFocus) (0, $4623aa9f87f28cd4$export$de79e2c695e052f3)(element);
                let modality = (0, $77c8ff0a3cb27e18$export$630ff653c5ada6a9)();
                if (modality === 'keyboard') (0, $9508892f11ae5828$export$c826860796309d1b)(element, {
                    containingElement: ref.current
                });
            }
        }
    };
    let onBlur = (e)=>{
        // Don't set blurred and then focused again if moving focus within the collection.
        if (!e.currentTarget.contains(e.relatedTarget)) manager.setFocused(false);
    };
    // Ref to track whether the first item in the collection should be automatically focused. Specifically used for autocomplete when user types
    // to focus the first key AFTER the collection updates.
    // TODO: potentially expand the usage of this
    let shouldVirtualFocusFirst = (0, $acw62.useRef)(false);
    (0, $b95c9737ad40d7c7$export$90fc3a17d93f704c)(ref, (0, $ea864a57d520f50b$export$831c820ad60f9d12), !shouldUseVirtualFocus ? undefined : (e)=>{
        let { detail: detail } = e;
        e.stopPropagation();
        manager.setFocused(true);
        // If the user is typing forwards, autofocus the first option in the list.
        if ((detail === null || detail === void 0 ? void 0 : detail.focusStrategy) === 'first') shouldVirtualFocusFirst.current = true;
    });
    (0, $b39a28f8939ed970$export$72ef708ab07251f1)(()=>{
        if (shouldVirtualFocusFirst.current) {
            var _delegate_getFirstKey;
            var _delegate_getFirstKey1;
            let keyToFocus = (_delegate_getFirstKey1 = (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate)) !== null && _delegate_getFirstKey1 !== void 0 ? _delegate_getFirstKey1 : null;
            // If no focusable items exist in the list, make sure to clear any activedescendant that may still exist and move focus back to
            // the original active element (e.g. the autocomplete input)
            if (keyToFocus == null) {
                let previousActiveElement = (0, $bc46b52522f8f24d$export$cd4e5573fbe2b576)();
                (0, $12dcf8f3b90d8ae0$export$76e4e37e5339496d)(ref.current);
                (0, $12dcf8f3b90d8ae0$export$2b35b76d2e30e129)(previousActiveElement, null);
                // If there wasn't a focusable key but the collection had items, then that means we aren't in an intermediate load state and all keys are disabled.
                // Reset shouldVirtualFocusFirst so that we don't erronously autofocus an item when the collection is filtered again.
                if (manager.collection.size > 0) shouldVirtualFocusFirst.current = false;
            } else {
                manager.setFocusedKey(keyToFocus);
                // Only set shouldVirtualFocusFirst to false if we've successfully set the first key as the focused key
                // If there wasn't a key to focus, we might be in a temporary loading state so we'll want to still focus the first key
                // after the collection updates after load
                shouldVirtualFocusFirst.current = false;
            }
        }
    }, [
        manager.collection
    ]);
    (0, $b39a28f8939ed970$export$72ef708ab07251f1)(()=>{
        // If user causes the focused key to change in any other way, clear shouldVirtualFocusFirst so we don't
        // accidentally move focus from under them. Skip this if the collection was empty because we might be in a load
        // state and will still want to focus the first item after load
        if (manager.collection.size > 0) shouldVirtualFocusFirst.current = false;
    }, [
        manager.focusedKey
    ]);
    (0, $b95c9737ad40d7c7$export$90fc3a17d93f704c)(ref, (0, $ea864a57d520f50b$export$447a38995de2c711), !shouldUseVirtualFocus ? undefined : (e)=>{
        var _e_detail;
        e.stopPropagation();
        manager.setFocused(false);
        if ((_e_detail = e.detail) === null || _e_detail === void 0 ? void 0 : _e_detail.clearFocusKey) manager.setFocusedKey(null);
    });
    const autoFocusRef = (0, $acw62.useRef)(autoFocus);
    const didAutoFocusRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (autoFocusRef.current) {
            var _delegate_getFirstKey, _delegate_getLastKey;
            let focusedKey = null;
            var _delegate_getFirstKey1;
            // Check focus strategy to determine which item to focus
            if (autoFocus === 'first') focusedKey = (_delegate_getFirstKey1 = (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate)) !== null && _delegate_getFirstKey1 !== void 0 ? _delegate_getFirstKey1 : null;
            var _delegate_getLastKey1;
            if (autoFocus === 'last') focusedKey = (_delegate_getLastKey1 = (_delegate_getLastKey = delegate.getLastKey) === null || _delegate_getLastKey === void 0 ? void 0 : _delegate_getLastKey.call(delegate)) !== null && _delegate_getLastKey1 !== void 0 ? _delegate_getLastKey1 : null;
            // If there are any selected keys, make the first one the new focus target
            let selectedKeys = manager.selectedKeys;
            if (selectedKeys.size) {
                for (let key of selectedKeys)if (manager.canSelectItem(key)) {
                    focusedKey = key;
                    break;
                }
            }
            manager.setFocused(true);
            manager.setFocusedKey(focusedKey);
            // If no default focus key is selected, focus the collection itself.
            if (focusedKey == null && !shouldUseVirtualFocus && ref.current) (0, $f84e6bd16978dcef$export$80f3e147d781571c)(ref.current);
            // Wait until the collection has items to autofocus.
            if (manager.collection.size > 0) {
                autoFocusRef.current = false;
                didAutoFocusRef.current = true;
            }
        }
    });
    // Scroll the focused element into view when the focusedKey changes.
    let lastFocusedKey = (0, $acw62.useRef)(manager.focusedKey);
    let raf = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (manager.isFocused && manager.focusedKey != null && (manager.focusedKey !== lastFocusedKey.current || didAutoFocusRef.current) && scrollRef.current && ref.current) {
            let modality = (0, $77c8ff0a3cb27e18$export$630ff653c5ada6a9)();
            let element = (0, $5a602a729cf93351$export$c3d8340acf92597f)(ref, manager.focusedKey);
            if (!(element instanceof HTMLElement)) // The collection may initially be empty (e.g. virtualizer), so wait until the element exists.
            return;
            if (modality === 'keyboard' || didAutoFocusRef.current) {
                if (raf.current) cancelAnimationFrame(raf.current);
                raf.current = requestAnimationFrame(()=>{
                    if (scrollRef.current) {
                        (0, $9508892f11ae5828$export$53a0910f038337bd)(scrollRef.current, element);
                        // Avoid scroll in iOS VO, since it may cause overlay to close (i.e. RAC submenu)
                        if (modality !== 'virtual') (0, $9508892f11ae5828$export$c826860796309d1b)(element, {
                            containingElement: ref.current
                        });
                    }
                });
            }
        }
        // If the focused key becomes null (e.g. the last item is deleted), focus the whole collection.
        if (!shouldUseVirtualFocus && manager.isFocused && manager.focusedKey == null && lastFocusedKey.current != null && ref.current) (0, $f84e6bd16978dcef$export$80f3e147d781571c)(ref.current);
        lastFocusedKey.current = manager.focusedKey;
        didAutoFocusRef.current = false;
    });
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, []);
    (0, $b95c9737ad40d7c7$export$90fc3a17d93f704c)(ref, 'react-aria-focus-scope-restore', (e)=>{
        e.preventDefault();
        manager.setFocused(true);
    });
    let handlers = {
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown (e) {
            // Ignore events that bubbled through portals.
            if (scrollRef.current === e.target) e.preventDefault();
        }
    };
    let { typeSelectProps: typeSelectProps } = (0, $03cc76e981c32a49$export$e32c88dfddc6e1d8)({
        keyboardDelegate: delegate,
        selectionManager: manager
    });
    if (!disallowTypeAhead) handlers = (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(typeSelectProps, handlers);
    // If nothing is focused within the collection, make the collection itself tabbable.
    // This will be marshalled to either the first or last item depending on where focus came from.
    let tabIndex = undefined;
    if (!shouldUseVirtualFocus) tabIndex = manager.focusedKey == null ? 0 : -1;
    let collectionId = (0, $5a602a729cf93351$export$881eb0d9f3605d9d)(manager.collection);
    return {
        collectionProps: (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(handlers, {
            tabIndex: tabIndex,
            'data-collection': collectionId
        })
    };
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $26c2006a6c7d87f9$export$b95089534ab7c1fd(props) {
    let { selectionManager: selectionManager, collection: collection, disabledKeys: disabledKeys, ref: ref, keyboardDelegate: keyboardDelegate, layoutDelegate: layoutDelegate } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, $b66e5976a4251b0c$export$a16aca283550c30d)({
        usage: 'search',
        sensitivity: 'base'
    });
    let disabledBehavior = selectionManager.disabledBehavior;
    let delegate = (0, $acw62.useMemo)(()=>keyboardDelegate || new (0, $afe5b32ffd8dcd97$export$a05409b8bb224a5a)({
            collection: collection,
            disabledKeys: disabledKeys,
            disabledBehavior: disabledBehavior,
            ref: ref,
            collator: collator,
            layoutDelegate: layoutDelegate
        }), [
        keyboardDelegate,
        layoutDelegate,
        collection,
        disabledKeys,
        ref,
        collator,
        disabledBehavior
    ]);
    let { collectionProps: collectionProps } = (0, $5d42d73b717d1d8d$export$d6daf82dcd84e87c)({
        ...props,
        ref: ref,
        selectionManager: selectionManager,
        keyboardDelegate: delegate
    });
    return {
        listProps: collectionProps
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6e849b386e44477b$export$50eacbbf140a3141(props, state, ref) {
    let domProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    // Use props instead of state here. We don't want this to change due to long press.
    let selectionBehavior = props.selectionBehavior || 'toggle';
    let linkBehavior = props.linkBehavior || (selectionBehavior === 'replace' ? 'action' : 'override');
    if (selectionBehavior === 'toggle' && linkBehavior === 'action') // to initiate selection (checkboxes are not allowed inside a listbox). Link items will not be
    // selectable in this configuration.
    linkBehavior = 'override';
    let { listProps: listProps } = (0, $26c2006a6c7d87f9$export$b95089534ab7c1fd)({
        ...props,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        linkBehavior: linkBehavior
    });
    let { focusWithinProps: focusWithinProps } = (0, $02fb4773760e27fa$export$420e68273165f4ec)({
        onFocusWithin: props.onFocus,
        onBlurWithin: props.onBlur,
        onFocusWithinChange: props.onFocusChange
    });
    // Share list id and some props with child options.
    let id = (0, $855de91ebb07800c$export$f680877a34711e37)(props.id);
    (0, $a5549fa17747a039$export$3585ede4d035bf14).set(state, {
        id: id,
        shouldUseVirtualFocus: props.shouldUseVirtualFocus,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp,
        shouldFocusOnHover: props.shouldFocusOnHover,
        isVirtualized: props.isVirtualized,
        onAction: props.onAction,
        linkBehavior: linkBehavior,
        // @ts-ignore
        UNSTABLE_itemBehavior: props['UNSTABLE_itemBehavior']
    });
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $7db7643eb43655f9$export$8467354a121f1b9f)({
        ...props,
        id: id,
        // listbox is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span'
    });
    return {
        labelProps: labelProps,
        listBoxProps: (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(domProps, focusWithinProps, state.selectionManager.selectionMode === 'multiple' ? {
            'aria-multiselectable': 'true'
        } : {}, {
            role: 'listbox',
            ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)(fieldProps, listProps)
        })
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6b7ff93333bba5d0$export$c3f9f39876e4bc7(props) {
    let { heading: heading, 'aria-label': ariaLabel } = props;
    let headingId = (0, $855de91ebb07800c$export$f680877a34711e37)();
    return {
        itemProps: {
            role: 'presentation'
        },
        headingProps: heading ? {
            // Techincally, listbox cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, using role="presentation",
            // and only use it as a visual label for the nested group.
            id: headingId,
            role: 'presentation'
        } : {},
        groupProps: {
            role: 'group',
            'aria-label': ariaLabel,
            'aria-labelledby': heading ? headingId : undefined
        }
    };
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0c872771c245f177$export$1005530eda016c13(node, collection) {
    // New API: call collection.getChildren with the node key.
    if (typeof collection.getChildren === 'function') return collection.getChildren(node.key);
    // Old API: access childNodes directly.
    return node.childNodes;
}
function $0c872771c245f177$export$fbdeaa6a76694f71(iterable) {
    return $0c872771c245f177$export$5f3398f8733f90e2(iterable, 0);
}
function $0c872771c245f177$export$5f3398f8733f90e2(iterable, index) {
    if (index < 0) return undefined;
    let i = 0;
    for (let item of iterable){
        if (i === index) return item;
        i++;
    }
}
function $0c872771c245f177$export$7475b2c64539e4cf(iterable) {
    let lastItem = undefined;
    for (let value of iterable)lastItem = value;
    return lastItem;
}
function $0c872771c245f177$export$8c434b3a7a4dad6(collection, a, b) {
    // If the two nodes have the same parent, compare their indices.
    if (a.parentKey === b.parentKey) return a.index - b.index;
    // Otherwise, collect all of the ancestors from each node, and find the first one that doesn't match starting from the root.
    // Include the base nodes in case we are comparing nodes of different levels so that we can compare the higher node to the lower level node's
    // ancestor of the same level
    let aAncestors = [
        ...$0c872771c245f177$var$$c5a24bc478652b5f$var$getAncestors(collection, a),
        a
    ];
    let bAncestors = [
        ...$0c872771c245f177$var$$c5a24bc478652b5f$var$getAncestors(collection, b),
        b
    ];
    let firstNonMatchingAncestor = aAncestors.slice(0, bAncestors.length).findIndex((a, i)=>a !== bAncestors[i]);
    if (firstNonMatchingAncestor !== -1) {
        // Compare the indices of two children within the common ancestor.
        a = aAncestors[firstNonMatchingAncestor];
        b = bAncestors[firstNonMatchingAncestor];
        return a.index - b.index;
    }
    // If there isn't a non matching ancestor, we might be in a case where one of the nodes is the ancestor of the other.
    if (aAncestors.findIndex((node)=>node === b) >= 0) return 1;
    else if (bAncestors.findIndex((node)=>node === a) >= 0) return -1;
    // 🤷
    return -1;
}
function $0c872771c245f177$var$$c5a24bc478652b5f$var$getAncestors(collection, node) {
    let parents = [];
    let currNode = node;
    while((currNode === null || currNode === void 0 ? void 0 : currNode.parentKey) != null){
        currNode = collection.getItem(currNode.parentKey);
        if (currNode) parents.unshift(currNode);
    }
    return parents;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $1173ed60a7d91dfd$var$$453cc9f0df89c0a5$var$cache = new WeakMap();
function $1173ed60a7d91dfd$export$77d5aafae4e095b2(collection) {
    let count = $1173ed60a7d91dfd$var$$453cc9f0df89c0a5$var$cache.get(collection);
    if (count != null) return count;
    // TS isn't smart enough to know we've ensured count is a number, so use a new variable
    let counter = 0;
    let countItems = (items)=>{
        for (let item of items){
            if (item.type === 'section') countItems((0, $0c872771c245f177$export$1005530eda016c13)(item, collection));
            else if (item.type === 'item') counter++;
        }
    };
    countItems(collection);
    $1173ed60a7d91dfd$var$$453cc9f0df89c0a5$var$cache.set(collection, counter);
    return counter;
}








var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $633963a23b08716a$var$$ef06256079686ba0$var$descriptionId = 0;
const $633963a23b08716a$var$$ef06256079686ba0$var$descriptionNodes = new Map();
function $633963a23b08716a$export$f8aeda7b10753fa1(description) {
    let [id, setId] = (0, $acw62.useState)();
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        if (!description) return;
        let desc = $633963a23b08716a$var$$ef06256079686ba0$var$descriptionNodes.get(description);
        if (!desc) {
            let id = `react-aria-description-${$633963a23b08716a$var$$ef06256079686ba0$var$descriptionId++}`;
            setId(id);
            let node = document.createElement('div');
            node.id = id;
            node.style.display = 'none';
            node.textContent = description;
            document.body.appendChild(node);
            desc = {
                refCount: 0,
                element: node
            };
            $633963a23b08716a$var$$ef06256079686ba0$var$descriptionNodes.set(description, desc);
        } else setId(desc.element.id);
        desc.refCount++;
        return ()=>{
            if (desc && --desc.refCount === 0) {
                desc.element.remove();
                $633963a23b08716a$var$$ef06256079686ba0$var$descriptionNodes.delete(description);
            }
        };
    }, [
        description
    ]);
    return {
        'aria-describedby': description ? id : undefined
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $2db4cebf4c07bbb1$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $2db4cebf4c07bbb1$export$c24ed0104d07eab9(props) {
    let { isDisabled: isDisabled, onLongPressStart: onLongPressStart, onLongPressEnd: onLongPressEnd, onLongPress: onLongPress, threshold: threshold = $2db4cebf4c07bbb1$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD, accessibilityDescription: accessibilityDescription } = props;
    const timeRef = (0, $acw62.useRef)(undefined);
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $2dd678e31a4cc7e0$export$4eaf04e54aa8eed6)();
    let { pressProps: pressProps } = (0, $6c43aa319e86785e$export$45712eceda6fad21)({
        isDisabled: isDisabled,
        onPressStart (e) {
            e.continuePropagation();
            if (e.pointerType === 'mouse' || e.pointerType === 'touch') {
                if (onLongPressStart) onLongPressStart({
                    ...e,
                    type: 'longpressstart'
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent('pointercancel', {
                        bubbles: true
                    }));
                    // Ensure target is focused. On touch devices, browsers typically focus on pointer up.
                    if ((0, $48852fd65b79e251$export$b204af158042fbac)(e.target).activeElement !== e.target) (0, $4623aa9f87f28cd4$export$de79e2c695e052f3)(e.target);
                    if (onLongPress) onLongPress({
                        ...e,
                        type: 'longpress'
                    });
                    timeRef.current = undefined;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === 'touch') {
                    let onContextMenu = (e)=>{
                        e.preventDefault();
                    };
                    addGlobalListener(e.target, 'contextmenu', onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, 'pointerup', ()=>{
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(()=>{
                            removeGlobalListener(e.target, 'contextmenu', onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === 'mouse' || e.pointerType === 'touch')) onLongPressEnd({
                ...e,
                type: 'longpressend'
            });
        }
    });
    let descriptionProps = (0, $633963a23b08716a$export$f8aeda7b10753fa1)(onLongPress && !isDisabled ? accessibilityDescription : undefined);
    return {
        longPressProps: (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(pressProps, descriptionProps)
    };
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0043bec6983b82da$export$ecf600387e221c37(options) {
    let { id: id, selectionManager: manager, key: key, ref: ref, shouldSelectOnPressUp: shouldSelectOnPressUp, shouldUseVirtualFocus: shouldUseVirtualFocus, focus: focus, isDisabled: isDisabled, onAction: onAction, allowsDifferentPressOrigin: allowsDifferentPressOrigin, linkBehavior: linkBehavior = 'action' } = options;
    let router = (0, $c9b835cc9e261550$export$9a302a45f65d0572)();
    id = (0, $855de91ebb07800c$export$f680877a34711e37)(id);
    let onSelect = (e)=>{
        if (e.pointerType === 'keyboard' && (0, $5a602a729cf93351$export$d3e3bd3e26688c04)(e)) manager.toggleSelection(key);
        else {
            if (manager.selectionMode === 'none') return;
            if (manager.isLink(key)) {
                if (linkBehavior === 'selection' && ref.current) {
                    let itemProps = manager.getItemProps(key);
                    router.open(ref.current, e, itemProps.href, itemProps.routerOptions);
                    // Always set selected keys back to what they were so that select and combobox close.
                    manager.setSelectedKeys(manager.selectedKeys);
                    return;
                } else if (linkBehavior === 'override' || linkBehavior === 'none') return;
            }
            if (manager.selectionMode === 'single') {
                if (manager.isSelected(key) && !manager.disallowEmptySelection) manager.toggleSelection(key);
                else manager.replaceSelection(key);
            } else if (e && e.shiftKey) manager.extendSelection(key);
            else if (manager.selectionBehavior === 'toggle' || e && ((0, $8a16f7e89990868c$export$16792effe837dba3)(e) || e.pointerType === 'touch' || e.pointerType === 'virtual')) manager.toggleSelection(key);
            else manager.replaceSelection(key);
        }
    };
    (0, $acw62.useEffect)(()=>{
        let isFocused = key === manager.focusedKey;
        if (isFocused && manager.isFocused) {
            if (!shouldUseVirtualFocus) {
                if (focus) focus();
                else if (document.activeElement !== ref.current && ref.current) (0, $f84e6bd16978dcef$export$80f3e147d781571c)(ref.current);
            } else (0, $12dcf8f3b90d8ae0$export$76e4e37e5339496d)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref,
        key,
        manager.focusedKey,
        manager.childFocusStrategy,
        manager.isFocused,
        shouldUseVirtualFocus
    ]);
    isDisabled = isDisabled || manager.isDisabled(key);
    // Set tabIndex to 0 if the element is focused, or -1 otherwise so that only the last focused
    // item is tabbable.  If using virtual focus, don't set a tabIndex at all so that VoiceOver
    // on iOS 14 doesn't try to move real DOM focus to the item anyway.
    let itemProps = {};
    if (!shouldUseVirtualFocus && !isDisabled) itemProps = {
        tabIndex: key === manager.focusedKey ? 0 : -1,
        onFocus (e) {
            if (e.target === ref.current) manager.setFocusedKey(key);
        }
    };
    else if (isDisabled) itemProps.onMouseDown = (e)=>{
        // Prevent focus going to the body when clicking on a disabled item.
        e.preventDefault();
    };
    // With checkbox selection, onAction (i.e. navigation) becomes primary, and occurs on a single click of the row.
    // Clicking the checkbox enters selection mode, after which clicking anywhere on any row toggles selection for that row.
    // With highlight selection, onAction is secondary, and occurs on double click. Single click selects the row.
    // With touch, onAction occurs on single tap, and long press enters selection mode.
    let isLinkOverride = manager.isLink(key) && linkBehavior === 'override';
    let isActionOverride = onAction && options['UNSTABLE_itemBehavior'] === 'action';
    let hasLinkAction = manager.isLink(key) && linkBehavior !== 'selection' && linkBehavior !== 'none';
    let allowsSelection = !isDisabled && manager.canSelectItem(key) && !isLinkOverride && !isActionOverride;
    let allowsActions = (onAction || hasLinkAction) && !isDisabled;
    let hasPrimaryAction = allowsActions && (manager.selectionBehavior === 'replace' ? !allowsSelection : !allowsSelection || manager.isEmpty);
    let hasSecondaryAction = allowsActions && allowsSelection && manager.selectionBehavior === 'replace';
    let hasAction = hasPrimaryAction || hasSecondaryAction;
    let modality = (0, $acw62.useRef)(null);
    let longPressEnabled = hasAction && allowsSelection;
    let longPressEnabledOnPressStart = (0, $acw62.useRef)(false);
    let hadPrimaryActionOnPressStart = (0, $acw62.useRef)(false);
    let collectionItemProps = manager.getItemProps(key);
    let performAction = (e)=>{
        if (onAction) {
            var _ref_current;
            onAction();
            (_ref_current = ref.current) === null || _ref_current === void 0 || _ref_current.dispatchEvent(new CustomEvent('react-aria-item-action', {
                bubbles: true
            }));
        }
        if (hasLinkAction && ref.current) router.open(ref.current, e, collectionItemProps.href, collectionItemProps.routerOptions);
    };
    // By default, selection occurs on pointer down. This can be strange if selecting an
    // item causes the UI to disappear immediately (e.g. menus).
    // If shouldSelectOnPressUp is true, we use onPressUp instead of onPressStart.
    // onPress requires a pointer down event on the same element as pointer up. For menus,
    // we want to be able to have the pointer down on the trigger that opens the menu and
    // the pointer up on the menu item rather than requiring a separate press.
    // For keyboard events, selection still occurs on key down.
    let itemPressProps = {
        ref: ref
    };
    if (shouldSelectOnPressUp) {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            if (e.pointerType === 'keyboard' && (!hasAction || $0043bec6983b82da$var$$880e95eb8b93ba9a$var$isSelectionKey())) onSelect(e);
        };
        // If allowsDifferentPressOrigin and interacting with mouse, make selection happen on pressUp (e.g. open menu on press down, selection on menu item happens on press up.)
        // Otherwise, have selection happen onPress (prevents listview row selection when clicking on interactable elements in the row)
        if (!allowsDifferentPressOrigin) itemPressProps.onPress = (e)=>{
            if (hasPrimaryAction || hasSecondaryAction && e.pointerType !== 'mouse') {
                if (e.pointerType === 'keyboard' && !$0043bec6983b82da$var$$880e95eb8b93ba9a$var$isActionKey()) return;
                performAction(e);
            } else if (e.pointerType !== 'keyboard' && allowsSelection) onSelect(e);
        };
        else {
            itemPressProps.onPressUp = hasPrimaryAction ? undefined : (e)=>{
                if (e.pointerType === 'mouse' && allowsSelection) onSelect(e);
            };
            itemPressProps.onPress = hasPrimaryAction ? performAction : (e)=>{
                if (e.pointerType !== 'keyboard' && e.pointerType !== 'mouse' && allowsSelection) onSelect(e);
            };
        }
    } else {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            hadPrimaryActionOnPressStart.current = hasPrimaryAction;
            // Select on mouse down unless there is a primary action which will occur on mouse up.
            // For keyboard, select on key down. If there is an action, the Space key selects on key down,
            // and the Enter key performs onAction on key up.
            if (allowsSelection && (e.pointerType === 'mouse' && !hasPrimaryAction || e.pointerType === 'keyboard' && (!allowsActions || $0043bec6983b82da$var$$880e95eb8b93ba9a$var$isSelectionKey()))) onSelect(e);
        };
        itemPressProps.onPress = (e)=>{
            // Selection occurs on touch up. Primary actions always occur on pointer up.
            // Both primary and secondary actions occur on Enter key up. The only exception
            // is secondary actions, which occur on double click with a mouse.
            if (e.pointerType === 'touch' || e.pointerType === 'pen' || e.pointerType === 'virtual' || e.pointerType === 'keyboard' && hasAction && $0043bec6983b82da$var$$880e95eb8b93ba9a$var$isActionKey() || e.pointerType === 'mouse' && hadPrimaryActionOnPressStart.current) {
                if (hasAction) performAction(e);
                else if (allowsSelection) onSelect(e);
            }
        };
    }
    itemProps['data-collection'] = (0, $5a602a729cf93351$export$6aeb1680a0ae8741)(manager.collection);
    itemProps['data-key'] = key;
    itemPressProps.preventFocusOnPress = shouldUseVirtualFocus;
    // When using virtual focus, make sure the focused key gets updated on press.
    if (shouldUseVirtualFocus) itemPressProps = (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(itemPressProps, {
        onPressStart (e) {
            if (e.pointerType !== 'touch') {
                manager.setFocused(true);
                manager.setFocusedKey(key);
            }
        },
        onPress (e) {
            if (e.pointerType === 'touch') {
                manager.setFocused(true);
                manager.setFocusedKey(key);
            }
        }
    });
    if (collectionItemProps) {
        for (let key of [
            'onPressStart',
            'onPressEnd',
            'onPressChange',
            'onPress',
            'onPressUp',
            'onClick'
        ])if (collectionItemProps[key]) itemPressProps[key] = (0, $366a72b5d02721fb$export$e08e3b67e392101e)(itemPressProps[key], collectionItemProps[key]);
    }
    let { pressProps: pressProps, isPressed: isPressed } = (0, $6c43aa319e86785e$export$45712eceda6fad21)(itemPressProps);
    // Double clicking with a mouse with selectionBehavior = 'replace' performs an action.
    let onDoubleClick = hasSecondaryAction ? (e)=>{
        if (modality.current === 'mouse') {
            e.stopPropagation();
            e.preventDefault();
            performAction(e);
        }
    } : undefined;
    // Long pressing an item with touch when selectionBehavior = 'replace' switches the selection behavior
    // to 'toggle'. This changes the single tap behavior from performing an action (i.e. navigating) to
    // selecting, and may toggle the appearance of a UI affordance like checkboxes on each item.
    let { longPressProps: longPressProps } = (0, $2db4cebf4c07bbb1$export$c24ed0104d07eab9)({
        isDisabled: !longPressEnabled,
        onLongPress (e) {
            if (e.pointerType === 'touch') {
                onSelect(e);
                manager.setSelectionBehavior('toggle');
            }
        }
    });
    // Prevent native drag and drop on long press if we also select on long press.
    // Once the user is in selection mode, they can long press again to drag.
    // Use a capturing listener to ensure this runs before useDrag, regardless of
    // the order the props get merged.
    let onDragStartCapture = (e)=>{
        if (modality.current === 'touch' && longPressEnabledOnPressStart.current) e.preventDefault();
    };
    // Prevent default on link clicks so that we control exactly
    // when they open (to match selection behavior).
    let onClick = linkBehavior !== 'none' && manager.isLink(key) ? (e)=>{
        if (!(0, $c9b835cc9e261550$export$95185d699e05d4d7).isOpening) e.preventDefault();
    } : undefined;
    return {
        itemProps: (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(itemProps, allowsSelection || hasPrimaryAction || shouldUseVirtualFocus && !isDisabled ? pressProps : {}, longPressEnabled ? longPressProps : {}, {
            onDoubleClick: onDoubleClick,
            onDragStartCapture: onDragStartCapture,
            onClick: onClick,
            id: id
        }, shouldUseVirtualFocus ? {
            onMouseDown: (e)=>e.preventDefault()
        } : undefined),
        isPressed: isPressed,
        isSelected: manager.isSelected(key),
        isFocused: manager.isFocused && manager.focusedKey === key,
        isDisabled: isDisabled,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}
function $0043bec6983b82da$var$$880e95eb8b93ba9a$var$isActionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === 'Enter';
}
function $0043bec6983b82da$var$$880e95eb8b93ba9a$var$isSelectionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === ' ' || (event === null || event === void 0 ? void 0 : event.code) === 'Space';
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $bc6bd3a472d51322$export$497855f14858aa34(props, state, ref) {
    var _item_props, _item_props1;
    let { key: key } = props;
    let data = (0, $a5549fa17747a039$export$3585ede4d035bf14).get(state);
    var _props_isDisabled;
    let isDisabled = (_props_isDisabled = props.isDisabled) !== null && _props_isDisabled !== void 0 ? _props_isDisabled : state.selectionManager.isDisabled(key);
    var _props_isSelected;
    let isSelected = (_props_isSelected = props.isSelected) !== null && _props_isSelected !== void 0 ? _props_isSelected : state.selectionManager.isSelected(key);
    var _props_shouldSelectOnPressUp;
    let shouldSelectOnPressUp = (_props_shouldSelectOnPressUp = props.shouldSelectOnPressUp) !== null && _props_shouldSelectOnPressUp !== void 0 ? _props_shouldSelectOnPressUp : data === null || data === void 0 ? void 0 : data.shouldSelectOnPressUp;
    var _props_shouldFocusOnHover;
    let shouldFocusOnHover = (_props_shouldFocusOnHover = props.shouldFocusOnHover) !== null && _props_shouldFocusOnHover !== void 0 ? _props_shouldFocusOnHover : data === null || data === void 0 ? void 0 : data.shouldFocusOnHover;
    var _props_shouldUseVirtualFocus;
    let shouldUseVirtualFocus = (_props_shouldUseVirtualFocus = props.shouldUseVirtualFocus) !== null && _props_shouldUseVirtualFocus !== void 0 ? _props_shouldUseVirtualFocus : data === null || data === void 0 ? void 0 : data.shouldUseVirtualFocus;
    var _props_isVirtualized;
    let isVirtualized = (_props_isVirtualized = props.isVirtualized) !== null && _props_isVirtualized !== void 0 ? _props_isVirtualized : data === null || data === void 0 ? void 0 : data.isVirtualized;
    let labelId = (0, $855de91ebb07800c$export$b4cc09c592e8fdb8)();
    let descriptionId = (0, $855de91ebb07800c$export$b4cc09c592e8fdb8)();
    let optionProps = {
        role: 'option',
        'aria-disabled': isDisabled || undefined,
        'aria-selected': state.selectionManager.selectionMode !== 'none' ? isSelected : undefined
    };
    // Safari with VoiceOver on macOS misreads options with aria-labelledby or aria-label as simply "text".
    // We should not map slots to the label and description on Safari and instead just have VoiceOver read the textContent.
    // https://bugs.webkit.org/show_bug.cgi?id=209279
    if (!((0, $c0699bc5a0b3191f$export$9ac100e40613ea10)() && (0, $c0699bc5a0b3191f$export$78551043582a6a98)())) {
        optionProps['aria-label'] = props['aria-label'];
        optionProps['aria-labelledby'] = labelId;
        optionProps['aria-describedby'] = descriptionId;
    }
    let item = state.collection.getItem(key);
    if (isVirtualized) {
        let index = Number(item === null || item === void 0 ? void 0 : item.index);
        optionProps['aria-posinset'] = Number.isNaN(index) ? undefined : index + 1;
        optionProps['aria-setsize'] = (0, $1173ed60a7d91dfd$export$77d5aafae4e095b2)(state.collection);
    }
    let onAction = (data === null || data === void 0 ? void 0 : data.onAction) ? ()=>{
        var _data_onAction;
        return data === null || data === void 0 ? void 0 : (_data_onAction = data.onAction) === null || _data_onAction === void 0 ? void 0 : _data_onAction.call(data, key);
    } : undefined;
    let id = (0, $a5549fa17747a039$export$9145995848b05025)(state, key);
    let { itemProps: itemProps, isPressed: isPressed, isFocused: isFocused, hasAction: hasAction, allowsSelection: allowsSelection } = (0, $0043bec6983b82da$export$ecf600387e221c37)({
        selectionManager: state.selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        allowsDifferentPressOrigin: shouldSelectOnPressUp && shouldFocusOnHover,
        isVirtualized: isVirtualized,
        shouldUseVirtualFocus: shouldUseVirtualFocus,
        isDisabled: isDisabled,
        onAction: onAction || (item === null || item === void 0 ? void 0 : (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.onAction) ? (0, $366a72b5d02721fb$export$e08e3b67e392101e)(item === null || item === void 0 ? void 0 : (_item_props1 = item.props) === null || _item_props1 === void 0 ? void 0 : _item_props1.onAction, onAction) : undefined,
        linkBehavior: data === null || data === void 0 ? void 0 : data.linkBehavior,
        // @ts-ignore
        UNSTABLE_itemBehavior: data === null || data === void 0 ? void 0 : data['UNSTABLE_itemBehavior'],
        id: id
    });
    let { hoverProps: hoverProps } = (0, $8d62ff0ac4dc2be2$export$ae780daf29e6d456)({
        isDisabled: isDisabled || !shouldFocusOnHover,
        onHoverStart () {
            if (!(0, $77c8ff0a3cb27e18$export$b9b3dfddab17db27)()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(key);
            }
        }
    });
    let domProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(item === null || item === void 0 ? void 0 : item.props);
    delete domProps.id;
    let linkProps = (0, $c9b835cc9e261550$export$7e924b3091a3bd18)(item === null || item === void 0 ? void 0 : item.props);
    return {
        optionProps: {
            ...optionProps,
            ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)(domProps, itemProps, hoverProps, linkProps),
            id: id
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        isFocused: isFocused,
        isFocusVisible: isFocused && state.selectionManager.isFocused && (0, $77c8ff0a3cb27e18$export$b9b3dfddab17db27)(),
        isSelected: isSelected,
        isDisabled: isDisabled,
        isPressed: isPressed,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $859ef2c97b2281b0$export$d085fb9e920b5ca7 {
    *[Symbol.iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this._size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        var _node_prevKey;
        return node ? (_node_prevKey = node.prevKey) !== null && _node_prevKey !== void 0 ? _node_prevKey : null : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        var _node_nextKey;
        return node ? (_node_nextKey = node.nextKey) !== null && _node_nextKey !== void 0 ? _node_nextKey : null : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        var _this_keyMap_get;
        return (_this_keyMap_get = this.keyMap.get(key)) !== null && _this_keyMap_get !== void 0 ? _this_keyMap_get : null;
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    getChildren(key) {
        let node = this.keyMap.get(key);
        return (node === null || node === void 0 ? void 0 : node.childNodes) || [];
    }
    constructor(nodes){
        this.keyMap = new Map();
        this.firstKey = null;
        this.lastKey = null;
        this.iterable = nodes;
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && node.type === 'section') for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last = null;
        let index = 0;
        let size = 0;
        for (let [key, node] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node.prevKey = last.key;
            } else {
                this.firstKey = key;
                node.prevKey = undefined;
            }
            if (node.type === 'item') node.index = index++;
            // Only count sections and items when determining size so that
            // loaders and separators in RAC/S2 don't influence the emptyState determination
            if (node.type === 'section' || node.type === 'item') size++;
            last = node;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        this._size = size;
        var _last_key;
        this.lastKey = (_last_key = last === null || last === void 0 ? void 0 : last.key) !== null && _last_key !== void 0 ? _last_key : null;
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $f5f308357031e94c$export$52baac22726c72bf extends Set {
    constructor(keys, anchorKey, currentKey){
        super(keys);
        if (keys instanceof $f5f308357031e94c$export$52baac22726c72bf) {
            this.anchorKey = anchorKey !== null && anchorKey !== void 0 ? anchorKey : keys.anchorKey;
            this.currentKey = currentKey !== null && currentKey !== void 0 ? currentKey : keys.currentKey;
        } else {
            this.anchorKey = anchorKey !== null && anchorKey !== void 0 ? anchorKey : null;
            this.currentKey = currentKey !== null && currentKey !== void 0 ? currentKey : null;
        }
    }
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $612ad27198cc9cf7$export$6c8a5aaad13c9852 {
    /**
   * The type of selection that is allowed in the collection.
   */ get selectionMode() {
        return this.state.selectionMode;
    }
    /**
   * Whether the collection allows empty selection.
   */ get disallowEmptySelection() {
        return this.state.disallowEmptySelection;
    }
    /**
   * The selection behavior for the collection.
   */ get selectionBehavior() {
        return this.state.selectionBehavior;
    }
    /**
   * Sets the selection behavior for the collection.
   */ setSelectionBehavior(selectionBehavior) {
        this.state.setSelectionBehavior(selectionBehavior);
    }
    /**
   * Whether the collection is currently focused.
   */ get isFocused() {
        return this.state.isFocused;
    }
    /**
   * Sets whether the collection is focused.
   */ setFocused(isFocused) {
        this.state.setFocused(isFocused);
    }
    /**
   * The current focused key in the collection.
   */ get focusedKey() {
        return this.state.focusedKey;
    }
    /** Whether the first or last child of the focused key should receive focus. */ get childFocusStrategy() {
        return this.state.childFocusStrategy;
    }
    /**
   * Sets the focused key.
   */ setFocusedKey(key, childFocusStrategy) {
        if (key == null || this.collection.getItem(key)) this.state.setFocusedKey(key, childFocusStrategy);
    }
    /**
   * The currently selected keys in the collection.
   */ get selectedKeys() {
        return this.state.selectedKeys === 'all' ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
    }
    /**
   * The raw selection value for the collection.
   * Either 'all' for select all, or a set of keys.
   */ get rawSelection() {
        return this.state.selectedKeys;
    }
    /**
   * Returns whether a key is selected.
   */ isSelected(key) {
        if (this.state.selectionMode === 'none') return false;
        let mappedKey = this.getKey(key);
        if (mappedKey == null) return false;
        return this.state.selectedKeys === 'all' ? this.canSelectItem(mappedKey) : this.state.selectedKeys.has(mappedKey);
    }
    /**
   * Whether the selection is empty.
   */ get isEmpty() {
        return this.state.selectedKeys !== 'all' && this.state.selectedKeys.size === 0;
    }
    /**
   * Whether all items in the collection are selected.
   */ get isSelectAll() {
        if (this.isEmpty) return false;
        if (this.state.selectedKeys === 'all') return true;
        if (this._isSelectAll != null) return this._isSelectAll;
        let allKeys = this.getSelectAllKeys();
        let selectedKeys = this.state.selectedKeys;
        this._isSelectAll = allKeys.every((k)=>selectedKeys.has(k));
        return this._isSelectAll;
    }
    get firstSelectedKey() {
        let first = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!first || item && (0, $0c872771c245f177$export$8c434b3a7a4dad6)(this.collection, item, first) < 0) first = item;
        }
        var _first_key;
        return (_first_key = first === null || first === void 0 ? void 0 : first.key) !== null && _first_key !== void 0 ? _first_key : null;
    }
    get lastSelectedKey() {
        let last = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!last || item && (0, $0c872771c245f177$export$8c434b3a7a4dad6)(this.collection, item, last) > 0) last = item;
        }
        var _last_key;
        return (_last_key = last === null || last === void 0 ? void 0 : last.key) !== null && _last_key !== void 0 ? _last_key : null;
    }
    get disabledKeys() {
        return this.state.disabledKeys;
    }
    get disabledBehavior() {
        return this.state.disabledBehavior;
    }
    /**
   * Extends the selection to the given key.
   */ extendSelection(toKey) {
        if (this.selectionMode === 'none') return;
        if (this.selectionMode === 'single') {
            this.replaceSelection(toKey);
            return;
        }
        let mappedToKey = this.getKey(toKey);
        if (mappedToKey == null) return;
        let selection;
        // Only select the one key if coming from a select all.
        if (this.state.selectedKeys === 'all') selection = new (0, $f5f308357031e94c$export$52baac22726c72bf)([
            mappedToKey
        ], mappedToKey, mappedToKey);
        else {
            let selectedKeys = this.state.selectedKeys;
            var _selectedKeys_anchorKey;
            let anchorKey = (_selectedKeys_anchorKey = selectedKeys.anchorKey) !== null && _selectedKeys_anchorKey !== void 0 ? _selectedKeys_anchorKey : mappedToKey;
            selection = new (0, $f5f308357031e94c$export$52baac22726c72bf)(selectedKeys, anchorKey, mappedToKey);
            var _selectedKeys_currentKey;
            for (let key of this.getKeyRange(anchorKey, (_selectedKeys_currentKey = selectedKeys.currentKey) !== null && _selectedKeys_currentKey !== void 0 ? _selectedKeys_currentKey : mappedToKey))selection.delete(key);
            for (let key of this.getKeyRange(mappedToKey, anchorKey))if (this.canSelectItem(key)) selection.add(key);
        }
        this.state.setSelectedKeys(selection);
    }
    getKeyRange(from, to) {
        let fromItem = this.collection.getItem(from);
        let toItem = this.collection.getItem(to);
        if (fromItem && toItem) {
            if ((0, $0c872771c245f177$export$8c434b3a7a4dad6)(this.collection, fromItem, toItem) <= 0) return this.getKeyRangeInternal(from, to);
            return this.getKeyRangeInternal(to, from);
        }
        return [];
    }
    getKeyRangeInternal(from, to) {
        var _this_layoutDelegate;
        if ((_this_layoutDelegate = this.layoutDelegate) === null || _this_layoutDelegate === void 0 ? void 0 : _this_layoutDelegate.getKeyRange) return this.layoutDelegate.getKeyRange(from, to);
        let keys = [];
        let key = from;
        while(key != null){
            let item = this.collection.getItem(key);
            if (item && (item.type === 'item' || item.type === 'cell' && this.allowsCellSelection)) keys.push(key);
            if (key === to) return keys;
            key = this.collection.getKeyAfter(key);
        }
        return [];
    }
    getKey(key) {
        let item = this.collection.getItem(key);
        if (!item) return key;
        // If cell selection is allowed, just return the key.
        if (item.type === 'cell' && this.allowsCellSelection) return key;
        // Find a parent item to select
        while(item && item.type !== 'item' && item.parentKey != null)item = this.collection.getItem(item.parentKey);
        if (!item || item.type !== 'item') return null;
        return item.key;
    }
    /**
   * Toggles whether the given key is selected.
   */ toggleSelection(key) {
        if (this.selectionMode === 'none') return;
        if (this.selectionMode === 'single' && !this.isSelected(key)) {
            this.replaceSelection(key);
            return;
        }
        let mappedKey = this.getKey(key);
        if (mappedKey == null) return;
        let keys = new (0, $f5f308357031e94c$export$52baac22726c72bf)(this.state.selectedKeys === 'all' ? this.getSelectAllKeys() : this.state.selectedKeys);
        if (keys.has(mappedKey)) keys.delete(mappedKey);
        else if (this.canSelectItem(mappedKey)) {
            keys.add(mappedKey);
            keys.anchorKey = mappedKey;
            keys.currentKey = mappedKey;
        }
        if (this.disallowEmptySelection && keys.size === 0) return;
        this.state.setSelectedKeys(keys);
    }
    /**
   * Replaces the selection with only the given key.
   */ replaceSelection(key) {
        if (this.selectionMode === 'none') return;
        let mappedKey = this.getKey(key);
        if (mappedKey == null) return;
        let selection = this.canSelectItem(mappedKey) ? new (0, $f5f308357031e94c$export$52baac22726c72bf)([
            mappedKey
        ], mappedKey, mappedKey) : new (0, $f5f308357031e94c$export$52baac22726c72bf)();
        this.state.setSelectedKeys(selection);
    }
    /**
   * Replaces the selection with the given keys.
   */ setSelectedKeys(keys) {
        if (this.selectionMode === 'none') return;
        let selection = new (0, $f5f308357031e94c$export$52baac22726c72bf)();
        for (let key of keys){
            let mappedKey = this.getKey(key);
            if (mappedKey != null) {
                selection.add(mappedKey);
                if (this.selectionMode === 'single') break;
            }
        }
        this.state.setSelectedKeys(selection);
    }
    getSelectAllKeys() {
        let keys = [];
        let addKeys = (key)=>{
            while(key != null){
                if (this.canSelectItem(key)) {
                    var _getFirstItem;
                    let item = this.collection.getItem(key);
                    if ((item === null || item === void 0 ? void 0 : item.type) === 'item') keys.push(key);
                    var _getFirstItem_key;
                    // Add child keys. If cell selection is allowed, then include item children too.
                    if ((item === null || item === void 0 ? void 0 : item.hasChildNodes) && (this.allowsCellSelection || item.type !== 'item')) addKeys((_getFirstItem_key = (_getFirstItem = (0, $0c872771c245f177$export$fbdeaa6a76694f71)((0, $0c872771c245f177$export$1005530eda016c13)(item, this.collection))) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key) !== null && _getFirstItem_key !== void 0 ? _getFirstItem_key : null);
                }
                key = this.collection.getKeyAfter(key);
            }
        };
        addKeys(this.collection.getFirstKey());
        return keys;
    }
    /**
   * Selects all items in the collection.
   */ selectAll() {
        if (!this.isSelectAll && this.selectionMode === 'multiple') this.state.setSelectedKeys('all');
    }
    /**
   * Removes all keys from the selection.
   */ clearSelection() {
        if (!this.disallowEmptySelection && (this.state.selectedKeys === 'all' || this.state.selectedKeys.size > 0)) this.state.setSelectedKeys(new (0, $f5f308357031e94c$export$52baac22726c72bf)());
    }
    /**
   * Toggles between select all and an empty selection.
   */ toggleSelectAll() {
        if (this.isSelectAll) this.clearSelection();
        else this.selectAll();
    }
    select(key, e) {
        if (this.selectionMode === 'none') return;
        if (this.selectionMode === 'single') {
            if (this.isSelected(key) && !this.disallowEmptySelection) this.toggleSelection(key);
            else this.replaceSelection(key);
        } else if (this.selectionBehavior === 'toggle' || e && (e.pointerType === 'touch' || e.pointerType === 'virtual')) this.toggleSelection(key);
        else this.replaceSelection(key);
    }
    /**
   * Returns whether the current selection is equal to the given selection.
   */ isSelectionEqual(selection) {
        if (selection === this.state.selectedKeys) return true;
        // Check if the set of keys match.
        let selectedKeys = this.selectedKeys;
        if (selection.size !== selectedKeys.size) return false;
        for (let key of selection){
            if (!selectedKeys.has(key)) return false;
        }
        for (let key of selectedKeys){
            if (!selection.has(key)) return false;
        }
        return true;
    }
    canSelectItem(key) {
        var _item_props;
        if (this.state.selectionMode === 'none' || this.state.disabledKeys.has(key)) return false;
        let item = this.collection.getItem(key);
        if (!item || (item === null || item === void 0 ? void 0 : (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.isDisabled) || item.type === 'cell' && !this.allowsCellSelection) return false;
        return true;
    }
    isDisabled(key) {
        var _this_collection_getItem_props, _this_collection_getItem;
        return this.state.disabledBehavior === 'all' && (this.state.disabledKeys.has(key) || !!((_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : (_this_collection_getItem_props = _this_collection_getItem.props) === null || _this_collection_getItem_props === void 0 ? void 0 : _this_collection_getItem_props.isDisabled));
    }
    isLink(key) {
        var _this_collection_getItem_props, _this_collection_getItem;
        return !!((_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : (_this_collection_getItem_props = _this_collection_getItem.props) === null || _this_collection_getItem_props === void 0 ? void 0 : _this_collection_getItem_props.href);
    }
    getItemProps(key) {
        var _this_collection_getItem;
        return (_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : _this_collection_getItem.props;
    }
    withCollection(collection) {
        return new $612ad27198cc9cf7$export$6c8a5aaad13c9852(collection, this.state, {
            allowsCellSelection: this.allowsCellSelection,
            layoutDelegate: this.layoutDelegate || undefined
        });
    }
    constructor(collection, state, options){
        this.collection = collection;
        this.state = state;
        var _options_allowsCellSelection;
        this.allowsCellSelection = (_options_allowsCellSelection = options === null || options === void 0 ? void 0 : options.allowsCellSelection) !== null && _options_allowsCellSelection !== void 0 ? _options_allowsCellSelection : false;
        this._isSelectAll = null;
        this.layoutDelegate = (options === null || options === void 0 ? void 0 : options.layoutDelegate) || null;
    }
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ab083b9331e6e49d$var$$7af3f5b51489e0b5$var$equalSets(setA, setB) {
    if (setA.size !== setB.size) return false;
    for (let item of setA){
        if (!setB.has(item)) return false;
    }
    return true;
}
function $ab083b9331e6e49d$export$253fe78d46329472(props) {
    let { selectionMode: selectionMode = 'none', disallowEmptySelection: disallowEmptySelection = false, allowDuplicateSelectionEvents: allowDuplicateSelectionEvents, selectionBehavior: selectionBehaviorProp = 'toggle', disabledBehavior: disabledBehavior = 'all' } = props;
    // We want synchronous updates to `isFocused` and `focusedKey` after their setters are called.
    // But we also need to trigger a react re-render. So, we have both a ref (sync) and state (async).
    let isFocusedRef = (0, $acw62.useRef)(false);
    let [, setFocused] = (0, $acw62.useState)(false);
    let focusedKeyRef = (0, $acw62.useRef)(null);
    let childFocusStrategyRef = (0, $acw62.useRef)(null);
    let [, setFocusedKey] = (0, $acw62.useState)(null);
    let selectedKeysProp = (0, $acw62.useMemo)(()=>$ab083b9331e6e49d$var$$7af3f5b51489e0b5$var$convertSelection(props.selectedKeys), [
        props.selectedKeys
    ]);
    let defaultSelectedKeys = (0, $acw62.useMemo)(()=>$ab083b9331e6e49d$var$$7af3f5b51489e0b5$var$convertSelection(props.defaultSelectedKeys, new (0, $f5f308357031e94c$export$52baac22726c72bf)()), [
        props.defaultSelectedKeys
    ]);
    let [selectedKeys, setSelectedKeys] = (0, $3316814d6906df5c$export$40bfa8c7b0832715)(selectedKeysProp, defaultSelectedKeys, props.onSelectionChange);
    let disabledKeysProp = (0, $acw62.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let [selectionBehavior, setSelectionBehavior] = (0, $acw62.useState)(selectionBehaviorProp);
    // If the selectionBehavior prop is set to replace, but the current state is toggle (e.g. due to long press
    // to enter selection mode on touch), and the selection becomes empty, reset the selection behavior.
    if (selectionBehaviorProp === 'replace' && selectionBehavior === 'toggle' && typeof selectedKeys === 'object' && selectedKeys.size === 0) setSelectionBehavior('replace');
    // If the selectionBehavior prop changes, update the state as well.
    let lastSelectionBehavior = (0, $acw62.useRef)(selectionBehaviorProp);
    (0, $acw62.useEffect)(()=>{
        if (selectionBehaviorProp !== lastSelectionBehavior.current) {
            setSelectionBehavior(selectionBehaviorProp);
            lastSelectionBehavior.current = selectionBehaviorProp;
        }
    }, [
        selectionBehaviorProp
    ]);
    return {
        selectionMode: selectionMode,
        disallowEmptySelection: disallowEmptySelection,
        selectionBehavior: selectionBehavior,
        setSelectionBehavior: setSelectionBehavior,
        get isFocused () {
            return isFocusedRef.current;
        },
        setFocused (f) {
            isFocusedRef.current = f;
            setFocused(f);
        },
        get focusedKey () {
            return focusedKeyRef.current;
        },
        get childFocusStrategy () {
            return childFocusStrategyRef.current;
        },
        setFocusedKey (k, childFocusStrategy = 'first') {
            focusedKeyRef.current = k;
            childFocusStrategyRef.current = childFocusStrategy;
            setFocusedKey(k);
        },
        selectedKeys: selectedKeys,
        setSelectedKeys (keys) {
            if (allowDuplicateSelectionEvents || !$ab083b9331e6e49d$var$$7af3f5b51489e0b5$var$equalSets(keys, selectedKeys)) setSelectedKeys(keys);
        },
        disabledKeys: disabledKeysProp,
        disabledBehavior: disabledBehavior
    };
}
function $ab083b9331e6e49d$var$$7af3f5b51489e0b5$var$convertSelection(selection, defaultValue) {
    if (!selection) return defaultValue;
    return selection === 'all' ? 'all' : new (0, $f5f308357031e94c$export$52baac22726c72bf)(selection);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $3357d7073c7151fb$export$bf788dd355e3a401 {
    build(props, context) {
        this.context = context;
        return $3357d7073c7151fb$var$$eb2240fc39a57fa5$var$iterable(()=>this.iterateCollection(props));
    }
    *iterateCollection(props) {
        let { children: children, items: items } = props;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(children) && children.type === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment) yield* this.iterateCollection({
            children: children.props.children,
            items: items
        });
        else if (typeof children === 'function') {
            if (!items) throw new Error('props.children was a function but props.items is missing');
            let index = 0;
            for (let item of items){
                yield* this.getFullNode({
                    value: item,
                    index: index
                }, {
                    renderer: children
                });
                index++;
            }
        } else {
            let items = [];
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
                if (child) items.push(child);
            });
            let index = 0;
            for (let item of items){
                let nodes = this.getFullNode({
                    element: item,
                    index: index
                }, {});
                for (let node of nodes){
                    index++;
                    yield node;
                }
            }
        }
    }
    getKey(item, partialNode, state, parentKey) {
        if (item.key != null) return item.key;
        if (partialNode.type === 'cell' && partialNode.key != null) return `${parentKey}${partialNode.key}`;
        let v = partialNode.value;
        if (v != null) {
            var _v_key;
            let key = (_v_key = v.key) !== null && _v_key !== void 0 ? _v_key : v.id;
            if (key == null) throw new Error('No key found for item');
            return key;
        }
        return parentKey ? `${parentKey}.${partialNode.index}` : `$.${partialNode.index}`;
    }
    getChildState(state, partialNode) {
        return {
            renderer: partialNode.renderer || state.renderer
        };
    }
    *getFullNode(partialNode, state, parentKey, parentNode) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(partialNode.element) && partialNode.element.type === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment) {
            let children = [];
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(partialNode.element.props.children, (child)=>{
                children.push(child);
            });
            var _partialNode_index;
            let index = (_partialNode_index = partialNode.index) !== null && _partialNode_index !== void 0 ? _partialNode_index : 0;
            for (const child of children)yield* this.getFullNode({
                element: child,
                index: index++
            }, state, parentKey, parentNode);
            return;
        }
        // If there's a value instead of an element on the node, and a parent renderer function is available,
        // use it to render an element for the value.
        let element = partialNode.element;
        if (!element && partialNode.value && state && state.renderer) {
            let cached = this.cache.get(partialNode.value);
            if (cached && (!cached.shouldInvalidate || !cached.shouldInvalidate(this.context))) {
                cached.index = partialNode.index;
                cached.parentKey = parentNode ? parentNode.key : null;
                yield cached;
                return;
            }
            element = state.renderer(partialNode.value);
        }
        // If there's an element with a getCollectionNode function on its type, then it's a supported component.
        // Call this function to get a partial node, and recursively build a full node from there.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(element)) {
            let type = element.type;
            if (typeof type !== 'function' && typeof type.getCollectionNode !== 'function') {
                let name = element.type;
                throw new Error(`Unknown element <${name}> in collection.`);
            }
            let childNodes = type.getCollectionNode(element.props, this.context);
            var _partialNode_index1;
            let index = (_partialNode_index1 = partialNode.index) !== null && _partialNode_index1 !== void 0 ? _partialNode_index1 : 0;
            let result = childNodes.next();
            while(!result.done && result.value){
                let childNode = result.value;
                partialNode.index = index;
                var _childNode_key;
                let nodeKey = (_childNode_key = childNode.key) !== null && _childNode_key !== void 0 ? _childNode_key : null;
                if (nodeKey == null) nodeKey = childNode.element ? null : this.getKey(element, partialNode, state, parentKey);
                let nodes = this.getFullNode({
                    ...childNode,
                    key: nodeKey,
                    index: index,
                    wrapper: $3357d7073c7151fb$var$$eb2240fc39a57fa5$var$compose(partialNode.wrapper, childNode.wrapper)
                }, this.getChildState(state, childNode), parentKey ? `${parentKey}${element.key}` : element.key, parentNode);
                let children = [
                    ...nodes
                ];
                for (let node of children){
                    var _childNode_value, _ref;
                    // Cache the node based on its value
                    node.value = (_ref = (_childNode_value = childNode.value) !== null && _childNode_value !== void 0 ? _childNode_value : partialNode.value) !== null && _ref !== void 0 ? _ref : null;
                    if (node.value) this.cache.set(node.value, node);
                    var _parentNode_type;
                    // The partial node may have specified a type for the child in order to specify a constraint.
                    // Verify that the full node that was built recursively matches this type.
                    if (partialNode.type && node.type !== partialNode.type) throw new Error(`Unsupported type <${$3357d7073c7151fb$var$$eb2240fc39a57fa5$var$capitalize(node.type)}> in <${$3357d7073c7151fb$var$$eb2240fc39a57fa5$var$capitalize((_parentNode_type = parentNode === null || parentNode === void 0 ? void 0 : parentNode.type) !== null && _parentNode_type !== void 0 ? _parentNode_type : 'unknown parent type')}>. Only <${$3357d7073c7151fb$var$$eb2240fc39a57fa5$var$capitalize(partialNode.type)}> is supported.`);
                    index++;
                    yield node;
                }
                result = childNodes.next(children);
            }
            return;
        }
        // Ignore invalid elements
        if (partialNode.key == null || partialNode.type == null) return;
        // Create full node
        let builder = this;
        var _partialNode_value, _partialNode_textValue;
        let node = {
            type: partialNode.type,
            props: partialNode.props,
            key: partialNode.key,
            parentKey: parentNode ? parentNode.key : null,
            value: (_partialNode_value = partialNode.value) !== null && _partialNode_value !== void 0 ? _partialNode_value : null,
            level: parentNode ? parentNode.level + 1 : 0,
            index: partialNode.index,
            rendered: partialNode.rendered,
            textValue: (_partialNode_textValue = partialNode.textValue) !== null && _partialNode_textValue !== void 0 ? _partialNode_textValue : '',
            'aria-label': partialNode['aria-label'],
            wrapper: partialNode.wrapper,
            shouldInvalidate: partialNode.shouldInvalidate,
            hasChildNodes: partialNode.hasChildNodes || false,
            childNodes: $3357d7073c7151fb$var$$eb2240fc39a57fa5$var$iterable(function*() {
                if (!partialNode.hasChildNodes || !partialNode.childNodes) return;
                let index = 0;
                for (let child of partialNode.childNodes()){
                    // Ensure child keys are globally unique by prepending the parent node's key
                    if (child.key != null) // Currently this line will have issues when a parent has a key `a` and a child with key `bc`
                    // but another parent has key `ab` and its child has a key `c`. The combined keys would result in both
                    // children having a key of `abc`.
                    child.key = `${node.key}${child.key}`;
                    let nodes = builder.getFullNode({
                        ...child,
                        index: index
                    }, builder.getChildState(state, child), node.key, node);
                    for (let node of nodes){
                        index++;
                        yield node;
                    }
                }
            })
        };
        yield node;
    }
    constructor(){
        this.cache = new WeakMap();
    }
}
// Wraps an iterator function as an iterable object, and caches the results.
function $3357d7073c7151fb$var$$eb2240fc39a57fa5$var$iterable(iterator) {
    let cache = [];
    let iterable = null;
    return {
        *[Symbol.iterator] () {
            for (let item of cache)yield item;
            if (!iterable) iterable = iterator();
            for (let item of iterable){
                cache.push(item);
                yield item;
            }
        }
    };
}
function $3357d7073c7151fb$var$$eb2240fc39a57fa5$var$compose(outer, inner) {
    if (outer && inner) return (element)=>outer(inner(element));
    if (outer) return outer;
    if (inner) return inner;
}
function $3357d7073c7151fb$var$$eb2240fc39a57fa5$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7446aeaa4358c815$export$6cd28814d92fa9c9(props, factory, context) {
    let builder = (0, $acw62.useMemo)(()=>new (0, $3357d7073c7151fb$export$bf788dd355e3a401)(), []);
    let { children: children, items: items, collection: collection } = props;
    let result = (0, $acw62.useMemo)(()=>{
        if (collection) return collection;
        let nodes = builder.build({
            children: children,
            items: items
        }, context);
        return factory(nodes);
    }, [
        builder,
        children,
        items,
        collection,
        context,
        factory
    ]);
    return result;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $54ac9d6cc3ba2949$export$2f645645f7bca764(props) {
    let { filter: filter, layoutDelegate: layoutDelegate } = props;
    let selectionState = (0, $ab083b9331e6e49d$export$253fe78d46329472)(props);
    let disabledKeys = (0, $acw62.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let factory = (0, $acw62.useCallback)((nodes)=>filter ? new (0, $859ef2c97b2281b0$export$d085fb9e920b5ca7)(filter(nodes)) : new (0, $859ef2c97b2281b0$export$d085fb9e920b5ca7)(nodes), [
        filter
    ]);
    let context = (0, $acw62.useMemo)(()=>({
            suppressTextValueWarning: props.suppressTextValueWarning
        }), [
        props.suppressTextValueWarning
    ]);
    let collection = (0, $7446aeaa4358c815$export$6cd28814d92fa9c9)(props, factory, context);
    let selectionManager = (0, $acw62.useMemo)(()=>new (0, $612ad27198cc9cf7$export$6c8a5aaad13c9852)(collection, selectionState, {
            layoutDelegate: layoutDelegate
        }), [
        collection,
        selectionState,
        layoutDelegate
    ]);
    $54ac9d6cc3ba2949$var$$e72dd72e1c76a225$var$useFocusedKeyReset(collection, selectionManager);
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager
    };
}
function $54ac9d6cc3ba2949$export$ba9d38c0f1bf2b36(state, filterFn) {
    let collection = (0, $acw62.useMemo)(()=>filterFn ? state.collection.filter(filterFn) : state.collection, [
        state.collection,
        filterFn
    ]);
    let selectionManager = state.selectionManager.withCollection(collection);
    $54ac9d6cc3ba2949$var$$e72dd72e1c76a225$var$useFocusedKeyReset(collection, selectionManager);
    return {
        collection: collection,
        selectionManager: selectionManager,
        disabledKeys: state.disabledKeys
    };
}
function $54ac9d6cc3ba2949$var$$e72dd72e1c76a225$var$useFocusedKeyReset(collection, selectionManager) {
    // Reset focused key if that item is deleted from the collection.
    const cachedCollection = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (selectionManager.focusedKey != null && !collection.getItem(selectionManager.focusedKey) && cachedCollection.current) {
            const startItem = cachedCollection.current.getItem(selectionManager.focusedKey);
            const cachedItemNodes = [
                ...cachedCollection.current.getKeys()
            ].map((key)=>{
                const itemNode = cachedCollection.current.getItem(key);
                return (itemNode === null || itemNode === void 0 ? void 0 : itemNode.type) === 'item' ? itemNode : null;
            }).filter((node)=>node !== null);
            const itemNodes = [
                ...collection.getKeys()
            ].map((key)=>{
                const itemNode = collection.getItem(key);
                return (itemNode === null || itemNode === void 0 ? void 0 : itemNode.type) === 'item' ? itemNode : null;
            }).filter((node)=>node !== null);
            var _cachedItemNodes_length, _itemNodes_length;
            const diff = ((_cachedItemNodes_length = cachedItemNodes === null || cachedItemNodes === void 0 ? void 0 : cachedItemNodes.length) !== null && _cachedItemNodes_length !== void 0 ? _cachedItemNodes_length : 0) - ((_itemNodes_length = itemNodes === null || itemNodes === void 0 ? void 0 : itemNodes.length) !== null && _itemNodes_length !== void 0 ? _itemNodes_length : 0);
            var _startItem_index, _startItem_index1, _itemNodes_length1;
            let index = Math.min(diff > 1 ? Math.max(((_startItem_index = startItem === null || startItem === void 0 ? void 0 : startItem.index) !== null && _startItem_index !== void 0 ? _startItem_index : 0) - diff + 1, 0) : (_startItem_index1 = startItem === null || startItem === void 0 ? void 0 : startItem.index) !== null && _startItem_index1 !== void 0 ? _startItem_index1 : 0, ((_itemNodes_length1 = itemNodes === null || itemNodes === void 0 ? void 0 : itemNodes.length) !== null && _itemNodes_length1 !== void 0 ? _itemNodes_length1 : 0) - 1);
            let newNode = null;
            let isReverseSearching = false;
            while(index >= 0){
                if (!selectionManager.isDisabled(itemNodes[index].key)) {
                    newNode = itemNodes[index];
                    break;
                }
                // Find next, not disabled item.
                if (index < itemNodes.length - 1 && !isReverseSearching) index++;
                else {
                    isReverseSearching = true;
                    var _startItem_index2, _startItem_index3;
                    if (index > ((_startItem_index2 = startItem === null || startItem === void 0 ? void 0 : startItem.index) !== null && _startItem_index2 !== void 0 ? _startItem_index2 : 0)) index = (_startItem_index3 = startItem === null || startItem === void 0 ? void 0 : startItem.index) !== null && _startItem_index3 !== void 0 ? _startItem_index3 : 0;
                    index--;
                }
            }
            selectionManager.setFocusedKey(newNode ? newNode.key : null);
        }
        cachedCollection.current = collection;
    }, [
        collection,
        selectionManager
    ]);
}



var $acw62 = parcelRequire("acw62");
function $9493f3225e995d9d$export$a9d04c5684123369(value) {
    const pieces = (0, $acw62.version).split('.');
    const major = parseInt(pieces[0], 10);
    if (major >= 19) return value;
    // compatibility with React < 19
    return value ? 'true' : undefined;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a08583dfd8fd8668$export$cfa2225e87938781(node, checkForOverflow) {
    let scrollableNode = node;
    if ((0, $6468d10c4b206c14$export$2bb74740c4e19def)(scrollableNode, checkForOverflow)) scrollableNode = scrollableNode.parentElement;
    while(scrollableNode && !(0, $6468d10c4b206c14$export$2bb74740c4e19def)(scrollableNode, checkForOverflow))scrollableNode = scrollableNode.parentElement;
    return scrollableNode || document.scrollingElement || document.documentElement;
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $986b93eb6b4466d6$export$ccaea96c28e8b9e7(props, ref) {
    let { collection: collection, onLoadMore: onLoadMore, scrollOffset: scrollOffset = 1 } = props;
    let sentinelObserver = (0, $acw62.useRef)(null);
    let triggerLoadMore = (0, $92fff981738f62fe$export$7f54fc3180508a52)((entries)=>{
        // Use "isIntersecting" over an equality check of 0 since it seems like there is cases where
        // a intersection ratio of 0 can be reported when isIntersecting is actually true
        for (let entry of entries)// Up to user discretion as to how to handle these multiple onLoadMore calls
        if (entry.isIntersecting && onLoadMore) onLoadMore();
    });
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        if (ref.current) {
            // Tear down and set up a new IntersectionObserver when the collection changes so that we can properly trigger additional loadMores if there is room for more items
            // Need to do this tear down and set up since using a large rootMargin will mean the observer's callback isn't called even when scrolling the item into view beause its visibility hasn't actually changed
            // https://codesandbox.io/p/sandbox/magical-swanson-dhgp89?file=%2Fsrc%2FApp.js%3A21%2C21
            sentinelObserver.current = new IntersectionObserver(triggerLoadMore, {
                root: (0, $a08583dfd8fd8668$export$cfa2225e87938781)(ref === null || ref === void 0 ? void 0 : ref.current),
                rootMargin: `0px ${100 * scrollOffset}% ${100 * scrollOffset}% ${100 * scrollOffset}%`
            });
            sentinelObserver.current.observe(ref.current);
        }
        return ()=>{
            if (sentinelObserver.current) sentinelObserver.current.disconnect();
        };
    }, [
        collection,
        ref,
        scrollOffset
    ]);
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $eddedc696190b9ab$export$7ff8f37d2d81a48d = (0, $acw62.createContext)(null);
const $eddedc696190b9ab$export$7c5906fe4f1f2af2 = (0, $acw62.createContext)(null);
const $eddedc696190b9ab$export$41f133550aa26f48 = (0, $acw62.forwardRef)(function ListBox(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $eddedc696190b9ab$export$7ff8f37d2d81a48d);
    let state = (0, $acw62.useContext)($eddedc696190b9ab$export$7c5906fe4f1f2af2);
    // The structure of ListBox is a bit strange because it needs to work inside other components like ComboBox and Select.
    // Those components render two copies of their children so that the collection can be built even when the popover is closed.
    // The first copy sends a collection document via context which we render the collection portal into.
    // The second copy sends a ListState object via context which we use to render the ListBox without rebuilding the state.
    // Otherwise, we have a standalone ListBox, so we need to create a collection and state ourselves.
    if (state) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eddedc696190b9ab$var$$eed445e0843c11d0$var$ListBoxInner, {
        state: state,
        props: props,
        listBoxRef: ref
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5fe83fb7b4e6e89f$export$bf788dd355e3a401), {
        content: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5fe83fb7b4e6e89f$export$fb8073518f34e6ec), props)
    }, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eddedc696190b9ab$var$$eed445e0843c11d0$var$StandaloneListBox, {
            props: props,
            listBoxRef: ref,
            collection: collection
        }));
});
function $eddedc696190b9ab$var$$eed445e0843c11d0$var$StandaloneListBox({ props: props, listBoxRef: listBoxRef, collection: collection }) {
    props = {
        ...props,
        collection: collection,
        children: null,
        items: null
    };
    let { layoutDelegate: layoutDelegate } = (0, $acw62.useContext)((0, $0152a93b06da2b96$export$4feb769f8ddf26c5));
    let state = (0, $54ac9d6cc3ba2949$export$2f645645f7bca764)({
        ...props,
        layoutDelegate: layoutDelegate
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eddedc696190b9ab$var$$eed445e0843c11d0$var$ListBoxInner, {
        state: state,
        props: props,
        listBoxRef: listBoxRef
    });
}
function $eddedc696190b9ab$var$$eed445e0843c11d0$var$ListBoxInner({ state: inputState, props: props, listBoxRef: listBoxRef }) {
    [props, listBoxRef] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, listBoxRef, (0, $11cc862e572cddbb$export$b0d3ecf7112093a7));
    let { dragAndDropHooks: dragAndDropHooks, layout: layout = 'stack', orientation: orientation = 'vertical', filter: filter } = props;
    let state = (0, $54ac9d6cc3ba2949$export$ba9d38c0f1bf2b36)(inputState, filter);
    let { collection: collection, selectionManager: selectionManager } = state;
    let isListDraggable = !!(dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDraggableCollectionState);
    let isListDroppable = !!(dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDroppableCollectionState);
    let { direction: direction } = (0, $a7e3b1109bf64033$export$43bb16f9c6d9e3f7)();
    let { disabledBehavior: disabledBehavior, disabledKeys: disabledKeys } = selectionManager;
    let collator = (0, $b66e5976a4251b0c$export$a16aca283550c30d)({
        usage: 'search',
        sensitivity: 'base'
    });
    let { isVirtualized: isVirtualized, layoutDelegate: layoutDelegate, dropTargetDelegate: ctxDropTargetDelegate, CollectionRoot: CollectionRoot } = (0, $acw62.useContext)((0, $0152a93b06da2b96$export$4feb769f8ddf26c5));
    let keyboardDelegate = (0, $acw62.useMemo)(()=>props.keyboardDelegate || new (0, $afe5b32ffd8dcd97$export$a05409b8bb224a5a)({
            collection: collection,
            collator: collator,
            ref: listBoxRef,
            disabledKeys: disabledKeys,
            disabledBehavior: disabledBehavior,
            layout: layout,
            orientation: orientation,
            direction: direction,
            layoutDelegate: layoutDelegate
        }), [
        collection,
        collator,
        listBoxRef,
        disabledBehavior,
        disabledKeys,
        orientation,
        direction,
        props.keyboardDelegate,
        layout,
        layoutDelegate
    ]);
    let { listBoxProps: listBoxProps } = (0, $6e849b386e44477b$export$50eacbbf140a3141)({
        ...props,
        shouldSelectOnPressUp: isListDraggable || props.shouldSelectOnPressUp,
        keyboardDelegate: keyboardDelegate,
        isVirtualized: isVirtualized
    }, state, listBoxRef);
    let dragHooksProvided = (0, $acw62.useRef)(isListDraggable);
    let dropHooksProvided = (0, $acw62.useRef)(isListDroppable);
    (0, $acw62.useEffect)(()=>{
        return;
    }, [
        isListDraggable,
        isListDroppable
    ]);
    let dragState = undefined;
    let dropState = undefined;
    let droppableCollection = undefined;
    let isRootDropTarget = false;
    let dragPreview = null;
    let preview = (0, $acw62.useRef)(null);
    if (isListDraggable && dragAndDropHooks) {
        dragState = dragAndDropHooks.useDraggableCollectionState({
            collection: collection,
            selectionManager: selectionManager,
            preview: dragAndDropHooks.renderDragPreview ? preview : undefined
        });
        dragAndDropHooks.useDraggableCollection({}, dragState, listBoxRef);
        let DragPreview = dragAndDropHooks.DragPreview;
        dragPreview = dragAndDropHooks.renderDragPreview ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DragPreview, {
            ref: preview
        }, dragAndDropHooks.renderDragPreview) : null;
    }
    if (isListDroppable && dragAndDropHooks) {
        dropState = dragAndDropHooks.useDroppableCollectionState({
            collection: collection,
            selectionManager: selectionManager
        });
        let dropTargetDelegate = dragAndDropHooks.dropTargetDelegate || ctxDropTargetDelegate || new dragAndDropHooks.ListDropTargetDelegate(collection, listBoxRef, {
            orientation: orientation,
            layout: layout,
            direction: direction
        });
        droppableCollection = dragAndDropHooks.useDroppableCollection({
            keyboardDelegate: keyboardDelegate,
            dropTargetDelegate: dropTargetDelegate
        }, dropState, listBoxRef);
        isRootDropTarget = dropState.isDropTarget({
            type: 'root'
        });
    }
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $da27ef38ba6b0ce3$export$4e328f61c538687f)();
    let isEmpty = state.collection.size === 0;
    let renderValues = {
        isDropTarget: isRootDropTarget,
        isEmpty: isEmpty,
        isFocused: isFocused,
        isFocusVisible: isFocusVisible,
        layout: props.layout || 'stack',
        state: state
    };
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        className: props.className,
        style: props.style,
        defaultClassName: 'react-aria-ListBox',
        values: renderValues
    });
    let emptyState = null;
    if (isEmpty && props.renderEmptyState) emptyState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        // eslint-disable-next-line
        role: "option",
        style: {
            display: 'contents'
        }
    }, props.renderEmptyState(renderValues));
    let DOMProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dd1b249b49caa281$export$20e40289641fbbb6), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)(DOMProps, renderProps, listBoxProps, focusProps, droppableCollection === null || droppableCollection === void 0 ? void 0 : droppableCollection.collectionProps),
        ref: listBoxRef,
        slot: props.slot || undefined,
        onScroll: props.onScroll,
        "data-drop-target": isRootDropTarget || undefined,
        "data-empty": isEmpty || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-layout": props.layout || 'stack',
        "data-orientation": props.orientation || 'vertical'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $12ee5c1d62d6b2e5$export$2881499e37b75b9a), {
        values: [
            [
                $eddedc696190b9ab$export$7ff8f37d2d81a48d,
                props
            ],
            [
                $eddedc696190b9ab$export$7c5906fe4f1f2af2,
                state
            ],
            [
                (0, $ff9bfcb76836598c$export$d188a835a7bc5783),
                {
                    dragAndDropHooks: dragAndDropHooks,
                    dragState: dragState,
                    dropState: dropState
                }
            ],
            [
                (0, $c59ca94960be2e1f$export$6615d83f6de245ce),
                {
                    elementType: 'div'
                }
            ],
            [
                (0, $ff9bfcb76836598c$export$f55761759794cf55),
                {
                    render: $eddedc696190b9ab$var$$eed445e0843c11d0$var$ListBoxDropIndicatorWrapper
                }
            ],
            [
                (0, $0152a93b06da2b96$export$d40e14dec8b060a8),
                {
                    name: 'ListBoxSection',
                    render: $eddedc696190b9ab$var$$eed445e0843c11d0$var$ListBoxSectionInner
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $77f6c3892c21261c$export$758399f318e6385a), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CollectionRoot, {
        collection: collection,
        scrollRef: listBoxRef,
        persistedKeys: (0, $ff9bfcb76836598c$export$d1e8e3fbb7461f6)(selectionManager, dragAndDropHooks, dropState),
        renderDropIndicator: (0, $ff9bfcb76836598c$export$971707d8a129a1f7)(dragAndDropHooks, dropState)
    }))), emptyState, dragPreview));
}
function $eddedc696190b9ab$var$$eed445e0843c11d0$var$ListBoxSectionInner(props, ref, section, className = 'react-aria-ListBoxSection') {
    let state = (0, $acw62.useContext)($eddedc696190b9ab$export$7c5906fe4f1f2af2);
    let { dragAndDropHooks: dragAndDropHooks, dropState: dropState } = (0, $acw62.useContext)((0, $ff9bfcb76836598c$export$d188a835a7bc5783));
    let { CollectionBranch: CollectionBranch } = (0, $acw62.useContext)((0, $0152a93b06da2b96$export$4feb769f8ddf26c5));
    let [headingRef, heading] = (0, $12ee5c1d62d6b2e5$export$9d4c57ee4c6ffdd8)();
    var _props_arialabel;
    let { headingProps: headingProps, groupProps: groupProps } = (0, $6b7ff93333bba5d0$export$c3f9f39876e4bc7)({
        heading: heading,
        'aria-label': (_props_arialabel = props['aria-label']) !== null && _props_arialabel !== void 0 ? _props_arialabel : undefined
    });
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        defaultClassName: className,
        className: props.className,
        style: props.style,
        values: {}
    });
    let DOMProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)(DOMProps, renderProps, groupProps),
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c879a8de1219885d$export$e0e4026c12a8bdbb).Provider, {
        value: {
            ...headingProps,
            ref: headingRef
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CollectionBranch, {
        collection: state.collection,
        parent: section,
        renderDropIndicator: (0, $ff9bfcb76836598c$export$971707d8a129a1f7)(dragAndDropHooks, dropState)
    })));
}
const $eddedc696190b9ab$export$dca12b0bb56e4fc = (0, $5fe83fb7b4e6e89f$export$e953bb1cd0f19726)((0, $168b0e08d3f28116$export$437f11dc9b403b78), $eddedc696190b9ab$var$$eed445e0843c11d0$var$ListBoxSectionInner);
const $eddedc696190b9ab$export$a11e76429ed99b4 = (0, $5fe83fb7b4e6e89f$export$18af5c7a9e9b3664)((0, $168b0e08d3f28116$export$fd11f34e1d07f134), function ListBoxItem(props, forwardedRef, item) {
    let ref = (0, $426ce7b4b2df0896$export$4338b53315abf666)(forwardedRef);
    let state = (0, $acw62.useContext)($eddedc696190b9ab$export$7c5906fe4f1f2af2);
    let { dragAndDropHooks: dragAndDropHooks, dragState: dragState, dropState: dropState } = (0, $acw62.useContext)((0, $ff9bfcb76836598c$export$d188a835a7bc5783));
    let { optionProps: optionProps, labelProps: labelProps, descriptionProps: descriptionProps, ...states } = (0, $bc6bd3a472d51322$export$497855f14858aa34)({
        key: item.key,
        'aria-label': props === null || props === void 0 ? void 0 : props['aria-label']
    }, state, ref);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $8d62ff0ac4dc2be2$export$ae780daf29e6d456)({
        isDisabled: !states.allowsSelection && !states.hasAction,
        onHoverStart: item.props.onHoverStart,
        onHoverChange: item.props.onHoverChange,
        onHoverEnd: item.props.onHoverEnd
    });
    let { focusProps: focusProps } = (0, $7cd244a03c8a5e7a$export$f8168d8dd8fd66e6)(props);
    let draggableItem = null;
    if (dragState && dragAndDropHooks) draggableItem = dragAndDropHooks.useDraggableItem({
        key: item.key,
        hasAction: states.hasAction
    }, dragState);
    let droppableItem = null;
    if (dropState && dragAndDropHooks) droppableItem = dragAndDropHooks.useDroppableItem({
        target: {
            type: 'item',
            key: item.key,
            dropPosition: 'on'
        }
    }, dropState, ref);
    let isDragging = dragState && dragState.isDragging(item.key);
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        ...props,
        id: undefined,
        children: props.children,
        defaultClassName: 'react-aria-ListBoxItem',
        values: {
            ...states,
            isHovered: isHovered,
            selectionMode: state.selectionManager.selectionMode,
            selectionBehavior: state.selectionManager.selectionBehavior,
            allowsDragging: !!dragState,
            isDragging: isDragging,
            isDropTarget: droppableItem === null || droppableItem === void 0 ? void 0 : droppableItem.isDropTarget
        }
    });
    (0, $acw62.useEffect)(()=>{
        item.textValue;
    }, [
        item.textValue
    ]);
    let ElementType = props.href ? 'a' : 'div';
    let DOMProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    if (ElementType === 'a' && optionProps.tabIndex == null) optionProps.tabIndex = -1;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ElementType, {
        ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)(DOMProps, renderProps, optionProps, hoverProps, focusProps, draggableItem === null || draggableItem === void 0 ? void 0 : draggableItem.dragProps, droppableItem === null || droppableItem === void 0 ? void 0 : droppableItem.dropProps),
        ref: ref,
        "data-allows-dragging": !!dragState || undefined,
        "data-selected": states.isSelected || undefined,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": states.isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-dragging": isDragging || undefined,
        "data-drop-target": (droppableItem === null || droppableItem === void 0 ? void 0 : droppableItem.isDropTarget) || undefined,
        "data-selection-mode": state.selectionManager.selectionMode === 'none' ? undefined : state.selectionManager.selectionMode
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $12ee5c1d62d6b2e5$export$2881499e37b75b9a), {
        values: [
            [
                (0, $424592b5daddcd29$export$9afb8bc826b033ea),
                {
                    slots: {
                        [(0, $12ee5c1d62d6b2e5$export$c62b8e45d58ddad9)]: labelProps,
                        label: labelProps,
                        description: descriptionProps
                    }
                }
            ],
            [
                (0, $50e2ea1c2adde70a$export$c9549807523555e0),
                {
                    isSelected: states.isSelected
                }
            ]
        ]
    }, renderProps.children));
});
function $eddedc696190b9ab$var$$eed445e0843c11d0$var$ListBoxDropIndicatorWrapper(props, ref) {
    ref = (0, $426ce7b4b2df0896$export$4338b53315abf666)(ref);
    let { dragAndDropHooks: dragAndDropHooks, dropState: dropState } = (0, $acw62.useContext)((0, $ff9bfcb76836598c$export$d188a835a7bc5783));
    let { dropIndicatorProps: dropIndicatorProps, isHidden: isHidden, isDropTarget: isDropTarget } = dragAndDropHooks.useDropIndicator(props, dropState, ref);
    if (isHidden) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eddedc696190b9ab$var$$eed445e0843c11d0$var$ListBoxDropIndicatorForwardRef, {
        ...props,
        dropIndicatorProps: dropIndicatorProps,
        isDropTarget: isDropTarget,
        ref: ref
    });
}
function $eddedc696190b9ab$var$$eed445e0843c11d0$var$ListBoxDropIndicator(props, ref) {
    let { dropIndicatorProps: dropIndicatorProps, isDropTarget: isDropTarget, ...otherProps } = props;
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        ...otherProps,
        defaultClassName: 'react-aria-DropIndicator',
        values: {
            isDropTarget: isDropTarget
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...dropIndicatorProps,
        ...renderProps,
        // eslint-disable-next-line
        role: "option",
        ref: ref,
        "data-drop-target": isDropTarget || undefined
    });
}
const $eddedc696190b9ab$var$$eed445e0843c11d0$var$ListBoxDropIndicatorForwardRef = (0, $acw62.forwardRef)($eddedc696190b9ab$var$$eed445e0843c11d0$var$ListBoxDropIndicator);
const $eddedc696190b9ab$export$8e6d031a08cf56a1 = (0, $5fe83fb7b4e6e89f$export$18af5c7a9e9b3664)((0, $168b0e08d3f28116$export$8258a0665a675899), function ListBoxLoadingIndicator(props, ref, item) {
    let state = (0, $acw62.useContext)($eddedc696190b9ab$export$7c5906fe4f1f2af2);
    let { isLoading: isLoading, onLoadMore: onLoadMore, scrollOffset: scrollOffset, ...otherProps } = props;
    let sentinelRef = (0, $acw62.useRef)(null);
    let memoedLoadMoreProps = (0, $acw62.useMemo)(()=>({
            onLoadMore: onLoadMore,
            collection: state === null || state === void 0 ? void 0 : state.collection,
            sentinelRef: sentinelRef,
            scrollOffset: scrollOffset
        }), [
        onLoadMore,
        scrollOffset,
        state === null || state === void 0 ? void 0 : state.collection
    ]);
    (0, $986b93eb6b4466d6$export$ccaea96c28e8b9e7)(memoedLoadMoreProps, sentinelRef);
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        ...otherProps,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-ListBoxLoadingIndicator',
        values: null
    });
    let optionProps = {
        // For Android talkback
        tabIndex: -1
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'relative',
            width: 0,
            height: 0
        },
        inert: (0, $9493f3225e995d9d$export$a9d04c5684123369)(true)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "loadMoreSentinel",
        ref: sentinelRef,
        style: {
            position: 'absolute',
            height: 1,
            width: 1
        }
    })), isLoading && renderProps.children && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)((0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
            global: true
        }), optionProps),
        ...renderProps,
        // aria-selected isn't needed here since this option is not selectable.
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ref: ref
    }, renderProps.children));
});









var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $98dede014d81daac$export$2de4954e8ae13b9f = (0, $acw62.createContext)({
    placement: 'bottom'
});
const $98dede014d81daac$export$746d02f47f4d381 = (0, $acw62.forwardRef)(function OverlayArrow(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $98dede014d81daac$export$2de4954e8ae13b9f);
    let placement = props.placement;
    let style = {
        position: 'absolute',
        transform: placement === 'top' || placement === 'bottom' ? 'translateX(-50%)' : 'translateY(-50%)'
    };
    if (placement != null) style[placement] = '100%';
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        ...props,
        defaultClassName: 'react-aria-OverlayArrow',
        values: {
            placement: placement
        }
    });
    // remove undefined values from renderProps.style object so that it can be
    // spread merged with the other style object
    if (renderProps.style) Object.keys(renderProps.style).forEach((key)=>renderProps.style[key] === undefined && delete renderProps.style[key]);
    let DOMProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...DOMProps,
        ...renderProps,
        style: {
            ...style,
            ...renderProps.style
        },
        ref: ref,
        "data-placement": placement
    });
});



var $76644b93d9ae3743$export$2e2bcd8739ae039 = {};
$76644b93d9ae3743$export$2e2bcd8739ae039 = {
    "dismiss": `\u{62A}\u{62C}\u{627}\u{647}\u{644}`
};


var $1fed27579ffd118e$export$2e2bcd8739ae039 = {};
$1fed27579ffd118e$export$2e2bcd8739ae039 = {
    "dismiss": `\u{41E}\u{442}\u{445}\u{432}\u{44A}\u{440}\u{43B}\u{44F}\u{43D}\u{435}`
};


var $8a20028173d3348e$export$2e2bcd8739ae039 = {};
$8a20028173d3348e$export$2e2bcd8739ae039 = {
    "dismiss": `Odstranit`
};


var $e11a1b57a758547a$export$2e2bcd8739ae039 = {};
$e11a1b57a758547a$export$2e2bcd8739ae039 = {
    "dismiss": `Luk`
};


var $02a67ebaf18a164c$export$2e2bcd8739ae039 = {};
$02a67ebaf18a164c$export$2e2bcd8739ae039 = {
    "dismiss": `Schlie\xdfen`
};


var $03a6114c39389d94$export$2e2bcd8739ae039 = {};
$03a6114c39389d94$export$2e2bcd8739ae039 = {
    "dismiss": `\u{391}\u{3C0}\u{3CC}\u{3C1}\u{3C1}\u{3B9}\u{3C8}\u{3B7}`
};


var $847a9fef4fe3b867$export$2e2bcd8739ae039 = {};
$847a9fef4fe3b867$export$2e2bcd8739ae039 = {
    "dismiss": `Dismiss`
};


var $3c2a26739c9289f1$export$2e2bcd8739ae039 = {};
$3c2a26739c9289f1$export$2e2bcd8739ae039 = {
    "dismiss": `Descartar`
};


var $4c657c88aba442c8$export$2e2bcd8739ae039 = {};
$4c657c88aba442c8$export$2e2bcd8739ae039 = {
    "dismiss": `L\xf5peta`
};


var $83ee2bd9cb3ed7c6$export$2e2bcd8739ae039 = {};
$83ee2bd9cb3ed7c6$export$2e2bcd8739ae039 = {
    "dismiss": `Hylk\xe4\xe4`
};


var $5104feff75c038a7$export$2e2bcd8739ae039 = {};
$5104feff75c038a7$export$2e2bcd8739ae039 = {
    "dismiss": `Rejeter`
};


var $15bb54895babfb3f$export$2e2bcd8739ae039 = {};
$15bb54895babfb3f$export$2e2bcd8739ae039 = {
    "dismiss": `\u{5D4}\u{5EA}\u{5E2}\u{5DC}\u{5DD}`
};


var $d433d48afe79a6cc$export$2e2bcd8739ae039 = {};
$d433d48afe79a6cc$export$2e2bcd8739ae039 = {
    "dismiss": `Odbaci`
};


var $dca082ae8b2ff949$export$2e2bcd8739ae039 = {};
$dca082ae8b2ff949$export$2e2bcd8739ae039 = {
    "dismiss": `Elutas\xedt\xe1s`
};


var $3649ec1d76b72d96$export$2e2bcd8739ae039 = {};
$3649ec1d76b72d96$export$2e2bcd8739ae039 = {
    "dismiss": `Ignora`
};


var $366c2e7c21f3c780$export$2e2bcd8739ae039 = {};
$366c2e7c21f3c780$export$2e2bcd8739ae039 = {
    "dismiss": `\u{9589}\u{3058}\u{308B}`
};


var $0599f489c3ac11e3$export$2e2bcd8739ae039 = {};
$0599f489c3ac11e3$export$2e2bcd8739ae039 = {
    "dismiss": `\u{BB34}\u{C2DC}`
};


var $7d1715c99d1d0757$export$2e2bcd8739ae039 = {};
$7d1715c99d1d0757$export$2e2bcd8739ae039 = {
    "dismiss": `Atmesti`
};


var $2b65718aaef6be39$export$2e2bcd8739ae039 = {};
$2b65718aaef6be39$export$2e2bcd8739ae039 = {
    "dismiss": `Ner\u{101}d\u{12B}t`
};


var $9376615fb5283fc2$export$2e2bcd8739ae039 = {};
$9376615fb5283fc2$export$2e2bcd8739ae039 = {
    "dismiss": `Lukk`
};


var $077e89479eebaa6e$export$2e2bcd8739ae039 = {};
$077e89479eebaa6e$export$2e2bcd8739ae039 = {
    "dismiss": `Negeren`
};


var $34e628a737262fa8$export$2e2bcd8739ae039 = {};
$34e628a737262fa8$export$2e2bcd8739ae039 = {
    "dismiss": `Zignoruj`
};


var $66c322adaf3604c0$export$2e2bcd8739ae039 = {};
$66c322adaf3604c0$export$2e2bcd8739ae039 = {
    "dismiss": `Descartar`
};


var $3a9494b0547c7213$export$2e2bcd8739ae039 = {};
$3a9494b0547c7213$export$2e2bcd8739ae039 = {
    "dismiss": `Dispensar`
};


var $c821a0f7f9aae411$export$2e2bcd8739ae039 = {};
$c821a0f7f9aae411$export$2e2bcd8739ae039 = {
    "dismiss": `Revocare`
};


var $57e96b5c446bfa3f$export$2e2bcd8739ae039 = {};
$57e96b5c446bfa3f$export$2e2bcd8739ae039 = {
    "dismiss": `\u{41F}\u{440}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{442}\u{44C}`
};


var $990592be0c7c3bba$export$2e2bcd8739ae039 = {};
$990592be0c7c3bba$export$2e2bcd8739ae039 = {
    "dismiss": `Zru\u{161}i\u{165}`
};


var $d329371cbb072ebe$export$2e2bcd8739ae039 = {};
$d329371cbb072ebe$export$2e2bcd8739ae039 = {
    "dismiss": `Opusti`
};


var $8f0b98702c8db9e9$export$2e2bcd8739ae039 = {};
$8f0b98702c8db9e9$export$2e2bcd8739ae039 = {
    "dismiss": `Odbaci`
};


var $26a545e3429c6933$export$2e2bcd8739ae039 = {};
$26a545e3429c6933$export$2e2bcd8739ae039 = {
    "dismiss": `Avvisa`
};


var $71404bb7b7999c5a$export$2e2bcd8739ae039 = {};
$71404bb7b7999c5a$export$2e2bcd8739ae039 = {
    "dismiss": `Kapat`
};


var $2fa81663524b5286$export$2e2bcd8739ae039 = {};
$2fa81663524b5286$export$2e2bcd8739ae039 = {
    "dismiss": `\u{421}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}`
};


var $fe0bd9593db5d7bf$export$2e2bcd8739ae039 = {};
$fe0bd9593db5d7bf$export$2e2bcd8739ae039 = {
    "dismiss": `\u{53D6}\u{6D88}`
};


var $ea81bfc06dced2a4$export$2e2bcd8739ae039 = {};
$ea81bfc06dced2a4$export$2e2bcd8739ae039 = {
    "dismiss": `\u{95DC}\u{9589}`
};


var $99d0fd38555b4082$export$2e2bcd8739ae039 = {};
$99d0fd38555b4082$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $76644b93d9ae3743$export$2e2bcd8739ae039),
    "bg-BG": (0, $1fed27579ffd118e$export$2e2bcd8739ae039),
    "cs-CZ": (0, $8a20028173d3348e$export$2e2bcd8739ae039),
    "da-DK": (0, $e11a1b57a758547a$export$2e2bcd8739ae039),
    "de-DE": (0, $02a67ebaf18a164c$export$2e2bcd8739ae039),
    "el-GR": (0, $03a6114c39389d94$export$2e2bcd8739ae039),
    "en-US": (0, $847a9fef4fe3b867$export$2e2bcd8739ae039),
    "es-ES": (0, $3c2a26739c9289f1$export$2e2bcd8739ae039),
    "et-EE": (0, $4c657c88aba442c8$export$2e2bcd8739ae039),
    "fi-FI": (0, $83ee2bd9cb3ed7c6$export$2e2bcd8739ae039),
    "fr-FR": (0, $5104feff75c038a7$export$2e2bcd8739ae039),
    "he-IL": (0, $15bb54895babfb3f$export$2e2bcd8739ae039),
    "hr-HR": (0, $d433d48afe79a6cc$export$2e2bcd8739ae039),
    "hu-HU": (0, $dca082ae8b2ff949$export$2e2bcd8739ae039),
    "it-IT": (0, $3649ec1d76b72d96$export$2e2bcd8739ae039),
    "ja-JP": (0, $366c2e7c21f3c780$export$2e2bcd8739ae039),
    "ko-KR": (0, $0599f489c3ac11e3$export$2e2bcd8739ae039),
    "lt-LT": (0, $7d1715c99d1d0757$export$2e2bcd8739ae039),
    "lv-LV": (0, $2b65718aaef6be39$export$2e2bcd8739ae039),
    "nb-NO": (0, $9376615fb5283fc2$export$2e2bcd8739ae039),
    "nl-NL": (0, $077e89479eebaa6e$export$2e2bcd8739ae039),
    "pl-PL": (0, $34e628a737262fa8$export$2e2bcd8739ae039),
    "pt-BR": (0, $66c322adaf3604c0$export$2e2bcd8739ae039),
    "pt-PT": (0, $3a9494b0547c7213$export$2e2bcd8739ae039),
    "ro-RO": (0, $c821a0f7f9aae411$export$2e2bcd8739ae039),
    "ru-RU": (0, $57e96b5c446bfa3f$export$2e2bcd8739ae039),
    "sk-SK": (0, $990592be0c7c3bba$export$2e2bcd8739ae039),
    "sl-SI": (0, $d329371cbb072ebe$export$2e2bcd8739ae039),
    "sr-SP": (0, $8f0b98702c8db9e9$export$2e2bcd8739ae039),
    "sv-SE": (0, $26a545e3429c6933$export$2e2bcd8739ae039),
    "tr-TR": (0, $71404bb7b7999c5a$export$2e2bcd8739ae039),
    "uk-UA": (0, $2fa81663524b5286$export$2e2bcd8739ae039),
    "zh-CN": (0, $fe0bd9593db5d7bf$export$2e2bcd8739ae039),
    "zh-TW": (0, $ea81bfc06dced2a4$export$2e2bcd8739ae039)
};



var $acw62 = parcelRequire("acw62");


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $79f23ee9c19a1f41$var$$5b160d28a433310d$var$localeSymbol = Symbol.for('react-aria.i18n.locale');
const $79f23ee9c19a1f41$var$$5b160d28a433310d$var$stringsSymbol = Symbol.for('react-aria.i18n.strings');
let $79f23ee9c19a1f41$var$$5b160d28a433310d$var$cachedGlobalStrings = undefined;
class $79f23ee9c19a1f41$export$c17fa47878dc55b6 {
    /** Returns a localized string for the given key and locale. */ getStringForLocale(key, locale) {
        let strings = this.getStringsForLocale(locale);
        let string = strings[key];
        if (!string) throw new Error(`Could not find intl message ${key} in ${locale} locale`);
        return string;
    }
    /** Returns all localized strings for the given locale. */ getStringsForLocale(locale) {
        let strings = this.strings[locale];
        if (!strings) {
            strings = $79f23ee9c19a1f41$var$$5b160d28a433310d$var$getStringsForLocale(locale, this.strings, this.defaultLocale);
            this.strings[locale] = strings;
        }
        return strings;
    }
    static getGlobalDictionaryForPackage(packageName) {
        if (typeof window === 'undefined') return null;
        let locale = window[$79f23ee9c19a1f41$var$$5b160d28a433310d$var$localeSymbol];
        if ($79f23ee9c19a1f41$var$$5b160d28a433310d$var$cachedGlobalStrings === undefined) {
            let globalStrings = window[$79f23ee9c19a1f41$var$$5b160d28a433310d$var$stringsSymbol];
            if (!globalStrings) return null;
            $79f23ee9c19a1f41$var$$5b160d28a433310d$var$cachedGlobalStrings = {};
            for(let pkg in globalStrings)$79f23ee9c19a1f41$var$$5b160d28a433310d$var$cachedGlobalStrings[pkg] = new $79f23ee9c19a1f41$export$c17fa47878dc55b6({
                [locale]: globalStrings[pkg]
            }, locale);
        }
        let dictionary = $79f23ee9c19a1f41$var$$5b160d28a433310d$var$cachedGlobalStrings === null || $79f23ee9c19a1f41$var$$5b160d28a433310d$var$cachedGlobalStrings === void 0 ? void 0 : $79f23ee9c19a1f41$var$$5b160d28a433310d$var$cachedGlobalStrings[packageName];
        if (!dictionary) throw new Error(`Strings for package "${packageName}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
        return dictionary;
    }
    constructor(messages, defaultLocale = 'en-US'){
        // Clone messages so we don't modify the original object.
        // Filter out entries with falsy values which may have been caused by applying optimize-locales-plugin.
        this.strings = Object.fromEntries(Object.entries(messages).filter(([, v])=>v));
        this.defaultLocale = defaultLocale;
    }
}
function $79f23ee9c19a1f41$var$$5b160d28a433310d$var$getStringsForLocale(locale, strings, defaultLocale = 'en-US') {
    // If there is an exact match, use it.
    if (strings[locale]) return strings[locale];
    // Attempt to find the closest match by language.
    // For example, if the locale is fr-CA (French Canadian), but there is only
    // an fr-FR (France) set of strings, use that.
    // This could be replaced with Intl.LocaleMatcher once it is supported.
    // https://github.com/tc39/proposal-intl-localematcher
    let language = $79f23ee9c19a1f41$var$$5b160d28a433310d$var$getLanguage(locale);
    if (strings[language]) return strings[language];
    for(let key in strings){
        if (key.startsWith(language + '-')) return strings[key];
    }
    // Nothing close, use english.
    return strings[defaultLocale];
}
function $79f23ee9c19a1f41$var$$5b160d28a433310d$var$getLanguage(locale) {
    // @ts-ignore
    if (Intl.Locale) return new Intl.Locale(locale).language;
    return locale.split('-')[0];
}

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c5ee7683f5e0da84$var$$6db58dc88e78b024$var$pluralRulesCache = new Map();
const $c5ee7683f5e0da84$var$$6db58dc88e78b024$var$numberFormatCache = new Map();
class $c5ee7683f5e0da84$export$2f817fcdc4b89ae0 {
    /** Formats a localized string for the given key with the provided variables. */ format(key, variables) {
        let message = this.strings.getStringForLocale(key, this.locale);
        return typeof message === 'function' ? message(variables, this) : message;
    }
    plural(count, options, type = 'cardinal') {
        let opt = options['=' + count];
        if (opt) return typeof opt === 'function' ? opt() : opt;
        let key = this.locale + ':' + type;
        let pluralRules = $c5ee7683f5e0da84$var$$6db58dc88e78b024$var$pluralRulesCache.get(key);
        if (!pluralRules) {
            pluralRules = new Intl.PluralRules(this.locale, {
                type: type
            });
            $c5ee7683f5e0da84$var$$6db58dc88e78b024$var$pluralRulesCache.set(key, pluralRules);
        }
        let selected = pluralRules.select(count);
        opt = options[selected] || options.other;
        return typeof opt === 'function' ? opt() : opt;
    }
    number(value) {
        let numberFormat = $c5ee7683f5e0da84$var$$6db58dc88e78b024$var$numberFormatCache.get(this.locale);
        if (!numberFormat) {
            numberFormat = new Intl.NumberFormat(this.locale);
            $c5ee7683f5e0da84$var$$6db58dc88e78b024$var$numberFormatCache.set(this.locale, numberFormat);
        }
        return numberFormat.format(value);
    }
    select(options, value) {
        let opt = options[value] || options.other;
        return typeof opt === 'function' ? opt() : opt;
    }
    constructor(locale, strings){
        this.locale = locale;
        this.strings = strings;
    }
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $3681d06d99b0f841$var$$fca6afa0e843324b$var$cache = new WeakMap();
function $3681d06d99b0f841$var$$fca6afa0e843324b$var$getCachedDictionary(strings) {
    let dictionary = $3681d06d99b0f841$var$$fca6afa0e843324b$var$cache.get(strings);
    if (!dictionary) {
        dictionary = new (0, $79f23ee9c19a1f41$export$c17fa47878dc55b6)(strings);
        $3681d06d99b0f841$var$$fca6afa0e843324b$var$cache.set(strings, dictionary);
    }
    return dictionary;
}
function $3681d06d99b0f841$export$87b761675e8eaa10(strings, packageName) {
    return packageName && (0, $79f23ee9c19a1f41$export$c17fa47878dc55b6).getGlobalDictionaryForPackage(packageName) || $3681d06d99b0f841$var$$fca6afa0e843324b$var$getCachedDictionary(strings);
}
function $3681d06d99b0f841$export$f12b703ca79dfbb1(strings, packageName) {
    let { locale: locale } = (0, $a7e3b1109bf64033$export$43bb16f9c6d9e3f7)();
    let dictionary = $3681d06d99b0f841$export$87b761675e8eaa10(strings, packageName);
    return (0, $acw62.useMemo)(()=>new (0, $c5ee7683f5e0da84$export$2f817fcdc4b89ae0)(locale, dictionary), [
        locale,
        dictionary
    ]);
}



function $b9f96be5f9deb791$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b9f96be5f9deb791$export$2317d149ed6f78c4(props) {
    let { onDismiss: onDismiss, ...otherProps } = props;
    let stringFormatter = (0, $3681d06d99b0f841$export$f12b703ca79dfbb1)($b9f96be5f9deb791$var$$parcel$interopDefault((0, $99d0fd38555b4082$export$2e2bcd8739ae039)), '@react-aria/overlays');
    let labels = (0, $ad7d494fae923873$export$d6875122194c7b44)(otherProps, stringFormatter.format('dismiss'));
    let onClick = ()=>{
        if (onDismiss) onDismiss();
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2b6fccd6bf1aab09$export$439d29a4e110a164), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ...labels,
        tabIndex: -1,
        onClick: onClick,
        style: {
            width: 1,
            height: 1
        }
    }));
}


var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $927a6f3069887f1d$export$60d741e20e0aa309 = (0, $acw62.createContext)({});
function $927a6f3069887f1d$export$78efe591171d7d45(props) {
    let { getContainer: getContainer } = props;
    let { getContainer: ctxGetContainer } = $927a6f3069887f1d$export$9fc1347d4195ccb3();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($927a6f3069887f1d$export$60d741e20e0aa309.Provider, {
        value: {
            getContainer: getContainer === null ? undefined : getContainer !== null && getContainer !== void 0 ? getContainer : ctxGetContainer
        }
    }, props.children);
}
function $927a6f3069887f1d$export$9fc1347d4195ccb3() {
    var _useContext;
    return (_useContext = (0, $acw62.useContext)($927a6f3069887f1d$export$60d741e20e0aa309)) !== null && _useContext !== void 0 ? _useContext : {};
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $682dc91e15d197fb$export$3351871ee4b288b8 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ children: children, ...props }, ref)=>{
    let isRegistered = (0, $acw62.useRef)(false);
    let prevContext = (0, $acw62.useContext)((0, $c8e06b8dad0b260d$export$5165eccb35aaadb5));
    ref = (0, $426ce7b4b2df0896$export$4338b53315abf666)(ref || (prevContext === null || prevContext === void 0 ? void 0 : prevContext.ref));
    let context = (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(prevContext || {}, {
        ...props,
        ref: ref,
        register () {
            isRegistered.current = true;
            if (prevContext) prevContext.register();
        }
    });
    (0, $6a29d2bb7f5a367f$export$4debdb1a3f0fa79e)(prevContext, ref);
    (0, $acw62.useEffect)(()=>{
        if (!isRegistered.current) isRegistered.current = true; // only warn once in strict mode.
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c8e06b8dad0b260d$export$5165eccb35aaadb5).Provider, {
        value: context
    }, children);
});
function $682dc91e15d197fb$export$cf75428e0b9ed1ea({ children: children }) {
    let context = (0, $acw62.useMemo)(()=>({
            register: ()=>{}
        }), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c8e06b8dad0b260d$export$5165eccb35aaadb5).Provider, {
        value: context
    }, children);
}




var $acw62 = parcelRequire("acw62");



/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $47b79271f309ea43$export$a2200b96afd16271 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $47b79271f309ea43$export$c6fdb837b070b4ff(props) {
    let isSSR = (0, $3355288d61aeabc2$export$535bd6ca7f90a273)();
    let { portalContainer: portalContainer = isSSR ? null : document.body, isExiting: isExiting } = props;
    let [contain, setContain] = (0, $acw62.useState)(false);
    let contextValue = (0, $acw62.useMemo)(()=>({
            contain: contain,
            setContain: setContain
        }), [
        contain,
        setContain
    ]);
    let { getContainer: getContainer } = (0, $927a6f3069887f1d$export$9fc1347d4195ccb3)();
    if (!props.portalContainer && getContainer) portalContainer = getContainer();
    if (!portalContainer) return null;
    let contents = props.children;
    if (!props.disableFocusManagement) contents = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dd1b249b49caa281$export$20e40289641fbbb6), {
        restoreFocus: true,
        contain: (props.shouldContainFocus || contain) && !isExiting
    }, contents);
    contents = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($47b79271f309ea43$export$a2200b96afd16271.Provider, {
        value: contextValue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $682dc91e15d197fb$export$cf75428e0b9ed1ea), null, contents));
    return (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(contents, portalContainer);
}
function $47b79271f309ea43$export$14c98a7594375490() {
    let ctx = (0, $acw62.useContext)($47b79271f309ea43$export$a2200b96afd16271);
    let setContain = ctx === null || ctx === void 0 ? void 0 : ctx.setContain;
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        setContain === null || setContain === void 0 || setContain(true);
    }, [
        setContain
    ]);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $35c480da0fc20955$var$$5e3802645cc19319$var$supportsInert = typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
// Keeps a ref count of all hidden elements. Added to when hiding an element, and
// subtracted from when showing it again. When it reaches zero, aria-hidden is removed.
let $35c480da0fc20955$var$$5e3802645cc19319$var$refCountMap = new WeakMap();
let $35c480da0fc20955$var$$5e3802645cc19319$var$observerStack = [];
function $35c480da0fc20955$export$1c3ebcada18427bf(targets, options) {
    let windowObj = (0, $48852fd65b79e251$export$f21a1ffae260145a)(targets === null || targets === void 0 ? void 0 : targets[0]);
    let opts = options instanceof windowObj.Element ? {
        root: options
    } : options;
    var _opts_root;
    let root = (_opts_root = opts === null || opts === void 0 ? void 0 : opts.root) !== null && _opts_root !== void 0 ? _opts_root : document.body;
    let shouldUseInert = (opts === null || opts === void 0 ? void 0 : opts.shouldUseInert) && $35c480da0fc20955$var$$5e3802645cc19319$var$supportsInert;
    let visibleNodes = new Set(targets);
    let hiddenNodes = new Set();
    let getHidden = (element)=>{
        return shouldUseInert && element instanceof windowObj.HTMLElement ? element.inert : element.getAttribute('aria-hidden') === 'true';
    };
    let setHidden = (element, hidden)=>{
        if (shouldUseInert && element instanceof windowObj.HTMLElement) element.inert = hidden;
        else if (hidden) element.setAttribute('aria-hidden', 'true');
        else {
            element.removeAttribute('aria-hidden');
            if (element instanceof windowObj.HTMLElement) // we are trying to make the element visible to screen readers again, so remove inert as well
            element.inert = false;
        }
    };
    let walk = (root)=>{
        // Keep live announcer and top layer elements (e.g. toasts) visible.
        for (let element of root.querySelectorAll('[data-live-announcer], [data-react-aria-top-layer]'))visibleNodes.add(element);
        let acceptNode = (node)=>{
            // Skip this node and its children if it is one of the target nodes, or a live announcer.
            // Also skip children of already hidden nodes, as aria-hidden is recursive. An exception is
            // made for elements with role="row" since VoiceOver on iOS has issues hiding elements with role="row".
            // For that case we want to hide the cells inside as well (https://bugs.webkit.org/show_bug.cgi?id=222623).
            if (hiddenNodes.has(node) || visibleNodes.has(node) || node.parentElement && hiddenNodes.has(node.parentElement) && node.parentElement.getAttribute('role') !== 'row') return NodeFilter.FILTER_REJECT;
            // Skip this node but continue to children if one of the targets is inside the node.
            for (let target of visibleNodes){
                if (node.contains(target)) return NodeFilter.FILTER_SKIP;
            }
            return NodeFilter.FILTER_ACCEPT;
        };
        let walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
            acceptNode: acceptNode
        });
        // TreeWalker does not include the root.
        let acceptRoot = acceptNode(root);
        if (acceptRoot === NodeFilter.FILTER_ACCEPT) hide(root);
        if (acceptRoot !== NodeFilter.FILTER_REJECT) {
            let node = walker.nextNode();
            while(node != null){
                hide(node);
                node = walker.nextNode();
            }
        }
    };
    let hide = (node)=>{
        var _refCountMap_get;
        let refCount = (_refCountMap_get = $35c480da0fc20955$var$$5e3802645cc19319$var$refCountMap.get(node)) !== null && _refCountMap_get !== void 0 ? _refCountMap_get : 0;
        // If already aria-hidden, and the ref count is zero, then this element
        // was already hidden and there's nothing for us to do.
        if (getHidden(node) && refCount === 0) return;
        if (refCount === 0) setHidden(node, true);
        hiddenNodes.add(node);
        $35c480da0fc20955$var$$5e3802645cc19319$var$refCountMap.set(node, refCount + 1);
    };
    // If there is already a MutationObserver listening from a previous call,
    // disconnect it so the new on takes over.
    if ($35c480da0fc20955$var$$5e3802645cc19319$var$observerStack.length) $35c480da0fc20955$var$$5e3802645cc19319$var$observerStack[$35c480da0fc20955$var$$5e3802645cc19319$var$observerStack.length - 1].disconnect();
    walk(root);
    let observer = new MutationObserver((changes)=>{
        for (let change of changes){
            if (change.type !== 'childList') continue;
            // If the parent element of the added nodes is not within one of the targets,
            // and not already inside a hidden node, hide all of the new children.
            if (![
                ...visibleNodes,
                ...hiddenNodes
            ].some((node)=>node.contains(change.target))) for (let node of change.addedNodes){
                if ((node instanceof HTMLElement || node instanceof SVGElement) && (node.dataset.liveAnnouncer === 'true' || node.dataset.reactAriaTopLayer === 'true')) visibleNodes.add(node);
                else if (node instanceof Element) walk(node);
            }
        }
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
    let observerWrapper = {
        visibleNodes: visibleNodes,
        hiddenNodes: hiddenNodes,
        observe () {
            observer.observe(root, {
                childList: true,
                subtree: true
            });
        },
        disconnect () {
            observer.disconnect();
        }
    };
    $35c480da0fc20955$var$$5e3802645cc19319$var$observerStack.push(observerWrapper);
    return ()=>{
        observer.disconnect();
        for (let node of hiddenNodes){
            let count = $35c480da0fc20955$var$$5e3802645cc19319$var$refCountMap.get(node);
            if (count == null) continue;
            if (count === 1) {
                setHidden(node, false);
                $35c480da0fc20955$var$$5e3802645cc19319$var$refCountMap.delete(node);
            } else $35c480da0fc20955$var$$5e3802645cc19319$var$refCountMap.set(node, count - 1);
        }
        // Remove this observer from the stack, and start the previous one.
        if (observerWrapper === $35c480da0fc20955$var$$5e3802645cc19319$var$observerStack[$35c480da0fc20955$var$$5e3802645cc19319$var$observerStack.length - 1]) {
            $35c480da0fc20955$var$$5e3802645cc19319$var$observerStack.pop();
            if ($35c480da0fc20955$var$$5e3802645cc19319$var$observerStack.length) $35c480da0fc20955$var$$5e3802645cc19319$var$observerStack[$35c480da0fc20955$var$$5e3802645cc19319$var$observerStack.length - 1].observe();
        } else $35c480da0fc20955$var$$5e3802645cc19319$var$observerStack.splice($35c480da0fc20955$var$$5e3802645cc19319$var$observerStack.indexOf(observerWrapper), 1);
    };
}
function $35c480da0fc20955$export$1020fa7f77e17884(element) {
    let observer = $35c480da0fc20955$var$$5e3802645cc19319$var$observerStack[$35c480da0fc20955$var$$5e3802645cc19319$var$observerStack.length - 1];
    if (observer && !observer.visibleNodes.has(element)) {
        observer.visibleNodes.add(element);
        return ()=>{
            observer.visibleNodes.delete(element);
        };
    }
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $1c3a968762f1c435$var$$edcf132a9284368a$var$AXIS = {
    top: 'top',
    bottom: 'top',
    left: 'left',
    right: 'left'
};
const $1c3a968762f1c435$var$$edcf132a9284368a$var$FLIPPED_DIRECTION = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
const $1c3a968762f1c435$var$$edcf132a9284368a$var$CROSS_AXIS = {
    top: 'left',
    left: 'top'
};
const $1c3a968762f1c435$var$$edcf132a9284368a$var$AXIS_SIZE = {
    top: 'height',
    left: 'width'
};
const $1c3a968762f1c435$var$$edcf132a9284368a$var$TOTAL_SIZE = {
    width: 'totalWidth',
    height: 'totalHeight'
};
const $1c3a968762f1c435$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE = {};
let $1c3a968762f1c435$var$$edcf132a9284368a$var$getVisualViewport = ()=>typeof document !== 'undefined' ? window.visualViewport : null;
function $1c3a968762f1c435$var$$edcf132a9284368a$var$getContainerDimensions(containerNode, visualViewport) {
    let width = 0, height = 0, totalWidth = 0, totalHeight = 0, top = 0, left = 0;
    let scroll = {};
    var _visualViewport_scale;
    let isPinchZoomedIn = ((_visualViewport_scale = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.scale) !== null && _visualViewport_scale !== void 0 ? _visualViewport_scale : 1) > 1;
    // In the case where the container is `html` or `body` and the container doesn't have something like `position: relative`,
    // then position absolute will be positioned relative to the viewport, also known as the `initial containing block`.
    // That's why we use the visual viewport instead.
    if (containerNode.tagName === 'BODY' || containerNode.tagName === 'HTML') {
        let documentElement = document.documentElement;
        totalWidth = documentElement.clientWidth;
        totalHeight = documentElement.clientHeight;
        var _visualViewport_width;
        width = (_visualViewport_width = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.width) !== null && _visualViewport_width !== void 0 ? _visualViewport_width : totalWidth;
        var _visualViewport_height;
        height = (_visualViewport_height = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.height) !== null && _visualViewport_height !== void 0 ? _visualViewport_height : totalHeight;
        scroll.top = documentElement.scrollTop || containerNode.scrollTop;
        scroll.left = documentElement.scrollLeft || containerNode.scrollLeft;
        // The goal of the below is to get a top/left value that represents the top/left of the visual viewport with
        // respect to the layout viewport origin. This combined with the scrollTop/scrollLeft will allow us to calculate
        // coordinates/values with respect to the visual viewport or with respect to the layout viewport.
        if (visualViewport) {
            top = visualViewport.offsetTop;
            left = visualViewport.offsetLeft;
        }
    } else {
        ({ width: width, height: height, top: top, left: left } = $1c3a968762f1c435$var$$edcf132a9284368a$var$getOffset(containerNode, false));
        scroll.top = containerNode.scrollTop;
        scroll.left = containerNode.scrollLeft;
        totalWidth = width;
        totalHeight = height;
    }
    if ((0, $c0699bc5a0b3191f$export$78551043582a6a98)() && (containerNode.tagName === 'BODY' || containerNode.tagName === 'HTML') && isPinchZoomedIn) {
        // Safari will report a non-zero scrollTop/Left for the non-scrolling body/HTML element when pinch zoomed in unlike other browsers.
        // Set to zero for parity calculations so we get consistent positioning of overlays across all browsers.
        // Also switch to visualViewport.pageTop/pageLeft so that we still accomodate for scroll positioning for body/HTML elements that are actually scrollable
        // before pinch zoom happens
        scroll.top = 0;
        scroll.left = 0;
        var _visualViewport_pageTop;
        top = (_visualViewport_pageTop = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.pageTop) !== null && _visualViewport_pageTop !== void 0 ? _visualViewport_pageTop : 0;
        var _visualViewport_pageLeft;
        left = (_visualViewport_pageLeft = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.pageLeft) !== null && _visualViewport_pageLeft !== void 0 ? _visualViewport_pageLeft : 0;
    }
    return {
        width: width,
        height: height,
        totalWidth: totalWidth,
        totalHeight: totalHeight,
        scroll: scroll,
        top: top,
        left: left
    };
}
function $1c3a968762f1c435$var$$edcf132a9284368a$var$getScroll(node) {
    return {
        top: node.scrollTop,
        left: node.scrollLeft,
        width: node.scrollWidth,
        height: node.scrollHeight
    };
}
// Determines the amount of space required when moving the overlay to ensure it remains in the boundary
function $1c3a968762f1c435$var$$edcf132a9284368a$var$getDelta(axis, offset, size, // positioned within (most of the time this is the <body>).
boundaryDimensions, // positioned relative to (e.g. parent with position: relative).
// Usually this is the same as the boundary element, but if the popover
// is portaled somewhere other than the body and has an ancestor with
// position: relative/absolute, it will be different.
containerDimensions, padding, containerOffsetWithBoundary) {
    var _containerDimensions_scroll_axis;
    let containerScroll = (_containerDimensions_scroll_axis = containerDimensions.scroll[axis]) !== null && _containerDimensions_scroll_axis !== void 0 ? _containerDimensions_scroll_axis : 0;
    // The height/width of the boundary. Matches the axis along which we are adjusting the overlay position
    let boundarySize = boundaryDimensions[$1c3a968762f1c435$var$$edcf132a9284368a$var$AXIS_SIZE[axis]];
    // Calculate the edges of the boundary (accomodating for the boundary padding) and the edges of the overlay.
    // Note that these values are with respect to the visual viewport (aka 0,0 is the top left of the viewport)
    let boundaryStartEdge = containerOffsetWithBoundary[axis] + boundaryDimensions.scroll[$1c3a968762f1c435$var$$edcf132a9284368a$var$AXIS[axis]] + padding;
    let boundaryEndEdge = containerOffsetWithBoundary[axis] + boundaryDimensions.scroll[$1c3a968762f1c435$var$$edcf132a9284368a$var$AXIS[axis]] + boundarySize - padding;
    // transformed value of the left edge of the overlay
    let startEdgeOffset = offset - containerScroll + boundaryDimensions.scroll[$1c3a968762f1c435$var$$edcf132a9284368a$var$AXIS[axis]] + containerOffsetWithBoundary[axis] - boundaryDimensions[$1c3a968762f1c435$var$$edcf132a9284368a$var$AXIS[axis]];
    // transformed value of the right edge of the overlay
    let endEdgeOffset = offset - containerScroll + size + boundaryDimensions.scroll[$1c3a968762f1c435$var$$edcf132a9284368a$var$AXIS[axis]] + containerOffsetWithBoundary[axis] - boundaryDimensions[$1c3a968762f1c435$var$$edcf132a9284368a$var$AXIS[axis]];
    // If any of the overlay edges falls outside of the boundary, shift the overlay the required amount to align one of the overlay's
    // edges with the closest boundary edge.
    if (startEdgeOffset < boundaryStartEdge) return boundaryStartEdge - startEdgeOffset;
    else if (endEdgeOffset > boundaryEndEdge) return Math.max(boundaryEndEdge - endEdgeOffset, boundaryStartEdge - startEdgeOffset);
    else return 0;
}
function $1c3a968762f1c435$var$$edcf132a9284368a$var$getMargins(node) {
    let style = window.getComputedStyle(node);
    return {
        top: parseInt(style.marginTop, 10) || 0,
        bottom: parseInt(style.marginBottom, 10) || 0,
        left: parseInt(style.marginLeft, 10) || 0,
        right: parseInt(style.marginRight, 10) || 0
    };
}
function $1c3a968762f1c435$var$$edcf132a9284368a$var$parsePlacement(input) {
    if ($1c3a968762f1c435$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input]) return $1c3a968762f1c435$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
    let [placement, crossPlacement] = input.split(' ');
    let axis = $1c3a968762f1c435$var$$edcf132a9284368a$var$AXIS[placement] || 'right';
    let crossAxis = $1c3a968762f1c435$var$$edcf132a9284368a$var$CROSS_AXIS[axis];
    if (!$1c3a968762f1c435$var$$edcf132a9284368a$var$AXIS[crossPlacement]) crossPlacement = 'center';
    let size = $1c3a968762f1c435$var$$edcf132a9284368a$var$AXIS_SIZE[axis];
    let crossSize = $1c3a968762f1c435$var$$edcf132a9284368a$var$AXIS_SIZE[crossAxis];
    $1c3a968762f1c435$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input] = {
        placement: placement,
        crossPlacement: crossPlacement,
        axis: axis,
        crossAxis: crossAxis,
        size: size,
        crossSize: crossSize
    };
    return $1c3a968762f1c435$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
}
function $1c3a968762f1c435$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset, containerDimensions) {
    let { placement: placement, crossPlacement: crossPlacement, axis: axis, crossAxis: crossAxis, size: size, crossSize: crossSize } = placementInfo;
    let position = {};
    var _childOffset_crossAxis;
    // button position
    position[crossAxis] = (_childOffset_crossAxis = childOffset[crossAxis]) !== null && _childOffset_crossAxis !== void 0 ? _childOffset_crossAxis : 0;
    var _childOffset_crossSize, _overlaySize_crossSize, _childOffset_crossSize1, _overlaySize_crossSize1;
    if (crossPlacement === 'center') // at this point the overlay center should match the button center
    position[crossAxis] += (((_childOffset_crossSize = childOffset[crossSize]) !== null && _childOffset_crossSize !== void 0 ? _childOffset_crossSize : 0) - ((_overlaySize_crossSize = overlaySize[crossSize]) !== null && _overlaySize_crossSize !== void 0 ? _overlaySize_crossSize : 0)) / 2;
    else if (crossPlacement !== crossAxis) // at this point the overlay bottom should match the button bottom
    position[crossAxis] += ((_childOffset_crossSize1 = childOffset[crossSize]) !== null && _childOffset_crossSize1 !== void 0 ? _childOffset_crossSize1 : 0) - ((_overlaySize_crossSize1 = overlaySize[crossSize]) !== null && _overlaySize_crossSize1 !== void 0 ? _overlaySize_crossSize1 : 0);
    /* else {
    the overlay top should match the button top
  } */ position[crossAxis] += crossOffset;
    // overlay top or left overlapping arrow with button bottom or right
    const minPosition = childOffset[crossAxis] - overlaySize[crossSize] + arrowSize + arrowBoundaryOffset;
    // overlay bottom or right overlapping arrow with button top or left
    const maxPosition = childOffset[crossAxis] + childOffset[crossSize] - arrowSize - arrowBoundaryOffset;
    position[crossAxis] = (0, $bd1873f619f62ffd$export$7d15b64cf5a3a4c4)(position[crossAxis], minPosition, maxPosition);
    // Floor these so the position isn't placed on a partial pixel, only whole pixels. Shouldn't matter if it was floored or ceiled, so chose one.
    if (placement === axis) {
        // If the container is positioned (non-static), then we use the container's actual
        // height, as `bottom` will be relative to this height.  But if the container is static,
        // then it can only be the `document.body`, and `bottom` will be relative to _its_
        // container.
        let containerHeight = isContainerPositioned ? containerDimensions[size] : containerDimensions[$1c3a968762f1c435$var$$edcf132a9284368a$var$TOTAL_SIZE[size]];
        position[$1c3a968762f1c435$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] = Math.floor(containerHeight - childOffset[axis] + offset);
    } else position[axis] = Math.floor(childOffset[axis] + childOffset[size] + offset);
    return position;
}
function $1c3a968762f1c435$var$$edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlayHeight, heightGrowthDirection, containerDimensions, isContainerDescendentOfBoundary, visualViewport) {
    var _position_bottom, _containerDimensions_scroll_top;
    // For cases where position is set via "bottom" instead of "top", we need to calculate the true overlay top
    // with respect to the container.
    let overlayTop = (position.top != null ? position.top : containerDimensions[$1c3a968762f1c435$var$$edcf132a9284368a$var$TOTAL_SIZE.height] - ((_position_bottom = position.bottom) !== null && _position_bottom !== void 0 ? _position_bottom : 0) - overlayHeight) - ((_containerDimensions_scroll_top = containerDimensions.scroll.top) !== null && _containerDimensions_scroll_top !== void 0 ? _containerDimensions_scroll_top : 0);
    // calculate the dimentions of the "boundingRect" which is most restrictive top/bottom of the boundaryRect and the visual view port
    let boundaryToContainerTransformOffset = isContainerDescendentOfBoundary ? containerOffsetWithBoundary.top : 0;
    var _visualViewport_offsetTop, _visualViewport_offsetTop1, _visualViewport_height;
    let boundingRect = {
        // This should be boundary top in container coord system vs viewport top in container coord system
        // For the viewport top, there are several cases
        // 1. pinchzoom case where we want the viewports offset top as top here
        // 2. case where container is offset from the boundary and is contained by the boundary. In this case the top we want here is NOT 0, we want to take boundary's top even though is is a negative number OR the visual viewport, whichever is more restrictive
        top: Math.max(boundaryDimensions.top + boundaryToContainerTransformOffset, ((_visualViewport_offsetTop = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.offsetTop) !== null && _visualViewport_offsetTop !== void 0 ? _visualViewport_offsetTop : boundaryDimensions.top) + boundaryToContainerTransformOffset),
        bottom: Math.min(boundaryDimensions.top + boundaryDimensions.height + boundaryToContainerTransformOffset, ((_visualViewport_offsetTop1 = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.offsetTop) !== null && _visualViewport_offsetTop1 !== void 0 ? _visualViewport_offsetTop1 : 0) + ((_visualViewport_height = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.height) !== null && _visualViewport_height !== void 0 ? _visualViewport_height : 0))
    };
    var _margins_top, _margins_bottom, _margins_top1, _margins_bottom1;
    let maxHeight = heightGrowthDirection !== 'top' ? Math.max(0, boundingRect.bottom // this is the bottom of the boundary
     - overlayTop // this is the top of the overlay
     - (((_margins_top = margins.top) !== null && _margins_top !== void 0 ? _margins_top : 0) + ((_margins_bottom = margins.bottom) !== null && _margins_bottom !== void 0 ? _margins_bottom : 0) + padding // save additional space for margin and padding
    )) : Math.max(0, overlayTop + overlayHeight // this is the bottom of the overlay
     - boundingRect.top // this is the top of the boundary
     - (((_margins_top1 = margins.top) !== null && _margins_top1 !== void 0 ? _margins_top1 : 0) + ((_margins_bottom1 = margins.bottom) !== null && _margins_bottom1 !== void 0 ? _margins_bottom1 : 0) + padding // save additional space for margin and padding
    ));
    return maxHeight;
}
function $1c3a968762f1c435$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding, placementInfo, containerDimensions, isContainerDescendentOfBoundary) {
    let { placement: placement, axis: axis, size: size } = placementInfo;
    var _containerDimensions_scroll_axis, _margins_axis;
    if (placement === axis) return Math.max(0, childOffset[axis] // trigger start
     - ((_containerDimensions_scroll_axis = containerDimensions.scroll[axis]) !== null && _containerDimensions_scroll_axis !== void 0 ? _containerDimensions_scroll_axis : 0 // transform trigger position to be with respect to viewport 0,0
    ) - (boundaryDimensions[axis] + (isContainerDescendentOfBoundary ? containerOffsetWithBoundary[axis] : 0 // boundary start
    )) - ((_margins_axis = margins[axis]) !== null && _margins_axis !== void 0 ? _margins_axis : 0 // margins usually for arrows or other decorations
    ) - margins[$1c3a968762f1c435$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding); // padding between overlay and boundary
    var _containerDimensions_scroll_axis1, _margins_axis1;
    return Math.max(0, boundaryDimensions[size] + boundaryDimensions[axis] + (isContainerDescendentOfBoundary ? containerOffsetWithBoundary[axis] : 0) - childOffset[axis] - childOffset[size] + ((_containerDimensions_scroll_axis1 = containerDimensions.scroll[axis]) !== null && _containerDimensions_scroll_axis1 !== void 0 ? _containerDimensions_scroll_axis1 : 0) - ((_margins_axis1 = margins[axis]) !== null && _margins_axis1 !== void 0 ? _margins_axis1 : 0) - margins[$1c3a968762f1c435$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
}
function $1c3a968762f1c435$export$6839422d1f33cee9(placementInput, childOffset, overlaySize, scrollSize, margins, padding, flip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, userSetMaxHeight, arrowSize, arrowBoundaryOffset, isContainerDescendentOfBoundary, visualViewport) {
    let placementInfo = $1c3a968762f1c435$var$$edcf132a9284368a$var$parsePlacement(placementInput);
    let { size: size, crossAxis: crossAxis, crossSize: crossSize, placement: placement, crossPlacement: crossPlacement } = placementInfo;
    let position = $1c3a968762f1c435$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset, containerDimensions);
    let normalizedOffset = offset;
    let space = $1c3a968762f1c435$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, placementInfo, containerDimensions, isContainerDescendentOfBoundary);
    // Check if the scroll size of the overlay is greater than the available space to determine if we need to flip
    if (flip && overlaySize[size] > space) {
        let flippedPlacementInfo = $1c3a968762f1c435$var$$edcf132a9284368a$var$parsePlacement(`${$1c3a968762f1c435$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[placement]} ${crossPlacement}`);
        let flippedPosition = $1c3a968762f1c435$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, flippedPlacementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset, containerDimensions);
        let flippedSpace = $1c3a968762f1c435$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, flippedPlacementInfo, containerDimensions, isContainerDescendentOfBoundary);
        // If the available space for the flipped position is greater than the original available space, flip.
        if (flippedSpace > space) {
            placementInfo = flippedPlacementInfo;
            position = flippedPosition;
            normalizedOffset = offset;
        }
    }
    // Determine the direction the height of the overlay can grow so that we can choose how to calculate the max height
    let heightGrowthDirection = 'bottom';
    if (placementInfo.axis === 'top') {
        if (placementInfo.placement === 'top') heightGrowthDirection = 'top';
        else if (placementInfo.placement === 'bottom') heightGrowthDirection = 'bottom';
    } else if (placementInfo.crossAxis === 'top') {
        if (placementInfo.crossPlacement === 'top') heightGrowthDirection = 'bottom';
        else if (placementInfo.crossPlacement === 'bottom') heightGrowthDirection = 'top';
    }
    let delta = $1c3a968762f1c435$var$$edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
    position[crossAxis] += delta;
    let maxHeight = $1c3a968762f1c435$var$$edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlaySize.height, heightGrowthDirection, containerDimensions, isContainerDescendentOfBoundary, visualViewport);
    if (userSetMaxHeight && userSetMaxHeight < maxHeight) maxHeight = userSetMaxHeight;
    overlaySize.height = Math.min(overlaySize.height, maxHeight);
    position = $1c3a968762f1c435$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, normalizedOffset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset, containerDimensions);
    delta = $1c3a968762f1c435$var$$edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
    position[crossAxis] += delta;
    let arrowPosition = {};
    // All values are transformed so that 0 is at the top/left of the overlay depending on the orientation
    // Prefer the arrow being in the center of the trigger/overlay anchor element
    // childOffset[crossAxis] + .5 * childOffset[crossSize] = absolute position with respect to the trigger's coordinate system that would place the arrow in the center of the trigger
    // position[crossAxis] - margins[AXIS[crossAxis]] = value use to transform the position to a value with respect to the overlay's coordinate system. A child element's (aka arrow) position absolute's "0"
    // is positioned after the margin of its parent (aka overlay) so we need to subtract it to get the proper coordinate transform
    let origin = childOffset[crossAxis] - position[crossAxis] - margins[$1c3a968762f1c435$var$$edcf132a9284368a$var$AXIS[crossAxis]];
    let preferredArrowPosition = origin + .5 * childOffset[crossSize];
    // Min/Max position limits for the arrow with respect to the overlay
    const arrowMinPosition = arrowSize / 2 + arrowBoundaryOffset;
    var _margins_left, _margins_right, _margins_top, _margins_bottom;
    // overlaySize[crossSize] - margins = true size of the overlay
    const overlayMargin = $1c3a968762f1c435$var$$edcf132a9284368a$var$AXIS[crossAxis] === 'left' ? ((_margins_left = margins.left) !== null && _margins_left !== void 0 ? _margins_left : 0) + ((_margins_right = margins.right) !== null && _margins_right !== void 0 ? _margins_right : 0) : ((_margins_top = margins.top) !== null && _margins_top !== void 0 ? _margins_top : 0) + ((_margins_bottom = margins.bottom) !== null && _margins_bottom !== void 0 ? _margins_bottom : 0);
    const arrowMaxPosition = overlaySize[crossSize] - overlayMargin - arrowSize / 2 - arrowBoundaryOffset;
    // Min/Max position limits for the arrow with respect to the trigger/overlay anchor element
    // Same margin accomodation done here as well as for the preferredArrowPosition
    const arrowOverlappingChildMinEdge = childOffset[crossAxis] + arrowSize / 2 - (position[crossAxis] + margins[$1c3a968762f1c435$var$$edcf132a9284368a$var$AXIS[crossAxis]]);
    const arrowOverlappingChildMaxEdge = childOffset[crossAxis] + childOffset[crossSize] - arrowSize / 2 - (position[crossAxis] + margins[$1c3a968762f1c435$var$$edcf132a9284368a$var$AXIS[crossAxis]]);
    // Clamp the arrow positioning so that it always is within the bounds of the anchor and the overlay
    const arrowPositionOverlappingChild = (0, $bd1873f619f62ffd$export$7d15b64cf5a3a4c4)(preferredArrowPosition, arrowOverlappingChildMinEdge, arrowOverlappingChildMaxEdge);
    arrowPosition[crossAxis] = (0, $bd1873f619f62ffd$export$7d15b64cf5a3a4c4)(arrowPositionOverlappingChild, arrowMinPosition, arrowMaxPosition);
    // If there is an arrow, use that as the origin so that animations are smooth.
    // Otherwise use the target edge.
    ({ placement: placement, crossPlacement: crossPlacement } = placementInfo);
    if (arrowSize) origin = arrowPosition[crossAxis];
    else if (crossPlacement === 'right') origin += childOffset[crossSize];
    else if (crossPlacement === 'center') origin += childOffset[crossSize] / 2;
    let crossOrigin = placement === 'left' || placement === 'top' ? overlaySize[size] : 0;
    let triggerAnchorPoint = {
        x: placement === 'top' || placement === 'bottom' ? origin : crossOrigin,
        y: placement === 'left' || placement === 'right' ? origin : crossOrigin
    };
    return {
        position: position,
        maxHeight: maxHeight,
        arrowOffsetLeft: arrowPosition.left,
        arrowOffsetTop: arrowPosition.top,
        placement: placement,
        triggerAnchorPoint: triggerAnchorPoint
    };
}
function $1c3a968762f1c435$export$b3ceb0cbf1056d98(opts) {
    let { placement: placement, targetNode: targetNode, overlayNode: overlayNode, scrollNode: scrollNode, padding: padding, shouldFlip: shouldFlip, boundaryElement: boundaryElement, offset: offset, crossOffset: crossOffset, maxHeight: maxHeight, arrowSize: arrowSize = 0, arrowBoundaryOffset: arrowBoundaryOffset = 0 } = opts;
    let visualViewport = $1c3a968762f1c435$var$$edcf132a9284368a$var$getVisualViewport();
    let container = overlayNode instanceof HTMLElement ? $1c3a968762f1c435$var$$edcf132a9284368a$var$getContainingBlock(overlayNode) : document.documentElement;
    let isViewportContainer = container === document.documentElement;
    const containerPositionStyle = window.getComputedStyle(container).position;
    let isContainerPositioned = !!containerPositionStyle && containerPositionStyle !== 'static';
    let childOffset = isViewportContainer ? $1c3a968762f1c435$var$$edcf132a9284368a$var$getOffset(targetNode, false) : $1c3a968762f1c435$var$$edcf132a9284368a$var$getPosition(targetNode, container, false);
    if (!isViewportContainer) {
        let { marginTop: marginTop, marginLeft: marginLeft } = window.getComputedStyle(targetNode);
        childOffset.top += parseInt(marginTop, 10) || 0;
        childOffset.left += parseInt(marginLeft, 10) || 0;
    }
    let overlaySize = $1c3a968762f1c435$var$$edcf132a9284368a$var$getOffset(overlayNode, true);
    let margins = $1c3a968762f1c435$var$$edcf132a9284368a$var$getMargins(overlayNode);
    var _margins_left, _margins_right;
    overlaySize.width += ((_margins_left = margins.left) !== null && _margins_left !== void 0 ? _margins_left : 0) + ((_margins_right = margins.right) !== null && _margins_right !== void 0 ? _margins_right : 0);
    var _margins_top, _margins_bottom;
    overlaySize.height += ((_margins_top = margins.top) !== null && _margins_top !== void 0 ? _margins_top : 0) + ((_margins_bottom = margins.bottom) !== null && _margins_bottom !== void 0 ? _margins_bottom : 0);
    let scrollSize = $1c3a968762f1c435$var$$edcf132a9284368a$var$getScroll(scrollNode);
    // Note that due to logic inside getContainerDimensions, for cases where the boundary element is the body, we will return
    // a height/width that matches the visual viewport size rather than the body's height/width (aka for zoom it will be zoom adjusted size)
    // and a top/left that is adjusted as well (will return the top/left of the zoomed in viewport, or 0,0 for a non-zoomed body)
    // Otherwise this returns the height/width of a arbitrary boundary element, and its top/left with respect to the viewport (NOTE THIS MEANS IT DOESNT INCLUDE SCROLL)
    let boundaryDimensions = $1c3a968762f1c435$var$$edcf132a9284368a$var$getContainerDimensions(boundaryElement, visualViewport);
    let containerDimensions = $1c3a968762f1c435$var$$edcf132a9284368a$var$getContainerDimensions(container, visualViewport);
    // If the container is the HTML element wrapping the body element, the retrieved scrollTop/scrollLeft will be equal to the
    // body element's scroll. Set the container's scroll values to 0 since the overlay's edge position value in getDelta don't then need to be further offset
    // by the container scroll since they are essentially the same containing element and thus in the same coordinate system
    let containerOffsetWithBoundary = $1c3a968762f1c435$var$$edcf132a9284368a$var$getPosition(boundaryElement, container, false);
    let isContainerDescendentOfBoundary = boundaryElement.contains(container);
    return $1c3a968762f1c435$export$6839422d1f33cee9(placement, childOffset, overlaySize, scrollSize, margins, padding, shouldFlip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, maxHeight, arrowSize, arrowBoundaryOffset, isContainerDescendentOfBoundary, visualViewport);
}
function $1c3a968762f1c435$export$4b834cebd9e5cebe(node, ignoreScale) {
    let { top: top, left: left, width: width, height: height } = node.getBoundingClientRect();
    // Use offsetWidth and offsetHeight if this is an HTML element, so that
    // the size is not affected by scale transforms.
    if (ignoreScale && node instanceof node.ownerDocument.defaultView.HTMLElement) {
        width = node.offsetWidth;
        height = node.offsetHeight;
    }
    return {
        top: top,
        left: left,
        width: width,
        height: height
    };
}
function $1c3a968762f1c435$var$$edcf132a9284368a$var$getOffset(node, ignoreScale) {
    let { top: top, left: left, width: width, height: height } = $1c3a968762f1c435$export$4b834cebd9e5cebe(node, ignoreScale);
    let { scrollTop: scrollTop, scrollLeft: scrollLeft, clientTop: clientTop, clientLeft: clientLeft } = document.documentElement;
    return {
        top: top + scrollTop - clientTop,
        left: left + scrollLeft - clientLeft,
        width: width,
        height: height
    };
}
function $1c3a968762f1c435$var$$edcf132a9284368a$var$getPosition(node, parent, ignoreScale) {
    let style = window.getComputedStyle(node);
    let offset;
    if (style.position === 'fixed') offset = $1c3a968762f1c435$export$4b834cebd9e5cebe(node, ignoreScale);
    else {
        offset = $1c3a968762f1c435$var$$edcf132a9284368a$var$getOffset(node, ignoreScale);
        let parentOffset = $1c3a968762f1c435$var$$edcf132a9284368a$var$getOffset(parent, ignoreScale);
        let parentStyle = window.getComputedStyle(parent);
        parentOffset.top += (parseInt(parentStyle.borderTopWidth, 10) || 0) - parent.scrollTop;
        parentOffset.left += (parseInt(parentStyle.borderLeftWidth, 10) || 0) - parent.scrollLeft;
        offset.top -= parentOffset.top;
        offset.left -= parentOffset.left;
    }
    offset.top -= parseInt(style.marginTop, 10) || 0;
    offset.left -= parseInt(style.marginLeft, 10) || 0;
    return offset;
}
// Returns the containing block of an element, which is the element that
// this element will be positioned relative to.
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block
function $1c3a968762f1c435$var$$edcf132a9284368a$var$getContainingBlock(node) {
    // The offsetParent of an element in most cases equals the containing block.
    // https://w3c.github.io/csswg-drafts/cssom-view/#dom-htmlelement-offsetparent
    let offsetParent = node.offsetParent;
    // The offsetParent algorithm terminates at the document body,
    // even if the body is not a containing block. Double check that
    // and use the documentElement if so.
    if (offsetParent && offsetParent === document.body && window.getComputedStyle(offsetParent).position === 'static' && !$1c3a968762f1c435$var$$edcf132a9284368a$var$isContainingBlock(offsetParent)) offsetParent = document.documentElement;
    // TODO(later): handle table elements?
    // The offsetParent can be null if the element has position: fixed, or a few other cases.
    // We have to walk up the tree manually in this case because fixed positioned elements
    // are still positioned relative to their containing block, which is not always the viewport.
    if (offsetParent == null) {
        offsetParent = node.parentElement;
        while(offsetParent && !$1c3a968762f1c435$var$$edcf132a9284368a$var$isContainingBlock(offsetParent))offsetParent = offsetParent.parentElement;
    }
    // Fall back to the viewport.
    return offsetParent || document.documentElement;
}
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
function $1c3a968762f1c435$var$$edcf132a9284368a$var$isContainingBlock(node) {
    let style = window.getComputedStyle(node);
    return style.transform !== 'none' || /transform|perspective/.test(style.willChange) || style.filter !== 'none' || style.contain === 'paint' || 'backdropFilter' in style && style.backdropFilter !== 'none' || 'WebkitBackdropFilter' in style && style.WebkitBackdropFilter !== 'none';
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $54feb6ccb4701e1a$export$f6211563215e3b37 = new WeakMap();
function $54feb6ccb4701e1a$export$18fc8428861184da(opts) {
    let { triggerRef: triggerRef, isOpen: isOpen, onClose: onClose } = opts;
    (0, $acw62.useEffect)(()=>{
        if (!isOpen || onClose === null) return;
        let onScroll = (e)=>{
            // Ignore if scrolling an scrollable region outside the trigger's tree.
            let target = e.target;
            // window is not a Node and doesn't have contain, but window contains everything
            if (!triggerRef.current || target instanceof Node && !target.contains(triggerRef.current)) return;
            // Ignore scroll events on any input or textarea as the cursor position can cause it to scroll
            // such as in a combobox. Clicking the dropdown button places focus on the input, and if the
            // text inside the input extends beyond the 'end', then it will scroll so the cursor is visible at the end.
            if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) return;
            let onCloseHandler = onClose || $54feb6ccb4701e1a$export$f6211563215e3b37.get(triggerRef.current);
            if (onCloseHandler) onCloseHandler();
        };
        window.addEventListener('scroll', onScroll, true);
        return ()=>{
            window.removeEventListener('scroll', onScroll, true);
        };
    }, [
        isOpen,
        onClose,
        triggerRef
    ]);
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $d0b7c56cfad5caf3$var$$9daab02d461809db$var$hasResizeObserver() {
    return typeof window.ResizeObserver !== 'undefined';
}
function $d0b7c56cfad5caf3$export$683480f191c0e3ea(options) {
    // Only call onResize from inside the effect, otherwise we'll void our assumption that
    // useEffectEvents are safe to pass in.
    const { ref: ref, box: box, onResize: onResize } = options;
    let onResizeEvent = (0, $92fff981738f62fe$export$7f54fc3180508a52)(onResize);
    (0, $acw62.useEffect)(()=>{
        let element = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!element) return;
        if (!$d0b7c56cfad5caf3$var$$9daab02d461809db$var$hasResizeObserver()) {
            window.addEventListener('resize', onResizeEvent, false);
            return ()=>{
                window.removeEventListener('resize', onResizeEvent, false);
            };
        } else {
            const resizeObserverInstance = new window.ResizeObserver((entries)=>{
                if (!entries.length) return;
                onResizeEvent();
            });
            resizeObserverInstance.observe(element, {
                box: box
            });
            return ()=>{
                if (element) resizeObserverInstance.unobserve(element);
            };
        }
    }, [
        ref,
        box
    ]);
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport = typeof document !== 'undefined' ? window.visualViewport : null;
function $fad55d9b69e34061$export$d39e1813b3bdd0e1(props) {
    let { direction: direction } = (0, $a7e3b1109bf64033$export$43bb16f9c6d9e3f7)();
    let { arrowSize: arrowSize, targetRef: targetRef, overlayRef: overlayRef, arrowRef: arrowRef, scrollRef: scrollRef = overlayRef, placement: placement = 'bottom', containerPadding: containerPadding = 12, shouldFlip: shouldFlip = true, boundaryElement: boundaryElement = typeof document !== 'undefined' ? document.body : null, offset: offset = 0, crossOffset: crossOffset = 0, shouldUpdatePosition: shouldUpdatePosition = true, isOpen: isOpen = true, onClose: onClose, maxHeight: maxHeight, arrowBoundaryOffset: arrowBoundaryOffset = 0 } = props;
    let [position, setPosition] = (0, $acw62.useState)(null);
    let deps = [
        shouldUpdatePosition,
        placement,
        overlayRef.current,
        targetRef.current,
        arrowRef === null || arrowRef === void 0 ? void 0 : arrowRef.current,
        scrollRef.current,
        containerPadding,
        shouldFlip,
        boundaryElement,
        offset,
        crossOffset,
        isOpen,
        direction,
        maxHeight,
        arrowBoundaryOffset,
        arrowSize
    ];
    // Note, the position freezing breaks if body sizes itself dynamicly with the visual viewport but that might
    // just be a non-realistic use case
    // Upon opening a overlay, record the current visual viewport scale so we can freeze the overlay styles
    let lastScale = (0, $acw62.useRef)($fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport === null || $fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport.scale);
    (0, $acw62.useEffect)(()=>{
        if (isOpen) lastScale.current = $fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport === null || $fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport.scale;
    }, [
        isOpen
    ]);
    let updatePosition = (0, $acw62.useCallback)(()=>{
        if (shouldUpdatePosition === false || !isOpen || !overlayRef.current || !targetRef.current || !boundaryElement) return;
        if (($fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport === null || $fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport.scale) !== lastScale.current) return;
        // Determine a scroll anchor based on the focused element.
        // This stores the offset of the anchor element from the scroll container
        // so it can be restored after repositioning. This way if the overlay height
        // changes, the focused element appears to stay in the same position.
        let anchor = null;
        if (scrollRef.current && scrollRef.current.contains(document.activeElement)) {
            var _document_activeElement;
            let anchorRect = (_document_activeElement = document.activeElement) === null || _document_activeElement === void 0 ? void 0 : _document_activeElement.getBoundingClientRect();
            let scrollRect = scrollRef.current.getBoundingClientRect();
            var _anchorRect_top;
            // Anchor from the top if the offset is in the top half of the scrollable element,
            // otherwise anchor from the bottom.
            anchor = {
                type: 'top',
                offset: ((_anchorRect_top = anchorRect === null || anchorRect === void 0 ? void 0 : anchorRect.top) !== null && _anchorRect_top !== void 0 ? _anchorRect_top : 0) - scrollRect.top
            };
            if (anchor.offset > scrollRect.height / 2) {
                anchor.type = 'bottom';
                var _anchorRect_bottom;
                anchor.offset = ((_anchorRect_bottom = anchorRect === null || anchorRect === void 0 ? void 0 : anchorRect.bottom) !== null && _anchorRect_bottom !== void 0 ? _anchorRect_bottom : 0) - scrollRect.bottom;
            }
        }
        // Always reset the overlay's previous max height if not defined by the user so that we can compensate for
        // RAC collections populating after a second render and properly set a correct max height + positioning when it populates.
        let overlay = overlayRef.current;
        if (!maxHeight && overlayRef.current) {
            var _window_visualViewport;
            overlay.style.top = '0px';
            overlay.style.bottom = '';
            var _window_visualViewport_height;
            overlay.style.maxHeight = ((_window_visualViewport_height = (_window_visualViewport = window.visualViewport) === null || _window_visualViewport === void 0 ? void 0 : _window_visualViewport.height) !== null && _window_visualViewport_height !== void 0 ? _window_visualViewport_height : window.innerHeight) + 'px';
        }
        let position = (0, $1c3a968762f1c435$export$b3ceb0cbf1056d98)({
            placement: $fad55d9b69e34061$var$$2a41e45df1593e64$var$translateRTL(placement, direction),
            overlayNode: overlayRef.current,
            targetNode: targetRef.current,
            scrollNode: scrollRef.current || overlayRef.current,
            padding: containerPadding,
            shouldFlip: shouldFlip,
            boundaryElement: boundaryElement,
            offset: offset,
            crossOffset: crossOffset,
            maxHeight: maxHeight,
            arrowSize: arrowSize !== null && arrowSize !== void 0 ? arrowSize : (arrowRef === null || arrowRef === void 0 ? void 0 : arrowRef.current) ? (0, $1c3a968762f1c435$export$4b834cebd9e5cebe)(arrowRef.current, true).width : 0,
            arrowBoundaryOffset: arrowBoundaryOffset
        });
        if (!position.position) return;
        // Modify overlay styles directly so positioning happens immediately without the need of a second render
        // This is so we don't have to delay autoFocus scrolling or delay applying preventScroll for popovers
        overlay.style.top = '';
        overlay.style.bottom = '';
        overlay.style.left = '';
        overlay.style.right = '';
        Object.keys(position.position).forEach((key)=>overlay.style[key] = position.position[key] + 'px');
        overlay.style.maxHeight = position.maxHeight != null ? position.maxHeight + 'px' : '';
        // Restore scroll position relative to anchor element.
        if (anchor && document.activeElement && scrollRef.current) {
            let anchorRect = document.activeElement.getBoundingClientRect();
            let scrollRect = scrollRef.current.getBoundingClientRect();
            let newOffset = anchorRect[anchor.type] - scrollRect[anchor.type];
            scrollRef.current.scrollTop += newOffset - anchor.offset;
        }
        // Trigger a set state for a second render anyway for arrow positioning
        setPosition(position);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(updatePosition, deps);
    // Update position on window resize
    $fad55d9b69e34061$var$$2a41e45df1593e64$var$useResize(updatePosition);
    (0, $d0b7c56cfad5caf3$export$683480f191c0e3ea)({
        ref: overlayRef,
        onResize: updatePosition
    });
    (0, $d0b7c56cfad5caf3$export$683480f191c0e3ea)({
        ref: targetRef,
        onResize: updatePosition
    });
    // Reposition the overlay and do not close on scroll while the visual viewport is resizing.
    // This will ensure that overlays adjust their positioning when the iOS virtual keyboard appears.
    let isResizing = (0, $acw62.useRef)(false);
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        let timeout;
        let onResize = ()=>{
            isResizing.current = true;
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                isResizing.current = false;
            }, 500);
            updatePosition();
        };
        // Only reposition the overlay if a scroll event happens immediately as a result of resize (aka the virtual keyboard has appears)
        // We don't want to reposition the overlay if the user has pinch zoomed in and is scrolling the viewport around.
        let onScroll = ()=>{
            if (isResizing.current) onResize();
        };
        $fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport === null || $fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport === void 0 || $fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport.addEventListener('resize', onResize);
        $fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport === null || $fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport === void 0 || $fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport.addEventListener('scroll', onScroll);
        return ()=>{
            $fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport === null || $fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport === void 0 || $fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport.removeEventListener('resize', onResize);
            $fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport === null || $fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport === void 0 || $fad55d9b69e34061$var$$2a41e45df1593e64$var$visualViewport.removeEventListener('scroll', onScroll);
        };
    }, [
        updatePosition
    ]);
    let close = (0, $acw62.useCallback)(()=>{
        if (!isResizing.current) onClose === null || onClose === void 0 || onClose();
    }, [
        onClose,
        isResizing
    ]);
    (0, $54feb6ccb4701e1a$export$18fc8428861184da)({
        triggerRef: targetRef,
        isOpen: isOpen,
        onClose: onClose && close
    });
    var _position_maxHeight, _position_placement, _position_triggerAnchorPoint;
    return {
        overlayProps: {
            style: {
                position: position ? 'absolute' : 'fixed',
                top: !position ? 0 : undefined,
                left: !position ? 0 : undefined,
                zIndex: 100000,
                ...position === null || position === void 0 ? void 0 : position.position,
                maxHeight: (_position_maxHeight = position === null || position === void 0 ? void 0 : position.maxHeight) !== null && _position_maxHeight !== void 0 ? _position_maxHeight : '100vh'
            }
        },
        placement: (_position_placement = position === null || position === void 0 ? void 0 : position.placement) !== null && _position_placement !== void 0 ? _position_placement : null,
        triggerAnchorPoint: (_position_triggerAnchorPoint = position === null || position === void 0 ? void 0 : position.triggerAnchorPoint) !== null && _position_triggerAnchorPoint !== void 0 ? _position_triggerAnchorPoint : null,
        arrowProps: {
            'aria-hidden': 'true',
            role: 'presentation',
            style: {
                left: position === null || position === void 0 ? void 0 : position.arrowOffsetLeft,
                top: position === null || position === void 0 ? void 0 : position.arrowOffsetTop
            }
        },
        updatePosition: updatePosition
    };
}
function $fad55d9b69e34061$var$$2a41e45df1593e64$var$useResize(onResize) {
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        window.addEventListener('resize', onResize, false);
        return ()=>{
            window.removeEventListener('resize', onResize, false);
        };
    }, [
        onResize
    ]);
}
function $fad55d9b69e34061$var$$2a41e45df1593e64$var$translateRTL(position, direction) {
    if (direction === 'rtl') return position.replace('start', 'right').replace('end', 'left');
    return position.replace('start', 'left').replace('end', 'right');
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $c4a617b17040033d$export$872b660ac5a1ff98(props) {
    let { ref: ref, onInteractOutside: onInteractOutside, isDisabled: isDisabled, onInteractOutsideStart: onInteractOutsideStart } = props;
    let stateRef = (0, $acw62.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false
    });
    let onPointerDown = (0, $92fff981738f62fe$export$7f54fc3180508a52)((e)=>{
        if (onInteractOutside && $c4a617b17040033d$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
            if (onInteractOutsideStart) onInteractOutsideStart(e);
            stateRef.current.isPointerDown = true;
        }
    });
    let triggerInteractOutside = (0, $92fff981738f62fe$export$7f54fc3180508a52)((e)=>{
        if (onInteractOutside) onInteractOutside(e);
    });
    (0, $acw62.useEffect)(()=>{
        let state = stateRef.current;
        if (isDisabled) return;
        const element = ref.current;
        const documentObject = (0, $48852fd65b79e251$export$b204af158042fbac)(element);
        // Use pointer events if available. Otherwise, fall back to mouse and touch events.
        if (typeof PointerEvent !== 'undefined') {
            let onClick = (e)=>{
                if (state.isPointerDown && $c4a617b17040033d$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            // changing these to capture phase fixed combobox
            // Use click instead of pointerup to avoid Android Chrome issue
            // https://issues.chromium.org/issues/40732224
            documentObject.addEventListener('pointerdown', onPointerDown, true);
            documentObject.addEventListener('click', onClick, true);
            return ()=>{
                documentObject.removeEventListener('pointerdown', onPointerDown, true);
                documentObject.removeEventListener('click', onClick, true);
            };
        }
    }, [
        ref,
        isDisabled
    ]);
}
function $c4a617b17040033d$var$$e0b6e0b68ec7f50f$var$isValidEvent(event, ref) {
    if (event.button > 0) return false;
    if (event.target) {
        // if the event target is no longer in the document, ignore
        const ownerDocument = event.target.ownerDocument;
        if (!ownerDocument || !ownerDocument.documentElement.contains(event.target)) return false;
        // If the target is within a top layer element (e.g. toasts), ignore.
        if (event.target.closest('[data-react-aria-top-layer]')) return false;
    }
    if (!ref.current) return false;
    // When the event source is inside a Shadow DOM, event.target is just the shadow root.
    // Using event.composedPath instead means we can get the actual element inside the shadow root.
    // This only works if the shadow root is open, there is no way to detect if it is closed.
    // If the event composed path contains the ref, interaction is inside.
    return !event.composedPath().includes(ref.current);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $954a5e99231682ee$var$$a11501f3d1d39e6c$var$visibleOverlays = [];
function $954a5e99231682ee$export$ea8f71083e90600f(props, ref) {
    let { onClose: onClose, shouldCloseOnBlur: shouldCloseOnBlur, isOpen: isOpen, isDismissable: isDismissable = false, isKeyboardDismissDisabled: isKeyboardDismissDisabled = false, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside } = props;
    (0, $acw62.useEffect)(()=>{
        if (isOpen && !$954a5e99231682ee$var$$a11501f3d1d39e6c$var$visibleOverlays.includes(ref)) {
            $954a5e99231682ee$var$$a11501f3d1d39e6c$var$visibleOverlays.push(ref);
            return ()=>{
                let index = $954a5e99231682ee$var$$a11501f3d1d39e6c$var$visibleOverlays.indexOf(ref);
                if (index >= 0) $954a5e99231682ee$var$$a11501f3d1d39e6c$var$visibleOverlays.splice(index, 1);
            };
        }
    }, [
        isOpen,
        ref
    ]);
    // Only hide the overlay when it is the topmost visible overlay in the stack
    let onHide = ()=>{
        if ($954a5e99231682ee$var$$a11501f3d1d39e6c$var$visibleOverlays[$954a5e99231682ee$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref && onClose) onClose();
    };
    let onInteractOutsideStart = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($954a5e99231682ee$var$$a11501f3d1d39e6c$var$visibleOverlays[$954a5e99231682ee$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
        }
    };
    let onInteractOutside = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($954a5e99231682ee$var$$a11501f3d1d39e6c$var$visibleOverlays[$954a5e99231682ee$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
            onHide();
        }
    };
    // Handle the escape key
    let onKeyDown = (e)=>{
        if (e.key === 'Escape' && !isKeyboardDismissDisabled && !e.nativeEvent.isComposing) {
            e.stopPropagation();
            e.preventDefault();
            onHide();
        }
    };
    (0, $c4a617b17040033d$export$872b660ac5a1ff98)({
        ref: ref,
        onInteractOutside: isDismissable && isOpen ? onInteractOutside : undefined,
        onInteractOutsideStart: onInteractOutsideStart
    });
    let { focusWithinProps: focusWithinProps } = (0, $02fb4773760e27fa$export$420e68273165f4ec)({
        isDisabled: !shouldCloseOnBlur,
        onBlurWithin: (e)=>{
            // Do not close if relatedTarget is null, which means focus is lost to the body.
            // That can happen when switching tabs, or due to a VoiceOver/Chrome bug with Control+Option+Arrow navigation.
            // Clicking on the body to close the overlay should already be handled by useInteractOutside.
            // https://github.com/adobe/react-spectrum/issues/4130
            // https://github.com/adobe/react-spectrum/issues/4922
            //
            // If focus is moving into a child focus scope (e.g. menu inside a dialog),
            // do not close the outer overlay. At this point, the active scope should
            // still be the outer overlay, since blur events run before focus.
            if (!e.relatedTarget || (0, $dd1b249b49caa281$export$1258395f99bf9cbf)(e.relatedTarget)) return;
            if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.relatedTarget)) onClose === null || onClose === void 0 || onClose();
        }
    });
    let onPointerDownUnderlay = (e)=>{
        // fixes a firefox issue that starts text selection https://bugzilla.mozilla.org/show_bug.cgi?id=1675846
        if (e.target === e.currentTarget) e.preventDefault();
    };
    return {
        overlayProps: {
            onKeyDown: onKeyDown,
            ...focusWithinProps
        },
        underlayProps: {
            onPointerDown: onPointerDownUnderlay
        }
    };
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $759242c8ff1bf230$var$$49c51c25361d4cd2$var$visualViewport = typeof document !== 'undefined' && window.visualViewport;
// The number of active usePreventScroll calls. Used to determine whether to revert back to the original page style/scroll position
let $759242c8ff1bf230$var$$49c51c25361d4cd2$var$preventScrollCount = 0;
let $759242c8ff1bf230$var$$49c51c25361d4cd2$var$restore;
function $759242c8ff1bf230$export$ee0f7cc6afcd1c18(options = {}) {
    let { isDisabled: isDisabled } = options;
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        if (isDisabled) return;
        $759242c8ff1bf230$var$$49c51c25361d4cd2$var$preventScrollCount++;
        if ($759242c8ff1bf230$var$$49c51c25361d4cd2$var$preventScrollCount === 1) {
            if ((0, $c0699bc5a0b3191f$export$fedb369cb70207f1)()) $759242c8ff1bf230$var$$49c51c25361d4cd2$var$restore = $759242c8ff1bf230$var$$49c51c25361d4cd2$var$preventScrollMobileSafari();
            else $759242c8ff1bf230$var$$49c51c25361d4cd2$var$restore = $759242c8ff1bf230$var$$49c51c25361d4cd2$var$preventScrollStandard();
        }
        return ()=>{
            $759242c8ff1bf230$var$$49c51c25361d4cd2$var$preventScrollCount--;
            if ($759242c8ff1bf230$var$$49c51c25361d4cd2$var$preventScrollCount === 0) $759242c8ff1bf230$var$$49c51c25361d4cd2$var$restore();
        };
    }, [
        isDisabled
    ]);
}
// For most browsers, all we need to do is set `overflow: hidden` on the root element, and
// add some padding to prevent the page from shifting when the scrollbar is hidden.
function $759242c8ff1bf230$var$$49c51c25361d4cd2$var$preventScrollStandard() {
    let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return (0, $366a72b5d02721fb$export$e08e3b67e392101e)(scrollbarWidth > 0 && // Use scrollbar-gutter when supported because it also works for fixed positioned elements.
    ('scrollbarGutter' in document.documentElement.style ? $759242c8ff1bf230$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, 'scrollbarGutter', 'stable') : $759242c8ff1bf230$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, 'paddingRight', `${scrollbarWidth}px`)), $759242c8ff1bf230$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, 'overflow', 'hidden'));
}
// Mobile Safari is a whole different beast. Even with overflow: hidden,
// it still scrolls the page in many situations:
//
// 1. When the bottom toolbar and address bar are collapsed, page scrolling is always allowed.
// 2. When the keyboard is visible, the viewport does not resize. Instead, the keyboard covers part of
//    it, so it becomes scrollable.
// 3. When tapping on an input, the page always scrolls so that the input is centered in the visual viewport.
//    This may cause even fixed position elements to scroll off the screen.
// 4. When using the next/previous buttons in the keyboard to navigate between inputs, the whole page always
//    scrolls, even if the input is inside a nested scrollable element that could be scrolled instead.
//
// In order to work around these cases, and prevent scrolling without jankiness, we do a few things:
//
// 1. Prevent default on `touchmove` events that are not in a scrollable element. This prevents touch scrolling
//    on the window.
// 2. Set `overscroll-behavior: contain` on nested scrollable regions so they do not scroll the page when at
//    the top or bottom. Work around a bug where this does not work when the element does not actually overflow
//    by preventing default in a `touchmove` event. This is best effort: we can't prevent default when pinch
//    zooming or when an element contains text selection, which may allow scrolling in some cases.
// 3. Prevent default on `touchend` events on input elements and handle focusing the element ourselves.
// 4. When focus moves to an input, create an off screen input and focus that temporarily. This prevents 
//    Safari from scrolling the page. After a small delay, focus the real input and scroll it into view
//    ourselves, without scrolling the whole page.
function $759242c8ff1bf230$var$$49c51c25361d4cd2$var$preventScrollMobileSafari() {
    let scrollable;
    let allowTouchMove = false;
    let onTouchStart = (e)=>{
        // Store the nearest scrollable parent element from the element that the user touched.
        let target = e.target;
        scrollable = (0, $6468d10c4b206c14$export$2bb74740c4e19def)(target) ? target : (0, $a08583dfd8fd8668$export$cfa2225e87938781)(target, true);
        allowTouchMove = false;
        // If the target is selected, don't preventDefault in touchmove to allow user to adjust selection.
        let selection = target.ownerDocument.defaultView.getSelection();
        if (selection && !selection.isCollapsed && selection.containsNode(target, true)) allowTouchMove = true;
        // If this is a focused input element with a selected range, allow user to drag the selection handles.
        if ('selectionStart' in target && 'selectionEnd' in target && target.selectionStart < target.selectionEnd && target.ownerDocument.activeElement === target) allowTouchMove = true;
    };
    // Prevent scrolling up when at the top and scrolling down when at the bottom
    // of a nested scrollable area, otherwise mobile Safari will start scrolling
    // the window instead.
    // This must be applied before the touchstart event as of iOS 26, so inject it as a <style> element.
    let style = document.createElement('style');
    style.textContent = `
@layer {
  * {
    overscroll-behavior: contain;
  }
}`.trim();
    document.head.prepend(style);
    let onTouchMove = (e)=>{
        // Allow pinch-zooming.
        if (e.touches.length === 2 || allowTouchMove) return;
        // Prevent scrolling the window.
        if (!scrollable || scrollable === document.documentElement || scrollable === document.body) {
            e.preventDefault();
            return;
        }
        // overscroll-behavior should prevent scroll chaining, but currently does not
        // if the element doesn't actually overflow. https://bugs.webkit.org/show_bug.cgi?id=243452
        // This checks that both the width and height do not overflow, otherwise we might
        // block horizontal scrolling too. In that case, adding `touch-action: pan-x` to
        // the element will prevent vertical page scrolling. We can't add that automatically
        // because it must be set before the touchstart event.
        if (scrollable.scrollHeight === scrollable.clientHeight && scrollable.scrollWidth === scrollable.clientWidth) e.preventDefault();
    };
    let onBlur = (e)=>{
        let target = e.target;
        let relatedTarget = e.relatedTarget;
        if (relatedTarget && (0, $8a16f7e89990868c$export$c57958e35f31ed73)(relatedTarget)) {
            // Focus without scrolling the whole page, and then scroll into view manually.
            relatedTarget.focus({
                preventScroll: true
            });
            $759242c8ff1bf230$var$$49c51c25361d4cd2$var$scrollIntoViewWhenReady(relatedTarget, (0, $8a16f7e89990868c$export$c57958e35f31ed73)(target));
        } else if (!relatedTarget) {
            var _target_parentElement;
            // When tapping the Done button on the keyboard, focus moves to the body.
            // FocusScope will then restore focus back to the input. Later when tapping
            // the same input again, it is already focused, so no blur event will fire,
            // resulting in the flow above never running and Safari's native scrolling occurring.
            // Instead, move focus to the parent focusable element (e.g. the dialog).
            let focusable = (_target_parentElement = target.parentElement) === null || _target_parentElement === void 0 ? void 0 : _target_parentElement.closest('[tabindex]');
            focusable === null || focusable === void 0 || focusable.focus({
                preventScroll: true
            });
        }
    };
    // Override programmatic focus to scroll into view without scrolling the whole page.
    let focus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function(opts) {
        // Track whether the keyboard was already visible before.
        let wasKeyboardVisible = document.activeElement != null && (0, $8a16f7e89990868c$export$c57958e35f31ed73)(document.activeElement);
        // Focus the element without scrolling the page.
        focus.call(this, {
            ...opts,
            preventScroll: true
        });
        if (!opts || !opts.preventScroll) $759242c8ff1bf230$var$$49c51c25361d4cd2$var$scrollIntoViewWhenReady(this, wasKeyboardVisible);
    };
    let removeEvents = (0, $366a72b5d02721fb$export$e08e3b67e392101e)($759242c8ff1bf230$var$$49c51c25361d4cd2$var$addEvent(document, 'touchstart', onTouchStart, {
        passive: false,
        capture: true
    }), $759242c8ff1bf230$var$$49c51c25361d4cd2$var$addEvent(document, 'touchmove', onTouchMove, {
        passive: false,
        capture: true
    }), $759242c8ff1bf230$var$$49c51c25361d4cd2$var$addEvent(document, 'blur', onBlur, true));
    return ()=>{
        removeEvents();
        style.remove();
        HTMLElement.prototype.focus = focus;
    };
}
// Sets a CSS property on an element, and returns a function to revert it to the previous value.
function $759242c8ff1bf230$var$$49c51c25361d4cd2$var$setStyle(element, style, value) {
    let cur = element.style[style];
    element.style[style] = value;
    return ()=>{
        element.style[style] = cur;
    };
}
// Adds an event listener to an element, and returns a function to remove it.
function $759242c8ff1bf230$var$$49c51c25361d4cd2$var$addEvent(target, event, handler, options) {
    // internal function, so it's ok to ignore the difficult to fix type error
    // @ts-ignore
    target.addEventListener(event, handler, options);
    return ()=>{
        // @ts-ignore
        target.removeEventListener(event, handler, options);
    };
}
function $759242c8ff1bf230$var$$49c51c25361d4cd2$var$scrollIntoViewWhenReady(target, wasKeyboardVisible) {
    if (wasKeyboardVisible || !$759242c8ff1bf230$var$$49c51c25361d4cd2$var$visualViewport) $759242c8ff1bf230$var$$49c51c25361d4cd2$var$scrollIntoView(target);
    else // measure the correct position to scroll to.
    $759242c8ff1bf230$var$$49c51c25361d4cd2$var$visualViewport.addEventListener('resize', ()=>$759242c8ff1bf230$var$$49c51c25361d4cd2$var$scrollIntoView(target), {
        once: true
    });
}
function $759242c8ff1bf230$var$$49c51c25361d4cd2$var$scrollIntoView(target) {
    let root = document.scrollingElement || document.documentElement;
    let nextTarget = target;
    while(nextTarget && nextTarget !== root){
        // Find the parent scrollable element and adjust the scroll position if the target is not already in view.
        let scrollable = (0, $a08583dfd8fd8668$export$cfa2225e87938781)(nextTarget);
        if (scrollable !== document.documentElement && scrollable !== document.body && scrollable !== nextTarget) {
            let scrollableRect = scrollable.getBoundingClientRect();
            let targetRect = nextTarget.getBoundingClientRect();
            if (targetRect.top < scrollableRect.top || targetRect.bottom > scrollableRect.top + nextTarget.clientHeight) {
                let bottom = scrollableRect.bottom;
                if ($759242c8ff1bf230$var$$49c51c25361d4cd2$var$visualViewport) bottom = Math.min(bottom, $759242c8ff1bf230$var$$49c51c25361d4cd2$var$visualViewport.offsetTop + $759242c8ff1bf230$var$$49c51c25361d4cd2$var$visualViewport.height);
                // Center within the viewport.
                let adjustment = targetRect.top - scrollableRect.top - ((bottom - scrollableRect.top) / 2 - targetRect.height / 2);
                scrollable.scrollTo({
                    // Clamp to the valid range to prevent over-scrolling.
                    top: Math.max(0, Math.min(scrollable.scrollHeight - scrollable.clientHeight, scrollable.scrollTop + adjustment)),
                    behavior: 'smooth'
                });
            }
        }
        nextTarget = scrollable.parentElement;
    }
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2ecbe94d0b669030$export$542a6fd13ac93354(props, state) {
    let { triggerRef: triggerRef, popoverRef: popoverRef, groupRef: groupRef, isNonModal: isNonModal, isKeyboardDismissDisabled: isKeyboardDismissDisabled, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside, ...otherProps } = props;
    let isSubmenu = otherProps['trigger'] === 'SubmenuTrigger';
    let { overlayProps: overlayProps, underlayProps: underlayProps } = (0, $954a5e99231682ee$export$ea8f71083e90600f)({
        isOpen: state.isOpen,
        onClose: state.close,
        shouldCloseOnBlur: true,
        isDismissable: !isNonModal || isSubmenu,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
    }, groupRef !== null && groupRef !== void 0 ? groupRef : popoverRef);
    let { overlayProps: positionProps, arrowProps: arrowProps, placement: placement, triggerAnchorPoint: origin } = (0, $fad55d9b69e34061$export$d39e1813b3bdd0e1)({
        ...otherProps,
        targetRef: triggerRef,
        overlayRef: popoverRef,
        isOpen: state.isOpen,
        onClose: isNonModal && !isSubmenu ? state.close : null
    });
    (0, $759242c8ff1bf230$export$ee0f7cc6afcd1c18)({
        isDisabled: isNonModal || !state.isOpen
    });
    (0, $acw62.useEffect)(()=>{
        if (state.isOpen && popoverRef.current) {
            var _groupRef_current, _groupRef_current1;
            if (isNonModal) return (0, $35c480da0fc20955$export$1020fa7f77e17884)((_groupRef_current = groupRef === null || groupRef === void 0 ? void 0 : groupRef.current) !== null && _groupRef_current !== void 0 ? _groupRef_current : popoverRef.current);
            else return (0, $35c480da0fc20955$export$1c3ebcada18427bf)([
                (_groupRef_current1 = groupRef === null || groupRef === void 0 ? void 0 : groupRef.current) !== null && _groupRef_current1 !== void 0 ? _groupRef_current1 : popoverRef.current
            ], {
                shouldUseInert: true
            });
        }
    }, [
        isNonModal,
        state.isOpen,
        popoverRef,
        groupRef
    ]);
    return {
        popoverProps: (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(overlayProps, positionProps),
        arrowProps: arrowProps,
        underlayProps: underlayProps,
        placement: placement,
        triggerAnchorPoint: origin
    };
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $28725adc419809f4$export$6d3443f2c48bfc20(ref, isReady = true) {
    let [isEntering, setEntering] = (0, $acw62.useState)(true);
    let isAnimationReady = isEntering && isReady;
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        if (isAnimationReady && ref.current && 'getAnimations' in ref.current) {
            for (let animation of ref.current.getAnimations())if (animation instanceof CSSTransition) animation.cancel();
        }
    }, [
        ref,
        isAnimationReady
    ]);
    $28725adc419809f4$var$$d3f049242431219c$var$useAnimation(ref, isAnimationReady, (0, $acw62.useCallback)(()=>setEntering(false), []));
    return isAnimationReady;
}
function $28725adc419809f4$export$45fda7c47f93fd48(ref, isOpen) {
    let [exitState, setExitState] = (0, $acw62.useState)(isOpen ? 'open' : 'closed');
    switch(exitState){
        case 'open':
            // If isOpen becomes false, set the state to exiting.
            if (!isOpen) setExitState('exiting');
            break;
        case 'closed':
        case 'exiting':
            // If we are exiting and isOpen becomes true, the animation was interrupted.
            // Reset the state to open.
            if (isOpen) setExitState('open');
            break;
    }
    let isExiting = exitState === 'exiting';
    $28725adc419809f4$var$$d3f049242431219c$var$useAnimation(ref, isExiting, (0, $acw62.useCallback)(()=>{
        // Set the state to closed, which will cause the element to be unmounted.
        setExitState((state)=>state === 'exiting' ? 'closed' : state);
    }, []));
    return isExiting;
}
function $28725adc419809f4$var$$d3f049242431219c$var$useAnimation(ref, isActive, onEnd) {
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        if (isActive && ref.current) {
            if (!('getAnimations' in ref.current)) {
                // JSDOM
                onEnd();
                return;
            }
            let animations = ref.current.getAnimations();
            if (animations.length === 0) {
                onEnd();
                return;
            }
            let canceled = false;
            Promise.all(animations.map((a)=>a.finished)).then(()=>{
                if (!canceled) (0, $11492dca620dcaa5$exports.flushSync)(()=>{
                    onEnd();
                });
            }).catch(()=>{});
            return ()=>{
                canceled = true;
            };
        }
    }, [
        ref,
        isActive,
        onEnd
    ]);
}




var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9a55ce4a79a9cb0d$export$61c6a8c84e605fb6(props) {
    let [isOpen, setOpen] = (0, $3316814d6906df5c$export$40bfa8c7b0832715)(props.isOpen, props.defaultOpen || false, props.onOpenChange);
    const open = (0, $acw62.useCallback)(()=>{
        setOpen(true);
    }, [
        setOpen
    ]);
    const close = (0, $acw62.useCallback)(()=>{
        setOpen(false);
    }, [
        setOpen
    ]);
    const toggle = (0, $acw62.useCallback)(()=>{
        setOpen(!isOpen);
    }, [
        setOpen,
        isOpen
    ]);
    return {
        isOpen: isOpen,
        setOpen: setOpen,
        open: open,
        close: close,
        toggle: toggle
    };
}



var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $58149d5ffdda7d3e$export$9b9a0cd73afb7ca4 = (0, $acw62.createContext)(null);
// Stores a ref for the portal container for a group of popovers (e.g. submenus).
const $58149d5ffdda7d3e$var$$07b14b47974efb58$var$PopoverGroupContext = (0, $acw62.createContext)(null);
const $58149d5ffdda7d3e$export$5b6b19405a83ff9d = (0, $acw62.forwardRef)(function Popover(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $58149d5ffdda7d3e$export$9b9a0cd73afb7ca4);
    let contextState = (0, $acw62.useContext)((0, $33689c90e5739620$export$d2f961adcb0afbe));
    let localState = (0, $9a55ce4a79a9cb0d$export$61c6a8c84e605fb6)(props);
    let state = props.isOpen != null || props.defaultOpen != null || !contextState ? localState : contextState;
    let isExiting = (0, $28725adc419809f4$export$45fda7c47f93fd48)(ref, state.isOpen) || props.isExiting || false;
    let isHidden = (0, $73addfbf71cdc088$export$b5d7cc18bb8d2b59)();
    let { direction: direction } = (0, $a7e3b1109bf64033$export$43bb16f9c6d9e3f7)();
    // If we are in a hidden tree, we still need to preserve our children.
    if (isHidden) {
        let children = props.children;
        if (typeof children === 'function') children = children({
            trigger: props.trigger || null,
            placement: 'bottom',
            isEntering: false,
            isExiting: false,
            defaultChildren: null
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
    }
    if (state && !state.isOpen && !isExiting) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($58149d5ffdda7d3e$var$$07b14b47974efb58$var$PopoverInner, {
        ...props,
        triggerRef: props.triggerRef,
        state: state,
        popoverRef: ref,
        isExiting: isExiting,
        dir: direction
    });
});
function $58149d5ffdda7d3e$var$$07b14b47974efb58$var$PopoverInner({ state: state, isExiting: isExiting, UNSTABLE_portalContainer: UNSTABLE_portalContainer, clearContexts: clearContexts, ...props }) {
    // Calculate the arrow size internally (and remove props.arrowSize from PopoverProps)
    // Referenced from: packages/@react-spectrum/tooltip/src/TooltipTrigger.tsx
    let arrowRef = (0, $acw62.useRef)(null);
    let containerRef = (0, $acw62.useRef)(null);
    let groupCtx = (0, $acw62.useContext)($58149d5ffdda7d3e$var$$07b14b47974efb58$var$PopoverGroupContext);
    let isSubPopover = groupCtx && props.trigger === 'SubmenuTrigger';
    var _props_offset;
    let { popoverProps: popoverProps, underlayProps: underlayProps, arrowProps: arrowProps, placement: placement, triggerAnchorPoint: triggerAnchorPoint } = (0, $2ecbe94d0b669030$export$542a6fd13ac93354)({
        ...props,
        offset: (_props_offset = props.offset) !== null && _props_offset !== void 0 ? _props_offset : 8,
        arrowRef: arrowRef,
        // If this is a submenu/subdialog, use the root popover's container
        // to detect outside interaction and add aria-hidden.
        groupRef: isSubPopover ? groupCtx : containerRef
    }, state);
    let ref = props.popoverRef;
    let isEntering = (0, $28725adc419809f4$export$6d3443f2c48bfc20)(ref, !!placement) || props.isEntering || false;
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        ...props,
        defaultClassName: 'react-aria-Popover',
        values: {
            trigger: props.trigger || null,
            placement: placement,
            isEntering: isEntering,
            isExiting: isExiting
        }
    });
    // Automatically render Popover with role=dialog except when isNonModal is true,
    // or a dialog is already nested inside the popover.
    let shouldBeDialog = !props.isNonModal || props.trigger === 'SubmenuTrigger';
    let [isDialog, setDialog] = (0, $acw62.useState)(false);
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        if (ref.current) setDialog(shouldBeDialog && !ref.current.querySelector('[role=dialog]'));
    }, [
        ref,
        shouldBeDialog
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isDialog && props.trigger !== 'SubmenuTrigger' && ref.current && !ref.current.contains(document.activeElement)) (0, $f84e6bd16978dcef$export$80f3e147d781571c)(ref.current);
    }, [
        isDialog,
        ref,
        props.trigger
    ]);
    let children = (0, $acw62.useMemo)(()=>{
        let children = renderProps.children;
        if (clearContexts) for (let Context of clearContexts)children = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Context.Provider, {
            value: null
        }, children);
        return children;
    }, [
        renderProps.children,
        clearContexts
    ]);
    let style = {
        ...popoverProps.style,
        '--trigger-anchor-point': triggerAnchorPoint ? `${triggerAnchorPoint.x}px ${triggerAnchorPoint.y}px` : undefined,
        ...renderProps.style
    };
    let overlay = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)((0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
            global: true
        }), popoverProps),
        ...renderProps,
        role: isDialog ? 'dialog' : undefined,
        tabIndex: isDialog ? -1 : undefined,
        "aria-label": props['aria-label'],
        "aria-labelledby": props['aria-labelledby'],
        ref: ref,
        slot: props.slot || undefined,
        style: style,
        dir: props.dir,
        "data-trigger": props.trigger,
        "data-placement": placement,
        "data-entering": isEntering || undefined,
        "data-exiting": isExiting || undefined
    }, !props.isNonModal && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9f96be5f9deb791$export$2317d149ed6f78c4), {
        onDismiss: state.close
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $98dede014d81daac$export$2de4954e8ae13b9f).Provider, {
        value: {
            ...arrowProps,
            placement: placement,
            ref: arrowRef
        }
    }, children), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9f96be5f9deb791$export$2317d149ed6f78c4), {
        onDismiss: state.close
    }));
    // If this is a root popover, render an extra div to act as the portal container for submenus/subdialogs.
    if (!isSubPopover) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $47b79271f309ea43$export$c6fdb837b070b4ff), {
        ...props,
        shouldContainFocus: isDialog,
        isExiting: isExiting,
        portalContainer: UNSTABLE_portalContainer
    }, !props.isNonModal && state.isOpen && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "underlay",
        ...underlayProps,
        style: {
            position: 'fixed',
            inset: 0
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: containerRef,
        style: {
            display: 'contents'
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($58149d5ffdda7d3e$var$$07b14b47974efb58$var$PopoverGroupContext.Provider, {
        value: containerRef
    }, overlay)));
    var _ref;
    // Submenus/subdialogs are mounted into the root popover's container.
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $47b79271f309ea43$export$c6fdb837b070b4ff), {
        ...props,
        shouldContainFocus: isDialog,
        isExiting: isExiting,
        portalContainer: (_ref = UNSTABLE_portalContainer !== null && UNSTABLE_portalContainer !== void 0 ? UNSTABLE_portalContainer : groupCtx === null || groupCtx === void 0 ? void 0 : groupCtx.current) !== null && _ref !== void 0 ? _ref : undefined
    }, overlay);
}








var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $63dcb4594bc5d8f1$export$744d98a3b8a94e1c = (0, $acw62.createContext)({});
const $63dcb4594bc5d8f1$export$16e4d70cc375e707 = (0, $acw62.forwardRef)(function Keyboard(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $63dcb4594bc5d8f1$export$744d98a3b8a94e1c);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("kbd", {
        dir: "ltr",
        ...props,
        ref: ref
    });
});








/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $3c8c8ef9a1ed83e7$export$6f49b4016bfc8d56 = new WeakMap();




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d730431f5e6d2801$export$38eaa17faae8f579(props, state, ref) {
    let { shouldFocusWrap: shouldFocusWrap = true, onKeyDown: onKeyDown, onKeyUp: onKeyUp, ...otherProps } = props;
    !props['aria-label'] && props['aria-labelledby'];
    let domProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let { listProps: listProps } = (0, $26c2006a6c7d87f9$export$b95089534ab7c1fd)({
        ...otherProps,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        shouldFocusWrap: shouldFocusWrap,
        linkBehavior: 'override'
    });
    (0, $3c8c8ef9a1ed83e7$export$6f49b4016bfc8d56).set(state, {
        onClose: props.onClose,
        onAction: props.onAction,
        shouldUseVirtualFocus: props.shouldUseVirtualFocus
    });
    return {
        menuProps: (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(domProps, {
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp
        }, {
            role: 'menu',
            ...listProps,
            onKeyDown: (e)=>{
                var _listProps_onKeyDown;
                // don't clear the menu selected keys if the user is presses escape since escape closes the menu
                if (e.key !== 'Escape' || props.shouldUseVirtualFocus) (_listProps_onKeyDown = listProps.onKeyDown) === null || _listProps_onKeyDown === void 0 || _listProps_onKeyDown.call(listProps, e);
            }
        })
    };
}






var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d9f04a2cc49c8b02$export$9d32628fc2aea7da(props, state, ref) {
    let { id: id, key: key, closeOnSelect: closeOnSelect, isVirtualized: isVirtualized, 'aria-haspopup': hasPopup, onPressStart: onPressStart, onPressUp: pressUpProp, onPress: onPress, onPressChange: pressChangeProp, onPressEnd: onPressEnd, onClick: onClickProp, onHoverStart: hoverStartProp, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onFocus: onFocus, onFocusChange: onFocusChange, onBlur: onBlur, selectionManager: selectionManager = state.selectionManager } = props;
    let isTrigger = !!hasPopup;
    let isTriggerExpanded = isTrigger && props['aria-expanded'] === 'true';
    var _props_isDisabled;
    let isDisabled = (_props_isDisabled = props.isDisabled) !== null && _props_isDisabled !== void 0 ? _props_isDisabled : selectionManager.isDisabled(key);
    var _props_isSelected;
    let isSelected = (_props_isSelected = props.isSelected) !== null && _props_isSelected !== void 0 ? _props_isSelected : selectionManager.isSelected(key);
    let data = (0, $3c8c8ef9a1ed83e7$export$6f49b4016bfc8d56).get(state);
    let item = state.collection.getItem(key);
    let onClose = props.onClose || data.onClose;
    let router = (0, $c9b835cc9e261550$export$9a302a45f65d0572)();
    let performAction = ()=>{
        var _item_props;
        if (isTrigger) return;
        if (item === null || item === void 0 ? void 0 : (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.onAction) item.props.onAction();
        else if (props.onAction) props.onAction(key);
        if (data.onAction) {
            // Must reassign to variable otherwise `this` binding gets messed up. Something to do with WeakMap.
            let onAction = data.onAction;
            onAction(key);
        }
    };
    let role = 'menuitem';
    if (!isTrigger) {
        if (selectionManager.selectionMode === 'single') role = 'menuitemradio';
        else if (selectionManager.selectionMode === 'multiple') role = 'menuitemcheckbox';
    }
    let labelId = (0, $855de91ebb07800c$export$b4cc09c592e8fdb8)();
    let descriptionId = (0, $855de91ebb07800c$export$b4cc09c592e8fdb8)();
    let keyboardId = (0, $855de91ebb07800c$export$b4cc09c592e8fdb8)();
    let ariaProps = {
        id: id,
        'aria-disabled': isDisabled || undefined,
        role: role,
        'aria-label': props['aria-label'],
        'aria-labelledby': labelId,
        'aria-describedby': [
            descriptionId,
            keyboardId
        ].filter(Boolean).join(' ') || undefined,
        'aria-controls': props['aria-controls'],
        'aria-haspopup': hasPopup,
        'aria-expanded': props['aria-expanded']
    };
    if (selectionManager.selectionMode !== 'none' && !isTrigger) ariaProps['aria-checked'] = isSelected;
    if (isVirtualized) {
        ariaProps['aria-posinset'] = item === null || item === void 0 ? void 0 : item.index;
        ariaProps['aria-setsize'] = (0, $1173ed60a7d91dfd$export$77d5aafae4e095b2)(state.collection);
    }
    let isPressedRef = (0, $acw62.useRef)(false);
    let onPressChange = (isPressed)=>{
        pressChangeProp === null || pressChangeProp === void 0 || pressChangeProp(isPressed);
        isPressedRef.current = isPressed;
    };
    let interaction = (0, $acw62.useRef)(null);
    let onPressUp = (e)=>{
        if (e.pointerType !== 'keyboard') interaction.current = {
            pointerType: e.pointerType
        };
        // If interacting with mouse, allow the user to mouse down on the trigger button,
        // drag, and release over an item (matching native behavior).
        if (e.pointerType === 'mouse') {
            if (!isPressedRef.current) e.target.click();
        }
        pressUpProp === null || pressUpProp === void 0 || pressUpProp(e);
    };
    let onClick = (e)=>{
        var _interaction_current, _interaction_current1;
        onClickProp === null || onClickProp === void 0 || onClickProp(e);
        performAction();
        (0, $c9b835cc9e261550$export$13aea1a3cb5e3f1f)(e, router, item.props.href, item === null || item === void 0 ? void 0 : item.props.routerOptions);
        let shouldClose = ((_interaction_current = interaction.current) === null || _interaction_current === void 0 ? void 0 : _interaction_current.pointerType) === 'keyboard' ? ((_interaction_current1 = interaction.current) === null || _interaction_current1 === void 0 ? void 0 : _interaction_current1.key) === 'Enter' || selectionManager.selectionMode === 'none' || selectionManager.isLink(key) : selectionManager.selectionMode !== 'multiple' || selectionManager.isLink(key);
        shouldClose = closeOnSelect !== null && closeOnSelect !== void 0 ? closeOnSelect : shouldClose;
        if (onClose && !isTrigger && shouldClose) onClose();
        interaction.current = null;
    };
    let { itemProps: itemProps, isFocused: isFocused } = (0, $0043bec6983b82da$export$ecf600387e221c37)({
        id: id,
        selectionManager: selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: true,
        allowsDifferentPressOrigin: true,
        // Disable all handling of links in useSelectable item
        // because we handle it ourselves. The behavior of menus
        // is slightly different from other collections because
        // actions are performed on key down rather than key up.
        linkBehavior: 'none',
        shouldUseVirtualFocus: data.shouldUseVirtualFocus
    });
    let { pressProps: pressProps, isPressed: isPressed } = (0, $6c43aa319e86785e$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPress: onPress,
        onPressUp: onPressUp,
        onPressChange: onPressChange,
        onPressEnd: onPressEnd,
        isDisabled: isDisabled
    });
    let { hoverProps: hoverProps } = (0, $8d62ff0ac4dc2be2$export$ae780daf29e6d456)({
        isDisabled: isDisabled,
        onHoverStart (e) {
            // Hovering over an already expanded sub dialog trigger should keep focus in the dialog.
            if (!(0, $77c8ff0a3cb27e18$export$b9b3dfddab17db27)() && !(isTriggerExpanded && hasPopup)) {
                selectionManager.setFocused(true);
                selectionManager.setFocusedKey(key);
            }
            hoverStartProp === null || hoverStartProp === void 0 || hoverStartProp(e);
        },
        onHoverChange: onHoverChange,
        onHoverEnd: onHoverEnd
    });
    let { keyboardProps: keyboardProps } = (0, $72b9a5e52bb6271d$export$8f71654801c2f7cd)({
        onKeyDown: (e)=>{
            // Ignore repeating events, which may have started on the menu trigger before moving
            // focus to the menu item. We want to wait for a second complete key press sequence.
            if (e.repeat) {
                e.continuePropagation();
                return;
            }
            switch(e.key){
                case ' ':
                    interaction.current = {
                        pointerType: 'keyboard',
                        key: ' '
                    };
                    e.target.click();
                    break;
                case 'Enter':
                    interaction.current = {
                        pointerType: 'keyboard',
                        key: 'Enter'
                    };
                    // Trigger click unless this is a link. Links trigger click natively.
                    if (e.target.tagName !== 'A') e.target.click();
                    break;
                default:
                    if (!isTrigger) e.continuePropagation();
                    onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
                    break;
            }
        },
        onKeyUp: onKeyUp
    });
    let { focusProps: focusProps } = (0, $7cd244a03c8a5e7a$export$f8168d8dd8fd66e6)({
        onBlur: onBlur,
        onFocus: onFocus,
        onFocusChange: onFocusChange
    });
    let domProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(item === null || item === void 0 ? void 0 : item.props);
    delete domProps.id;
    let linkProps = (0, $c9b835cc9e261550$export$7e924b3091a3bd18)(item === null || item === void 0 ? void 0 : item.props);
    return {
        menuItemProps: {
            ...ariaProps,
            ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)(domProps, linkProps, isTrigger ? {
                onFocus: itemProps.onFocus,
                'data-collection': itemProps['data-collection'],
                'data-key': itemProps['data-key']
            } : itemProps, pressProps, hoverProps, keyboardProps, focusProps, data.shouldUseVirtualFocus || isTrigger ? {
                onMouseDown: (e)=>e.preventDefault()
            } : undefined, isDisabled ? undefined : {
                onClick: onClick
            }),
            // If a submenu is expanded, set the tabIndex to -1 so that shift tabbing goes out of the menu instead of the parent menu item.
            tabIndex: itemProps.tabIndex != null && isTriggerExpanded && !data.shouldUseVirtualFocus ? -1 : itemProps.tabIndex
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        keyboardShortcutProps: {
            id: keyboardId
        },
        isFocused: isFocused,
        isFocusVisible: isFocused && selectionManager.isFocused && (0, $77c8ff0a3cb27e18$export$b9b3dfddab17db27)() && !isTriggerExpanded,
        isSelected: isSelected,
        isPressed: isPressed,
        isDisabled: isDisabled
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b61889228174484b$export$73f7a44322579622(props) {
    let { heading: heading, 'aria-label': ariaLabel } = props;
    let headingId = (0, $855de91ebb07800c$export$f680877a34711e37)();
    return {
        itemProps: {
            role: 'presentation'
        },
        headingProps: heading ? {
            // Techincally, menus cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, using role="presentation",
            // and only use it as a label for the nested group.
            id: headingId,
            role: 'presentation'
        } : {},
        groupProps: {
            role: 'group',
            'aria-label': ariaLabel,
            'aria-labelledby': heading ? headingId : undefined
        }
    };
}

var $16d32f621839cc62$export$2e2bcd8739ae039 = {};
$16d32f621839cc62$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{627}\u{636}\u{63A}\u{637} \u{645}\u{637}\u{648}\u{644}\u{627}\u{64B} \u{623}\u{648} \u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} Alt + \u{627}\u{644}\u{633}\u{647}\u{645} \u{644}\u{623}\u{633}\u{641}\u{644} \u{644}\u{641}\u{62A}\u{62D} \u{627}\u{644}\u{642}\u{627}\u{626}\u{645}\u{629}`
};


var $fab3daeb7aa11d31$export$2e2bcd8739ae039 = {};
$fab3daeb7aa11d31$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{43F}\u{440}\u{43E}\u{434}\u{44A}\u{43B}\u{436}\u{438}\u{442}\u{435}\u{43B}\u{43D}\u{43E} \u{438}\u{43B}\u{438} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} Alt+ \u{441}\u{442}\u{440}\u{435}\u{43B}\u{43A}\u{430} \u{43D}\u{430}\u{434}\u{43E}\u{43B}\u{443}, \u{437}\u{430} \u{434}\u{430} \u{43E}\u{442}\u{432}\u{43E}\u{440}\u{438}\u{442}\u{435} \u{43C}\u{435}\u{43D}\u{44E}\u{442}\u{43E}`
};


var $6c3b6faf39c433f3$export$2e2bcd8739ae039 = {};
$6c3b6faf39c433f3$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dlouh\xfdm stiskem nebo stisknut\xedm kl\xe1ves Alt + \u{161}ipka dol\u{16F} otev\u{159}ete nab\xeddku`
};


var $1135a0afc8c3dc0c$export$2e2bcd8739ae039 = {};
$1135a0afc8c3dc0c$export$2e2bcd8739ae039 = {
    "longPressMessage": `Langt tryk eller tryk p\xe5 Alt + pil ned for at \xe5bne menuen`
};


var $daf1847ce4789012$export$2e2bcd8739ae039 = {};
$daf1847ce4789012$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dr\xfccken Sie lange oder dr\xfccken Sie Alt + Nach-unten, um das Men\xfc zu \xf6ffnen`
};


var $89ddbc012d1d9922$export$2e2bcd8739ae039 = {};
$89ddbc012d1d9922$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{3A0}\u{3B9}\u{3AD}\u{3C3}\u{3C4}\u{3B5} \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3C4}\u{3B5}\u{3C4}\u{3B1}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3AE} \u{3C0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Alt + \u{3BA}\u{3AC}\u{3C4}\u{3C9} \u{3B2}\u{3AD}\u{3BB}\u{3BF}\u{3C2} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3B1}\u{3BD}\u{3BF}\u{3AF}\u{3BE}\u{3B5}\u{3C4}\u{3B5} \u{3C4}\u{3BF} \u{3BC}\u{3B5}\u{3BD}\u{3BF}\u{3CD}`
};


var $d0c8beb4ee8ba887$export$2e2bcd8739ae039 = {};
$d0c8beb4ee8ba887$export$2e2bcd8739ae039 = {
    "longPressMessage": `Long press or press Alt + ArrowDown to open menu`
};


var $bb76bf5e0b6e41a3$export$2e2bcd8739ae039 = {};
$bb76bf5e0b6e41a3$export$2e2bcd8739ae039 = {
    "longPressMessage": `Mantenga pulsado o pulse Alt + flecha abajo para abrir el men\xfa`
};


var $8add34ffd5475f5e$export$2e2bcd8739ae039 = {};
$8add34ffd5475f5e$export$2e2bcd8739ae039 = {
    "longPressMessage": `Men\xfc\xfc avamiseks vajutage pikalt v\xf5i vajutage klahve Alt + allanool`
};


var $1f41e0ff20744cfa$export$2e2bcd8739ae039 = {};
$1f41e0ff20744cfa$export$2e2bcd8739ae039 = {
    "longPressMessage": `Avaa valikko painamalla pohjassa tai n\xe4pp\xe4inyhdistelm\xe4ll\xe4 Alt + Alanuoli`
};


var $1356adcfafdd6318$export$2e2bcd8739ae039 = {};
$1356adcfafdd6318$export$2e2bcd8739ae039 = {
    "longPressMessage": `Appuyez de mani\xe8re prolong\xe9e ou appuyez sur Alt\xa0+\xa0Fl\xe8che vers le bas pour ouvrir le menu.`
};


var $c81655b9c1430c3a$export$2e2bcd8739ae039 = {};
$c81655b9c1430c3a$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{5DC}\u{5D7}\u{5E5} \u{5DC}\u{5D7}\u{5D9}\u{5E6}\u{5D4} \u{5D0}\u{5E8}\u{5D5}\u{5DB}\u{5D4} \u{5D0}\u{5D5} \u{5D4}\u{5E7}\u{5E9} Alt + ArrowDown \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E4}\u{5EA}\u{5D5}\u{5D7} \u{5D0}\u{5EA} \u{5D4}\u{5EA}\u{5E4}\u{5E8}\u{5D9}\u{5D8}`
};


var $0d8b14c4b0029dbc$export$2e2bcd8739ae039 = {};
$0d8b14c4b0029dbc$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika`
};


var $6a7fb869077ed089$export$2e2bcd8739ae039 = {};
$6a7fb869077ed089$export$2e2bcd8739ae039 = {
    "longPressMessage": `Nyomja meg hosszan, vagy nyomja meg az Alt + lefele ny\xedl gombot a men\xfc megnyit\xe1s\xe1hoz`
};


var $9e39b2a7c5a40de8$export$2e2bcd8739ae039 = {};
$9e39b2a7c5a40de8$export$2e2bcd8739ae039 = {
    "longPressMessage": `Premi a lungo o premi Alt + Freccia gi\xf9 per aprire il menu`
};


var $ee7f5c6a11992a4f$export$2e2bcd8739ae039 = {};
$ee7f5c6a11992a4f$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{9577}\u{62BC}\u{3057}\u{307E}\u{305F}\u{306F} Alt+\u{4E0B}\u{77E2}\u{5370}\u{30AD}\u{30FC}\u{3067}\u{30E1}\u{30CB}\u{30E5}\u{30FC}\u{3092}\u{958B}\u{304F}`
};


var $f91d504189fd79d6$export$2e2bcd8739ae039 = {};
$f91d504189fd79d6$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{AE38}\u{AC8C} \u{B204}\u{B974}\u{AC70}\u{B098} Alt + \u{C544}\u{B798}\u{CABD} \u{D654}\u{C0B4}\u{D45C}\u{B97C} \u{B20C}\u{B7EC} \u{BA54}\u{B274} \u{C5F4}\u{AE30}`
};


var $f8fe9a295476d079$export$2e2bcd8739ae039 = {};
$f8fe9a295476d079$export$2e2bcd8739ae039 = {
    "longPressMessage": `Nor\u{117}dami atidaryti meniu, nuspaud\u{119} palaikykite arba paspauskite \u{201E}Alt + ArrowDown\u{201C}.`
};


var $352c09904a8eb3ef$export$2e2bcd8739ae039 = {};
$352c09904a8eb3ef$export$2e2bcd8739ae039 = {
    "longPressMessage": `Lai atv\u{113}rtu izv\u{113}lni, turiet nospiestu vai nospiediet tausti\u{146}u kombin\u{101}ciju Alt + lejupv\u{113}rst\u{101} bulti\u{146}a`
};


var $91329c14d9752257$export$2e2bcd8739ae039 = {};
$91329c14d9752257$export$2e2bcd8739ae039 = {
    "longPressMessage": `Langt trykk eller trykk Alt + PilNed for \xe5 \xe5pne menyen`
};


var $339c5988278a9880$export$2e2bcd8739ae039 = {};
$339c5988278a9880$export$2e2bcd8739ae039 = {
    "longPressMessage": `Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen`
};


var $c553ddf2df00b6ca$export$2e2bcd8739ae039 = {};
$c553ddf2df00b6ca$export$2e2bcd8739ae039 = {
    "longPressMessage": `Naci\u{15B}nij i przytrzymaj lub naci\u{15B}nij klawisze Alt + Strza\u{142}ka w d\xf3\u{142}, aby otworzy\u{107} menu`
};


var $ebffcd7b2e110247$export$2e2bcd8739ae039 = {};
$ebffcd7b2e110247$export$2e2bcd8739ae039 = {
    "longPressMessage": `Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu`
};


var $b4ca89937b14b9d7$export$2e2bcd8739ae039 = {};
$b4ca89937b14b9d7$export$2e2bcd8739ae039 = {
    "longPressMessage": `Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu`
};


var $8d9bad1db27108d4$export$2e2bcd8739ae039 = {};
$8d9bad1db27108d4$export$2e2bcd8739ae039 = {
    "longPressMessage": `Ap\u{103}sa\u{21B}i lung sau ap\u{103}sa\u{21B}i pe Alt + s\u{103}geat\u{103} \xeen jos pentru a deschide meniul`
};


var $dc942cb8fd800f9d$export$2e2bcd8739ae039 = {};
$dc942cb8fd800f9d$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{438} \u{443}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435} \u{438}\u{43B}\u{438} \u{43D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} Alt + \u{421}\u{442}\u{440}\u{435}\u{43B}\u{43A}\u{430} \u{432}\u{43D}\u{438}\u{437}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44C} \u{43C}\u{435}\u{43D}\u{44E}`
};


var $ed1834661e8bfbfd$export$2e2bcd8739ae039 = {};
$ed1834661e8bfbfd$export$2e2bcd8739ae039 = {
    "longPressMessage": `Ponuku otvor\xedte dlh\xfdm stla\u{10D}en\xedm alebo stla\u{10D}en\xedm kl\xe1vesu Alt + kl\xe1vesu so \u{161}\xedpkou nadol`
};


var $c95f60bfa41fb12a$export$2e2bcd8739ae039 = {};
$c95f60bfa41fb12a$export$2e2bcd8739ae039 = {
    "longPressMessage": `Za odprtje menija pritisnite in dr\u{17E}ite gumb ali pritisnite Alt+pu\u{161}\u{10D}ica navzdol`
};


var $3da7dfebe1905ba0$export$2e2bcd8739ae039 = {};
$3da7dfebe1905ba0$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni`
};


var $329f441f7a81de66$export$2e2bcd8739ae039 = {};
$329f441f7a81de66$export$2e2bcd8739ae039 = {
    "longPressMessage": `H\xe5ll nedtryckt eller tryck p\xe5 Alt + pil ned\xe5t f\xf6r att \xf6ppna menyn`
};


var $848744c9d0e2e5ee$export$2e2bcd8739ae039 = {};
$848744c9d0e2e5ee$export$2e2bcd8739ae039 = {
    "longPressMessage": `Men\xfcy\xfc a\xe7mak i\xe7in uzun bas\u{131}n veya Alt + A\u{15F}a\u{11F}\u{131} Ok tu\u{15F}una bas\u{131}n`
};


var $e1fb3597af6f2793$export$2e2bcd8739ae039 = {};
$e1fb3597af6f2793$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{414}\u{43E}\u{432}\u{433}\u{43E} \u{430}\u{431}\u{43E} \u{437}\u{432}\u{438}\u{447}\u{430}\u{439}\u{43D}\u{43E} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} \u{43A}\u{43E}\u{43C}\u{431}\u{456}\u{43D}\u{430}\u{446}\u{456}\u{44E} \u{43A}\u{43B}\u{430}\u{432}\u{456}\u{448} Alt \u{456} \u{441}\u{442}\u{440}\u{456}\u{43B}\u{43A}\u{430} \u{432}\u{43D}\u{438}\u{437}, \u{449}\u{43E}\u{431} \u{432}\u{456}\u{434}\u{43A}\u{440}\u{438}\u{442}\u{438} \u{43C}\u{435}\u{43D}\u{44E}`
};


var $a502e6c4b06cf227$export$2e2bcd8739ae039 = {};
$a502e6c4b06cf227$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{957F}\u{6309}\u{6216}\u{6309} Alt + \u{5411}\u{4E0B}\u{65B9}\u{5411}\u{952E}\u{4EE5}\u{6253}\u{5F00}\u{83DC}\u{5355}`
};


var $6794cd48b9f77687$export$2e2bcd8739ae039 = {};
$6794cd48b9f77687$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{9577}\u{6309}\u{6216}\u{6309} Alt+\u{5411}\u{4E0B}\u{9375}\u{4EE5}\u{958B}\u{555F}\u{529F}\u{80FD}\u{8868}`
};


var $3606dcfa5c5612b8$export$2e2bcd8739ae039 = {};
$3606dcfa5c5612b8$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $16d32f621839cc62$export$2e2bcd8739ae039),
    "bg-BG": (0, $fab3daeb7aa11d31$export$2e2bcd8739ae039),
    "cs-CZ": (0, $6c3b6faf39c433f3$export$2e2bcd8739ae039),
    "da-DK": (0, $1135a0afc8c3dc0c$export$2e2bcd8739ae039),
    "de-DE": (0, $daf1847ce4789012$export$2e2bcd8739ae039),
    "el-GR": (0, $89ddbc012d1d9922$export$2e2bcd8739ae039),
    "en-US": (0, $d0c8beb4ee8ba887$export$2e2bcd8739ae039),
    "es-ES": (0, $bb76bf5e0b6e41a3$export$2e2bcd8739ae039),
    "et-EE": (0, $8add34ffd5475f5e$export$2e2bcd8739ae039),
    "fi-FI": (0, $1f41e0ff20744cfa$export$2e2bcd8739ae039),
    "fr-FR": (0, $1356adcfafdd6318$export$2e2bcd8739ae039),
    "he-IL": (0, $c81655b9c1430c3a$export$2e2bcd8739ae039),
    "hr-HR": (0, $0d8b14c4b0029dbc$export$2e2bcd8739ae039),
    "hu-HU": (0, $6a7fb869077ed089$export$2e2bcd8739ae039),
    "it-IT": (0, $9e39b2a7c5a40de8$export$2e2bcd8739ae039),
    "ja-JP": (0, $ee7f5c6a11992a4f$export$2e2bcd8739ae039),
    "ko-KR": (0, $f91d504189fd79d6$export$2e2bcd8739ae039),
    "lt-LT": (0, $f8fe9a295476d079$export$2e2bcd8739ae039),
    "lv-LV": (0, $352c09904a8eb3ef$export$2e2bcd8739ae039),
    "nb-NO": (0, $91329c14d9752257$export$2e2bcd8739ae039),
    "nl-NL": (0, $339c5988278a9880$export$2e2bcd8739ae039),
    "pl-PL": (0, $c553ddf2df00b6ca$export$2e2bcd8739ae039),
    "pt-BR": (0, $ebffcd7b2e110247$export$2e2bcd8739ae039),
    "pt-PT": (0, $b4ca89937b14b9d7$export$2e2bcd8739ae039),
    "ro-RO": (0, $8d9bad1db27108d4$export$2e2bcd8739ae039),
    "ru-RU": (0, $dc942cb8fd800f9d$export$2e2bcd8739ae039),
    "sk-SK": (0, $ed1834661e8bfbfd$export$2e2bcd8739ae039),
    "sl-SI": (0, $c95f60bfa41fb12a$export$2e2bcd8739ae039),
    "sr-SP": (0, $3da7dfebe1905ba0$export$2e2bcd8739ae039),
    "sv-SE": (0, $329f441f7a81de66$export$2e2bcd8739ae039),
    "tr-TR": (0, $848744c9d0e2e5ee$export$2e2bcd8739ae039),
    "uk-UA": (0, $e1fb3597af6f2793$export$2e2bcd8739ae039),
    "zh-CN": (0, $a502e6c4b06cf227$export$2e2bcd8739ae039),
    "zh-TW": (0, $6794cd48b9f77687$export$2e2bcd8739ae039)
};







var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $800f5d9456bca761$export$f9d5c8beee7d008d(props, state, ref) {
    let { type: type } = props;
    let { isOpen: isOpen } = state;
    (0, $acw62.useEffect)(()=>{
        if (ref && ref.current) (0, $54feb6ccb4701e1a$export$f6211563215e3b37).set(ref.current, state.close);
    });
    // Aria 1.1 supports multiple values for aria-haspopup other than just menus.
    // https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
    // However, we only add it for menus for now because screen readers often
    // announce it as a menu even for other values.
    let ariaHasPopup = undefined;
    if (type === 'menu') ariaHasPopup = true;
    else if (type === 'listbox') ariaHasPopup = 'listbox';
    let overlayId = (0, $855de91ebb07800c$export$f680877a34711e37)();
    return {
        triggerProps: {
            'aria-haspopup': ariaHasPopup,
            'aria-expanded': isOpen,
            'aria-controls': isOpen ? overlayId : undefined,
            onPress: state.toggle
        },
        overlayProps: {
            id: overlayId
        }
    };
}


function $02ef2881ed6cea8d$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $02ef2881ed6cea8d$export$dc9c12ed27dd1b49(props, state, ref) {
    let { type: type = 'menu', isDisabled: isDisabled, trigger: trigger = 'press' } = props;
    let menuTriggerId = (0, $855de91ebb07800c$export$f680877a34711e37)();
    let { triggerProps: triggerProps, overlayProps: overlayProps } = (0, $800f5d9456bca761$export$f9d5c8beee7d008d)({
        type: type
    }, state, ref);
    let onKeyDown = (e)=>{
        if (isDisabled) return;
        if (trigger === 'longPress' && !e.altKey) return;
        if (ref && ref.current) switch(e.key){
            case 'Enter':
            case ' ':
                // React puts listeners on the same root, so even if propagation was stopped, immediate propagation is still possible.
                // useTypeSelect will handle the spacebar first if it's running, so we don't want to open if it's handled it already.
                // We use isDefaultPrevented() instead of isPropagationStopped() because createEventHandler stops propagation by default.
                // And default prevented means that the event was handled by something else (typeahead), so we don't want to open the menu.
                if (trigger === 'longPress' || e.isDefaultPrevented()) return;
            // fallthrough
            case 'ArrowDown':
                // Stop propagation, unless it would already be handled by useKeyboard.
                if (!('continuePropagation' in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle('first');
                break;
            case 'ArrowUp':
                if (!('continuePropagation' in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle('last');
                break;
            default:
                // Allow other keys.
                if ('continuePropagation' in e) e.continuePropagation();
        }
    };
    let stringFormatter = (0, $3681d06d99b0f841$export$f12b703ca79dfbb1)($02ef2881ed6cea8d$var$$parcel$interopDefault((0, $3606dcfa5c5612b8$export$2e2bcd8739ae039)), '@react-aria/menu');
    let { longPressProps: longPressProps } = (0, $2db4cebf4c07bbb1$export$c24ed0104d07eab9)({
        isDisabled: isDisabled || trigger !== 'longPress',
        accessibilityDescription: stringFormatter.format('longPressMessage'),
        onLongPressStart () {
            state.close();
        },
        onLongPress () {
            state.open('first');
        }
    });
    let pressProps = {
        preventFocusOnPress: true,
        onPressStart (e) {
            // For consistency with native, open the menu on mouse/key down, but touch up.
            if (e.pointerType !== 'touch' && e.pointerType !== 'keyboard' && !isDisabled) {
                (0, $4623aa9f87f28cd4$export$de79e2c695e052f3)(e.target);
                // If opened with a screen reader, auto focus the first item.
                // Otherwise, the menu itself will be focused.
                state.open(e.pointerType === 'virtual' ? 'first' : null);
            }
        },
        onPress (e) {
            if (e.pointerType === 'touch' && !isDisabled) {
                (0, $4623aa9f87f28cd4$export$de79e2c695e052f3)(e.target);
                state.toggle();
            }
        }
    };
    // omit onPress from triggerProps since we override it above.
    delete triggerProps.onPress;
    return {
        // @ts-ignore - TODO we pass out both DOMAttributes AND AriaButtonProps, but useButton will discard the longPress event handlers, it's only through PressResponder magic that this works for RSP and RAC. it does not work in aria examples
        menuTriggerProps: {
            ...triggerProps,
            ...trigger === 'press' ? pressProps : longPressProps,
            id: menuTriggerId,
            onKeyDown: onKeyDown
        },
        menuProps: {
            ...overlayProps,
            'aria-labelledby': menuTriggerId,
            autoFocus: state.focusStrategy || true,
            onClose: state.close
        }
    };
}


var $acw62 = parcelRequire("acw62");


const $92899f4140424a71$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS = 2;
const $92899f4140424a71$var$$d275435c250248f8$var$THROTTLE_TIME = 50;
const $92899f4140424a71$var$$d275435c250248f8$var$TIMEOUT_TIME = 1000;
const $92899f4140424a71$var$$d275435c250248f8$var$ANGLE_PADDING = Math.PI / 12; // 15°
function $92899f4140424a71$export$85ec83e04c95f50a(options) {
    let { menuRef: menuRef, submenuRef: submenuRef, isOpen: isOpen, isDisabled: isDisabled } = options;
    let prevPointerPos = (0, $acw62.useRef)(undefined);
    let submenuRect = (0, $acw62.useRef)(undefined);
    let lastProcessedTime = (0, $acw62.useRef)(0);
    let timeout = (0, $acw62.useRef)(undefined);
    let autoCloseTimeout = (0, $acw62.useRef)(undefined);
    let submenuSide = (0, $acw62.useRef)(undefined);
    let movementsTowardsSubmenuCount = (0, $acw62.useRef)(2);
    let [preventPointerEvents, setPreventPointerEvents] = (0, $acw62.useState)(false);
    let updateSubmenuRect = ()=>{
        if (submenuRef.current) {
            submenuRect.current = submenuRef.current.getBoundingClientRect();
            submenuSide.current = undefined;
        }
    };
    (0, $d0b7c56cfad5caf3$export$683480f191c0e3ea)({
        ref: submenuRef,
        onResize: updateSubmenuRect
    });
    let reset = ()=>{
        setPreventPointerEvents(false);
        movementsTowardsSubmenuCount.current = $92899f4140424a71$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS;
        prevPointerPos.current = undefined;
    };
    let modality = (0, $77c8ff0a3cb27e18$export$98e20ec92f614cfe)();
    // Prevent mouse down over safe triangle. Clicking while pointer-events: none is applied
    // will cause focus to move unexpectedly since it will go to an element behind the menu.
    let onPointerDown = (0, $92fff981738f62fe$export$7f54fc3180508a52)((e)=>{
        if (preventPointerEvents) e.preventDefault();
    });
    (0, $acw62.useEffect)(()=>{
        if (preventPointerEvents && menuRef.current) menuRef.current.style.pointerEvents = 'none';
        else menuRef.current.style.pointerEvents = '';
    }, [
        menuRef,
        preventPointerEvents
    ]);
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        let submenu = submenuRef.current;
        let menu = menuRef.current;
        if (isDisabled || !submenu || !isOpen || modality !== 'pointer' || !menu) {
            reset();
            return;
        }
        submenuRect.current = submenu.getBoundingClientRect();
        let onPointerMove = (e)=>{
            if (e.pointerType === 'touch' || e.pointerType === 'pen') return;
            let currentTime = Date.now();
            // Throttle
            if (currentTime - lastProcessedTime.current < $92899f4140424a71$var$$d275435c250248f8$var$THROTTLE_TIME) return;
            clearTimeout(timeout.current);
            clearTimeout(autoCloseTimeout.current);
            let { clientX: mouseX, clientY: mouseY } = e;
            if (!prevPointerPos.current) {
                prevPointerPos.current = {
                    x: mouseX,
                    y: mouseY
                };
                return;
            }
            if (!submenuRect.current) return;
            if (!submenuSide.current) submenuSide.current = mouseX > submenuRect.current.right ? 'left' : 'right';
            // Pointer is outside of parent menu
            if (mouseX < menu.getBoundingClientRect().left || mouseX > menu.getBoundingClientRect().right || mouseY < menu.getBoundingClientRect().top || mouseY > menu.getBoundingClientRect().bottom) {
                reset();
                return;
            }
            /* Check if pointer is moving towards submenu.
        Uses the 2-argument arctangent (https://en.wikipedia.org/wiki/Atan2) to calculate:
          - angle between previous pointer and top of submenu
          - angle between previous pointer and bottom of submenu
          - angle between previous pointer and current pointer (delta)
        If the pointer delta angle value is between the top and bottom angle values, we know the pointer is moving towards the submenu.
      */ let prevMouseX = prevPointerPos.current.x;
            let prevMouseY = prevPointerPos.current.y;
            let toSubmenuX = submenuSide.current === 'right' ? submenuRect.current.left - prevMouseX : prevMouseX - submenuRect.current.right;
            let angleTop = Math.atan2(prevMouseY - submenuRect.current.top, toSubmenuX) + $92899f4140424a71$var$$d275435c250248f8$var$ANGLE_PADDING;
            let angleBottom = Math.atan2(prevMouseY - submenuRect.current.bottom, toSubmenuX) - $92899f4140424a71$var$$d275435c250248f8$var$ANGLE_PADDING;
            let anglePointer = Math.atan2(prevMouseY - mouseY, submenuSide.current === 'left' ? -(mouseX - prevMouseX) : mouseX - prevMouseX);
            let isMovingTowardsSubmenu = anglePointer < angleTop && anglePointer > angleBottom;
            movementsTowardsSubmenuCount.current = isMovingTowardsSubmenu ? Math.min(movementsTowardsSubmenuCount.current + 1, $92899f4140424a71$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS) : Math.max(movementsTowardsSubmenuCount.current - 1, 0);
            if (movementsTowardsSubmenuCount.current >= $92899f4140424a71$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS) setPreventPointerEvents(true);
            else setPreventPointerEvents(false);
            lastProcessedTime.current = currentTime;
            prevPointerPos.current = {
                x: mouseX,
                y: mouseY
            };
            // If the pointer is moving towards the submenu, start a timeout to close if no other movements are made after 500ms.
            if (isMovingTowardsSubmenu) timeout.current = setTimeout(()=>{
                reset();
                autoCloseTimeout.current = setTimeout(()=>{
                    // Fire a pointerover event to trigger the menu to close.
                    // Wait until pointer-events:none is no longer applied
                    let target = document.elementFromPoint(mouseX, mouseY);
                    if (target && menu.contains(target)) target.dispatchEvent(new PointerEvent('pointerover', {
                        bubbles: true,
                        cancelable: true
                    }));
                }, 100);
            }, $92899f4140424a71$var$$d275435c250248f8$var$TIMEOUT_TIME);
        };
        window.addEventListener('pointermove', onPointerMove);
        window.addEventListener('pointerdown', onPointerDown, true);
        return ()=>{
            window.removeEventListener('pointermove', onPointerMove);
            window.removeEventListener('pointerdown', onPointerDown, true);
            clearTimeout(timeout.current);
            clearTimeout(autoCloseTimeout.current);
            movementsTowardsSubmenuCount.current = $92899f4140424a71$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS;
        };
    }, [
        isDisabled,
        isOpen,
        menuRef,
        modality,
        setPreventPointerEvents,
        submenuRef
    ]);
}




var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $bcdd375a3afd7516$export$7138b0d059a6e743(props, state, ref) {
    let { parentMenuRef: parentMenuRef, submenuRef: submenuRef, type: type = 'menu', isDisabled: isDisabled, delay: delay = 200, shouldUseVirtualFocus: shouldUseVirtualFocus } = props;
    let submenuTriggerId = (0, $855de91ebb07800c$export$f680877a34711e37)();
    let overlayId = (0, $855de91ebb07800c$export$f680877a34711e37)();
    let { direction: direction } = (0, $a7e3b1109bf64033$export$43bb16f9c6d9e3f7)();
    let openTimeout = (0, $acw62.useRef)(undefined);
    let cancelOpenTimeout = (0, $acw62.useCallback)(()=>{
        if (openTimeout.current) {
            clearTimeout(openTimeout.current);
            openTimeout.current = undefined;
        }
    }, [
        openTimeout
    ]);
    let onSubmenuOpen = (0, $acw62.useCallback)((focusStrategy)=>{
        cancelOpenTimeout();
        state.open(focusStrategy);
    }, [
        state,
        cancelOpenTimeout
    ]);
    let onSubmenuClose = (0, $acw62.useCallback)(()=>{
        cancelOpenTimeout();
        state.close();
    }, [
        state,
        cancelOpenTimeout
    ]);
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        return ()=>{
            cancelOpenTimeout();
        };
    }, [
        cancelOpenTimeout
    ]);
    let submenuKeyDown = (e)=>{
        // If focus is not within the menu, assume virtual focus is being used.
        // This means some other input element is also within the popover, so we shouldn't close the menu.
        if (!e.currentTarget.contains(document.activeElement)) return;
        switch(e.key){
            case 'ArrowLeft':
                if (direction === 'ltr' && e.currentTarget.contains(e.target)) {
                    e.preventDefault();
                    e.stopPropagation();
                    onSubmenuClose();
                    if (!shouldUseVirtualFocus && ref.current) (0, $4623aa9f87f28cd4$export$de79e2c695e052f3)(ref.current);
                }
                break;
            case 'ArrowRight':
                if (direction === 'rtl' && e.currentTarget.contains(e.target)) {
                    e.preventDefault();
                    e.stopPropagation();
                    onSubmenuClose();
                    if (!shouldUseVirtualFocus && ref.current) (0, $4623aa9f87f28cd4$export$de79e2c695e052f3)(ref.current);
                }
                break;
            case 'Escape':
                var _submenuRef_current;
                // TODO: can remove this when we fix collection event leaks
                if ((_submenuRef_current = submenuRef.current) === null || _submenuRef_current === void 0 ? void 0 : _submenuRef_current.contains(e.target)) {
                    e.stopPropagation();
                    onSubmenuClose();
                    if (!shouldUseVirtualFocus && ref.current) (0, $4623aa9f87f28cd4$export$de79e2c695e052f3)(ref.current);
                }
                break;
        }
    };
    var _state_focusStrategy;
    let submenuProps = {
        id: overlayId,
        'aria-labelledby': submenuTriggerId,
        submenuLevel: state.submenuLevel,
        ...type === 'menu' && {
            onClose: state.closeAll,
            autoFocus: (_state_focusStrategy = state.focusStrategy) !== null && _state_focusStrategy !== void 0 ? _state_focusStrategy : undefined,
            onKeyDown: submenuKeyDown
        }
    };
    let submenuTriggerKeyDown = (e)=>{
        switch(e.key){
            case 'ArrowRight':
                if (!isDisabled) {
                    if (direction === 'ltr') {
                        e.preventDefault();
                        if (!state.isOpen) onSubmenuOpen('first');
                        if (type === 'menu' && !!(submenuRef === null || submenuRef === void 0 ? void 0 : submenuRef.current) && document.activeElement === (ref === null || ref === void 0 ? void 0 : ref.current)) (0, $4623aa9f87f28cd4$export$de79e2c695e052f3)(submenuRef.current);
                    } else if (state.isOpen) onSubmenuClose();
                    else e.continuePropagation();
                }
                break;
            case 'ArrowLeft':
                if (!isDisabled) {
                    if (direction === 'rtl') {
                        e.preventDefault();
                        if (!state.isOpen) onSubmenuOpen('first');
                        if (type === 'menu' && !!(submenuRef === null || submenuRef === void 0 ? void 0 : submenuRef.current) && document.activeElement === (ref === null || ref === void 0 ? void 0 : ref.current)) (0, $4623aa9f87f28cd4$export$de79e2c695e052f3)(submenuRef.current);
                    } else if (state.isOpen) onSubmenuClose();
                    else e.continuePropagation();
                }
                break;
            default:
                e.continuePropagation();
                break;
        }
    };
    let onPressStart = (e)=>{
        if (!isDisabled && (e.pointerType === 'virtual' || e.pointerType === 'keyboard')) onSubmenuOpen('first');
    };
    let onPress = (e)=>{
        if (!isDisabled && (e.pointerType === 'touch' || e.pointerType === 'mouse')) // press up happening on the newly opened tray items
        onSubmenuOpen();
    };
    let onHoverChange = (isHovered)=>{
        if (!isDisabled) {
            if (isHovered && !state.isOpen) {
                if (!openTimeout.current) openTimeout.current = setTimeout(()=>{
                    onSubmenuOpen();
                }, delay);
            } else if (!isHovered) cancelOpenTimeout();
        }
    };
    (0, $b95c9737ad40d7c7$export$90fc3a17d93f704c)(parentMenuRef, 'focusin', (e)=>{
        var _parentMenuRef_current;
        // If we detect focus moved to a different item in the same menu that the currently open submenu trigger is in
        // then close the submenu. This is for a case where the user hovers a root menu item when multiple submenus are open
        if (state.isOpen && ((_parentMenuRef_current = parentMenuRef.current) === null || _parentMenuRef_current === void 0 ? void 0 : _parentMenuRef_current.contains(e.target)) && e.target !== ref.current) onSubmenuClose();
    });
    let shouldCloseOnInteractOutside = (target)=>{
        if (target !== ref.current) return true;
        return false;
    };
    (0, $92899f4140424a71$export$85ec83e04c95f50a)({
        menuRef: parentMenuRef,
        submenuRef: submenuRef,
        isOpen: state.isOpen,
        isDisabled: isDisabled
    });
    return {
        submenuTriggerProps: {
            id: submenuTriggerId,
            'aria-controls': state.isOpen ? overlayId : undefined,
            'aria-haspopup': !isDisabled ? type : undefined,
            'aria-expanded': state.isOpen ? 'true' : 'false',
            onPressStart: onPressStart,
            onPress: onPress,
            onHoverChange: onHoverChange,
            onKeyDown: submenuTriggerKeyDown,
            isOpen: state.isOpen
        },
        submenuProps: submenuProps,
        popoverProps: {
            isNonModal: true,
            shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
        }
    };
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $59e7b8bfc6d00736$export$79fefeb1c2091ac3(props) {
    let overlayTriggerState = (0, $9a55ce4a79a9cb0d$export$61c6a8c84e605fb6)(props);
    let [focusStrategy, setFocusStrategy] = (0, $acw62.useState)(null);
    let [expandedKeysStack, setExpandedKeysStack] = (0, $acw62.useState)([]);
    let closeAll = ()=>{
        setExpandedKeysStack([]);
        overlayTriggerState.close();
    };
    let openSubmenu = (triggerKey, level)=>{
        setExpandedKeysStack((oldStack)=>{
            if (level > oldStack.length) return oldStack;
            return [
                ...oldStack.slice(0, level),
                triggerKey
            ];
        });
    };
    let closeSubmenu = (triggerKey, level)=>{
        setExpandedKeysStack((oldStack)=>{
            let key = oldStack[level];
            if (key === triggerKey) return oldStack.slice(0, level);
            else return oldStack;
        });
    };
    return {
        focusStrategy: focusStrategy,
        ...overlayTriggerState,
        open (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.open();
        },
        toggle (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.toggle();
        },
        close () {
            closeAll();
        },
        expandedKeysStack: expandedKeysStack,
        openSubmenu: openSubmenu,
        closeSubmenu: closeSubmenu
    };
}


var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7686c8d7244c3492$export$cfc51cf86138bf98(props, state) {
    let { triggerKey: triggerKey } = props;
    let { expandedKeysStack: expandedKeysStack, openSubmenu: openSubmenu, closeSubmenu: closeSubmenu, close: closeAll } = state;
    let [submenuLevel] = (0, $acw62.useState)(expandedKeysStack === null || expandedKeysStack === void 0 ? void 0 : expandedKeysStack.length);
    let isOpen = (0, $acw62.useMemo)(()=>expandedKeysStack[submenuLevel] === triggerKey, [
        expandedKeysStack,
        triggerKey,
        submenuLevel
    ]);
    let [focusStrategy, setFocusStrategy] = (0, $acw62.useState)(null);
    let open = (0, $acw62.useCallback)((focusStrategy)=>{
        setFocusStrategy(focusStrategy !== null && focusStrategy !== void 0 ? focusStrategy : null);
        openSubmenu(triggerKey, submenuLevel);
    }, [
        openSubmenu,
        submenuLevel,
        triggerKey
    ]);
    let close = (0, $acw62.useCallback)(()=>{
        setFocusStrategy(null);
        closeSubmenu(triggerKey, submenuLevel);
    }, [
        closeSubmenu,
        submenuLevel,
        triggerKey
    ]);
    let toggle = (0, $acw62.useCallback)((focusStrategy)=>{
        setFocusStrategy(focusStrategy !== null && focusStrategy !== void 0 ? focusStrategy : null);
        if (isOpen) close();
        else open(focusStrategy);
    }, [
        close,
        open,
        isOpen
    ]);
    return (0, $acw62.useMemo)(()=>({
            focusStrategy: focusStrategy,
            isOpen: isOpen,
            open: open,
            close: close,
            closeAll: closeAll,
            submenuLevel: submenuLevel,
            // TODO: Placeholders that aren't used but give us parity with OverlayTriggerState so we can use this in Popover. Refactor if we update Popover via
            // https://github.com/adobe/react-spectrum/pull/4976#discussion_r1336472863
            setOpen: ()=>{},
            toggle: toggle
        }), [
        isOpen,
        open,
        close,
        closeAll,
        focusStrategy,
        toggle,
        submenuLevel
    ]);
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $4fdc86091e04596b$export$863faf230ee2118a {
    *[Symbol.iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        var _node_prevKey;
        return node ? (_node_prevKey = node.prevKey) !== null && _node_prevKey !== void 0 ? _node_prevKey : null : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        var _node_nextKey;
        return node ? (_node_nextKey = node.nextKey) !== null && _node_nextKey !== void 0 ? _node_nextKey : null : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        var _this_keyMap_get;
        return (_this_keyMap_get = this.keyMap.get(key)) !== null && _this_keyMap_get !== void 0 ? _this_keyMap_get : null;
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    constructor(nodes, { expandedKeys: expandedKeys } = {}){
        this.keyMap = new Map();
        this.firstKey = null;
        this.lastKey = null;
        this.iterable = nodes;
        expandedKeys = expandedKeys || new Set();
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && (node.type === 'section' || expandedKeys.has(node.key))) for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last = null;
        let index = 0;
        for (let [key, node] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node.prevKey = last.key;
            } else {
                this.firstKey = key;
                node.prevKey = undefined;
            }
            if (node.type === 'item') node.index = index++;
            last = node;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        var _last_key;
        this.lastKey = (_last_key = last === null || last === void 0 ? void 0 : last.key) !== null && _last_key !== void 0 ? _last_key : null;
    }
}




var $acw62 = parcelRequire("acw62");


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8f379791081c42a9$export$728d6ba534403756(props) {
    let { onExpandedChange: onExpandedChange } = props;
    let [expandedKeys, setExpandedKeys] = (0, $3316814d6906df5c$export$40bfa8c7b0832715)(props.expandedKeys ? new Set(props.expandedKeys) : undefined, props.defaultExpandedKeys ? new Set(props.defaultExpandedKeys) : new Set(), onExpandedChange);
    let selectionState = (0, $ab083b9331e6e49d$export$253fe78d46329472)(props);
    let disabledKeys = (0, $acw62.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let tree = (0, $7446aeaa4358c815$export$6cd28814d92fa9c9)(props, (0, $acw62.useCallback)((nodes)=>new (0, $4fdc86091e04596b$export$863faf230ee2118a)(nodes, {
            expandedKeys: expandedKeys
        }), [
        expandedKeys
    ]), null);
    (0, $acw62.useEffect)(()=>{
        if (selectionState.focusedKey != null && !tree.getItem(selectionState.focusedKey)) selectionState.setFocusedKey(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tree,
        selectionState.focusedKey
    ]);
    let onToggle = (key)=>{
        setExpandedKeys($8f379791081c42a9$var$$875d6693e12af071$var$toggleKey(expandedKeys, key));
    };
    return {
        collection: tree,
        expandedKeys: expandedKeys,
        disabledKeys: disabledKeys,
        toggleKey: onToggle,
        setExpandedKeys: setExpandedKeys,
        selectionManager: new (0, $612ad27198cc9cf7$export$6c8a5aaad13c9852)(tree, selectionState)
    };
}
function $8f379791081c42a9$var$$875d6693e12af071$var$toggleKey(set, key) {
    let res = new Set(set);
    if (res.has(key)) res.delete(key);
    else res.add(key);
    return res;
}






var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $61ec433404134521$export$c7e742effb1c51e2 = (0, $acw62.createContext)(null);
const $61ec433404134521$export$24aad8519b95b41b = (0, $acw62.createContext)(null);
const $61ec433404134521$export$795aec4671cbae19 = (0, $acw62.createContext)(null);
const $61ec433404134521$var$$3674c52c6b3c5bce$var$SelectionManagerContext = (0, $acw62.createContext)(null);
function $61ec433404134521$export$27d2ad3c5815583e(props) {
    let state = (0, $59e7b8bfc6d00736$export$79fefeb1c2091ac3)(props);
    let ref = (0, $acw62.useRef)(null);
    let { menuTriggerProps: menuTriggerProps, menuProps: menuProps } = (0, $02ef2881ed6cea8d$export$dc9c12ed27dd1b49)({
        ...props,
        type: 'menu'
    }, state, ref);
    // Allows menu width to match button
    let [buttonWidth, setButtonWidth] = (0, $acw62.useState)(null);
    let onResize = (0, $acw62.useCallback)(()=>{
        if (ref.current) setButtonWidth(ref.current.offsetWidth + 'px');
    }, [
        ref
    ]);
    (0, $d0b7c56cfad5caf3$export$683480f191c0e3ea)({
        ref: ref,
        onResize: onResize
    });
    let scrollRef = (0, $acw62.useRef)(null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $12ee5c1d62d6b2e5$export$2881499e37b75b9a), {
        values: [
            [
                $61ec433404134521$export$c7e742effb1c51e2,
                {
                    ...menuProps,
                    ref: scrollRef
                }
            ],
            [
                (0, $33689c90e5739620$export$d2f961adcb0afbe),
                state
            ],
            [
                $61ec433404134521$export$795aec4671cbae19,
                state
            ],
            [
                (0, $58149d5ffdda7d3e$export$9b9a0cd73afb7ca4),
                {
                    trigger: 'MenuTrigger',
                    triggerRef: ref,
                    scrollRef: scrollRef,
                    placement: 'bottom start',
                    style: {
                        '--trigger-width': buttonWidth
                    },
                    'aria-labelledby': menuProps['aria-labelledby']
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $682dc91e15d197fb$export$3351871ee4b288b8), {
        ...menuTriggerProps,
        ref: ref,
        isPressed: state.isOpen
    }, props.children));
}
const $61ec433404134521$var$$3674c52c6b3c5bce$var$SubmenuTriggerContext = (0, $acw62.createContext)(null);
class $61ec433404134521$var$$3674c52c6b3c5bce$var$SubmenuTriggerNode extends (0, $168b0e08d3f28116$export$d68d59712b04d9d1) {
    filter(collection, newCollection, filterFn) {
        let triggerNode = collection.getItem(this.firstChildKey);
        if (triggerNode && filterFn(triggerNode.textValue, this)) {
            let clone = this.clone();
            newCollection.addDescendants(clone, collection);
            return clone;
        }
        return null;
    }
}
$61ec433404134521$var$$3674c52c6b3c5bce$var$SubmenuTriggerNode.type = 'submenutrigger';
const $61ec433404134521$export$ecabc99eeffab7ca = (0, $5fe83fb7b4e6e89f$export$e953bb1cd0f19726)($61ec433404134521$var$$3674c52c6b3c5bce$var$SubmenuTriggerNode, (props, ref, item)=>{
    let { CollectionBranch: CollectionBranch } = (0, $acw62.useContext)((0, $0152a93b06da2b96$export$4feb769f8ddf26c5));
    let state = (0, $acw62.useContext)($61ec433404134521$export$24aad8519b95b41b);
    let rootMenuTriggerState = (0, $acw62.useContext)($61ec433404134521$export$795aec4671cbae19);
    let submenuTriggerState = (0, $7686c8d7244c3492$export$cfc51cf86138bf98)({
        triggerKey: item.key
    }, rootMenuTriggerState);
    let submenuRef = (0, $acw62.useRef)(null);
    let itemRef = (0, $426ce7b4b2df0896$export$4338b53315abf666)(ref);
    let { parentMenuRef: parentMenuRef, shouldUseVirtualFocus: shouldUseVirtualFocus } = (0, $acw62.useContext)($61ec433404134521$var$$3674c52c6b3c5bce$var$SubmenuTriggerContext);
    let { submenuTriggerProps: submenuTriggerProps, submenuProps: submenuProps, popoverProps: popoverProps } = (0, $bcdd375a3afd7516$export$7138b0d059a6e743)({
        parentMenuRef: parentMenuRef,
        submenuRef: submenuRef,
        delay: props.delay,
        shouldUseVirtualFocus: shouldUseVirtualFocus
    }, submenuTriggerState, itemRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $12ee5c1d62d6b2e5$export$2881499e37b75b9a), {
        values: [
            [
                $61ec433404134521$var$$3674c52c6b3c5bce$var$MenuItemContext,
                {
                    ...submenuTriggerProps,
                    onAction: undefined,
                    ref: itemRef
                }
            ],
            [
                $61ec433404134521$export$c7e742effb1c51e2,
                {
                    ref: submenuRef,
                    ...submenuProps
                }
            ],
            [
                (0, $33689c90e5739620$export$d2f961adcb0afbe),
                submenuTriggerState
            ],
            [
                (0, $58149d5ffdda7d3e$export$9b9a0cd73afb7ca4),
                {
                    trigger: 'SubmenuTrigger',
                    triggerRef: itemRef,
                    placement: 'end top',
                    'aria-labelledby': submenuProps['aria-labelledby'],
                    ...popoverProps
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CollectionBranch, {
        collection: state.collection,
        parent: item
    }), props.children[1]);
}, (props)=>props.children[0]);
const $61ec433404134521$export$d9b273488cd8ce6f = (0, $acw62.forwardRef)(function Menu(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $61ec433404134521$export$c7e742effb1c51e2);
    // Delay rendering the actual menu until we have the collection so that auto focus works properly.
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5fe83fb7b4e6e89f$export$bf788dd355e3a401), {
        content: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5fe83fb7b4e6e89f$export$fb8073518f34e6ec), props)
    }, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($61ec433404134521$var$$3674c52c6b3c5bce$var$MenuInner, {
            props: props,
            collection: collection,
            menuRef: ref
        }));
});
function $61ec433404134521$var$$3674c52c6b3c5bce$var$MenuInner({ props: props, collection: collection, menuRef: ref }) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, (0, $11cc862e572cddbb$export$b0d3ecf7112093a7));
    let { filter: filter, ...autocompleteMenuProps } = props;
    let filteredCollection = (0, $acw62.useMemo)(()=>filter ? collection.filter(filter) : collection, [
        collection,
        filter
    ]);
    let state = (0, $8f379791081c42a9$export$728d6ba534403756)({
        ...props,
        collection: filteredCollection,
        children: undefined
    });
    let triggerState = (0, $acw62.useContext)($61ec433404134521$export$795aec4671cbae19);
    let { isVirtualized: isVirtualized, CollectionRoot: CollectionRoot } = (0, $acw62.useContext)((0, $0152a93b06da2b96$export$4feb769f8ddf26c5));
    let { menuProps: menuProps } = (0, $d730431f5e6d2801$export$38eaa17faae8f579)({
        ...props,
        isVirtualized: isVirtualized,
        onClose: props.onClose || (triggerState === null || triggerState === void 0 ? void 0 : triggerState.close)
    }, state, ref);
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        defaultClassName: 'react-aria-Menu',
        className: props.className,
        style: props.style,
        values: {
            isEmpty: state.collection.size === 0
        }
    });
    let emptyState = null;
    if (state.collection.size === 0 && props.renderEmptyState) emptyState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "menuitem",
        style: {
            display: 'contents'
        }
    }, props.renderEmptyState());
    let DOMProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dd1b249b49caa281$export$20e40289641fbbb6), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)(DOMProps, renderProps, menuProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-empty": state.collection.size === 0 || undefined,
        onScroll: props.onScroll
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $12ee5c1d62d6b2e5$export$2881499e37b75b9a), {
        values: [
            [
                $61ec433404134521$export$24aad8519b95b41b,
                state
            ],
            [
                (0, $c59ca94960be2e1f$export$6615d83f6de245ce),
                {
                    elementType: 'div'
                }
            ],
            [
                (0, $0152a93b06da2b96$export$d40e14dec8b060a8),
                {
                    name: 'MenuSection',
                    render: $61ec433404134521$var$$3674c52c6b3c5bce$var$MenuSectionInner
                }
            ],
            [
                $61ec433404134521$var$$3674c52c6b3c5bce$var$SubmenuTriggerContext,
                {
                    parentMenuRef: ref,
                    shouldUseVirtualFocus: autocompleteMenuProps === null || autocompleteMenuProps === void 0 ? void 0 : autocompleteMenuProps.shouldUseVirtualFocus
                }
            ],
            [
                $61ec433404134521$var$$3674c52c6b3c5bce$var$MenuItemContext,
                null
            ],
            [
                (0, $11cc862e572cddbb$export$b0d3ecf7112093a7),
                null
            ],
            [
                (0, $11cc862e572cddbb$export$698f465ec27e93df),
                null
            ],
            [
                $61ec433404134521$var$$3674c52c6b3c5bce$var$SelectionManagerContext,
                state.selectionManager
            ],
            /* Ensure root MenuTriggerState is defined, in case Menu is rendered outside a MenuTrigger. */ /* We assume the context can never change between defined and undefined. */ /* eslint-disable-next-line react-hooks/rules-of-hooks */ [
                $61ec433404134521$export$795aec4671cbae19,
                triggerState !== null && triggerState !== void 0 ? triggerState : (0, $59e7b8bfc6d00736$export$79fefeb1c2091ac3)({})
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $77f6c3892c21261c$export$758399f318e6385a), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CollectionRoot, {
        collection: state.collection,
        persistedKeys: (0, $0152a93b06da2b96$export$90e00781bc59d8f9)(state.selectionManager.focusedKey),
        scrollRef: ref
    }))), emptyState));
}
// A subclass of SelectionManager that forwards focus-related properties to the parent,
// but has its own local selection state.
class $61ec433404134521$var$$3674c52c6b3c5bce$var$GroupSelectionManager extends (0, $612ad27198cc9cf7$export$6c8a5aaad13c9852) {
    get focusedKey() {
        return this.parent.focusedKey;
    }
    get isFocused() {
        return this.parent.isFocused;
    }
    setFocusedKey(key, childFocusStrategy) {
        return this.parent.setFocusedKey(key, childFocusStrategy);
    }
    setFocused(isFocused) {
        this.parent.setFocused(isFocused);
    }
    get childFocusStrategy() {
        return this.parent.childFocusStrategy;
    }
    constructor(parent, state){
        super(parent.collection, state);
        this.parent = parent;
    }
}
function $61ec433404134521$var$$3674c52c6b3c5bce$var$MenuSectionInner(props, ref, section, className = 'react-aria-MenuSection') {
    var _section_props, _section_props1;
    let state = (0, $acw62.useContext)($61ec433404134521$export$24aad8519b95b41b);
    let { CollectionBranch: CollectionBranch } = (0, $acw62.useContext)((0, $0152a93b06da2b96$export$4feb769f8ddf26c5));
    let [headingRef, heading] = (0, $12ee5c1d62d6b2e5$export$9d4c57ee4c6ffdd8)();
    var _section_props_arialabel;
    let { headingProps: headingProps, groupProps: groupProps } = (0, $b61889228174484b$export$73f7a44322579622)({
        heading: heading,
        'aria-label': (_section_props_arialabel = section.props['aria-label']) !== null && _section_props_arialabel !== void 0 ? _section_props_arialabel : undefined
    });
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        defaultClassName: className,
        className: (_section_props = section.props) === null || _section_props === void 0 ? void 0 : _section_props.className,
        style: (_section_props1 = section.props) === null || _section_props1 === void 0 ? void 0 : _section_props1.style,
        values: {}
    });
    let parent = (0, $acw62.useContext)($61ec433404134521$var$$3674c52c6b3c5bce$var$SelectionManagerContext);
    let selectionState = (0, $ab083b9331e6e49d$export$253fe78d46329472)(props);
    let manager = props.selectionMode != null ? new $61ec433404134521$var$$3674c52c6b3c5bce$var$GroupSelectionManager(parent, selectionState) : parent;
    let DOMProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)(DOMProps, renderProps, groupProps),
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $12ee5c1d62d6b2e5$export$2881499e37b75b9a), {
        values: [
            [
                (0, $c879a8de1219885d$export$e0e4026c12a8bdbb),
                {
                    ...headingProps,
                    ref: headingRef
                }
            ],
            [
                $61ec433404134521$var$$3674c52c6b3c5bce$var$SelectionManagerContext,
                manager
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CollectionBranch, {
        collection: state.collection,
        parent: section
    })));
}
const $61ec433404134521$export$4b1545b4f2016d26 = (0, $5fe83fb7b4e6e89f$export$e953bb1cd0f19726)((0, $168b0e08d3f28116$export$437f11dc9b403b78), $61ec433404134521$var$$3674c52c6b3c5bce$var$MenuSectionInner);
const $61ec433404134521$var$$3674c52c6b3c5bce$var$MenuItemContext = (0, $acw62.createContext)(null);
const $61ec433404134521$export$2ce376c2cc3355c8 = (0, $5fe83fb7b4e6e89f$export$18af5c7a9e9b3664)((0, $168b0e08d3f28116$export$fd11f34e1d07f134), function MenuItem(props, forwardedRef, item) {
    var _useSlottedContext;
    [props, forwardedRef] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, forwardedRef, $61ec433404134521$var$$3674c52c6b3c5bce$var$MenuItemContext);
    let id = (_useSlottedContext = (0, $12ee5c1d62d6b2e5$export$fabf2dc03a41866e)($61ec433404134521$var$$3674c52c6b3c5bce$var$MenuItemContext)) === null || _useSlottedContext === void 0 ? void 0 : _useSlottedContext.id;
    let state = (0, $acw62.useContext)($61ec433404134521$export$24aad8519b95b41b);
    let ref = (0, $426ce7b4b2df0896$export$4338b53315abf666)(forwardedRef);
    let selectionManager = (0, $acw62.useContext)($61ec433404134521$var$$3674c52c6b3c5bce$var$SelectionManagerContext);
    let { menuItemProps: menuItemProps, labelProps: labelProps, descriptionProps: descriptionProps, keyboardShortcutProps: keyboardShortcutProps, ...states } = (0, $d9f04a2cc49c8b02$export$9d32628fc2aea7da)({
        ...props,
        id: id,
        key: item.key,
        selectionManager: selectionManager
    }, state, ref);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $8d62ff0ac4dc2be2$export$ae780daf29e6d456)({
        isDisabled: states.isDisabled
    });
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        ...props,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-MenuItem',
        values: {
            ...states,
            isHovered: isHovered,
            isFocusVisible: states.isFocusVisible,
            selectionMode: selectionManager.selectionMode,
            selectionBehavior: selectionManager.selectionBehavior,
            hasSubmenu: !!props['aria-haspopup'],
            isOpen: props['aria-expanded'] === 'true'
        }
    });
    let ElementType = props.href ? 'a' : 'div';
    let DOMProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ElementType, {
        ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)(DOMProps, renderProps, menuItemProps, hoverProps),
        ref: ref,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": states.isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-selected": states.isSelected || undefined,
        "data-selection-mode": selectionManager.selectionMode === 'none' ? undefined : selectionManager.selectionMode,
        "data-has-submenu": !!props['aria-haspopup'] || undefined,
        "data-open": props['aria-expanded'] === 'true' || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $12ee5c1d62d6b2e5$export$2881499e37b75b9a), {
        values: [
            [
                (0, $424592b5daddcd29$export$9afb8bc826b033ea),
                {
                    slots: {
                        [(0, $12ee5c1d62d6b2e5$export$c62b8e45d58ddad9)]: labelProps,
                        label: labelProps,
                        description: descriptionProps
                    }
                }
            ],
            [
                (0, $63dcb4594bc5d8f1$export$744d98a3b8a94e1c),
                keyboardShortcutProps
            ],
            [
                (0, $50e2ea1c2adde70a$export$c9549807523555e0),
                {
                    isSelected: states.isSelected
                }
            ]
        ]
    }, renderProps.children));
});





var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0f7d8ef8f578ec61$export$d55e7ee900f34e93(props, ref) {
    let { role: role = 'dialog' } = props;
    let titleId = (0, $855de91ebb07800c$export$b4cc09c592e8fdb8)();
    titleId = props['aria-label'] ? undefined : titleId;
    let isRefocusing = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (ref.current && !ref.current.contains(document.activeElement)) {
            (0, $f84e6bd16978dcef$export$80f3e147d781571c)(ref.current);
            // Safari on iOS does not move the VoiceOver cursor to the dialog
            // or announce that it has opened until it has rendered. A workaround
            // is to wait for half a second, then blur and re-focus the dialog.
            let timeout = setTimeout(()=>{
                // Check that the dialog is still focused, or focused was lost to the body.
                if (document.activeElement === ref.current || document.activeElement === document.body) {
                    isRefocusing.current = true;
                    if (ref.current) {
                        ref.current.blur();
                        (0, $f84e6bd16978dcef$export$80f3e147d781571c)(ref.current);
                    }
                    isRefocusing.current = false;
                }
            }, 500);
            return ()=>{
                clearTimeout(timeout);
            };
        }
    }, [
        ref
    ]);
    (0, $47b79271f309ea43$export$14c98a7594375490)();
    // We do not use aria-modal due to a Safari bug which forces the first focusable element to be focused
    // on mount when inside an iframe, no matter which element we programmatically focus.
    // See https://bugs.webkit.org/show_bug.cgi?id=211934.
    // useModal sets aria-hidden on all elements outside the dialog, so the dialog will behave as a modal
    // even without aria-modal on the dialog itself.
    return {
        dialogProps: {
            ...(0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
                labelable: true
            }),
            role: role,
            tabIndex: -1,
            'aria-labelledby': props['aria-labelledby'] || titleId,
            // Prevent blur events from reaching useOverlay, which may cause
            // popovers to close. Since focus is contained within the dialog,
            // we don't want this to occur due to the above useEffect.
            onBlur: (e)=>{
                if (isRefocusing.current) e.stopPropagation();
            }
        },
        titleProps: {
            id: titleId
        }
    };
}






var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $33689c90e5739620$export$8b93a07348a7730c = (0, $acw62.createContext)(null);
const $33689c90e5739620$export$d2f961adcb0afbe = (0, $acw62.createContext)(null);
function $33689c90e5739620$export$2e1e1122cf0cba88(props) {
    // Use useMenuTriggerState instead of useOverlayTriggerState in case a menu is embedded in the dialog.
    // This is needed to handle submenus.
    let state = (0, $59e7b8bfc6d00736$export$79fefeb1c2091ac3)(props);
    let buttonRef = (0, $acw62.useRef)(null);
    let { triggerProps: triggerProps, overlayProps: overlayProps } = (0, $800f5d9456bca761$export$f9d5c8beee7d008d)({
        type: 'dialog'
    }, state, buttonRef);
    // Allows popover width to match trigger element
    let [buttonWidth, setButtonWidth] = (0, $acw62.useState)(null);
    let onResize = (0, $acw62.useCallback)(()=>{
        if (buttonRef.current) setButtonWidth(buttonRef.current.offsetWidth + 'px');
    }, [
        buttonRef
    ]);
    (0, $d0b7c56cfad5caf3$export$683480f191c0e3ea)({
        ref: buttonRef,
        onResize: onResize
    });
    // Label dialog by the trigger as a fallback if there is no title slot.
    // This is done in RAC instead of hooks because otherwise we cannot distinguish
    // between context and props. Normally aria-labelledby overrides the title
    // but when sent by context we want the title to win.
    triggerProps.id = (0, $855de91ebb07800c$export$f680877a34711e37)();
    overlayProps['aria-labelledby'] = triggerProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $12ee5c1d62d6b2e5$export$2881499e37b75b9a), {
        values: [
            [
                $33689c90e5739620$export$d2f961adcb0afbe,
                state
            ],
            [
                (0, $61ec433404134521$export$795aec4671cbae19),
                state
            ],
            [
                $33689c90e5739620$export$8b93a07348a7730c,
                overlayProps
            ],
            [
                (0, $58149d5ffdda7d3e$export$9b9a0cd73afb7ca4),
                {
                    trigger: 'DialogTrigger',
                    triggerRef: buttonRef,
                    'aria-labelledby': overlayProps['aria-labelledby'],
                    style: {
                        '--trigger-width': buttonWidth
                    }
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $682dc91e15d197fb$export$3351871ee4b288b8), {
        ...triggerProps,
        ref: buttonRef,
        isPressed: state.isOpen
    }, props.children));
}
const $33689c90e5739620$export$3ddf2d174ce01153 = (0, $acw62.forwardRef)(function Dialog(props, ref) {
    let originalAriaLabelledby = props['aria-labelledby'];
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $33689c90e5739620$export$8b93a07348a7730c);
    let { dialogProps: dialogProps, titleProps: titleProps } = (0, $0f7d8ef8f578ec61$export$d55e7ee900f34e93)({
        ...props,
        // Only pass aria-labelledby from props, not context.
        // Context is used as a fallback below.
        'aria-labelledby': originalAriaLabelledby
    }, ref);
    let state = (0, $acw62.useContext)($33689c90e5739620$export$d2f961adcb0afbe);
    if (!dialogProps['aria-label'] && !dialogProps['aria-labelledby']) // If aria-labelledby exists on props, we know it came from context.
    // Use that as a fallback in case there is no title slot.
    {
        if (props['aria-labelledby']) dialogProps['aria-labelledby'] = props['aria-labelledby'];
    }
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        defaultClassName: 'react-aria-Dialog',
        className: props.className,
        style: props.style,
        children: props.children,
        values: {
            close: (state === null || state === void 0 ? void 0 : state.close) || (()=>{})
        }
    });
    let DOMProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)(DOMProps, renderProps, dialogProps),
        ref: ref,
        slot: props.slot || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $12ee5c1d62d6b2e5$export$2881499e37b75b9a), {
        values: [
            [
                (0, $11cc862e572cddbb$export$d688439359537581),
                {
                    slots: {
                        [(0, $12ee5c1d62d6b2e5$export$c62b8e45d58ddad9)]: {},
                        title: {
                            ...titleProps,
                            level: 2
                        }
                    }
                }
            ],
            [
                (0, $541712d7db8b7c7b$export$24d547caef80ccd1),
                {
                    slots: {
                        [(0, $12ee5c1d62d6b2e5$export$c62b8e45d58ddad9)]: {},
                        close: {
                            onPress: ()=>state === null || state === void 0 ? void 0 : state.close()
                        }
                    }
                }
            ]
        ]
    }, renderProps.children));
});






var $acw62 = parcelRequire("acw62");





/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $754d8e2aac1dc1a3$export$703601b7e90536f8 = new WeakMap();
function $754d8e2aac1dc1a3$export$e64b2f635402ca43(props, state, ref) {
    let { keyboardDelegate: keyboardDelegate, isDisabled: isDisabled, isRequired: isRequired, name: name, form: form, validationBehavior: validationBehavior = 'aria' } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, $b66e5976a4251b0c$export$a16aca283550c30d)({
        usage: 'search',
        sensitivity: 'base'
    });
    let delegate = (0, $acw62.useMemo)(()=>keyboardDelegate || new (0, $afe5b32ffd8dcd97$export$a05409b8bb224a5a)(state.collection, state.disabledKeys, ref, collator), [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        collator,
        ref
    ]);
    let { menuTriggerProps: menuTriggerProps, menuProps: menuProps } = (0, $02ef2881ed6cea8d$export$dc9c12ed27dd1b49)({
        isDisabled: isDisabled,
        type: 'listbox'
    }, state, ref);
    let onKeyDown = (e)=>{
        if (state.selectionManager.selectionMode === 'multiple') return;
        switch(e.key){
            case 'ArrowLeft':
                {
                    var _delegate_getKeyAbove, _delegate_getFirstKey;
                    // prevent scrolling containers
                    e.preventDefault();
                    let key = state.selectedKey != null ? (_delegate_getKeyAbove = delegate.getKeyAbove) === null || _delegate_getKeyAbove === void 0 ? void 0 : _delegate_getKeyAbove.call(delegate, state.selectedKey) : (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate);
                    if (key) state.setSelectedKey(key);
                    break;
                }
            case 'ArrowRight':
                {
                    var _delegate_getKeyBelow, _delegate_getFirstKey1;
                    // prevent scrolling containers
                    e.preventDefault();
                    let key = state.selectedKey != null ? (_delegate_getKeyBelow = delegate.getKeyBelow) === null || _delegate_getKeyBelow === void 0 ? void 0 : _delegate_getKeyBelow.call(delegate, state.selectedKey) : (_delegate_getFirstKey1 = delegate.getFirstKey) === null || _delegate_getFirstKey1 === void 0 ? void 0 : _delegate_getFirstKey1.call(delegate);
                    if (key) state.setSelectedKey(key);
                    break;
                }
        }
    };
    let { typeSelectProps: typeSelectProps } = (0, $03cc76e981c32a49$export$e32c88dfddc6e1d8)({
        keyboardDelegate: delegate,
        selectionManager: state.selectionManager,
        onTypeSelect (key) {
            state.setSelectedKey(key);
        }
    });
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $54c383c3558c03c1$export$294aa081a6c6f55d)({
        ...props,
        labelElementType: 'span',
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    typeSelectProps.onKeyDown = typeSelectProps.onKeyDownCapture;
    delete typeSelectProps.onKeyDownCapture;
    if (state.selectionManager.selectionMode === 'multiple') typeSelectProps = {};
    let domProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    let triggerProps = (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(typeSelectProps, menuTriggerProps, fieldProps);
    let valueId = (0, $855de91ebb07800c$export$f680877a34711e37)();
    $754d8e2aac1dc1a3$export$703601b7e90536f8.set(state, {
        isDisabled: isDisabled,
        isRequired: isRequired,
        name: name,
        form: form,
        validationBehavior: validationBehavior
    });
    return {
        labelProps: {
            ...labelProps,
            onClick: ()=>{
                if (!props.isDisabled) {
                    var _ref_current;
                    (_ref_current = ref.current) === null || _ref_current === void 0 || _ref_current.focus();
                    (0, $77c8ff0a3cb27e18$export$8397ddfc504fdb9a)('keyboard');
                }
            }
        },
        triggerProps: (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(domProps, {
            ...triggerProps,
            isDisabled: isDisabled,
            onKeyDown: (0, $366a72b5d02721fb$export$e08e3b67e392101e)(triggerProps.onKeyDown, onKeyDown, props.onKeyDown),
            onKeyUp: props.onKeyUp,
            'aria-labelledby': [
                valueId,
                triggerProps['aria-labelledby'],
                triggerProps['aria-label'] && !triggerProps['aria-labelledby'] ? triggerProps.id : null
            ].filter(Boolean).join(' '),
            onFocus (e) {
                if (state.isFocused) return;
                if (props.onFocus) props.onFocus(e);
                if (props.onFocusChange) props.onFocusChange(true);
                state.setFocused(true);
            },
            onBlur (e) {
                if (state.isOpen) return;
                if (props.onBlur) props.onBlur(e);
                if (props.onFocusChange) props.onFocusChange(false);
                state.setFocused(false);
            }
        }),
        valueProps: {
            id: valueId
        },
        menuProps: {
            ...menuProps,
            autoFocus: state.focusStrategy || true,
            shouldSelectOnPressUp: true,
            shouldFocusOnHover: true,
            disallowEmptySelection: true,
            linkBehavior: 'selection',
            onBlur: (e)=>{
                if (e.currentTarget.contains(e.relatedTarget)) return;
                if (props.onBlur) props.onBlur(e);
                if (props.onFocusChange) props.onFocusChange(false);
                state.setFocused(false);
            },
            'aria-labelledby': [
                fieldProps['aria-labelledby'],
                triggerProps['aria-label'] && !fieldProps['aria-labelledby'] ? triggerProps.id : null
            ].filter(Boolean).join(' ')
        },
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails,
        hiddenSelectProps: {
            isDisabled: isDisabled,
            name: name,
            label: props.label,
            state: state,
            triggerRef: ref,
            form: form
        }
    };
}



var $acw62 = parcelRequire("acw62");



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6d59afdc3ce94e5e$export$f809e80f58e251d1(props, state, triggerRef) {
    let data = (0, $754d8e2aac1dc1a3$export$703601b7e90536f8).get(state) || {};
    let { autoComplete: autoComplete, name: name = data.name, form: form = data.form, isDisabled: isDisabled = data.isDisabled } = props;
    let { validationBehavior: validationBehavior, isRequired: isRequired } = data;
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $2b6fccd6bf1aab09$export$a966af930f325cab)({
        style: {
            // Prevent page scrolling.
            position: 'fixed',
            top: 0,
            left: 0
        }
    });
    (0, $7f099d759e9c1e4d$export$5add1d006293d136)(props.selectRef, state.defaultValue, state.setValue);
    (0, $13ce3eede8664ea0$export$b8473d3665f3a75a)({
        validationBehavior: validationBehavior,
        focus: ()=>{
            var _triggerRef_current;
            return (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
        }
    }, state, props.selectRef);
    let setValue = state.setValue;
    let onChange = (0, $acw62.useCallback)((e)=>{
        if (e.target.multiple) setValue(Array.from(e.target.selectedOptions, (option)=>option.value));
        else setValue(e.currentTarget.value);
    }, [
        setValue
    ]);
    var _state_value;
    // In Safari, the <select> cannot have `display: none` or `hidden` for autofill to work.
    // In Firefox, there must be a <label> to identify the <select> whereas other browsers
    // seem to identify it just by surrounding text.
    // The solution is to use <VisuallyHidden> to hide the elements, which clips the elements to a
    // 1px rectangle. In addition, we hide from screen readers with aria-hidden, and make the <select>
    // non tabbable with tabIndex={-1}.
    return {
        containerProps: {
            ...visuallyHiddenProps,
            'aria-hidden': true,
            // @ts-ignore
            ['data-react-aria-prevent-focus']: true,
            // @ts-ignore
            ['data-a11y-ignore']: 'aria-hidden-focus'
        },
        inputProps: {
            style: {
                display: 'none'
            }
        },
        selectProps: {
            tabIndex: -1,
            autoComplete: autoComplete,
            disabled: isDisabled,
            multiple: state.selectionManager.selectionMode === 'multiple',
            required: validationBehavior === 'native' && isRequired,
            name: name,
            form: form,
            value: (_state_value = state.value) !== null && _state_value !== void 0 ? _state_value : '',
            onChange: onChange,
            onInput: onChange
        }
    };
}
function $6d59afdc3ce94e5e$export$cbd84cdb2e668835(props) {
    let { state: state, triggerRef: triggerRef, label: label, name: name, form: form, isDisabled: isDisabled } = props;
    let selectRef = (0, $acw62.useRef)(null);
    let inputRef = (0, $acw62.useRef)(null);
    let { containerProps: containerProps, selectProps: selectProps } = $6d59afdc3ce94e5e$export$f809e80f58e251d1({
        ...props,
        selectRef: state.collection.size <= 300 ? selectRef : inputRef
    }, state, triggerRef);
    // If used in a <form>, use a hidden input so the value can be submitted to a server.
    // If the collection isn't too big, use a hidden <select> element for this so that browser
    // autofill will work. Otherwise, use an <input type="hidden">.
    if (state.collection.size <= 300) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...containerProps,
        "data-testid": "hidden-select-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", null, label, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        ...selectProps,
        ref: selectRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", null), [
        ...state.collection.getKeys()
    ].map((key)=>{
        let item = state.collection.getItem(key);
        if (item && item.type === 'item') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: item.key,
            value: item.key
        }, item.textValue);
    }))));
    else if (name) {
        let data = (0, $754d8e2aac1dc1a3$export$703601b7e90536f8).get(state) || {};
        let { validationBehavior: validationBehavior } = data;
        // Always render at least one hidden input to ensure required form submission.
        let values = Array.isArray(state.value) ? state.value : [
            state.value
        ];
        if (values.length === 0) values = [
            null
        ];
        let res = values.map((value, i)=>{
            let inputProps = {
                type: 'hidden',
                autoComplete: selectProps.autoComplete,
                name: name,
                form: form,
                disabled: isDisabled,
                value: value !== null && value !== void 0 ? value : ''
            };
            if (validationBehavior === 'native') // so that an empty value blocks HTML form submission when the field is required.
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                key: i,
                ...inputProps,
                ref: i === 0 ? inputRef : null,
                style: {
                    display: 'none'
                },
                type: "text",
                required: i === 0 ? selectProps.required : false,
                onChange: ()=>{}
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                key: i,
                ...inputProps,
                ref: i === 0 ? inputRef : null
            });
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, res);
    }
    return null;
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $de83c0c9a729c90d$export$a2f47a3d2973640(options = {}) {
    let { locale: locale } = (0, $a7e3b1109bf64033$export$43bb16f9c6d9e3f7)();
    return (0, $acw62.useMemo)(()=>new Intl.ListFormat(locale, options), [
        locale,
        options
    ]);
}







var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $27a42756236882d9$export$5159ec8b34d4ec12(props) {
    let { selectionMode: selectionMode = 'single' } = props;
    let triggerState = (0, $9a55ce4a79a9cb0d$export$61c6a8c84e605fb6)(props);
    let [focusStrategy, setFocusStrategy] = (0, $acw62.useState)(null);
    let defaultValue = (0, $acw62.useMemo)(()=>{
        var _props_defaultSelectedKey;
        return props.defaultValue !== undefined ? props.defaultValue : selectionMode === 'single' ? (_props_defaultSelectedKey = props.defaultSelectedKey) !== null && _props_defaultSelectedKey !== void 0 ? _props_defaultSelectedKey : null : [];
    }, [
        props.defaultValue,
        props.defaultSelectedKey,
        selectionMode
    ]);
    let value = (0, $acw62.useMemo)(()=>{
        return props.value !== undefined ? props.value : selectionMode === 'single' ? props.selectedKey : undefined;
    }, [
        props.value,
        props.selectedKey,
        selectionMode
    ]);
    let [controlledValue, setControlledValue] = (0, $3316814d6906df5c$export$40bfa8c7b0832715)(value, defaultValue, props.onChange);
    // Only display the first selected item if in single selection mode but the value is an array.
    let displayValue = selectionMode === 'single' && Array.isArray(controlledValue) ? controlledValue[0] : controlledValue;
    let setValue = (value)=>{
        if (selectionMode === 'single') {
            var _props_onSelectionChange;
            var _value_;
            let key = Array.isArray(value) ? (_value_ = value[0]) !== null && _value_ !== void 0 ? _value_ : null : value;
            setControlledValue(key);
            if (key !== displayValue) (_props_onSelectionChange = props.onSelectionChange) === null || _props_onSelectionChange === void 0 || _props_onSelectionChange.call(props, key);
        } else {
            let keys = [];
            if (Array.isArray(value)) keys = value;
            else if (value != null) keys = [
                value
            ];
            setControlledValue(keys);
        }
    };
    let listState = (0, $54ac9d6cc3ba2949$export$2f645645f7bca764)({
        ...props,
        selectionMode: selectionMode,
        disallowEmptySelection: selectionMode === 'single',
        allowDuplicateSelectionEvents: true,
        selectedKeys: (0, $acw62.useMemo)(()=>$27a42756236882d9$var$$2bc3a590c5373a4e$var$convertValue(displayValue), [
            displayValue
        ]),
        onSelectionChange: (keys)=>{
            // impossible, but TS doesn't know that
            if (keys === 'all') return;
            if (selectionMode === 'single') {
                var _keys_values_next_value;
                let key = (_keys_values_next_value = keys.values().next().value) !== null && _keys_values_next_value !== void 0 ? _keys_values_next_value : null;
                setValue(key);
                triggerState.close();
            } else setValue([
                ...keys
            ]);
            validationState.commitValidation();
        }
    });
    let selectedKey = listState.selectionManager.firstSelectedKey;
    let selectedItems = (0, $acw62.useMemo)(()=>{
        return [
            ...listState.selectionManager.selectedKeys
        ].map((key)=>listState.collection.getItem(key)).filter((item)=>item != null);
    }, [
        listState.selectionManager.selectedKeys,
        listState.collection
    ]);
    let validationState = (0, $bf01417b417639db$export$fc1a364ae1f3ff10)({
        ...props,
        value: Array.isArray(displayValue) && displayValue.length === 0 ? null : displayValue
    });
    let [isFocused, setFocused] = (0, $acw62.useState)(false);
    let [initialValue] = (0, $acw62.useState)(displayValue);
    var _selectedItems_, _props_defaultSelectedKey;
    return {
        ...validationState,
        ...listState,
        ...triggerState,
        value: displayValue,
        defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : initialValue,
        setValue: setValue,
        selectedKey: selectedKey,
        setSelectedKey: setValue,
        selectedItem: (_selectedItems_ = selectedItems[0]) !== null && _selectedItems_ !== void 0 ? _selectedItems_ : null,
        selectedItems: selectedItems,
        defaultSelectedKey: (_props_defaultSelectedKey = props.defaultSelectedKey) !== null && _props_defaultSelectedKey !== void 0 ? _props_defaultSelectedKey : props.selectionMode === 'single' ? initialValue : null,
        focusStrategy: focusStrategy,
        open (focusStrategy = null) {
            // Don't open if the collection is empty.
            if (listState.collection.size !== 0 || props.allowsEmptyCollection) {
                setFocusStrategy(focusStrategy);
                triggerState.open();
            }
        },
        toggle (focusStrategy = null) {
            if (listState.collection.size !== 0 || props.allowsEmptyCollection) {
                setFocusStrategy(focusStrategy);
                triggerState.toggle();
            }
        },
        isFocused: isFocused,
        setFocused: setFocused
    };
}
function $27a42756236882d9$var$$2bc3a590c5373a4e$var$convertValue(value) {
    if (value === undefined) return undefined;
    if (value === null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
}





var $acw62 = parcelRequire("acw62");
function $289d77013fb9bcb8$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $289d77013fb9bcb8$export$7540cee5be7dc19b = (0, $acw62.createContext)(null);
const $289d77013fb9bcb8$export$ef445b55be0601bd = (0, $acw62.createContext)(null);
const $289d77013fb9bcb8$export$ef9b1a59e592288f = (0, $acw62.forwardRef)(function Select(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $289d77013fb9bcb8$export$7540cee5be7dc19b);
    let { children: children, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false } = props;
    let content = (0, $acw62.useMemo)(()=>typeof children === 'function' ? children({
            isOpen: false,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isRequired: isRequired,
            isFocused: false,
            isFocusVisible: false,
            defaultChildren: null
        }) : children, [
        children,
        isDisabled,
        isInvalid,
        isRequired
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5fe83fb7b4e6e89f$export$bf788dd355e3a401), {
        content: content
    }, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($289d77013fb9bcb8$var$$82d7e5349645de74$var$SelectInner, {
            props: props,
            collection: collection,
            selectRef: ref
        }));
});
// Contexts to clear inside the popover.
const $289d77013fb9bcb8$var$$82d7e5349645de74$var$CLEAR_CONTEXTS = [
    (0, $794346013ab6e680$export$75b6ee27786ba447),
    (0, $541712d7db8b7c7b$export$24d547caef80ccd1),
    (0, $424592b5daddcd29$export$9afb8bc826b033ea)
];
function $289d77013fb9bcb8$var$$82d7e5349645de74$var$SelectInner({ props: props, selectRef: ref, collection: collection }) {
    let { validationBehavior: formValidationBehavior } = (0, $12ee5c1d62d6b2e5$export$fabf2dc03a41866e)((0, $99b9335b6cbca82a$export$c24727297075ec6a)) || {};
    var _props_validationBehavior, _ref;
    let validationBehavior = (_ref = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : formValidationBehavior) !== null && _ref !== void 0 ? _ref : 'native';
    let state = (0, $27a42756236882d9$export$5159ec8b34d4ec12)({
        ...props,
        collection: collection,
        children: undefined,
        validationBehavior: validationBehavior
    });
    let { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $da27ef38ba6b0ce3$export$4e328f61c538687f)({
        within: true
    });
    // Get props for child elements from useSelect
    let buttonRef = (0, $acw62.useRef)(null);
    let [labelRef, label] = (0, $12ee5c1d62d6b2e5$export$9d4c57ee4c6ffdd8)(!props['aria-label'] && !props['aria-labelledby']);
    let { labelProps: labelProps, triggerProps: triggerProps, valueProps: valueProps, menuProps: menuProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, hiddenSelectProps: hiddenSelectProps, ...validation } = (0, $754d8e2aac1dc1a3$export$e64b2f635402ca43)({
        ...(0, $12ee5c1d62d6b2e5$export$ef03459518577ad4)(props),
        label: label,
        validationBehavior: validationBehavior
    }, state, buttonRef);
    // Make menu width match input + button
    let [buttonWidth, setButtonWidth] = (0, $acw62.useState)(null);
    let onResize = (0, $acw62.useCallback)(()=>{
        if (buttonRef.current) setButtonWidth(buttonRef.current.offsetWidth + 'px');
    }, [
        buttonRef
    ]);
    (0, $d0b7c56cfad5caf3$export$683480f191c0e3ea)({
        ref: buttonRef,
        onResize: onResize
    });
    // Only expose a subset of state to renderProps function to avoid infinite render loop
    let renderPropsState = (0, $acw62.useMemo)(()=>({
            isOpen: state.isOpen,
            isFocused: state.isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid || false,
            isRequired: props.isRequired || false
        }), [
        state.isOpen,
        state.isFocused,
        isFocusVisible,
        props.isDisabled,
        validation.isInvalid,
        props.isRequired
    ]);
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        ...props,
        values: renderPropsState,
        defaultClassName: 'react-aria-Select'
    });
    let DOMProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.id;
    let scrollRef = (0, $acw62.useRef)(null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $12ee5c1d62d6b2e5$export$2881499e37b75b9a), {
        values: [
            [
                $289d77013fb9bcb8$export$7540cee5be7dc19b,
                props
            ],
            [
                $289d77013fb9bcb8$export$ef445b55be0601bd,
                state
            ],
            [
                $289d77013fb9bcb8$export$f8f745c04421623f,
                valueProps
            ],
            [
                (0, $794346013ab6e680$export$75b6ee27786ba447),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: 'span'
                }
            ],
            [
                (0, $541712d7db8b7c7b$export$24d547caef80ccd1),
                {
                    ...triggerProps,
                    ref: buttonRef,
                    isPressed: state.isOpen,
                    autoFocus: props.autoFocus
                }
            ],
            [
                (0, $33689c90e5739620$export$d2f961adcb0afbe),
                state
            ],
            [
                (0, $58149d5ffdda7d3e$export$9b9a0cd73afb7ca4),
                {
                    trigger: 'Select',
                    triggerRef: buttonRef,
                    scrollRef: scrollRef,
                    placement: 'bottom start',
                    style: {
                        '--trigger-width': buttonWidth
                    },
                    'aria-labelledby': menuProps['aria-labelledby'],
                    clearContexts: $289d77013fb9bcb8$var$$82d7e5349645de74$var$CLEAR_CONTEXTS
                }
            ],
            [
                (0, $eddedc696190b9ab$export$7ff8f37d2d81a48d),
                {
                    ...menuProps,
                    ref: scrollRef
                }
            ],
            [
                (0, $eddedc696190b9ab$export$7c5906fe4f1f2af2),
                state
            ],
            [
                (0, $424592b5daddcd29$export$9afb8bc826b033ea),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $7dd8b2fec65d8b6a$export$ff05c3ac10437e03),
                validation
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)(DOMProps, renderProps, focusProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-focused": state.isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-open": state.isOpen || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined,
        "data-required": props.isRequired || undefined
    }, renderProps.children, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6d59afdc3ce94e5e$export$cbd84cdb2e668835), {
        ...hiddenSelectProps,
        autoComplete: props.autoComplete
    })));
}
const $289d77013fb9bcb8$export$f8f745c04421623f = (0, $acw62.createContext)(null);
const $289d77013fb9bcb8$export$e288731fd71264f0 = (0, $73addfbf71cdc088$export$86427a43e3e48ebb)(function SelectValue(props, ref) {
    var _state_selectedItems_;
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $289d77013fb9bcb8$export$f8f745c04421623f);
    let state = (0, $acw62.useContext)($289d77013fb9bcb8$export$ef445b55be0601bd);
    let { placeholder: placeholder } = (0, $12ee5c1d62d6b2e5$export$fabf2dc03a41866e)($289d77013fb9bcb8$export$7540cee5be7dc19b);
    let rendered = state.selectedItems.map((item)=>{
        var _item_props;
        let rendered = (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.children;
        // If the selected item has a function as a child, we need to call it to render to React.JSX.
        if (typeof rendered === 'function') {
            let fn = rendered;
            rendered = fn({
                isHovered: false,
                isPressed: false,
                isSelected: false,
                isFocused: false,
                isFocusVisible: false,
                isDisabled: false,
                selectionMode: 'single',
                selectionBehavior: 'toggle'
            });
        }
        return rendered;
    });
    let formatter = (0, $de83c0c9a729c90d$export$a2f47a3d2973640)();
    let textValue = (0, $acw62.useMemo)(()=>state.selectedItems.map((item)=>item === null || item === void 0 ? void 0 : item.textValue), [
        state.selectedItems
    ]);
    let selectionMode = state.selectionManager.selectionMode;
    let selectedText = (0, $acw62.useMemo)(()=>{
        var _textValue_;
        return selectionMode === 'single' ? (_textValue_ = textValue[0]) !== null && _textValue_ !== void 0 ? _textValue_ : '' : formatter.format(textValue);
    }, [
        selectionMode,
        formatter,
        textValue
    ]);
    let defaultChildren = (0, $acw62.useMemo)(()=>{
        if (selectionMode === 'single') return rendered[0];
        let parts = formatter.formatToParts(textValue);
        if (parts.length === 0) return null;
        let index = 0;
        return parts.map((part)=>{
            if (part.type === 'element') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), {
                key: index
            }, rendered[index++]);
            else return part.value;
        });
    }, [
        selectionMode,
        formatter,
        textValue,
        rendered
    ]);
    let stringFormatter = (0, $3681d06d99b0f841$export$f12b703ca79dfbb1)($289d77013fb9bcb8$var$$parcel$interopDefault((0, $b17b813572a3b535$export$2e2bcd8739ae039)), 'react-aria-components');
    var _ref, _state_selectedItems__value;
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        ...props,
        defaultChildren: (_ref = defaultChildren !== null && defaultChildren !== void 0 ? defaultChildren : placeholder) !== null && _ref !== void 0 ? _ref : stringFormatter.format('selectPlaceholder'),
        defaultClassName: 'react-aria-SelectValue',
        values: {
            selectedItem: (_state_selectedItems__value = (_state_selectedItems_ = state.selectedItems[0]) === null || _state_selectedItems_ === void 0 ? void 0 : _state_selectedItems_.value) !== null && _state_selectedItems__value !== void 0 ? _state_selectedItems__value : null,
            selectedItems: (0, $acw62.useMemo)(()=>state.selectedItems.map((item)=>{
                    var _item_value;
                    return (_item_value = item.value) !== null && _item_value !== void 0 ? _item_value : null;
                }), [
                state.selectedItems
            ]),
            selectedText: selectedText,
            isPlaceholder: state.selectedItems.length === 0,
            state: state
        }
    });
    let DOMProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: ref,
        ...DOMProps,
        ...renderProps,
        "data-placeholder": state.selectedItems.length === 0 || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $424592b5daddcd29$export$9afb8bc826b033ea).Provider, {
        value: undefined
    }, renderProps.children));
});








var $acw62 = parcelRequire("acw62");

function $748dcc472c9de93e$export$931cbfb6bfb85fc({ label: label, items: items, onSelect: onSelect, className: className, disabled: disabled }) {
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [highlightedIndex, setHighlightedIndex] = (0, $acw62.useState)(-1);
    const btnRef = (0, $acw62.useRef)(null);
    const menuRef = (0, $acw62.useRef)(null);
    const itemRefs = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const handler = (e)=>{
            if (!menuRef.current || !btnRef.current) return;
            if (!menuRef.current.contains(e.target) && !btnRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return ()=>document.removeEventListener('mousedown', handler);
    }, [
        open
    ]);
    const handleSelect = (0, $acw62.useCallback)((item)=>{
        if (!item.disabled) {
            onSelect(item);
            setOpen(false);
            setHighlightedIndex(-1);
            btnRef.current?.focus();
        }
    }, [
        onSelect
    ]);
    const onKeyDownList = (0, $acw62.useCallback)((e)=>{
        if (!open) return;
        if (e.key === 'Escape') {
            e.preventDefault();
            setOpen(false);
            btnRef.current?.focus();
            return;
        }
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setHighlightedIndex((prev)=>{
                const next = prev + 1 >= items.length ? 0 : prev + 1;
                return next;
            });
            return;
        }
        if (e.key === 'ArrowUp') {
            e.preventDefault();
            setHighlightedIndex((prev)=>{
                const next = prev - 1 < 0 ? items.length - 1 : prev - 1;
                return next;
            });
            return;
        }
        if (e.key === 'Enter') {
            e.preventDefault();
            if (highlightedIndex >= 0 && highlightedIndex < items.length) handleSelect(items[highlightedIndex]);
        }
        if (e.key === 'Home') {
            e.preventDefault();
            setHighlightedIndex(0);
        }
        if (e.key === 'End') {
            e.preventDefault();
            setHighlightedIndex(items.length - 1);
        }
    }, [
        open,
        items,
        highlightedIndex,
        handleSelect
    ]);
    (0, $acw62.useEffect)(()=>{
        if (open && items.length > 0) setHighlightedIndex((prev)=>prev === -1 ? 0 : prev);
    }, [
        open,
        items.length
    ]);
    (0, $acw62.useEffect)(()=>{
        if (open && highlightedIndex >= 0 && itemRefs.current[highlightedIndex]) itemRefs.current[highlightedIndex].focus();
    }, [
        highlightedIndex,
        open
    ]);
    const handleButtonKeyDown = (e)=>{
        if (disabled) return;
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            setOpen(true);
            setHighlightedIndex(()=>{
                if (e.key === 'ArrowDown') return 0;
                return items.length - 1;
            });
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('relative inline-block text-left text-body', className),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                ref: btnRef,
                type: "button",
                "aria-haspopup": "listbox",
                "aria-expanded": open,
                className: "p-2.5 pr-8.5 text-small bg-white text-gray-500 rounded-md font-normal disabled:opacity-50 disabled:pointer-events-none",
                onClick: ()=>{
                    if (disabled) return;
                    setOpen((o)=>!o);
                },
                onKeyDown: handleButtonKeyDown,
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: label
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2.5",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dcddf554cab09b71$export$2e2bcd8739ae039), {
                            className: "size-3.75 text-gray-500"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4), {
                show: open,
                enter: "transition-opacity duration-150",
                enterFrom: "opacity-0",
                enterTo: "opacity-100",
                leave: "transition-opacity duration-150",
                leaveFrom: "opacity-100",
                leaveTo: "opacity-0",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                    ref: menuRef,
                    role: "listbox",
                    tabIndex: -1,
                    onKeyDown: onKeyDownList,
                    className: "absolute z-50 mt-[1px] max-h-[225px] w-full min-w-[310px] overflow-auto rounded shadow-lg bg-white py-1.25 caption font-medium",
                    children: items.map((item, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            ref: (el)=>itemRefs.current[idx] = el,
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('p-2.5 mb-1.25 transition-colors cursor-pointer last:mb-0 data-[disabled=false]:hover:bg-primary-100 data-[disabled=false]:active:bg-primary-100 data-[disabled=true]:opacity-50 data-[disabled=true]:cursor-default'),
                            role: "option",
                            "aria-selected": highlightedIndex === idx || item.isSelected,
                            tabIndex: -1,
                            onClick: ()=>handleSelect(item),
                            onMouseEnter: ()=>setHighlightedIndex(idx),
                            "data-disabled": item.disabled,
                            children: item.label
                        }, item.value))
                })
            })
        ]
    });
}
function $748dcc472c9de93e$export$41f133550aa26f48({ children: children, ...props }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eddedc696190b9ab$export$41f133550aa26f48), {
        ...props,
        className: "py-1 empty:p-0 outline-0 w-full bg-white border rounded box-border max-h-[inherit] overflow-auto [clip-path:inset(0_0_0_0_round_.25rem)]",
        children: children
    });
}
const $748dcc472c9de93e$export$25fefe78d771888d = {
    extend: 'focusRing',
    base: 'group relative flex items-center gap-8 cursor-default select-none py-2 px-3',
    variants: {
        isSelected: {
            false: 'text-neutral-700 dark:text-neutral-300 hover:bg-neutral-100 pressed:bg-neutral-100 dark:hover:bg-neutral-800 dark:pressed:bg-neutral-800 -outline-offset-2',
            true: 'bg-blue-600 text-white forced-colors:bg-[Highlight] forced-colors:text-[HighlightText] [&:has(+[data-selected])]:rounded-b-none [&+[data-selected]]:rounded-t-none -outline-offset-4 outline-white dark:outline-white forced-colors:outline-[HighlightText]'
        },
        isDisabled: {
            true: 'text-neutral-300 dark:text-neutral-600 forced-colors:text-[GrayText]'
        }
    }
};
function $748dcc472c9de93e$export$a11e76429ed99b4({ children: children, ...props }) {
    let textValue = props.textValue || (typeof props.children === 'string' ? props.children : undefined);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eddedc696190b9ab$export$a11e76429ed99b4), {
        ...props,
        textValue: textValue,
        className: $748dcc472c9de93e$export$25fefe78d771888d.base,
        children: children
    });
}
function $748dcc472c9de93e$export$6648d5fa18559e7f(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eddedc696190b9ab$export$a11e76429ed99b4), {
        className: "group/item",
        ...props,
        children: (0, $12ee5c1d62d6b2e5$export$c245e6201fed2f75)(props.children, (children)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "flex items-center flex-1 gap-2 text-base font-normal truncate px-2 py-1.5 group-data-[hovered=true]/item:bg-primary-500 group-data-[hovered=true]/item:text-white group-data-[focused=true]/item:bg-primary-500 group-data-[focused=true]/item:text-white",
                children: children
            }))
    });
}
function $748dcc472c9de93e$export$7ab5ff309fff16bb({ title: title, items: items, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $eddedc696190b9ab$export$dca12b0bb56e4fc), {
        className: "after:content-[''] after:block after:h-[5px] last:after:hidden",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c879a8de1219885d$export$8b251419efc915eb), {
                className: "text-base font-semibold truncate px-2 py-1.5 [&+*]:mt-1",
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5fe83fb7b4e6e89f$export$fb8073518f34e6ec), {
                items: items,
                children: children
            })
        ]
    });
}






function $4916017e31e74360$export$5b6b19405a83ff9d({ className: className, loading: loading, ...props }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $58149d5ffdda7d3e$export$5b6b19405a83ff9d), {
        offset: 0,
        ...props,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(className, 'mt-1 bg-white rounded-md border border-solid border-300 shadow-md bg-clip-padding outline-0'),
        children: (0, $12ee5c1d62d6b2e5$export$c245e6201fed2f75)(props.children, (children, { isEntering: isEntering, isExiting: isExiting })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('duration-700', isEntering && 'ease-out animate-in fade-in', isExiting && 'ease-in animate-out fade-out'),
                children: children
            }))
    });
}


const $4cd9875607f3fe92$export$43b5183e9b4e4d46 = /*#__PURE__*/ (0, $acw62.forwardRef)(function Select({ label: label, options: options, placeholder: placeholder = '', ...props }, ref) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $289d77013fb9bcb8$export$ef9b1a59e592288f), {
        ...props,
        placeholder: placeholder,
        ref: ref,
        className: "group flex flex-col gap-1 relative",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e29ab1100b9991a4$export$b04be29aa201d4f5), {
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $541712d7db8b7c7b$export$353f5b6fc5456de1), {
                name: props.name,
                className: "h-10.5 text-body-dark hover:text-body-dark rounded-md border border-solid border-300 shadow-sm placeholder:text-light-500 focus-within:ring-1 ring-primary focus-within:border-primary bg-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c1367d7afc3d8fbe$export$eb2fcfdbd7ba97d4), {
                    className: "flex items-center relative justify-stretch w-full",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $289d77013fb9bcb8$export$e288731fd71264f0), {
                            className: "data-[placeholder=true]:px-2 data-[placeholder=true]:text-light-500",
                            children: ({ defaultChildren: defaultChildren })=>defaultChildren
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dcddf554cab09b71$export$2e2bcd8739ae039), {
                            className: "absolute right-2 top-1/2 -translate-y-2.5 size-5 pointer-events-none text-light-400 grow-0",
                            "aria-hidden": "true"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4916017e31e74360$export$5b6b19405a83ff9d), {
                className: "w-[--trigger-width]",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $748dcc472c9de93e$export$41f133550aa26f48), {
                    items: options,
                    className: "outline-hidden box-border p-1 max-h-[inherit] overflow-auto [clip-path:inset(0_0_0_0_round_.75rem)]",
                    children: ({ value: value, label: label, disabled: disabled })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $748dcc472c9de93e$export$6648d5fa18559e7f), {
                            id: value,
                            textValue: label,
                            disabled: disabled,
                            children: label
                        })
                })
            })
        ]
    });
});
function $4cd9875607f3fe92$export$ef9b1a59e592288f(props) {
    const { field: field } = (0, $0d70f179cf56e662$export$e8c786024a2b0a79)({
        name: props.name
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cd9875607f3fe92$export$43b5183e9b4e4d46, {
        ...props,
        ...field,
        isDisabled: props.disabled
    });
}


const $d7da738cd227c811$var$bookmarkSteps = [
    {
        path: /\/(specialist|appointment|appointment-reserved)$/,
        to: 'specialist',
        labelKey: 'step.appointment',
        status: (_, invite)=>invite.appointment ? 'done' : 'todo',
        useStepDetails: $d7da738cd227c811$var$useAppointmentDetails
    },
    {
        path: /\/(name-birthdate|nhi-residency|home-address|contact-details|doctor|emergency)$/,
        to: 'name-birthdate',
        labelKey: 'step.details',
        status: ({ patient: patient, gp: gp, emergency: emergency })=>{
            const completed = [
                patient?.dateOfBirth,
                typeof patient?.isResident === 'boolean',
                patient?.address,
                patient?.email,
                gp,
                emergency?.fullName
            ].filter(Boolean);
            return completed.length === 6 ? 'done' : completed.length === 0 ? 'todo' : 'doing';
        },
        useStepDetails: $d7da738cd227c811$var$useNoDetails
    },
    {
        path: /\/insurance$/,
        to: 'insurance',
        labelKey: 'step.insurance',
        status: ({ insurance: insurance })=>typeof insurance?.termsAccepted === 'boolean' ? 'done' : 'todo',
        useStepDetails: $d7da738cd227c811$var$useInsuranceDetails
    },
    {
        path: /\/health-[a-z-]+$/,
        to: 'health-questions',
        labelKey: 'step.health-questions',
        status: (...args)=>{
            const total = (0, $e5c7a076ba516446$export$64e7b4513fce920).length;
            const done = (0, $e5c7a076ba516446$export$64e7b4513fce920).reduce((acc, q)=>acc + (q.done(...args) ? 1 : 0), 0);
            return done === total ? 'done' : done > 0 ? 'doing' : 'todo';
        },
        useStepDetails: $d7da738cd227c811$var$useHealthQuestionsDetails
    },
    {
        path: /\/medications$/,
        to: 'medications',
        labelKey: 'step.medications',
        status: ({ medicationsConfirmed: medicationsConfirmed })=>medicationsConfirmed ? 'done' : 'todo',
        useStepDetails: $d7da738cd227c811$var$useNoDetails
    },
    {
        path: /\/history$/,
        to: 'history',
        labelKey: 'step.history',
        status: ({ proceduresConfirmed: proceduresConfirmed })=>proceduresConfirmed ? 'done' : 'todo',
        useStepDetails: $d7da738cd227c811$var$useNoDetails
    },
    {
        path: /\/preference-[a-z-]+$/,
        to: 'preference-mobility',
        labelKey: 'step.preference-questions',
        status: (...args)=>{
            const total = (0, $403b1d2dd4bc76fe$export$b789f320c0d06368).length;
            const done = (0, $403b1d2dd4bc76fe$export$b789f320c0d06368).reduce((acc, q)=>acc + (q.done(...args) ? 1 : 0), 0);
            return done === total ? 'done' : done > 0 ? 'doing' : 'todo';
        },
        useStepDetails: $d7da738cd227c811$var$useNoDetails
    }
];
function $d7da738cd227c811$export$d91fe704b267f194({ nextLabel: nextLabel }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [menuOpen, setMenuOpen] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("footer", {
        className: "w-full",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
            "aria-label": t('bookmarksMenu'),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d7da738cd227c811$var$MenuButton, {
                            onClick: ()=>setMenuOpen(true)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef08a5ee29d75f65$export$b03061e17dddb512), {
                            label: nextLabel
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d7da738cd227c811$var$MenuDrawer, {
                    menuOpen: menuOpen,
                    setMenuOpen: setMenuOpen
                })
            ]
        })
    });
}
function $d7da738cd227c811$var$MenuButton({ onClick: onClick }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        type: "button",
        className: "flex-shrink-0 size-12.5 flex items-center justify-center text-white bg-primary-active hover:text-white hover:bg-primary-hover active:bg-primary",
        onClick: onClick,
        "aria-label": t('openBookmarksMenu'),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f828eed5b069fd9$export$2e2bcd8739ae039), {
            className: "size-7.5"
        })
    });
}
function $d7da738cd227c811$var$MenuDrawer({ menuOpen: menuOpen, setMenuOpen: setMenuOpen }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const location = (0, $618a07bedf38a2ba$export$45d76561a5302f2b)();
    const { invite: invite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    const bookmarks = (0, $acw62.useMemo)(()=>{
        let current = -1;
        const statuses = $d7da738cd227c811$var$bookmarkSteps.map((step, index, array)=>{
            let status = step.status(invite.onlineBookingData, invite);
            if (step.path.test(location.pathname)) {
                current = index;
                const prevStatus = array[index - 1]?.status(invite.onlineBookingData, invite) ?? 'done';
                if (status !== 'done' && prevStatus === 'done') status = 'doing';
            }
            return status;
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
            className: "flex-grow overflow-hidden",
            children: $d7da738cd227c811$var$bookmarkSteps.map((step, index, array)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d7da738cd227c811$var$MenuDrawerStepItem, {
                    step: {
                        ...step,
                        status: statuses[index],
                        current: current === index
                    },
                    next: {
                        ...array[index + 1] ?? {},
                        status: statuses[index + 1] ?? 'todo'
                    },
                    prev: {
                        ...array[index - 1] ?? {},
                        status: statuses[index - 1] ?? 'done'
                    },
                    current: current === index,
                    setMenuOpen: setMenuOpen
                }, step.labelKey))
        });
    }, [
        invite,
        location.pathname,
        setMenuOpen
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11a90cea0cc9744a$export$3ddf2d174ce01153), {
        open: menuOpen,
        onOpenChange: setMenuOpen,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11a90cea0cc9744a$export$b6d9565de1e068cf), {
            className: "Dialog fixed flex flex-col top-0 left-0 size-full overflow-y-auto sm:w-[390px] p-5 bg-primary-active text-white",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "container flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $11a90cea0cc9744a$export$2cd93e047c5f0909), {
                        className: "title-sm flex items-start justify-between gap-4 mb-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t('yourProgress')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11a90cea0cc9744a$export$fba2fb7cd781b7ac), {
                                className: "hover:text-primary-light",
                                "aria-label": t('closeDialog'),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1be71097818d26ed$export$2e2bcd8739ae039), {
                                    className: "size-6",
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    }),
                    bookmarks
                ]
            })
        })
    });
}
function $d7da738cd227c811$var$MenuDrawerStepItem({ step: step, prev: prev, next: next, setMenuOpen: setMenuOpen }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { invite: invite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    const href = step.to && !step.current ? `/${invite.reference}/${step.to}` : null;
    const { summary: summary = null, actions: actions = null } = step.useStepDetails({
        href: href,
        setMenuOpen: setMenuOpen,
        status: step.status
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
        className: "pb-[1.5rem] first:mt-0 flex flex-row items-stretch gap-3 group/step",
        "data-status": step.status,
        "data-prev-status": prev.status,
        "data-has-prev": !!prev,
        "data-next-status": next.status,
        "data-has-next": !!next,
        "data-current": step.current,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative flex-grow flex flex-col justify-start w-9 max-w-9",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex-shrink-0 size-9 flex items-center justify-center rounded-full border-2 border-success-600 group-data-[status=done]/step:bg-success-600 group-data-[status=doing]/step:bg-light-active group-data-[status=todo]/step:bg-white group-data-[status=todo]/step:border-slate-400 after:top-1/2 after:size-3 after:bg-success-600 after:rounded-full after:hidden group-data-[status=doing]/step:after:block  group-data-[status=todo]/step:opacity-50",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8faef5e48f16404b$export$2e2bcd8739ae039), {
                            className: "size-5 text-white hidden group-data-[status=done]/step:block"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        className: "absolute h-[calc(100%_+_1.5rem_-_theme(spacing.9))] -bottom-[1.5rem] left-1/2 border-l-[2px] border-success-600 -z-1 group-data-[has-next=false]/step:hidden group-data-[next-status=todo]/step:hidden group-data-[next-status=doing]/step:border-white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col items-start justify-center w-full",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $618a07bedf38a2ba$export$a6c7ac8248d6e38a), {
                        to: href,
                        className: "flex flex-col justify-center w-full group-data-[status=todo]/step:opacity-50 group-data-[current=true]/step:font-bold hover:text-inherit",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-small w-full truncate",
                                children: t(step.labelKey)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "pt-1 flex flex-col group-data-[status=todo]/step:hidden",
                                children: summary
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-col w-full group-data-[status=todo]/step:hidden",
                        children: actions
                    })
                ]
            })
        ]
    });
}
function $d7da738cd227c811$var$useNoDetails() {
    return 0, $2bd9d04ce55ef2a0$export$253fab909bb52269;
}
function $d7da738cd227c811$var$useAppointmentDetails() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.specialist');
    const { invite: invite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    const { appointment: appointment } = invite;
    return (0, $acw62.useMemo)(()=>{
        if (appointment) {
            const date = (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).tz(`${appointment.appointmentDate}T${appointment.appointmentTime}`, (0, $2bd9d04ce55ef2a0$export$6f5c75afcb5ad5cc));
            const practitionerId = invite.appointment?.practitioner?.practitionerId ?? 'unknown';
            return {
                summary: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: t('common:formattedDate', {
                                date: date?.format((0, $e464564ddd12cbba$export$a51eaa568b139b5f)),
                                time: date?.format((0, $e464564ddd12cbba$export$26148d4b363fecad))
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: t(`specialists.${practitionerId}.name`)
                        })
                    ]
                })
            };
        } else return {};
    }, [
        appointment,
        invite.appointment?.practitioner?.practitionerId,
        t
    ]);
}
function $d7da738cd227c811$var$useInsuranceDetails() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.insurance');
    const { invite: invite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    const insurer = invite.onlineBookingData?.insurance?.healthInsurer;
    return (0, $acw62.useMemo)(()=>{
        if (insurer) return {
            summary: t(`insurerSelect.${insurer}`)
        };
        else return {};
    }, [
        insurer,
        t
    ]);
}
function $d7da738cd227c811$var$isTextNode(node) {
    return node.type === 'text';
}
function $d7da738cd227c811$var$findTextNodeText(list) {
    for (const node of list){
        if ($d7da738cd227c811$var$isTextNode(node)) return node.content;
        else if (node.children?.length > 0) {
            const text = $d7da738cd227c811$var$findTextNodeText(node.children);
            if (typeof text === 'string') return text;
        }
    }
}
// The HTML parsing here is not great but we would need to restructure the
// translations to avoid it.
function $d7da738cd227c811$var$useHealthQuestionLabels() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.health-questions');
    return (0, $acw62.useMemo)(()=>(0, $e5c7a076ba516446$export$64e7b4513fce920).map((question)=>{
            const key = question.props.translationKey;
            const translation = t(`${key}.title`);
            const html = (0, $69084eaa2e6a0d50$export$2e2bcd8739ae039).parse(translation);
            return $d7da738cd227c811$var$findTextNodeText(html) ?? key;
        }), [
        t
    ]);
}
function $d7da738cd227c811$var$useHealthQuestionsDetails({ status: status, setMenuOpen: setMenuOpen }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.health-questions');
    const navigate = (0, $618a07bedf38a2ba$export$9770f232ac06a008)();
    const { invite: invite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    const labels = $d7da738cd227c811$var$useHealthQuestionLabels();
    return (0, $acw62.useMemo)(()=>{
        let summary = null;
        let options = null;
        if (status !== 'done') {
            const { dropdownOptions: dropdownOptions, progressIndex: progressIndex } = (0, $e5c7a076ba516446$export$64e7b4513fce920).reduce((acc, question, index)=>{
                const done = question.done(invite.onlineBookingData, invite);
                acc.dropdownOptions.push({
                    value: question.path,
                    label: labels[index],
                    done: done,
                    disabled: !done && !(acc.dropdownOptions.at(-1)?.done ?? true)
                });
                acc.progressIndex = Math.min(acc.progressIndex, done ? (0, $e5c7a076ba516446$export$64e7b4513fce920).length : index);
                return acc;
            }, {
                dropdownOptions: [],
                progressIndex: (0, $e5c7a076ba516446$export$64e7b4513fce920).length - 1
            });
            summary = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    "At ",
                    labels[progressIndex],
                    " (",
                    progressIndex + 1,
                    "/",
                    (0, $e5c7a076ba516446$export$64e7b4513fce920).length,
                    ")"
                ]
            });
            options = dropdownOptions;
        } else if (status === 'done') {
            const { dropdownOptions: dropdownOptions, questionsYes: questionsYes } = (0, $e5c7a076ba516446$export$64e7b4513fce920).reduce((acc, question, index)=>{
                const primary = question.answer(invite.onlineBookingData, invite)?.primary;
                if (primary && primary !== 'no') acc.questionsYes.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "last:after:content-none after:content-[','] mr-1",
                    children: labels[index]
                }, index));
                acc.dropdownOptions.push({
                    value: question.path,
                    label: labels[index],
                    done: true,
                    disabled: false
                });
                return acc;
            }, {
                dropdownOptions: [],
                questionsYes: []
            });
            summary = questionsYes.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "italic",
                children: [
                    t('common:yesTo'),
                    ": ",
                    questionsYes
                ]
            }) : null;
            options = dropdownOptions;
        }
        return {
            summary: summary,
            actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4cd9875607f3fe92$export$43b5183e9b4e4d46), {
                placeholder: t('dropLabel'),
                options: options,
                onChange: (path)=>{
                    navigate(`/${invite.reference}/${path}`);
                    setMenuOpen(false);
                }
            })
        };
    }, [
        invite,
        labels,
        navigate,
        setMenuOpen,
        status,
        t
    ]);
}




var $acw62 = parcelRequire("acw62");
function $5a5ab2d913bb7407$var$XMarkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z"
    }));
}
const $5a5ab2d913bb7407$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($5a5ab2d913bb7407$var$XMarkIcon);
var $5a5ab2d913bb7407$export$2e2bcd8739ae039 = $5a5ab2d913bb7407$var$ForwardRef;



parcelRequire("acw62");
const $749f762d6ba7410f$var$SvgLanguageIcon = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        viewBox: "0 0 30 30",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "currentColor",
                d: "M7.02 10.325h1.355c.215.495.7 1.48 1.475 2.435-.595.58-1.325 1.065-2.18 1.25a.502.502 0 0 0 .215.98c1.06-.23 1.935-.805 2.645-1.49.71.68 1.585 1.255 2.645 1.49.035.01.07.01.105.01.23 0 .435-.16.49-.395a.5.5 0 0 0-.38-.595c-.86-.185-1.585-.67-2.18-1.25a11 11 0 0 0 1.475-2.435h1.355c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-3.005V8.33c0-.275-.225-.5-.5-.5s-.5.225-.5.5v.995H7.03c-.275 0-.5.225-.5.5s.215.5.49.5M10.525 12c-.475-.61-.82-1.225-1.045-1.675h2.09c-.225.455-.575 1.07-1.045 1.675M19.075 20.33a.504.504 0 0 0 .655-.27l.605-1.45h2.655l.605 1.45a.5.5 0 0 0 .655.265.5.5 0 0 0 .27-.655l-.735-1.755s0-.005-.005-.005l-1.66-3.965a.5.5 0 0 0-.46-.305c-.2 0-.385.12-.46.305l-1.66 3.97-.735 1.755a.506.506 0 0 0 .27.66m2.585-4.89.91 2.175h-1.82z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "currentColor",
                d: "M4.885 17.88h.35v2.27c0 .2.12.385.31.46a.5.5 0 0 0 .545-.105l2.62-2.62h4.79v2.65c0 1.175.955 2.13 2.13 2.13h6.41l2.245 2.245a.503.503 0 0 0 .855-.355v-1.89h.23c1.175 0 2.13-.955 2.13-2.13v-7.05c0-1.175-.955-2.13-2.13-2.13h-6.82V7.34a2.39 2.39 0 0 0-2.385-2.385H4.885A2.38 2.38 0 0 0 2.5 7.335v8.16a2.39 2.39 0 0 0 2.385 2.385m20.485-5.53c.625 0 1.13.505 1.13 1.13v7.05c0 .625-.505 1.13-1.13 1.13h-.73c-.275 0-.5.225-.5.5v1.185l-1.54-1.54a.5.5 0 0 0-.355-.145H15.63c-.625 0-1.13-.505-1.13-1.13v-2.65h1.665a2.39 2.39 0 0 0 2.385-2.385V12.35zM3.5 7.335c0-.765.62-1.385 1.385-1.385H16.16c.765 0 1.385.62 1.385 1.385v8.16c0 .765-.62 1.385-1.385 1.385H8.5a.52.52 0 0 0-.355.145L6.23 18.94v-1.56c0-.275-.225-.5-.5-.5h-.85c-.76 0-1.38-.62-1.38-1.385z"
            })
        ]
    });
var $749f762d6ba7410f$export$2e2bcd8739ae039 = $749f762d6ba7410f$var$SvgLanguageIcon;



var $acw62 = parcelRequire("acw62");





function $42e70d01a5bcb4e4$export$c25acd513dcc8062({ children: children, className: className, disabled: disabled, type: type = 'button', variant: variant = 'light', size: size = 'base', to: to, ...props }) {
    const variants = {
        white: 'bg-white',
        light: 'bg-light'
    };
    const sizes = {
        base: 'w-[60px] h-[60px]',
        md: 'w-[50px] h-[50px]'
    };
    const commonClasses = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('shrink-0 flex items-center justify-center rounded-full transition-colors text-primary-active hover:text-primary-active hover:bg-light-hover active:bg-light-active disabled:opacity-60 disabled:pointer-events-none', variants[variant], sizes[size], className);
    if (to) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $618a07bedf38a2ba$export$a6c7ac8248d6e38a), {
        to: to,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(commonClasses, {
            'opacity-60 pointer-events-none': disabled
        }),
        ...props,
        children: children
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        type: type,
        className: commonClasses,
        disabled: disabled,
        ...props,
        children: children
    });
}



const $20f24174b25b698d$var$languages = [
    {
        value: 'en',
        label: 'Use this website in English'
    },
    {
        value: 'mi',
        label: "Whakamahia t\u0113nei paetukutuku i te Reo M\u0101ori"
    },
    {
        value: 'hi',
        label: "\u0907\u0938 \u0935\u0947\u092C\u0938\u093E\u0907\u091F \u0915\u094B \u0939\u093F\u0928\u094D\u0926\u0940 \u092E\u0947\u0902 \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0947\u0902"
    },
    {
        value: 'sm',
        label: "Fa\u2018aaoga lenei uepisaite i le Gagana S\u0101moa"
    },
    {
        value: 'zh',
        label: "\u5C06\u672C\u7F51\u7AD9\u5207\u6362\u4E3A\u4E2D\u6587"
    }
];
function $20f24174b25b698d$export$c9852e63c080b({ size: size = 'base' }) {
    const [open, setOpen] = (0, $acw62.useState)(false);
    const { i18n: i18n, t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const setLang = (0, $acw62.useCallback)((lang)=>{
        i18n.changeLanguage(lang);
        setOpen(false);
    }, [
        i18n
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $42e70d01a5bcb4e4$export$c25acd513dcc8062), {
                onClick: ()=>setOpen(true),
                size: size,
                "aria-label": t('selectLanguage'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $749f762d6ba7410f$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11a90cea0cc9744a$export$3ddf2d174ce01153), {
                open: open,
                onOpenChange: setOpen,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11a90cea0cc9744a$export$b6d9565de1e068cf), {
                    className: "Dialog fixed top-0 left-0 size-full overflow-y-auto sm:w-[390px] pt-5 px-4 bg-primary-active text-white",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $11a90cea0cc9744a$export$2cd93e047c5f0909), {
                                className: "flex items-start justify-between gap-4 mb-6",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $749f762d6ba7410f$export$2e2bcd8739ae039), {
                                        className: "size-17.5",
                                        "aria-label": t('selectLanguage'),
                                        role: "img"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11a90cea0cc9744a$export$fba2fb7cd781b7ac), {
                                        className: "hover:text-primary-light",
                                        "aria-label": t('closeDialog'),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a5ab2d913bb7407$export$2e2bcd8739ae039), {
                                            className: "size-6",
                                            "aria-hidden": "true"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "rounded-md bg-white text-body-dark overflow-hidden",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41015efefa2d03bc$export$db143058563e2c63), {
                                    Component: (0, $41015efefa2d03bc$export$371ab307eab489c0),
                                    options: $20f24174b25b698d$var$languages,
                                    value: i18n.language,
                                    onChange: setLang
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}





function $57c242dbb0f23715$export$c17561cb55d4db30({ progress: progress, min: min = 0, max: max = 100 }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "relative h-[5px] w-full rounded-[5px] bg-primary-100 overflow-hidden",
        role: "progressbar",
        "aria-valuenow": progress,
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-label": t('progress', {
            progress: progress
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "h-full rounded-[0_5px_5px_0] bg-primary-active",
            style: {
                width: `${progress / max * 100}%`
            }
        })
    });
}


function $4777412ac24f8fdf$export$8becf861e7fda17d({ prev: prev, progress: progress, nextLabel: nextLabel, showMenu: showMenu = true, className: className, headerClassName: headerClassName, children: children }) {
    // const extendedSteps = useMemo(() => {
    //   const list = [...steps];
    //   const expand = (baseKey, questions, prefix) => {
    //     const idx = list.findIndex((s) => s.key === baseKey);
    //     if (idx !== -1 && Array.isArray(questions)) {
    //       const questionSteps = questions.map((q) => ({ key: `${prefix}-${q.id}` }));
    //       list.splice(idx + 1, 0, ...questionSteps);
    //     }
    //   };
    //   expand('health-questions', healthQuestions, 'health-questions');
    //   expand('preference-questions', preferenceQuestions, 'preference-questions');
    //   return list;
    // }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('w-full h-[100dvh] relative overflow-hidden bg-brand flex', className),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative w-full sm:w-[640px] max-h-[100dvh] flex-shrink-0 flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('pb-5 max-h-[100dvh] flex-1 flex flex-col max-w-full overflow-x-hidden overflow-y-auto', {
                            'max-h-[calc(100dvh-3.125rem)]': showMenu
                        }),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("header", {
                                className: "pt-2.5 px-5 mb-5 bg-white",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('flex flex-row justify-between items-center gap-5 lg:gap-12.5 pb-2.5 border-b border-solid', headerClassName),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $42e70d01a5bcb4e4$export$c25acd513dcc8062), {
                                            to: `../${prev?.path}`,
                                            viewTransition: true,
                                            variant: "white",
                                            size: "md",
                                            "aria-label": prev?.label,
                                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(prev || 'invisible'),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d7ede180b94f21b8$export$2e2bcd8739ae039), {
                                                className: "size-5"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57c242dbb0f23715$export$c17561cb55d4db30), {
                                            progress: progress * 100
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20f24174b25b698d$export$c9852e63c080b), {
                                            size: "md"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                                className: "px-5 flex-grow flex flex-col",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                                    children: children
                                })
                            })
                        ]
                    }),
                    showMenu && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d7da738cd227c811$export$d91fe704b267f194), {
                        nextLabel: nextLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "relative flex-[1.25] hidden sm:block before:absolute before:inset-0 before:bg-white/80 brand-background"
            })
        ]
    });
}


// eslint-disable-next-line import/no-unresolved



var $acw62 = parcelRequire("acw62");
function $e7f477e2cdb760ee$var$CheckCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z",
        clipRule: "evenodd"
    }));
}
const $e7f477e2cdb760ee$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($e7f477e2cdb760ee$var$CheckCircleIcon);
var $e7f477e2cdb760ee$export$2e2bcd8739ae039 = $e7f477e2cdb760ee$var$ForwardRef;



var $acw62 = parcelRequire("acw62");



function $d212ba9d073a953d$var$SpecialistCardBase({ value: value, title: title, children: children }) {
    const { field: field } = (0, $0d70f179cf56e662$export$e8c786024a2b0a79)({
        name: 'specialistId'
    });
    const selectedValue = (0, $0d70f179cf56e662$export$3c773aa2b84f29e0)({
        name: 'specialistId'
    });
    const isSelected = selectedValue === value;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "group relative mb-2.5 p-3.5 rounded-lg border overflow-hidden cursor-pointer transition-colors bg-white border-300 last:mb-0 hover:border-primary data-[selected=true]:bg-primary-50 data-[selected=true]:border-primary group-data-[single-specialist=true]/specialists:data-[value=any]:hidden",
        "data-selected": isSelected,
        "data-value": value,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                className: "absolute z-10 inset-0 cursor-pointer rounded-lg",
                "aria-checked": isSelected,
                tabIndex: 0,
                onKeyDown: (e)=>{
                    if (e.key === ' ' || e.key === 'Enter') {
                        e.preventDefault();
                        field.onChange('any');
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "radio",
                        checked: isSelected,
                        className: "sr-only",
                        ...field,
                        value: value
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "sr-only",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute top-2 right-2 size-6 flex items-center justify-center rounded-full border transition-colors text-primary border-300 bg-white",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7f477e2cdb760ee$export$2e2bcd8739ae039), {
                    className: "shrink-0 size-7.5 opacity-0 transition-opacity group-data-[selected=true]:opacity-100"
                })
            }),
            children
        ]
    });
}
function $d212ba9d073a953d$export$68890f054db6efff() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.specialist');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d212ba9d073a953d$var$SpecialistCardBase, {
        value: "any",
        title: t('anySpecialist.title'),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                    className: "title-sm",
                    children: t('anySpecialist.title')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: t('anySpecialist.text')
                })
            ]
        })
    });
}
function $d212ba9d073a953d$export$206da70a2aa39f33({ specialist: specialist }) {
    const [open, setOpen] = (0, $acw62.useState)(false);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.specialist');
    const specialistId = specialist.practitionerId;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d212ba9d073a953d$var$SpecialistCardBase, {
        value: specialistId,
        title: t(`specialists.${specialistId}.name`),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d212ba9d073a953d$var$SpecialistIntro, {
                url: specialist.practitionerImageUrl,
                specialistId: specialistId
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "group-data-[single-specialist=false]/specialists:hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d212ba9d073a953d$var$SpecialistText, {
                    specialistId: specialistId
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "caption relative z-20 ml-27.5 font-medium text-primary hover:text-primary-hover active:text-primary-active group-data-[single-specialist=true]/specialists:hidden",
                type: "button",
                onClick: ()=>setOpen(true),
                children: t('viewProfile')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d212ba9d073a953d$export$a86a1d3f59ee7451, {
                menuOpen: open,
                setMenuOpen: setOpen,
                url: specialist.practitionerImageUrl,
                specialistId: specialistId
            })
        ]
    });
}
function $d212ba9d073a953d$var$SpecialistText({ specialistId: specialistId }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.specialist', {
        keyPrefix: `specialists.${specialistId}`
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
        i18nKey: "profile",
        t: t,
        components: {
            p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
            b: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {}),
            i: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {})
        },
        values: (0, $22c4bfea680558f2$export$2e2bcd8739ae039)
    });
}
function $d212ba9d073a953d$var$SpecialistIntro({ specialistId: specialistId, url: url }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.specialist', {
        keyPrefix: `specialists.${specialistId}`
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "py-2.5 mb-2.5 flex items-center gap-2.5",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: "shrink-0 size-25 object-cover rounded-full overflow-hidden bg-primary-100 group-data-[selected=true]:bg-white",
                src: url,
                alt: t('name')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "title-sm mb-0",
                        children: t('name')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "caption mb-1.25",
                        children: t('titles')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "font-medium",
                        children: t('profession')
                    })
                ]
            })
        ]
    });
}
function $d212ba9d073a953d$export$a86a1d3f59ee7451({ menuOpen: menuOpen, setMenuOpen: setMenuOpen, specialistId: specialistId, url: url }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { t: tSpecialist } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.specialist');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11a90cea0cc9744a$export$3ddf2d174ce01153), {
        open: menuOpen,
        onOpenChange: setMenuOpen,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11a90cea0cc9744a$export$b6d9565de1e068cf), {
            className: "Dialog fixed top-0 left-0 size-full overflow-y-auto md:w-[500px] p-5 bg-primary-active text-white",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $11a90cea0cc9744a$export$2cd93e047c5f0909), {
                        className: "title-sm flex items-start justify-between gap-4 mb-2.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: tSpecialist('profile')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11a90cea0cc9744a$export$fba2fb7cd781b7ac), {
                                className: "hover:text-primary-light",
                                "aria-label": t('closeDialog'),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a5ab2d913bb7407$export$2e2bcd8739ae039), {
                                    className: "size-6",
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d212ba9d073a953d$var$SpecialistIntro, {
                        isSelected: true,
                        url: url,
                        specialistId: specialistId
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d212ba9d073a953d$var$SpecialistText, {
                        specialistId: specialistId
                    })
                ]
            })
        })
    });
}





function $8f563c890ed38cb6$export$353f5b6fc5456de1({ children: children, className: className, disabled: disabled, type: type = 'button', variant: variant = 'primary', to: to, ...props }) {
    const variants = {
        primary: 'bg-primary text-white border-transparent hover:bg-primary-hover active:bg-primary-active hover:text-white',
        'primary-light': 'bg-primary-100 text-primary-hover hover:bg-primary-hover active:bg-primary-active hover:text-white active:text-white',
        outlined: 'bg-white text-body border-light-300 hover:text-body hover:bg-light-hover active:bg-light-active'
    };
    const commonClasses = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('inline-block w-full text-center rounded-md px-3 py-2 border border-solid font-medium shadow-sm transition-colors disabled:opacity-60 disabled:pointer-events-none', variants[variant], className);
    if (to) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $618a07bedf38a2ba$export$a6c7ac8248d6e38a), {
        to: to,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(commonClasses, {
            'opacity-60 pointer-events-none': disabled
        }),
        ...props,
        children: children
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        type: type,
        className: commonClasses,
        disabled: disabled,
        ...props,
        children: children
    });
}





function $36f595e8846b41d7$export$174438b8ed55acf() {
    const navigate = (0, $618a07bedf38a2ba$export$9770f232ac06a008)();
    return (url, options)=>{
        if (document.startViewTransition) document.startViewTransition(()=>navigate(url, options));
        else navigate(url, options);
    };
}



const $641e6457757d8f34$export$f69b927d95b72681 = /^((?:19|20)\d{2})-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
const $641e6457757d8f34$export$58eacdd7158b2a77 = 'YYYY-MM-DD';


(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($a05dabb57d62d821$exports))));
const $b0d33fd2456c63c3$var$schema = $09193e81812ba154$export$be5493f9613cbbe({
    selectedDate: $09193e81812ba154$export$22b082955e083ec3(),
    appointmentSlotId: $09193e81812ba154$export$22b082955e083ec3().min(1)
});
function $b0d33fd2456c63c3$var$updateAvailability(availability, slotTime) {
    if (parseInt(slotTime.split(':')[0], 10) < 12) return [
        'green',
        availability[1]
    ];
    else return [
        availability[0],
        'green'
    ];
}
function $b0d33fd2456c63c3$var$useAvailableSpecialistsByDay() {
    const { invite: invite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    return (0, $acw62.useMemo)(()=>{
        const chosenPractitionerId = invite.onlineBookingData.specialistId;
        // Create a map from days to specialists have have available slots on that
        // day and an availability dots pair for that day.
        const intermediate = invite.practitioners.filter((practitioner)=>chosenPractitionerId === 'any' || practitioner.practitionerId === chosenPractitionerId).filter((practitioner)=>practitioner.calendarSlots.length > 0).reduce((acc, practitioner)=>{
            for (const slot of practitioner.calendarSlots){
                if (!Object.hasOwn(acc, slot.date)) acc[slot.date] = {
                    availability: [
                        'gray',
                        'gray'
                    ]
                };
                if (!Object.hasOwn(acc[slot.date], practitioner.practitionerId)) {
                    // Assign practitioner and slots to this day
                    const daySlots = practitioner.calendarSlots.filter((s)=>s.date === slot.date);
                    acc[slot.date][practitioner.practitionerId] = {
                        ...practitioner,
                        calendarSlots: daySlots
                    };
                    // Update day availability
                    for (const s of daySlots)acc[slot.date].availability = $b0d33fd2456c63c3$var$updateAvailability(acc[slot.date].availability, s.slotTime);
                }
            }
            return acc;
        }, {});
        // Reconstruct a slot from the current appointment and add it to the map
        // above because after confirming the appointment the backend won't send
        // back this slot as available anymore, but we still want to show it to the
        // user.
        if (invite.appointment) {
            const practitionerId = invite.appointment.practitioner.practitionerId;
            const calendarSlot = {
                slotId: invite.appointment.calendarListSlotId ?? invite.appointment.calendarSlotId,
                date: invite.appointment.appointmentDate,
                slotTime: invite.appointment.appointmentTime
            };
            // Patch day
            if (!Object.hasOwn(intermediate, calendarSlot.date)) intermediate[calendarSlot.date] = {
                availability: $b0d33fd2456c63c3$var$updateAvailability([
                    'gray',
                    'gray'
                ], calendarSlot.slotTime)
            };
            else intermediate[calendarSlot.date].availability = $b0d33fd2456c63c3$var$updateAvailability(intermediate[calendarSlot.date].availability, calendarSlot.slotTime);
            // Patch practitioner
            if (!Object.hasOwn(intermediate[calendarSlot.date], practitionerId)) intermediate[calendarSlot.date][practitionerId] = {
                practitionerId: practitionerId,
                practitionerImageUrl: null,
                calendarSlots: [
                    calendarSlot
                ]
            };
            else if (!intermediate[calendarSlot.date][practitionerId].calendarSlots.some((x)=>x.slotId === calendarSlot.slotId)) {
                intermediate[calendarSlot.date][practitionerId].calendarSlots.push(calendarSlot);
                intermediate[calendarSlot.date][practitionerId].calendarSlots.sort((a, b)=>a.slotTime.localeCompare(b.slotTime));
            }
        }
        // Convert the map of specialists to an array.
        return Object.fromEntries(Object.entries(intermediate).map(([k, { availability: availability, ...rest }])=>[
                k,
                {
                    availability: availability,
                    specialists: Object.values(rest)
                }
            ]));
    }, [
        invite.appointment,
        invite.onlineBookingData.specialistId,
        invite.practitioners
    ]);
}
const $b0d33fd2456c63c3$var$AvailabilityContext = /*#__PURE__*/ (0, $acw62.createContext)();
function $b0d33fd2456c63c3$var$useAvailability(date) {
    const state = (0, $acw62.useContext)($b0d33fd2456c63c3$var$AvailabilityContext);
    return state[date] ?? {};
}
function $b0d33fd2456c63c3$export$17c88b0571a3c569(props) {
    const { invite: invite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)([
        'page.appointment'
    ]);
    const { next: next } = props;
    const reserveTime = (0, $e88c134850f84ce4$export$b13b809beebfb74d)();
    const navigate = (0, $36f595e8846b41d7$export$174438b8ed55acf)();
    const [openTimeModal, setOpenTimeModal] = (0, $acw62.useState)(false);
    const today = (0, $a0555542f484e05c$export$6d84255ad587f3b5)().format((0, $641e6457757d8f34$export$58eacdd7158b2a77));
    const availableSpecialists = $b0d33fd2456c63c3$var$useAvailableSpecialistsByDay();
    const [initialDate] = (0, $acw62.useState)(()=>{
        // Initial state is current appointment date, the first available date or
        // otherwise today.
        return invite.appointment?.appointmentDate ?? Object.keys(availableSpecialists ?? {
            today: today
        }).toSorted().at(0);
    });
    const form = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        defaultValues: {
            selectedDate: invite.appointment?.appointmentDate ?? initialDate,
            appointmentSlotId: invite.appointment?.calendarListSlotId ?? invite.appointment?.calendarSlotId ?? ''
        },
        resolver: (0, $0591fe66d7f046a7$export$66b7b5879c70f722)($b0d33fd2456c63c3$var$schema),
        mode: 'onChange'
    });
    const { reset: resetForm } = form;
    const onSubmit = (0, $acw62.useCallback)(async ({ appointmentSlotId: appointmentSlotId })=>{
        try {
            await reserveTime.execute(appointmentSlotId);
            navigate(`/${invite.reference}/${next.path}`);
        } catch  {
            resetForm();
            setOpenTimeModal(true);
        }
    }, [
        invite.reference,
        navigate,
        next.path,
        reserveTime,
        resetForm
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
        ...form,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
            id: "patch-invite-form",
            className: "contents",
            onSubmit: form.handleSubmit(onSubmit),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4777412ac24f8fdf$export$8becf861e7fda17d), {
                ...props,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: "title mb-5",
                        children: t('title')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($b0d33fd2456c63c3$var$AvailabilityContext.Provider, {
                        value: availableSpecialists,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5272f7244e8a5255$export$e1aef45b828286de), {
                                initialDate: initialDate,
                                DayComponent: $b0d33fd2456c63c3$export$3634bcef04b44d54
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b0d33fd2456c63c3$var$AppointmentFields, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b0d33fd2456c63c3$var$ChooseTimeModal, {
                        openModal: openTimeModal,
                        setOpenModal: setOpenTimeModal
                    })
                ]
            })
        })
    });
}
function $b0d33fd2456c63c3$var$AppointmentFields() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.appointment');
    const selectedDate = (0, $0d70f179cf56e662$export$3c773aa2b84f29e0)({
        name: 'selectedDate'
    });
    const { specialists: specialists } = $b0d33fd2456c63c3$var$useAvailability(selectedDate);
    return specialists ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: specialists.map((specialist)=>{
            const options = specialist.calendarSlots.map((slot)=>({
                    value: slot.slotId,
                    label: (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).tz(`2000-01-01T${slot.slotTime}`, (0, $2bd9d04ce55ef2a0$export$6f5c75afcb5ad5cc)).format((0, $e464564ddd12cbba$export$26148d4b363fecad))
                }));
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41015efefa2d03bc$export$a98f0dcb43a68a25), {
                layout: "grid",
                name: "appointmentSlotId",
                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b0d33fd2456c63c3$var$InfoButton, {
                    specialist: specialist
                }),
                options: options
            }, specialist.practitionerId);
        })
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "text-light-500",
        children: t('noTimeText')
    });
}
function $b0d33fd2456c63c3$var$InfoButton({ specialist: specialist }) {
    const [open, setOpen] = (0, $acw62.useState)(false);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.specialist', {
        keyPrefix: `specialists.${specialist.practitionerId}`
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                className: "flex items-center gap-1",
                onClick: ()=>setOpen(true),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: t('name')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $726732e43fc7950f$export$2e2bcd8739ae039), {
                        className: "size-5 text-primary",
                        "aria-hidden": "true"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d212ba9d073a953d$export$a86a1d3f59ee7451), {
                menuOpen: open,
                setMenuOpen: setOpen,
                url: specialist.practitionerImageUrl,
                specialistId: specialist.practitionerId
            })
        ]
    });
}
function $b0d33fd2456c63c3$var$ChooseTimeModal({ openModal: openModal, setOpenModal: setOpenModal }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { t: tAppointment } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.appointment');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11a90cea0cc9744a$export$3ddf2d174ce01153), {
        open: openModal,
        onOpenChange: setOpenModal,
        className: "p-4 bg-modalBg/75",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $11a90cea0cc9744a$export$b6d9565de1e068cf), {
            className: "Dialog p-4 pt-5 flex flex-col items-center container w-full overflow-y-auto rounded-lg bg-white text-body-dark shadow-xl text-center max-w-[480px]",
            direction: "bottom",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mb-3 size-15 flex items-center justify-center bg-primary-100 rounded-full",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $579305e6f01660e1$export$2e2bcd8739ae039), {
                        className: "text-light-900"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                    className: "mb-2 title-sm font-medium",
                    children: tAppointment('modal.title')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "caption mb-5 text-light-500",
                    children: tAppointment(t('modal.text'))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f563c890ed38cb6$export$353f5b6fc5456de1), {
                    onClick: ()=>setOpenModal(false),
                    children: tAppointment(t('modal.buttonLabel'))
                })
            ]
        })
    });
}
function $b0d33fd2456c63c3$export$3634bcef04b44d54({ day: day }) {
    const today = (0, $a0555542f484e05c$export$6d84255ad587f3b5)();
    const dayValue = day.format((0, $641e6457757d8f34$export$58eacdd7158b2a77));
    const { availability: availability } = $b0d33fd2456c63c3$var$useAvailability(dayValue);
    const { setValue: setValue, watch: watch } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const selectedValue = watch('selectedDate');
    let variant;
    if (selectedValue === dayValue) variant = 'selected';
    else if (day.isSame(today, 'day')) variant = 'today';
    else variant = availability ? 'available' : 'unavailable';
    const handleSelectDay = (0, $acw62.useCallback)(()=>{
        setValue('selectedDate', dayValue);
        setValue('appointmentSlotId', '');
    }, [
        dayValue,
        setValue
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex-1 text-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-small w-full flex items-center justify-center h-8 mb-1 text-body-dark data-[weekend=true]:text-gray-300",
                "data-weekend": day.isoWeekday() >= 6,
                children: day.format('ddd').charAt(0)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                onClick: handleSelectDay,
                className: "p-0.5 flex-col mx-auto flex w-full h-9 items-center justify-start rounded-lg text-center relative hover:text-current hover:bg-gray-200 disabled:hover:bg-inherit data-[variant=unavailable]:text-gray-300 data-[variant=today]:font-semibold data-[variant=today]:text-blue-600 data-[variant=selected]:bg-blue-600 data-[variant=selected]:text-white data-[variant=selected]:hover:bg-blue-600",
                type: "button",
                disabled: !availability,
                "data-testid": dayValue,
                "data-variant": variant,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aade598d94459724$export$82f9ebd9adeba146), {
                        t: day,
                        format: "D"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute bottom-0 pb-1.25",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24192cf7d8ba7168$export$ed9ea036f41d9d59), {
                            availability: availability
                        })
                    })
                ]
            })
        ]
    });
}






var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($a05dabb57d62d821$exports))));
function $eba937bebf24b6c7$export$e5b4eeeb5e722231(isoString) {
    return (0, $acw62.useMemo)(()=>{
        const t = (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).tz(isoString, (0, $2bd9d04ce55ef2a0$export$6f5c75afcb5ad5cc));
        const formattedDate = t.format((0, $e464564ddd12cbba$export$a51eaa568b139b5f));
        const formattedTime = t.format((0, $e464564ddd12cbba$export$26148d4b363fecad));
        return {
            t: t,
            formattedDate: formattedDate,
            formattedTime: formattedTime
        };
    }, [
        isoString
    ]);
}


function $e89436abf76c6f63$export$a7ae4cbf178a6bca() {
    const { invite: invite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    const { t: tCommon } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('common');
    const { t: tSpecialist } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.specialist');
    const { t: t, formattedDate: formattedDate, formattedTime: formattedTime } = (0, $eba937bebf24b6c7$export$e5b4eeeb5e722231)(invite.appointment ? `${invite.appointment?.appointmentDate}T${invite.appointment?.appointmentTime}` : null);
    return (0, $acw62.useMemo)(()=>({
            ...invite,
            practitioners: invite.practitioners.map((practitioner)=>({
                    ...practitioner,
                    practitionerRole: tCommon(`roles.${practitioner.practitionerRole}`),
                    ...tSpecialist(`specialists.${practitioner.practitionerId}`, {
                        returnObjects: true
                    })
                })),
            requestingPractitioner: {
                ...invite.requestingPractitioner,
                practitionerRole: tCommon(`roles.${invite.requestingPractitioner.practitionerRole}`)
            },
            appointment: invite.appointment ? {
                ...invite.appointment,
                specialist: tSpecialist(`specialists.${invite.appointment?.practitioner?.practitionerId ?? 'unknown'}.name`),
                date: formattedDate,
                time: formattedTime,
                t: t
            } : null
        }), [
        formattedDate,
        formattedTime,
        invite,
        t,
        tCommon,
        tSpecialist
    ]);
}



(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($a05dabb57d62d821$exports))));
const $0c1f89caa70a7fa7$export$4902baddc787debb = $09193e81812ba154$export$be5493f9613cbbe({
    contactConsent: $09193e81812ba154$export$971dd5b0dfd021b6([
        $09193e81812ba154$export$c8ec6e1ec9fefcb0('yes'),
        $09193e81812ba154$export$c8ec6e1ec9fefcb0('no')
    ])
});
function $0c1f89caa70a7fa7$var$extractDefaults({ contactConsent: contactConsent }) {
    return {
        contactConsent: contactConsent === true ? 'yes' : 'no'
    };
}
function $0c1f89caa70a7fa7$var$transformValues({ contactConsent: contactConsent }) {
    return {
        contactConsent: contactConsent === 'yes'
    };
}
function $0c1f89caa70a7fa7$export$6627cb344363e02e(props) {
    const invite = (0, $e89436abf76c6f63$export$a7ae4cbf178a6bca)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.appointment-reserved');
    const now = (0, $ada6a062d2ca6395$export$3a404aece3dff2fa)();
    const { t: expires, formattedDate: formattedDate, formattedTime: formattedTime } = (0, $eba937bebf24b6c7$export$e5b4eeeb5e722231)(invite.appointment?.expiryDate ?? invite.expiryDate);
    const { deadlineText: deadlineText, deadlineTime: deadlineTime } = (0, $acw62.useMemo)(()=>{
        const deadlineTime = expires.diff(now, 'hour');
        let deadlineText;
        if (expires.isSame(now, 'day')) deadlineText = t('common:timeToday', {
            time: formattedTime
        });
        else if (expires.isSame(now.add(1, 'day'), 'day')) deadlineText = t('common:timeTomorrow', {
            time: formattedTime
        });
        else deadlineText = t('common:formattedDate', {
            date: formattedDate,
            time: formattedTime
        });
        return {
            deadlineText: deadlineText,
            deadlineTime: deadlineTime
        };
    }, [
        expires,
        formattedDate,
        formattedTime,
        now,
        t
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dea25ad601eb8263$export$70aabb5da7e125f8), {
        extractDefaults: $0c1f89caa70a7fa7$var$extractDefaults,
        transformValues: $0c1f89caa70a7fa7$var$transformValues,
        schema: $0c1f89caa70a7fa7$export$4902baddc787debb,
        nextPath: props.next.path,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4777412ac24f8fdf$export$8becf861e7fda17d), {
            ...props,
            className: "bg-primary-50",
            headerClassName: "border-b-0",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "title pt-1",
                    children: t('title')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    i18nKey: "text",
                    ns: "page.appointment-reserved",
                    components: {
                        p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "mb-5"
                        }),
                        strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "font-semibold"
                        }),
                        Status: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "font-semibold text-warning-600"
                        })
                    },
                    values: invite
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "pt-2.5",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        i18nKey: "description",
                        ns: "page.appointment-reserved",
                        components: {
                            p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
                            strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "font-semibold"
                            }),
                            b: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "font-medium"
                            }),
                            ul: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "pl-6 list-disc"
                            }),
                            li: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {}),
                            span: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mb-0"
                            })
                        },
                        values: {
                            deadlineText: deadlineText,
                            deadlineTime: deadlineTime
                        }
                    })
                })
            ]
        })
    });
} /*
function ComingSoon() {
  const { t: tCommon } = useTranslation();
  const { t } = useTranslation('page.appointment-reserved');
  const { watch, setValue } = useFormContext();
  const consent = watch('contactConsent');

  const options = useMemo(
    () => [
      {
        value: 'yes',
        label: t('contactConsent.yes'),
      },
      {
        value: 'no',
        label: t('contactConsent.no'),
      },
    ],
    [t],
  );

  return (
    <div className="mb-2.5 p-3.75 bg-white rounded-lg border border-primary-300 shadow-sm">
      <Transition
        show={!consent}
        enter="transition-opacity duration-150"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-0"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <h3 className="subtitle mb-3.75">{t('comingSoonTitle')}</h3>

        <div className="mb-3.75">
          <Trans
            i18nKey="comingSoonText"
            ns="page.appointment-reserved"
            components={{
              p: <p />,
            }}
          />
        </div>

        <RadioCardList
          name="contactConsent"
          options={options}
          labelClassName="w-full !text-body"
          groupClassName="gap-y-2"
        />
      </Transition>

      {options.map(({ value }) => (
        <Transition
          show={consent === value}
          enter="transition-opacity duration-150"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-0"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          key={value}
        >
          <div className="flex items-center justify-between gap-3.75">
            <p className="mb-0">{t(`contactConsentDetails.${value}`)}</p>

            <button
              type="button"
              onClick={() => setValue('contactConsent', '')}
              className="caption font-medium text-primary hover:text-primary-hover"
            >
              {tCommon('change')}
            </button>
          </div>
        </Transition>
      ))}
    </div>
  );
}
*/ 




var $acw62 = parcelRequire("acw62");




function $dd7353e61bcdeb46$export$1f76078961993024() {
    const { invite: invite, setInvite: setInvite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    return (0, $36464e4be8053fb8$export$fbeb804c371ac8d)(async ()=>{
        await (0, $56ff6b9a4ee43a2e$export$644d8ea042df96a6).auth.post('onlinebooking/complete-booking', {
            json: {
                bookingReference: invite.reference
            },
            retry: {
                limit: 100,
                backoffLimit: 10000
            }
        });
        // TODO: FIX ME
        setInvite({
            ...invite,
            status: 'Completed'
        });
    });
}




function $05fc0a4d0e875da9$export$c349430af49f3c78({ children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "w-full h-[100dvh] relative overflow-hidden bg-brand flex",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative pb-5 w-full sm:w-[640px] max-h-[100dvh] overflow-y-auto flex-shrink-0 flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("header", {
                        className: "pt-2.5 px-5 mb-5 bg-white",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row justify-stretch items-center gap-5 pb-5 border-b border-solid",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
                                    alt: "logo",
                                    className: "ml-4 grow h-24 brand-logo"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "grow-0",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20f24174b25b698d$export$c9852e63c080b), {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                        className: "px-5 flex-grow flex flex-col",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                            children: children
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "relative flex-[1.25] hidden sm:block before:absolute before:inset-0 before:bg-white/80 brand-background"
            })
        ]
    });
}



function $2cfbcce25e145fc6$export$41b6293a43d01328() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.confirmation');
    const { invite: invite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    const { execute: execute } = (0, $dd7353e61bcdeb46$export$1f76078961993024)();
    // This should complete the online booking and update the store triggering an
    // automatic navigation to the /completed url
    (0, $acw62.useEffect)(()=>{
        execute();
    }, [
        execute
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05fc0a4d0e875da9$export$c349430af49f3c78), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
            className: "title",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                i18nKey: "title",
                t: t,
                values: invite,
                components: {
                    br: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {})
                }
            })
        })
    });
}









const $59c33553cf03104d$export$4902baddc787debb = $09193e81812ba154$export$be5493f9613cbbe({
    email: $09193e81812ba154$export$22b082955e083ec3().email(),
    mobileNumber: $09193e81812ba154$export$22b082955e083ec3().trim().regex((0, $e464564ddd12cbba$export$5188c7cace6b4075)),
    phoneNumber: $09193e81812ba154$export$971dd5b0dfd021b6([
        $09193e81812ba154$export$22b082955e083ec3().trim().regex((0, $e464564ddd12cbba$export$5188c7cace6b4075)),
        $09193e81812ba154$export$c8ec6e1ec9fefcb0('')
    ])
});
function $59c33553cf03104d$var$extractDefaults({ patient: patient }, invite) {
    return {
        email: patient?.email ?? invite.patient.email ?? '',
        mobileNumber: patient?.mobileNumber ?? invite.patient.mobileNumber ?? '',
        phoneNumber: patient?.phoneNumber ?? invite.patient.phoneNumber ?? ''
    };
}
function $59c33553cf03104d$var$transformValues({ email: email, mobileNumber: mobileNumber, phoneNumber: phoneNumber }) {
    return {
        patient: {
            email: email,
            mobileNumber: mobileNumber,
            phoneNumber: phoneNumber
        }
    };
}
function $59c33553cf03104d$export$b9d767bd38ad68e1(props) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.details');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dea25ad601eb8263$export$70aabb5da7e125f8), {
        extractDefaults: $59c33553cf03104d$var$extractDefaults,
        transformValues: $59c33553cf03104d$var$transformValues,
        schema: $59c33553cf03104d$export$4902baddc787debb,
        nextPath: props.next.path,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4777412ac24f8fdf$export$8becf861e7fda17d), {
            ...props,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "title",
                    children: t('contact-details.title')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "mb-5",
                    children: t('contact-details.text')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "space-y-5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                            type: "email",
                            name: "email",
                            label: t(`contact-details.email`)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                            name: "mobileNumber",
                            type: "tel",
                            label: t(`contact-details.mobilePhone`)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                            name: "phoneNumber",
                            type: "tel",
                            label: t(`contact-details.otherPhone`),
                            optional: true
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");



const $e536fa895fb3af60$var$pDebounce = (functionToDebounce, wait, options = {})=>{
    if (!Number.isFinite(wait)) throw new TypeError('Expected `wait` to be a finite number');
    let leadingValue;
    let timeout;
    let promiseHandlers = []; // Single array of {resolve, reject}
    const onAbort = ()=>{
        clearTimeout(timeout);
        timeout = undefined;
        try {
            options.signal?.throwIfAborted();
        } catch (error) {
            for (const { reject: reject } of promiseHandlers)reject(error);
            promiseHandlers = [];
        }
    };
    return function(...arguments_) {
        return new Promise((resolve, reject)=>{
            // Check if already aborted
            try {
                options.signal?.throwIfAborted();
            } catch (error) {
                reject(error);
                return;
            }
            const shouldCallNow = options.before && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(async ()=>{
                timeout = undefined;
                // Capture the current handlers for this execution
                const currentHandlers = promiseHandlers;
                // Clear handlers for next cycle (new calls during execution will add to new list)
                promiseHandlers = [];
                try {
                    const result = options.before ? leadingValue : await functionToDebounce.apply(this, arguments_);
                    for (const { resolve: resolveFunction } of currentHandlers)resolveFunction(result);
                } catch (error) {
                    for (const { reject: rejectFunction } of currentHandlers)rejectFunction(error);
                }
                // Clear leading value for next cycle
                leadingValue = undefined;
                // Remove abort listener
                options.signal?.removeEventListener('abort', onAbort);
            }, wait);
            if (shouldCallNow) // Execute immediately for leading edge
            (async ()=>{
                try {
                    leadingValue = await functionToDebounce.apply(this, arguments_);
                    resolve(leadingValue);
                } catch (error) {
                    reject(error);
                }
            })();
            else {
                // Add to handlers for later resolution
                promiseHandlers.push({
                    resolve: resolve,
                    reject: reject
                });
                // Set up abort listener (only once per batch)
                if (options.signal && promiseHandlers.length === 1) options.signal.addEventListener('abort', onAbort, {
                    once: true
                });
            }
        });
    };
};
$e536fa895fb3af60$var$pDebounce.promise = (function_, options = {})=>{
    let currentPromise;
    let queuedCall;
    return async function(...arguments_) {
        if (currentPromise) {
            if (!options.after) return currentPromise;
            // Queue latest call (replacing any existing queue)
            queuedCall ??= {
                resolvers: []
            };
            queuedCall.arguments = arguments_;
            queuedCall.context = this;
            return new Promise((resolve, reject)=>{
                queuedCall.resolvers.push({
                    resolve: resolve,
                    reject: reject
                });
            });
        }
        currentPromise = (async ()=>{
            let result;
            let initialError;
            try {
                result = await function_.apply(this, arguments_);
            } catch (error) {
                initialError = error;
            }
            // Process queued calls regardless of initial result
            while(queuedCall){
                const call = queuedCall;
                queuedCall = undefined;
                try {
                    // eslint-disable-next-line no-await-in-loop
                    const queuedResult = await function_.apply(call.context, call.arguments);
                    for (const { resolve: resolve } of call.resolvers)resolve(queuedResult);
                } catch (error) {
                    for (const { reject: reject } of call.resolvers)reject(error);
                }
            }
            if (initialError) throw initialError;
            return result;
        })();
        try {
            return await currentPromise;
        } finally{
            currentPromise = undefined;
        }
    };
};
var $e536fa895fb3af60$export$2e2bcd8739ae039 = $e536fa895fb3af60$var$pDebounce;





async function $6f7f62dc06b9d67e$var$searchDoctor(abortSignal, query) {
    query = query.trim();
    if (query) {
        const data = await (0, $56ff6b9a4ee43a2e$export$644d8ea042df96a6).auth.post('onlinebooking/practitioner-search', {
            signal: abortSignal,
            json: {
                searchTerm: query.trim(),
                role: 'GeneralPractitioner'
            }
        }).json();
        if (Array.isArray(data)) return data;
    }
    return 0, $2bd9d04ce55ef2a0$export$2c66e96878bf4792;
}
const $6f7f62dc06b9d67e$var$debouncedSearchAddress = (0, $e536fa895fb3af60$export$2e2bcd8739ae039)($6f7f62dc06b9d67e$var$searchDoctor, 1000);
function $6f7f62dc06b9d67e$export$74f594857fde2404(query) {
    return (0, $36464e4be8053fb8$export$a4c3459d1b3dd407)($6f7f62dc06b9d67e$var$debouncedSearchAddress, [
        query
    ]);
}







var $acw62 = parcelRequire("acw62");
function $d83d895abc8ae8e7$var$ArrowPathIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M15.312 11.424a5.5 5.5 0 0 1-9.201 2.466l-.312-.311h2.433a.75.75 0 0 0 0-1.5H3.989a.75.75 0 0 0-.75.75v4.242a.75.75 0 0 0 1.5 0v-2.43l.31.31a7 7 0 0 0 11.712-3.138.75.75 0 0 0-1.449-.39Zm1.23-3.723a.75.75 0 0 0 .219-.53V2.929a.75.75 0 0 0-1.5 0V5.36l-.31-.31A7 7 0 0 0 3.239 8.188a.75.75 0 1 0 1.448.389A5.5 5.5 0 0 1 13.89 6.11l.311.31h-2.432a.75.75 0 0 0 0 1.5h4.243a.75.75 0 0 0 .53-.219Z",
        clipRule: "evenodd"
    }));
}
const $d83d895abc8ae8e7$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($d83d895abc8ae8e7$var$ArrowPathIcon);
var $d83d895abc8ae8e7$export$2e2bcd8739ae039 = $d83d895abc8ae8e7$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $84a35d80e3e9ca45$var$MagnifyingGlassIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z",
        clipRule: "evenodd"
    }));
}
const $84a35d80e3e9ca45$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($84a35d80e3e9ca45$var$MagnifyingGlassIcon);
var $84a35d80e3e9ca45$export$2e2bcd8739ae039 = $84a35d80e3e9ca45$var$ForwardRef;



var $acw62 = parcelRequire("acw62");











var $5795a6d23da0a5bd$export$2e2bcd8739ae039 = {};
$5795a6d23da0a5bd$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{639}\u{631}\u{636} \u{627}\u{644}\u{645}\u{642}\u{62A}\u{631}\u{62D}\u{627}\u{62A}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{62E}\u{64A}\u{627}\u{631}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{62E}\u{64A}\u{627}\u{631}\u{627}\u{62A}`
        })} \u{645}\u{62A}\u{627}\u{62D}\u{629}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{627}\u{644}\u{645}\u{62C}\u{645}\u{648}\u{639}\u{629} \u{627}\u{644}\u{645}\u{62F}\u{62E}\u{644}\u{629} ${args.groupTitle}, \u{645}\u{639} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{62E}\u{64A}\u{627}\u{631}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{62E}\u{64A}\u{627}\u{631}\u{627}\u{62A}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{645}\u{62D}\u{62F}\u{62F}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{645}\u{642}\u{62A}\u{631}\u{62D}\u{627}\u{62A}`,
    "selectedAnnouncement": (args)=>`${args.optionText}\u{60C} \u{645}\u{62D}\u{62F}\u{62F}`
};


var $e22abfd51289f1f8$export$2e2bcd8739ae039 = {};
$e22abfd51289f1f8$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{41F}\u{43E}\u{43A}\u{430}\u{436}\u{438} \u{43F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{43E}\u{43F}\u{446}\u{438}\u{44F}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{43E}\u{43F}\u{446}\u{438}\u{438}`
        })} \u{43D}\u{430} \u{440}\u{430}\u{437}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{412}\u{44A}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{430} \u{433}\u{440}\u{443}\u{43F}\u{430} ${args.groupTitle}, \u{441} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{43E}\u{43F}\u{446}\u{438}\u{44F}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{43E}\u{43F}\u{446}\u{438}\u{438}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{41F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}`
};


var $efe57441752b305f$export$2e2bcd8739ae039 = {};
$efe57441752b305f$export$2e2bcd8739ae039 = {
    "buttonLabel": `Zobrazit doporu\u{10D}en\xed`,
    "countAnnouncement": (args, formatter)=>`K dispozici ${formatter.plural(args.optionCount, {
            one: ()=>`je ${formatter.number(args.optionCount)} mo\u{17E}nost`,
            other: ()=>`jsou/je ${formatter.number(args.optionCount)} mo\u{17E}nosti/-\xed`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Zadan\xe1 skupina \u{201E}${args.groupTitle}\u{201C} ${formatter.plural(args.groupCount, {
                    one: ()=>`s ${formatter.number(args.groupCount)} mo\u{17E}nost\xed`,
                    other: ()=>`se ${formatter.number(args.groupCount)} mo\u{17E}nostmi`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: ` (vybr\xe1no)`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `N\xe1vrhy`,
    "selectedAnnouncement": (args)=>`${args.optionText}, vybr\xe1no`
};


var $1f2dc995fafa8fcc$export$2e2bcd8739ae039 = {};
$1f2dc995fafa8fcc$export$2e2bcd8739ae039 = {
    "buttonLabel": `Vis forslag`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} mulighed tilg\xe6ngelig`,
            other: ()=>`${formatter.number(args.optionCount)} muligheder tilg\xe6ngelige`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Angivet gruppe ${args.groupTitle}, med ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} mulighed`,
                    other: ()=>`${formatter.number(args.groupCount)} muligheder`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valgt`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Forslag`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valgt`
};


var $fff9aee7732a8e8a$export$2e2bcd8739ae039 = {};
$fff9aee7732a8e8a$export$2e2bcd8739ae039 = {
    "buttonLabel": `Empfehlungen anzeigen`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} Option`,
            other: ()=>`${formatter.number(args.optionCount)} Optionen`
        })} verf\xfcgbar.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Eingetretene Gruppe ${args.groupTitle}, mit ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} Option`,
                    other: ()=>`${formatter.number(args.groupCount)} Optionen`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, ausgew\xe4hlt`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Empfehlungen`,
    "selectedAnnouncement": (args)=>`${args.optionText}, ausgew\xe4hlt`
};


var $0b8ae78f839d0cb2$export$2e2bcd8739ae039 = {};
$0b8ae78f839d0cb2$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{3A0}\u{3C1}\u{3BF}\u{3B2}\u{3BF}\u{3BB}\u{3AE} \u{3C0}\u{3C1}\u{3BF}\u{3C4}\u{3AC}\u{3C3}\u{3B5}\u{3C9}\u{3BD}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AD}\u{3C2} `
        })} \u{3B4}\u{3B9}\u{3B1}\u{3B8}\u{3AD}\u{3C3}\u{3B9}\u{3BC}\u{3B5}\u{3C2}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{395}\u{3B9}\u{3C3}\u{3B1}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B7} \u{3BF}\u{3BC}\u{3AC}\u{3B4}\u{3B1} ${args.groupTitle}, \u{3BC}\u{3B5} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AD}\u{3C2}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3BF}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{3A0}\u{3C1}\u{3BF}\u{3C4}\u{3AC}\u{3C3}\u{3B5}\u{3B9}\u{3C2}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5}`
};


var $0b011e5449aa10ab$export$2e2bcd8739ae039 = {};
$0b011e5449aa10ab$export$2e2bcd8739ae039 = {
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Entered group ${args.groupTitle}, with ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} option`,
                    other: ()=>`${formatter.number(args.groupCount)} options`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selected`,
            other: ``
        }, args.isSelected)}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} option`,
            other: ()=>`${formatter.number(args.optionCount)} options`
        })} available.`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selected`,
    "buttonLabel": `Show suggestions`,
    "listboxLabel": `Suggestions`
};


var $2080c12003e67cc4$export$2e2bcd8739ae039 = {};
$2080c12003e67cc4$export$2e2bcd8739ae039 = {
    "buttonLabel": `Mostrar sugerencias`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opci\xf3n`,
            other: ()=>`${formatter.number(args.optionCount)} opciones`
        })} disponible(s).`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Se ha unido al grupo ${args.groupTitle}, con ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opci\xf3n`,
                    other: ()=>`${formatter.number(args.groupCount)} opciones`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, seleccionado`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugerencias`,
    "selectedAnnouncement": (args)=>`${args.optionText}, seleccionado`
};


var $96d49ec1740311fb$export$2e2bcd8739ae039 = {};
$96d49ec1740311fb$export$2e2bcd8739ae039 = {
    "buttonLabel": `Kuva soovitused`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} valik`,
            other: ()=>`${formatter.number(args.optionCount)} valikud`
        })} saadaval.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Sisestatud r\xfchm ${args.groupTitle}, valikuga ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} valik`,
                    other: ()=>`${formatter.number(args.groupCount)} valikud`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valitud`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Soovitused`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valitud`
};


var $176a9f03c3235271$export$2e2bcd8739ae039 = {};
$176a9f03c3235271$export$2e2bcd8739ae039 = {
    "buttonLabel": `N\xe4yt\xe4 ehdotukset`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} vaihtoehto`,
            other: ()=>`${formatter.number(args.optionCount)} vaihtoehdot`
        })} saatavilla.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Mentiin ryhm\xe4\xe4n ${args.groupTitle}, ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} vaihtoehdon`,
                    other: ()=>`${formatter.number(args.groupCount)} vaihtoehdon`
                })} kanssa.`,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valittu`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Ehdotukset`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valittu`
};


var $4f6675826c0a6a10$export$2e2bcd8739ae039 = {};
$4f6675826c0a6a10$export$2e2bcd8739ae039 = {
    "buttonLabel": `Afficher les suggestions`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} option`,
            other: ()=>`${formatter.number(args.optionCount)} options`
        })} disponible(s).`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Groupe ${args.groupTitle} rejoint, avec ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} option`,
                    other: ()=>`${formatter.number(args.groupCount)} options`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, s\xe9lectionn\xe9(s)`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Suggestions`,
    "selectedAnnouncement": (args)=>`${args.optionText}, s\xe9lectionn\xe9`
};


var $a6859721aba208af$export$2e2bcd8739ae039 = {};
$a6859721aba208af$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{5D4}\u{5E6}\u{5D2} \u{5D4}\u{5E6}\u{5E2}\u{5D5}\u{5EA}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`\u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5EA} ${formatter.number(args.optionCount)}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5D9}\u{5D5}\u{5EA}`
        })} \u{5D1}\u{5DE}\u{5E6}\u{5D1} \u{5D6}\u{5DE}\u{5D9}\u{5DF}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{5E0}\u{5DB}\u{5E0}\u{5E1} \u{5DC}\u{5E7}\u{5D1}\u{5D5}\u{5E6}\u{5D4} ${args.groupTitle}, \u{5E2}\u{5DD} ${formatter.plural(args.groupCount, {
                    one: ()=>`\u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5EA} ${formatter.number(args.groupCount)}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5D9}\u{5D5}\u{5EA}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{5E0}\u{5D1}\u{5D7}\u{5E8}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{5D4}\u{5E6}\u{5E2}\u{5D5}\u{5EA}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{5E0}\u{5D1}\u{5D7}\u{5E8}`
};


var $d10b26589f632012$export$2e2bcd8739ae039 = {};
$d10b26589f632012$export$2e2bcd8739ae039 = {
    "buttonLabel": `Prika\u{17E}i prijedloge`,
    "countAnnouncement": (args, formatter)=>`Dostupno jo\u{161}: ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcije/a`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Unesena skupina ${args.groupTitle}, s ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcijom`,
                    other: ()=>`${formatter.number(args.groupCount)} opcije/a`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, odabranih`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Prijedlozi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, odabrano`
};


var $5883b9ba9b0c8573$export$2e2bcd8739ae039 = {};
$5883b9ba9b0c8573$export$2e2bcd8739ae039 = {
    "buttonLabel": `Javaslatok megjelen\xedt\xe9se`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} lehet\u{151}s\xe9g`,
            other: ()=>`${formatter.number(args.optionCount)} lehet\u{151}s\xe9g`
        })} \xe1ll rendelkez\xe9sre.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Bel\xe9pett a(z) ${args.groupTitle} csoportba, amely ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} lehet\u{151}s\xe9get`,
                    other: ()=>`${formatter.number(args.groupCount)} lehet\u{151}s\xe9get`
                })} tartalmaz. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, kijel\xf6lve`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Javaslatok`,
    "selectedAnnouncement": (args)=>`${args.optionText}, kijel\xf6lve`
};


var $950d6f6bc29984da$export$2e2bcd8739ae039 = {};
$950d6f6bc29984da$export$2e2bcd8739ae039 = {
    "buttonLabel": `Mostra suggerimenti`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opzione disponibile`,
            other: ()=>`${formatter.number(args.optionCount)} opzioni disponibili`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Ingresso nel gruppo ${args.groupTitle}, con ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opzione`,
                    other: ()=>`${formatter.number(args.groupCount)} opzioni`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selezionato`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Suggerimenti`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selezionato`
};


var $8b136aff4c155430$export$2e2bcd8739ae039 = {};
$8b136aff4c155430$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{5019}\u{88DC}\u{3092}\u{8868}\u{793A}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{500B}\u{306E}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{500B}\u{306E}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}`
        })}\u{3092}\u{5229}\u{7528}\u{3067}\u{304D}\u{307E}\u{3059}\u{3002}`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{5165}\u{529B}\u{3055}\u{308C}\u{305F}\u{30B0}\u{30EB}\u{30FC}\u{30D7} ${args.groupTitle}\u{3001}${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{500B}\u{306E}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{500B}\u{306E}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}`
                })}\u{3092}\u{542B}\u{3080}\u{3002}`,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `\u{3001}\u{9078}\u{629E}\u{6E08}\u{307F}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{5019}\u{88DC}`,
    "selectedAnnouncement": (args)=>`${args.optionText}\u{3001}\u{9078}\u{629E}\u{6E08}\u{307F}`
};


var $7e30b7b0a1dc67e3$export$2e2bcd8739ae039 = {};
$7e30b7b0a1dc67e3$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{C81C}\u{C548} \u{C0AC}\u{D56D} \u{D45C}\u{C2DC}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)}\u{AC1C} \u{C635}\u{C158}`,
            other: ()=>`${formatter.number(args.optionCount)}\u{AC1C} \u{C635}\u{C158}`
        })}\u{C744} \u{C0AC}\u{C6A9}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{C785}\u{B825}\u{D55C} \u{ADF8}\u{B8F9} ${args.groupTitle}, ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)}\u{AC1C} \u{C635}\u{C158}`,
                    other: ()=>`${formatter.number(args.groupCount)}\u{AC1C} \u{C635}\u{C158}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{C120}\u{D0DD}\u{B428}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{C81C}\u{C548}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{C120}\u{D0DD}\u{B428}`
};


var $7340646d5e8aea49$export$2e2bcd8739ae039 = {};
$7340646d5e8aea49$export$2e2bcd8739ae039 = {
    "buttonLabel": `Rodyti pasi\u{16B}lymus`,
    "countAnnouncement": (args, formatter)=>`Yra ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} parinktis`,
            other: ()=>`${formatter.number(args.optionCount)} parinktys (-i\u{173})`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{12E}vesta grup\u{117} ${args.groupTitle}, su ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} parinktimi`,
                    other: ()=>`${formatter.number(args.groupCount)} parinktimis (-i\u{173})`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, pasirinkta`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Pasi\u{16B}lymai`,
    "selectedAnnouncement": (args)=>`${args.optionText}, pasirinkta`
};


var $a81ae79b1d6b0fdb$export$2e2bcd8739ae039 = {};
$a81ae79b1d6b0fdb$export$2e2bcd8739ae039 = {
    "buttonLabel": `R\u{101}d\u{12B}t ieteikumus`,
    "countAnnouncement": (args, formatter)=>`Pieejamo opciju skaits: ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcijas`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Ievad\u{12B}ta grupa ${args.groupTitle}, ar ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opciju`,
                    other: ()=>`${formatter.number(args.groupCount)} opcij\u{101}m`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, atlas\u{12B}ta`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Ieteikumi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, atlas\u{12B}ta`
};


var $9825aedf5a7cd445$export$2e2bcd8739ae039 = {};
$9825aedf5a7cd445$export$2e2bcd8739ae039 = {
    "buttonLabel": `Vis forslag`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} alternativ`,
            other: ()=>`${formatter.number(args.optionCount)} alternativer`
        })} finnes.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Angitt gruppe ${args.groupTitle}, med ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} alternativ`,
                    other: ()=>`${formatter.number(args.groupCount)} alternativer`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valgt`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Forslag`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valgt`
};


var $de64f11ed9153d05$export$2e2bcd8739ae039 = {};
$de64f11ed9153d05$export$2e2bcd8739ae039 = {
    "buttonLabel": `Suggesties weergeven`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} optie`,
            other: ()=>`${formatter.number(args.optionCount)} opties`
        })} beschikbaar.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Groep ${args.groupTitle} ingevoerd met ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} optie`,
                    other: ()=>`${formatter.number(args.groupCount)} opties`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, geselecteerd`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Suggesties`,
    "selectedAnnouncement": (args)=>`${args.optionText}, geselecteerd`
};


var $b362f72e554c203b$export$2e2bcd8739ae039 = {};
$b362f72e554c203b$export$2e2bcd8739ae039 = {
    "buttonLabel": `Wy\u{15B}wietlaj sugestie`,
    "countAnnouncement": (args, formatter)=>`dost\u{119}pna/dost\u{119}pne(-nych) ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcja`,
            other: ()=>`${formatter.number(args.optionCount)} opcje(-i)`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Do\u{142}\u{105}czono do grupy ${args.groupTitle}, z ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcj\u{105}`,
                    other: ()=>`${formatter.number(args.groupCount)} opcjami`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, wybrano`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugestie`,
    "selectedAnnouncement": (args)=>`${args.optionText}, wybrano`
};


var $500f9ed6a87b905c$export$2e2bcd8739ae039 = {};
$500f9ed6a87b905c$export$2e2bcd8739ae039 = {
    "buttonLabel": `Mostrar sugest\xf5es`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} op\xe7\xe3o`,
            other: ()=>`${formatter.number(args.optionCount)} op\xe7\xf5es`
        })} dispon\xedvel.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Grupo inserido ${args.groupTitle}, com ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} op\xe7\xe3o`,
                    other: ()=>`${formatter.number(args.groupCount)} op\xe7\xf5es`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selecionado`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugest\xf5es`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selecionado`
};


var $d6c170b5b05ee936$export$2e2bcd8739ae039 = {};
$d6c170b5b05ee936$export$2e2bcd8739ae039 = {
    "buttonLabel": `Apresentar sugest\xf5es`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} op\xe7\xe3o`,
            other: ()=>`${formatter.number(args.optionCount)} op\xe7\xf5es`
        })} dispon\xedvel.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Grupo introduzido ${args.groupTitle}, com ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} op\xe7\xe3o`,
                    other: ()=>`${formatter.number(args.groupCount)} op\xe7\xf5es`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selecionado`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugest\xf5es`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selecionado`
};


var $959d792130b3f6d9$export$2e2bcd8739ae039 = {};
$959d792130b3f6d9$export$2e2bcd8739ae039 = {
    "buttonLabel": `Afi\u{219}are sugestii`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} op\u{21B}iune`,
            other: ()=>`${formatter.number(args.optionCount)} op\u{21B}iuni`
        })} disponibile.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Grup ${args.groupTitle} introdus, cu ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} op\u{21B}iune`,
                    other: ()=>`${formatter.number(args.groupCount)} op\u{21B}iuni`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, selectat`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Sugestii`,
    "selectedAnnouncement": (args)=>`${args.optionText}, selectat`
};


var $847a38d641349fb1$export$2e2bcd8739ae039 = {};
$847a38d641349fb1$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C} \u{43F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{43E}\u{432}`
        })} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{43E}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{412}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{43D}\u{430}\u{44F} \u{433}\u{440}\u{443}\u{43F}\u{43F}\u{430} ${args.groupTitle}, \u{441} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{43E}\u{43C}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{430}\u{43C}\u{438}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{43C}\u{438}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{41F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}`
};


var $e9151f8df1a7d09b$export$2e2bcd8739ae039 = {};
$e9151f8df1a7d09b$export$2e2bcd8739ae039 = {
    "buttonLabel": `Zobrazi\u{165} n\xe1vrhy`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} mo\u{17E}nos\u{165}`,
            other: ()=>`${formatter.number(args.optionCount)} mo\u{17E}nosti/-\xed`
        })} k dispoz\xedcii.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Zadan\xe1 skupina ${args.groupTitle}, s ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} mo\u{17E}nos\u{165}ou`,
                    other: ()=>`${formatter.number(args.groupCount)} mo\u{17E}nos\u{165}ami`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, vybrat\xe9`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `N\xe1vrhy`,
    "selectedAnnouncement": (args)=>`${args.optionText}, vybrat\xe9`
};


var $769fef24c8b0f706$export$2e2bcd8739ae039 = {};
$769fef24c8b0f706$export$2e2bcd8739ae039 = {
    "buttonLabel": `Prika\u{17E}i predloge`,
    "countAnnouncement": (args, formatter)=>`Na voljo je ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcije`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Vnesena skupina ${args.groupTitle}, z ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcija`,
                    other: ()=>`${formatter.number(args.groupCount)} opcije`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, izbrano`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Predlogi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, izbrano`
};


var $2d5c53abdd820f88$export$2e2bcd8739ae039 = {};
$2d5c53abdd820f88$export$2e2bcd8739ae039 = {
    "buttonLabel": `Prika\u{17E}i predloge`,
    "countAnnouncement": (args, formatter)=>`Dostupno jo\u{161}: ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} opcija`,
            other: ()=>`${formatter.number(args.optionCount)} opcije/a`
        })}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Unesena grupa ${args.groupTitle}, s ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} opcijom`,
                    other: ()=>`${formatter.number(args.groupCount)} optione/a`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, izabranih`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `Predlozi`,
    "selectedAnnouncement": (args)=>`${args.optionText}, izabrano`
};


var $f0f255946df6f26f$export$2e2bcd8739ae039 = {};
$f0f255946df6f26f$export$2e2bcd8739ae039 = {
    "buttonLabel": `Visa f\xf6rslag`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} alternativ`,
            other: ()=>`${formatter.number(args.optionCount)} alternativ`
        })} tillg\xe4ngliga.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Ingick i gruppen ${args.groupTitle} med ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} alternativ`,
                    other: ()=>`${formatter.number(args.groupCount)} alternativ`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, valda`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `F\xf6rslag`,
    "selectedAnnouncement": (args)=>`${args.optionText}, valda`
};


var $e8e2883eda8c0d04$export$2e2bcd8739ae039 = {};
$e8e2883eda8c0d04$export$2e2bcd8739ae039 = {
    "buttonLabel": `\xd6nerileri g\xf6ster`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} se\xe7enek`,
            other: ()=>`${formatter.number(args.optionCount)} se\xe7enekler`
        })} kullan\u{131}labilir.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`Girilen grup ${args.groupTitle}, ile ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} se\xe7enek`,
                    other: ()=>`${formatter.number(args.groupCount)} se\xe7enekler`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, se\xe7ildi`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\xd6neriler`,
    "selectedAnnouncement": (args)=>`${args.optionText}, se\xe7ildi`
};


var $7a1b91a7040f96fd$export$2e2bcd8739ae039 = {};
$7a1b91a7040f96fd$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{438} \u{43F}\u{440}\u{43E}\u{43F}\u{43E}\u{437}\u{438}\u{446}\u{456}\u{457}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{438}(-\u{456}\u{432})`
        })} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{43E}.`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{412}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{430} \u{433}\u{440}\u{443}\u{43F}\u{430} ${args.groupTitle}, \u{437} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{438}(-\u{456}\u{432})`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{41F}\u{440}\u{43E}\u{43F}\u{43E}\u{437}\u{438}\u{446}\u{456}\u{457}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`
};


var $5bdb4885c09d3f3f$export$2e2bcd8739ae039 = {};
$5bdb4885c09d3f3f$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{663E}\u{793A}\u{5EFA}\u{8BAE}`,
    "countAnnouncement": (args, formatter)=>`\u{6709} ${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{4E2A}\u{9009}\u{9879}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{4E2A}\u{9009}\u{9879}`
        })}\u{53EF}\u{7528}\u{3002}`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{8FDB}\u{5165}\u{4E86} ${args.groupTitle} \u{7EC4}\u{FF0C}\u{5176}\u{4E2D}\u{6709} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{4E2A}\u{9009}\u{9879}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{4E2A}\u{9009}\u{9879}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{5DF2}\u{9009}\u{62E9}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{5EFA}\u{8BAE}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{5DF2}\u{9009}\u{62E9}`
};


var $8cbfd38c6aa2a7ec$export$2e2bcd8739ae039 = {};
$8cbfd38c6aa2a7ec$export$2e2bcd8739ae039 = {
    "buttonLabel": `\u{986F}\u{793A}\u{5EFA}\u{8B70}`,
    "countAnnouncement": (args, formatter)=>`${formatter.plural(args.optionCount, {
            one: ()=>`${formatter.number(args.optionCount)} \u{9078}\u{9805}`,
            other: ()=>`${formatter.number(args.optionCount)} \u{9078}\u{9805}`
        })} \u{53EF}\u{7528}\u{3002}`,
    "focusAnnouncement": (args, formatter)=>`${formatter.select({
            true: ()=>`\u{8F38}\u{5165}\u{7684}\u{7FA4}\u{7D44} ${args.groupTitle}, \u{6709} ${formatter.plural(args.groupCount, {
                    one: ()=>`${formatter.number(args.groupCount)} \u{9078}\u{9805}`,
                    other: ()=>`${formatter.number(args.groupCount)} \u{9078}\u{9805}`
                })}. `,
            other: ``
        }, args.isGroupChange)}${args.optionText}${formatter.select({
            true: `, \u{5DF2}\u{9078}\u{53D6}`,
            other: ``
        }, args.isSelected)}`,
    "listboxLabel": `\u{5EFA}\u{8B70}`,
    "selectedAnnouncement": (args)=>`${args.optionText}, \u{5DF2}\u{9078}\u{53D6}`
};


var $90c0bb2aef81c7dd$export$2e2bcd8739ae039 = {};
$90c0bb2aef81c7dd$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $5795a6d23da0a5bd$export$2e2bcd8739ae039),
    "bg-BG": (0, $e22abfd51289f1f8$export$2e2bcd8739ae039),
    "cs-CZ": (0, $efe57441752b305f$export$2e2bcd8739ae039),
    "da-DK": (0, $1f2dc995fafa8fcc$export$2e2bcd8739ae039),
    "de-DE": (0, $fff9aee7732a8e8a$export$2e2bcd8739ae039),
    "el-GR": (0, $0b8ae78f839d0cb2$export$2e2bcd8739ae039),
    "en-US": (0, $0b011e5449aa10ab$export$2e2bcd8739ae039),
    "es-ES": (0, $2080c12003e67cc4$export$2e2bcd8739ae039),
    "et-EE": (0, $96d49ec1740311fb$export$2e2bcd8739ae039),
    "fi-FI": (0, $176a9f03c3235271$export$2e2bcd8739ae039),
    "fr-FR": (0, $4f6675826c0a6a10$export$2e2bcd8739ae039),
    "he-IL": (0, $a6859721aba208af$export$2e2bcd8739ae039),
    "hr-HR": (0, $d10b26589f632012$export$2e2bcd8739ae039),
    "hu-HU": (0, $5883b9ba9b0c8573$export$2e2bcd8739ae039),
    "it-IT": (0, $950d6f6bc29984da$export$2e2bcd8739ae039),
    "ja-JP": (0, $8b136aff4c155430$export$2e2bcd8739ae039),
    "ko-KR": (0, $7e30b7b0a1dc67e3$export$2e2bcd8739ae039),
    "lt-LT": (0, $7340646d5e8aea49$export$2e2bcd8739ae039),
    "lv-LV": (0, $a81ae79b1d6b0fdb$export$2e2bcd8739ae039),
    "nb-NO": (0, $9825aedf5a7cd445$export$2e2bcd8739ae039),
    "nl-NL": (0, $de64f11ed9153d05$export$2e2bcd8739ae039),
    "pl-PL": (0, $b362f72e554c203b$export$2e2bcd8739ae039),
    "pt-BR": (0, $500f9ed6a87b905c$export$2e2bcd8739ae039),
    "pt-PT": (0, $d6c170b5b05ee936$export$2e2bcd8739ae039),
    "ro-RO": (0, $959d792130b3f6d9$export$2e2bcd8739ae039),
    "ru-RU": (0, $847a38d641349fb1$export$2e2bcd8739ae039),
    "sk-SK": (0, $e9151f8df1a7d09b$export$2e2bcd8739ae039),
    "sl-SI": (0, $769fef24c8b0f706$export$2e2bcd8739ae039),
    "sr-SP": (0, $2d5c53abdd820f88$export$2e2bcd8739ae039),
    "sv-SE": (0, $f0f255946df6f26f$export$2e2bcd8739ae039),
    "tr-TR": (0, $e8e2883eda8c0d04$export$2e2bcd8739ae039),
    "uk-UA": (0, $7a1b91a7040f96fd$export$2e2bcd8739ae039),
    "zh-CN": (0, $5bdb4885c09d3f3f$export$2e2bcd8739ae039),
    "zh-TW": (0, $8cbfd38c6aa2a7ec$export$2e2bcd8739ae039)
};







var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0bb138712ebad13f$export$496315a1608d9602(cb, dependencies) {
    const isInitialMount = (0, $acw62.useRef)(true);
    const lastDeps = (0, $acw62.useRef)(null);
    let cbEvent = (0, $92fff981738f62fe$export$7f54fc3180508a52)(cb);
    (0, $acw62.useEffect)(()=>{
        isInitialMount.current = true;
        return ()=>{
            isInitialMount.current = false;
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        let prevDeps = lastDeps.current;
        if (isInitialMount.current) isInitialMount.current = false;
        else if (!prevDeps || dependencies.some((dep, i)=>!Object.is(dep, prevDeps[i]))) cbEvent();
        lastDeps.current = dependencies;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}




var $acw62 = parcelRequire("acw62");






function $dbbb6c4c5da0e91d$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $dbbb6c4c5da0e91d$export$8c18d1b4f7232bbf(props, state) {
    let { buttonRef: buttonRef, popoverRef: popoverRef, inputRef: inputRef, listBoxRef: listBoxRef, keyboardDelegate: keyboardDelegate, layoutDelegate: layoutDelegate, shouldFocusWrap: shouldFocusWrap, isReadOnly: isReadOnly, isDisabled: isDisabled } = props;
    let backupBtnRef = (0, $acw62.useRef)(null);
    buttonRef = buttonRef !== null && buttonRef !== void 0 ? buttonRef : backupBtnRef;
    let stringFormatter = (0, $3681d06d99b0f841$export$f12b703ca79dfbb1)($dbbb6c4c5da0e91d$var$$parcel$interopDefault((0, $90c0bb2aef81c7dd$export$2e2bcd8739ae039)), '@react-aria/combobox');
    let { menuTriggerProps: menuTriggerProps, menuProps: menuProps } = (0, $02ef2881ed6cea8d$export$dc9c12ed27dd1b49)({
        type: 'listbox',
        isDisabled: isDisabled || isReadOnly
    }, state, buttonRef);
    (0, $a5549fa17747a039$export$3585ede4d035bf14).set(state, {
        id: menuProps.id
    });
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let { collection: collection } = state;
    let { disabledKeys: disabledKeys } = state.selectionManager;
    let delegate = (0, $acw62.useMemo)(()=>keyboardDelegate || new (0, $afe5b32ffd8dcd97$export$a05409b8bb224a5a)({
            collection: collection,
            disabledKeys: disabledKeys,
            ref: listBoxRef,
            layoutDelegate: layoutDelegate
        }), [
        keyboardDelegate,
        layoutDelegate,
        collection,
        disabledKeys,
        listBoxRef
    ]);
    // Use useSelectableCollection to get the keyboard handlers to apply to the textfield
    let { collectionProps: collectionProps } = (0, $5d42d73b717d1d8d$export$d6daf82dcd84e87c)({
        selectionManager: state.selectionManager,
        keyboardDelegate: delegate,
        disallowTypeAhead: true,
        disallowEmptySelection: true,
        shouldFocusWrap: shouldFocusWrap,
        ref: inputRef,
        // Prevent item scroll behavior from being applied here, should be handled in the user's Popover + ListBox component
        isVirtualized: true
    });
    let router = (0, $c9b835cc9e261550$export$9a302a45f65d0572)();
    // For textfield specific keydown operations
    let onKeyDown = (e)=>{
        if (e.nativeEvent.isComposing) return;
        switch(e.key){
            case 'Enter':
            case 'Tab':
                // Prevent form submission if menu is open since we may be selecting a option
                if (state.isOpen && e.key === 'Enter') e.preventDefault();
                // If the focused item is a link, trigger opening it. Items that are links are not selectable.
                if (state.isOpen && listBoxRef.current && state.selectionManager.focusedKey != null) {
                    let collectionItem = state.collection.getItem(state.selectionManager.focusedKey);
                    if (collectionItem === null || collectionItem === void 0 ? void 0 : collectionItem.props.href) {
                        let item = listBoxRef.current.querySelector(`[data-key="${CSS.escape(state.selectionManager.focusedKey.toString())}"]`);
                        if (e.key === 'Enter' && item instanceof HTMLAnchorElement) router.open(item, e, collectionItem.props.href, collectionItem.props.routerOptions);
                        state.close();
                        break;
                    } else if (collectionItem === null || collectionItem === void 0 ? void 0 : collectionItem.props.onAction) {
                        collectionItem.props.onAction();
                        state.close();
                        break;
                    }
                }
                state.commit();
                break;
            case 'Escape':
                if (state.selectedKey !== null || state.inputValue === '' || props.allowsCustomValue) e.continuePropagation();
                state.revert();
                break;
            case 'ArrowDown':
                state.open('first', 'manual');
                break;
            case 'ArrowUp':
                state.open('last', 'manual');
                break;
            case 'ArrowLeft':
            case 'ArrowRight':
                state.selectionManager.setFocusedKey(null);
                break;
        }
    };
    let onBlur = (e)=>{
        var _popoverRef_current;
        let blurFromButton = (buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) && buttonRef.current === e.relatedTarget;
        let blurIntoPopover = (_popoverRef_current = popoverRef.current) === null || _popoverRef_current === void 0 ? void 0 : _popoverRef_current.contains(e.relatedTarget);
        // Ignore blur if focused moved to the button(if exists) or into the popover.
        if (blurFromButton || blurIntoPopover) return;
        if (props.onBlur) props.onBlur(e);
        state.setFocused(false);
    };
    let onFocus = (e)=>{
        if (state.isFocused) return;
        if (props.onFocus) props.onFocus(e);
        state.setFocused(true);
    };
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    let { labelProps: labelProps, inputProps: inputProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $731c2f30442e44c3$export$712718f7aec83d5)({
        ...props,
        onChange: state.setInputValue,
        onKeyDown: !isReadOnly ? (0, $366a72b5d02721fb$export$e08e3b67e392101e)(state.isOpen && collectionProps.onKeyDown, onKeyDown, props.onKeyDown) : props.onKeyDown,
        onBlur: onBlur,
        value: state.inputValue,
        defaultValue: state.defaultInputValue,
        onFocus: onFocus,
        autoComplete: 'off',
        validate: undefined,
        [(0, $bf01417b417639db$export$a763b9476acd3eb)]: state
    }, inputRef);
    // Press handlers for the ComboBox button
    let onPress = (e)=>{
        if (e.pointerType === 'touch') {
            var _inputRef_current;
            (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 || _inputRef_current.focus();
            state.toggle(null, 'manual');
        }
    };
    let onPressStart = (e)=>{
        if (e.pointerType !== 'touch') {
            var _inputRef_current;
            (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 || _inputRef_current.focus();
            state.toggle(e.pointerType === 'keyboard' || e.pointerType === 'virtual' ? 'first' : null, 'manual');
        }
    };
    let triggerLabelProps = (0, $ad7d494fae923873$export$d6875122194c7b44)({
        id: menuTriggerProps.id,
        'aria-label': stringFormatter.format('buttonLabel'),
        'aria-labelledby': props['aria-labelledby'] || labelProps.id
    });
    let listBoxProps = (0, $ad7d494fae923873$export$d6875122194c7b44)({
        id: menuProps.id,
        'aria-label': stringFormatter.format('listboxLabel'),
        'aria-labelledby': props['aria-labelledby'] || labelProps.id
    });
    // If a touch happens on direct center of ComboBox input, might be virtual click from iPad so open ComboBox menu
    let lastEventTime = (0, $acw62.useRef)(0);
    let onTouchEnd = (e)=>{
        if (isDisabled || isReadOnly) return;
        // Sometimes VoiceOver on iOS fires two touchend events in quick succession. Ignore the second one.
        if (e.timeStamp - lastEventTime.current < 500) {
            var _inputRef_current;
            e.preventDefault();
            (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 || _inputRef_current.focus();
            return;
        }
        let rect = e.target.getBoundingClientRect();
        let touch = e.changedTouches[0];
        let centerX = Math.ceil(rect.left + .5 * rect.width);
        let centerY = Math.ceil(rect.top + .5 * rect.height);
        if (touch.clientX === centerX && touch.clientY === centerY) {
            var _inputRef_current1;
            e.preventDefault();
            (_inputRef_current1 = inputRef.current) === null || _inputRef_current1 === void 0 || _inputRef_current1.focus();
            state.toggle(null, 'manual');
            lastEventTime.current = e.timeStamp;
        }
    };
    // VoiceOver has issues with announcing aria-activedescendant properly on change
    // (especially on iOS). We use a live region announcer to announce focus changes
    // manually. In addition, section titles are announced when navigating into a new section.
    let focusedItem = state.selectionManager.focusedKey != null && state.isOpen ? state.collection.getItem(state.selectionManager.focusedKey) : undefined;
    var _focusedItem_parentKey;
    let sectionKey = (_focusedItem_parentKey = focusedItem === null || focusedItem === void 0 ? void 0 : focusedItem.parentKey) !== null && _focusedItem_parentKey !== void 0 ? _focusedItem_parentKey : null;
    var _state_selectionManager_focusedKey;
    let itemKey = (_state_selectionManager_focusedKey = state.selectionManager.focusedKey) !== null && _state_selectionManager_focusedKey !== void 0 ? _state_selectionManager_focusedKey : null;
    let lastSection = (0, $acw62.useRef)(sectionKey);
    let lastItem = (0, $acw62.useRef)(itemKey);
    (0, $acw62.useEffect)(()=>{
        if ((0, $c0699bc5a0b3191f$export$e1865c3bedcd822b)() && focusedItem != null && itemKey != null && itemKey !== lastItem.current) {
            let isSelected = state.selectionManager.isSelected(itemKey);
            let section = sectionKey != null ? state.collection.getItem(sectionKey) : null;
            let sectionTitle = (section === null || section === void 0 ? void 0 : section['aria-label']) || (typeof (section === null || section === void 0 ? void 0 : section.rendered) === 'string' ? section.rendered : '') || '';
            var _ref;
            let announcement = stringFormatter.format('focusAnnouncement', {
                isGroupChange: (_ref = section && sectionKey !== lastSection.current) !== null && _ref !== void 0 ? _ref : false,
                groupTitle: sectionTitle,
                groupCount: section ? [
                    ...(0, $0c872771c245f177$export$1005530eda016c13)(section, state.collection)
                ].length : 0,
                optionText: focusedItem['aria-label'] || focusedItem.textValue || '',
                isSelected: isSelected
            });
            (0, $19250283ca240c8f$export$a9b970dcc4ae71a9)(announcement);
        }
        lastSection.current = sectionKey;
        lastItem.current = itemKey;
    });
    // Announce the number of available suggestions when it changes
    let optionCount = (0, $1173ed60a7d91dfd$export$77d5aafae4e095b2)(state.collection);
    let lastSize = (0, $acw62.useRef)(optionCount);
    let lastOpen = (0, $acw62.useRef)(state.isOpen);
    (0, $acw62.useEffect)(()=>{
        // Only announce the number of options available when the menu opens if there is no
        // focused item, otherwise screen readers will typically read e.g. "1 of 6".
        // The exception is VoiceOver since this isn't included in the message above.
        let didOpenWithoutFocusedItem = state.isOpen !== lastOpen.current && (state.selectionManager.focusedKey == null || (0, $c0699bc5a0b3191f$export$e1865c3bedcd822b)());
        if (state.isOpen && (didOpenWithoutFocusedItem || optionCount !== lastSize.current)) {
            let announcement = stringFormatter.format('countAnnouncement', {
                optionCount: optionCount
            });
            (0, $19250283ca240c8f$export$a9b970dcc4ae71a9)(announcement);
        }
        lastSize.current = optionCount;
        lastOpen.current = state.isOpen;
    });
    // Announce when a selection occurs for VoiceOver. Other screen readers typically do this automatically.
    let lastSelectedKey = (0, $acw62.useRef)(state.selectedKey);
    (0, $acw62.useEffect)(()=>{
        if ((0, $c0699bc5a0b3191f$export$e1865c3bedcd822b)() && state.isFocused && state.selectedItem && state.selectedKey !== lastSelectedKey.current) {
            let optionText = state.selectedItem['aria-label'] || state.selectedItem.textValue || '';
            let announcement = stringFormatter.format('selectedAnnouncement', {
                optionText: optionText
            });
            (0, $19250283ca240c8f$export$a9b970dcc4ae71a9)(announcement);
        }
        lastSelectedKey.current = state.selectedKey;
    });
    (0, $acw62.useEffect)(()=>{
        if (state.isOpen) return (0, $35c480da0fc20955$export$1c3ebcada18427bf)([
            inputRef.current,
            popoverRef.current
        ].filter((element)=>element != null));
    }, [
        state.isOpen,
        inputRef,
        popoverRef
    ]);
    (0, $0bb138712ebad13f$export$496315a1608d9602)(()=>{
        // Re-show focus ring when there is no virtually focused item.
        if (!focusedItem && inputRef.current && (0, $bc46b52522f8f24d$export$cd4e5573fbe2b576)((0, $48852fd65b79e251$export$b204af158042fbac)(inputRef.current)) === inputRef.current) (0, $12dcf8f3b90d8ae0$export$2b35b76d2e30e129)(inputRef.current, null);
    }, [
        focusedItem
    ]);
    (0, $b95c9737ad40d7c7$export$90fc3a17d93f704c)(listBoxRef, 'react-aria-item-action', state.isOpen ? ()=>{
        state.close();
    } : undefined);
    return {
        labelProps: labelProps,
        buttonProps: {
            ...menuTriggerProps,
            ...triggerLabelProps,
            excludeFromTabOrder: true,
            preventFocusOnPress: true,
            onPress: onPress,
            onPressStart: onPressStart,
            isDisabled: isDisabled || isReadOnly
        },
        inputProps: (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(inputProps, {
            role: 'combobox',
            'aria-expanded': menuTriggerProps['aria-expanded'],
            'aria-controls': state.isOpen ? menuProps.id : undefined,
            // TODO: readd proper logic for completionMode = complete (aria-autocomplete: both)
            'aria-autocomplete': 'list',
            'aria-activedescendant': focusedItem ? (0, $a5549fa17747a039$export$9145995848b05025)(state, focusedItem.key) : undefined,
            onTouchEnd: onTouchEnd,
            // This disable's iOS's autocorrect suggestions, since the combo box provides its own suggestions.
            autoCorrect: 'off',
            // This disable's the macOS Safari spell check auto corrections.
            spellCheck: 'false'
        }),
        listBoxProps: (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(menuProps, listBoxProps, {
            autoFocus: state.focusStrategy || true,
            shouldUseVirtualFocus: true,
            shouldSelectOnPressUp: true,
            shouldFocusOnHover: true,
            linkBehavior: 'selection',
            ['UNSTABLE_itemBehavior']: 'action'
        }),
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e822a52a17c16d76$export$3274cf84b703fff(options) {
    let collator = (0, $b66e5976a4251b0c$export$a16aca283550c30d)({
        usage: 'search',
        ...options
    });
    // TODO(later): these methods don't currently support the ignorePunctuation option.
    let startsWith = (0, $acw62.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        // Normalize both strings so we can slice safely
        // TODO: take into account the ignorePunctuation option as well...
        string = string.normalize('NFC');
        substring = substring.normalize('NFC');
        return collator.compare(string.slice(0, substring.length), substring) === 0;
    }, [
        collator
    ]);
    let endsWith = (0, $acw62.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        string = string.normalize('NFC');
        substring = substring.normalize('NFC');
        return collator.compare(string.slice(-substring.length), substring) === 0;
    }, [
        collator
    ]);
    let contains = (0, $acw62.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        string = string.normalize('NFC');
        substring = substring.normalize('NFC');
        let scan = 0;
        let sliceLen = substring.length;
        for(; scan + sliceLen <= string.length; scan++){
            let slice = string.slice(scan, scan + sliceLen);
            if (collator.compare(substring, slice) === 0) return true;
        }
        return false;
    }, [
        collator
    ]);
    return (0, $acw62.useMemo)(()=>({
            startsWith: startsWith,
            endsWith: endsWith,
            contains: contains
        }), [
        startsWith,
        endsWith,
        contains
    ]);
}







var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $096439f0f96c8bbf$export$e7f05e985daf4b5f(props) {
    var _props_defaultSelectedKey;
    let [selectedKey, setSelectedKey] = (0, $3316814d6906df5c$export$40bfa8c7b0832715)(props.selectedKey, (_props_defaultSelectedKey = props.defaultSelectedKey) !== null && _props_defaultSelectedKey !== void 0 ? _props_defaultSelectedKey : null, props.onSelectionChange);
    let selectedKeys = (0, $acw62.useMemo)(()=>selectedKey != null ? [
            selectedKey
        ] : [], [
        selectedKey
    ]);
    let { collection: collection, disabledKeys: disabledKeys, selectionManager: selectionManager } = (0, $54ac9d6cc3ba2949$export$2f645645f7bca764)({
        ...props,
        selectionMode: 'single',
        disallowEmptySelection: true,
        allowDuplicateSelectionEvents: true,
        selectedKeys: selectedKeys,
        onSelectionChange: (keys)=>{
            // impossible, but TS doesn't know that
            if (keys === 'all') return;
            var _keys_values_next_value;
            let key = (_keys_values_next_value = keys.values().next().value) !== null && _keys_values_next_value !== void 0 ? _keys_values_next_value : null;
            // Always fire onSelectionChange, even if the key is the same
            // as the current key (useControlledState does not).
            if (key === selectedKey && props.onSelectionChange) props.onSelectionChange(key);
            setSelectedKey(key);
        }
    });
    let selectedItem = selectedKey != null ? collection.getItem(selectedKey) : null;
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager,
        selectedKey: selectedKey,
        setSelectedKey: setSelectedKey,
        selectedItem: selectedItem
    };
}




var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $048dea6b927d7ee3$export$b453a3bfd4a5fa9e(props) {
    var _collection_getItem;
    let { defaultFilter: defaultFilter, menuTrigger: menuTrigger = 'input', allowsEmptyCollection: allowsEmptyCollection = false, allowsCustomValue: allowsCustomValue, shouldCloseOnBlur: shouldCloseOnBlur = true } = props;
    let [showAllItems, setShowAllItems] = (0, $acw62.useState)(false);
    let [isFocused, setFocusedState] = (0, $acw62.useState)(false);
    let [focusStrategy, setFocusStrategy] = (0, $acw62.useState)(null);
    let onSelectionChange = (key)=>{
        if (props.onSelectionChange) props.onSelectionChange(key);
        // If key is the same, reset the inputValue and close the menu
        // (scenario: user clicks on already selected option)
        if (key === selectedKey) {
            resetInputValue();
            closeMenu();
        }
    };
    var _props_items;
    let { collection: collection, selectionManager: selectionManager, selectedKey: selectedKey, setSelectedKey: setSelectedKey, selectedItem: selectedItem, disabledKeys: disabledKeys } = (0, $096439f0f96c8bbf$export$e7f05e985daf4b5f)({
        ...props,
        onSelectionChange: onSelectionChange,
        items: (_props_items = props.items) !== null && _props_items !== void 0 ? _props_items : props.defaultItems
    });
    let [inputValue, setInputValue] = (0, $3316814d6906df5c$export$40bfa8c7b0832715)(props.inputValue, $048dea6b927d7ee3$var$$a9e7382a7d111cb5$var$getDefaultInputValue(props.defaultInputValue, selectedKey, collection) || '', props.onInputChange);
    let [initialSelectedKey] = (0, $acw62.useState)(selectedKey);
    let [initialValue] = (0, $acw62.useState)(inputValue);
    // Preserve original collection so we can show all items on demand
    let originalCollection = collection;
    let filteredCollection = (0, $acw62.useMemo)(()=>props.items != null || !defaultFilter ? collection : $048dea6b927d7ee3$var$$a9e7382a7d111cb5$var$filterCollection(collection, inputValue, defaultFilter), [
        collection,
        inputValue,
        defaultFilter,
        props.items
    ]);
    let [lastCollection, setLastCollection] = (0, $acw62.useState)(filteredCollection);
    // Track what action is attempting to open the menu
    let menuOpenTrigger = (0, $acw62.useRef)('focus');
    let onOpenChange = (open)=>{
        if (props.onOpenChange) props.onOpenChange(open, open ? menuOpenTrigger.current : undefined);
        selectionManager.setFocused(open);
        if (!open) selectionManager.setFocusedKey(null);
    };
    let triggerState = (0, $9a55ce4a79a9cb0d$export$61c6a8c84e605fb6)({
        ...props,
        onOpenChange: onOpenChange,
        isOpen: undefined,
        defaultOpen: undefined
    });
    let open = (focusStrategy = null, trigger)=>{
        let displayAllItems = trigger === 'manual' || trigger === 'focus' && menuTrigger === 'focus';
        // Prevent open operations from triggering if there is nothing to display
        // Also prevent open operations from triggering if items are uncontrolled but defaultItems is empty, even if displayAllItems is true.
        // This is to prevent comboboxes with empty defaultItems from opening but allow controlled items comboboxes to open even if the inital list is empty (assumption is user will provide swap the empty list with a base list via onOpenChange returning `menuTrigger` manual)
        if (allowsEmptyCollection || filteredCollection.size > 0 || displayAllItems && originalCollection.size > 0 || props.items) {
            if (displayAllItems && !triggerState.isOpen && props.items === undefined) setShowAllItems(true);
            menuOpenTrigger.current = trigger;
            setFocusStrategy(focusStrategy);
            triggerState.open();
        }
    };
    let toggle = (focusStrategy = null, trigger)=>{
        let displayAllItems = trigger === 'manual' || trigger === 'focus' && menuTrigger === 'focus';
        // If the menu is closed and there is nothing to display, early return so toggle isn't called to prevent extraneous onOpenChange
        if (!(allowsEmptyCollection || filteredCollection.size > 0 || displayAllItems && originalCollection.size > 0 || props.items) && !triggerState.isOpen) return;
        if (displayAllItems && !triggerState.isOpen && props.items === undefined) setShowAllItems(true);
        // Only update the menuOpenTrigger if menu is currently closed
        if (!triggerState.isOpen) menuOpenTrigger.current = trigger;
        toggleMenu(focusStrategy);
    };
    let updateLastCollection = (0, $acw62.useCallback)(()=>{
        setLastCollection(showAllItems ? originalCollection : filteredCollection);
    }, [
        showAllItems,
        originalCollection,
        filteredCollection
    ]);
    // If menu is going to close, save the current collection so we can freeze the displayed collection when the
    // user clicks outside the popover to close the menu. Prevents the menu contents from updating as the menu closes.
    let toggleMenu = (0, $acw62.useCallback)((focusStrategy = null)=>{
        if (triggerState.isOpen) updateLastCollection();
        setFocusStrategy(focusStrategy);
        triggerState.toggle();
    }, [
        triggerState,
        updateLastCollection
    ]);
    let closeMenu = (0, $acw62.useCallback)(()=>{
        if (triggerState.isOpen) {
            updateLastCollection();
            triggerState.close();
        }
    }, [
        triggerState,
        updateLastCollection
    ]);
    let [lastValue, setLastValue] = (0, $acw62.useState)(inputValue);
    let resetInputValue = ()=>{
        var _collection_getItem;
        var _collection_getItem_textValue;
        let itemText = selectedKey != null ? (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : '' : '';
        setLastValue(itemText);
        setInputValue(itemText);
    };
    var _props_selectedKey, _ref;
    let lastSelectedKey = (0, $acw62.useRef)((_ref = (_props_selectedKey = props.selectedKey) !== null && _props_selectedKey !== void 0 ? _props_selectedKey : props.defaultSelectedKey) !== null && _ref !== void 0 ? _ref : null);
    var _collection_getItem_textValue;
    let lastSelectedKeyText = (0, $acw62.useRef)(selectedKey != null ? (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : '' : '');
    (0, $acw62.useEffect)(()=>{
        var _collection_getItem;
        // Open and close menu automatically when the input value changes if the input is focused,
        // and there are items in the collection or allowEmptyCollection is true.
        if (isFocused && (filteredCollection.size > 0 || allowsEmptyCollection) && !triggerState.isOpen && inputValue !== lastValue && menuTrigger !== 'manual') open(null, 'input');
        // Close the menu if the collection is empty. Don't close menu if filtered collection size is 0
        // but we are currently showing all items via button press
        if (!showAllItems && !allowsEmptyCollection && triggerState.isOpen && filteredCollection.size === 0) closeMenu();
        // Close when an item is selected.
        if (selectedKey != null && selectedKey !== lastSelectedKey.current) closeMenu();
        // Clear focused key when input value changes and display filtered collection again.
        if (inputValue !== lastValue) {
            selectionManager.setFocusedKey(null);
            setShowAllItems(false);
            // Set selectedKey to null when the user clears the input.
            // If controlled, this is the application developer's responsibility.
            if (inputValue === '' && (props.inputValue === undefined || props.selectedKey === undefined)) setSelectedKey(null);
        }
        // If the selectedKey changed, update the input value.
        // Do nothing if both inputValue and selectedKey are controlled.
        // In this case, it's the user's responsibility to update inputValue in onSelectionChange.
        if (selectedKey !== lastSelectedKey.current && (props.inputValue === undefined || props.selectedKey === undefined)) resetInputValue();
        else if (lastValue !== inputValue) setLastValue(inputValue);
        var _collection_getItem_textValue;
        // Update the inputValue if the selected item's text changes from its last tracked value.
        // This is to handle cases where a selectedKey is specified but the items aren't available (async loading) or the selected item's text value updates.
        // Only reset if the user isn't currently within the field so we don't erroneously modify user input.
        // If inputValue is controlled, it is the user's responsibility to update the inputValue when items change.
        let selectedItemText = selectedKey != null ? (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : '' : '';
        if (!isFocused && selectedKey != null && props.inputValue === undefined && selectedKey === lastSelectedKey.current) {
            if (lastSelectedKeyText.current !== selectedItemText) {
                setLastValue(selectedItemText);
                setInputValue(selectedItemText);
            }
        }
        lastSelectedKey.current = selectedKey;
        lastSelectedKeyText.current = selectedItemText;
    });
    let validation = (0, $bf01417b417639db$export$fc1a364ae1f3ff10)({
        ...props,
        value: (0, $acw62.useMemo)(()=>({
                inputValue: inputValue,
                selectedKey: selectedKey
            }), [
            inputValue,
            selectedKey
        ])
    });
    // Revert input value and close menu
    let revert = ()=>{
        if (allowsCustomValue && selectedKey == null) commitCustomValue();
        else commitSelection();
    };
    let commitCustomValue = ()=>{
        lastSelectedKey.current = null;
        setSelectedKey(null);
        closeMenu();
    };
    let commitSelection = ()=>{
        // If multiple things are controlled, call onSelectionChange
        if (props.selectedKey !== undefined && props.inputValue !== undefined) {
            var _props_onSelectionChange, _collection_getItem;
            (_props_onSelectionChange = props.onSelectionChange) === null || _props_onSelectionChange === void 0 || _props_onSelectionChange.call(props, selectedKey);
            var _collection_getItem_textValue;
            // Stop menu from reopening from useEffect
            let itemText = selectedKey != null ? (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : '' : '';
            setLastValue(itemText);
            closeMenu();
        } else {
            // If only a single aspect of combobox is controlled, reset input value and close menu for the user
            resetInputValue();
            closeMenu();
        }
    };
    const commitValue = ()=>{
        if (allowsCustomValue) {
            var _collection_getItem;
            var _collection_getItem_textValue;
            const itemText = selectedKey != null ? (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : '' : '';
            inputValue === itemText ? commitSelection() : commitCustomValue();
        } else commitSelection();
    };
    let commit = ()=>{
        if (triggerState.isOpen && selectionManager.focusedKey != null) {
            // Reset inputValue and close menu here if the selected key is already the focused key. Otherwise
            // fire onSelectionChange to allow the application to control the closing.
            if (selectedKey === selectionManager.focusedKey) commitSelection();
            else setSelectedKey(selectionManager.focusedKey);
        } else commitValue();
    };
    let valueOnFocus = (0, $acw62.useRef)(inputValue);
    let setFocused = (isFocused)=>{
        if (isFocused) {
            valueOnFocus.current = inputValue;
            if (menuTrigger === 'focus' && !props.isReadOnly) open(null, 'focus');
        } else {
            if (shouldCloseOnBlur) commitValue();
            if (inputValue !== valueOnFocus.current) validation.commitValidation();
        }
        setFocusedState(isFocused);
    };
    let displayedCollection = (0, $acw62.useMemo)(()=>{
        if (triggerState.isOpen) {
            if (showAllItems) return originalCollection;
            else return filteredCollection;
        } else return lastCollection;
    }, [
        triggerState.isOpen,
        originalCollection,
        filteredCollection,
        showAllItems,
        lastCollection
    ]);
    var _props_defaultSelectedKey;
    let defaultSelectedKey = (_props_defaultSelectedKey = props.defaultSelectedKey) !== null && _props_defaultSelectedKey !== void 0 ? _props_defaultSelectedKey : initialSelectedKey;
    var _getDefaultInputValue;
    return {
        ...validation,
        ...triggerState,
        focusStrategy: focusStrategy,
        toggle: toggle,
        open: open,
        close: commitValue,
        selectionManager: selectionManager,
        selectedKey: selectedKey,
        defaultSelectedKey: defaultSelectedKey,
        setSelectedKey: setSelectedKey,
        disabledKeys: disabledKeys,
        isFocused: isFocused,
        setFocused: setFocused,
        selectedItem: selectedItem,
        collection: displayedCollection,
        inputValue: inputValue,
        defaultInputValue: (_getDefaultInputValue = $048dea6b927d7ee3$var$$a9e7382a7d111cb5$var$getDefaultInputValue(props.defaultInputValue, defaultSelectedKey, collection)) !== null && _getDefaultInputValue !== void 0 ? _getDefaultInputValue : initialValue,
        setInputValue: setInputValue,
        commit: commit,
        revert: revert
    };
}
function $048dea6b927d7ee3$var$$a9e7382a7d111cb5$var$filterCollection(collection, inputValue, filter) {
    return new (0, $859ef2c97b2281b0$export$d085fb9e920b5ca7)($048dea6b927d7ee3$var$$a9e7382a7d111cb5$var$filterNodes(collection, collection, inputValue, filter));
}
function $048dea6b927d7ee3$var$$a9e7382a7d111cb5$var$filterNodes(collection, nodes, inputValue, filter) {
    let filteredNode = [];
    for (let node of nodes){
        if (node.type === 'section' && node.hasChildNodes) {
            let filtered = $048dea6b927d7ee3$var$$a9e7382a7d111cb5$var$filterNodes(collection, (0, $0c872771c245f177$export$1005530eda016c13)(node, collection), inputValue, filter);
            if ([
                ...filtered
            ].some((node)=>node.type === 'item')) filteredNode.push({
                ...node,
                childNodes: filtered
            });
        } else if (node.type === 'item' && filter(node.textValue, inputValue)) filteredNode.push({
            ...node
        });
        else if (node.type !== 'item') filteredNode.push({
            ...node
        });
    }
    return filteredNode;
}
function $048dea6b927d7ee3$var$$a9e7382a7d111cb5$var$getDefaultInputValue(defaultInputValue, selectedKey, collection) {
    if (defaultInputValue == null) {
        var _collection_getItem;
        var _collection_getItem_textValue;
        if (selectedKey != null) return (_collection_getItem_textValue = (_collection_getItem = collection.getItem(selectedKey)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue) !== null && _collection_getItem_textValue !== void 0 ? _collection_getItem_textValue : '';
    }
    return defaultInputValue;
}





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $812aed73334d4f5a$export$d414ccceff7063c3 = (0, $acw62.createContext)(null);
const $812aed73334d4f5a$export$c02625b26074192c = (0, $acw62.createContext)(null);
const $812aed73334d4f5a$export$72b9695b8216309a = (0, $acw62.forwardRef)(function ComboBox(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $812aed73334d4f5a$export$d414ccceff7063c3);
    let { children: children, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false } = props;
    let content = (0, $acw62.useMemo)(()=>{
        var _props_items;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eddedc696190b9ab$export$7ff8f37d2d81a48d).Provider, {
            value: {
                items: (_props_items = props.items) !== null && _props_items !== void 0 ? _props_items : props.defaultItems
            }
        }, typeof children === 'function' ? children({
            isOpen: false,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isRequired: isRequired,
            defaultChildren: null
        }) : children);
    }, [
        children,
        isDisabled,
        isInvalid,
        isRequired,
        props.items,
        props.defaultItems
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5fe83fb7b4e6e89f$export$bf788dd355e3a401), {
        content: content
    }, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($812aed73334d4f5a$var$$d01f2c01039c0eec$var$ComboBoxInner, {
            props: props,
            collection: collection,
            comboBoxRef: ref
        }));
});
// Contexts to clear inside the popover.
const $812aed73334d4f5a$var$$d01f2c01039c0eec$var$CLEAR_CONTEXTS = [
    (0, $794346013ab6e680$export$75b6ee27786ba447),
    (0, $541712d7db8b7c7b$export$24d547caef80ccd1),
    (0, $ccd48495800651c4$export$37fb8590cf2c088c),
    (0, $c1367d7afc3d8fbe$export$f9c6924e160136d1),
    (0, $424592b5daddcd29$export$9afb8bc826b033ea)
];
function $812aed73334d4f5a$var$$d01f2c01039c0eec$var$ComboBoxInner({ props: props, collection: collection, comboBoxRef: ref }) {
    let { name: name, formValue: formValue = 'key', allowsCustomValue: allowsCustomValue } = props;
    if (allowsCustomValue) formValue = 'text';
    let { validationBehavior: formValidationBehavior } = (0, $12ee5c1d62d6b2e5$export$fabf2dc03a41866e)((0, $99b9335b6cbca82a$export$c24727297075ec6a)) || {};
    var _props_validationBehavior, _ref;
    let validationBehavior = (_ref = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : formValidationBehavior) !== null && _ref !== void 0 ? _ref : 'native';
    let { contains: contains } = (0, $e822a52a17c16d76$export$3274cf84b703fff)({
        sensitivity: 'base'
    });
    let state = (0, $048dea6b927d7ee3$export$b453a3bfd4a5fa9e)({
        defaultFilter: props.defaultFilter || contains,
        ...props,
        // If props.items isn't provided, rely on collection filtering (aka listbox.items is provided or defaultItems provided to Combobox)
        items: props.items,
        children: undefined,
        collection: collection,
        validationBehavior: validationBehavior
    });
    let buttonRef = (0, $acw62.useRef)(null);
    let inputRef = (0, $acw62.useRef)(null);
    let listBoxRef = (0, $acw62.useRef)(null);
    let popoverRef = (0, $acw62.useRef)(null);
    let [labelRef, label] = (0, $12ee5c1d62d6b2e5$export$9d4c57ee4c6ffdd8)(!props['aria-label'] && !props['aria-labelledby']);
    let { buttonProps: buttonProps, inputProps: inputProps, listBoxProps: listBoxProps, labelProps: labelProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $dbbb6c4c5da0e91d$export$8c18d1b4f7232bbf)({
        ...(0, $12ee5c1d62d6b2e5$export$ef03459518577ad4)(props),
        label: label,
        inputRef: inputRef,
        buttonRef: buttonRef,
        listBoxRef: listBoxRef,
        popoverRef: popoverRef,
        name: formValue === 'text' ? name : undefined,
        validationBehavior: validationBehavior
    }, state);
    // Make menu width match input + button
    let [menuWidth, setMenuWidth] = (0, $acw62.useState)(null);
    let onResize = (0, $acw62.useCallback)(()=>{
        if (inputRef.current) {
            var _buttonRef_current;
            let buttonRect = (_buttonRef_current = buttonRef.current) === null || _buttonRef_current === void 0 ? void 0 : _buttonRef_current.getBoundingClientRect();
            let inputRect = inputRef.current.getBoundingClientRect();
            let minX = buttonRect ? Math.min(buttonRect.left, inputRect.left) : inputRect.left;
            let maxX = buttonRect ? Math.max(buttonRect.right, inputRect.right) : inputRect.right;
            setMenuWidth(maxX - minX + 'px');
        }
    }, [
        buttonRef,
        inputRef,
        setMenuWidth
    ]);
    (0, $d0b7c56cfad5caf3$export$683480f191c0e3ea)({
        ref: inputRef,
        onResize: onResize
    });
    // Only expose a subset of state to renderProps function to avoid infinite render loop
    let renderPropsState = (0, $acw62.useMemo)(()=>({
            isOpen: state.isOpen,
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid || false,
            isRequired: props.isRequired || false
        }), [
        state.isOpen,
        props.isDisabled,
        validation.isInvalid,
        props.isRequired
    ]);
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        ...props,
        values: renderPropsState,
        defaultClassName: 'react-aria-ComboBox'
    });
    let DOMProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.id;
    var _state_selectedKey;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $12ee5c1d62d6b2e5$export$2881499e37b75b9a), {
        values: [
            [
                $812aed73334d4f5a$export$c02625b26074192c,
                state
            ],
            [
                (0, $794346013ab6e680$export$75b6ee27786ba447),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ],
            [
                (0, $541712d7db8b7c7b$export$24d547caef80ccd1),
                {
                    ...buttonProps,
                    ref: buttonRef,
                    isPressed: state.isOpen
                }
            ],
            [
                (0, $ccd48495800651c4$export$37fb8590cf2c088c),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, $33689c90e5739620$export$d2f961adcb0afbe),
                state
            ],
            [
                (0, $58149d5ffdda7d3e$export$9b9a0cd73afb7ca4),
                {
                    ref: popoverRef,
                    triggerRef: inputRef,
                    scrollRef: listBoxRef,
                    placement: 'bottom start',
                    isNonModal: true,
                    trigger: 'ComboBox',
                    style: {
                        '--trigger-width': menuWidth
                    },
                    clearContexts: $812aed73334d4f5a$var$$d01f2c01039c0eec$var$CLEAR_CONTEXTS
                }
            ],
            [
                (0, $eddedc696190b9ab$export$7ff8f37d2d81a48d),
                {
                    ...listBoxProps,
                    ref: listBoxRef
                }
            ],
            [
                (0, $eddedc696190b9ab$export$7c5906fe4f1f2af2),
                state
            ],
            [
                (0, $424592b5daddcd29$export$9afb8bc826b033ea),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $c1367d7afc3d8fbe$export$f9c6924e160136d1),
                {
                    isInvalid: validation.isInvalid,
                    isDisabled: props.isDisabled || false
                }
            ],
            [
                (0, $7dd8b2fec65d8b6a$export$ff05c3ac10437e03),
                validation
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-focused": state.isFocused || undefined,
        "data-open": state.isOpen || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined,
        "data-required": props.isRequired || undefined
    }), name && formValue === 'key' && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "hidden",
        name: name,
        form: props.form,
        value: (_state_selectedKey = state.selectedKey) !== null && _state_selectedKey !== void 0 ? _state_selectedKey : ''
    }));
}






const $c832edbd16d59312$var$ALWAYS_TRUE = ()=>true;
function $c832edbd16d59312$export$2f2b9559550c7bbc({ label: label, name: name, inputValue: inputValue, onInputChange: onInputChange, items: items, children: children, loading: loading, onSelect: onSelect, ...props }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $812aed73334d4f5a$export$72b9695b8216309a), {
        ...props,
        inputValue: inputValue,
        onSelectionChange: (...args)=>{
            if (typeof onSelect === 'function') try {
                onSelect(...args);
            } catch (error) {
                console.error('Bug on select handler', error);
            }
        },
        onInputChange: onInputChange,
        defaultFilter: $c832edbd16d59312$var$ALWAYS_TRUE,
        className: "group flex flex-col gap-1",
        allowsEmptyCollection: true,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e29ab1100b9991a4$export$b04be29aa201d4f5), {
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c1367d7afc3d8fbe$export$eb2fcfdbd7ba97d4), {
                className: "flex items-center relative justify-stretch w-full text-body-dark rounded-md border border-solid border-300 shadow-sm placeholder:text-light-500 focus-within:ring-1 ring-primary focus-within:border-primary",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84a35d80e3e9ca45$export$2e2bcd8739ae039), {
                        className: "absolute left-2 top-1/2 -translate-y-2.5 size-5 pointer-events-none text-light-400 grow-0",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ccd48495800651c4$export$f5b8910cec6cf069), {
                        ...props,
                        name: name,
                        className: "py-2 pl-9 pr-2 border-0 focus:ring-0 focus:border-0 grow bg-transparent text-base"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4916017e31e74360$export$5b6b19405a83ff9d), {
                className: "w-[--trigger-width] group/popup",
                "data-loading": !!loading,
                "data-empty": items.length === 0,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $748dcc472c9de93e$export$41f133550aa26f48), {
                        items: items,
                        children: children
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c879a8de1219885d$export$8b251419efc915eb), {
                        className: "px-2 py-1.5 hidden group-data-[loading=true]/popup:block",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d83d895abc8ae8e7$export$2e2bcd8739ae039), {
                            className: "size-5 mr-2 pointer-events-none text-gray-300 grow-0 animate-spin",
                            "aria-hidden": "true"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c879a8de1219885d$export$8b251419efc915eb), {
                        className: "text-base text-gray-500 italic truncate px-2 py-1.5 hidden group-data-[empty=true]/popup:group-data-[loading=false]/popup:block",
                        children: "No results found"
                    })
                ]
            })
        ]
    });
}
$c832edbd16d59312$export$2f2b9559550c7bbc.Item = (0, $748dcc472c9de93e$export$6648d5fa18559e7f);
$c832edbd16d59312$export$2f2b9559550c7bbc.Section = (0, $748dcc472c9de93e$export$7ab5ff309fff16bb);
function $c832edbd16d59312$export$91456bb36b2952c4(useAsyncAbortableHook) {
    return ()=>{
        const [search, setSearch] = (0, $acw62.useState)('');
        const searchState = useAsyncAbortableHook(search);
        const autocompleteProps = (0, $acw62.useMemo)(()=>({
                inputValue: search,
                onInputChange: setSearch,
                loading: !!search && searchState.loading,
                items: searchState.result ?? (0, $2bd9d04ce55ef2a0$export$2c66e96878bf4792)
            }), [
            search,
            searchState.loading,
            searchState.result
        ]);
        return {
            ...searchState,
            autocompleteProps: autocompleteProps
        };
    };
}




function $33d105d6fe79066e$export$be73d5ff5b7c90a2({ onClick: onClick, className: className, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "relative py-5 before:absolute before:top-0 before:bottom-0 before:left-[-99999px] before:right-[-99999px] before:bg-gray-100",
        "data-testid": "edit-card",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('group relative flex items-center justify-stretch min-h-[90px] py-2.5 px-4 border border-300 rounded-lg bg-white shadow-sm font-normal text-body-dark transition-colors hover:bg-primary-50 hover:border-primary', className),
            role: "button",
            onClick: onClick,
            onKeyDown: (e)=>{
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onClick?.(e);
                }
            },
            tabIndex: 0,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "grow",
                    children: children
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "size-11 flex items-center justify-center",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        className: "stroke-gray-500 transition-colors group-hover:stroke-primary",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M11 5H6C4.89543 5 4 5.89543 4 7V18C4 19.1046 4.89543 20 6 20H17C18.1046 20 19 19.1046 19 18V13M17.5858 3.58579C18.3668 2.80474 19.6332 2.80474 20.4142 3.58579C21.1953 4.36683 21.1953 5.63316 20.4142 6.41421L11.8284 15H9L9 12.1716L17.5858 3.58579Z",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    })
                })
            ]
        })
    });
}



const $31bea2dc1a8c2f4b$export$4902baddc787debb = $09193e81812ba154$export$be5493f9613cbbe({
    gp: $09193e81812ba154$export$22b082955e083ec3().nonempty(),
    medicalCentre: $09193e81812ba154$export$22b082955e083ec3()
});
function $31bea2dc1a8c2f4b$var$extractDefaults({ gp: gp, medicalCentre: medicalCentre }, { requestingPractitioner: requestingPractitioner }) {
    return {
        gp: gp ?? requestingPractitioner?.displayName,
        medicalCentre: medicalCentre ?? requestingPractitioner?.organisationNames?.[0]
    };
}
function $31bea2dc1a8c2f4b$var$transformValues(values) {
    return values;
}
function $31bea2dc1a8c2f4b$export$b6a3594f6594322(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dea25ad601eb8263$export$70aabb5da7e125f8), {
        extractDefaults: $31bea2dc1a8c2f4b$var$extractDefaults,
        transformValues: $31bea2dc1a8c2f4b$var$transformValues,
        schema: $31bea2dc1a8c2f4b$export$4902baddc787debb,
        nextPath: props.next.path,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31bea2dc1a8c2f4b$var$DoctorInternal, {
            ...props
        })
    });
}
function $31bea2dc1a8c2f4b$var$DoctorInternal(props) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.details');
    const { getValues: getValues } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const [editing, setEditing] = (0, $acw62.useState)(()=>{
        const values = getValues();
        return !(values.gp && values.medicalCentre);
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4777412ac24f8fdf$export$8becf861e7fda17d), {
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "title",
                children: t('doctor.title')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mb-5",
                children: t('doctor.text')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a253e8a9807820d2$export$be5b6c6ac24b4683), {
                show: editing,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31bea2dc1a8c2f4b$var$EditDoctor, {
                    setEditing: setEditing
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a253e8a9807820d2$export$be5b6c6ac24b4683), {
                show: !editing,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31bea2dc1a8c2f4b$var$DoctorDetails, {
                    setEditing: setEditing
                })
            })
        ]
    });
}
function $31bea2dc1a8c2f4b$var$useDoctorSearchAutocompleteInternal(query) {
    const state = (0, $6f7f62dc06b9d67e$export$74f594857fde2404)(query);
    const result = (0, $acw62.useMemo)(()=>{
        const grouped = {};
        for (const item of state.result ?? [])for (const o of item.organisations?.length > 0 ? item.organisations : [
            {
                id: 'unassociated'
            }
        ]){
            if (!Object.hasOwn(grouped, o.id)) grouped[o.id] = {
                id: o.id,
                organisation: o,
                practitioners: []
            };
            grouped[o.id].practitioners.push(item);
        }
        return Object.values(grouped);
    }, [
        state.result
    ]);
    return {
        ...state,
        result: result
    };
}
const $31bea2dc1a8c2f4b$var$useDoctorSearchAutocomplete = (0, $c832edbd16d59312$export$91456bb36b2952c4)($31bea2dc1a8c2f4b$var$useDoctorSearchAutocompleteInternal);
function $31bea2dc1a8c2f4b$var$EditDoctor({ setEditing: setEditing }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.details');
    const searchState = $31bea2dc1a8c2f4b$var$useDoctorSearchAutocomplete();
    const { setValue: setValue } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-5",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c832edbd16d59312$export$2f2b9559550c7bbc), {
                ...searchState.autocompleteProps,
                label: "Search doctor",
                placeholder: t('doctor.searchPlaceholder'),
                name: "doctor-suggestions",
                onSelect: (id)=>{
                    if (id) {
                        const [practitionerId, organisationId] = JSON.parse(id);
                        const { organisation: organisation, practitioners: practitioners } = searchState.result.find((x)=>x.id === organisationId) ?? {};
                        if (organisation) {
                            setValue('medicalCentre', organisation.longDescription, {
                                shouldValidate: true
                            });
                            const practitioner = practitioners.find((x)=>x.id === practitionerId);
                            if (practitioner) setValue('gp', practitioner.nameText, {
                                shouldValidate: true
                            });
                        }
                        setEditing(false);
                        searchState.autocompleteProps.onInputChange('');
                    }
                },
                autoFocus: true,
                children: (item)=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c832edbd16d59312$export$2f2b9559550c7bbc).Section, {
                        id: item.organisation.id,
                        title: item.organisation.longDescription,
                        items: item.practitioners,
                        children: (practitioner)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c832edbd16d59312$export$2f2b9559550c7bbc).Item, {
                                id: JSON.stringify([
                                    practitioner.id,
                                    item.organisation.id
                                ]),
                                textValue: practitioner.nameText,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "before:content-['-'] before:mr-2",
                                    children: practitioner.nameText
                                })
                            })
                    });
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                name: "gp",
                label: t(`doctor.gp`)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                name: "medicalCentre",
                label: t(`doctor.medicalCentre`)
            })
        ]
    });
}
function $31bea2dc1a8c2f4b$var$DoctorDetails({ setEditing: setEditing }) {
    const [gp, medicalCentre] = (0, $0d70f179cf56e662$export$3c773aa2b84f29e0)({
        name: [
            'gp',
            'medicalCentre'
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $33d105d6fe79066e$export$be73d5ff5b7c90a2), {
        onClick: ()=>setEditing(true),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "title-sm font-semibold mb-2.5",
                children: gp
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: medicalCentre
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");







const $5466c574d62e24d0$export$4902baddc787debb = $09193e81812ba154$export$be5493f9613cbbe({
    fullName: $09193e81812ba154$export$22b082955e083ec3().nonempty(),
    relationship: $09193e81812ba154$export$22b082955e083ec3().nonempty(),
    mobileNumber: $09193e81812ba154$export$22b082955e083ec3().trim().regex((0, $e464564ddd12cbba$export$5188c7cace6b4075))
});
function $5466c574d62e24d0$var$extractDefaults({ emergency: emergency }) {
    return {
        fullName: emergency?.fullName ?? '',
        relationship: emergency?.relationship ?? '',
        mobileNumber: emergency?.mobileNumber ?? ''
    };
}
function $5466c574d62e24d0$var$transformValues(values) {
    return {
        emergency: {
            ...values
        }
    };
}
function $5466c574d62e24d0$export$b692444947d69bd1(props) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.details');
    const relationshipOptions = (0, $acw62.useMemo)(()=>[
            {
                id: 'parent',
                label: t('emergency.select.parent')
            },
            {
                id: 'spouse',
                label: t('emergency.select.spouse')
            },
            {
                id: 'child',
                label: t('emergency.select.child')
            },
            {
                id: 'friend',
                label: t('emergency.select.friend')
            },
            {
                id: 'other',
                label: t('emergency.select.other')
            }
        ], [
        t
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dea25ad601eb8263$export$70aabb5da7e125f8), {
        extractDefaults: $5466c574d62e24d0$var$extractDefaults,
        transformValues: $5466c574d62e24d0$var$transformValues,
        schema: $5466c574d62e24d0$export$4902baddc787debb,
        nextPath: props.next.path,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4777412ac24f8fdf$export$8becf861e7fda17d), {
            ...props,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "title",
                    children: t('emergency.title')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "mb-5",
                    children: t('emergency.text')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "space-y-5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                            name: "fullName",
                            label: t(`emergency.fullName`)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4cd9875607f3fe92$export$ef9b1a59e592288f), {
                            name: "relationship",
                            options: relationshipOptions,
                            label: t('emergency.relationship')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                            name: "mobileNumber",
                            type: "tel",
                            label: t(`emergency.mobileNumber`)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "mt-5 italic",
                    children: t('emergency.footnote')
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");






async function $3204d4a02b11889b$var$fetchAddressDetails(abortSignal, id) {
    if (id) {
        const data = await (0, $56ff6b9a4ee43a2e$export$644d8ea042df96a6).auth.get(`address/${id}`, {
            signal: abortSignal
        }).json();
        const building = [];
        for(let i = 1; i <= 3; i++){
            const line = data[`postal_line_${i}`];
            if (!line || line.includes(data.street)) break;
            building.push(line);
        }
        data.building = building.join(', ');
        return data;
    } else return {
        success: false
    };
}
function $3204d4a02b11889b$export$ac0686965540f22d(id, options) {
    return (0, $36464e4be8053fb8$export$a4c3459d1b3dd407)($3204d4a02b11889b$var$fetchAddressDetails, [
        id
    ], options);
}






async function $165b355f06a9fc9a$var$searchAddress(abortSignal, query) {
    query = query.trim();
    if (query) {
        const data = await (0, $56ff6b9a4ee43a2e$export$644d8ea042df96a6).auth.post('address/search', {
            signal: abortSignal,
            json: {
                searchTerm: query,
                maxResults: 20
            }
        }).json();
        return Array.from(data.reduce((acc, { addressId: addressId, formattedAddress: formattedAddress })=>{
            acc.set(addressId, {
                id: addressId,
                label: formattedAddress
            });
            return acc;
        }, new Map()).values());
    }
    return 0, $2bd9d04ce55ef2a0$export$2c66e96878bf4792;
}
const $165b355f06a9fc9a$var$debouncedSearchAddress = (0, $e536fa895fb3af60$export$2e2bcd8739ae039)($165b355f06a9fc9a$var$searchAddress, 1000);
function $165b355f06a9fc9a$export$e42ee5d6155f0576(query) {
    return (0, $36464e4be8053fb8$export$a4c3459d1b3dd407)($165b355f06a9fc9a$var$debouncedSearchAddress, [
        query
    ]);
}









const $1afa35ca37f2466a$export$4902baddc787debb = $09193e81812ba154$export$be5493f9613cbbe({
    id: $09193e81812ba154$export$22b082955e083ec3().optional(),
    building: $09193e81812ba154$export$22b082955e083ec3().optional(),
    street: $09193e81812ba154$export$22b082955e083ec3().nonempty(),
    suburb: $09193e81812ba154$export$22b082955e083ec3().optional(),
    city: $09193e81812ba154$export$22b082955e083ec3().nonempty(),
    postcode: $09193e81812ba154$export$22b082955e083ec3().nonempty()
});
function $1afa35ca37f2466a$var$extractDefaults({ patient: patient }) {
    return {
        id: patient.address?.id ?? '',
        building: patient.address?.building ?? '',
        street: patient.address?.street ?? '',
        suburb: patient.address?.suburb ?? '',
        city: patient.address?.city ?? '',
        postcode: patient.address?.postcode ?? ''
    };
}
function $1afa35ca37f2466a$var$transformValues(values) {
    return {
        patient: {
            address: values
        }
    };
}
function $1afa35ca37f2466a$export$4adf321e56356701(props) {
    const { invite: invite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    const [editing, setEditing] = (0, $acw62.useState)(!invite.onlineBookingData.patient?.address?.id);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dea25ad601eb8263$export$70aabb5da7e125f8), {
        extractDefaults: $1afa35ca37f2466a$var$extractDefaults,
        transformValues: $1afa35ca37f2466a$var$transformValues,
        schema: $1afa35ca37f2466a$export$4902baddc787debb,
        nextPath: props.next.path,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4777412ac24f8fdf$export$8becf861e7fda17d), {
            ...props,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1afa35ca37f2466a$var$Title, {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a253e8a9807820d2$export$be5b6c6ac24b4683), {
                    show: editing,
                    unmount: false,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1afa35ca37f2466a$var$FormFields, {
                        setEditing: setEditing
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a253e8a9807820d2$export$be5b6c6ac24b4683), {
                    show: !editing,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1afa35ca37f2466a$var$AddressDetails, {
                        setEditing: setEditing
                    })
                })
            ]
        })
    });
}
function $1afa35ca37f2466a$var$Title() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.details');
    const id = (0, $0d70f179cf56e662$export$3c773aa2b84f29e0)({
        name: 'id'
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "title",
                children: t('home-address.title')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mb-5",
                children: t(id ? 'home-address.textSecondary' : 'home-address.text')
            })
        ]
    });
}
function $1afa35ca37f2466a$var$AddressDetails({ setEditing: setEditing }) {
    const [building, street, suburb, city, postcode] = (0, $0d70f179cf56e662$export$3c773aa2b84f29e0)({
        name: [
            'building',
            'street',
            'suburb',
            'city',
            'postcode'
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33d105d6fe79066e$export$be73d5ff5b7c90a2), {
        onClick: ()=>setEditing(true),
        className: "title-sm",
        children: street && city ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
            className: "font-sans leading-normal",
            children: `${building ? `${building}, ` : ''}${street}\n${suburb ? `${suburb}, ` : ''}${city} ${postcode}`
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "max-w-full animate-pulse space-y-4 w-full",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "block w-3/4 h-2 bg-gray-300 rounded-full text-inherit",
                    children: "\xa0"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "block w-3/4 h-2 bg-gray-300 rounded-full text-inherit",
                    children: "\xa0"
                })
            ]
        })
    });
}
function $1afa35ca37f2466a$var$useAddressSearchAutocompleteInternal(query) {
    const state = (0, $165b355f06a9fc9a$export$e42ee5d6155f0576)(query);
    const result = (0, $acw62.useMemo)(()=>!!query && !state.loading > 0 ? [
            ...state.result?.map(({ id: id, label: label })=>({
                    id: id,
                    label: label
                })) ?? [],
            {
                id: 'manual',
                label: 'Enter manually',
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    i18nKey: "home-address.manually",
                    ns: "page.details",
                    components: {
                        PrimaryText: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "font-semibold text-primary group-data-[hovered=true]/item:text-white group-data-[focused=true]/item:text-white"
                        })
                    }
                })
            }
        ] : (0, $2bd9d04ce55ef2a0$export$2c66e96878bf4792), [
        query,
        state.loading,
        state.result
    ]);
    return {
        ...state,
        result: result
    };
}
const $1afa35ca37f2466a$var$useAddressSearchAutocomplete = (0, $c832edbd16d59312$export$91456bb36b2952c4)($1afa35ca37f2466a$var$useAddressSearchAutocompleteInternal);
function $1afa35ca37f2466a$var$FormFields({ setEditing: setEditing }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.details');
    const { setValue: setValue, watch: watch } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const id = watch('id');
    const searchState = $1afa35ca37f2466a$var$useAddressSearchAutocomplete();
    const [addressId, setAddressId] = (0, $acw62.useState)(null);
    const addressState = (0, $3204d4a02b11889b$export$ac0686965540f22d)(addressId, {
        onSuccess: ({ success: success, building: building, suburb: suburb, city: city, street: street, number: number, postcode: postcode })=>{
            if (success) {
                setValue('id', addressId, {
                    shouldValidate: true,
                    shouldDirty: true
                });
                setValue('building', building, {
                    shouldValidate: true,
                    shouldDirty: true
                });
                setValue('street', `${number} ${street}`, {
                    shouldValidate: true,
                    shouldDirty: true
                });
                setValue('suburb', suburb, {
                    shouldValidate: true,
                    shouldDirty: true
                });
                setValue('city', city, {
                    shouldValidate: true,
                    shouldDirty: true
                });
                setValue('postcode', String(postcode), {
                    shouldValidate: true,
                    shouldDirty: true
                });
            }
        }
    });
    const disabled = searchState.loading || addressState.loading;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "group space-y-4",
        "data-has-address": !!id,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c832edbd16d59312$export$2f2b9559550c7bbc), {
                ...searchState.autocompleteProps,
                label: "Search address",
                placeholder: t('home-address.searchPlaceholder'),
                name: "address",
                onSelect: (id)=>{
                    if (id) {
                        setValue('id', id, {
                            shouldValidate: true
                        });
                        setValue('street', '', {
                            shouldValidate: true
                        });
                        setValue('suburb', '', {
                            shouldValidate: true
                        });
                        setValue('city', '', {
                            shouldValidate: true
                        });
                        setValue('postcode', '', {
                            shouldValidate: true
                        });
                        if (id === 'manual') {
                            setEditing(true);
                            setAddressId('');
                        } else if (id) {
                            setAddressId(id);
                            setEditing(false);
                        }
                        searchState.autocompleteProps.onInputChange('');
                    }
                },
                autoFocus: true,
                children: ({ label: label, element: element })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c832edbd16d59312$export$2f2b9559550c7bbc).Item, {
                        textValue: label,
                        children: element ?? label
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "group-data-[has-address=false]:hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                    name: "building",
                    label: t('home-address.building'),
                    optional: true,
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "group-data-[has-address=false]:hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                    name: "street",
                    label: t('home-address.street'),
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "group-data-[has-address=false]:hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                    name: "suburb",
                    label: t('home-address.suburb'),
                    optional: true,
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "group-data-[has-address=false]:hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                    name: "city",
                    label: t('home-address.city'),
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "group-data-[has-address=false]:hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                    name: "postcode",
                    label: t('home-address.postcode'),
                    disabled: disabled
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");








/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6029cd325c4477d7$export$842a2cf37af977e1(amount, numerator) {
    return amount - numerator * Math.floor(amount / numerator);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $164d3c47591a715e$var$$3b62074eb05584b2$var$EPOCH = 1721426; // 001/01/03 Julian C.E.
function $164d3c47591a715e$export$f297eb839006d339(era, year, month, day) {
    year = $164d3c47591a715e$export$c36e0ecb2d4fa69d(era, year);
    let y1 = year - 1;
    let monthOffset = -2;
    if (month <= 2) monthOffset = 0;
    else if ($164d3c47591a715e$export$553d7fa8e3805fc0(year)) monthOffset = -1;
    return $164d3c47591a715e$var$$3b62074eb05584b2$var$EPOCH - 1 + 365 * y1 + Math.floor(y1 / 4) - Math.floor(y1 / 100) + Math.floor(y1 / 400) + Math.floor((367 * month - 362) / 12 + monthOffset + day);
}
function $164d3c47591a715e$export$553d7fa8e3805fc0(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $164d3c47591a715e$export$c36e0ecb2d4fa69d(era, year) {
    return era === 'BC' ? 1 - year : year;
}
function $164d3c47591a715e$export$4475b7e617eb123c(year) {
    let era = 'AD';
    if (year <= 0) {
        era = 'BC';
        year = 1 - year;
    }
    return [
        era,
        year
    ];
}
const $164d3c47591a715e$var$$3b62074eb05584b2$var$daysInMonth = {
    standard: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    leapyear: [
        31,
        29,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ]
};
class $164d3c47591a715e$export$80ee6245ec4f29ec {
    fromJulianDay(jd) {
        let jd0 = jd;
        let depoch = jd0 - $164d3c47591a715e$var$$3b62074eb05584b2$var$EPOCH;
        let quadricent = Math.floor(depoch / 146097);
        let dqc = (0, $6029cd325c4477d7$export$842a2cf37af977e1)(depoch, 146097);
        let cent = Math.floor(dqc / 36524);
        let dcent = (0, $6029cd325c4477d7$export$842a2cf37af977e1)(dqc, 36524);
        let quad = Math.floor(dcent / 1461);
        let dquad = (0, $6029cd325c4477d7$export$842a2cf37af977e1)(dcent, 1461);
        let yindex = Math.floor(dquad / 365);
        let extendedYear = quadricent * 400 + cent * 100 + quad * 4 + yindex + (cent !== 4 && yindex !== 4 ? 1 : 0);
        let [era, year] = $164d3c47591a715e$export$4475b7e617eb123c(extendedYear);
        let yearDay = jd0 - $164d3c47591a715e$export$f297eb839006d339(era, year, 1, 1);
        let leapAdj = 2;
        if (jd0 < $164d3c47591a715e$export$f297eb839006d339(era, year, 3, 1)) leapAdj = 0;
        else if ($164d3c47591a715e$export$553d7fa8e3805fc0(year)) leapAdj = 1;
        let month = Math.floor(((yearDay + leapAdj) * 12 + 373) / 367);
        let day = jd0 - $164d3c47591a715e$export$f297eb839006d339(era, year, month, 1) + 1;
        return new (0, $465374ca30ab45d0$export$99faa760c7908e4f)(era, year, month, day);
    }
    toJulianDay(date) {
        return $164d3c47591a715e$export$f297eb839006d339(date.era, date.year, date.month, date.day);
    }
    getDaysInMonth(date) {
        return $164d3c47591a715e$var$$3b62074eb05584b2$var$daysInMonth[$164d3c47591a715e$export$553d7fa8e3805fc0(date.year) ? 'leapyear' : 'standard'][date.month - 1];
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getMonthsInYear(date) {
        return 12;
    }
    getDaysInYear(date) {
        return $164d3c47591a715e$export$553d7fa8e3805fc0(date.year) ? 366 : 365;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getYearsInEra(date) {
        return 9999;
    }
    getEras() {
        return [
            'BC',
            'AD'
        ];
    }
    isInverseEra(date) {
        return date.era === 'BC';
    }
    balanceDate(date) {
        if (date.year <= 0) {
            date.era = date.era === 'BC' ? 'AD' : 'BC';
            date.year = 1 - date.year;
        }
    }
    constructor(){
        this.identifier = 'gregory';
    }
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Data from https://github.com/unicode-cldr/cldr-core/blob/master/supplemental/weekData.json
// Locales starting on Sunday have been removed for compression.
const $33788255c78d08d4$export$7a5acbd77d414bd9 = {
    '001': 1,
    AD: 1,
    AE: 6,
    AF: 6,
    AI: 1,
    AL: 1,
    AM: 1,
    AN: 1,
    AR: 1,
    AT: 1,
    AU: 1,
    AX: 1,
    AZ: 1,
    BA: 1,
    BE: 1,
    BG: 1,
    BH: 6,
    BM: 1,
    BN: 1,
    BY: 1,
    CH: 1,
    CL: 1,
    CM: 1,
    CN: 1,
    CR: 1,
    CY: 1,
    CZ: 1,
    DE: 1,
    DJ: 6,
    DK: 1,
    DZ: 6,
    EC: 1,
    EE: 1,
    EG: 6,
    ES: 1,
    FI: 1,
    FJ: 1,
    FO: 1,
    FR: 1,
    GB: 1,
    GE: 1,
    GF: 1,
    GP: 1,
    GR: 1,
    HR: 1,
    HU: 1,
    IE: 1,
    IQ: 6,
    IR: 6,
    IS: 1,
    IT: 1,
    JO: 6,
    KG: 1,
    KW: 6,
    KZ: 1,
    LB: 1,
    LI: 1,
    LK: 1,
    LT: 1,
    LU: 1,
    LV: 1,
    LY: 6,
    MC: 1,
    MD: 1,
    ME: 1,
    MK: 1,
    MN: 1,
    MQ: 1,
    MV: 5,
    MY: 1,
    NL: 1,
    NO: 1,
    NZ: 1,
    OM: 6,
    PL: 1,
    QA: 6,
    RE: 1,
    RO: 1,
    RS: 1,
    RU: 1,
    SD: 6,
    SE: 1,
    SI: 1,
    SK: 1,
    SM: 1,
    SY: 6,
    TJ: 1,
    TM: 1,
    TR: 1,
    UA: 1,
    UY: 1,
    UZ: 1,
    VA: 1,
    VN: 1,
    XK: 1
};


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $45b01a5678208999$export$ea39ec197993aef0(a, b) {
    b = (0, $24197fe0fbca7789$export$b4a036af3fc0b032)(b, a.calendar);
    return a.era === b.era && a.year === b.year && a.month === b.month && a.day === b.day;
}
function $45b01a5678208999$export$a18c89cbd24170ff(a, b) {
    b = (0, $24197fe0fbca7789$export$b4a036af3fc0b032)(b, a.calendar);
    // In the Japanese calendar, months can span multiple eras/years, so only compare the first of the month.
    a = $45b01a5678208999$export$a5a3b454ada2268e(a);
    b = $45b01a5678208999$export$a5a3b454ada2268e(b);
    return a.era === b.era && a.year === b.year && a.month === b.month;
}
function $45b01a5678208999$export$5841f9eb9773f25f(a, b) {
    b = (0, $24197fe0fbca7789$export$b4a036af3fc0b032)(b, a.calendar);
    a = $45b01a5678208999$export$f91e89d3d0406102(a);
    b = $45b01a5678208999$export$f91e89d3d0406102(b);
    return a.era === b.era && a.year === b.year;
}
function $45b01a5678208999$export$91b62ebf2ba703ee(a, b) {
    return $45b01a5678208999$export$dbc69fd56b53d5e(a.calendar, b.calendar) && $45b01a5678208999$export$ea39ec197993aef0(a, b);
}
function $45b01a5678208999$export$5a8da0c44a3afdf2(a, b) {
    return $45b01a5678208999$export$dbc69fd56b53d5e(a.calendar, b.calendar) && $45b01a5678208999$export$a18c89cbd24170ff(a, b);
}
function $45b01a5678208999$export$ea840f5a6dda8147(a, b) {
    return $45b01a5678208999$export$dbc69fd56b53d5e(a.calendar, b.calendar) && $45b01a5678208999$export$5841f9eb9773f25f(a, b);
}
function $45b01a5678208999$export$dbc69fd56b53d5e(a, b) {
    var _a_isEqual, _b_isEqual;
    var _a_isEqual1, _ref;
    return (_ref = (_a_isEqual1 = (_a_isEqual = a.isEqual) === null || _a_isEqual === void 0 ? void 0 : _a_isEqual.call(a, b)) !== null && _a_isEqual1 !== void 0 ? _a_isEqual1 : (_b_isEqual = b.isEqual) === null || _b_isEqual === void 0 ? void 0 : _b_isEqual.call(b, a)) !== null && _ref !== void 0 ? _ref : a.identifier === b.identifier;
}
function $45b01a5678208999$export$629b0a497aa65267(date, timeZone) {
    return $45b01a5678208999$export$ea39ec197993aef0(date, $45b01a5678208999$export$d0bdf45af03a6ea3(timeZone));
}
const $45b01a5678208999$var$$14e0f24ef4ac5c92$var$DAY_MAP = {
    sun: 0,
    mon: 1,
    tue: 2,
    wed: 3,
    thu: 4,
    fri: 5,
    sat: 6
};
function $45b01a5678208999$export$2061056d06d7cdf7(date, locale, firstDayOfWeek) {
    let julian = date.calendar.toJulianDay(date);
    // If julian is negative, then julian % 7 will be negative, so we adjust
    // accordingly.  Julian day 0 is Monday.
    let weekStart = firstDayOfWeek ? $45b01a5678208999$var$$14e0f24ef4ac5c92$var$DAY_MAP[firstDayOfWeek] : $45b01a5678208999$var$$14e0f24ef4ac5c92$var$getWeekStart(locale);
    let dayOfWeek = Math.ceil(julian + 1 - weekStart) % 7;
    if (dayOfWeek < 0) dayOfWeek += 7;
    return dayOfWeek;
}
function $45b01a5678208999$export$461939dd4422153(timeZone) {
    return (0, $24197fe0fbca7789$export$1b96692a1ba042ac)(Date.now(), timeZone);
}
function $45b01a5678208999$export$d0bdf45af03a6ea3(timeZone) {
    return (0, $24197fe0fbca7789$export$93522d1a439f3617)($45b01a5678208999$export$461939dd4422153(timeZone));
}
function $45b01a5678208999$export$68781ddf31c0090f(a, b) {
    return a.calendar.toJulianDay(a) - b.calendar.toJulianDay(b);
}
function $45b01a5678208999$export$c19a80a9721b80f6(a, b) {
    return $45b01a5678208999$var$$14e0f24ef4ac5c92$var$timeToMs(a) - $45b01a5678208999$var$$14e0f24ef4ac5c92$var$timeToMs(b);
}
function $45b01a5678208999$var$$14e0f24ef4ac5c92$var$timeToMs(a) {
    return a.hour * 3600000 + a.minute * 60000 + a.second * 1000 + a.millisecond;
}
function $45b01a5678208999$export$126c91c941de7e(a, timeZone) {
    let ms = (0, $24197fe0fbca7789$export$5107c82f94518f5c)(a, timeZone);
    let tomorrow = a.add({
        days: 1
    });
    let tomorrowMs = (0, $24197fe0fbca7789$export$5107c82f94518f5c)(tomorrow, timeZone);
    return (tomorrowMs - ms) / 3600000;
}
let $45b01a5678208999$var$$14e0f24ef4ac5c92$var$localTimeZone = null;
function $45b01a5678208999$export$aa8b41735afcabd2() {
    if ($45b01a5678208999$var$$14e0f24ef4ac5c92$var$localTimeZone == null) $45b01a5678208999$var$$14e0f24ef4ac5c92$var$localTimeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
    return $45b01a5678208999$var$$14e0f24ef4ac5c92$var$localTimeZone;
}
function $45b01a5678208999$export$61a9d83ceb59a3dd(timeZone) {
    $45b01a5678208999$var$$14e0f24ef4ac5c92$var$localTimeZone = timeZone;
}
function $45b01a5678208999$export$55753838ffe79333() {
    $45b01a5678208999$var$$14e0f24ef4ac5c92$var$localTimeZone = null;
}
function $45b01a5678208999$export$a5a3b454ada2268e(date) {
    // Use `subtract` instead of `set` so we don't get constrained in an era.
    return date.subtract({
        days: date.day - 1
    });
}
function $45b01a5678208999$export$a2258d9c4118825c(date) {
    return date.add({
        days: date.calendar.getDaysInMonth(date) - date.day
    });
}
function $45b01a5678208999$export$f91e89d3d0406102(date) {
    return $45b01a5678208999$export$a5a3b454ada2268e(date.subtract({
        months: date.month - 1
    }));
}
function $45b01a5678208999$export$8b7aa55c66d5569e(date) {
    return $45b01a5678208999$export$a2258d9c4118825c(date.add({
        months: date.calendar.getMonthsInYear(date) - date.month
    }));
}
function $45b01a5678208999$export$5412ac11713b72ad(date) {
    if (date.calendar.getMinimumMonthInYear) return date.calendar.getMinimumMonthInYear(date);
    return 1;
}
function $45b01a5678208999$export$b2f4953d301981d5(date) {
    if (date.calendar.getMinimumDayInMonth) return date.calendar.getMinimumDayInMonth(date);
    return 1;
}
function $45b01a5678208999$export$42c81a444fbfb5d4(date, locale, firstDayOfWeek) {
    let dayOfWeek = $45b01a5678208999$export$2061056d06d7cdf7(date, locale, firstDayOfWeek);
    return date.subtract({
        days: dayOfWeek
    });
}
function $45b01a5678208999$export$ef8b6d9133084f4e(date, locale, firstDayOfWeek) {
    return $45b01a5678208999$export$42c81a444fbfb5d4(date, locale, firstDayOfWeek).add({
        days: 6
    });
}
const $45b01a5678208999$var$$14e0f24ef4ac5c92$var$cachedRegions = new Map();
const $45b01a5678208999$var$$14e0f24ef4ac5c92$var$cachedWeekInfo = new Map();
function $45b01a5678208999$var$$14e0f24ef4ac5c92$var$getRegion(locale) {
    // If the Intl.Locale API is available, use it to get the region for the locale.
    // @ts-ignore
    if (Intl.Locale) {
        // Constructing an Intl.Locale is expensive, so cache the result.
        let region = $45b01a5678208999$var$$14e0f24ef4ac5c92$var$cachedRegions.get(locale);
        if (!region) {
            // @ts-ignore
            region = new Intl.Locale(locale).maximize().region;
            if (region) $45b01a5678208999$var$$14e0f24ef4ac5c92$var$cachedRegions.set(locale, region);
        }
        return region;
    }
    // If not, just try splitting the string.
    // If the second part of the locale string is 'u',
    // then this is a unicode extension, so ignore it.
    // Otherwise, it should be the region.
    let part = locale.split('-')[1];
    return part === 'u' ? undefined : part;
}
function $45b01a5678208999$var$$14e0f24ef4ac5c92$var$getWeekStart(locale) {
    // TODO: use Intl.Locale for this once browsers support the weekInfo property
    // https://github.com/tc39/proposal-intl-locale-info
    let weekInfo = $45b01a5678208999$var$$14e0f24ef4ac5c92$var$cachedWeekInfo.get(locale);
    if (!weekInfo) {
        if (Intl.Locale) {
            // @ts-ignore
            let localeInst = new Intl.Locale(locale);
            if ('getWeekInfo' in localeInst) {
                // @ts-expect-error
                weekInfo = localeInst.getWeekInfo();
                if (weekInfo) {
                    $45b01a5678208999$var$$14e0f24ef4ac5c92$var$cachedWeekInfo.set(locale, weekInfo);
                    return weekInfo.firstDay;
                }
            }
        }
        let region = $45b01a5678208999$var$$14e0f24ef4ac5c92$var$getRegion(locale);
        if (locale.includes('-fw-')) {
            // pull the value for the attribute fw from strings such as en-US-u-ca-iso8601-fw-tue or en-US-u-ca-iso8601-fw-mon-nu-thai
            // where the fw attribute could be followed by another unicode locale extension or not
            let day = locale.split('-fw-')[1].split('-')[0];
            if (day === 'mon') weekInfo = {
                firstDay: 1
            };
            else if (day === 'tue') weekInfo = {
                firstDay: 2
            };
            else if (day === 'wed') weekInfo = {
                firstDay: 3
            };
            else if (day === 'thu') weekInfo = {
                firstDay: 4
            };
            else if (day === 'fri') weekInfo = {
                firstDay: 5
            };
            else if (day === 'sat') weekInfo = {
                firstDay: 6
            };
            else weekInfo = {
                firstDay: 0
            };
        } else if (locale.includes('-ca-iso8601')) weekInfo = {
            firstDay: 1
        };
        else weekInfo = {
            firstDay: region ? (0, $33788255c78d08d4$export$7a5acbd77d414bd9)[region] || 0 : 0
        };
        $45b01a5678208999$var$$14e0f24ef4ac5c92$var$cachedWeekInfo.set(locale, weekInfo);
    }
    return weekInfo.firstDay;
}
function $45b01a5678208999$export$ccc1b2479e7dd654(date, locale, firstDayOfWeek) {
    let days = date.calendar.getDaysInMonth(date);
    return Math.ceil(($45b01a5678208999$export$2061056d06d7cdf7($45b01a5678208999$export$a5a3b454ada2268e(date), locale, firstDayOfWeek) + days) / 7);
}
function $45b01a5678208999$export$5c333a116e949cdd(a, b) {
    if (a && b) return a.compare(b) <= 0 ? a : b;
    return a || b;
}
function $45b01a5678208999$export$a75f2bff57811055(a, b) {
    if (a && b) return a.compare(b) >= 0 ? a : b;
    return a || b;
}
const $45b01a5678208999$var$$14e0f24ef4ac5c92$var$WEEKEND_DATA = {
    AF: [
        4,
        5
    ],
    AE: [
        5,
        6
    ],
    BH: [
        5,
        6
    ],
    DZ: [
        5,
        6
    ],
    EG: [
        5,
        6
    ],
    IL: [
        5,
        6
    ],
    IQ: [
        5,
        6
    ],
    IR: [
        5,
        5
    ],
    JO: [
        5,
        6
    ],
    KW: [
        5,
        6
    ],
    LY: [
        5,
        6
    ],
    OM: [
        5,
        6
    ],
    QA: [
        5,
        6
    ],
    SA: [
        5,
        6
    ],
    SD: [
        5,
        6
    ],
    SY: [
        5,
        6
    ],
    YE: [
        5,
        6
    ]
};
function $45b01a5678208999$export$618d60ea299da42(date, locale) {
    let julian = date.calendar.toJulianDay(date);
    // If julian is negative, then julian % 7 will be negative, so we adjust
    // accordingly.  Julian day 0 is Monday.
    let dayOfWeek = Math.ceil(julian + 1) % 7;
    if (dayOfWeek < 0) dayOfWeek += 7;
    let region = $45b01a5678208999$var$$14e0f24ef4ac5c92$var$getRegion(locale);
    // Use Intl.Locale for this once weekInfo is supported.
    // https://github.com/tc39/proposal-intl-locale-info
    let [start, end] = $45b01a5678208999$var$$14e0f24ef4ac5c92$var$WEEKEND_DATA[region] || [
        6,
        0
    ];
    return dayOfWeek === start || dayOfWeek === end;
}
function $45b01a5678208999$export$ee9d87258e1d19ed(date, locale) {
    return !$45b01a5678208999$export$618d60ea299da42(date, locale);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from the TC39 Temporal proposal.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
function $24197fe0fbca7789$export$bd4fb2bc8bb06fb(date) {
    date = $24197fe0fbca7789$export$b4a036af3fc0b032(date, new (0, $164d3c47591a715e$export$80ee6245ec4f29ec)());
    let year = (0, $164d3c47591a715e$export$c36e0ecb2d4fa69d)(date.era, date.year);
    return $24197fe0fbca7789$var$$11d87f3f76e88657$var$epochFromParts(year, date.month, date.day, date.hour, date.minute, date.second, date.millisecond);
}
function $24197fe0fbca7789$var$$11d87f3f76e88657$var$epochFromParts(year, month, day, hour, minute, second, millisecond) {
    // Note: Date.UTC() interprets one and two-digit years as being in the
    // 20th century, so don't use it
    let date = new Date();
    date.setUTCHours(hour, minute, second, millisecond);
    date.setUTCFullYear(year, month - 1, day);
    return date.getTime();
}
function $24197fe0fbca7789$export$59c99f3515d3493f(ms, timeZone) {
    // Fast path for UTC.
    if (timeZone === 'UTC') return 0;
    // Fast path: for local timezone after 1970, use native Date.
    if (ms > 0 && timeZone === (0, $45b01a5678208999$export$aa8b41735afcabd2)()) return new Date(ms).getTimezoneOffset() * -60000;
    let { year: year, month: month, day: day, hour: hour, minute: minute, second: second } = $24197fe0fbca7789$var$$11d87f3f76e88657$var$getTimeZoneParts(ms, timeZone);
    let utc = $24197fe0fbca7789$var$$11d87f3f76e88657$var$epochFromParts(year, month, day, hour, minute, second, 0);
    return utc - Math.floor(ms / 1000) * 1000;
}
const $24197fe0fbca7789$var$$11d87f3f76e88657$var$formattersByTimeZone = new Map();
function $24197fe0fbca7789$var$$11d87f3f76e88657$var$getTimeZoneParts(ms, timeZone) {
    let formatter = $24197fe0fbca7789$var$$11d87f3f76e88657$var$formattersByTimeZone.get(timeZone);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone,
            hour12: false,
            era: 'short',
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric'
        });
        $24197fe0fbca7789$var$$11d87f3f76e88657$var$formattersByTimeZone.set(timeZone, formatter);
    }
    let parts = formatter.formatToParts(new Date(ms));
    let namedParts = {};
    for (let part of parts)if (part.type !== 'literal') namedParts[part.type] = part.value;
    return {
        // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
        year: namedParts.era === 'BC' || namedParts.era === 'B' ? -namedParts.year + 1 : +namedParts.year,
        month: +namedParts.month,
        day: +namedParts.day,
        hour: namedParts.hour === '24' ? 0 : +namedParts.hour,
        minute: +namedParts.minute,
        second: +namedParts.second
    };
}
const $24197fe0fbca7789$var$$11d87f3f76e88657$var$DAYMILLIS = 86400000;
function $24197fe0fbca7789$export$136f38efe7caf549(date, timeZone) {
    let ms = $24197fe0fbca7789$export$bd4fb2bc8bb06fb(date);
    let earlier = ms - $24197fe0fbca7789$export$59c99f3515d3493f(ms - $24197fe0fbca7789$var$$11d87f3f76e88657$var$DAYMILLIS, timeZone);
    let later = ms - $24197fe0fbca7789$export$59c99f3515d3493f(ms + $24197fe0fbca7789$var$$11d87f3f76e88657$var$DAYMILLIS, timeZone);
    return $24197fe0fbca7789$var$$11d87f3f76e88657$var$getValidWallTimes(date, timeZone, earlier, later);
}
function $24197fe0fbca7789$var$$11d87f3f76e88657$var$getValidWallTimes(date, timeZone, earlier, later) {
    let found = earlier === later ? [
        earlier
    ] : [
        earlier,
        later
    ];
    return found.filter((absolute)=>$24197fe0fbca7789$var$$11d87f3f76e88657$var$isValidWallTime(date, timeZone, absolute));
}
function $24197fe0fbca7789$var$$11d87f3f76e88657$var$isValidWallTime(date, timeZone, absolute) {
    let parts = $24197fe0fbca7789$var$$11d87f3f76e88657$var$getTimeZoneParts(absolute, timeZone);
    return date.year === parts.year && date.month === parts.month && date.day === parts.day && date.hour === parts.hour && date.minute === parts.minute && date.second === parts.second;
}
function $24197fe0fbca7789$export$5107c82f94518f5c(date, timeZone, disambiguation = 'compatible') {
    let dateTime = $24197fe0fbca7789$export$b21e0b124e224484(date);
    // Fast path: if the time zone is UTC, use native Date.
    if (timeZone === 'UTC') return $24197fe0fbca7789$export$bd4fb2bc8bb06fb(dateTime);
    // Fast path: if the time zone is the local timezone and disambiguation is compatible, use native Date.
    if (timeZone === (0, $45b01a5678208999$export$aa8b41735afcabd2)() && disambiguation === 'compatible') {
        dateTime = $24197fe0fbca7789$export$b4a036af3fc0b032(dateTime, new (0, $164d3c47591a715e$export$80ee6245ec4f29ec)());
        // Don't use Date constructor here because two-digit years are interpreted in the 20th century.
        let date = new Date();
        let year = (0, $164d3c47591a715e$export$c36e0ecb2d4fa69d)(dateTime.era, dateTime.year);
        date.setFullYear(year, dateTime.month - 1, dateTime.day);
        date.setHours(dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);
        return date.getTime();
    }
    let ms = $24197fe0fbca7789$export$bd4fb2bc8bb06fb(dateTime);
    let offsetBefore = $24197fe0fbca7789$export$59c99f3515d3493f(ms - $24197fe0fbca7789$var$$11d87f3f76e88657$var$DAYMILLIS, timeZone);
    let offsetAfter = $24197fe0fbca7789$export$59c99f3515d3493f(ms + $24197fe0fbca7789$var$$11d87f3f76e88657$var$DAYMILLIS, timeZone);
    let valid = $24197fe0fbca7789$var$$11d87f3f76e88657$var$getValidWallTimes(dateTime, timeZone, ms - offsetBefore, ms - offsetAfter);
    if (valid.length === 1) return valid[0];
    if (valid.length > 1) switch(disambiguation){
        // 'compatible' means 'earlier' for "fall back" transitions
        case 'compatible':
        case 'earlier':
            return valid[0];
        case 'later':
            return valid[valid.length - 1];
        case 'reject':
            throw new RangeError('Multiple possible absolute times found');
    }
    switch(disambiguation){
        case 'earlier':
            return Math.min(ms - offsetBefore, ms - offsetAfter);
        // 'compatible' means 'later' for "spring forward" transitions
        case 'compatible':
        case 'later':
            return Math.max(ms - offsetBefore, ms - offsetAfter);
        case 'reject':
            throw new RangeError('No such absolute time found');
    }
}
function $24197fe0fbca7789$export$e67a095c620b86fe(dateTime, timeZone, disambiguation = 'compatible') {
    return new Date($24197fe0fbca7789$export$5107c82f94518f5c(dateTime, timeZone, disambiguation));
}
function $24197fe0fbca7789$export$1b96692a1ba042ac(ms, timeZone) {
    let offset = $24197fe0fbca7789$export$59c99f3515d3493f(ms, timeZone);
    let date = new Date(ms + offset);
    let year = date.getUTCFullYear();
    let month = date.getUTCMonth() + 1;
    let day = date.getUTCDate();
    let hour = date.getUTCHours();
    let minute = date.getUTCMinutes();
    let second = date.getUTCSeconds();
    let millisecond = date.getUTCMilliseconds();
    return new (0, $465374ca30ab45d0$export$d3b7288e7994edea)(year < 1 ? 'BC' : 'AD', year < 1 ? -year + 1 : year, month, day, timeZone, offset, hour, minute, second, millisecond);
}
function $24197fe0fbca7789$export$e57ff100d91bd4b9(date, timeZone) {
    return $24197fe0fbca7789$export$1b96692a1ba042ac(date.getTime(), timeZone);
}
function $24197fe0fbca7789$export$d7f92bcd3596b086(date) {
    return $24197fe0fbca7789$export$e57ff100d91bd4b9(date, (0, $45b01a5678208999$export$aa8b41735afcabd2)());
}
function $24197fe0fbca7789$export$93522d1a439f3617(dateTime) {
    return new (0, $465374ca30ab45d0$export$99faa760c7908e4f)(dateTime.calendar, dateTime.era, dateTime.year, dateTime.month, dateTime.day);
}
function $24197fe0fbca7789$export$6f4d78149f3f53ac(date) {
    return {
        era: date.era,
        year: date.year,
        month: date.month,
        day: date.day
    };
}
function $24197fe0fbca7789$export$4d0393e732857be5(date) {
    return {
        hour: date.hour,
        minute: date.minute,
        second: date.second,
        millisecond: date.millisecond
    };
}
function $24197fe0fbca7789$export$b21e0b124e224484(date, time) {
    let hour = 0, minute = 0, second = 0, millisecond = 0;
    if ('timeZone' in date) ({ hour: hour, minute: minute, second: second, millisecond: millisecond } = date);
    else if ('hour' in date && !time) return date;
    if (time) ({ hour: hour, minute: minute, second: second, millisecond: millisecond } = time);
    return new (0, $465374ca30ab45d0$export$ca871e8dbb80966f)(date.calendar, date.era, date.year, date.month, date.day, hour, minute, second, millisecond);
}
function $24197fe0fbca7789$export$d33f79e3ffc3dc83(dateTime) {
    return new (0, $465374ca30ab45d0$export$680ea196effce5f)(dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);
}
function $24197fe0fbca7789$export$b4a036af3fc0b032(date, calendar) {
    if ((0, $45b01a5678208999$export$dbc69fd56b53d5e)(date.calendar, calendar)) return date;
    let calendarDate = calendar.fromJulianDay(date.calendar.toJulianDay(date));
    let copy = date.copy();
    copy.calendar = calendar;
    copy.era = calendarDate.era;
    copy.year = calendarDate.year;
    copy.month = calendarDate.month;
    copy.day = calendarDate.day;
    (0, $300478f3cc6d5523$export$c4e2ecac49351ef2)(copy);
    return copy;
}
function $24197fe0fbca7789$export$84c95a83c799e074(date, timeZone, disambiguation) {
    if (date instanceof (0, $465374ca30ab45d0$export$d3b7288e7994edea)) {
        if (date.timeZone === timeZone) return date;
        return $24197fe0fbca7789$export$538b00033cc11c75(date, timeZone);
    }
    let ms = $24197fe0fbca7789$export$5107c82f94518f5c(date, timeZone, disambiguation);
    return $24197fe0fbca7789$export$1b96692a1ba042ac(ms, timeZone);
}
function $24197fe0fbca7789$export$83aac07b4c37b25(date) {
    let ms = $24197fe0fbca7789$export$bd4fb2bc8bb06fb(date) - date.offset;
    return new Date(ms);
}
function $24197fe0fbca7789$export$538b00033cc11c75(date, timeZone) {
    let ms = $24197fe0fbca7789$export$bd4fb2bc8bb06fb(date) - date.offset;
    return $24197fe0fbca7789$export$b4a036af3fc0b032($24197fe0fbca7789$export$1b96692a1ba042ac(ms, timeZone), date.calendar);
}
function $24197fe0fbca7789$export$d9b67bc93c097491(date) {
    return $24197fe0fbca7789$export$538b00033cc11c75(date, (0, $45b01a5678208999$export$aa8b41735afcabd2)());
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $300478f3cc6d5523$var$$735220c2d4774dd3$var$ONE_HOUR = 3600000;
function $300478f3cc6d5523$export$e16d8520af44a096(date, duration) {
    let mutableDate = date.copy();
    let days = 'hour' in mutableDate ? $300478f3cc6d5523$var$$735220c2d4774dd3$var$addTimeFields(mutableDate, duration) : 0;
    $300478f3cc6d5523$var$$735220c2d4774dd3$var$addYears(mutableDate, duration.years || 0);
    if (mutableDate.calendar.balanceYearMonth) mutableDate.calendar.balanceYearMonth(mutableDate, date);
    mutableDate.month += duration.months || 0;
    $300478f3cc6d5523$var$$735220c2d4774dd3$var$balanceYearMonth(mutableDate);
    $300478f3cc6d5523$var$$735220c2d4774dd3$var$constrainMonthDay(mutableDate);
    mutableDate.day += (duration.weeks || 0) * 7;
    mutableDate.day += duration.days || 0;
    mutableDate.day += days;
    $300478f3cc6d5523$var$$735220c2d4774dd3$var$balanceDay(mutableDate);
    if (mutableDate.calendar.balanceDate) mutableDate.calendar.balanceDate(mutableDate);
    // Constrain in case adding ended up with a date outside the valid range for the calendar system.
    // The behavior here is slightly different than when constraining in the `set` function in that
    // we adjust smaller fields to their minimum/maximum values rather than constraining each field
    // individually. This matches the general behavior of `add` vs `set` regarding how fields are balanced.
    if (mutableDate.year < 1) {
        mutableDate.year = 1;
        mutableDate.month = 1;
        mutableDate.day = 1;
    }
    let maxYear = mutableDate.calendar.getYearsInEra(mutableDate);
    if (mutableDate.year > maxYear) {
        var _mutableDate_calendar_isInverseEra, _mutableDate_calendar;
        let isInverseEra = (_mutableDate_calendar_isInverseEra = (_mutableDate_calendar = mutableDate.calendar).isInverseEra) === null || _mutableDate_calendar_isInverseEra === void 0 ? void 0 : _mutableDate_calendar_isInverseEra.call(_mutableDate_calendar, mutableDate);
        mutableDate.year = maxYear;
        mutableDate.month = isInverseEra ? 1 : mutableDate.calendar.getMonthsInYear(mutableDate);
        mutableDate.day = isInverseEra ? 1 : mutableDate.calendar.getDaysInMonth(mutableDate);
    }
    if (mutableDate.month < 1) {
        mutableDate.month = 1;
        mutableDate.day = 1;
    }
    let maxMonth = mutableDate.calendar.getMonthsInYear(mutableDate);
    if (mutableDate.month > maxMonth) {
        mutableDate.month = maxMonth;
        mutableDate.day = mutableDate.calendar.getDaysInMonth(mutableDate);
    }
    mutableDate.day = Math.max(1, Math.min(mutableDate.calendar.getDaysInMonth(mutableDate), mutableDate.day));
    return mutableDate;
}
function $300478f3cc6d5523$var$$735220c2d4774dd3$var$addYears(date, years) {
    var _date_calendar_isInverseEra, _date_calendar;
    if ((_date_calendar_isInverseEra = (_date_calendar = date.calendar).isInverseEra) === null || _date_calendar_isInverseEra === void 0 ? void 0 : _date_calendar_isInverseEra.call(_date_calendar, date)) years = -years;
    date.year += years;
}
function $300478f3cc6d5523$var$$735220c2d4774dd3$var$balanceYearMonth(date) {
    while(date.month < 1){
        $300478f3cc6d5523$var$$735220c2d4774dd3$var$addYears(date, -1);
        date.month += date.calendar.getMonthsInYear(date);
    }
    let monthsInYear = 0;
    while(date.month > (monthsInYear = date.calendar.getMonthsInYear(date))){
        date.month -= monthsInYear;
        $300478f3cc6d5523$var$$735220c2d4774dd3$var$addYears(date, 1);
    }
}
function $300478f3cc6d5523$var$$735220c2d4774dd3$var$balanceDay(date) {
    while(date.day < 1){
        date.month--;
        $300478f3cc6d5523$var$$735220c2d4774dd3$var$balanceYearMonth(date);
        date.day += date.calendar.getDaysInMonth(date);
    }
    while(date.day > date.calendar.getDaysInMonth(date)){
        date.day -= date.calendar.getDaysInMonth(date);
        date.month++;
        $300478f3cc6d5523$var$$735220c2d4774dd3$var$balanceYearMonth(date);
    }
}
function $300478f3cc6d5523$var$$735220c2d4774dd3$var$constrainMonthDay(date) {
    date.month = Math.max(1, Math.min(date.calendar.getMonthsInYear(date), date.month));
    date.day = Math.max(1, Math.min(date.calendar.getDaysInMonth(date), date.day));
}
function $300478f3cc6d5523$export$c4e2ecac49351ef2(date) {
    if (date.calendar.constrainDate) date.calendar.constrainDate(date);
    date.year = Math.max(1, Math.min(date.calendar.getYearsInEra(date), date.year));
    $300478f3cc6d5523$var$$735220c2d4774dd3$var$constrainMonthDay(date);
}
function $300478f3cc6d5523$export$3e2544e88a25bff8(duration) {
    let inverseDuration = {};
    for(let key in duration)if (typeof duration[key] === 'number') inverseDuration[key] = -duration[key];
    return inverseDuration;
}
function $300478f3cc6d5523$export$4e2d2ead65e5f7e3(date, duration) {
    return $300478f3cc6d5523$export$e16d8520af44a096(date, $300478f3cc6d5523$export$3e2544e88a25bff8(duration));
}
function $300478f3cc6d5523$export$adaa4cf7ef1b65be(date, fields) {
    let mutableDate = date.copy();
    if (fields.era != null) mutableDate.era = fields.era;
    if (fields.year != null) mutableDate.year = fields.year;
    if (fields.month != null) mutableDate.month = fields.month;
    if (fields.day != null) mutableDate.day = fields.day;
    $300478f3cc6d5523$export$c4e2ecac49351ef2(mutableDate);
    return mutableDate;
}
function $300478f3cc6d5523$export$e5d5e1c1822b6e56(value, fields) {
    let mutableValue = value.copy();
    if (fields.hour != null) mutableValue.hour = fields.hour;
    if (fields.minute != null) mutableValue.minute = fields.minute;
    if (fields.second != null) mutableValue.second = fields.second;
    if (fields.millisecond != null) mutableValue.millisecond = fields.millisecond;
    $300478f3cc6d5523$export$7555de1e070510cb(mutableValue);
    return mutableValue;
}
function $300478f3cc6d5523$var$$735220c2d4774dd3$var$balanceTime(time) {
    time.second += Math.floor(time.millisecond / 1000);
    time.millisecond = $300478f3cc6d5523$var$$735220c2d4774dd3$var$nonNegativeMod(time.millisecond, 1000);
    time.minute += Math.floor(time.second / 60);
    time.second = $300478f3cc6d5523$var$$735220c2d4774dd3$var$nonNegativeMod(time.second, 60);
    time.hour += Math.floor(time.minute / 60);
    time.minute = $300478f3cc6d5523$var$$735220c2d4774dd3$var$nonNegativeMod(time.minute, 60);
    let days = Math.floor(time.hour / 24);
    time.hour = $300478f3cc6d5523$var$$735220c2d4774dd3$var$nonNegativeMod(time.hour, 24);
    return days;
}
function $300478f3cc6d5523$export$7555de1e070510cb(time) {
    time.millisecond = Math.max(0, Math.min(time.millisecond, 1000));
    time.second = Math.max(0, Math.min(time.second, 59));
    time.minute = Math.max(0, Math.min(time.minute, 59));
    time.hour = Math.max(0, Math.min(time.hour, 23));
}
function $300478f3cc6d5523$var$$735220c2d4774dd3$var$nonNegativeMod(a, b) {
    let result = a % b;
    if (result < 0) result += b;
    return result;
}
function $300478f3cc6d5523$var$$735220c2d4774dd3$var$addTimeFields(time, duration) {
    time.hour += duration.hours || 0;
    time.minute += duration.minutes || 0;
    time.second += duration.seconds || 0;
    time.millisecond += duration.milliseconds || 0;
    return $300478f3cc6d5523$var$$735220c2d4774dd3$var$balanceTime(time);
}
function $300478f3cc6d5523$export$7ed87b6bc2506470(time, duration) {
    let res = time.copy();
    $300478f3cc6d5523$var$$735220c2d4774dd3$var$addTimeFields(res, duration);
    return res;
}
function $300478f3cc6d5523$export$fe34d3a381cd7501(time, duration) {
    return $300478f3cc6d5523$export$7ed87b6bc2506470(time, $300478f3cc6d5523$export$3e2544e88a25bff8(duration));
}
function $300478f3cc6d5523$export$d52ced6badfb9a4c(value, field, amount, options) {
    let mutable = value.copy();
    switch(field){
        case 'era':
            {
                let eras = value.calendar.getEras();
                let eraIndex = eras.indexOf(value.era);
                if (eraIndex < 0) throw new Error('Invalid era: ' + value.era);
                eraIndex = $300478f3cc6d5523$var$$735220c2d4774dd3$var$cycleValue(eraIndex, amount, 0, eras.length - 1, options === null || options === void 0 ? void 0 : options.round);
                mutable.era = eras[eraIndex];
                // Constrain the year and other fields within the era, so the era doesn't change when we balance below.
                $300478f3cc6d5523$export$c4e2ecac49351ef2(mutable);
                break;
            }
        case 'year':
            var _mutable_calendar_isInverseEra, _mutable_calendar;
            if ((_mutable_calendar_isInverseEra = (_mutable_calendar = mutable.calendar).isInverseEra) === null || _mutable_calendar_isInverseEra === void 0 ? void 0 : _mutable_calendar_isInverseEra.call(_mutable_calendar, mutable)) amount = -amount;
            // The year field should not cycle within the era as that can cause weird behavior affecting other fields.
            // We need to also allow values < 1 so that decrementing goes to the previous era. If we get -Infinity back
            // we know we wrapped around after reaching 9999 (the maximum), so set the year back to 1.
            mutable.year = $300478f3cc6d5523$var$$735220c2d4774dd3$var$cycleValue(value.year, amount, -Infinity, 9999, options === null || options === void 0 ? void 0 : options.round);
            if (mutable.year === -Infinity) mutable.year = 1;
            if (mutable.calendar.balanceYearMonth) mutable.calendar.balanceYearMonth(mutable, value);
            break;
        case 'month':
            mutable.month = $300478f3cc6d5523$var$$735220c2d4774dd3$var$cycleValue(value.month, amount, 1, value.calendar.getMonthsInYear(value), options === null || options === void 0 ? void 0 : options.round);
            break;
        case 'day':
            mutable.day = $300478f3cc6d5523$var$$735220c2d4774dd3$var$cycleValue(value.day, amount, 1, value.calendar.getDaysInMonth(value), options === null || options === void 0 ? void 0 : options.round);
            break;
        default:
            throw new Error('Unsupported field ' + field);
    }
    if (value.calendar.balanceDate) value.calendar.balanceDate(mutable);
    $300478f3cc6d5523$export$c4e2ecac49351ef2(mutable);
    return mutable;
}
function $300478f3cc6d5523$export$dd02b3e0007dfe28(value, field, amount, options) {
    let mutable = value.copy();
    switch(field){
        case 'hour':
            {
                let hours = value.hour;
                let min = 0;
                let max = 23;
                if ((options === null || options === void 0 ? void 0 : options.hourCycle) === 12) {
                    let isPM = hours >= 12;
                    min = isPM ? 12 : 0;
                    max = isPM ? 23 : 11;
                }
                mutable.hour = $300478f3cc6d5523$var$$735220c2d4774dd3$var$cycleValue(hours, amount, min, max, options === null || options === void 0 ? void 0 : options.round);
                break;
            }
        case 'minute':
            mutable.minute = $300478f3cc6d5523$var$$735220c2d4774dd3$var$cycleValue(value.minute, amount, 0, 59, options === null || options === void 0 ? void 0 : options.round);
            break;
        case 'second':
            mutable.second = $300478f3cc6d5523$var$$735220c2d4774dd3$var$cycleValue(value.second, amount, 0, 59, options === null || options === void 0 ? void 0 : options.round);
            break;
        case 'millisecond':
            mutable.millisecond = $300478f3cc6d5523$var$$735220c2d4774dd3$var$cycleValue(value.millisecond, amount, 0, 999, options === null || options === void 0 ? void 0 : options.round);
            break;
        default:
            throw new Error('Unsupported field ' + field);
    }
    return mutable;
}
function $300478f3cc6d5523$var$$735220c2d4774dd3$var$cycleValue(value, amount, min, max, round = false) {
    if (round) {
        value += Math.sign(amount);
        if (value < min) value = max;
        let div = Math.abs(amount);
        if (amount > 0) value = Math.ceil(value / div) * div;
        else value = Math.floor(value / div) * div;
        if (value > max) value = min;
    } else {
        value += amount;
        if (value < min) value = max - (min - value - 1);
        else if (value > max) value = min + (value - max - 1);
    }
    return value;
}
function $300478f3cc6d5523$export$96b1d28349274637(dateTime, duration) {
    let ms;
    if (duration.years != null && duration.years !== 0 || duration.months != null && duration.months !== 0 || duration.weeks != null && duration.weeks !== 0 || duration.days != null && duration.days !== 0) {
        let res = $300478f3cc6d5523$export$e16d8520af44a096((0, $24197fe0fbca7789$export$b21e0b124e224484)(dateTime), {
            years: duration.years,
            months: duration.months,
            weeks: duration.weeks,
            days: duration.days
        });
        // Changing the date may change the timezone offset, so we need to recompute
        // using the 'compatible' disambiguation.
        ms = (0, $24197fe0fbca7789$export$5107c82f94518f5c)(res, dateTime.timeZone);
    } else ms = (0, $24197fe0fbca7789$export$bd4fb2bc8bb06fb)(dateTime) - dateTime.offset;
    // Perform time manipulation in milliseconds rather than on the original time fields to account for DST.
    // For example, adding one hour during a DST transition may result in the hour field staying the same or
    // skipping an hour. This results in the offset field changing value instead of the specified field.
    ms += duration.milliseconds || 0;
    ms += (duration.seconds || 0) * 1000;
    ms += (duration.minutes || 0) * 60000;
    ms += (duration.hours || 0) * 3600000;
    let res = (0, $24197fe0fbca7789$export$1b96692a1ba042ac)(ms, dateTime.timeZone);
    return (0, $24197fe0fbca7789$export$b4a036af3fc0b032)(res, dateTime.calendar);
}
function $300478f3cc6d5523$export$6814caac34ca03c7(dateTime, duration) {
    return $300478f3cc6d5523$export$96b1d28349274637(dateTime, $300478f3cc6d5523$export$3e2544e88a25bff8(duration));
}
function $300478f3cc6d5523$export$9a297d111fc86b79(dateTime, field, amount, options) {
    // For date fields, we want the time to remain consistent and the UTC offset to potentially change to account for DST changes.
    // For time fields, we want the time to change by the amount given. This may result in the hour field staying the same, but the UTC
    // offset changing in the case of a backward DST transition, or skipping an hour in the case of a forward DST transition.
    switch(field){
        case 'hour':
            {
                let min = 0;
                let max = 23;
                if ((options === null || options === void 0 ? void 0 : options.hourCycle) === 12) {
                    let isPM = dateTime.hour >= 12;
                    min = isPM ? 12 : 0;
                    max = isPM ? 23 : 11;
                }
                // The minimum and maximum hour may be affected by daylight saving time.
                // For example, it might jump forward at midnight, and skip 1am.
                // Or it might end at midnight and repeat the 11pm hour. To handle this, we get
                // the possible absolute times for the min and max, and find the maximum range
                // that is within the current day.
                let plainDateTime = (0, $24197fe0fbca7789$export$b21e0b124e224484)(dateTime);
                let minDate = (0, $24197fe0fbca7789$export$b4a036af3fc0b032)($300478f3cc6d5523$export$e5d5e1c1822b6e56(plainDateTime, {
                    hour: min
                }), new (0, $164d3c47591a715e$export$80ee6245ec4f29ec)());
                let minAbsolute = [
                    (0, $24197fe0fbca7789$export$5107c82f94518f5c)(minDate, dateTime.timeZone, 'earlier'),
                    (0, $24197fe0fbca7789$export$5107c82f94518f5c)(minDate, dateTime.timeZone, 'later')
                ].filter((ms)=>(0, $24197fe0fbca7789$export$1b96692a1ba042ac)(ms, dateTime.timeZone).day === minDate.day)[0];
                let maxDate = (0, $24197fe0fbca7789$export$b4a036af3fc0b032)($300478f3cc6d5523$export$e5d5e1c1822b6e56(plainDateTime, {
                    hour: max
                }), new (0, $164d3c47591a715e$export$80ee6245ec4f29ec)());
                let maxAbsolute = [
                    (0, $24197fe0fbca7789$export$5107c82f94518f5c)(maxDate, dateTime.timeZone, 'earlier'),
                    (0, $24197fe0fbca7789$export$5107c82f94518f5c)(maxDate, dateTime.timeZone, 'later')
                ].filter((ms)=>(0, $24197fe0fbca7789$export$1b96692a1ba042ac)(ms, dateTime.timeZone).day === maxDate.day).pop();
                // Since hours may repeat, we need to operate on the absolute time in milliseconds.
                // This is done in hours from the Unix epoch so that cycleValue works correctly,
                // and then converted back to milliseconds.
                let ms = (0, $24197fe0fbca7789$export$bd4fb2bc8bb06fb)(dateTime) - dateTime.offset;
                let hours = Math.floor(ms / $300478f3cc6d5523$var$$735220c2d4774dd3$var$ONE_HOUR);
                let remainder = ms % $300478f3cc6d5523$var$$735220c2d4774dd3$var$ONE_HOUR;
                ms = $300478f3cc6d5523$var$$735220c2d4774dd3$var$cycleValue(hours, amount, Math.floor(minAbsolute / $300478f3cc6d5523$var$$735220c2d4774dd3$var$ONE_HOUR), Math.floor(maxAbsolute / $300478f3cc6d5523$var$$735220c2d4774dd3$var$ONE_HOUR), options === null || options === void 0 ? void 0 : options.round) * $300478f3cc6d5523$var$$735220c2d4774dd3$var$ONE_HOUR + remainder;
                // Now compute the new timezone offset, and convert the absolute time back to local time.
                return (0, $24197fe0fbca7789$export$b4a036af3fc0b032)((0, $24197fe0fbca7789$export$1b96692a1ba042ac)(ms, dateTime.timeZone), dateTime.calendar);
            }
        case 'minute':
        case 'second':
        case 'millisecond':
            // @ts-ignore
            return $300478f3cc6d5523$export$dd02b3e0007dfe28(dateTime, field, amount, options);
        case 'era':
        case 'year':
        case 'month':
        case 'day':
            {
                let res = $300478f3cc6d5523$export$d52ced6badfb9a4c((0, $24197fe0fbca7789$export$b21e0b124e224484)(dateTime), field, amount, options);
                let ms = (0, $24197fe0fbca7789$export$5107c82f94518f5c)(res, dateTime.timeZone);
                return (0, $24197fe0fbca7789$export$b4a036af3fc0b032)((0, $24197fe0fbca7789$export$1b96692a1ba042ac)(ms, dateTime.timeZone), dateTime.calendar);
            }
        default:
            throw new Error('Unsupported field ' + field);
    }
}
function $300478f3cc6d5523$export$31b5430eb18be4f8(dateTime, fields, disambiguation) {
    // Set the date/time fields, and recompute the UTC offset to account for DST changes.
    // We also need to validate by converting back to a local time in case hours are skipped during forward DST transitions.
    let plainDateTime = (0, $24197fe0fbca7789$export$b21e0b124e224484)(dateTime);
    let res = $300478f3cc6d5523$export$e5d5e1c1822b6e56($300478f3cc6d5523$export$adaa4cf7ef1b65be(plainDateTime, fields), fields);
    // If the resulting plain date time values are equal, return the original time.
    // We don't want to change the offset when setting the time to the same value.
    if (res.compare(plainDateTime) === 0) return dateTime;
    let ms = (0, $24197fe0fbca7789$export$5107c82f94518f5c)(res, dateTime.timeZone, disambiguation);
    return (0, $24197fe0fbca7789$export$b4a036af3fc0b032)((0, $24197fe0fbca7789$export$1b96692a1ba042ac)(ms, dateTime.timeZone), dateTime.calendar);
}







/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $465374ca30ab45d0$var$$35ea8db9cb2ccb90$var$shiftArgs(args) {
    let calendar = typeof args[0] === 'object' ? args.shift() : new (0, $164d3c47591a715e$export$80ee6245ec4f29ec)();
    let era;
    if (typeof args[0] === 'string') era = args.shift();
    else {
        let eras = calendar.getEras();
        era = eras[eras.length - 1];
    }
    let year = args.shift();
    let month = args.shift();
    let day = args.shift();
    return [
        calendar,
        era,
        year,
        month,
        day
    ];
}
var // i.e. a ZonedDateTime should not be be passable to a parameter that expects CalendarDate.
// If that behavior is desired, use the AnyCalendarDate interface instead.
// @ts-ignore
$465374ca30ab45d0$var$$35ea8db9cb2ccb90$var$_type = /*#__PURE__*/ new WeakMap();
class $465374ca30ab45d0$export$99faa760c7908e4f {
    /** Returns a copy of this date. */ copy() {
        if (this.era) return new $465374ca30ab45d0$export$99faa760c7908e4f(this.calendar, this.era, this.year, this.month, this.day);
        else return new $465374ca30ab45d0$export$99faa760c7908e4f(this.calendar, this.year, this.month, this.day);
    }
    /** Returns a new `CalendarDate` with the given duration added to it. */ add(duration) {
        return (0, $300478f3cc6d5523$export$e16d8520af44a096)(this, duration);
    }
    /** Returns a new `CalendarDate` with the given duration subtracted from it. */ subtract(duration) {
        return (0, $300478f3cc6d5523$export$4e2d2ead65e5f7e3)(this, duration);
    }
    /** Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly. */ set(fields) {
        return (0, $300478f3cc6d5523$export$adaa4cf7ef1b65be)(this, fields);
    }
    /**
   * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        return (0, $300478f3cc6d5523$export$d52ced6badfb9a4c)(this, field, amount, options);
    }
    /** Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone. */ toDate(timeZone) {
        return (0, $24197fe0fbca7789$export$e67a095c620b86fe)(this, timeZone);
    }
    /** Converts the date to an ISO 8601 formatted string. */ toString() {
        return (0, $6e5edc2e47674229$export$60dfd74aa96791bd)(this);
    }
    /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ compare(b) {
        return (0, $45b01a5678208999$export$68781ddf31c0090f)(this, b);
    }
    constructor(...args){
        (0, $01f13bd32e43989c$export$e235798705076415)(this, $465374ca30ab45d0$var$$35ea8db9cb2ccb90$var$_type, {
            writable: true,
            value: void 0
        });
        let [calendar, era, year, month, day] = $465374ca30ab45d0$var$$35ea8db9cb2ccb90$var$shiftArgs(args);
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        (0, $300478f3cc6d5523$export$c4e2ecac49351ef2)(this);
    }
}
var // @ts-ignore
$465374ca30ab45d0$var$$35ea8db9cb2ccb90$var$_type1 = /*#__PURE__*/ new WeakMap();
class $465374ca30ab45d0$export$680ea196effce5f {
    /** Returns a copy of this time. */ copy() {
        return new $465374ca30ab45d0$export$680ea196effce5f(this.hour, this.minute, this.second, this.millisecond);
    }
    /** Returns a new `Time` with the given duration added to it. */ add(duration) {
        return (0, $300478f3cc6d5523$export$7ed87b6bc2506470)(this, duration);
    }
    /** Returns a new `Time` with the given duration subtracted from it. */ subtract(duration) {
        return (0, $300478f3cc6d5523$export$fe34d3a381cd7501)(this, duration);
    }
    /** Returns a new `Time` with the given fields set to the provided values. Other fields will be constrained accordingly. */ set(fields) {
        return (0, $300478f3cc6d5523$export$e5d5e1c1822b6e56)(this, fields);
    }
    /**
   * Returns a new `Time` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        return (0, $300478f3cc6d5523$export$dd02b3e0007dfe28)(this, field, amount, options);
    }
    /** Converts the time to an ISO 8601 formatted string. */ toString() {
        return (0, $6e5edc2e47674229$export$f59dee82248f5ad4)(this);
    }
    /** Compares this time with another. A negative result indicates that this time is before the given one, and a positive time indicates that it is after. */ compare(b) {
        return (0, $45b01a5678208999$export$c19a80a9721b80f6)(this, b);
    }
    constructor(hour = 0, minute = 0, second = 0, millisecond = 0){
        (0, $01f13bd32e43989c$export$e235798705076415)(this, $465374ca30ab45d0$var$$35ea8db9cb2ccb90$var$_type1, {
            writable: true,
            value: void 0
        });
        this.hour = hour;
        this.minute = minute;
        this.second = second;
        this.millisecond = millisecond;
        (0, $300478f3cc6d5523$export$7555de1e070510cb)(this);
    }
}
var // @ts-ignore
$465374ca30ab45d0$var$$35ea8db9cb2ccb90$var$_type2 = /*#__PURE__*/ new WeakMap();
class $465374ca30ab45d0$export$ca871e8dbb80966f {
    /** Returns a copy of this date. */ copy() {
        if (this.era) return new $465374ca30ab45d0$export$ca871e8dbb80966f(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
        else return new $465374ca30ab45d0$export$ca871e8dbb80966f(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
    }
    /** Returns a new `CalendarDateTime` with the given duration added to it. */ add(duration) {
        return (0, $300478f3cc6d5523$export$e16d8520af44a096)(this, duration);
    }
    /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */ subtract(duration) {
        return (0, $300478f3cc6d5523$export$4e2d2ead65e5f7e3)(this, duration);
    }
    /** Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */ set(fields) {
        return (0, $300478f3cc6d5523$export$adaa4cf7ef1b65be)((0, $300478f3cc6d5523$export$e5d5e1c1822b6e56)(this, fields), fields);
    }
    /**
   * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        switch(field){
            case 'era':
            case 'year':
            case 'month':
            case 'day':
                return (0, $300478f3cc6d5523$export$d52ced6badfb9a4c)(this, field, amount, options);
            default:
                return (0, $300478f3cc6d5523$export$dd02b3e0007dfe28)(this, field, amount, options);
        }
    }
    /** Converts the date to a native JavaScript Date object in the given time zone. */ toDate(timeZone, disambiguation) {
        return (0, $24197fe0fbca7789$export$e67a095c620b86fe)(this, timeZone, disambiguation);
    }
    /** Converts the date to an ISO 8601 formatted string. */ toString() {
        return (0, $6e5edc2e47674229$export$4223de14708adc63)(this);
    }
    /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ compare(b) {
        let res = (0, $45b01a5678208999$export$68781ddf31c0090f)(this, b);
        if (res === 0) return (0, $45b01a5678208999$export$c19a80a9721b80f6)(this, (0, $24197fe0fbca7789$export$b21e0b124e224484)(b));
        return res;
    }
    constructor(...args){
        (0, $01f13bd32e43989c$export$e235798705076415)(this, $465374ca30ab45d0$var$$35ea8db9cb2ccb90$var$_type2, {
            writable: true,
            value: void 0
        });
        let [calendar, era, year, month, day] = $465374ca30ab45d0$var$$35ea8db9cb2ccb90$var$shiftArgs(args);
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        this.hour = args.shift() || 0;
        this.minute = args.shift() || 0;
        this.second = args.shift() || 0;
        this.millisecond = args.shift() || 0;
        (0, $300478f3cc6d5523$export$c4e2ecac49351ef2)(this);
    }
}
var // @ts-ignore
$465374ca30ab45d0$var$$35ea8db9cb2ccb90$var$_type3 = /*#__PURE__*/ new WeakMap();
class $465374ca30ab45d0$export$d3b7288e7994edea {
    /** Returns a copy of this date. */ copy() {
        if (this.era) return new $465374ca30ab45d0$export$d3b7288e7994edea(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
        else return new $465374ca30ab45d0$export$d3b7288e7994edea(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
    }
    /** Returns a new `ZonedDateTime` with the given duration added to it. */ add(duration) {
        return (0, $300478f3cc6d5523$export$96b1d28349274637)(this, duration);
    }
    /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */ subtract(duration) {
        return (0, $300478f3cc6d5523$export$6814caac34ca03c7)(this, duration);
    }
    /** Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */ set(fields, disambiguation) {
        return (0, $300478f3cc6d5523$export$31b5430eb18be4f8)(this, fields, disambiguation);
    }
    /**
   * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        return (0, $300478f3cc6d5523$export$9a297d111fc86b79)(this, field, amount, options);
    }
    /** Converts the date to a native JavaScript Date object. */ toDate() {
        return (0, $24197fe0fbca7789$export$83aac07b4c37b25)(this);
    }
    /** Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone identifier. */ toString() {
        return (0, $6e5edc2e47674229$export$bf79f1ebf4b18792)(this);
    }
    /** Converts the date to an ISO 8601 formatted string in UTC. */ toAbsoluteString() {
        return this.toDate().toISOString();
    }
    /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ compare(b) {
        // TODO: Is this a bad idea??
        return this.toDate().getTime() - (0, $24197fe0fbca7789$export$84c95a83c799e074)(b, this.timeZone).toDate().getTime();
    }
    constructor(...args){
        (0, $01f13bd32e43989c$export$e235798705076415)(this, $465374ca30ab45d0$var$$35ea8db9cb2ccb90$var$_type3, {
            writable: true,
            value: void 0
        });
        let [calendar, era, year, month, day] = $465374ca30ab45d0$var$$35ea8db9cb2ccb90$var$shiftArgs(args);
        let timeZone = args.shift();
        let offset = args.shift();
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        this.timeZone = timeZone;
        this.offset = offset;
        this.hour = args.shift() || 0;
        this.minute = args.shift() || 0;
        this.second = args.shift() || 0;
        this.millisecond = args.shift() || 0;
        (0, $300478f3cc6d5523$export$c4e2ecac49351ef2)(this);
    }
}





/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6e5edc2e47674229$var$$fae977aafc393c5c$var$TIME_RE = /^(\d{2})(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
const $6e5edc2e47674229$var$$fae977aafc393c5c$var$DATE_RE = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})$/;
const $6e5edc2e47674229$var$$fae977aafc393c5c$var$DATE_TIME_RE = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
const $6e5edc2e47674229$var$$fae977aafc393c5c$var$ZONED_DATE_TIME_RE = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:([+-]\d{2})(?::?(\d{2}))?(?::?(\d{2}))?)?\[(.*?)\]$/;
const $6e5edc2e47674229$var$$fae977aafc393c5c$var$ABSOLUTE_RE = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:(?:([+-]\d{2})(?::?(\d{2}))?)|Z)$/;
const $6e5edc2e47674229$var$$fae977aafc393c5c$var$DATE_TIME_DURATION_RE = /^((?<negative>-)|\+)?P((?<years>\d*)Y)?((?<months>\d*)M)?((?<weeks>\d*)W)?((?<days>\d*)D)?((?<time>T)((?<hours>\d*[.,]?\d{1,9})H)?((?<minutes>\d*[.,]?\d{1,9})M)?((?<seconds>\d*[.,]?\d{1,9})S)?)?$/;
const $6e5edc2e47674229$var$$fae977aafc393c5c$var$requiredDurationTimeGroups = [
    'hours',
    'minutes',
    'seconds'
];
const $6e5edc2e47674229$var$$fae977aafc393c5c$var$requiredDurationGroups = [
    'years',
    'months',
    'weeks',
    'days',
    ...$6e5edc2e47674229$var$$fae977aafc393c5c$var$requiredDurationTimeGroups
];
function $6e5edc2e47674229$export$c9698ec7f05a07e1(value) {
    let m = value.match($6e5edc2e47674229$var$$fae977aafc393c5c$var$TIME_RE);
    if (!m) throw new Error('Invalid ISO 8601 time string: ' + value);
    return new (0, $465374ca30ab45d0$export$680ea196effce5f)($6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[1], 0, 23), m[2] ? $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[2], 0, 59) : 0, m[3] ? $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, 59) : 0, m[4] ? $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[4], 0, Infinity) * 1000 : 0);
}
function $6e5edc2e47674229$export$6b862160d295c8e(value) {
    let m = value.match($6e5edc2e47674229$var$$fae977aafc393c5c$var$DATE_RE);
    if (!m) {
        if ($6e5edc2e47674229$var$$fae977aafc393c5c$var$ABSOLUTE_RE.test(value)) throw new Error(`Invalid ISO 8601 date string: ${value}. Use parseAbsolute() instead.`);
        throw new Error('Invalid ISO 8601 date string: ' + value);
    }
    let date = new (0, $465374ca30ab45d0$export$99faa760c7908e4f)($6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[1], 0, 9999), $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1);
    date.day = $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[3], 1, date.calendar.getDaysInMonth(date));
    return date;
}
function $6e5edc2e47674229$export$588937bcd60ade55(value) {
    let m = value.match($6e5edc2e47674229$var$$fae977aafc393c5c$var$DATE_TIME_RE);
    if (!m) {
        if ($6e5edc2e47674229$var$$fae977aafc393c5c$var$ABSOLUTE_RE.test(value)) throw new Error(`Invalid ISO 8601 date time string: ${value}. Use parseAbsolute() instead.`);
        throw new Error('Invalid ISO 8601 date time string: ' + value);
    }
    let year = $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[1], -9999, 9999);
    let era = year < 1 ? 'BC' : 'AD';
    let date = new (0, $465374ca30ab45d0$export$ca871e8dbb80966f)(era, year < 1 ? -year + 1 : year, $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1, m[4] ? $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    return date;
}
function $6e5edc2e47674229$export$fd7893f06e92a6a4(value, disambiguation) {
    let m = value.match($6e5edc2e47674229$var$$fae977aafc393c5c$var$ZONED_DATE_TIME_RE);
    if (!m) throw new Error('Invalid ISO 8601 date time string: ' + value);
    let year = $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[1], -9999, 9999);
    let era = year < 1 ? 'BC' : 'AD';
    let date = new (0, $465374ca30ab45d0$export$d3b7288e7994edea)(era, year < 1 ? -year + 1 : year, $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1, m[11], 0, m[4] ? $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    let plainDateTime = (0, $24197fe0fbca7789$export$b21e0b124e224484)(date);
    let ms;
    if (m[8]) {
        let hourOffset = $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[8], -23, 23);
        var _m_, _m_1;
        date.offset = Math.sign(hourOffset) * (Math.abs(hourOffset) * 3600000 + $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber((_m_ = m[9]) !== null && _m_ !== void 0 ? _m_ : '0', 0, 59) * 60000 + $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber((_m_1 = m[10]) !== null && _m_1 !== void 0 ? _m_1 : '0', 0, 59) * 1000);
        ms = (0, $24197fe0fbca7789$export$bd4fb2bc8bb06fb)(date) - date.offset;
        // Validate offset against parsed date.
        let absolutes = (0, $24197fe0fbca7789$export$136f38efe7caf549)(plainDateTime, date.timeZone);
        if (!absolutes.includes(ms)) throw new Error(`Offset ${$6e5edc2e47674229$var$$fae977aafc393c5c$var$offsetToString(date.offset)} is invalid for ${$6e5edc2e47674229$export$4223de14708adc63(date)} in ${date.timeZone}`);
    } else ms = (0, $24197fe0fbca7789$export$5107c82f94518f5c)((0, $24197fe0fbca7789$export$b21e0b124e224484)(plainDateTime), date.timeZone, disambiguation);
    return (0, $24197fe0fbca7789$export$1b96692a1ba042ac)(ms, date.timeZone);
}
function $6e5edc2e47674229$export$5adfdab05168c219(value, timeZone) {
    let m = value.match($6e5edc2e47674229$var$$fae977aafc393c5c$var$ABSOLUTE_RE);
    if (!m) throw new Error('Invalid ISO 8601 date time string: ' + value);
    let year = $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[1], -9999, 9999);
    let era = year < 1 ? 'BC' : 'AD';
    let date = new (0, $465374ca30ab45d0$export$d3b7288e7994edea)(era, year < 1 ? -year + 1 : year, $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1, timeZone, 0, m[4] ? $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    var _m_;
    if (m[8]) date.offset = $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(m[8], -23, 23) * 3600000 + $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber((_m_ = m[9]) !== null && _m_ !== void 0 ? _m_ : '0', 0, 59) * 60000;
    return (0, $24197fe0fbca7789$export$538b00033cc11c75)(date, timeZone);
}
function $6e5edc2e47674229$export$8e384432362ed0f0(value) {
    return $6e5edc2e47674229$export$5adfdab05168c219(value, (0, $45b01a5678208999$export$aa8b41735afcabd2)());
}
function $6e5edc2e47674229$var$$fae977aafc393c5c$var$parseNumber(value, min, max) {
    let val = Number(value);
    if (val < min || val > max) throw new RangeError(`Value out of range: ${min} <= ${val} <= ${max}`);
    return val;
}
function $6e5edc2e47674229$export$f59dee82248f5ad4(time) {
    return `${String(time.hour).padStart(2, '0')}:${String(time.minute).padStart(2, '0')}:${String(time.second).padStart(2, '0')}${time.millisecond ? String(time.millisecond / 1000).slice(1) : ''}`;
}
function $6e5edc2e47674229$export$60dfd74aa96791bd(date) {
    let gregorianDate = (0, $24197fe0fbca7789$export$b4a036af3fc0b032)(date, new (0, $164d3c47591a715e$export$80ee6245ec4f29ec)());
    let year;
    if (gregorianDate.era === 'BC') year = gregorianDate.year === 1 ? '0000' : '-' + String(Math.abs(1 - gregorianDate.year)).padStart(6, '00');
    else year = String(gregorianDate.year).padStart(4, '0');
    return `${year}-${String(gregorianDate.month).padStart(2, '0')}-${String(gregorianDate.day).padStart(2, '0')}`;
}
function $6e5edc2e47674229$export$4223de14708adc63(date) {
    // @ts-ignore
    return `${$6e5edc2e47674229$export$60dfd74aa96791bd(date)}T${$6e5edc2e47674229$export$f59dee82248f5ad4(date)}`;
}
function $6e5edc2e47674229$var$$fae977aafc393c5c$var$offsetToString(offset) {
    let sign = Math.sign(offset) < 0 ? '-' : '+';
    offset = Math.abs(offset);
    let offsetHours = Math.floor(offset / 3600000);
    let offsetMinutes = Math.floor(offset % 3600000 / 60000);
    let offsetSeconds = Math.floor(offset % 3600000 % 60000 / 1000);
    let stringOffset = `${sign}${String(offsetHours).padStart(2, '0')}:${String(offsetMinutes).padStart(2, '0')}`;
    if (offsetSeconds !== 0) stringOffset += `:${String(offsetSeconds).padStart(2, '0')}`;
    return stringOffset;
}
function $6e5edc2e47674229$export$bf79f1ebf4b18792(date) {
    return `${$6e5edc2e47674229$export$4223de14708adc63(date)}${$6e5edc2e47674229$var$$fae977aafc393c5c$var$offsetToString(date.offset)}[${date.timeZone}]`;
}
function $6e5edc2e47674229$export$ecae829bb3747ea6(value) {
    var _match_groups, _match_groups1, _match_groups2, _match_groups3, _match_groups4, _match_groups5, _match_groups6, _match_groups7, _match_groups8;
    const match = value.match($6e5edc2e47674229$var$$fae977aafc393c5c$var$DATE_TIME_DURATION_RE);
    if (!match) throw new Error(`Invalid ISO 8601 Duration string: ${value}`);
    const parseDurationGroup = (group, isNegative)=>{
        if (!group) return 0;
        try {
            const sign = isNegative ? -1 : 1;
            return sign * Number(group.replace(',', '.'));
        } catch  {
            throw new Error(`Invalid ISO 8601 Duration string: ${value}`);
        }
    };
    const isNegative = !!((_match_groups = match.groups) === null || _match_groups === void 0 ? void 0 : _match_groups.negative);
    const hasRequiredGroups = $6e5edc2e47674229$var$$fae977aafc393c5c$var$requiredDurationGroups.some((group)=>{
        var _match_groups;
        return (_match_groups = match.groups) === null || _match_groups === void 0 ? void 0 : _match_groups[group];
    });
    if (!hasRequiredGroups) throw new Error(`Invalid ISO 8601 Duration string: ${value}`);
    const durationStringIncludesTime = (_match_groups1 = match.groups) === null || _match_groups1 === void 0 ? void 0 : _match_groups1.time;
    if (durationStringIncludesTime) {
        const hasRequiredDurationTimeGroups = $6e5edc2e47674229$var$$fae977aafc393c5c$var$requiredDurationTimeGroups.some((group)=>{
            var _match_groups;
            return (_match_groups = match.groups) === null || _match_groups === void 0 ? void 0 : _match_groups[group];
        });
        if (!hasRequiredDurationTimeGroups) throw new Error(`Invalid ISO 8601 Duration string: ${value}`);
    }
    const duration = {
        years: parseDurationGroup((_match_groups2 = match.groups) === null || _match_groups2 === void 0 ? void 0 : _match_groups2.years, isNegative),
        months: parseDurationGroup((_match_groups3 = match.groups) === null || _match_groups3 === void 0 ? void 0 : _match_groups3.months, isNegative),
        weeks: parseDurationGroup((_match_groups4 = match.groups) === null || _match_groups4 === void 0 ? void 0 : _match_groups4.weeks, isNegative),
        days: parseDurationGroup((_match_groups5 = match.groups) === null || _match_groups5 === void 0 ? void 0 : _match_groups5.days, isNegative),
        hours: parseDurationGroup((_match_groups6 = match.groups) === null || _match_groups6 === void 0 ? void 0 : _match_groups6.hours, isNegative),
        minutes: parseDurationGroup((_match_groups7 = match.groups) === null || _match_groups7 === void 0 ? void 0 : _match_groups7.minutes, isNegative),
        seconds: parseDurationGroup((_match_groups8 = match.groups) === null || _match_groups8 === void 0 ? void 0 : _match_groups8.seconds, isNegative)
    };
    if (duration.hours !== undefined && duration.hours % 1 !== 0 && (duration.minutes || duration.seconds)) throw new Error(`Invalid ISO 8601 Duration string: ${value} - only the smallest unit can be fractional`);
    if (duration.minutes !== undefined && duration.minutes % 1 !== 0 && duration.seconds) throw new Error(`Invalid ISO 8601 Duration string: ${value} - only the smallest unit can be fractional`);
    return duration;
}



var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $878d1189b2fd67b2$var$$c699643d2073b351$var$dateSegments = [
    'day',
    'month',
    'year'
];
const $878d1189b2fd67b2$var$$c699643d2073b351$var$granularityMap = {
    'hour': 1,
    'minute': 2,
    'second': 3
};
function $878d1189b2fd67b2$export$f6a685cd1acbd1fa(props, state) {
    let { autoComplete: autoComplete, isDisabled: isDisabled, name: name } = props;
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $2b6fccd6bf1aab09$export$a966af930f325cab)({
        style: {
            // Prevent page scrolling.
            position: 'fixed',
            top: 0,
            left: 0
        }
    });
    let inputStep = 60;
    if (state.granularity === 'second') inputStep = 1;
    else if (state.granularity === 'hour') inputStep = 3600;
    let dateValue = state.value == null ? '' : state.value.toString();
    let inputType = state.granularity === 'day' ? 'date' : 'datetime-local';
    let timeSegments = [
        'hour',
        'minute',
        'second'
    ];
    // Depending on the granularity, we only want to validate certain time segments
    let end = 0;
    if (timeSegments.includes(state.granularity)) {
        end = $878d1189b2fd67b2$var$$c699643d2073b351$var$granularityMap[state.granularity];
        timeSegments = timeSegments.slice(0, end);
    }
    return {
        containerProps: {
            ...visuallyHiddenProps,
            'aria-hidden': true,
            // @ts-ignore
            ['data-react-aria-prevent-focus']: true,
            // @ts-ignore
            ['data-a11y-ignore']: 'aria-hidden-focus'
        },
        inputProps: {
            tabIndex: -1,
            autoComplete: autoComplete,
            disabled: isDisabled,
            type: inputType,
            // We set the form prop to an empty string to prevent the hidden date input's value from being submitted
            form: '',
            name: name,
            step: inputStep,
            value: dateValue,
            onChange: (e)=>{
                let targetString = e.target.value.toString();
                if (targetString) try {
                    let targetValue = (0, $6e5edc2e47674229$export$588937bcd60ade55)(targetString);
                    if (state.granularity === 'day') targetValue = (0, $6e5edc2e47674229$export$6b862160d295c8e)(targetString);
                    // We check to to see if setSegment exists in the state since it only exists in DateFieldState and not DatePickerState.
                    // The setValue method has different behavior depending on if it's coming from DateFieldState or DatePickerState.
                    // In DateFieldState, setValue firsts checks to make sure that each segment is filled before committing the newValue
                    // which is why in the code below we first set each segment to validate it before committing the new value.
                    // However, in DatePickerState, since we have to be able to commit values from the Calendar popover, we are also able to
                    // set a new value when the field itself is empty.
                    if ('setSegment' in state) for(let type in targetValue){
                        // eslint-disable-next-line max-depth
                        if ($878d1189b2fd67b2$var$$c699643d2073b351$var$dateSegments.includes(type)) state.setSegment(type, targetValue[type]);
                        // eslint-disable-next-line max-depth
                        if (timeSegments.includes(type)) state.setSegment(type, targetValue[type]);
                    }
                    state.setValue(targetValue);
                } catch  {
                // ignore
                }
            }
        }
    };
}
function $878d1189b2fd67b2$export$eefa3e19139f00f3(props) {
    let { state: state } = props;
    let { containerProps: containerProps, inputProps: inputProps } = $878d1189b2fd67b2$export$f6a685cd1acbd1fa({
        ...props
    }, state);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...containerProps,
        "data-testid": "hidden-dateinput-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", inputProps));
}





var $2251f9680a0ba75b$export$2e2bcd8739ae039 = {};
$2251f9680a0ba75b$export$2e2bcd8739ae039 = {
    "calendar": `\u{627}\u{644}\u{62A}\u{642}\u{648}\u{64A}\u{645}`,
    "day": `\u{64A}\u{648}\u{645}`,
    "dayPeriod": `\u{635}/\u{645}`,
    "endDate": `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{647}\u{627}\u{621}`,
    "era": `\u{627}\u{644}\u{639}\u{635}\u{631}`,
    "hour": `\u{627}\u{644}\u{633}\u{627}\u{639}\u{627}\u{62A}`,
    "minute": `\u{627}\u{644}\u{62F}\u{642}\u{627}\u{626}\u{642}`,
    "month": `\u{627}\u{644}\u{634}\u{647}\u{631}`,
    "second": `\u{627}\u{644}\u{62B}\u{648}\u{627}\u{646}\u{64A}`,
    "selectedDateDescription": (args)=>`\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{645}\u{62D}\u{62F}\u{62F}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{627}\u{644}\u{645}\u{62F}\u{649} \u{627}\u{644}\u{632}\u{645}\u{646}\u{64A} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}: ${args.startDate} \u{625}\u{644}\u{649} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{627}\u{644}\u{648}\u{642}\u{62A} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}: ${args.time}`,
    "startDate": `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{628}\u{62F}\u{621}`,
    "timeZoneName": `\u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{62A}`,
    "weekday": `\u{627}\u{644}\u{64A}\u{648}\u{645}`,
    "year": `\u{627}\u{644}\u{633}\u{646}\u{629}`
};


var $39373b69a5439375$export$2e2bcd8739ae039 = {};
$39373b69a5439375$export$2e2bcd8739ae039 = {
    "calendar": `\u{41A}\u{430}\u{43B}\u{435}\u{43D}\u{434}\u{430}\u{440}`,
    "day": `\u{434}\u{435}\u{43D}`,
    "dayPeriod": `\u{43F}\u{440}.\u{43E}\u{431}./\u{441}\u{43B}.\u{43E}\u{431}.`,
    "endDate": `\u{41A}\u{440}\u{430}\u{439}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}`,
    "era": `\u{435}\u{440}\u{430}`,
    "hour": `\u{447}\u{430}\u{441}`,
    "minute": `\u{43C}\u{438}\u{43D}\u{443}\u{442}\u{430}`,
    "month": `\u{43C}\u{435}\u{441}\u{435}\u{446}`,
    "second": `\u{441}\u{435}\u{43A}\u{443}\u{43D}\u{434}\u{430}`,
    "selectedDateDescription": (args)=>`\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}: ${args.startDate} \u{434}\u{43E} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{435}: ${args.time}`,
    "startDate": `\u{41D}\u{430}\u{447}\u{430}\u{43B}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}`,
    "timeZoneName": `\u{447}\u{430}\u{441}\u{43E}\u{432}\u{430} \u{437}\u{43E}\u{43D}\u{430}`,
    "weekday": `\u{434}\u{435}\u{43D} \u{43E}\u{442} \u{441}\u{435}\u{434}\u{43C}\u{438}\u{446}\u{430}\u{442}\u{430}`,
    "year": `\u{433}\u{43E}\u{434}\u{438}\u{43D}\u{430}`
};


var $5acbbb221c65a23b$export$2e2bcd8739ae039 = {};
$5acbbb221c65a23b$export$2e2bcd8739ae039 = {
    "calendar": `Kalend\xe1\u{159}`,
    "day": `den`,
    "dayPeriod": `\u{10D}\xe1st dne`,
    "endDate": `Kone\u{10D}n\xe9 datum`,
    "era": `letopo\u{10D}et`,
    "hour": `hodina`,
    "minute": `minuta`,
    "month": `m\u{11B}s\xedc`,
    "second": `sekunda`,
    "selectedDateDescription": (args)=>`Vybran\xe9 datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Vybran\xe9 obdob\xed: ${args.startDate} a\u{17E} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Vybran\xfd \u{10D}as: ${args.time}`,
    "startDate": `Po\u{10D}\xe1te\u{10D}n\xed datum`,
    "timeZoneName": `\u{10D}asov\xe9 p\xe1smo`,
    "weekday": `den v t\xfddnu`,
    "year": `rok`
};


var $9cdd126680428a42$export$2e2bcd8739ae039 = {};
$9cdd126680428a42$export$2e2bcd8739ae039 = {
    "calendar": `Kalender`,
    "day": `dag`,
    "dayPeriod": `AM/PM`,
    "endDate": `Slutdato`,
    "era": `\xe6ra`,
    "hour": `time`,
    "minute": `minut`,
    "month": `m\xe5ned`,
    "second": `sekund`,
    "selectedDateDescription": (args)=>`Valgt dato: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valgt interval: ${args.startDate} til ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Valgt tidspunkt: ${args.time}`,
    "startDate": `Startdato`,
    "timeZoneName": `tidszone`,
    "weekday": `ugedag`,
    "year": `\xe5r`
};


var $40e356c0f9432c15$export$2e2bcd8739ae039 = {};
$40e356c0f9432c15$export$2e2bcd8739ae039 = {
    "calendar": `Kalender`,
    "day": `Tag`,
    "dayPeriod": `Tagesh\xe4lfte`,
    "endDate": `Enddatum`,
    "era": `Epoche`,
    "hour": `Stunde`,
    "minute": `Minute`,
    "month": `Monat`,
    "second": `Sekunde`,
    "selectedDateDescription": (args)=>`Ausgew\xe4hltes Datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Ausgew\xe4hlter Bereich: ${args.startDate} bis ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Ausgew\xe4hlte Zeit: ${args.time}`,
    "startDate": `Startdatum`,
    "timeZoneName": `Zeitzone`,
    "weekday": `Wochentag`,
    "year": `Jahr`
};


var $7705ab87b687774e$export$2e2bcd8739ae039 = {};
$7705ab87b687774e$export$2e2bcd8739ae039 = {
    "calendar": `\u{397}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BB}\u{3CC}\u{3B3}\u{3B9}\u{3BF}`,
    "day": `\u{3B7}\u{3BC}\u{3AD}\u{3C1}\u{3B1}`,
    "dayPeriod": `\u{3C0}.\u{3BC}./\u{3BC}.\u{3BC}.`,
    "endDate": `\u{397}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1} \u{3BB}\u{3AE}\u{3BE}\u{3B7}\u{3C2}`,
    "era": `\u{3C0}\u{3B5}\u{3C1}\u{3AF}\u{3BF}\u{3B4}\u{3BF}\u{3C2}`,
    "hour": `\u{3CE}\u{3C1}\u{3B1}`,
    "minute": `\u{3BB}\u{3B5}\u{3C0}\u{3C4}\u{3CC}`,
    "month": `\u{3BC}\u{3AE}\u{3BD}\u{3B1}\u{3C2}`,
    "second": `\u{3B4}\u{3B5}\u{3C5}\u{3C4}\u{3B5}\u{3C1}\u{3CC}\u{3BB}\u{3B5}\u{3C0}\u{3C4}\u{3BF}`,
    "selectedDateDescription": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B7} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3BF} \u{3B5}\u{3CD}\u{3C1}\u{3BF}\u{3C2}: ${args.startDate} \u{3AD}\u{3C9}\u{3C2} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B7} \u{3CE}\u{3C1}\u{3B1}: ${args.time}`,
    "startDate": `\u{397}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1} \u{3AD}\u{3BD}\u{3B1}\u{3C1}\u{3BE}\u{3B7}\u{3C2}`,
    "timeZoneName": `\u{3B6}\u{3CE}\u{3BD}\u{3B7} \u{3CE}\u{3C1}\u{3B1}\u{3C2}`,
    "weekday": `\u{3BA}\u{3B1}\u{3B8}\u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3B9}\u{3BD}\u{3AE}`,
    "year": `\u{3AD}\u{3C4}\u{3BF}\u{3C2}`
};


var $64ea6d91b60fcfc3$export$2e2bcd8739ae039 = {};
$64ea6d91b60fcfc3$export$2e2bcd8739ae039 = {
    "era": `era`,
    "year": `year`,
    "month": `month`,
    "day": `day`,
    "hour": `hour`,
    "minute": `minute`,
    "second": `second`,
    "dayPeriod": `AM/PM`,
    "calendar": `Calendar`,
    "startDate": `Start Date`,
    "endDate": `End Date`,
    "weekday": `day of the week`,
    "timeZoneName": `time zone`,
    "selectedDateDescription": (args)=>`Selected Date: ${args.date}`,
    "selectedRangeDescription": (args)=>`Selected Range: ${args.startDate} to ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Selected Time: ${args.time}`
};


var $1126aa38eb661cec$export$2e2bcd8739ae039 = {};
$1126aa38eb661cec$export$2e2bcd8739ae039 = {
    "calendar": `Calendario`,
    "day": `d\xeda`,
    "dayPeriod": `a.\xa0m./p.\xa0m.`,
    "endDate": `Fecha final`,
    "era": `era`,
    "hour": `hora`,
    "minute": `minuto`,
    "month": `mes`,
    "second": `segundo`,
    "selectedDateDescription": (args)=>`Fecha seleccionada: ${args.date}`,
    "selectedRangeDescription": (args)=>`Rango seleccionado: ${args.startDate} a ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Hora seleccionada: ${args.time}`,
    "startDate": `Fecha de inicio`,
    "timeZoneName": `zona horaria`,
    "weekday": `d\xeda de la semana`,
    "year": `a\xf1o`
};


var $bed2ee99d1bc6b87$export$2e2bcd8739ae039 = {};
$bed2ee99d1bc6b87$export$2e2bcd8739ae039 = {
    "calendar": `Kalender`,
    "day": `p\xe4ev`,
    "dayPeriod": `enne/p\xe4rast l\xf5unat`,
    "endDate": `L\xf5ppkuup\xe4ev`,
    "era": `ajastu`,
    "hour": `tund`,
    "minute": `minut`,
    "month": `kuu`,
    "second": `sekund`,
    "selectedDateDescription": (args)=>`Valitud kuup\xe4ev: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valitud vahemik: ${args.startDate} kuni ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Valitud aeg: ${args.time}`,
    "startDate": `Alguskuup\xe4ev`,
    "timeZoneName": `ajav\xf6\xf6nd`,
    "weekday": `n\xe4dalap\xe4ev`,
    "year": `aasta`
};


var $eac22fa260e9502c$export$2e2bcd8739ae039 = {};
$eac22fa260e9502c$export$2e2bcd8739ae039 = {
    "calendar": `Kalenteri`,
    "day": `p\xe4iv\xe4`,
    "dayPeriod": `vuorokaudenaika`,
    "endDate": `P\xe4\xe4ttymisp\xe4iv\xe4`,
    "era": `aikakausi`,
    "hour": `tunti`,
    "minute": `minuutti`,
    "month": `kuukausi`,
    "second": `sekunti`,
    "selectedDateDescription": (args)=>`Valittu p\xe4iv\xe4m\xe4\xe4r\xe4: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valittu aikav\xe4li: ${args.startDate} \u{2013} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Valittu aika: ${args.time}`,
    "startDate": `Alkamisp\xe4iv\xe4`,
    "timeZoneName": `aikavy\xf6hyke`,
    "weekday": `viikonp\xe4iv\xe4`,
    "year": `vuosi`
};


var $a5edca4a285d9e4d$export$2e2bcd8739ae039 = {};
$a5edca4a285d9e4d$export$2e2bcd8739ae039 = {
    "calendar": `Calendrier`,
    "day": `jour`,
    "dayPeriod": `cadran`,
    "endDate": `Date de fin`,
    "era": `\xe8re`,
    "hour": `heure`,
    "minute": `minute`,
    "month": `mois`,
    "second": `seconde`,
    "selectedDateDescription": (args)=>`Date s\xe9lectionn\xe9e\xa0: ${args.date}`,
    "selectedRangeDescription": (args)=>`Plage s\xe9lectionn\xe9e\xa0: ${args.startDate} au ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Heure choisie\xa0: ${args.time}`,
    "startDate": `Date de d\xe9but`,
    "timeZoneName": `fuseau horaire`,
    "weekday": `jour de la semaine`,
    "year": `ann\xe9e`
};


var $1f768739a9a83be1$export$2e2bcd8739ae039 = {};
$1f768739a9a83be1$export$2e2bcd8739ae039 = {
    "calendar": `\u{5DC}\u{5D5}\u{5D7} \u{5E9}\u{5E0}\u{5D4}`,
    "day": `\u{5D9}\u{5D5}\u{5DD}`,
    "dayPeriod": `\u{5DC}\u{5E4}\u{5E0}\u{5D4}\u{5F4}\u{5E6}/\u{5D0}\u{5D7}\u{5D4}\u{5F4}\u{5E6}`,
    "endDate": `\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5E1}\u{5D9}\u{5D5}\u{5DD}`,
    "era": `\u{5EA}\u{5E7}\u{5D5}\u{5E4}\u{5D4}`,
    "hour": `\u{5E9}\u{5E2}\u{5D4}`,
    "minute": `\u{5D3}\u{5E7}\u{5D4}`,
    "month": `\u{5D7}\u{5D5}\u{5D3}\u{5E9}`,
    "second": `\u{5E9}\u{5E0}\u{5D9}\u{5D9}\u{5D4}`,
    "selectedDateDescription": (args)=>`\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5E0}\u{5D1}\u{5D7}\u{5E8}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{5D8}\u{5D5}\u{5D5}\u{5D7} \u{5E0}\u{5D1}\u{5D7}\u{5E8}: ${args.startDate} \u{5E2}\u{5D3} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{5D6}\u{5DE}\u{5DF} \u{5E0}\u{5D1}\u{5D7}\u{5E8}: ${args.time}`,
    "startDate": `\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5D4}\u{5EA}\u{5D7}\u{5DC}\u{5D4}`,
    "timeZoneName": `\u{5D0}\u{5D6}\u{5D5}\u{5E8} \u{5D6}\u{5DE}\u{5DF}`,
    "weekday": `\u{5D9}\u{5D5}\u{5DD} \u{5D1}\u{5E9}\u{5D1}\u{5D5}\u{5E2}`,
    "year": `\u{5E9}\u{5E0}\u{5D4}`
};


var $695b93f8d1020069$export$2e2bcd8739ae039 = {};
$695b93f8d1020069$export$2e2bcd8739ae039 = {
    "calendar": `Kalendar`,
    "day": `dan`,
    "dayPeriod": `AM/PM`,
    "endDate": `Datum zavr\u{161}etka`,
    "era": `era`,
    "hour": `sat`,
    "minute": `minuta`,
    "month": `mjesec`,
    "second": `sekunda`,
    "selectedDateDescription": (args)=>`Odabrani datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Odabrani raspon: ${args.startDate} do ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Odabrano vrijeme: ${args.time}`,
    "startDate": `Datum po\u{10D}etka`,
    "timeZoneName": `vremenska zona`,
    "weekday": `dan u tjednu`,
    "year": `godina`
};


var $2cf6b3eecb530d83$export$2e2bcd8739ae039 = {};
$2cf6b3eecb530d83$export$2e2bcd8739ae039 = {
    "calendar": `Napt\xe1r`,
    "day": `nap`,
    "dayPeriod": `napszak`,
    "endDate": `Befejez\u{151} d\xe1tum`,
    "era": `\xe9ra`,
    "hour": `\xf3ra`,
    "minute": `perc`,
    "month": `h\xf3nap`,
    "second": `m\xe1sodperc`,
    "selectedDateDescription": (args)=>`Kijel\xf6lt d\xe1tum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Kijel\xf6lt tartom\xe1ny: ${args.startDate}\u{2013}${args.endDate}`,
    "selectedTimeDescription": (args)=>`Kijel\xf6lt id\u{151}: ${args.time}`,
    "startDate": `Kezd\u{151} d\xe1tum`,
    "timeZoneName": `id\u{151}z\xf3na`,
    "weekday": `h\xe9t napja`,
    "year": `\xe9v`
};


var $e8edc3756e2f9c47$export$2e2bcd8739ae039 = {};
$e8edc3756e2f9c47$export$2e2bcd8739ae039 = {
    "calendar": `Calendario`,
    "day": `giorno`,
    "dayPeriod": `AM/PM`,
    "endDate": `Data finale`,
    "era": `era`,
    "hour": `ora`,
    "minute": `minuto`,
    "month": `mese`,
    "second": `secondo`,
    "selectedDateDescription": (args)=>`Data selezionata: ${args.date}`,
    "selectedRangeDescription": (args)=>`Intervallo selezionato: da ${args.startDate} a ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Ora selezionata: ${args.time}`,
    "startDate": `Data iniziale`,
    "timeZoneName": `fuso orario`,
    "weekday": `giorno della settimana`,
    "year": `anno`
};


var $5d3b85672e21cfdb$export$2e2bcd8739ae039 = {};
$5d3b85672e21cfdb$export$2e2bcd8739ae039 = {
    "calendar": `\u{30AB}\u{30EC}\u{30F3}\u{30C0}\u{30FC}`,
    "day": `\u{65E5}`,
    "dayPeriod": `\u{5348}\u{524D}/\u{5348}\u{5F8C}`,
    "endDate": `\u{7D42}\u{4E86}\u{65E5}`,
    "era": `\u{6642}\u{4EE3}`,
    "hour": `\u{6642}`,
    "minute": `\u{5206}`,
    "month": `\u{6708}`,
    "second": `\u{79D2}`,
    "selectedDateDescription": (args)=>`\u{9078}\u{629E}\u{3057}\u{305F}\u{65E5}\u{4ED8} : ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{9078}\u{629E}\u{7BC4}\u{56F2} : ${args.startDate} \u{304B}\u{3089} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{9078}\u{629E}\u{3057}\u{305F}\u{6642}\u{9593} : ${args.time}`,
    "startDate": `\u{958B}\u{59CB}\u{65E5}`,
    "timeZoneName": `\u{30BF}\u{30A4}\u{30E0}\u{30BE}\u{30FC}\u{30F3}`,
    "weekday": `\u{66DC}\u{65E5}`,
    "year": `\u{5E74}`
};


var $ef645eeb2ad25acb$export$2e2bcd8739ae039 = {};
$ef645eeb2ad25acb$export$2e2bcd8739ae039 = {
    "calendar": `\u{B2EC}\u{B825}`,
    "day": `\u{C77C}`,
    "dayPeriod": `\u{C624}\u{C804}/\u{C624}\u{D6C4}`,
    "endDate": `\u{C885}\u{B8CC}\u{C77C}`,
    "era": `\u{C5F0}\u{D638}`,
    "hour": `\u{C2DC}`,
    "minute": `\u{BD84}`,
    "month": `\u{C6D4}`,
    "second": `\u{CD08}`,
    "selectedDateDescription": (args)=>`\u{C120}\u{D0DD} \u{C77C}\u{C790}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{C120}\u{D0DD} \u{BC94}\u{C704}: ${args.startDate} ~ ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{C120}\u{D0DD} \u{C2DC}\u{AC04}: ${args.time}`,
    "startDate": `\u{C2DC}\u{C791}\u{C77C}`,
    "timeZoneName": `\u{C2DC}\u{AC04}\u{B300}`,
    "weekday": `\u{C694}\u{C77C}`,
    "year": `\u{B144}`
};


var $cd831d1387fa2849$export$2e2bcd8739ae039 = {};
$cd831d1387fa2849$export$2e2bcd8739ae039 = {
    "calendar": `Kalendorius`,
    "day": `diena`,
    "dayPeriod": `iki piet\u{173} / po piet\u{173}`,
    "endDate": `Pabaigos data`,
    "era": `era`,
    "hour": `valanda`,
    "minute": `minut\u{117}`,
    "month": `m\u{117}nuo`,
    "second": `sekund\u{117}`,
    "selectedDateDescription": (args)=>`Pasirinkta data: ${args.date}`,
    "selectedRangeDescription": (args)=>`Pasirinktas intervalas: nuo ${args.startDate} iki ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Pasirinktas laikas: ${args.time}`,
    "startDate": `Prad\u{17E}ios data`,
    "timeZoneName": `laiko juosta`,
    "weekday": `savait\u{117}s diena`,
    "year": `metai`
};


var $a0214264dbf65f4b$export$2e2bcd8739ae039 = {};
$a0214264dbf65f4b$export$2e2bcd8739ae039 = {
    "calendar": `Kalend\u{101}rs`,
    "day": `diena`,
    "dayPeriod": `priek\u{161}pusdien\u{101}/p\u{113}cpusdien\u{101}`,
    "endDate": `Beigu datums`,
    "era": `\u{113}ra`,
    "hour": `stundas`,
    "minute": `min\u{16B}tes`,
    "month": `m\u{113}nesis`,
    "second": `sekundes`,
    "selectedDateDescription": (args)=>`Atlas\u{12B}tais datums: ${args.date}`,
    "selectedRangeDescription": (args)=>`Atlas\u{12B}tais diapazons: no ${args.startDate} l\u{12B}dz ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Atlas\u{12B}tais laiks: ${args.time}`,
    "startDate": `S\u{101}kuma datums`,
    "timeZoneName": `laika josla`,
    "weekday": `ned\u{113}\u{13C}as diena`,
    "year": `gads`
};


var $cf510b2cd792b2bb$export$2e2bcd8739ae039 = {};
$cf510b2cd792b2bb$export$2e2bcd8739ae039 = {
    "calendar": `Kalender`,
    "day": `dag`,
    "dayPeriod": `a.m./p.m.`,
    "endDate": `Sluttdato`,
    "era": `tidsalder`,
    "hour": `time`,
    "minute": `minutt`,
    "month": `m\xe5ned`,
    "second": `sekund`,
    "selectedDateDescription": (args)=>`Valgt dato: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valgt omr\xe5de: ${args.startDate} til ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Valgt tid: ${args.time}`,
    "startDate": `Startdato`,
    "timeZoneName": `tidssone`,
    "weekday": `ukedag`,
    "year": `\xe5r`
};


var $c0c1fdb8b30bf9e3$export$2e2bcd8739ae039 = {};
$c0c1fdb8b30bf9e3$export$2e2bcd8739ae039 = {
    "calendar": `Kalender`,
    "day": `dag`,
    "dayPeriod": `a.m./p.m.`,
    "endDate": `Einddatum`,
    "era": `tijdperk`,
    "hour": `uur`,
    "minute": `minuut`,
    "month": `maand`,
    "second": `seconde`,
    "selectedDateDescription": (args)=>`Geselecteerde datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Geselecteerd bereik: ${args.startDate} tot ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Geselecteerde tijd: ${args.time}`,
    "startDate": `Startdatum`,
    "timeZoneName": `tijdzone`,
    "weekday": `dag van de week`,
    "year": `jaar`
};


var $5dfca2378177f161$export$2e2bcd8739ae039 = {};
$5dfca2378177f161$export$2e2bcd8739ae039 = {
    "calendar": `Kalendarz`,
    "day": `dzie\u{144}`,
    "dayPeriod": `rano / po po\u{142}udniu / wieczorem`,
    "endDate": `Data ko\u{144}cowa`,
    "era": `era`,
    "hour": `godzina`,
    "minute": `minuta`,
    "month": `miesi\u{105}c`,
    "second": `sekunda`,
    "selectedDateDescription": (args)=>`Wybrana data: ${args.date}`,
    "selectedRangeDescription": (args)=>`Wybrany zakres: ${args.startDate} do ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Wybrany czas: ${args.time}`,
    "startDate": `Data pocz\u{105}tkowa`,
    "timeZoneName": `strefa czasowa`,
    "weekday": `dzie\u{144} tygodnia`,
    "year": `rok`
};


var $ae59cecd404f76b8$export$2e2bcd8739ae039 = {};
$ae59cecd404f76b8$export$2e2bcd8739ae039 = {
    "calendar": `Calend\xe1rio`,
    "day": `dia`,
    "dayPeriod": `AM/PM`,
    "endDate": `Data final`,
    "era": `era`,
    "hour": `hora`,
    "minute": `minuto`,
    "month": `m\xeas`,
    "second": `segundo`,
    "selectedDateDescription": (args)=>`Data selecionada: ${args.date}`,
    "selectedRangeDescription": (args)=>`Intervalo selecionado: ${args.startDate} a ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Hora selecionada: ${args.time}`,
    "startDate": `Data inicial`,
    "timeZoneName": `fuso hor\xe1rio`,
    "weekday": `dia da semana`,
    "year": `ano`
};


var $b1d31aa5c5e53ade$export$2e2bcd8739ae039 = {};
$b1d31aa5c5e53ade$export$2e2bcd8739ae039 = {
    "calendar": `Calend\xe1rio`,
    "day": `dia`,
    "dayPeriod": `am/pm`,
    "endDate": `Data de T\xe9rmino`,
    "era": `era`,
    "hour": `hora`,
    "minute": `minuto`,
    "month": `m\xeas`,
    "second": `segundo`,
    "selectedDateDescription": (args)=>`Data selecionada: ${args.date}`,
    "selectedRangeDescription": (args)=>`Intervalo selecionado: ${args.startDate} a ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Hora selecionada: ${args.time}`,
    "startDate": `Data de In\xedcio`,
    "timeZoneName": `fuso hor\xe1rio`,
    "weekday": `dia da semana`,
    "year": `ano`
};


var $f32d0eea6b72e54d$export$2e2bcd8739ae039 = {};
$f32d0eea6b72e54d$export$2e2bcd8739ae039 = {
    "calendar": `Calendar`,
    "day": `zi`,
    "dayPeriod": `a.m/p.m.`,
    "endDate": `Dat\u{103} final`,
    "era": `er\u{103}`,
    "hour": `or\u{103}`,
    "minute": `minut`,
    "month": `lun\u{103}`,
    "second": `secund\u{103}`,
    "selectedDateDescription": (args)=>`Dat\u{103} selectat\u{103}: ${args.date}`,
    "selectedRangeDescription": (args)=>`Interval selectat: de la ${args.startDate} p\xe2n\u{103} la ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Ora selectat\u{103}: ${args.time}`,
    "startDate": `Dat\u{103} \xeenceput`,
    "timeZoneName": `fus orar`,
    "weekday": `ziua din s\u{103}pt\u{103}m\xe2n\u{103}`,
    "year": `an`
};


var $e07969c6b77ca604$export$2e2bcd8739ae039 = {};
$e07969c6b77ca604$export$2e2bcd8739ae039 = {
    "calendar": `\u{41A}\u{430}\u{43B}\u{435}\u{43D}\u{434}\u{430}\u{440}\u{44C}`,
    "day": `\u{434}\u{435}\u{43D}\u{44C}`,
    "dayPeriod": `AM/PM`,
    "endDate": `\u{414}\u{430}\u{442}\u{430} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F}`,
    "era": `\u{44D}\u{440}\u{430}`,
    "hour": `\u{447}\u{430}\u{441}`,
    "minute": `\u{43C}\u{438}\u{43D}\u{443}\u{442}\u{430}`,
    "month": `\u{43C}\u{435}\u{441}\u{44F}\u{446}`,
    "second": `\u{441}\u{435}\u{43A}\u{443}\u{43D}\u{434}\u{430}`,
    "selectedDateDescription": (args)=>`\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{430}\u{44F} \u{434}\u{430}\u{442}\u{430}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{439} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}: \u{441} ${args.startDate} \u{43F}\u{43E} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{43E}\u{435} \u{432}\u{440}\u{435}\u{43C}\u{44F}: ${args.time}`,
    "startDate": `\u{414}\u{430}\u{442}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430}`,
    "timeZoneName": `\u{447}\u{430}\u{441}\u{43E}\u{432}\u{43E}\u{439} \u{43F}\u{43E}\u{44F}\u{441}`,
    "weekday": `\u{434}\u{435}\u{43D}\u{44C} \u{43D}\u{435}\u{434}\u{435}\u{43B}\u{438}`,
    "year": `\u{433}\u{43E}\u{434}`
};


var $32b6388efe377850$export$2e2bcd8739ae039 = {};
$32b6388efe377850$export$2e2bcd8739ae039 = {
    "calendar": `Kalend\xe1r`,
    "day": `de\u{148}`,
    "dayPeriod": `AM/PM`,
    "endDate": `D\xe1tum ukon\u{10D}enia`,
    "era": `letopo\u{10D}et`,
    "hour": `hodina`,
    "minute": `min\xfata`,
    "month": `mesiac`,
    "second": `sekunda`,
    "selectedDateDescription": (args)=>`Vybrat\xfd d\xe1tum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Vybrat\xfd rozsah: od ${args.startDate} do ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Vybrat\xfd \u{10D}as: ${args.time}`,
    "startDate": `D\xe1tum za\u{10D}atia`,
    "timeZoneName": `\u{10D}asov\xe9 p\xe1smo`,
    "weekday": `de\u{148} t\xfd\u{17E}d\u{148}a`,
    "year": `rok`
};


var $5030d45943fed8b3$export$2e2bcd8739ae039 = {};
$5030d45943fed8b3$export$2e2bcd8739ae039 = {
    "calendar": `Koledar`,
    "day": `dan`,
    "dayPeriod": `dop/pop`,
    "endDate": `Datum konca`,
    "era": `doba`,
    "hour": `ura`,
    "minute": `minuta`,
    "month": `mesec`,
    "second": `sekunda`,
    "selectedDateDescription": (args)=>`Izbrani datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Izbrano obmo\u{10D}je: ${args.startDate} do ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Izbrani \u{10D}as: ${args.time}`,
    "startDate": `Datum za\u{10D}etka`,
    "timeZoneName": `\u{10D}asovni pas`,
    "weekday": `dan v tednu`,
    "year": `leto`
};


var $25cd6f19f5c9752d$export$2e2bcd8739ae039 = {};
$25cd6f19f5c9752d$export$2e2bcd8739ae039 = {
    "calendar": `Kalendar`,
    "day": `\u{434}\u{430}\u{43D}`,
    "dayPeriod": `\u{43F}\u{440}\u{435} \u{43F}\u{43E}\u{434}\u{43D}\u{435}/\u{43F}\u{43E} \u{43F}\u{43E}\u{434}\u{43D}\u{435}`,
    "endDate": `Datum zavr\u{161}etka`,
    "era": `\u{435}\u{440}\u{430}`,
    "hour": `\u{441}\u{430}\u{442}`,
    "minute": `\u{43C}\u{438}\u{43D}\u{443}\u{442}`,
    "month": `\u{43C}\u{435}\u{441}\u{435}\u{446}`,
    "second": `\u{441}\u{435}\u{43A}\u{443}\u{43D}\u{434}`,
    "selectedDateDescription": (args)=>`Izabrani datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Izabrani opseg: od ${args.startDate} do ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Izabrano vreme: ${args.time}`,
    "startDate": `Datum po\u{10D}etka`,
    "timeZoneName": `\u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{441}\u{43A}\u{430} \u{437}\u{43E}\u{43D}\u{430}`,
    "weekday": `\u{434}\u{430}\u{43D} \u{443} \u{43D}\u{435}\u{434}\u{435}\u{459}\u{438}`,
    "year": `\u{433}\u{43E}\u{434}\u{438}\u{43D}\u{430}`
};


var $d0456ad11c3b043f$export$2e2bcd8739ae039 = {};
$d0456ad11c3b043f$export$2e2bcd8739ae039 = {
    "calendar": `Kalender`,
    "day": `dag`,
    "dayPeriod": `fm/em`,
    "endDate": `Slutdatum`,
    "era": `era`,
    "hour": `timme`,
    "minute": `minut`,
    "month": `m\xe5nad`,
    "second": `sekund`,
    "selectedDateDescription": (args)=>`Valt datum: ${args.date}`,
    "selectedRangeDescription": (args)=>`Valt intervall: ${args.startDate} till ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Vald tid: ${args.time}`,
    "startDate": `Startdatum`,
    "timeZoneName": `tidszon`,
    "weekday": `veckodag`,
    "year": `\xe5r`
};


var $aacae95c79a93cfa$export$2e2bcd8739ae039 = {};
$aacae95c79a93cfa$export$2e2bcd8739ae039 = {
    "calendar": `Takvim`,
    "day": `g\xfcn`,
    "dayPeriod": `\xd6\xd6/\xd6S`,
    "endDate": `Biti\u{15F} Tarihi`,
    "era": `\xe7a\u{11F}`,
    "hour": `saat`,
    "minute": `dakika`,
    "month": `ay`,
    "second": `saniye`,
    "selectedDateDescription": (args)=>`Se\xe7ilen Tarih: ${args.date}`,
    "selectedRangeDescription": (args)=>`Se\xe7ilen Aral\u{131}k: ${args.startDate} - ${args.endDate}`,
    "selectedTimeDescription": (args)=>`Se\xe7ilen Zaman: ${args.time}`,
    "startDate": `Ba\u{15F}lang\u{131}\xe7 Tarihi`,
    "timeZoneName": `saat dilimi`,
    "weekday": `haftan\u{131}n g\xfcn\xfc`,
    "year": `y\u{131}l`
};


var $06c36927c14a7ede$export$2e2bcd8739ae039 = {};
$06c36927c14a7ede$export$2e2bcd8739ae039 = {
    "calendar": `\u{41A}\u{430}\u{43B}\u{435}\u{43D}\u{434}\u{430}\u{440}`,
    "day": `\u{434}\u{435}\u{43D}\u{44C}`,
    "dayPeriod": `\u{434}\u{43F}/\u{43F}\u{43F}`,
    "endDate": `\u{414}\u{430}\u{442}\u{430} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43D}\u{44F}`,
    "era": `\u{435}\u{440}\u{430}`,
    "hour": `\u{433}\u{43E}\u{434}\u{438}\u{43D}\u{430}`,
    "minute": `\u{445}\u{432}\u{438}\u{43B}\u{438}\u{43D}\u{430}`,
    "month": `\u{43C}\u{456}\u{441}\u{44F}\u{446}\u{44C}`,
    "second": `\u{441}\u{435}\u{43A}\u{443}\u{43D}\u{434}\u{430}`,
    "selectedDateDescription": (args)=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}: ${args.date}`,
    "selectedRangeDescription": (args)=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{439} \u{434}\u{456}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}: ${args.startDate} \u{2014} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{439} \u{447}\u{430}\u{441}: ${args.time}`,
    "startDate": `\u{414}\u{430}\u{442}\u{430} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{43A}\u{443}`,
    "timeZoneName": `\u{447}\u{430}\u{441}\u{43E}\u{432}\u{438}\u{439} \u{43F}\u{43E}\u{44F}\u{441}`,
    "weekday": `\u{434}\u{435}\u{43D}\u{44C} \u{442}\u{438}\u{436}\u{43D}\u{44F}`,
    "year": `\u{440}\u{456}\u{43A}`
};


var $d84ad65180831434$export$2e2bcd8739ae039 = {};
$d84ad65180831434$export$2e2bcd8739ae039 = {
    "calendar": `\u{65E5}\u{5386}`,
    "day": `\u{65E5}`,
    "dayPeriod": `\u{4E0A}\u{5348}/\u{4E0B}\u{5348}`,
    "endDate": `\u{7ED3}\u{675F}\u{65E5}\u{671F}`,
    "era": `\u{7EAA}\u{5143}`,
    "hour": `\u{5C0F}\u{65F6}`,
    "minute": `\u{5206}\u{949F}`,
    "month": `\u{6708}`,
    "second": `\u{79D2}`,
    "selectedDateDescription": (args)=>`\u{9009}\u{5B9A}\u{7684}\u{65E5}\u{671F}\u{FF1A}${args.date}`,
    "selectedRangeDescription": (args)=>`\u{9009}\u{5B9A}\u{7684}\u{8303}\u{56F4}\u{FF1A}${args.startDate} \u{81F3} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{9009}\u{5B9A}\u{7684}\u{65F6}\u{95F4}\u{FF1A}${args.time}`,
    "startDate": `\u{5F00}\u{59CB}\u{65E5}\u{671F}`,
    "timeZoneName": `\u{65F6}\u{533A}`,
    "weekday": `\u{5DE5}\u{4F5C}\u{65E5}`,
    "year": `\u{5E74}`
};


var $c5f062667975d202$export$2e2bcd8739ae039 = {};
$c5f062667975d202$export$2e2bcd8739ae039 = {
    "calendar": `\u{65E5}\u{66C6}`,
    "day": `\u{65E5}`,
    "dayPeriod": `\u{4E0A}\u{5348}/\u{4E0B}\u{5348}`,
    "endDate": `\u{7D50}\u{675F}\u{65E5}\u{671F}`,
    "era": `\u{7EAA}\u{5143}`,
    "hour": `\u{5C0F}\u{65F6}`,
    "minute": `\u{5206}\u{949F}`,
    "month": `\u{6708}`,
    "second": `\u{79D2}`,
    "selectedDateDescription": (args)=>`\u{9078}\u{5B9A}\u{7684}\u{65E5}\u{671F}\u{FF1A}${args.date}`,
    "selectedRangeDescription": (args)=>`\u{9078}\u{5B9A}\u{7684}\u{7BC4}\u{570D}\u{FF1A}${args.startDate} \u{81F3} ${args.endDate}`,
    "selectedTimeDescription": (args)=>`\u{9078}\u{5B9A}\u{7684}\u{6642}\u{9593}\u{FF1A}${args.time}`,
    "startDate": `\u{958B}\u{59CB}\u{65E5}\u{671F}`,
    "timeZoneName": `\u{65F6}\u{533A}`,
    "weekday": `\u{5DE5}\u{4F5C}\u{65E5}`,
    "year": `\u{5E74}`
};


var $298e7b902e1fbdc0$export$2e2bcd8739ae039 = {};
$298e7b902e1fbdc0$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $2251f9680a0ba75b$export$2e2bcd8739ae039),
    "bg-BG": (0, $39373b69a5439375$export$2e2bcd8739ae039),
    "cs-CZ": (0, $5acbbb221c65a23b$export$2e2bcd8739ae039),
    "da-DK": (0, $9cdd126680428a42$export$2e2bcd8739ae039),
    "de-DE": (0, $40e356c0f9432c15$export$2e2bcd8739ae039),
    "el-GR": (0, $7705ab87b687774e$export$2e2bcd8739ae039),
    "en-US": (0, $64ea6d91b60fcfc3$export$2e2bcd8739ae039),
    "es-ES": (0, $1126aa38eb661cec$export$2e2bcd8739ae039),
    "et-EE": (0, $bed2ee99d1bc6b87$export$2e2bcd8739ae039),
    "fi-FI": (0, $eac22fa260e9502c$export$2e2bcd8739ae039),
    "fr-FR": (0, $a5edca4a285d9e4d$export$2e2bcd8739ae039),
    "he-IL": (0, $1f768739a9a83be1$export$2e2bcd8739ae039),
    "hr-HR": (0, $695b93f8d1020069$export$2e2bcd8739ae039),
    "hu-HU": (0, $2cf6b3eecb530d83$export$2e2bcd8739ae039),
    "it-IT": (0, $e8edc3756e2f9c47$export$2e2bcd8739ae039),
    "ja-JP": (0, $5d3b85672e21cfdb$export$2e2bcd8739ae039),
    "ko-KR": (0, $ef645eeb2ad25acb$export$2e2bcd8739ae039),
    "lt-LT": (0, $cd831d1387fa2849$export$2e2bcd8739ae039),
    "lv-LV": (0, $a0214264dbf65f4b$export$2e2bcd8739ae039),
    "nb-NO": (0, $cf510b2cd792b2bb$export$2e2bcd8739ae039),
    "nl-NL": (0, $c0c1fdb8b30bf9e3$export$2e2bcd8739ae039),
    "pl-PL": (0, $5dfca2378177f161$export$2e2bcd8739ae039),
    "pt-BR": (0, $ae59cecd404f76b8$export$2e2bcd8739ae039),
    "pt-PT": (0, $b1d31aa5c5e53ade$export$2e2bcd8739ae039),
    "ro-RO": (0, $f32d0eea6b72e54d$export$2e2bcd8739ae039),
    "ru-RU": (0, $e07969c6b77ca604$export$2e2bcd8739ae039),
    "sk-SK": (0, $32b6388efe377850$export$2e2bcd8739ae039),
    "sl-SI": (0, $5030d45943fed8b3$export$2e2bcd8739ae039),
    "sr-SP": (0, $25cd6f19f5c9752d$export$2e2bcd8739ae039),
    "sv-SE": (0, $d0456ad11c3b043f$export$2e2bcd8739ae039),
    "tr-TR": (0, $aacae95c79a93cfa$export$2e2bcd8739ae039),
    "uk-UA": (0, $06c36927c14a7ede$export$2e2bcd8739ae039),
    "zh-CN": (0, $d84ad65180831434$export$2e2bcd8739ae039),
    "zh-TW": (0, $c5f062667975d202$export$2e2bcd8739ae039)
};






var $acw62 = parcelRequire("acw62");

function $f9e2ed52c63620c2$export$4a931266a3838b86(state, ref, disableArrowNavigation) {
    let { direction: direction } = (0, $a7e3b1109bf64033$export$43bb16f9c6d9e3f7)();
    let focusManager = (0, $acw62.useMemo)(()=>(0, $dd1b249b49caa281$export$c5251b9e124bf29)(ref), [
        ref
    ]);
    // Open the popover on alt + arrow down
    let onKeyDown = (e)=>{
        if (!e.currentTarget.contains(e.target)) return;
        if (e.altKey && (e.key === 'ArrowDown' || e.key === 'ArrowUp') && 'setOpen' in state) {
            e.preventDefault();
            e.stopPropagation();
            state.setOpen(true);
        }
        if (disableArrowNavigation) return;
        switch(e.key){
            case 'ArrowLeft':
                e.preventDefault();
                e.stopPropagation();
                if (direction === 'rtl') {
                    if (ref.current) {
                        let target = e.target;
                        let prev = $f9e2ed52c63620c2$var$$3dfb0f96be0d6a08$var$findNextSegment(ref.current, target.getBoundingClientRect().left, -1);
                        if (prev) prev.focus();
                    }
                } else focusManager.focusPrevious();
                break;
            case 'ArrowRight':
                e.preventDefault();
                e.stopPropagation();
                if (direction === 'rtl') {
                    if (ref.current) {
                        let target = e.target;
                        let next = $f9e2ed52c63620c2$var$$3dfb0f96be0d6a08$var$findNextSegment(ref.current, target.getBoundingClientRect().left, 1);
                        if (next) next.focus();
                    }
                } else focusManager.focusNext();
                break;
        }
    };
    // Focus the first placeholder segment from the end on mouse down/touch up in the field.
    let focusLast = ()=>{
        var _window_event;
        if (!ref.current) return;
        // Try to find the segment prior to the element that was clicked on.
        let target = (_window_event = window.event) === null || _window_event === void 0 ? void 0 : _window_event.target;
        let walker = (0, $dd1b249b49caa281$export$2d6ec8fc375ceafa)(ref.current, {
            tabbable: true
        });
        if (target) {
            walker.currentNode = target;
            target = walker.previousNode();
        }
        // If no target found, find the last element from the end.
        if (!target) {
            let last;
            do {
                last = walker.lastChild();
                if (last) target = last;
            }while (last);
        }
        // Now go backwards until we find an element that is not a placeholder.
        while(target === null || target === void 0 ? void 0 : target.hasAttribute('data-placeholder')){
            let prev = walker.previousNode();
            if (prev && prev.hasAttribute('data-placeholder')) target = prev;
            else break;
        }
        if (target) target.focus();
    };
    let { pressProps: pressProps } = (0, $6c43aa319e86785e$export$45712eceda6fad21)({
        preventFocusOnPress: true,
        allowTextSelectionOnPress: true,
        onPressStart (e) {
            if (e.pointerType === 'mouse') focusLast();
        },
        onPress (e) {
            if (e.pointerType === 'touch' || e.pointerType === 'pen') focusLast();
        }
    });
    return (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(pressProps, {
        onKeyDown: onKeyDown
    });
}
function $f9e2ed52c63620c2$var$$3dfb0f96be0d6a08$var$findNextSegment(group, fromX, direction) {
    let walker = (0, $dd1b249b49caa281$export$2d6ec8fc375ceafa)(group, {
        tabbable: true
    });
    let node = walker.nextNode();
    let closest = null;
    let closestDistance = Infinity;
    while(node){
        let x = node.getBoundingClientRect().left;
        let distance = x - fromX;
        let absoluteDistance = Math.abs(distance);
        if (Math.sign(distance) === direction && absoluteDistance < closestDistance) {
            closest = node;
            closestDistance = absoluteDistance;
        }
        node = walker.nextNode();
    }
    return closest;
}





var $acw62 = parcelRequire("acw62");




function $6a062e87893a747c$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6a062e87893a747c$export$653eddfc964b0f8a = new WeakMap();
const $6a062e87893a747c$export$300019f83c56d282 = '__role_' + Date.now();
const $6a062e87893a747c$export$7b3062cd49e80452 = '__focusManager_' + Date.now();
function $6a062e87893a747c$export$5591b0b878c1a989(props, state, ref) {
    var _state_value;
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $54c383c3558c03c1$export$294aa081a6c6f55d)({
        ...props,
        labelElementType: 'span',
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let valueOnFocus = (0, $acw62.useRef)(null);
    let { focusWithinProps: focusWithinProps } = (0, $02fb4773760e27fa$export$420e68273165f4ec)({
        ...props,
        onFocusWithin (e) {
            var _props_onFocus;
            valueOnFocus.current = state.value;
            (_props_onFocus = props.onFocus) === null || _props_onFocus === void 0 || _props_onFocus.call(props, e);
        },
        onBlurWithin: (e)=>{
            var _props_onBlur;
            state.confirmPlaceholder();
            if (state.value !== valueOnFocus.current) state.commitValidation();
            (_props_onBlur = props.onBlur) === null || _props_onBlur === void 0 || _props_onBlur.call(props, e);
        },
        onFocusWithinChange: props.onFocusChange
    });
    let stringFormatter = (0, $3681d06d99b0f841$export$f12b703ca79dfbb1)($6a062e87893a747c$var$$parcel$interopDefault((0, $298e7b902e1fbdc0$export$2e2bcd8739ae039)), '@react-aria/datepicker');
    let message = state.maxGranularity === 'hour' ? 'selectedTimeDescription' : 'selectedDateDescription';
    let field = state.maxGranularity === 'hour' ? 'time' : 'date';
    let description = state.value ? stringFormatter.format(message, {
        [field]: state.formatValue({
            month: 'long'
        })
    }) : '';
    let descProps = (0, $633963a23b08716a$export$f8aeda7b10753fa1)(description);
    // If within a date picker or date range picker, the date field will have role="presentation" and an aria-describedby
    // will be passed in that references the value (e.g. entire range). Otherwise, add the field's value description.
    let describedBy = props[$6a062e87893a747c$export$300019f83c56d282] === 'presentation' ? fieldProps['aria-describedby'] : [
        descProps['aria-describedby'],
        fieldProps['aria-describedby']
    ].filter(Boolean).join(' ') || undefined;
    let propsFocusManager = props[$6a062e87893a747c$export$7b3062cd49e80452];
    let focusManager = (0, $acw62.useMemo)(()=>propsFocusManager || (0, $dd1b249b49caa281$export$c5251b9e124bf29)(ref), [
        propsFocusManager,
        ref
    ]);
    let groupProps = (0, $f9e2ed52c63620c2$export$4a931266a3838b86)(state, ref, props[$6a062e87893a747c$export$300019f83c56d282] === 'presentation');
    // Pass labels and other information to segments.
    $6a062e87893a747c$export$653eddfc964b0f8a.set(state, {
        ariaLabel: props['aria-label'],
        ariaLabelledBy: [
            labelProps.id,
            props['aria-labelledby']
        ].filter(Boolean).join(' ') || undefined,
        ariaDescribedBy: describedBy,
        focusManager: focusManager
    });
    let autoFocusRef = (0, $acw62.useRef)(props.autoFocus);
    // When used within a date picker or date range picker, the field gets role="presentation"
    // rather than role="group". Since the date picker/date range picker already has a role="group"
    // with a label and description, and the segments are already labeled by this as well, this
    // avoids very verbose duplicate announcements.
    let fieldDOMProps;
    if (props[$6a062e87893a747c$export$300019f83c56d282] === 'presentation') fieldDOMProps = {
        role: 'presentation'
    };
    else fieldDOMProps = (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(fieldProps, {
        role: 'group',
        'aria-disabled': props.isDisabled || undefined,
        'aria-describedby': describedBy
    });
    (0, $acw62.useEffect)(()=>{
        if (autoFocusRef.current) focusManager.focusFirst();
        autoFocusRef.current = false;
    }, [
        focusManager
    ]);
    (0, $7f099d759e9c1e4d$export$5add1d006293d136)(props.inputRef, state.defaultValue, state.setValue);
    (0, $13ce3eede8664ea0$export$b8473d3665f3a75a)({
        ...props,
        focus () {
            focusManager.focusFirst();
        }
    }, state, props.inputRef);
    let inputProps = {
        type: 'hidden',
        name: props.name,
        form: props.form,
        value: ((_state_value = state.value) === null || _state_value === void 0 ? void 0 : _state_value.toString()) || '',
        disabled: props.isDisabled
    };
    if (props.validationBehavior === 'native') {
        // Use a hidden <input type="text"> rather than <input type="hidden">
        // so that an empty value blocks HTML form submission when the field is required.
        inputProps.type = 'text';
        inputProps.hidden = true;
        inputProps.required = props.isRequired;
        // Ignore react warning.
        inputProps.onChange = ()=>{};
    }
    let domProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props);
    return {
        labelProps: {
            ...labelProps,
            onClick: ()=>{
                focusManager.focusFirst();
            }
        },
        fieldProps: (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(domProps, fieldDOMProps, groupProps, focusWithinProps, {
            onKeyDown (e) {
                if (props.onKeyDown) props.onKeyDown(e);
            },
            onKeyUp (e) {
                if (props.onKeyUp) props.onKeyUp(e);
            },
            style: {
                unicodeBidi: 'isolate'
            }
        }),
        inputProps: inputProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}
function $6a062e87893a747c$export$4c842f6a241dc825(props, state, ref) {
    var _state_timeValue;
    let res = $6a062e87893a747c$export$5591b0b878c1a989(props, state, ref);
    res.inputProps.value = ((_state_timeValue = state.timeValue) === null || _state_timeValue === void 0 ? void 0 : _state_timeValue.toString()) || '';
    return res;
}





var $acw62 = parcelRequire("acw62");
function $e94f1ecfdf1ef15c$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // @ts-ignore
function $e94f1ecfdf1ef15c$export$d42c60378c8168f8() {
    let { locale: locale } = (0, $a7e3b1109bf64033$export$43bb16f9c6d9e3f7)();
    let dictionary = (0, $3681d06d99b0f841$export$87b761675e8eaa10)($e94f1ecfdf1ef15c$var$$parcel$interopDefault((0, $298e7b902e1fbdc0$export$2e2bcd8739ae039)), '@react-aria/datepicker');
    return (0, $acw62.useMemo)(()=>{
        // Try to use Intl.DisplayNames if possible. It may be supported in browsers, but not support the dateTimeField
        // type as that was only added in v2. https://github.com/tc39/intl-displaynames-v2
        try {
            return new Intl.DisplayNames(locale, {
                type: 'dateTimeField'
            });
        } catch  {
            return new $e94f1ecfdf1ef15c$var$$3aeceb3a64eb8358$var$DisplayNamesPolyfill(locale, dictionary);
        }
    }, [
        locale,
        dictionary
    ]);
}
class $e94f1ecfdf1ef15c$var$$3aeceb3a64eb8358$var$DisplayNamesPolyfill {
    of(field) {
        return this.dictionary.getStringForLocale(field, this.locale);
    }
    constructor(locale, dictionary){
        this.locale = locale;
        this.dictionary = dictionary;
    }
}





/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $f764810b880bba05$var$$6c7bd7858deea686$var$CURRENCY_SIGN_REGEX = new RegExp('^.*\\(.*\\).*$');
const $f764810b880bba05$var$$6c7bd7858deea686$var$NUMBERING_SYSTEMS = [
    'latn',
    'arab',
    'hanidec',
    'deva',
    'beng',
    'fullwide'
];
class $f764810b880bba05$export$cd11ab140839f11d {
    /**
   * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
   */ parse(value) {
        return $f764810b880bba05$var$$6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).parse(value);
    }
    /**
   * Returns whether the given string could potentially be a valid number. This should be used to
   * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
   * of the minus/plus sign characters can be checked.
   */ isValidPartialNumber(value, minValue, maxValue) {
        return $f764810b880bba05$var$$6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).isValidPartialNumber(value, minValue, maxValue);
    }
    /**
   * Returns a numbering system for which the given string is valid in the current locale.
   * If no numbering system could be detected, the default numbering system for the current
   * locale is returned.
   */ getNumberingSystem(value) {
        return $f764810b880bba05$var$$6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).options.numberingSystem;
    }
    constructor(locale, options = {}){
        this.locale = locale;
        this.options = options;
    }
}
const $f764810b880bba05$var$$6c7bd7858deea686$var$numberParserCache = new Map();
function $f764810b880bba05$var$$6c7bd7858deea686$var$getNumberParserImpl(locale, options, value) {
    // First try the default numbering system for the provided locale
    let defaultParser = $f764810b880bba05$var$$6c7bd7858deea686$var$getCachedNumberParser(locale, options);
    // If that doesn't match, and the locale doesn't include a hard coded numbering system,
    // try each of the other supported numbering systems until we find one that matches.
    if (!locale.includes('-nu-') && !defaultParser.isValidPartialNumber(value)) {
        for (let numberingSystem of $f764810b880bba05$var$$6c7bd7858deea686$var$NUMBERING_SYSTEMS)if (numberingSystem !== defaultParser.options.numberingSystem) {
            let parser = $f764810b880bba05$var$$6c7bd7858deea686$var$getCachedNumberParser(locale + (locale.includes('-u-') ? '-nu-' : '-u-nu-') + numberingSystem, options);
            if (parser.isValidPartialNumber(value)) return parser;
        }
    }
    return defaultParser;
}
function $f764810b880bba05$var$$6c7bd7858deea686$var$getCachedNumberParser(locale, options) {
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : '');
    let parser = $f764810b880bba05$var$$6c7bd7858deea686$var$numberParserCache.get(cacheKey);
    if (!parser) {
        parser = new $f764810b880bba05$var$$6c7bd7858deea686$var$NumberParserImpl(locale, options);
        $f764810b880bba05$var$$6c7bd7858deea686$var$numberParserCache.set(cacheKey, parser);
    }
    return parser;
}
// The actual number parser implementation. Instances of this class are cached
// based on the locale, options, and detected numbering system.
class $f764810b880bba05$var$$6c7bd7858deea686$var$NumberParserImpl {
    parse(value) {
        // to parse the number, we need to remove anything that isn't actually part of the number, for example we want '-10.40' not '-10.40 USD'
        let fullySanitizedValue = this.sanitize(value);
        if (this.symbols.group) fullySanitizedValue = $f764810b880bba05$var$$6c7bd7858deea686$var$replaceAll(fullySanitizedValue, this.symbols.group, '');
        if (this.symbols.decimal) fullySanitizedValue = fullySanitizedValue.replace(this.symbols.decimal, '.');
        if (this.symbols.minusSign) fullySanitizedValue = fullySanitizedValue.replace(this.symbols.minusSign, '-');
        fullySanitizedValue = fullySanitizedValue.replace(this.symbols.numeral, this.symbols.index);
        if (this.options.style === 'percent') {
            // javascript is bad at dividing by 100 and maintaining the same significant figures, so perform it on the string before parsing
            let isNegative = fullySanitizedValue.indexOf('-');
            fullySanitizedValue = fullySanitizedValue.replace('-', '');
            fullySanitizedValue = fullySanitizedValue.replace('+', '');
            let index = fullySanitizedValue.indexOf('.');
            if (index === -1) index = fullySanitizedValue.length;
            fullySanitizedValue = fullySanitizedValue.replace('.', '');
            if (index - 2 === 0) fullySanitizedValue = `0.${fullySanitizedValue}`;
            else if (index - 2 === -1) fullySanitizedValue = `0.0${fullySanitizedValue}`;
            else if (index - 2 === -2) fullySanitizedValue = '0.00';
            else fullySanitizedValue = `${fullySanitizedValue.slice(0, index - 2)}.${fullySanitizedValue.slice(index - 2)}`;
            if (isNegative > -1) fullySanitizedValue = `-${fullySanitizedValue}`;
        }
        let newValue = fullySanitizedValue ? +fullySanitizedValue : NaN;
        if (isNaN(newValue)) return NaN;
        if (this.options.style === 'percent') {
            var _this_options_minimumFractionDigits, _this_options_maximumFractionDigits;
            // extra step for rounding percents to what our formatter would output
            let options = {
                ...this.options,
                style: 'decimal',
                minimumFractionDigits: Math.min(((_this_options_minimumFractionDigits = this.options.minimumFractionDigits) !== null && _this_options_minimumFractionDigits !== void 0 ? _this_options_minimumFractionDigits : 0) + 2, 20),
                maximumFractionDigits: Math.min(((_this_options_maximumFractionDigits = this.options.maximumFractionDigits) !== null && _this_options_maximumFractionDigits !== void 0 ? _this_options_maximumFractionDigits : 0) + 2, 20)
            };
            return new $f764810b880bba05$export$cd11ab140839f11d(this.locale, options).parse(new (0, $14359adf615d4bd8$export$cc77c4ff7e8673c5)(this.locale, options).format(newValue));
        }
        // accounting will always be stripped to a positive number, so if it's accounting and has a () around everything, then we need to make it negative again
        if (this.options.currencySign === 'accounting' && $f764810b880bba05$var$$6c7bd7858deea686$var$CURRENCY_SIGN_REGEX.test(value)) newValue = -1 * newValue;
        return newValue;
    }
    sanitize(value) {
        // Remove literals and whitespace, which are allowed anywhere in the string
        value = value.replace(this.symbols.literals, '');
        // Replace the ASCII minus sign with the minus sign used in the current locale
        // so that both are allowed in case the user's keyboard doesn't have the locale's minus sign.
        if (this.symbols.minusSign) value = value.replace('-', this.symbols.minusSign);
        // In arab numeral system, their decimal character is 1643, but most keyboards don't type that
        // instead they use the , (44) character or apparently the (1548) character.
        if (this.options.numberingSystem === 'arab') {
            if (this.symbols.decimal) {
                value = value.replace(',', this.symbols.decimal);
                value = value.replace(String.fromCharCode(1548), this.symbols.decimal);
            }
            if (this.symbols.group) value = $f764810b880bba05$var$$6c7bd7858deea686$var$replaceAll(value, '.', this.symbols.group);
        }
        // In some locale styles, such as swiss currency, the group character can be a special single quote
        // that keyboards don't typically have. This expands the character to include the easier to type single quote.
        if (this.symbols.group === "\u2019" && value.includes("'")) value = $f764810b880bba05$var$$6c7bd7858deea686$var$replaceAll(value, "'", this.symbols.group);
        // fr-FR group character is narrow non-breaking space, char code 8239 (U+202F), but that's not a key on the french keyboard,
        // so allow space and non-breaking space as a group char as well
        if (this.options.locale === 'fr-FR' && this.symbols.group) {
            value = $f764810b880bba05$var$$6c7bd7858deea686$var$replaceAll(value, ' ', this.symbols.group);
            value = $f764810b880bba05$var$$6c7bd7858deea686$var$replaceAll(value, /\u00A0/g, this.symbols.group);
        }
        return value;
    }
    isValidPartialNumber(value, minValue = -Infinity, maxValue = Infinity) {
        value = this.sanitize(value);
        // Remove minus or plus sign, which must be at the start of the string.
        if (this.symbols.minusSign && value.startsWith(this.symbols.minusSign) && minValue < 0) value = value.slice(this.symbols.minusSign.length);
        else if (this.symbols.plusSign && value.startsWith(this.symbols.plusSign) && maxValue > 0) value = value.slice(this.symbols.plusSign.length);
        // Numbers cannot start with a group separator
        if (this.symbols.group && value.startsWith(this.symbols.group)) return false;
        // Numbers that can't have any decimal values fail if a decimal character is typed
        if (this.symbols.decimal && value.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0) return false;
        // Remove numerals, groups, and decimals
        if (this.symbols.group) value = $f764810b880bba05$var$$6c7bd7858deea686$var$replaceAll(value, this.symbols.group, '');
        value = value.replace(this.symbols.numeral, '');
        if (this.symbols.decimal) value = value.replace(this.symbols.decimal, '');
        // The number is valid if there are no remaining characters
        return value.length === 0;
    }
    constructor(locale, options = {}){
        this.locale = locale;
        // see https://tc39.es/ecma402/#sec-setnfdigitoptions, when using roundingIncrement, the maximumFractionDigits and minimumFractionDigits must be equal
        // by default, they are 0 and 3 respectively, so we set them to 0 if neither are set
        if (options.roundingIncrement !== 1 && options.roundingIncrement != null) {
            if (options.maximumFractionDigits == null && options.minimumFractionDigits == null) {
                options.maximumFractionDigits = 0;
                options.minimumFractionDigits = 0;
            } else if (options.maximumFractionDigits == null) options.maximumFractionDigits = options.minimumFractionDigits;
            else if (options.minimumFractionDigits == null) options.minimumFractionDigits = options.maximumFractionDigits;
        // if both are specified, let the normal Range Error be thrown
        }
        this.formatter = new Intl.NumberFormat(locale, options);
        this.options = this.formatter.resolvedOptions();
        this.symbols = $f764810b880bba05$var$$6c7bd7858deea686$var$getSymbols(locale, this.formatter, this.options, options);
        var _this_options_minimumFractionDigits, _this_options_maximumFractionDigits;
        if (this.options.style === 'percent' && (((_this_options_minimumFractionDigits = this.options.minimumFractionDigits) !== null && _this_options_minimumFractionDigits !== void 0 ? _this_options_minimumFractionDigits : 0) > 18 || ((_this_options_maximumFractionDigits = this.options.maximumFractionDigits) !== null && _this_options_maximumFractionDigits !== void 0 ? _this_options_maximumFractionDigits : 0) > 18)) console.warn('NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.');
    }
}
const $f764810b880bba05$var$$6c7bd7858deea686$var$nonLiteralParts = new Set([
    'decimal',
    'fraction',
    'integer',
    'minusSign',
    'plusSign',
    'group'
]);
// This list is derived from https://www.unicode.org/cldr/charts/43/supplemental/language_plural_rules.html#comparison and includes
// all unique numbers which we need to check in order to determine all the plural forms for a given locale.
// See: https://github.com/adobe/react-spectrum/pull/5134/files#r1337037855 for used script
const $f764810b880bba05$var$$6c7bd7858deea686$var$pluralNumbers = [
    0,
    4,
    2,
    1,
    11,
    20,
    3,
    7,
    100,
    21,
    0.1,
    1.1
];
function $f764810b880bba05$var$$6c7bd7858deea686$var$getSymbols(locale, formatter, intlOptions, originalOptions) {
    var _allParts_find, _posAllParts_find, _decimalParts_find, _allParts_find1;
    // formatter needs access to all decimal places in order to generate the correct literal strings for the plural set
    let symbolFormatter = new Intl.NumberFormat(locale, {
        ...intlOptions,
        // Resets so we get the full range of symbols
        minimumSignificantDigits: 1,
        maximumSignificantDigits: 21,
        roundingIncrement: 1,
        roundingPriority: 'auto',
        roundingMode: 'halfExpand'
    });
    // Note: some locale's don't add a group symbol until there is a ten thousands place
    let allParts = symbolFormatter.formatToParts(-10000.111);
    let posAllParts = symbolFormatter.formatToParts(10000.111);
    let pluralParts = $f764810b880bba05$var$$6c7bd7858deea686$var$pluralNumbers.map((n)=>symbolFormatter.formatToParts(n));
    var _allParts_find_value;
    let minusSign = (_allParts_find_value = (_allParts_find = allParts.find((p)=>p.type === 'minusSign')) === null || _allParts_find === void 0 ? void 0 : _allParts_find.value) !== null && _allParts_find_value !== void 0 ? _allParts_find_value : '-';
    let plusSign = (_posAllParts_find = posAllParts.find((p)=>p.type === 'plusSign')) === null || _posAllParts_find === void 0 ? void 0 : _posAllParts_find.value;
    // Safari does not support the signDisplay option, but our number parser polyfills it.
    // If no plus sign was returned, but the original options contained signDisplay, default to the '+' character.
    if (!plusSign && ((originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === 'exceptZero' || (originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === 'always')) plusSign = '+';
    // If maximumSignificantDigits is 1 (the minimum) then we won't get decimal characters out of the above formatters
    // Percent also defaults to 0 fractionDigits, so we need to make a new one that isn't percent to get an accurate decimal
    let decimalParts = new Intl.NumberFormat(locale, {
        ...intlOptions,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).formatToParts(0.001);
    let decimal = (_decimalParts_find = decimalParts.find((p)=>p.type === 'decimal')) === null || _decimalParts_find === void 0 ? void 0 : _decimalParts_find.value;
    let group = (_allParts_find1 = allParts.find((p)=>p.type === 'group')) === null || _allParts_find1 === void 0 ? void 0 : _allParts_find1.value;
    // this set is also for a regex, it's all literals that might be in the string we want to eventually parse that
    // don't contribute to the numerical value
    let allPartsLiterals = allParts.filter((p)=>!$f764810b880bba05$var$$6c7bd7858deea686$var$nonLiteralParts.has(p.type)).map((p)=>$f764810b880bba05$var$$6c7bd7858deea686$var$escapeRegex(p.value));
    let pluralPartsLiterals = pluralParts.flatMap((p)=>p.filter((p)=>!$f764810b880bba05$var$$6c7bd7858deea686$var$nonLiteralParts.has(p.type)).map((p)=>$f764810b880bba05$var$$6c7bd7858deea686$var$escapeRegex(p.value)));
    let sortedLiterals = [
        ...new Set([
            ...allPartsLiterals,
            ...pluralPartsLiterals
        ])
    ].sort((a, b)=>b.length - a.length);
    let literals = sortedLiterals.length === 0 ? new RegExp('[\\p{White_Space}]', 'gu') : new RegExp(`${sortedLiterals.join('|')}|[\\p{White_Space}]`, 'gu');
    // These are for replacing non-latn characters with the latn equivalent
    let numerals = [
        ...new Intl.NumberFormat(intlOptions.locale, {
            useGrouping: false
        }).format(9876543210)
    ].reverse();
    let indexes = new Map(numerals.map((d, i)=>[
            d,
            i
        ]));
    let numeral = new RegExp(`[${numerals.join('')}]`, 'g');
    let index = (d)=>String(indexes.get(d));
    return {
        minusSign: minusSign,
        plusSign: plusSign,
        decimal: decimal,
        group: group,
        literals: literals,
        numeral: numeral,
        index: index
    };
}
function $f764810b880bba05$var$$6c7bd7858deea686$var$replaceAll(str, find, replace) {
    if (str.replaceAll) return str.replaceAll(find, replace);
    return str.split(find).join(replace);
}
function $f764810b880bba05$var$$6c7bd7858deea686$var$escapeRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}



var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$formatterCache = new Map();
class $ecbf8fbbe677b7c2$export$ad991b66133851cf {
    /** Formats a date as a string according to the locale and format options passed to the constructor. */ format(value) {
        return this.formatter.format(value);
    }
    /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */ formatToParts(value) {
        return this.formatter.formatToParts(value);
    }
    /** Formats a date range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRange === 'function') return this.formatter.formatRange(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        // Very basic fallback for old browsers.
        return `${this.formatter.format(start)} \u{2013} ${this.formatter.format(end)}`;
    }
    /** Formats a date range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRangeToParts === 'function') return this.formatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        let startParts = this.formatter.formatToParts(start);
        let endParts = this.formatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: 'startRange'
                })),
            {
                type: 'literal',
                value: " \u2013 ",
                source: 'shared'
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: 'endRange'
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let resolvedOptions = this.formatter.resolvedOptions();
        if ($ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$hasBuggyResolvedHourCycle()) {
            if (!this.resolvedHourCycle) this.resolvedHourCycle = $ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$getResolvedHourCycle(resolvedOptions.locale, this.options);
            resolvedOptions.hourCycle = this.resolvedHourCycle;
            resolvedOptions.hour12 = this.resolvedHourCycle === 'h11' || this.resolvedHourCycle === 'h12';
        }
        // Safari uses a different name for the Ethiopic (Amete Alem) calendar.
        // https://bugs.webkit.org/show_bug.cgi?id=241564
        if (resolvedOptions.calendar === 'ethiopic-amete-alem') resolvedOptions.calendar = 'ethioaa';
        return resolvedOptions;
    }
    constructor(locale, options = {}){
        this.formatter = $ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, options);
        this.options = options;
    }
}
// There are multiple bugs involving the hour12 and hourCycle options in various browser engines.
//   - Chrome [1] (and the ECMA 402 spec [2]) resolve hour12: false in English and other locales to h24 (24:00 - 23:59)
//     rather than h23 (00:00 - 23:59). Same can happen with hour12: true in French, which Chrome resolves to h11 (00:00 - 11:59)
//     rather than h12 (12:00 - 11:59).
//   - WebKit returns an incorrect hourCycle resolved option in the French locale due to incorrect parsing of 'h' literal
//     in the resolved pattern. It also formats incorrectly when specifying the hourCycle option for the same reason. [3]
// [1] https://bugs.chromium.org/p/chromium/issues/detail?id=1045791
// [2] https://github.com/tc39/ecma402/issues/402
// [3] https://bugs.webkit.org/show_bug.cgi?id=229313
// https://github.com/unicode-org/cldr/blob/018b55eff7ceb389c7e3fc44e2f657eae3b10b38/common/supplemental/supplementalData.xml#L4774-L4802
const $ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$hour12Preferences = {
    true: {
        // Only Japanese uses the h11 style for 12 hour time. All others use h12.
        ja: 'h11'
    },
    false: {}
};
function $ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, options = {}) {
    // Work around buggy hour12 behavior in Chrome / ECMA 402 spec by using hourCycle instead.
    // Only apply the workaround if the issue is detected, because the hourCycle option is buggy in Safari.
    if (typeof options.hour12 === 'boolean' && $ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$hasBuggyHour12Behavior()) {
        options = {
            ...options
        };
        let pref = $ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$hour12Preferences[String(options.hour12)][locale.split('-')[0]];
        let defaultHourCycle = options.hour12 ? 'h12' : 'h23';
        options.hourCycle = pref !== null && pref !== void 0 ? pref : defaultHourCycle;
        delete options.hour12;
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : '');
    if ($ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$formatterCache.has(cacheKey)) return $ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.DateTimeFormat(locale, options);
    $ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
let $ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior = null;
function $ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$hasBuggyHour12Behavior() {
    if ($ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior == null) $ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        hour12: false
    }).format(new Date(2020, 2, 3, 0)) === '24';
    return $ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior;
}
let $ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = null;
function $ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$hasBuggyResolvedHourCycle() {
    if ($ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle == null) $ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = new Intl.DateTimeFormat('fr', {
        hour: 'numeric',
        hour12: false
    }).resolvedOptions().hourCycle === 'h12';
    return $ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle;
}
function $ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$getResolvedHourCycle(locale, options) {
    if (!options.timeStyle && !options.hour) return undefined;
    // Work around buggy results in resolved hourCycle and hour12 options in WebKit.
    // Format the minimum possible hour and maximum possible hour in a day and parse the results.
    locale = locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, '');
    locale += (locale.includes('-u-') ? '' : '-u') + '-nu-latn';
    let formatter = $ecbf8fbbe677b7c2$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, {
        ...options,
        timeZone: undefined // use local timezone
    });
    let min = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 0)).find((p)=>p.type === 'hour').value, 10);
    let max = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 23)).find((p)=>p.type === 'hour').value, 10);
    if (min === 0 && max === 23) return 'h23';
    if (min === 24 && max === 23) return 'h24';
    if (min === 0 && max === 11) return 'h11';
    if (min === 12 && max === 11) return 'h12';
    throw new Error('Unexpected hour cycle result');
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* eslint-disable rulesdir/pure-render */ function $120dc3eec0127e56$export$722debc0e56fea39(value, isEqual) {
    // Using a ref during render is ok here because it's only an optimization – both values are equivalent.
    // If a render is thrown away, it'll still work the same no matter if the next render is the same or not.
    let lastValue = (0, $acw62.useRef)(null);
    if (value && lastValue.current && isEqual(value, lastValue.current)) value = lastValue.current;
    lastValue.current = value;
    return value;
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $bc6a8bb8d27b9642$export$85fd5fdf27bacc79(options) {
    // Reuse last options object if it is shallowly equal, which allows the useMemo result to also be reused.
    options = (0, $120dc3eec0127e56$export$722debc0e56fea39)(options !== null && options !== void 0 ? options : {}, $bc6a8bb8d27b9642$var$$896ba0a80a8f4d36$var$isEqual);
    let { locale: locale } = (0, $a7e3b1109bf64033$export$43bb16f9c6d9e3f7)();
    return (0, $acw62.useMemo)(()=>new (0, $ecbf8fbbe677b7c2$export$ad991b66133851cf)(locale, options), [
        locale,
        options
    ]);
}
function $bc6a8bb8d27b9642$var$$896ba0a80a8f4d36$var$isEqual(a, b) {
    if (a === b) return true;
    let aKeys = Object.keys(a);
    let bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    for (let key of aKeys){
        if (b[key] !== a[key]) return false;
    }
    return true;
}


var $b3329b0bf008a928$export$2e2bcd8739ae039 = {};
$b3329b0bf008a928$export$2e2bcd8739ae039 = {
    "Empty": `\u{641}\u{627}\u{631}\u{63A}`
};


var $7325b81a13e6a0c1$export$2e2bcd8739ae039 = {};
$7325b81a13e6a0c1$export$2e2bcd8739ae039 = {
    "Empty": `\u{418}\u{437}\u{43F}\u{440}\u{430}\u{437}\u{43D}\u{438}`
};


var $9fc995f74e3d4a7e$export$2e2bcd8739ae039 = {};
$9fc995f74e3d4a7e$export$2e2bcd8739ae039 = {
    "Empty": `Pr\xe1zdn\xe9`
};


var $c6f7b108c76a70a7$export$2e2bcd8739ae039 = {};
$c6f7b108c76a70a7$export$2e2bcd8739ae039 = {
    "Empty": `Tom`
};


var $dbbb2eb64552f112$export$2e2bcd8739ae039 = {};
$dbbb2eb64552f112$export$2e2bcd8739ae039 = {
    "Empty": `Leer`
};


var $c436ff58269f2ef2$export$2e2bcd8739ae039 = {};
$c436ff58269f2ef2$export$2e2bcd8739ae039 = {
    "Empty": `\u{386}\u{3B4}\u{3B5}\u{3B9}\u{3BF}`
};


var $038846391c4d0517$export$2e2bcd8739ae039 = {};
$038846391c4d0517$export$2e2bcd8739ae039 = {
    "Empty": `Empty`
};


var $3c2f6f2016058ec9$export$2e2bcd8739ae039 = {};
$3c2f6f2016058ec9$export$2e2bcd8739ae039 = {
    "Empty": `Vac\xedo`
};


var $43c4c06e6b4c5345$export$2e2bcd8739ae039 = {};
$43c4c06e6b4c5345$export$2e2bcd8739ae039 = {
    "Empty": `T\xfchjenda`
};


var $7c4c71b098ccba7d$export$2e2bcd8739ae039 = {};
$7c4c71b098ccba7d$export$2e2bcd8739ae039 = {
    "Empty": `Tyhj\xe4`
};


var $a2ae709ad47d2ad0$export$2e2bcd8739ae039 = {};
$a2ae709ad47d2ad0$export$2e2bcd8739ae039 = {
    "Empty": `Vide`
};


var $15e3793f51a3573e$export$2e2bcd8739ae039 = {};
$15e3793f51a3573e$export$2e2bcd8739ae039 = {
    "Empty": `\u{5E8}\u{5D9}\u{5E7}`
};


var $a1729ce8f705e3b6$export$2e2bcd8739ae039 = {};
$a1729ce8f705e3b6$export$2e2bcd8739ae039 = {
    "Empty": `Prazno`
};


var $38afd487f015b93c$export$2e2bcd8739ae039 = {};
$38afd487f015b93c$export$2e2bcd8739ae039 = {
    "Empty": `\xdcres`
};


var $abbe61f3667784b4$export$2e2bcd8739ae039 = {};
$abbe61f3667784b4$export$2e2bcd8739ae039 = {
    "Empty": `Vuoto`
};


var $166876efe8fb2c94$export$2e2bcd8739ae039 = {};
$166876efe8fb2c94$export$2e2bcd8739ae039 = {
    "Empty": `\u{7A7A}`
};


var $c4c07806a9764407$export$2e2bcd8739ae039 = {};
$c4c07806a9764407$export$2e2bcd8739ae039 = {
    "Empty": `\u{BE44}\u{C5B4} \u{C788}\u{C74C}`
};


var $940e7140abad20bd$export$2e2bcd8739ae039 = {};
$940e7140abad20bd$export$2e2bcd8739ae039 = {
    "Empty": `Tu\u{161}\u{10D}ias`
};


var $f436554022edce17$export$2e2bcd8739ae039 = {};
$f436554022edce17$export$2e2bcd8739ae039 = {
    "Empty": `Tuk\u{161}s`
};


var $0bb53f165d9884b8$export$2e2bcd8739ae039 = {};
$0bb53f165d9884b8$export$2e2bcd8739ae039 = {
    "Empty": `Tom`
};


var $8eef7e608554edc6$export$2e2bcd8739ae039 = {};
$8eef7e608554edc6$export$2e2bcd8739ae039 = {
    "Empty": `Leeg`
};


var $6959fc729a0d09bd$export$2e2bcd8739ae039 = {};
$6959fc729a0d09bd$export$2e2bcd8739ae039 = {
    "Empty": `Pusty`
};


var $8e8b2459e7faf6e3$export$2e2bcd8739ae039 = {};
$8e8b2459e7faf6e3$export$2e2bcd8739ae039 = {
    "Empty": `Vazio`
};


var $33e40da4a434561a$export$2e2bcd8739ae039 = {};
$33e40da4a434561a$export$2e2bcd8739ae039 = {
    "Empty": `Vazio`
};


var $30a516ce55d73d4f$export$2e2bcd8739ae039 = {};
$30a516ce55d73d4f$export$2e2bcd8739ae039 = {
    "Empty": `Gol`
};


var $b22aa7e86d4319f3$export$2e2bcd8739ae039 = {};
$b22aa7e86d4319f3$export$2e2bcd8739ae039 = {
    "Empty": `\u{41D}\u{435} \u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{43E}`
};


var $256c711e0a1cb4b2$export$2e2bcd8739ae039 = {};
$256c711e0a1cb4b2$export$2e2bcd8739ae039 = {
    "Empty": `Pr\xe1zdne`
};


var $6f35bcdcba43dfb8$export$2e2bcd8739ae039 = {};
$6f35bcdcba43dfb8$export$2e2bcd8739ae039 = {
    "Empty": `Prazen`
};


var $510246ae6856dbc0$export$2e2bcd8739ae039 = {};
$510246ae6856dbc0$export$2e2bcd8739ae039 = {
    "Empty": `Prazno`
};


var $126952f76677a86f$export$2e2bcd8739ae039 = {};
$126952f76677a86f$export$2e2bcd8739ae039 = {
    "Empty": `Tomt`
};


var $9c2c50d387e3eb34$export$2e2bcd8739ae039 = {};
$9c2c50d387e3eb34$export$2e2bcd8739ae039 = {
    "Empty": `Bo\u{15F}`
};


var $c7d3d15a3d464da5$export$2e2bcd8739ae039 = {};
$c7d3d15a3d464da5$export$2e2bcd8739ae039 = {
    "Empty": `\u{41F}\u{443}\u{441}\u{442}\u{43E}`
};


var $4c27e6473e7af8cd$export$2e2bcd8739ae039 = {};
$4c27e6473e7af8cd$export$2e2bcd8739ae039 = {
    "Empty": `\u{7A7A}`
};


var $2e2e143895093263$export$2e2bcd8739ae039 = {};
$2e2e143895093263$export$2e2bcd8739ae039 = {
    "Empty": `\u{7A7A}\u{767D}`
};


var $ca32bd489f7671d0$export$2e2bcd8739ae039 = {};
$ca32bd489f7671d0$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $b3329b0bf008a928$export$2e2bcd8739ae039),
    "bg-BG": (0, $7325b81a13e6a0c1$export$2e2bcd8739ae039),
    "cs-CZ": (0, $9fc995f74e3d4a7e$export$2e2bcd8739ae039),
    "da-DK": (0, $c6f7b108c76a70a7$export$2e2bcd8739ae039),
    "de-DE": (0, $dbbb2eb64552f112$export$2e2bcd8739ae039),
    "el-GR": (0, $c436ff58269f2ef2$export$2e2bcd8739ae039),
    "en-US": (0, $038846391c4d0517$export$2e2bcd8739ae039),
    "es-ES": (0, $3c2f6f2016058ec9$export$2e2bcd8739ae039),
    "et-EE": (0, $43c4c06e6b4c5345$export$2e2bcd8739ae039),
    "fi-FI": (0, $7c4c71b098ccba7d$export$2e2bcd8739ae039),
    "fr-FR": (0, $a2ae709ad47d2ad0$export$2e2bcd8739ae039),
    "he-IL": (0, $15e3793f51a3573e$export$2e2bcd8739ae039),
    "hr-HR": (0, $a1729ce8f705e3b6$export$2e2bcd8739ae039),
    "hu-HU": (0, $38afd487f015b93c$export$2e2bcd8739ae039),
    "it-IT": (0, $abbe61f3667784b4$export$2e2bcd8739ae039),
    "ja-JP": (0, $166876efe8fb2c94$export$2e2bcd8739ae039),
    "ko-KR": (0, $c4c07806a9764407$export$2e2bcd8739ae039),
    "lt-LT": (0, $940e7140abad20bd$export$2e2bcd8739ae039),
    "lv-LV": (0, $f436554022edce17$export$2e2bcd8739ae039),
    "nb-NO": (0, $0bb53f165d9884b8$export$2e2bcd8739ae039),
    "nl-NL": (0, $8eef7e608554edc6$export$2e2bcd8739ae039),
    "pl-PL": (0, $6959fc729a0d09bd$export$2e2bcd8739ae039),
    "pt-BR": (0, $8e8b2459e7faf6e3$export$2e2bcd8739ae039),
    "pt-PT": (0, $33e40da4a434561a$export$2e2bcd8739ae039),
    "ro-RO": (0, $30a516ce55d73d4f$export$2e2bcd8739ae039),
    "ru-RU": (0, $b22aa7e86d4319f3$export$2e2bcd8739ae039),
    "sk-SK": (0, $256c711e0a1cb4b2$export$2e2bcd8739ae039),
    "sl-SI": (0, $6f35bcdcba43dfb8$export$2e2bcd8739ae039),
    "sr-SP": (0, $510246ae6856dbc0$export$2e2bcd8739ae039),
    "sv-SE": (0, $126952f76677a86f$export$2e2bcd8739ae039),
    "tr-TR": (0, $9c2c50d387e3eb34$export$2e2bcd8739ae039),
    "uk-UA": (0, $c7d3d15a3d464da5$export$2e2bcd8739ae039),
    "zh-CN": (0, $4c27e6473e7af8cd$export$2e2bcd8739ae039),
    "zh-TW": (0, $2e2e143895093263$export$2e2bcd8739ae039)
};




var $acw62 = parcelRequire("acw62");


function $8f5f80057a06de6c$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8f5f80057a06de6c$export$e908e06f4b8e3402(props) {
    const _async = (0, $acw62.useRef)(undefined);
    let { value: value, textValue: textValue, minValue: minValue, maxValue: maxValue, isDisabled: isDisabled, isReadOnly: isReadOnly, isRequired: isRequired, onIncrement: onIncrement, onIncrementPage: onIncrementPage, onDecrement: onDecrement, onDecrementPage: onDecrementPage, onDecrementToMin: onDecrementToMin, onIncrementToMax: onIncrementToMax } = props;
    const stringFormatter = (0, $3681d06d99b0f841$export$f12b703ca79dfbb1)($8f5f80057a06de6c$var$$parcel$interopDefault((0, $ca32bd489f7671d0$export$2e2bcd8739ae039)), '@react-aria/spinbutton');
    let isSpinning = (0, $acw62.useRef)(false);
    const clearAsync = (0, $acw62.useCallback)(()=>{
        clearTimeout(_async.current);
        isSpinning.current = false;
    }, []);
    const clearAsyncEvent = (0, $92fff981738f62fe$export$7f54fc3180508a52)(()=>{
        clearAsync();
    });
    (0, $acw62.useEffect)(()=>{
        return ()=>clearAsyncEvent();
    }, []);
    let onKeyDown = (e)=>{
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || isReadOnly || e.nativeEvent.isComposing) return;
        switch(e.key){
            case 'PageUp':
                if (onIncrementPage) {
                    e.preventDefault();
                    onIncrementPage === null || onIncrementPage === void 0 || onIncrementPage();
                    break;
                }
            // fallthrough!
            case 'ArrowUp':
            case 'Up':
                if (onIncrement) {
                    e.preventDefault();
                    onIncrement === null || onIncrement === void 0 || onIncrement();
                }
                break;
            case 'PageDown':
                if (onDecrementPage) {
                    e.preventDefault();
                    onDecrementPage === null || onDecrementPage === void 0 || onDecrementPage();
                    break;
                }
            // fallthrough
            case 'ArrowDown':
            case 'Down':
                if (onDecrement) {
                    e.preventDefault();
                    onDecrement === null || onDecrement === void 0 || onDecrement();
                }
                break;
            case 'Home':
                if (onDecrementToMin) {
                    e.preventDefault();
                    onDecrementToMin === null || onDecrementToMin === void 0 || onDecrementToMin();
                }
                break;
            case 'End':
                if (onIncrementToMax) {
                    e.preventDefault();
                    onIncrementToMax === null || onIncrementToMax === void 0 || onIncrementToMax();
                }
                break;
        }
    };
    let isFocused = (0, $acw62.useRef)(false);
    let onFocus = ()=>{
        isFocused.current = true;
    };
    let onBlur = ()=>{
        isFocused.current = false;
    };
    // Replace Unicode hyphen-minus (U+002D) with minus sign (U+2212).
    // This ensures that macOS VoiceOver announces it as "minus" even with other characters between the minus sign
    // and the number (e.g. currency symbol). Otherwise it announces nothing because it assumes the character is a hyphen.
    // In addition, replace the empty string with the word "Empty" so that iOS VoiceOver does not read "50%" for an empty field.
    let ariaTextValue = textValue === '' ? stringFormatter.format('Empty') : (textValue || `${value}`).replace('-', '\u2212');
    (0, $acw62.useEffect)(()=>{
        if (isFocused.current) {
            (0, $19250283ca240c8f$export$d10ae4f68404609a)('assertive');
            (0, $19250283ca240c8f$export$a9b970dcc4ae71a9)(ariaTextValue, 'assertive');
        }
    }, [
        ariaTextValue
    ]);
    // For touch users, if they move their finger like they're scrolling, we don't want to trigger a spin.
    let onPointerCancel = (0, $acw62.useCallback)(()=>{
        clearAsync();
    }, [
        clearAsync
    ]);
    const onIncrementPressStart = (0, $92fff981738f62fe$export$7f54fc3180508a52)((initialStepDelay)=>{
        clearAsyncEvent();
        isSpinning.current = true;
        onIncrement === null || onIncrement === void 0 || onIncrement();
        // Start spinning after initial delay
        _async.current = window.setTimeout(()=>{
            if (maxValue === undefined || isNaN(maxValue) || value === undefined || isNaN(value) || value < maxValue) onIncrementPressStart(60);
        }, initialStepDelay);
    });
    const onDecrementPressStart = (0, $92fff981738f62fe$export$7f54fc3180508a52)((initialStepDelay)=>{
        clearAsyncEvent();
        isSpinning.current = true;
        onDecrement === null || onDecrement === void 0 || onDecrement();
        // Start spinning after initial delay
        _async.current = window.setTimeout(()=>{
            if (minValue === undefined || isNaN(minValue) || value === undefined || isNaN(value) || value > minValue) onDecrementPressStart(60);
        }, initialStepDelay);
    });
    let cancelContextMenu = (e)=>{
        e.preventDefault();
    };
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $2dd678e31a4cc7e0$export$4eaf04e54aa8eed6)();
    // Tracks in touch if the press end event was preceded by a press up.
    // If it wasn't, then we know the finger left the button while still in contact with the screen.
    // This means that the user is trying to scroll or interact in some way that shouldn't trigger
    // an increment or decrement.
    let isUp = (0, $acw62.useRef)(false);
    let [isIncrementPressed, setIsIncrementPressed] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (isIncrementPressed === 'touch') onIncrementPressStart(60);
        else if (isIncrementPressed) onIncrementPressStart(400);
    }, [
        isIncrementPressed
    ]);
    let [isDecrementPressed, setIsDecrementPressed] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (isDecrementPressed === 'touch') onDecrementPressStart(60);
        else if (isDecrementPressed) onDecrementPressStart(400);
    }, [
        isDecrementPressed
    ]);
    return {
        spinButtonProps: {
            role: 'spinbutton',
            'aria-valuenow': value !== undefined && !isNaN(value) ? value : undefined,
            'aria-valuetext': ariaTextValue,
            'aria-valuemin': minValue,
            'aria-valuemax': maxValue,
            'aria-disabled': isDisabled || undefined,
            'aria-readonly': isReadOnly || undefined,
            'aria-required': isRequired || undefined,
            onKeyDown: onKeyDown,
            onFocus: onFocus,
            onBlur: onBlur
        },
        incrementButtonProps: {
            onPressStart: (e)=>{
                if (e.pointerType !== 'touch') setIsIncrementPressed('mouse');
                else {
                    if (_async.current) clearAsync();
                    addGlobalListener(window, 'pointercancel', onPointerCancel, {
                        capture: true
                    });
                    isUp.current = false;
                    // For touch users, don't trigger a decrement on press start, we'll wait for the press end to trigger it if
                    // the control isn't spinning.
                    _async.current = window.setTimeout(()=>{
                        setIsIncrementPressed('touch');
                    }, 600);
                }
                addGlobalListener(window, 'contextmenu', cancelContextMenu);
            },
            onPressUp: (e)=>{
                if (e.pointerType === 'touch') isUp.current = true;
                clearAsync();
                removeAllGlobalListeners();
                setIsIncrementPressed(null);
            },
            onPressEnd: (e)=>{
                if (e.pointerType === 'touch') {
                    if (!isSpinning.current && isUp.current) onIncrement === null || onIncrement === void 0 || onIncrement();
                }
                clearAsync();
                isUp.current = false;
                setIsIncrementPressed(null);
            },
            onFocus: onFocus,
            onBlur: onBlur
        },
        decrementButtonProps: {
            onPressStart: (e)=>{
                if (e.pointerType !== 'touch') setIsDecrementPressed('mouse');
                else {
                    if (_async.current) clearAsync();
                    addGlobalListener(window, 'pointercancel', onPointerCancel, {
                        capture: true
                    });
                    isUp.current = false;
                    // For touch users, don't trigger a decrement on press start, we'll wait for the press end to trigger it if
                    // the control isn't spinning.
                    _async.current = window.setTimeout(()=>{
                        setIsDecrementPressed('touch');
                    }, 600);
                }
            },
            onPressUp: (e)=>{
                if (e.pointerType === 'touch') isUp.current = true;
                clearAsync();
                removeAllGlobalListeners();
                setIsDecrementPressed(null);
            },
            onPressEnd: (e)=>{
                if (e.pointerType === 'touch') {
                    if (!isSpinning.current && isUp.current) onDecrement === null || onDecrement === void 0 || onDecrement();
                }
                clearAsync();
                isUp.current = false;
                setIsDecrementPressed(null);
            },
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7448e1f067fdcc2b$export$1315d136e6f7581(segment, state, ref) {
    let enteredKeys = (0, $acw62.useRef)('');
    let { locale: locale, direction: direction } = (0, $a7e3b1109bf64033$export$43bb16f9c6d9e3f7)();
    let displayNames = (0, $e94f1ecfdf1ef15c$export$d42c60378c8168f8)();
    let { ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, focusManager: focusManager } = (0, $6a062e87893a747c$export$653eddfc964b0f8a).get(state);
    let textValue = segment.isPlaceholder ? '' : segment.text;
    let options = (0, $acw62.useMemo)(()=>state.dateFormatter.resolvedOptions(), [
        state.dateFormatter
    ]);
    let monthDateFormatter = (0, $bc6a8bb8d27b9642$export$85fd5fdf27bacc79)({
        month: 'long',
        timeZone: options.timeZone
    });
    let hourDateFormatter = (0, $bc6a8bb8d27b9642$export$85fd5fdf27bacc79)({
        hour: 'numeric',
        hour12: options.hour12,
        timeZone: options.timeZone
    });
    if (segment.type === 'month' && !segment.isPlaceholder) {
        let monthTextValue = monthDateFormatter.format(state.dateValue);
        textValue = monthTextValue !== textValue ? `${textValue} \u{2013} ${monthTextValue}` : monthTextValue;
    } else if (segment.type === 'hour' && !segment.isPlaceholder) textValue = hourDateFormatter.format(state.dateValue);
    let { spinButtonProps: spinButtonProps } = (0, $8f5f80057a06de6c$export$e908e06f4b8e3402)({
        // The ARIA spec says aria-valuenow is optional if there's no value, but aXe seems to require it.
        // This doesn't seem to have any negative effects with real AT since we also use aria-valuetext.
        // https://github.com/dequelabs/axe-core/issues/3505
        value: segment.value,
        textValue: textValue,
        minValue: segment.minValue,
        maxValue: segment.maxValue,
        isDisabled: state.isDisabled,
        isReadOnly: state.isReadOnly || !segment.isEditable,
        isRequired: state.isRequired,
        onIncrement: ()=>{
            enteredKeys.current = '';
            state.increment(segment.type);
        },
        onDecrement: ()=>{
            enteredKeys.current = '';
            state.decrement(segment.type);
        },
        onIncrementPage: ()=>{
            enteredKeys.current = '';
            state.incrementPage(segment.type);
        },
        onDecrementPage: ()=>{
            enteredKeys.current = '';
            state.decrementPage(segment.type);
        },
        onIncrementToMax: ()=>{
            enteredKeys.current = '';
            if (segment.maxValue !== undefined) state.setSegment(segment.type, segment.maxValue);
        },
        onDecrementToMin: ()=>{
            enteredKeys.current = '';
            if (segment.minValue !== undefined) state.setSegment(segment.type, segment.minValue);
        }
    });
    let parser = (0, $acw62.useMemo)(()=>new (0, $f764810b880bba05$export$cd11ab140839f11d)(locale, {
            maximumFractionDigits: 0
        }), [
        locale
    ]);
    let backspace = ()=>{
        if (segment.text === segment.placeholder) focusManager.focusPrevious();
        if (parser.isValidPartialNumber(segment.text) && !state.isReadOnly && !segment.isPlaceholder) {
            let newValue = segment.text.slice(0, -1);
            let parsed = parser.parse(newValue);
            newValue = parsed === 0 ? '' : newValue;
            if (newValue.length === 0 || parsed === 0) state.clearSegment(segment.type);
            else state.setSegment(segment.type, parsed);
            enteredKeys.current = newValue;
        } else if (segment.type === 'dayPeriod') state.clearSegment(segment.type);
    };
    let onKeyDown = (e)=>{
        // Firefox does not fire selectstart for Ctrl/Cmd + A
        // https://bugzilla.mozilla.org/show_bug.cgi?id=1742153
        if (e.key === 'a' && ((0, $c0699bc5a0b3191f$export$9ac100e40613ea10)() ? e.metaKey : e.ctrlKey)) e.preventDefault();
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
        switch(e.key){
            case 'Backspace':
            case 'Delete':
                // Safari on iOS does not fire beforeinput for the backspace key because the cursor is at the start.
                e.preventDefault();
                e.stopPropagation();
                backspace();
                break;
        }
    };
    // Safari dayPeriod option doesn't work...
    let { startsWith: startsWith } = (0, $e822a52a17c16d76$export$3274cf84b703fff)({
        sensitivity: 'base'
    });
    let amPmFormatter = (0, $bc6a8bb8d27b9642$export$85fd5fdf27bacc79)({
        hour: 'numeric',
        hour12: true
    });
    let am = (0, $acw62.useMemo)(()=>{
        let date = new Date();
        date.setHours(0);
        return amPmFormatter.formatToParts(date).find((part)=>part.type === 'dayPeriod').value;
    }, [
        amPmFormatter
    ]);
    let pm = (0, $acw62.useMemo)(()=>{
        let date = new Date();
        date.setHours(12);
        return amPmFormatter.formatToParts(date).find((part)=>part.type === 'dayPeriod').value;
    }, [
        amPmFormatter
    ]);
    // Get a list of formatted era names so users can type the first character to choose one.
    let eraFormatter = (0, $bc6a8bb8d27b9642$export$85fd5fdf27bacc79)({
        year: 'numeric',
        era: 'narrow',
        timeZone: 'UTC'
    });
    let eras = (0, $acw62.useMemo)(()=>{
        if (segment.type !== 'era') return [];
        let date = (0, $24197fe0fbca7789$export$b4a036af3fc0b032)(new (0, $465374ca30ab45d0$export$99faa760c7908e4f)(1, 1, 1), state.calendar);
        let eras = state.calendar.getEras().map((era)=>{
            let eraDate = date.set({
                year: 1,
                month: 1,
                day: 1,
                era: era
            }).toDate('UTC');
            let parts = eraFormatter.formatToParts(eraDate);
            let formatted = parts.find((p)=>p.type === 'era').value;
            return {
                era: era,
                formatted: formatted
            };
        });
        // Remove the common prefix from formatted values. This is so that in calendars with eras like
        // ERA0 and ERA1 (e.g. Ethiopic), users can press "0" and "1" to select an era. In other cases,
        // the first letter is used.
        let prefixLength = $7448e1f067fdcc2b$var$$32489daedd52963e$var$commonPrefixLength(eras.map((era)=>era.formatted));
        if (prefixLength) for (let era of eras)era.formatted = era.formatted.slice(prefixLength);
        return eras;
    }, [
        eraFormatter,
        state.calendar,
        segment.type
    ]);
    let onInput = (key)=>{
        if (state.isDisabled || state.isReadOnly) return;
        let newValue = enteredKeys.current + key;
        switch(segment.type){
            case 'dayPeriod':
                if (startsWith(am, key)) state.setSegment('dayPeriod', 0);
                else if (startsWith(pm, key)) state.setSegment('dayPeriod', 12);
                else break;
                focusManager.focusNext();
                break;
            case 'era':
                {
                    let matched = eras.find((e)=>startsWith(e.formatted, key));
                    if (matched) {
                        state.setSegment('era', matched.era);
                        focusManager.focusNext();
                    }
                    break;
                }
            case 'day':
            case 'hour':
            case 'minute':
            case 'second':
            case 'month':
            case 'year':
                {
                    if (!parser.isValidPartialNumber(newValue)) return;
                    let numberValue = parser.parse(newValue);
                    let segmentValue = numberValue;
                    let allowsZero = segment.minValue === 0;
                    if (segment.type === 'hour' && state.dateFormatter.resolvedOptions().hour12) {
                        switch(state.dateFormatter.resolvedOptions().hourCycle){
                            case 'h11':
                                if (numberValue > 11) segmentValue = parser.parse(key);
                                break;
                            case 'h12':
                                allowsZero = false;
                                if (numberValue > 12) segmentValue = parser.parse(key);
                                break;
                        }
                        if (segment.value !== undefined && segment.value >= 12 && numberValue > 1) numberValue += 12;
                    } else if (segment.maxValue !== undefined && numberValue > segment.maxValue) segmentValue = parser.parse(key);
                    if (isNaN(numberValue)) return;
                    let shouldSetValue = segmentValue !== 0 || allowsZero;
                    if (shouldSetValue) state.setSegment(segment.type, segmentValue);
                    if (segment.maxValue !== undefined && (Number(numberValue + '0') > segment.maxValue || newValue.length >= String(segment.maxValue).length)) {
                        enteredKeys.current = '';
                        if (shouldSetValue) focusManager.focusNext();
                    } else enteredKeys.current = newValue;
                    break;
                }
        }
    };
    let onFocus = ()=>{
        enteredKeys.current = '';
        if (ref.current) (0, $9508892f11ae5828$export$c826860796309d1b)(ref.current, {
            containingElement: (0, $a08583dfd8fd8668$export$cfa2225e87938781)(ref.current)
        });
        // Collapse selection to start or Chrome won't fire input events.
        let selection = window.getSelection();
        selection === null || selection === void 0 || selection.collapse(ref.current);
    };
    let documentRef = (0, $acw62.useRef)(typeof document !== 'undefined' ? document : null);
    (0, $b95c9737ad40d7c7$export$90fc3a17d93f704c)(documentRef, 'selectionchange', ()=>{
        var _ref_current;
        // Enforce that the selection is collapsed when inside a date segment.
        // Otherwise, when tapping on a segment in Android Chrome and then entering text,
        // composition events will be fired that break the DOM structure and crash the page.
        let selection = window.getSelection();
        if ((selection === null || selection === void 0 ? void 0 : selection.anchorNode) && ((_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.contains(selection === null || selection === void 0 ? void 0 : selection.anchorNode))) selection.collapse(ref.current);
    });
    let compositionRef = (0, $acw62.useRef)('');
    (0, $b95c9737ad40d7c7$export$90fc3a17d93f704c)(ref, 'beforeinput', (e)=>{
        if (!ref.current) return;
        e.preventDefault();
        switch(e.inputType){
            case 'deleteContentBackward':
            case 'deleteContentForward':
                if (parser.isValidPartialNumber(segment.text) && !state.isReadOnly) backspace();
                break;
            case 'insertCompositionText':
                // insertCompositionText cannot be canceled.
                // Record the current state of the element so we can restore it in the `input` event below.
                compositionRef.current = ref.current.textContent;
                // Safari gets stuck in a composition state unless we also assign to the value here.
                // eslint-disable-next-line no-self-assign
                ref.current.textContent = ref.current.textContent;
                break;
            default:
                if (e.data != null) onInput(e.data);
                break;
        }
    });
    (0, $b95c9737ad40d7c7$export$90fc3a17d93f704c)(ref, 'input', (e)=>{
        let { inputType: inputType, data: data } = e;
        switch(inputType){
            case 'insertCompositionText':
                // Reset the DOM to how it was in the beforeinput event.
                if (ref.current) ref.current.textContent = compositionRef.current;
                // Android sometimes fires key presses of letters as composition events. Need to handle am/pm keys here too.
                // Can also happen e.g. with Pinyin keyboard on iOS.
                if (data != null && (startsWith(am, data) || startsWith(pm, data))) onInput(data);
                break;
        }
    });
    (0, $38781589fd33010c$export$e5c5a5f917a5871c)(()=>{
        let element = ref.current;
        return ()=>{
            // If the focused segment is removed, focus the previous one, or the next one if there was no previous one.
            if (document.activeElement === element) {
                let prev = focusManager.focusPrevious();
                if (!prev) focusManager.focusNext();
            }
        };
    }, [
        ref,
        focusManager
    ]);
    // spinbuttons cannot be focused with VoiceOver on iOS.
    let touchPropOverrides = (0, $c0699bc5a0b3191f$export$fedb369cb70207f1)() || segment.type === 'timeZoneName' ? {
        role: 'textbox',
        'aria-valuemax': null,
        'aria-valuemin': null,
        'aria-valuetext': null,
        'aria-valuenow': null
    } : {};
    // Only apply aria-describedby to the first segment, unless the field is invalid. This avoids it being
    // read every time the user navigates to a new segment.
    let firstSegment = (0, $acw62.useMemo)(()=>state.segments.find((s)=>s.isEditable), [
        state.segments
    ]);
    if (segment !== firstSegment && !state.isInvalid) ariaDescribedBy = undefined;
    let id = (0, $855de91ebb07800c$export$f680877a34711e37)();
    let isEditable = !state.isDisabled && !state.isReadOnly && segment.isEditable;
    // Prepend the label passed from the field to each segment name.
    // This is needed because VoiceOver on iOS does not announce groups.
    let name = segment.type === 'literal' ? '' : displayNames.of(segment.type);
    let labelProps = (0, $ad7d494fae923873$export$d6875122194c7b44)({
        'aria-label': `${name}${ariaLabel ? `, ${ariaLabel}` : ''}${ariaLabelledBy ? ', ' : ''}`,
        'aria-labelledby': ariaLabelledBy
    });
    // Literal segments should not be visible to screen readers. We don't really need any of the above,
    // but the rules of hooks mean hooks cannot be conditional so we have to put this condition here.
    if (segment.type === 'literal') return {
        segmentProps: {
            'aria-hidden': true
        }
    };
    let segmentStyle = {
        caretColor: 'transparent'
    };
    if (direction === 'rtl') {
        // While the bidirectional algorithm seems to work properly on inline elements with actual values, it returns different results for placeholder strings. 
        // To ensure placeholder render in correct format, we apply the CSS equivalent of LRE (left-to-right embedding). See https://www.unicode.org/reports/tr9/#Explicit_Directional_Embeddings.
        // However, we apply this to both placeholders and date segments with an actual value because the date segments will shift around when deleting otherwise. 
        segmentStyle.unicodeBidi = 'embed';
        let format = options[segment.type];
        if (format === 'numeric' || format === '2-digit') segmentStyle.direction = 'ltr';
    }
    return {
        segmentProps: (0, $e611552c564dfe1f$export$9d1611c77c2fe928)(spinButtonProps, labelProps, {
            id: id,
            ...touchPropOverrides,
            'aria-invalid': state.isInvalid ? 'true' : undefined,
            'aria-describedby': ariaDescribedBy,
            'aria-readonly': state.isReadOnly || !segment.isEditable ? 'true' : undefined,
            'data-placeholder': segment.isPlaceholder || undefined,
            contentEditable: isEditable,
            suppressContentEditableWarning: isEditable,
            spellCheck: isEditable ? 'false' : undefined,
            autoCorrect: isEditable ? 'off' : undefined,
            // Capitalization was changed in React 17...
            [parseInt((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version, 10) >= 17 ? 'enterKeyHint' : 'enterkeyhint']: isEditable ? 'next' : undefined,
            inputMode: state.isDisabled || segment.type === 'dayPeriod' || segment.type === 'era' || !isEditable ? undefined : 'numeric',
            tabIndex: state.isDisabled ? undefined : 0,
            onKeyDown: onKeyDown,
            onFocus: onFocus,
            style: segmentStyle,
            // Prevent pointer events from reaching useDatePickerGroup, and allow native browser behavior to focus the segment.
            onPointerDown (e) {
                e.stopPropagation();
            },
            onMouseDown (e) {
                e.stopPropagation();
            }
        })
    };
}
function $7448e1f067fdcc2b$var$$32489daedd52963e$var$commonPrefixLength(strings) {
    // Sort the strings, and compare the characters in the first and last to find the common prefix.
    strings.sort();
    let first = strings[0];
    let last = strings[strings.length - 1];
    for(let i = 0; i < first.length; i++){
        if (first[i] !== last[i]) return i;
    }
    return 0;
}




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $bd4fa81aad972291$var$$8d73d47422ca7302$var$BUDDHIST_ERA_START = -543;
class $bd4fa81aad972291$export$42d20a78301dee44 extends (0, $164d3c47591a715e$export$80ee6245ec4f29ec) {
    fromJulianDay(jd) {
        let gregorianDate = super.fromJulianDay(jd);
        let year = (0, $164d3c47591a715e$export$c36e0ecb2d4fa69d)(gregorianDate.era, gregorianDate.year);
        return new (0, $465374ca30ab45d0$export$99faa760c7908e4f)(this, year - $bd4fa81aad972291$var$$8d73d47422ca7302$var$BUDDHIST_ERA_START, gregorianDate.month, gregorianDate.day);
    }
    toJulianDay(date) {
        return super.toJulianDay($bd4fa81aad972291$var$$8d73d47422ca7302$var$toGregorian(date));
    }
    getEras() {
        return [
            'BE'
        ];
    }
    getDaysInMonth(date) {
        return super.getDaysInMonth($bd4fa81aad972291$var$$8d73d47422ca7302$var$toGregorian(date));
    }
    balanceDate() {}
    constructor(...args){
        super(...args), this.identifier = 'buddhist';
    }
}
function $bd4fa81aad972291$var$$8d73d47422ca7302$var$toGregorian(date) {
    let [era, year] = (0, $164d3c47591a715e$export$4475b7e617eb123c)(date.year + $bd4fa81aad972291$var$$8d73d47422ca7302$var$BUDDHIST_ERA_START);
    return new (0, $465374ca30ab45d0$export$99faa760c7908e4f)(era, year, date.month, date.day);
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$ETHIOPIC_EPOCH = 1723856;
const $91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$COPTIC_EPOCH = 1824665;
// The delta between Amete Alem 1 and Amete Mihret 1
// AA 5501 = AM 1
const $91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA = 5500;
function $91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$ceToJulianDay(epoch, year, month, day) {
    return epoch // difference from Julian epoch to 1,1,1
     + 365 * year // number of days from years
     + Math.floor(year / 4) // extra day of leap year
     + 30 * (month - 1 // number of days from months (1 based)
    ) + day - 1 // number of days for present month (1 based)
    ;
}
function $91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$julianDayToCE(epoch, jd) {
    let year = Math.floor(4 * (jd - epoch) / 1461);
    let month = 1 + Math.floor((jd - $91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$ceToJulianDay(epoch, year, 1, 1)) / 30);
    let day = jd + 1 - $91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$ceToJulianDay(epoch, year, month, 1);
    return [
        year,
        month,
        day
    ];
}
function $91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$getLeapDay(year) {
    return Math.floor(year % 4 / 3);
}
function $91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$getDaysInMonth(year, month) {
    // The Ethiopian and Coptic calendars have 13 months, 12 of 30 days each and
    // an intercalary month at the end of the year of 5 or 6 days, depending whether
    // the year is a leap year or not. The Leap Year follows the same rules as the
    // Julian Calendar so that the extra month always has six days in the year before
    // a Julian Leap Year.
    if (month % 13 !== 0) return 30;
    else return $91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$getLeapDay(year) + 5;
}
class $91aedb93fbe111a0$export$26ba6eab5e20cd7d {
    fromJulianDay(jd) {
        let [year, month, day] = $91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$julianDayToCE($91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$ETHIOPIC_EPOCH, jd);
        let era = 'AM';
        if (year <= 0) {
            era = 'AA';
            year += $91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;
        }
        return new (0, $465374ca30ab45d0$export$99faa760c7908e4f)(this, era, year, month, day);
    }
    toJulianDay(date) {
        let year = date.year;
        if (date.era === 'AA') year -= $91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;
        return $91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$ceToJulianDay($91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$ETHIOPIC_EPOCH, year, date.month, date.day);
    }
    getDaysInMonth(date) {
        return $91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$getDaysInMonth(date.year, date.month);
    }
    getMonthsInYear() {
        return 13;
    }
    getDaysInYear(date) {
        return 365 + $91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$getLeapDay(date.year);
    }
    getYearsInEra(date) {
        // 9999-12-31 gregorian is 9992-20-02 ethiopic.
        // Round down to 9991 for the last full year.
        // AA 9999-01-01 ethiopic is 4506-09-30 gregorian.
        return date.era === 'AA' ? 9999 : 9991;
    }
    getEras() {
        return [
            'AA',
            'AM'
        ];
    }
    constructor(){
        this.identifier = 'ethiopic';
    }
}
class $91aedb93fbe111a0$export$d72e0c37005a4914 extends $91aedb93fbe111a0$export$26ba6eab5e20cd7d {
    fromJulianDay(jd) {
        let [year, month, day] = $91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$julianDayToCE($91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$ETHIOPIC_EPOCH, jd);
        year += $91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;
        return new (0, $465374ca30ab45d0$export$99faa760c7908e4f)(this, 'AA', year, month, day);
    }
    getEras() {
        return [
            'AA'
        ];
    }
    getYearsInEra() {
        // 9999-13-04 ethioaa is the maximum date, which is equivalent to 4506-09-29 gregorian.
        return 9999;
    }
    constructor(...args){
        super(...args), this.identifier = 'ethioaa' // also known as 'ethiopic-amete-alem' in ICU
        ;
    }
}
class $91aedb93fbe111a0$export$fe6243cbe1a4b7c1 extends $91aedb93fbe111a0$export$26ba6eab5e20cd7d {
    fromJulianDay(jd) {
        let [year, month, day] = $91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$julianDayToCE($91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$COPTIC_EPOCH, jd);
        let era = 'CE';
        if (year <= 0) {
            era = 'BCE';
            year = 1 - year;
        }
        return new (0, $465374ca30ab45d0$export$99faa760c7908e4f)(this, era, year, month, day);
    }
    toJulianDay(date) {
        let year = date.year;
        if (date.era === 'BCE') year = 1 - year;
        return $91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$ceToJulianDay($91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$COPTIC_EPOCH, year, date.month, date.day);
    }
    getDaysInMonth(date) {
        let year = date.year;
        if (date.era === 'BCE') year = 1 - year;
        return $91aedb93fbe111a0$var$$b956b2d7a6cf451f$var$getDaysInMonth(year, date.month);
    }
    isInverseEra(date) {
        return date.era === 'BCE';
    }
    balanceDate(date) {
        if (date.year <= 0) {
            date.era = date.era === 'BCE' ? 'CE' : 'BCE';
            date.year = 1 - date.year;
        }
    }
    getEras() {
        return [
            'BCE',
            'CE'
        ];
    }
    getYearsInEra(date) {
        // 9999-12-30 gregorian is 9716-02-20 coptic.
        // Round down to 9715 for the last full year.
        // BCE 9999-01-01 coptic is BC 9716-06-15 gregorian.
        return date.era === 'BCE' ? 9999 : 9715;
    }
    constructor(...args){
        super(...args), this.identifier = 'coptic';
    }
}





/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$HEBREW_EPOCH = 347997;
// Hebrew date calculations are performed in terms of days, hours, and
// "parts" (or halakim), which are 1/1080 of an hour, or 3 1/3 seconds.
const $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$HOUR_PARTS = 1080;
const $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$DAY_PARTS = 24 * $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$HOUR_PARTS;
// An approximate value for the length of a lunar month.
// It is used to calculate the approximate year and month of a given
// absolute date.
const $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$MONTH_DAYS = 29;
const $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$MONTH_FRACT = 12 * $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$HOUR_PARTS + 793;
const $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$MONTH_PARTS = $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$MONTH_DAYS * $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$DAY_PARTS + $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$MONTH_FRACT;
function $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$isLeapYear(year) {
    return (0, $6029cd325c4477d7$export$842a2cf37af977e1)(year * 7 + 1, 19) < 7;
}
// Test for delay of start of new year and to avoid
// Sunday, Wednesday, and Friday as start of the new year.
function $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$hebrewDelay1(year) {
    let months = Math.floor((235 * year - 234) / 19);
    let parts = 12084 + 13753 * months;
    let day = months * 29 + Math.floor(parts / 25920);
    if ((0, $6029cd325c4477d7$export$842a2cf37af977e1)(3 * (day + 1), 7) < 3) day += 1;
    return day;
}
// Check for delay in start of new year due to length of adjacent years
function $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$hebrewDelay2(year) {
    let last = $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$hebrewDelay1(year - 1);
    let present = $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$hebrewDelay1(year);
    let next = $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$hebrewDelay1(year + 1);
    if (next - present === 356) return 2;
    if (present - last === 382) return 1;
    return 0;
}
function $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$startOfYear(year) {
    return $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$hebrewDelay1(year) + $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$hebrewDelay2(year);
}
function $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$getDaysInYear(year) {
    return $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$startOfYear(year + 1) - $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$startOfYear(year);
}
function $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$getYearType(year) {
    let yearLength = $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$getDaysInYear(year);
    if (yearLength > 380) yearLength -= 30; // Subtract length of leap month.
    switch(yearLength){
        case 353:
            return 0; // deficient
        case 354:
            return 1; // normal
        case 355:
            return 2; // complete
    }
}
function $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$getDaysInMonth(year, month) {
    // Normalize month numbers from 1 - 13, even on non-leap years
    if (month >= 6 && !$4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$isLeapYear(year)) month++;
    // First of all, dispose of fixed-length 29 day months
    if (month === 4 || month === 7 || month === 9 || month === 11 || month === 13) return 29;
    let yearType = $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$getYearType(year);
    // If it's Heshvan, days depend on length of year
    if (month === 2) return yearType === 2 ? 30 : 29;
    // Similarly, Kislev varies with the length of year
    if (month === 3) return yearType === 0 ? 29 : 30;
    // Adar I only exists in leap years
    if (month === 6) return $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$isLeapYear(year) ? 30 : 0;
    return 30;
}
class $4825ebaf0e9a53ce$export$ca405048b8fb5af {
    fromJulianDay(jd) {
        let d = jd - $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$HEBREW_EPOCH;
        let m = d * $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$DAY_PARTS / $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$MONTH_PARTS; // Months (approx)
        let year = Math.floor((19 * m + 234) / 235) + 1; // Years (approx)
        let ys = $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$startOfYear(year); // 1st day of year
        let dayOfYear = Math.floor(d - ys);
        // Because of the postponement rules, it's possible to guess wrong.  Fix it.
        while(dayOfYear < 1){
            year--;
            ys = $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$startOfYear(year);
            dayOfYear = Math.floor(d - ys);
        }
        // Now figure out which month we're in, and the date within that month
        let month = 1;
        let monthStart = 0;
        while(monthStart < dayOfYear){
            monthStart += $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$getDaysInMonth(year, month);
            month++;
        }
        month--;
        monthStart -= $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$getDaysInMonth(year, month);
        let day = dayOfYear - monthStart;
        return new (0, $465374ca30ab45d0$export$99faa760c7908e4f)(this, year, month, day);
    }
    toJulianDay(date) {
        let jd = $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$startOfYear(date.year);
        for(let month = 1; month < date.month; month++)jd += $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$getDaysInMonth(date.year, month);
        return jd + date.day + $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$HEBREW_EPOCH;
    }
    getDaysInMonth(date) {
        return $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$getDaysInMonth(date.year, date.month);
    }
    getMonthsInYear(date) {
        return $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$isLeapYear(date.year) ? 13 : 12;
    }
    getDaysInYear(date) {
        return $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$getDaysInYear(date.year);
    }
    getYearsInEra() {
        // 6239 gregorian
        return 9999;
    }
    getEras() {
        return [
            'AM'
        ];
    }
    balanceYearMonth(date, previousDate) {
        // Keep date in the same month when switching between leap years and non leap years
        if (previousDate.year !== date.year) {
            if ($4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$isLeapYear(previousDate.year) && !$4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$isLeapYear(date.year) && previousDate.month > 6) date.month--;
            else if (!$4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$isLeapYear(previousDate.year) && $4825ebaf0e9a53ce$var$$7c5f6fbf42389787$var$isLeapYear(date.year) && previousDate.month > 6) date.month++;
        }
    }
    constructor(){
        this.identifier = 'hebrew';
    }
}




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
// Starts in 78 AD,
const $8e577aaaeb7438e7$var$$82c358003bdda0a8$var$INDIAN_ERA_START = 78;
// The Indian year starts 80 days later than the Gregorian year.
const $8e577aaaeb7438e7$var$$82c358003bdda0a8$var$INDIAN_YEAR_START = 80;
class $8e577aaaeb7438e7$export$39f31c639fa15726 extends (0, $164d3c47591a715e$export$80ee6245ec4f29ec) {
    fromJulianDay(jd) {
        // Gregorian date for Julian day
        let date = super.fromJulianDay(jd);
        // Year in Saka era
        let indianYear = date.year - $8e577aaaeb7438e7$var$$82c358003bdda0a8$var$INDIAN_ERA_START;
        // Day number in Gregorian year (starting from 0)
        let yDay = jd - (0, $164d3c47591a715e$export$f297eb839006d339)(date.era, date.year, 1, 1);
        let leapMonth;
        if (yDay < $8e577aaaeb7438e7$var$$82c358003bdda0a8$var$INDIAN_YEAR_START) {
            //  Day is at the end of the preceding Saka year
            indianYear--;
            // Days in leapMonth this year, previous Gregorian year
            leapMonth = (0, $164d3c47591a715e$export$553d7fa8e3805fc0)(date.year - 1) ? 31 : 30;
            yDay += leapMonth + 155 + 90 + 10;
        } else {
            // Days in leapMonth this year
            leapMonth = (0, $164d3c47591a715e$export$553d7fa8e3805fc0)(date.year) ? 31 : 30;
            yDay -= $8e577aaaeb7438e7$var$$82c358003bdda0a8$var$INDIAN_YEAR_START;
        }
        let indianMonth;
        let indianDay;
        if (yDay < leapMonth) {
            indianMonth = 1;
            indianDay = yDay + 1;
        } else {
            let mDay = yDay - leapMonth;
            if (mDay < 155) {
                indianMonth = Math.floor(mDay / 31) + 2;
                indianDay = mDay % 31 + 1;
            } else {
                mDay -= 155;
                indianMonth = Math.floor(mDay / 30) + 7;
                indianDay = mDay % 30 + 1;
            }
        }
        return new (0, $465374ca30ab45d0$export$99faa760c7908e4f)(this, indianYear, indianMonth, indianDay);
    }
    toJulianDay(date) {
        let extendedYear = date.year + $8e577aaaeb7438e7$var$$82c358003bdda0a8$var$INDIAN_ERA_START;
        let [era, year] = (0, $164d3c47591a715e$export$4475b7e617eb123c)(extendedYear);
        let leapMonth;
        let jd;
        if ((0, $164d3c47591a715e$export$553d7fa8e3805fc0)(year)) {
            leapMonth = 31;
            jd = (0, $164d3c47591a715e$export$f297eb839006d339)(era, year, 3, 21);
        } else {
            leapMonth = 30;
            jd = (0, $164d3c47591a715e$export$f297eb839006d339)(era, year, 3, 22);
        }
        if (date.month === 1) return jd + date.day - 1;
        jd += leapMonth + Math.min(date.month - 2, 5) * 31;
        if (date.month >= 8) jd += (date.month - 7) * 30;
        jd += date.day - 1;
        return jd;
    }
    getDaysInMonth(date) {
        if (date.month === 1 && (0, $164d3c47591a715e$export$553d7fa8e3805fc0)(date.year + $8e577aaaeb7438e7$var$$82c358003bdda0a8$var$INDIAN_ERA_START)) return 31;
        if (date.month >= 2 && date.month <= 6) return 31;
        return 30;
    }
    getYearsInEra() {
        // 9999-12-31 gregorian is 9920-10-10 indian.
        // Round down to 9919 for the last full year.
        return 9919;
    }
    getEras() {
        return [
            'saka'
        ];
    }
    balanceDate() {}
    constructor(...args){
        super(...args), this.identifier = 'indian';
    }
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC = 1948440; // CE 622 July 16 Friday (Julian calendar) / CE 622 July 19 (Gregorian calendar)
const $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$ASTRONOMICAL_EPOC = 1948439; // CE 622 July 15 Thursday (Julian calendar)
const $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START = 1300;
const $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END = 1600;
const $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_START_DAYS = 460322;
function $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$islamicToJulianDay(epoch, year, month, day) {
    return day + Math.ceil(29.5 * (month - 1)) + (year - 1) * 354 + Math.floor((3 + 11 * year) / 30) + epoch - 1;
}
function $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$julianDayToIslamic(calendar, epoch, jd) {
    let year = Math.floor((30 * (jd - epoch) + 10646) / 10631);
    let month = Math.min(12, Math.ceil((jd - (29 + $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$islamicToJulianDay(epoch, year, 1, 1))) / 29.5) + 1);
    let day = jd - $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$islamicToJulianDay(epoch, year, month, 1) + 1;
    return new (0, $465374ca30ab45d0$export$99faa760c7908e4f)(calendar, year, month, day);
}
function $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$isLeapYear(year) {
    return (14 + 11 * year) % 30 < 11;
}
class $fd20d32a3aa38e16$export$2066795aadd37bfc {
    fromJulianDay(jd) {
        return $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$julianDayToIslamic(this, $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC, jd);
    }
    toJulianDay(date) {
        return $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$islamicToJulianDay($fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC, date.year, date.month, date.day);
    }
    getDaysInMonth(date) {
        let length = 29 + date.month % 2;
        if (date.month === 12 && $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$isLeapYear(date.year)) length++;
        return length;
    }
    getMonthsInYear() {
        return 12;
    }
    getDaysInYear(date) {
        return $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$isLeapYear(date.year) ? 355 : 354;
    }
    getYearsInEra() {
        // 9999 gregorian
        return 9665;
    }
    getEras() {
        return [
            'AH'
        ];
    }
    constructor(){
        this.identifier = 'islamic-civil';
    }
}
class $fd20d32a3aa38e16$export$37f0887f2f9d22f7 extends $fd20d32a3aa38e16$export$2066795aadd37bfc {
    fromJulianDay(jd) {
        return $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$julianDayToIslamic(this, $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$ASTRONOMICAL_EPOC, jd);
    }
    toJulianDay(date) {
        return $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$islamicToJulianDay($fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$ASTRONOMICAL_EPOC, date.year, date.month, date.day);
    }
    constructor(...args){
        super(...args), this.identifier = 'islamic-tbla';
    }
}
// Generated by scripts/generate-umalqura.js
const $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_DATA = 'qgpUDckO1AbqBmwDrQpVBakGkgepC9QF2gpcBS0NlQZKB1QLagutBa4ETwoXBYsGpQbVCtYCWwmdBE0KJg2VDawFtgm6AlsKKwWVCsoG6Qr0AnYJtgJWCcoKpAvSC9kF3AJtCU0FpQpSC6ULtAW2CVcFlwJLBaMGUgdlC2oFqworBZUMSg2lDcoF1gpXCasESwmlClILagt1BXYCtwhbBFUFqQW0BdoJ3QRuAjYJqgpUDbIN1QXaAlsJqwRVCkkLZAtxC7QFtQpVCiUNkg7JDtQG6QprCasEkwpJDaQNsg25CroEWworBZUKKgtVC1wFvQQ9Ah0JlQpKC1oLbQW2AjsJmwRVBqkGVAdqC2wFrQpVBSkLkgupC9QF2gpaBasKlQVJB2QHqgu1BbYCVgpNDiULUgtqC60FrgIvCZcESwalBqwG1gpdBZ0ETQoWDZUNqgW1BdoCWwmtBJUFygbkBuoK9QS2AlYJqgpUC9IL2QXqAm0JrQSVCkoLpQuyBbUJ1gSXCkcFkwZJB1ULagVrCisFiwpGDaMNygXWCtsEawJLCaUKUgtpC3UFdgG3CFsCKwVlBbQF2gntBG0BtgimClINqQ3UBdoKWwmrBFMGKQdiB6kLsgW1ClUFJQuSDckO0gbpCmsFqwRVCikNVA2qDbUJugQ7CpsETQqqCtUK2gJdCV4ELgqaDFUNsga5BroEXQotBZUKUguoC7QLuQXaAloJSgukDdEO6AZqC20FNQWVBkoNqA3UDdoGWwWdAisGFQtKC5ULqgWuCi4JjwwnBZUGqgbWCl0FnQI=';
let $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH;
let $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE;
function $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$umalquraYearStart(year) {
    return $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_START_DAYS + $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year - $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START];
}
function $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(year, month) {
    let idx = year - $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START;
    let mask = 0x01 << 11 - (month - 1);
    if (($fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH[idx] & mask) === 0) return 29;
    else return 30;
}
function $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$umalquraMonthStart(year, month) {
    let day = $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$umalquraYearStart(year);
    for(let i = 1; i < month; i++)day += $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(year, i);
    return day;
}
function $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$umalquraYearLength(year) {
    return $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year + 1 - $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START] - $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year - $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START];
}
class $fd20d32a3aa38e16$export$5baab4758c231076 extends $fd20d32a3aa38e16$export$2066795aadd37bfc {
    fromJulianDay(jd) {
        let days = jd - $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC;
        let startDays = $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$umalquraYearStart($fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START);
        let endDays = $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$umalquraYearStart($fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END);
        if (days < startDays || days > endDays) return super.fromJulianDay(jd);
        else {
            let y = $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START - 1;
            let m = 1;
            let d = 1;
            while(d > 0){
                y++;
                d = days - $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$umalquraYearStart(y) + 1;
                let yearLength = $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$umalquraYearLength(y);
                if (d === yearLength) {
                    m = 12;
                    break;
                } else if (d < yearLength) {
                    let monthLength = $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(y, m);
                    m = 1;
                    while(d > monthLength){
                        d -= monthLength;
                        m++;
                        monthLength = $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(y, m);
                    }
                    break;
                }
            }
            return new (0, $465374ca30ab45d0$export$99faa760c7908e4f)(this, y, m, days - $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$umalquraMonthStart(y, m) + 1);
        }
    }
    toJulianDay(date) {
        if (date.year < $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START || date.year > $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END) return super.toJulianDay(date);
        return $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC + $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$umalquraMonthStart(date.year, date.month) + (date.day - 1);
    }
    getDaysInMonth(date) {
        if (date.year < $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START || date.year > $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END) return super.getDaysInMonth(date);
        return $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(date.year, date.month);
    }
    getDaysInYear(date) {
        if (date.year < $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START || date.year > $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END) return super.getDaysInYear(date);
        return $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$umalquraYearLength(date.year);
    }
    constructor(){
        super(), this.identifier = 'islamic-umalqura';
        if (!$fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH) $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH = new Uint16Array(Uint8Array.from(atob($fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_DATA), (c)=>c.charCodeAt(0)).buffer);
        if (!$fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE) {
            $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE = new Uint32Array($fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END - $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START + 1);
            let yearStart = 0;
            for(let year = $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START; year <= $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END; year++){
                $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year - $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START] = yearStart;
                for(let i = 1; i <= 12; i++)yearStart += $fd20d32a3aa38e16$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(year, i);
            }
        }
    }
}




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from the TC39 Temporal proposal.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_START_DATES = [
    [
        1868,
        9,
        8
    ],
    [
        1912,
        7,
        30
    ],
    [
        1926,
        12,
        25
    ],
    [
        1989,
        1,
        8
    ],
    [
        2019,
        5,
        1
    ]
];
const $dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_END_DATES = [
    [
        1912,
        7,
        29
    ],
    [
        1926,
        12,
        24
    ],
    [
        1989,
        1,
        7
    ],
    [
        2019,
        4,
        30
    ]
];
const $dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_ADDENDS = [
    1867,
    1911,
    1925,
    1988,
    2018
];
const $dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_NAMES = [
    'meiji',
    'taisho',
    'showa',
    'heisei',
    'reiwa'
];
function $dff7e49b1a7306bf$var$$62225008020f0a13$var$findEraFromGregorianDate(date) {
    const idx = $dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_START_DATES.findIndex(([year, month, day])=>{
        if (date.year < year) return true;
        if (date.year === year && date.month < month) return true;
        if (date.year === year && date.month === month && date.day < day) return true;
        return false;
    });
    if (idx === -1) return $dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_START_DATES.length - 1;
    if (idx === 0) return 0;
    return idx - 1;
}
function $dff7e49b1a7306bf$var$$62225008020f0a13$var$toGregorian(date) {
    let eraAddend = $dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_ADDENDS[$dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_NAMES.indexOf(date.era)];
    if (!eraAddend) throw new Error('Unknown era: ' + date.era);
    return new (0, $465374ca30ab45d0$export$99faa760c7908e4f)(date.year + eraAddend, date.month, date.day);
}
class $dff7e49b1a7306bf$export$b746ab2b60cdffbf extends (0, $164d3c47591a715e$export$80ee6245ec4f29ec) {
    fromJulianDay(jd) {
        let date = super.fromJulianDay(jd);
        let era = $dff7e49b1a7306bf$var$$62225008020f0a13$var$findEraFromGregorianDate(date);
        return new (0, $465374ca30ab45d0$export$99faa760c7908e4f)(this, $dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_NAMES[era], date.year - $dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_ADDENDS[era], date.month, date.day);
    }
    toJulianDay(date) {
        return super.toJulianDay($dff7e49b1a7306bf$var$$62225008020f0a13$var$toGregorian(date));
    }
    balanceDate(date) {
        let gregorianDate = $dff7e49b1a7306bf$var$$62225008020f0a13$var$toGregorian(date);
        let era = $dff7e49b1a7306bf$var$$62225008020f0a13$var$findEraFromGregorianDate(gregorianDate);
        if ($dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_NAMES[era] !== date.era) {
            date.era = $dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_NAMES[era];
            date.year = gregorianDate.year - $dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_ADDENDS[era];
        }
        // Constrain in case we went before the first supported era.
        this.constrainDate(date);
    }
    constrainDate(date) {
        let idx = $dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
        let end = $dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_END_DATES[idx];
        if (end != null) {
            let [endYear, endMonth, endDay] = end;
            // Constrain the year to the maximum possible value in the era.
            // Then constrain the month and day fields within that.
            let maxYear = endYear - $dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_ADDENDS[idx];
            date.year = Math.max(1, Math.min(maxYear, date.year));
            if (date.year === maxYear) {
                date.month = Math.min(endMonth, date.month);
                if (date.month === endMonth) date.day = Math.min(endDay, date.day);
            }
        }
        if (date.year === 1 && idx >= 0) {
            let [, startMonth, startDay] = $dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_START_DATES[idx];
            date.month = Math.max(startMonth, date.month);
            if (date.month === startMonth) date.day = Math.max(startDay, date.day);
        }
    }
    getEras() {
        return $dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_NAMES;
    }
    getYearsInEra(date) {
        // Get the number of years in the era, taking into account the date's month and day fields.
        let era = $dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
        let cur = $dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_START_DATES[era];
        let next = $dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_START_DATES[era + 1];
        if (next == null) return 9999 - cur[0] + 1;
        let years = next[0] - cur[0];
        if (date.month < next[1] || date.month === next[1] && date.day < next[2]) years++;
        return years;
    }
    getDaysInMonth(date) {
        return super.getDaysInMonth($dff7e49b1a7306bf$var$$62225008020f0a13$var$toGregorian(date));
    }
    getMinimumMonthInYear(date) {
        let start = $dff7e49b1a7306bf$var$$62225008020f0a13$var$getMinimums(date);
        return start ? start[1] : 1;
    }
    getMinimumDayInMonth(date) {
        let start = $dff7e49b1a7306bf$var$$62225008020f0a13$var$getMinimums(date);
        return start && date.month === start[1] ? start[2] : 1;
    }
    constructor(...args){
        super(...args), this.identifier = 'japanese';
    }
}
function $dff7e49b1a7306bf$var$$62225008020f0a13$var$getMinimums(date) {
    if (date.year === 1) {
        let idx = $dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
        return $dff7e49b1a7306bf$var$$62225008020f0a13$var$ERA_START_DATES[idx];
    }
}




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $aa1e3af8fd685566$var$$f3ed2e4472ae7e25$var$PERSIAN_EPOCH = 1948320;
// Number of days from the start of the year to the start of each month.
const $aa1e3af8fd685566$var$$f3ed2e4472ae7e25$var$MONTH_START = [
    0,
    31,
    62,
    93,
    124,
    155,
    186,
    216,
    246,
    276,
    306,
    336 // Esfand
];
class $aa1e3af8fd685566$export$37fccdbfd14c5939 {
    fromJulianDay(jd) {
        let daysSinceEpoch = jd - $aa1e3af8fd685566$var$$f3ed2e4472ae7e25$var$PERSIAN_EPOCH;
        let year = 1 + Math.floor((33 * daysSinceEpoch + 3) / 12053);
        let farvardin1 = 365 * (year - 1) + Math.floor((8 * year + 21) / 33);
        let dayOfYear = daysSinceEpoch - farvardin1;
        let month = dayOfYear < 216 ? Math.floor(dayOfYear / 31) : Math.floor((dayOfYear - 6) / 30);
        let day = dayOfYear - $aa1e3af8fd685566$var$$f3ed2e4472ae7e25$var$MONTH_START[month] + 1;
        return new (0, $465374ca30ab45d0$export$99faa760c7908e4f)(this, year, month + 1, day);
    }
    toJulianDay(date) {
        let jd = $aa1e3af8fd685566$var$$f3ed2e4472ae7e25$var$PERSIAN_EPOCH - 1 + 365 * (date.year - 1) + Math.floor((8 * date.year + 21) / 33);
        jd += $aa1e3af8fd685566$var$$f3ed2e4472ae7e25$var$MONTH_START[date.month - 1];
        jd += date.day;
        return jd;
    }
    getMonthsInYear() {
        return 12;
    }
    getDaysInMonth(date) {
        if (date.month <= 6) return 31;
        if (date.month <= 11) return 30;
        let isLeapYear = (0, $6029cd325c4477d7$export$842a2cf37af977e1)(25 * date.year + 11, 33) < 8;
        return isLeapYear ? 30 : 29;
    }
    getEras() {
        return [
            'AP'
        ];
    }
    getYearsInEra() {
        // 9378-10-10 persian is 9999-12-31 gregorian.
        // Round down to 9377 to set the maximum full year.
        return 9377;
    }
    constructor(){
        this.identifier = 'persian';
    }
}




/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $61324acaac7bd23c$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START = 1911;
function $61324acaac7bd23c$var$$5f31bd6f0c8940b2$var$gregorianYear(date) {
    return date.era === 'minguo' ? date.year + $61324acaac7bd23c$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START : 1 - date.year + $61324acaac7bd23c$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START;
}
function $61324acaac7bd23c$var$$5f31bd6f0c8940b2$var$gregorianToTaiwan(year) {
    let y = year - $61324acaac7bd23c$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START;
    if (y > 0) return [
        'minguo',
        y
    ];
    else return [
        'before_minguo',
        1 - y
    ];
}
class $61324acaac7bd23c$export$65e01080afcb0799 extends (0, $164d3c47591a715e$export$80ee6245ec4f29ec) {
    fromJulianDay(jd) {
        let date = super.fromJulianDay(jd);
        let extendedYear = (0, $164d3c47591a715e$export$c36e0ecb2d4fa69d)(date.era, date.year);
        let [era, year] = $61324acaac7bd23c$var$$5f31bd6f0c8940b2$var$gregorianToTaiwan(extendedYear);
        return new (0, $465374ca30ab45d0$export$99faa760c7908e4f)(this, era, year, date.month, date.day);
    }
    toJulianDay(date) {
        return super.toJulianDay($61324acaac7bd23c$var$$5f31bd6f0c8940b2$var$toGregorian(date));
    }
    getEras() {
        return [
            'before_minguo',
            'minguo'
        ];
    }
    balanceDate(date) {
        let [era, year] = $61324acaac7bd23c$var$$5f31bd6f0c8940b2$var$gregorianToTaiwan($61324acaac7bd23c$var$$5f31bd6f0c8940b2$var$gregorianYear(date));
        date.era = era;
        date.year = year;
    }
    isInverseEra(date) {
        return date.era === 'before_minguo';
    }
    getDaysInMonth(date) {
        return super.getDaysInMonth($61324acaac7bd23c$var$$5f31bd6f0c8940b2$var$toGregorian(date));
    }
    getYearsInEra(date) {
        return date.era === 'before_minguo' ? 9999 : 9999 - $61324acaac7bd23c$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START;
    }
    constructor(...args){
        super(...args), this.identifier = 'roc' // Republic of China
        ;
    }
}
function $61324acaac7bd23c$var$$5f31bd6f0c8940b2$var$toGregorian(date) {
    let [era, year] = (0, $164d3c47591a715e$export$4475b7e617eb123c)($61324acaac7bd23c$var$$5f31bd6f0c8940b2$var$gregorianYear(date));
    return new (0, $465374ca30ab45d0$export$99faa760c7908e4f)(era, year, date.month, date.day);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5a975329a8a829eb$export$dd0bbc9b26defe37(name) {
    switch(name){
        case 'buddhist':
            return new (0, $bd4fa81aad972291$export$42d20a78301dee44)();
        case 'ethiopic':
            return new (0, $91aedb93fbe111a0$export$26ba6eab5e20cd7d)();
        case 'ethioaa':
            return new (0, $91aedb93fbe111a0$export$d72e0c37005a4914)();
        case 'coptic':
            return new (0, $91aedb93fbe111a0$export$fe6243cbe1a4b7c1)();
        case 'hebrew':
            return new (0, $4825ebaf0e9a53ce$export$ca405048b8fb5af)();
        case 'indian':
            return new (0, $8e577aaaeb7438e7$export$39f31c639fa15726)();
        case 'islamic-civil':
            return new (0, $fd20d32a3aa38e16$export$2066795aadd37bfc)();
        case 'islamic-tbla':
            return new (0, $fd20d32a3aa38e16$export$37f0887f2f9d22f7)();
        case 'islamic-umalqura':
            return new (0, $fd20d32a3aa38e16$export$5baab4758c231076)();
        case 'japanese':
            return new (0, $dff7e49b1a7306bf$export$b746ab2b60cdffbf)();
        case 'persian':
            return new (0, $aa1e3af8fd685566$export$37fccdbfd14c5939)();
        case 'roc':
            return new (0, $61324acaac7bd23c$export$65e01080afcb0799)();
        case 'gregory':
        default:
            return new (0, $164d3c47591a715e$export$80ee6245ec4f29ec)();
    }
}


var $ee6e54bc3c1a6860$export$2e2bcd8739ae039 = {};
$ee6e54bc3c1a6860$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{62A}\u{643}\u{648}\u{646} \u{627}\u{644}\u{642}\u{64A}\u{645}\u{629} ${args.maxValue} \u{623}\u{648} \u{642}\u{628}\u{644} \u{630}\u{644}\u{643}.`,
    "rangeReversed": `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{628}\u{62F}\u{621} \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} \u{642}\u{628}\u{644} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{647}\u{627}\u{621}.`,
    "rangeUnderflow": (args)=>`\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{62A}\u{643}\u{648}\u{646} \u{627}\u{644}\u{642}\u{64A}\u{645}\u{629} ${args.minValue} \u{623}\u{648} \u{628}\u{639}\u{62F} \u{630}\u{644}\u{643}.`,
    "unavailableDate": `\u{627}\u{644}\u{628}\u{64A}\u{627}\u{646}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}\u{629} \u{63A}\u{64A}\u{631} \u{645}\u{62A}\u{627}\u{62D}\u{629}.`
};


var $3270a3573bd569ee$export$2e2bcd8739ae039 = {};
$3270a3573bd569ee$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`\u{421}\u{442}\u{43E}\u{439}\u{43D}\u{43E}\u{441}\u{442}\u{442}\u{430} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{435} ${args.maxValue} \u{438}\u{43B}\u{438} \u{43F}\u{43E}-\u{440}\u{430}\u{43D}\u{43D}\u{430}.`,
    "rangeReversed": `\u{41D}\u{430}\u{447}\u{430}\u{43B}\u{43D}\u{430}\u{442}\u{430} \u{434}\u{430}\u{442}\u{430} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{435} \u{43F}\u{440}\u{435}\u{434}\u{438} \u{43A}\u{440}\u{430}\u{439}\u{43D}\u{430}\u{442}\u{430}.`,
    "rangeUnderflow": (args)=>`\u{421}\u{442}\u{43E}\u{439}\u{43D}\u{43E}\u{441}\u{442}\u{442}\u{430} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{435} ${args.minValue} \u{438}\u{43B}\u{438} \u{43F}\u{43E}-\u{43A}\u{44A}\u{441}\u{43D}\u{43E}.`,
    "unavailableDate": `\u{418}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{430}\u{442}\u{430} \u{434}\u{430}\u{442}\u{430} \u{43D}\u{435} \u{435} \u{43D}\u{430}\u{43B}\u{438}\u{447}\u{43D}\u{430}.`
};


var $72828c298fc827fa$export$2e2bcd8739ae039 = {};
$72828c298fc827fa$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Hodnota mus\xed b\xfdt ${args.maxValue} nebo d\u{159}\xedv\u{11B}j\u{161}\xed.`,
    "rangeReversed": `Datum zah\xe1jen\xed mus\xed p\u{159}edch\xe1zet datu ukon\u{10D}en\xed.`,
    "rangeUnderflow": (args)=>`Hodnota mus\xed b\xfdt ${args.minValue} nebo pozd\u{11B}j\u{161}\xed.`,
    "unavailableDate": `Vybran\xe9 datum nen\xed k dispozici.`
};


var $e721edddfd7e2524$export$2e2bcd8739ae039 = {};
$e721edddfd7e2524$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`V\xe6rdien skal v\xe6re ${args.maxValue} eller tidligere.`,
    "rangeReversed": `Startdatoen skal v\xe6re f\xf8r slutdatoen.`,
    "rangeUnderflow": (args)=>`V\xe6rdien skal v\xe6re ${args.minValue} eller nyere.`,
    "unavailableDate": `Den valgte dato er ikke tilg\xe6ngelig.`
};


var $898a9edbdb1c5e6a$export$2e2bcd8739ae039 = {};
$898a9edbdb1c5e6a$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Der Wert muss ${args.maxValue} oder fr\xfcher sein.`,
    "rangeReversed": `Das Startdatum muss vor dem Enddatum liegen.`,
    "rangeUnderflow": (args)=>`Der Wert muss ${args.minValue} oder sp\xe4ter sein.`,
    "unavailableDate": `Das ausgew\xe4hlte Datum ist nicht verf\xfcgbar.`
};


var $9ca21e39241f277f$export$2e2bcd8739ae039 = {};
$9ca21e39241f277f$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`\u{397} \u{3C4}\u{3B9}\u{3BC}\u{3AE} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} ${args.maxValue} \u{3AE} \u{3C0}\u{3B1}\u{3BB}\u{3B1}\u{3B9}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3B7}.`,
    "rangeReversed": `\u{397} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1} \u{3AD}\u{3BD}\u{3B1}\u{3C1}\u{3BE}\u{3B7}\u{3C2} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3C0}\u{3C1}\u{3B9}\u{3BD} \u{3B1}\u{3C0}\u{3CC} \u{3C4}\u{3B7}\u{3BD} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1} \u{3BB}\u{3AE}\u{3BE}\u{3B7}\u{3C2}.`,
    "rangeUnderflow": (args)=>`\u{397} \u{3C4}\u{3B9}\u{3BC}\u{3AE} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} ${args.minValue} \u{3AE} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3B3}\u{3B5}\u{3BD}\u{3AD}\u{3C3}\u{3C4}\u{3B5}\u{3C1}\u{3B7}.`,
    "unavailableDate": `\u{397} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B7} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1} \u{3B4}\u{3B5}\u{3BD} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3B4}\u{3B9}\u{3B1}\u{3B8}\u{3AD}\u{3C3}\u{3B9}\u{3BC}\u{3B7}.`
};


var $19064be8b34101bf$export$2e2bcd8739ae039 = {};
$19064be8b34101bf$export$2e2bcd8739ae039 = {
    "rangeUnderflow": (args)=>`Value must be ${args.minValue} or later.`,
    "rangeOverflow": (args)=>`Value must be ${args.maxValue} or earlier.`,
    "rangeReversed": `Start date must be before end date.`,
    "unavailableDate": `Selected date unavailable.`
};


var $6fe85f32c528e257$export$2e2bcd8739ae039 = {};
$6fe85f32c528e257$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`El valor debe ser ${args.maxValue} o anterior.`,
    "rangeReversed": `La fecha de inicio debe ser anterior a la fecha de finalizaci\xf3n.`,
    "rangeUnderflow": (args)=>`El valor debe ser ${args.minValue} o posterior.`,
    "unavailableDate": `Fecha seleccionada no disponible.`
};


var $0085fb6b073dbd86$export$2e2bcd8739ae039 = {};
$0085fb6b073dbd86$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`V\xe4\xe4rtus peab olema ${args.maxValue} v\xf5i varasem.`,
    "rangeReversed": `Alguskuup\xe4ev peab olema enne l\xf5ppkuup\xe4eva.`,
    "rangeUnderflow": (args)=>`V\xe4\xe4rtus peab olema ${args.minValue} v\xf5i hilisem.`,
    "unavailableDate": `Valitud kuup\xe4ev pole saadaval.`
};


var $00ba9fcf3fe9102b$export$2e2bcd8739ae039 = {};
$00ba9fcf3fe9102b$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Arvon on oltava ${args.maxValue} tai sit\xe4 aikaisempi.`,
    "rangeReversed": `Aloitusp\xe4iv\xe4n on oltava ennen lopetusp\xe4iv\xe4\xe4.`,
    "rangeUnderflow": (args)=>`Arvon on oltava ${args.minValue} tai sit\xe4 my\xf6h\xe4isempi.`,
    "unavailableDate": `Valittu p\xe4iv\xe4m\xe4\xe4r\xe4 ei ole k\xe4ytett\xe4viss\xe4.`
};


var $3486e3936993151e$export$2e2bcd8739ae039 = {};
$3486e3936993151e$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`La valeur doit \xeatre ${args.maxValue} ou ant\xe9rieure.`,
    "rangeReversed": `La date de d\xe9but doit \xeatre ant\xe9rieure \xe0 la date de fin.`,
    "rangeUnderflow": (args)=>`La valeur doit \xeatre ${args.minValue} ou ult\xe9rieure.`,
    "unavailableDate": `La date s\xe9lectionn\xe9e n\u{2019}est pas disponible.`
};


var $2d05dfb17e46835c$export$2e2bcd8739ae039 = {};
$2d05dfb17e46835c$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`\u{5D4}\u{5E2}\u{5E8}\u{5DA} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} ${args.maxValue} \u{5D0}\u{5D5} \u{5DE}\u{5D5}\u{5E7}\u{5D3}\u{5DD} \u{5D9}\u{5D5}\u{5EA}\u{5E8}.`,
    "rangeReversed": `\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5D4}\u{5D4}\u{5EA}\u{5D7}\u{5DC}\u{5D4} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5DC}\u{5E4}\u{5E0}\u{5D9} \u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5D4}\u{5E1}\u{5D9}\u{5D5}\u{5DD}.`,
    "rangeUnderflow": (args)=>`\u{5D4}\u{5E2}\u{5E8}\u{5DA} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} ${args.minValue} \u{5D0}\u{5D5} \u{5DE}\u{5D0}\u{5D5}\u{5D7}\u{5E8} \u{5D9}\u{5D5}\u{5EA}\u{5E8}.`,
    "unavailableDate": `\u{5D4}\u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5D4}\u{5E0}\u{5D1}\u{5D7}\u{5E8} \u{5D0}\u{5D9}\u{5E0}\u{5D5} \u{5D6}\u{5DE}\u{5D9}\u{5DF}.`
};


var $526b1d82ed793e8d$export$2e2bcd8739ae039 = {};
$526b1d82ed793e8d$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Vrijednost mora biti ${args.maxValue} ili ranije.`,
    "rangeReversed": `Datum po\u{10D}etka mora biti prije datuma zavr\u{161}etka.`,
    "rangeUnderflow": (args)=>`Vrijednost mora biti ${args.minValue} ili kasnije.`,
    "unavailableDate": `Odabrani datum nije dostupan.`
};


var $e94a5f83cf2e2b33$export$2e2bcd8739ae039 = {};
$e94a5f83cf2e2b33$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Az \xe9rt\xe9knek ${args.maxValue} vagy kor\xe1bbinak kell lennie.`,
    "rangeReversed": `A kezd\u{151} d\xe1tumnak a befejez\u{151} d\xe1tumn\xe1l kor\xe1bbinak kell lennie.`,
    "rangeUnderflow": (args)=>`Az \xe9rt\xe9knek ${args.minValue} vagy k\xe9s\u{151}bbinek kell lennie.`,
    "unavailableDate": `A kiv\xe1lasztott d\xe1tum nem \xe9rhet\u{151} el.`
};


var $09c7cb18a3fb7269$export$2e2bcd8739ae039 = {};
$09c7cb18a3fb7269$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Il valore deve essere ${args.maxValue} o precedente.`,
    "rangeReversed": `La data di inizio deve essere antecedente alla data di fine.`,
    "rangeUnderflow": (args)=>`Il valore deve essere ${args.minValue} o successivo.`,
    "unavailableDate": `Data selezionata non disponibile.`
};


var $3aaa5c585bc5e6c1$export$2e2bcd8739ae039 = {};
$3aaa5c585bc5e6c1$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`\u{5024}\u{306F} ${args.maxValue} \u{4EE5}\u{4E0B}\u{306B}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    "rangeReversed": `\u{958B}\u{59CB}\u{65E5}\u{306F}\u{7D42}\u{4E86}\u{65E5}\u{3088}\u{308A}\u{524D}\u{306B}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    "rangeUnderflow": (args)=>`\u{5024}\u{306F} ${args.minValue} \u{4EE5}\u{4E0A}\u{306B}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    "unavailableDate": `\u{9078}\u{629E}\u{3057}\u{305F}\u{65E5}\u{4ED8}\u{306F}\u{4F7F}\u{7528}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`
};


var $e42e9d62666a8fd0$export$2e2bcd8739ae039 = {};
$e42e9d62666a8fd0$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`\u{AC12}\u{C740} ${args.maxValue} \u{C774}\u{C804}\u{C774}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    "rangeReversed": `\u{C2DC}\u{C791}\u{C77C}\u{C740} \u{C885}\u{B8CC}\u{C77C} \u{C774}\u{C804}\u{C774}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    "rangeUnderflow": (args)=>`\u{AC12}\u{C740} ${args.minValue} \u{C774}\u{D6C4}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    "unavailableDate": `\u{C120}\u{D0DD}\u{D55C} \u{B0A0}\u{C9DC}\u{B97C} \u{C0AC}\u{C6A9}\u{D560} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`
};


var $cdb01d94698caf4a$export$2e2bcd8739ae039 = {};
$cdb01d94698caf4a$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Reik\u{161}m\u{117} turi b\u{16B}ti ${args.maxValue} arba ankstesn\u{117}.`,
    "rangeReversed": `Prad\u{17E}ios data turi b\u{16B}ti ankstesn\u{117} nei pabaigos data.`,
    "rangeUnderflow": (args)=>`Reik\u{161}m\u{117} turi b\u{16B}ti ${args.minValue} arba naujesn\u{117}.`,
    "unavailableDate": `Pasirinkta data nepasiekiama.`
};


var $985ef299334f3294$export$2e2bcd8739ae039 = {};
$985ef299334f3294$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`V\u{113}rt\u{12B}bai ir j\u{101}b\u{16B}t ${args.maxValue} vai agr\u{101}kai.`,
    "rangeReversed": `S\u{101}kuma datumam ir j\u{101}b\u{16B}t pirms beigu datuma.`,
    "rangeUnderflow": (args)=>`V\u{113}rt\u{12B}bai ir j\u{101}b\u{16B}t ${args.minValue} vai v\u{113}l\u{101}kai.`,
    "unavailableDate": `Atlas\u{12B}tais datums nav pieejams.`
};


var $23e9eabda3b078c9$export$2e2bcd8739ae039 = {};
$23e9eabda3b078c9$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Verdien m\xe5 v\xe6re ${args.maxValue} eller tidligere.`,
    "rangeReversed": `Startdatoen m\xe5 v\xe6re f\xf8r sluttdatoen.`,
    "rangeUnderflow": (args)=>`Verdien m\xe5 v\xe6re ${args.minValue} eller senere.`,
    "unavailableDate": `Valgt dato utilgjengelig.`
};


var $b42960fa670cd6d3$export$2e2bcd8739ae039 = {};
$b42960fa670cd6d3$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Waarde moet ${args.maxValue} of eerder zijn.`,
    "rangeReversed": `De startdatum moet voor de einddatum liggen.`,
    "rangeUnderflow": (args)=>`Waarde moet ${args.minValue} of later zijn.`,
    "unavailableDate": `Geselecteerde datum niet beschikbaar.`
};


var $af1175219bbf231a$export$2e2bcd8739ae039 = {};
$af1175219bbf231a$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Warto\u{15B}\u{107} musi mie\u{107} warto\u{15B}\u{107} ${args.maxValue} lub wcze\u{15B}niejsz\u{105}.`,
    "rangeReversed": `Data rozpocz\u{119}cia musi by\u{107} wcze\u{15B}niejsza ni\u{17C} data zako\u{144}czenia.`,
    "rangeUnderflow": (args)=>`Warto\u{15B}\u{107} musi mie\u{107} warto\u{15B}\u{107} ${args.minValue} lub p\xf3\u{17A}niejsz\u{105}.`,
    "unavailableDate": `Wybrana data jest niedost\u{119}pna.`
};


var $0a581176bb9098eb$export$2e2bcd8739ae039 = {};
$0a581176bb9098eb$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`O valor deve ser ${args.maxValue} ou anterior.`,
    "rangeReversed": `A data inicial deve ser anterior \xe0 data final.`,
    "rangeUnderflow": (args)=>`O valor deve ser ${args.minValue} ou posterior.`,
    "unavailableDate": `Data selecionada indispon\xedvel.`
};


var $24a7caf45845b6a4$export$2e2bcd8739ae039 = {};
$24a7caf45845b6a4$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`O valor tem de ser ${args.maxValue} ou anterior.`,
    "rangeReversed": `A data de in\xedcio deve ser anterior \xe0 data de fim.`,
    "rangeUnderflow": (args)=>`O valor tem de ser ${args.minValue} ou posterior.`,
    "unavailableDate": `Data selecionada indispon\xedvel.`
};


var $7674746520bec4d9$export$2e2bcd8739ae039 = {};
$7674746520bec4d9$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Valoarea trebuie s\u{103} fie ${args.maxValue} sau anterioar\u{103}.`,
    "rangeReversed": `Data de \xeenceput trebuie s\u{103} fie anterioar\u{103} datei de sf\xe2r\u{219}it.`,
    "rangeUnderflow": (args)=>`Valoarea trebuie s\u{103} fie ${args.minValue} sau ulterioar\u{103}.`,
    "unavailableDate": `Data selectat\u{103} nu este disponibil\u{103}.`
};


var $5200be9c7b4a8a68$export$2e2bcd8739ae039 = {};
$5200be9c7b4a8a68$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`\u{417}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{43D}\u{435} \u{43F}\u{43E}\u{437}\u{436}\u{435} ${args.maxValue}.`,
    "rangeReversed": `\u{414}\u{430}\u{442}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{43F}\u{440}\u{435}\u{434}\u{448}\u{435}\u{441}\u{442}\u{432}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{434}\u{430}\u{442}\u{435} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F}.`,
    "rangeUnderflow": (args)=>`\u{417}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{43D}\u{435} \u{440}\u{430}\u{43D}\u{44C}\u{448}\u{435} ${args.minValue}.`,
    "unavailableDate": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{430}\u{44F} \u{434}\u{430}\u{442}\u{430} \u{43D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430}.`
};


var $cfa293ca99657b1f$export$2e2bcd8739ae039 = {};
$cfa293ca99657b1f$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Hodnota mus\xed by\u{165} ${args.maxValue} alebo skor\u{161}ia.`,
    "rangeReversed": `D\xe1tum za\u{10D}iatku mus\xed by\u{165} skor\u{161}\xed ako d\xe1tum konca.`,
    "rangeUnderflow": (args)=>`Hodnota mus\xed by\u{165} ${args.minValue} alebo neskor\u{161}ia.`,
    "unavailableDate": `Vybrat\xfd d\xe1tum je nedostupn\xfd.`
};


var $7e37cb171ec1a6aa$export$2e2bcd8739ae039 = {};
$7e37cb171ec1a6aa$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Vrednost mora biti ${args.maxValue} ali starej\u{161}a.`,
    "rangeReversed": `Za\u{10D}etni datum mora biti pred kon\u{10D}nim datumom.`,
    "rangeUnderflow": (args)=>`Vrednost mora biti ${args.minValue} ali novej\u{161}a.`,
    "unavailableDate": `Izbrani datum ni na voljo.`
};


var $cfb9472a91fbe62b$export$2e2bcd8739ae039 = {};
$cfb9472a91fbe62b$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`Vrednost mora da bude ${args.maxValue} ili starija.`,
    "rangeReversed": `Datum po\u{10D}etka mora biti pre datuma zavr\u{161}etka.`,
    "rangeUnderflow": (args)=>`Vrednost mora da bude ${args.minValue} ili novija.`,
    "unavailableDate": `Izabrani datum nije dostupan.`
};


var $613d3fd934ab16f9$export$2e2bcd8739ae039 = {};
$613d3fd934ab16f9$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`V\xe4rdet m\xe5ste vara ${args.maxValue} eller tidigare.`,
    "rangeReversed": `Startdatumet m\xe5ste vara f\xf6re slutdatumet.`,
    "rangeUnderflow": (args)=>`V\xe4rdet m\xe5ste vara ${args.minValue} eller senare.`,
    "unavailableDate": `Det valda datumet \xe4r inte tillg\xe4ngligt.`
};


var $a3d4ec759a570576$export$2e2bcd8739ae039 = {};
$a3d4ec759a570576$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`De\u{11F}er, ${args.maxValue} veya \xf6ncesi olmal\u{131}d\u{131}r.`,
    "rangeReversed": `Ba\u{15F}lang\u{131}\xe7 tarihi biti\u{15F} tarihinden \xf6nce olmal\u{131}d\u{131}r.`,
    "rangeUnderflow": (args)=>`De\u{11F}er, ${args.minValue} veya sonras\u{131} olmal\u{131}d\u{131}r.`,
    "unavailableDate": `Se\xe7ilen tarih kullan\u{131}lam\u{131}yor.`
};


var $98b507c2a0f01d2e$export$2e2bcd8739ae039 = {};
$98b507c2a0f01d2e$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`\u{417}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43D}\u{44F} \u{43C}\u{430}\u{454} \u{431}\u{443}\u{442}\u{438} \u{43D}\u{435} \u{43F}\u{456}\u{437}\u{43D}\u{456}\u{448}\u{435} ${args.maxValue}.`,
    "rangeReversed": `\u{414}\u{430}\u{442}\u{430} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{43A}\u{443} \u{43C}\u{430}\u{454} \u{43F}\u{435}\u{440}\u{435}\u{434}\u{443}\u{432}\u{430}\u{442}\u{438} \u{434}\u{430}\u{442}\u{456} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43D}\u{44F}.`,
    "rangeUnderflow": (args)=>`\u{417}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43D}\u{44F} \u{43C}\u{430}\u{454} \u{431}\u{443}\u{442}\u{438} \u{43D}\u{435} \u{440}\u{430}\u{43D}\u{456}\u{448}\u{435} ${args.minValue}.`,
    "unavailableDate": `\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430} \u{43D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430}.`
};


var $558f1429ded9717f$export$2e2bcd8739ae039 = {};
$558f1429ded9717f$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`\u{503C}\u{5FC5}\u{987B}\u{662F} ${args.maxValue} \u{6216}\u{66F4}\u{65E9}\u{65E5}\u{671F}\u{3002}`,
    "rangeReversed": `\u{5F00}\u{59CB}\u{65E5}\u{671F}\u{5FC5}\u{987B}\u{65E9}\u{4E8E}\u{7ED3}\u{675F}\u{65E5}\u{671F}\u{3002}`,
    "rangeUnderflow": (args)=>`\u{503C}\u{5FC5}\u{987B}\u{662F} ${args.minValue} \u{6216}\u{66F4}\u{665A}\u{65E5}\u{671F}\u{3002}`,
    "unavailableDate": `\u{6240}\u{9009}\u{65E5}\u{671F}\u{4E0D}\u{53EF}\u{7528}\u{3002}`
};


var $8cde6d43ba8420a0$export$2e2bcd8739ae039 = {};
$8cde6d43ba8420a0$export$2e2bcd8739ae039 = {
    "rangeOverflow": (args)=>`\u{503C}\u{5FC5}\u{9808}\u{662F} ${args.maxValue} \u{6216}\u{66F4}\u{65E9}\u{3002}`,
    "rangeReversed": `\u{958B}\u{59CB}\u{65E5}\u{671F}\u{5FC5}\u{9808}\u{5728}\u{7D50}\u{675F}\u{65E5}\u{671F}\u{4E4B}\u{524D}\u{3002}`,
    "rangeUnderflow": (args)=>`\u{503C}\u{5FC5}\u{9808}\u{662F} ${args.minValue} \u{6216}\u{66F4}\u{665A}\u{3002}`,
    "unavailableDate": `\u{6240}\u{9078}\u{65E5}\u{671F}\u{7121}\u{6CD5}\u{4F7F}\u{7528}\u{3002}`
};


var $326d2eb2434b952e$export$2e2bcd8739ae039 = {};
$326d2eb2434b952e$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $ee6e54bc3c1a6860$export$2e2bcd8739ae039),
    "bg-BG": (0, $3270a3573bd569ee$export$2e2bcd8739ae039),
    "cs-CZ": (0, $72828c298fc827fa$export$2e2bcd8739ae039),
    "da-DK": (0, $e721edddfd7e2524$export$2e2bcd8739ae039),
    "de-DE": (0, $898a9edbdb1c5e6a$export$2e2bcd8739ae039),
    "el-GR": (0, $9ca21e39241f277f$export$2e2bcd8739ae039),
    "en-US": (0, $19064be8b34101bf$export$2e2bcd8739ae039),
    "es-ES": (0, $6fe85f32c528e257$export$2e2bcd8739ae039),
    "et-EE": (0, $0085fb6b073dbd86$export$2e2bcd8739ae039),
    "fi-FI": (0, $00ba9fcf3fe9102b$export$2e2bcd8739ae039),
    "fr-FR": (0, $3486e3936993151e$export$2e2bcd8739ae039),
    "he-IL": (0, $2d05dfb17e46835c$export$2e2bcd8739ae039),
    "hr-HR": (0, $526b1d82ed793e8d$export$2e2bcd8739ae039),
    "hu-HU": (0, $e94a5f83cf2e2b33$export$2e2bcd8739ae039),
    "it-IT": (0, $09c7cb18a3fb7269$export$2e2bcd8739ae039),
    "ja-JP": (0, $3aaa5c585bc5e6c1$export$2e2bcd8739ae039),
    "ko-KR": (0, $e42e9d62666a8fd0$export$2e2bcd8739ae039),
    "lt-LT": (0, $cdb01d94698caf4a$export$2e2bcd8739ae039),
    "lv-LV": (0, $985ef299334f3294$export$2e2bcd8739ae039),
    "nb-NO": (0, $23e9eabda3b078c9$export$2e2bcd8739ae039),
    "nl-NL": (0, $b42960fa670cd6d3$export$2e2bcd8739ae039),
    "pl-PL": (0, $af1175219bbf231a$export$2e2bcd8739ae039),
    "pt-BR": (0, $0a581176bb9098eb$export$2e2bcd8739ae039),
    "pt-PT": (0, $24a7caf45845b6a4$export$2e2bcd8739ae039),
    "ro-RO": (0, $7674746520bec4d9$export$2e2bcd8739ae039),
    "ru-RU": (0, $5200be9c7b4a8a68$export$2e2bcd8739ae039),
    "sk-SK": (0, $cfa293ca99657b1f$export$2e2bcd8739ae039),
    "sl-SI": (0, $7e37cb171ec1a6aa$export$2e2bcd8739ae039),
    "sr-SP": (0, $cfb9472a91fbe62b$export$2e2bcd8739ae039),
    "sv-SE": (0, $613d3fd934ab16f9$export$2e2bcd8739ae039),
    "tr-TR": (0, $a3d4ec759a570576$export$2e2bcd8739ae039),
    "uk-UA": (0, $98b507c2a0f01d2e$export$2e2bcd8739ae039),
    "zh-CN": (0, $558f1429ded9717f$export$2e2bcd8739ae039),
    "zh-TW": (0, $8cde6d43ba8420a0$export$2e2bcd8739ae039)
};






var $acw62 = parcelRequire("acw62");
function $9ec22d3a5d10504e$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $9ec22d3a5d10504e$var$$35a22f14a1f04b11$var$dictionary = new (0, $79f23ee9c19a1f41$export$c17fa47878dc55b6)($9ec22d3a5d10504e$var$$parcel$interopDefault((0, $326d2eb2434b952e$export$2e2bcd8739ae039)));
function $9ec22d3a5d10504e$var$$35a22f14a1f04b11$var$getLocale() {
    // Match browser language setting here, NOT react-aria's I18nProvider, so that we match other browser-provided
    // validation messages, which to not respect our provider's language.
    // @ts-ignore
    let locale = typeof navigator !== 'undefined' && (navigator.language || navigator.userLanguage) || 'en-US';
    try {
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch  {
        locale = 'en-US';
    }
    return locale;
}
function $9ec22d3a5d10504e$export$f18627323ab57ac0(value, minValue, maxValue, isDateUnavailable, options) {
    let rangeOverflow = value != null && maxValue != null && value.compare(maxValue) > 0;
    let rangeUnderflow = value != null && minValue != null && value.compare(minValue) < 0;
    let isUnavailable = value != null && (isDateUnavailable === null || isDateUnavailable === void 0 ? void 0 : isDateUnavailable(value)) || false;
    let isInvalid = rangeOverflow || rangeUnderflow || isUnavailable;
    let errors = [];
    if (isInvalid) {
        let locale = $9ec22d3a5d10504e$var$$35a22f14a1f04b11$var$getLocale();
        let strings = (0, $79f23ee9c19a1f41$export$c17fa47878dc55b6).getGlobalDictionaryForPackage('@react-stately/datepicker') || $9ec22d3a5d10504e$var$$35a22f14a1f04b11$var$dictionary;
        let formatter = new (0, $c5ee7683f5e0da84$export$2f817fcdc4b89ae0)(locale, strings);
        let dateFormatter = new (0, $ecbf8fbbe677b7c2$export$ad991b66133851cf)(locale, $9ec22d3a5d10504e$export$7e319ea407e63bc0({}, options));
        let timeZone = dateFormatter.resolvedOptions().timeZone;
        if (rangeUnderflow && minValue != null) errors.push(formatter.format('rangeUnderflow', {
            minValue: dateFormatter.format(minValue.toDate(timeZone))
        }));
        if (rangeOverflow && maxValue != null) errors.push(formatter.format('rangeOverflow', {
            maxValue: dateFormatter.format(maxValue.toDate(timeZone))
        }));
        if (isUnavailable) errors.push(formatter.format('unavailableDate'));
    }
    return {
        isInvalid: isInvalid,
        validationErrors: errors,
        validationDetails: {
            badInput: isUnavailable,
            customError: false,
            patternMismatch: false,
            rangeOverflow: rangeOverflow,
            rangeUnderflow: rangeUnderflow,
            stepMismatch: false,
            tooLong: false,
            tooShort: false,
            typeMismatch: false,
            valueMissing: false,
            valid: !isInvalid
        }
    };
}
function $9ec22d3a5d10504e$export$80ff8fc0ae339c13(value, minValue, maxValue, isDateUnavailable, options) {
    var _value_start;
    let startValidation = $9ec22d3a5d10504e$export$f18627323ab57ac0((_value_start = value === null || value === void 0 ? void 0 : value.start) !== null && _value_start !== void 0 ? _value_start : null, minValue, maxValue, isDateUnavailable, options);
    var _value_end;
    let endValidation = $9ec22d3a5d10504e$export$f18627323ab57ac0((_value_end = value === null || value === void 0 ? void 0 : value.end) !== null && _value_end !== void 0 ? _value_end : null, minValue, maxValue, isDateUnavailable, options);
    let result = (0, $bf01417b417639db$export$75ee7c75d68f5b0e)(startValidation, endValidation);
    if ((value === null || value === void 0 ? void 0 : value.end) != null && value.start != null && value.end.compare(value.start) < 0) {
        let strings = (0, $79f23ee9c19a1f41$export$c17fa47878dc55b6).getGlobalDictionaryForPackage('@react-stately/datepicker') || $9ec22d3a5d10504e$var$$35a22f14a1f04b11$var$dictionary;
        result = (0, $bf01417b417639db$export$75ee7c75d68f5b0e)(result, {
            isInvalid: true,
            validationErrors: [
                strings.getStringForLocale('rangeReversed', $9ec22d3a5d10504e$var$$35a22f14a1f04b11$var$getLocale())
            ],
            validationDetails: {
                ...(0, $bf01417b417639db$export$aca958c65c314e6c),
                rangeUnderflow: true,
                rangeOverflow: true,
                valid: false
            }
        });
    }
    return result;
}
const $9ec22d3a5d10504e$var$$35a22f14a1f04b11$var$DEFAULT_FIELD_OPTIONS = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit'
};
const $9ec22d3a5d10504e$var$$35a22f14a1f04b11$var$TWO_DIGIT_FIELD_OPTIONS = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
};
function $9ec22d3a5d10504e$export$7e319ea407e63bc0(fieldOptions, options) {
    let defaultFieldOptions = options.shouldForceLeadingZeros ? $9ec22d3a5d10504e$var$$35a22f14a1f04b11$var$TWO_DIGIT_FIELD_OPTIONS : $9ec22d3a5d10504e$var$$35a22f14a1f04b11$var$DEFAULT_FIELD_OPTIONS;
    fieldOptions = {
        ...defaultFieldOptions,
        ...fieldOptions
    };
    let granularity = options.granularity || 'minute';
    let keys = Object.keys(fieldOptions);
    var _options_maxGranularity;
    let startIdx = keys.indexOf((_options_maxGranularity = options.maxGranularity) !== null && _options_maxGranularity !== void 0 ? _options_maxGranularity : 'year');
    if (startIdx < 0) startIdx = 0;
    let endIdx = keys.indexOf(granularity);
    if (endIdx < 0) endIdx = 2;
    if (startIdx > endIdx) throw new Error('maxGranularity must be greater than granularity');
    let opts = keys.slice(startIdx, endIdx + 1).reduce((opts, key)=>{
        opts[key] = fieldOptions[key];
        return opts;
    }, {});
    if (options.hourCycle != null) opts.hour12 = options.hourCycle === 12;
    opts.timeZone = options.timeZone || 'UTC';
    let hasTime = granularity === 'hour' || granularity === 'minute' || granularity === 'second';
    if (hasTime && options.timeZone && !options.hideTimeZone) opts.timeZoneName = 'short';
    if (options.showEra && startIdx === 0) opts.era = 'short';
    return opts;
}
function $9ec22d3a5d10504e$export$c5221a78ef73c5e9(placeholderValue) {
    if (placeholderValue && 'hour' in placeholderValue) return placeholderValue;
    return new (0, $465374ca30ab45d0$export$680ea196effce5f)();
}
function $9ec22d3a5d10504e$export$61a490a80c552550(value, calendar) {
    if (value === null) return null;
    if (!value) return undefined;
    return (0, $24197fe0fbca7789$export$b4a036af3fc0b032)(value, calendar);
}
function $9ec22d3a5d10504e$export$66aa2b09de4b1ea5(placeholderValue, granularity, calendar, timeZone) {
    if (placeholderValue) return $9ec22d3a5d10504e$export$61a490a80c552550(placeholderValue, calendar);
    let date = (0, $24197fe0fbca7789$export$b4a036af3fc0b032)((0, $45b01a5678208999$export$461939dd4422153)(timeZone !== null && timeZone !== void 0 ? timeZone : (0, $45b01a5678208999$export$aa8b41735afcabd2)()).set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
    }), calendar);
    if (granularity === 'year' || granularity === 'month' || granularity === 'day') return (0, $24197fe0fbca7789$export$93522d1a439f3617)(date);
    if (!timeZone) return (0, $24197fe0fbca7789$export$b21e0b124e224484)(date);
    return date;
}
function $9ec22d3a5d10504e$export$2440da353cedad43(v, granularity) {
    // Compute default granularity and time zone from the value. If the value becomes null, keep the last values.
    let defaultTimeZone = v && 'timeZone' in v ? v.timeZone : undefined;
    let defaultGranularity = v && 'minute' in v ? 'minute' : 'day';
    // props.granularity must actually exist in the value if one is provided.
    if (v && granularity && !(granularity in v)) throw new Error('Invalid granularity ' + granularity + ' for value ' + v.toString());
    let [lastValue, setLastValue] = (0, $acw62.useState)([
        defaultGranularity,
        defaultTimeZone
    ]);
    // If the granularity or time zone changed, update the last value.
    if (v && (lastValue[0] !== defaultGranularity || lastValue[1] !== defaultTimeZone)) setLastValue([
        defaultGranularity,
        defaultTimeZone
    ]);
    if (!granularity) granularity = v ? defaultGranularity : lastValue[0];
    let timeZone = v ? defaultTimeZone : lastValue[1];
    return [
        granularity,
        timeZone
    ];
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // These placeholders are based on the strings used by the <input type="date">
// implementations in Chrome and Firefox. Additional languages are supported
// here than React Spectrum's typical translations.
const $e591719f4dc70bbc$var$$3e3ed55ab2966714$var$placeholders = new (0, $79f23ee9c19a1f41$export$c17fa47878dc55b6)({
    ach: {
        year: 'mwaka',
        month: 'dwe',
        day: 'nino'
    },
    af: {
        year: 'jjjj',
        month: 'mm',
        day: 'dd'
    },
    am: {
        year: "\u12D3\u12D3\u12D3\u12D3",
        month: "\u121A\u121C",
        day: "\u1240\u1240"
    },
    an: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    ar: {
        year: "\u0633\u0646\u0629",
        month: "\u0634\u0647\u0631",
        day: "\u064A\u0648\u0645"
    },
    ast: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    az: {
        year: 'iiii',
        month: 'aa',
        day: 'gg'
    },
    be: {
        year: "\u0433\u0433\u0433\u0433",
        month: "\u043C\u043C",
        day: "\u0434\u0434"
    },
    bg: {
        year: "\u0433\u0433\u0433\u0433",
        month: "\u043C\u043C",
        day: "\u0434\u0434"
    },
    bn: {
        year: 'yyyy',
        month: "\u09AE\u09BF\u09AE\u09BF",
        day: 'dd'
    },
    br: {
        year: 'bbbb',
        month: 'mm',
        day: 'dd'
    },
    bs: {
        year: 'gggg',
        month: 'mm',
        day: 'dd'
    },
    ca: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    cak: {
        year: 'jjjj',
        month: 'ii',
        day: "q'q'"
    },
    ckb: {
        year: "\u0633\u0627\u06B5",
        month: "\u0645\u0627\u0646\u06AF",
        day: "\u0695\u06C6\u0698"
    },
    cs: {
        year: 'rrrr',
        month: 'mm',
        day: 'dd'
    },
    cy: {
        year: 'bbbb',
        month: 'mm',
        day: 'dd'
    },
    da: {
        year: "\xe5\xe5\xe5\xe5",
        month: 'mm',
        day: 'dd'
    },
    de: {
        year: 'jjjj',
        month: 'mm',
        day: 'tt'
    },
    dsb: {
        year: 'llll',
        month: 'mm',
        day: "\u017A\u017A"
    },
    el: {
        year: "\u03B5\u03B5\u03B5\u03B5",
        month: "\u03BC\u03BC",
        day: "\u03B7\u03B7"
    },
    en: {
        year: 'yyyy',
        month: 'mm',
        day: 'dd'
    },
    eo: {
        year: 'jjjj',
        month: 'mm',
        day: 'tt'
    },
    es: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    et: {
        year: 'aaaa',
        month: 'kk',
        day: 'pp'
    },
    eu: {
        year: 'uuuu',
        month: 'hh',
        day: 'ee'
    },
    fa: {
        year: "\u0633\u0627\u0644",
        month: "\u0645\u0627\u0647",
        day: "\u0631\u0648\u0632"
    },
    ff: {
        year: 'hhhh',
        month: 'll',
        day: "\xf1\xf1"
    },
    fi: {
        year: 'vvvv',
        month: 'kk',
        day: 'pp'
    },
    fr: {
        year: 'aaaa',
        month: 'mm',
        day: 'jj'
    },
    fy: {
        year: 'jjjj',
        month: 'mm',
        day: 'dd'
    },
    ga: {
        year: 'bbbb',
        month: 'mm',
        day: 'll'
    },
    gd: {
        year: 'bbbb',
        month: 'mm',
        day: 'll'
    },
    gl: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    he: {
        year: "\u05E9\u05E0\u05D4",
        month: "\u05D7\u05D5\u05D3\u05E9",
        day: "\u05D9\u05D5\u05DD"
    },
    hr: {
        year: 'gggg',
        month: 'mm',
        day: 'dd'
    },
    hsb: {
        year: 'llll',
        month: 'mm',
        day: 'dd'
    },
    hu: {
        year: "\xe9\xe9\xe9\xe9",
        month: 'hh',
        day: 'nn'
    },
    ia: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    id: {
        year: 'tttt',
        month: 'bb',
        day: 'hh'
    },
    it: {
        year: 'aaaa',
        month: 'mm',
        day: 'gg'
    },
    ja: {
        year: "\u5E74",
        month: "\u6708",
        day: "\u65E5"
    },
    ka: {
        year: "\u10EC\u10EC\u10EC\u10EC",
        month: "\u10D7\u10D7",
        day: "\u10E0\u10E0"
    },
    kk: {
        year: "\u0436\u0436\u0436\u0436",
        month: "\u0430\u0430",
        day: "\u043A\u043A"
    },
    kn: {
        year: "\u0CB5\u0CB5\u0CB5\u0CB5",
        month: "\u0CAE\u0CBF\u0CAE\u0CC0",
        day: "\u0CA6\u0CBF\u0CA6\u0CBF"
    },
    ko: {
        year: "\uC5F0\uB3C4",
        month: "\uC6D4",
        day: "\uC77C"
    },
    lb: {
        year: 'jjjj',
        month: 'mm',
        day: 'dd'
    },
    lo: {
        year: "\u0E9B\u0E9B\u0E9B\u0E9B",
        month: "\u0E94\u0E94",
        day: "\u0EA7\u0EA7"
    },
    lt: {
        year: 'mmmm',
        month: 'mm',
        day: 'dd'
    },
    lv: {
        year: 'gggg',
        month: 'mm',
        day: 'dd'
    },
    meh: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    ml: {
        year: "\u0D35\u0D7C\u0D37\u0D02",
        month: "\u0D2E\u0D3E\u0D38\u0D02",
        day: "\u0D24\u0D40\u0D2F\u0D24\u0D3F"
    },
    ms: {
        year: 'tttt',
        month: 'mm',
        day: 'hh'
    },
    nb: {
        year: "\xe5\xe5\xe5\xe5",
        month: 'mm',
        day: 'dd'
    },
    nl: {
        year: 'jjjj',
        month: 'mm',
        day: 'dd'
    },
    nn: {
        year: "\xe5\xe5\xe5\xe5",
        month: 'mm',
        day: 'dd'
    },
    no: {
        year: "\xe5\xe5\xe5\xe5",
        month: 'mm',
        day: 'dd'
    },
    oc: {
        year: 'aaaa',
        month: 'mm',
        day: 'jj'
    },
    pl: {
        year: 'rrrr',
        month: 'mm',
        day: 'dd'
    },
    pt: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    rm: {
        year: 'oooo',
        month: 'mm',
        day: 'dd'
    },
    ro: {
        year: 'aaaa',
        month: 'll',
        day: 'zz'
    },
    ru: {
        year: "\u0433\u0433\u0433\u0433",
        month: "\u043C\u043C",
        day: "\u0434\u0434"
    },
    sc: {
        year: 'aaaa',
        month: 'mm',
        day: 'dd'
    },
    scn: {
        year: 'aaaa',
        month: 'mm',
        day: 'jj'
    },
    sk: {
        year: 'rrrr',
        month: 'mm',
        day: 'dd'
    },
    sl: {
        year: 'llll',
        month: 'mm',
        day: 'dd'
    },
    sr: {
        year: "\u0433\u0433\u0433\u0433",
        month: "\u043C\u043C",
        day: "\u0434\u0434"
    },
    sv: {
        year: "\xe5\xe5\xe5\xe5",
        month: 'mm',
        day: 'dd'
    },
    szl: {
        year: 'rrrr',
        month: 'mm',
        day: 'dd'
    },
    tg: {
        year: "\u0441\u0441\u0441\u0441",
        month: "\u043C\u043C",
        day: "\u0440\u0440"
    },
    th: {
        year: "\u0E1B\u0E1B\u0E1B\u0E1B",
        month: "\u0E14\u0E14",
        day: "\u0E27\u0E27"
    },
    tr: {
        year: 'yyyy',
        month: 'aa',
        day: 'gg'
    },
    uk: {
        year: "\u0440\u0440\u0440\u0440",
        month: "\u043C\u043C",
        day: "\u0434\u0434"
    },
    'zh-CN': {
        year: "\u5E74",
        month: "\u6708",
        day: "\u65E5"
    },
    'zh-TW': {
        year: "\u5E74",
        month: "\u6708",
        day: "\u65E5"
    }
}, 'en');
function $e591719f4dc70bbc$export$d3f5c5e0a5023fa0(field, value, locale) {
    // Use the actual placeholder value for the era and day period fields.
    if (field === 'era' || field === 'dayPeriod') return value;
    if (field === 'year' || field === 'month' || field === 'day') return $e591719f4dc70bbc$var$$3e3ed55ab2966714$var$placeholders.getStringForLocale(field, locale);
    // For time fields (e.g. hour, minute, etc.), use two dashes as the placeholder.
    return "\u2013\u2013";
}






var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$EDITABLE_SEGMENTS = {
    year: true,
    month: true,
    day: true,
    hour: true,
    minute: true,
    second: true,
    dayPeriod: true,
    era: true
};
const $ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$PAGE_STEP = {
    year: 5,
    month: 2,
    day: 7,
    hour: 2,
    minute: 15,
    second: 15
};
const $ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$TYPE_MAPPING = {
    // Node seems to convert everything to lowercase...
    dayperiod: 'dayPeriod',
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts#named_years
    relatedYear: 'year',
    yearName: 'literal',
    unknown: 'literal'
};
function $ba8f0f8ca30a01aa$export$60e84778edff6d26(props) {
    let { locale: locale, createCalendar: createCalendar, hideTimeZone: hideTimeZone, isDisabled: isDisabled = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, minValue: minValue, maxValue: maxValue, isDateUnavailable: isDateUnavailable } = props;
    let v = props.value || props.defaultValue || props.placeholderValue || null;
    let [granularity, defaultTimeZone] = (0, $9ec22d3a5d10504e$export$2440da353cedad43)(v, props.granularity);
    let timeZone = defaultTimeZone || 'UTC';
    // props.granularity must actually exist in the value if one is provided.
    if (v && !(granularity in v)) throw new Error('Invalid granularity ' + granularity + ' for value ' + v.toString());
    let defaultFormatter = (0, $acw62.useMemo)(()=>new (0, $ecbf8fbbe677b7c2$export$ad991b66133851cf)(locale), [
        locale
    ]);
    let calendar = (0, $acw62.useMemo)(()=>createCalendar(defaultFormatter.resolvedOptions().calendar), [
        createCalendar,
        defaultFormatter
    ]);
    var _props_defaultValue;
    let [value, setDate] = (0, $3316814d6906df5c$export$40bfa8c7b0832715)(props.value, (_props_defaultValue = props.defaultValue) !== null && _props_defaultValue !== void 0 ? _props_defaultValue : null, props.onChange);
    let [initialValue] = (0, $acw62.useState)(value);
    let calendarValue = (0, $acw62.useMemo)(()=>{
        var _convertValue;
        return (_convertValue = (0, $9ec22d3a5d10504e$export$61a490a80c552550)(value, calendar)) !== null && _convertValue !== void 0 ? _convertValue : null;
    }, [
        value,
        calendar
    ]);
    // We keep track of the placeholder date separately in state so that onChange is not called
    // until all segments are set. If the value === null (not undefined), then assume the component
    // is controlled, so use the placeholder as the value until all segments are entered so it doesn't
    // change from uncontrolled to controlled and emit a warning.
    let [placeholderDate, setPlaceholderDate] = (0, $acw62.useState)(()=>(0, $9ec22d3a5d10504e$export$66aa2b09de4b1ea5)(props.placeholderValue, granularity, calendar, defaultTimeZone));
    let val = calendarValue || placeholderDate;
    let showEra = calendar.identifier === 'gregory' && val.era === 'BC';
    let formatOpts = (0, $acw62.useMemo)(()=>{
        var _props_maxGranularity;
        return {
            granularity: granularity,
            maxGranularity: (_props_maxGranularity = props.maxGranularity) !== null && _props_maxGranularity !== void 0 ? _props_maxGranularity : 'year',
            timeZone: defaultTimeZone,
            hideTimeZone: hideTimeZone,
            hourCycle: props.hourCycle,
            showEra: showEra,
            shouldForceLeadingZeros: props.shouldForceLeadingZeros
        };
    }, [
        props.maxGranularity,
        granularity,
        props.hourCycle,
        props.shouldForceLeadingZeros,
        defaultTimeZone,
        hideTimeZone,
        showEra
    ]);
    let opts = (0, $acw62.useMemo)(()=>(0, $9ec22d3a5d10504e$export$7e319ea407e63bc0)({}, formatOpts), [
        formatOpts
    ]);
    let dateFormatter = (0, $acw62.useMemo)(()=>new (0, $ecbf8fbbe677b7c2$export$ad991b66133851cf)(locale, opts), [
        locale,
        opts
    ]);
    let resolvedOptions = (0, $acw62.useMemo)(()=>dateFormatter.resolvedOptions(), [
        dateFormatter
    ]);
    // Determine how many editable segments there are for validation purposes.
    // The result is cached for performance.
    let allSegments = (0, $acw62.useMemo)(()=>dateFormatter.formatToParts(new Date()).filter((seg)=>$ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$EDITABLE_SEGMENTS[seg.type]).reduce((p, seg)=>(p[$ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$TYPE_MAPPING[seg.type] || seg.type] = true, p), {}), [
        dateFormatter
    ]);
    let [validSegments, setValidSegments] = (0, $acw62.useState)(()=>props.value || props.defaultValue ? {
            ...allSegments
        } : {});
    let clearedSegment = (0, $acw62.useRef)(null);
    // Reset placeholder when calendar changes
    let lastCalendar = (0, $acw62.useRef)(calendar);
    (0, $acw62.useEffect)(()=>{
        if (!(0, $45b01a5678208999$export$dbc69fd56b53d5e)(calendar, lastCalendar.current)) {
            lastCalendar.current = calendar;
            setPlaceholderDate((placeholder)=>Object.keys(validSegments).length > 0 ? (0, $24197fe0fbca7789$export$b4a036af3fc0b032)(placeholder, calendar) : (0, $9ec22d3a5d10504e$export$66aa2b09de4b1ea5)(props.placeholderValue, granularity, calendar, defaultTimeZone));
        }
    }, [
        calendar,
        granularity,
        validSegments,
        defaultTimeZone,
        props.placeholderValue
    ]);
    // If there is a value prop, and some segments were previously placeholders, mark them all as valid.
    if (value && Object.keys(validSegments).length < Object.keys(allSegments).length) {
        validSegments = {
            ...allSegments
        };
        setValidSegments(validSegments);
    }
    // If the value is set to null and all segments are valid, reset the placeholder.
    if (value == null && Object.keys(validSegments).length === Object.keys(allSegments).length) {
        validSegments = {};
        setValidSegments(validSegments);
        setPlaceholderDate((0, $9ec22d3a5d10504e$export$66aa2b09de4b1ea5)(props.placeholderValue, granularity, calendar, defaultTimeZone));
    }
    // If all segments are valid, use the date from state, otherwise use the placeholder date.
    let displayValue = calendarValue && Object.keys(validSegments).length >= Object.keys(allSegments).length ? calendarValue : placeholderDate;
    let setValue = (newValue)=>{
        if (props.isDisabled || props.isReadOnly) return;
        let validKeys = Object.keys(validSegments);
        let allKeys = Object.keys(allSegments);
        // if all the segments are completed or a timefield with everything but am/pm set the time, also ignore when am/pm cleared
        if (newValue == null) {
            setDate(null);
            setPlaceholderDate((0, $9ec22d3a5d10504e$export$66aa2b09de4b1ea5)(props.placeholderValue, granularity, calendar, defaultTimeZone));
            setValidSegments({});
        } else if (validKeys.length === 0 && clearedSegment.current == null || validKeys.length >= allKeys.length || validKeys.length === allKeys.length - 1 && allSegments.dayPeriod && !validSegments.dayPeriod && clearedSegment.current !== 'dayPeriod') {
            // If the field was empty (no valid segments) or all segments are completed, commit the new value.
            // When committing from an empty state, mark every segment as valid so value is committed.
            if (validKeys.length === 0) {
                validSegments = {
                    ...allSegments
                };
                setValidSegments(validSegments);
            }
            // The display calendar should not have any effect on the emitted value.
            // Emit dates in the same calendar as the original value, if any, otherwise gregorian.
            newValue = (0, $24197fe0fbca7789$export$b4a036af3fc0b032)(newValue, (v === null || v === void 0 ? void 0 : v.calendar) || new (0, $164d3c47591a715e$export$80ee6245ec4f29ec)());
            setDate(newValue);
        } else setPlaceholderDate(newValue);
        clearedSegment.current = null;
    };
    let dateValue = (0, $acw62.useMemo)(()=>displayValue.toDate(timeZone), [
        displayValue,
        timeZone
    ]);
    let segments = (0, $acw62.useMemo)(()=>$ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$processSegments(dateValue, validSegments, dateFormatter, resolvedOptions, displayValue, calendar, locale, granularity), [
        dateValue,
        validSegments,
        dateFormatter,
        resolvedOptions,
        displayValue,
        calendar,
        locale,
        granularity
    ]);
    // When the era field appears, mark it valid if the year field is already valid.
    // If the era field disappears, remove it from the valid segments.
    if (allSegments.era && validSegments.year && !validSegments.era) {
        validSegments.era = true;
        setValidSegments({
            ...validSegments
        });
    } else if (!allSegments.era && validSegments.era) {
        delete validSegments.era;
        setValidSegments({
            ...validSegments
        });
    }
    let markValid = (part)=>{
        validSegments[part] = true;
        if (part === 'year' && allSegments.era) validSegments.era = true;
        setValidSegments({
            ...validSegments
        });
    };
    let adjustSegment = (type, amount)=>{
        if (!validSegments[type]) {
            markValid(type);
            let validKeys = Object.keys(validSegments);
            let allKeys = Object.keys(allSegments);
            if (validKeys.length >= allKeys.length || validKeys.length === allKeys.length - 1 && allSegments.dayPeriod && !validSegments.dayPeriod) setValue(displayValue);
        } else setValue($ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$addSegment(displayValue, type, amount, resolvedOptions));
    };
    let builtinValidation = (0, $acw62.useMemo)(()=>(0, $9ec22d3a5d10504e$export$f18627323ab57ac0)(value, minValue, maxValue, isDateUnavailable, formatOpts), [
        value,
        minValue,
        maxValue,
        isDateUnavailable,
        formatOpts
    ]);
    let validation = (0, $bf01417b417639db$export$fc1a364ae1f3ff10)({
        ...props,
        value: value,
        builtinValidation: builtinValidation
    });
    let isValueInvalid = validation.displayValidation.isInvalid;
    let validationState = props.validationState || (isValueInvalid ? 'invalid' : null);
    var _props_defaultValue1, _props_maxGranularity;
    return {
        ...validation,
        value: calendarValue,
        defaultValue: (_props_defaultValue1 = props.defaultValue) !== null && _props_defaultValue1 !== void 0 ? _props_defaultValue1 : initialValue,
        dateValue: dateValue,
        calendar: calendar,
        setValue: setValue,
        segments: segments,
        dateFormatter: dateFormatter,
        validationState: validationState,
        isInvalid: isValueInvalid,
        granularity: granularity,
        maxGranularity: (_props_maxGranularity = props.maxGranularity) !== null && _props_maxGranularity !== void 0 ? _props_maxGranularity : 'year',
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        increment (part) {
            adjustSegment(part, 1);
        },
        decrement (part) {
            adjustSegment(part, -1);
        },
        incrementPage (part) {
            adjustSegment(part, $ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$PAGE_STEP[part] || 1);
        },
        decrementPage (part) {
            adjustSegment(part, -($ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$PAGE_STEP[part] || 1));
        },
        setSegment (part, v) {
            markValid(part);
            setValue($ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$setSegment(displayValue, part, v, resolvedOptions));
        },
        confirmPlaceholder () {
            if (props.isDisabled || props.isReadOnly) return;
            // Confirm the placeholder if only the day period is not filled in.
            let validKeys = Object.keys(validSegments);
            let allKeys = Object.keys(allSegments);
            if (validKeys.length === allKeys.length - 1 && allSegments.dayPeriod && !validSegments.dayPeriod) {
                validSegments = {
                    ...allSegments
                };
                setValidSegments(validSegments);
                setValue(displayValue.copy());
            }
        },
        clearSegment (part) {
            delete validSegments[part];
            clearedSegment.current = part;
            setValidSegments({
                ...validSegments
            });
            let placeholder = (0, $9ec22d3a5d10504e$export$66aa2b09de4b1ea5)(props.placeholderValue, granularity, calendar, defaultTimeZone);
            let value = displayValue;
            // Reset day period to default without changing the hour.
            if (part === 'dayPeriod' && 'hour' in displayValue && 'hour' in placeholder) {
                let isPM = displayValue.hour >= 12;
                let shouldBePM = placeholder.hour >= 12;
                if (isPM && !shouldBePM) value = displayValue.set({
                    hour: displayValue.hour - 12
                });
                else if (!isPM && shouldBePM) value = displayValue.set({
                    hour: displayValue.hour + 12
                });
            } else if (part === 'hour' && 'hour' in displayValue && displayValue.hour >= 12 && validSegments.dayPeriod) value = displayValue.set({
                hour: placeholder['hour'] + 12
            });
            else if (part in displayValue) value = displayValue.set({
                [part]: placeholder[part]
            });
            setDate(null);
            setValue(value);
        },
        formatValue (fieldOptions) {
            if (!calendarValue) return '';
            let formatOptions = (0, $9ec22d3a5d10504e$export$7e319ea407e63bc0)(fieldOptions, formatOpts);
            let formatter = new (0, $ecbf8fbbe677b7c2$export$ad991b66133851cf)(locale, formatOptions);
            return formatter.format(dateValue);
        },
        getDateFormatter (locale, formatOptions) {
            let newOptions = {
                ...formatOpts,
                ...formatOptions
            };
            let newFormatOptions = (0, $9ec22d3a5d10504e$export$7e319ea407e63bc0)({}, newOptions);
            return new (0, $ecbf8fbbe677b7c2$export$ad991b66133851cf)(locale, newFormatOptions);
        }
    };
}
function $ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$processSegments(dateValue, validSegments, dateFormatter, resolvedOptions, displayValue, calendar, locale, granularity) {
    let timeValue = [
        'hour',
        'minute',
        'second'
    ];
    let segments = dateFormatter.formatToParts(dateValue);
    let processedSegments = [];
    for (let segment of segments){
        let type = $ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$TYPE_MAPPING[segment.type] || segment.type;
        let isEditable = $ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$EDITABLE_SEGMENTS[type];
        if (type === 'era' && calendar.getEras().length === 1) isEditable = false;
        let isPlaceholder = $ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$EDITABLE_SEGMENTS[type] && !validSegments[type];
        let placeholder = $ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$EDITABLE_SEGMENTS[type] ? (0, $e591719f4dc70bbc$export$d3f5c5e0a5023fa0)(type, segment.value, locale) : null;
        let dateSegment = {
            type: type,
            text: isPlaceholder ? placeholder : segment.value,
            ...$ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$getSegmentLimits(displayValue, type, resolvedOptions),
            isPlaceholder: isPlaceholder,
            placeholder: placeholder,
            isEditable: isEditable
        };
        // There is an issue in RTL languages where time fields render (minute:hour) instead of (hour:minute).
        // To force an LTR direction on the time field since, we wrap the time segments in LRI (left-to-right) isolate unicode. See https://www.w3.org/International/questions/qa-bidi-unicode-controls.
        // These unicode characters will be added to the array of processed segments as literals and will mark the start and end of the embedded direction change.
        if (type === 'hour') {
            // This marks the start of the embedded direction change.
            processedSegments.push({
                type: 'literal',
                text: '\u2066',
                ...$ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$getSegmentLimits(displayValue, 'literal', resolvedOptions),
                isPlaceholder: false,
                placeholder: '',
                isEditable: false
            });
            processedSegments.push(dateSegment);
            // This marks the end of the embedded direction change in the case that the granularity it set to "hour".
            if (type === granularity) processedSegments.push({
                type: 'literal',
                text: '\u2069',
                ...$ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$getSegmentLimits(displayValue, 'literal', resolvedOptions),
                isPlaceholder: false,
                placeholder: '',
                isEditable: false
            });
        } else if (timeValue.includes(type) && type === granularity) {
            processedSegments.push(dateSegment);
            // This marks the end of the embedded direction change.
            processedSegments.push({
                type: 'literal',
                text: '\u2069',
                ...$ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$getSegmentLimits(displayValue, 'literal', resolvedOptions),
                isPlaceholder: false,
                placeholder: '',
                isEditable: false
            });
        } else processedSegments.push(dateSegment);
    }
    return processedSegments;
}
function $ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$getSegmentLimits(date, type, options) {
    switch(type){
        case 'era':
            {
                let eras = date.calendar.getEras();
                return {
                    value: eras.indexOf(date.era),
                    minValue: 0,
                    maxValue: eras.length - 1
                };
            }
        case 'year':
            return {
                value: date.year,
                minValue: 1,
                maxValue: date.calendar.getYearsInEra(date)
            };
        case 'month':
            return {
                value: date.month,
                minValue: (0, $45b01a5678208999$export$5412ac11713b72ad)(date),
                maxValue: date.calendar.getMonthsInYear(date)
            };
        case 'day':
            return {
                value: date.day,
                minValue: (0, $45b01a5678208999$export$b2f4953d301981d5)(date),
                maxValue: date.calendar.getDaysInMonth(date)
            };
    }
    if ('hour' in date) switch(type){
        case 'dayPeriod':
            return {
                value: date.hour >= 12 ? 12 : 0,
                minValue: 0,
                maxValue: 12
            };
        case 'hour':
            if (options.hour12) {
                let isPM = date.hour >= 12;
                return {
                    value: date.hour,
                    minValue: isPM ? 12 : 0,
                    maxValue: isPM ? 23 : 11
                };
            }
            return {
                value: date.hour,
                minValue: 0,
                maxValue: 23
            };
        case 'minute':
            return {
                value: date.minute,
                minValue: 0,
                maxValue: 59
            };
        case 'second':
            return {
                value: date.second,
                minValue: 0,
                maxValue: 59
            };
    }
    return {};
}
function $ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$addSegment(value, part, amount, options) {
    switch(part){
        case 'era':
        case 'year':
        case 'month':
        case 'day':
            return value.cycle(part, amount, {
                round: part === 'year'
            });
    }
    if ('hour' in value) switch(part){
        case 'dayPeriod':
            {
                let hours = value.hour;
                let isPM = hours >= 12;
                return value.set({
                    hour: isPM ? hours - 12 : hours + 12
                });
            }
        case 'hour':
        case 'minute':
        case 'second':
            return value.cycle(part, amount, {
                round: part !== 'hour',
                hourCycle: options.hour12 ? 12 : 24
            });
    }
    throw new Error('Unknown segment: ' + part);
}
function $ba8f0f8ca30a01aa$var$$3c0fc76039f1c516$var$setSegment(value, part, segmentValue, options) {
    switch(part){
        case 'day':
        case 'month':
        case 'year':
        case 'era':
            return value.set({
                [part]: segmentValue
            });
    }
    if ('hour' in value && typeof segmentValue === 'number') switch(part){
        case 'dayPeriod':
            {
                let hours = value.hour;
                let wasPM = hours >= 12;
                let isPM = segmentValue >= 12;
                if (isPM === wasPM) return value;
                return value.set({
                    hour: wasPM ? hours - 12 : hours + 12
                });
            }
        case 'hour':
            // In 12 hour time, ensure that AM/PM does not change
            if (options.hour12) {
                let hours = value.hour;
                let wasPM = hours >= 12;
                if (!wasPM && segmentValue === 12) segmentValue = 0;
                if (wasPM && segmentValue < 12) segmentValue += 12;
            }
        // fallthrough
        case 'minute':
        case 'second':
            return value.set({
                [part]: segmentValue
            });
    }
    throw new Error('Unknown segment: ' + part);
}




var $acw62 = parcelRequire("acw62");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $51497a514db52264$export$fd53cef0cc796101(props) {
    let { placeholderValue: placeholderValue = new (0, $465374ca30ab45d0$export$680ea196effce5f)(), minValue: minValue, maxValue: maxValue, defaultValue: defaultValue, granularity: granularity, validate: validate } = props;
    let [value, setValue] = (0, $3316814d6906df5c$export$40bfa8c7b0832715)(props.value, defaultValue !== null && defaultValue !== void 0 ? defaultValue : null, props.onChange);
    let v = value || placeholderValue;
    let day = v && 'day' in v ? v : undefined;
    let defaultValueTimeZone = defaultValue && 'timeZone' in defaultValue ? defaultValue.timeZone : undefined;
    let placeholderDate = (0, $acw62.useMemo)(()=>{
        let valueTimeZone = v && 'timeZone' in v ? v.timeZone : undefined;
        return (valueTimeZone || defaultValueTimeZone) && placeholderValue ? (0, $24197fe0fbca7789$export$84c95a83c799e074)($51497a514db52264$var$$eff5d8ee529ac4bb$var$convertValue(placeholderValue), valueTimeZone || defaultValueTimeZone) : $51497a514db52264$var$$eff5d8ee529ac4bb$var$convertValue(placeholderValue);
    }, [
        placeholderValue,
        v,
        defaultValueTimeZone
    ]);
    let minDate = (0, $acw62.useMemo)(()=>$51497a514db52264$var$$eff5d8ee529ac4bb$var$convertValue(minValue, day), [
        minValue,
        day
    ]);
    let maxDate = (0, $acw62.useMemo)(()=>$51497a514db52264$var$$eff5d8ee529ac4bb$var$convertValue(maxValue, day), [
        maxValue,
        day
    ]);
    let timeValue = (0, $acw62.useMemo)(()=>value && 'day' in value ? (0, $24197fe0fbca7789$export$d33f79e3ffc3dc83)(value) : value, [
        value
    ]);
    let dateTime = (0, $acw62.useMemo)(()=>value == null ? null : $51497a514db52264$var$$eff5d8ee529ac4bb$var$convertValue(value), [
        value
    ]);
    let defaultDateTime = (0, $acw62.useMemo)(()=>defaultValue == null ? null : $51497a514db52264$var$$eff5d8ee529ac4bb$var$convertValue(defaultValue), [
        defaultValue
    ]);
    let onChange = (newValue)=>{
        setValue(day || defaultValueTimeZone ? newValue : newValue && (0, $24197fe0fbca7789$export$d33f79e3ffc3dc83)(newValue));
    };
    let state = (0, $ba8f0f8ca30a01aa$export$60e84778edff6d26)({
        ...props,
        value: dateTime,
        defaultValue: defaultDateTime,
        minValue: minDate,
        maxValue: maxDate,
        onChange: onChange,
        granularity: granularity || 'minute',
        maxGranularity: 'hour',
        placeholderValue: placeholderDate !== null && placeholderDate !== void 0 ? placeholderDate : undefined,
        // Calendar should not matter for time fields.
        createCalendar: ()=>new (0, $164d3c47591a715e$export$80ee6245ec4f29ec)(),
        validate: (0, $acw62.useCallback)(()=>validate === null || validate === void 0 ? void 0 : validate(value), [
            validate,
            value
        ])
    });
    return {
        ...state,
        timeValue: timeValue
    };
}
function $51497a514db52264$var$$eff5d8ee529ac4bb$var$convertValue(value, date = (0, $45b01a5678208999$export$d0bdf45af03a6ea3)((0, $45b01a5678208999$export$aa8b41735afcabd2)())) {
    if (!value) return null;
    if ('day' in value) return value;
    return (0, $24197fe0fbca7789$export$b21e0b124e224484)(date, value);
}




var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $abf23c6098f3851b$export$7b3e670c86da5fe8 = (0, $acw62.createContext)(null);
const $abf23c6098f3851b$export$8e17ddc448e87c1e = (0, $acw62.createContext)(null);
const $abf23c6098f3851b$export$3b08bebcf796eea0 = (0, $acw62.createContext)(null);
const $abf23c6098f3851b$export$5d8dc44abd10a920 = (0, $acw62.createContext)(null);
const $abf23c6098f3851b$export$d9781c7894a82487 = (0, $acw62.forwardRef)(function DateField(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $abf23c6098f3851b$export$7b3e670c86da5fe8);
    let { validationBehavior: formValidationBehavior } = (0, $12ee5c1d62d6b2e5$export$fabf2dc03a41866e)((0, $99b9335b6cbca82a$export$c24727297075ec6a)) || {};
    var _props_validationBehavior, _ref;
    let validationBehavior = (_ref = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : formValidationBehavior) !== null && _ref !== void 0 ? _ref : 'native';
    let { locale: locale } = (0, $a7e3b1109bf64033$export$43bb16f9c6d9e3f7)();
    let state = (0, $ba8f0f8ca30a01aa$export$60e84778edff6d26)({
        ...props,
        locale: locale,
        createCalendar: (0, $5a975329a8a829eb$export$dd0bbc9b26defe37),
        validationBehavior: validationBehavior
    });
    let fieldRef = (0, $acw62.useRef)(null);
    let [labelRef, label] = (0, $12ee5c1d62d6b2e5$export$9d4c57ee4c6ffdd8)(!props['aria-label'] && !props['aria-labelledby']);
    let inputRef = (0, $acw62.useRef)(null);
    let { labelProps: labelProps, fieldProps: fieldProps, inputProps: inputProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $6a062e87893a747c$export$5591b0b878c1a989)({
        ...(0, $12ee5c1d62d6b2e5$export$ef03459518577ad4)(props),
        label: label,
        inputRef: inputRef,
        validationBehavior: validationBehavior
    }, state, fieldRef);
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        ...(0, $12ee5c1d62d6b2e5$export$ef03459518577ad4)(props),
        values: {
            state: state,
            isInvalid: state.isInvalid,
            isDisabled: state.isDisabled,
            isReadOnly: state.isReadOnly
        },
        defaultClassName: 'react-aria-DateField'
    });
    let DOMProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $12ee5c1d62d6b2e5$export$2881499e37b75b9a), {
        values: [
            [
                $abf23c6098f3851b$export$3b08bebcf796eea0,
                state
            ],
            [
                (0, $c1367d7afc3d8fbe$export$f9c6924e160136d1),
                {
                    ...fieldProps,
                    ref: fieldRef,
                    isInvalid: state.isInvalid,
                    isDisabled: state.isDisabled
                }
            ],
            [
                (0, $ccd48495800651c4$export$37fb8590cf2c088c),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, $794346013ab6e680$export$75b6ee27786ba447),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: 'span'
                }
            ],
            [
                (0, $424592b5daddcd29$export$9afb8bc826b033ea),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $7dd8b2fec65d8b6a$export$ff05c3ac10437e03),
                validation
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-disabled": state.isDisabled || undefined,
        "data-readonly": state.isReadOnly || undefined
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $878d1189b2fd67b2$export$eefa3e19139f00f3), {
        autoComplete: props.autoComplete,
        name: props.name,
        isDisabled: props.isDisabled,
        state: state
    }));
});
const $abf23c6098f3851b$export$5eaee2322dd727eb = (0, $acw62.forwardRef)(function TimeField(props, ref) {
    [props, ref] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)(props, ref, $abf23c6098f3851b$export$8e17ddc448e87c1e);
    let { validationBehavior: formValidationBehavior } = (0, $12ee5c1d62d6b2e5$export$fabf2dc03a41866e)((0, $99b9335b6cbca82a$export$c24727297075ec6a)) || {};
    var _props_validationBehavior, _ref;
    let validationBehavior = (_ref = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : formValidationBehavior) !== null && _ref !== void 0 ? _ref : 'native';
    let { locale: locale } = (0, $a7e3b1109bf64033$export$43bb16f9c6d9e3f7)();
    let state = (0, $51497a514db52264$export$fd53cef0cc796101)({
        ...props,
        locale: locale,
        validationBehavior: validationBehavior
    });
    let fieldRef = (0, $acw62.useRef)(null);
    let [labelRef, label] = (0, $12ee5c1d62d6b2e5$export$9d4c57ee4c6ffdd8)(!props['aria-label'] && !props['aria-labelledby']);
    let inputRef = (0, $acw62.useRef)(null);
    let { labelProps: labelProps, fieldProps: fieldProps, inputProps: inputProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $6a062e87893a747c$export$4c842f6a241dc825)({
        ...(0, $12ee5c1d62d6b2e5$export$ef03459518577ad4)(props),
        label: label,
        inputRef: inputRef,
        validationBehavior: validationBehavior
    }, state, fieldRef);
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        ...props,
        values: {
            state: state,
            isInvalid: state.isInvalid,
            isDisabled: state.isDisabled,
            isReadOnly: state.isReadOnly
        },
        defaultClassName: 'react-aria-TimeField'
    });
    let DOMProps = (0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(props, {
        global: true
    });
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $12ee5c1d62d6b2e5$export$2881499e37b75b9a), {
        values: [
            [
                $abf23c6098f3851b$export$5d8dc44abd10a920,
                state
            ],
            [
                (0, $c1367d7afc3d8fbe$export$f9c6924e160136d1),
                {
                    ...fieldProps,
                    ref: fieldRef,
                    isInvalid: state.isInvalid,
                    isDisabled: state.isDisabled
                }
            ],
            [
                (0, $ccd48495800651c4$export$37fb8590cf2c088c),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, $794346013ab6e680$export$75b6ee27786ba447),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: 'span'
                }
            ],
            [
                (0, $424592b5daddcd29$export$9afb8bc826b033ea),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $7dd8b2fec65d8b6a$export$ff05c3ac10437e03),
                validation
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-disabled": state.isDisabled || undefined,
        "data-readonly": state.isReadOnly || undefined
    }));
});
const $abf23c6098f3851b$export$7edc06cf1783b30f = (0, $acw62.forwardRef)(function DateInput(props, ref) {
    // If state is provided by DateField/TimeField, just render.
    // Otherwise (e.g. in DatePicker), we need to call hooks and create state ourselves.
    let dateFieldState = (0, $acw62.useContext)($abf23c6098f3851b$export$3b08bebcf796eea0);
    let timeFieldState = (0, $acw62.useContext)($abf23c6098f3851b$export$5d8dc44abd10a920);
    return dateFieldState || timeFieldState ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($abf23c6098f3851b$var$$40825cdb76e74f70$var$DateInputInner, {
        ...props,
        ref: ref
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($abf23c6098f3851b$var$$40825cdb76e74f70$var$DateInputStandalone, {
        ...props,
        ref: ref
    });
});
const $abf23c6098f3851b$var$$40825cdb76e74f70$var$DateInputStandalone = (0, $acw62.forwardRef)((props, ref)=>{
    let [dateFieldProps, fieldRef] = (0, $12ee5c1d62d6b2e5$export$29f1550f4b0d4415)({
        slot: props.slot
    }, ref, $abf23c6098f3851b$export$7b3e670c86da5fe8);
    let { locale: locale } = (0, $a7e3b1109bf64033$export$43bb16f9c6d9e3f7)();
    let state = (0, $ba8f0f8ca30a01aa$export$60e84778edff6d26)({
        ...dateFieldProps,
        locale: locale,
        createCalendar: (0, $5a975329a8a829eb$export$dd0bbc9b26defe37)
    });
    let inputRef = (0, $acw62.useRef)(null);
    let { fieldProps: fieldProps, inputProps: inputProps } = (0, $6a062e87893a747c$export$5591b0b878c1a989)({
        ...dateFieldProps,
        inputRef: inputRef
    }, state, fieldRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $12ee5c1d62d6b2e5$export$2881499e37b75b9a), {
        values: [
            [
                $abf23c6098f3851b$export$3b08bebcf796eea0,
                state
            ],
            [
                (0, $ccd48495800651c4$export$37fb8590cf2c088c),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, $c1367d7afc3d8fbe$export$f9c6924e160136d1),
                {
                    ...fieldProps,
                    ref: fieldRef,
                    isInvalid: state.isInvalid,
                    isDisabled: state.isDisabled
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($abf23c6098f3851b$var$$40825cdb76e74f70$var$DateInputInner, props));
});
const $abf23c6098f3851b$var$$40825cdb76e74f70$var$DateInputInner = (0, $acw62.forwardRef)((props, ref)=>{
    let { className: className, children: children } = props;
    let dateFieldState = (0, $acw62.useContext)($abf23c6098f3851b$export$3b08bebcf796eea0);
    let timeFieldState = (0, $acw62.useContext)($abf23c6098f3851b$export$5d8dc44abd10a920);
    let state = dateFieldState !== null && dateFieldState !== void 0 ? dateFieldState : timeFieldState;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c1367d7afc3d8fbe$export$eb2fcfdbd7ba97d4), {
        ...props,
        ref: ref,
        slot: props.slot || undefined,
        className: className !== null && className !== void 0 ? className : 'react-aria-DateInput',
        isReadOnly: state.isReadOnly,
        isInvalid: state.isInvalid,
        isDisabled: state.isDisabled
    }, state.segments.map((segment, i)=>(0, $acw62.cloneElement)(children(segment), {
            key: i
        }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ccd48495800651c4$export$f5b8910cec6cf069), {
        className: ""
    }));
});
const $abf23c6098f3851b$export$336ab7fa954c4b5f = (0, $acw62.forwardRef)(function DateSegment({ segment: segment, ...otherProps }, ref) {
    let dateFieldState = (0, $acw62.useContext)($abf23c6098f3851b$export$3b08bebcf796eea0);
    let timeFieldState = (0, $acw62.useContext)($abf23c6098f3851b$export$5d8dc44abd10a920);
    let state = dateFieldState !== null && dateFieldState !== void 0 ? dateFieldState : timeFieldState;
    let domRef = (0, $426ce7b4b2df0896$export$4338b53315abf666)(ref);
    let { segmentProps: segmentProps } = (0, $7448e1f067fdcc2b$export$1315d136e6f7581)(segment, state, domRef);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $da27ef38ba6b0ce3$export$4e328f61c538687f)();
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $8d62ff0ac4dc2be2$export$ae780daf29e6d456)({
        ...otherProps,
        isDisabled: state.isDisabled || segment.type === 'literal'
    });
    let renderProps = (0, $12ee5c1d62d6b2e5$export$4d86445c2cf5e3)({
        ...otherProps,
        values: {
            ...segment,
            isReadOnly: state.isReadOnly,
            isInvalid: state.isInvalid,
            isDisabled: state.isDisabled,
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible
        },
        defaultChildren: segment.text,
        defaultClassName: 'react-aria-DateSegment'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ...(0, $e611552c564dfe1f$export$9d1611c77c2fe928)((0, $c2bab733f68d1f9c$export$457c3d6518dd4c6f)(otherProps, {
            global: true
        }), segmentProps, focusProps, hoverProps),
        ...renderProps,
        style: segmentProps.style,
        ref: domRef,
        "data-placeholder": segment.isPlaceholder || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-readonly": state.isReadOnly || undefined,
        "data-disabled": state.isDisabled || undefined,
        "data-type": segment.type,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined
    });
});




function $ccb7b96bc20cedcb$export$d9781c7894a82487({ name: name, label: label, className: className, ...props }) {
    const { field: field } = (0, $0d70f179cf56e662$export$e8c786024a2b0a79)({
        name: name
    });
    const defaultValue = (0, $acw62.useMemo)(()=>$ccb7b96bc20cedcb$var$tryParseDate(field.value), [
        field.value
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $abf23c6098f3851b$export$d9781c7894a82487), {
        ...props,
        name: name,
        defaultValue: defaultValue,
        onChange: (date)=>field.onChange(date?.toString() ?? ''),
        onBlur: ()=>field.onBlur(),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e29ab1100b9991a4$export$b04be29aa201d4f5), {
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $abf23c6098f3851b$export$7edc06cf1783b30f), {
                className: "block w-full mt-1.5 px-3 pt-2 pb-1 text-body-dark rounded-md border border-solid border-300 shadow-sm cursor-text disabled:cursor-default whitespace-nowrap overflow-x-auto [scrollbar-width:none] focus-within:ring-1 focus-within:border-primary ring-primary",
                type: "date",
                children: (segment)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $abf23c6098f3851b$export$336ab7fa954c4b5f), {
                        segment: segment,
                        className: "inline-block px-1 text-base text-center cursor-text leading-snug disabled:cursor-default whitespace-nowrap overflow-x-auto [scrollbar-width:none] data-[type=day]:min-w-8 data-[type=year]:min-w-14 data-[type=month]:min-w-8 data-[focused=true]:bg-primary-500 data-[focused=true]:text-white data-[placeholder=true]:text-light-500 data-[placeholder=true]:data-[focused=true]:text-white focus-visible:outline-none"
                    })
            })
        ]
    });
}
function $ccb7b96bc20cedcb$var$tryParseDate(value) {
    try {
        return (0, $6e5edc2e47674229$export$6b862160d295c8e)(value);
    } catch  {
        return '';
    }
}





const $fc63a763a2a1732b$export$4902baddc787debb = $09193e81812ba154$export$be5493f9613cbbe({
    namePrefix: $09193e81812ba154$export$22b082955e083ec3().min(1),
    nameGiven: $09193e81812ba154$export$22b082955e083ec3().min(1),
    nameFamily: $09193e81812ba154$export$22b082955e083ec3().min(1),
    namePreferred: $09193e81812ba154$export$22b082955e083ec3().min(1),
    dateOfBirth: $09193e81812ba154$export$22b082955e083ec3().regex((0, $641e6457757d8f34$export$f69b927d95b72681))
});
function $fc63a763a2a1732b$var$extractDefaults({ patient: patient }, invite) {
    let patientDateOfBirth;
    const matches = (0, $641e6457757d8f34$export$f69b927d95b72681).exec(invite.patient.dateOfBirth);
    if (matches?.length === 4) patientDateOfBirth = matches[0];
    return {
        namePrefix: patient?.namePrefix ?? invite.patient.namePrefix ?? '',
        nameGiven: patient?.nameGiven ?? invite.patient.nameGiven ?? '',
        nameFamily: patient?.nameFamily ?? invite.patient.nameFamily ?? '',
        namePreferred: patient?.namePreferred ?? invite.patient.nameGiven ?? '',
        dateOfBirth: patient?.dateOfBirth ?? patientDateOfBirth ?? ''
    };
}
function $fc63a763a2a1732b$var$transformValues(values) {
    return {
        patient: values
    };
}
function $fc63a763a2a1732b$export$842f6d7d17990d8c(props) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.details');
    const titleOptions = (0, $acw62.useMemo)(()=>[
            {
                value: 'mr',
                label: t('name-birthdate.select.mr')
            },
            {
                value: 'mrs',
                label: t('name-birthdate.select.mrs')
            },
            {
                value: 'ms',
                label: t('name-birthdate.select.ms')
            },
            {
                value: 'miss',
                label: t('name-birthdate.select.miss')
            },
            {
                value: 'mx',
                label: t('name-birthdate.select.mx')
            },
            {
                value: 'dr',
                label: t('name-birthdate.select.dr')
            },
            {
                value: 'prof',
                label: t('name-birthdate.select.prof')
            },
            {
                value: 'rev',
                label: t('name-birthdate.select.rev')
            },
            {
                value: 'sir',
                label: t('name-birthdate.select.sir')
            },
            {
                value: 'dame',
                label: t('name-birthdate.select.dame')
            }
        ], [
        t
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dea25ad601eb8263$export$70aabb5da7e125f8), {
        extractDefaults: $fc63a763a2a1732b$var$extractDefaults,
        transformValues: $fc63a763a2a1732b$var$transformValues,
        schema: $fc63a763a2a1732b$export$4902baddc787debb,
        nextPath: props.next.path,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4777412ac24f8fdf$export$8becf861e7fda17d), {
            ...props,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "title",
                    children: t('name-birthdate.title')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "mb-5",
                    children: t('name-birthdate.text')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4cd9875607f3fe92$export$ef9b1a59e592288f), {
                            name: "namePrefix",
                            options: titleOptions,
                            ns: "page.details",
                            label: t('name-birthdate.select.label'),
                            placeholder: t('name-birthdate.select.placeholder')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                            name: "nameFamily",
                            label: t('name-birthdate.familyName'),
                            className: "mb-5 last:mb-0",
                            inputClassName: "uppercase"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                            name: "nameGiven",
                            label: t('name-birthdate.firstName'),
                            className: "mb-5 last:mb-0"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                            name: "namePreferred",
                            label: t('name-birthdate.preferredName'),
                            className: "mb-5 last:mb-0"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ccb7b96bc20cedcb$export$d9781c7894a82487), {
                            name: "dateOfBirth",
                            label: t('name-birthdate.birthDate'),
                            autoComplete: "bday",
                            className: "mb-5 last:mb-0"
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");






const $490a6c7f73f3c708$export$4902baddc787debb = $09193e81812ba154$export$be5493f9613cbbe({
    isResident: $09193e81812ba154$export$78a99c8d44d72635([
        'yes',
        'no'
    ])
});
function $490a6c7f73f3c708$var$extractDefaults({ patient: patient }) {
    return {
        isResident: (0, $2cfbe4d1e444ba23$export$e4d1d359df9812d2)(patient?.isResident)
    };
}
function $490a6c7f73f3c708$var$transformValues({ isResident: isResident }) {
    return {
        patient: {
            isResident: isResident === 'yes'
        }
    };
}
function $490a6c7f73f3c708$export$47b580cadca596de(props) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.details');
    const radioOptions = (0, $acw62.useMemo)(()=>[
            {
                value: 'yes',
                label: t('common:yes')
            },
            {
                value: 'no',
                label: t('common:no')
            }
        ], [
        t
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dea25ad601eb8263$export$70aabb5da7e125f8), {
        extractDefaults: $490a6c7f73f3c708$var$extractDefaults,
        transformValues: $490a6c7f73f3c708$var$transformValues,
        schema: $490a6c7f73f3c708$export$4902baddc787debb,
        nextPath: props.next.path,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4777412ac24f8fdf$export$8becf861e7fda17d), {
            ...props,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "title",
                    children: t('nhi-residency.title')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "mb-5",
                    children: t('nhi-residency.text')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "space-y-5",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41015efefa2d03bc$export$a98f0dcb43a68a25), {
                        orientation: "horizontal",
                        name: "isResident",
                        options: radioOptions,
                        labelVariant: "sm",
                        description: t('nhi-residency.residentText')
                    })
                })
            ]
        })
    });
}


// eslint-disable-next-line import/no-unresolved





var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");
function $144bb4386178122c$var$PlusIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z"
    }));
}
const $144bb4386178122c$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($144bb4386178122c$var$PlusIcon);
var $144bb4386178122c$export$2e2bcd8739ae039 = $144bb4386178122c$var$ForwardRef;



var $acw62 = parcelRequire("acw62");




function $8761de775eed7565$export$ea72572e99d27ad1({ onClick: onClick, disabled: disabled, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        className: "group relative flex items-center justify-between w-full min-h-12.5 p-2.5 border border-300 rounded-lg bg-white shadow-sm font-normal text-body-dark hover:text-body-dark transition-colors disabled:opacity-50 hover:enabled:bg-error-50 hover:enabled:border-error-500",
        onClick: onClick,
        // onKeyDown={(e) => {
        //   if (e.key === 'Enter' || e.key === ' ') {
        //     e.preventDefault();
        //     onClick?.(e);
        //   }
        // }}
        disabled: disabled,
        tabIndex: 0,
        type: "button",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex items-center gap-2.5",
                children: children
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "size-11 flex items-center justify-center",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    className: "stroke-gray-500 transition-colors group-hover:stroke-error",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M19 7L18.1327 19.1425C18.0579 20.1891 17.187 21 16.1378 21H7.86224C6.81296 21 5.94208 20.1891 5.86732 19.1425L5 7M10 11V17M14 11V17M15 7V4C15 3.44772 14.5523 3 14 3H10C9.44772 3 9 3.44772 9 4V7M4 7H20",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                })
            })
        ]
    });
}


function $fdb72c6a66849198$export$8651306a9173292d({ fieldArrayName: fieldArrayName, ItemComponent: ItemComponent, showFromButtonLabel: showFromButtonLabel, FormComponent: FormComponent }) {
    const [showForm, setShowForm] = (0, $acw62.useState)(false);
    const { remove: remove } = (0, $0d70f179cf56e662$export$310131896651d559)({
        name: fieldArrayName
    });
    const items = (0, $0d70f179cf56e662$export$3c773aa2b84f29e0)({
        name: fieldArrayName
    });
    const itemsList = (0, $acw62.useMemo)(()=>items.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a253e8a9807820d2$export$be5b6c6ac24b4683), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8761de775eed7565$export$ea72572e99d27ad1), {
                    className: "min-h-17.5",
                    onClick: (e)=>{
                        e.preventDefault();
                        remove(index);
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ItemComponent, {
                        item: item
                    })
                })
            }, JSON.stringify(item))), [
        items,
        remove
    ]);
    const show = showForm || items.length === 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "relative mb-2.5 z-1 py-5 space-y-2.5 empty:hidden before:absolute before:-z-1 before:top-0 before:left-[-99999px] before:right-[-99999px] before:bottom-0 before:bg-gray-100",
                children: itemsList
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a253e8a9807820d2$export$be5b6c6ac24b4683), {
                show: !show,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f563c890ed38cb6$export$353f5b6fc5456de1), {
                    type: "button",
                    variant: "outlined",
                    className: "min-h-12.5 flex items-center justify-center gap-3",
                    onClick: (e)=>{
                        e.preventDefault();
                        setShowForm(true);
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $144bb4386178122c$export$2e2bcd8739ae039), {
                            className: "size-5 text-gray-500"
                        }),
                        showFromButtonLabel
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a253e8a9807820d2$export$be5b6c6ac24b4683), {
                show: show,
                unmount: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(FormComponent, {
                    onAdd: ()=>setShowForm(false)
                })
            })
        ]
    });
}






const $29e8ff095de49e68$var$manualSchema = $09193e81812ba154$export$be5493f9613cbbe({
    procedure: $09193e81812ba154$export$22b082955e083ec3().nonempty(),
    date: $09193e81812ba154$export$22b082955e083ec3().nonempty(),
    location: $09193e81812ba154$export$22b082955e083ec3().nonempty()
});
const $29e8ff095de49e68$export$4902baddc787debb = $09193e81812ba154$export$be5493f9613cbbe({
    proceduresConfirmed: $09193e81812ba154$export$c8ec6e1ec9fefcb0(true),
    proceduresManual: $09193e81812ba154$export$2f23118c22fb2630($29e8ff095de49e68$var$manualSchema)
});
function $29e8ff095de49e68$var$extractDefaults({ proceduresManual: proceduresManual }) {
    return {
        proceduresConfirmed: true,
        proceduresManual: proceduresManual ?? []
    };
}
function $29e8ff095de49e68$var$transformValues({ proceduresManual: proceduresManual }) {
    return {
        proceduresConfirmed: true,
        proceduresManual: proceduresManual
    };
}
function $29e8ff095de49e68$export$84202caead5689ba(props) {
    const { invite: invite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.history');
    const { t: tCommon } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const pastProcedureTime = (0, $acw62.useMemo)(()=>{
        const date = (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(invite.onlineBookingData?.info?.pastProcedureTime).tz((0, $2bd9d04ce55ef2a0$export$6f5c75afcb5ad5cc), false);
        return `${date.format('MMMM')} ${date.format('YYYY')}`;
    }, [
        invite.onlineBookingData?.info?.pastProcedureTime
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dea25ad601eb8263$export$70aabb5da7e125f8), {
        nextPath: props.next.path,
        extractDefaults: $29e8ff095de49e68$var$extractDefaults,
        transformValues: $29e8ff095de49e68$var$transformValues,
        schema: $29e8ff095de49e68$export$4902baddc787debb,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4777412ac24f8fdf$export$8becf861e7fda17d), {
            ...props,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "pb-2.5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            className: "title",
                            children: t('title')
                        }),
                        invite.onlineBookingData?.info?.pastProcedureTime && invite.onlineBookingData?.info?.pastProcedure ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                            i18nKey: "text",
                            ns: "page.history",
                            components: {
                                p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
                                strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    className: "font-semibold"
                                }),
                                ul: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                    className: "pl-6 list-disc"
                                }),
                                li: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {})
                            },
                            values: {
                                procedure: tCommon(invite.onlineBookingData?.info?.pastProcedure),
                                date: pastProcedureTime,
                                company: (0, $22c4bfea680558f2$export$2e2bcd8739ae039).companyShort
                            }
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: t('textNoProcedure')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdb72c6a66849198$export$8651306a9173292d), {
                    fieldArrayName: "proceduresManual",
                    ItemComponent: $29e8ff095de49e68$var$ManualProcedure,
                    showFromButtonLabel: t('addButtonLabel'),
                    FormComponent: $29e8ff095de49e68$var$ManualProcedureForm
                })
            ]
        })
    });
}
function $29e8ff095de49e68$var$ManualProcedure({ item: item }) {
    const { procedure: procedure, date: date, location: location } = item;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "px-2.5 flex flex-col items-start",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "block mb-2 font-medium",
                children: procedure
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "caption",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: date
                    }),
                    " \u2022 ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: location
                    })
                ]
            })
        ]
    });
}
function $29e8ff095de49e68$var$ManualProcedureForm({ onAdd: onAdd }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.history');
    const { append: append } = (0, $0d70f179cf56e662$export$310131896651d559)({
        name: 'proceduresManual'
    });
    const form = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        defaultValues: {
            procedure: '',
            date: '',
            location: ''
        },
        resolver: (0, $0591fe66d7f046a7$export$66b7b5879c70f722)($29e8ff095de49e68$var$manualSchema)
    });
    const { isValid: isValid } = form.formState;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
        ...form,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                    name: "procedure",
                    label: t('procedure'),
                    placeholder: t('procedurePlaceholder')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                    name: "date",
                    label: t('date'),
                    placeholder: t('datePlaceholder')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                    name: "location",
                    label: t('location'),
                    placeholder: t('locationPlaceholder', {
                        company: (0, $22c4bfea680558f2$export$2e2bcd8739ae039).companyShort
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f563c890ed38cb6$export$353f5b6fc5456de1), {
                    type: "button",
                    variant: "primary-light",
                    onClick: form.handleSubmit((values)=>{
                        append(values);
                        form.reset();
                        onAdd();
                    }),
                    disabled: !isValid,
                    children: t('saveButton')
                })
            ]
        })
    });
}


// eslint-disable-next-line import/no-unresolved




var $acw62 = parcelRequire("acw62");









function $4c17aead7dd77426$export$8b7b7cdfb85d78c5({ label: label, variant: variant = 'primary', className: className }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { isValid: isValid, isSubmitting: isSubmitting } = (0, $0d70f179cf56e662$export$606f11b2eb45ecc6)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f563c890ed38cb6$export$353f5b6fc5456de1), {
        type: "submit",
        variant: variant,
        disabled: !isValid || isSubmitting,
        className: className,
        children: isSubmitting ? 'Loading ...' : label ?? t('continue')
    });
}





function $ff38c73dbe0e7492$export$48513f6b9f8ce62d({ name: name, label: label, description: description, className: className, ...rest }) {
    const { register: register, clearErrors: clearErrors } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const { onChange: onChange, ...field } = register(name);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('px-2.5 py-5 mb-2.5 last:mb-0', className),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-start gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        id: name,
                        type: "checkbox",
                        ...field,
                        ...rest,
                        onChange: (e)=>{
                            clearErrors('root');
                            onChange(e);
                        },
                        className: "size-5 mt-0.5 rounded border text-primary cursor-pointer"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "font-semibold",
                        htmlFor: name,
                        children: label
                    })
                ]
            }),
            description && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "caption block pt-1.5 px-1 leading-none text-light-500",
                children: description
            })
        ]
    });
}




function $3a5daec5db3bdecd$export$2c396862c514d9b4({ className: className, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('mt-5 pt-5 border-t border-solid', className),
        children: children
    });
}






function $8b1710acf92137fb$export$96e99d0e61df2702(phone) {
    return phone.replace(/\D/g, '');
}


const $9d60da8c1cf04df5$var$INSURER_OPTIONS = [
    {
        value: 'southern-cross',
        label: 'Southern Cross'
    },
    {
        value: 'nib',
        label: 'NIB'
    },
    {
        value: 'aia',
        label: 'AIA'
    }
];
const $9d60da8c1cf04df5$var$schema = $09193e81812ba154$export$971dd5b0dfd021b6([
    $09193e81812ba154$export$be5493f9613cbbe({
        termsAccepted: $09193e81812ba154$export$c8ec6e1ec9fefcb0(true),
        hasCoverage: $09193e81812ba154$export$c8ec6e1ec9fefcb0('no')
    }),
    $09193e81812ba154$export$be5493f9613cbbe({
        termsAccepted: $09193e81812ba154$export$c8ec6e1ec9fefcb0(true),
        hasCoverage: $09193e81812ba154$export$c8ec6e1ec9fefcb0('yes'),
        hasPreApproval: $09193e81812ba154$export$78a99c8d44d72635([
            'yes',
            'no'
        ]),
        healthInsurer: $09193e81812ba154$export$22b082955e083ec3().nonempty(),
        membershipNumber: $09193e81812ba154$export$22b082955e083ec3().nonempty()
    })
]);
function $9d60da8c1cf04df5$var$extractDefaults({ insurance: insurance }) {
    return {
        termsAccepted: insurance?.termsAccepted ?? '',
        hasCoverage: (0, $2cfbe4d1e444ba23$export$e4d1d359df9812d2)(insurance?.hasCoverage) ?? 'no',
        hasPreApproval: (0, $2cfbe4d1e444ba23$export$e4d1d359df9812d2)(insurance?.hasPreApproval),
        membershipNumber: insurance?.membershipNumber ?? '',
        healthInsurer: insurance?.healthInsurer ?? ''
    };
}
function $9d60da8c1cf04df5$var$transformValues(values) {
    return {
        insurance: {
            ...values,
            hasCoverage: values.hasCoverage === 'yes',
            hasPreApproval: values.hasPreApproval === 'yes'
        }
    };
}
function $9d60da8c1cf04df5$export$56ad944ccf4d3da9(props) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.insurance');
    const { t: tCommon } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const hasCoverageOptions = (0, $acw62.useMemo)(()=>[
            {
                value: 'yes',
                label: tCommon('yes')
            },
            {
                value: 'no',
                label: `${tCommon('no')} - ${t('noCovered')}`
            }
        ], [
        t,
        tCommon
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dea25ad601eb8263$export$70aabb5da7e125f8), {
        nextPath: props.next.path,
        extractDefaults: $9d60da8c1cf04df5$var$extractDefaults,
        transformValues: $9d60da8c1cf04df5$var$transformValues,
        schema: $9d60da8c1cf04df5$var$schema,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4777412ac24f8fdf$export$8becf861e7fda17d), {
            ...props,
            showMenu: false,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "title",
                    children: t('title')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4cd9875607f3fe92$export$ef9b1a59e592288f), {
                    name: "hasCoverage",
                    label: t('insuranceCovered'),
                    options: hasCoverageOptions,
                    labelVariant: "base",
                    className: "mb-5 last:mb-0"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9d60da8c1cf04df5$var$InsurerFields, {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ff38c73dbe0e7492$export$48513f6b9f8ce62d), {
                    name: "termsAccepted",
                    label: t('insuranceLabel'),
                    className: "pb-0 mb-0"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    i18nKey: "insuranceDetails",
                    ns: "page.insurance",
                    components: {
                        ul: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                            className: "pl-14 mb-4.5 -mt-1.5 list-disc"
                        }),
                        li: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {}),
                        strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "font-semibold"
                        })
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c17aead7dd77426$export$8b7b7cdfb85d78c5), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a5daec5db3bdecd$export$2c396862c514d9b4), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        i18nKey: "helpMessage",
                        ns: "page.insurance",
                        values: {
                            phone: (0, $22c4bfea680558f2$export$2e2bcd8739ae039).phone
                        },
                        components: {
                            h3: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "subtitle mb-0"
                            }),
                            p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
                            br: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "font-semibold"
                            }),
                            a: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: `tel:${(0, $8b1710acf92137fb$export$96e99d0e61df2702)((0, $22c4bfea680558f2$export$2e2bcd8739ae039).phone)}`
                            })
                        }
                    })
                })
            ]
        })
    });
}
function $9d60da8c1cf04df5$var$InsurerFields() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.insurance');
    const { t: tCommon } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { watch: watch, setValue: setValue } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const hasCoverage = watch('hasCoverage');
    const healthInsurer = watch('healthInsurer');
    const hasPreApproval = watch('hasPreApproval');
    const hasCovered = hasCoverage === 'yes';
    const hasPreApprovalOptions = (0, $acw62.useMemo)(()=>[
            {
                value: 'yes',
                label: tCommon('yes')
            },
            {
                value: 'no',
                label: tCommon('no')
            }
        ], [
        tCommon
    ]);
    (0, $acw62.useEffect)(()=>{
        if (hasCoverage === 'no') {
            setValue('healthInsurer', '');
            setValue('membershipNumber', '');
            setValue('hasPreApproval', 'no');
        }
    }, [
        hasCoverage,
        setValue
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4), {
                show: hasCovered,
                enter: "transition-opacity duration-150",
                enterFrom: "opacity-0",
                enterTo: "opacity-100",
                leave: "transition-opacity duration-150",
                leaveFrom: "opacity-100",
                leaveTo: "opacity-0",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4cd9875607f3fe92$export$ef9b1a59e592288f), {
                            name: "healthInsurer",
                            options: $9d60da8c1cf04df5$var$INSURER_OPTIONS,
                            ns: "page.insurance",
                            label: t('insurerLabel'),
                            labelVariant: "base",
                            className: "mb-5 last:mb-0"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                            name: "membershipNumber",
                            label: t('membershipLabel'),
                            type: "number",
                            labelVariant: "base"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41015efefa2d03bc$export$a98f0dcb43a68a25), {
                            orientation: "horizontal",
                            name: "hasPreApproval",
                            label: t('preApprovalLabel'),
                            options: hasPreApprovalOptions,
                            labelVariant: "base",
                            labelClassName: "border-2"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4), {
                show: hasCovered && healthInsurer !== '' && hasPreApproval === 'no',
                enter: "transition-opacity duration-150",
                enterFrom: "opacity-0",
                enterTo: "opacity-100",
                leave: "transition-opacity duration-150",
                leaveFrom: "opacity-100",
                leaveTo: "opacity-0",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "relative z-1 mt-6 py-5 before:absolute before:-z-1 before:top-0 before:bottom-0 before:left-[-99999px] before:right-[-99999px] before:bg-primary-50",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        i18nKey: "preApprovalText",
                        ns: "page.insurance",
                        components: {
                            h3: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "subtitle mb-3.75"
                            }),
                            p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
                            strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "font-semibold"
                            }),
                            ul: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "pl-6 list-disc"
                            }),
                            li: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {}),
                            span: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mb-0"
                            })
                        },
                        values: {
                            insurer: t(`insurerSelect.${healthInsurer}`)
                        }
                    })
                })
            })
        ]
    });
}






parcelRequire("acw62");
const $5327f1caa0f7e754$var$SvgDropIcon = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M28 8H12a4 4 0 0 0-4 4v20m0 0v4a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4v-8M8 32l9.172-9.172a4 4 0 0 1 5.656 0L28 28m12-8v8m0 0-3.172-3.172a4 4 0 0 0-5.656 0L28 28m0 0 4 4m4-24h8m-4-4v8m-12 4h.02"
        })
    });
var $5327f1caa0f7e754$export$2e2bcd8739ae039 = $5327f1caa0f7e754$var$SvgDropIcon;



parcelRequire("acw62");
const $1ce71fbb17d37306$var$SvgFileIcon = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 50,
        height: 50,
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M34.467 15.626h4.395l-8.279-8.278v4.4a3.885 3.885 0 0 0 3.884 3.878m0 1.5a5.387 5.387 0 0 1-5.383-5.38v-5.46H13.959a3.885 3.885 0 0 0-3.88 3.88v29.668a3.884 3.884 0 0 0 3.88 3.878l22.081-.002c2.14 0 3.883-1.739 3.883-3.877V17.126zm-18.663-2.73h3.164V11.23h3.164v3.166h3.166v3.162h-3.166v3.166h-3.164v-3.166h-3.164zm18.393 23.486H15.804v-1.5h18.394zm0-5.751H15.804v-1.5h18.394zm0-5.751H15.804v-1.5h18.394z"
        })
    });
var $1ce71fbb17d37306$export$2e2bcd8739ae039 = $1ce71fbb17d37306$var$SvgFileIcon;



var $acw62 = parcelRequire("acw62");

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $a0acfd416da73b8a$var$extendStatics = function(d, b) {
    $a0acfd416da73b8a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a0acfd416da73b8a$var$extendStatics(d, b);
};
function $a0acfd416da73b8a$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a0acfd416da73b8a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a0acfd416da73b8a$export$18ce0697a983be9b = function() {
    $a0acfd416da73b8a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a0acfd416da73b8a$export$18ce0697a983be9b.apply(this, arguments);
};
function $a0acfd416da73b8a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a0acfd416da73b8a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a0acfd416da73b8a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a0acfd416da73b8a$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a0acfd416da73b8a$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a0acfd416da73b8a$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $a0acfd416da73b8a$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a0acfd416da73b8a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a0acfd416da73b8a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a0acfd416da73b8a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a0acfd416da73b8a$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a0acfd416da73b8a$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a0acfd416da73b8a$export$45d3717a4c69092e(o, m, p);
}
function $a0acfd416da73b8a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a0acfd416da73b8a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a0acfd416da73b8a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a0acfd416da73b8a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a0acfd416da73b8a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a0acfd416da73b8a$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a0acfd416da73b8a$export$10c90e4f7922046c(v) {
    return this instanceof $a0acfd416da73b8a$export$10c90e4f7922046c ? (this.v = v, this) : new $a0acfd416da73b8a$export$10c90e4f7922046c(v);
}
function $a0acfd416da73b8a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a0acfd416da73b8a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a0acfd416da73b8a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a0acfd416da73b8a$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a0acfd416da73b8a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a0acfd416da73b8a$export$19a8beecd37a4c45 === "function" ? $a0acfd416da73b8a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a0acfd416da73b8a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a0acfd416da73b8a$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $a0acfd416da73b8a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a0acfd416da73b8a$export$45d3717a4c69092e(result, mod, k);
    }
    $a0acfd416da73b8a$var$__setModuleDefault(result, mod);
    return result;
}
function $a0acfd416da73b8a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a0acfd416da73b8a$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a0acfd416da73b8a$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a0acfd416da73b8a$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $a0acfd416da73b8a$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $a0acfd416da73b8a$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $a0acfd416da73b8a$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $a0acfd416da73b8a$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $a0acfd416da73b8a$export$2e2bcd8739ae039 = {
    __extends: $a0acfd416da73b8a$export$a8ba968b8961cb8a,
    __assign: $a0acfd416da73b8a$export$18ce0697a983be9b,
    __rest: $a0acfd416da73b8a$export$3c9a16f847548506,
    __decorate: $a0acfd416da73b8a$export$29e00dfd3077644b,
    __param: $a0acfd416da73b8a$export$d5ad3fd78186038f,
    __metadata: $a0acfd416da73b8a$export$f1db080c865becb9,
    __awaiter: $a0acfd416da73b8a$export$1050f835b63b671e,
    __generator: $a0acfd416da73b8a$export$67ebef60e6f28a6,
    __createBinding: $a0acfd416da73b8a$export$45d3717a4c69092e,
    __exportStar: $a0acfd416da73b8a$export$f33643c0debef087,
    __values: $a0acfd416da73b8a$export$19a8beecd37a4c45,
    __read: $a0acfd416da73b8a$export$8d051b38c9118094,
    __spread: $a0acfd416da73b8a$export$afc72e2116322959,
    __spreadArrays: $a0acfd416da73b8a$export$6388937ca91ccae8,
    __spreadArray: $a0acfd416da73b8a$export$1216008129fb82ed,
    __await: $a0acfd416da73b8a$export$10c90e4f7922046c,
    __asyncGenerator: $a0acfd416da73b8a$export$e427f37a30a4de9b,
    __asyncDelegator: $a0acfd416da73b8a$export$bbd80228419bb833,
    __asyncValues: $a0acfd416da73b8a$export$e3b29a3d6162315f,
    __makeTemplateObject: $a0acfd416da73b8a$export$4fb47efe1390b86f,
    __importStar: $a0acfd416da73b8a$export$c21735bcef00d192,
    __importDefault: $a0acfd416da73b8a$export$da59b14a69baef04,
    __classPrivateFieldGet: $a0acfd416da73b8a$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $a0acfd416da73b8a$export$d40a35129aaff81f,
    __classPrivateFieldIn: $a0acfd416da73b8a$export$81fdc39f203e4e04,
    __addDisposableResource: $a0acfd416da73b8a$export$88ac25d8e944e405,
    __disposeResources: $a0acfd416da73b8a$export$8f076105dc360e92
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $acw62 = parcelRequire("acw62");
var $d2b63732fb4ff365$exports = {};
//
$d2b63732fb4ff365$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $e853ac0080e24cb4$export$71ad59f2e432cfe8 = '-ms-';
var $e853ac0080e24cb4$export$2c0f367103c8d01c = '-moz-';
var $e853ac0080e24cb4$export$39dfd62a25e0fe93 = '-webkit-';
var $e853ac0080e24cb4$export$a29989082612d0d9 = 'comm';
var $e853ac0080e24cb4$export$aa3a2e812ca8570d = 'rule';
var $e853ac0080e24cb4$export$527d108ccf083c2b = 'decl';
var $e853ac0080e24cb4$export$d3d35020fa5b54f0 = '@page';
var $e853ac0080e24cb4$export$500415a86c544f73 = '@media';
var $e853ac0080e24cb4$export$a763edbf796b780a = '@import';
var $e853ac0080e24cb4$export$2790aeb8b4e5c826 = '@charset';
var $e853ac0080e24cb4$export$1cc683e23b84b133 = '@viewport';
var $e853ac0080e24cb4$export$9447a5efea57e862 = '@supports';
var $e853ac0080e24cb4$export$ef011b4e114b1fba = '@document';
var $e853ac0080e24cb4$export$6aad947bda0f3f46 = '@namespace';
var $e853ac0080e24cb4$export$b44a8529a35fcb60 = '@keyframes';
var $e853ac0080e24cb4$export$2c16de31893252e6 = '@font-face';
var $e853ac0080e24cb4$export$3d846dd52e150c6f = '@counter-style';
var $e853ac0080e24cb4$export$22314bfbb57653fe = '@font-feature-values';
var $e853ac0080e24cb4$export$d773506282b3cfe6 = '@layer';
var $e853ac0080e24cb4$export$1c5a554c78c0cd12 = '@scope';


/**
 * @param {number}
 * @return {number}
 */ var $5e4f012072913cb4$export$2335f513bbd82c6d = Math.abs;
var $5e4f012072913cb4$export$6788812c4e6611e6 = String.fromCharCode;
var $5e4f012072913cb4$export$e6e34fd1f2686227 = Object.assign;
function $5e4f012072913cb4$export$d6af199866bfb566(value, length) {
    return $5e4f012072913cb4$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 0)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 1)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 2)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 3) : 0;
}
function $5e4f012072913cb4$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $5e4f012072913cb4$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $5e4f012072913cb4$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $5e4f012072913cb4$export$f8e21b1e77979a08(value, search, position) {
    return value.indexOf(search, position);
}
function $5e4f012072913cb4$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $5e4f012072913cb4$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $5e4f012072913cb4$export$36776f635604f274(value) {
    return value.length;
}
function $5e4f012072913cb4$export$f9084667e487ed46(value) {
    return value.length;
}
function $5e4f012072913cb4$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $5e4f012072913cb4$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}
function $5e4f012072913cb4$export$3dea766d36a8935f(array, pattern) {
    return array.filter(function(value) {
        return !$5e4f012072913cb4$export$4659b591c19bdf3d(value, pattern);
    });
}



var $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c = 1;
var $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1;
var $f4f4fca9115ed8bd$export$f24224f1c91d8156 = 0;
var $f4f4fca9115ed8bd$export$5880b8b5730aff45 = 0;
var $f4f4fca9115ed8bd$export$c0306caf338ac095 = 0;
var $f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = '';
function $f4f4fca9115ed8bd$export$35059013cd4a06db(value, root, parent, type, props, children, length, siblings) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c,
        column: $f4f4fca9115ed8bd$export$4e0c71f277ca26b3,
        length: length,
        return: '',
        siblings: siblings
    };
}
function $f4f4fca9115ed8bd$export$784d13d8ee351f07(root, props) {
    return (0, $5e4f012072913cb4$export$e6e34fd1f2686227)($f4f4fca9115ed8bd$export$35059013cd4a06db('', null, null, '', null, null, 0, root.siblings), root, {
        length: -root.length
    }, props);
}
function $f4f4fca9115ed8bd$export$590e8b2c435046d9(root) {
    while(root.root)root = $f4f4fca9115ed8bd$export$784d13d8ee351f07(root.root, {
        children: [
            root
        ]
    });
    (0, $5e4f012072913cb4$export$10d8903dec122b9d)(root, root.siblings);
}
function $f4f4fca9115ed8bd$export$eba6f6f03b0a92e7() {
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$232faf9add678146() {
    $f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$5880b8b5730aff45 > 0 ? (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, --$f4f4fca9115ed8bd$export$5880b8b5730aff45) : 0;
    if ($f4f4fca9115ed8bd$export$4e0c71f277ca26b3--, $f4f4fca9115ed8bd$export$c0306caf338ac095 === 10) $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c--;
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$48cfd1e771a65c4f() {
    $f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$5880b8b5730aff45 < $f4f4fca9115ed8bd$export$f24224f1c91d8156 ? (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, $f4f4fca9115ed8bd$export$5880b8b5730aff45++) : 0;
    if ($f4f4fca9115ed8bd$export$4e0c71f277ca26b3++, $f4f4fca9115ed8bd$export$c0306caf338ac095 === 10) $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c++;
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() {
    return (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, $f4f4fca9115ed8bd$export$5880b8b5730aff45);
}
function $f4f4fca9115ed8bd$export$e88cb2efb12ae807() {
    return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
}
function $f4f4fca9115ed8bd$export$58adb3bec8346d0f(begin, end) {
    return (0, $5e4f012072913cb4$export$2f35ab04d2335697)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, begin, end);
}
function $f4f4fca9115ed8bd$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $f4f4fca9115ed8bd$export$2de70f21292aac9e(value) {
    return $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c = $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$f24224f1c91d8156 = (0, $5e4f012072913cb4$export$36776f635604f274)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = value), $f4f4fca9115ed8bd$export$5880b8b5730aff45 = 0, [];
}
function $f4f4fca9115ed8bd$export$45918ac1574455b1(value) {
    return $f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = '', value;
}
function $f4f4fca9115ed8bd$export$410ac95b9ec204b8(type) {
    return (0, $5e4f012072913cb4$export$87c2784dc9fc4ab)($f4f4fca9115ed8bd$export$58adb3bec8346d0f($f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1, $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $f4f4fca9115ed8bd$export$660b2ee2d4fb4eff(value) {
    return $f4f4fca9115ed8bd$export$45918ac1574455b1($f4f4fca9115ed8bd$export$5f8c09e3ae6f64e1($f4f4fca9115ed8bd$export$2de70f21292aac9e(value)));
}
function $f4f4fca9115ed8bd$export$7af1228ff777d175(type) {
    while($f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$4d3fb11e950abb9e())if ($f4f4fca9115ed8bd$export$c0306caf338ac095 < 33) $f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
    else break;
    return $f4f4fca9115ed8bd$export$9e1725a4cfeada27(type) > 2 || $f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $f4f4fca9115ed8bd$export$5f8c09e3ae6f64e1(children) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())switch($f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$c0306caf338ac095)){
        case 0:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)($f4f4fca9115ed8bd$export$c2ab62c7bf24634($f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)($f4f4fca9115ed8bd$export$410ac95b9ec204b8($f4f4fca9115ed8bd$export$c0306caf338ac095), children);
            break;
        default:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)((0, $5e4f012072913cb4$export$6788812c4e6611e6)($f4f4fca9115ed8bd$export$c0306caf338ac095), children);
    }
    return children;
}
function $f4f4fca9115ed8bd$export$955ba06d119e085e(index, count) {
    while(--count && $f4f4fca9115ed8bd$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($f4f4fca9115ed8bd$export$c0306caf338ac095 < 48 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 102 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 57 && $f4f4fca9115ed8bd$export$c0306caf338ac095 < 65 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 70 && $f4f4fca9115ed8bd$export$c0306caf338ac095 < 97) break;
    return $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$e88cb2efb12ae807() + (count < 6 && $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() == 32 && $f4f4fca9115ed8bd$export$48cfd1e771a65c4f() == 32));
}
function $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())switch($f4f4fca9115ed8bd$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $f4f4fca9115ed8bd$export$c889f2fcc19dbf12($f4f4fca9115ed8bd$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
            break;
    }
    return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
}
function $f4f4fca9115ed8bd$export$4254d4e2b3745c4c(type, index) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())// //
    if (type + $f4f4fca9115ed8bd$export$c0306caf338ac095 === 57) break;
    else if (type + $f4f4fca9115ed8bd$export$c0306caf338ac095 === 84 && $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1) + '*' + (0, $5e4f012072913cb4$export$6788812c4e6611e6)(type === 47 ? type : $f4f4fca9115ed8bd$export$48cfd1e771a65c4f());
}
function $f4f4fca9115ed8bd$export$c2ab62c7bf24634(index) {
    while(!$f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$4d3fb11e950abb9e()))$f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
    return $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$5880b8b5730aff45);
}


function $36ea00327b41abe1$export$ef7acd7185315e22(value) {
    return (0, $f4f4fca9115ed8bd$export$45918ac1574455b1)($36ea00327b41abe1$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $f4f4fca9115ed8bd$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $36ea00327b41abe1$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $5e4f012072913cb4$export$a9db5e087081082d)(characters, length - 1) == 58) {
                if ((0, $5e4f012072913cb4$export$f8e21b1e77979a08)(characters += (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)(character), '&', '&\f'), '&\f', (0, $5e4f012072913cb4$export$2335f513bbd82c6d)(index ? points[index - 1] : 0)) != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $f4f4fca9115ed8bd$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $f4f4fca9115ed8bd$export$955ba06d119e085e)((0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $5e4f012072913cb4$export$10d8903dec122b9d)($36ea00327b41abe1$export$4a34f930e789283c((0, $f4f4fca9115ed8bd$export$4254d4e2b3745c4c)((0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)(), (0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)()), root, parent, declarations), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $5e4f012072913cb4$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(characters, /\f/g, '');
                    if (property > 0 && (0, $5e4f012072913cb4$export$36776f635604f274)(characters) - length) (0, $5e4f012072913cb4$export$10d8903dec122b9d)(property > 32 ? $36ea00327b41abe1$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1, declarations) : $36ea00327b41abe1$export$f8483753829ec8f3((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(characters, ' ', '') + ';', rule, parent, length - 2, declarations), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $5e4f012072913cb4$export$10d8903dec122b9d)(reference = $36ea00327b41abe1$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length, rulesets), rulesets);
                    if (character === 123) {
                        if (offset === 0) $36ea00327b41abe1$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $5e4f012072913cb4$export$a9db5e087081082d)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $36ea00327b41abe1$export$98e6a39c04603d36(value, reference, reference, rule && (0, $5e4f012072913cb4$export$10d8903dec122b9d)($36ea00327b41abe1$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length, children), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $36ea00327b41abe1$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $5e4f012072913cb4$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $f4f4fca9115ed8bd$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $5e4f012072913cb4$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $5e4f012072913cb4$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)() === 45) characters += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)((0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)());
                    atrule = (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)(), offset = length = (0, $5e4f012072913cb4$export$36776f635604f274)(type = characters += (0, $f4f4fca9115ed8bd$export$c2ab62c7bf24634)((0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $5e4f012072913cb4$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $36ea00327b41abe1$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length, siblings) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $5e4f012072913cb4$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, post + 1, post = (0, $5e4f012072913cb4$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $5e4f012072913cb4$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + ' ' + y : (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $e853ac0080e24cb4$export$aa3a2e812ca8570d) : type, props, children, length, siblings);
}
function $36ea00327b41abe1$export$4a34f930e789283c(value, root, parent, siblings) {
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, (0, $e853ac0080e24cb4$export$a29989082612d0d9), (0, $5e4f012072913cb4$export$6788812c4e6611e6)((0, $f4f4fca9115ed8bd$export$eba6f6f03b0a92e7)()), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 2, -2), 0, siblings);
}
function $36ea00327b41abe1$export$f8483753829ec8f3(value, root, parent, length, siblings) {
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, (0, $e853ac0080e24cb4$export$527d108ccf083c2b), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 0, length), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, length + 1, -1), length, siblings);
}






function $8f2522f8594faa86$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    for(var i = 0; i < children.length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $8f2522f8594faa86$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $e853ac0080e24cb4$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $e853ac0080e24cb4$export$a763edbf796b780a:
        case 0, $e853ac0080e24cb4$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $e853ac0080e24cb4$export$a29989082612d0d9:
            return '';
        case 0, $e853ac0080e24cb4$export$b44a8529a35fcb60:
            return element.return = element.value + '{' + $8f2522f8594faa86$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
            if (!(0, $5e4f012072913cb4$export$36776f635604f274)(element.value = element.props.join(','))) return '';
    }
    return (0, $5e4f012072913cb4$export$36776f635604f274)(children = $8f2522f8594faa86$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}




function $be3fa667258f7944$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $5e4f012072913cb4$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // tab-size
        case 4789:
            return (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // writing-mode
        case 5936:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') + (!(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /flex-|baseline/) ? (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'grid-row-' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // justify-self
        case 4200:
            if (!(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /flex-|baseline/)) return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'grid-column-align' + (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $5e4f012072913cb4$export$4659b591c19bdf3d)(element.props, /grid-\w+-end/);
            })) return ~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value + (children = children[length].value), 'span', 0) ? value : (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-start', '') + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'grid-row-span:' + (~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(children, 'span', 0) ? (0, $5e4f012072913cb4$export$4659b591c19bdf3d)(children, /\d+/) : +(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(children, /\d+/) - +(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /\d+/)) + ';';
            return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $5e4f012072913cb4$export$4659b591c19bdf3d)(element.props, /grid-\w+-start/);
            }) ? value : (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $5e4f012072913cb4$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value, 'stretch', 0) ? $be3fa667258f7944$export$82e9f45cca5ba907((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + a + ':' + b + f + (c ? (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 6) === 121) return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, (0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}


function $b9a8452e0aabfcf6$export$5a7767152ae0305f(collection) {
    var length = (0, $5e4f012072913cb4$export$f9084667e487ed46)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $b9a8452e0aabfcf6$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $b9a8452e0aabfcf6$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $e853ac0080e24cb4$export$527d108ccf083c2b:
                element.return = (0, $be3fa667258f7944$export$82e9f45cca5ba907)(element.value, element.length, children);
                return;
            case 0, $e853ac0080e24cb4$export$b44a8529a35fcb60:
                return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                    (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                        value: (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
                if (element.length) return (0, $5e4f012072913cb4$export$1be1fc439b849fdf)(children = element.props, function(value) {
                    switch((0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, callback = /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            (0, $f4f4fca9115ed8bd$export$590e8b2c435046d9)((0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + '$1')
                                ]
                            }));
                            (0, $f4f4fca9115ed8bd$export$590e8b2c435046d9)((0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                props: [
                                    value
                                ]
                            }));
                            (0, $5e4f012072913cb4$export$e6e34fd1f2686227)(element, {
                                props: (0, $5e4f012072913cb4$export$3dea766d36a8935f)(children, callback)
                            });
                            break;
                        // :placeholder
                        case '::placeholder':
                            (0, $f4f4fca9115ed8bd$export$590e8b2c435046d9)((0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'input-$1')
                                ]
                            }));
                            (0, $f4f4fca9115ed8bd$export$590e8b2c435046d9)((0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + '$1')
                                ]
                            }));
                            (0, $f4f4fca9115ed8bd$export$590e8b2c435046d9)((0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'input-$1')
                                ]
                            }));
                            (0, $f4f4fca9115ed8bd$export$590e8b2c435046d9)((0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                props: [
                                    value
                                ]
                            }));
                            (0, $5e4f012072913cb4$export$e6e34fd1f2686227)(element, {
                                props: (0, $5e4f012072913cb4$export$3dea766d36a8935f)(children, callback)
                            });
                            break;
                    }
                    return '';
                });
        }
    }
}
function $b9a8452e0aabfcf6$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
            element.props = element.props.map(function(value) {
                return (0, $5e4f012072913cb4$export$1be1fc439b849fdf)((0, $f4f4fca9115ed8bd$export$660b2ee2d4fb4eff)(value), function(value, index, children) {
                    switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 0)){
                        // \f
                        case 12:
                            return (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 1, (0, $5e4f012072913cb4$export$36776f635604f274)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $5e4f012072913cb4$export$2f35ab04d2335697)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $5e4f012072913cb4$export$f9084667e487ed46)(children) > 1 ? '' : value;
                                case index = (0, $5e4f012072913cb4$export$f9084667e487ed46)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $f8dbcd8598db1f0b$var$f = "data-styled", $f8dbcd8598db1f0b$var$m = "active", $f8dbcd8598db1f0b$var$y = "data-styled-version", $f8dbcd8598db1f0b$export$83d89fbfd8236492 = "6.1.19", $f8dbcd8598db1f0b$var$g = "/*!sc*/\n", $f8dbcd8598db1f0b$var$S = "undefined" != typeof window && "undefined" != typeof document, $f8dbcd8598db1f0b$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : false), $f8dbcd8598db1f0b$var$b = {}, $f8dbcd8598db1f0b$var$E = /invalid hook call/i, $f8dbcd8598db1f0b$var$N = new Set, $f8dbcd8598db1f0b$var$P = function(t, n) {
    var o, s, i, a, e;
}, $f8dbcd8598db1f0b$var$_ = Object.freeze([]), $f8dbcd8598db1f0b$var$C = Object.freeze({});
function $f8dbcd8598db1f0b$var$I(e, t, n) {
    return void 0 === n && (n = $f8dbcd8598db1f0b$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $f8dbcd8598db1f0b$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $f8dbcd8598db1f0b$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f8dbcd8598db1f0b$var$D = /(^-|-$)/g;
function $f8dbcd8598db1f0b$var$R(e) {
    return e.replace($f8dbcd8598db1f0b$var$O, "-").replace($f8dbcd8598db1f0b$var$D, "");
}
var $f8dbcd8598db1f0b$var$T = /(a)(d)/gi, $f8dbcd8598db1f0b$var$k = 52, $f8dbcd8598db1f0b$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $f8dbcd8598db1f0b$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $f8dbcd8598db1f0b$var$k; t = t / $f8dbcd8598db1f0b$var$k | 0)n = $f8dbcd8598db1f0b$var$j(t % $f8dbcd8598db1f0b$var$k) + n;
    return ($f8dbcd8598db1f0b$var$j(t % $f8dbcd8598db1f0b$var$k) + n).replace($f8dbcd8598db1f0b$var$T, "$1-$2");
}
var $f8dbcd8598db1f0b$var$V, $f8dbcd8598db1f0b$var$F = 5381, $f8dbcd8598db1f0b$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f8dbcd8598db1f0b$var$z = function(e) {
    return $f8dbcd8598db1f0b$var$M($f8dbcd8598db1f0b$var$F, e);
};
function $f8dbcd8598db1f0b$var$$(e) {
    return $f8dbcd8598db1f0b$var$x($f8dbcd8598db1f0b$var$z(e) >>> 0);
}
function $f8dbcd8598db1f0b$var$B(e) {
    return e.displayName || e.name || "Component";
}
function $f8dbcd8598db1f0b$var$L(e) {
    return "string" == typeof e && true;
}
var $f8dbcd8598db1f0b$var$G = "function" == typeof Symbol && Symbol.for, $f8dbcd8598db1f0b$var$Y = $f8dbcd8598db1f0b$var$G ? Symbol.for("react.memo") : 60115, $f8dbcd8598db1f0b$var$W = $f8dbcd8598db1f0b$var$G ? Symbol.for("react.forward_ref") : 60112, $f8dbcd8598db1f0b$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $f8dbcd8598db1f0b$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $f8dbcd8598db1f0b$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $f8dbcd8598db1f0b$var$J = (($f8dbcd8598db1f0b$var$V = {})[$f8dbcd8598db1f0b$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $f8dbcd8598db1f0b$var$V[$f8dbcd8598db1f0b$var$Y] = $f8dbcd8598db1f0b$var$U, $f8dbcd8598db1f0b$var$V);
function $f8dbcd8598db1f0b$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $f8dbcd8598db1f0b$var$Y ? $f8dbcd8598db1f0b$var$U : "$$typeof" in e ? $f8dbcd8598db1f0b$var$J[e.$$typeof] : $f8dbcd8598db1f0b$var$q;
}
var $f8dbcd8598db1f0b$var$Z = Object.defineProperty, $f8dbcd8598db1f0b$var$K = Object.getOwnPropertyNames, $f8dbcd8598db1f0b$var$Q = Object.getOwnPropertySymbols, $f8dbcd8598db1f0b$var$ee = Object.getOwnPropertyDescriptor, $f8dbcd8598db1f0b$var$te = Object.getPrototypeOf, $f8dbcd8598db1f0b$var$ne = Object.prototype;
function $f8dbcd8598db1f0b$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($f8dbcd8598db1f0b$var$ne) {
            var o = $f8dbcd8598db1f0b$var$te(t);
            o && o !== $f8dbcd8598db1f0b$var$ne && $f8dbcd8598db1f0b$var$oe(e, o, n);
        }
        var r = $f8dbcd8598db1f0b$var$K(t);
        $f8dbcd8598db1f0b$var$Q && (r = r.concat($f8dbcd8598db1f0b$var$Q(t)));
        for(var s = $f8dbcd8598db1f0b$var$X(e), i = $f8dbcd8598db1f0b$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $f8dbcd8598db1f0b$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $f8dbcd8598db1f0b$var$ee(t, c);
                try {
                    $f8dbcd8598db1f0b$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $f8dbcd8598db1f0b$var$re(e) {
    return "function" == typeof e;
}
function $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $f8dbcd8598db1f0b$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $f8dbcd8598db1f0b$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $f8dbcd8598db1f0b$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $f8dbcd8598db1f0b$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$f8dbcd8598db1f0b$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $f8dbcd8598db1f0b$var$le(e[o], t[o]);
    else if ($f8dbcd8598db1f0b$var$ce(t)) for(var o in t)e[o] = $f8dbcd8598db1f0b$var$le(e[o], t[o]);
    return e;
}
function $f8dbcd8598db1f0b$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $f8dbcd8598db1f0b$var$pe = {};
function $f8dbcd8598db1f0b$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $f8dbcd8598db1f0b$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $f8dbcd8598db1f0b$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $f8dbcd8598db1f0b$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($f8dbcd8598db1f0b$var$g);
        return t;
    }, e;
}(), $f8dbcd8598db1f0b$var$me = 1073741824, $f8dbcd8598db1f0b$var$ye = new Map, $f8dbcd8598db1f0b$var$ve = new Map, $f8dbcd8598db1f0b$var$ge = 1, $f8dbcd8598db1f0b$var$Se = function(e) {
    if ($f8dbcd8598db1f0b$var$ye.has(e)) return $f8dbcd8598db1f0b$var$ye.get(e);
    for(; $f8dbcd8598db1f0b$var$ve.has($f8dbcd8598db1f0b$var$ge);)$f8dbcd8598db1f0b$var$ge++;
    var t = $f8dbcd8598db1f0b$var$ge++;
    return $f8dbcd8598db1f0b$var$ye.set(e, t), $f8dbcd8598db1f0b$var$ve.set(t, e), t;
}, $f8dbcd8598db1f0b$var$we = function(e, t) {
    $f8dbcd8598db1f0b$var$ge = t + 1, $f8dbcd8598db1f0b$var$ye.set(e, t), $f8dbcd8598db1f0b$var$ve.set(t, e);
}, $f8dbcd8598db1f0b$var$be = "style[".concat($f8dbcd8598db1f0b$var$f, "][").concat($f8dbcd8598db1f0b$var$y, '="').concat($f8dbcd8598db1f0b$export$83d89fbfd8236492, '"]'), $f8dbcd8598db1f0b$var$Ee = new RegExp("^".concat($f8dbcd8598db1f0b$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $f8dbcd8598db1f0b$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $f8dbcd8598db1f0b$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($f8dbcd8598db1f0b$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($f8dbcd8598db1f0b$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($f8dbcd8598db1f0b$var$we(u, l), $f8dbcd8598db1f0b$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $f8dbcd8598db1f0b$var$_e = function(e) {
    for(var t = document.querySelectorAll($f8dbcd8598db1f0b$var$be), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute($f8dbcd8598db1f0b$var$f) !== $f8dbcd8598db1f0b$var$m && ($f8dbcd8598db1f0b$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $f8dbcd8598db1f0b$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $f8dbcd8598db1f0b$var$Ie = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($f8dbcd8598db1f0b$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($f8dbcd8598db1f0b$var$f, $f8dbcd8598db1f0b$var$m), o.setAttribute($f8dbcd8598db1f0b$var$y, $f8dbcd8598db1f0b$export$83d89fbfd8236492);
    var i = $f8dbcd8598db1f0b$var$Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $f8dbcd8598db1f0b$var$Ae = function() {
    function e(e) {
        this.element = $f8dbcd8598db1f0b$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $f8dbcd8598db1f0b$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$Oe = function() {
    function e(e) {
        this.element = $f8dbcd8598db1f0b$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$Re = $f8dbcd8598db1f0b$var$S, $f8dbcd8598db1f0b$var$Te = {
    isServer: !$f8dbcd8598db1f0b$var$S,
    useCSSOMInjection: !$f8dbcd8598db1f0b$var$w
}, $f8dbcd8598db1f0b$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $f8dbcd8598db1f0b$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, $f8dbcd8598db1f0b$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $f8dbcd8598db1f0b$var$S && $f8dbcd8598db1f0b$var$Re && ($f8dbcd8598db1f0b$var$Re = !1, $f8dbcd8598db1f0b$var$_e(this)), $f8dbcd8598db1f0b$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $f8dbcd8598db1f0b$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($f8dbcd8598db1f0b$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($f8dbcd8598db1f0b$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $f8dbcd8598db1f0b$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $f8dbcd8598db1f0b$var$S && $f8dbcd8598db1f0b$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $f8dbcd8598db1f0b$var$De(n) : t ? new $f8dbcd8598db1f0b$var$Ae(n) : new $f8dbcd8598db1f0b$var$Oe(n);
        }(this.options), new $f8dbcd8598db1f0b$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($f8dbcd8598db1f0b$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f8dbcd8598db1f0b$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($f8dbcd8598db1f0b$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $f8dbcd8598db1f0b$var$je = /&/g, $f8dbcd8598db1f0b$var$xe = /^\s*\/\/.*$/gm;
function $f8dbcd8598db1f0b$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $f8dbcd8598db1f0b$var$Ve(e.children, t)), e;
    });
}
function $f8dbcd8598db1f0b$var$Fe(e) {
    var t, n, o, r = void 0 === e ? $f8dbcd8598db1f0b$var$C : e, s = r.options, i = void 0 === s ? $f8dbcd8598db1f0b$var$C : s, a = r.plugins, c = void 0 === a ? $f8dbcd8598db1f0b$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $e853ac0080e24cb4$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($f8dbcd8598db1f0b$var$je, n).replace(o, l));
    }), i.prefix && u.push($b9a8452e0aabfcf6$export$e08c7d021b829b7a), u.push($8f2522f8594faa86$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($f8dbcd8598db1f0b$var$xe, ""), l = $36ea00327b41abe1$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $f8dbcd8598db1f0b$var$Ve(l, i.namespace));
        var p = [];
        return $8f2522f8594faa86$export$dfdc1655ccc5b9cb(l, $b9a8452e0aabfcf6$export$5a7767152ae0305f(u.concat($b9a8452e0aabfcf6$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $f8dbcd8598db1f0b$var$he(15), $f8dbcd8598db1f0b$var$M(e, t.name);
    }, $f8dbcd8598db1f0b$var$F).toString() : "", p;
}
var $f8dbcd8598db1f0b$var$Me = new $f8dbcd8598db1f0b$var$ke, $f8dbcd8598db1f0b$var$ze = $f8dbcd8598db1f0b$var$Fe(), $f8dbcd8598db1f0b$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $f8dbcd8598db1f0b$var$Me,
    stylis: $f8dbcd8598db1f0b$var$ze
}), $f8dbcd8598db1f0b$export$91317688fc694efa = $f8dbcd8598db1f0b$export$8c190ef828af4c86.Consumer, $f8dbcd8598db1f0b$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(void 0);
function $f8dbcd8598db1f0b$var$Ge() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$8c190ef828af4c86);
}
function $f8dbcd8598db1f0b$export$a473771da2f0ff7c(e) {
    var t = (0, $acw62.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $f8dbcd8598db1f0b$var$Ge().styleSheet, l = (0, $acw62.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $acw62.useMemo)(function() {
        return $f8dbcd8598db1f0b$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $acw62.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($d2b63732fb4ff365$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $acw62.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$var$Le.Provider, {
        value: u
    }, e.children));
}
var $f8dbcd8598db1f0b$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $f8dbcd8598db1f0b$var$ze);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $f8dbcd8598db1f0b$var$ue(this, function() {
            throw $f8dbcd8598db1f0b$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $f8dbcd8598db1f0b$var$ze), this.name + e.hash;
    }, e;
}(), $f8dbcd8598db1f0b$var$qe = function(e) {
    return e >= "A" && e <= "Z";
};
function $f8dbcd8598db1f0b$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $f8dbcd8598db1f0b$var$qe(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $f8dbcd8598db1f0b$var$Ue = function(e) {
    return null == e || !1 === e || "" === e;
}, $f8dbcd8598db1f0b$var$Je = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$f8dbcd8598db1f0b$var$Ue(i) && (Array.isArray(i) && i.isCss || $f8dbcd8598db1f0b$var$re(i) ? r.push("".concat($f8dbcd8598db1f0b$var$He(s), ":"), i, ";") : $f8dbcd8598db1f0b$var$ce(i) ? r.push.apply(r, (0, $a0acfd416da73b8a$export$1216008129fb82ed)((0, $a0acfd416da73b8a$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $f8dbcd8598db1f0b$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($f8dbcd8598db1f0b$var$He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $936be3b045ab836e$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $f8dbcd8598db1f0b$var$Xe(e, t, n, o) {
    if ($f8dbcd8598db1f0b$var$Ue(e)) return [];
    if ($f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($f8dbcd8598db1f0b$var$re(e)) {
        if (!$f8dbcd8598db1f0b$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $f8dbcd8598db1f0b$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $f8dbcd8598db1f0b$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $f8dbcd8598db1f0b$var$ce(e) ? $f8dbcd8598db1f0b$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($f8dbcd8598db1f0b$var$_, e.map(function(e) {
        return $f8dbcd8598db1f0b$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $f8dbcd8598db1f0b$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($f8dbcd8598db1f0b$var$re(n) && !$f8dbcd8598db1f0b$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $f8dbcd8598db1f0b$var$Ke = $f8dbcd8598db1f0b$var$z($f8dbcd8598db1f0b$export$83d89fbfd8236492), $f8dbcd8598db1f0b$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $f8dbcd8598db1f0b$var$Ze(e), this.componentId = t, this.baseHash = $f8dbcd8598db1f0b$var$M($f8dbcd8598db1f0b$var$Ke, t), this.baseStyle = n, $f8dbcd8598db1f0b$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $f8dbcd8598db1f0b$var$ie(o, this.staticRulesId);
            else {
                var r = $f8dbcd8598db1f0b$var$ae($f8dbcd8598db1f0b$var$Xe(this.rules, e, t, n)), s = $f8dbcd8598db1f0b$var$x($f8dbcd8598db1f0b$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $f8dbcd8598db1f0b$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $f8dbcd8598db1f0b$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $f8dbcd8598db1f0b$var$ae($f8dbcd8598db1f0b$var$Xe(u, e, t, n));
                    a = $f8dbcd8598db1f0b$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $f8dbcd8598db1f0b$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $f8dbcd8598db1f0b$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $f8dbcd8598db1f0b$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(void 0), $f8dbcd8598db1f0b$export$b631efc24e9d5e2f = $f8dbcd8598db1f0b$export$2c657da244d00bd6.Consumer;
function $f8dbcd8598db1f0b$export$93d4e7f90805808f() {
    var e = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6);
    if (!e) throw $f8dbcd8598db1f0b$var$he(18);
    return e;
}
function $f8dbcd8598db1f0b$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), r = (0, $acw62.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $f8dbcd8598db1f0b$var$he(14);
            if ($f8dbcd8598db1f0b$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $f8dbcd8598db1f0b$var$he(8);
            return n ? (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $f8dbcd8598db1f0b$var$rt = {}, $f8dbcd8598db1f0b$var$st = new Set;
function $f8dbcd8598db1f0b$var$it(e, r, s) {
    var i = $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e), a = e, c = !$f8dbcd8598db1f0b$var$L(e), p = r.attrs, d = void 0 === p ? $f8dbcd8598db1f0b$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $f8dbcd8598db1f0b$var$R(e);
        $f8dbcd8598db1f0b$var$rt[n] = ($f8dbcd8598db1f0b$var$rt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($f8dbcd8598db1f0b$var$$($f8dbcd8598db1f0b$export$83d89fbfd8236492 + n + $f8dbcd8598db1f0b$var$rt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $f8dbcd8598db1f0b$var$L(e) ? "styled.".concat(e) : "Styled(".concat($f8dbcd8598db1f0b$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($f8dbcd8598db1f0b$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $f8dbcd8598db1f0b$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), m = $f8dbcd8598db1f0b$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $f8dbcd8598db1f0b$var$I(r, f, c) || $f8dbcd8598db1f0b$var$C, g = function(e, n, o) {
                for(var r, s = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $f8dbcd8598db1f0b$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $f8dbcd8598db1f0b$var$ie(s[c], a[c]) : "style" === c ? (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $f8dbcd8598db1f0b$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $f8dbcd8598db1f0b$var$Ge(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $f8dbcd8598db1f0b$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$f8dbcd8598db1f0b$var$L(S) && !$f8dbcd8598db1f0b$var$A.has(S) ? "class" : "className"] = N, s && (w.ref = s), (0, $acw62.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $f8dbcd8598db1f0b$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$f8dbcd8598db1f0b$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $f8dbcd8598db1f0b$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $f8dbcd8598db1f0b$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $f8dbcd8598db1f0b$var$at(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $f8dbcd8598db1f0b$var$ct = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $f8dbcd8598db1f0b$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($f8dbcd8598db1f0b$var$re(t) || $f8dbcd8598db1f0b$var$ce(t)) return $f8dbcd8598db1f0b$var$ct($f8dbcd8598db1f0b$var$Xe($f8dbcd8598db1f0b$var$at($f8dbcd8598db1f0b$var$_, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $f8dbcd8598db1f0b$var$Xe(r) : $f8dbcd8598db1f0b$var$ct($f8dbcd8598db1f0b$var$Xe($f8dbcd8598db1f0b$var$at(r, n)));
}
function $f8dbcd8598db1f0b$var$ut(n, o, r) {
    if (void 0 === r && (r = $f8dbcd8598db1f0b$var$C), !o) throw $f8dbcd8598db1f0b$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $f8dbcd8598db1f0b$var$ut(n, o, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $f8dbcd8598db1f0b$var$ut(n, o, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $f8dbcd8598db1f0b$var$pt = function(e) {
    return $f8dbcd8598db1f0b$var$ut($f8dbcd8598db1f0b$var$it, e);
}, $f8dbcd8598db1f0b$export$2e2bcd8739ae039 = $f8dbcd8598db1f0b$var$pt;
$f8dbcd8598db1f0b$var$A.forEach(function(e) {
    $f8dbcd8598db1f0b$export$2e2bcd8739ae039[e] = $f8dbcd8598db1f0b$var$pt(e);
});
var $f8dbcd8598db1f0b$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $f8dbcd8598db1f0b$var$Ze(e), $f8dbcd8598db1f0b$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($f8dbcd8598db1f0b$var$ae($f8dbcd8598db1f0b$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $f8dbcd8598db1f0b$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $f8dbcd8598db1f0b$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($f8dbcd8598db1f0b$var$$(JSON.stringify(i))), c = new $f8dbcd8598db1f0b$var$ht(i, a);
    var l = function(e) {
        var t = $f8dbcd8598db1f0b$var$Ge(), n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $f8dbcd8598db1f0b$var$b, o, s);
        else {
            var i = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, n), {
                theme: $f8dbcd8598db1f0b$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(l);
}
function $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $f8dbcd8598db1f0b$var$ae($f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $f8dbcd8598db1f0b$var$$(r);
    return new $f8dbcd8598db1f0b$var$We(s, r);
}
function $f8dbcd8598db1f0b$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(n, r) {
        var s = $f8dbcd8598db1f0b$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($f8dbcd8598db1f0b$var$B(e), ")"), $f8dbcd8598db1f0b$var$oe(n, e);
}
var $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $f8dbcd8598db1f0b$var$Ce(), o = $f8dbcd8598db1f0b$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($f8dbcd8598db1f0b$var$f, '="true"'),
                "".concat($f8dbcd8598db1f0b$var$y, '="').concat($f8dbcd8598db1f0b$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $f8dbcd8598db1f0b$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $f8dbcd8598db1f0b$var$he(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$f8dbcd8598db1f0b$var$f] = "", n[$f8dbcd8598db1f0b$var$y] = $f8dbcd8598db1f0b$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $f8dbcd8598db1f0b$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $f8dbcd8598db1f0b$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $f8dbcd8598db1f0b$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $f8dbcd8598db1f0b$var$he(3);
    }, e;
}(), $f8dbcd8598db1f0b$export$5c87cfe6c475f500 = {
    StyleSheet: $f8dbcd8598db1f0b$var$ke,
    mainSheet: $f8dbcd8598db1f0b$var$Me
};
var $f8dbcd8598db1f0b$var$St = "__sc-".concat($f8dbcd8598db1f0b$var$f, "__");



var $acw62 = parcelRequire("acw62");
var $103feeda949e48d9$var$p = function() {
    return $103feeda949e48d9$var$p = Object.assign || function(n) {
        for(var e, r = 1, t = arguments.length; r < t; r++)for(var i in e = arguments[r])Object.prototype.hasOwnProperty.call(e, i) && (n[i] = e[i]);
        return n;
    }, $103feeda949e48d9$var$p.apply(this, arguments);
};
function $103feeda949e48d9$var$d(n, e) {
    return Object.defineProperty ? Object.defineProperty(n, "raw", {
        value: e
    }) : n.raw = e, n;
}
"function" == typeof SuppressedError && SuppressedError;
var $103feeda949e48d9$var$c, $103feeda949e48d9$var$u, $103feeda949e48d9$var$f, $103feeda949e48d9$var$h, $103feeda949e48d9$var$v, $103feeda949e48d9$var$x = "#666", $103feeda949e48d9$var$b = (0, $f8dbcd8598db1f0b$export$dbf350e5966cf602)($103feeda949e48d9$var$c || ($103feeda949e48d9$var$c = $103feeda949e48d9$var$d([
    "\n  display: flex;\n  align-items: center;\n  min-width: 322px;\n  max-width: 508px;\n  height: 48px;\n  border: dashed 2px ",
    ";\n  padding: 8px 16px 8px 8px;\n  border-radius: 5px;\n  cursor: pointer;\n  flex-grow: 0;\n\n  &.is-disabled {\n    border: dashed 2px ",
    ";\n    cursor: no-drop;\n    svg {\n      fill: ",
    ";\n      color: ",
    ";\n      path {\n        fill: ",
    ";\n        color: ",
    ";\n      }\n    }\n  }\n"
], [
    "\n  display: flex;\n  align-items: center;\n  min-width: 322px;\n  max-width: 508px;\n  height: 48px;\n  border: dashed 2px ",
    ";\n  padding: 8px 16px 8px 8px;\n  border-radius: 5px;\n  cursor: pointer;\n  flex-grow: 0;\n\n  &.is-disabled {\n    border: dashed 2px ",
    ";\n    cursor: no-drop;\n    svg {\n      fill: ",
    ";\n      color: ",
    ";\n      path {\n        fill: ",
    ";\n        color: ",
    ";\n      }\n    }\n  }\n"
])), "#0658c2", $103feeda949e48d9$var$x, $103feeda949e48d9$var$x, $103feeda949e48d9$var$x, $103feeda949e48d9$var$x, $103feeda949e48d9$var$x), $103feeda949e48d9$var$g = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).label($103feeda949e48d9$var$u || ($103feeda949e48d9$var$u = $103feeda949e48d9$var$d([
    "\n  position: relative;\n  ",
    ";\n  &:focus-within {\n    outline: 2px solid black;\n  }\n  & > input {\n    display: block;\n    opacity: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n"
], [
    "\n  position: relative;\n  ",
    ";\n  &:focus-within {\n    outline: 2px solid black;\n  }\n  & > input {\n    display: block;\n    opacity: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n"
])), function(n) {
    return n.override ? "" : $103feeda949e48d9$var$b;
}), $103feeda949e48d9$var$m = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div($103feeda949e48d9$var$f || ($103feeda949e48d9$var$f = $103feeda949e48d9$var$d([
    "\n  border: dashed 2px ",
    ";\n  border-radius: 5px;\n  background-color: ",
    ";\n  opacity: 0.9;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  z-index: 999;\n  & > span {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translateX(-50%) translateY(-50%);\n  }\n"
], [
    "\n  border: dashed 2px ",
    ";\n  border-radius: 5px;\n  background-color: ",
    ";\n  opacity: 0.9;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  z-index: 999;\n  & > span {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translateX(-50%) translateY(-50%);\n  }\n"
])), $103feeda949e48d9$var$x, "#999"), $103feeda949e48d9$var$y = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div($103feeda949e48d9$var$h || ($103feeda949e48d9$var$h = $103feeda949e48d9$var$d([
    "\n  display: flex;\n  justify-content: space-between;\n  flex-grow: 1;\n  & > span {\n    font-size: 12px;\n    color: ",
    ";\n  }\n  .file-types {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 100px;\n  }\n"
], [
    "\n  display: flex;\n  justify-content: space-between;\n  flex-grow: 1;\n  & > span {\n    font-size: 12px;\n    color: ",
    ";\n  }\n  .file-types {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 100px;\n  }\n"
])), function(n) {
    return n.$error ? "red" : $103feeda949e48d9$var$x;
}), $103feeda949e48d9$var$w = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span($103feeda949e48d9$var$v || ($103feeda949e48d9$var$v = $103feeda949e48d9$var$d([
    "\n  font-size: 14px;\n  color: ",
    ";\n  span {\n    text-decoration: underline;\n  }\n"
], [
    "\n  font-size: 14px;\n  color: ",
    ";\n  span {\n    text-decoration: underline;\n  }\n"
])), $103feeda949e48d9$var$x), $103feeda949e48d9$var$z = function(n) {
    return n / 1024 / 1024;
}, $103feeda949e48d9$var$L = function(n) {
    return void 0 === n ? "" : n.map(function(n) {
        return ".".concat(n.toLowerCase());
    }).join(",");
};
function $103feeda949e48d9$var$C(e) {
    var r = e.types, t = e.minSize, i = e.maxSize;
    if (r) {
        var o = r.toString(), a = "";
        return i && (a += "size >= ".concat(i, ", ")), t && (a += "size <= ".concat(t, ", ")), (0, $7b02d682eb115277$exports.jsx)("span", $103feeda949e48d9$var$p({
            title: "".concat(a, "types: ").concat(o),
            className: "file-types"
        }, {
            children: o
        }));
    }
    return null;
}
function $103feeda949e48d9$var$E() {
    return (0, $7b02d682eb115277$exports.jsxs)("svg", $103feeda949e48d9$var$p({
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.33317 6.66667H22.6665V16H25.3332V6.66667C25.3332 5.196 24.1372 4 22.6665 4H5.33317C3.8625 4 2.6665 5.196 2.6665 6.66667V22.6667C2.6665 24.1373 3.8625 25.3333 5.33317 25.3333H15.9998V22.6667H5.33317V6.66667Z",
                fill: "#0658C2"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10.6665 14.6667L6.6665 20H21.3332L15.9998 12L11.9998 17.3333L10.6665 14.6667Z",
                fill: "#0658C2"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M25.3332 18.6667H22.6665V22.6667H18.6665V25.3333H22.6665V29.3333H25.3332V25.3333H29.3332V22.6667H25.3332V18.6667Z",
                fill: "#0658C2"
            })
        ]
    }));
}
var $103feeda949e48d9$var$H = 0;
var $103feeda949e48d9$var$S = function(t, i, o, a, l, s) {
    return o ? (0, $7b02d682eb115277$exports.jsx)("span", {
        children: "File type/size error, Hovered on types!"
    }) : (0, $7b02d682eb115277$exports.jsx)($103feeda949e48d9$var$w, {
        children: a ? (0, $7b02d682eb115277$exports.jsx)("span", {
            children: "Upload disabled"
        }) : (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), t || i ? {
            children: s ? (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: s
                })
            }) : (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "Uploaded Successfully!"
                    }),
                    " Upload another?"
                ]
            })
        } : {
            children: (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), l ? {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: l.split(" ")[0]
                    }),
                    " ",
                    l.substr(l.indexOf(" ") + 1)
                ]
            } : {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "Upload"
                    }),
                    " or drop a file right here"
                ]
            })
        })
    });
}, $103feeda949e48d9$export$1a5cb5295a7d2749 = function(t) {
    var i = t.name, d = t.hoverTitle, c = t.types, u = t.handleChange, f = t.classes, h = t.children, v = t.maxSize, x = t.minSize, b = t.fileOrFiles, w = t.onSizeError, k = t.onTypeError, D = t.onSelect, V = t.onDrop, P = t.disabled, j = t.label, F = t.uploadedLabel, O = t.multiple, T = t.required, M = t.onDraggingStateChange, R = t.dropMessageStyle, U = t.ariaLabel, Z = t.ariaDescribedby, q = (0, $acw62.useRef)(null), N = (0, $acw62.useRef)(null), X = (0, $acw62.useState)(!1), Y = X[0], $ = X[1], B = (0, $acw62.useState)(null), A = B[0], G = B[1], I = (0, $acw62.useState)(!1), J = I[0], K = I[1], Q = function(n) {
        return c && !function(n, e) {
            var r = n.name.split(".").pop();
            return e.map(function(n) {
                return n.toLowerCase();
            }).includes(r.toLowerCase());
        }(n, c) ? (K(!0), k && k("File type is not supported"), !1) : v && $103feeda949e48d9$var$z(n.size) > v ? (K(!0), w && w("File size is too big"), !1) : !(x && $103feeda949e48d9$var$z(n.size) < x) || (K(!0), w && w("File size is too small"), !1);
    }, W = function(n) {
        var e = !1;
        if (n) {
            if (n instanceof File) e = !Q(n);
            else for(var r = 0; r < n.length; r++){
                var t = n[r];
                e = !Q(t) || e;
            }
            return !e && (u && u(n), G(n), $(!0), K(!1), !0);
        }
        return !1;
    }, _ = function(n) {
        var e = n.labelRef, r = n.inputRef, t = n.multiple, i = n.handleChanges, s = n.onDrop, p = (0, $acw62.useState)(!1), d = p[0], c = p[1], u = (0, $acw62.useCallback)(function() {
            r.current.click();
        }, [
            r
        ]), f = (0, $acw62.useCallback)(function(n) {
            n.preventDefault(), n.stopPropagation(), $103feeda949e48d9$var$H++, n.dataTransfer.items && 0 !== n.dataTransfer.items.length && c(!0);
        }, []), h = (0, $acw62.useCallback)(function(n) {
            n.preventDefault(), n.stopPropagation(), --$103feeda949e48d9$var$H > 0 || c(!1);
        }, []), v = (0, $acw62.useCallback)(function(n) {
            n.preventDefault(), n.stopPropagation();
        }, []), x = (0, $acw62.useCallback)(function(n) {
            n.preventDefault(), n.stopPropagation(), c(!1), $103feeda949e48d9$var$H = 0;
            var e = n.dataTransfer.files;
            if (e && e.length > 0) {
                var r = t ? e : e[0], o = i(r);
                s && o && s(r);
            }
        }, [
            i
        ]);
        return (0, $acw62.useEffect)(function() {
            var n = e.current;
            return n.addEventListener("click", u), n.addEventListener("dragenter", f), n.addEventListener("dragleave", h), n.addEventListener("dragover", v), n.addEventListener("drop", x), function() {
                n.removeEventListener("click", u), n.removeEventListener("dragenter", f), n.removeEventListener("dragleave", h), n.removeEventListener("dragover", v), n.removeEventListener("drop", x);
            };
        }, [
            u,
            f,
            h,
            v,
            x,
            e
        ]), d;
    }({
        labelRef: q,
        inputRef: N,
        multiple: O,
        handleChanges: W,
        onDrop: V
    });
    return (0, $acw62.useEffect)(function() {
        null == M || M(_);
    }, [
        _
    ]), (0, $acw62.useEffect)(function() {
        b ? ($(!0), G(b)) : (N.current && (N.current.value = ""), $(!1), G(null));
    }, [
        b
    ]), (0, $7b02d682eb115277$exports.jsxs)($103feeda949e48d9$var$g, $103feeda949e48d9$var$p({
        override: h,
        className: "".concat(f || "", " ").concat(P ? "is-disabled" : ""),
        ref: q,
        htmlFor: i,
        onClick: function(n) {
            n.preventDefault(), n.stopPropagation();
        },
        "aria-describedby": Z,
        role: "button",
        "aria-label": U
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("input", {
                onClick: function(n) {
                    n.stopPropagation(), N && N.current && (N.current.value = "", N.current.click());
                },
                onChange: function(n) {
                    var e = n.target.files, r = O ? e : e[0], t = W(r);
                    D && t && D(r);
                },
                accept: $103feeda949e48d9$var$L(c),
                ref: N,
                type: "file",
                id: i,
                name: i,
                disabled: P,
                multiple: O,
                required: T
            }),
            _ && (0, $7b02d682eb115277$exports.jsx)($103feeda949e48d9$var$m, $103feeda949e48d9$var$p({
                style: R
            }, {
                children: (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: d || "Drop Here"
                })
            })),
            !h && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)($103feeda949e48d9$var$E, {}),
                    (0, $7b02d682eb115277$exports.jsxs)($103feeda949e48d9$var$y, $103feeda949e48d9$var$p({
                        $error: J
                    }, {
                        children: [
                            $103feeda949e48d9$var$S(A, Y, J, P, j, F),
                            (0, $7b02d682eb115277$exports.jsx)($103feeda949e48d9$var$C, {
                                types: c,
                                minSize: x,
                                maxSize: v
                            })
                        ]
                    }))
                ]
            }),
            h
        ]
    }));
};









function $9098887a59a3a10b$export$50cc34fc3f08cd74() {
    const { invite: invite, removeAttachment: removeAttachment } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    const start = (0, $be79a52cbffa2be6$export$f32f6ef648fb680f)((s)=>s.start);
    const stop = (0, $be79a52cbffa2be6$export$f32f6ef648fb680f)((s)=>s.stop);
    return (0, $36464e4be8053fb8$export$fbeb804c371ac8d)(async (attachmentId)=>{
        if (!attachmentId) return true;
        start();
        try {
            await (0, $56ff6b9a4ee43a2e$export$644d8ea042df96a6).auth.delete(`attachment/${attachmentId}/${invite.id}`);
            removeAttachment(attachmentId);
        } catch (e) {
            // TODO: user feedback
            console.error('Failed to delete attachment:', e);
        } finally{
            stop();
        }
    });
}







function $8a71ab2ff7b7c045$export$f7a61246b71a5a37() {
    const { invite: invite, addAttachment: addAttachment } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    const start = (0, $be79a52cbffa2be6$export$f32f6ef648fb680f)((s)=>s.start);
    const stop = (0, $be79a52cbffa2be6$export$f32f6ef648fb680f)((s)=>s.stop);
    return (0, $36464e4be8053fb8$export$fbeb804c371ac8d)(async (file)=>{
        if (file) {
            start();
            try {
                const formData = new FormData();
                formData.append('file', file);
                formData.append('shortDescription', file.name);
                formData.append('relatedEntityId', invite.id);
                formData.append('type', 'Other');
                formData.append('isConfidential', true);
                const data = await (0, $56ff6b9a4ee43a2e$export$644d8ea042df96a6).auth.post('attachment/upload', {
                    body: formData
                }).json();
                if (data?.attachmentId) {
                    addAttachment({
                        attachmentId: data.attachmentId,
                        fileName: data.originalFileName ?? file.name,
                        contentType: data.contentType,
                        shortDescription: ''
                    });
                    return data.attachmentId;
                }
            } catch (error) {
                throw (0, $ad23f5e3326fb0ee$export$547fac850f50d49b)(error, 'errors.uploadFailed.title', 'errors.uploadFailed.details');
            } finally{
                stop();
            }
        }
        return null;
    });
}






// eslint-disable-next-line import/no-unresolved




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $49495919e62ceb0a$var$XCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.28 7.22a.75.75 0 0 0-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 1 0 1.06 1.06L10 11.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L11.06 10l1.72-1.72a.75.75 0 0 0-1.06-1.06L10 8.94 8.28 7.22Z",
        clipRule: "evenodd"
    }));
}
const $49495919e62ceb0a$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($49495919e62ceb0a$var$XCircleIcon);
var $49495919e62ceb0a$export$2e2bcd8739ae039 = $49495919e62ceb0a$var$ForwardRef;



function $e0e8e1d0cade1129$export$915e9e7bd4f0f96d({ title: title, details: details, className: className }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('text-sm mb-5 p-4 flex gap-3 bg-error-50 text-error-500 rounded-md', className),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49495919e62ceb0a$export$2e2bcd8739ae039), {
                className: "size-5 min-w-5 min-h-5 text-error-400"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mb-1 font-medium",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-error-700 *:pl-4 *:list-disc",
                        children: details
                    })
                ]
            })
        ]
    });
}


function $7ba541db038d3dda$var$useLatestNonEmpty(next) {
    const latestRef = (0, $acw62.useRef)(next);
    (0, $acw62.useEffect)(()=>{
        if (next && next !== latestRef.current) latestRef.current = next;
    }, [
        next
    ]);
    return latestRef.current;
}
function $7ba541db038d3dda$export$5f71c1e53eaf1d93({ error: error }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4), {
        show: !!error,
        enter: "transition-opacity duration-150",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "transition-opacity duration-150",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0e8e1d0cade1129$export$915e9e7bd4f0f96d), {
            title: t(error?.title, {
                ns: 'common'
            }),
            details: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                i18nKey: error?.details,
                ns: "common",
                components: {
                    ul: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {}),
                    li: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {})
                },
                values: (0, $22c4bfea680558f2$export$2e2bcd8739ae039)
            }),
            className: "!mb-2.5"
        })
    });
}







const $f083286d9aeac6ed$var$manualSchema = $09193e81812ba154$export$be5493f9613cbbe({
    name: $09193e81812ba154$export$22b082955e083ec3().min(1),
    dose: $09193e81812ba154$export$22b082955e083ec3().min(1),
    frequency: $09193e81812ba154$export$22b082955e083ec3().min(1)
});
const $f083286d9aeac6ed$export$4902baddc787debb = $09193e81812ba154$export$be5493f9613cbbe({
    medicationsConfirmed: $09193e81812ba154$export$c8ec6e1ec9fefcb0(true),
    medicationsManual: $09193e81812ba154$export$2f23118c22fb2630($f083286d9aeac6ed$var$manualSchema).default([])
});
function $f083286d9aeac6ed$var$extractDefaults({ medicationsManual: medicationsManual }) {
    return {
        medicationsConfirmed: true,
        medicationsManual: medicationsManual ?? []
    };
}
function $f083286d9aeac6ed$var$transformValues({ medicationsManual: medicationsManual }) {
    return {
        medicationsConfirmed: true,
        medicationsManual: medicationsManual
    };
}
const $f083286d9aeac6ed$var$fileTypes = [
    'PNG',
    'JPG',
    'GIF',
    'PDF'
];
const $f083286d9aeac6ed$var$fileExtensions = $f083286d9aeac6ed$var$fileTypes.slice(0, -1).join(', ');
const $f083286d9aeac6ed$var$fileExtension = $f083286d9aeac6ed$var$fileTypes.at(-1);
const $f083286d9aeac6ed$var$fileMaxSize = 10;
function $f083286d9aeac6ed$export$2868d2a917920a44(props) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.medications');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dea25ad601eb8263$export$70aabb5da7e125f8), {
        nextPath: props.next.path,
        extractDefaults: $f083286d9aeac6ed$var$extractDefaults,
        transformValues: $f083286d9aeac6ed$var$transformValues,
        schema: $f083286d9aeac6ed$export$4902baddc787debb,
        markVisited: props.currentStepKey,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4777412ac24f8fdf$export$8becf861e7fda17d), {
            ...props,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "title",
                    children: t('title')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    i18nKey: "text",
                    ns: "page.medications",
                    components: {
                        p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {})
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3a5daec5db3bdecd$export$2c396862c514d9b4), {
                    className: "!pt-2.5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                            i18nKey: "uploadText",
                            ns: "page.medications",
                            components: {
                                p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mb-2.5 last:mb-0"
                                }),
                                strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    className: "block mb-2.5 font-semibold"
                                })
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f083286d9aeac6ed$var$UploadAttachment, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f083286d9aeac6ed$var$InviteAttachments, {})
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3a5daec5db3bdecd$export$2c396862c514d9b4), {
                    className: "!pt-2.5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                            i18nKey: "manuallyText",
                            ns: "page.medications",
                            components: {
                                p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mb-2.5 last:mb-0"
                                }),
                                strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    className: "block mb-2.5 font-semibold"
                                })
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdb72c6a66849198$export$8651306a9173292d), {
                            fieldArrayName: "medicationsManual",
                            ItemComponent: $f083286d9aeac6ed$var$ManualMedication,
                            showFromButtonLabel: t('addButtonLabel'),
                            FormComponent: $f083286d9aeac6ed$var$ManualMedicationForm
                        })
                    ]
                })
            ]
        })
    });
}
function $f083286d9aeac6ed$var$ManualMedication({ item: item }) {
    const { name: name, dose: dose, frequency: frequency } = item;
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.medications');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "px-2.5 flex flex-col items-start",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "block mb-2 font-medium",
                children: name
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "caption",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: dose
                    }),
                    " \u2022 ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: t(`select.${frequency}`)
                    })
                ]
            })
        ]
    });
}
function $f083286d9aeac6ed$var$ManualMedicationForm({ onAdd: onAdd }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.medications');
    const { append: append } = (0, $0d70f179cf56e662$export$310131896651d559)({
        name: 'medicationsManual'
    });
    const form = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        defaultValues: {
            name: '',
            dose: '',
            frequency: ''
        },
        resolver: (0, $0591fe66d7f046a7$export$66b7b5879c70f722)($f083286d9aeac6ed$var$manualSchema)
    });
    const { isValid: isValid } = form.formState;
    const frequencyOptions = (0, $acw62.useMemo)(()=>[
            {
                value: 'once-daily',
                label: t('select.once-daily')
            },
            {
                value: 'twice-daily',
                label: t('select.twice-daily')
            },
            {
                value: 'three-time-daily',
                label: t('select.three-time-daily')
            },
            {
                value: 'as-needed',
                label: t('select.as-needed')
            }
        ], [
        t
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
        ...form,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                    name: "name",
                    label: t('medicationName'),
                    placeholder: t('medicationPlaceholder')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                    name: "dose",
                    label: t('dose'),
                    placeholder: t('dosePlaceholder')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4cd9875607f3fe92$export$ef9b1a59e592288f), {
                    name: "frequency",
                    options: frequencyOptions,
                    label: t('frequency')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f563c890ed38cb6$export$353f5b6fc5456de1), {
                    type: "button",
                    variant: "primary-light",
                    onClick: form.handleSubmit((values)=>{
                        append(values);
                        form.reset();
                        onAdd();
                    }),
                    disabled: !isValid,
                    children: t('saveButton')
                })
            ]
        })
    });
}
function $f083286d9aeac6ed$var$UploadAttachment() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.medications');
    const { error: error, execute: execute } = (0, $8a71ab2ff7b7c045$export$f7a61246b71a5a37)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ba541db038d3dda$export$5f71c1e53eaf1d93), {
                error: error
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $103feeda949e48d9$export$1a5cb5295a7d2749), {
                classes: "group my-5 flex flex-col items-center p-5.5 pb-6.5 w-full border-2 border-dashed border-light-300 text-center rounded-md transition-colors hover:border-primary",
                //multiple
                types: $f083286d9aeac6ed$var$fileTypes,
                handleChange: (file)=>{
                    execute(file);
                },
                name: "file",
                hoverTitle: t('dropHere'),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5327f1caa0f7e754$export$2e2bcd8739ae039), {
                        "aria-hidden": "true",
                        className: "mb-1 text-light-400 transition-colors group-hover:text-primary"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        i18nKey: "dropTitle",
                        ns: "page.medications",
                        components: {
                            p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mb-1 last:mb-0 font-medium text-light-600"
                            }),
                            strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-primary"
                            })
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        i18nKey: "dropText",
                        ns: "page.medications",
                        values: {
                            fileExtensions: $f083286d9aeac6ed$var$fileExtensions,
                            fileExtension: $f083286d9aeac6ed$var$fileExtension,
                            mb: $f083286d9aeac6ed$var$fileMaxSize
                        },
                        components: {
                            p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-small font-normal"
                            })
                        }
                    })
                ]
            })
        ]
    });
}
function $f083286d9aeac6ed$var$InviteAttachments() {
    const { invite: invite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    const cards = (0, $acw62.useMemo)(()=>invite.attachments.map((attachment)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4), {
                show: true,
                appear: true,
                enter: "transition-opacity duration-150",
                enterFrom: "opacity-0",
                enterTo: "opacity-100",
                leave: "transition-opacity duration-150",
                leaveFrom: "opacity-100",
                leaveTo: "opacity-0",
                as: "li",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f083286d9aeac6ed$var$InviteAttachmentCard, {
                    attachment: attachment
                })
            }, attachment.attachmentId)), [
        invite.attachments
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
        className: "relative z-1 py-2.5 space-y-2.5 empty:hidden before:absolute before:-z-1 before:top-0 before:left-[-99999px] before:right-[-99999px] before:bottom-0 before:bg-gray-100",
        children: cards
    });
}
function $f083286d9aeac6ed$var$InviteAttachmentCard({ attachment: attachment }) {
    const { loading: loading, execute: execute } = (0, $9098887a59a3a10b$export$50cc34fc3f08cd74)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8761de775eed7565$export$ea72572e99d27ad1), {
        trashCard: true,
        disabled: loading,
        onClick: ()=>execute(attachment.attachmentId),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ce71fbb17d37306$export$2e2bcd8739ae039), {
                className: "text-light-500"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                className: "font-medium text-base text-body-dark",
                children: attachment.fileName
            })
        ]
    });
}


// eslint-disable-next-line import/no-unresolved










const $20353a70181b599c$var$schema = $09193e81812ba154$export$be5493f9613cbbe({
    acceptedPrivacy: $09193e81812ba154$export$c8ec6e1ec9fefcb0(true)
});
function $20353a70181b599c$var$extractDefaults({ acceptedPrivacy: acceptedPrivacy = false }) {
    return {
        acceptedPrivacy: acceptedPrivacy
    };
}
function $20353a70181b599c$var$transformValues({ acceptedPrivacy: acceptedPrivacy }) {
    return {
        acceptedPrivacy: acceptedPrivacy
    };
}
function $20353a70181b599c$export$c5c352a5595119a5(props) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.privacy');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dea25ad601eb8263$export$70aabb5da7e125f8), {
        extractDefaults: $20353a70181b599c$var$extractDefaults,
        transformValues: $20353a70181b599c$var$transformValues,
        schema: $20353a70181b599c$var$schema,
        nextPath: props.next.path,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4777412ac24f8fdf$export$8becf861e7fda17d), {
            ...props,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "title",
                    children: t('title')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    i18nKey: "text",
                    ns: "page.privacy",
                    components: {
                        p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {})
                    },
                    values: {
                        company: (0, $22c4bfea680558f2$export$2e2bcd8739ae039).company
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3a5daec5db3bdecd$export$2c396862c514d9b4), {
                    className: "mb-2.5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "subtitle mb-0",
                            children: t('privacyText')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                            i18nKey: "privacyDetails",
                            ns: "page.privacy",
                            values: (0, $22c4bfea680558f2$export$2e2bcd8739ae039),
                            components: {
                                ul: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                    className: "pl-6 list-disc"
                                }),
                                li: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {})
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ff38c73dbe0e7492$export$48513f6b9f8ce62d), {
                    name: "acceptedPrivacy",
                    label: t('privacyLabel')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c17aead7dd77426$export$8b7b7cdfb85d78c5), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a5daec5db3bdecd$export$2c396862c514d9b4), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        i18nKey: "helpMessage",
                        ns: "page.privacy",
                        values: {
                            phone: (0, $22c4bfea680558f2$export$2e2bcd8739ae039).phone
                        },
                        components: {
                            h3: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "subtitle mb-0"
                            }),
                            p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
                            br: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "font-semibold"
                            }),
                            a: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: `tel:${(0, $8b1710acf92137fb$export$96e99d0e61df2702)((0, $22c4bfea680558f2$export$2e2bcd8739ae039).phone)}`
                            })
                        }
                    })
                })
            ]
        })
    });
}







const $97fc6752ecb46d7d$var$schema = $09193e81812ba154$export$be5493f9613cbbe({
    healthQuestionsStarted: $09193e81812ba154$export$c8ec6e1ec9fefcb0(true)
});
function $97fc6752ecb46d7d$var$extractDefaults() {
    return {
        healthQuestionsStarted: true
    };
}
function $97fc6752ecb46d7d$var$transformValues({ healthQuestionsStarted: healthQuestionsStarted }) {
    return {
        healthQuestionsStarted: healthQuestionsStarted
    };
}
function $97fc6752ecb46d7d$export$e07f43ef0917fbb1(props) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.health-questions');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dea25ad601eb8263$export$70aabb5da7e125f8), {
        extractDefaults: $97fc6752ecb46d7d$var$extractDefaults,
        transformValues: $97fc6752ecb46d7d$var$transformValues,
        schema: $97fc6752ecb46d7d$var$schema,
        nextPath: props.next.path,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4777412ac24f8fdf$export$8becf861e7fda17d), {
            ...props,
            className: "bg-primary-50",
            headerClassName: "border-b-0",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "title mb-7.5 pt-1",
                    children: t('title')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    i18nKey: "text",
                    ns: "page.health-questions",
                    components: {
                        p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
                        strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "font-semibold"
                        })
                    }
                })
            ]
        })
    });
}









const $ff838d01b275bfeb$export$4902baddc787debb = $09193e81812ba154$export$be5493f9613cbbe({
    specialistId: $09193e81812ba154$export$22b082955e083ec3().min(1)
});
function $ff838d01b275bfeb$var$extractDefaults({ specialistId: specialistId }, invite) {
    return {
        specialistId: specialistId ?? (invite.practitioners.length === 1 ? invite.practitioners[0].practitionerId : 'any')
    };
}
function $ff838d01b275bfeb$var$transformValues({ specialistId: specialistId }) {
    return {
        specialistId: specialistId
    };
}
function $ff838d01b275bfeb$export$3f0c04588a474830(props) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)([
        'page.specialist'
    ]);
    const invite = (0, $e89436abf76c6f63$export$a7ae4cbf178a6bca)();
    const isSingleSpecialist = invite.practitioners.length === 1;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dea25ad601eb8263$export$70aabb5da7e125f8), {
        extractDefaults: $ff838d01b275bfeb$var$extractDefaults,
        transformValues: $ff838d01b275bfeb$var$transformValues,
        schema: $ff838d01b275bfeb$export$4902baddc787debb,
        nextPath: props.next.path,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4777412ac24f8fdf$export$8becf861e7fda17d), {
            ...props,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "title",
                    children: t(isSingleSpecialist ? 'titleSingle' : 'titleMultiple')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    i18nKey: isSingleSpecialist ? 'textSingle' : 'textMultiple',
                    t: t,
                    values: invite,
                    components: {
                        p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
                        h3: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "subtitle mb-0"
                        })
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "group/specialists",
                    "data-single-specialist": isSingleSpecialist,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d212ba9d073a953d$export$68890f054db6efff), {
                            name: "specialistId"
                        }),
                        invite.practitioners.filter((practitioner)=>practitioner.calendarSlots?.length > 0).map((specialist)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d212ba9d073a953d$export$206da70a2aa39f33), {
                                name: "specialistId",
                                specialist: specialist
                            }, specialist.practitionerId))
                    ]
                })
            ]
        })
    });
}


// eslint-disable-next-line import/no-unresolved





var $acw62 = parcelRequire("acw62");






function $e1f233760eb691e5$export$fc128d59c1aec892(options) {
    const { invite: invite, setInvite: setInvite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    return (0, $36464e4be8053fb8$export$fbeb804c371ac8d)(async ({ declineReason: declineReason })=>{
        await (0, $56ff6b9a4ee43a2e$export$644d8ea042df96a6).auth.post('onlinebooking/decline-booking', {
            json: {
                bookingReference: invite.reference,
                statusReasonDescription: declineReason
            }
        });
        setInvite({
            status: (0, $9dfc7fe3975de14a$export$8dffa4efb9fbc37b).CANCELLED
        });
    }, options);
}








var $acw62 = parcelRequire("acw62");
function $47cc6c221cb514b0$var$PauseCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM9 8.25a.75.75 0 0 0-.75.75v6c0 .414.336.75.75.75h.75a.75.75 0 0 0 .75-.75V9a.75.75 0 0 0-.75-.75H9Zm5.25 0a.75.75 0 0 0-.75.75v6c0 .414.336.75.75.75H15a.75.75 0 0 0 .75-.75V9a.75.75 0 0 0-.75-.75h-.75Z",
        clipRule: "evenodd"
    }));
}
const $47cc6c221cb514b0$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($47cc6c221cb514b0$var$PauseCircleIcon);
var $47cc6c221cb514b0$export$2e2bcd8739ae039 = $47cc6c221cb514b0$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $425bcacc5e6c16fd$var$PlayCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm14.024-.983a1.125 1.125 0 0 1 0 1.966l-5.603 3.113A1.125 1.125 0 0 1 9 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113Z",
        clipRule: "evenodd"
    }));
}
const $425bcacc5e6c16fd$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($425bcacc5e6c16fd$var$PlayCircleIcon);
var $425bcacc5e6c16fd$export$2e2bcd8739ae039 = $425bcacc5e6c16fd$var$ForwardRef;



var $acw62 = parcelRequire("acw62");
const $39c9b1f63509fe43$var$MUX_ENV_KEY = 'jue9kicinbhtv6qg94hb4c1mc';
const $39c9b1f63509fe43$export$7da5300bbf831ceb = ({ playbackId: playbackId, caption: caption })=>{
    const ref = (0, $acw62.useRef)(null);
    const [playbackState, setPlaybackState] = (0, $acw62.useState)('paused');
    (0, $acw62.useEffect)(()=>{
        const handler = (event)=>{
            switch(event.type){
                case 'play':
                case 'playing':
                    setPlaybackState('playing');
                    break;
                case 'pause':
                case 'ended':
                case 'error':
                    setPlaybackState('paused');
                    break;
            }
        };
        const element = ref.current;
        if (ref) {
            element.addEventListener('ended', handler);
            element.addEventListener('error', handler);
            element.addEventListener('pause', handler);
            element.addEventListener('play', handler);
            element.addEventListener('playing', handler);
            return ()=>{
                element.removeEventListener('ended', handler);
                element.removeEventListener('error', handler);
                element.removeEventListener('pause', handler);
                element.removeEventListener('play', handler);
                element.removeEventListener('playing', handler);
            };
        }
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("figure", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative group rounded-lg overflow-hidden w-full aspect-video bg-gray-100",
                "data-playback-state": playbackState,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mux-video", {
                        ref: ref,
                        "playback-id": playbackId,
                        "env-key": $39c9b1f63509fe43$var$MUX_ENV_KEY,
                        "disable-tracking": true,
                        "disable-cookies": true,
                        disablePictureInPicture: true,
                        onClick: ()=>{
                            if (ref.current.paused || ref.current.ended) ref.current.play();
                            else ref.current.pause();
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $425bcacc5e6c16fd$export$2e2bcd8739ae039), {
                        className: "absolute pointer-events-none top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 aspect-square h-1/5 text-white group-hover:scale-110 transition-transform hidden group-data-[playback-state=paused]:block"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $47cc6c221cb514b0$export$2e2bcd8739ae039), {
                        className: "absolute pointer-events-none top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 aspect-square h-1/5 text-white opacity-0 group-hover:opacity-100 transition-opacity hidden group-data-[playback-state=playing]:block"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("figcaption", {
                className: "caption italic",
                children: caption
            })
        ]
    });
};





const $1bd4c2a737e932dd$var$resolver = (0, $0591fe66d7f046a7$export$66b7b5879c70f722)($09193e81812ba154$export$be5493f9613cbbe({
    declineReason: $09193e81812ba154$export$22b082955e083ec3().min(1)
}));
const $1bd4c2a737e932dd$var$acceptInviteSchema = $09193e81812ba154$export$be5493f9613cbbe({
    acceptedInvite: $09193e81812ba154$export$4a21f16c33752377().refine((x)=>x === true)
});
function $1bd4c2a737e932dd$var$extractDefaults() {
    return {
        acceptedInvite: true
    };
}
function $1bd4c2a737e932dd$var$transformValues() {
    return {
        acceptedInvite: true
    };
}
function $1bd4c2a737e932dd$export$568b89e600fc77eb({ next: next }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)([
        'page.start',
        'page.specialist'
    ]);
    const invite = (0, $e89436abf76c6f63$export$a7ae4cbf178a6bca)();
    const declineInvite = (0, $e1f233760eb691e5$export$fc128d59c1aec892)();
    const form = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        defaultValues: {
            declineReason: ''
        },
        resolver: $1bd4c2a737e932dd$var$resolver
    });
    const procedurePlaybackId = $1bd4c2a737e932dd$var$useInviteVideoPlaybackId(invite);
    const declineOptions = (0, $acw62.useMemo)(()=>[
            {
                value: 'didnt-know-referred',
                label: t('select.didntKnowReferred')
            },
            {
                value: 'had-elsewhere',
                label: t('select.hadElsewhere')
            },
            {
                value: 'cant-afford',
                label: t('select.cantAfford')
            },
            {
                value: 'bad-timing',
                label: t('select.badTiming')
            },
            {
                value: 'not-necessary',
                label: t('select.notNecessary')
            }
        ], [
        t
    ]);
    const onSubmit = (0, $acw62.useCallback)(async (formFields)=>{
        await declineInvite.execute(formFields);
    }, [
        declineInvite
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $05fc0a4d0e875da9$export$c349430af49f3c78), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "title",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    i18nKey: "title",
                    ns: "page.start",
                    values: invite,
                    components: {
                        br: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {})
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                i18nKey: invite.practitioners.length > 1 ? 'textNoSpecialist' : 'text',
                t: t,
                values: invite,
                components: {
                    p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mb-5"
                    }),
                    strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "font-semibold"
                    })
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3a5daec5db3bdecd$export$2c396862c514d9b4), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        i18nKey: "info",
                        t: t,
                        components: {
                            p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
                            h3: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "subtitle mb-0"
                            })
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39c9b1f63509fe43$export$7da5300bbf831ceb), {
                        playbackId: procedurePlaybackId,
                        caption: t('videoCaption')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3a5daec5db3bdecd$export$2c396862c514d9b4), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        i18nKey: "bookText",
                        t: t,
                        components: {
                            ul: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "mb-4"
                            }),
                            li: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                className: "mt-0.5"
                            }),
                            h3: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "subtitle mb-0"
                            }),
                            strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "font-semibold"
                            })
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dea25ad601eb8263$export$70aabb5da7e125f8), {
                        extractDefaults: $1bd4c2a737e932dd$var$extractDefaults,
                        transformValues: $1bd4c2a737e932dd$var$transformValues,
                        schema: $1bd4c2a737e932dd$var$acceptInviteSchema,
                        nextPath: next.path,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c17aead7dd77426$export$8b7b7cdfb85d78c5), {
                            label: t('bookButtonLabel')
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a5daec5db3bdecd$export$2c396862c514d9b4), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    i18nKey: "declineText",
                    t: t,
                    components: {
                        h3: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "subtitle mb-0"
                        }),
                        p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {})
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
                ...form,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    onSubmit: form.handleSubmit(onSubmit),
                    className: "pt-2.5 space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4cd9875607f3fe92$export$ef9b1a59e592288f), {
                            name: "declineReason",
                            options: declineOptions,
                            ns: "page.start",
                            placement: "top",
                            placeholder: t('select.placeholder')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4), {
                            show: form.formState.isValid,
                            enter: "transition-opacity duration-150",
                            enterFrom: "opacity-0",
                            enterTo: "opacity-100",
                            leave: "transition-opacity duration-150",
                            leaveFrom: "opacity-100",
                            leaveTo: "opacity-0",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c17aead7dd77426$export$8b7b7cdfb85d78c5), {
                                label: t('declineButtonLabel'),
                                variant: "outlined"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a5daec5db3bdecd$export$2c396862c514d9b4), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    i18nKey: "helpMessage",
                    t: t,
                    values: {
                        phone: (0, $22c4bfea680558f2$export$2e2bcd8739ae039).phone
                    },
                    components: {
                        h3: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "subtitle mb-0"
                        }),
                        p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
                        br: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "font-semibold"
                        }),
                        a: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: `tel:${(0, $8b1710acf92137fb$export$96e99d0e61df2702)((0, $22c4bfea680558f2$export$2e2bcd8739ae039).phone)}`
                        })
                    }
                })
            })
        ]
    });
}
function $1bd4c2a737e932dd$var$useInviteVideoPlaybackId(invite) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.start');
    const procedurePackageGroupCode = invite.procedure?.groupCode ?? 'unknown';
    return (0, $acw62.useMemo)(()=>t([
            `videos.${procedurePackageGroupCode.toLowerCase()}`,
            'videos.fallback'
        ]), [
        procedurePackageGroupCode,
        t
    ]);
}




const $719afc6b1355ea07$export$be3f796aed065412 = [
    {
        path: 'start',
        component: (0, $1bd4c2a737e932dd$export$568b89e600fc77eb),
        done: ({ acceptedInvite: acceptedInvite, acceptedPrivacy: acceptedPrivacy })=>acceptedInvite || acceptedPrivacy,
        props: {
            progress: 0.05
        }
    },
    {
        path: 'privacy',
        component: (0, $20353a70181b599c$export$c5c352a5595119a5),
        done: ({ acceptedPrivacy: acceptedPrivacy })=>acceptedPrivacy,
        props: {
            showMenu: false,
            progress: 0.1
        }
    },
    {
        path: 'specialist',
        component: (0, $ff838d01b275bfeb$export$3f0c04588a474830),
        done: ({ specialistId: specialistId })=>!!specialistId,
        props: {
            progress: 0.15
        }
    },
    {
        path: 'appointment',
        component: (0, $b0d33fd2456c63c3$export$17c88b0571a3c569),
        done: (_, invite)=>!!invite.appointment,
        props: {
            progress: 0.2
        }
    },
    {
        path: 'appointment-reserved',
        component: (0, $0c1f89caa70a7fa7$export$6627cb344363e02e),
        done: ({ contactConsent: contactConsent })=>typeof contactConsent === 'boolean',
        props: {
            progress: 0.25
        }
    },
    {
        path: 'name-birthdate',
        namespace: 'page.details',
        nextLabel: 'page.details:name-birthdate.nextLabel',
        component: (0, $fc63a763a2a1732b$export$842f6d7d17990d8c),
        done: ({ patient: patient })=>!!patient?.namePrefix && !!patient?.nameGiven && !!patient?.nameFamily && !!patient?.namePreferred && !!patient?.dateOfBirth,
        props: {
            progress: 0.3
        }
    },
    {
        path: 'nhi-residency',
        namespace: 'step.details',
        nextLabel: 'page.details:nhi-residency.nextLabel',
        component: (0, $490a6c7f73f3c708$export$47b580cadca596de),
        done: ({ patient: patient })=>typeof patient?.isResident === 'boolean',
        props: {
            progress: 0.35
        }
    },
    {
        path: 'home-address',
        namespace: 'step.details',
        nextLabel: 'page.details:home-address.nextLabel',
        component: (0, $1afa35ca37f2466a$export$4adf321e56356701),
        done: ({ patient: patient })=>!!patient?.address,
        props: {
            progress: 0.4
        }
    },
    {
        path: 'contact-details',
        namespace: 'step.details',
        nextLabel: 'page.details:contact-details.nextLabel',
        component: (0, $59c33553cf03104d$export$b9d767bd38ad68e1),
        done: ({ patient: patient })=>!!patient?.email && !!patient?.mobileNumber,
        props: {
            progress: 0.425
        }
    },
    {
        key: 'doctor',
        path: 'doctor',
        namespace: 'step.details',
        nextLabel: 'page.details:doctor.nextLabel',
        component: (0, $31bea2dc1a8c2f4b$export$b6a3594f6594322),
        done: ({ gp: gp, medicalCentre: medicalCentre })=>!!gp && !!medicalCentre,
        props: {
            progress: 0.5
        }
    },
    {
        path: 'emergency',
        namespace: 'step.details',
        nextLabel: 'page.details:emergency.nextLabel',
        component: (0, $5466c574d62e24d0$export$b692444947d69bd1),
        done: ({ emergency: emergency })=>!!emergency?.fullName && !!emergency?.relationship && !!emergency?.mobileNumber,
        props: {
            progress: 0.475
        }
    },
    {
        path: 'insurance',
        component: (0, $9d60da8c1cf04df5$export$56ad944ccf4d3da9),
        done: ({ insurance: insurance })=>!!insurance?.termsAccepted,
        props: {
            progress: 0.49
        }
    },
    {
        path: 'health-questions',
        component: (0, $97fc6752ecb46d7d$export$e07f43ef0917fbb1),
        done: ({ healthQuestionsStarted: healthQuestionsStarted })=>healthQuestionsStarted,
        props: {
            progress: 0.5
        }
    },
    ...(0, $e5c7a076ba516446$export$64e7b4513fce920),
    {
        path: 'medications',
        component: (0, $f083286d9aeac6ed$export$2868d2a917920a44),
        done: ({ medicationsConfirmed: medicationsConfirmed })=>!!medicationsConfirmed,
        props: {
            progress: 0.6
        }
    },
    {
        path: 'history',
        component: (0, $29e8ff095de49e68$export$84202caead5689ba),
        done: ({ proceduresManual: proceduresManual })=>Array.isArray(proceduresManual),
        props: {
            progress: 0.6
        }
    },
    ...(0, $403b1d2dd4bc76fe$export$b789f320c0d06368),
    {
        path: 'confirmation',
        progress: 1,
        component: (0, $2cfbcce25e145fc6$export$41b6293a43d01328),
        done: ()=>false
    }
];
function $719afc6b1355ea07$export$3ba3bdeb1afab63a(progress = (0, $2bd9d04ce55ef2a0$export$253fab909bb52269), invite) {
    return $719afc6b1355ea07$export$be3f796aed065412.find((step)=>typeof step.done === 'function' ? !step.done(progress, invite) : false);
}


const $673ff3dfc4a496de$var$isString = (obj)=>typeof obj === 'string';
const $673ff3dfc4a496de$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $673ff3dfc4a496de$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $673ff3dfc4a496de$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $673ff3dfc4a496de$var$lastOfPathSeparatorRegExp = /###/g;
const $673ff3dfc4a496de$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($673ff3dfc4a496de$var$lastOfPathSeparatorRegExp, '.') : key;
const $673ff3dfc4a496de$var$canNotTraverseDeeper = (object)=>!object || $673ff3dfc4a496de$var$isString(object);
const $673ff3dfc4a496de$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$673ff3dfc4a496de$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($673ff3dfc4a496de$var$canNotTraverseDeeper(object)) return {};
        const key = $673ff3dfc4a496de$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($673ff3dfc4a496de$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $673ff3dfc4a496de$var$cleanKey(stack[stackIndex])
    };
};
const $673ff3dfc4a496de$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $673ff3dfc4a496de$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $673ff3dfc4a496de$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $673ff3dfc4a496de$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $673ff3dfc4a496de$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
};
const $673ff3dfc4a496de$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $673ff3dfc4a496de$var$getPath(data, key);
    if (value !== undefined) return value;
    return $673ff3dfc4a496de$var$getPath(defaultData, key);
};
const $673ff3dfc4a496de$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($673ff3dfc4a496de$var$isString(target[prop]) || target[prop] instanceof String || $673ff3dfc4a496de$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $673ff3dfc4a496de$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $673ff3dfc4a496de$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $673ff3dfc4a496de$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $673ff3dfc4a496de$var$escape = (data)=>{
    if ($673ff3dfc4a496de$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$673ff3dfc4a496de$var$_entityMap[s]);
    return data;
};
class $673ff3dfc4a496de$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $673ff3dfc4a496de$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $673ff3dfc4a496de$var$looksLikeObjectPathRegExpCache = new $673ff3dfc4a496de$var$RegExpCache(20);
const $673ff3dfc4a496de$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $673ff3dfc4a496de$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $673ff3dfc4a496de$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $673ff3dfc4a496de$var$deepFind = function(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $673ff3dfc4a496de$var$getCleanedCode = (code)=>code?.replace('_', '-');
const $673ff3dfc4a496de$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $673ff3dfc4a496de$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $673ff3dfc4a496de$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, 'log', '', true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, 'warn', '', true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, 'error', '');
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($673ff3dfc4a496de$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $673ff3dfc4a496de$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $673ff3dfc4a496de$var$Logger(this.logger, options);
    }
}
var $673ff3dfc4a496de$var$baseLogger = new $673ff3dfc4a496de$var$Logger();
class $673ff3dfc4a496de$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach((_ref)=>{
                let [observer, numTimesAdded] = _ref;
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach((_ref2)=>{
                let [observer, numTimesAdded] = _ref2;
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class $673ff3dfc4a496de$var$ResourceStore extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($673ff3dfc4a496de$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $673ff3dfc4a496de$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$673ff3dfc4a496de$var$isString(key)) return result;
        return $673ff3dfc4a496de$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $673ff3dfc4a496de$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if ($673ff3dfc4a496de$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false,
            skipCopy: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $673ff3dfc4a496de$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $673ff3dfc4a496de$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $673ff3dfc4a496de$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $673ff3dfc4a496de$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options, translator) ?? value;
        });
        return value;
    }
};
const $673ff3dfc4a496de$var$checkedLoadedFor = {};
class $673ff3dfc4a496de$var$Translator extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $673ff3dfc4a496de$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved?.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $673ff3dfc4a496de$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $673ff3dfc4a496de$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === 'object') options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return '';
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = !$673ff3dfc4a496de$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !($673ff3dfc4a496de$var$isString(joinArrays) && Array.isArray(res))) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(res);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $673ff3dfc4a496de$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && !$673ff3dfc4a496de$var$isString(options.count);
            const hasDefaultValue = $673ff3dfc4a496de$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : '';
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0;
            const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, options);
                        if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = $673ff3dfc4a496de$var$isString(res) && (options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && !$673ff3dfc4a496de$var$isString(options.replace) ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language || resolved.usedLng, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && resolved && resolved.res) options.lng = this.language || resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey?.[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = $673ff3dfc4a496de$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames?.length && options.applyPostProcessor !== false) res = $673ff3dfc4a496de$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(options)
            },
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($673ff3dfc4a496de$var$isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && !$673ff3dfc4a496de$var$isString(options.count);
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0;
            const needsContextHandling = options.context !== undefined && ($673ff3dfc4a496de$var$isString(options.context) || typeof options.context === 'number') && options.context !== '';
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$673ff3dfc4a496de$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    $673ff3dfc4a496de$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$673ff3dfc4a496de$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
class $673ff3dfc4a496de$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($673ff3dfc4a496de$var$isString(code) && code.indexOf('-') > -1) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($673ff3dfc4a496de$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($673ff3dfc4a496de$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($673ff3dfc4a496de$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
const $673ff3dfc4a496de$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $673ff3dfc4a496de$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $673ff3dfc4a496de$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const cleanedCode = $673ff3dfc4a496de$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (!Intl) {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $673ff3dfc4a496de$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $673ff3dfc4a496de$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$673ff3dfc4a496de$var$suffixesOrder[pluralCategory1] - $673ff3dfc4a496de$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
}
const $673ff3dfc4a496de$var$deepFindWithDefaults = function(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $673ff3dfc4a496de$var$isString(key)) {
        path = $673ff3dfc4a496de$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $673ff3dfc4a496de$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $673ff3dfc4a496de$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $673ff3dfc4a496de$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options?.interpolation?.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $673ff3dfc4a496de$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $673ff3dfc4a496de$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $673ff3dfc4a496de$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $673ff3dfc4a496de$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $673ff3dfc4a496de$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $673ff3dfc4a496de$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $673ff3dfc4a496de$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$673ff3dfc4a496de$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $673ff3dfc4a496de$var$regexSafe(this.escape(val)) : $673ff3dfc4a496de$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $673ff3dfc4a496de$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$673ff3dfc4a496de$var$isString(value) && !this.useRawValueToEscape) value = $673ff3dfc4a496de$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$673ff3dfc4a496de$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$673ff3dfc4a496de$var$isString(value)) return value;
            if (!$673ff3dfc4a496de$var$isString(value)) value = $673ff3dfc4a496de$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $673ff3dfc4a496de$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $673ff3dfc4a496de$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (val, lng, options)=>{
        let optForCache = options;
        if (options && options.interpolationkey && options.formatParams && options.formatParams[options.interpolationkey] && options[options.interpolationkey]) optForCache = {
            ...optForCache,
            [options.interpolationkey]: undefined
        };
        const key = lng + JSON.stringify(optForCache);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($673ff3dfc4a496de$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
};
class $673ff3dfc4a496de$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('formatter');
        this.options = options;
        this.formats = {
            number: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        this.formatSeparator = options.interpolation.formatSeparator || ',';
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $673ff3dfc4a496de$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $673ff3dfc4a496de$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options?.formatParams?.[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $673ff3dfc4a496de$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $673ff3dfc4a496de$var$Connector extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $673ff3dfc4a496de$var$pushPath(q.loaded, [
                lng
            ], ns);
            $673ff3dfc4a496de$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($673ff3dfc4a496de$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($673ff3dfc4a496de$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $673ff3dfc4a496de$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($673ff3dfc4a496de$var$isString(args[1])) ret.defaultValue = args[1];
            if ($673ff3dfc4a496de$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        }
    });
const $673ff3dfc4a496de$var$transformOptions = (options)=>{
    if ($673ff3dfc4a496de$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($673ff3dfc4a496de$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($673ff3dfc4a496de$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs?.indexOf?.('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    if (typeof options.initImmediate === 'boolean') options.initAsync = options.initImmediate;
    return options;
};
const $673ff3dfc4a496de$var$noop = ()=>{};
const $673ff3dfc4a496de$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $673ff3dfc4a496de$var$I18n extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $673ff3dfc4a496de$var$transformOptions(options);
        this.services = {};
        this.logger = $673ff3dfc4a496de$var$baseLogger;
        this.modules = {
            external: []
        };
        $673ff3dfc4a496de$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if ($673ff3dfc4a496de$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $673ff3dfc4a496de$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$673ff3dfc4a496de$var$transformOptions(options)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $673ff3dfc4a496de$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $673ff3dfc4a496de$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $673ff3dfc4a496de$var$Formatter;
            const lu = new $673ff3dfc4a496de$var$LanguageUtil(this.options);
            this.store = new $673ff3dfc4a496de$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $673ff3dfc4a496de$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $673ff3dfc4a496de$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $673ff3dfc4a496de$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $673ff3dfc4a496de$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $673ff3dfc4a496de$var$Translator(this.services, this.options);
            this.translator.on('*', function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $673ff3dfc4a496de$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
        let usedCallback = callback;
        const usedLng = $673ff3dfc4a496de$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $673ff3dfc4a496de$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $673ff3dfc4a496de$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit('languageChanged', l);
                this.logger.log('languageChanged', l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = $673ff3dfc4a496de$var$isString(lngs) ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== 'object') {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            if (options.keyPrefix !== '') options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || '.';
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if ($673ff3dfc4a496de$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.translator?.translate(...args);
    }
    exists() {
        for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($673ff3dfc4a496de$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if ($673ff3dfc4a496de$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $673ff3dfc4a496de$var$LanguageUtil($673ff3dfc4a496de$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $673ff3dfc4a496de$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $673ff3dfc4a496de$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $673ff3dfc4a496de$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $673ff3dfc4a496de$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', function(event) {
            for(var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)args[_key6 - 1] = arguments[_key6];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $673ff3dfc4a496de$export$2e2bcd8739ae039 = $673ff3dfc4a496de$var$I18n.createInstance();
$673ff3dfc4a496de$export$2e2bcd8739ae039.createInstance = $673ff3dfc4a496de$var$I18n.createInstance;
const $673ff3dfc4a496de$export$99152e8d49ca4e7d = $673ff3dfc4a496de$export$2e2bcd8739ae039.createInstance;
const $673ff3dfc4a496de$export$147ec2801e896265 = $673ff3dfc4a496de$export$2e2bcd8739ae039.dir;
const $673ff3dfc4a496de$export$2cd8252107eb640b = $673ff3dfc4a496de$export$2e2bcd8739ae039.init;
const $673ff3dfc4a496de$export$d3d08d944062d7e = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadResources;
const $673ff3dfc4a496de$export$a5d9bf5d83fcab09 = $673ff3dfc4a496de$export$2e2bcd8739ae039.reloadResources;
const $673ff3dfc4a496de$export$1f96ae73734a86cc = $673ff3dfc4a496de$export$2e2bcd8739ae039.use;
const $673ff3dfc4a496de$export$61465194746e7fd2 = $673ff3dfc4a496de$export$2e2bcd8739ae039.changeLanguage;
const $673ff3dfc4a496de$export$f90d180fc7da3b3b = $673ff3dfc4a496de$export$2e2bcd8739ae039.getFixedT;
const $673ff3dfc4a496de$export$625550452a3fa3ec = $673ff3dfc4a496de$export$2e2bcd8739ae039.t;
const $673ff3dfc4a496de$export$f7e9f41ea797a17 = $673ff3dfc4a496de$export$2e2bcd8739ae039.exists;
const $673ff3dfc4a496de$export$2b4b218e406d2d00 = $673ff3dfc4a496de$export$2e2bcd8739ae039.setDefaultNamespace;
const $673ff3dfc4a496de$export$93d9ee97c1ad3f31 = $673ff3dfc4a496de$export$2e2bcd8739ae039.hasLoadedNamespace;
const $673ff3dfc4a496de$export$83be934b53fff43b = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadNamespaces;
const $673ff3dfc4a496de$export$8cd7e7a54fa865bc = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadLanguages;


const { slice: $60196a4650e96cb1$var$slice, forEach: $60196a4650e96cb1$var$forEach } = [];
function $60196a4650e96cb1$var$defaults(obj) {
    $60196a4650e96cb1$var$forEach.call($60196a4650e96cb1$var$slice.call(arguments, 1), (source)=>{
        if (source) {
            for(const prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
const $60196a4650e96cb1$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
const $60196a4650e96cb1$var$serializeCookie = (name, val, options)=>{
    const opt = options || {};
    opt.path = opt.path || '/';
    const value = encodeURIComponent(val);
    let str = `${name}=${value}`;
    if (opt.maxAge > 0) {
        const maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += `; Max-Age=${Math.floor(maxAge)}`;
    }
    if (opt.domain) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += `; Domain=${opt.domain}`;
    }
    if (opt.path) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += `; Path=${opt.path}`;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += `; Expires=${opt.expires.toUTCString()}`;
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        const sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    return str;
};
const $60196a4650e96cb1$var$cookie = {
    create (name, value, minutes, domain) {
        let cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $60196a4650e96cb1$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read (name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove (name) {
        this.create(name, '', -1);
    }
};
var $60196a4650e96cb1$var$cookie$1 = {
    name: 'cookie',
    // Deconstruct the options object and extract the lookupCookie property
    lookup (_ref) {
        let { lookupCookie: lookupCookie } = _ref;
        if (lookupCookie && typeof document !== 'undefined') return $60196a4650e96cb1$var$cookie.read(lookupCookie) || undefined;
        return undefined;
    },
    // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
    cacheUserLanguage (lng, _ref2) {
        let { lookupCookie: lookupCookie, cookieMinutes: cookieMinutes, cookieDomain: cookieDomain, cookieOptions: cookieOptions } = _ref2;
        if (lookupCookie && typeof document !== 'undefined') $60196a4650e96cb1$var$cookie.create(lookupCookie, lng, cookieMinutes, cookieDomain, cookieOptions);
    }
};
var $60196a4650e96cb1$var$querystring = {
    name: 'querystring',
    // Deconstruct the options object and extract the lookupQuerystring property
    lookup (_ref) {
        let { lookupQuerystring: lookupQuerystring } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            let { search: search } = window.location;
            if (!window.location.search && window.location.hash?.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            const query = search.substring(1);
            const params = query.split('&');
            for(let i = 0; i < params.length; i++){
                const pos = params[i].indexOf('=');
                if (pos > 0) {
                    const key = params[i].substring(0, pos);
                    if (key === lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
let $60196a4650e96cb1$var$hasLocalStorageSupport = null;
const $60196a4650e96cb1$var$localStorageAvailable = ()=>{
    if ($60196a4650e96cb1$var$hasLocalStorageSupport !== null) return $60196a4650e96cb1$var$hasLocalStorageSupport;
    try {
        $60196a4650e96cb1$var$hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
        const testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasLocalStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasLocalStorageSupport;
};
var $60196a4650e96cb1$var$localStorage = {
    name: 'localStorage',
    // Deconstruct the options object and extract the lookupLocalStorage property
    lookup (_ref) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref;
        if (lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) return window.localStorage.getItem(lookupLocalStorage) || undefined; // Undefined ensures type consistency with the previous version of this function
        return undefined;
    },
    // Deconstruct the options object and extract the lookupLocalStorage property
    cacheUserLanguage (lng, _ref2) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref2;
        if (lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) window.localStorage.setItem(lookupLocalStorage, lng);
    }
};
let $60196a4650e96cb1$var$hasSessionStorageSupport = null;
const $60196a4650e96cb1$var$sessionStorageAvailable = ()=>{
    if ($60196a4650e96cb1$var$hasSessionStorageSupport !== null) return $60196a4650e96cb1$var$hasSessionStorageSupport;
    try {
        $60196a4650e96cb1$var$hasSessionStorageSupport = window !== 'undefined' && window.sessionStorage !== null;
        const testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasSessionStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasSessionStorageSupport;
};
var $60196a4650e96cb1$var$sessionStorage = {
    name: 'sessionStorage',
    lookup (_ref) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref;
        if (lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) return window.sessionStorage.getItem(lookupSessionStorage) || undefined;
        return undefined;
    },
    cacheUserLanguage (lng, _ref2) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref2;
        if (lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) window.sessionStorage.setItem(lookupSessionStorage, lng);
    }
};
var $60196a4650e96cb1$var$navigator$1 = {
    name: 'navigator',
    lookup (options) {
        const found = [];
        if (typeof navigator !== 'undefined') {
            const { languages: languages, userLanguage: userLanguage, language: language } = navigator;
            if (languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(let i = 0; i < languages.length; i++)found.push(languages[i]);
            if (userLanguage) found.push(userLanguage);
            if (language) found.push(language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $60196a4650e96cb1$var$htmlTag = {
    name: 'htmlTag',
    // Deconstruct the options object and extract the htmlTag property
    lookup (_ref) {
        let { htmlTag: htmlTag } = _ref;
        let found;
        const internalHtmlTag = htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (internalHtmlTag && typeof internalHtmlTag.getAttribute === 'function') found = internalHtmlTag.getAttribute('lang');
        return found;
    }
};
var $60196a4650e96cb1$var$path = {
    name: 'path',
    // Deconstruct the options object and extract the lookupFromPathIndex property
    lookup (_ref) {
        let { lookupFromPathIndex: lookupFromPathIndex } = _ref;
        if (typeof window === 'undefined') return undefined;
        const language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
        if (!Array.isArray(language)) return undefined;
        const index = typeof lookupFromPathIndex === 'number' ? lookupFromPathIndex : 0;
        return language[index]?.replace('/', '');
    }
};
var $60196a4650e96cb1$var$subdomain = {
    name: 'subdomain',
    lookup (_ref) {
        let { lookupFromSubdomainIndex: lookupFromSubdomainIndex } = _ref;
        // If given get the subdomain index else 1
        const internalLookupFromSubdomainIndex = typeof lookupFromSubdomainIndex === 'number' ? lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group match which should be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        const language = typeof window !== 'undefined' && window.location?.hostname?.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[internalLookupFromSubdomainIndex];
    }
};
function $60196a4650e96cb1$var$getDefaults() {
    return {
        order: [
            'querystring',
            'cookie',
            'localStorage',
            'sessionStorage',
            'navigator',
            'htmlTag'
        ],
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: (l)=>l
    };
}
class $60196a4650e96cb1$export$2e2bcd8739ae039 {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.services = services || {
            languageUtils: {}
        }; // this way the language detector can be used without i18next
        this.options = $60196a4650e96cb1$var$defaults(options, this.options || {}, $60196a4650e96cb1$var$getDefaults());
        if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = (l)=>l.replace('-', '_');
        // backwards compatibility
        if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
        this.i18nOptions = i18nOptions;
        this.addDetector($60196a4650e96cb1$var$cookie$1);
        this.addDetector($60196a4650e96cb1$var$querystring);
        this.addDetector($60196a4650e96cb1$var$localStorage);
        this.addDetector($60196a4650e96cb1$var$sessionStorage);
        this.addDetector($60196a4650e96cb1$var$navigator$1);
        this.addDetector($60196a4650e96cb1$var$htmlTag);
        this.addDetector($60196a4650e96cb1$var$path);
        this.addDetector($60196a4650e96cb1$var$subdomain);
    }
    addDetector(detector) {
        this.detectors[detector.name] = detector;
        return this;
    }
    detect(detectionOrder) {
        if (!detectionOrder) detectionOrder = this.options.order;
        let detected = [];
        detectionOrder.forEach((detectorName)=>{
            if (this.detectors[detectorName]) {
                let lookup = this.detectors[detectorName].lookup(this.options);
                if (lookup && typeof lookup === 'string') lookup = [
                    lookup
                ];
                if (lookup) detected = detected.concat(lookup);
            }
        });
        detected = detected.map((d)=>this.options.convertDetectedLanguage(d));
        if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
        return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
    cacheUserLanguage(lng, caches) {
        if (!caches) caches = this.options.caches;
        if (!caches) return;
        if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
        caches.forEach((cacheName)=>{
            if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
        });
    }
}
$60196a4650e96cb1$export$2e2bcd8739ae039.type = 'languageDetector';



// WARNING: This file is automatically generated!
var $86640f75f3d9fb26$exports = {};
$86640f75f3d9fb26$exports = JSON.parse('{"back":"Back","bookmarksMenu":"Menu","change":"Change","closeBookmarksMenu":"Close menu","closeDialog":"Close","colonoscopy":"Colonoscopy","continue":"Continue","details":"Details","errors":{"invalidOtp":{"details":"<ul><li>Check for any typos and try again.</li><li>If you\u2019re stuck, call us on {{phone}} (press Option 2).</li></ul>","title":"That didn\u2019t match our records"},"serverErrorOtp":{"details":"<ul><li>Your details might be correct \u2013 but we were unable to verify them right now.</li><li>Please wait a moment and try again.</li></ul>","title":"Something went wrong."},"uploadFailed":{"details":"<ul><li>Something unexpected occurred when uploading your attachment.</li><li>Please wait a moment and try again.</li></ul>","title":"Attachment upload failed."}},"formattedDate":"{{date}} at {{time}}","gastroscopy":"Gastroscopy","loading":"Loading...","next":"Next","nextWeek":"Next week","no":"No","none":"None","openBookmarksMenu":"Open menu","optional":"Optional","prevWeek":"Previous week","progress":"Progress {{progress}}%","roles":{"GeneralPractitioner":"GP","Specialist":"Specialist"},"selectLanguage":"Select language","step":{"appointment":"Appointment Time","details":"Personal details","health-questions":"Health questions","history":"Past procedures or surgeries","insurance":"Health insurance","medications":"Medications","preference-questions":"Preference questions","specialist":"Specialist"},"timeToday":"{{time}} today","timeTomorrow":"{{time}} tomorrow","videoUnsupported":"Your browser does not support the video tag.","yes":"Yes","yesTo":"Yes to","yourProgress":"Your progress"}');


var $d9d450b61d746e4a$exports = {};
$d9d450b61d746e4a$exports = JSON.parse('{"comingSoonText":"<p>You\u2019ll have seen that no appointments were available for at least a week from today.</p><p>Sometimes, earlier times open up due to cancellations.</p><p>Would you like us to contact you if something sooner becomes available?</p><p>There\u2019s no pressure to change - you can stick with your current time if it doesn\u2019t suit.</p>","comingSoonTitle":"Open to coming in sooner?","contactConsent":{"no":"No - I\u2019ll stick with what I\u2019ve chosen","yes":"Yes - I\u2019m happy to be contacted"},"contactConsentDetails":{"no":"We won\u2019t contact you about earlier times.","yes":"We\u2019ll let you know if an earlier time becomes available."},"description":"<p>Please complete your booking <strong>now</strong> to confirm this appointment.</p><p>Your appointment time is being held for you until <strong>tomorrow 8:00 AM</strong>.</p><p><span>To finish your booking, we just need you to:</span><ul><li>Confirm or update <strong>your patient details</strong></li><li>Let us know <strong>who\u2019s paying</strong> (for example, insurance)</li><li>Answer a few <strong>health and preference questions</strong></li></ul><p>This usually takes less than <strong>12 minutes</strong> and helps our team prepare everything you need for your procedure.</p>","nextLabel":"$t(common:next): <b>Confirm your details</b>","text":"<p>Your <strong>{{procedure.displayName}}</strong> with <strong>{{appointment.specialist}}</strong> on <strong>{{appointment.date}}</strong> at <strong>{{appointment.time}}</strong> has been <Status>temporarily reserved</Status> for you.</p>","title":"We\u2019ve reserved your appointment"}');


var $f5c044f334eda78b$exports = {};
$f5c044f334eda78b$exports = JSON.parse("{\"modal\":{\"buttonLabel\":\"Choose a new time\",\"text\":\"Someone else has just booked that time.\",\"title\":\"Just missed it!\"},\"nextLabel\":\"$t(common:next): <b>Reserve appointment time</b>\",\"nextWeek\":\"Next week\",\"noTimeText\":\"There are no times available for the selected date.\",\"prevWeek\":\"Prev week\",\"title\":\"Choose your appointment time\"}");


var $686c8670052246d4$exports = {};
$686c8670052246d4$exports = JSON.parse('{"helpMessage":"<p>If you\u2019re having trouble, please call us on <a><strong>{{phone}}</strong></a> (then press <strong>Option 2</strong>).</p>","noCode":"Didn\u2019t get the code?","remainingTime":"{{time}} remaining","sendCode":"Send a new code","text":"<p>We\u2019ve sent a 4-digit code to your mobile number: <strong><PhonePlaceholder /></strong></p><p>The code is valid for {{validityMinutes}} minutes.</p><p>Please enter code below to continue.</p>","textExpired":"Please request a new code to continue.","title":"Enter your code","titleExpired":"Your code has expired"}');


var $e3b0a5cbad0c2c7d$exports = {};
$e3b0a5cbad0c2c7d$exports = JSON.parse('{"calendarButtonLabel":"Add to calendar","confirmationText":"<h3>Expect an email within 24 hours:</h3><ul><li>\u2705  Appointment confirmation</li><li>\uD83D\uDCB2  Estimate for your insurer</li><li></li><li>\uD83E\uDD64  Prep instructions</li><li>\uD83C\uDFE5  Visit info (directions, parking etc.)</li><li>\uD83D\uDC8A  Prep prescription</li></ul><p>We\u2019ll also review your health answers, and one of our team will be in touch if we need to follow up before your procedure.</p>","helpMessage":"<h3>Contact us</h3><p>If you have any questions or need to make changes, call our friendly team:<br/><a><strong>\u260E\uFE0F {{phone}}</strong></a> (then press <strong>Option 2</strong>)<br/>Monday to Friday, 8am\u20135pm.</p>","text":"<p>Your <strong>{{procedure.displayName}}</strong> with <strong>{{appointment.specialist}}</strong> on <strong>{{appointment.date}}</strong> at <strong>{{appointment.time}}</strong> is <Status>confirmed</Status>.</p>","title":"Thanks {{patient.nameGiven}}! <br/> That\u2019s everything we need for now."}');


var $5e10f6a57744f5ec$exports = {};
$5e10f6a57744f5ec$exports = JSON.parse('{"contact-details":{"email":"Email address","mobilePhone":"Mobile phone","nextLabel":"$t(common:next): <b>Your GP (doctor)</b>","otherPhone":"Other phone","text":"We\u2019ve been using these details to contact you, but you can update if needed.","title":"Your contact details"},"doctor":{"gp":"GP (doctor) name","manually":"Doctor not showing? <PrimaryText>Enter it manually...</PrimaryText>","medicalCentre":"Medical Centre","nextLabel":"$t(common:next): <b>Your emergency contact</b>","searchPlaceholder":"Search for your GP or medical centre","text":"Is this your GP? If not, please update.","title":"Your GP (doctor)"},"emergency":{"fullName":"Full name","mobileNumber":"Mobile number","nextLabel":"$t(common:next): <b>Insurance / who\u2019s paying</b>","relationship":"Relationship to you","select":{"child":"Child","friend":"Friend","other":"Other","parent":"Parent","spouse":"Spouse / Partner"},"text":"Who should we contact in an emergency?","title":"Your emergency contact","footnote":"Please ensure this person knows you are having a procedure and can be contacted on the day, if required."},"home-address":{"building":"Building or Subdivision level, floor or unit","city":"Town/City","manually":"Address not showing? <PrimaryText>Enter it manually...</PrimaryText>","nextLabel":"$t(common:next): <b>Your contact details</b>","postcode":"Postcode","searchPlaceholder":"Search address in New Zealand","street":"Street name and number","suburb":"Suburb or RD","text":"Please enter your home address:","textSecondary":"Here\u2019s the address we\u2019ll use:","title":"Your home address"},"name-birthdate":{"birthDate":"Date of birth","dateFormat":"dd/mm/yyyy","familyName":"FAMILY name:","firstName":"First name(s)","nextLabel":"$t(common:next): <b>Your residency status</b>","preferredName":"Preferred name","select":{"dame":"Dame","dr":"Dr","label":"Title","miss":"Miss","mr":"Mr","mrs":"Mrs","ms":"Ms","mx":"Mx","placeholder":"Select your title","prof":"Prof","rev":"Rev","sir":"Sir"},"text":"Please check these details and update anything that\u2019s missing or incorrect:","title":"Your name and birthdate"},"nhi-residency":{"nextLabel":"$t(common:next): <b>Your home address</b>","nhiNumber":"NHI number","resident":"Are you a New Zealand resident?","residentText":"If you\u2019re not a NZ resident, you may be billed for some services such as lab tests.","text":"Are you a New Zealand resident?","title":"Your residency status"}}');


var $4cf04496feffde13$exports = {};
$4cf04496feffde13$exports = JSON.parse('{"code":"Invitation code","error":{"details":"<ul><li>Check for any typos and try again.</li><li>If you\u2019re stuck, call us on {{phone}} (press Option 2).</li></ul>","title":"That invitation code didn\u2019t work"},"helpMessage":"<p>Lost your invite or unsure what to do?<br />Please call us on <a><strong>{{phone}}</strong></a> (then press <strong>Option 2</strong>).</p>","text":"<p>Enter your 6-character invitation code to get started.</p><p>You\u2019ll find this code in your email invitation, or it may have been given to you by your referrer.</p>","title":"Access your booking invitation"}');


var $c964eb77bd305b20$exports = {};
$c964eb77bd305b20$exports = JSON.parse('{"dropLabel":"Jump to specific question","nextLabel":"<b>Answer health questions</b>","questions":{"allergies":{"detailsPlaceholder":"e.g. Penicillin \u2013 rash and swelling; Latex \u2013 mild irritation","label":"Do you have any allergies?","nextLabel":"$t(common:next): <b>Weight and height</b>","title":"<h3>Allergies</h3>"},"arrhythmias":{"detailsPlaceholder":"e.g. Irregular heartbeat, on beta blockers","label":"Do you have irregular heartbeat, palpitations, or a heart murmur?","nextLabel":"$t(common:next): <b>Pacemaker</b>","title":"<h3>Arrhythmias (irregular heart rate)</h3>"},"asthmaLungConditions":{"detailsPlaceholder":"e.g. Mild asthma \u2013 use inhaler occasionally","label":"Do you have asthma, COPD or any other lung condition?","nextLabel":"$t(common:next): <b>Digestive conditions</b>","title":"<h3>Asthma or lung conditions</h3>"},"bloodProblems":{"detailsPlaceholder":"e.g. Easy bruising \u2013 diagnosed with Von Willebrand disease","label":"Do you have any bleeding or clotting disorders, or bruise easily?","nextLabel":"$t(common:next): <b>Organ transplant</b>","title":"<h3>Blood disorders or bleeding problems</h3>"},"bloodThinningMedication":{"detailsPlaceholder":"e.g. Apixaban, Warfarin, Rivaroxaban, Dabigatran, Ticagrelor, Clopidogrel","label":"Are you currently taking any blood thinning medication other than aspirin?","nextLabel":"$t(common:next): <b>Heart conditions</b>","title":"<h3>Blood thinning medication</h3>"},"cancerTreatment":{"detailsPlaceholder":"e.g. Chemotherapy for breast cancer \u2013 ongoing","label":"Are you currently receiving chemotherapy, radiotherapy or any other treatment for cancer?","nextLabel":"$t(common:next): <b>Infectious diseases</b>","title":"<h3>Cancer treatment</h3>"},"diabetes":{"detailsLabel":"How is your diabetes managed?","diet-controlled":"Diet-controlled","insulin":"Insulin","label":"Do you have diabetes?","nextLabel":"$t(common:next): <b>High blood pressure</b>","no":"No","tablets":"Tablets (e.g. Metformin)","title":"<h3>Diabetes</h3>","type-1":"Type 1 - on insulin","type-2":"Type 2","yes-type-1":"Yes - Type 1 on insulin","yes-type-2":"Yes - Type 2"},"digestiveConditions":{"detailsPlaceholder":"e.g. Reflux managed with omeprazole","label":"Do you have GORD (reflux), IBS, or IBD?","nextLabel":"$t(common:next): <b>Blood or bleeding problems</b>","title":"<h3>Digestive conditions</h3>"},"epilepsy":{"detailsPlaceholder":"e.g. Last seizure in 2020 \u2013 currently stable","label":"Do you have epilepsy or a history of seizures?","nextLabel":"$t(common:next): <b>Neurological conditions</b>","title":"<h3>Epilepsy</h3>"},"glp1Medications":{"detailsPlaceholder":"e.g. Wegovy, Ozempic, Trulicity, Saxenda, Victoza, Mournjaro","detailsLabel":"Which one?","label":"Are you currently taking any GLP-1 medications (often used for diabetes or weight management)?","nextLabel":"$t(common:next): <b>Other medications</b>","title":"<h3>GLP-1 medications</h3>"},"heartConditions":{"detailsPlaceholder":"e.g. Heart attack in 2020 \u2013 stent inserted","label":"Have you ever had a heart condition (e.g. heart attack, angina)?","nextLabel":"$t(common:next): <b>Stroke or mini-stroke (TIA)</b>","title":"<h3>Heart conditions</h3>"},"highBloodPressure":{"detailsPlaceholder":"e.g. Diagnosed in 2018 \u2013 managed with medication","label":"Do you have high blood pressure?","nextLabel":"$t(common:next): <b>Irregular heart rate</b>","title":"<h3>High blood pressure</h3>"},"infectiousDiseases":{"detailsPlaceholder":"e.g. MRSA","label":"Have you ever tested positive for MRSA, ESBL, VRE or CPE?","nextLabel":"$t(common:next): <b>Pregnancy</b>","title":"<h3>Multi-resistant organisms</h3>"},"metalImplants":{"detailsPlaceholder":"e.g. Right hip replacement, dental implants, or metal rod in leg","label":"Do you have any metal implants or metalware on your body? (e.g. pins, plates, screws, joint replacements)","nextLabel":"$t(common:next): <b>Diabetes</b>","title":"<h3>Implants or metal</h3>"},"obstructiveSleepApnoea":{"detailsPlaceholder":"e.g. Diagnosed in 2022 \u2013 use CPAP machine every night","label":"Do you have obstructive sleep apnoea or use a CPAP machine at night when sleeping?","nextLabel":"$t(common:next): <b>Asthma or lung conditions</b>","title":"<h3>Obstructive sleep apnoea</h3>"},"organTransplant":{"detailsPlaceholder":"e.g. Kidney transplant in 2018 \u2013 taking tacrolimus and prednisone","label":"Have you had an organ transplant and are you taking immunosuppressive medication?","nextLabel":"$t(common:next): <b>Cancer treatment</b>","title":"<h3>Organ transplant</h3>"},"otherHealthConditions":{"detailsPlaceholder":"e.g. Coeliac disease, recent surgery, chronic pain","label":"Do you have any other medical conditions or concerns we should know about?","nextLabel":"$t(common:next): <b>GLP-1 Medications</b>","title":"<h3>Other health conditions</h3>"},"pacemaker":{"defibrillator":"Defibrillator","detailsLabel":"What type is it?","label":"Do you have a pacemaker or other implanted cardiac device?","nextLabel":"$t(common:next): <b>Blood thinning medications</b>","not-sure":"I\u2019m not sure","pacing":"Pacing","title":"<h3>Pacemaker or implanted cardiac device</h3>"},"pregnancy":{"detailsLabel":"How many weeks?","detailsPlaceholder":"Enter number of weeks","label":"Are you currently - or possibly - pregnant?","nextLabel":"$t(common:next): <b>Other conditions</b>","title":"<h3>Pregnancy</h3>"},"stroke":{"detailsPlaceholder":"e.g. Stroke in 2021 \u2013 mild weakness on left side","label":"Have you had a stroke or mini-stroke?","nextLabel":"$t(common:next): <b>Epilepsy</b>","title":"<h3>Stroke or mini-stroke (TIA)</h3>"},"weightHeight":{"cm":"cm","height":"Height","kg":"kg","nextLabel":"$t(common:next): <b>Implants or metal</b>","title":"<h3>Weight and height</h3><p>Please enter your</p>","weight":"Weight"}},"text":"<p>We\u2019re nearly done.</p><p>We just need to ask a few questions about your health, medications, and preferences.</p><p>It\u2019s important we understand anything that could affect your care.</p><p>If we need to clarify anything, one of our team will be in touch before your procedure.</p><p>This last part of the process usually takes less than <strong>10 minutes</strong>.</p>","title":"Health and preference questions"}');


var $1036cbb44ce7ed32$exports = {};
$1036cbb44ce7ed32$exports = JSON.parse("{\"addButtonLabel\":\"Add procedure or surgery\",\"date\":\"Date\",\"datePlaceholder\":\"e.g. June 2022, 2021, or ~5 years ago\",\"location\":\"Location\",\"locationPlaceholder\":\"e.g. Ormiston Hospital, Auckland\",\"nextLabel\":\"$t(common:next): <b>Mobility</b>\",\"procedure\":\"Procedure or Surgery description\",\"procedurePlaceholder\":\"e.g. Colonoscopy to investigate bleeding\",\"saveButton\":\"Save procedure or surgery\",\"text\":\"<p>We have a record of your previous endoscopy at {{company}}:</p><ul><li><strong>{{procedure}}</strong> in <strong>{{date}}</strong></li></ul><p>Have you had any other endoscopies, abdominal or major surgeries since then?</p>\",\"textNoProcedure\":\"Have you had any endoscopies, abdominal, or major surgeries in the past?\",\"title\":\"Recent procedures or surgeries\"}");


var $4150c1f9d124e03f$exports = {};
$4150c1f9d124e03f$exports = JSON.parse('{"helpMessage":"<h3>Insurance questions?</h3><p>Our team is happy to help \u2014 call:<br/><a><strong>\u260E\uFE0F {{phone}}</strong></a> (then press <strong>Option 2</strong>)<br/>Monday to Friday, 8am\u20135pm.</p>","insuranceCovered":"Will health insurance cover some or all of your procedure costs?","insuranceDetails":"<ul><li>I\u2019m responsible for any outstanding amounts not covered by insurance.</li><li>I will pay any required amount on the day of admission.</li><li>I\u2019m responsible for any debt collection costs if I don\u2019t pay my account.</li></ul>","insuranceLabel":"I understand and accept that:","insurerLabel":"Who is your health insurer?","insurerSelect":{"aia":"AIA","nib":"NIB","southern-cross":"Southern Cross"},"membershipLabel":"Membership number","noCovered":"I will pay the full costs myself","preApprovalLabel":"Have you obtained prior approval for this procedure?","preApprovalText":"<h3>{{insurer}} pre-approval</h3><p>We\u2019ll contact {{insurer}} on your behalf to request approval for your procedure.</p><p>You\u2019ll receive an update confirming the outcome, including an estimate of any amount you may need to pay.</p><span>This could include:</span><ul><li><strong>Excess:</strong> the amount set by your policy, and/or</li><li><strong>Shortfall:</strong> the difference between your policy cover and the procedure cost.</li></ul><p>Any excess or shortfall will need to be <strong>paid\xa0on the day of your procedure</strong>.</p>","title":"Health Insurance"}');


var $022f3fcb73f31e63$exports = {};
$022f3fcb73f31e63$exports = JSON.parse('{"helpMessage":"<h3>Got questions?</h3><p>We\u2019re happy to help - call our team:<br/><a><strong>\u260E\uFE0F {{phone}}</strong></a> (then press <strong>Option 2</strong>)<br/>Monday to Friday, 8am\u20135pm.</p>","title":"Invitation is not valid"}');


var $99f972315e244b64$exports = {};
$99f972315e244b64$exports = JSON.parse('{"helpMessage":"<h3>Got questions?</h3><p>We\u2019re happy to help - call our team:<br/><a><strong>\u260E\uFE0F {{phone}}</strong></a> (then press <strong>Option 2</strong>)<br/>Monday to Friday, 8am\u20135pm.</p>","text":"<p>We\u2019ll let your referring doctor know, and they may follow up with you to discuss next steps.</p> <p>There\u2019s nothing else you need to do for now.</p>","title":"You\u2019ve chosen not to book right now"}');


var $4530f233fe32a0bf$exports = {};
$4530f233fe32a0bf$exports = JSON.parse('{"text":"<p>This link is no longer active - but <strong>you can still make an appointment</strong></p><p><strong>Booking reference: <em>{{inviteId}}</em></strong><br/>(Quote this when you call.)</p><p>Please call our team and we\'ll help you get booked in:</p><a><strong>\u260E\uFE0F {{phone}}</strong></a> (then press <strong>Option 2</strong>)<br/>Monday to Friday, 8am\u20135pm.</p>","title":"Your booking invitation has expired"}');


var $47441ea0a82725e4$exports = {};
$47441ea0a82725e4$exports = JSON.parse('{"text":"<p>After several unsuccessful attempts to verify your identity, we\u2019ve temporarily locked this invitation to protect your privacy.</p><p>Don\u2019t worry \u2013 we can still help.</p><p>Please call our team to complete your booking:</p><p><a><strong>\u260E\uFE0F {{phone}}</strong></a> (then press <strong>Option 2</strong>)<br/>Monday to Friday, 8am\u20135pm.</p>","title":"Invitation locked for your security"}');


var $ad005130958e9b65$exports = {};
$ad005130958e9b65$exports = JSON.parse('{"addButtonLabel":"Add medication","dose":"Dose","dosePlaceholder":"e.g. 500mg or 1 tablet","dropHere":"Drop here","dropText":"<p>{{fileExtensions}} or {{fileExtension}} up to {{mb}}MB</p>","dropTitle":"<p><strong>Upload a file</strong> or drag and drop</p>","frequency":"Frequency","manuallyText":"<strong>Add medications manually</strong><p>Add one medication at a time. Include the name, dose and how often you take it.</p>","medicationName":"Medication name","medicationPlaceholder":"e.g. Metformin","nextLabel":"$t(common:next): <b>History</b>","saveButton":"Save medication","select":{"as-needed":"As needed","once-daily":"Once daily","three-time-daily":"Three times daily","twice-daily":"Twice daily"},"text":"<p>Please tell us about any other medications, inhalers, injections, or supplements you\u2019re currently taking not already mentioned.</p><p>You can upload a list or add them manually.</p>","title":"Other medications","uploadText":"<strong>Upload a prescription or list</strong><p>If you have a list from your GP or pharmacy, upload a photo or PDF.</p>"}');


var $dcb4da0e150ee6d5$exports = {};
$dcb4da0e150ee6d5$exports = JSON.parse('{"questions":{"culture":{"detailsPlaceholder":"","label":"Do you have any cultural or family needs?","nextLabel":"$t(common:next): <b>Dietary requirements</b>","title":"<h3>Cultural or family needs</h3>"},"diet":{"detailsPlaceholder":"e.g. Vegetarian, vegan, halal, dairy free, gluten free","label":"Do you have any special dietary requirements?","nextLabel":"$t(common:next): <b>Other special needs or info</b>","title":"<h3>Dietary requirements</h3>"},"language":{"de":"Deutsch / German","detailsLabel":"What is your preferred language?","fj":"Vosa Vakaviti / Fijian","fr":"Fran\xe7ais / French","ja":"\u65E5\u672C\u8A9E / Japanese","ko":"\uD55C\uAD6D\uC5B4 / Korean","label":"Do you have difficulty understanding English?","mi":"Te Reo M\u0101ori","ms":"Malay / Malaysian","nextLabel":"$t(common:next): <b>Religious or spiritual needs</b>","other":"Other","pt":"Portugu\xeas / Portuguese","sm":"Gagana Samoa / Samoan","ta":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD / Tamil","title":"<h3>Understanding English</h3>","tl":"Tagalog / Tagalog","to":"Lea Faka-Tonga / Tongan","zh":"\u7B80\u4F53\u4E2D\u6587 / Chinese"},"mobility":{"detailsPlaceholder":"e.g. Use walking frame or wheelchair; need help transferring to bed","label":"Do you have a disability or need support with mobility?","nextLabel":"$t(common:next): <b>Understanding English</b>","title":"<h3>Mobility</h3>"},"other":{"detailsPlaceholder":"Only share what you feel is relevant. This helps us support you better.","label":"Do you have any other special needs, or is there any other information you would like us to know about?","nextLabel":"$t(common:next): <b>Getting your bowel prep</b>","title":"<h3>Other special needs or information</h3>"},"prep":{"label":"Please choose how you\u2019d like to receive it:","nextLabel":"$t(common:next): <b>Complete booking</b>","pick-up-from-hospital":"<label>Pick up from {{company}}</label><p>Collect your prep pack from reception during opening hours.</p>","pick-up-from-local-pharmacy":"<label>Pick up from your local pharmacy</label><p>We\u2019ll email you a prescription to take to your pharmacy.</p>","receive-by-mail":"<label>Receive by mail</label><p>We\u2019ll post your prep pack to the home address you gave us if your procedure is booked more than a week out.</p>","text":"To prepare for your procedure, you\u2019ll need to take special medication that clears your bowel.","title":"<h3>Getting your bowel prep</h3><p>To prepare for your procedure, you\u2019ll need to take special medication that clears your bowel.</p>"},"religion":{"detailsPlaceholder":"e.g. Quiet space for prayer, prefer same-gender staff for personal care","label":"Do you have any religious or spiritual needs?","nextLabel":"$t(common:next): <b>Cultural or family needs</b>","title":"<h3>Religious or spiritual needs</h3>"}}}');


var $00eb2d1963ced994$exports = {};
$00eb2d1963ced994$exports = JSON.parse('{"helpMessage":"<h3>Privacy questions?</h3><p>Our team is happy to help - call:<br/><a><strong>\u260E\uFE0F {{phone}}</strong></a> (then press <strong>Option 2</strong>)<br/>Monday to Friday, 8am\u20135pm.</p>","privacyDetails":"<ul><li>You understand how your information will be used.</li><li>You are completing this booking for yourself\xa0or\xa0for someone you are authorised to support (e.g. as a caregiver or parent).</li><li>You agree to continue the booking process.</li></ul>","privacyLabel":"I accept this Privacy Statement","privacyText":"By accepting this Privacy Statement, you confirm that:","text":"<p>We take your privacy seriously.</p><p>The information you provide during this process will be securely stored and used only to support your care at {{company}}.</p><p>Your personal and medical details will be shared only with the healthcare professionals involved in your treatment.</p><p>We do not share your information with third parties for marketing purposes.</p><p>You can contact us at any time to request access to or correction of your information.</p>","title":"Privacy Statement"}');


var $13de4d4fb487ae96$exports = {};
$13de4d4fb487ae96$exports = JSON.parse('{"anySpecialist":{"text":"Show me the widest range of available appointment times.","title":"I don\u2019t mind who"},"nextLabel":"$t(common:next): <b>Choose a time<b>","profile":"Specialist Profile","specialists":{"00000000-0000-da7a-0003-000000000001":{"name":"Dr. Paul Casey","profession":"Gastroenterologist, Endoscopist & Hepatologist","profile":"<p>Dr Paul Casey is an experienced gastroenterologist who has been practising since 2005. He completed his medical training in Auckland and works publicly at Middlemore Hospital and privately at Ormiston. He performs gastroscopy and colonoscopy procedures and is known for his patient-centred approach to care.</p><p>He values clear communication, thorough planning, and helping patients feel informed and confident before any procedure.</p><p>Outside of work, Paul enjoys time on the golf course, running, and life with his wife, kids, and their two dogs.</p>","titles":"MBChB, FRACP"},"00000000-0000-da7a-0003-000000000002":{"name":"Dr. Ravinder Ogra","profession":"Gastroenterologist & Interventional Endoscopist","profile":"<p>Dr. Ogra is a gastroenterologist specialising in gastroscopy, colonoscopy, and advanced interventional endoscopy - often avoiding the need for more invasive surgery. He trained in Kashmir, India, and completed his gastroenterology fellowship in New Zealand.</p><p>Known for his cheerful manner and warm communication style, Dr. Ogra puts patients at ease with a smile and light conversation, while always listening closely to their concerns.</p><p>Outside of medicine, he\'s a passionate gardener, a regular on New Zealand\'s Great Walks, and a devoted All Blacks supporter - having attended every Rugby World Cup since 2007.</p>","titles":"MBBS, MD, FRACP, AGAF, FASGE"},"00000000-0000-da7a-0003-000000000003":{"name":"Dr. Stephen Persson","profession":"Gastroenterologist, Endoscopist & Hepatologist","profile":"<p>Dr. Stephen Persson is a specialist gastroenterologist with over 25 years of experience. He trained in Auckland and London, returning in 1998 to join Middlemore Hospital as a consultant. Stephen is known for his expertise in a wide range of gastrointestinal conditions and is a highly skilled endoscopist, participating in the NZ Bowel Cancer Screening Programme.</p><p>He combines clinical excellence with a warm, patient-focused approach and is committed to clear communication and continuity of care. Patients and referrers are welcome to contact him directly with any questions.</p>","titles":"MBChB, FRACP"},"00000000-0000-da7a-0003-000000000004":{"name":"Dr. Robert Lopez","profession":"NEED SPECIALTIES","profile":"<p>NEED BIO</p>","titles":"NEED QUALS"},"00000000-0000-da7a-0003-000000000005":{"name":"Dr. Dinesh Lal","profession":"Gastroenterologist & Endoscopist","profile":"<p>Dr. Lal is a senior gastroenterologist with over 25 years of specialist experience in gastroscopy, colonoscopy, and advanced procedures such as ERCP and EUS. He combines a meticulous, safety-focused approach with a strong emphasis on communication and patient reassurance.</p><p>Dinesh is passionate about preventative care, particularly in the early detection of bowel cancer.</p><p>Outside of work, he enjoys golf, walking his dog, and volunteering on medical missions to underserved communities - a pursuit he finds deeply rewarding both personally and professionally.</p>","titles":"MBChB, FRACP"},"00000000-0000-da7a-0003-000000000006":{"name":"Dr. Parry Singh","profession":"Colorectal Surgeon & Endoscopist.","profile":"<p>Dr. Singh is a specialist colorectal surgeon with advanced training in surgical endoscopy.</p><p>His dual expertise in both surgery and endoscopy gives him a unique ability to diagnose and treat bowel and anorectal conditions such as haemorrhoids, fissures, fistulas, diverticulitis, and bowel cancer.</p><p>Known for his warm manner, clear communication, and touch of humour, Parry helps put patients at ease during what can be an anxious time.</p><p>Music is always playing - and requests are welcome - creating a calm, comfortable atmosphere where patients feel relaxed and in control.</p>","titles":"MBChB, FRACP"},"00000000-0000-da7a-0003-000000000007":{"name":"Dr. Anurag Sekra","profession":"Gastroenterologist & Interventional Endoscopist","profile":"<p>Dr. Anurag Sekra is a gastroenterologist with a decade of specialist experience in gastroscopy, colonoscopy, and endoscopic ultrasound (EUS).</p><p>Known for his warm smile and clear communication, Anurag takes a patient-centred approach - carefully listening, explaining, and collaborating on treatment plans that feel right for each individual.</p><p>He brings a calm, thorough presence to every consultation, helping first-time patients feel at ease.</p><p>Outside of medicine, he enjoys travelling, cricket, running, and reading - all part of staying balanced and curious.<p>","titles":"MBBS, FRACP"},"00000000-0000-da7a-0003-000000000008":{"name":"Dr. Stephen Gerred","profession":"Gastroenterologist, Endoscopist & Hepatologist","profile":"<p>Dr. Stephen Gerred is a highly experienced gastroenterologist with over 25 years of specialist practice.</p><p>Known for his calm, unhurried approach, Stephen takes time to listen, explain each step clearly, and ensure patients feel informed and at ease.</p><p>He understands how digestive health issues can affect day-to-day wellbeing and takes a holistic view of care.</p><p>Outside of work, Stephen enjoys tramping, skiing, travel, and raising a variety of animals on his rural South Auckland lifestyle block.</p>","titles":"MBChB, FRACP"},"00000000-0000-da7a-0003-000000000009":{"name":"Dr. Jon Barnard","profession":"Colorectal Surgeon & Endoscopist","profile":"<p>Dr. Barnard is a specialist colorectal surgeon with a focus on bowel cancer detection and treatment, as well as common benign conditions such as haemorrhoids. He completed his medical training in Auckland and subspecialty colorectal training through CSSANZ.</p><p>Jon combines clinical excellence with a friendly, down-to-earth approach. He takes time to explain each procedure clearly, answer questions, and help patients feel at ease even inviting playlist requests.</p><p>Outside of work, Jon enjoys exploring the Wait\xe4kere and Hunua Ranges with his wife and three children, making the most of New Zealand\'s great outdoors.</p>","titles":"MBChB, FRACS"},"00000000-0000-da7a-0003-000000000010":{"name":"Dr. Sri Salvaratnam","profession":"Gastroenterologist & Endoscopist","profile":"<p>Dr. Selvaratnam is a gastroenterologist with expertise in diagnostic and therapeutic endoscopy. He trained in Auckland and Sydney, completing a fellowship in Inflammatory Bowel Disease, and has been practising for six years.</p><p>Known for his compassionate, patient-focused care, Dr. Selvaratnam ensures patients feel informed, respected, and comfortable throughout their journey.</p><p>Outside of work, Dr. Selvaratnam enjoys time with his wife and two young children. A passionate footballer, he represented New Zealand at the World Medical Football Championships in Dublin in 2025.</p>","titles":"MBChB, MRES, FRACP"},"00000000-0000-da7a-0003-000000000011":{"name":"Dr. Aung Htoo","profession":"NEED SPECIALTIES","profile":"<p>NEED BIO</p>","titles":"NEED QUALS"},"00000000-0000-da7a-0003-000000000012":{"name":"Dr. Laila Sheikh","profession":"NEED SPECIALTIES","profile":"<p>NEED BIO</p>","titles":"NEED QUALS"},"00000000-0000-da7a-0003-000000000013":{"name":"Dr. Lily Wu","profession":"NEED SPECIALTIES","profile":"<p>NEED BIO</p>","titles":"NEED QUALS"},"00000000-0000-da7a-0003-000000000014":{"name":"Dr. Maggie Chapman-Ow","profession":"Gastroenterologist","profile":"<p>Dr. Chapman-Ow is a gastroenterologist with expertise in diagnostic and therapeutic endoscopy, including polypectomy and dilatation. She trained in Auckland and the UK, holds a doctoral degree from the University of Auckland, and has been practising since 2014.</p><p>Warm, empathetic, and calm under pressure, Maggie takes time to ensure each patient feels safe, heard, and well cared for\u2014especially those navigating complex or daily symptoms.</p><p>Outside of work, she enjoys mountain biking and beach adventures with her young son and family.</p>","titles":"MBChB, FRACP"},"00000000-0000-da7a-0003-000000000015":{"name":"Dr. Paras Garg","profession":"NEED SPECIALTIES","profile":"<p>NEED BIO</p>","titles":"NEED QUALS"},"00000000-0000-da7a-0003-000000000016":{"name":"Dr. Mirthe van de Valk","profession":"NEED SPECIALTIES","profile":"<p>NEED BIO</p>","titles":"NEED QUALS"},"00000000-0000-da7a-0003-000000001001":{"name":"Dr. Peter Cassidy","profession":"Gastroenterologist & Endoscopist","profile":"<p>Dr Cassidy is a New Zealand-trained gastroenterologist known for his calm, attentive manner and clear communication style.</p><p>After completing his medical degree at the University of Otago, he trained in internal medicine and gastroenterology in Auckland. He has a particular interest in inflammatory bowel disease (IBD) and is actively involved in bowel cancer screening programmes.</p><p>Patients often comment on his reassuring presence and willingness to explain things clearly.</p>","titles":"MBChB, FRACP"},"00000000-0000-da7a-0003-000000001002":{"name":"Dr. Rowan Osmani","profession":"Gastroenterologist","profile":"<p>Dr Osmani is a New Zealand-born gastroenterologist of Afghan heritage. She completed her PhD in coeliac disease at the University of Auckland and continues to be active in clinical research.</p><p>Patients appreciate her holistic approach, especially in the management of complex, functional gut conditions.</p><p>She\u2019s passionate about empowering patients with knowledge and improving quality of life.</p>","titles":"MBChB, FRACP, PhD"},"00000000-0000-da7a-0003-000000001003":{"name":"Dr. Sean Pearson","profession":"Gastroenterologist & Endoscopist","profile":"<p>Dr Pearson is a general gastroenterologist with a focus on colorectal cancer prevention. He trained in Christchurch and completed further endoscopy training at the Royal Melbourne Hospital.</p><p>Known for his thoroughness and approachability, he works closely with GPs to ensure timely access to screening and surveillance.</p><p>In his spare time, he enjoys tramping and photography.</p>","titles":"MBChB, FRACP"},"00000000-0000-da7a-0003-000000001004":{"name":"Dr. Rodrigo Lowe","profession":"Gastroenterologist & Endoscopist","profile":"<p>Dr Lowe was born in Brazil and completed his medical degree in S\xe3o Paulo before moving to New Zealand for advanced training.</p><p>His warm, friendly manner is matched by a strong interest in swallowing disorders and oesophageal health.</p><p>He is fluent in Portuguese and conversational in Spanish, and enjoys connecting with patients from all backgrounds.</p>","titles":"MD, FRACP"},"00000000-0000-da7a-0003-000000001005":{"name":"Dr. Daniel Larkin","profession":"Gastroenterologist & Endoscopist","profile":"<p>Dr Larkin is a New Zealand-born gastroenterologist with additional training in paediatrics, making him especially popular with younger adult patients.</p><p>He takes a down-to-earth, friendly approach and is a strong advocate for gut health education.</p><p>He completed his gastroenterology training in Auckland and now balances private and public work with raising two energetic children.</p>","titles":"MBChB, FRACP, DipPaed"},"00000000-0000-da7a-0003-000000001006":{"name":"Dr. Pavan Sandhu","profession":"Gastroenterologist","profile":"<p>Dr Sandhu is a New Zealand-trained gastroenterologist of Punjabi descent. She is particularly interested in the intersection of hormonal changes and gastrointestinal symptoms in women.</p><p>Known for her empathetic manner and strong communication skills, she creates a safe, collaborative environment for her patients.</p><p>Outside of work, she enjoys cooking and long-distance running.</p>","titles":"MBChB, FRACP"},"00000000-0000-da7a-0003-000000001007":{"name":"Dr. Arun Sethi","profession":"Gastroenterologist & Endoscopist","profile":"<p>Dr Sethi trained in India and New Zealand, with a particular focus on liver health. He has extensive experience managing hepatitis, fatty liver, and metabolic syndrome-related complications.</p><p>Patients describe him as thoughtful and methodical, with a knack for helping them understand complex conditions.</p><p>He also contributes to community health initiatives promoting early detection of liver disease.</p>","titles":"MBBS, MD, FRACP"},"00000000-0000-da7a-0003-000000001008":{"name":"Dr. Simon Garrett","profession":"Gastroenterologist & Endoscopist","profile":"<p>Originally from the UK, Dr Garrett trained at University College London and completed his advanced gastroenterology training in both London and Wellington.</p><p>With a subspecialty interest in therapeutic endoscopy, he brings both technical precision and a thoughtful, empathetic approach to patient care.</p><p>Outside the clinic, he\u2019s a keen cyclist and amateur gardener.</p>","titles":"MBChB, MRCP (UK), FRACP"},"00000000-0000-da7a-0003-000000001009":{"name":"Dr. John Barnwell","profession":"Gastroenterologist & Endoscopist","profile":"<p>Dr Barnwell is a senior gastroenterologist with deep experience in advanced endoscopic procedures. He trained in New Zealand and completed a fellowship in endoscopic ultrasound in Brisbane.</p><p>Despite his technical expertise, patients often remark on how down-to-earth and approachable he is.</p><p>He brings a calm, confident energy to the team.</p>","titles":"MBChB, FRACP"},"00000000-0000-da7a-0003-000000001010":{"name":"Dr. Suresh Selby","profession":"Gastroenterologist & Endoscopist","profile":"<p>Dr Selby is a second-generation Kiwi-Indian endoscopist who is passionate about delivering high-quality, equitable care.</p><p>He has led quality improvement initiatives in both public and private settings, and is deeply committed to improving access to screening and early intervention.</p><p>When he\u2019s not in the procedure room, you\u2019ll likely find him paddleboarding or exploring coastal walks.</p>","titles":"MBChB, FRACP"},"00000000-0000-da7a-0003-000000001011":{"name":"Dr. Lillian Wong","profession":"Gastroenterologist & Endoscopist","profile":"<p>Dr Wong is a Hong Kong\u2013born New Zealander who brings a thoughtful, patient-centred approach to her work. She completed her medical training in Auckland and undertook additional experience in upper GI disorders in Sydney.</p><p>With her gentle manner and strong attention to detail, she\u2019s particularly popular with patients undergoing their first endoscopy.</p>","titles":"MBChB, FRACP"},"00000000-0000-da7a-0003-000000001012":{"name":"Dr. Aaron Hales","profession":"Gastroenterologist","profile":"<p>Dr Hales has a strong interest in the role of the nervous system in gut function and dysfunction. His patients appreciate his listening skills and his interest in exploring both physical and psychological factors contributing to gut symptoms.</p><p>He trained in Dunedin and Auckland, and continues to teach and supervise trainees in the public system.</p>","titles":"MBChB, FRACP"},"00000001-0000-da7a-0003-000000001001":{"name":"TODO","profession":"TODO","profile":"<p>TODO</p>","titles":"TODO"},"00000002-0000-da7a-0003-000000001002":{"name":"TODO","profession":"TODO","profile":"<p>TODO</p>","titles":"TODO"},"00000003-0000-da7a-0003-000000001003":{"name":"TODO","profession":"TODO","profile":"<p>TODO</p>","titles":"TODO"},"00000004-0000-da7a-0003-000000001004":{"name":"TODO","profession":"TODO","profile":"<p>TODO</p>","titles":"TODO"},"00000005-0000-da7a-0003-000000001005":{"name":"TODO","profession":"TODO","profile":"<p>TODO</p>","titles":"TODO"},"00000006-0000-da7a-0003-000000001006":{"name":"TODO","profession":"TODO","profile":"<p>TODO</p>","titles":"TODO"},"00000007-0000-da7a-0003-000000001007":{"name":"TODO","profession":"TODO","profile":"<p>TODO</p>","titles":"TODO"},"00000008-0000-da7a-0003-000000001008":{"name":"TODO","profession":"TODO","profile":"<p>TODO</p>","titles":"TODO"},"00000009-0000-da7a-0003-000000001009":{"name":"TODO","profession":"TODO","profile":"<p>TODO</p>","titles":"TODO"},"0000000a-0000-da7a-0003-000000001010":{"name":"TODO","profession":"TODO","profile":"<p>TODO</p>","titles":"TODO"},"0000000b-0000-da7a-0003-000000001011":{"name":"TODO","profession":"TODO","profile":"<p>TODO</p>","titles":"TODO"},"unknown":{"name":"a Specialist","profession":"Specialist","profile":"<p></p>","titles":""}},"textMultiple":"<p>All of these specialists are great choices. Pick one, or just continue with \u201CI don\u2019t mind who\u201D.</p>","textSingle":"<p>Your {{requestingPractitioner.practitionerRole}} - {{requestingPractitioner.displayName}} - has referred you to:</p>","titleMultiple":"Choose your specialist","titleSingle":"Your specialist","viewProfile":"View full profile"}');


var $b59049dc6dd4b26f$exports = {};
$b59049dc6dd4b26f$exports = JSON.parse('{"bookButtonLabel":"Book appointment now","bookText":"<h3>Book online:</h3>\\n<ul>\\n  <li>\u23F1\uFE0F  <strong>Quick and easy -</strong> 15 minutes or less</li>\\n  <li>\uD83C\uDF19  <strong>Book anytime -</strong> even after hours</li>\\n  <li>\uD83D\uDDD3\uFE0F  <strong>Pick an appointment time that suits you</strong></li>\\n  <li>\uD83D\uDD10  <strong>No paperwork -</strong> secure and accurate</li>\\n</ul>","declineButtonLabel":"Decline this invitation to book now","declineText":"<h3>Not expecting or wanting this procedure?</h3> <p>Let us know by selecting a reason:</p>","helpMessage":"<h3>Prefer to speak with someone?</h3><p>Our friendly team is happy to help:<br/><a><strong>\u260E\uFE0F {{phone}}</strong></a> (then press <strong>Option 2</strong>)<br/>Monday to Friday, 8am\u20135pm.</p>","info":"<h3>Want to know more about this procedure?</h3><p>Watch a short video that explains what to expect and how to prepare.</p>","select":{"badTiming":"Timing not convenient","cantAfford":"Can\'t afford right now","didntKnowReferred":"Didn\'t know I\'d been referred","hadElsewhere":"Have already had elsewhere","notNecessary":"Don\'t think it\'s necessary","placeholder":"Select a reason"},"text":"<p>Your {{requestingPractitioner.practitionerRole}}, <strong>{{requestingPractitioner.displayName}}</strong>, has referred you for a <strong>{{procedure.displayName}}</strong> with <strong>{{practitioners.0.name}}</strong>.</p>","textNoSpecialist":"<p>Your {{requestingPractitioner.practitionerRole}}, <strong>{{requestingPractitioner.displayName}}</strong>, has referred you for a <strong>{{procedure.displayName}}</strong>.</p>","title":"Hi {{patient.nameGiven}}. <br /> It\u2019s time to book your procedure.","videoButtonLabel":"Play video about having an endoscopy procedure","videoCaption":"We recommend watching this video before booking.","videos":{"COL":"FKpCAiLuhM01tRghlmeHKuEuJTvjt2kkKitGXJcJN02Xc","GAS":"41GTp01UgOlonZITzkM6Hbo01GadM87pbsNhM00TmEqch4","TNT":"A5Oh2HoSOhkfPxW6cG0197Ev1bbDX014TDM9pNJvNEdxs","fallback":"41GTp01UgOlonZITzkM6Hbo01GadM87pbsNhM00TmEqch4"}}');


var $76e4baf9d41bc5fb$exports = {};
$76e4baf9d41bc5fb$exports = JSON.parse('{"birthDate":"Your date of birth","dateFormat":"dd/mm/yyyy","familyName":"Your FAMILY name","helpMessage":"<p>If the number above doesn\u2019t look right, or you\u2019re unsure what to do, please call us on <a><strong>{{phone}}</strong></a> (then press <strong>Option 2</strong>).</p>","sendCode":"Send code","text":"<p>This booking invitation is for a patient with the mobile number: <strong><PhonePlaceholder /></strong></p><p>If this is you, please enter your <strong>family name</strong> and <strong>date of birth</strong> below and click the button.</p><p>For security, we\u2019ll text you a one-time <strong>4-digit code</strong> to verify your identity.</p>","text-caregiver":"<p>This booking invitation is for a patient who is being cared for by someone with the mobile number: <strong><PhonePlaceholder /></strong></p><p>If this is you, please enter the <strong>patient\u2019s family name</strong> and <strong>date of birth</strong> below and click the button.</p><p>For security, we\u2019ll text you a one-time <strong>4-digit code</strong> to verify your identity.</p>","title":"Welcome to <strong>{{company}} Online Booking</strong>"}');


var $6db58658cfb9a210$exports = {};
$6db58658cfb9a210$exports = JSON.parse('{"bookmarksMenu":"\u092E\u0947\u0928\u0942","change":"\u092C\u0926\u0932\u0947\u0902","closeBookmarksMenu":"\u092E\u0947\u0928\u0942 \u092C\u0902\u0926 \u0915\u0930\u0947\u0902","closeDialog":"\u092C\u0902\u0926 \u0915\u0930\u0947\u0902","colonoscopy":"\u0915\u094B\u0932\u094B\u0928\u094B\u0938\u094D\u0915\u094B\u092A\u0940 (colonoscopy)","continue":"\u091C\u093E\u0930\u0940 \u0930\u0916\u0947\u0902","details":"\u0935\u093F\u0935\u0930\u0923","errors":{"invalidOtp":{"details":"<ul>  \\n<li>\u0915\u0943\u092A\u092F\u093E \u0915\u094B\u0908 \u0935\u0930\u094D\u0924\u0928\u0940 \u0915\u0940 \u0917\u0932\u0924\u0940 \u0939\u094B \u0924\u094B \u091C\u093E\u0902\u091A\u0947\u0902 \u0914\u0930 \u092B\u093F\u0930 \u0938\u0947 \u092A\u094D\u0930\u092F\u093E\u0938 \u0915\u0930\u0947\u0902\u0964</li>  \\n<li>\u0905\u0917\u0930 \u0906\u092A \u0905\u091F\u0915 \u0917\u090F \u0939\u0948\u0902, \u0924\u094B \u0915\u0943\u092A\u092F\u093E \u0939\u092E\u0947\u0902 {{phone}} \u092A\u0930 \u0915\u0949\u0932 \u0915\u0930\u0947\u0902 (\u092B\u093F\u0930 Option 2 \u0926\u092C\u093E\u090F\u0901)\u0964</li>  \\n</ul>","title":"\u092F\u0939 \u0939\u092E\u093E\u0930\u0940 \u0930\u093F\u0915\u0949\u0930\u094D\u0921\u094D\u0938 \u0938\u0947 \u092E\u0947\u0932 \u0928\u0939\u0940\u0902 \u0916\u093E\u0924\u093E"},"serverErrorOtp":{"details":"<ul>  \\n<li>\u0906\u092A\u0915\u0940 \u091C\u093E\u0928\u0915\u093E\u0930\u0940 \u0938\u0939\u0940 \u0939\u094B \u0938\u0915\u0924\u0940 \u0939\u0948 \u2013 \u0932\u0947\u0915\u093F\u0928 \u0939\u092E \u0905\u092D\u0940 \u0909\u0928\u094D\u0939\u0947\u0902 \u0938\u0924\u094D\u092F\u093E\u092A\u093F\u0924 \u0928\u0939\u0940\u0902 \u0915\u0930 \u092A\u093E\u090F\u0964</li>  \\n<li>\u0915\u0943\u092A\u092F\u093E \u090F\u0915 \u0915\u094D\u0937\u0923 \u092A\u094D\u0930\u0924\u0940\u0915\u094D\u0937\u093E \u0915\u0930\u0947\u0902 \u0914\u0930 \u092B\u093F\u0930 \u0938\u0947 \u092A\u094D\u0930\u092F\u093E\u0938 \u0915\u0930\u0947\u0902\u0964</li>  \\n</ul>","title":"\u0915\u0941\u091B \u0917\u0932\u0924 \u0939\u094B \u0917\u092F\u093E\u0964"}},"formattedDate":"{{date}} \u0915\u094B {{time}} \u092C\u091C\u0947","gastroscopy":"\u0917\u0948\u0938\u094D\u091F\u094D\u0930\u094B\u0938\u094D\u0915\u094B\u092A\u0940 (gastroscopy)","loading":"\u0932\u094B\u0921 \u0939\u094B \u0930\u0939\u093E \u0939\u0948...","next":"\u0906\u0917\u0947","no":"\u0928\u0939\u0940\u0902","openBookmarksMenu":"\u092E\u0947\u0928\u0942 \u0916\u094B\u0932\u0947\u0902","optional":"\u0935\u0948\u0915\u0932\u094D\u092A\u093F\u0915","progress":"\u092A\u094D\u0930\u0917\u0924\u093F {{progress}}%","selectLanguage":"\u092D\u093E\u0937\u093E \u091A\u0941\u0928\u0947\u0902","step":{"appointment":"\u0905\u092A\u0949\u0907\u0902\u091F\u092E\u0947\u0902\u091F \u0915\u093E \u0938\u092E\u092F","details":"\u0935\u094D\u092F\u0915\u094D\u0924\u093F\u0917\u0924 \u0935\u093F\u0935\u0930\u0923","health-questions":"\u0938\u094D\u0935\u093E\u0938\u094D\u0925\u094D\u092F \u0938\u0902\u092C\u0902\u0927\u0940 \u092A\u094D\u0930\u0936\u094D\u0928","history":"\u092A\u0942\u0930\u094D\u0935 \u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E\u090F\u0902 \u092F\u093E \u0938\u0930\u094D\u091C\u0930\u0940","insurance":"\u0938\u094D\u0935\u093E\u0938\u094D\u0925\u094D\u092F \u092C\u0940\u092E\u093E","medications":"\u0926\u0935\u093E\u0907\u092F\u093E\u0902","preference-questions":"\u092A\u0938\u0902\u0926 \u0938\u0947 \u0938\u0902\u092C\u0902\u0927\u093F\u0924 \u092A\u094D\u0930\u0936\u094D\u0928","specialist":"\u0935\u093F\u0936\u0947\u0937\u091C\u094D\u091E"},"videoUnsupported":"\u0906\u092A\u0915\u093E \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0935\u0940\u0921\u093F\u092F\u094B \u091F\u0948\u0917 \u0915\u093E \u0938\u092E\u0930\u094D\u0925\u0928 \u0928\u0939\u0940\u0902 \u0915\u0930\u0924\u093E \u0939\u0948\u0964","yes":"\u0939\u093E\u0901","yesTo":"\u0939\u093E\u0901, \u0907\u0938\u0915\u0947 \u0932\u093F\u090F","yourProgress":"\u0906\u092A\u0915\u0940 \u092A\u094D\u0930\u0917\u0924\u093F"}');


var $8d0b70eeb74fc1f1$exports = {};
$8d0b70eeb74fc1f1$exports = JSON.parse('{"comingSoonText":"<p>\u0906\u092A\u0928\u0947 \u0926\u0947\u0916\u093E \u0939\u094B\u0917\u093E \u0915\u093F \u0906\u091C \u0938\u0947 \u0915\u092E \u0938\u0947 \u0915\u092E \u090F\u0915 \u0938\u092A\u094D\u0924\u093E\u0939 \u0924\u0915 \u0915\u094B\u0908 \u0905\u092A\u0949\u0907\u0902\u091F\u092E\u0947\u0902\u091F \u0909\u092A\u0932\u092C\u094D\u0927 \u0928\u0939\u0940\u0902 \u0925\u093E\u0964</p>\\n<p>\u0915\u092D\u0940-\u0915\u092D\u0940 \u0930\u0926\u094D\u0926\u0940\u0915\u0930\u0923 \u0915\u0947 \u0915\u093E\u0930\u0923 \u092A\u0939\u0932\u0947 \u0915\u0947 \u0938\u092E\u092F \u0909\u092A\u0932\u092C\u094D\u0927 \u0939\u094B \u091C\u093E\u0924\u0947 \u0939\u0948\u0902\u0964</p>\\n<p>\u0905\u0917\u0930 \u0915\u094B\u0908 \u091C\u0932\u094D\u0926\u0940 \u0915\u093E \u0938\u092E\u092F \u0909\u092A\u0932\u092C\u094D\u0927 \u0939\u094B \u091C\u093E\u090F \u0924\u094B \u0915\u094D\u092F\u093E \u0906\u092A \u091A\u093E\u0939\u0924\u0947 \u0939\u0948\u0902 \u0915\u093F \u0939\u092E \u0906\u092A\u0938\u0947 \u0938\u0902\u092A\u0930\u094D\u0915 \u0915\u0930\u0947\u0902?</p>\\n<p>\u092C\u0926\u0932\u0928\u0947 \u0915\u093E \u0915\u094B\u0908 \u0926\u092C\u093E\u0935 \u0928\u0939\u0940\u0902 \u0939\u0948 \u2014 \u092F\u0926\u093F \u0935\u0930\u094D\u0924\u092E\u093E\u0928 \u0938\u092E\u092F \u0906\u092A\u0915\u0947 \u0932\u093F\u090F \u0920\u0940\u0915 \u0939\u0948, \u0924\u094B \u0906\u092A \u0909\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u092C\u0928\u0947 \u0930\u0939 \u0938\u0915\u0924\u0947 \u0939\u0948\u0902\u0964</p>","comingSoonTitle":"\u0915\u094D\u092F\u093E \u0906\u092A \u091C\u0932\u094D\u0926\u0940 \u0906\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0924\u0948\u092F\u093E\u0930 \u0939\u0948\u0902?","contactConsent":{"no":"\u0928\u0939\u0940\u0902 \u2013 \u092E\u0948\u0902 \u0905\u092A\u0928\u0940 \u091A\u0941\u0928\u0940 \u0939\u0941\u0908 \u0938\u092E\u092F-\u0938\u093E\u0930\u0923\u0940 \u092A\u0930 \u0939\u0940 \u0930\u0939\u0942\u0902\u0917\u093E","yes":"\u0939\u093E\u0901 \u2013 \u092E\u0941\u091D\u0947 \u0938\u0902\u092A\u0930\u094D\u0915 \u0915\u0930\u0928\u0947 \u092E\u0947\u0902 \u0915\u094B\u0908 \u0906\u092A\u0924\u094D\u0924\u093F \u0928\u0939\u0940\u0902 \u0939\u0948"},"contactConsentDetails":{"no":"\u0939\u092E \u0906\u092A\u0915\u094B \u092A\u0939\u0932\u0947 \u0938\u092E\u092F\u094B\u0902 \u0915\u0947 \u092C\u093E\u0930\u0947 \u092E\u0947\u0902 \u0938\u0902\u092A\u0930\u094D\u0915 \u0928\u0939\u0940\u0902 \u0915\u0930\u0947\u0902\u0917\u0947\u0964","yes":"\u0905\u0917\u0930 \u0915\u094B\u0908 \u092A\u0939\u0932\u0947 \u0915\u093E \u0938\u092E\u092F \u0909\u092A\u0932\u092C\u094D\u0927 \u0939\u094B\u0924\u093E \u0939\u0948 \u0924\u094B \u0939\u092E \u0906\u092A\u0915\u094B \u0938\u0942\u091A\u093F\u0924 \u0915\u0930\u0947\u0902\u0917\u0947\u0964"},"description":"<p>\u0905\u092C \u0906\u092A\u0915\u0947 \u092A\u093E\u0938 \u0905\u092A\u0928\u0940 \u092C\u0941\u0915\u093F\u0902\u0917 \u092A\u0942\u0930\u0940 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F <strong>{{deadlineText}}</strong> \u0924\u0915 \u0915\u093E \u0938\u092E\u092F \u0939\u0948 \u2013 \u092F\u093E\u0928\u0940 \u0932\u0917\u092D\u0917 <b>{{deadlineTime}} \u0918\u0902\u091F\u0947</b>\u0964</p>\\n<span>\u092A\u0942\u0930\u093E \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F, \u0939\u092E\u0947\u0902 \u0906\u092A\u0938\u0947 \u092F\u0947 \u091A\u0940\u091C\u093C\u0947\u0902 \u091A\u093E\u0939\u093F\u090F:</span>\\n<ul>\\n  <li><strong>\u0905\u092A\u0928\u0947 \u092E\u0930\u0940\u091C\u093C \u0915\u0940 \u091C\u093E\u0928\u0915\u093E\u0930\u0940</strong> \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u092F\u093E \u0909\u0938\u092E\u0947\u0902 \u091C\u094B\u0921\u093C\u0947\u0902</li>\\n  <li><strong>\u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u0930\u0928\u0947 \u0935\u093E\u0932\u093E \u0915\u094C\u0928 \u0939\u0948</strong> (\u091C\u0948\u0938\u0947 \u0915\u093F \u092C\u0940\u092E\u093E) \u092F\u0939 \u092C\u0924\u093E\u090F\u0902</li>\\n  <li><strong>\u0938\u094D\u0935\u093E\u0938\u094D\u0925\u094D\u092F \u0914\u0930 \u092A\u0938\u0902\u0926 \u0938\u0947 \u091C\u0941\u0921\u093C\u0947 \u092A\u094D\u0930\u0936\u094D\u0928\u094B\u0902</strong> \u0915\u0947 \u0909\u0924\u094D\u0924\u0930 \u0926\u0947\u0902</li>\\n</ul>\\n<p>\u092F\u0939 \u0906\u092E\u0924\u094C\u0930 \u092A\u0930 <strong>12 \u092E\u093F\u0928\u091F</strong> \u0938\u0947 \u092D\u0940 \u0915\u092E \u0938\u092E\u092F \u0932\u0947\u0924\u093E \u0939\u0948\u0964</p>","nextLabel":"$t(common:next): <b>\u0905\u092A\u0928\u0940 \u091C\u093E\u0928\u0915\u093E\u0930\u0940 \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902</b>","text":"<p><strong>{{appointment.date}}</strong> \u0915\u094B <strong>{{appointment.time}}</strong> \u092C\u091C\u0947 <strong>{{appointment.specialist}}</strong> \u0915\u0947 \u0938\u093E\u0925 \u0906\u092A\u0915\u0940 <strong>{{procedure.displayName}}</strong> <Status>\u0905\u0938\u094D\u0925\u093E\u092F\u0940 \u0930\u0942\u092A \u0938\u0947 \u0906\u0930\u0915\u094D\u0937\u093F\u0924</Status> \u0915\u0930 \u0926\u0940 \u0917\u0908 \u0939\u0948\u0964</p>","title":"\u0906\u092A\u0915\u0940 \u0905\u092A\u0949\u0907\u0902\u091F\u092E\u0947\u0902\u091F \u0906\u0930\u0915\u094D\u0937\u093F\u0924 \u0915\u0930 \u0926\u0940 \u0917\u0908 \u0939\u0948"}');


var $6a6f26e972b148f8$exports = {};
$6a6f26e972b148f8$exports = JSON.parse('{"modal":{"buttonLabel":"\u0928\u092F\u093E \u0938\u092E\u092F \u091A\u0941\u0928\u0947\u0902","text":"\u0915\u093F\u0938\u0940 \u0914\u0930 \u0928\u0947 \u0905\u092D\u0940-\u0905\u092D\u0940 \u0935\u0939 \u0938\u092E\u092F \u092C\u0941\u0915 \u0915\u0930 \u0932\u093F\u092F\u093E \u0939\u0948\u0964","title":"\u092C\u0938 \u091B\u0942\u091F \u0917\u092F\u093E!"},"nextLabel":"$t(common:next): <b>\u0905\u092A\u0949\u0907\u0902\u091F\u092E\u0947\u0902\u091F \u0938\u092E\u092F \u0906\u0930\u0915\u094D\u0937\u093F\u0924 \u0915\u0930\u0947\u0902</b>","nextWeek":"\u0905\u0917\u0932\u0947 \u0938\u092A\u094D\u0924\u093E\u0939","noTimeText":"\u091A\u092F\u0928\u093F\u0924 \u0924\u093F\u0925\u093F \u0915\u0947 \u0932\u093F\u090F \u0915\u094B\u0908 \u0938\u092E\u092F \u0909\u092A\u0932\u092C\u094D\u0927 \u0928\u0939\u0940\u0902 \u0939\u0948\u0964","prevWeek":"\u092A\u093F\u091B\u0932\u093E \u0938\u092A\u094D\u0924\u093E\u0939","title":"\u0905\u092A\u0928\u093E \u0905\u092A\u0949\u0907\u0902\u091F\u092E\u0947\u0902\u091F \u0938\u092E\u092F \u091A\u0941\u0928\u0947\u0902"}');


var $857b6de68c05f329$exports = {};
$857b6de68c05f329$exports = JSON.parse('{"helpMessage":"<p>\u092F\u0926\u093F \u0906\u092A\u0915\u094B \u0915\u094B\u0908 \u0938\u092E\u0938\u094D\u092F\u093E \u0939\u094B \u0930\u0939\u0940 \u0939\u0948, \u0924\u094B \u0915\u0943\u092A\u092F\u093E <a><strong>{{phone}}</strong></a> \u092A\u0930 \u0915\u0949\u0932 \u0915\u0930\u0947\u0902 (\u092B\u093F\u0930 <strong>\u0935\u093F\u0915\u0932\u094D\u092A 2</strong> \u0926\u092C\u093E\u090F\u0902)\u0964</p>","noCode":"\u0915\u094B\u0921 \u0928\u0939\u0940\u0902 \u092E\u093F\u0932\u093E?","remainingTime":"{{time}} \u0936\u0947\u0937","sendCode":"\u0928\u092F\u093E \u0915\u094B\u0921 \u092D\u0947\u091C\u0947\u0902","text":"<p>\u0939\u092E\u0928\u0947 \u0906\u092A\u0915\u0947 \u092E\u094B\u092C\u093E\u0907\u0932 \u0928\u0902\u092C\u0930 <strong><PhonePlaceholder /></strong> \u092A\u0930 \u090F\u0915 4-\u0905\u0902\u0915\u0940\u092F \u0915\u094B\u0921 \u092D\u0947\u091C\u093E \u0939\u0948\u0964</p>\\n<p>\u092F\u0939 \u0915\u094B\u0921 {{validityMinutes}} \u092E\u093F\u0928\u091F \u0924\u0915 \u092E\u093E\u0928\u094D\u092F \u0939\u0948\u0964</p>\\n<p>\u091C\u093E\u0930\u0940 \u0930\u0916\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0915\u0943\u092A\u092F\u093E \u0928\u0940\u091A\u0947 \u0915\u094B\u0921 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902\u0964</p>","title":"\u0905\u092A\u0928\u093E \u0915\u094B\u0921 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902"}');


var $e606d7b1a241cca2$exports = {};
$e606d7b1a241cca2$exports = JSON.parse('{"calendarButtonLabel":"\u0915\u0948\u0932\u0947\u0902\u0921\u0930 \u092E\u0947\u0902 \u091C\u094B\u0921\u093C\u0947\u0902","confirmationText":"<h3>24 \u0918\u0902\u091F\u094B\u0902 \u0915\u0947 \u092D\u0940\u0924\u0930 \u090F\u0915 \u0908\u092E\u0947\u0932 \u0915\u0940 \u0905\u092A\u0947\u0915\u094D\u0937\u093E \u0915\u0930\u0947\u0902:</h3>\\n<ul>\\n  <li>\u2705  \u0905\u092A\u0949\u0907\u0902\u091F\u092E\u0947\u0902\u091F \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F</li>\\n  <li>\uD83D\uDCB2  \u0906\u092A\u0915\u0947 \u092C\u0940\u092E\u093E\u0915\u0930\u094D\u0924\u093E \u0915\u0947 \u0932\u093F\u090F \u0905\u0928\u0941\u092E\u093E\u0928</li>\\n  <li></li>\\n  <li>\uD83E\uDD64  \u0924\u0948\u092F\u093E\u0930\u0940 \u0915\u0947 \u0928\u093F\u0930\u094D\u0926\u0947\u0936</li>\\n  <li>\uD83C\uDFE5  \u0906\u0928\u0947 \u0915\u0940 \u091C\u093E\u0928\u0915\u093E\u0930\u0940 (\u0926\u093F\u0936\u093E-\u0928\u093F\u0930\u094D\u0926\u0947\u0936, \u092A\u093E\u0930\u094D\u0915\u093F\u0902\u0917 \u0906\u0926\u093F)</li>\\n  <li>\uD83D\uDC8A  \u0924\u0948\u092F\u093E\u0930\u0940 \u0915\u0940 \u0926\u0935\u093E</li>\\n</ul>\\n<p>\u0939\u092E \u0906\u092A\u0915\u0947 \u0938\u094D\u0935\u093E\u0938\u094D\u0925\u094D\u092F \u0909\u0924\u094D\u0924\u0930\u094B\u0902 \u0915\u0940 \u0938\u092E\u0940\u0915\u094D\u0937\u093E \u0915\u0930\u0947\u0902\u0917\u0947, \u0914\u0930 \u092F\u0926\u093F \u091C\u093C\u0930\u0942\u0930\u0924 \u0939\u094B \u0924\u094B \u0939\u092E\u093E\u0930\u0940 \u091F\u0940\u092E \u0915\u093E \u0915\u094B\u0908 \u0938\u0926\u0938\u094D\u092F \u0906\u092A\u0915\u0940 \u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u0938\u0947 \u092A\u0939\u0932\u0947 \u0906\u092A\u0938\u0947 \u0938\u0902\u092A\u0930\u094D\u0915 \u0915\u0930\u0947\u0917\u093E\u0964</p>","helpMessage":"<h3>\u0938\u0902\u092A\u0930\u094D\u0915 \u0915\u0930\u0947\u0902</h3>\\n<p>\u092F\u0926\u093F \u0906\u092A\u0915\u0947 \u0915\u094B\u0908 \u092A\u094D\u0930\u0936\u094D\u0928 \u0939\u0948\u0902 \u092F\u093E \u092C\u0926\u0932\u093E\u0935 \u0915\u0930\u0928\u0947 \u0915\u0940 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E \u0939\u0948, \u0924\u094B \u0939\u092E\u093E\u0930\u0940 \u0938\u0939\u093E\u092F\u0924\u093E \u091F\u0940\u092E \u0915\u094B \u0915\u0949\u0932 \u0915\u0930\u0947\u0902:<br/>\\n<a><strong>\u260E\uFE0F {{phone}}</strong></a> (\u092B\u093F\u0930 <strong>\u0935\u093F\u0915\u0932\u094D\u092A 2</strong> \u0926\u092C\u093E\u090F\u0902)<br/>\\n\u0938\u094B\u092E\u0935\u093E\u0930 \u0938\u0947 \u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930, \u0938\u0941\u092C\u0939 8 \u0938\u0947 \u0936\u093E\u092E 5 \u092C\u091C\u0947 \u0924\u0915\u0964</p>\\n<p><em>\u0939\u092E\u093E\u0930\u0940 \u091F\u0940\u092E \u0915\u0947\u0935\u0932 \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092C\u094B\u0932 \u0938\u0915\u0924\u0940 \u0939\u0948 \u2014 \u0906\u092A\u0915\u0940 \u0938\u092E\u091D\u0926\u093E\u0930\u0940 \u0915\u0947 \u0932\u093F\u090F \u0927\u0928\u094D\u092F\u0935\u093E\u0926\u0964</em></p>","text":"<p>\u0906\u092A\u0915\u0940 <strong>{{procedure.displayName}}</strong> <strong>{{appointment.specialist}}</strong> \u0915\u0947 \u0938\u093E\u0925 <strong>{{appointment.date}}</strong> \u0915\u094B <strong>{{appointment.time}}</strong> \u092A\u0930 <Status>\u092A\u0941\u0937\u094D\u091F</Status> \u0939\u094B \u0917\u0908 \u0939\u0948\u0964</p>","title":"\u0927\u0928\u094D\u092F\u0935\u093E\u0926 {{patient.nameGiven}}! <br/> \u0905\u092D\u0940 \u0915\u0947 \u0932\u093F\u090F \u0939\u092E\u0947\u0902 \u092C\u0938 \u0907\u0924\u0928\u0940 \u0939\u0940 \u091C\u093E\u0928\u0915\u093E\u0930\u0940 \u091A\u093E\u0939\u093F\u090F \u0925\u0940\u0964"}');


var $a28f53f5052b201d$exports = {};
$a28f53f5052b201d$exports = JSON.parse('{"contact-details":{"email":"\u0908\u092E\u0947\u0932 \u092A\u0924\u093E","mobilePhone":"\u092E\u094B\u092C\u093E\u0907\u0932 \u092B\u093C\u094B\u0928","nextLabel":"$t(common:next): <b>\u0906\u092A\u0915\u0947 \u091C\u0940\u092A\u0940 (\u0921\u0949\u0915\u094D\u091F\u0930)</b>","otherPhone":"\u0905\u0928\u094D\u092F \u092B\u093C\u094B\u0928","text":"\u0939\u092E \u0906\u092A\u0938\u0947 \u0938\u0902\u092A\u0930\u094D\u0915 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0907\u0928 \u0935\u093F\u0935\u0930\u0923\u094B\u0902 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930 \u0930\u0939\u0947 \u0939\u0948\u0902, \u0932\u0947\u0915\u093F\u0928 \u092F\u0926\u093F \u0906\u0935\u0936\u094D\u092F\u0915 \u0939\u094B \u0924\u094B \u0906\u092A \u0907\u0928\u094D\u0939\u0947\u0902 \u0905\u092A\u0921\u0947\u091F \u0915\u0930 \u0938\u0915\u0924\u0947 \u0939\u0948\u0902\u0964","title":"\u0906\u092A\u0915\u0940 \u0938\u0902\u092A\u0930\u094D\u0915 \u091C\u093E\u0928\u0915\u093E\u0930\u0940"},"doctor":{"gp":"\u091C\u0940\u092A\u0940 (\u0921\u0949\u0915\u094D\u091F\u0930) \u0915\u093E \u0928\u093E\u092E","manually":"\u0921\u0949\u0915\u094D\u091F\u0930 \u0926\u093F\u0916\u093E\u0908 \u0928\u0939\u0940\u0902 \u0926\u0947 \u0930\u0939\u093E \u0939\u0948? <PrimaryText>\u0907\u0938\u0947 \u092E\u0948\u0928\u094D\u092F\u0941\u0905\u0932\u0940 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902...</PrimaryText>","medicalCentre":"\u091A\u093F\u0915\u093F\u0924\u094D\u0938\u093E \u0915\u0947\u0902\u0926\u094D\u0930","nextLabel":"$t(common:next): <b>\u0906\u092A\u0915\u093E \u0906\u092A\u093E\u0924\u0915\u093E\u0932\u0940\u0928 \u0938\u0902\u092A\u0930\u094D\u0915</b>","searchPlaceholder":"\u0905\u092A\u0928\u0947 \u091C\u0940\u092A\u0940 \u092F\u093E \u091A\u093F\u0915\u093F\u0924\u094D\u0938\u093E \u0915\u0947\u0902\u0926\u094D\u0930 \u0915\u0940 \u0916\u094B\u091C \u0915\u0930\u0947\u0902","text":"\u0915\u094D\u092F\u093E \u092F\u0939 \u0906\u092A\u0915\u0947 \u091C\u0940\u092A\u0940 \u0939\u0948\u0902? \u092F\u0926\u093F \u0928\u0939\u0940\u0902, \u0924\u094B \u0915\u0943\u092A\u092F\u093E \u0905\u092A\u0921\u0947\u091F \u0915\u0930\u0947\u0902\u0964","title":"\u0906\u092A\u0915\u0947 \u091C\u0940\u092A\u0940 (\u0921\u0949\u0915\u094D\u091F\u0930)"},"emergency":{"fullName":"\u092A\u0942\u0930\u093E \u0928\u093E\u092E","mobileNumber":"\u092E\u094B\u092C\u093E\u0907\u0932 \u0928\u0902\u092C\u0930","nextLabel":"$t(common:next): <b>\u092C\u0940\u092E\u093E / \u0915\u094C\u0928 \u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u0930 \u0930\u0939\u093E \u0939\u0948</b>","relationship":"\u0906\u092A\u0938\u0947 \u0938\u0902\u092C\u0902\u0927","select":{"child":"\u092C\u091A\u094D\u091A\u093E","friend":"\u092E\u093F\u0924\u094D\u0930","other":"\u0905\u0928\u094D\u092F","parent":"\u092E\u093E\u0924\u093E-\u092A\u093F\u0924\u093E","spouse":"\u092A\u0924\u093F / \u092A\u0924\u094D\u0928\u0940 \u092F\u093E \u0938\u093E\u0925\u0940"},"text":"\u0906\u092A\u093E\u0924 \u0938\u094D\u0925\u093F\u0924\u093F \u092E\u0947\u0902 \u0939\u092E \u0915\u093F\u0938\u0938\u0947 \u0938\u0902\u092A\u0930\u094D\u0915 \u0915\u0930\u0947\u0902?","title":"\u0906\u092A\u093E\u0924\u0915\u093E\u0932\u0940\u0928 \u0938\u0902\u092A\u0930\u094D\u0915"},"home-address":{"building":"\u0907\u092E\u093E\u0930\u0924 \u092F\u093E \u0909\u092A\u0916\u0902\u0921 \u0915\u093E \u0938\u094D\u0924\u0930, \u092E\u0902\u091C\u093C\u093F\u0932 \u092F\u093E \u0907\u0915\u093E\u0908","city":"\u0936\u0939\u0930 / \u0928\u0917\u0930","manually":"\u092A\u0924\u093E \u0928\u0939\u0940\u0902 \u0926\u093F\u0916 \u0930\u0939\u093E \u0939\u0948? <PrimaryText>\u0907\u0938\u0947 \u092E\u0948\u0928\u094D\u092F\u0941\u0905\u0932\u0940 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902...</PrimaryText>","nextLabel":"$t(common:next): <b>\u0906\u092A\u0915\u0940 \u0938\u0902\u092A\u0930\u094D\u0915 \u091C\u093E\u0928\u0915\u093E\u0930\u0940</b>","postcode":"\u092A\u093F\u0928 \u0915\u094B\u0921","searchPlaceholder":"\u0928\u094D\u092F\u0942\u091C\u093C\u0940\u0932\u0948\u0902\u0921 \u092E\u0947\u0902 \u092A\u0924\u093E \u0916\u094B\u091C\u0947\u0902","street":"\u0938\u0921\u093C\u0915 \u0915\u093E \u0928\u093E\u092E \u0914\u0930 \u0928\u0902\u092C\u0930","suburb":"\u0909\u092A\u0928\u0917\u0930 \u092F\u093E \u0906\u0930\u0921\u0940 (\u0917\u094D\u0930\u093E\u092E\u0940\u0923 \u0921\u093F\u0932\u0940\u0935\u0930\u0940)","text":"\u0915\u0943\u092A\u092F\u093E \u0905\u092A\u0928\u093E \u0918\u0930 \u0915\u093E \u092A\u0924\u093E \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902:","textSecondary":"\u092F\u0939 \u092A\u0924\u093E \u0939\u0948 \u091C\u093F\u0938\u0915\u093E \u0939\u092E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0947\u0902\u0917\u0947:","title":"\u0906\u092A\u0915\u093E \u0918\u0930 \u0915\u093E \u092A\u0924\u093E"},"name-birthdate":{"birthDate":"\u091C\u0928\u094D\u092E \u0924\u093F\u0925\u093F","dateFormat":"dd/mm/yyyy","familyName":"\u092A\u0930\u093F\u0935\u093E\u0930 \u0915\u093E \u0928\u093E\u092E:","firstName":"\u092A\u0939\u0932\u093E \u0928\u093E\u092E (\u0928\u093E\u092E)","nextLabel":"$t(common:next): <b>\u0906\u092A\u0915\u093E NHI \u0914\u0930 \u0928\u093F\u0935\u093E\u0938 \u0938\u094D\u0925\u093F\u0924\u093F</b>","preferredName":"\u092A\u0938\u0902\u0926\u0940\u0926\u093E \u0928\u093E\u092E","select":{"label":"\u0909\u092A\u093E\u0927\u093F","mr":"Mr","ms":"Ms","mx":"Mx","placeholder":"\u0905\u092A\u0928\u093E \u0909\u092A\u093E\u0927\u093F \u091A\u0941\u0928\u0947\u0902"},"text":"\u0915\u0943\u092A\u092F\u093E \u0907\u0928 \u0935\u093F\u0935\u0930\u0923\u094B\u0902 \u0915\u0940 \u091C\u093E\u0902\u091A \u0915\u0930\u0947\u0902 \u0914\u0930 \u091C\u094B \u092D\u0940 \u0917\u093C\u0932\u0924 \u092F\u093E \u0905\u0927\u0942\u0930\u093E \u0939\u094B, \u0909\u0938\u0947 \u0905\u092A\u0921\u0947\u091F \u0915\u0930\u0947\u0902:","title":"\u0906\u092A\u0915\u093E \u0928\u093E\u092E \u0914\u0930 \u091C\u0928\u094D\u092E\u0924\u093F\u0925\u093F"},"nhi-residency":{"nextLabel":"$t(common:next): <b>\u0906\u092A\u0915\u093E \u0918\u0930 \u0915\u093E \u092A\u0924\u093E</b>","nhiNumber":"NHI \u0928\u0902\u092C\u0930 (\u0930\u093E\u0937\u094D\u091F\u094D\u0930\u0940\u092F \u0938\u094D\u0935\u093E\u0938\u094D\u0925\u094D\u092F \u0938\u0942\u091A\u0915\u093E\u0902\u0915 \u0938\u0902\u0916\u094D\u092F\u093E)","resident":"\u0915\u094D\u092F\u093E \u0906\u092A \u0928\u094D\u092F\u0942\u091C\u093C\u0940\u0932\u0948\u0902\u0921 \u0915\u0947 \u0928\u093F\u0935\u093E\u0938\u0940 \u0939\u0948\u0902?","residentText":"\u092F\u0926\u093F \u0906\u092A \u0928\u094D\u092F\u0942\u091C\u093C\u0940\u0932\u0948\u0902\u0921 \u0915\u0947 \u0928\u093F\u0935\u093E\u0938\u0940 \u0928\u0939\u0940\u0902 \u0939\u0948\u0902, \u0924\u094B \u0906\u092A\u0915\u094B \u0915\u0941\u091B \u0938\u0947\u0935\u093E\u0913\u0902 \u091C\u0948\u0938\u0947 \u0915\u093F \u0932\u0948\u092C \u091C\u093E\u0902\u091A \u0915\u0947 \u0932\u093F\u090F \u0936\u0941\u0932\u094D\u0915 \u0932\u093F\u092F\u093E \u091C\u093E \u0938\u0915\u0924\u093E \u0939\u0948\u0964","text":"\u0915\u0943\u092A\u092F\u093E \u091C\u093E\u0902\u091A\u0947\u0902 \u0914\u0930 \u0915\u094B\u0908 \u092D\u0940 \u0917\u0941\u092E \u092F\u093E \u0917\u0932\u0924 \u091C\u093E\u0928\u0915\u093E\u0930\u0940 \u0905\u092A\u0921\u0947\u091F \u0915\u0930\u0947\u0902:","title":"\u0906\u092A\u0915\u093E NHI \u0914\u0930 \u0928\u093F\u0935\u093E\u0938 \u0938\u094D\u0925\u093F\u0924\u093F"}}');


var $de3a341757f0f952$exports = {};
$de3a341757f0f952$exports = JSON.parse('{"code":"\u0906\u092E\u0902\u0924\u094D\u0930\u0923 \u0915\u094B\u0921","error":{"details":"<ul>  \\n<li>\u0915\u0943\u092A\u092F\u093E \u0915\u093F\u0938\u0940 \u092D\u0940 \u091F\u093E\u0907\u092A\u094B \u0915\u0940 \u091C\u093E\u0902\u091A \u0915\u0930\u0947\u0902 \u0914\u0930 \u092B\u093F\u0930 \u0938\u0947 \u092A\u094D\u0930\u092F\u093E\u0938 \u0915\u0930\u0947\u0902\u0964</li>  \\n<li>\u0905\u0917\u0930 \u0906\u092A \u0905\u091F\u0915 \u0917\u090F \u0939\u0948\u0902, \u0924\u094B \u0939\u092E\u0947\u0902 \u0907\u0938 \u0928\u0902\u092C\u0930 \u092A\u0930 \u0915\u0949\u0932 \u0915\u0930\u0947\u0902: {{phone}} (\u092B\u093F\u0930 \u0935\u093F\u0915\u0932\u094D\u092A 2 \u0926\u092C\u093E\u090F\u0902)\u0964</li>  \\n</ul>","title":"\u092F\u0939 \u0906\u092E\u0902\u0924\u094D\u0930\u0923 \u0915\u094B\u0921 \u0915\u093E\u092E \u0928\u0939\u0940\u0902 \u0915\u0930 \u0930\u0939\u093E \u0939\u0948"},"helpMessage":"<p>\u0906\u092A\u0915\u093E \u0906\u092E\u0902\u0924\u094D\u0930\u0923 \u0916\u094B \u0917\u092F\u093E \u0939\u0948 \u092F\u093E \u0906\u092A \u0928\u0939\u0940\u0902 \u091C\u093E\u0928\u0924\u0947 \u0915\u094D\u092F\u093E \u0915\u0930\u0928\u093E \u0939\u0948?<br />\u0915\u0943\u092A\u092F\u093E \u0939\u092E\u0947\u0902 <a><strong>{{phone}}</strong></a> \u092A\u0930 \u0915\u0949\u0932 \u0915\u0930\u0947\u0902 (\u092B\u093F\u0930 <strong>\u0935\u093F\u0915\u0932\u094D\u092A 2</strong> \u0926\u092C\u093E\u090F\u0902)\u0964</p>","text":"<p>\u0936\u0941\u0930\u0942 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0905\u092A\u0928\u093E 6-\u0905\u0915\u094D\u0937\u0930\u094B\u0902 \u0935\u093E\u0932\u093E \u0906\u092E\u0902\u0924\u094D\u0930\u0923 \u0915\u094B\u0921 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902\u0964</p><p>\u092F\u0939 \u0915\u094B\u0921 \u0906\u092A\u0915\u094B \u0905\u092A\u0928\u0947 \u0908\u092E\u0947\u0932 \u0906\u092E\u0902\u0924\u094D\u0930\u0923 \u092E\u0947\u0902 \u092E\u093F\u0932\u0947\u0917\u093E, \u092F\u093E \u0906\u092A\u0915\u0947 \u0930\u0947\u092B\u093C\u0930\u0930 \u0928\u0947 \u0906\u092A\u0915\u094B \u092F\u0939 \u0915\u094B\u0921 \u0926\u093F\u092F\u093E \u0939\u094B \u0938\u0915\u0924\u093E \u0939\u0948\u0964</p>","title":"\u0905\u092A\u0928\u093E \u092C\u0941\u0915\u093F\u0902\u0917 \u0906\u092E\u0902\u0924\u094D\u0930\u0923 \u0916\u094B\u0932\u0947\u0902"}');


var $3c0dbca4e0e20d64$exports = {};
$3c0dbca4e0e20d64$exports = JSON.parse('{"dropLabel":"\u0915\u093F\u0938\u0940 \u0935\u093F\u0936\u0947\u0937 \u092A\u094D\u0930\u0936\u094D\u0928 \u092A\u0930 \u091C\u093E\u090F\u0902","nextLabel":"<b>\u0938\u094D\u0935\u093E\u0938\u094D\u0925\u094D\u092F \u0938\u0947 \u091C\u0941\u0921\u093C\u0947 \u092A\u094D\u0930\u0936\u094D\u0928\u094B\u0902 \u0915\u0947 \u0909\u0924\u094D\u0924\u0930 \u0926\u0947\u0902</b>","questions":{"allergies":{"detailsPlaceholder":"\u0915\u0943\u092A\u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092D\u0930\u0947\u0902\u0964 \u0909\u0926\u093E\u0939\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F:<br/>\\nPenicillin \u2013 rash and swelling; Latex \u2013 mild irritation","label":"\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u094B \u0915\u094B\u0908 \u090F\u0932\u0930\u094D\u091C\u0940 \u0939\u0948?","nextLabel":"$t(common:next): <b>\u0935\u091C\u0928 \u0914\u0930 \u0915\u0926</b>","title":"<h3>\u090F\u0932\u0930\u094D\u091C\u0940 (Allergies)</h3>"},"arrhythmias":{"detailsPlaceholder":"\u0915\u0943\u092A\u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092D\u0930\u0947\u0902\u0964 \u0909\u0926\u093E\u0939\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F: <br/>Irregular heartbeat, on beta blockers since 2021","label":"\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u094B \u0905\u0928\u093F\u092F\u092E\u093F\u0924 \u0926\u093F\u0932 \u0915\u0940 \u0927\u0921\u093C\u0915\u0928, \u0927\u0921\u093C\u0915\u0928 \u0915\u093E \u0905\u0928\u0941\u092D\u0935, \u092F\u093E \u0926\u093F\u0932 \u092E\u0947\u0902 \u092E\u0930\u094D\u092E\u0930 \u0939\u0948?","nextLabel":"$t(common:next): <b>\u092A\u0947\u0938\u092E\u0947\u0915\u0930</b>","title":"<h3>\u0905\u0930\u093F\u0927\u094D\u092E\u093F\u092F\u093E (\u0905\u0928\u093F\u092F\u092E\u093F\u0924 \u0939\u0943\u0926\u092F \u0917\u0924\u093F) (Arrhythmias)</h3>"},"asthmaLungConditions":{"detailsPlaceholder":"\u0915\u0943\u092A\u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092D\u0930\u0947\u0902\u0964 \u0909\u0926\u093E\u0939\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F:<br/>\\nMild asthma \u2013 use inhaler occasionally","label":"\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u094B \u0905\u0938\u094D\u0925\u092E\u093E, \u0938\u0940\u0913\u092A\u0940\u0921\u0940 \u092F\u093E \u0915\u094B\u0908 \u0905\u0928\u094D\u092F \u092B\u0947\u092B\u0921\u093C\u094B\u0902 \u0915\u0940 \u092C\u0940\u092E\u093E\u0930\u0940 \u0939\u0948?","nextLabel":"$t(common:next): <b>\u092A\u093E\u091A\u0928 \u0938\u0902\u092C\u0902\u0927\u0940 \u0938\u094D\u0925\u093F\u0924\u093F\u092F\u093E\u0902</b>","title":"<h3>\u0905\u0938\u094D\u0925\u092E\u093E \u092F\u093E \u092B\u0947\u092B\u0921\u093C\u094B\u0902 \u0915\u0940 \u092C\u0940\u092E\u093E\u0930\u093F\u092F\u093E\u0902 (Asthma or lung conditions)</h3>"},"bloodProblems":{"detailsPlaceholder":"\u0915\u0943\u092A\u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092D\u0930\u0947\u0902\u0964 \u0909\u0926\u093E\u0939\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F: <br/>\\nEasy bruising \u2013 diagnosed with Von Willebrand disease","label":"\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u094B \u091C\u0940\u0913\u0906\u0930\u0921\u0940 (\u0930\u093F\u092B\u094D\u0932\u0915\u094D\u0938), \u0906\u0908\u092C\u0940\u090F\u0938, \u092F\u093E \u0906\u0908\u092C\u0940\u0921\u0940 \u0939\u0948?","nextLabel":"$t(common:next): <b>\u0905\u0902\u0917 \u092A\u094D\u0930\u0924\u093F\u0930\u094B\u092A\u0923</b>","title":"<h3>\u0930\u0915\u094D\u0924 \u0935\u093F\u0915\u093E\u0930 \u092F\u093E \u0930\u0915\u094D\u0924\u0938\u094D\u0930\u093E\u0935 \u0915\u0940 \u0938\u092E\u0938\u094D\u092F\u093E\u090F\u0902 (Blood disorders or bleeding problems)</h3>"},"bloodThinningMedication":{"detailsPlaceholder":"\u0915\u0943\u092A\u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092D\u0930\u0947\u0902\u0964 \u0909\u0926\u093E\u0939\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F: <br/>Apixaban \u2013 5mg daily, last taken on 3 June","label":"\u0915\u094D\u092F\u093E \u0906\u092A \u0935\u0930\u094D\u0924\u092E\u093E\u0928 \u092E\u0947\u0902 \u0915\u094B\u0908 \u0930\u0915\u094D\u0924 \u092A\u0924\u0932\u093E \u0915\u0930\u0928\u0947 \u0935\u093E\u0932\u0940 \u0926\u0935\u093E \u0932\u0947 \u0930\u0939\u0947 \u0939\u0948\u0902?","nextLabel":"$t(common:next): <b>\u0939\u0943\u0926\u092F \u0938\u0902\u092C\u0902\u0927\u0940 \u0938\u092E\u0938\u094D\u092F\u093E\u090F\u0902</b>","title":"<h3>\u0916\u0942\u0928 \u092A\u0924\u0932\u093E \u0915\u0930\u0928\u0947 \u0935\u093E\u0932\u0940 \u0926\u0935\u093E (Blood thinning medication)</h3>"},"cancerTreatment":{"detailsPlaceholder":"\u0915\u0943\u092A\u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092D\u0930\u0947\u0902\u0964 \u0909\u0926\u093E\u0939\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F: <br/>\\nChemotherapy for breast cancer \u2013 ongoing","label":"\u0915\u094D\u092F\u093E \u0906\u092A \u0935\u0930\u094D\u0924\u092E\u093E\u0928 \u092E\u0947\u0902 \u0915\u0940\u092E\u094B\u0925\u0947\u0930\u0947\u092A\u0940, \u0930\u0947\u0921\u093F\u092F\u094B\u0925\u0947\u0930\u0947\u092A\u0940 \u092F\u093E \u0915\u0948\u0902\u0938\u0930 \u0915\u093E \u0915\u094B\u0908 \u0905\u0928\u094D\u092F \u0909\u092A\u091A\u093E\u0930 \u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0915\u0930 \u0930\u0939\u0947 \u0939\u0948\u0902?","nextLabel":"$t(common:next): <b>\u0938\u0902\u0915\u094D\u0930\u093E\u092E\u0915 \u0930\u094B\u0917</b>","title":"<h3>\u0915\u0948\u0902\u0938\u0930 \u0915\u093E \u0907\u0932\u093E\u091C (Cancer treatment)</h3>"},"diabetes":{"detailsLabel":"\u0906\u092A\u0915\u093E \u092E\u0927\u0941\u092E\u0947\u0939 \u0915\u0948\u0938\u0947 \u092A\u094D\u0930\u092C\u0902\u0927\u093F\u0924 \u0915\u093F\u092F\u093E \u091C\u093E\u0924\u093E \u0939\u0948?","diet-controlled":"\u0906\u0939\u093E\u0930 \u0938\u0947 \u0928\u093F\u092F\u0902\u0924\u094D\u0930\u093F\u0924","insulin":"\u0907\u0902\u0938\u0941\u0932\u093F\u0928","label":"\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u094B \u092E\u0927\u0941\u092E\u0947\u0939 \u0939\u0948?","nextLabel":"$t(common:next): <b>\u0909\u091A\u094D\u091A \u0930\u0915\u094D\u0924\u091A\u093E\u092A</b>","no":"\u0928\u0939\u0940\u0902","tablets":"\u091F\u0948\u092C\u0932\u0947\u091F\u094D\u0938 (\u091C\u0948\u0938\u0947 Metformin)","title":"<h3>\u092E\u0927\u0941\u092E\u0947\u0939 (Diabetes)</h3>","type-1":"\u091F\u093E\u0907\u092A 1 \u2013 \u0907\u0902\u0938\u0941\u0932\u093F\u0928 \u092A\u0930","type-2":"\u091F\u093E\u0907\u092A 2","yes-type-1":"\u0939\u093E\u0901 \u2013 \u091F\u093E\u0907\u092A 1, \u0907\u0902\u0938\u0941\u0932\u093F\u0928 \u092A\u0930","yes-type-2":"\u0939\u093E\u0901 \u2013 \u091F\u093E\u0907\u092A 2"},"digestiveConditions":{"detailsPlaceholder":"\u0915\u0943\u092A\u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092D\u0930\u0947\u0902\u0964 \u0909\u0926\u093E\u0939\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F:<br/>Reflux managed with omeprazole","label":"\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u094B \u091C\u0940\u0913\u0906\u0930\u0921\u0940 (\u0930\u093F\u092B\u094D\u0932\u0915\u094D\u0938), \u0906\u0908\u092C\u0940\u090F\u0938, \u092F\u093E \u0906\u0908\u092C\u0940\u0921\u0940 \u0939\u0948?","nextLabel":"$t(common:next): <b>\u0930\u0915\u094D\u0924 \u092F\u093E \u0930\u0915\u094D\u0924\u0938\u094D\u0930\u093E\u0935 \u0938\u0947 \u091C\u0941\u0921\u093C\u0940 \u0938\u092E\u0938\u094D\u092F\u093E\u090F\u0902</b>","title":"<h3>\u092A\u093E\u091A\u0928 \u0938\u0902\u092C\u0902\u0927\u0940 \u0938\u092E\u0938\u094D\u092F\u093E\u090F\u0902 (Digestive conditions)</h3>"},"epilepsy":{"detailsPlaceholder":"\u0915\u0943\u092A\u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092D\u0930\u0947\u0902\u0964 \u0909\u0926\u093E\u0939\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F:<br/>\\nLast seizure in 2020 \u2013 currently stable","label":"\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u094B \u092E\u093F\u0930\u094D\u0917\u0940 \u0939\u0948 \u092F\u093E \u0926\u094C\u0930\u0947 \u092A\u0921\u093C\u0928\u0947 \u0915\u093E \u0915\u094B\u0908 \u0907\u0924\u093F\u0939\u093E\u0938 \u0939\u0948?","nextLabel":"$t(common:next): <b>\u0924\u0902\u0924\u094D\u0930\u093F\u0915\u093E \u0938\u0902\u092C\u0902\u0927\u0940 \u0938\u094D\u0925\u093F\u0924\u093F\u092F\u093E\u0902</b>","title":"<h3>\u092E\u093F\u0930\u094D\u0917\u0940 (Epilepsy)</h3>"},"heartConditions":{"detailsPlaceholder":"\u0915\u0943\u092A\u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092D\u0930\u0947\u0902\u0964 \u0909\u0926\u093E\u0939\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F: <br/>Heart attack in 2020 \u2013 stent inserted","label":"\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u094B \u0915\u092D\u0940 \u0915\u094B\u0908 \u0939\u0943\u0926\u092F \u0938\u0902\u092C\u0902\u0927\u0940 \u092C\u0940\u092E\u093E\u0930\u0940 \u0930\u0939\u0940 \u0939\u0948 (\u091C\u0948\u0938\u0947 \u0926\u093F\u0932 \u0915\u093E \u0926\u094C\u0930\u093E, \u090F\u0928\u091C\u093E\u0907\u0928\u093E)?","nextLabel":"$t(common:next): <b>\u0938\u094D\u091F\u094D\u0930\u094B\u0915 \u092F\u093E \u091F\u0940\u0906\u0908\u090F</b>","title":"<h3>\u0939\u0943\u0926\u092F \u0938\u0902\u092C\u0902\u0927\u0940 \u0938\u092E\u0938\u094D\u092F\u093E\u090F\u0902 (Heart conditions)</h3>"},"highBloodPressure":{"detailsPlaceholder":"\u0915\u0943\u092A\u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092D\u0930\u0947\u0902\u0964 \u0909\u0926\u093E\u0939\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F: <br/>\\nDiagnosed in 2018 \u2013 managed with medication","label":"\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u094B \u0909\u091A\u094D\u091A \u0930\u0915\u094D\u0924\u091A\u093E\u092A \u0939\u0948?","nextLabel":"$t(common:next): <b>\u0905\u0928\u093F\u092F\u092E\u093F\u0924 \u0939\u0943\u0926\u092F \u0917\u0924\u093F</b>","title":"<h3>\u0909\u091A\u094D\u091A \u0930\u0915\u094D\u0924\u091A\u093E\u092A (High blood pressure)</h3>"},"infectiousDiseases":{"detailsPlaceholder":"\u0915\u0943\u092A\u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092D\u0930\u0947\u0902\u0964 \u0909\u0926\u093E\u0939\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F: <br/>MRSA \u2013 cleared after treatment in 2021","label":"\u0915\u094D\u092F\u093E \u0906\u092A\u0928\u0947 \u0915\u092D\u0940 MRSA, ESBL, VRE \u092F\u093E CPE \u0915\u0947 \u0932\u093F\u090F \u092A\u0949\u091C\u093F\u091F\u093F\u0935 \u092A\u0930\u0940\u0915\u094D\u0937\u0923 \u0915\u093F\u092F\u093E \u0939\u0948?","nextLabel":"$t(common:next): <b>\u0917\u0930\u094D\u092D\u093E\u0935\u0938\u094D\u0925\u093E</b>","title":"<h3>\u092E\u0932\u094D\u091F\u0940-\u0930\u0947\u091C\u093C\u093F\u0938\u094D\u091F\u0947\u0902\u091F \u091C\u0940\u0935\u093E\u0923\u0941 (Multi-resistant organisms)</h3>"},"metalImplants":{"detailsPlaceholder":"\u0915\u0943\u092A\u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092D\u0930\u0947\u0902\u0964 \u0909\u0926\u093E\u0939\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F: <br/>Right hip replacement (2020), dental implants, or metal rod in leg","label":"\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u0947 \u0936\u0930\u0940\u0930 \u092E\u0947\u0902 \u0915\u094B\u0908 \u0927\u093E\u0924\u0941 \u092A\u094D\u0930\u0924\u094D\u092F\u093E\u0930\u094B\u092A\u0923 \u092F\u093E \u0927\u093E\u0924\u0941 \u0909\u092A\u0915\u0930\u0923 \u0939\u0948? (\u091C\u0948\u0938\u0947 \u092A\u0947\u0938\u092E\u0947\u0915\u0930 \u092F\u093E \u0915\u0943\u0924\u094D\u0930\u093F\u092E \u0905\u0902\u0917)","nextLabel":"$t(common:next): <b>\u092E\u0927\u0941\u092E\u0947\u0939</b>","title":"<h3>\u0907\u092E\u094D\u092A\u094D\u0932\u093E\u0902\u091F\u094D\u0938 \u092F\u093E \u0927\u093E\u0924\u0941 (Implants or metal)</h3>"},"obstructiveSleepApnoea":{"detailsPlaceholder":"\u0915\u0943\u092A\u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092D\u0930\u0947\u0902\u0964 \u0909\u0926\u093E\u0939\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F:<br/>\\nDiagnosed in 2022 \u2013 use CPAP machine every night","label":"\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u094B \u0911\u092C\u094D\u0938\u091F\u094D\u0930\u0915\u094D\u091F\u093F\u0935 \u0938\u094D\u0932\u0940\u092A \u090F\u092A\u0928\u093F\u092F\u093E \u0939\u0948 \u092F\u093E \u0915\u094D\u092F\u093E \u0906\u092A \u0930\u093E\u0924 \u0915\u094B \u0938\u094B\u0924\u0947 \u0938\u092E\u092F CPAP \u092E\u0936\u0940\u0928 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0924\u0947 \u0939\u0948\u0902?","nextLabel":"$t(common:next): <b>\u0926\u092E\u093E \u092F\u093E \u092B\u0947\u092B\u0921\u093C\u094B\u0902 \u0915\u0940 \u0938\u094D\u0925\u093F\u0924\u093F\u092F\u093E\u0901</b>","title":"<h3>\u0911\u092C\u094D\u0938\u094D\u091F\u094D\u0930\u0915\u094D\u091F\u093F\u0935 \u0938\u094D\u0932\u0940\u092A \u090F\u092A\u0928\u093F\u092F\u093E (Obstructive Sleep Apnoea)</h3>"},"organTransplant":{"detailsPlaceholder":"\u0915\u0943\u092A\u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092D\u0930\u0947\u0902\u0964 \u0909\u0926\u093E\u0939\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F: <br/>\\nKidney transplant in 2018 \u2013 taking tacrolimus and prednisone","label":"\u0915\u094D\u092F\u093E \u0906\u092A\u0928\u0947 \u0905\u0902\u0917 \u092A\u094D\u0930\u0924\u093F\u0930\u094B\u092A\u0923 \u0915\u0930\u0935\u093E\u092F\u093E \u0939\u0948 \u0914\u0930 \u0915\u094D\u092F\u093E \u0906\u092A \u0907\u092E\u094D\u092F\u0942\u0928\u094B\u092A\u094D\u0930\u0947\u0938\u093F\u0935 \u0926\u0935\u093E\u090F\u0902 \u0932\u0947 \u0930\u0939\u0947 \u0939\u0948\u0902?","nextLabel":"$t(common:next): <b>\u0915\u0948\u0902\u0938\u0930 \u0915\u093E \u0909\u092A\u091A\u093E\u0930</b>","title":"<h3>\u0905\u0902\u0917 \u092A\u094D\u0930\u0924\u094D\u092F\u093E\u0930\u094B\u092A\u0923 (Organ transplant)</h3>"},"otherHealthConditions":{"detailsPlaceholder":"\u0915\u0943\u092A\u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092D\u0930\u0947\u0902\u0964 \u0909\u0926\u093E\u0939\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F: <br/>\\nCoeliac disease, recent surgery, chronic pain","label":"\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u094B \u0915\u094B\u0908 \u0905\u0928\u094D\u092F \u091A\u093F\u0915\u093F\u0924\u094D\u0938\u0940\u092F \u0938\u094D\u0925\u093F\u0924\u093F \u092F\u093E \u091A\u093F\u0902\u0924\u093E \u0939\u0948 \u091C\u093F\u0938\u0915\u0947 \u092C\u093E\u0930\u0947 \u092E\u0947\u0902 \u0939\u092E\u0947\u0902 \u091C\u093E\u0928\u0928\u093E \u091A\u093E\u0939\u093F\u090F?","nextLabel":"$t(common:next): <b>\u0926\u0935\u093E\u090F\u0902</b>","title":"<h3>\u0905\u0928\u094D\u092F \u0938\u094D\u0935\u093E\u0938\u094D\u0925\u094D\u092F \u0938\u094D\u0925\u093F\u0924\u093F\u092F\u093E\u0901 (Other health conditions)</h3>"},"pacemaker":{"defibrillator":"\u0921\u093F\u092B\u093F\u092C\u094D\u0930\u093F\u0932\u0947\u091F\u0930","detailsLabel":"\u092F\u0939 \u0915\u093F\u0938 \u092A\u094D\u0930\u0915\u093E\u0930 \u0915\u093E \u0939\u0948?","label":"\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u0947 \u092A\u093E\u0938 \u092A\u0947\u0938\u092E\u0947\u0915\u0930 \u092F\u093E \u0915\u094B\u0908 \u0905\u0928\u094D\u092F \u092A\u094D\u0930\u0924\u093F\u0930\u094B\u092A\u093F\u0924 \u0939\u0943\u0926\u092F \u0921\u093F\u0935\u093E\u0907\u0938 \u0939\u0948?","nextLabel":"$t(common:next): <b>\u092C\u094D\u0932\u0921 \u0925\u093F\u0928\u0930 \u0926\u0935\u093E\u090F\u0902</b>","not-sure":"\u092E\u0941\u091D\u0947 \u0928\u0939\u0940\u0902 \u092A\u0924\u093E","pacing":"\u092A\u0947\u0938\u093F\u0902\u0917","title":"<h3>\u092A\u0947\u0938\u092E\u0947\u0915\u0930 \u092F\u093E \u092A\u094D\u0930\u0924\u094D\u092F\u093E\u0930\u094B\u092A\u093F\u0924 \u0939\u0943\u0926\u092F \u0909\u092A\u0915\u0930\u0923 (Pacemaker or implanted cardiac device)</h3>"},"pregnancy":{"label":"\u0915\u094D\u092F\u093E \u0906\u092A \u0935\u0930\u094D\u0924\u092E\u093E\u0928 \u092E\u0947\u0902 \u0917\u0930\u094D\u092D\u0935\u0924\u0940 \u0939\u0948\u0902 \u2013 \u092F\u093E \u0938\u0902\u092D\u0935\u0924\u0903 \u0917\u0930\u094D\u092D\u0935\u0924\u0940 \u0939\u094B \u0938\u0915\u0924\u0940 \u0939\u0948\u0902?","nextLabel":"$t(common:next): <b>\u0905\u0928\u094D\u092F \u0938\u094D\u0935\u093E\u0938\u094D\u0925\u094D\u092F \u0938\u094D\u0925\u093F\u0924\u093F\u092F\u093E\u0901</b>","title":"<h3>\u0917\u0930\u094D\u092D\u093E\u0935\u0938\u094D\u0925\u093E (Pregnancy)</h3>"},"stroke":{"detailsPlaceholder":"\u0915\u0943\u092A\u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092D\u0930\u0947\u0902\u0964 \u0909\u0926\u093E\u0939\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F:<br/>\\nStroke in 2021 \u2013 mild weakness on left side","label":"\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u094B \u0915\u092D\u0940 \u0938\u094D\u091F\u094D\u0930\u094B\u0915 \u092F\u093E \u092E\u093F\u0928\u0940-\u0938\u094D\u091F\u094D\u0930\u094B\u0915 (TIA) \u0939\u0941\u0906 \u0939\u0948?","nextLabel":"$t(common:next): <b>\u092E\u093F\u0930\u094D\u0917\u0940 (Epilepsy)</b>","title":"<h3>\u0938\u094D\u091F\u094D\u0930\u094B\u0915 \u092F\u093E \u091B\u094B\u091F\u093E \u0938\u094D\u091F\u094D\u0930\u094B\u0915 (TIA)</h3>"},"weightHeight":{"cm":"cm","height":"\u090A\u0902\u091A\u093E\u0908","kg":"kg","nextLabel":"$t(common:next): <b>\u0907\u092E\u094D\u092A\u094D\u0932\u093E\u0902\u091F / \u0927\u093E\u0924\u0941</b>","text":"\u0915\u0943\u092A\u092F\u093E \u0905\u092A\u0928\u093E \u0905\u0928\u0941\u092E\u093E\u0928\u093F\u0924 \u0935\u091C\u093C\u0928 \u0914\u0930 \u0915\u0926 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902\u0964","title":"<h3>\u0935\u091C\u093C\u0928 \u0914\u0930 \u0915\u0926</h3><p>\u0915\u0943\u092A\u092F\u093E \u0905\u092A\u0928\u093E \u0905\u0928\u0941\u092E\u093E\u0928\u093F\u0924 \u0935\u091C\u093C\u0928 \u0914\u0930 \u0915\u0926 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902\u0964</p>","weight":"\u0935\u091C\u093C\u0928"}},"text":"<p>\u0939\u092E \u0932\u0917\u092D\u0917 \u092A\u0942\u0930\u093E \u0915\u0930 \u091A\u0941\u0915\u0947 \u0939\u0948\u0902\u0964</p>\\n<p>\u0939\u092E\u0947\u0902 \u0906\u092A\u0915\u0947 \u0938\u094D\u0935\u093E\u0938\u094D\u0925\u094D\u092F, \u0926\u0935\u093E\u0913\u0902 \u0914\u0930 \u092A\u094D\u0930\u093E\u0925\u092E\u093F\u0915\u0924\u093E\u0913\u0902 \u0915\u0947 \u092C\u093E\u0930\u0947 \u092E\u0947\u0902 \u0915\u0941\u091B \u0938\u0935\u093E\u0932 \u092A\u0942\u091B\u0928\u0947 \u0939\u0948\u0902\u0964</p>\\n<p>\u0906\u092A\u0915\u0940 \u0926\u0947\u0916\u092D\u093E\u0932 \u0915\u094B \u092A\u094D\u0930\u092D\u093E\u0935\u093F\u0924 \u0915\u0930 \u0938\u0915\u0928\u0947 \u0935\u093E\u0932\u0940 \u0915\u093F\u0938\u0940 \u092D\u0940 \u091A\u0940\u091C\u093C \u0915\u094B \u0938\u092E\u091D\u0928\u093E \u0939\u092E\u093E\u0930\u0947 \u0932\u093F\u090F \u091C\u093C\u0930\u0942\u0930\u0940 \u0939\u0948\u0964</p>\\n<p>\u0905\u0917\u0930 \u0915\u0941\u091B \u0938\u094D\u092A\u0937\u094D\u091F \u0915\u0930\u0928\u0947 \u0915\u0940 \u091C\u093C\u0930\u0942\u0930\u0924 \u092A\u0921\u093C\u0940, \u0924\u094B \u0939\u092E\u093E\u0930\u0940 \u091F\u0940\u092E \u0915\u093E \u0915\u094B\u0908 \u0938\u0926\u0938\u094D\u092F \u0906\u092A\u0915\u0940 \u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u0938\u0947 \u092A\u0939\u0932\u0947 \u0906\u092A\u0938\u0947 \u0938\u0902\u092A\u0930\u094D\u0915 \u0915\u0930\u0947\u0917\u093E\u0964</p>\\n<p>\u0907\u0938 \u0905\u0902\u0924\u093F\u092E \u091A\u0930\u0923 \u092E\u0947\u0902 \u0906\u092E\u0924\u094C\u0930 \u092A\u0930 <strong>10 \u092E\u093F\u0928\u091F</strong> \u0938\u0947 \u092D\u0940 \u0915\u092E \u0938\u092E\u092F \u0932\u0917\u0924\u093E \u0939\u0948\u0964</p>","title":"\u0938\u094D\u0935\u093E\u0938\u094D\u0925\u094D\u092F \u0914\u0930 \u092A\u094D\u0930\u093E\u0925\u092E\u093F\u0915\u0924\u093E \u0938\u0947 \u091C\u0941\u0921\u093C\u0947 \u092A\u094D\u0930\u0936\u094D\u0928"}');


var $c4d419a84e54d9a6$exports = {};
$c4d419a84e54d9a6$exports = JSON.parse('{"addButtonLabel":"\u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u092F\u093E \u0936\u0932\u094D\u092F\u091A\u093F\u0915\u093F\u0924\u094D\u0938\u093E","date":"\u0924\u093E\u0930\u0940\u0916","datePlaceholder":"e.g. June 2022, 2021, or ~5 years ago","location":"\u0938\u094D\u0925\u093E\u0928","locationPlaceholder":"e.g. Ormiston Hospital, Auckland","nextLabel":"$t(common:next): <b>\u0917\u0924\u093F\u0936\u0940\u0932\u0924\u093E</b>","procedure":"\u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u092F\u093E \u0938\u0930\u094D\u091C\u0930\u0940 \u0915\u093E \u0935\u093F\u0935\u0930\u0923","procedurePlaceholder":"\u0915\u0943\u092A\u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092D\u0930\u0947\u0902\u0964 \u0909\u0926\u093E\u0939\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F: <br/>\\nColonoscopy to investigate bleeding","saveButton":"\u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u092F\u093E \u0938\u0930\u094D\u091C\u0930\u0940 \u0938\u0939\u0947\u091C\u0947\u0902","text":"<p>\u0939\u092E\u093E\u0930\u0947 \u092A\u093E\u0938 {{company}} \u092E\u0947\u0902 \u0906\u092A\u0915\u0940 \u092A\u093F\u091B\u0932\u0940 \u090F\u0902\u0921\u094B\u0938\u094D\u0915\u094B\u092A\u0940 \u0915\u093E \u0930\u093F\u0915\u0949\u0930\u094D\u0921 \u0939\u0948:</p>\\n<ul><li><strong>{{procedure}}</strong> \u2013 <strong>{{date}}</strong> \u0915\u094B</li></ul>\\n<p>\u0915\u094D\u092F\u093E \u0924\u092C \u0938\u0947 \u0906\u092A\u0915\u0940 \u0915\u094B\u0908 \u0914\u0930 \u090F\u0902\u0921\u094B\u0938\u094D\u0915\u094B\u092A\u0940, \u092A\u0947\u091F \u0938\u0947 \u091C\u0941\u0921\u093C\u0940 \u092F\u093E \u092C\u0921\u093C\u0940 \u0938\u0930\u094D\u091C\u0930\u0940 \u0939\u0941\u0908 \u0939\u0948?</p>","textNoProcedure":"\u0915\u094D\u092F\u093E \u0906\u092A\u0928\u0947 \u092A\u0939\u0932\u0947 \u0915\u092D\u0940 \u090F\u0902\u0921\u094B\u0938\u094D\u0915\u094B\u092A\u0940, \u092A\u0947\u091F \u0915\u0940 \u0938\u0930\u094D\u091C\u0930\u0940 \u092F\u093E \u0915\u094B\u0908 \u092C\u0921\u093C\u0940 \u0938\u0930\u094D\u091C\u0930\u0940 \u0915\u0930\u0935\u093E\u0908 \u0939\u0948?","title":"\u0939\u093E\u0932 \u0915\u0940 \u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E\u090F\u0902 \u092F\u093E \u0938\u0930\u094D\u091C\u0930\u0940"}');


var $0e1599b698ee7876$exports = {};
$0e1599b698ee7876$exports = JSON.parse('{"helpMessage":"<h3>\u092C\u0940\u092E\u093E \u0938\u0947 \u091C\u0941\u0921\u093C\u0947 \u0938\u0935\u093E\u0932?</h3>\\n<p>\u0939\u092E\u093E\u0930\u0940 \u091F\u0940\u092E \u092E\u0926\u0926 \u0915\u0947 \u0932\u093F\u090F \u0924\u0948\u092F\u093E\u0930 \u0939\u0948 \u2014 \u0915\u0949\u0932 \u0915\u0930\u0947\u0902:<br/><a><strong>\u260E\uFE0F {{phone}}</strong></a> (\u092B\u093F\u0930 <strong>Option 2</strong> \u0926\u092C\u093E\u090F\u0902)<br/>Monday to Friday, 8am\u20135pm.</p>","insuranceCovered":"\u0915\u094D\u092F\u093E \u0938\u094D\u0935\u093E\u0938\u094D\u0925\u094D\u092F \u092C\u0940\u092E\u093E \u0906\u092A\u0915\u0947 \u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u0936\u0941\u0932\u094D\u0915 \u0915\u093E \u0915\u0941\u091B \u092F\u093E \u092A\u0942\u0930\u093E \u0939\u093F\u0938\u094D\u0938\u093E \u0915\u0935\u0930 \u0915\u0930\u0947\u0917\u093E?","insuranceDetails":"<ul>\\n  <li>\u092C\u0940\u092E\u093E \u0926\u094D\u0935\u093E\u0930\u093E \u0915\u0935\u0930 \u0928 \u0915\u0940 \u0917\u0908 \u0915\u093F\u0938\u0940 \u092D\u0940 \u0936\u0947\u0937 \u0930\u093E\u0936\u093F \u0915\u0947 \u0932\u093F\u090F \u092E\u0948\u0902 \u091C\u093F\u092E\u094D\u092E\u0947\u0926\u093E\u0930 \u0939\u0942\u0902\u0964</li>\\n  <li>\u092E\u0948\u0902 \u092A\u094D\u0930\u0935\u0947\u0936 \u0915\u0947 \u0926\u093F\u0928 \u0915\u093F\u0938\u0940 \u092D\u0940 \u0906\u0935\u0936\u094D\u092F\u0915 \u0930\u093E\u0936\u093F \u0915\u093E \u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u0930\u0942\u0902\u0917\u093E/\u0915\u0930\u0942\u0902\u0917\u0940\u0964</li>\\n  <li>\u092F\u0926\u093F \u092E\u0948\u0902 \u0905\u092A\u0928\u093E \u0916\u093E\u0924\u093E \u092D\u0941\u0917\u0924\u093E\u0928 \u0928\u0939\u0940\u0902 \u0915\u0930\u0924\u093E/\u0915\u0930\u0924\u0940, \u0924\u094B \u0915\u093F\u0938\u0940 \u092D\u0940 \u090B\u0923 \u0935\u0938\u0942\u0932\u0940 \u0932\u093E\u0917\u0924 \u0915\u0947 \u0932\u093F\u090F \u092E\u0948\u0902 \u091C\u093F\u092E\u094D\u092E\u0947\u0926\u093E\u0930 \u0939\u0942\u0902\u0964</li>\\n</ul>","insuranceLabel":"\u092E\u0948\u0902 \u0938\u092E\u091D\u0924\u093E/\u0938\u092E\u091D\u0924\u0940 \u0939\u0942\u0902 \u0914\u0930 \u0938\u094D\u0935\u0940\u0915\u093E\u0930 \u0915\u0930\u0924\u093E/\u0915\u0930\u0924\u0940 \u0939\u0942\u0902 \u0915\u093F:","insurerLabel":"\u0906\u092A\u0915\u093E \u0938\u094D\u0935\u093E\u0938\u094D\u0925\u094D\u092F \u092C\u0940\u092E\u093E\u0915\u0930\u094D\u0924\u093E \u0915\u094C\u0928 \u0939\u0948?","insurerSelect":{"aia":"AIA","nib":"NIB","southern-cross":"Southern Cross"},"membershipLabel":"\u0938\u0926\u0938\u094D\u092F\u0924\u093E \u0938\u0902\u0916\u094D\u092F\u093E","noCovered":"\u092E\u0948\u0902 \u0938\u092D\u0940 \u0916\u0930\u094D\u091A\u094B\u0902 \u0915\u093E \u092D\u0941\u0917\u0924\u093E\u0928 \u0938\u094D\u0935\u092F\u0902 \u0915\u0930\u0942\u0902\u0917\u093E/\u0915\u0930\u0942\u0902\u0917\u0940\u0964","preApprovalLabel":"\u0915\u094D\u092F\u093E \u0906\u092A\u0928\u0947 \u0907\u0938 \u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u0915\u0947 \u0932\u093F\u090F \u092A\u0942\u0930\u094D\u0935 \u0905\u0928\u0941\u092E\u094B\u0926\u0928 \u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0915\u093F\u092F\u093E \u0939\u0948?","preApprovalText":"<h3>{{insurer}} \u092A\u0942\u0930\u094D\u0935-\u0938\u094D\u0935\u0940\u0915\u0943\u0924\u093F</h3>\\n<p>\u0939\u092E \u0906\u092A\u0915\u0947 \u0938\u094D\u0925\u093E\u0928 \u092A\u0930 {{insurer}} \u0938\u0947 \u0938\u0902\u092A\u0930\u094D\u0915 \u0915\u0930\u0947\u0902\u0917\u0947 \u0924\u093E\u0915\u093F \u0906\u092A\u0915\u0940 \u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u0915\u0947 \u0932\u093F\u090F \u0938\u094D\u0935\u0940\u0915\u0943\u0924\u093F \u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0915\u0940 \u091C\u093E \u0938\u0915\u0947\u0964</p>\\n<p>\u0906\u092A\u0915\u094B \u090F\u0915 \u0905\u092A\u0921\u0947\u091F \u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0939\u094B\u0917\u093E \u091C\u093F\u0938\u092E\u0947\u0902 \u0938\u094D\u0935\u0940\u0915\u0943\u0924\u093F \u0915\u093E \u092A\u0930\u093F\u0923\u093E\u092E \u0914\u0930 \u0935\u0939 \u0930\u093E\u0936\u093F \u0936\u093E\u092E\u093F\u0932 \u0939\u094B\u0917\u0940 \u091C\u094B \u0906\u092A\u0915\u094B \u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u0930\u0928\u0940 \u092A\u0921\u093C \u0938\u0915\u0924\u0940 \u0939\u0948\u0964</p>\\n<span>\u0907\u0938\u092E\u0947\u0902 \u0936\u093E\u092E\u093F\u0932 \u0939\u094B \u0938\u0915\u0924\u093E \u0939\u0948:</span>\\n<ul>\\n<li><strong>\u090F\u0915\u094D\u0938\u0947\u0938:</strong> \u0906\u092A\u0915\u0940 \u092A\u0949\u0932\u093F\u0938\u0940 \u0926\u094D\u0935\u093E\u0930\u093E \u0928\u093F\u0930\u094D\u0927\u093E\u0930\u093F\u0924 \u0930\u093E\u0936\u093F, \u0914\u0930/\u092F\u093E</li>\\n<li><strong>\u0905\u0902\u0924\u0930:</strong> \u0906\u092A\u0915\u0940 \u092A\u0949\u0932\u093F\u0938\u0940 \u0915\u0935\u0930\u0947\u091C \u0914\u0930 \u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u0932\u093E\u0917\u0924 \u0915\u0947 \u092C\u0940\u091A \u0915\u093E \u0905\u0902\u0924\u0930\u0964</li>\\n</ul>\\n<p>\u0915\u094B\u0908 \u092D\u0940 \u090F\u0915\u094D\u0938\u0947\u0938 \u092F\u093E \u0905\u0902\u0924\u0930 <strong>\u0906\u092A\u0915\u0940 \u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u0915\u0947 \u0926\u093F\u0928 \u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u093F\u092F\u093E \u091C\u093E\u0928\u093E \u091A\u093E\u0939\u093F\u090F</strong>\u0964</p>","title":"\u0938\u094D\u0935\u093E\u0938\u094D\u0925\u094D\u092F \u092C\u0940\u092E\u093E"}');


var $f48b9a33919ca111$exports = {};
$f48b9a33919ca111$exports = JSON.parse('{"helpMessage":"<h3>\u0915\u094B\u0908 \u0938\u0935\u093E\u0932 \u0939\u0948?</h3>\\n<p>\u0939\u092E\u093E\u0930\u0940 \u091F\u0940\u092E \u0906\u092A\u0915\u0940 \u092E\u0926\u0926 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0909\u092A\u0932\u092C\u094D\u0927 \u0939\u0948 - \u0915\u0949\u0932 \u0915\u0930\u0947\u0902:<br/><a><strong>\u260E\uFE0F {{phone}}</strong></a> (\u092B\u093F\u0930 \u0926\u092C\u093E\u090F\u0902 <strong>Option 2</strong>)<br/>\u0938\u094B\u092E\u0935\u093E\u0930 \u0938\u0947 \u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930, \u0938\u0941\u092C\u0939 8 \u0938\u0947 \u0936\u093E\u092E 5 \u092C\u091C\u0947 \u0924\u0915\u0964</p>","title":"\u0928\u093F\u092E\u0902\u0924\u094D\u0930\u0923 \u0905\u092E\u093E\u0928\u094D\u092F \u0939\u0948"}');


var $33a955ce8e880431$exports = {};
$33a955ce8e880431$exports = JSON.parse('{"helpMessage":"<h3>\u0915\u094B\u0908 \u0938\u0935\u093E\u0932 \u0939\u0948?</h3>\\n<p>\u0939\u092E\u093E\u0930\u0940 \u091F\u0940\u092E \u092E\u0926\u0926 \u0915\u0947 \u0932\u093F\u090F \u0924\u0948\u092F\u093E\u0930 \u0939\u0948 - \u0915\u0949\u0932 \u0915\u0930\u0947\u0902:<br/>\\n<a><strong>\u260E\uFE0F {{phone}}</strong></a> (\u092B\u093F\u0930 <strong>\u0935\u093F\u0915\u0932\u094D\u092A 2</strong> \u0926\u092C\u093E\u090F\u0901)<br/>\\n\u0938\u094B\u092E\u0935\u093E\u0930 \u0938\u0947 \u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930, \u0938\u0941\u092C\u0939 8 \u0938\u0947 \u0936\u093E\u092E 5 \u092C\u091C\u0947 \u0924\u0915\u0964</p>","text":"<p>\u0939\u092E \u0906\u092A\u0915\u0947 \u0930\u0947\u092B\u0930 \u0915\u0930\u0928\u0947 \u0935\u093E\u0932\u0947 \u0921\u0949\u0915\u094D\u091F\u0930 \u0915\u094B \u0938\u0942\u091A\u093F\u0924 \u0915\u0930 \u0926\u0947\u0902\u0917\u0947, \u0914\u0930 \u0935\u0947 \u0906\u092A\u0938\u0947 \u0905\u0917\u0932\u0947 \u0915\u0926\u092E\u094B\u0902 \u092A\u0930 \u091A\u0930\u094D\u091A\u093E \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0938\u0902\u092A\u0930\u094D\u0915 \u0915\u0930 \u0938\u0915\u0924\u0947 \u0939\u0948\u0902\u0964</p>\\n<p>\u0905\u092D\u0940 \u0915\u0947 \u0932\u093F\u090F \u0906\u092A\u0915\u094B \u0914\u0930 \u0915\u0941\u091B \u0915\u0930\u0928\u0947 \u0915\u0940 \u091C\u093C\u0930\u0942\u0930\u0924 \u0928\u0939\u0940\u0902 \u0939\u0948\u0964</p>","title":"\u0906\u092A\u0928\u0947 \u0905\u092D\u0940 \u092C\u0941\u0915 \u0928 \u0915\u0930\u0928\u0947 \u0915\u093E \u0935\u093F\u0915\u0932\u094D\u092A \u091A\u0941\u0928\u093E \u0939\u0948\u0964"}');


var $12644a44eb1cc8a8$exports = {};
$12644a44eb1cc8a8$exports = JSON.parse("{}");


var $4fa3bbc985722780$exports = {};
$4fa3bbc985722780$exports = JSON.parse('{"text":"<p>\u0906\u092A\u0915\u0940 \u092A\u0939\u091A\u093E\u0928 \u0915\u094B \u0915\u0908 \u092C\u093E\u0930 \u0938\u0924\u094D\u092F\u093E\u092A\u093F\u0924 \u0915\u0930\u0928\u0947 \u0915\u093E \u092A\u094D\u0930\u092F\u093E\u0938 \u0935\u093F\u092B\u0932 \u0939\u094B\u0928\u0947 \u0915\u0947 \u092C\u093E\u0926, \u0906\u092A\u0915\u0940 \u0917\u094B\u092A\u0928\u0940\u092F\u0924\u093E \u0915\u0940 \u0938\u0941\u0930\u0915\u094D\u0937\u093E \u0915\u0947 \u0932\u093F\u090F \u0939\u092E\u0928\u0947 \u0907\u0938 \u0928\u093F\u092E\u0902\u0924\u094D\u0930\u0923 \u0915\u094B \u0905\u0938\u094D\u0925\u093E\u092F\u0940 \u0930\u0942\u092A \u0938\u0947 \u0932\u0949\u0915 \u0915\u0930 \u0926\u093F\u092F\u093E \u0939\u0948\u0964</p>\\n<p>\u091A\u093F\u0902\u0924\u093E \u0928 \u0915\u0930\u0947\u0902 \u2013 \u0939\u092E \u0905\u092D\u0940 \u092D\u0940 \u0906\u092A\u0915\u0940 \u0938\u0939\u093E\u092F\u0924\u093E \u0915\u0930 \u0938\u0915\u0924\u0947 \u0939\u0948\u0902\u0964</p>\\n<p>\u0905\u092A\u0928\u0940 \u092C\u0941\u0915\u093F\u0902\u0917 \u092A\u0942\u0930\u0940 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0915\u0943\u092A\u092F\u093E \u0939\u092E\u093E\u0930\u0940 \u091F\u0940\u092E \u0915\u094B \u0915\u0949\u0932 \u0915\u0930\u0947\u0902:</p>\\n<p><a><strong>\u260E\uFE0F {{phone}}</strong></a> (\u092B\u093F\u0930 \u0926\u092C\u093E\u090F\u0902 <strong>\u0935\u093F\u0915\u0932\u094D\u092A 2</strong>)<br/>\u0938\u094B\u092E\u0935\u093E\u0930 \u0938\u0947 \u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930, \u0938\u0941\u092C\u0939 8 \u092C\u091C\u0947 \u0938\u0947 \u0936\u093E\u092E 5 \u092C\u091C\u0947 \u0924\u0915\u0964</p>","title":"\u0906\u092A\u0915\u0940 \u0938\u0941\u0930\u0915\u094D\u0937\u093E \u0915\u0947 \u0932\u093F\u090F \u0928\u093F\u092E\u0902\u0924\u094D\u0930\u0923 \u0932\u0949\u0915 \u0915\u0930 \u0926\u093F\u092F\u093E \u0917\u092F\u093E \u0939\u0948"}');


var $e9eef1367c57f692$exports = {};
$e9eef1367c57f692$exports = JSON.parse('{"addButtonLabel":"\u0926\u0935\u093E \u091C\u094B\u0921\u093C\u0947\u0902","dose":"\u0916\u0941\u0930\u093E\u0915","dosePlaceholder":"e.g. 500mg or 1 tablet","dropHere":"\u092F\u0939\u093E\u0901 \u0921\u094D\u0930\u0949\u092A \u0915\u0930\u0947\u0902","dropText":"<p>{{fileExtensions}} \u092F\u093E {{fileExtension}} \u2014 \u0905\u0927\u093F\u0915\u0924\u092E {{mb}}MB \u0924\u0915</p>","dropTitle":"<p><strong>\u090F\u0915 \u092B\u093C\u093E\u0907\u0932 \u0905\u092A\u0932\u094B\u0921 \u0915\u0930\u0947\u0902</strong> \u092F\u093E \u0916\u0940\u0902\u091A\u0915\u0930 \u092F\u0939\u093E\u0901 \u091B\u094B\u0921\u093C\u0947\u0902</p>","frequency":"\u0906\u0935\u0943\u0924\u094D\u0924\u093F","manuallyText":"<strong>\u0926\u0935\u093E\u090F\u0902 \u092E\u0948\u0928\u094D\u092F\u0941\u0905\u0932\u0940 \u091C\u094B\u0921\u093C\u0947\u0902</strong><p>\u090F\u0915 \u092C\u093E\u0930 \u092E\u0947\u0902 \u090F\u0915 \u0926\u0935\u093E \u091C\u094B\u0921\u093C\u0947\u0902\u0964 \u0928\u093E\u092E, \u0916\u0941\u0930\u093E\u0915 \u0914\u0930 \u0915\u093F\u0924\u0928\u0940 \u092C\u093E\u0930 \u0932\u0947\u0924\u0947 \u0939\u0948\u0902, \u092F\u0939 \u0936\u093E\u092E\u093F\u0932 \u0915\u0930\u0947\u0902\u0964</p>","medicationName":"\u0926\u0935\u093E \u0915\u093E \u0928\u093E\u092E","medicationPlaceholder":"<p><strong>\u0915\u0943\u092A\u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092D\u0930\u0947\u0902\u0964</strong><br/>\u0909\u0926\u093E\u0939\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F: Metformin \u2013 500mg morning and night</p>","nextLabel":"$t(common:next): <b>\u0907\u0924\u093F\u0939\u093E\u0938</b>","saveButton":"\u0926\u0935\u093E \u0938\u0939\u0947\u091C\u0947\u0902","select":{"as-needed":"\u091C\u093C\u0930\u0942\u0930\u0924 \u092A\u0921\u093C\u0928\u0947 \u092A\u0930","once-daily":"\u0926\u093F\u0928 \u092E\u0947\u0902 \u090F\u0915 \u092C\u093E\u0930","three-time-daily":"\u0926\u093F\u0928 \u092E\u0947\u0902 \u0924\u0940\u0928 \u092C\u093E\u0930","twice-daily":"\u0926\u093F\u0928 \u092E\u0947\u0902 \u0926\u094B \u092C\u093E\u0930"},"text":"<p>\u0915\u0943\u092A\u092F\u093E \u0939\u092E\u0947\u0902 \u0909\u0928 \u0926\u0935\u093E\u0913\u0902, \u0907\u0928\u0939\u0947\u0932\u0930\u094D\u0938, \u0907\u0902\u091C\u0947\u0915\u094D\u0936\u0928\u094B\u0902 \u092F\u093E \u0938\u092A\u094D\u0932\u0940\u092E\u0947\u0902\u091F\u094D\u0938 \u0915\u0947 \u092C\u093E\u0930\u0947 \u092E\u0947\u0902 \u092C\u0924\u093E\u090F\u0902 \u091C\u094B \u0906\u092A \u0935\u0930\u094D\u0924\u092E\u093E\u0928 \u092E\u0947\u0902 \u0932\u0947 \u0930\u0939\u0947 \u0939\u0948\u0902\u0964</p>\\n<p>\u0906\u092A \u090F\u0915 \u0938\u0942\u091A\u0940 \u0905\u092A\u0932\u094B\u0921 \u0915\u0930 \u0938\u0915\u0924\u0947 \u0939\u0948\u0902 \u092F\u093E \u0909\u0928\u094D\u0939\u0947\u0902 \u092E\u0948\u0928\u094D\u092F\u0941\u0905\u0932\u0940 \u091C\u094B\u0921\u093C \u0938\u0915\u0924\u0947 \u0939\u0948\u0902\u0964</p>","title":"\u0926\u0935\u093E\u090F\u0901","uploadText":"<strong>\u090F\u0915 \u092A\u094D\u0930\u093F\u0938\u094D\u0915\u094D\u0930\u093F\u092A\u094D\u0936\u0928 \u092F\u093E \u0938\u0942\u091A\u0940 \u0905\u092A\u0932\u094B\u0921 \u0915\u0930\u0947\u0902</strong>\\n<p>\u092F\u0926\u093F \u0906\u092A\u0915\u0947 \u092A\u093E\u0938 \u0905\u092A\u0928\u0947 \u0921\u0949\u0915\u094D\u091F\u0930 \u092F\u093E \u092B\u093C\u093E\u0930\u094D\u092E\u0947\u0938\u0940 \u0938\u0947 \u092E\u093F\u0932\u0940 \u0938\u0942\u091A\u0940 \u0939\u0948, \u0924\u094B \u090F\u0915 \u092B\u093C\u094B\u091F\u094B \u092F\u093E PDF \u0905\u092A\u0932\u094B\u0921 \u0915\u0930\u0947\u0902\u0964</p>"}');


var $ab58912a75177bbf$exports = {};
$ab58912a75177bbf$exports = JSON.parse('{"questions":{"culture":{"detailsPlaceholder":"<p>\u0915\u0943\u092A\u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092D\u0930\u0947\u0902\u0964 \u0909\u0926\u093E\u0939\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F:</p>\\n<p>Wh\u0101nau to be present, need interpreter, specific dietary customs</p>","label":"\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u0940 \u0915\u094B\u0908 \u0938\u093E\u0902\u0938\u094D\u0915\u0943\u0924\u093F\u0915 \u092F\u093E \u092A\u093E\u0930\u093F\u0935\u093E\u0930\u093F\u0915 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E\u090F\u0901 \u0939\u0948\u0902?","nextLabel":"$t(common:next): <b>\u0905\u0928\u094D\u092F \u0935\u093F\u0936\u0947\u0937 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E\u090F\u0902 \u092F\u093E \u091C\u093E\u0928\u0915\u093E\u0930\u0940</b>","title":"<h3>\u0938\u093E\u0902\u0938\u094D\u0915\u0943\u0924\u093F\u0915 \u092F\u093E \u092A\u093E\u0930\u093F\u0935\u093E\u0930\u093F\u0915 \u091C\u093C\u0930\u0942\u0930\u0924\u0947\u0902</h3>"},"language":{"de":"Deutsch / German","detailsLabel":"\u0906\u092A\u0915\u0940 \u092A\u0938\u0902\u0926\u0940\u0926\u093E \u092D\u093E\u0937\u093E \u0915\u094D\u092F\u093E \u0939\u0948?","fj":"Vosa Vakaviti / Fijian","fr":"Fran\xe7ais / French","ja":"\u65E5\u672C\u8A9E / Japanese","ko":"\uD55C\uAD6D\uC5B4 / Korean","label":"\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u094B \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u0938\u092E\u091D\u0928\u0947 \u092E\u0947\u0902 \u0915\u0920\u093F\u0928\u093E\u0908 \u0939\u094B\u0924\u0940 \u0939\u0948?","mi":"Te Reo M\u0101ori","ms":"Malay / Malaysian","nextLabel":"$t(common:next): <b>\u0927\u093E\u0930\u094D\u092E\u093F\u0915 \u092F\u093E \u0906\u0927\u094D\u092F\u093E\u0924\u094D\u092E\u093F\u0915 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E\u090F\u0901</b>","other":"\u0905\u0928\u094D\u092F","pt":"Portugu\xeas / Portuguese","sm":"Gagana Samoa / Samoan","ta":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD / Tamil","title":"<h3>\u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u0938\u092E\u091D\u0928\u093E</h3>","tl":"Tagalog / Tagalog","to":"Lea Faka-Tonga / Tongan","zh":"\u7B80\u4F53\u4E2D\u6587 / Chinese"},"mobility":{"detailsPlaceholder":"\u0915\u0943\u092A\u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092D\u0930\u0947\u0902\u0964 \u0909\u0926\u093E\u0939\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F:<br/>\u0935\u0949\u0915\u0930 \u092F\u093E \u0935\u094D\u0939\u0940\u0932\u091A\u0947\u092F\u0930 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0924\u0947 \u0939\u0948\u0902; \u092C\u093F\u0938\u094D\u0924\u0930 \u092A\u0930 \u091A\u0922\u093C\u0928\u0947 \u092E\u0947\u0902 \u0938\u0939\u093E\u092F\u0924\u093E \u0915\u0940 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E","label":"\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u094B \u0915\u094B\u0908 \u0935\u093F\u0915\u0932\u093E\u0902\u0917\u0924\u093E \u0939\u0948 \u092F\u093E \u091A\u0932\u0928\u0947-\u092B\u093F\u0930\u0928\u0947 \u092E\u0947\u0902 \u0938\u0939\u093E\u092F\u0924\u093E \u0915\u0940 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E \u0939\u0948?","nextLabel":"$t(common:next): <b>\u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u0938\u092E\u091D\u0928\u093E</b>","title":"<h3>\u0917\u0924\u093F\u0936\u0940\u0932\u0924\u093E</h3>"},"other":{"detailsPlaceholder":"\u0915\u0947\u0935\u0932 \u0935\u0939\u0940 \u0938\u093E\u091D\u093E \u0915\u0930\u0947\u0902 \u091C\u094B \u0906\u092A\u0915\u094B \u092A\u094D\u0930\u093E\u0938\u0902\u0917\u093F\u0915 \u0932\u0917\u0947\u0964 \u0907\u0938\u0938\u0947 \u0939\u092E\u0947\u0902 \u0906\u092A\u0915\u0940 \u092C\u0947\u0939\u0924\u0930 \u0938\u0939\u093E\u092F\u0924\u093E \u0915\u0930\u0928\u0947 \u092E\u0947\u0902 \u092E\u0926\u0926 \u092E\u093F\u0932\u0924\u0940 \u0939\u0948\u0964","label":"\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u0940 \u0915\u094B\u0908 \u0905\u0928\u094D\u092F \u0935\u093F\u0936\u0947\u0937 \u091C\u093C\u0930\u0942\u0930\u0924\u0947\u0902 \u0939\u0948\u0902, \u092F\u093E \u0915\u0941\u091B \u0914\u0930 \u0939\u0948 \u091C\u094B \u0906\u092A \u0939\u092E\u0947\u0902 \u092C\u0924\u093E\u0928\u093E \u091A\u093E\u0939\u0947\u0902\u0917\u0947?","nextLabel":"$t(common:next): <b>\u0906\u092A\u0915\u0940 \u092C\u093E\u0909\u0932 \u092A\u094D\u0930\u0947\u092A \u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0915\u0930\u0928\u093E</b>","title":"<h3>\u0905\u0928\u094D\u092F \u0935\u093F\u0936\u0947\u0937 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E\u090F\u0901 \u092F\u093E \u091C\u093E\u0928\u0915\u093E\u0930\u0940</h3>"},"prep":{"label":"\u0915\u0943\u092A\u092F\u093E \u091A\u0941\u0928\u0947\u0902 \u0915\u093F \u0906\u092A \u0907\u0938\u0947 \u0915\u0948\u0938\u0947 \u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0915\u0930\u0928\u093E \u091A\u093E\u0939\u0947\u0902\u0917\u0947:","nextLabel":"$t(common:next): <b>\u092C\u0941\u0915\u093F\u0902\u0917 \u092A\u0942\u0930\u093E \u0915\u0930\u0947\u0902</b>","pick-up-from-hospital":"<label>{{company}} \u0938\u0947 \u092A\u093F\u0915-\u0905\u092A \u0915\u0930\u0947\u0902</label>\\n<p>\u0916\u0941\u0932\u0928\u0947 \u0915\u0947 \u0938\u092E\u092F \u0915\u0947 \u0926\u094C\u0930\u093E\u0928 \u0930\u093F\u0938\u0947\u092A\u094D\u0936\u0928 \u0938\u0947 \u0905\u092A\u0928\u0940 \u092A\u094D\u0930\u0947\u092A \u092A\u0948\u0915 \u0932\u0947\u0902\u0964</p>","pick-up-from-local-pharmacy":"<label>\u0905\u092A\u0928\u0947 \u0928\u091C\u093C\u0926\u0940\u0915\u0940 \u092B\u093C\u093E\u0930\u094D\u092E\u0947\u0938\u0940 \u0938\u0947 \u092A\u093F\u0915-\u0905\u092A \u0915\u0930\u0947\u0902</label>\\n<p>\u0939\u092E \u0906\u092A\u0915\u094B \u090F\u0915 \u092A\u094D\u0930\u093F\u0938\u094D\u0915\u094D\u0930\u093F\u092A\u094D\u0936\u0928 \u0908\u092E\u0947\u0932 \u0915\u0930\u0947\u0902\u0917\u0947 \u091C\u093F\u0938\u0947 \u0906\u092A \u0905\u092A\u0928\u0940 \u092B\u093C\u093E\u0930\u094D\u092E\u0947\u0938\u0940 \u092E\u0947\u0902 \u0932\u0947 \u091C\u093E \u0938\u0915\u0924\u0947 \u0939\u0948\u0902\u0964</p>","receive-by-mail":"<label>\u0921\u093E\u0915 \u0926\u094D\u0935\u093E\u0930\u093E \u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0915\u0930\u0947\u0902</label>\\n<p>\u0939\u092E \u0906\u092A\u0915\u093E \u092A\u094D\u0930\u0947\u092A \u092A\u0948\u0915 \u0906\u092A\u0915\u0947 \u0926\u094D\u0935\u093E\u0930\u093E \u0926\u093F\u090F \u0917\u090F \u0918\u0930 \u0915\u0947 \u092A\u0924\u0947 \u092A\u0930 \u0915\u0941\u0930\u093F\u092F\u0930 \u0915\u0930\u0947\u0902\u0917\u0947\u0964</p>","text":"\u0906\u092A\u0915\u0940 \u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u0915\u0940 \u0924\u0948\u092F\u093E\u0930\u0940 \u0915\u0947 \u0932\u093F\u090F, \u0906\u092A\u0915\u094B \u090F\u0915 \u0935\u093F\u0936\u0947\u0937 \u0926\u0935\u093E \u0932\u0947\u0928\u0940 \u0939\u094B\u0917\u0940 \u091C\u094B \u0906\u092A\u0915\u0940 \u0906\u0902\u0924\u094B\u0902 \u0915\u094B \u0938\u093E\u092B \u0915\u0930\u0924\u0940 \u0939\u0948\u0964","title":"<h3>\u0905\u092A\u0928\u0940 \u0906\u0902\u0924 \u0915\u0940 \u0926\u0935\u093E \u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0915\u0930\u0928\u093E</h3><p>\u0906\u092A\u0915\u0940 \u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u0915\u0940 \u0924\u0948\u092F\u093E\u0930\u0940 \u0915\u0947 \u0932\u093F\u090F, \u0906\u092A\u0915\u094B \u090F\u0915 \u0935\u093F\u0936\u0947\u0937 \u0926\u0935\u093E \u0932\u0947\u0928\u0940 \u0939\u094B\u0917\u0940 \u091C\u094B \u0906\u092A\u0915\u0940 \u0906\u0902\u0924\u094B\u0902 \u0915\u094B \u0938\u093E\u092B \u0915\u0930\u0924\u0940 \u0939\u0948\u0964</p>"},"religion":{"detailsPlaceholder":"<p>\u0915\u0943\u092A\u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 (English) \u092E\u0947\u0902 \u092D\u0930\u0947\u0902\u0964 \u0909\u0926\u093E\u0939\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F:<br/>Quiet space for prayer, prefer same-gender staff for personal care</p>","label":"\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u0940 \u0915\u094B\u0908 \u0927\u093E\u0930\u094D\u092E\u093F\u0915 \u092F\u093E \u0906\u0927\u094D\u092F\u093E\u0924\u094D\u092E\u093F\u0915 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E\u090F\u0902 \u0939\u0948\u0902?","nextLabel":"$t(common:next): <b>\u0938\u093E\u0902\u0938\u094D\u0915\u0943\u0924\u093F\u0915 \u092F\u093E \u092A\u093E\u0930\u093F\u0935\u093E\u0930\u093F\u0915 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E\u090F\u0902</b>","title":"<h3>\u0927\u093E\u0930\u094D\u092E\u093F\u0915 \u092F\u093E \u0906\u0927\u094D\u092F\u093E\u0924\u094D\u092E\u093F\u0915 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E\u090F\u0902</h3>"}}}');


var $0e588dddcbe092c6$exports = {};
$0e588dddcbe092c6$exports = JSON.parse('{"helpMessage":"<h3>\u0917\u094B\u092A\u0928\u0940\u092F\u0924\u093E \u0938\u0947 \u091C\u0941\u0921\u093C\u0947 \u0938\u0935\u093E\u0932?</h3>\\n<p>\u0939\u092E\u093E\u0930\u0940 \u091F\u0940\u092E \u092E\u0926\u0926 \u0915\u0947 \u0932\u093F\u090F \u0909\u092A\u0932\u092C\u094D\u0927 \u0939\u0948 - \u0915\u0949\u0932 \u0915\u0930\u0947\u0902:<br/>\\n<a><strong>\u260E\uFE0F {{phone}}</strong></a> (\u092B\u093F\u0930 <strong>Option 2</strong> \u0926\u092C\u093E\u090F\u0902)<br/>\\n\u0938\u094B\u092E\u0935\u093E\u0930 \u0938\u0947 \u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930, \u0938\u0941\u092C\u0939 8 \u092C\u091C\u0947 \u2013 \u0936\u093E\u092E 5 \u092C\u091C\u0947\u0964</p>","privacyDetails":"<ul><li>\u0906\u092A \u0938\u092E\u091D\u0924\u0947 \u0939\u0948\u0902 \u0915\u093F \u0906\u092A\u0915\u0940 \u091C\u093E\u0928\u0915\u093E\u0930\u0940 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0948\u0938\u0947 \u0915\u093F\u092F\u093E \u091C\u093E\u090F\u0917\u093E\u0964</li><li>\u0906\u092A \u092F\u0939 \u092C\u0941\u0915\u093F\u0902\u0917 \u0905\u092A\u0928\u0947 \u0932\u093F\u090F \u092F\u093E \u0909\u0938 \u0935\u094D\u092F\u0915\u094D\u0924\u093F \u0915\u0947 \u0932\u093F\u090F \u0915\u0930 \u0930\u0939\u0947 \u0939\u0948\u0902 \u091C\u093F\u0938\u0947 \u0906\u092A \u0938\u0939\u093E\u092F\u0924\u093E \u092A\u094D\u0930\u0926\u093E\u0928 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0905\u0927\u093F\u0915\u0943\u0924 \u0939\u0948\u0902 (\u091C\u0948\u0938\u0947 \u0915\u093F \u090F\u0915 \u0926\u0947\u0916\u092D\u093E\u0932\u0915\u0930\u094D\u0924\u093E \u092F\u093E \u0905\u092D\u093F\u092D\u093E\u0935\u0915)\u0964</li><li>\u0906\u092A \u092C\u0941\u0915\u093F\u0902\u0917 \u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u091C\u093E\u0930\u0940 \u0930\u0916\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0938\u0939\u092E\u0924 \u0939\u0948\u0902\u0964</li></ul>","privacyLabel":"\u092E\u0948\u0902 \u0907\u0938 \u0917\u094B\u092A\u0928\u0940\u092F\u0924\u093E \u0935\u093F\u0935\u0930\u0923 \u0915\u094B \u0938\u094D\u0935\u0940\u0915\u093E\u0930 \u0915\u0930\u0924\u093E \u0939\u0942\u0902","privacyText":"\u0907\u0938 \u0917\u094B\u092A\u0928\u0940\u092F\u0924\u093E \u0935\u093F\u0935\u0930\u0923 \u0915\u094B \u0938\u094D\u0935\u0940\u0915\u093E\u0930 \u0915\u0930\u0915\u0947, \u0906\u092A \u0907\u0938\u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0924\u0947 \u0939\u0948\u0902 \u0915\u093F:","text":"<p>\u0939\u092E \u0906\u092A\u0915\u0940 \u0917\u094B\u092A\u0928\u0940\u092F\u0924\u093E \u0915\u094B \u0917\u0902\u092D\u0940\u0930\u0924\u093E \u0938\u0947 \u0932\u0947\u0924\u0947 \u0939\u0948\u0902\u0964</p>\\n<p>\u0907\u0938 \u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u0915\u0947 \u0926\u094C\u0930\u093E\u0928 \u0926\u0940 \u0917\u0908 \u091C\u093E\u0928\u0915\u093E\u0930\u0940 \u0915\u094B \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0930\u0942\u092A \u0938\u0947 \u0938\u0902\u0917\u094D\u0930\u0939\u0940\u0924 \u0915\u093F\u092F\u093E \u091C\u093E\u090F\u0917\u093E \u0914\u0930 \u0915\u0947\u0935\u0932 {{company}} \u092E\u0947\u0902 \u0906\u092A\u0915\u0940 \u0926\u0947\u0916\u092D\u093E\u0932 \u0915\u0947 \u0938\u092E\u0930\u094D\u0925\u0928 \u0915\u0947 \u0932\u093F\u090F \u0909\u092A\u092F\u094B\u0917 \u0915\u093F\u092F\u093E \u091C\u093E\u090F\u0917\u093E\u0964</p>\\n<p>\u0906\u092A\u0915\u093E \u0935\u094D\u092F\u0915\u094D\u0924\u093F\u0917\u0924 \u0914\u0930 \u091A\u093F\u0915\u093F\u0924\u094D\u0938\u0940\u092F \u0935\u093F\u0935\u0930\u0923 \u0915\u0947\u0935\u0932 \u0909\u0928 \u0938\u094D\u0935\u093E\u0938\u094D\u0925\u094D\u092F \u092A\u0947\u0936\u0947\u0935\u0930\u094B\u0902 \u0915\u0947 \u0938\u093E\u0925 \u0938\u093E\u091D\u093E \u0915\u093F\u092F\u093E \u091C\u093E\u090F\u0917\u093E \u091C\u094B \u0906\u092A\u0915\u0947 \u0909\u092A\u091A\u093E\u0930 \u092E\u0947\u0902 \u0936\u093E\u092E\u093F\u0932 \u0939\u0948\u0902\u0964</p>\\n<p>\u0939\u092E \u0906\u092A\u0915\u0947 \u0921\u0947\u091F\u093E \u0915\u094B \u0935\u093F\u092A\u0923\u0928 (\u092E\u093E\u0930\u094D\u0915\u0947\u091F\u093F\u0902\u0917) \u0909\u0926\u094D\u0926\u0947\u0936\u094D\u092F\u094B\u0902 \u0915\u0947 \u0932\u093F\u090F \u0915\u093F\u0938\u0940 \u0924\u0940\u0938\u0930\u0947 \u092A\u0915\u094D\u0937 \u0915\u0947 \u0938\u093E\u0925 \u0938\u093E\u091D\u093E \u0928\u0939\u0940\u0902 \u0915\u0930\u0924\u0947 \u0939\u0948\u0902\u0964</p>\\n<p>\u0906\u092A \u0915\u092D\u0940 \u092D\u0940 \u0939\u092E\u0938\u0947 \u0938\u0902\u092A\u0930\u094D\u0915 \u0915\u0930\u0915\u0947 \u0905\u092A\u0928\u0940 \u091C\u093E\u0928\u0915\u093E\u0930\u0940 \u0915\u094B \u0926\u0947\u0916\u0928\u0947 \u092F\u093E \u0909\u0938\u092E\u0947\u0902 \u0938\u0941\u0927\u093E\u0930 \u0915\u0930\u0928\u0947 \u0915\u093E \u0905\u0928\u0941\u0930\u094B\u0927 \u0915\u0930 \u0938\u0915\u0924\u0947 \u0939\u0948\u0902\u0964</p>","title":"Privacy Statement"}');


var $dff37a1fe147f0fc$exports = {};
$dff37a1fe147f0fc$exports = JSON.parse('{"anySpecialist":{"text":"\u092E\u0941\u091D\u0947 \u0909\u092A\u0932\u092C\u094D\u0927 \u0905\u092A\u0949\u0907\u0902\u091F\u092E\u0947\u0902\u091F \u0938\u092E\u092F\u094B\u0902 \u0915\u0940 \u0938\u092C\u0938\u0947 \u0935\u093F\u0938\u094D\u0924\u0943\u0924 \u0938\u0942\u091A\u0940 \u0926\u093F\u0916\u093E\u090F\u0902\u0964","title":"\u092E\u0941\u091D\u0947 \u0915\u094B\u0908 \u092B\u0930\u094D\u0915 \u0928\u0939\u0940\u0902 \u092A\u0921\u093C\u0924\u093E"},"nextLabel":"$t(common:next): <b>\u0938\u092E\u092F \u091A\u0941\u0928\u0947\u0902</b>","profile":"\u0935\u093F\u0936\u0947\u0937\u091C\u094D\u091E \u092A\u094D\u0930\u094B\u092B\u093C\u093E\u0907\u0932","specialists":{"00000000-0000-da7a-0003-000000000004":{"name":"Dr. Lopez"}},"textMultiple":"<p>\u092F\u0947 \u0938\u092D\u0940 \u0935\u093F\u0936\u0947\u0937\u091C\u094D\u091E \u092C\u0947\u0939\u0924\u0930\u0940\u0928 \u0935\u093F\u0915\u0932\u094D\u092A \u0939\u0948\u0902\u0964 \u0915\u093F\u0938\u0940 \u090F\u0915 \u0915\u094B \u091A\u0941\u0928\u0947\u0902, \u092F\u093E \u201C\u092E\u0941\u091D\u0947 \u0915\u094B\u0908 \u092B\u0930\u094D\u0915 \u0928\u0939\u0940\u0902 \u092A\u0921\u093C\u0924\u093E\u201D \u0935\u093F\u0915\u0932\u094D\u092A \u0915\u0947 \u0938\u093E\u0925 \u0906\u0917\u0947 \u092C\u0922\u093C\u0947\u0902\u0964</p>","textSingle":"<p>\u0906\u092A\u0915\u0947 \u091C\u0940\u092A\u0940 \u2013 {{referral.gp}} \u2013 \u0928\u0947 \u0906\u092A\u0915\u094B \u092F\u0939\u093E\u0902 \u0930\u0947\u092B\u0930 \u0915\u093F\u092F\u093E \u0939\u0948:</p>","titleMultiple":"\u0905\u092A\u0928\u0947 \u0935\u093F\u0936\u0947\u0937\u091C\u094D\u091E \u0915\u093E \u091A\u092F\u0928 \u0915\u0930\u0947\u0902","titleSingle":"\u0906\u092A\u0915\u0947 \u0935\u093F\u0936\u0947\u0937\u091C\u094D\u091E","viewProfile":"\u092A\u0942\u0930\u093E \u092A\u094D\u0930\u094B\u092B\u093C\u093E\u0907\u0932 \u0926\u0947\u0916\u0947\u0902"}');


var $2e45f9a59b7b5db0$exports = {};
$2e45f9a59b7b5db0$exports = JSON.parse('{"bookButtonLabel":"\u0905\u092D\u0940 \u0905\u092A\u0949\u0907\u0902\u091F\u092E\u0947\u0902\u091F \u092C\u0941\u0915 \u0915\u0930\u0947\u0902","bookText":"<h3>\u0911\u0928\u0932\u093E\u0907\u0928 \u092C\u0941\u0915 \u0915\u0930\u0947\u0902:</h3>\\n<ul>\\n  <li>\u23F1\uFE0F  <strong>\u0924\u0947\u091C\u093C \u0914\u0930 \u0906\u0938\u093E\u0928 -</strong> 15 \u092E\u093F\u0928\u091F \u092F\u093E \u0915\u092E</li>\\n  <li>\uD83C\uDF19  <strong>\u0915\u092D\u0940 \u092D\u0940 \u092C\u0941\u0915 \u0915\u0930\u0947\u0902 -</strong> \u0915\u093E\u092E\u0915\u093E\u091C\u0940 \u0938\u092E\u092F \u0915\u0947 \u092C\u093E\u0926 \u092D\u0940</li>\\n  <li>\uD83D\uDDD3\uFE0F  <strong>\u0905\u092A\u0928\u0947 \u0905\u0928\u0941\u0938\u093E\u0930 \u0938\u092E\u092F \u091A\u0941\u0928\u0947\u0902</strong></li>\\n  <li>\uD83D\uDD10  <strong>\u0915\u094B\u0908 \u0915\u093E\u0917\u091C\u0940 \u0915\u093E\u092E \u0928\u0939\u0940\u0902 -</strong> \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0914\u0930 \u0938\u091F\u0940\u0915</li>\\n</ul>","declineButtonLabel":"\u0907\u0938 \u092C\u0941\u0915\u093F\u0902\u0917 \u0928\u093F\u092E\u0902\u0924\u094D\u0930\u0923 \u0915\u094B \u0905\u0938\u094D\u0935\u0940\u0915\u093E\u0930 \u0915\u0930\u0947\u0902","declineText":"<h3>\u0915\u094D\u092F\u093E \u0906\u092A \u0907\u0938 \u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u0915\u0940 \u0909\u092E\u094D\u092E\u0940\u0926 \u0928\u0939\u0940\u0902 \u0915\u0930 \u0930\u0939\u0947 \u0925\u0947 \u092F\u093E \u0907\u0938\u0947 \u0928\u0939\u0940\u0902 \u091A\u093E\u0939\u0924\u0947?</h3>\\n<p>\u0915\u0943\u092A\u092F\u093E \u0915\u093E\u0930\u0923 \u091A\u0941\u0928\u0915\u0930 \u0939\u092E\u0947\u0902 \u092C\u0924\u093E\u090F\u0902:</p>","helpMessage":"<h3>\u0915\u094D\u092F\u093E \u0906\u092A \u0915\u093F\u0938\u0940 \u0938\u0947 \u092C\u093E\u0924 \u0915\u0930\u0928\u093E \u092A\u0938\u0902\u0926 \u0915\u0930\u0947\u0902\u0917\u0947?</h3>\\n<p>\u0939\u092E\u093E\u0930\u0940 \u0938\u0939\u093E\u092F\u0915 \u091F\u0940\u092E \u0906\u092A\u0915\u0940 \u092E\u0926\u0926 \u0915\u0947 \u0932\u093F\u090F \u0924\u0948\u092F\u093E\u0930 \u0939\u0948:<br/><a><strong>\u260E\uFE0F {{phone}}</strong></a> (\u092B\u093F\u0930 <strong>\u0935\u093F\u0915\u0932\u094D\u092A 2</strong> \u0926\u092C\u093E\u090F\u0902)<br/>\u0938\u094B\u092E\u0935\u093E\u0930 \u0938\u0947 \u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930, \u0938\u0941\u092C\u0939 8 \u0938\u0947 \u0936\u093E\u092E 5 \u092C\u091C\u0947 \u0924\u0915\u0964</p>\\n<p><em>\u0939\u092E\u093E\u0930\u0940 \u091F\u0940\u092E \u0915\u0947\u0935\u0932 \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092C\u094B\u0932 \u0938\u0915\u0924\u0940 \u0939\u0948 \u2014 \u0906\u092A\u0915\u0940 \u0938\u092E\u091D\u0926\u093E\u0930\u0940 \u0915\u0947 \u0932\u093F\u090F \u0927\u0928\u094D\u092F\u0935\u093E\u0926\u0964</em></p>","info":"<h3>\u0915\u094D\u092F\u093E \u0906\u092A \u0907\u0938 \u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u0915\u0947 \u092C\u093E\u0930\u0947 \u092E\u0947\u0902 \u0914\u0930 \u091C\u093E\u0928\u0928\u093E \u091A\u093E\u0939\u0924\u0947 \u0939\u0948\u0902?</h3>\\n<p>\u090F\u0915 \u091B\u094B\u091F\u093E \u0938\u093E \u0935\u0940\u0921\u093F\u092F\u094B \u0926\u0947\u0916\u0947\u0902 \u091C\u094B \u092C\u0924\u093E\u0924\u093E \u0939\u0948 \u0915\u093F \u0915\u094D\u092F\u093E \u0905\u092A\u0947\u0915\u094D\u0937\u093E \u0915\u0930\u0947\u0902 \u0914\u0930 \u0915\u0948\u0938\u0947 \u0924\u0948\u092F\u093E\u0930\u0940 \u0915\u0930\u0947\u0902\u0964</p>","select":{"badTiming":"\u0938\u092E\u092F \u0938\u0941\u0935\u093F\u0927\u093E\u091C\u0928\u0915 \u0928\u0939\u0940\u0902 \u0939\u0948","cantAfford":"\u0905\u092D\u0940 \u0916\u0930\u094D\u091A \u0928\u0939\u0940\u0902 \u0909\u0920\u093E \u0938\u0915\u0924\u093E/\u0938\u0915\u0924\u0940","didntKnowReferred":"\u092E\u0941\u091D\u0947 \u0928\u0939\u0940\u0902 \u092A\u0924\u093E \u0925\u093E \u0915\u093F \u092E\u0947\u0930\u093E \u0930\u0947\u092B\u093C\u0930\u0932 \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u0939\u0948","hadElsewhere":"\u092E\u0948\u0902 \u092F\u0939 \u092A\u0939\u0932\u0947 \u0939\u0940 \u0915\u0939\u0940\u0902 \u0914\u0930 \u0915\u0930\u0935\u093E \u091A\u0941\u0915\u093E/\u091A\u0941\u0915\u0940 \u0939\u0942\u0901","notNecessary":"\u092E\u0941\u091D\u0947 \u0928\u0939\u0940\u0902 \u0932\u0917\u0924\u093E \u0915\u093F \u092F\u0939 \u091C\u093C\u0930\u0942\u0930\u0940 \u0939\u0948","placeholder":"\u090F\u0915 \u0915\u093E\u0930\u0923 \u091A\u0941\u0928\u0947\u0902"},"text":"<p>\u0906\u092A\u0915\u0947 \u091C\u0940\u092A\u0940 <strong>{{requestingPractitioner.displayName}}</strong> \u0928\u0947 \u0906\u092A\u0915\u094B <strong>{{practitioners.0.name}}</strong> \u0915\u0947 \u0938\u093E\u0925 <strong>{{procedure.displayName}}</strong> \u0915\u0947 \u0932\u093F\u090F \u0930\u0947\u092B\u0930 \u0915\u093F\u092F\u093E \u0939\u0948\u0964</p>","textNoSpecialist":"<p>\u0906\u092A\u0915\u0947 \u091C\u0940\u092A\u0940 <strong>{{requestingPractitioner.displayName}}</strong> \u0928\u0947 \u0906\u092A\u0915\u094B <strong>{{procedure.displayName}}</strong> \u0915\u0947 \u0932\u093F\u090F \u0930\u0947\u092B\u0930 \u0915\u093F\u092F\u093E \u0939\u0948\u0964</p>","title":"\u0928\u092E\u0938\u094D\u0924\u0947 {{patient.nameGiven}}\u0964<br /> \u0905\u092C \u0906\u092A\u0915\u0940 \u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u0915\u0940 \u092C\u0941\u0915\u093F\u0902\u0917 \u0915\u093E \u0938\u092E\u092F \u0939\u0948\u0964","videoButtonLabel":"\u090F\u0902\u0921\u094B\u0938\u094D\u0915\u094B\u092A\u0940 \u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u0915\u0947 \u092C\u093E\u0930\u0947 \u092E\u0947\u0902 \u0935\u0940\u0921\u093F\u092F\u094B \u091A\u0932\u093E\u090F\u0902","videoCaption":"\u0939\u092E \u0905\u0928\u0941\u0936\u0902\u0938\u093E \u0915\u0930\u0924\u0947 \u0939\u0948\u0902 \u0915\u093F \u092C\u0941\u0915\u093F\u0902\u0917 \u0938\u0947 \u092A\u0939\u0932\u0947 \u0907\u0938 \u0935\u0940\u0921\u093F\u092F\u094B \u0915\u094B \u0926\u0947\u0916\u0947\u0902\u0964","videos":{"fallback":"xOJ9ZzI4ZMJesGEHEhogTu1uavfbneC6m5Xuf5HDrCo","gas":"xOJ9ZzI4ZMJesGEHEhogTu1uavfbneC6m5Xuf5HDrCo"}}');


var $3440822999052813$exports = {};
$3440822999052813$exports = JSON.parse('{"birthDate":"\u0906\u092A\u0915\u0940 \u091C\u0928\u094D\u092E\u0924\u093F\u0925\u093F","dateFormat":"dd/mm/yyyy","familyName":"\u0906\u092A\u0915\u093E \u0909\u092A\u0928\u093E\u092E","helpMessage":"<p>\u092F\u0926\u093F \u090A\u092A\u0930 \u0926\u093F\u092F\u093E \u0917\u092F\u093E \u0928\u0902\u092C\u0930 \u0938\u0939\u0940 \u0928\u0939\u0940\u0902 \u0932\u0917 \u0930\u0939\u093E \u0939\u0948, \u092F\u093E \u0906\u092A \u0928\u0939\u0940\u0902 \u091C\u093E\u0928\u0924\u0947 \u0915\u093F \u0915\u094D\u092F\u093E \u0915\u0930\u0928\u093E \u0939\u0948, \u0924\u094B \u0915\u0943\u092A\u092F\u093E \u0939\u092E\u0947\u0902 <a><strong>{{phone}}</strong></a> \u092A\u0930 \u0915\u0949\u0932 \u0915\u0930\u0947\u0902 (\u092B\u093F\u0930 <strong>\u0935\u093F\u0915\u0932\u094D\u092A 2</strong> \u0926\u092C\u093E\u090F\u0902)\u0964</p>","sendCode":"\u0915\u094B\u0921 \u092D\u0947\u091C\u0947\u0902","text":"<p>\u092F\u0939 \u092C\u0941\u0915\u093F\u0902\u0917 \u0928\u093F\u092E\u0902\u0924\u094D\u0930\u0923 \u0909\u0938 \u092E\u0930\u0940\u091C\u093C \u0915\u0947 \u0932\u093F\u090F \u0939\u0948 \u091C\u093F\u0938\u0915\u0940 \u0926\u0947\u0916\u092D\u093E\u0932 \u0907\u0938 \u092E\u094B\u092C\u093E\u0907\u0932 \u0928\u0902\u092C\u0930 \u0935\u093E\u0932\u0947 \u0935\u094D\u092F\u0915\u094D\u0924\u093F \u0926\u094D\u0935\u093E\u0930\u093E \u0915\u0940 \u091C\u093E \u0930\u0939\u0940 \u0939\u0948: <strong><PhonePlaceholder /></strong></p>\\n<p>\u092F\u0926\u093F \u092F\u0939 \u0906\u092A \u0939\u0948\u0902, \u0924\u094B \u0915\u0943\u092A\u092F\u093E \u0928\u0940\u091A\u0947 <strong>\u092E\u0930\u0940\u091C\u093C \u0915\u093E \u0909\u092A\u0928\u093E\u092E</strong> \u0914\u0930 <strong>\u091C\u0928\u094D\u092E\u0924\u093F\u0925\u093F</strong> \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902 \u0914\u0930 \u092C\u091F\u0928 \u092A\u0930 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902\u0964</p>\\n<p>\u0938\u0941\u0930\u0915\u094D\u0937\u093E \u0915\u0947 \u0932\u093F\u090F, \u0939\u092E \u0906\u092A\u0915\u0940 \u092A\u0939\u091A\u093E\u0928 \u0938\u0924\u094D\u092F\u093E\u092A\u093F\u0924 \u0915\u0930\u0928\u0947 \u0939\u0947\u0924\u0941 \u0906\u092A\u0915\u094B \u090F\u0915 \u092C\u093E\u0930 \u0907\u0938\u094D\u0924\u0947\u092E\u093E\u0932 \u0939\u094B\u0928\u0947 \u0935\u093E\u0932\u093E <strong>4-\u0905\u0902\u0915\u094B\u0902 \u0915\u093E \u0915\u094B\u0921</strong> \u092D\u0947\u091C\u0947\u0902\u0917\u0947\u0964</p>","title":"<strong>{{company}} \u0911\u0928\u0932\u093E\u0907\u0928 \u092C\u0941\u0915\u093F\u0902\u0917</strong> \u092E\u0947\u0902 \u0906\u092A\u0915\u093E \u0938\u094D\u0935\u093E\u0917\u0924 \u0939\u0948"}');


var $9789a2c276072f1b$exports = {};
$9789a2c276072f1b$exports = JSON.parse('{"back":"Muri","bookmarksMenu":"Tahua","change":"Hurihia","closeBookmarksMenu":"Katia te tahua","closeDialog":"Katia","colonoscopy":"m\u0101tai k\u014Dp\u016B (colonoscopy)","continue":"Haere tonu","details":"Ng\u0101 Taipitopito","errors":{"invalidOtp":{"details":"<ul>  \\n<li>Tirohia m\u0113n\u0101 he h\u0113 te tuhituhi, \u0101, ngana an\u014D.</li>  \\n<li>M\u0113n\u0101 kei te raru koe, waea mai ki a m\u0101tou i {{phone}} (p\u0113hia te K\u014Dwhiringa 2).</li>  \\n</ul>","title":"K\u0101ore t\u0113r\u0101 i h\u0101ngai ki \u0101 m\u0101tou p\u016Bkete"},"serverErrorOtp":{"details":"<ul>  \\n<li>T\u0113r\u0101 pea he tika \u014D taipitopito \u2013 engari k\u0101ore i taea te manatoko i t\u0113nei w\u0101.</li>  \\n<li>Tatari m\u014D t\u0113tahi w\u0101 poto, \u0101, ngana an\u014D.</li>  \\n</ul>","title":"I hapa t\u0113tahi mea."}},"formattedDate":"{{date}} i te {{time}}","gastroscopy":"m\u0101tai puku (gastroscopy)","loading":"Kei te utaina...","next":"Panuku","no":"K\u0101o","openBookmarksMenu":"Huakina te tahua","optional":"He k\u014Dwhiringa","progress":"K\u014Dkiritanga {{progress}}%","selectLanguage":"K\u014Dwhiria te reo","step":{"appointment":"Te W\u0101 Tono","details":"Ng\u0101 Taipitopito Whaiaro","health-questions":"Ng\u0101 P\u0101tai Hauora","history":"Ng\u0101 h\u0101tepe, pokanga r\u0101nei o mua","insurance":"Inihua Hauora","medications":"Ng\u0101 Rongo\u0101","preference-questions":"Ng\u0101 P\u0101tai Manakohanga","specialist":"M\u0101tanga"},"videoUnsupported":"K\u0101ore t\u014D p\u016Btirotiro e tautoko ana i te t\u016Btohu ataata.","yes":"\u0100e","yesTo":"\u0100e ki","yourProgress":"T\u014D kokiritanga"}');


var $249af127d2a7c2c3$exports = {};
$249af127d2a7c2c3$exports = JSON.parse('{"comingSoonText":"<p>Kua kite pea koe k\u0101ore he w\u0101 tono e w\u0101tea ana m\u014D te wiki kotahi atu i t\u0113nei r\u0101.</p>\\n<p>I \u0113tahi w\u0101, ka puta mai he w\u0101 moata n\u0101 te whakakore a t\u0113tahi atu.</p>\\n<p>M\u0113n\u0101 ka w\u0101tea he w\u0101 moata ake, e hiahia ana koe kia whakap\u0101 atu m\u0101tou ki a koe?</p>\\n<p>Kaore he p\u0113hitanga kia panoni \u2013 ka taea tonu e koe te noho ki t\u014D w\u0101 o n\u0101ianei m\u0113n\u0101 e pai ana.</p>","comingSoonTitle":"Kei te pai koe ki te tae wawe ake?","contactConsent":{"no":"K\u0101o \u2013 ka \u016B au ki t\u0101ku i k\u014Dwhiri ai","yes":"\u0100e \u2013 he pai ki au kia whakap\u0101 mai"},"contactConsentDetails":{"no":"Kaore m\u0101tou e whakap\u0101 atu ki a koe m\u014D ng\u0101 w\u0101 moata ake.","yes":"M\u0113n\u0101 ka w\u0101tea t\u0113tahi w\u0101 moata ake, ka whakam\u014Dhiotia koe e m\u0101tou."},"description":"<p>Kua tae in\u0101ianei ki te <strong>{{deadlineText}}</strong> te w\u0101 e toe ana ki te whakaoti i t\u014D tono \u2013 e <b>{{deadlineTime}} h\u0101ora</b> pea t\u0113nei.</p>\\n<span>Hei whakaoti, me mahi \u0113nei e whai ake nei:</span>\\n<ul>\\n  <li>Whaka\u016B, t\u0101pirihia r\u0101nei <strong>ng\u0101 taipitopito t\u016Broro</strong></li>\\n  <li>K\u014Drero mai <strong>ko wai te kaituku utu</strong> (hei tauira, he inihua)</li>\\n  <li>Whakautua ng\u0101 <strong>p\u0101tai hauora me ng\u0101 manakohanga</strong></li>\\n</ul>\\n<p>I te nuinga o te w\u0101, ka iti iho i te <strong>12 meneti</strong> t\u0113nei mahi.</p>","nextLabel":"$t(common:next): <b>Whaka\u016B \u014D taipitopito</b>","text":"<p>Kua <Status>rahuitia m\u014D te w\u0101 poto</Status> t\u014D <strong>{{procedure.displayName}}</strong> me <strong>{{appointment.specialist}}</strong> i te <strong>{{appointment.time}}</strong> i te <strong>{{appointment.date}}</strong>.</p>","title":"Kua rahuitia t\u014D whakaritenga"}');


var $5b956ec06e36ff7c$exports = {};
$5b956ec06e36ff7c$exports = JSON.parse('{"modal":{"buttonLabel":"K\u014Dwhiria he w\u0101 hou","text":"Kua oti k\u0113 taua w\u0101 te rahui e t\u0113tahi atu.","title":"Kua t\u014Dmuri k\u0113!"},"nextLabel":"$t(common:next): <b>Rahui i te w\u0101 whakaritenga</b>","nextWeek":"\u0100 t\u0113r\u0101 wiki","noTimeText":"K\u0101ore he w\u0101 e w\u0101tea ana m\u014D te r\u0101 i t\u012Bpakohia.","prevWeek":"Wiki kua pahure","title":"K\u014Dwhiria t\u014D w\u0101 whakaritenga"}');


var $fa2fb4653712066a$exports = {};
$fa2fb4653712066a$exports = JSON.parse('{"helpMessage":"<p>M\u0113n\u0101 kei te raru koe, waea mai ki <a><strong>{{phone}}</strong></a> (ka p\u0113hi i te <strong>K\u014Dwhiringa 2</strong>).</p>","noCode":"K\u0101ore koe i whiwhi i te waehere?","remainingTime":"E toe ana te {{time}}","sendCode":"Tukua he waehere hou","text":"<p>Kua tukua e m\u0101tou he waehere 4-mati ki t\u014D nama waea p\u016Bkoro: <strong><PhonePlaceholder /></strong></p>\\n<p>He whaimana te waehere m\u014D te {{validityMinutes}} meneti.</p>\\n<p>T\u0101urua te waehere ki raro nei kia haere tonu.</p>","title":"T\u0101urua t\u014D waehere"}');


var $2bd4b42ea9100de9$exports = {};
$2bd4b42ea9100de9$exports = JSON.parse('{"calendarButtonLabel":"T\u0101piri ki te maramataka","confirmationText":"<h3>Ka tae mai t\u0113tahi \u012Bm\u0113ra i roto i te 24 h\u0101ora:</h3>\\n<ul>\\n  <li>\u2705  Whakau i te w\u0101 whakaritenga</li>\\n  <li>\uD83D\uDCB2  Matapae utu m\u0101 t\u014D inihua</li>\\n  <li></li>\\n  <li>\uD83E\uDD64  Ng\u0101 tohutohu whakarite</li>\\n  <li>\uD83C\uDFE5  M\u014Dhiohio m\u014D te taenga atu (arataki, waka t\u016Bmatanui etc.)</li>\\n  <li>\uD83D\uDC8A  T\u014D rongo\u0101 whakarite</li>\\n</ul>\\n<p>Ka arotake m\u0101tou i \u014D whakautu hauora, \u0101, m\u0113n\u0101 he take, ka whakap\u0101 atu t\u0113tahi o \u0101 m\u0101tou kaimahi i mua i t\u014D h\u0101tepe.</p>","helpMessage":"<h3>Whakap\u0101 mai</h3>\\n<p>M\u0113n\u0101 he p\u0101tai \u0101u, mehemea r\u0101nei e hiahia ana koe ki te whakarerek\u0113, waea mai ki t\u0101 m\u0101tou r\u014Dp\u016B \u0101whina:<br/>\\n<a><strong>\u260E\uFE0F {{phone}}</strong></a> (katahi ka p\u0113hi <strong>K\u014Dwhiringa 2</strong>)<br/>\\nR\u0101hina ki te R\u0101mere, 8am\u20135pm.</p>\\n<p><em>Ka \u0101hei pea \u0101 m\u0101tou kaimahi ki te k\u014Drero reo P\u0101keh\u0101 anake. T\u0113n\u0101 koa, me te manawanui mai.</em></p>","text":"<p>Kei a koe he <strong>{{procedure.displayName}}</strong> ki a <strong>{{appointment.specialist}}</strong> i te <strong>{{appointment.date}}</strong>, i te <strong>{{appointment.time}}</strong>, kua <Status>whakamanatia</Status>.</p>","title":"Ng\u0101 mihi {{patient.nameGiven}}! <br/> Kua ea katoa ng\u0101 mea e hiahiatia ana in\u0101ianei."}');


var $eac795d313488c6b$exports = {};
$eac795d313488c6b$exports = JSON.parse('{"contact-details":{"email":"W\u0101hitau \u012Bm\u0113ra","mobilePhone":"Waea p\u016Bkoro","nextLabel":"$t(common:next): <b>T\u014D rata GP (t\u0101kuta)</b>","otherPhone":"\u0112tahi atu waea","text":"Kua whakamahia \u0113nei k\u014Drero hei whakap\u0101 atu ki a koe, engari ka taea te whakahou m\u0113n\u0101 e tika ana.","title":"\u014C p\u0101rongo whakap\u0101"},"doctor":{"gp":"Ingoa o te rata GP (t\u0101kuta)","manually":"Kei te kore e puta te t\u0101kuta? <PrimaryText>T\u0101uritia \u0101-ringa...</PrimaryText>","medicalCentre":"Pokap\u016B Hauora","nextLabel":"$t(common:next): <b>T\u014D whakap\u0101 ohotata</b>","searchPlaceholder":"Kimihia t\u014D rata GP, pokap\u016B hauora r\u0101nei","text":"Ko t\u0113nei t\u014D rata GP? M\u0113n\u0101 k\u0101o, t\u0113n\u0101 whakahoungia.","title":"T\u014D rata GP (t\u0101kuta)"},"emergency":{"fullName":"Ingoa katoa","mobileNumber":"Tau waea p\u016Bkoro","nextLabel":"$t(common:next): <b>Inihua / ko wai te tangata e utu ana</b>","relationship":"Hononga ki a koe","select":{"child":"Tamariki","friend":"Hoa","other":"\u0112tahi atu","parent":"M\u0101tua","spouse":"Hoa rangatira / hoa"},"text":"Me whakap\u0101 atu ki wai i te w\u0101 ohotata?","title":"T\u0101u whakap\u0101 ohotata"},"home-address":{"building":"Papa, r\u016Bma, r\u0101nei o te hanga whare, o te w\u0101hanga r\u0101nei","city":"T\u0101one/N\u016Btara","manually":"K\u0101ore te w\u0101hitau e puta ana? <PrimaryText>T\u0101uritia \u0101-ringa...</PrimaryText>","nextLabel":"$t(common:next): <b>\u014C p\u0101rongo whakap\u0101</b>","postcode":"Waehere pout\u0101peta","searchPlaceholder":"Rapua te w\u0101hitau i Aotearoa","street":"Ingoa me te tau o te tiriti","suburb":"Takiw\u0101, RD r\u0101nei (Tuku W\u0101hi Taiwhenua)","text":"T\u0113n\u0101, whakaurua t\u014D w\u0101hitau k\u0101inga:","textSecondary":"Anei te w\u0101hitau ka whakamahia e m\u0101tou:","title":"T\u014D w\u0101hitau k\u0101inga"},"name-birthdate":{"birthDate":"R\u0101 wh\u0101nau","dateFormat":"dd/mm/yyyy","familyName":"Ingoa WH\u0100NAU:","firstName":"Ingoa tuatahi","nextLabel":"$t(common:next): <b>T\u014D NHI me t\u014D nohoanga</b>","preferredName":"Ingoa pai","select":{"label":"Taitara","mr":"Mr","ms":"Ms","mx":"Mx","placeholder":"Tohua t\u014D taitara"},"text":"T\u0113n\u0101 tirohia \u0113nei k\u014Drero, \u0101, whakatikaina ng\u0101 mea h\u0113, ngaro r\u0101nei:","title":"T\u014D ingoa me t\u014D r\u0101 wh\u0101nau"},"nhi-residency":{"nextLabel":"$t(common:next): <b>T\u014D k\u0101inga noho</b>","nhiNumber":"Tau NHI (Tau Tauwh\u0101inga Hauora \u0101-Motu)","resident":"He kainoho koe n\u014D Aotearoa?","residentText":"M\u0113n\u0101 k\u0101ore koe he kainoho n\u014D Aotearoa, t\u0113r\u0101 pea ka p\u0101ngia koe ki te utu m\u014D \u0113tahi ratonga, p\u0113r\u0101 i ng\u0101 whakam\u0101tautau taiwhanga.","text":"T\u0113n\u0101 koa, tirohia \u0101u k\u014Drero, \u0101, whakatikahia ng\u0101 mea ngaro, h\u0113 r\u0101nei:","title":"T\u014D tau NHI me t\u014D t\u016Bnga noho"}}');


var $894506542b790025$exports = {};
$894506542b790025$exports = JSON.parse('{"code":"Waehere p\u0101hono","error":{"details":"<ul>  \\n<li>Tirohia m\u0113n\u0101 he hapa t\u0101u, \u0101, ngana an\u014D.</li>  \\n<li>M\u0113n\u0101 kei te raru koe, waea mai ki a m\u0101tou: {{phone}} (p\u0101whiritia te K\u014Dwhiringa 2).</li>  \\n</ul>","title":"K\u0101ore taua waehere p\u0101hono i mahi"},"helpMessage":"<p>Kua ngaro t\u014D p\u0101hono, k\u0101ore r\u0101nei koe i te m\u014Dhio me aha?<br />Waea mai ki a m\u0101tou i <a><strong>{{phone}}</strong></a> (ka p\u0113hi i te <strong>K\u014Dwhiringa 2</strong>).</p>","text":"<p>Whakaurua t\u014D waehere p\u0101hono 6-\u0101-ira hei t\u012Bmatanga.</p><p>Ka kitea t\u0113nei waehere i t\u014D \u012Bm\u0113ra p\u0101hono, i tukuna r\u0101nei e te tangata n\u0101na koe i tuku mai.</p>","title":"Tuwhera i t\u014D p\u0101hono whakaritenga"}');


var $451ef91abc415f13$exports = {};
$451ef91abc415f13$exports = JSON.parse('{"dropLabel":"Peke ki t\u0113tahi p\u0101tai motuhake","nextLabel":"<b>Whakautua ng\u0101 p\u0101tai hauora</b>","questions":{"allergies":{"detailsPlaceholder":"T\u0113n\u0101 tuhi mai ki te reo P\u0101keh\u0101. Hei tauira:<br/>\\nPenicillin \u2013 rash and swelling; Latex \u2013 mild irritation","label":"He mate p\u0101wera \u0101u?","nextLabel":"$t(common:next): <b>Taumaha me te teitei</b>","title":"<h3>Ng\u0101 mate p\u0101wera (Allergies)</h3>"},"arrhythmias":{"detailsPlaceholder":"T\u0113n\u0101 whakak\u012Bhia m\u0101 te reo P\u0101keh\u0101. Hei tauira: <br/>Irregular heartbeat, on beta blockers since 2021","label":"He patuki manawa rangirua, he kiriweti, he haruru manawa \u0101u?","nextLabel":"$t(common:next): <b>P\u016Boko manawa</b>","title":"<h3>Taiahoaho o te manawa (Arrhythmias)</h3>"},"asthmaLungConditions":{"detailsPlaceholder":"T\u0113n\u0101 whakak\u012Bhia m\u0101 te reo P\u0101keh\u0101. Hei tauira:<br/>\\nMild asthma \u2013 use inhaler occasionally","label":"He mate huang\u014D, COPD, \u0101hua mate r\u0101nei \u0101u e p\u0101 ana ki ng\u0101 p\u016Bkahukahu?","nextLabel":"$t(common:next): <b>Mate k\u014Dp\u016B</b>","title":"<h3>Mate huang\u014D, mate p\u016Bkahukahu r\u0101nei (Asthma or lung conditions)</h3>"},"bloodProblems":{"detailsPlaceholder":"T\u0113n\u0101 whakak\u012Bhia m\u0101 te reo P\u0101keh\u0101. Hei tauira: <br/>\\nEasy bruising \u2013 diagnosed with Von Willebrand disease","label":"He GORD (rewharewha), IBS, IBD r\u0101nei \u0101u?","nextLabel":"$t(common:next): <b>Whakakapi okana</b>","title":"<h3>Ng\u0101 raruraru toto, p\u0113r\u0101 i te pakukaha, te toto rere nui r\u0101nei (Blood disorders or bleeding problems)</h3>"},"bloodThinningMedication":{"detailsPlaceholder":"T\u0113n\u0101 whakak\u012Bhia m\u0101 te reo P\u0101keh\u0101. Hei tauira: <br/>Apixaban \u2013 5mg daily, last taken on 3 June","label":"Kei te kai rongo\u0101 whakarewa toto koe in\u0101ianei?","nextLabel":"$t(common:next): <b>Mate manawa</b>","title":"<h3>Rongo\u0101 whakaheke toto (Blood thinning medication)</h3>"},"cancerTreatment":{"detailsPlaceholder":"T\u0113n\u0101 whakak\u012Bhia m\u0101 te reo P\u0101keh\u0101. Hei tauira: <br/>\\nChemotherapy for breast cancer \u2013 ongoing","label":"Kei te whiwhi koe i te rongo\u0101 patu matepukupuku penei i te whakamomori, te irarua r\u0101nei, i t\u0113tahi atu momo maimoatanga hoki?","nextLabel":"$t(common:next): <b>Ng\u0101 mate urut\u0101</b>","title":"<h3>Te maimoatanga matepukupuku (Cancer treatment)</h3>"},"diabetes":{"detailsLabel":"E p\u0113hea ana te whakahaere i t\u014D mate huka?","diet-controlled":"Ka whakahaeretia m\u0101 te kai","insulin":"Inuha","label":"He mate huka \u0101u?","nextLabel":"$t(common:next): <b>P\u0113hanga toto teitei</b>","no":"K\u0101o","tablets":"P\u0101p\u0101ho (hei tauira: Metformin)","title":"<h3>Mate huka (Diabetes)</h3>","type-1":"Momo 1 \u2013 kei te whakamahi i te insulini","type-2":"Momo 2","yes-type-1":"\u0100e \u2013 Momo 1, kei te whakamahi i te insulin","yes-type-2":"\u0100e \u2013 Momo 2"},"digestiveConditions":{"detailsPlaceholder":"T\u0113n\u0101 whakak\u012Bhia m\u0101 te reo P\u0101keh\u0101. Hei tauira:<br/>Reflux managed with omeprazole","label":"He GORD (rewharewha), IBS, IBD r\u0101nei \u0101u?","nextLabel":"$t(common:next): <b>Raru toto, t\u016Bkinotanga r\u0101nei</b>","title":"<h3>Ng\u0101 mate whakat\u014Dkai (Digestive conditions)</h3>"},"epilepsy":{"detailsPlaceholder":"T\u0113n\u0101 tuhi mai ki te reo P\u0101keh\u0101. Hei tauira:<br/>\\nLast seizure in 2020 \u2013 currently stable","label":"He mate hukihuki t\u014D, kua p\u0101ngia r\u0101nei koe e ng\u0101 parekura i mua?","nextLabel":"$t(common:next): <b>Ng\u0101 mate roro</b>","title":"<h3>Mate hihira (Epilepsy)</h3>"},"heartConditions":{"detailsPlaceholder":"T\u0113n\u0101 whakak\u012Bhia m\u0101 te reo P\u0101keh\u0101. Hei tauira: <br/>Heart attack in 2020 \u2013 stent inserted","label":"Kua p\u0101ngia koe e t\u0113tahi mate manawa i mua (p\u0113nei i te mate manawa ohorere, te m\u0101m\u0101 o te \u016Bnga manawa)?","nextLabel":"$t(common:next): <b>Mate roro, TIA</b>","title":"<h3>Ng\u0101 mate manawa (Heart conditions)</h3>"},"highBloodPressure":{"detailsPlaceholder":"T\u0113n\u0101 whakak\u012Bhia m\u0101 te reo P\u0101keh\u0101. Hei tauira <br/>\\nDiagnosed in 2018 \u2013 managed with medication","label":"He p\u0113hanga toto teitei \u0101u?","nextLabel":"$t(common:next): <b>Kupu manawa p\u014Droheke</b>","title":"<h3>P\u0113hanga toto teitei (High blood pressure)</h3>"},"infectiousDiseases":{"detailsPlaceholder":"T\u0113n\u0101 whakak\u012Bhia m\u0101 te reo P\u0101keh\u0101. Hei tauira: <br/>\\nMRSA \u2013 cleared after treatment in 2021","label":"Kua puta he hua pai i a koe m\u014D te MRSA, ESBL, VRE, CPE r\u0101nei?","nextLabel":"$t(common:next): <b>H\u0101p\u016Btanga</b>","title":"<h3>Ng\u0101 rauropi aukati-maha (Multi-resistant organisms)</h3>"},"metalImplants":{"detailsPlaceholder":"T\u0113n\u0101 whakak\u012Bhia m\u0101 te reo P\u0101keh\u0101. Hei tauira: <br/>Right hip replacement (2020), dental implants, or metal rod in leg","label":"He momo whakaurunga konganuku kei t\u014D tinana? (p\u0113nei i te p\u016Boko manawa, he k\u014Diwi whakakapi r\u0101nei)","nextLabel":"$t(common:next): <b>Mate huka</b>","title":"<h3>Kua whakat\u014Dhia r\u0101nei he konganuku (Implants or metal)</h3>"},"obstructiveSleepApnoea":{"detailsPlaceholder":"T\u0101uruhia t\u0113nei k\u014Drero ki te reo P\u0101keh\u0101. Hei tauira:<br/>\\nDiagnosed in 2022 \u2013 use CPAP machine every night","label":"Kei a koe te mate moe t\u0101whatiwhati, \u0101, e whakamahi ana koe i te m\u012Bhini CPAP i te p\u014D e moe ana?","nextLabel":"$t(common:next): <b>Mate huang\u014D, \u0101, he raru r\u0101nei ki ng\u0101 p\u016Bkahukahu</b>","title":"<h3>Te \u0101rai moe h\u0101 o te po (Obstructive Sleep Apnoea)</h3>"},"organTransplant":{"detailsPlaceholder":"T\u0113n\u0101 whakak\u012Bhia m\u0101 te reo P\u0101keh\u0101. Hei tauira: <br/>\\nKidney transplant in 2018 \u2013 taking tacrolimus and prednisone","label":"Kua whiwhi k\u0113 koe i t\u0113tahi whakak\u014Dk\u012B okana, \u0101, kei te kai rongo\u0101 aukati \u0101rai mate r\u0101nei?","nextLabel":"$t(common:next): <b>Maimoatanga matepukupuku</b>","title":"<h3>Te whakawhitinga okana (Organ transplant)</h3>"},"otherHealthConditions":{"detailsPlaceholder":"T\u0113n\u0101 whakak\u012Bhia m\u0101 te reo P\u0101keh\u0101. Hei tauira: <br/>\\nCoeliac disease, recent surgery, chronic pain","label":"He atu \u0101huatanga hauora, \u0101wangawanga r\u0101nei e tika ana m\u0101 m\u0101tou e m\u014Dhio?","nextLabel":"$t(common:next): <b>Ng\u0101 rongo\u0101</b>","title":"<h3>\u0112tahi atu \u0101huatanga hauora (Other health conditions)</h3>"},"pacemaker":{"defibrillator":"P\u016Boko whakaora manawa","detailsLabel":"He aha te momo?","label":"Kei a koe t\u0113tahi taputapu \u0101-roro manawa, \u0101-t\u0101uta r\u0101nei m\u014D te manawa?","nextLabel":"$t(common:next): <b>Rongo\u0101 whakaheke toto</b>","not-sure":"K\u0101ore au i te m\u014Dhio","pacing":"P\u0113hinga","title":"<h3>P\u016Bkaha manawa, he p\u016Brere cardiac kua whakat\u014Dhia (Pacemaker or implanted cardiac device)</h3>"},"pregnancy":{"label":"Kei te hap\u016B koe in\u0101ianei \u2013 \u0101kene pea?","nextLabel":"$t(common:next): <b>\u0112tahi atu mate</b>","title":"<h3>Te hap\u016Btanga (Pregnancy)</h3>"},"stroke":{"detailsPlaceholder":"T\u0113n\u0101 tuhi mai ki te reo P\u0101keh\u0101. Hei tauira:<br/>\\nStroke in 2021 \u2013 mild weakness on left side","label":"Kua p\u0101ngia koe e te tukituki roro, i te tukituki roro iti r\u0101nei (TIA)?","nextLabel":"$t(common:next): <b>Mate roro hiko (Epilepsy)</b>","title":"<h3>Pate roro, r\u0101nei he mate iti (TIA)</h3>"},"weightHeight":{"cm":"cm","height":"Teitei","kg":"kg","nextLabel":"$t(common:next): <b>K\u014Dmiti / konganuku</b>","text":"T\u0113n\u0101, t\u0101uruhia t\u014D taumaha me t\u014D teitei tata.","title":"<h3>Taumaha me te teitei</h3><p>T\u0113n\u0101, t\u0101uruhia t\u014D taumaha me t\u014D teitei tata.</p>","weight":"Taumaha"}},"text":"<p>Kua tata mutu.</p>\\n<p>Me p\u0101tai noa atu m\u0101tou i \u0113tahi p\u0101tai m\u014D t\u014D hauora, \u0101u rongo\u0101, me \u014D hiahia.</p>\\n<p>He mea nui kia m\u0101rama m\u0101tou ki ng\u0101 mea ka p\u0101 pea ki t\u014D tiaki.</p>\\n<p>M\u0113n\u0101 me whakam\u0101rama \u0113tahi mea, ka whakap\u0101 atu t\u0113tahi o t\u014D m\u0101tou t\u012Bma i mua i t\u014D h\u0101paratanga.</p>\\n<p>He iti iho i te <strong>10 meneti</strong> te w\u0101 e pau m\u014D t\u0113nei w\u0101hanga whakamutunga.</p>","title":"Ng\u0101 p\u0101tai hauora me ng\u0101 manako"}');


var $73e624d0219bf80c$exports = {};
$73e624d0219bf80c$exports = JSON.parse('{"addButtonLabel":"Tukanga r\u0101nei, pokanga r\u0101nei","date":"R\u0101","datePlaceholder":"e.g. June 2022, 2021, or ~5 years ago","location":"W\u0101hi","locationPlaceholder":"e.g. Ormiston Hospital, Auckland","nextLabel":"$t(common:next): <b>Nekehanga</b>","procedure":"Whakam\u0101rama m\u014D te pokanga, tukanga r\u0101nei","procedurePlaceholder":"T\u0101uruhia ki te reo P\u0101keh\u0101. Hei tauira: <br/>\\nColonoscopy to investigate bleeding","saveButton":"Tiaki pokanga","text":"<p>Kei a m\u0101tou te p\u016Bkete o t\u0101u pokanga \u016Bwhatu o mua i te {{company}}:</p>\\n<ul><li><strong>{{procedure}}</strong> i <strong>{{date}}</strong></li></ul>\\n<p>Kua whiwhi k\u0113 koe i t\u0113tahi atu pokanga \u016Bwhatu, pokanga puku, pokanga nui r\u0101nei i muri mai i t\u0113r\u0101?</p>","textNoProcedure":"Kua whiwhi k\u0113 koe i t\u0113tahi pokanga \u016Bwhatu, pokanga puku, pokanga nui r\u0101nei i mua?","title":"Ng\u0101 pokanga, ng\u0101 tukanga tata nei"}');


var $d8e115ccbe3be14e$exports = {};
$d8e115ccbe3be14e$exports = JSON.parse('{"helpMessage":"<h3>He p\u0101tai \u0101u m\u014D te inihua?</h3>\\n<p>Kei konei \u0101 m\u0101tou kaimahi hei \u0101whina i a koe \u2014 waea mai:<br/><a><strong>\u260E\uFE0F {{phone}}</strong></a> (katahi ka p\u0113hi <strong>Option 2</strong>)<br/>Monday to Friday, 8am\u20135pm.</p>","insuranceCovered":"Ka hipokina \u0113tahi, katoa r\u0101nei, o ng\u0101 utu m\u0101u e te inihua hauora?","insuranceDetails":"<ul>\\n  <li>M\u0101ku e utu ng\u0101 nama k\u0101ore i hipokina e te inihua.</li>\\n  <li>M\u0101ku e utu te moni e hiahiatia ana i te r\u0101 ka whakaurua au.</li>\\n  <li>M\u0101ku e utu ng\u0101 utu m\u014D te kohi nama m\u0113n\u0101 k\u0101ore au e utu i taku p\u016Bkete.</li>\\n</ul>","insuranceLabel":"Kei te m\u0101rama au, \u0101, e whakaae ana au ki \u0113nei mea:","insurerLabel":"Ko wai t\u014D kamupene inihua hauora?","insurerSelect":{"aia":"AIA","nib":"NIB","southern-cross":"Southern Cross"},"membershipLabel":"Tau mema","noCovered":"M\u0101ku e utu katoa ng\u0101 utu.","preApprovalLabel":"Kua whiwhi whakaaetanga i mua m\u014D t\u0113nei pokanga?","preApprovalText":"<h3>{{insurer}} whakaaetanga i mua</h3>\\n<p>M\u0101tou ka whakap\u0101 atu ki a {{insurer}} m\u014Du hei tono whakaaetanga m\u014D t\u014D pokanga.</p>\\n<p>Ka whiwhi koe i t\u0113tahi whakam\u014Dhiotanga m\u014D te hua, tae atu ki te tatauranga o t\u0113tahi utu ka \u0101hei pea koe ki te utu.</p>\\n<span>T\u0113r\u0101 pea ka uru atu \u0113nei:</span>\\n<ul>\\n<li><strong>Utu tautapa:</strong> te nui kua whakaritea e t\u014D kaupapa here, \u0101 / r\u0101nei</li>\\n<li><strong>Utu koretake:</strong> te rerek\u0113tanga i waenga i t\u014D kaupapa here me te utu m\u014D te pokanga.</li>\\n</ul>\\n<p>Me <strong>utu ng\u0101 utu tautapa, koretake r\u0101nei i te r\u0101 o t\u014D pokanga</strong>.</p>","title":"Inihua Hauora"}');


var $08748cdac26b4620$exports = {};
$08748cdac26b4620$exports = JSON.parse('{"helpMessage":"<h3>He p\u0101tai \u0101u?</h3>\\n<p>Kei konei m\u0101tou hei \u0101whina - waea mai:<br/><a><strong>\u260E\uFE0F {{phone}}</strong></a> (katahi ka p\u0113hi i te <strong>Option 2</strong>)<br/>R\u0101hina ki te R\u0101mere, 8am\u20135pm.</p>","title":"K\u0101ore te p\u014Dhiri i te whaimana"}');


var $1b945b465d0edd97$exports = {};
$1b945b465d0edd97$exports = JSON.parse('{"helpMessage":"<h3>He p\u0101tai \u0101u?</h3>\\n<p>Kei konei m\u0101tou ki te \u0101whina \u2013 waea mai ki t\u0101 m\u0101tou t\u012Bma:<br/>\\n<a><strong>\u260E\uFE0F {{phone}}</strong></a> (p\u0113hia <strong>K\u014Dwhiringa 2</strong>)<br/>\\nR\u0101hina ki R\u0101mere, 8am\u20135pm.</p>","text":"<p>M\u0101 m\u0101tou t\u014D rata tuku ki te h\u014Dhipera e whakam\u014Dhio, \u0101, t\u0113r\u0101 pea ka whakap\u0101 mai r\u0101tou ki a koe ki te k\u014Drero m\u014D ng\u0101 mahi ka whai ake.</p>\\n<p>K\u0101ore he mahi an\u014D m\u0101u i t\u0113nei w\u0101.</p>","title":"Kua whakatau koe kia kaua e tono w\u0101 i t\u0113nei w\u0101."}');


var $4519763f8af53694$exports = {};
$4519763f8af53694$exports = JSON.parse("{}");


var $e829edacd2b8969a$exports = {};
$e829edacd2b8969a$exports = JSON.parse('{"text":"<p>I muri i ng\u0101 ngana maha kia manatoko i t\u014D tuakiri, kua r\u0101huitia m\u014D t\u0113nei w\u0101 t\u014D tono kia tiakina ai t\u014D t\u016Bmataiti.</p>\\n<p>Kaua e m\u0101harahara \u2013 ka taea tonu e m\u0101tou te \u0101whina.</p>\\n<p>T\u0113n\u0101 waea atu ki t\u0101 m\u0101tou r\u014Dp\u016B kia whakaotihia t\u014D whakaritenga:</p>\\n<p><a><strong>\u260E\uFE0F {{phone}}</strong></a> (ka p\u0113hia <strong>K\u014Dwhiringa 2</strong>)<br/>R\u0101hina ki te R\u0101mere, 8am\u20135pm.</p>","title":"Kua r\u0101huitia te tono hei tiaki i t\u014D haumaru"}');


var $05d4fb96c10dbdcf$exports = {};
$05d4fb96c10dbdcf$exports = JSON.parse('{"addButtonLabel":"T\u0101piri rongo\u0101","dose":"Inenga","dosePlaceholder":"e.g. 500mg or 1 tablet","dropHere":"Tukua ki konei","dropText":"<p>{{fileExtensions}}, {{fileExtension}}, tae atu ki te {{mb}}MB</p>","dropTitle":"<p><strong>Tukuatu he k\u014Dnae</strong> r\u0101nei t\u014Dia, tukuna iho</p>","frequency":"Auautanga","manuallyText":"<strong>Taapirihia ng\u0101 rongo\u0101 \u0101-ringa</strong><p>T\u0101pirihia t\u0113tahi rongo\u0101 kotahi i ia w\u0101. Whakaurua te ingoa, te horopeta me te auautanga o te tango.</p>","medicationName":"Ingoa rongo\u0101","medicationPlaceholder":"<p><strong>T\u0101uruhia m\u0101 te reo P\u0101keh\u0101.</strong><br/>Hei tauira: Metformin \u2013 500mg morning and night</p>","nextLabel":"$t(common:next): <b>H\u012Btori</b>","saveButton":"Tiaki rongo\u0101","select":{"as-needed":"Ina hiahiatia","once-daily":"Kotahi i te r\u0101","three-time-daily":"E toru i te r\u0101","twice-daily":"E rua i te r\u0101"},"text":"<p>T\u0113n\u0101 whakam\u014Dhiotia mai ng\u0101 rongo\u0101, ng\u0101 inhaler, ng\u0101 werohanga, me ng\u0101 kiritaki t\u0101piri kei te whakamahia e koe in\u0101ianei.</p>\\n<p>Ka taea e koe te tukuake r\u0101rangi, \u0101, t\u0101pirihia \u0101-ringa hoki.</p>","title":"Ng\u0101 rongo\u0101","uploadText":"<strong>Tukua ake he rongo\u0101 r\u0101nei he r\u0101rangi</strong>\\n<p>M\u0113n\u0101 he r\u0101rangi \u0101 t\u014D rata, \u0101 t\u014D whare rongo\u0101 r\u0101nei, tukuna ake he whakaahua, he PDF r\u0101nei.</p>"}');


var $34118c49d4d73f2c$exports = {};
$34118c49d4d73f2c$exports = JSON.parse('{"questions":{"culture":{"detailsPlaceholder":"<p>T\u0113n\u0101 tuhi mai ki te reo Ingarihi. Hei tauira:</p>\\n<p>Wh\u0101nau to be present, need interpreter, specific dietary customs</p>","label":"He hiahia ahurea, \u0101-wh\u0101nau r\u0101nei \u0101u?","nextLabel":"$t(common:next): <b>\u0112tahi atu hiahia motuhake, p\u0101rongo r\u0101nei</b>","title":"<h3>Ng\u0101 hiahia ahurea, \u0101-wh\u0101nau r\u0101nei</h3>"},"language":{"de":"Deutsch / German","detailsLabel":"He aha t\u014D reo pai?","fj":"Vosa Vakaviti / Fijian","fr":"Fran\xe7ais / French","ja":"\u65E5\u672C\u8A9E / Japanese","ko":"\uD55C\uAD6D\uC5B4 / Korean","label":"He uaua ki a koe te m\u0101rama ki te reo P\u0101keh\u0101?","mi":"Te Reo M\u0101ori","ms":"Malay / Malaysian","nextLabel":"$t(common:next): <b>Ng\u0101 hiahia whakapono, wairua r\u0101nei</b>","other":"\u0112tahi atu","pt":"Portugu\xeas / Portuguese","sm":"Gagana Samoa / Samoan","ta":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD / Tamil","title":"<h3>Te m\u0101rama ki te reo Ingarihi</h3>","tl":"Tagalog / Tagalog","to":"Lea Faka-Tonga / Tongan","zh":"\u7B80\u4F53\u4E2D\u6587 / Chinese"},"mobility":{"detailsPlaceholder":"T\u0113n\u0101 whakak\u012Bia ki te reo P\u0101keh\u0101. Hei tauira:<br/>Ka whakamahi t\u014Drino, t\u016Bru w\u012Bra r\u0101nei; me \u0101whina ki te neke ki te moenga","label":"He hau\u0101 t\u014Du, he hiahia \u0101whina r\u0101nei m\u014D te nekehanga?","nextLabel":"$t(common:next): <b>Te m\u0101rama ki te reo Ingarihi</b>","title":"<h3>Te \u0101heinga neke</h3>"},"other":{"detailsPlaceholder":"T\u016Bhonoa ng\u0101 mea e whakaaro ana koe he mea hira. M\u0101 t\u0113nei e pai ake ai t\u0101 m\u0101tou tautoko i a koe.","label":"He hiahia motuhake an\u014D \u0101u, he m\u014Dhiohio r\u0101nei e hiahia ana koe kia m\u014Dhiotia e m\u0101tou?","nextLabel":"$t(common:next): <b>Te tiki i t\u014D rongo\u0101 whakarite puku</b>","title":"<h3>\u0112tahi atu hiahia motuhake, p\u0101rongo r\u0101nei</h3>"},"prep":{"label":"T\u012Bpakohia te \u0101hua e hiahia ana koe ki te whiwhi i t\u0113nei:","nextLabel":"$t(common:next): <b>Whakaoti t\u0101u t\u0101pui</b>","pick-up-from-hospital":"<label>T\u012Bkina mai i te {{company}}</label>\\n<p>T\u012Bkina t\u014D m\u014Dkihi whakarite i te r\u016Bma whakatau i ng\u0101 h\u0101ora whakatuwhera.</p>","pick-up-from-local-pharmacy":"<label>T\u012Bkina mai i t\u014D whare rongo\u0101 k\u0101inga</label>\\n<p>Ka tukuna m\u0101 te \u012Bm\u0113ra he rongo\u0101 kua tohua e m\u0101tou hei kawe m\u0101u ki t\u014D whare rongo\u0101.</p>","receive-by-mail":"<label>Whiwhi m\u0101 te m\u0113ra</label>\\n<p>Ka tukuna m\u0101 te kaikawe t\u014D m\u014Dkihi whakarite ki te w\u0101hi noho i hoatu e koe.</p>","text":"Hei whakarite m\u014D t\u0101u pokanga, me inu koe i t\u0113tahi rongo\u0101 motuhake hei whakakore i t\u014D k\u014Dp\u016B.","title":"<h3>Te tiki i t\u014D rongo\u0101 k\u014Dp\u016B</h3><p>Hei whakarite m\u014D t\u0101u pokanga, me inu koe i t\u0113tahi rongo\u0101 motuhake hei whakakore i t\u014D k\u014Dp\u016B.</p>"},"religion":{"detailsPlaceholder":"<p>T\u0113n\u0101 whakak\u012Bhia m\u0101 te reo Ingarihi. Hei tauira:<br/>Quiet space for prayer, prefer same-gender staff for personal care</p>","label":"He hiahia whakapono, wairua r\u0101nei \u0101u?","nextLabel":"$t(common:next): <b>Ng\u0101 hiahia ahurea, wh\u0101nau hoki</b>","title":"<h3>Ng\u0101 hiahia whakapono, wairua hoki</h3>"}}}');


var $7b667792adce0a22$exports = {};
$7b667792adce0a22$exports = JSON.parse('{"helpMessage":"<h3>Ng\u0101 p\u0101tai t\u016Bmataiti?</h3>\\n<p>Kei te hari m\u0101tou ki te \u0101whina - waea mai:<br/>\\n<a><strong>\u260E\uFE0F {{phone}}</strong></a> (p\u0101whiritia <strong>Option 2</strong>)<br/>\\nR\u0101hina ki R\u0101mere, 8am\u20135pm.</p>","privacyDetails":"<ul><li>Kei te m\u0101rama koe me p\u0113hea t\u014D m\u014Dhiohio e whakamahia ai.</li><li>Kei te whakak\u012B koe i t\u0113nei tono m\u0101u an\u014D, m\u0101 t\u0113tahi r\u0101nei e \u0101hei ana koe ki te tautoko (hei tauira, he kaitiaki, he m\u0101tua r\u0101nei).</li><li>Kei te whakaae koe ki te haere tonu i te tukanga tono.</li></ul>","privacyLabel":"Ka whakaae au ki t\u0113nei Tau\u0101k\u012B T\u016Bmataitinga","privacyText":"M\u0101 te whakaae ki t\u0113nei Tau\u0101k\u012B T\u016Bmataitinga, ka whakat\u016Bpato koe i \u0113nei mea:","text":"<p>Ka tino whai whakaaro m\u0101tou ki t\u014D t\u016Bmataitinga.</p>\\n<p>Ka penapena haumaru ng\u0101 k\u014Drero ka tukuna e koe i t\u0113nei tukanga, \u0101, ka whakamahia anake hei tautoko i t\u014D manaakitanga ki {{company}}.</p>\\n<p>Ka tohatohatia \u014D k\u014Drero whaiaro me ng\u0101 taipitopito haumanu ki ng\u0101 kaimahi hauora e whai w\u0101hi ana ki t\u014D maimoatanga anake.</p>\\n<p>K\u0101ore m\u0101tou e tuku i \u014D k\u014Drero ki ng\u0101 r\u014Dp\u016B tuatoru m\u014D ng\u0101 kaupapa hokohoko.</p>\\n<p>Ka taea e koe te whakap\u0101 mai i ng\u0101 w\u0101 katoa m\u0113n\u0101 e hiahia ana koe ki te tono tirohanga, whakatika r\u0101nei i \u014D k\u014Drero.</p>","title":"Tau\u0101k\u012B T\u016Bmataitinga"}');


var $87c3b78d16dd5ef1$exports = {};
$87c3b78d16dd5ef1$exports = JSON.parse('{"anySpecialist":{"text":"Whakaaturia mai ng\u0101 w\u0101 w\u0101tea wh\u0101nui rawa atu m\u014D ng\u0101 whakaritenga.","title":"K\u0101ore au e m\u0101harahara ko wai"},"nextLabel":"$t(common:next): <b>K\u014Dwhiria he w\u0101</b>","profile":"K\u014Dtaha M\u0101tanga","specialists":{"00000000-0000-da7a-0003-000000000004":{"name":"Dr. Lopez"}},"textMultiple":"<p>He pai katoa \u0113nei m\u0101tanga. K\u014Dwhiria t\u0113tahi, k\u0101ore r\u0101nei \u2014 tohua noa te \u201CK\u0101ore au e m\u0101harahara ko wai\u201D.</p>","textSingle":"<p>\u0906\u092A\u0915\u0947 \u091C\u0940\u092A\u0940 \u2013 {{referral.gp}} \u2013 \u0928\u0947 \u0906\u092A\u0915\u094B \u092F\u0939\u093E\u0902 \u0930\u0947\u092B\u0930 \u0915\u093F\u092F\u093E \u0939\u0948:</p>","titleMultiple":"K\u014Dwhiria t\u014D m\u0101tanga","titleSingle":"T\u014D m\u0101tanga","viewProfile":"Tirohia te k\u014Dtaha katoa"}');


var $a90fd157c6b70050$exports = {};
$a90fd157c6b70050$exports = JSON.parse('{"bookButtonLabel":"Tono w\u0101 in\u0101ianei","bookText":"<h3>Tono \u0101-ipurangi:</h3>\\n<ul>\\n  <li>\u23F1\uFE0F  <strong>Tere, m\u0101m\u0101 hoki \u2013</strong> 15 meneti, iti iho r\u0101nei</li>\\n  <li>\uD83C\uDF19  <strong>Tono i te w\u0101 katoa \u2013</strong> ahakoa i muri i ng\u0101 haora mahi</li>\\n  <li>\uD83D\uDDD3\uFE0F  <strong>K\u014Dwhiria he w\u0101 e pai ana m\u014Du</strong></li>\\n  <li>\uD83D\uDD10  <strong>K\u0101ore he pepa \u2013</strong> haumaru, tika hoki</li>\\n</ul>","declineButtonLabel":"K\u0101ore au e hiahia ki te tono in\u0101ianei","declineText":"<h3>K\u0101ore koe i te t\u016Bmanako, i te hiahia hoki ki t\u0113nei h\u0101tepe?</h3>\\n<p>K\u014Dwhiria t\u0113tahi take hei whakam\u014Dhio mai ki a m\u0101tou:</p>","helpMessage":"<h3>He pai k\u0113 ki a koe te k\u014Drero ki t\u0113tahi?</h3>\\n<p>Kei konei t\u014D m\u0101tou r\u014Dp\u016B atawhai ki te \u0101whina:<br/><a><strong>\u260E\uFE0F {{phone}}</strong></a> (\u0101 muri iho, p\u0113hia te <strong>K\u014Dwhiringa 2</strong>)<br/>R\u0101hina ki R\u0101mere, 8am\u20135pm.</p>\\n<p><em>Ka \u0101hei pea \u0101 m\u0101tou kaimahi ki te k\u014Drero reo P\u0101keh\u0101 anake. T\u0113n\u0101 koa, me te manawanui mai.</em></p>","info":"<h3>Kei te hiahia koe ki te m\u014Dhio atu m\u014D t\u0113nei h\u0101tepe?</h3>\\n<p>M\u0101takitaki i t\u0113tahi ataata poto e whakam\u0101rama ana i ng\u0101 mea ka puta me te \u0101whina ki te whakarite.</p>","select":{"badTiming":"Ehara i te w\u0101 pai m\u014Dku","cantAfford":"K\u0101ore au e taea te utu i t\u0113nei w\u0101","didntKnowReferred":"K\u0101ore au i te m\u014Dhio kua tukuna he tononga m\u014Dku","hadElsewhere":"Kua oti k\u0113 i t\u0113tahi atu w\u0101hi","notNecessary":"Ki \u014Dku whakaaro k\u0101ore e hiahiatia","placeholder":"K\u014Dwhiria he take"},"text":"<p>Ko t\u014D rata, <strong>{{requestingPractitioner.displayName}}</strong>, i tuku kupu tohutohu kia haere koe ki te <strong>{{procedure.displayName}}</strong> me <strong>{{practitioners.0.name}}</strong>.</p>","textNoSpecialist":"<p>Ko t\u014D rata, <strong>{{requestingPractitioner.displayName}}</strong>, i tuku kupu tohutohu kia haere koe ki te <strong>{{procedure.displayName}}</strong>.</p>","title":"Kia ora {{patient.nameGiven}}.<br /> Kua tae te w\u0101 ki te tono i t\u014D h\u0101tepe.","videoButtonLabel":"P\u0101whiri kia m\u0101taki i te ataata m\u014D te h\u0101tepe endoscopy","videoCaption":"Ka t\u016Btohu m\u0101tou kia m\u0101taki koe i t\u0113nei ataata i mua i te tono w\u0101."}');


var $cf9bf9611bbb7ad6$exports = {};
$cf9bf9611bbb7ad6$exports = JSON.parse('{"birthDate":"T\u014D r\u0101 wh\u0101nau","dateFormat":"dd/mm/yyyy","familyName":"T\u014D ingoa wh\u0101nau","helpMessage":"<p>M\u0113n\u0101 k\u0101ore i te tika te nama i runga ake, k\u0101ore r\u0101nei koe i te m\u014Dhio me aha, waea mai koa ki <a><strong>{{phone}}</strong></a> (\u0101, p\u0113hia <strong>K\u014Dwhiringa 2</strong>).</p>","sendCode":"Tukua te waehere","text":"<p>He tono t\u0113nei m\u014D te whakarite w\u0101 m\u014D t\u0113tahi t\u016Broro e tiakina ana e t\u0113tahi kei a ia te nama waea p\u016Bkoro: <strong><PhonePlaceholder /></strong></p>\\n<p>M\u0113n\u0101 ko koe t\u0113nei, t\u0101urua koa te <strong>ingoa wh\u0101nau o te t\u016Broro</strong> me te <strong>ra whanau</strong> ki raro nei, \u0101, p\u0101whiritia te p\u0101tene.</p>\\n<p>M\u014D te haumarutanga, ka tukuna e m\u0101tou he <strong>waehere 4-mati</strong> kotahi anake m\u0101 te karere hei whakamana i t\u014D tuakiri.</p>","title":"Nau mai ki <strong>{{company}} Online Booking</strong>"}');


var $c1803275c25cc4b7$exports = {};
$c1803275c25cc4b7$exports = JSON.parse('{"bookmarksMenu":"Lisi","change":"Suia","closeBookmarksMenu":"Tapuni le lisi","closeDialog":"Tapuni","colonoscopy":"s\u016Bs\u016B i le kolone (colonoscopy)","continue":"Fa\u02BBaauau","details":"Fa\'amatalaga","errors":{"invalidOtp":{"details":"<ul>  \\n<li>Siaki pe iai ni sipelaga sese ma toe taumafai.</li>  \\n<li>Afai e faigat\u0101, vala\u2019au mai i le matou numera {{phone}} (ona oomi lea o le Option 2).</li>  \\n</ul>","title":"E le fetaui lena ma a matou fa\'amaumauga"},"serverErrorOtp":{"details":"<ul>  \\n<li>Masalo ua sa\u2019o au fa\u2019amatalaga \u2013 ae sa le mafai ona matou fa\u2019amaonia i le taimi nei.</li>  \\n<li>Fa\u2019amolemole fa\u2019atali mo sina taimi ona toe taumafai lea.</li>  \\n</ul>","title":"Sa iai se mea na sese."}},"formattedDate":"{{date}} i le {{time}}","gastroscopy":"s\u016Bs\u016B i le manava (gastroscopy)","loading":"O lo\'o utaina...","next":"Sosoo","no":"Leai","openBookmarksMenu":"Tatala le lisi","optional":"Filifiliga","progress":"Alualu i luma {{progress}}%","selectLanguage":"Filifili le gagana","step":{"appointment":"Taimi o le Tusi Taimi","details":"Fa\'amatalaga Patino","health-questions":"Fesili e uiga i le soifua m\u0101l\u014Dl\u014Dina","history":"Taotoga po\'o ni togafitiga na faia muamua","insurance":"Inisiua mo le soifua m\u0101l\u014Dl\u014Dina","medications":"Fuala\u02BBau","preference-questions":"Fesili e uiga i mea e fiafia i ai","specialist":"Foma\u02BBi Faapitoa"},"videoUnsupported":"E le lagolagoina e lau upega tafa\u02BBilagi le pine vitio.","yes":"Ioe","yesTo":"Ioe i","yourProgress":"O lau alualu i luma"}');


var $cb210e47b8af2f4b$exports = {};
$cb210e47b8af2f4b$exports = JSON.parse('{"comingSoonText":"<p>O le a e maitauina e leai ni taimi avanoa mo le itiiti ifo i le tasi le vaiaso mai le aso nei.</p>\\n<p>I nisi taimi, e mafai ona tatalaina ni taimi vave ona o ni fa\u2018aleaog\u0101ina.</p>\\n<p>E te mana\u2018o ia matou fa\u2018afeso\u2018ota\u2018i oe pe a tatalaina se taimi lata mai?</p>\\n<p>Leai se fa\u2018amalosi e suia \u2014 afai e lelei le taimi ua e filifilia, e mafai ona e tumau i ai.</p>","comingSoonTitle":"E te matala e sau vave atu?","contactConsent":{"no":"Leai \u2013 ou te tumau i le taimi na ou filifilia","yes":"Ioe \u2013 e mafai ona fa\'afeso\'ota\'i a\'u"},"contactConsentDetails":{"no":"E le mafai ona matou fa\'afeso\'ota\'i oe e uiga i ni taimi vave atu.","yes":"Afai e avanoa se taimi vave atu, o le a matou fa\u2018ailoa atu ia te oe."},"description":"<p>E o\'o mai i le taimi nei, e iai sau avanoa se\'ia o\'o i le <strong>{{deadlineText}}</strong> e fa\'amautu ai lau tusi taimi \u2013 e tusa ma le <b>{{deadlineTime}} itula</b>.</p>\\n<span>Ina ia mae\u2018a, fa\u2018amolemole:</span>\\n<ul>\\n  <li>Fa\u2018amaonia pe fa\u2018aopoopo <strong>au fa\u2018amatalaga o le tagata ma\u2018i</strong></li>\\n  <li>Ta\u2018u mai <strong>o ai e totogi</strong> (fa\u2018ata\u2018ita\u2018iga, inisiua)</li>\\n  <li>Tali i <strong>fesili e uiga i le soifua m\u0101l\u014Dl\u014Dina ma mea e te fiafia i ai</strong></li>\\n</ul>\\n<p>E masani ona itiiti ifo i le <strong>12 minute</strong> le umi o lenei fa\'agasolo.</p>","nextLabel":"$t(common:next): <b>Fa\u2018amaonia au fa\u2018amatalaga</b>","text":"<p>Ua <Status>fa\u2018aagaga mo se taimi pupuu</Status> lau <strong>{{procedure.displayName}}</strong> ma <strong>{{appointment.specialist}}</strong> i le <strong>{{appointment.date}}</strong> i le <strong>{{appointment.time}}</strong>.</p>","title":"Ua fa\u2018aagaga lau tofiga"}');


var $ce828f481d7bd218$exports = {};
$ce828f481d7bd218$exports = JSON.parse('{"modal":{"buttonLabel":"Filifili se taimi fou","text":"Ua uma ona fa\u2018aagaga lea taimi e se isi.","title":"Ua tuai i le mea iti!"},"nextLabel":"$t(common:next): <b>Fa\u2018aagaga le taimi o le tofiga</b>","nextWeek":"I le vaiaso fou","noTimeText":"E leai ni taimi avanoa mo le aso na e filifilia.","prevWeek":"Vaiaso ua te\u2018a","title":"Filifili le taimi o lau tofiga"}');


var $8da88c737f05f265$exports = {};
$8da88c737f05f265$exports = JSON.parse('{"helpMessage":"<p>Afai e iai se fa\u2018afitauli, fa\u2018amolemole vala\u2018au mai i le <a><strong>{{phone}}</strong></a> (ona oomi lea o le <strong>Filifiliga 2</strong>).</p>","noCode":"E te le\u2018i maua le numera?","remainingTime":"{{time}} o lo\u2018o totoe","sendCode":"Lafo se numera fou","text":"<p>Ua matou lafoina se numera e 4 numera i lau numera telefoni: <strong><PhonePlaceholder /></strong></p>\\n<p>O le numera e aoga mo le {{validityMinutes}} minute.</p>\\n<p>Fa\u2018amolemole ulufale le numera i lalo e fa\u2018aauau ai.</p>","title":"Ulufale lau numera"}');


var $0065dbf1a4d981da$exports = {};
$0065dbf1a4d981da$exports = JSON.parse('{"calendarButtonLabel":"Fa\u2018aopopo i le kalena","confirmationText":"<h3>Va\u2018ava\u2018ai i se imeli i totonu o le 24 itula:</h3>\\n<ul>\\n  <li>\u2705  Fa\u2018amaoniga o le tofiga</li>\\n  <li>\uD83D\uDCB2  Fuafuaga mo lau inisiua</li>\\n  <li></li>\\n  <li>\uD83E\uDD64  Fa\u2018atonuga mo sauniuniga</li>\\n  <li>\uD83C\uDFE5  Fa\u2018amatalaga mo le asiasiga (ta\u2018iala, paka ta\u2018avale, ma isi)</li>\\n  <li>\uD83D\uDC8A  Vaila\u2018au mo sauniuniga</li>\\n</ul>\\n<p>O le a matou iloiloina fo\u2018i au tali i fesili o le soifua m\u0101l\u014Dl\u014Dina, ma o le a feso\u2018ota\u2018i atu se tagata o le matou \u2018au pe a mana\u2018omia ni isi fa\u2018amatalaga a\u2018o le\u2018i faia le togafitiga.</p>","helpMessage":"<h3>Fa\u2018afeso\u2018ota\u2018i mai</h3>\\n<p>Afai e iai ni au fesili pe e te mana\u02BBomia ona suia se mea, vala\u2018au mai i le matou \u2018au fa\u2018afeiloa\u2018i:<br/>\\n<a><strong>\u260E\uFE0F {{phone}}</strong></a> (ona oomi lea o le <strong>Filifiliga 2</strong>)<br/>\\nAso Gafua i le Aso Faraile, 8am\u20135pm.</p>\\n<p><em>Atonu e na\u02BBo le Igilisi e mafai ona tautala ai la matou \u2018au \u2014 fa\u2018afetai mo lou malamalama.</em></p>","text":"<p>O lau <strong>{{procedure.displayName}}</strong> ma <strong>{{appointment.specialist}}</strong> i le <strong>{{appointment.date}}</strong> i le <strong>{{appointment.time}}</strong> ua <Status>fa\u2018amaonia</Status>.</p>","title":"Fa\u2018afetai {{patient.nameGiven}}! <br/> Ua lava mea uma mo le taimi nei."}');


var $e935b947cff44e22$exports = {};
$e935b947cff44e22$exports = JSON.parse('{"contact-details":{"email":"Tuatusi imeli","mobilePhone":"Telefoni fe\u2018avea\u2018i","nextLabel":"$t(common:next): <b>Lau foma\u2018i GP (dokita)</b>","otherPhone":"Isi telefoni`","text":"O lo\u2018o matou fa\u2018aaog\u0101 nei fa\u2018amatalaga e fa\u2018afeso\u2018ota\u2018i atu ai, ae e mafai ona e suia pe a mana\u2018omia.","title":"Lau fa\u2018amatalaga feso\u2018ota\u2018i"},"doctor":{"gp":"Igoa o le foma\u2018i GP (dokita)","manually":"E le o fa\u2018aalia le foma\u2018i? <PrimaryText>Ulufale i le lima...</PrimaryText>","medicalCentre":"Nofoaga Foma\u2018i`","nextLabel":"$t(common:next): <b>Lau fa\u2018afeso\u2018ota\u2018i fa\u2018alavelave fa\u2018afuase\u2018i</b>","searchPlaceholder":"Su\u2018esu\u2018e lau foma\u2018i GP po o le nofoaga foma\u2018i","text":"O lau foma\u2018i GP lea? Afai e leai, fa\u2018amolemole fa\u2018afou.","title":"Lau foma\u2018i GP (dokita)"},"emergency":{"fullName":"Igoa atoa","mobileNumber":"Numera feavea\u2018i","nextLabel":"$t(common:next): <b>Inisiua / o ai e totogiina</b>","relationship":"Sootaga iate oe","select":{"child":"Tamaiti","friend":"U\u014D","other":"Isi","parent":"M\u0101tua","spouse":"To\u2018alua / Pa\u2018aga"},"text":"O ai e tatau ona matou fa\u2018afeso\u2018ota\u2018i i se fa\u2018alavelave fa\u2018afuase\u2018i?","title":"Lau fa\u2018afeso\u2018ota\u2018i mo fa\u2018alavelave fa\u2018afuase\u2018i"},"home-address":{"building":"Lavelua, fola, po\u2018o le iunite o le fale po\u2018o le vaega o fanua tetele","city":"Taulaga/A\u2018ai","manually":"Le o fa\u2018aalia le tuatusi? <PrimaryText>Ulufale i lima...</PrimaryText>","nextLabel":"$t(common:next): <b>O au fa\u2018amatalaga fa\u2018afeso\u2018ota\u2018i</b>","postcode":"Numera o le meli","searchPlaceholder":"Su\u2018e tuatusi i Niu Sila","street":"Igoa ma le numera o le auala","suburb":"Pitonu\u2018u po\u2018o le RD (Tupe Fa\u2018ato\u2018aga)","text":"Fa\u2018amolemole, ulufale mai lou tuatusi o le fale:","textSecondary":"O le tuatusi lenei o le a matou fa\u2018aaog\u0101:","title":"Lou tuatusi o le fale"},"name-birthdate":{"birthDate":"Aso fanau","dateFormat":"dd/mm/yyyy","familyName":"Igoa o le \u2018\u0100IGA:","firstName":"Igoa muamua","nextLabel":"$t(common:next): <b>Lau NHI ma lou tulaga o le nonofo ai</b>","preferredName":"Igoa e fiafia e fa\u2018aaog\u0101","select":{"label":"Sui igoa","mr":"Mr","ms":"Ms","mx":"Mx","placeholder":"Filifili lau sui igoa"},"text":"Fa\u2018amolemole siaki nei fa\u2018amatalaga ma fa\u2018afou so\u02BBo se mea o lo\u2018o misia pe sese:","title":"Lau igoa ma le aso fanau"},"nhi-residency":{"nextLabel":"$t(common:next): <b>Lau tuatusi o le fale</b>","nhiNumber":"Numera NHI (National Health Index)","resident":"O oe o se tagata n\u014D Niu Sila?","residentText":"Afai e le o oe o se tagata n\u014D Niu Sila, atonu e tatau ona e totogiina nisi o auaunaga e pei o su\u2018esu\u2018ega i le falema\u2018i.","text":"Fa\u2018amolemole siaki ma fa\u2018afou so\u02BBo se mea o lo\u2019o misia pe sese:","title":"Lau numera NHI ma lou tulaga o le nonofo ai i Niu Sila"}}');


var $e839f14ce2c5524c$exports = {};
$e839f14ce2c5524c$exports = JSON.parse('{"code":"Code o le valaaulia","error":{"details":"<ul>  \\n<li>Siaki mo ni sipelaga sese ona toe taumafai lea.</li>  \\n<li>Afai o lo\u2019o e mana\u02BBomia se fesoasoani, vala\u2019au mai i le {{phone}} (ona oomi lea o le Filifiliga 2).</li>  \\n</ul>","title":"E le aoga le code o le valaaulia"},"helpMessage":"<p>Ua leiloa lau valaaulia pe e te le mautinoa le mea e fai?<br />Fa\u2018amolemole vala\u2018au mai i le <a><strong>{{phone}}</strong></a> (ona oomi lea o le <strong>Filifiliga 2</strong>).</p>","text":"<p>Ulufale lau code valaaulia e 6 mata\u2018itusi e amata ai.</p><p>O le a e mauaina lenei code i lau valaaulia i le imeli, po\u2019o le tagata na fa\u2018asino mai oe na tu\u2018uina atu.</p>","title":"Ulufale i lau valaaulia mo le tusi taimi"}');


var $64ef7dd46437c20d$exports = {};
$64ef7dd46437c20d$exports = JSON.parse('{"dropLabel":"Sasa\u2018a i se fesili fa\u2018apitoa","nextLabel":"<b>Tali fesili e uiga i le soifua m\u0101l\u014Dl\u014Dina</b>","questions":{"allergies":{"detailsPlaceholder":"Fa\u2018amolemole tusi i le Igilisi. Mo se fa\u2018ata\u2018ita\u2018iga:<br/>\\nPenicillin \u2013 rash and swelling; Latex \u2013 mild irritation","label":"E i ai ni ou ma\u2018i oona (allergies)?","nextLabel":"$t(common:next): <b>Mamafa ma le maualuga</b>","title":"<h3>Ogaoga i ni vaila\u02BBau po\u2019o mea\u2019ai (Allergies)</h3>"},"arrhythmias":{"detailsPlaceholder":"Fa\u2018amolemole tusi i le gagana Peretania. Fa\u2018ata\u2018ita\u2018iga: <br/>Irregular heartbeat, on beta blockers since 2021","label":"E iai sau fatu le masani, fatu tata vave, po o se leo i le fatu?","nextLabel":"$t(common:next): <b>Masini fatu</b>","title":"<h3>Tapuaiga o le fatu e le masani ai (Arrhythmias)</h3>"},"asthmaLungConditions":{"detailsPlaceholder":"Fa\u2018amolemole tusi i le gagana Peretania. Fa\u2018ata\u2018ita\u2018iga:<br/>\\nMild asthma \u2013 use inhaler occasionally","label":"E iai sau asima, COPD, po\u2019o se isi fo\u2019i ma\u2019i mama?","nextLabel":"$t(common:next): <b>G\u0101ioiga o le manava</b>","title":"<h3>Asima po\u02BBo nisi ma\u02BBi o le mama (Asthma or lung conditions)</h3>"},"bloodProblems":{"detailsPlaceholder":"Fa\u2018amolemole tusi i le gagana Peretania. Fa\u2018ata\u2018ita\u2018iga: <br/>\\nEasy bruising \u2013 diagnosed with Von Willebrand disease","label":"E iai sau GORD (reflux), IBS, po\u2019o le IBD?","nextLabel":"$t(common:next): <b>Fesuia\u2019iga o totoga</b>","title":"<h3>Mataupu tau le toto e pei o le pala toto po\u2019o le tafe toto faifai pea (Blood disorders or bleeding problems)</h3>"},"bloodThinningMedication":{"detailsPlaceholder":"Fa\u2018amolemole tusi i le gagana Peretania. Fa\u2018ata\u2018ita\u2018iga: <br/>Apixaban \u2013 5mg daily, last taken on 3 June","label":"O e inuina nei ni fuala\u02BBau e faaitiitia ai le maaa o le toto?","nextLabel":"$t(common:next): <b>a\u02BBi fatu</b>","title":"<h3>Fuala\u02BBau fa\u2019amama toto (Blood thinning medication)</h3>"},"cancerTreatment":{"detailsPlaceholder":"Fa\u2018amolemole tusi i le gagana Peretania. Fa\u2018ata\u2018ita\u2018iga: <br/>\\nChemotherapy for breast cancer \u2013 ongoing","label":"O lo\u2019o e faia togafitiga mo le kanesa e pei o le chemotherapy, radiotherapy po\u2019o se isi foi togafitiga?","nextLabel":"$t(common:next): <b>Fa\u2019ama\u2019i pipisi</b>","title":"<h3>Togafitiga o le kanesa (Cancer treatment)</h3>"},"diabetes":{"detailsLabel":"E fa\u02BBafefea ona fa\u02BBatautaia lau suka?","diet-controlled":"Pulea i le taumafataga","insulin":"Inisalini","label":"E iai sau ma\u02BBisuka?","nextLabel":"$t(common:next): <b>Faatosinaga toto maualuga</b>","no":"Leai","tablets":"Fuala\u02BBau i luga o le laulau (fa\u02BBata\u02BBita\u02BBiga: Metformin)","title":"<h3>Ma\u02BBi suka (Diabetes)</h3>","type-1":"Ituaiga 1 \u2013 fa\u2019aaogaina le inisalini","type-2":"Ituaiga 2","yes-type-1":"Ioe \u2013 Ituaiga 1, i le insulin","yes-type-2":"Ioe \u2013 Ituaiga 2"},"digestiveConditions":{"detailsPlaceholder":"Fa\u2018amolemole tusi i le gagana Peretania. Fa\u2018ata\u2018ita\u2018iga:<br/>Reflux managed with omeprazole","label":"E iai sau GORD (reflux), IBS, po\u2019o le IBD?","nextLabel":"$t(common:next): <b>Fa\u2019afitauli o le toto po\u2019o le tafe toto</b>","title":"<h3>G\u0101fa o le manava (Digestive conditions)</h3>"},"epilepsy":{"detailsPlaceholder":"Fa\u2018amolemole tusi i le Igilisi. Mo se fa\u2018ata\u2018ita\u2018iga:<br/>\\nLast seizure in 2020 \u2013 currently stable","label":"E iai sau epilepsi po o sau tala\u2018aga i le m\u0101\u2018i fifi?","nextLabel":"$t(common:next): <b>G\u0101fua o le neulosi</b>","title":"<h3>Fa\u2019ama\u2019i fatu (Epilepsy)</h3>"},"heartConditions":{"detailsPlaceholder":"Fa\u2018amolemole tusi i le gagana Peretania. Fa\u2018ata\u2018ita\u2018iga: <br/>Heart attack in 2020 \u2013 stent inserted","label":"Pe na iai se fa\u2019afitauli o lou fatu i le taimi ua tuana\u2019i (fa\u2019ata\u2019ita\u2019iga, fatu ta, angina)?","nextLabel":"$t(common:next): <b>Ta\u02BBavale po o le TIA</b>","title":"<h3>Foma\u02BBi o le fatu (Heart conditions)</h3>"},"highBloodPressure":{"detailsPlaceholder":"Fa\u2018amolemole tusi i le gagana Peretania. Fa\u2018ata\u2018ita\u2018iga: <br/>\\nDiagnosed in 2018 \u2013 managed with medication","label":"E iai sau toto maualuga?","nextLabel":"$t(common:next): <b>Fua fatu le masani</b>","title":"<h3>Faatosinaga maualuga o le toto (High blood pressure)</h3>"},"infectiousDiseases":{"detailsPlaceholder":"Fa\u2018amolemole tusi i le gagana Peretania. Fa\u2018ata\u2018ita\u2018iga: <br/>\\nMRSA \u2013 cleared after treatment in 2021","label":"Na e maua se i\u2019uga lelei mo MRSA, ESBL, VRE po\u2019o le CPE?","nextLabel":"$t(common:next): <b>ma\u02BBitaga</b>","title":"<h3>Siama e tetee i vaila\u02BBau eseese (Multi-resistant organisms)</h3>"},"metalImplants":{"detailsPlaceholder":"Fa\u2018amolemole tusi i le gagana Peretania. Fa\u2018ata\u2018ita\u2018iga: <br/>Right hip replacement (2020), dental implants, or metal rod in leg","label":"E i ai ni mea u\u02BBamea i totonu o lou tino? (fa\u02BBata\u02BBita\u02BBiga: pacemaker po\u02BBo ni sooga fa\u02BBapipi\u02BBi)","nextLabel":"$t(common:next): <b>Ma\u02BBi suka</b>","title":"<h3>Faatomuaga po\u02BBo u\u02BBamea (Implants or metal)</h3>"},"obstructiveSleepApnoea":{"detailsPlaceholder":"Fa\'amolemole tu\'u i le Igilisi. Fa\'ata\'ita\'iga:<br/>\\nDiagnosed in 2022 \u2013 use CPAP machine every night","label":"E iai sau obstructive sleep apnoea pe e fa\u2019aaoga se masini CPAP i le p\u014D a\u2019o e moe ai?","nextLabel":"$t(common:next): <b>Ma\u2019i sela po\u2019o ma\u2019i o le mama</b>","title":"<h3>O le tapunia o le ala m\u0101nava i le p\u014D (Obstructive Sleep Apnoea)</h3>"},"organTransplant":{"detailsPlaceholder":"Fa\u2018amolemole tusi i le gagana Peretania. Fa\u2018ata\u2018ita\u2018iga: <br/>\\nKidney transplant in 2018 \u2013 taking tacrolimus and prednisone","label":"Na e fai se tui aano (organ transplant) ma ua e fa\u2019aaogaina fuala\u2019au e fa\u2019aitiitia ai le puipuiga o le tino?","nextLabel":"$t(common:next): <b>Togafitiga o le kanesa</b>","title":"<h3>Fa\u02BBapipi\u02BBi o totoga (Organ transplant)</h3>"},"otherHealthConditions":{"detailsPlaceholder":"Fa\u2018amolemole tusi i le gagana Peretania. Fa\u2018ata\u2018ita\u2018iga: <br/>\\nCoeliac disease, recent surgery, chronic pain","label":"E i ai ni isi o ou tulaga tau soifua m\u0101l\u014Dl\u014Dina po\u02BBo ni popolega e tatau ona matou silafia ai?","nextLabel":"$t(common:next): <b>Fuala\u02BBau</b>","title":"<h3>Isi tulaga tau soifua m\u0101l\u014Dl\u014Dina (Other health conditions)</h3>"},"pacemaker":{"defibrillator":"Meafaigaluega fa\u2019aola fatu","detailsLabel":"O le \u0101 le ituaiga?","label":"E iai sau pacemaker po\u02BBo se isi masini fatu fa\u02BBapipi\u02BBi i totonu?","nextLabel":"$t(common:next): <b>Fuala\u02BBau fa\u2019amama toto</b>","not-sure":"Ou te le mautinoa","pacing":"Peseina","title":"<h3>Pacemaker po\u2019o se masini fatu ua fa\u2019apipi\u2019iina i totonu (Pacemaker or implanted cardiac device)</h3>"},"pregnancy":{"label":"O e ma\u02BBitaga i le taimi nei \u2013 pe masalo o e ma\u02BBitaga?","nextLabel":"$t(common:next): <b>Isi auga</b>","title":"<h3>Fa\u02BBatupu teine (Pregnancy)</h3>"},"stroke":{"detailsPlaceholder":"Fa\u2018amolemole tusi i le Igilisi. Mo se fa\u2018ata\u2018ita\u2018iga:<br/>\\nStroke in 2021 \u2013 mild weakness on left side","label":"Na e maua muamua i se stroke po\u2019o se mini-stroke (TIA)?","nextLabel":"$t(common:next): <b>Fa\u2018amai o le fai\u2018ai (Epilepsy)</b>","title":"<h3>Fasi o le fai\u2018ai po\u02BBo le fasi itiiti (TIA)</h3>"},"weightHeight":{"cm":"cm","height":"Maualuga","kg":"kg","nextLabel":"$t(common:next): <b>Faatu\u02BButu\u02BBu / u\u02BBamea</b>","text":"Fa\u2018amolemole, ulufale i lou mamafa ma lou maualuga fuafuaina.","title":"<h3>Mamafa ma le maualuga</h3><p>Fa\u2018amolemole, ulufale i lou mamafa ma lou maualuga fuafuaina.</p>","weight":"Mamafa"}},"text":"<p>O le a tatou lata i le fa\u2019ai\u2019uga.</p>\\n<p>E tatau ona matou fesili i ni fesili e uiga i lou soifua m\u0101l\u014Dl\u014Dina, fuala\u02BBau, ma ou mana\u2019oga patino.</p>\\n<p>E t\u0101ua tele le malamalama i so\u2019o se mea e mafai ona a\u2019afia ai lau tausiga.</p>\\n<p>Afai e mana\u02BBomia ona fa\u2019amalamalama se mea, o le a fa\u2019afeso\u2019ota\u2019i oe e se tagata o le matou \u2018au a\u2019o le\u2019i faia le taotoga.</p>\\n<p>E masani ona umi le vaega mulimuli e itiiti ifo i le <strong>10 minute</strong>.</p>","title":"Fesili e uiga i le soifua m\u0101l\u014Dl\u014Dina ma mana\u2019oga"}');


var $04d1c8793a24f020$exports = {};
$04d1c8793a24f020$exports = JSON.parse('{"addButtonLabel":"Fa\u2019agasologa po\u02BBo se taotoga","date":"Aso","datePlaceholder":"e.g. June 2022, 2021, or ~5 years ago","location":"Nofoaga","locationPlaceholder":"e.g. Ormiston Hospital, Auckland","nextLabel":"$t(common:next): <b>Gaoioiga o le tino</b>","procedure":"Fa\u2019amatalaga o le taotoga po\u2019o le togafitiga","procedurePlaceholder":"Fa\u2019amolemole tusi i le gagana Peretania. Fa\u2019ata\u2019ita\u2019iga: <br/>\\nColonoscopy to investigate bleeding","saveButton":"Sefe taotoga","text":"<p>O lo\'o iai le fa\'amaumauga o lau endoscopy talu ai i le {{company}}:</p>\\n<ul><li><strong>{{procedure}}</strong> i le <strong>{{date}}</strong></li></ul>\\n<p>Ua e faia se isi endoscopy, taotoga o le manava, po\'o se isi taotoga tetele talu mai len\u0101?</p>","textNoProcedure":"Na e faia muamua se endoscopy, taotoga o le manava, po\u2019o se isi taotoga tetele?","title":"Taotoga po\u02BBo ni togafitiga lata mai"}');


var $98a578c792aeb86a$exports = {};
$98a578c792aeb86a$exports = JSON.parse('{"helpMessage":"<h3>O iai ni au fesili e uiga i le inisiua?</h3>\\n<p>E fiafia le matou \u2018au e fesoasoani \u2014 vala\u02BBau:<br/><a><strong>\u260E\uFE0F {{phone}}</strong></a> (ona oomi lea o le <strong>Option 2</strong>)<br/>Monday to Friday, 8am\u20135pm.</p>","insuranceCovered":"O le a ufiufi e le inisiua le vaega pe atoa o tau o lau taotoga?","insuranceDetails":"<ul>\\n  <li>O a\u2019u e nafa ma so\u2019o se tupe e le aofia i le inisiua.</li>\\n  <li>O le a ou totogiina so\u2019o se tupe e mana\'omia i le aso e ulufale ai i le falemai.</li>\\n  <li>O a\u2019u e nafa ma so\u2019o se tau e aofia i le aumaia o le aitalafu pe afai ou te le totogiina la\u2019u teugatupe.</li>\\n</ul>","insuranceLabel":"Ou te malamalama ma taliaina le mea lea:","insurerLabel":"O ai lau kamupani inisiua mo le soifua m\u0101l\u014Dl\u014Dina?","insurerSelect":{"aia":"AIA","nib":"NIB","southern-cross":"Southern Cross"},"membershipLabel":"Numera o le sui auai","noCovered":"O le a ou totogiina uma le tau.","preApprovalLabel":"Ua e maua se fa\'atagaga muamua mo lenei taotoga?","preApprovalText":"<h3>{{insurer}} fa\'atagaga muamua</h3>\\n<p>O le a matou fa\'afeso\'ota\'i {{insurer}} mo oe e talosaga ai mo se fa\'atagaga mo lau taotoga.</p>\\n<p>O le a e maua se fa\'afouga e fa\'amaonia ai le i\'uga, e aofia ai ma se fuafuaga o so\'o se tupe e ono mana\'omia ona e totogi.</p>\\n<span>O lenei e ono aofia ai:</span>\\n<ul>\\n<li><strong>Fa\'atapula\'aina:</strong> le aofa\'i ua fa\'atulaga e lau inisiua, ma/po\'o</li>\\n<li><strong>Vaegatupe e le aofia:</strong> le eseesega i le va o le inisiua ma le tau o le taotoga.</li>\\n</ul>\\n<p>So\'o se fa\'atapula\'aina po\'o le vaegatupe e le aofia e tatau ona <strong>totogi i le aso o lau taotoga</strong>.</p>","title":"Inisiua Soifua"}');


var $d9876eacc5fc3fe3$exports = {};
$d9876eacc5fc3fe3$exports = JSON.parse('{"helpMessage":"<h3>Ei ni au fesili?</h3>\\n<p>Matou te fiafia e fesoasoani - vala\u02BBau mai i le matou \'au:<br/><a><strong>\u260E\uFE0F {{phone}}</strong></a> (ona oomi lea o le <strong>Option 2</strong>)<br/>Aso Gafua i le Aso Faraile, 8am\u20135pm.</p>","title":"Leai se aog\u0101 o le valaaulia"}');


var $cb32bf2d2aca5cfb$exports = {};
$cb32bf2d2aca5cfb$exports = JSON.parse('{"helpMessage":"<h3>O iai ni au fesili?</h3>\\n<p>Matou te sauni e fesoasoani \u2013 vili mai le matou \'au:<br/>\\n<a><strong>\u260E\uFE0F {{phone}}</strong></a> (ona fetaomi lea o le <strong>Filifiliga 2</strong>)<br/>\\nAso Gafua i le Aso Faraile, 8am\u20135pm.</p>","text":"<p>O le a matou logoina lau foma\u2018i na toe fa\u2018asino mai, ma atonu o le a ia fa\u2018afeso\u2018ota\u2018i atu e talanoaina la\u2018asaga o lo\u2018o lumana\u2018i.</p>\\n<p>Leai se isi mea e tatau ona e faia i le taimi nei.</p>","title":"Ua e filifili e l\u0113 tusi se taimi i le taimi nei."}');


var $bd682ace64f297d2$exports = {};
$bd682ace64f297d2$exports = JSON.parse("{}");


var $7f95dd9e20584a8a$exports = {};
$7f95dd9e20584a8a$exports = JSON.parse('{"text":"<p>Ina ua tele taumafaiga le manuia e fa\u02BBamaonia ai lou fa\u02BBamaoni, ua matou loka le valaaulia lenei mo sina taimi e puipui ai lou faalilolilo.</p>\\n<p>Aua e te popole \u2013 e mafai lava ona matou fesoasoani.</p>\\n<p>Faamolemole vala\u02BBau i le matou \u2018au e fa\u02BBamae\u2018a ai lau tusi taimi:</p>\\n<p><a><strong>\u260E\uFE0F {{phone}}</strong></a> (ona oomi lea o le <strong>Option 2</strong>)<br/>Aso Gafua i le Aso Faraile, 8am\u20135pm.</p>","title":"Ua loka le valaaulia mo lou saogalemu"}');


var $91d5550fbd97d20b$exports = {};
$91d5550fbd97d20b$exports = JSON.parse('{"addButtonLabel":"Fa\u02BBaopopo vaila\u02BBau","dose":"Togafitiga","dosePlaceholder":"e.g. 500mg or 1 tablet","dropHere":"Tu\u02BBu i le vaega lenei","dropText":"<p>{{fileExtensions}} po\u02BBo le {{fileExtension}} \u2014 e oo atu i le {{mb}}MB</p>","dropTitle":"<p><strong>Tu\u02BBu i luga se faila</strong> pe toso ma tufa</p>","frequency":"Taimi masani","manuallyText":"<strong>Fa\u02BBaopopo vaila\u02BBau i le lima</strong><p>Fa\u02BBaopopo le tasi vaila\u02BBau i le taimi. Fa\u02BBaofi le igoa, le fuala\u02BBau ma le taimi e te inu ai.</p>","medicationName":"Igoa o le vaila\u02BBau","medicationPlaceholder":"<p><strong>Fa\'amolemole, ulufale i le Igilisi.</strong><br/>Fa\'ata\'ita\'iga: Metformin \u2013 500mg morning and night</p>","nextLabel":"$t(common:next): <b>Tala\u02BBaga</b>","saveButton":"Sefe fuala\u02BBau","select":{"as-needed":"Pe a mana\u02BBomia","once-daily":"E tasi i le aso","three-time-daily":"Tolu i le aso","twice-daily":"Fa\u2019alua i le aso"},"text":"<p>Fa\'amolemole ta\'u mai so\'o se vaila\'au, inhaler, tui, po\'o se fuala\'au fa\'aopoopo o lo\'o e fa\'aaog\u0101ina i le taimi nei.</p>\\n<p>Oe mafai ona fa\'auluina se lisi po\'o fa\'aopoopo tusi.</p>","title":"Vaila\u02BBau","uploadText":"<strong>Tu\u02BBu i luga se foma\u02BBi po\u02BBo se lisi</strong>\\n<p>Afai ei ai sau lisi mai lau foma\u02BBi po\u02BBo le faletalavai, fa\'aulu se ata po\'o se PDF.</p>"}');


var $ebe9c08868fd57cd$exports = {};
$ebe9c08868fd57cd$exports = JSON.parse('{"questions":{"culture":{"detailsPlaceholder":"<p>Fa\u2018amolemole tusi i le Igilisi. Fa\u2019ata\u2019ita\u2019iga:</p>\\n<p>Wh\u0101nau to be present, need interpreter, specific dietary customs</p>","label":"E iai ni ou mana\u02BBoga fa\u2018ale-aganu\u2018u po o le aiga?","nextLabel":"$t(common:next): <b>Isi mana\u02BBoga fa\u02BBapitoa po\u02BBo fa\u02BBamatalaga</b>","title":"<h3>Mana\u02BBoga faaleaganu\u02BBu po o le aiga</h3>"},"language":{"de":"Deutsch / German","detailsLabel":"O le \u0101 lau gagana e te fiafia e fa\u2019aaog\u0101?","fj":"Vosa Vakaviti / Fijian","fr":"Fran\xe7ais / French","ja":"\u65E5\u672C\u8A9E / Japanese","ko":"\uD55C\uAD6D\uC5B4 / Korean","label":"E faigat\u0101 i\u0101 te oe le malamalama i le gagana Peretania?","mi":"Te Reo M\u0101ori","ms":"Malay / Malaysian","nextLabel":"$t(common:next): <b>Mana\u02BBoga faalelotu po o faaleagaga</b>","other":"Isi","pt":"Portugu\xeas / Portuguese","sm":"Gagana Samoa / Samoan","ta":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD / Tamil","title":"<h3>Malamalama i le gagana Peretania</h3>","tl":"Tagalog / Tagalog","to":"Lea Faka-Tonga / Tongan","zh":"\u7B80\u4F53\u4E2D\u6587 / Chinese"},"mobility":{"detailsPlaceholder":"Fa\'amolemole fa\'atumu i le gagana Peretania. Mo se fa\'ata\'ita\'iga:<br/>Fa\'aaoga se au savali po\'o se nofoa fa\'afoliga; mana\'omia se fesoasoani e si\'itia i luga o le moega","label":"E iai sau fa\u2019aletonu tumau po\u2019o se mana\u2019oga mo se fesoasoani i le savali?","nextLabel":"$t(common:next): <b>Malamalama i le Igilisi</b>","title":"<h3>Gafatia ona feoa\u2018i</h3>"},"other":{"detailsPlaceholder":"Fa\u2019asoa na\u2019o mea e te lagona e talafeagai. E fesoasoani lenei mea i le matou lagolagoina atili o oe.","label":"E iai ni isi o ou mana\u2019oga fa\u2019apitoa, pe iai fo\u2019i se isi fa\u2019amatalaga e te mana\u2019o e matou te silafia?","nextLabel":"$t(common:next): <b>Le mauaina o lau sauniuniga o le manava</b>","title":"<h3>Isi mana\u02BBoga faapitoa po o nisi fa\u02BBamatalaga</h3>"},"prep":{"label":"Fa\u2019amolemole filifili le auala e te mana\u2019o e maua ai:","nextLabel":"$t(common:next): <b>Fa\u2019amautu le tusi taimi</b>","pick-up-from-hospital":"<label>Piki mai i le {{company}}</label>\\n<p>Ao lau pusa sauni i le ofisa i taimi tatala.</p>","pick-up-from-local-pharmacy":"<label>Piki mai i lau faletalavai lata ane</label>\\n<p>O le a imeli atu e matou se foma\u02BBi fa\u02BBatonu e te ave i lau faletalavai.</p>","receive-by-mail":"<label>Tali i le meli</label>\\n<p>O le a lafo atu e matou le pusa sauni i le tuatusi i le fale na e tu\u02BBuina mai.</p>","text":"Ina ia sauni mo lau taotoga, e tatau ona e inuina se vaila\u02BBau fa\u2019apitoa e fa\u02BBam\u0101m\u0101 ai lou manava.","title":"<h3>Le tapenaina o lau fuala\u02BBau mo le manava</h3><p>Ina ia sauni mo lau taotoga, e tatau ona e inuina se vaila\u02BBau fa\u2019apitoa e fa\u02BBam\u0101m\u0101 ai lou manava.</p>"},"religion":{"detailsPlaceholder":"<p>Fa\u02BBamolemole ulufale i le gagana Peretania. Fa\u2019ata\u2019ita\u2019iga:<br/>Quiet space for prayer, prefer same-gender staff for personal care</p>","label":"E i ai ni ou mana\u02BBoga faalelotu po\u2019o faaleagaga?","nextLabel":"$t(common:next): <b>Mana\u02BBoga faaleaganu\u02BBu po o aiga</b>","title":"<h3>Mana\u02BBoga faalelotu po o faaleagaga</h3>"}}}');


var $3747076cf2b1537f$exports = {};
$3747076cf2b1537f$exports = JSON.parse("{\"helpMessage\":\"<h3>Fesili fa\u2019alilolilo?</h3>\\n<p>Ua sauni la matou 'au e fesoasoani - vala\u2019au mai:<br/>\\n<a><strong>\u260E\uFE0F {{phone}}</strong></a> (ona oomi lea o le <strong>Option 2</strong>)<br/>\\nAso Gafua i le Aso Faraile, 8am\u20135pm.</p>\",\"privacyDetails\":\"<ul><li>O lo'o e malamalama i le auala o le a fa'aogaina ai ou fa'amatalaga.</li><li>O lo'o e fa'atumuina lenei tusi mo oe lava\xa0po'o se isi tagata o lo'o e iai le fa'atagaga e lagolago ai (fa'ata'ita'iga, o se tagata tausi po'o se matua).</li><li>O lo'o e ioe e fa'aauau le faiga o le tusi taimi.</li></ul>\",\"privacyLabel\":\"Ou te taliaina lenei Fa\u2018amatalaga Fa\u2018alilolilo\",\"privacyText\":\"I le taliaina o lenei Fa\u2018amatalaga Fa\u2018alilolilo, o lo'o e fa\u2018amaonia mai:\",\"text\":\"<p>Matou te tausia ma le fa'aeteete lou fa'alilolilo.</p>\\n<p>O fa'amatalaga e te tu'uina atu i le taimi o lenei faiga o le a teuina ma le saogalemu ma fa'aaogaina na'o le fesoasoani i lau tausiga i le {{company}}.</p>\\n<p>O ou fa'amatalaga patino ma fa'afoma'i o le a fa'asoa na'o foma'i ma 'au soifua m\u0101l\u014Dl\u014Dina o lo'o galulue i lau togafitiga.</p>\\n<p>Matou te le fa'asoa i ou fa'amatalaga i isi vaega mo fa'amoemoega fa'al\u0101g\u0101ni.</p>\\n<p>O lo'o mafai ona e fa'afeso'ota'i i matou i so'o se taimi e talosagaina ai le avanoa i au fa'amatalaga, po'o le fa'asa'oina o nei fa'amatalaga.</p>\",\"title\":\"Fa\u2018amatalaga Fa\u2018alilolilo\"}");


var $75ee460adab6dae9$exports = {};
$75ee460adab6dae9$exports = JSON.parse('{"anySpecialist":{"text":"Fa\u2018aali mai le tele o taimi avanoa e mafai ona ou filifilia.","title":"E leai se eseesega mo a\u02BBu"},"nextLabel":"$t(common:next): <b>Filifili se taimi</b>","profile":"Tala o le Foma\u02BBi Faapitoa","specialists":{"00000000-0000-da7a-0003-000000000004":{"name":"Dr. Lopez"}},"textMultiple":"<p>O nei foma\u02BBi faapitoa uma o ni filifiliga lelei. Filifili se tasi, pe na o le fa\'aauau i le \u201CE leai se eseesega mo a\u02BBu\u201D.</p>","textSingle":"<p>O lau foma\u02BBi masani \u2013 {{referral.gp}} \u2013 ua fautuaina oe i le:</p>","titleMultiple":"Filifili lau foma\u02BBi faapitoa","titleSingle":"Lau foma\u02BBi faapitoa","viewProfile":"Va\u02BBai i le tala atoa"}');


var $be64b94c13d8ffb5$exports = {};
$be64b94c13d8ffb5$exports = JSON.parse('{"bookButtonLabel":"Tusi se taimi nei","bookText":"<h3>Tusi i luga o le initaneti:</h3>\\n<ul>\\n  <li>\u23F1\uFE0F  <strong>Vave ma faigofie -</strong> 15 minute pe iti atu</li>\\n  <li>\uD83C\uDF19  <strong>E mafai ona tusi i soo se taimi -</strong> e aofia ai ma po</li>\\n  <li>\uD83D\uDDD3\uFE0F  <strong>Filifili se taimi e fetaui ma oe</strong></li>\\n  <li>\uD83D\uDD10  <strong>E leai se pepa -</strong> saogalemu ma sa\u2018o</li>\\n</ul>","declineButtonLabel":"T\u0113 le talia lenei valaaulia mo le tusi taimi","declineText":"<h3>E te le\u02BBi fa\u2018amoemoeina pe mana\u02BBo i lenei taotoga?</h3>\\n<p>Fa\u2018amolemole filifili se mafua\u2018aga e ta\u2018u mai ai i matou:</p>","helpMessage":"<h3>Mananao e talanoa ma se tasi?</h3>\\n<p>O la matou \'au fesoasoani agalelei o lo\'o sauni e fesoasoani atu:<br/><a><strong>\u260E\uFE0F {{phone}}</strong></a> (ona oomi lea o le <strong>Filifiliga 2</strong>)<br/>Aso Gafua i le Aso Faraile, 8am\u20135pm.</p>\\n<p><em>E ono na\'o le Igilisi e mafai ona tautala ai la matou \'au \u2014 fa\'afetai mo lou malamalama.</em></p>","info":"<h3>E te mana\u02BBo e iloa atili e uiga i lenei taotoga?</h3>\\n<p>Matamata i se vitio pu\u02BBupu\u02BBu e fa\'amalamalama ai mea e mafai ona e fa\'amoemoe i ai ma le auala e sauni ai.</p>","select":{"badTiming":"E le talafeagai le taimi","cantAfford":"E le mafai ona gafatia i le taimi nei","didntKnowReferred":"Sa ou le iloa sa ou ua toe fa\u2019at\u016Bina i se foma\u2019i/fa\u2019al\u0113to\u2019aga","hadElsewhere":"Ua uma ona fai i se isi nofoaga","notNecessary":"Ou te manatu e le mana\u02BBomia","placeholder":"Filifili se mafua\u02BBaga"},"text":"<p>O lau foma\u02BBi masani, <strong>{{requestingPractitioner.displayName}}</strong>, ua fautuaina oe mo le <strong>{{procedure.displayName}}</strong> ma <strong>{{practitioners.0.name}}</strong>.</p>","textNoSpecialist":"<p>O lau foma\u02BBi masani, <strong>{{requestingPractitioner.displayName}}</strong>, ua fautuaina oe mo le <strong>{{procedure.displayName}}</strong>.</p>","title":"Talofa {{patient.nameGiven}}.<br /> Ua o\u02BBo i le taimi e tusi ai lau taotoga.","videoButtonLabel":"Kiliki e matamata i le vitio e uiga i le endoscopy","videoCaption":"Matou te fautuaina le matamata i lenei vitio a\'o le\'i tusi se taimi."}');


var $bcb0f9f5a11fa946$exports = {};
$bcb0f9f5a11fa946$exports = JSON.parse('{"birthDate":"Lau aso fanau","dateFormat":"dd/mm/yyyy","familyName":"Lou igoa o le aiga","helpMessage":"<p>Afai e le sa\u02BBo le numera i luga, pe e te le mautinoa le mea e fai, fa\'amolemole vala\'au mai i le <a><strong>{{phone}}</strong></a> (ona oomi lea o le <strong>Filifiliga 2</strong>).</p>","sendCode":"Lafo le numera","text":"<p>O lenei valaaulia mo se tusi o se gasegase o lo\u2019o tausia e se tagata e iai le numera telefoni: <strong><PhonePlaceholder /></strong></p>\\n<p>Afai o oe lea, fa\'amolemole ulufale i le <strong>igoa o le aiga o le gasegase</strong> ma le <strong>aso fanau</strong> i lalo ma kiliki le faamau.</p>\\n<p>Mo le saogalemu, o le a matou lafo atu se <strong>numera 4-numera fa\'amaonia</strong> e fa\'amaonia ai lou tulaga.</p>","title":"Afio mai i le <strong>{{company}} Online Booking</strong>"}');


var $cce25a550bf5cc00$exports = {};
$cce25a550bf5cc00$exports = JSON.parse('{"bookmarksMenu":"\u83DC\u5355","change":"\u66F4\u6539","closeBookmarksMenu":"\u5173\u95ED\u83DC\u5355","closeDialog":"\u5173\u95ED","colonoscopy":"\u7ED3\u80A0\u955C\u68C0\u67E5 (colonoscopy)","continue":"\u7EE7\u7EED","details":"\u8BE6\u7EC6\u4FE1\u606F","errors":{"invalidOtp":{"details":"<ul>  \\n<li>\u8BF7\u68C0\u67E5\u662F\u5426\u6709\u62FC\u5199\u9519\u8BEF\uFF0C\u7136\u540E\u91CD\u8BD5\u3002</li>  \\n<li>\u5982\u679C\u60A8\u9047\u5230\u56F0\u96BE\uFF0C\u8BF7\u81F4\u7535 {{phone}}\uFF08\u7136\u540E\u6309\u9009\u9879 2\uFF09\u3002</li>  \\n</ul>","title":"\u8FD9\u4E0E\u6211\u4EEC\u7684\u8BB0\u5F55\u4E0D\u5339\u914D"},"serverErrorOtp":{"details":"<ul>  \\n<li>\u60A8\u7684\u4FE1\u606F\u53EF\u80FD\u662F\u6B63\u786E\u7684\uFF0C\u4F46\u6211\u4EEC\u76EE\u524D\u65E0\u6CD5\u9A8C\u8BC1\u3002</li>  \\n<li>\u8BF7\u7A0D\u7B49\u7247\u523B\u540E\u518D\u8BD5\u4E00\u6B21\u3002</li>  \\n</ul>","title":"\u51FA\u73B0\u4E86\u4E00\u4E9B\u95EE\u9898\u3002"}},"formattedDate":"{{date}} {{time}}","gastroscopy":"\u80C3\u955C\u68C0\u67E5 (gastroscopy)","loading":"\u6B63\u5728\u52A0\u8F7D...","next":"\u4E0B\u4E00\u6B65","no":"\u5426","openBookmarksMenu":"\u6253\u5F00\u83DC\u5355","optional":"\u53EF\u9009","progress":"\u8FDB\u5EA6 {{progress}}%","selectLanguage":"\u9009\u62E9\u8BED\u8A00","step":{"appointment":"\u9884\u7EA6\u65F6\u95F4","details":"\u4E2A\u4EBA\u4FE1\u606F","health-questions":"\u5065\u5EB7\u95EE\u9898","history":"\u65E2\u5F80\u7684\u624B\u672F\u6216\u6CBB\u7597","insurance":"\u5065\u5EB7\u4FDD\u9669","medications":"\u836F\u7269","preference-questions":"\u504F\u597D\u95EE\u9898","specialist":"\u4E13\u79D1\u533B\u751F"},"videoUnsupported":"\u60A8\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301 video \u6807\u7B7E\u3002","yes":"\u662F","yesTo":"\u662F\uFF0C\u9009\u62E9","yourProgress":"\u60A8\u7684\u8FDB\u5EA6"}');


var $18ec1e6a38feaee6$exports = {};
$18ec1e6a38feaee6$exports = JSON.parse('{"comingSoonText":"<p>\u60A8\u53EF\u80FD\u5DF2\u7ECF\u770B\u5230\uFF0C\u4ECE\u4ECA\u5929\u8D77\u81F3\u5C11\u4E00\u5468\u5185\u6CA1\u6709\u53EF\u7528\u7684\u9884\u7EA6\u65F6\u95F4\u3002</p>\\n<p>\u6709\u65F6\u56E0\u53D6\u6D88\u4F1A\u7A7A\u51FA\u66F4\u65E9\u7684\u65F6\u95F4\u3002</p>\\n<p>\u5982\u679C\u6709\u66F4\u65E9\u7684\u65F6\u95F4\u51FA\u73B0\uFF0C\u60A8\u5E0C\u671B\u6211\u4EEC\u8054\u7CFB\u60A8\u5417\uFF1F</p>\\n<p>\u6CA1\u6709\u4EFB\u4F55\u66F4\u6539\u7684\u538B\u529B \u2014\u2014 \u5982\u679C\u5F53\u524D\u65F6\u95F4\u9002\u5408\u60A8\uFF0C\u5B8C\u5168\u53EF\u4EE5\u4FDD\u7559\u5B83\u3002</p>","comingSoonTitle":"\u60A8\u613F\u610F\u63D0\u524D\u6765\u770B\u8BCA\u5417\uFF1F","contactConsent":{"no":"\u4E0D\uFF0C\u8C22\u8C22 \u2013 \u6211\u5C31\u6309\u539F\u5B9A\u65F6\u95F4\u6765","yes":"\u662F\u7684 \u2013 \u6B22\u8FCE\u4E0E\u6211\u8054\u7CFB"},"contactConsentDetails":{"no":"\u6211\u4EEC\u4E0D\u4F1A\u5C31\u66F4\u65E9\u7684\u65F6\u95F4\u4E0E\u60A8\u8054\u7CFB\u3002","yes":"\u5982\u679C\u6709\u66F4\u65E9\u7684\u65F6\u95F4\u53EF\u7528\uFF0C\u6211\u4EEC\u4F1A\u901A\u77E5\u60A8\u3002"},"description":"<p>\u60A8\u73B0\u5728\u6709\u65F6\u95F4\u76F4\u5230 <strong>{{deadlineText}}</strong> \u5B8C\u6210\u9884\u7EA6 \u2014\u2014 \u5927\u7EA6\u8FD8\u6709 <b>{{deadlineTime}} \u5C0F\u65F6</b>\u3002</p>\\n<span>\u5B8C\u6210\u9884\u7EA6\uFF0C\u6211\u4EEC\u9700\u8981\u60A8\uFF1A</span>\\n<ul>\\n  <li>\u786E\u8BA4\u6216\u586B\u5199 <strong>\u60A3\u8005\u4FE1\u606F</strong></li>\\n  <li>\u544A\u77E5\u6211\u4EEC <strong>\u4ED8\u6B3E\u65B9</strong>\uFF08\u4F8B\u5982\uFF1A\u4FDD\u9669\uFF09</li>\\n  <li>\u56DE\u7B54\u4E00\u4E9B <strong>\u5065\u5EB7\u548C\u504F\u597D\u95EE\u9898</strong></li>\\n</ul>\\n<p>\u6574\u4E2A\u6D41\u7A0B\u901A\u5E38\u5C11\u4E8E <strong>12 \u5206\u949F</strong>\u3002</p>","nextLabel":"$t(common:next): <b>\u786E\u8BA4\u60A8\u7684\u4FE1\u606F</b>","text":"<p>\u60A8\u4E0E <strong>{{appointment.specialist}}</strong> \u7684 <strong>{{procedure.displayName}}</strong> \u5DF2\u4E8E <strong>{{appointment.date}}</strong> <strong>{{appointment.time}}</strong> <Status>\u4E34\u65F6\u9884\u7559</Status>\u3002</p>","title":"\u6211\u4EEC\u5DF2\u4E3A\u60A8\u9884\u7559\u4E86\u9884\u7EA6"}');


var $13a667778cfe1e6d$exports = {};
$13a667778cfe1e6d$exports = JSON.parse('{"modal":{"buttonLabel":"\u9009\u62E9\u65B0\u7684\u65F6\u95F4","text":"\u8BE5\u65F6\u95F4\u521A\u521A\u88AB\u4ED6\u4EBA\u9884\u8BA2\u3002","title":"\u521A\u9519\u8FC7\u4E86\uFF01"},"nextLabel":"$t(common:next): <b>\u9884\u7559\u9884\u7EA6\u65F6\u95F4</b>","nextWeek":"\u4E0B\u5468","noTimeText":"\u6240\u9009\u65E5\u671F\u6682\u65E0\u53EF\u7528\u65F6\u95F4\u3002","prevWeek":"\u4E0A\u5468","title":"\u8BF7\u9009\u62E9\u60A8\u7684\u9884\u7EA6\u65F6\u95F4"}');


var $a8693a0d4cf7f3e4$exports = {};
$a8693a0d4cf7f3e4$exports = JSON.parse('{"helpMessage":"<p>\u5982\u679C\u60A8\u9047\u5230\u95EE\u9898\uFF0C\u8BF7\u81F4\u7535 <a><strong>{{phone}}</strong></a>\uFF08\u7136\u540E\u6309 <strong>\u9009\u9879 2</strong>\uFF09\u3002</p>","noCode":"\u6CA1\u6709\u6536\u5230\u9A8C\u8BC1\u7801\uFF1F","remainingTime":"\u5269\u4F59 {{time}}","sendCode":"\u53D1\u9001\u65B0\u9A8C\u8BC1\u7801","text":"<p>\u6211\u4EEC\u5DF2\u5411\u60A8\u7684\u624B\u673A\u53F7\u7801\u53D1\u9001\u4E86\u4E00\u4E2A4\u4F4D\u9A8C\u8BC1\u7801\uFF1A<strong><PhonePlaceholder /></strong></p>\\n<p>\u8BE5\u9A8C\u8BC1\u7801\u5728{{validityMinutes}}\u5206\u949F\u5185\u6709\u6548\u3002</p>\\n<p>\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801\u4EE5\u7EE7\u7EED\u3002</p>","title":"\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801"}');


var $e1737540f673ad02$exports = {};
$e1737540f673ad02$exports = JSON.parse('{"calendarButtonLabel":"\u6DFB\u52A0\u5230\u65E5\u5386","confirmationText":"<h3>\u8BF7\u572824\u5C0F\u65F6\u5185\u7559\u610F\u4E00\u5C01\u7535\u5B50\u90AE\u4EF6\uFF1A</h3>\\n<ul>\\n  <li>\u2705  \u9884\u7EA6\u786E\u8BA4</li>\\n  <li>\uD83D\uDCB2  \u63D0\u4F9B\u7ED9\u60A8\u4FDD\u9669\u516C\u53F8\u7684\u8D39\u7528\u9884\u4F30</li>\\n  <li></li>\\n  <li>\uD83E\uDD64  \u51C6\u5907\u8BF4\u660E</li>\\n  <li>\uD83C\uDFE5  \u5C31\u8BCA\u4FE1\u606F\uFF08\u8DEF\u7EBF\u3001\u505C\u8F66\u7B49\uFF09</li>\\n  <li>\uD83D\uDC8A  \u51C6\u5907\u7528\u836F\u5904\u65B9</li>\\n</ul>\\n<p>\u6211\u4EEC\u4E5F\u4F1A\u5BA1\u6838\u60A8\u7684\u5065\u5EB7\u56DE\u7B54\uFF0C\u5982\u679C\u5728\u624B\u672F\u524D\u9700\u8981\u8FDB\u4E00\u6B65\u8054\u7CFB\uFF0C\u6211\u4EEC\u7684\u5DE5\u4F5C\u4EBA\u5458\u4F1A\u4E0E\u60A8\u8054\u7CFB\u3002</p>","helpMessage":"<h3>\u8054\u7CFB\u6211\u4EEC</h3>\\n<p>\u5982\u679C\u60A8\u6709\u4EFB\u4F55\u95EE\u9898\u6216\u9700\u8981\u66F4\u6539\uFF0C\u8BF7\u81F4\u7535\u6211\u4EEC\u7684\u5BA2\u670D\u56E2\u961F\uFF1A<br/>\\n<a><strong>\u260E\uFE0F {{phone}}</strong></a>\uFF08\u7136\u540E\u6309 <strong>\u9009\u98792</strong>\uFF09<br/>\\n\u5468\u4E00\u81F3\u5468\u4E94\uFF0C\u4E0A\u53488\u70B9\u81F3\u4E0B\u53485\u70B9\u3002</p>\\n<p><em>\u6211\u4EEC\u7684\u5DE5\u4F5C\u4EBA\u5458\u53EF\u80FD\u53EA\u4F1A\u8BF4\u82F1\u8BED \u2014 \u611F\u8C22\u60A8\u7684\u7406\u89E3\u3002</em></p>","text":"<p>\u60A8\u4E0E <strong>{{appointment.specialist}}</strong> \u7684 <strong>{{procedure.displayName}}</strong> \u5DF2\u4E8E <strong>{{appointment.date}}</strong> <strong>{{appointment.time}}</strong> <Status>\u786E\u8BA4</Status>\u3002</p>","title":"\u8C22\u8C22\u4F60\uFF0C{{patient.nameGiven}}\uFF01<br/> \u76EE\u524D\u6211\u4EEC\u6240\u9700\u7684\u4FE1\u606F\u90FD\u5DF2\u6536\u96C6\u5B8C\u6BD5\u3002"}');


var $3ce7bbba87a01ffc$exports = {};
$3ce7bbba87a01ffc$exports = JSON.parse('{"contact-details":{"email":"\u7535\u5B50\u90AE\u4EF6\u5730\u5740","mobilePhone":"\u624B\u673A","nextLabel":"$t(common:next): <b>\u60A8\u7684\u5168\u79D1\u533B\u751F\uFF08\u533B\u751F\uFF09</b>","otherPhone":"\u5176\u4ED6\u7535\u8BDD","text":"\u6211\u4EEC\u4E00\u76F4\u4F7F\u7528\u8FD9\u4E9B\u4FE1\u606F\u4E0E\u60A8\u8054\u7CFB\uFF0C\u4F46\u5982\u679C\u9700\u8981\uFF0C\u60A8\u53EF\u4EE5\u66F4\u65B0\u5B83\u4EEC\u3002","title":"\u60A8\u7684\u8054\u7CFB\u65B9\u5F0F"},"doctor":{"gp":"\u5168\u79D1\u533B\u751F\uFF08\u533B\u751F\uFF09\u59D3\u540D","manually":"\u533B\u751F\u6CA1\u6709\u663E\u793A\uFF1F<PrimaryText>\u8BF7\u624B\u52A8\u8F93\u5165...</PrimaryText>","medicalCentre":"\u533B\u7597\u4E2D\u5FC3","nextLabel":"$t(common:next): <b>\u60A8\u7684\u7D27\u6025\u8054\u7CFB\u4EBA</b>","searchPlaceholder":"\u641C\u7D22\u60A8\u7684\u5168\u79D1\u533B\u751F\u6216\u533B\u7597\u4E2D\u5FC3","text":"\u8FD9\u662F\u60A8\u7684\u5168\u79D1\u533B\u751F\u5417\uFF1F\u5982\u679C\u4E0D\u662F\uFF0C\u8BF7\u66F4\u65B0\u3002","title":"\u60A8\u7684\u5168\u79D1\u533B\u751F\uFF08\u533B\u751F\uFF09"},"emergency":{"fullName":"\u5168\u540D","mobileNumber":"\u624B\u673A\u53F7\u7801","nextLabel":"$t(common:next): <b>\u4FDD\u9669 / \u8C01\u6765\u4ED8\u6B3E</b>","relationship":"\u4E0E\u60A8\u7684\u5173\u7CFB","select":{"child":"\u5B50\u5973","friend":"\u670B\u53CB","other":"\u5176\u4ED6","parent":"\u7236\u6BCD","spouse":"\u914D\u5076 / \u4F34\u4FA3"},"text":"\u7D27\u6025\u60C5\u51B5\u4E0B\u6211\u4EEC\u5E94\u8054\u7CFB\u8C01\uFF1F","title":"\u60A8\u7684\u7D27\u6025\u8054\u7CFB\u4EBA"},"home-address":{"building":"\u5EFA\u7B51\u6216\u5C0F\u533A\u7684\u697C\u5C42\u3001\u5C42\u7EA7\u6216\u5355\u5143","city":"\u57CE\u9547 / \u57CE\u5E02","manually":"\u5730\u5740\u672A\u663E\u793A\uFF1F<PrimaryText>\u624B\u52A8\u8F93\u5165...</PrimaryText>","nextLabel":"$t(common:next): <b>\u60A8\u7684\u8054\u7CFB\u4FE1\u606F</b>","postcode":"\u90AE\u653F\u7F16\u7801","searchPlaceholder":"\u5728\u65B0\u897F\u5170\u641C\u7D22\u5730\u5740","street":"\u8857\u9053\u540D\u79F0\u548C\u95E8\u724C\u53F7","suburb":"\u90CA\u533A\u6216 RD\uFF08\u519C\u6751\u6295\u9012\uFF09","text":"\u8BF7\u8F93\u5165\u60A8\u7684\u5BB6\u5EAD\u4F4F\u5740\uFF1A","textSecondary":"\u8FD9\u662F\u6211\u4EEC\u5C06\u4F7F\u7528\u7684\u5730\u5740\uFF1A","title":"\u60A8\u7684\u5BB6\u5EAD\u4F4F\u5740"},"name-birthdate":{"birthDate":"\u51FA\u751F\u65E5\u671F","dateFormat":"dd/mm/yyyy","familyName":"\u59D3\u6C0F\uFF1A","firstName":"\u540D\u5B57","nextLabel":"$t(common:next): <b>\u60A8\u7684 NHI \u7F16\u53F7\u548C\u5C45\u4F4F\u72B6\u51B5</b>","preferredName":"\u504F\u597D\u59D3\u540D","select":{"label":"\u79F0\u8C13","mr":"Mr","ms":"Ms","mx":"Mx","placeholder":"\u9009\u62E9\u60A8\u7684\u79F0\u8C13"},"text":"\u8BF7\u68C0\u67E5\u4EE5\u4E0B\u4FE1\u606F\uFF0C\u5E76\u66F4\u65B0\u4EFB\u4F55\u9057\u6F0F\u6216\u4E0D\u6B63\u786E\u7684\u5185\u5BB9\uFF1A","title":"\u60A8\u7684\u59D3\u540D\u548C\u51FA\u751F\u65E5\u671F"},"nhi-residency":{"nextLabel":"$t(common:next): <b>\u60A8\u7684\u5BB6\u5EAD\u4F4F\u5740</b>","nhiNumber":"NHI\u53F7\u7801\uFF08\u56FD\u5BB6\u5065\u5EB7\u7D22\u5F15\u7F16\u53F7\uFF09","resident":"\u60A8\u662F\u65B0\u897F\u5170\u5C45\u6C11\u5417\uFF1F","residentText":"\u5982\u679C\u60A8\u4E0D\u662F\u65B0\u897F\u5170\u5C45\u6C11\uFF0C\u53EF\u80FD\u9700\u8981\u4E3A\u67D0\u4E9B\u670D\u52A1\uFF08\u4F8B\u5982\u5B9E\u9A8C\u5BA4\u68C0\u6D4B\uFF09\u652F\u4ED8\u8D39\u7528\u3002","text":"\u8BF7\u68C0\u67E5\u5E76\u66F4\u65B0\u4EFB\u4F55\u9057\u6F0F\u6216\u4E0D\u6B63\u786E\u7684\u4FE1\u606F\uFF1A","title":"\u60A8\u7684 NHI \u53F7\u7801\u548C\u5C45\u7559\u8EAB\u4EFD"}}');


var $e3fd611d3398564b$exports = {};
$e3fd611d3398564b$exports = JSON.parse('{"code":"\u9080\u8BF7\u7801","error":{"details":"<ul>  \\n<li>\u8BF7\u68C0\u67E5\u662F\u5426\u6709\u62FC\u5199\u9519\u8BEF\uFF0C\u7136\u540E\u91CD\u8BD5\u3002</li>  \\n<li>\u5982\u679C\u60A8\u9047\u5230\u95EE\u9898\uFF0C\u8BF7\u81F4\u7535 {{phone}}\uFF08\u7136\u540E\u6309\u9009\u98792\uFF09\u3002</li>  \\n</ul>","title":"\u8BE5\u9080\u8BF7\u7801\u65E0\u6548"},"helpMessage":"<p>\u4E22\u5931\u4E86\u9080\u8BF7\u7801\u6216\u4E0D\u786E\u5B9A\u8BE5\u600E\u4E48\u505A\uFF1F<br />\u8BF7\u81F4\u7535 <a><strong>{{phone}}</strong></a> \u8054\u7CFB\u6211\u4EEC\uFF08\u7136\u540E\u6309 <strong>\u9009\u9879 2</strong>\uFF09\u3002</p>","text":"<p>\u8BF7\u8F93\u5165\u60A8\u76846\u4F4D\u9080\u8BF7\u7801\u4EE5\u5F00\u59CB\u3002</p><p>\u60A8\u53EF\u4EE5\u5728\u7535\u5B50\u90AE\u4EF6\u9080\u8BF7\u4E2D\u627E\u5230\u6B64\u4EE3\u7801\uFF0C\u6216\u8005\u53EF\u80FD\u7531\u8F6C\u8BCA\u4EBA\u63D0\u4F9B\u3002</p>","title":"\u8BBF\u95EE\u60A8\u7684\u9884\u7EA6\u9080\u8BF7"}');


var $2cc160906c51db5d$exports = {};
$2cc160906c51db5d$exports = JSON.parse('{"dropLabel":"\u8DF3\u8F6C\u5230\u7279\u5B9A\u95EE\u9898","nextLabel":"<b>\u56DE\u7B54\u5065\u5EB7\u76F8\u5173\u95EE\u9898</b>","questions":{"allergies":{"detailsPlaceholder":"\u8BF7\u4F7F\u7528\u82F1\u6587\u586B\u5199\u3002\u4F8B\u5982\uFF1A<br/>\\nPenicillin \u2013 rash and swelling; Latex \u2013 mild irritation","label":"\u60A8\u6709\u4EFB\u4F55\u8FC7\u654F\u53CD\u5E94\u5417\uFF1F","nextLabel":"$t(common:next): <b>\u4F53\u91CD\u548C\u8EAB\u9AD8</b>","title":"<h3>\u8FC7\u654F\u53CD\u5E94 (Allergies)</h3>"},"arrhythmias":{"detailsPlaceholder":"\u8BF7\u7528\u82F1\u6587\u586B\u5199\u3002\u4F8B\u5982\uFF1A <br/>Irregular heartbeat, on beta blockers since 2021","label":"\u60A8\u6709\u5FC3\u5F8B\u4E0D\u9F50\u3001\u5FC3\u60B8\u6216\u5FC3\u810F\u6742\u97F3\u5417\uFF1F","nextLabel":"$t(common:next): <b>\u8D77\u640F\u5668</b>","title":"<h3>\u5FC3\u5F8B\u4E0D\u9F50 (Arrhythmias)</h3>"},"asthmaLungConditions":{"detailsPlaceholder":"\u8BF7\u7528\u82F1\u6587\u586B\u5199\u3002\u4F8B\u5982\uFF1A<br/>\\nMild asthma \u2013 use inhaler occasionally","label":"\u60A8\u662F\u5426\u60A3\u6709\u54EE\u5598\u3001\u6162\u6027\u963B\u585E\u6027\u80BA\u75C5 (COPD) \u6216\u5176\u4ED6\u80BA\u90E8\u75BE\u75C5\uFF1F","nextLabel":"$t(common:next): <b>\u6D88\u5316\u7CFB\u7EDF\u75BE\u75C5</b>","title":"<h3>\u54EE\u5598\u6216\u80BA\u90E8\u75BE\u75C5 (Asthma or lung conditions)</h3>"},"bloodProblems":{"detailsPlaceholder":"\u8BF7\u7528\u82F1\u6587\u586B\u5199\u3002\u4F8B\u5982\uFF1A<br/>Easy bruising \u2013 diagnosed with Von Willebrand disease","label":"\u60A8\u662F\u5426\u60A3\u6709\u80C3\u98DF\u7BA1\u53CD\u6D41\u75C5\uFF08GORD\uFF09\u3001\u80A0\u6613\u6FC0\u7EFC\u5408\u75C7\uFF08IBS\uFF09\u6216\u708E\u75C7\u6027\u80A0\u75C5\uFF08IBD\uFF09\uFF1F","nextLabel":"$t(common:next): <b>\u5668\u5B98\u79FB\u690D</b>","title":"<h3>\u8840\u6DB2\u75BE\u75C5\u6216\u51FA\u8840\u95EE\u9898 (Blood disorders or bleeding problems)</h3>"},"bloodThinningMedication":{"detailsPlaceholder":"\u8BF7\u7528\u82F1\u6587\u586B\u5199\u3002\u4F8B\u5982\uFF1A <br/>Apixaban \u2013 5mg daily, last taken on 3 June","label":"\u60A8\u76EE\u524D\u6B63\u5728\u670D\u7528\u6297\u51DD\u8840\u836F\u7269\u5417\uFF1F","nextLabel":"$t(common:next): <b>\u5FC3\u810F\u75BE\u75C5</b>","title":"<h3>\u6297\u51DD\u8840\u836F\u7269 (Blood thinning medication)</h3>"},"cancerTreatment":{"detailsPlaceholder":"\u8BF7\u7528\u82F1\u6587\u586B\u5199\u3002\u4F8B\u5982\uFF1A<br/>\\nChemotherapy for breast cancer \u2013 ongoing","label":"\u60A8\u76EE\u524D\u662F\u5426\u6B63\u5728\u63A5\u53D7\u5316\u7597\u3001\u653E\u7597\u6216\u4EFB\u4F55\u5176\u4ED6\u764C\u75C7\u6CBB\u7597\uFF1F","nextLabel":"$t(common:next): <b>\u4F20\u67D3\u75C5</b>","title":"<h3>\u764C\u75C7\u6CBB\u7597 (Cancer treatment)</h3>"},"diabetes":{"detailsLabel":"\u60A8\u7684\u7CD6\u5C3F\u75C5\u662F\u5982\u4F55\u63A7\u5236\u7684\uFF1F","diet-controlled":"\u996E\u98DF\u63A7\u5236","insulin":"\u80F0\u5C9B\u7D20","label":"\u60A8\u6709\u7CD6\u5C3F\u75C5\u5417\uFF1F","nextLabel":"$t(common:next): <b>\u9AD8\u8840\u538B</b>","no":"\u5426","tablets":"\u7247\u5242\uFF08\u4F8B\u5982\uFF1A\u4E8C\u7532\u53CC\u80CD","title":"<h3>\u7CD6\u5C3F\u75C5 (Diabetes)</h3>","type-1":"1\u578B \u2013 \u4F7F\u7528\u80F0\u5C9B\u7D20","type-2":"2\u578B","yes-type-1":"\u662F \u2013 1\u578B\uFF0C\u4F7F\u7528\u80F0\u5C9B\u7D20","yes-type-2":"\u662F \u2013 2\u578B"},"digestiveConditions":{"detailsPlaceholder":"\u8BF7\u7528\u82F1\u6587\u586B\u5199\u3002\u4F8B\u5982\uFF1A<br/>Reflux managed with omeprazole","label":"\u60A8\u662F\u5426\u60A3\u6709\u80C3\u98DF\u7BA1\u53CD\u6D41\u75C5\uFF08GORD\uFF09\u3001\u80A0\u6613\u6FC0\u7EFC\u5408\u75C7\uFF08IBS\uFF09\u6216\u708E\u75C7\u6027\u80A0\u75C5\uFF08IBD\uFF09\uFF1F","nextLabel":"$t(common:next): <b>\u8840\u6DB2\u6216\u51FA\u8840\u95EE\u9898</b>","title":"<h3>\u6D88\u5316\u7CFB\u7EDF\u75BE\u75C5 (Digestive conditions)</h3>"},"epilepsy":{"detailsPlaceholder":"\u8BF7\u4F7F\u7528\u82F1\u6587\u586B\u5199\u3002\u4F8B\u5982\uFF1A<br/>\\nLast seizure in 2020 \u2013 currently stable","label":"\u60A8\u662F\u5426\u60A3\u6709\u766B\u75EB\u6216\u6709\u766B\u75EB\u53D1\u4F5C\u7684\u75C5\u53F2\uFF1F","nextLabel":"$t(common:next): <b>\u795E\u7ECF\u7CFB\u7EDF\u75BE\u75C5</b>","title":"<h3>\u766B\u75EB (Epilepsy)</h3>"},"heartConditions":{"detailsPlaceholder":"\u8BF7\u7528\u82F1\u6587\u586B\u5199\u3002\u4F8B\u5982\uFF1A <br/>Heart attack in 2020 \u2013 stent inserted","label":"\u60A8\u662F\u5426\u66FE\u7ECF\u60A3\u6709\u5FC3\u810F\u75BE\u75C5\uFF08\u4F8B\u5982\u5FC3\u810F\u75C5\u53D1\u4F5C\u3001\u5FC3\u7EDE\u75DB\uFF09\uFF1F","nextLabel":"$t(common:next): <b>\u4E2D\u98CE\u6216TIA</b>","title":"<h3>\u5FC3\u810F\u75BE\u75C5 (Heart conditions)</h3>"},"highBloodPressure":{"detailsPlaceholder":"\u8BF7\u7528\u82F1\u6587\u586B\u5199\u3002\u4F8B\u5982\uFF1A<br/>Diagnosed in 2018 \u2013 managed with medication","label":"\u60A8\u6709\u9AD8\u8840\u538B\u5417\uFF1F","nextLabel":"$t(common:next): <b>\u5FC3\u5F8B\u4E0D\u9F50</b>","title":"<h3>\u9AD8\u8840\u538B (High blood pressure)</h3>"},"infectiousDiseases":{"detailsPlaceholder":"\u8BF7\u7528\u82F1\u6587\u586B\u5199\u3002\u4F8B\u5982\uFF1A<br/>\\nMRSA \u2013 cleared after treatment in 2021","label":"\u60A8\u662F\u5426\u66FE\u7ECF\u88AB\u68C0\u6D4B\u51FA MRSA\u3001ESBL\u3001VRE \u6216 CPE \u5448\u9633\u6027\uFF1F","nextLabel":"$t(common:next): <b>\u6000\u5B55</b>","title":"<h3>\u591A\u91CD\u8010\u836F\u83CC (Multi-resistant organisms)</h3>"},"metalImplants":{"detailsPlaceholder":"\u8BF7\u7528\u82F1\u6587\u586B\u5199\u3002\u4F8B\u5982\uFF1A <br/>Right hip replacement (2020), dental implants, or metal rod in leg","label":"\u60A8\u7684\u4F53\u5185\u6709\u91D1\u5C5E\u690D\u5165\u7269\u6216\u91D1\u5C5E\u5668\u4EF6\u5417\uFF1F\uFF08\u4F8B\u5982\uFF1A\u5FC3\u810F\u8D77\u640F\u5668\u6216\u5047\u4F53\uFF09","nextLabel":"$t(common:next): <b>\u7CD6\u5C3F\u75C5</b>","title":"<h3>\u690D\u5165\u7269\u6216\u91D1\u5C5E (Implants or metal)</h3>"},"obstructiveSleepApnoea":{"detailsPlaceholder":"\u8BF7\u7528\u82F1\u6587\u586B\u5199\u3002\u4F8B\u5982\uFF1A<br/>\\nDiagnosed in 2022 \u2013 use CPAP machine every night","label":"\u60A8\u662F\u5426\u60A3\u6709\u963B\u585E\u6027\u7761\u7720\u547C\u5438\u6682\u505C\u75C7\uFF0C\u6216\u5728\u665A\u4E0A\u7761\u89C9\u65F6\u4F7F\u7528 CPAP \u673A\u5668\uFF1F","nextLabel":"$t(common:next): <b>\u54EE\u5598\u6216\u80BA\u90E8\u75BE\u75C5</b>","title":"<h3>\u963B\u585E\u6027\u7761\u7720\u547C\u5438\u6682\u505C (Obstructive Sleep Apnoea)</h3>"},"organTransplant":{"detailsPlaceholder":"\u8BF7\u7528\u82F1\u6587\u586B\u5199\u3002\u4F8B\u5982\uFF1A<br/>\\nKidney transplant in 2018 \u2013 taking tacrolimus and prednisone","label":"\u60A8\u662F\u5426\u63A5\u53D7\u8FC7\u5668\u5B98\u79FB\u690D\uFF0C\u5E76\u6B63\u5728\u670D\u7528\u514D\u75AB\u6291\u5236\u836F\u7269\uFF1F","nextLabel":"$t(common:next): <b>\u764C\u75C7\u6CBB\u7597</b>","title":"<h3>\u5668\u5B98\u79FB\u690D (Organ transplant)</h3>"},"otherHealthConditions":{"detailsPlaceholder":"\u8BF7\u7528\u82F1\u6587\u586B\u5199\u3002\u4F8B\u5982\uFF1A<br/>\\nCoeliac disease, recent surgery, chronic pain","label":"\u60A8\u8FD8\u6709\u5176\u4ED6\u6211\u4EEC\u9700\u8981\u4E86\u89E3\u7684\u5065\u5EB7\u72B6\u51B5\u6216\u62C5\u5FE7\u5417\uFF1F","nextLabel":"$t(common:next): <b>\u836F\u7269</b>","title":"<h3>\u5176\u4ED6\u5065\u5EB7\u72B6\u51B5 (Other health conditions)</h3>"},"pacemaker":{"defibrillator":"\u9664\u98A4\u5668","detailsLabel":"\u8FD9\u662F\u4EC0\u4E48\u7C7B\u578B\uFF1F","label":"\u60A8\u6709\u8D77\u640F\u5668\u6216\u5176\u4ED6\u690D\u5165\u5F0F\u5FC3\u810F\u88C5\u7F6E\u5417\uFF1F","nextLabel":"$t(common:next): <b>\u6297\u51DD\u836F</b>","not-sure":"\u6211\u4E0D\u786E\u5B9A","pacing":"\u8D77\u640F\u5668\u6A21\u5F0F","title":"<h3>\u8D77\u640F\u5668\u6216\u690D\u5165\u5F0F\u5FC3\u810F\u88C5\u7F6E (Pacemaker or implanted cardiac device)</h3>"},"pregnancy":{"label":"\u60A8\u73B0\u5728\u662F\u5426\u6000\u5B55\uFF0C\u6216\u53EF\u80FD\u6000\u5B55\uFF1F","nextLabel":"$t(common:next): <b>\u5176\u4ED6\u60C5\u51B5</b>","title":"<h3>\u6000\u5B55 (Pregnancy)</h3>"},"stroke":{"detailsPlaceholder":"\u8BF7\u4F7F\u7528\u82F1\u6587\u586B\u5199\u3002\u4F8B\u5982\uFF1A<br/>\\nStroke in 2021 \u2013 mild weakness on left side","label":"\u60A8\u66FE\u7ECF\u4E2D\u98CE\u6216\u8F7B\u5FAE\u4E2D\u98CE\uFF08TIA\uFF09\u5417\uFF1F","nextLabel":"$t(common:next): <b>\u766B\u75EB\uFF08Epilepsy\uFF09</b>","title":"<h3>\u4E2D\u98CE\u6216\u77ED\u6682\u6027\u8111\u7F3A\u8840\u53D1\u4F5C\uFF08TIA\uFF09</h3>"},"weightHeight":{"cm":"cm","height":"\u8EAB\u9AD8","kg":"kg","nextLabel":"$t(common:next): <b>\u690D\u5165\u7269 / \u91D1\u5C5E</b>","text":"\u8BF7\u8F93\u5165\u60A8\u7684\u5927\u81F4\u4F53\u91CD\u548C\u8EAB\u9AD8\u3002","title":"<h3>\u4F53\u91CD\u548C\u8EAB\u9AD8</h3><p>\u8BF7\u8F93\u5165\u60A8\u7684\u5927\u81F4\u4F53\u91CD\u548C\u8EAB\u9AD8\u3002</p>","weight":"\u4F53\u91CD"}},"text":"<p>\u6211\u4EEC\u5FEB\u5B8C\u6210\u4E86\u3002</p>\\n<p>\u6211\u4EEC\u9700\u8981\u4E86\u89E3\u4E00\u4E9B\u5173\u4E8E\u60A8\u7684\u5065\u5EB7\u72B6\u51B5\u3001\u7528\u836F\u60C5\u51B5\u548C\u4E2A\u4EBA\u504F\u597D\u7684\u95EE\u9898\u3002</p>\\n<p>\u4E86\u89E3\u4EFB\u4F55\u53EF\u80FD\u5F71\u54CD\u60A8\u62A4\u7406\u7684\u60C5\u51B5\u975E\u5E38\u91CD\u8981\u3002</p>\\n<p>\u5982\u679C\u6709\u9700\u8981\u786E\u8BA4\u7684\u5730\u65B9\uFF0C\u6211\u4EEC\u7684\u56E2\u961F\u6210\u5458\u5C06\u5728\u60A8\u7684\u68C0\u67E5\u524D\u4E0E\u60A8\u8054\u7CFB\u3002</p>\\n<p>\u8FD9\u4E2A\u6700\u540E\u7684\u6B65\u9AA4\u901A\u5E38\u5C11\u4E8E<strong>10\u5206\u949F</strong>\u5373\u53EF\u5B8C\u6210\u3002</p>","title":"\u5065\u5EB7\u548C\u504F\u597D\u95EE\u9898"}');


var $681d5cbfa2549556$exports = {};
$681d5cbfa2549556$exports = JSON.parse('{"addButtonLabel":"\u64CD\u4F5C\u6216\u624B\u672F","date":"\u65E5\u671F","datePlaceholder":"e.g. June 2022, 2021, or ~5 years ago","location":"\u5730\u70B9","locationPlaceholder":"e.g. Ormiston Hospital, Auckland","nextLabel":"$t(common:next): <b>\u884C\u52A8\u80FD\u529B</b>","procedure":"\u624B\u672F\u6216\u6CBB\u7597\u7684\u63CF\u8FF0","procedurePlaceholder":"\u8BF7\u7528\u82F1\u6587\u586B\u5199\u3002\u4F8B\u5982: <br/>\\nColonoscopy to investigate bleeding","saveButton":"\u4FDD\u5B58\u624B\u672F\u4FE1\u606F","text":"<p>\u6211\u4EEC\u8BB0\u5F55\u4E86\u60A8\u5728 {{company}} \u7684\u4E0A\u4E00\u6B21\u5185\u7AA5\u955C\u68C0\u67E5\uFF1A</p>\\n<ul><li><strong>{{procedure}}</strong> \u4E8E <strong>{{date}}</strong></li></ul>\\n<p>\u81EA\u90A3\u4EE5\u540E\uFF0C\u60A8\u662F\u5426\u505A\u8FC7\u5176\u4ED6\u5185\u7AA5\u955C\u68C0\u67E5\u3001\u8179\u90E8\u624B\u672F\u6216\u5927\u578B\u624B\u672F\uFF1F</p>","textNoProcedure":"\u60A8\u8FC7\u53BB\u505A\u8FC7\u5185\u7AA5\u955C\u68C0\u67E5\u3001\u8179\u90E8\u624B\u672F\u6216\u5927\u578B\u624B\u672F\u5417\uFF1F","title":"\u6700\u8FD1\u7684\u624B\u672F\u6216\u6CBB\u7597\u7A0B\u5E8F"}');


var $14f41dd9871924dc$exports = {};
$14f41dd9871924dc$exports = JSON.parse('{"helpMessage":"<h3>\u6709\u4FDD\u9669\u76F8\u5173\u7684\u95EE\u9898\u5417\uFF1F</h3>\\n<p>\u6211\u4EEC\u7684\u56E2\u961F\u4E50\u610F\u4E3A\u60A8\u63D0\u4F9B\u5E2E\u52A9 \u2014 \u8BF7\u81F4\u7535\uFF1A<br/><a><strong>\u260E\uFE0F {{phone}}</strong></a>\uFF08\u7136\u540E\u6309 <strong>Option 2</strong>\uFF09<br/>Monday to Friday, 8am\u20135pm.</p>","insuranceCovered":"\u60A8\u7684\u5065\u5EB7\u4FDD\u9669\u4F1A\u62A5\u9500\u90E8\u5206\u6216\u5168\u90E8\u624B\u672F\u8D39\u7528\u5417\uFF1F","insuranceDetails":"<ul>\\n  <li>\u6211\u5C06\u8D1F\u8D23\u4FDD\u9669\u672A\u6DB5\u76D6\u7684\u4EFB\u4F55\u672A\u7ED3\u91D1\u989D\u3002</li>\\n  <li>\u6211\u5C06\u5728\u5165\u9662\u5F53\u5929\u652F\u4ED8\u6240\u9700\u91D1\u989D\u3002</li>\\n  <li>\u5982\u679C\u6211\u672A\u80FD\u652F\u4ED8\u8D26\u5355\uFF0C\u6211\u5C06\u627F\u62C5\u4EFB\u4F55\u50AC\u6536\u8D39\u7528\u3002</li>\\n</ul>","insuranceLabel":"\u6211\u7406\u89E3\u5E76\u63A5\u53D7\u4EE5\u4E0B\u5185\u5BB9\uFF1A","insurerLabel":"\u4F60\u7684\u5065\u5EB7\u4FDD\u9669\u516C\u53F8\u662F\u54EA\u4E00\u5BB6\uFF1F","insurerSelect":{"aia":"AIA","nib":"NIB","southern-cross":"Southern Cross"},"membershipLabel":"\u4F1A\u5458\u7F16\u53F7","noCovered":"\u6211\u5C06\u81EA\u884C\u627F\u62C5\u5168\u90E8\u8D39\u7528\u3002","preApprovalLabel":"\u60A8\u662F\u5426\u5DF2\u83B7\u5F97\u6B64\u624B\u672F\u7684\u4E8B\u5148\u6279\u51C6\uFF1F","preApprovalText":"<h3>{{insurer}} \u9884\u5148\u6279\u51C6</h3>\\n<p>\u6211\u4EEC\u5C06\u4EE3\u8868\u60A8\u8054\u7CFB {{insurer}}\uFF0C\u8BF7\u6C42\u4E3A\u60A8\u7684\u624B\u672F\u83B7\u5F97\u6279\u51C6\u3002</p>\\n<p>\u60A8\u5C06\u6536\u5230\u7ED3\u679C\u901A\u77E5\uFF0C\u5305\u62EC\u60A8\u53EF\u80FD\u9700\u8981\u652F\u4ED8\u91D1\u989D\u7684\u4F30\u7B97\u3002</p>\\n<span>\u8FD9\u53EF\u80FD\u5305\u62EC\uFF1A</span>\\n<ul>\\n<li><strong>\u81EA\u4ED8\u989D\uFF1A</strong>\u7531\u60A8\u7684\u4FDD\u5355\u8BBE\u5B9A\u7684\u91D1\u989D\uFF0C\u548C/\u6216</li>\\n<li><strong>\u5DEE\u989D\uFF1A</strong>\u60A8\u7684\u4FDD\u5355\u62A5\u9500\u989D\u5EA6\u4E0E\u624B\u672F\u8D39\u7528\u4E4B\u95F4\u7684\u5DEE\u989D\u3002</li>\\n</ul>\\n<p>\u4EFB\u4F55\u81EA\u4ED8\u989D\u6216\u5DEE\u989D\u90FD\u9700\u8981\u5728 <strong>\u624B\u672F\u5F53\u5929\u652F\u4ED8</strong>\u3002</p>","title":"\u5065\u5EB7\u4FDD\u9669"}');


var $bb85dba2f0a461fa$exports = {};
$bb85dba2f0a461fa$exports = JSON.parse('{"helpMessage":"<h3>\u6709\u95EE\u9898\u5417\uFF1F</h3>\\n<p>\u6B22\u8FCE\u8054\u7CFB\u6211\u4EEC\u7684\u56E2\u961F - \u8BF7\u62E8\u6253\u7535\u8BDD\uFF1A<br/><a><strong>\u260E\uFE0F {{phone}}</strong></a>\uFF08\u7136\u540E\u6309 <strong>\u9009\u9879 2</strong>\uFF09<br/>\u5468\u4E00\u81F3\u5468\u4E94\uFF0C\u4E0A\u5348 8 \u70B9\u81F3\u4E0B\u5348 5 \u70B9\u3002</p>","title":"\u9080\u8BF7\u65E0\u6548"}');


var $4462b2ccf412f6b7$exports = {};
$4462b2ccf412f6b7$exports = JSON.parse('{"helpMessage":"<h3>\u6709\u7591\u95EE\u5417\uFF1F</h3>\\n<p>\u6211\u4EEC\u4E50\u610F\u4E3A\u60A8\u63D0\u4F9B\u5E2E\u52A9 - \u8BF7\u81F4\u7535\u6211\u4EEC\u7684\u56E2\u961F\uFF1A<br/>\\n<a><strong>\u260E\uFE0F {{phone}}</strong></a>\uFF08\u7136\u540E\u6309 <strong>\u9009\u9879 2</strong>\uFF09<br/>\\n\u5468\u4E00\u81F3\u5468\u4E94\uFF0C\u4E0A\u5348 8 \u70B9\u81F3\u4E0B\u5348 5 \u70B9\u3002</p>","text":"<p>\u6211\u4EEC\u4F1A\u901A\u77E5\u60A8\u7684\u8F6C\u8BCA\u533B\u751F\uFF0C\u4ED6\u4EEC\u53EF\u80FD\u4F1A\u8054\u7CFB\u60A8\u8BA8\u8BBA\u4E0B\u4E00\u6B65\u3002</p>\\n<p>\u76EE\u524D\u60A8\u65E0\u9700\u505A\u4EFB\u4F55\u5176\u4ED6\u4E8B\u60C5\u3002</p>","title":"\u60A8\u5DF2\u9009\u62E9\u6682\u65F6\u4E0D\u9884\u7EA6\u3002"}');


var $26ebd174767c200e$exports = {};
$26ebd174767c200e$exports = JSON.parse("{}");


var $087cb933fc0a12e7$exports = {};
$087cb933fc0a12e7$exports = JSON.parse('{"text":"<p>\u7531\u4E8E\u591A\u6B21\u672A\u80FD\u6210\u529F\u9A8C\u8BC1\u60A8\u7684\u8EAB\u4EFD\uFF0C\u6211\u4EEC\u5DF2\u6682\u65F6\u9501\u5B9A\u6B64\u9080\u8BF7\uFF0C\u4EE5\u4FDD\u62A4\u60A8\u7684\u9690\u79C1\u3002</p>\\n<p>\u8BF7\u4E0D\u7528\u62C5\u5FC3 \u2014 \u6211\u4EEC\u4ECD\u7136\u53EF\u4EE5\u63D0\u4F9B\u5E2E\u52A9\u3002</p>\\n<p>\u8BF7\u81F4\u7535\u6211\u4EEC\u7684\u56E2\u961F\u5B8C\u6210\u9884\u7EA6\uFF1A</p>\\n<p><a><strong>\u260E\uFE0F {{phone}}</strong></a>\uFF08\u7136\u540E\u6309 <strong>\u9009\u98792</strong>\uFF09<br/>\u5468\u4E00\u81F3\u5468\u4E94\uFF0C\u4E0A\u53488\u70B9\u81F3\u4E0B\u53485\u70B9\u3002</p>","title":"\u4E3A\u4FDD\u969C\u60A8\u7684\u5B89\u5168\uFF0C\u9080\u8BF7\u5DF2\u88AB\u9501\u5B9A"}');


var $126ec51cdc79782a$exports = {};
$126ec51cdc79782a$exports = JSON.parse('{"addButtonLabel":"\u6DFB\u52A0\u836F\u7269","dose":"\u5242\u91CF","dosePlaceholder":"e.g. 500mg or 1 tablet","dropHere":"\u8BF7\u62D6\u653E\u5230\u6B64\u5904","dropText":"<p>{{fileExtensions}} \u6216 {{fileExtension}}\uFF0C\u5927\u5C0F\u6700\u591A {{mb}}MB</p>","dropTitle":"<p><strong>\u4E0A\u4F20\u6587\u4EF6</strong>\u6216\u62D6\u653E</p>","frequency":"\u9891\u7387","manuallyText":"<strong>\u624B\u52A8\u6DFB\u52A0\u836F\u7269</strong><p>\u4E00\u6B21\u6DFB\u52A0\u4E00\u79CD\u836F\u7269\u3002\u8BF7\u586B\u5199\u540D\u79F0\u3001\u5242\u91CF\u548C\u670D\u7528\u9891\u7387\u3002</p>","medicationName":"\u836F\u7269\u540D\u79F0","medicationPlaceholder":"<p><strong>\u8BF7\u7528\u82F1\u6587\u586B\u5199\u3002</strong><br/>\u4F8B\u5982\uFF1AMetformin \u2013 500mg morning and night</p>","nextLabel":"$t(common:next): <b>\u75C5\u53F2</b>","saveButton":"\u4FDD\u5B58\u836F\u7269","select":{"as-needed":"\u6839\u636E\u9700\u8981","once-daily":"\u6BCF\u65E5\u4E00\u6B21","three-time-daily":"\u6BCF\u65E5\u4E09\u6B21","twice-daily":"\u6BCF\u65E5\u4E24\u6B21"},"text":"<p>\u8BF7\u544A\u8BC9\u6211\u4EEC\u60A8\u76EE\u524D\u6B63\u5728\u670D\u7528\u7684\u4EFB\u4F55\u836F\u7269\u3001\u5438\u5165\u5668\u3001\u6CE8\u5C04\u5242\u6216\u8865\u5145\u5242\u3002</p>\\n<p>\u60A8\u53EF\u4EE5\u4E0A\u4F20\u4E00\u4EFD\u6E05\u5355\u6216\u624B\u52A8\u6DFB\u52A0\u3002</p>","title":"\u836F\u7269","uploadText":"<strong>\u4E0A\u4F20\u5904\u65B9\u6216\u6E05\u5355</strong>\\n<p>\u5982\u679C\u60A8\u6709\u6765\u81EA\u5168\u79D1\u533B\u751F\u6216\u836F\u623F\u7684\u6E05\u5355\uFF0C\u8BF7\u4E0A\u4F20\u7167\u7247\u6216 PDF \u6587\u4EF6\u3002</p>"}');


var $497eecd2359831d8$exports = {};
$497eecd2359831d8$exports = JSON.parse('{"questions":{"culture":{"detailsPlaceholder":"<p>\u8BF7\u7528\u82F1\u6587\u586B\u5199\u3002\u4F8B\u5982\uFF1A</p>\\n<p>Wh\u0101nau to be present, need interpreter, specific dietary customs</p>","label":"\u60A8\u6709\u4EFB\u4F55\u6587\u5316\u6216\u5BB6\u5EAD\u65B9\u9762\u7684\u9700\u6C42\u5417\uFF1F","nextLabel":"$t(common:next): <b>\u5176\u4ED6\u7279\u6B8A\u9700\u6C42\u6216\u4FE1\u606F</b>","title":"<h3>\u6587\u5316\u6216\u5BB6\u5EAD\u9700\u6C42</h3>"},"language":{"de":"Deutsch / German","detailsLabel":"\u60A8\u504F\u597D\u7684\u8BED\u8A00\u662F\u4EC0\u4E48\uFF1F","fj":"Vosa Vakaviti / Fijian","fr":"Fran\xe7ais / French","ja":"\u65E5\u672C\u8A9E / Japanese","ko":"\uD55C\uAD6D\uC5B4 / Korean","label":"\u60A8\u7406\u89E3\u82F1\u8BED\u6709\u56F0\u96BE\u5417\uFF1F","mi":"Te Reo M\u0101ori","ms":"Malay / Malaysian","nextLabel":"$t(common:next): <b>\u5B97\u6559\u6216\u7CBE\u795E\u9700\u6C42</b>","other":"\u5176\u4ED6","pt":"Portugu\xeas / Portuguese","sm":"Gagana Samoa / Samoan","ta":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD / Tamil","title":"<h3>\u7406\u89E3\u82F1\u8BED</h3>","tl":"Tagalog / Tagalog","to":"Lea Faka-Tonga / Tongan","zh":"\u7B80\u4F53\u4E2D\u6587 / Chinese"},"mobility":{"detailsPlaceholder":"\u8BF7\u7528\u82F1\u6587\u586B\u5199\u3002\u4F8B\u5982\uFF1A<br/>\u4F7F\u7528\u52A9\u884C\u5668\u6216\u8F6E\u6905\uFF1B\u9700\u8981\u5E2E\u52A9\u4E0A\u5E8A","label":"\u60A8\u662F\u5426\u6709\u6B8B\u75BE\uFF0C\u6216\u5728\u884C\u52A8\u65B9\u9762\u9700\u8981\u534F\u52A9\uFF1F","nextLabel":"$t(common:next): <b>\u7406\u89E3\u82F1\u6587</b>","title":"<h3>\u884C\u52A8\u80FD\u529B</h3>"},"other":{"detailsPlaceholder":"\u53EA\u9700\u5206\u4EAB\u60A8\u8BA4\u4E3A\u76F8\u5173\u7684\u4FE1\u606F\u3002\u8FD9\u6837\u6709\u52A9\u4E8E\u6211\u4EEC\u66F4\u597D\u5730\u4E3A\u60A8\u63D0\u4F9B\u652F\u6301\u3002","label":"\u60A8\u662F\u5426\u6709\u5176\u4ED6\u7279\u6B8A\u9700\u6C42\uFF0C\u6216\u6709\u5176\u4ED6\u4FE1\u606F\u5E0C\u671B\u6211\u4EEC\u4E86\u89E3\uFF1F","nextLabel":"$t(common:next): <b>\u9886\u53D6\u60A8\u7684\u80A0\u9053\u51C6\u5907\u836F\u7269</b>","title":"<h3>\u5176\u4ED6\u7279\u6B8A\u9700\u6C42\u6216\u4FE1\u606F</h3>"},"prep":{"label":"\u8BF7\u9009\u62E9\u60A8\u5E0C\u671B\u63A5\u6536\u7684\u65B9\u5F0F\uFF1A","nextLabel":"$t(common:next): <b>\u5B8C\u6210\u9884\u7EA6</b>","pick-up-from-hospital":"<label>{{company}}</label>\\n<p>\u5728\u5F00\u653E\u65F6\u95F4\u5185\u8BF7\u5230\u63A5\u5F85\u5904\u9886\u53D6\u60A8\u7684\u51C6\u5907\u5305\u3002</p>","pick-up-from-local-pharmacy":"<label>\u4ECE\u60A8\u9644\u8FD1\u7684\u836F\u623F\u9886\u53D6</label>\\n<p>\u6211\u4EEC\u4F1A\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u53D1\u9001\u5904\u65B9\uFF0C\u60A8\u53EF\u4EE5\u5E26\u53BB\u836F\u623F\u3002</p>","receive-by-mail":"<label>\u901A\u8FC7\u90AE\u5BC4\u63A5\u6536</label>\\n<p>\u6211\u4EEC\u4F1A\u5C06\u60A8\u7684\u51C6\u5907\u5305\u5FEB\u9012\u5230\u60A8\u63D0\u4F9B\u7684\u4F4F\u5740\u3002</p>","text":"\u4E3A\u51C6\u5907\u60A8\u7684\u624B\u672F\uFF0C\u60A8\u9700\u8981\u670D\u7528\u4E00\u79CD\u53EF\u4EE5\u6E05\u7406\u80A0\u9053\u7684\u7279\u6B8A\u836F\u7269\u3002","title":"<h3>\u83B7\u53D6\u60A8\u7684\u80A0\u9053\u51C6\u5907\u836F</h3><p>\u4E3A\u51C6\u5907\u60A8\u7684\u624B\u672F\uFF0C\u60A8\u9700\u8981\u670D\u7528\u4E00\u79CD\u53EF\u4EE5\u6E05\u7406\u80A0\u9053\u7684\u7279\u6B8A\u836F\u7269\u3002</p>"},"religion":{"detailsPlaceholder":"<p>\u8BF7\u7528\u82F1\u8BED\u586B\u5199\u3002\u4F8B\u5982\uFF1A<br/>Quiet space for prayer, prefer same-gender staff for personal care</p>","label":"\u60A8\u6709\u4EFB\u4F55\u5B97\u6559\u6216\u7CBE\u795E\u65B9\u9762\u7684\u9700\u6C42\u5417\uFF1F","nextLabel":"$t(common:next): <b>\u6587\u5316\u6216\u5BB6\u5EAD\u9700\u6C42</b>","title":"<h3>\u5B97\u6559\u6216\u7CBE\u795E\u9700\u6C42</h3>"}}}');


var $718d474e787604ca$exports = {};
$718d474e787604ca$exports = JSON.parse('{"helpMessage":"<h3>\u9690\u79C1\u76F8\u5173\u95EE\u9898\uFF1F</h3>\\n<p>\u6211\u4EEC\u7684\u56E2\u961F\u4E50\u610F\u534F\u52A9\u60A8 - \u8BF7\u81F4\u7535\uFF1A<br/>\\n<a><strong>\u260E\uFE0F {{phone}}</strong></a>\uFF08\u7136\u540E\u6309 <strong>Option 2</strong>\uFF09<br/>\\n\u661F\u671F\u4E00\u81F3\u661F\u671F\u4E94\uFF0C\u4E0A\u53488\u70B9\u81F3\u4E0B\u53485\u70B9\u3002</p>","privacyDetails":"<ul><li>\u60A8\u4E86\u89E3\u60A8\u7684\u4FE1\u606F\u5C06\u5982\u4F55\u88AB\u4F7F\u7528\u3002</li><li>\u60A8\u6B63\u5728\u4E3A\u81EA\u5DF1\u6216\u4E3A\u60A8\u6709\u6743\u652F\u6301\u7684\u4EBA\u5B8C\u6210\u6B64\u9884\u7EA6\uFF08\u4F8B\u5982\u4F5C\u4E3A\u7167\u62A4\u8005\u6216\u5BB6\u957F\uFF09\u3002</li><li>\u60A8\u540C\u610F\u7EE7\u7EED\u8FDB\u884C\u9884\u7EA6\u6D41\u7A0B\u3002</li></ul>","privacyLabel":"\u6211\u63A5\u53D7\u672C\u9690\u79C1\u58F0\u660E","privacyText":"\u901A\u8FC7\u63A5\u53D7\u672C\u9690\u79C1\u58F0\u660E\uFF0C\u60A8\u786E\u8BA4\u4EE5\u4E0B\u5185\u5BB9\uFF1A","text":"<p>\u6211\u4EEC\u975E\u5E38\u91CD\u89C6\u60A8\u7684\u9690\u79C1\u3002</p>\\n<p>\u60A8\u5728\u6B64\u8FC7\u7A0B\u4E2D\u63D0\u4F9B\u7684\u4FE1\u606F\u5C06\u88AB\u5B89\u5168\u4FDD\u5B58\uFF0C\u5E76\u4EC5\u7528\u4E8E\u652F\u6301\u60A8\u5728 {{company}} \u7684\u6CBB\u7597\u548C\u62A4\u7406\u3002</p>\\n<p>\u60A8\u7684\u4E2A\u4EBA\u548C\u533B\u7597\u4FE1\u606F\u4EC5\u4F1A\u4E0E\u53C2\u4E0E\u60A8\u6CBB\u7597\u7684\u533B\u7597\u4E13\u4E1A\u4EBA\u5458\u5171\u4EAB\u3002</p>\\n<p>\u6211\u4EEC\u4E0D\u4F1A\u5C06\u60A8\u7684\u4FE1\u606F\u7528\u4E8E\u5E02\u573A\u8425\u9500\uFF0C\u4E5F\u4E0D\u4F1A\u4E0E\u7B2C\u4E09\u65B9\u5171\u4EAB\u7528\u4E8E\u6B64\u76EE\u7684\u3002</p>\\n<p>\u60A8\u53EF\u4EE5\u968F\u65F6\u8054\u7CFB\u6211\u4EEC\uFF0C\u7533\u8BF7\u8BBF\u95EE\u6216\u66F4\u6B63\u60A8\u7684\u4FE1\u606F\u3002</p>","title":"\u9690\u79C1\u58F0\u660E"}');


var $ad572935d20ac7e0$exports = {};
$ad572935d20ac7e0$exports = JSON.parse('{"anySpecialist":{"text":"\u8BF7\u663E\u793A\u6240\u6709\u53EF\u9884\u7EA6\u7684\u65F6\u95F4\u8303\u56F4\u3002","title":"\u6211\u90FD\u53EF\u4EE5"},"nextLabel":"$t(common:next): <b>\u8BF7\u9009\u62E9\u65F6\u95F4</b>","profile":"\u4E13\u79D1\u533B\u751F\u7B80\u4ECB","specialists":{"00000000-0000-da7a-0003-000000000004":{"name":"Dr. Lopez"}},"textMultiple":"<p>\u8FD9\u4E9B\u4E13\u79D1\u533B\u751F\u90FD\u662F\u5F88\u597D\u7684\u9009\u62E9\u3002\u8BF7\u9009\u62E9\u5176\u4E2D\u4E00\u4F4D\uFF0C\u6216\u8005\u7EE7\u7EED\u70B9\u51FB\u201C\u6211\u90FD\u53EF\u4EE5\u201D\u3002</p>","textSingle":"<p>\u60A8\u7684\u5168\u79D1\u533B\u751F \u2013 {{referral.gp}} \u2013 \u5DF2\u5C06\u60A8\u8F6C\u8BCA\u81F3\uFF1A</p>","titleMultiple":"\u8BF7\u9009\u62E9\u60A8\u7684\u4E13\u79D1\u533B\u751F","titleSingle":"\u60A8\u7684\u4E13\u79D1\u533B\u751F","viewProfile":"\u67E5\u770B\u5B8C\u6574\u8D44\u6599"}');


var $87283a2d18119a06$exports = {};
$87283a2d18119a06$exports = JSON.parse('{"bookButtonLabel":"\u7ACB\u5373\u9884\u7EA6","bookText":"<h3>\u5728\u7EBF\u9884\u7EA6\uFF1A</h3>\\n<ul>\\n  <li>\u23F1\uFE0F  <strong>\u5FEB\u6377\u65B9\u4FBF -</strong> 15 \u5206\u949F\u4EE5\u5185</li>\\n  <li>\uD83C\uDF19  <strong>\u968F\u65F6\u9884\u7EA6 -</strong> \u4E0B\u73ED\u540E\u4E5F\u53EF\u4EE5</li>\\n  <li>\uD83D\uDDD3\uFE0F  <strong>\u9009\u62E9\u9002\u5408\u60A8\u7684\u65F6\u95F4</strong></li>\\n  <li>\uD83D\uDD10  <strong>\u65E0\u7EB8\u5316 -</strong> \u5B89\u5168\u51C6\u786E</li>\\n</ul>","declineButtonLabel":"\u62D2\u7EDD\u6B64\u9884\u7EA6\u9080\u8BF7","declineText":"<h3>\u60A8\u6CA1\u6709\u9884\u671F\u6216\u4E0D\u60F3\u8FDB\u884C\u8FD9\u4E2A\u68C0\u67E5\uFF1F</h3>\\n<p>\u8BF7\u9009\u62E9\u4E00\u4E2A\u539F\u56E0\u544A\u8BC9\u6211\u4EEC\uFF1A</p>","helpMessage":"<h3>\u60F3\u4E0E\u6211\u4EEC\u901A\u8BDD\u5417\uFF1F</h3>\\n<p>\u6211\u4EEC\u7684\u53CB\u5584\u56E2\u961F\u4E50\u610F\u4E3A\u60A8\u63D0\u4F9B\u5E2E\u52A9\uFF1A<br/><a><strong>\u260E\uFE0F {{phone}}</strong></a>\uFF08\u7136\u540E\u6309 <strong>\u9009\u9879 2</strong>\uFF09<br/>\u5468\u4E00\u81F3\u5468\u4E94\uFF0C\u4E0A\u5348 8 \u70B9\u81F3\u4E0B\u5348 5 \u70B9\u3002</p>\\n<p><em>\u6211\u4EEC\u7684\u56E2\u961F\u53EF\u80FD\u53EA\u80FD\u8BF4\u82F1\u8BED \u2014 \u611F\u8C22\u60A8\u7684\u7406\u89E3\u3002</em></p>","info":"<h3>\u60F3\u4E86\u89E3\u66F4\u591A\u5173\u4E8E\u8FD9\u4E2A\u68C0\u67E5\u5417\uFF1F</h3>\\n<p>\u89C2\u770B\u4E00\u4E2A\u7B80\u77ED\u7684\u89C6\u9891\uFF0C\u4E86\u89E3\u68C0\u67E5\u6D41\u7A0B\u4EE5\u53CA\u5982\u4F55\u505A\u597D\u51C6\u5907\u3002</p>","select":{"badTiming":"\u65F6\u95F4\u4E0D\u65B9\u4FBF","cantAfford":"\u73B0\u5728\u8D1F\u62C5\u4E0D\u8D77","didntKnowReferred":"\u6211\u4E0D\u77E5\u9053\u6709\u4EBA\u4E3A\u6211\u8F6C\u8BCA\u4E86","hadElsewhere":"\u6211\u5DF2\u7ECF\u5728\u522B\u5904\u505A\u8FC7\u4E86","notNecessary":"\u6211\u8BA4\u4E3A\u6CA1\u6709\u5FC5\u8981","placeholder":"\u8BF7\u9009\u62E9\u539F\u56E0"},"text":"<p>\u60A8\u7684\u5168\u79D1\u533B\u751F <strong>{{requestingPractitioner.displayName}}</strong> \u5DF2\u5C06\u60A8\u8F6C\u8BCA\u7ED9 <strong>{{practitioners.0.name}}</strong> \u8FDB\u884C <strong>{{procedure.displayName}}</strong>\u3002</p>","textNoSpecialist":"<p>\u60A8\u7684\u5168\u79D1\u533B\u751F <strong>{{requestingPractitioner.displayName}}</strong> \u5DF2\u5C06\u60A8\u8F6C\u8BCA\u8FDB\u884C <strong>{{procedure.displayName}}</strong>\u3002</p>","title":"\u60A8\u597D\uFF0C{{patient.nameGiven}}\u3002<br /> \u73B0\u5728\u662F\u9884\u7EA6\u60A8\u7684\u68C0\u67E5\u7684\u65F6\u5019\u4E86\u3002","videoButtonLabel":"\u64AD\u653E\u5173\u4E8E\u8FDB\u884C\u5185\u7AA5\u955C\u68C0\u67E5\u7684\u89C6\u9891","videoCaption":"\u6211\u4EEC\u5EFA\u8BAE\u60A8\u5728\u9884\u7EA6\u524D\u89C2\u770B\u6B64\u89C6\u9891\u3002","videos":{"GAS":"Jdaob00qXgETZuakhvxfdR3kb1lcpJIIm84mMoo9o7Rw","fallback":"Jdaob00qXgETZuakhvxfdR3kb1lcpJIIm84mMoo9o7Rw"}}');


var $9b5e9a960919dc9f$exports = {};
$9b5e9a960919dc9f$exports = JSON.parse('{"birthDate":"\u60A8\u7684\u51FA\u751F\u65E5\u671F","dateFormat":"dd/mm/yyyy","familyName":"\u60A8\u7684\u59D3\u6C0F","helpMessage":"<p>\u5982\u679C\u4E0A\u65B9\u7684\u53F7\u7801\u4E0D\u6B63\u786E\uFF0C\u6216\u8005\u60A8\u4E0D\u786E\u5B9A\u8BE5\u600E\u4E48\u505A\uFF0C\u8BF7\u81F4\u7535 <a><strong>{{phone}}</strong></a>\uFF08\u7136\u540E\u6309 <strong>\u9009\u9879 2</strong>\uFF09\u3002</p>","sendCode":"\u53D1\u9001\u9A8C\u8BC1\u7801","text":"<p>\u6B64\u9884\u7EA6\u9080\u8BF7\u662F\u4E3A\u7531\u624B\u673A\u53F7\u7801 <strong><PhonePlaceholder /></strong> \u6240\u7167\u62A4\u7684\u60A3\u8005\u800C\u53D1\u51FA\u7684\u3002</p>\\n<p>\u5982\u679C\u662F\u60A8\u672C\u4EBA\uFF0C\u8BF7\u5728\u4E0B\u65B9\u8F93\u5165<strong>\u60A3\u8005\u7684\u59D3\u6C0F</strong>\u548C<strong>\u51FA\u751F\u65E5\u671F</strong>\uFF0C\u7136\u540E\u70B9\u51FB\u6309\u94AE\u3002</p>\\n<p>\u4E3A\u4FDD\u969C\u5B89\u5168\uFF0C\u6211\u4EEC\u5C06\u5411\u60A8\u53D1\u9001\u4E00\u6B21\u6027<strong>4\u4F4D\u6570\u9A8C\u8BC1\u7801</strong>\u4EE5\u9A8C\u8BC1\u8EAB\u4EFD\u3002</p>","title":"\u6B22\u8FCE\u4F7F\u7528 <strong>{{company}} \u5728\u7EBF\u9884\u7EA6</strong>"}');


const $3f3b0a137420e5ad$var$RESOURCES = {
    en: {
        common: (0, (/*@__PURE__*/$parcel$interopDefault($86640f75f3d9fb26$exports))),
        'page.appointment-reserved': (0, (/*@__PURE__*/$parcel$interopDefault($d9d450b61d746e4a$exports))),
        'page.appointment': (0, (/*@__PURE__*/$parcel$interopDefault($f5c044f334eda78b$exports))),
        'page.code': (0, (/*@__PURE__*/$parcel$interopDefault($686c8670052246d4$exports))),
        'page.confirmation': (0, (/*@__PURE__*/$parcel$interopDefault($e3b0a5cbad0c2c7d$exports))),
        'page.details': (0, (/*@__PURE__*/$parcel$interopDefault($5e10f6a57744f5ec$exports))),
        'page.enter-invite': (0, (/*@__PURE__*/$parcel$interopDefault($4cf04496feffde13$exports))),
        'page.health-questions': (0, (/*@__PURE__*/$parcel$interopDefault($c964eb77bd305b20$exports))),
        'page.history': (0, (/*@__PURE__*/$parcel$interopDefault($1036cbb44ce7ed32$exports))),
        'page.insurance': (0, (/*@__PURE__*/$parcel$interopDefault($4150c1f9d124e03f$exports))),
        'page.invalid-invite': (0, (/*@__PURE__*/$parcel$interopDefault($022f3fcb73f31e63$exports))),
        'page.invite-declined': (0, (/*@__PURE__*/$parcel$interopDefault($99f972315e244b64$exports))),
        'page.invite-expired': (0, (/*@__PURE__*/$parcel$interopDefault($4530f233fe32a0bf$exports))),
        'page.invite-locked': (0, (/*@__PURE__*/$parcel$interopDefault($47441ea0a82725e4$exports))),
        'page.medications': (0, (/*@__PURE__*/$parcel$interopDefault($ad005130958e9b65$exports))),
        'page.preference-questions': (0, (/*@__PURE__*/$parcel$interopDefault($dcb4da0e150ee6d5$exports))),
        'page.privacy': (0, (/*@__PURE__*/$parcel$interopDefault($00eb2d1963ced994$exports))),
        'page.specialist': (0, (/*@__PURE__*/$parcel$interopDefault($13de4d4fb487ae96$exports))),
        'page.start': (0, (/*@__PURE__*/$parcel$interopDefault($b59049dc6dd4b26f$exports))),
        'page.welcome': (0, (/*@__PURE__*/$parcel$interopDefault($76e4baf9d41bc5fb$exports)))
    },
    hi: {
        common: (0, (/*@__PURE__*/$parcel$interopDefault($6db58658cfb9a210$exports))),
        'page.appointment-reserved': (0, (/*@__PURE__*/$parcel$interopDefault($8d0b70eeb74fc1f1$exports))),
        'page.appointment': (0, (/*@__PURE__*/$parcel$interopDefault($6a6f26e972b148f8$exports))),
        'page.code': (0, (/*@__PURE__*/$parcel$interopDefault($857b6de68c05f329$exports))),
        'page.confirmation': (0, (/*@__PURE__*/$parcel$interopDefault($e606d7b1a241cca2$exports))),
        'page.details': (0, (/*@__PURE__*/$parcel$interopDefault($a28f53f5052b201d$exports))),
        'page.enter-invite': (0, (/*@__PURE__*/$parcel$interopDefault($de3a341757f0f952$exports))),
        'page.health-questions': (0, (/*@__PURE__*/$parcel$interopDefault($3c0dbca4e0e20d64$exports))),
        'page.history': (0, (/*@__PURE__*/$parcel$interopDefault($c4d419a84e54d9a6$exports))),
        'page.insurance': (0, (/*@__PURE__*/$parcel$interopDefault($0e1599b698ee7876$exports))),
        'page.invalid-invite': (0, (/*@__PURE__*/$parcel$interopDefault($f48b9a33919ca111$exports))),
        'page.invite-declined': (0, (/*@__PURE__*/$parcel$interopDefault($33a955ce8e880431$exports))),
        'page.invite-expired': (0, (/*@__PURE__*/$parcel$interopDefault($12644a44eb1cc8a8$exports))),
        'page.invite-locked': (0, (/*@__PURE__*/$parcel$interopDefault($4fa3bbc985722780$exports))),
        'page.medications': (0, (/*@__PURE__*/$parcel$interopDefault($e9eef1367c57f692$exports))),
        'page.preference-questions': (0, (/*@__PURE__*/$parcel$interopDefault($ab58912a75177bbf$exports))),
        'page.privacy': (0, (/*@__PURE__*/$parcel$interopDefault($0e588dddcbe092c6$exports))),
        'page.specialist': (0, (/*@__PURE__*/$parcel$interopDefault($dff37a1fe147f0fc$exports))),
        'page.start': (0, (/*@__PURE__*/$parcel$interopDefault($2e45f9a59b7b5db0$exports))),
        'page.welcome': (0, (/*@__PURE__*/$parcel$interopDefault($3440822999052813$exports)))
    },
    mi: {
        common: (0, (/*@__PURE__*/$parcel$interopDefault($9789a2c276072f1b$exports))),
        'page.appointment-reserved': (0, (/*@__PURE__*/$parcel$interopDefault($249af127d2a7c2c3$exports))),
        'page.appointment': (0, (/*@__PURE__*/$parcel$interopDefault($5b956ec06e36ff7c$exports))),
        'page.code': (0, (/*@__PURE__*/$parcel$interopDefault($fa2fb4653712066a$exports))),
        'page.confirmation': (0, (/*@__PURE__*/$parcel$interopDefault($2bd4b42ea9100de9$exports))),
        'page.details': (0, (/*@__PURE__*/$parcel$interopDefault($eac795d313488c6b$exports))),
        'page.enter-invite': (0, (/*@__PURE__*/$parcel$interopDefault($894506542b790025$exports))),
        'page.health-questions': (0, (/*@__PURE__*/$parcel$interopDefault($451ef91abc415f13$exports))),
        'page.history': (0, (/*@__PURE__*/$parcel$interopDefault($73e624d0219bf80c$exports))),
        'page.insurance': (0, (/*@__PURE__*/$parcel$interopDefault($d8e115ccbe3be14e$exports))),
        'page.invalid-invite': (0, (/*@__PURE__*/$parcel$interopDefault($08748cdac26b4620$exports))),
        'page.invite-declined': (0, (/*@__PURE__*/$parcel$interopDefault($1b945b465d0edd97$exports))),
        'page.invite-expired': (0, (/*@__PURE__*/$parcel$interopDefault($4519763f8af53694$exports))),
        'page.invite-locked': (0, (/*@__PURE__*/$parcel$interopDefault($e829edacd2b8969a$exports))),
        'page.medications': (0, (/*@__PURE__*/$parcel$interopDefault($05d4fb96c10dbdcf$exports))),
        'page.preference-questions': (0, (/*@__PURE__*/$parcel$interopDefault($34118c49d4d73f2c$exports))),
        'page.privacy': (0, (/*@__PURE__*/$parcel$interopDefault($7b667792adce0a22$exports))),
        'page.specialist': (0, (/*@__PURE__*/$parcel$interopDefault($87c3b78d16dd5ef1$exports))),
        'page.start': (0, (/*@__PURE__*/$parcel$interopDefault($a90fd157c6b70050$exports))),
        'page.welcome': (0, (/*@__PURE__*/$parcel$interopDefault($cf9bf9611bbb7ad6$exports)))
    },
    sm: {
        common: (0, (/*@__PURE__*/$parcel$interopDefault($c1803275c25cc4b7$exports))),
        'page.appointment-reserved': (0, (/*@__PURE__*/$parcel$interopDefault($cb210e47b8af2f4b$exports))),
        'page.appointment': (0, (/*@__PURE__*/$parcel$interopDefault($ce828f481d7bd218$exports))),
        'page.code': (0, (/*@__PURE__*/$parcel$interopDefault($8da88c737f05f265$exports))),
        'page.confirmation': (0, (/*@__PURE__*/$parcel$interopDefault($0065dbf1a4d981da$exports))),
        'page.details': (0, (/*@__PURE__*/$parcel$interopDefault($e935b947cff44e22$exports))),
        'page.enter-invite': (0, (/*@__PURE__*/$parcel$interopDefault($e839f14ce2c5524c$exports))),
        'page.health-questions': (0, (/*@__PURE__*/$parcel$interopDefault($64ef7dd46437c20d$exports))),
        'page.history': (0, (/*@__PURE__*/$parcel$interopDefault($04d1c8793a24f020$exports))),
        'page.insurance': (0, (/*@__PURE__*/$parcel$interopDefault($98a578c792aeb86a$exports))),
        'page.invalid-invite': (0, (/*@__PURE__*/$parcel$interopDefault($d9876eacc5fc3fe3$exports))),
        'page.invite-declined': (0, (/*@__PURE__*/$parcel$interopDefault($cb32bf2d2aca5cfb$exports))),
        'page.invite-expired': (0, (/*@__PURE__*/$parcel$interopDefault($bd682ace64f297d2$exports))),
        'page.invite-locked': (0, (/*@__PURE__*/$parcel$interopDefault($7f95dd9e20584a8a$exports))),
        'page.medications': (0, (/*@__PURE__*/$parcel$interopDefault($91d5550fbd97d20b$exports))),
        'page.preference-questions': (0, (/*@__PURE__*/$parcel$interopDefault($ebe9c08868fd57cd$exports))),
        'page.privacy': (0, (/*@__PURE__*/$parcel$interopDefault($3747076cf2b1537f$exports))),
        'page.specialist': (0, (/*@__PURE__*/$parcel$interopDefault($75ee460adab6dae9$exports))),
        'page.start': (0, (/*@__PURE__*/$parcel$interopDefault($be64b94c13d8ffb5$exports))),
        'page.welcome': (0, (/*@__PURE__*/$parcel$interopDefault($bcb0f9f5a11fa946$exports)))
    },
    zh: {
        common: (0, (/*@__PURE__*/$parcel$interopDefault($cce25a550bf5cc00$exports))),
        'page.appointment-reserved': (0, (/*@__PURE__*/$parcel$interopDefault($18ec1e6a38feaee6$exports))),
        'page.appointment': (0, (/*@__PURE__*/$parcel$interopDefault($13a667778cfe1e6d$exports))),
        'page.code': (0, (/*@__PURE__*/$parcel$interopDefault($a8693a0d4cf7f3e4$exports))),
        'page.confirmation': (0, (/*@__PURE__*/$parcel$interopDefault($e1737540f673ad02$exports))),
        'page.details': (0, (/*@__PURE__*/$parcel$interopDefault($3ce7bbba87a01ffc$exports))),
        'page.enter-invite': (0, (/*@__PURE__*/$parcel$interopDefault($e3fd611d3398564b$exports))),
        'page.health-questions': (0, (/*@__PURE__*/$parcel$interopDefault($2cc160906c51db5d$exports))),
        'page.history': (0, (/*@__PURE__*/$parcel$interopDefault($681d5cbfa2549556$exports))),
        'page.insurance': (0, (/*@__PURE__*/$parcel$interopDefault($14f41dd9871924dc$exports))),
        'page.invalid-invite': (0, (/*@__PURE__*/$parcel$interopDefault($bb85dba2f0a461fa$exports))),
        'page.invite-declined': (0, (/*@__PURE__*/$parcel$interopDefault($4462b2ccf412f6b7$exports))),
        'page.invite-expired': (0, (/*@__PURE__*/$parcel$interopDefault($26ebd174767c200e$exports))),
        'page.invite-locked': (0, (/*@__PURE__*/$parcel$interopDefault($087cb933fc0a12e7$exports))),
        'page.medications': (0, (/*@__PURE__*/$parcel$interopDefault($126ec51cdc79782a$exports))),
        'page.preference-questions': (0, (/*@__PURE__*/$parcel$interopDefault($497eecd2359831d8$exports))),
        'page.privacy': (0, (/*@__PURE__*/$parcel$interopDefault($718d474e787604ca$exports))),
        'page.specialist': (0, (/*@__PURE__*/$parcel$interopDefault($ad572935d20ac7e0$exports))),
        'page.start': (0, (/*@__PURE__*/$parcel$interopDefault($87283a2d18119a06$exports))),
        'page.welcome': (0, (/*@__PURE__*/$parcel$interopDefault($9b5e9a960919dc9f$exports)))
    }
};
var $3f3b0a137420e5ad$export$2e2bcd8739ae039 = $3f3b0a137420e5ad$var$RESOURCES;


// eslint-disable-next-line react-hooks/rules-of-hooks
(0, $673ff3dfc4a496de$export$1f96ae73734a86cc)((0, $60196a4650e96cb1$export$2e2bcd8739ae039)).use((0, $26bfda595e5aa141$export$ae7e14d40d89f296)).init({
    fallbackLng: 'en',
    supportedLngs: [
        'en',
        'mi',
        'sm',
        'hi',
        'zh'
    ],
    resources: $3f3b0a137420e5ad$export$2e2bcd8739ae039,
    ns: [
        'common'
    ],
    defaultNS: 'common',
    returnEmptyString: true
});


// eslint-disable-next-line import/no-unresolved












const $57e65ef82483d664$var$resolver = (0, $0591fe66d7f046a7$export$66b7b5879c70f722)($09193e81812ba154$export$be5493f9613cbbe({
    bookingReference: $09193e81812ba154$export$fc37fe19dfda43ee((x)=>x?.replaceAll(/\s+/g, '').toLowerCase() ?? '', $09193e81812ba154$export$22b082955e083ec3().min(1).regex(/^[a-z0-9]{6}$/))
}));
function $57e65ef82483d664$export$bb799570cb877084() {
    const invite = (0, $9dfc7fe3975de14a$export$9074eb99b058a8d5)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.enter-invite');
    const form = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        defaultValues: {
            bookingReference: invite?.reference
        },
        resolver: $57e65ef82483d664$var$resolver,
        mode: 'onChange'
    });
    const onSubmit = ({ bookingReference: bookingReference })=>{
        window.location = `/${bookingReference}`;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $05fc0a4d0e875da9$export$c349430af49f3c78), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: "title font-medium mb-5",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                            i18nKey: "title",
                            ns: "page.welcome",
                            components: {
                                strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    className: "block"
                                })
                            },
                            values: (0, $22c4bfea680558f2$export$2e2bcd8739ae039)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "title font-medium",
                        children: t('title')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        i18nKey: "text",
                        ns: "page.enter-invite",
                        components: {
                            p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {})
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
                ...form,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    onSubmit: form.handleSubmit(onSubmit),
                    className: "pt-2.5 space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                            name: "bookingReference",
                            label: t('code'),
                            className: "uppercase",
                            autoFocus: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c17aead7dd77426$export$8b7b7cdfb85d78c5), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a5daec5db3bdecd$export$2c396862c514d9b4), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    i18nKey: "helpMessage",
                    ns: "page.enter-invite",
                    values: {
                        phone: (0, $22c4bfea680558f2$export$2e2bcd8739ae039).phone
                    },
                    components: {
                        p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
                        br: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "font-semibold"
                        }),
                        a: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: `tel:${(0, $8b1710acf92137fb$export$96e99d0e61df2702)((0, $22c4bfea680558f2$export$2e2bcd8739ae039).phone)}`
                        })
                    }
                })
            })
        ]
    });
}


// eslint-disable-next-line import/no-unresolved






function $89fc7d6450c3ed8e$export$2150ef7ed21e6f1c() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.invalid-invite');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $05fc0a4d0e875da9$export$c349430af49f3c78), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "title text-error-500",
                children: t('title')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a5daec5db3bdecd$export$2c396862c514d9b4), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    i18nKey: "helpMessage",
                    ns: "page.invalid-invite",
                    values: {
                        phone: (0, $22c4bfea680558f2$export$2e2bcd8739ae039).phone
                    },
                    components: {
                        h3: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "subtitle mb-0"
                        }),
                        p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
                        br: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "font-semibold"
                        }),
                        a: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: `tel:${(0, $8b1710acf92137fb$export$96e99d0e61df2702)((0, $22c4bfea680558f2$export$2e2bcd8739ae039).phone)}`
                        })
                    }
                })
            })
        ]
    });
}


// eslint-disable-next-line import/no-unresolved




parcelRequire("acw62");
const $432bca5a7ac94b88$var$SvgCalendarIcon = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M6 2a1 1 0 0 0-1 1v1H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1V3a1 1 0 1 0-2 0v1H7V3a1 1 0 0 0-1-1m0 5a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2z",
            clipRule: "evenodd"
        })
    });
var $432bca5a7ac94b88$export$2e2bcd8739ae039 = $432bca5a7ac94b88$var$SvgCalendarIcon;








function $a709e4c9308808b8$export$631d00cd58a8f6db() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.confirmation');
    const invite = (0, $e89436abf76c6f63$export$a7ae4cbf178a6bca)();
    const { icsFile: icsFile } = invite;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $05fc0a4d0e875da9$export$c349430af49f3c78), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "title",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    i18nKey: "title",
                    t: t,
                    values: invite,
                    components: {
                        br: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {})
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                i18nKey: "text",
                t: t,
                values: invite,
                components: {
                    p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mb-2.5"
                    }),
                    strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "font-semibold"
                    }),
                    Status: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "font-semibold text-success-600"
                    })
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f563c890ed38cb6$export$353f5b6fc5456de1), {
                to: icsFile,
                type: "button",
                variant: "outlined",
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('flex items-center justify-center gap-3', icsFile || 'hidden'),
                download: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $432bca5a7ac94b88$export$2e2bcd8739ae039), {
                    className: "size-5 text-gray-500"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a5daec5db3bdecd$export$2c396862c514d9b4), {
                className: "!pt-2.5",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    i18nKey: "confirmationText",
                    t: t,
                    components: {
                        ul: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {}),
                        li: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            className: "mt-0.5"
                        }),
                        h3: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "subtitle mb-0"
                        }),
                        strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "font-semibold"
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a5daec5db3bdecd$export$2c396862c514d9b4), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    i18nKey: "helpMessage",
                    t: t,
                    values: {
                        phone: (0, $22c4bfea680558f2$export$2e2bcd8739ae039).phone
                    },
                    components: {
                        h3: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "subtitle mb-0"
                        }),
                        p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
                        br: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "font-semibold"
                        }),
                        a: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: `tel:${(0, $8b1710acf92137fb$export$96e99d0e61df2702)((0, $22c4bfea680558f2$export$2e2bcd8739ae039).phone)}`
                        })
                    }
                })
            })
        ]
    });
}


// eslint-disable-next-line import/no-unresolved






function $1df1d5eabf3783ca$export$a725250edc90f8c2() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.invite-declined');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $05fc0a4d0e875da9$export$c349430af49f3c78), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "title",
                children: t('title')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                i18nKey: "text",
                ns: "page.invite-declined",
                components: {
                    p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {})
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a5daec5db3bdecd$export$2c396862c514d9b4), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    i18nKey: "helpMessage",
                    ns: "page.invite-declined",
                    values: {
                        phone: (0, $22c4bfea680558f2$export$2e2bcd8739ae039).phone
                    },
                    components: {
                        h3: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "subtitle mb-0"
                        }),
                        p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
                        br: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "font-semibold"
                        }),
                        a: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: `tel:${(0, $8b1710acf92137fb$export$96e99d0e61df2702)((0, $22c4bfea680558f2$export$2e2bcd8739ae039).phone)}`
                        })
                    }
                })
            })
        ]
    });
}


// eslint-disable-next-line import/no-unresolved







function $6ab68bde9cbdf8fd$export$8967795e3d51fba7() {
    const { inviteId: inviteId } = (0, $618a07bedf38a2ba$export$99eaa27ddbbb95ef)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.invite-expired');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $05fc0a4d0e875da9$export$c349430af49f3c78), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "title text-error-500",
                children: t('title')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a5daec5db3bdecd$export$2c396862c514d9b4), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    i18nKey: "text",
                    t: t,
                    values: {
                        ...(0, $22c4bfea680558f2$export$2e2bcd8739ae039),
                        inviteId: inviteId
                    },
                    components: {
                        h3: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "subtitle mb-0"
                        }),
                        p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
                        br: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        em: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "uppercase"
                        }),
                        strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "font-semibold"
                        }),
                        a: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: `tel:${(0, $8b1710acf92137fb$export$96e99d0e61df2702)((0, $22c4bfea680558f2$export$2e2bcd8739ae039).phone)}`
                        })
                    }
                })
            })
        ]
    });
}


// eslint-disable-next-line import/no-unresolved





function $4e502e09c43ad4b6$export$bf20e430f62d8c48() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.invite-locked');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $05fc0a4d0e875da9$export$c349430af49f3c78), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "title text-error-500",
                children: t('title')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                i18nKey: "text",
                ns: "page.invite-locked",
                values: {
                    phone: (0, $22c4bfea680558f2$export$2e2bcd8739ae039).phone
                },
                components: {
                    p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
                    br: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "font-semibold"
                    }),
                    a: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: `tel:${(0, $8b1710acf92137fb$export$96e99d0e61df2702)((0, $22c4bfea680558f2$export$2e2bcd8739ae039).phone)}`
                    })
                }
            })
        ]
    });
}


/*eslint import/no-unresolved: [2, { ignore: ['^jsx:.+\\.svg$'] }]*/ 

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $0413b065fc297747$export$2e2bcd8739ae039(fn, ms) {
    if (ms === void 0) ms = 0;
    var ready = (0, $acw62.useRef)(false);
    var timeout = (0, $acw62.useRef)();
    var callback = (0, $acw62.useRef)(fn);
    var isReady = (0, $acw62.useCallback)(function() {
        return ready.current;
    }, []);
    var set = (0, $acw62.useCallback)(function() {
        ready.current = false;
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(function() {
            ready.current = true;
            callback.current();
        }, ms);
    }, [
        ms
    ]);
    var clear = (0, $acw62.useCallback)(function() {
        ready.current = null;
        timeout.current && clearTimeout(timeout.current);
    }, []);
    // update ref when function changes
    (0, $acw62.useEffect)(function() {
        callback.current = fn;
    }, [
        fn
    ]);
    // set on mount, clear on unmount
    (0, $acw62.useEffect)(function() {
        set();
        return clear;
    }, [
        ms
    ]);
    return [
        isReady,
        clear,
        set
    ];
}


function $1eed403137e89aa1$export$669f6ea7d267feaf({ after: after = 0 }) {
    const [hide, setHide] = (0, $acw62.useState)(after > 10);
    (0, $0413b065fc297747$export$2e2bcd8739ae039)(()=>setHide(false), after);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "text-white/50 data-[hide=true]:hidden",
        "data-hide": hide,
        children: "..."
    });
}
//<LoadingSpinner />
$1eed403137e89aa1$export$669f6ea7d267feaf.propTypes = {
};


// eslint-disable-next-line import/no-unresolved




parcelRequire("acw62");
const $539d7db82b1be756$var$SvgClockIcon = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 18",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M10 17a8 8 0 1 0 0-16 8 8 0 0 0 0 16m1-12a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l2.828 2.829a1 1 0 1 0 1.415-1.415L11 8.586z",
            clipRule: "evenodd"
        })
    });
var $539d7db82b1be756$export$2e2bcd8739ae039 = $539d7db82b1be756$var$SvgClockIcon;



var $acw62 = parcelRequire("acw62");







var $fcd8f60277f7fcfe$exports = {};
!function(e, t) {
    $fcd8f60277f7fcfe$exports = t();
}($fcd8f60277f7fcfe$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});






const $9829299c7e045421$var$GRACE_MARGIN = 10000;
const $9829299c7e045421$export$c9b45bbf1014e3f1 = (0, $bd07366b96e7d92e$export$185802fd694ee1f5)((0, $db1029f36b931e86$export$6922d3b3a607469e)((0, $db1029f36b931e86$export$9a6132153fba2e0)((set)=>({
        previousName: '',
        previousDob: '',
        expiresAt: 0,
        resetExpiresAt: (expires, name, dob)=>set((current)=>{
                const expiresAt = (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(expires).valueOf();
                return {
                    previousName: name ?? current.previousName,
                    previousDob: dob ?? current.previousDob,
                    expiresAt: expiresAt - $9829299c7e045421$var$GRACE_MARGIN,
                    validityMinutes: Math.round((expiresAt - Date.now()) / 60000)
                };
            }, false, 'EXPIRE/SET')
    }), {
    name: 'otp-timer-storage',
    partialize: (state)=>({
            previousName: state.previousName,
            previousDob: state.previousDob,
            expiresAt: state.expiresAt
        })
}), {
    name: 'CodeStore'
}));





(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($fcd8f60277f7fcfe$exports))));
function $58e11ab646c0edf1$export$a851da9adada3059() {
    const { setInvite: setInvite, invite: invite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    const { previousName: previousName, previousDob: previousDob, resetExpiresAt: resetExpiresAt } = (0, $9829299c7e045421$export$c9b45bbf1014e3f1)();
    return (0, $36464e4be8053fb8$export$fbeb804c371ac8d)(async (maybeFamilyName, maybeDob)=>{
        const bookingReference = invite?.reference;
        const familyName = maybeFamilyName ?? previousName;
        const dateOfBirth = maybeDob ? maybeDob : previousDob;
        try {
            const response = await (0, $56ff6b9a4ee43a2e$export$644d8ea042df96a6).public.post('onlinebooking/request-otp', {
                json: {
                    onlineBookingReference: bookingReference,
                    familyName: familyName,
                    dateOfBirth: dateOfBirth
                }
            }).json();
            resetExpiresAt(response.expiryDateTime, familyName, dateOfBirth);
            return true;
        } catch (error) {
            switch(error.response?.status){
                case 400:
                    throw (0, $ad23f5e3326fb0ee$export$547fac850f50d49b)(error, 'errors.invalidOtp.title', 'errors.invalidOtp.details');
                case 409:
                    // Not throwing to avoid error message flash
                    setInvite({
                        status: 'locked'
                    });
                    break;
            }
            throw (0, $ad23f5e3326fb0ee$export$547fac850f50d49b)(error, 'errors.serverErrorOtp.title', 'errors.serverErrorOtp.details');
        }
    });
}










async function $bd4b7fb786bdd21c$export$bd04e8a3d68d2(inviteReference, setInvite) {
    try {
        const data = await (0, $56ff6b9a4ee43a2e$export$644d8ea042df96a6).auth.get(`onlinebooking/${inviteReference}`).json();
        const transformed = (0, $ad23f5e3326fb0ee$export$6e3cb9320fb61c26)(data);
        setInvite(transformed);
        return transformed;
    } catch (error) {
        if (error.response?.status >= 400 && error.response?.status < 500) setInvite({
            status: (0, $9dfc7fe3975de14a$export$8dffa4efb9fbc37b).INVALID
        });
        else throw error;
    }
}
function $bd4b7fb786bdd21c$export$7400951eb3895708(inviteReference) {
    const { setInvite: setInvite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    return (0, $36464e4be8053fb8$export$cdf1dc76b55502e3)($bd4b7fb786bdd21c$export$bd04e8a3d68d2, [
        inviteReference,
        setInvite
    ]);
}



function $69587e21279c402a$export$7c0ab1d2421cd411() {
    const { invite: invite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    const { setJwt: setJwt } = (0, $faff77658948d155$export$650ce9f0b4df82fd)();
    const { setInvite: setInvite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    return (0, $36464e4be8053fb8$export$fbeb804c371ac8d)(async (code)=>{
        try {
            const jwt = await (0, $56ff6b9a4ee43a2e$export$644d8ea042df96a6).public.post('onlinebooking/verify-otp', {
                json: {
                    onlineBookingReference: invite.reference,
                    otp: code
                }
            }).json();
            setJwt(jwt);
            return await (0, $bd4b7fb786bdd21c$export$bd04e8a3d68d2)(invite.reference, setInvite);
        } catch (error) {
            switch(error.response?.status){
                case 400:
                    throw (0, $ad23f5e3326fb0ee$export$547fac850f50d49b)(error, 'errors.invalidOtp.title', 'errors.invalidOtp.details');
            }
            throw (0, $ad23f5e3326fb0ee$export$547fac850f50d49b)(error, 'errors.serverErrorOtp.title', 'errors.serverErrorOtp.details');
        }
    });
}











function $20698d5b6ab216c3$export$3203edd9e5edd663(seconds) {
    const m = Math.floor(seconds / 60);
    const s = String(seconds % 60).padStart(2, '0');
    return `${m}:${s}`;
}


const $b73d6eddc992c116$var$resolver = (0, $0591fe66d7f046a7$export$66b7b5879c70f722)($09193e81812ba154$export$be5493f9613cbbe({
    code: $09193e81812ba154$export$22b082955e083ec3().regex(/^\d{4}$/)
}));
function $b73d6eddc992c116$var$useCodeExpiry() {
    const { expiresAt: expiresAt } = (0, $9829299c7e045421$export$c9b45bbf1014e3f1)();
    const remaining = (0, $7b6704a6d7dd640a$export$f4b266cd2aae9cb1)(()=>Math.max(Math.floor((expiresAt - Date.now()) / 1000), 0), 1000);
    return {
        remaining: remaining,
        state: remaining <= 0 ? 'expired' : remaining <= 10 ? 'expiring' : 'valid'
    };
}
let $b73d6eddc992c116$var$defaultValues = {
    code: ''
};
if (!(0, $2bd9d04ce55ef2a0$export$9b5f2e1c20ef6571)) $b73d6eddc992c116$var$defaultValues.code = localStorage.getItem('soopa-invite-code-otp') ?? '';
function $b73d6eddc992c116$export$52f0f02147b12c03() {
    const { state: state } = $b73d6eddc992c116$var$useCodeExpiry();
    return state === 'expired' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b73d6eddc992c116$var$CodeExpired, {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b73d6eddc992c116$var$CodeValid, {});
}
function $b73d6eddc992c116$var$CodeValid() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.code');
    const navigate = (0, $618a07bedf38a2ba$export$9770f232ac06a008)();
    const { invite: invite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    const { validityMinutes: validityMinutes } = (0, $9829299c7e045421$export$c9b45bbf1014e3f1)();
    const validateOtp = (0, $69587e21279c402a$export$7c0ab1d2421cd411)();
    const form = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        defaultValues: $b73d6eddc992c116$var$defaultValues,
        resolver: $b73d6eddc992c116$var$resolver,
        mode: 'onChange'
    });
    const onSubmit = (0, $acw62.useCallback)(async ({ code: code })=>{
        try {
            const { status: status } = await validateOtp.execute(code);
            // Only need to continue when the invite status is not final. If it is
            // final the EnsureInvite component will display the correct page.
            if (!(0, $9dfc7fe3975de14a$export$f24af7fbd92c164a).includes(status?.toLowerCase())) navigate(`/${invite.reference}/continue`);
        } catch  {
        // Handled
        }
    }, [
        invite.reference,
        navigate,
        validateOtp
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $05fc0a4d0e875da9$export$c349430af49f3c78), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: "title",
                        children: t('title')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        i18nKey: "text",
                        ns: "page.code",
                        components: {
                            p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
                            strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "font-semibold"
                            }),
                            PhonePlaceholder: invite?.phone
                        },
                        values: {
                            validityMinutes: validityMinutes
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ba541db038d3dda$export$5f71c1e53eaf1d93), {
                error: validateOtp.error
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
                ...form,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        onSubmit: form.handleSubmit(onSubmit),
                        className: "pt-2.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                                name: "code",
                                autoFocus: true,
                                autoComplete: "one-time-code",
                                isRequired: true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "my-3.5 flex items-center gap-2.5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $539d7db82b1be756$export$2e2bcd8739ae039), {
                                        className: "text-primary-active",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-sm leading-none text-light-500",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b73d6eddc992c116$var$TimeRemaining, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c17aead7dd77426$export$8b7b7cdfb85d78c5), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3a5daec5db3bdecd$export$2c396862c514d9b4), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "subtitle",
                                children: t('noCode')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b73d6eddc992c116$var$ResendButton, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a5daec5db3bdecd$export$2c396862c514d9b4), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    i18nKey: "helpMessage",
                    ns: "page.code",
                    values: (0, $22c4bfea680558f2$export$2e2bcd8739ae039),
                    components: {
                        p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
                        br: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "font-semibold"
                        }),
                        a: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: `tel:${(0, $8b1710acf92137fb$export$96e99d0e61df2702)((0, $22c4bfea680558f2$export$2e2bcd8739ae039).phone)}`
                        })
                    }
                })
            })
        ]
    });
}
function $b73d6eddc992c116$var$CodeExpired() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.code');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05fc0a4d0e875da9$export$c349430af49f3c78), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "mb-5",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "title",
                    children: t('titleExpired')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    i18nKey: "textExpired",
                    t: t,
                    components: {
                        p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
                        strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "font-semibold"
                        })
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mt-5",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b73d6eddc992c116$var$ResendButton, {
                        variant: "primary"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a5daec5db3bdecd$export$2c396862c514d9b4), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        i18nKey: "helpMessage",
                        ns: "page.code",
                        values: (0, $22c4bfea680558f2$export$2e2bcd8739ae039),
                        components: {
                            p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
                            br: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "font-semibold"
                            }),
                            a: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: `tel:${(0, $8b1710acf92137fb$export$96e99d0e61df2702)((0, $22c4bfea680558f2$export$2e2bcd8739ae039).phone)}`
                            })
                        }
                    })
                })
            ]
        })
    });
}
function $b73d6eddc992c116$var$TimeRemaining() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.code');
    const { remaining: remaining, state: state } = $b73d6eddc992c116$var$useCodeExpiry();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "data-[state=expiring]:text-warning-500 data-[state=expired]:text-error-500",
        "data-state": state,
        children: t('remainingTime', {
            time: (0, $20698d5b6ab216c3$export$3203edd9e5edd663)(remaining)
        })
    });
}
function $b73d6eddc992c116$var$ResendButton({ variant: variant = 'outlined' }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)('page.code');
    const requestOtp = (0, $58e11ab646c0edf1$export$a851da9adada3059)();
    // TODO: handle request otp error
    const onClick = (0, $acw62.useCallback)(async ()=>{
        await requestOtp.execute();
    }, [
        requestOtp
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f563c890ed38cb6$export$353f5b6fc5456de1), {
        type: "button",
        variant: variant,
        onClick: onClick,
        children: t('sendCode')
    });
}


// eslint-disable-next-line import/no-unresolved




var $acw62 = parcelRequire("acw62");















const $4fc48a0da5c6636b$var$resolver = (0, $0591fe66d7f046a7$export$66b7b5879c70f722)($09193e81812ba154$export$be5493f9613cbbe({
    name: $09193e81812ba154$export$22b082955e083ec3().min(1),
    dateOfBirth: $09193e81812ba154$export$22b082955e083ec3().regex((0, $641e6457757d8f34$export$f69b927d95b72681))
}));
let $4fc48a0da5c6636b$var$defaultValues = {
    name: '',
    dateOfBirth: ''
};
if (!(0, $2bd9d04ce55ef2a0$export$9b5f2e1c20ef6571)) {
    $4fc48a0da5c6636b$var$defaultValues.name = localStorage.getItem('soopa-invite-code-name') ?? '';
    $4fc48a0da5c6636b$var$defaultValues.dateOfBirth = localStorage.getItem('soopa-invite-code-dob') ?? '';
}
function $4fc48a0da5c6636b$export$23191e4434a9e834() {
    const { invite: invite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    const navigate = (0, $618a07bedf38a2ba$export$9770f232ac06a008)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)([
        'page.welcome',
        'common'
    ]);
    const requestOtp = (0, $58e11ab646c0edf1$export$a851da9adada3059)();
    const form = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        defaultValues: $4fc48a0da5c6636b$var$defaultValues,
        resolver: $4fc48a0da5c6636b$var$resolver,
        mode: 'onChange'
    });
    const onSubmit = (0, $acw62.useCallback)(async ({ name: name, dateOfBirth: dateOfBirth })=>{
        try {
            await requestOtp.execute(name, dateOfBirth);
            navigate('../code');
        } catch  {
        // Handled
        }
    }, [
        navigate,
        requestOtp
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $05fc0a4d0e875da9$export$c349430af49f3c78), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: "title font-medium",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                            i18nKey: "title",
                            t: t,
                            components: {
                                strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    className: "block"
                                })
                            },
                            values: {
                                company: (0, $22c4bfea680558f2$export$2e2bcd8739ae039).company
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        i18nKey: "text",
                        t: t,
                        components: {
                            p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
                            strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                className: "font-semibold"
                            }),
                            PhonePlaceholder: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: invite?.phone
                            })
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ba541db038d3dda$export$5f71c1e53eaf1d93), {
                error: requestOtp.error
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
                ...form,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    onSubmit: form.handleSubmit(onSubmit),
                    className: "pt-2.5 space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba2139d830a3ba4d$export$f5b8910cec6cf069), {
                            name: "name",
                            label: t('familyName'),
                            autoFocus: true,
                            className: "uppercase",
                            autoComplete: "family-name"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ccb7b96bc20cedcb$export$d9781c7894a82487), {
                            name: "dateOfBirth",
                            label: t('birthDate'),
                            autoComplete: "bday"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c17aead7dd77426$export$8b7b7cdfb85d78c5), {
                            label: t('sendCode')
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a5daec5db3bdecd$export$2c396862c514d9b4), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    i18nKey: "helpMessage",
                    t: t,
                    values: {
                        phone: (0, $22c4bfea680558f2$export$2e2bcd8739ae039).phone
                    },
                    components: {
                        p: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {}),
                        br: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            className: "font-semibold"
                        }),
                        a: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: `tel:${(0, $8b1710acf92137fb$export$96e99d0e61df2702)((0, $22c4bfea680558f2$export$2e2bcd8739ae039).phone)}`
                        })
                    }
                })
            })
        ]
    });
}



const $f81dc41776b47e8c$var$ROUTER = (0, $618a07bedf38a2ba$export$1f3f55432a00e06d)([
    {
        path: '/',
        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f81dc41776b47e8c$export$be92b6f5f03c0fe9, {}),
        children: [
            {
                index: true,
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57e65ef82483d664$export$bb799570cb877084), {})
            },
            {
                path: ':inviteId',
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f81dc41776b47e8c$var$EnsureInvite, {}),
                children: [
                    {
                        index: true,
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $618a07bedf38a2ba$export$444b3ab0cb9aec40), {
                            to: "welcome",
                            replace: true
                        })
                    },
                    {
                        path: 'welcome',
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fc48a0da5c6636b$export$23191e4434a9e834), {})
                    },
                    {
                        path: 'code',
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b73d6eddc992c116$export$52f0f02147b12c03), {})
                    },
                    {
                        path: 'continue',
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f81dc41776b47e8c$var$Continue, {})
                    },
                    {
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f81dc41776b47e8c$var$EnsureNonPartialInvite, {}),
                        children: (0, $719afc6b1355ea07$export$be3f796aed065412).filter((step)=>step.component).map((step, index)=>({
                                path: step.path,
                                element: /*#__PURE__*/ (0, $acw62.createElement)(step.component, {
                                    ...step.props,
                                    nextLabel: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                        i18nKey: step.nextLabel ?? `page.${step.path}:nextLabel`,
                                        components: {
                                            b: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {})
                                        }
                                    }),
                                    next: (0, $719afc6b1355ea07$export$be3f796aed065412).at(index + 1) ?? null,
                                    prev: (0, $719afc6b1355ea07$export$be3f796aed065412).at(index - 1) ?? null
                                })
                            }))
                    }
                ],
                errorElement: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $618a07bedf38a2ba$export$444b3ab0cb9aec40), {
                    to: "/",
                    replace: true
                })
            }
        ],
        errorElement: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $618a07bedf38a2ba$export$444b3ab0cb9aec40), {
            to: "/",
            replace: true
        })
    }
], {
    future: {
        v7_relativeSplatPath: true
    }
});
function $f81dc41776b47e8c$export$be92b6f5f03c0fe9() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $618a07bedf38a2ba$export$910ae8079b2c2852), {});
}
function $f81dc41776b47e8c$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.StrictMode), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
            fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1eed403137e89aa1$export$669f6ea7d267feaf), {}),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2437f33e36922204$export$d33e3d7abec0d9e9), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $618a07bedf38a2ba$export$323e4fc2fa4753fb), {
                    router: $f81dc41776b47e8c$var$ROUTER
                })
            })
        })
    });
}
function $f81dc41776b47e8c$var$EnsureInvite() {
    const { inviteId: inviteId } = (0, $618a07bedf38a2ba$export$99eaa27ddbbb95ef)();
    const { reference: reference, status: status } = (0, $9dfc7fe3975de14a$export$9074eb99b058a8d5)();
    switch(status.toLowerCase()){
        case (0, $9dfc7fe3975de14a$export$8dffa4efb9fbc37b).CREATED:
        case (0, $9dfc7fe3975de14a$export$8dffa4efb9fbc37b).STARTED:
            if (reference.toLowerCase() === inviteId.trim().toLowerCase()) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $618a07bedf38a2ba$export$910ae8079b2c2852), {});
            else {
                console.warn(`Invite id mismatch (${reference.toLowerCase()} != ${inviteId.trim().toLowerCase()}), redirecting to root.`);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $618a07bedf38a2ba$export$444b3ab0cb9aec40), {
                    to: "/",
                    replace: true
                });
            }
        case (0, $9dfc7fe3975de14a$export$8dffa4efb9fbc37b).COMPLETED:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a709e4c9308808b8$export$631d00cd58a8f6db), {});
        case (0, $9dfc7fe3975de14a$export$8dffa4efb9fbc37b).CANCELLED:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1df1d5eabf3783ca$export$a725250edc90f8c2), {});
        case (0, $9dfc7fe3975de14a$export$8dffa4efb9fbc37b).LOCKED:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e502e09c43ad4b6$export$bf20e430f62d8c48), {});
        case (0, $9dfc7fe3975de14a$export$8dffa4efb9fbc37b).EXPIRED:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ab68bde9cbdf8fd$export$8967795e3d51fba7), {});
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $89fc7d6450c3ed8e$export$2150ef7ed21e6f1c), {});
}
function $f81dc41776b47e8c$var$Continue() {
    const { invite: invite } = (0, $9dfc7fe3975de14a$export$b7f2c41423608aeb)();
    const navigate = (0, $618a07bedf38a2ba$export$9770f232ac06a008)();
    (0, $acw62.useEffect)(()=>{
        const step = (0, $719afc6b1355ea07$export$3ba3bdeb1afab63a)(invite.onlineBookingData, invite);
        navigate(`/${invite.reference}/${step.path}`, {
            replace: true
        });
    }, [
        invite,
        navigate
    ]);
    return null;
}
function $f81dc41776b47e8c$var$EnsureNonPartialInvite() {
    const { reference: reference, partial: partial } = (0, $9dfc7fe3975de14a$export$9074eb99b058a8d5)();
    if (partial) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $618a07bedf38a2ba$export$444b3ab0cb9aec40), {
        to: `/${reference}/welcome`,
        replace: true
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $618a07bedf38a2ba$export$910ae8079b2c2852), {});
}


const $509498b074d890c3$var$node = document.getElementById('root');
const $509498b074d890c3$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($509498b074d890c3$var$node);
$509498b074d890c3$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f81dc41776b47e8c$export$86fbec116b87613f), {}));


//# sourceMappingURL=site.8532086a.js.map
